webpackJsonp([5],{

/***/ "++mS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var passiveSupported = false;

try {
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveSupported = true;
    }
  });
  window.addEventListener('test', null, options);
} catch (err) {}

/* harmony default export */ __webpack_exports__["a"] = (passiveSupported);

/***/ }),

/***/ "+1cx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};


/***/ }),

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+Ixu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__("BEQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);


var mergeOptions = function mergeOptions($vm, options) {
  var defaults = {};
  for (var i in $vm.$options.props) {
    if (i !== 'value') {
      defaults[i] = $vm.$options.props[i].default;
    }
  }
  var _options = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, defaults, options);
  for (var _i in _options) {
    $vm[_i] = _options[_i];
  }
};



/***/ }),

/***/ "+MLA":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("EqjI");
var meta = __webpack_require__("06OY").onFreeze;

__webpack_require__("uqUo")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "+geU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/animate.js
var time = Date.now || function () {
  return +new Date();
};

var running = {};
var counter = 1;
var desiredFrames = 60;
var millisecondsPerSecond = 1000;

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel
if (typeof window !== 'undefined') {
  ;(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
    }
    if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
      };
    }
  })();
}

/* harmony default export */ var picker_animate = ({

  // A requestAnimationFrame wrapper / polyfill.
  requestAnimationFrame: function () {
    if (typeof window !== 'undefined') {
      var requestFrame = window.requestAnimationFrame;
      return function (callback, root) {
        requestFrame(callback, root);
      };
    }
  }(),

  // Stops the given animation.
  stop: function stop(id) {
    var cleared = running[id] != null;
    if (cleared) {
      running[id] = null;
    }
    return cleared;
  },


  // Whether the given animation is still running.
  isRunning: function isRunning(id) {
    return running[id] != null;
  },


  // Start the animation.
  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod, root) {
    var _this = this;
    var start = time();
    var lastFrame = start;
    var percent = 0;
    var dropCounter = 0;
    var id = counter++;

    if (!root) {
      root = document.body;
    }

    // Compacting running db automatically every few new animations
    if (id % 20 === 0) {
      var newRunning = {};
      for (var usedId in running) {
        newRunning[usedId] = true;
      }
      running = newRunning;
    }

    // This is the internal step method which is called every few milliseconds
    var step = function step(virtual) {
      // Normalize virtual value
      var render = virtual !== true;
      // Get current time
      var now = time();

      // Verification is executed before next animation step
      if (!running[id] || verifyCallback && !verifyCallback(id)) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
        return;
      }

      // For the current rendering to apply let's update omitted steps in memory.
      // This is important to bring internal state variables up-to-date with progress in time.
      if (render) {
        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
          step(true);
          dropCounter++;
        }
      }

      // Compute percent value
      if (duration) {
        percent = (now - start) / duration;
        if (percent > 1) {
          percent = 1;
        }
      }

      // Execute step callback, then...
      var value = easingMethod ? easingMethod(percent) : percent;
      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
      } else if (render) {
        lastFrame = now;
        _this.requestAnimationFrame(step, root);
      }
    };

    // Mark as running
    running[id] = true;
    // Init first step
    _this.requestAnimationFrame(step, root);
    // Return unique animation ID
    return id;
  }
});
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/util.js
function getElement(expr) {
  return typeof expr === 'string' ? document.querySelector(expr) : expr;
}

function getComputedStyle(el, key) {
  var computedStyle = window.getComputedStyle(el);
  return computedStyle[key] || '';
}

// Easing Equations (c) 2003 Robert Penner, all rights reserved.
// Open source under the BSD License.
function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
}

function easeInOutCubic(pos) {
  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(pos, 3);
  }
  return 0.5 * (Math.pow(pos - 2, 3) + 2);
}
// EXTERNAL MODULE: ./node_modules/vux/src/libs/passive_supported.js
var passive_supported = __webpack_require__("++mS");

// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/scroller.js


/*
* Anima Scroller
* Based Zynga Scroller (http://github.com/zynga/scroller)
* Copyright 2011, Zynga Inc.
* Licensed under the MIT License.
* https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
*/

var isBrowser = (typeof window === 'undefined' ? 'undefined' : typeof_default()(window)) === 'object';

var TEMPLATE = '\n<div class="scroller-component" data-role="component">\n  <div class="scroller-mask" data-role="mask"></div>\n  <div class="scroller-indicator" data-role="indicator"></div>\n  <div class="scroller-content" data-role="content"></div>\n</div>\n';





var getDpr = function getDpr() {
  var dpr = 1;
  if (isBrowser) {
    if (window.VUX_CONFIG && window.VUX_CONFIG.$picker && window.VUX_CONFIG.$picker.respectHtmlDataDpr) {
      dpr = document.documentElement.getAttribute('data-dpr') || 1;
    }
  }
  return dpr;
};

var scroller_Scroller = function Scroller(container, options) {
  var self = this;

  self.isDestroy = false;

  self.dpr = getDpr();

  options = options || {};

  self.options = {
    itemClass: 'scroller-item',
    onSelect: function onSelect() {},

    defaultValue: 0,
    data: []
  };

  for (var key in options) {
    if (options[key] !== undefined) {
      self.options[key] = options[key];
    }
  }

  self.__container = getElement(container);

  var tempContainer = document.createElement('div');
  tempContainer.innerHTML = options.template || TEMPLATE;

  var component = self.__component = tempContainer.querySelector('[data-role=component]');
  var content = self.__content = component.querySelector('[data-role=content]');
  var indicator = component.querySelector('[data-role=indicator]');

  var data = self.options.data;
  var html = '';
  if (data.length && data[0].constructor === Object) {
    data.forEach(function (row) {
      html += '<div class="' + self.options.itemClass + '" data-value=' + stringify_default()({
        value: encodeURI(row.value)
      }) + '>' + row.name + '</div>';
    });
  } else {
    data.forEach(function (val) {
      html += '<div class="' + self.options.itemClass + '" data-value=' + stringify_default()({
        value: encodeURI(val)
      }) + '>' + val + '</div>';
    });
  }
  content.innerHTML = html;

  self.__container.appendChild(component);

  self.__itemHeight = parseFloat(getComputedStyle(indicator, 'height'), 10);

  self.__callback = options.callback || function (top) {
    var distance = -top * self.dpr;
    content.style.webkitTransform = 'translate3d(0, ' + distance + 'px, 0)';
    content.style.transform = 'translate3d(0, ' + distance + 'px, 0)';
  };

  var rect = component.getBoundingClientRect();

  self.__clientTop = rect.top + component.clientTop || 0;

  self.__setDimensions(component.clientHeight, content.offsetHeight);

  if (component.clientHeight === 0) {
    self.__setDimensions(parseFloat(getComputedStyle(component, 'height'), 10), 204);
  }
  self.select(self.options.defaultValue, false);

  var touchStartHandler = function touchStartHandler(e) {
    if (e.target.tagName.match(/input|textarea|select/i)) {
      return;
    }
    e.preventDefault();
    self.__doTouchStart(e, e.timeStamp);
  };

  var touchMoveHandler = function touchMoveHandler(e) {
    self.__doTouchMove(e, e.timeStamp);
  };

  var touchEndHandler = function touchEndHandler(e) {
    self.__doTouchEnd(e.timeStamp);
  };

  var willPreventDefault = passive_supported["a" /* default */] ? {
    passive: false
  } : false;
  var willNotPreventDefault = passive_supported["a" /* default */] ? {
    passive: true
  } : false;

  component.addEventListener('touchstart', touchStartHandler, willPreventDefault);
  component.addEventListener('mousedown', touchStartHandler, willPreventDefault);

  component.addEventListener('touchmove', touchMoveHandler, willNotPreventDefault);
  component.addEventListener('mousemove', touchMoveHandler, willNotPreventDefault);

  component.addEventListener('touchend', touchEndHandler, willNotPreventDefault);
  component.addEventListener('mouseup', touchEndHandler, willNotPreventDefault);
};

var members = {
  value: null,
  __prevValue: null,
  __isSingleTouch: false,
  __isTracking: false,
  __didDecelerationComplete: false,
  __isGesturing: false,
  __isDragging: false,
  __isDecelerating: false,
  __isAnimating: false,
  __clientTop: 0,
  __clientHeight: 0,
  __contentHeight: 0,
  __itemHeight: 0,
  __scrollTop: 0,
  __minScrollTop: 0,
  __maxScrollTop: 0,
  __scheduledTop: 0,
  __lastTouchTop: null,
  __lastTouchMove: null,
  __positions: null,
  __minDecelerationScrollTop: null,
  __maxDecelerationScrollTop: null,
  __decelerationVelocityY: null,

  __setDimensions: function __setDimensions(clientHeight, contentHeight) {
    var self = this;

    self.__clientHeight = clientHeight;
    self.__contentHeight = contentHeight;

    var totalItemCount = self.options.data.length;
    var clientItemCount = Math.round(self.__clientHeight / self.__itemHeight);

    self.__minScrollTop = -self.__itemHeight * (clientItemCount / 2);
    self.__maxScrollTop = self.__minScrollTop + totalItemCount * self.__itemHeight - 0.1;
  },
  selectByIndex: function selectByIndex(index, animate) {
    var self = this;
    if (index < 0 || index > self.__content.childElementCount - 1) {
      return;
    }
    self.__scrollTop = self.__minScrollTop + index * self.__itemHeight;

    self.scrollTo(self.__scrollTop, animate);

    self.__selectItem(self.__content.children[index]);
  },
  select: function select(value, animate) {
    var self = this;

    var children = self.__content.children;
    for (var i = 0, len = children.length; i < len; i++) {
      if (decodeURI(JSON.parse(children[i].dataset.value).value) === value) {
        self.selectByIndex(i, animate);
        return;
      }
    }

    self.selectByIndex(0, animate);
  },
  getValue: function getValue() {
    return this.value;
  },
  scrollTo: function scrollTo(top, animate) {
    var self = this;

    animate = animate === undefined ? true : animate;

    if (self.__isDecelerating) {
      picker_animate.stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    top = Math.round((top / self.__itemHeight).toFixed(5)) * self.__itemHeight;
    top = Math.max(Math.min(self.__maxScrollTop, top), self.__minScrollTop);

    if (top === self.__scrollTop || !animate) {
      self.__publish(top);
      self.__scrollingComplete();
      return;
    }
    self.__publish(top, 250);
  },
  destroy: function destroy() {
    this.isDestroy = true;
    this.__component.parentNode && this.__component.parentNode.removeChild(this.__component);
  },
  __selectItem: function __selectItem(selectedItem) {
    var self = this;

    var selectedItemClass = self.options.itemClass + '-selected';
    var lastSelectedElem = self.__content.querySelector('.' + selectedItemClass);
    if (lastSelectedElem) {
      lastSelectedElem.classList.remove(selectedItemClass);
    }
    selectedItem.classList.add(selectedItemClass);

    if (self.value !== null) {
      self.__prevValue = self.value;
    }

    self.value = decodeURI(JSON.parse(selectedItem.dataset.value).value);
  },
  __scrollingComplete: function __scrollingComplete() {
    var self = this;

    var index = Math.round((self.__scrollTop - self.__minScrollTop - self.__itemHeight / 2) / self.__itemHeight);

    self.__selectItem(self.__content.children[index]);

    if (self.__prevValue !== null && self.__prevValue !== self.value && !self.isDestroy) {
      self.options.onSelect(self.value);
    }
  },
  __doTouchStart: function __doTouchStart(ev, timeStamp) {
    var touches = ev.touches;
    var self = this;
    var target = ev.touches ? ev.touches[0] : ev;
    var isMobile = !!ev.touches;

    if (ev.touches && touches.length == null) {
      throw new Error('Invalid touch list: ' + touches);
    }
    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    self.__interruptedAnimation = true;

    if (self.__isDecelerating) {
      picker_animate.stop(self.__isDecelerating);
      self.__isDecelerating = false;
      self.__interruptedAnimation = true;
    }

    if (self.__isAnimating) {
      picker_animate.stop(self.__isAnimating);
      self.__isAnimating = false;
      self.__interruptedAnimation = true;
    }

    // Use center point when dealing with two fingers
    var currentTouchTop;
    var isSingleTouch = isMobile && touches.length === 1 || !isMobile;
    if (isSingleTouch) {
      currentTouchTop = target.pageY;
    } else {
      currentTouchTop = Math.abs(target.pageY + touches[1].pageY) / 2;
    }

    self.__initialTouchTop = currentTouchTop;
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = 1;
    self.__enableScrollY = !isSingleTouch;
    self.__isTracking = true;
    self.__didDecelerationComplete = false;
    self.__isDragging = !isSingleTouch;
    self.__isSingleTouch = isSingleTouch;
    self.__positions = [];
  },
  __doTouchMove: function __doTouchMove(ev, timeStamp, scale) {
    var self = this;
    var touches = ev.touches;
    var target = ev.touches ? ev.touches[0] : ev;
    var isMobile = !!ev.touches;

    if (touches && touches.length == null) {
      throw new Error('Invalid touch list: ' + touches);
    }
    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    // Ignore event when tracking is not enabled (event might be outside of element)
    if (!self.__isTracking) {
      return;
    }

    var currentTouchTop;

    // Compute move based around of center of fingers
    if (isMobile && touches.length === 2) {
      currentTouchTop = Math.abs(target.pageY + touches[1].pageY) / 2;
    } else {
      currentTouchTop = target.pageY;
    }

    var positions = self.__positions;

    // Are we already is dragging mode?
    if (self.__isDragging) {
      var moveY = currentTouchTop - self.__lastTouchTop;
      var scrollTop = self.__scrollTop;

      if (self.__enableScrollY) {
        scrollTop -= moveY;

        var minScrollTop = self.__minScrollTop;
        var maxScrollTop = self.__maxScrollTop;

        if (scrollTop > maxScrollTop || scrollTop < minScrollTop) {
          // Slow down on the edges
          if (scrollTop > maxScrollTop) {
            scrollTop = maxScrollTop;
          } else {
            scrollTop = minScrollTop;
          }
        }
      }

      // Keep list from growing infinitely (holding min 10, max 20 measure points)
      if (positions.length > 40) {
        positions.splice(0, 20);
      }

      // Track scroll movement for decleration
      positions.push(scrollTop, timeStamp);

      // Sync scroll position
      self.__publish(scrollTop);

      // Otherwise figure out whether we are switching into dragging mode now.
    } else {
      var minimumTrackingForScroll = 0;
      var minimumTrackingForDrag = 5;

      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

      self.__enableScrollY = distanceY >= minimumTrackingForScroll;

      positions.push(self.__scrollTop, timeStamp);

      self.__isDragging = self.__enableScrollY && distanceY >= minimumTrackingForDrag;

      if (self.__isDragging) {
        self.__interruptedAnimation = false;
      }
    }

    // Update last touch positions and time stamp for next event
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = scale;
  },
  __doTouchEnd: function __doTouchEnd(timeStamp) {
    var self = this;

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== 'number') {
      throw new Error('Invalid timestamp value: ' + timeStamp);
    }

    // Ignore event when tracking is not enabled (no touchstart event on element)
    // This is required as this listener ('touchmove') sits on the document and not on the element itself.
    if (!self.__isTracking) {
      return;
    }

    // Not touching anymore (when two finger hit the screen there are two touch end events)
    self.__isTracking = false;

    // Be sure to reset the dragging flag now. Here we also detect whether
    // the finger has moved fast enough to switch into a deceleration animation.
    if (self.__isDragging) {
      // Reset dragging flag
      self.__isDragging = false;

      // Start deceleration
      // Verify that the last move detected was in some relevant time frame
      if (self.__isSingleTouch && timeStamp - self.__lastTouchMove <= 100) {
        // Then figure out what the scroll position was about 100ms ago
        var positions = self.__positions;
        var endPos = positions.length - 1;
        var startPos = endPos;

        // Move pointer to position measured 100ms ago
        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 2) {
          startPos = i;
        }

        // If start and stop position is identical in a 100ms timeframe,
        // we cannot compute any useful deceleration.
        if (startPos !== endPos) {
          // Compute relative movement between these two points
          var timeOffset = positions[endPos] - positions[startPos];
          var movedTop = self.__scrollTop - positions[startPos - 1];

          // Based on 50ms compute the movement to apply for each render step
          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

          // How much velocity is required to start the deceleration
          var minVelocityToStartDeceleration = 4;

          // Verify that we have enough velocity to start deceleration
          if (Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {
            self.__startDeceleration(timeStamp);
          }
        }
      }
    }

    if (!self.__isDecelerating) {
      self.scrollTo(self.__scrollTop);
    }

    // Fully cleanup list
    self.__positions.length = 0;
  },


  // Applies the scroll position to the content element
  __publish: function __publish(top, animationDuration) {
    var self = this;

    // Remember whether we had an animation, then we try to continue based on the current "drive" of the animation
    var wasAnimating = self.__isAnimating;
    if (wasAnimating) {
      picker_animate.stop(wasAnimating);
      self.__isAnimating = false;
    }

    if (animationDuration) {
      // Keep scheduled positions for scrollBy functionality
      self.__scheduledTop = top;

      var oldTop = self.__scrollTop;
      var diffTop = top - oldTop;

      var step = function step(percent, now, render) {
        self.__scrollTop = oldTop + diffTop * percent;
        // Push values out
        if (self.__callback) {
          self.__callback(self.__scrollTop);
        }
      };

      var verify = function verify(id) {
        return self.__isAnimating === id;
      };

      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
        if (animationId === self.__isAnimating) {
          self.__isAnimating = false;
        }
        if (self.__didDecelerationComplete || wasFinished) {
          self.__scrollingComplete();
        }
      };

      // When continuing based on previous animation we choose an ease-out animation instead of ease-in-out
      self.__isAnimating = picker_animate.start(step, verify, completed, animationDuration, wasAnimating ? easeOutCubic : easeInOutCubic);
    } else {
      self.__scheduledTop = self.__scrollTop = top;
      // Push values out
      if (self.__callback) {
        self.__callback(top);
      }
    }
  },


  // Called when a touch sequence end and the speed of the finger was high enough to switch into deceleration mode.
  __startDeceleration: function __startDeceleration(timeStamp) {
    var self = this;

    self.__minDecelerationScrollTop = self.__minScrollTop;
    self.__maxDecelerationScrollTop = self.__maxScrollTop;

    // Wrap class method
    var step = function step(percent, now, render) {
      self.__stepThroughDeceleration(render);
    };

    // How much velocity is required to keep the deceleration running
    var minVelocityToKeepDecelerating = 0.5;

    // Detect whether it's still worth to continue animating steps
    // If we are already slow enough to not being user perceivable anymore, we stop the whole process here.
    var verify = function verify() {
      var shouldContinue = Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
      if (!shouldContinue) {
        self.__didDecelerationComplete = true;
      }
      return shouldContinue;
    };

    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
      self.__isDecelerating = false;
      if (self.__scrollTop <= self.__minScrollTop || self.__scrollTop >= self.__maxScrollTop) {
        self.scrollTo(self.__scrollTop);
        return;
      }
      if (self.__didDecelerationComplete) {
        self.__scrollingComplete();
      }
    };

    // Start animation and switch on flag
    self.__isDecelerating = picker_animate.start(step, verify, completed);
  },


  // Called on every step of the animation
  __stepThroughDeceleration: function __stepThroughDeceleration(render) {
    var self = this;

    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

    var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
    if (scrollTopFixed !== scrollTop) {
      scrollTop = scrollTopFixed;
      self.__decelerationVelocityY = 0;
    }

    if (Math.abs(self.__decelerationVelocityY) <= 1) {
      if (Math.abs(scrollTop % self.__itemHeight) < 1) {
        self.__decelerationVelocityY = 0;
      }
    } else {
      self.__decelerationVelocityY *= 0.95;
    }

    self.__publish(scrollTop);
  }
};

// Copy over members to prototype
for (var scroller_key in members) {
  scroller_Scroller.prototype[scroller_key] = members[scroller_key];
}

/* harmony default export */ var scroller = __webpack_exports__["a"] = (scroller_Scroller);

/***/ }),

/***/ "+tPU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xGkn");
var global = __webpack_require__("7KvD");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var TO_STRING_TAG = __webpack_require__("dSzd")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+v63":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_passive_supported__ = __webpack_require__("++mS");


var isBrowser = (typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window)) === 'object';

// not a good way but works well
if (isBrowser) {
  window.__$vuxPopups = window.__$vuxPopups || {};
}

var popupDialog = function popupDialog(option) {
  var _this = this;

  if (!isBrowser) {
    return;
  }
  this.uuid = Math.random().toString(36).substring(3, 8);
  this.params = {};
  if (Object.prototype.toString.call(option) === '[object Object]') {
    this.params = {
      hideOnBlur: option.hideOnBlur,
      onOpen: option.onOpen || function () {},
      onClose: option.onClose || function () {},
      showMask: option.showMask
    };
  }
  if (!!document.querySelectorAll('.vux-popup-mask').length <= 0) {
    this.divMask = document.createElement('a');
    this.divMask.className = 'vux-popup-mask';
    this.divMask.dataset.uuid = '';
    this.divMask.href = 'javascript:void(0)';
    document.body.appendChild(this.divMask);
  }
  var div = void 0;
  if (!option.container) {
    div = document.createElement('div');
  } else {
    div = option.container;
  }

  div.className += ' vux-popup-dialog vux-popup-dialog-' + this.uuid;
  if (!this.params.hideOnBlur) {
    div.className += ' vux-popup-mask-disabled';
  }

  this.div = div;

  if (!option.container) {
    document.body.appendChild(div);
  }
  this.container = document.querySelector('.vux-popup-dialog-' + this.uuid);
  this.mask = document.querySelector('.vux-popup-mask');
  this.mask.dataset.uuid += ',' + this.uuid;
  this._bindEvents();
  option = null;
  this.containerHandler = function () {
    _this.mask && !/show/.test(_this.mask.className) && setTimeout(function () {
      !/show/.test(_this.mask.className) && (_this.mask.style['zIndex'] = -1);
    }, 200);
  };

  this.container && this.container.addEventListener('webkitTransitionEnd', this.containerHandler);
  this.container && this.container.addEventListener('transitionend', this.containerHandler);
};

popupDialog.prototype.onClickMask = function () {
  this.params.hideOnBlur && this.params.onClose();
};

popupDialog.prototype._bindEvents = function () {
  if (this.params.hideOnBlur) {
    this.mask.addEventListener('click', this.onClickMask.bind(this), false);
    this.mask.addEventListener('touchmove', function (e) {
      return e.preventDefault();
    }, __WEBPACK_IMPORTED_MODULE_1__libs_passive_supported__["a" /* default */] ? { passive: false } : false);
  }
};

popupDialog.prototype.show = function () {
  if (this.params.showMask) {
    this.mask.classList.add('vux-popup-show');
    this.mask.style['zIndex'] = 500;
  }
  this.container.classList.add('vux-popup-show');
  this.params.onOpen && this.params.onOpen(this);
  if (isBrowser) {
    window.__$vuxPopups[this.uuid] = 1;
  }
};

popupDialog.prototype.hide = function () {
  var _this2 = this;

  var shouldCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  this.container.classList.remove('vux-popup-show');
  if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
    this.mask.classList.remove('vux-popup-show');
    setTimeout(function () {
      _this2.mask && !/show/.test(_this2.mask.className) && (_this2.mask.style['zIndex'] = -1);
    }, 400);
  }
  shouldCallback === false && this.params.onClose && this.params.hideOnBlur && this.params.onClose(this);
  this.isShow = false;
  if (isBrowser) {
    delete window.__$vuxPopups[this.uuid];
  }
};

popupDialog.prototype.destroy = function () {
  this.mask.dataset.uuid = this.mask.dataset.uuid.replace(new RegExp(',' + this.uuid, 'g'), '');
  if (!this.mask.dataset.uuid) {
    this.mask.removeEventListener('click', this.onClickMask.bind(this), false);
    this.mask && this.mask.parentNode && this.mask.parentNode.removeChild(this.mask);
  } else {
    this.hide();
  }
  this.container.removeEventListener('webkitTransitionEnd', this.containerHandler);
  this.container.removeEventListener('transitionend', this.containerHandler);
  if (isBrowser) {
    delete window.__$vuxPopups[this.uuid];
  }
};

/* harmony default export */ __webpack_exports__["a"] = (popupDialog);

/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("U5ju"), __esModule: true };

/***/ }),

/***/ "/bQp":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "/n6Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("+tPU");
module.exports = __webpack_require__("Kh4W").f('iterator');


/***/ }),

/***/ "/ocq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationFailureType */
/* unused harmony export RouterLink */
/* unused harmony export RouterView */
/* unused harmony export START_LOCATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueRouter$1; });
/* unused harmony export isNavigationFailure */
/* unused harmony export version */
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b, onlyPath) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath ||
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query))
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      (onlyPath || (
        a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params))
      )
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/(?:\s*\/)+/g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("<router-link> with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(
          false,
          "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(
          false,
          "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
        );
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap,
  parentRoute
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias
      ? typeof route.alias === 'string'
        ? [route.alias]
        : route.alias
      : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'}\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute (parentOrRoute, route) {
    var parent = (typeof parentOrRoute !== 'object') ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
        // $flow-disable-line route is defined if parent is
        parent.alias.map(function (alias) { return ({ path: alias, children: [route] }); }),
        pathList,
        pathMap,
        nameMap,
        parent
      );
    }
  }

  function getRoutes () {
    return pathList.map(function (path) { return pathMap[path]; })
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1$1.ensureURL();
      this$1$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1$1.ready) {
        this$1$1.ready = true;
        this$1$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1$1.ready = true;
          this$1$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1$1.errorCbs.length) {
        this$1$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1$1.replace(to);
          } else {
            this$1$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1$1.pending = null;
      onComplete(route);
      if (this$1$1.router.app) {
        this$1$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1$1.base);
      if (this$1$1.current === START && location === this$1$1._startLocation) {
        return
      }

      this$1$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1$1.base + route.fullPath));
      handleScroll(this$1$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && ((pathLowerCase === baseLowerCase) ||
    (pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0))) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index + 1).concat(route);
        this$1$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1$1.stack = this$1$1.stack.slice(0, this$1$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1$1.current;
        this$1$1.index = targetIndex;
        this$1$1.updateRoute(route);
        this$1$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1$1.apps.indexOf(app);
    if (index > -1) { this$1$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1$1.app === app) { this$1$1.app = this$1$1.apps[0] || null; }

    if (!this$1$1.app) { this$1$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.getRoutes = function getRoutes () {
  return this.matcher.getRoutes()
};

VueRouter.prototype.addRoute = function addRoute (parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

var VueRouter$1 = VueRouter;

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

// We cannot remove this as it would be a breaking change
VueRouter.install = install;
VueRouter.version = '3.6.5';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

var version = '3.6.5';




/***/ }),

/***/ "02Hb":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ "06OY":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("3Eo+")('meta');
var isObject = __webpack_require__("EqjI");
var has = __webpack_require__("D2L2");
var setDesc = __webpack_require__("evD5").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("S82l")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "0FxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = go;
/* unused harmony export getUrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

function go(url, $router) {
  if (/^javas/.test(url) || !url) return;
  var useRouter = (typeof url === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(url)) === 'object' || $router && typeof url === 'string' && !/http/.test(url);
  if (useRouter) {
    if ((typeof url === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(url)) === 'object' && url.replace === true) {
      $router.replace(url);
    } else {
      url === 'BACK' ? $router.go(-1) : $router.push(url);
    }
  } else {
    window.location.href = url;
  }
}

function getUrl(url, $router) {
  // Make sure the href is right in hash mode
  if ($router && !$router._history && typeof url === 'string' && !/http/.test(url)) {
    return '#!' + url;
  }
  return url && (typeof url === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(url)) !== 'object' ? url : 'javascript:void(0);';
}

/***/ }),

/***/ "0Iyz":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),

/***/ "0hgu":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("mP1F"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "1J88":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),

/***/ "1Obu":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
module.exports = __webpack_require__("Kh4W").f('toStringTag');


/***/ }),

/***/ "1alW":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("kM2E");

$export($export.S, 'Number', { isInteger: __webpack_require__("AKgy") });


/***/ }),

/***/ "1kS7":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "1nuA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("kMPS");
exports.encode = exports.stringify = __webpack_require__("xaZU");


/***/ }),

/***/ "2IIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    title: [String, Number],
    value: [String, Number, Array],
    isLink: Boolean,
    isLoading: Boolean,
    inlineDesc: [String, Number],
    primary: {
      type: String,
      default: 'title'
    },
    link: [String, Object],
    valueAlign: [String, Boolean, Number],
    borderIntent: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    arrowDirection: String, // down or up
    alignItems: String
  };
});

/***/ }),

/***/ "2KxR":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "2LX0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__("LLCR");

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__("CFqi");

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__("cddD");

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),

/***/ "2QDH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("NLm3"), __esModule: true };

/***/ }),

/***/ "2kPN":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("kM2E");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "30KW":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("kM2E");
var _isFinite = __webpack_require__("7KvD").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "3BeM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__("BEQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_toast__ = __webpack_require__("rLAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_plugin_helper__ = __webpack_require__("+Ixu");





var $vm = void 0;
var watcher = void 0;

var plugin = {
  install: function install(vue) {
    var pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var Toast = vue.extend(__WEBPACK_IMPORTED_MODULE_2__components_toast__["a" /* default */]);

    if (!$vm) {
      $vm = new Toast({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }

    var defaults = {};
    for (var i in $vm.$options.props) {
      if (i !== 'value') {
        defaults[i] = $vm.$options.props[i].default;
      }
    }

    var toast = {
      show: function show() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        // destroy watcher
        watcher && watcher();
        if (typeof options === 'string') {
          Object(__WEBPACK_IMPORTED_MODULE_3__libs_plugin_helper__["a" /* mergeOptions */])($vm, __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, pluginOptions, { text: options }));
        } else if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_3__libs_plugin_helper__["a" /* mergeOptions */])($vm, __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({}, pluginOptions, options));
        }
        if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object' && options.onShow || options.onHide) {
          watcher = $vm.$watch('show', function (val) {
            val && options.onShow && options.onShow($vm);
            val === false && options.onHide && options.onHide($vm);
          });
        }
        $vm.show = true;
      },
      text: function text(_text) {
        var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

        this.show({
          type: 'text',
          width: 'auto',
          position: position,
          text: _text
        });
      },
      hide: function hide() {
        $vm.show = false;
      },
      isVisible: function isVisible() {
        return $vm.show;
      }
    };

    // all Vux's plugins are included in this.$vux
    if (!vue.$vux) {
      vue.$vux = {
        toast: toast
      };
    } else {
      vue.$vux.toast = toast;
    }

    vue.mixin({
      created: function created() {
        this.$vux = vue.$vux;
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (plugin);
var install = plugin.install;

/***/ }),

/***/ "3C/1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("qCoq");
__webpack_require__("UvrK");
__webpack_require__("Xjd4");
__webpack_require__("bqnK");
module.exports = __webpack_require__("FeBl").Map;


/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "3NE9":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("wj1U"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),

/***/ "3fs2":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "4WTo":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("NWt+");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "4mcu":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "4pyl":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("wj1U"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5PlU":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("RY/4");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var Iterators = __webpack_require__("/bQp");
module.exports = __webpack_require__("FeBl").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "5Pol":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("wj1U"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BwfY"), __esModule: true };

/***/ }),

/***/ "5zde":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zQR9");
__webpack_require__("qyJz");
module.exports = __webpack_require__("FeBl").Array.from;


/***/ }),

/***/ "601f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var idGenerator     = options.idGenerator;
    var getState        = options.stateHandler.getState;

    /**
     * Gets the resize detector id of the element.
     * @public
     * @param {element} element The target element to get the id of.
     * @returns {string|number|null} The id of the element. Null if it has no id.
     */
    function getId(element) {
        var state = getState(element);

        if (state && state.id !== undefined) {
            return state.id;
        }

        return null;
    }

    /**
     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
     * @public
     * @param {element} element The target element to set the id of.
     * @returns {string|number|null} The id of the element.
     */
    function setId(element) {
        var state = getState(element);

        if (!state) {
            throw new Error("setId required the element to have a resize detection state.");
        }

        var id = idGenerator.generate();

        state.id = id;

        return id;
    }

    return {
        get: getId,
        set: setId
    };
};


/***/ }),

/***/ "63CM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__("BEQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
// Thanks to: https://github.com/calebroseland/vue-dom-portal


/**
 * Get target DOM Node
 * @param {(Node|string|Boolean)} [node=document.body] DOM Node, CSS selector, or Boolean
 * @return {Node} The target that the el will be appended to
 */
function getTarget(node) {
  if (node === void 0) {
    return document.body;
  }

  if (typeof node === 'string' && node.indexOf('?') === 0) {
    return document.body;
  } else if (typeof node === 'string' && node.indexOf('?') > 0) {
    node = node.split('?')[0];
  }

  if (node === 'body' || node === true) {
    return document.body;
  }

  return node instanceof window.Node ? node : document.querySelector(node);
}

function getShouldUpdate(node) {
  // do not updated by default
  if (!node) {
    return false;
  }
  if (typeof node === 'string' && node.indexOf('?') > 0) {
    try {
      var config = JSON.parse(node.split('?')[1]);
      return config.autoUpdate || false;
    } catch (e) {
      return false;
    }
  }
  return false;
}

var directive = {
  inserted: function inserted(el, _ref, vnode) {
    var value = _ref.value;

    el.className = el.className ? el.className + ' v-transfer-dom' : 'v-transfer-dom';
    var parentNode = el.parentNode;
    var home = document.createComment('');
    var hasMovedOut = false;

    if (value !== false) {
      parentNode.replaceChild(home, el); // moving out, el is no longer in the document
      getTarget(value).appendChild(el); // moving into new place
      hasMovedOut = true;
    }
    if (!el.__transferDomData) {
      el.__transferDomData = {
        parentNode: parentNode,
        home: home,
        target: getTarget(value),
        hasMovedOut: hasMovedOut
      };
    }
  },
  componentUpdated: function componentUpdated(el, _ref2) {
    var value = _ref2.value;

    var shouldUpdate = getShouldUpdate(value);
    if (!shouldUpdate) {
      return;
    }
    // need to make sure children are done updating (vs. `update`)
    var ref$1 = el.__transferDomData;
    // homes.get(el)
    var parentNode = ref$1.parentNode;
    var home = ref$1.home;
    var hasMovedOut = ref$1.hasMovedOut; // recall where home is

    if (!hasMovedOut && value) {
      // remove from document and leave placeholder
      parentNode.replaceChild(home, el);
      // append to target
      getTarget(value).appendChild(el);
      el.__transferDomData = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, el.__transferDomData, { hasMovedOut: true, target: getTarget(value) });
    } else if (hasMovedOut && value === false) {
      // previously moved, coming back home
      parentNode.replaceChild(el, home);
      el.__transferDomData = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, el.__transferDomData, { hasMovedOut: false, target: getTarget(value) });
    } else if (value) {
      // already moved, going somewhere else
      getTarget(value).appendChild(el);
    }
  },

  unbind: function unbind(el, binding) {
    el.className = el.className.replace('v-transfer-dom', '');
    if (el.__transferDomData && el.__transferDomData.hasMovedOut === true) {
      el.__transferDomData.parentNode && el.__transferDomData.parentNode.appendChild(el);
    }
    el.__transferDomData = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (directive);

/***/ }),

/***/ "6qVS":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Vue; });
/* unused harmony export defineAsyncComponent */
/* unused harmony export defineComponent */
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* unused harmony export inject */
/* unused harmony export isProxy */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export isShallow */
/* unused harmony export markRaw */
/* unused harmony export mergeDefaults */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* unused harmony export onMounted */
/* unused harmony export onRenderTracked */
/* unused harmony export onRenderTriggered */
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* unused harmony export ref */
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCssModule */
/* unused harmony export useCssVars */
/* unused harmony export useListeners */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, null, 2)
            : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys$1(modules) {
    return modules
        .reduce(function (keys, m) {
        return keys.concat(m.staticKeys || []);
    }, [])
        .join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                global['process'] && global['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
        'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function (target, key) {
        warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") +
            'referenced during render. Make sure that this property is reactive, ' +
            'either in the data option, or for class-based components, by ' +
            'initializing the property. ' +
            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function (target, key) {
        warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
            'prevent conflicts with Vue internals. ' +
            'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function (target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                }
                else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function (target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) ||
                (typeof key === 'string' &&
                    key.charAt(0) === '_' &&
                    !(key in target.$data));
            if (!has && !isAllowed) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        }
        else {
            vm._renderProxy = vm;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function () {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) { return s; });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(__assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) { return s; });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) { return a.id - b.id; });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                target: this,
                key: method
            });
        }
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */ &&
        !isRef(value) &&
        !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            }
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */,
            target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    }
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' &&
            warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */,
            target: target,
            key: key
        });
    }
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn$2("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn$2("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep &&
            ref.dep.notify({
                type: "set" /* TriggerOpTypes.SET */,
                target: ref,
                key: 'value'
            });
    }
    else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */,
                key: 'value'
            });
        }
        else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */,
                key: 'value'
            });
        }
        else {
            dep.notify();
        }
    }), get = _a.get, set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn$2("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Vue 2 does not support readonly arrays.");
            }
            else if (isCollectionType(target)) {
                warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
            }
            else {
                warn$2("value cannot be made readonly: ".concat(typeof target));
            }
        }
        return target;
    }
    if (false) {
        warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function () {
            "production" !== 'production' &&
                warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false
            ? function () {
                warn$2('Write operation failed: computed value is readonly');
            }
            : noop;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering()
        ? null
        : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */,
                            key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            }
            else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
        // @ts-ignore
        perf_1.mark &&
        // @ts-ignore
        perf_1.measure &&
        // @ts-ignore
        perf_1.clearMarks &&
        // @ts-ignore
        perf_1.clearMeasures) {
        mark = function (tag) { return perf_1.mark(tag); };
        measure = function (name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' &&
                warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                        "".concat(formatComponentName(
                        // @ts-expect-error tag is string
                        tag || Ctor), ", but the declared prop name is") +
                        " \"".concat(key, "\". ") +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' &&
            warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn$2('Avoid using non-primitive value as key, ' +
            'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn$2('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' &&
                warn$2('v-bind without argument expects an Object or Array value', this);
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic$1(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic$1(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn$2('v-on without argument expects an Object value', this);
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (false) {
            // null is a special value for explicitly removing a binding
            warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn$2("setup() should not return VNodes directly - " +
                    "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (false) {
                        warn$2("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (false) {
            warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function (exposed) {
            if (false) {
                if (exposeCalled) {
                    warn$2("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn$2("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw)
        ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
        : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if (false) {
            warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
        }, true);
    }
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                }
                catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            }
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn$2('Multiple root nodes returned from render function. Render function ' +
                    'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' &&
                warn$2("Failed to resolve async component: ".concat(String(factory)) +
                    (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                    "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                    "Note that HTML attributes are case-insensitive and you cannot use " +
                    "v-on to listen to camelCase events when using in-DOM templates. " +
                    "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                vm.$options.el ||
                el) {
                warn$2('You are using the runtime-only build of Vue where the template ' +
                    'compiler is not available. Either pre-compile the templates into ' +
                    'render functions, or use the compiler-included build.', vm);
            }
            else {
                warn$2('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function () {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    }
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
        watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index$1 = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index$1 = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue.length; index$1++) {
        watcher = queue[index$1];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn$2('You may have an infinite update loop ' +
                    (watcher.user
                        ? "in watcher with expression \"".concat(watcher.expression, "\"")
                        : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index$1 && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'post' }) : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'sync' }) : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn$2("`watch(fn, options?)` signature has been moved to a separate API. " +
            "Use `watchEffect(fn, options?)` instead. `watch` now only " +
            "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn$2("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn$2("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function (s) {
        warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
            "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function (fn, type, args) {
        if (args === void 0) { args = null; }
        return invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                }
                else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return call(source, WATCHER_GETTER); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    }
    else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            call(cb, WATCHER_CB, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                    })
                    : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    }
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () { return queueWatcher(watcher); };
    }
    else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0)
                    buffer.push(watcher);
            }
            else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        }
        else {
            oldValue = watcher.get();
        }
    }
    else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () { return watcher.get(); });
    }
    else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (false) {
            warn$2("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}());
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if (false) {
        warn$2("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn$2("provide() can only be used inside setup().");
        }
    }
    else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue)
                ? defaultValue.call(instance)
                : defaultValue;
        }
        else if (false) {
            warn$2("injection \"".concat(String(key), "\" not found."));
        }
    }
    else if (false) {
        warn$2("inject() can only be used inside setup() or functional components.");
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' &&
            warn$2("globally imported h() can only be invoked when there is an active " +
                "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) { name = '$style'; }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn$2("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' &&
                warn$2("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false)
        return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' &&
            warn$2("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$2("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$2("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) { target = currentInstance; }
        if (!target) {
            "production" !== 'production' &&
                warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") +
                    "associated with. " +
                    "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    }
    else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.14';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        val.__v_skip /* ReactiveFlags.SKIP */ ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' &&
                    warn$2("Failed watching path: \"".concat(expOrFn, "\" ") +
                        'Watcher only accepts simple dot-delimited paths. ' +
                        'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) ||
                config.isReservedAttr(hyphenatedKey)) {
                warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn$2("Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            });
        }
        else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' &&
            warn$2('data functions should return an object:\n' +
                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' &&
                warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") +
                    "Use prop default value instead.", vm);
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (false) {
            if (key in vm.$data) {
                warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
            }
            else if (vm.$options.props && key in vm.$options.props) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            }
            else if (vm.$options.methods && key in vm.$options.methods) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn$2("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                    "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                    "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn$2('Avoid replacing instance root $data. ' +
                'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn$2("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn$2("Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        "injection being mutated: \"".concat(key, "\""), vm);
                });
            }
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (false) {
                warn$2("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        }
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
            renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn$2 = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function (str) {
        return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
    };
    warn$2 = function (msg, vm) {
        if (vm === void 0) { vm = currentInstance; }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        }
        else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function (msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function (vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null
            ? vm.options
            : vm._isVue
                ? vm.$options || vm.constructor.options
                : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
            (file && includeFile !== false ? " at ".concat(file) : ''));
    };
    var repeat_1 = function (str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1)
                res += str;
            if (n > 1)
                str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function (vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    }
                    else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return ('\n\nfound in\n\n' +
                tree
                    .map(function (vm, i) {
                    return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                        ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                        : formatComponentName(vm));
                })
                    .join('\n'));
        }
        else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn$2("option \"".concat(key, "\" can only be used during instance ") +
                'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' &&
                warn$2('The "data" option should be a function ' +
                    'that returns a per-instance value in component ' +
                    'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && "production" !== 'production') {
                        assertObjectType(key, childVal, vm);
                    }
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = function (parentVal, childVal) {
    if (!parentVal)
        return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn$2('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn$2('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (false) {
                warn$2('props must be strings when using array syntax.');
            }
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"props\": expected an Array or an Object, " +
            "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"inject\": expected an Array or an Object, " +
            "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn$2('Invalid default value for prop "' +
            key +
            '": ' +
            'Props with type Object/Array must use a factory function ' +
            'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

function Vue(options) {
    if (false) {
        warn$2('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config; };
    if (false) {
        configDef.set = function () {
            warn$2('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn$2,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isPreTag = function (tag) { return tag === 'pre'; };
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (false) {
            warn$2("Invalid template ref type: ".concat(typeof ref));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config.ignoredElements.length &&
                config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2('Unknown custom element: <' +
                        tag +
                        '> - did you ' +
                        'register the component correctly? For recursive components, ' +
                        'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (false) {
                            warn$2('The client-side rendered virtual DOM tree is not matching ' +
                                'server-rendered content. This is likely caused by incorrect ' +
                                'HTML markup, for example nesting block-level elements inside ' +
                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives$1 = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives$1];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass$1 = {
    create: updateClass,
    update: updateClass
};

var validDivisionCharRE = /[\w).+\-_$\]]/;
function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c)
                inSingle = false;
        }
        else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c)
                inDouble = false;
        }
        else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c)
                inTemplateString = false;
        }
        else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c)
                inRegex = false;
        }
        else if (c === 0x7c && // pipe
            exp.charCodeAt(i + 1) !== 0x7c &&
            exp.charCodeAt(i - 1) !== 0x7c &&
            !curly &&
            !square &&
            !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            }
            else {
                pushFilter();
            }
        }
        else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                var j = i - 1;
                var p 
                // find first non-whitespace prev char
                = void 0;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ')
                        break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    }
    else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) {
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i]);
        }
    }
    return expression;
}
function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
        // _f: resolveFilter
        return "_f(\"".concat(filter, "\")(").concat(exp, ")");
    }
    else {
        var name_1 = filter.slice(0, i);
        var args = filter.slice(i + 1);
        return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
    }
}

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
    console.error("[Vue compiler]: ".concat(msg));
}
/* eslint-enable no-unused-vars */
function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; }) : [];
}
function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic
        ? el.dynamicAttrs || (el.dynamicAttrs = [])
        : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}
function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
}
function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (false) {
        warn("passive and prevent can't be used together. " +
            "Passive handler can't prevent default event.", range);
    }
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    }
    else if (modifiers.middle) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'mouseup';
        }
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
        delete modifiers.passive;
        name = prependModifierMarker('&', name, dynamic);
    }
    var events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    }
    else {
        events = el.events || (el.events = {});
    }
    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
        newHandler.modifiers = modifiers;
    }
    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
        important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    }
    else if (handlers) {
        events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    }
    else {
        events[name] = newHandler;
    }
    el.plain = false;
}
function getRawBindingAttr(el, name) {
    return (el.rawAttrsMap[':' + name] ||
        el.rawAttrsMap['v-bind:' + name] ||
        el.rawAttrsMap[name]);
}
function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
        return parseFilters(dynamicValue);
    }
    else if (getStatic !== false) {
        var staticValue = getAndRemoveAttr(el, name);
        if (staticValue != null) {
            return JSON.stringify(staticValue);
        }
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
        var list = el.attrsList;
        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i].name === name) {
                list.splice(i, 1);
                break;
            }
        }
    }
    if (removeFromMap) {
        delete el.attrsMap[name];
    }
    return val;
}
function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
        var attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) {
            item.start = range.start;
        }
        if (range.end != null) {
            item.end = range.end;
        }
    }
    return item;
}

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
    var _a = modifiers || {}, number = _a.number, trim = _a.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
        valueExpression =
            "(typeof ".concat(baseValueExpression, " === 'string'") +
                "? ".concat(baseValueExpression, ".trim()") +
                ": ".concat(baseValueExpression, ")");
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
        value: "(".concat(value, ")"),
        expression: JSON.stringify(value),
        callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
    var res = parseModel(value);
    if (res.key === null) {
        return "".concat(value, "=").concat(assignment);
    }
    else {
        return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
    }
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */
var len, str, chr, index, expressionPos, expressionEndPos;
function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
        index = val.lastIndexOf('.');
        if (index > -1) {
            return {
                exp: val.slice(0, index),
                key: '"' + val.slice(index + 1) + '"'
            };
        }
        else {
            return {
                exp: val,
                key: null
            };
        }
    }
    str = val;
    index = expressionPos = expressionEndPos = 0;
    while (!eof()) {
        chr = next();
        /* istanbul ignore if */
        if (isStringStart(chr)) {
            parseString(chr);
        }
        else if (chr === 0x5b) {
            parseBracket(chr);
        }
    }
    return {
        exp: val.slice(0, expressionPos),
        key: val.slice(expressionPos + 1, expressionEndPos)
    };
}
function next() {
    return str.charCodeAt(++index);
}
function eof() {
    return index >= len;
}
function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index;
    while (!eof()) {
        chr = next();
        if (isStringStart(chr)) {
            parseString(chr);
            continue;
        }
        if (chr === 0x5b)
            inBracket++;
        if (chr === 0x5d)
            inBracket--;
        if (inBracket === 0) {
            expressionEndPos = index;
            break;
        }
    }
}
function parseString(chr) {
    var stringQuote = chr;
    while (!eof()) {
        chr = next();
        if (chr === stringQuote) {
            break;
        }
    }
}

var warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';
function model$1(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    if (false) {
        // inputs with type="file" are read only and setting the input's
        // value will throw an error.
        if (tag === 'input' && type === 'file') {
            warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") +
                "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
        }
    }
    if (el.component) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (tag === 'select') {
        genSelect(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'checkbox') {
        genCheckboxModel(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'radio') {
        genRadioModel(el, value, modifiers);
    }
    else if (tag === 'input' || tag === 'textarea') {
        genDefaultModel(el, value, modifiers);
    }
    else if (!config.isReservedTag(tag)) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (false) {
        warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
            "v-model is not supported on this element type. " +
            "If you are working with contenteditable, it's recommended to " +
            'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    }
    // ensure runtime directive metadata
    return true;
}
function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(".concat(value, ")") +
        "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
        (trueValueBinding === 'true'
            ? ":(".concat(value, ")")
            : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
    addHandler(el, 'change', "var $$a=".concat(value, ",") +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") +
        'if(Array.isArray($$a)){' +
        "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") +
        '$$i=_i($$a,$$v);' +
        "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") +
        "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") +
        "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
}
function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
    addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}
function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" +
        ".call($event.target.options,function(o){return o.selected})" +
        ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
        "return ".concat(number ? '_n(val)' : 'val', "})");
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = ".concat(selectedVal, ";");
    code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
}
function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    if (false) {
        var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value_1 && !typeBinding) {
            var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") +
                'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    var _a = modifiers || {}, lazy = _a.lazy, number = _a.number, trim = _a.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';
    if (trim) {
        valueExpression = "$event.target.value.trim()";
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
        code = "if($event.target.composing)return;".concat(code);
    }
    addProp(el, 'value', "(".concat(value, ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
        addHandler(el, 'blur', '$forceUpdate()');
    }
}

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style$1 = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn$2("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules$1 = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' &&
            warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                    .call(value)
                    .slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn$2('<transition> can only be used on a single element. Use ' +
                '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn$2('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts
                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
                        : c.tag;
                    warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                    'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                "Make sure to turn on production mode when deploying for production.\n" +
                "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function parseText(text, delimiters) {
    //@ts-expect-error
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
        return;
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = (tagRE.lastIndex = 0);
    var match, index, tokenValue;
    while ((match = tagRE.exec(text))) {
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push((tokenValue = text.slice(lastIndex, index)));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        var exp = parseFilters(match[1].trim());
        tokens.push("_s(".concat(exp, ")"));
        rawTokens.push({ '@binding': exp });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push((tokenValue = text.slice(lastIndex)));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}

function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (false) {
        var res = parseText(staticClass, options.delimiters);
        if (res) {
            warn("class=\"".concat(staticClass, "\": ") +
                'Interpolation inside attributes has been removed. ' +
                'Use v-bind or the colon shorthand instead. For example, ' +
                'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
        }
    }
    if (staticClass) {
        el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
        el.classBinding = classBinding;
    }
}
function genData$2(el) {
    var data = '';
    if (el.staticClass) {
        data += "staticClass:".concat(el.staticClass, ",");
    }
    if (el.classBinding) {
        data += "class:".concat(el.classBinding, ",");
    }
    return data;
}
var klass = {
    staticKeys: ['staticClass'],
    transformNode: transformNode$1,
    genData: genData$2
};

function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */
        if (false) {
            var res = parseText(staticStyle, options.delimiters);
            if (res) {
                warn("style=\"".concat(staticStyle, "\": ") +
                    'Interpolation inside attributes has been removed. ' +
                    'Use v-bind or the colon shorthand instead. For example, ' +
                    'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
            }
        }
        el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }
    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
        el.styleBinding = styleBinding;
    }
}
function genData$1(el) {
    var data = '';
    if (el.staticStyle) {
        data += "staticStyle:".concat(el.staticStyle, ",");
    }
    if (el.styleBinding) {
        data += "style:(".concat(el.styleBinding, "),");
    }
    return data;
}
var style = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode,
    genData: genData$1
};

var decoder;
var he = {
    decode: function (html) {
        decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
    }
};

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
    'link,meta,param,source,track,wbr');
// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
    'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
    'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
    'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
    'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */
// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
var startTagOpen = new RegExp("^<".concat(qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};
var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};
function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) { return decodingMap[match]; });
}
function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag = options.isUnaryTag || no;
    var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    var _loop_1 = function () {
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !isPlainTextElement(lastTag)) {
            var textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if (comment.test(html)) {
                    var commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) {
                            options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        }
                        advance(commentEnd + 3);
                        return "continue";
                    }
                }
                // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        return "continue";
                    }
                }
                // Doctype:
                var doctypeMatch = html.match(doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                }
                // End tag:
                var endTagMatch = html.match(endTag);
                if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                }
                // Start tag:
                var startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                        advance(1);
                    }
                    return "continue";
                }
            }
            var text = void 0, rest = void 0, next = void 0;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while (!endTag.test(rest) &&
                    !startTagOpen.test(rest) &&
                    !comment.test(rest) &&
                    !conditionalComment.test(rest)) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0)
                        break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) {
                text = html;
            }
            if (text) {
                advance(text.length);
            }
            if (options.chars && text) {
                options.chars(text, index - text.length, index);
            }
        }
        else {
            var endTagLength_1 = 0;
            var stackedTag_1 = lastTag.toLowerCase();
            var reStackedTag = reCache[stackedTag_1] ||
                (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
            var rest = html.replace(reStackedTag, function (all, text, endTag) {
                endTagLength_1 = endTag.length;
                if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                    text = text
                        .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                        .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                }
                if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                    text = text.slice(1);
                }
                if (options.chars) {
                    options.chars(text);
                }
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag_1, index - endTagLength_1, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (false) {
                options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                    start: index + html.length
                });
            }
            return "break";
        }
    };
    while (html) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        var start = html.match(startTagOpen);
        if (start) {
            var match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            var end = void 0, attr = void 0;
            while (!(end = html.match(startTagClose)) &&
                (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        var tagName = match.tagName;
        var unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                parseEndTag(lastTag);
            }
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                parseEndTag(tagName);
            }
        }
        var unary = isUnaryTag(tagName) || !!unarySlash;
        var l = match.attrs.length;
        var attrs = new Array(l);
        for (var i = 0; i < l; i++) {
            var args = match.attrs[i];
            var value = args[3] || args[4] || args[5] || '';
            var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
                ? options.shouldDecodeNewlinesForHref
                : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: decodeAttr(value, shouldDecodeNewlines)
            };
            if (false) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) {
            options.start(tagName, attrs, unary, match.start, match.end);
        }
    }
    function parseEndTag(tagName, start, end) {
        var pos, lowerCasedTagName;
        if (start == null)
            start = index;
        if (end == null)
            end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                }
            }
        }
        else {
            // If no tag name is provided, clean shop
            pos = 0;
        }
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (false) {
                    options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                        start: stack[i].start,
                        end: stack[i].end
                    });
                }
                if (options.end) {
                    options.end(stack[i].tag, start, end);
                }
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        }
        else if (lowerCasedTagName === 'br') {
            if (options.start) {
                options.start(tagName, [], true, start, end);
            }
        }
        else if (lowerCasedTagName === 'p') {
            if (options.start) {
                options.start(tagName, [], false, start, end);
            }
            if (options.end) {
                options.end(tagName, start, end);
            }
        }
    }
}

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;
var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
var slotRE = /^v-slot(:|$)|^#/;
var lineBreakRE = /[\r\n]/;
var whitespaceRE = /[ \f\t\r\n]+/g;
var invalidAttributeRE = /[\s"'<>\/=]/;
var decodeHTMLCached = cached(he.decode);
var emptySlotScopeToken = "_empty_";
// configurable state
var warn;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;
function createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
    warn = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function (el) {
        return !!(el.component ||
            el.attrsMap[':is'] ||
            el.attrsMap['v-bind:is'] ||
            !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };
    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) {
            element = processElement(element, options);
        }
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                if (false) {
                    checkRootConstraints(element);
                }
                addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            }
            else if (false) {
                warnOnce("Component template should contain exactly one root element. " +
                    "If you are using v-if on multiple elements, " +
                    "use v-else-if to chain them instead.", { start: element.start });
            }
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) {
                processIfConditions(element, currentParent);
            }
            else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter(function (c) { return !c.slotScope; });
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) {
            inVPre = false;
        }
        if (platformIsPreTag(element.tag)) {
            inPre = false;
        }
        // apply post-transforms
        for (var i = 0; i < postTransforms.length; i++) {
            postTransforms[i](element, options);
        }
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            var lastNode = void 0;
            while ((lastNode = el.children[el.children.length - 1]) &&
                lastNode.type === 3 &&
                lastNode.text === ' ') {
                el.children.pop();
            }
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") +
                'contain multiple nodes.', { start: el.start });
        }
        if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' +
                'it renders multiple elements.', el.rawAttrsMap['v-for']);
        }
    }
    parseHTML(template, {
        warn: warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start: function (tag, attrs, unary, start, end) {
            // check namespace.
            // inherit parent ns if there is one
            var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */
            if (isIE && ns === 'svg') {
                attrs = guardIESVGBug(attrs);
            }
            var element = createASTElement(tag, attrs, currentParent);
            if (ns) {
                element.ns = ns;
            }
            if (false) {
                if (options.outputSourceRange) {
                    element.start = start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                        cumulated[attr.name] = attr;
                        return cumulated;
                    }, {});
                }
                attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                        warn("Invalid dynamic argument expression: attribute names cannot contain " +
                            "spaces, quotes, <, >, / or =.", options.outputSourceRange
                            ? {
                                start: attr.start + attr.name.indexOf("["),
                                end: attr.start + attr.name.length
                            }
                            : undefined);
                    }
                });
            }
            if (isForbiddenTag(element) && !isServerRendering()) {
                element.forbidden = true;
                "production" !== 'production' &&
                    warn('Templates should only be responsible for mapping the state to the ' +
                        'UI. Avoid placing tags with side-effects in your templates, such as ' +
                        "<".concat(tag, ">") +
                        ', as they will not be parsed.', { start: element.start });
            }
            // apply pre-transforms
            for (var i = 0; i < preTransforms.length; i++) {
                element = preTransforms[i](element, options) || element;
            }
            if (!inVPre) {
                processPre(element);
                if (element.pre) {
                    inVPre = true;
                }
            }
            if (platformIsPreTag(element.tag)) {
                inPre = true;
            }
            if (inVPre) {
                processRawAttrs(element);
            }
            else if (!element.processed) {
                // structural directives
                processFor(element);
                processIf(element);
                processOnce(element);
            }
            if (!root) {
                root = element;
                if (false) {
                    checkRootConstraints(root);
                }
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            }
            else {
                closeElement(element);
            }
        },
        end: function (tag, start, end) {
            var element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (false) {
                element.end = end;
            }
            closeElement(element);
        },
        chars: function (text, start, end) {
            if (!currentParent) {
                if (false) {
                    if (text === template) {
                        warnOnce('Component template requires a root element, rather than just text.', { start: start });
                    }
                    else if ((text = text.trim())) {
                        warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                            start: start
                        });
                    }
                }
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */
            if (isIE &&
                currentParent.tag === 'textarea' &&
                currentParent.attrsMap.placeholder === text) {
                return;
            }
            var children = currentParent.children;
            if (inPre || text.trim()) {
                text = isTextTag(currentParent)
                    ? text
                    : decodeHTMLCached(text);
            }
            else if (!children.length) {
                // remove the whitespace-only node right after an opening tag
                text = '';
            }
            else if (whitespaceOption) {
                if (whitespaceOption === 'condense') {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? '' : ' ';
                }
                else {
                    text = ' ';
                }
            }
            else {
                text = preserveWhitespace ? ' ' : '';
            }
            if (text) {
                if (!inPre && whitespaceOption === 'condense') {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, ' ');
                }
                var res = void 0;
                var child = void 0;
                if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                    child = {
                        type: 2,
                        expression: res.expression,
                        tokens: res.tokens,
                        text: text
                    };
                }
                else if (text !== ' ' ||
                    !children.length ||
                    children[children.length - 1].text !== ' ') {
                    child = {
                        type: 3,
                        text: text
                    };
                }
                if (child) {
                    if (false) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment: function (text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                var child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (false) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
        el.pre = true;
    }
}
function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
        var attrs = (el.attrs = new Array(len));
        for (var i = 0; i < len; i++) {
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    }
    else if (!el.pre) {
        // non root node in pre blocks with no attributes
        el.plain = true;
    }
}
function processElement(element, options) {
    processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain =
        !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
        element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element;
}
function processKey(el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
        if (false) {
            if (el.tag === 'template') {
                warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
            }
            if (el.for) {
                var iterator = el.iterator2 || el.iterator1;
                var parent_1 = el.parent;
                if (iterator &&
                    iterator === exp &&
                    parent_1 &&
                    parent_1.tag === 'transition-group') {
                    warn("Do not use v-for index as key on <transition-group> children, " +
                        "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                }
            }
        }
        el.key = exp;
    }
}
function processRef(el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = checkInFor(el);
    }
}
function processFor(el) {
    var exp;
    if ((exp = getAndRemoveAttr(el, 'v-for'))) {
        var res = parseFor(exp);
        if (res) {
            extend(el, res);
        }
        else if (false) {
            warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
        }
    }
}
function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch)
        return;
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace(forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) {
            res.iterator2 = iteratorMatch[2].trim();
        }
    }
    else {
        res.alias = alias;
    }
    return res;
}
function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        addIfCondition(el, {
            exp: exp,
            block: el
        });
    }
    else {
        if (getAndRemoveAttr(el, 'v-else') != null) {
            el.else = true;
        }
        var elseif = getAndRemoveAttr(el, 'v-else-if');
        if (elseif) {
            el.elseif = elseif;
        }
    }
}
function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
        addIfCondition(prev, {
            exp: el.elseif,
            block: el
        });
    }
    else if (false) {
        warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") +
            "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
}
function findPrevElement(children) {
    var i = children.length;
    while (i--) {
        if (children[i].type === 1) {
            return children[i];
        }
        else {
            if (false) {
                warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") +
                    "will be ignored.", children[i]);
            }
            children.pop();
        }
    }
}
function addIfCondition(el, condition) {
    if (!el.ifConditions) {
        el.ifConditions = [];
    }
    el.ifConditions.push(condition);
}
function processOnce(el) {
    var once = getAndRemoveAttr(el, 'v-once');
    if (once != null) {
        el.once = true;
    }
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
    var slotScope;
    if (el.tag === 'template') {
        slotScope = getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */
        if (false) {
            warn("the \"scope\" attribute for scoped slots have been deprecated and " +
                "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
                "can also be used on plain elements in addition to <template> to " +
                "denote scoped slots.", el.rawAttrsMap['scope'], true);
        }
        el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    }
    else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
        /* istanbul ignore if */
        if (false) {
            warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") +
                "(v-for takes higher priority). Use a wrapper <template> for the " +
                "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
        }
        el.slotScope = slotScope;
    }
    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) {
            addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
        }
    }
    // 2.6 v-slot syntax
    {
        if (el.tag === 'template') {
            // v-slot on <template>
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (el.slotTarget || el.slotScope) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                        warn("<template v-slot> can only appear at the root level inside " +
                            "the receiving component", el);
                    }
                }
                var _a = getSlotName(slotBinding), name_2 = _a.name, dynamic = _a.dynamic;
                el.slotTarget = name_2;
                el.slotTargetDynamic = dynamic;
                el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
            }
        }
        else {
            // v-slot on component, denotes default slot
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (!maybeComponent(el)) {
                        warn("v-slot can only be used on components or <template>.", slotBinding);
                    }
                    if (el.slotScope || el.slotTarget) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.scopedSlots) {
                        warn("To avoid scope ambiguity, the default slot should also use " +
                            "<template> syntax when there are other named slots.", slotBinding);
                    }
                }
                // add the component's children to its default slot
                var slots = el.scopedSlots || (el.scopedSlots = {});
                var _b = getSlotName(slotBinding), name_3 = _b.name, dynamic = _b.dynamic;
                var slotContainer_1 = (slots[name_3] = createASTElement('template', [], el));
                slotContainer_1.slotTarget = name_3;
                slotContainer_1.slotTargetDynamic = dynamic;
                slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                        c.parent = slotContainer_1;
                        return true;
                    }
                });
                slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                // remove children as they are returned from scopedSlots now
                el.children = [];
                // mark el non-plain so data gets generated
                el.plain = false;
            }
        }
    }
}
function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') {
            name = 'default';
        }
        else if (false) {
            warn("v-slot shorthand syntax requires a slot name.", binding);
        }
    }
    return dynamicArgRE.test(name)
        ? // dynamic [name]
            { name: name.slice(1, -1), dynamic: true }
        : // static name
            { name: "\"".concat(name, "\""), dynamic: false };
}
// handle <slot/> outlets
function processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = getBindingAttr(el, 'name');
        if (false) {
            warn("`key` does not work on <slot> because slots are abstract outlets " +
                "and can possibly expand into multiple elements. " +
                "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
        }
    }
}
function processComponent(el) {
    var binding;
    if ((binding = getBindingAttr(el, 'is'))) {
        el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
        el.inlineTemplate = true;
    }
}
function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
        name = rawName = list[i].name;
        value = list[i].value;
        if (dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = parseModifiers(name.replace(dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) {
                name = name.replace(modifierRE, '');
            }
            if (bindRE.test(name)) {
                // v-bind
                name = name.replace(bindRE, '');
                value = parseFilters(value);
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                if (false) {
                    warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                }
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = camelize(name);
                        if (name === 'innerHtml')
                            name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) {
                        name = camelize(name);
                    }
                    if (modifiers.sync) {
                        syncGen = genAssignmentCode(value, "$event");
                        if (!isDynamic) {
                            addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                            if (hyphenate(name) !== camelize(name)) {
                                addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                            }
                        }
                        else {
                            // handler w/ dynamic event name
                            addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                            );
                        }
                    }
                }
                if ((modifiers && modifiers.prop) ||
                    (!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name))) {
                    addProp(el, name, value, list[i], isDynamic);
                }
                else {
                    addAttr(el, name, value, list[i], isDynamic);
                }
            }
            else if (onRE.test(name)) {
                // v-on
                name = name.replace(onRE, '');
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
            }
            else {
                // normal directives
                name = name.replace(dirRE, '');
                // parse arg
                var argMatch = name.match(argRE);
                var arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (false) {
                    checkForAliasModel(el, value);
                }
            }
        }
        else {
            // literal attribute
            if (false) {
                var res = parseText(value, delimiters);
                if (res) {
                    warn("".concat(name, "=\"").concat(value, "\": ") +
                        'Interpolation inside attributes has been removed. ' +
                        'Use v-bind or the colon shorthand instead. For example, ' +
                        'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                }
            }
            addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component &&
                name === 'muted' &&
                platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                addProp(el, name, 'true', list[i]);
            }
        }
    }
}
function checkInFor(el) {
    var parent = el;
    while (parent) {
        if (parent.for !== undefined) {
            return true;
        }
        parent = parent.parent;
    }
    return false;
}
function parseModifiers(name) {
    var match = name.match(modifierRE);
    if (match) {
        var ret_1 = {};
        match.forEach(function (m) {
            ret_1[m.slice(1)] = true;
        });
        return ret_1;
    }
}
function makeAttrsMap(attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
        if (false) {
            warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        }
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function isForbiddenTag(el) {
    return (el.tag === 'style' ||
        (el.tag === 'script' &&
            (!el.attrsMap.type || el.attrsMap.type === 'text/javascript')));
}
var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */
function guardIESVGBug(attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (!ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace(ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function checkForAliasModel(el, value) {
    var _el = el;
    while (_el) {
        if (_el.for && _el.alias === value) {
            warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
                "You are binding v-model directly to a v-for iteration alias. " +
                "This will not be able to modify the v-for source array because " +
                "writing to the alias is like modifying a function local variable. " +
                "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
        }
        _el = _el.parent;
    }
}

/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */
function preTransformNode(el, options) {
    if (el.tag === 'input') {
        var map = el.attrsMap;
        if (!map['v-model']) {
            return;
        }
        var typeBinding = void 0;
        if (map[':type'] || map['v-bind:type']) {
            typeBinding = getBindingAttr(el, 'type');
        }
        if (!map.type && !typeBinding && map['v-bind']) {
            typeBinding = "(".concat(map['v-bind'], ").type");
        }
        if (typeBinding) {
            var ifCondition = getAndRemoveAttr(el, 'v-if', true);
            var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
            var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
            var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            var branch0 = cloneASTElement(el);
            // process for on the main node
            processFor(branch0);
            addRawAttr(branch0, 'type', 'checkbox');
            processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
            addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            var branch1 = cloneASTElement(el);
            getAndRemoveAttr(branch1, 'v-for', true);
            addRawAttr(branch1, 'type', 'radio');
            processElement(branch1, options);
            addIfCondition(branch0, {
                exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                block: branch1
            });
            // 3. other
            var branch2 = cloneASTElement(el);
            getAndRemoveAttr(branch2, 'v-for', true);
            addRawAttr(branch2, ':type', typeBinding);
            processElement(branch2, options);
            addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) {
                branch0.else = true;
            }
            else if (elseIfCondition) {
                branch0.elseif = elseIfCondition;
            }
            return branch0;
        }
    }
}
function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var model = {
    preTransformNode: preTransformNode
};

var modules = [klass, style, model];

function text(el, dir) {
    if (dir.value) {
        addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
    }
}

function html(el, dir) {
    if (dir.value) {
        addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
    }
}

var directives = {
    model: model$1,
    text: text,
    html: html
};

var baseOptions = {
    expectHTML: true,
    modules: modules,
    directives: directives,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys$1(modules)
};

var isStaticKey;
var isPlatformReservedTag;
var genStaticKeysCached = cached(genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
    if (!root)
        return;
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
}
function genStaticKeys(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
        (keys ? ',' + keys : ''));
}
function markStatic(node) {
    node.static = isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!isPlatformReservedTag(node.tag) &&
            node.tag !== 'slot' &&
            node.attrsMap['inline-template'] == null) {
            return;
        }
        for (var i = 0, l = node.children.length; i < l; i++) {
            var child = node.children[i];
            markStatic(child);
            if (!child.static) {
                node.static = false;
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                var block = node.ifConditions[i].block;
                markStatic(block);
                if (!block.static) {
                    node.static = false;
                }
            }
        }
    }
}
function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) {
            node.staticInFor = isInFor;
        }
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static &&
            node.children.length &&
            !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        }
        else {
            node.staticRoot = false;
        }
        if (node.children) {
            for (var i = 0, l = node.children.length; i < l; i++) {
                markStaticRoots(node.children[i], isInFor || !!node.for);
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                markStaticRoots(node.ifConditions[i].block, isInFor);
            }
        }
    }
}
function isStatic(node) {
    if (node.type === 2) {
        // expression
        return false;
    }
    if (node.type === 3) {
        // text
        return true;
    }
    return !!(node.pre ||
        (!node.hasBindings && // no dynamic bindings
            !node.if &&
            !node.for && // not v-if or v-for or v-else
            !isBuiltInTag(node.tag) && // not a built-in
            isPlatformReservedTag(node.tag) && // not a component
            !isDirectChildOfTemplateFor(node) &&
            Object.keys(node).every(isStaticKey)));
}
function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
        node = node.parent;
        if (node.tag !== 'template') {
            return false;
        }
        if (node.for) {
            return true;
        }
    }
    return false;
}

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [8, 46]
};
// KeyboardEvent.key aliases
var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: ['Backspace', 'Delete', 'Del']
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return "if(".concat(condition, ")return null;"); };
var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
};
function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name_1 in events) {
        var handlerCode = genHandler(events[name_1]);
        //@ts-expect-error
        if (events[name_1] && events[name_1].dynamic) {
            dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
        }
        else {
            staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
        }
    }
    staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
    if (dynamicHandlers) {
        return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
    }
    else {
        return prefix + staticHandlers;
    }
}
function genHandler(handler) {
    if (!handler) {
        return 'function(){}';
    }
    if (Array.isArray(handler)) {
        return "[".concat(handler.map(function (handler) { return genHandler(handler); }).join(','), "]");
    }
    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) {
            return handler.value;
        }
        return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
    }
    else {
        var code = '';
        var genModifierCode = '';
        var keys = [];
        var _loop_1 = function (key) {
            if (modifierCode[key]) {
                genModifierCode += modifierCode[key];
                // left/right
                if (keyCodes[key]) {
                    keys.push(key);
                }
            }
            else if (key === 'exact') {
                var modifiers_1 = handler.modifiers;
                genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta']
                    .filter(function (keyModifier) { return !modifiers_1[keyModifier]; })
                    .map(function (keyModifier) { return "$event.".concat(keyModifier, "Key"); })
                    .join('||'));
            }
            else {
                keys.push(key);
            }
        };
        for (var key in handler.modifiers) {
            _loop_1(key);
        }
        if (keys.length) {
            code += genKeyFilter(keys);
        }
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) {
            code += genModifierCode;
        }
        var handlerCode = isMethodPath
            ? "return ".concat(handler.value, ".apply(null, arguments)")
            : isFunctionExpression
                ? "return (".concat(handler.value, ").apply(null, arguments)")
                : isFunctionInvocation
                    ? "return ".concat(handler.value)
                    : handler.value;
        return "function($event){".concat(code).concat(handlerCode, "}");
    }
}
function genKeyFilter(keys) {
    return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
        "".concat(keys.map(genFilterCode).join('&&'), ")return null;"));
}
function genFilterCode(key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
        return "$event.keyCode!==".concat(keyVal);
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return ("_k($event.keyCode," +
        "".concat(JSON.stringify(key), ",") +
        "".concat(JSON.stringify(keyCode), ",") +
        "$event.key," +
        "".concat(JSON.stringify(keyName)) +
        ")");
}

function on(el, dir) {
    if (false) {
        warn$2("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) { return "_g(".concat(code, ",").concat(dir.value, ")"); };
}

function bind(el, dir) {
    el.wrapData = function (code) {
        return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
    };
}

var baseDirectives = {
    on: on,
    bind: bind,
    cloak: noop
};

var CodegenState = /** @class */ (function () {
    function CodegenState(options) {
        this.options = options;
        this.warn = options.warn || baseWarn;
        this.transforms = pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
        this.directives = extend(extend({}, baseDirectives), options.directives);
        var isReservedTag = options.isReservedTag || no;
        this.maybeComponent = function (el) {
            return !!el.component || !isReservedTag(el.tag);
        };
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
    return CodegenState;
}());
function generate(ast, options) {
    var state = new CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    var code = ast
        ? ast.tag === 'script'
            ? 'null'
            : genElement(ast, state)
        : '_c("div")';
    return {
        render: "with(this){return ".concat(code, "}"),
        staticRenderFns: state.staticRenderFns
    };
}
function genElement(el, state) {
    if (el.parent) {
        el.pre = el.pre || el.parent.pre;
    }
    if (el.staticRoot && !el.staticProcessed) {
        return genStatic(el, state);
    }
    else if (el.once && !el.onceProcessed) {
        return genOnce(el, state);
    }
    else if (el.for && !el.forProcessed) {
        return genFor(el, state);
    }
    else if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
        return genChildren(el, state) || 'void 0';
    }
    else if (el.tag === 'slot') {
        return genSlot(el, state);
    }
    else {
        // component or element
        var code = void 0;
        if (el.component) {
            code = genComponent(el.component, el, state);
        }
        else {
            var data = void 0;
            var maybeComponent = state.maybeComponent(el);
            if (!el.plain || (el.pre && maybeComponent)) {
                data = genData(el, state);
            }
            var tag 
            // check if this is a component in <script setup>
            = void 0;
            // check if this is a component in <script setup>
            var bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                tag = checkBindingType(bindings, el.tag);
            }
            if (!tag)
                tag = "'".concat(el.tag, "'");
            var children = el.inlineTemplate ? null : genChildren(el, state, true);
            code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
            ).concat(children ? ",".concat(children) : '' // children
            , ")");
        }
        // module transforms
        for (var i = 0; i < state.transforms.length; i++) {
            code = state.transforms[i](el, code);
        }
        return code;
    }
}
function checkBindingType(bindings, key) {
    var camelName = camelize(key);
    var PascalName = capitalize(camelName);
    var checkType = function (type) {
        if (bindings[key] === type) {
            return key;
        }
        if (bindings[camelName] === type) {
            return camelName;
        }
        if (bindings[PascalName] === type) {
            return PascalName;
        }
    };
    var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
        checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
    if (fromConst) {
        return fromConst;
    }
    var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
        checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
        checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
    if (fromMaybeRef) {
        return fromMaybeRef;
    }
}
// hoist static sub-trees out
function genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
        state.pre = el.pre;
    }
    state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
    state.pre = originalPreState;
    return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
}
// v-once
function genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.staticInFor) {
        var key = '';
        var parent_1 = el.parent;
        while (parent_1) {
            if (parent_1.for) {
                key = parent_1.key;
                break;
            }
            parent_1 = parent_1.parent;
        }
        if (!key) {
            "production" !== 'production' &&
                state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
            return genElement(el, state);
        }
        return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
    }
    else {
        return genStatic(el, state);
    }
}
function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
        return altEmpty || '_e()';
    }
    var condition = conditions.shift();
    if (condition.exp) {
        return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
    }
    else {
        return "".concat(genTernaryExp(condition.block));
    }
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen
            ? altGen(el, state)
            : el.once
                ? genOnce(el, state)
                : genElement(el, state);
    }
}
function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
    var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
    if (false) {
        state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") +
            "v-for should have explicit keys. " +
            "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
    }
    el.forProcessed = true; // avoid recursion
    return ("".concat(altHelper || '_l', "((").concat(exp, "),") +
        "function(".concat(alias).concat(iterator1).concat(iterator2, "){") +
        "return ".concat((altGen || genElement)(el, state)) +
        '})');
}
function genData(el, state) {
    var data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs)
        data += dirs + ',';
    // key
    if (el.key) {
        data += "key:".concat(el.key, ",");
    }
    // ref
    if (el.ref) {
        data += "ref:".concat(el.ref, ",");
    }
    if (el.refInFor) {
        data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
        data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
        data += "tag:\"".concat(el.tag, "\",");
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
        data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
        data += "attrs:".concat(genProps(el.attrs), ",");
    }
    // DOM props
    if (el.props) {
        data += "domProps:".concat(genProps(el.props), ",");
    }
    // event handlers
    if (el.events) {
        data += "".concat(genHandlers(el.events, false), ",");
    }
    if (el.nativeEvents) {
        data += "".concat(genHandlers(el.nativeEvents, true), ",");
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
        data += "slot:".concat(el.slotTarget, ",");
    }
    // scoped slots
    if (el.scopedSlots) {
        data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
    }
    // component v-model
    if (el.model) {
        data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
    }
    // inline-template
    if (el.inlineTemplate) {
        var inlineTemplate = genInlineTemplate(el, state);
        if (inlineTemplate) {
            data += "".concat(inlineTemplate, ",");
        }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
        data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
    }
    // v-bind data wrap
    if (el.wrapData) {
        data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
        data = el.wrapListeners(data);
    }
    return data;
}
function genDirectives(el, state) {
    var dirs = el.directives;
    if (!dirs)
        return;
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
        dir = dirs[i];
        needRuntime = true;
        var gen = state.directives[dir.name];
        if (gen) {
            // compile-time directive that manipulates AST.
            // returns true if it also needs a runtime counterpart.
            needRuntime = !!gen(el, dir, state.warn);
        }
        if (needRuntime) {
            hasRuntime = true;
            res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value
                ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value))
                : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
        }
    }
    if (hasRuntime) {
        return res.slice(0, -1) + ']';
    }
}
function genInlineTemplate(el, state) {
    var ast = el.children[0];
    if (false) {
        state.warn('Inline-template components must have exactly one child element.', { start: el.start });
    }
    if (ast && ast.type === 1) {
        var inlineRenderFns = generate(ast, state.options);
        return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns
            .map(function (code) { return "function(){".concat(code, "}"); })
            .join(','), "]}");
    }
}
function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for ||
        Object.keys(slots).some(function (key) {
            var slot = slots[key];
            return (slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
            );
        });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        var parent_2 = el.parent;
        while (parent_2) {
            if ((parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken) ||
                parent_2.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent_2.if) {
                needsKey = true;
            }
            parent_2 = parent_2.parent;
        }
    }
    var generatedSlots = Object.keys(slots)
        .map(function (key) { return genScopedSlot(slots[key], state); })
        .join(',');
    return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
}
function hash(str) {
    var hash = 5381;
    var i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
function containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') {
            return true;
        }
        return el.children.some(containsSlotChild);
    }
    return false;
}
function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
        return genIf(el, state, genScopedSlot, "null");
    }
    if (el.for && !el.forProcessed) {
        return genFor(el, state, genScopedSlot);
    }
    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(".concat(slotScope, "){") +
        "return ".concat(el.tag === 'template'
            ? el.if && isLegacySyntax
                ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined")
                : genChildren(el, state) || 'undefined'
            : genElement(el, state), "}");
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
}
function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;
    if (children.length) {
        var el_1 = children[0];
        // optimize single v-for
        if (children.length === 1 &&
            el_1.for &&
            el_1.tag !== 'template' &&
            el_1.tag !== 'slot') {
            var normalizationType_1 = checkSkip
                ? state.maybeComponent(el_1)
                    ? ",1"
                    : ",0"
                : "";
            return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
        }
        var normalizationType = checkSkip
            ? getNormalizationType(children, state.maybeComponent)
            : 0;
        var gen_1 = altGenNode || genNode;
        return "[".concat(children.map(function (c) { return gen_1(c, state); }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.type !== 1) {
            continue;
        }
        if (needsNormalization(el) ||
            (el.ifConditions &&
                el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
            res = 2;
            break;
        }
        if (maybeComponent(el) ||
            (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
            res = 1;
        }
    }
    return res;
}
function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function genNode(node, state) {
    if (node.type === 1) {
        return genElement(node, state);
    }
    else if (node.type === 3 && node.isComment) {
        return genComment(node);
    }
    else {
        return genText(node);
    }
}
function genText(text) {
    return "_v(".concat(text.type === 2
        ? text.expression // no need for () because already wrapped in _s()
        : transformSpecialNewlines(JSON.stringify(text.text)), ")");
}
function genComment(comment) {
    return "_e(".concat(JSON.stringify(comment.text), ")");
}
function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
    var attrs = el.attrs || el.dynamicAttrs
        ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
            // slot props are camelized
            name: camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        }); }))
        : null;
    var bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) {
        res += ",null";
    }
    if (attrs) {
        res += ",".concat(attrs);
    }
    if (bind) {
        res += "".concat(attrs ? '' : ',null', ",").concat(bind);
    }
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
}
function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        var value = transformSpecialNewlines(prop.value);
        if (prop.dynamic) {
            dynamicProps += "".concat(prop.name, ",").concat(value, ",");
        }
        else {
            staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
        }
    }
    staticProps = "{".concat(staticProps.slice(0, -1), "}");
    if (dynamicProps) {
        return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
    }
    else {
        return staticProps;
    }
}
// #3895, #4268
function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' +
    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
        'super,throw,while,yield,delete,export,import,return,switch,default,' +
        'extends,finally,continue,debugger,function,arguments')
        .split(',')
        .join('\\b|\\b') +
    '\\b');
// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' +
    'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') +
    '\\s*\\([^\\)]*\\)');
// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function detectErrors(ast, warn) {
    if (ast) {
        checkNode(ast, warn);
    }
}
function checkNode(node, warn) {
    if (node.type === 1) {
        for (var name_1 in node.attrsMap) {
            if (dirRE.test(name_1)) {
                var value = node.attrsMap[name_1];
                if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === 'v-for') {
                        checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                    }
                    else if (name_1 === 'v-slot' || name_1[0] === '#') {
                        checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else if (onRE.test(name_1)) {
                        checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else {
                        checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                }
            }
        }
        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                checkNode(node.children[i], warn);
            }
        }
    }
    else if (node.type === 2) {
        checkExpression(node.expression, node.text, warn, node);
    }
}
function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
        warn("avoid using JavaScript unary operator as property name: " +
            "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
    }
    checkExpression(exp, text, warn, range);
}
function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
        try {
            new Function("var ".concat(ident, "=_"));
        }
        catch (e) {
            warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
        }
    }
}
function checkExpression(exp, text, warn, range) {
    try {
        new Function("return ".concat(exp));
    }
    catch (e) {
        var keywordMatch = exp
            .replace(stripStringRE, '')
            .match(prohibitedKeywordRE);
        if (keywordMatch) {
            warn("avoid using JavaScript keyword as property name: " +
                "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
        }
        else {
            warn("invalid expression: ".concat(e.message, " in\n\n") +
                "    ".concat(exp, "\n\n") +
                "  Raw expression: ".concat(text.trim(), "\n"), range);
        }
    }
}
function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    }
    catch (e) {
        warn("invalid function parameter expression: ".concat(e.message, " in\n\n") +
            "    ".concat(exp, "\n\n") +
            "  Raw expression: ".concat(text.trim(), "\n"), range);
    }
}

var range = 2;
function generateCodeFrame(source, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = source.length; }
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (var j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                }
                else if (j > i) {
                    if (end > count) {
                        var length_2 = Math.min(end - count, lineLength);
                        res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function repeat(str, n) {
    var result = '';
    if (n > 0) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-line
            if (n & 1)
                result += str;
            n >>>= 1;
            if (n <= 0)
                break;
            str += str;
        }
    }
    return result;
}

function createFunction(code, errors) {
    try {
        return new Function(code);
    }
    catch (err) {
        errors.push({ err: err, code: code });
        return noop;
    }
}
function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = extend({}, options);
        var warn = options.warn || warn$2;
        delete options.warn;
        /* istanbul ignore if */
        if (false) {
            // detect possible CSP restriction
            try {
                new Function('return 1');
            }
            catch (e) {
                if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn('It seems you are using the standalone build of Vue.js in an ' +
                        'environment with Content Security Policy that prohibits unsafe-eval. ' +
                        'The template compiler cannot work in this environment. Consider ' +
                        'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                        'templates into render functions.');
                }
            }
        }
        // check cache
        var key = options.delimiters
            ? String(options.delimiters) + template
            : template;
        if (cache[key]) {
            return cache[key];
        }
        // compile
        var compiled = compile(template, options);
        // check compilation errors/tips
        if (false) {
            if (compiled.errors && compiled.errors.length) {
                if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                        warn("Error compiling template:\n\n".concat(e.msg, "\n\n") +
                            generateCodeFrame(template, e.start, e.end), vm);
                    });
                }
                else {
                    warn("Error compiling template:\n\n".concat(template, "\n\n") +
                        compiled.errors.map(function (e) { return "- ".concat(e); }).join('\n') +
                        '\n', vm);
                }
            }
            if (compiled.tips && compiled.tips.length) {
                if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
                }
                else {
                    compiled.tips.forEach(function (msg) { return tip(msg, vm); });
                }
            }
        }
        // turn code into functions
        var res = {};
        var fnGenErrors = [];
        res.render = createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
            return createFunction(code, fnGenErrors);
        });
        // check function generation errors.
        // this should only happen if there is a bug in the compiler itself.
        // mostly for codegen development use
        /* istanbul ignore if */
        if (false) {
            if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                warn("Failed to generate render function:\n\n" +
                    fnGenErrors
                        .map(function (_a) {
                        var err = _a.err, code = _a.code;
                        return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                    })
                        .join('\n'), vm);
            }
        }
        return (cache[key] = res);
    };
}

function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            var finalOptions = Object.create(baseOptions);
            var errors = [];
            var tips = [];
            var warn = function (msg, range, tip) {
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (false) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function (msg, range, tip) {
                        var data = typeof msg === 'string' ? { msg: msg } : msg;
                        if (range) {
                            if (range.start != null) {
                                data.start = range.start + leadingSpaceLength_1;
                            }
                            if (range.end != null) {
                                data.end = range.end + leadingSpaceLength_1;
                            }
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                }
                // merge custom directives
                if (options.directives) {
                    finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                }
                // copy other options
                for (var key in options) {
                    if (key !== 'modules' && key !== 'directives') {
                        finalOptions[key] = options[key];
                    }
                }
            }
            finalOptions.warn = warn;
            var compiled = baseCompile(template.trim(), finalOptions);
            if (false) {
                detectErrors(compiled.ast, warn);
            }
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: createCompileToFunctionFn(compile)
        };
    };
}

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
        optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});

var _a = createCompiler(baseOptions), compileToFunctions = _a.compileToFunctions;

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser
    ? getShouldDecode(true)
    : false;

var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
});
var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
        "production" !== 'production' &&
            warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
        return this;
    }
    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        var template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (false) {
                        warn$2("Template element not found or is empty: ".concat(options.template), this);
                    }
                }
            }
            else if (template.nodeType) {
                template = template.innerHTML;
            }
            else {
                if (false) {
                    warn$2('invalid template option:' + template, this);
                }
                return this;
            }
        }
        else if (el) {
            // @ts-expect-error
            template = getOuterHTML(el);
        }
        if (template) {
            /* istanbul ignore if */
            if (false) {
                mark('compile');
            }
            var _a = compileToFunctions(template, {
                outputSourceRange: "production" !== 'production',
                shouldDecodeNewlines: shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this), render = _a.render, staticRenderFns = _a.staticRenderFns;
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */
            if (false) {
                mark('compile end');
                measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
            }
        }
    }
    return mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
    if (el.outerHTML) {
        return el.outerHTML;
    }
    else {
        var container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
Vue.compile = compileToFunctions;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "7Doy":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var isArray = __webpack_require__("7UMu");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7UMu":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("R9M2");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "7t+N":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
	// Make sure the the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {

			// Support: IE <9 only
			// IE doesn't have `contains` on `document` so we need to check for
			// `documentElement` presence.
			// We need to fall back to `a` when `documentElement` is missing
			// as `ownerDocument` of elements within `<template/>` may have
			// a null one - a default behavior of all modern browsers.
			var adown = a.nodeType === 9 && a.documentElement || a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "82Mu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var macrotask = __webpack_require__("L42u").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("R9M2")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8lT+":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),

/***/ "94VQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("Yobk");
var descriptor = __webpack_require__("X8DO");
var setToStringTag = __webpack_require__("e6n0");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("hJx8")(IteratorPrototype, __webpack_require__("dSzd")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "96it":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),

/***/ "9Bbf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("kM2E");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "9C8M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("evD5").f;
var create = __webpack_require__("Yobk");
var redefineAll = __webpack_require__("xH/j");
var ctx = __webpack_require__("+ZMJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var $iterDefine = __webpack_require__("vIB/");
var step = __webpack_require__("EGZi");
var setSpecies = __webpack_require__("bRrM");
var DESCRIPTORS = __webpack_require__("+E39");
var fastKey = __webpack_require__("06OY").fastKey;
var validate = __webpack_require__("LIJb");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "9bBU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("mClu");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "9iXT":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "AKgy":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("EqjI");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "ALrJ":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("+ZMJ");
var IObject = __webpack_require__("MU5D");
var toObject = __webpack_require__("sB3e");
var toLength = __webpack_require__("QRG4");
var asc = __webpack_require__("oeOm");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "AMV0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("k2Ib"), __esModule: true };

/***/ }),

/***/ "AU64":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("2kPN");
module.exports = __webpack_require__("FeBl").Math.log2;


/***/ }),

/***/ "Aeej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// eslint-disable-next-line strict
/* harmony default export */ __webpack_exports__["a"] = (null);

/***/ }),

/***/ "Av7u":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("1J88"), __webpack_require__("6qVS"), __webpack_require__("drMw"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("Ff/Y"), __webpack_require__("mP1F"), __webpack_require__("0hgu"), __webpack_require__("QA75"), __webpack_require__("x067"), __webpack_require__("v1IJ"), __webpack_require__("hjGT"), __webpack_require__("PIk1"), __webpack_require__("bBGs"), __webpack_require__("wj1U"), __webpack_require__("fGru"), __webpack_require__("E3Xu"), __webpack_require__("kVWZ"), __webpack_require__("s9og"), __webpack_require__("YeRv"), __webpack_require__("Trqf"), __webpack_require__("96it"), __webpack_require__("HYom"), __webpack_require__("Gqr1"), __webpack_require__("E+Sk"), __webpack_require__("0Iyz"), __webpack_require__("8lT+"), __webpack_require__("FQmK"), __webpack_require__("4pyl"), __webpack_require__("5Pol"), __webpack_require__("gkUh"), __webpack_require__("3NE9"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),

/***/ "BDhv":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("kM2E");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("m9gC")('Set') });


/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "BMSc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrbitControls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_three__ = __webpack_require__("Ml+6");






// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move

var _changeEvent = { type: 'change' };
var _startEvent = { type: 'start' };
var _endEvent = { type: 'end' };

var OrbitControls = function (_EventDispatcher) {
	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OrbitControls, _EventDispatcher);

	function OrbitControls(object, domElement) {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OrbitControls);

		var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OrbitControls.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OrbitControls)).call(this));

		_this.object = object;
		_this.domElement = domElement;
		_this.domElement.style.touchAction = 'none'; // disable touch scroll

		// Set to false to disable this control
		_this.enabled = true;

		// "target" sets the location of focus, where the object orbits around
		_this.target = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();

		// How far you can dolly in and out ( PerspectiveCamera only )
		_this.minDistance = 0;
		_this.maxDistance = Infinity;

		// How far you can zoom in and out ( OrthographicCamera only )
		_this.minZoom = 0;
		_this.maxZoom = Infinity;

		// How far you can orbit vertically, upper and lower limits.
		// Range is 0 to Math.PI radians.
		_this.minPolarAngle = 0; // radians
		_this.maxPolarAngle = Math.PI; // radians

		// How far you can orbit horizontally, upper and lower limits.
		// If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
		_this.minAzimuthAngle = -Infinity; // radians
		_this.maxAzimuthAngle = Infinity; // radians

		// Set to true to enable damping (inertia)
		// If damping is enabled, you must call controls.update() in your animation loop
		_this.enableDamping = false;
		_this.dampingFactor = 0.05;

		// This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
		// Set to false to disable zooming
		_this.enableZoom = true;
		_this.zoomSpeed = 1.0;

		// Set to false to disable rotating
		_this.enableRotate = true;
		_this.rotateSpeed = 1.0;

		// Set to false to disable panning
		_this.enablePan = true;
		_this.panSpeed = 1.0;
		_this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
		_this.keyPanSpeed = 7.0; // pixels moved per arrow key push

		// Set to true to automatically rotate around the target
		// If auto-rotate is enabled, you must call controls.update() in your animation loop
		_this.autoRotate = false;
		_this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60

		// The four arrow keys
		_this.keys = { LEFT: 'ArrowLeft', UP: 'ArrowUp', RIGHT: 'ArrowRight', BOTTOM: 'ArrowDown' };

		// Mouse buttons
		_this.mouseButtons = { LEFT: __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].ROTATE, MIDDLE: __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].DOLLY, RIGHT: __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].PAN };

		// Touch fingers
		_this.touches = { ONE: __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].ROTATE, TWO: __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].DOLLY_PAN };

		// for reset
		_this.target0 = _this.target.clone();
		_this.position0 = _this.object.position.clone();
		_this.zoom0 = _this.object.zoom;

		// the target DOM element for key events
		_this._domElementKeyEvents = null;

		//
		// public methods
		//

		_this.getPolarAngle = function () {

			return spherical.phi;
		};

		_this.getAzimuthalAngle = function () {

			return spherical.theta;
		};

		_this.getDistance = function () {

			return this.object.position.distanceTo(this.target);
		};

		_this.listenToKeyEvents = function (domElement) {

			domElement.addEventListener('keydown', onKeyDown);
			this._domElementKeyEvents = domElement;
		};

		_this.stopListenToKeyEvents = function () {

			this._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
			this._domElementKeyEvents = null;
		};

		_this.saveState = function () {

			scope.target0.copy(scope.target);
			scope.position0.copy(scope.object.position);
			scope.zoom0 = scope.object.zoom;
		};

		_this.reset = function () {

			scope.target.copy(scope.target0);
			scope.object.position.copy(scope.position0);
			scope.object.zoom = scope.zoom0;

			scope.object.updateProjectionMatrix();
			scope.dispatchEvent(_changeEvent);

			scope.update();

			state = STATE.NONE;
		};

		// this method is exposed, but perhaps it would be better if we can make it private...
		_this.update = function () {

			var offset = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();

			// so camera.up is the orbit axis
			var quat = new __WEBPACK_IMPORTED_MODULE_4_three__["_22" /* Quaternion */]().setFromUnitVectors(object.up, new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */](0, 1, 0));
			var quatInverse = quat.clone().invert();

			var lastPosition = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();
			var lastQuaternion = new __WEBPACK_IMPORTED_MODULE_4_three__["_22" /* Quaternion */]();

			var twoPI = 2 * Math.PI;

			return function update() {

				var position = scope.object.position;

				offset.copy(position).sub(scope.target);

				// rotate offset to "y-axis-is-up" space
				offset.applyQuaternion(quat);

				// angle from z-axis around y-axis
				spherical.setFromVector3(offset);

				if (scope.autoRotate && state === STATE.NONE) {

					rotateLeft(getAutoRotationAngle());
				}

				if (scope.enableDamping) {

					spherical.theta += sphericalDelta.theta * scope.dampingFactor;
					spherical.phi += sphericalDelta.phi * scope.dampingFactor;
				} else {

					spherical.theta += sphericalDelta.theta;
					spherical.phi += sphericalDelta.phi;
				}

				// restrict theta to be between desired limits

				var min = scope.minAzimuthAngle;
				var max = scope.maxAzimuthAngle;

				if (isFinite(min) && isFinite(max)) {

					if (min < -Math.PI) min += twoPI;else if (min > Math.PI) min -= twoPI;

					if (max < -Math.PI) max += twoPI;else if (max > Math.PI) max -= twoPI;

					if (min <= max) {

						spherical.theta = Math.max(min, Math.min(max, spherical.theta));
					} else {

						spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
					}
				}

				// restrict phi to be between desired limits
				spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));

				spherical.makeSafe();

				spherical.radius *= scale;

				// restrict radius to be between desired limits
				spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));

				// move target to panned location

				if (scope.enableDamping === true) {

					scope.target.addScaledVector(panOffset, scope.dampingFactor);
				} else {

					scope.target.add(panOffset);
				}

				offset.setFromSpherical(spherical);

				// rotate offset back to "camera-up-vector-is-up" space
				offset.applyQuaternion(quatInverse);

				position.copy(scope.target).add(offset);

				scope.object.lookAt(scope.target);

				if (scope.enableDamping === true) {

					sphericalDelta.theta *= 1 - scope.dampingFactor;
					sphericalDelta.phi *= 1 - scope.dampingFactor;

					panOffset.multiplyScalar(1 - scope.dampingFactor);
				} else {

					sphericalDelta.set(0, 0, 0);

					panOffset.set(0, 0, 0);
				}

				scale = 1;

				// update condition is:
				// min(camera displacement, camera rotation in radians)^2 > EPS
				// using small-angle approximation cos(x/2) = 1 - x^2 / 8

				if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {

					scope.dispatchEvent(_changeEvent);

					lastPosition.copy(scope.object.position);
					lastQuaternion.copy(scope.object.quaternion);
					zoomChanged = false;

					return true;
				}

				return false;
			};
		}();

		_this.dispose = function () {

			scope.domElement.removeEventListener('contextmenu', onContextMenu);

			scope.domElement.removeEventListener('pointerdown', onPointerDown);
			scope.domElement.removeEventListener('pointercancel', onPointerUp);
			scope.domElement.removeEventListener('wheel', onMouseWheel);

			scope.domElement.removeEventListener('pointermove', onPointerMove);
			scope.domElement.removeEventListener('pointerup', onPointerUp);

			if (scope._domElementKeyEvents !== null) {

				scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
				scope._domElementKeyEvents = null;
			}

			//scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
		};

		//
		// internals
		//

		var scope = _this;

		var STATE = {
			NONE: -1,
			ROTATE: 0,
			DOLLY: 1,
			PAN: 2,
			TOUCH_ROTATE: 3,
			TOUCH_PAN: 4,
			TOUCH_DOLLY_PAN: 5,
			TOUCH_DOLLY_ROTATE: 6
		};

		var state = STATE.NONE;

		var EPS = 0.000001;

		// current position in spherical coordinates
		var spherical = new __WEBPACK_IMPORTED_MODULE_4_three__["_31" /* Spherical */]();
		var sphericalDelta = new __WEBPACK_IMPORTED_MODULE_4_three__["_31" /* Spherical */]();

		var scale = 1;
		var panOffset = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();
		var zoomChanged = false;

		var rotateStart = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var rotateEnd = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var rotateDelta = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();

		var panStart = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var panEnd = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var panDelta = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();

		var dollyStart = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var dollyEnd = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
		var dollyDelta = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();

		var pointers = [];
		var pointerPositions = {};

		function getAutoRotationAngle() {

			return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
		}

		function getZoomScale() {

			return Math.pow(0.95, scope.zoomSpeed);
		}

		function rotateLeft(angle) {

			sphericalDelta.theta -= angle;
		}

		function rotateUp(angle) {

			sphericalDelta.phi -= angle;
		}

		var panLeft = function () {

			var v = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();

			return function panLeft(distance, objectMatrix) {

				v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
				v.multiplyScalar(-distance);

				panOffset.add(v);
			};
		}();

		var panUp = function () {

			var v = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();

			return function panUp(distance, objectMatrix) {

				if (scope.screenSpacePanning === true) {

					v.setFromMatrixColumn(objectMatrix, 1);
				} else {

					v.setFromMatrixColumn(objectMatrix, 0);
					v.crossVectors(scope.object.up, v);
				}

				v.multiplyScalar(distance);

				panOffset.add(v);
			};
		}();

		// deltaX and deltaY are in pixels; right and down are positive
		var pan = function () {

			var offset = new __WEBPACK_IMPORTED_MODULE_4_three__["_41" /* Vector3 */]();

			return function pan(deltaX, deltaY) {

				var element = scope.domElement;

				if (scope.object.isPerspectiveCamera) {

					// perspective
					var position = scope.object.position;
					offset.copy(position).sub(scope.target);
					var targetDistance = offset.length();

					// half of the fov is center to top of screen
					targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);

					// we use only clientHeight here so aspect ratio does not distort speed
					panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
					panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
				} else if (scope.object.isOrthographicCamera) {

					// orthographic
					panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
					panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
				} else {

					// camera neither orthographic nor perspective
					console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
					scope.enablePan = false;
				}
			};
		}();

		function dollyOut(dollyScale) {

			if (scope.object.isPerspectiveCamera) {

				scale /= dollyScale;
			} else if (scope.object.isOrthographicCamera) {

				scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
				scope.object.updateProjectionMatrix();
				zoomChanged = true;
			} else {

				console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
				scope.enableZoom = false;
			}
		}

		function dollyIn(dollyScale) {

			if (scope.object.isPerspectiveCamera) {

				scale *= dollyScale;
			} else if (scope.object.isOrthographicCamera) {

				scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
				scope.object.updateProjectionMatrix();
				zoomChanged = true;
			} else {

				console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
				scope.enableZoom = false;
			}
		}

		//
		// event callbacks - update the object state
		//

		function handleMouseDownRotate(event) {

			rotateStart.set(event.clientX, event.clientY);
		}

		function handleMouseDownDolly(event) {

			dollyStart.set(event.clientX, event.clientY);
		}

		function handleMouseDownPan(event) {

			panStart.set(event.clientX, event.clientY);
		}

		function handleMouseMoveRotate(event) {

			rotateEnd.set(event.clientX, event.clientY);

			rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

			var element = scope.domElement;

			rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

			rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);

			rotateStart.copy(rotateEnd);

			scope.update();
		}

		function handleMouseMoveDolly(event) {

			dollyEnd.set(event.clientX, event.clientY);

			dollyDelta.subVectors(dollyEnd, dollyStart);

			if (dollyDelta.y > 0) {

				dollyOut(getZoomScale());
			} else if (dollyDelta.y < 0) {

				dollyIn(getZoomScale());
			}

			dollyStart.copy(dollyEnd);

			scope.update();
		}

		function handleMouseMovePan(event) {

			panEnd.set(event.clientX, event.clientY);

			panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);

			pan(panDelta.x, panDelta.y);

			panStart.copy(panEnd);

			scope.update();
		}

		function handleMouseWheel(event) {

			if (event.deltaY < 0) {

				dollyIn(getZoomScale());
			} else if (event.deltaY > 0) {

				dollyOut(getZoomScale());
			}

			scope.update();
		}

		function handleKeyDown(event) {

			var needsUpdate = false;

			switch (event.code) {

				case scope.keys.UP:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						rotateUp(2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
					} else {

						pan(0, scope.keyPanSpeed);
					}

					needsUpdate = true;
					break;

				case scope.keys.BOTTOM:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						rotateUp(-2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
					} else {

						pan(0, -scope.keyPanSpeed);
					}

					needsUpdate = true;
					break;

				case scope.keys.LEFT:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						rotateLeft(2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
					} else {

						pan(scope.keyPanSpeed, 0);
					}

					needsUpdate = true;
					break;

				case scope.keys.RIGHT:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						rotateLeft(-2 * Math.PI * scope.rotateSpeed / scope.domElement.clientHeight);
					} else {

						pan(-scope.keyPanSpeed, 0);
					}

					needsUpdate = true;
					break;

			}

			if (needsUpdate) {

				// prevent the browser from scrolling on cursor keys
				event.preventDefault();

				scope.update();
			}
		}

		function handleTouchStartRotate() {

			if (pointers.length === 1) {

				rotateStart.set(pointers[0].pageX, pointers[0].pageY);
			} else {

				var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
				var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);

				rotateStart.set(x, y);
			}
		}

		function handleTouchStartPan() {

			if (pointers.length === 1) {

				panStart.set(pointers[0].pageX, pointers[0].pageY);
			} else {

				var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
				var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);

				panStart.set(x, y);
			}
		}

		function handleTouchStartDolly() {

			var dx = pointers[0].pageX - pointers[1].pageX;
			var dy = pointers[0].pageY - pointers[1].pageY;

			var distance = Math.sqrt(dx * dx + dy * dy);

			dollyStart.set(0, distance);
		}

		function handleTouchStartDollyPan() {

			if (scope.enableZoom) handleTouchStartDolly();

			if (scope.enablePan) handleTouchStartPan();
		}

		function handleTouchStartDollyRotate() {

			if (scope.enableZoom) handleTouchStartDolly();

			if (scope.enableRotate) handleTouchStartRotate();
		}

		function handleTouchMoveRotate(event) {

			if (pointers.length == 1) {

				rotateEnd.set(event.pageX, event.pageY);
			} else {

				var position = getSecondPointerPosition(event);

				var x = 0.5 * (event.pageX + position.x);
				var y = 0.5 * (event.pageY + position.y);

				rotateEnd.set(x, y);
			}

			rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);

			var element = scope.domElement;

			rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

			rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);

			rotateStart.copy(rotateEnd);
		}

		function handleTouchMovePan(event) {

			if (pointers.length === 1) {

				panEnd.set(event.pageX, event.pageY);
			} else {

				var position = getSecondPointerPosition(event);

				var x = 0.5 * (event.pageX + position.x);
				var y = 0.5 * (event.pageY + position.y);

				panEnd.set(x, y);
			}

			panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);

			pan(panDelta.x, panDelta.y);

			panStart.copy(panEnd);
		}

		function handleTouchMoveDolly(event) {

			var position = getSecondPointerPosition(event);

			var dx = event.pageX - position.x;
			var dy = event.pageY - position.y;

			var distance = Math.sqrt(dx * dx + dy * dy);

			dollyEnd.set(0, distance);

			dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));

			dollyOut(dollyDelta.y);

			dollyStart.copy(dollyEnd);
		}

		function handleTouchMoveDollyPan(event) {

			if (scope.enableZoom) handleTouchMoveDolly(event);

			if (scope.enablePan) handleTouchMovePan(event);
		}

		function handleTouchMoveDollyRotate(event) {

			if (scope.enableZoom) handleTouchMoveDolly(event);

			if (scope.enableRotate) handleTouchMoveRotate(event);
		}

		//
		// event handlers - FSM: listen for events and reset state
		//

		function onPointerDown(event) {

			if (scope.enabled === false) return;

			if (pointers.length === 0) {

				scope.domElement.setPointerCapture(event.pointerId);

				scope.domElement.addEventListener('pointermove', onPointerMove);
				scope.domElement.addEventListener('pointerup', onPointerUp);
			}

			//

			addPointer(event);

			if (event.pointerType === 'touch') {

				onTouchStart(event);
			} else {

				onMouseDown(event);
			}
		}

		function onPointerMove(event) {

			if (scope.enabled === false) return;

			if (event.pointerType === 'touch') {

				onTouchMove(event);
			} else {

				onMouseMove(event);
			}
		}

		function onPointerUp(event) {

			removePointer(event);

			if (pointers.length === 0) {

				scope.domElement.releasePointerCapture(event.pointerId);

				scope.domElement.removeEventListener('pointermove', onPointerMove);
				scope.domElement.removeEventListener('pointerup', onPointerUp);
			}

			scope.dispatchEvent(_endEvent);

			state = STATE.NONE;
		}

		function onMouseDown(event) {

			var mouseAction = void 0;

			switch (event.button) {

				case 0:

					mouseAction = scope.mouseButtons.LEFT;
					break;

				case 1:

					mouseAction = scope.mouseButtons.MIDDLE;
					break;

				case 2:

					mouseAction = scope.mouseButtons.RIGHT;
					break;

				default:

					mouseAction = -1;

			}

			switch (mouseAction) {

				case __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].DOLLY:

					if (scope.enableZoom === false) return;

					handleMouseDownDolly(event);

					state = STATE.DOLLY;

					break;

				case __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].ROTATE:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						if (scope.enablePan === false) return;

						handleMouseDownPan(event);

						state = STATE.PAN;
					} else {

						if (scope.enableRotate === false) return;

						handleMouseDownRotate(event);

						state = STATE.ROTATE;
					}

					break;

				case __WEBPACK_IMPORTED_MODULE_4_three__["Y" /* MOUSE */].PAN:

					if (event.ctrlKey || event.metaKey || event.shiftKey) {

						if (scope.enableRotate === false) return;

						handleMouseDownRotate(event);

						state = STATE.ROTATE;
					} else {

						if (scope.enablePan === false) return;

						handleMouseDownPan(event);

						state = STATE.PAN;
					}

					break;

				default:

					state = STATE.NONE;

			}

			if (state !== STATE.NONE) {

				scope.dispatchEvent(_startEvent);
			}
		}

		function onMouseMove(event) {

			switch (state) {

				case STATE.ROTATE:

					if (scope.enableRotate === false) return;

					handleMouseMoveRotate(event);

					break;

				case STATE.DOLLY:

					if (scope.enableZoom === false) return;

					handleMouseMoveDolly(event);

					break;

				case STATE.PAN:

					if (scope.enablePan === false) return;

					handleMouseMovePan(event);

					break;

			}
		}

		function onMouseWheel(event) {

			if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;

			event.preventDefault();

			scope.dispatchEvent(_startEvent);

			handleMouseWheel(event);

			scope.dispatchEvent(_endEvent);
		}

		function onKeyDown(event) {

			if (scope.enabled === false || scope.enablePan === false) return;

			handleKeyDown(event);
		}

		function onTouchStart(event) {

			trackPointer(event);

			switch (pointers.length) {

				case 1:

					switch (scope.touches.ONE) {

						case __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].ROTATE:

							if (scope.enableRotate === false) return;

							handleTouchStartRotate();

							state = STATE.TOUCH_ROTATE;

							break;

						case __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].PAN:

							if (scope.enablePan === false) return;

							handleTouchStartPan();

							state = STATE.TOUCH_PAN;

							break;

						default:

							state = STATE.NONE;

					}

					break;

				case 2:

					switch (scope.touches.TWO) {

						case __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].DOLLY_PAN:

							if (scope.enableZoom === false && scope.enablePan === false) return;

							handleTouchStartDollyPan();

							state = STATE.TOUCH_DOLLY_PAN;

							break;

						case __WEBPACK_IMPORTED_MODULE_4_three__["_33" /* TOUCH */].DOLLY_ROTATE:

							if (scope.enableZoom === false && scope.enableRotate === false) return;

							handleTouchStartDollyRotate();

							state = STATE.TOUCH_DOLLY_ROTATE;

							break;

						default:

							state = STATE.NONE;

					}

					break;

				default:

					state = STATE.NONE;

			}

			if (state !== STATE.NONE) {

				scope.dispatchEvent(_startEvent);
			}
		}

		function onTouchMove(event) {

			trackPointer(event);

			switch (state) {

				case STATE.TOUCH_ROTATE:

					if (scope.enableRotate === false) return;

					handleTouchMoveRotate(event);

					scope.update();

					break;

				case STATE.TOUCH_PAN:

					if (scope.enablePan === false) return;

					handleTouchMovePan(event);

					scope.update();

					break;

				case STATE.TOUCH_DOLLY_PAN:

					if (scope.enableZoom === false && scope.enablePan === false) return;

					handleTouchMoveDollyPan(event);

					scope.update();

					break;

				case STATE.TOUCH_DOLLY_ROTATE:

					if (scope.enableZoom === false && scope.enableRotate === false) return;

					handleTouchMoveDollyRotate(event);

					scope.update();

					break;

				default:

					state = STATE.NONE;

			}
		}

		function onContextMenu(event) {

			if (scope.enabled === false) return;

			event.preventDefault();
		}

		function addPointer(event) {

			pointers.push(event);
		}

		function removePointer(event) {

			delete pointerPositions[event.pointerId];

			for (var i = 0; i < pointers.length; i++) {

				if (pointers[i].pointerId == event.pointerId) {

					pointers.splice(i, 1);
					return;
				}
			}
		}

		function trackPointer(event) {

			var position = pointerPositions[event.pointerId];

			if (position === undefined) {

				position = new __WEBPACK_IMPORTED_MODULE_4_three__["_40" /* Vector2 */]();
				pointerPositions[event.pointerId] = position;
			}

			position.set(event.pageX, event.pageY);
		}

		function getSecondPointerPosition(event) {

			var pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];

			return pointerPositions[pointer.pointerId];
		}

		//

		scope.domElement.addEventListener('contextmenu', onContextMenu);

		scope.domElement.addEventListener('pointerdown', onPointerDown);
		scope.domElement.addEventListener('pointercancel', onPointerUp);
		scope.domElement.addEventListener('wheel', onMouseWheel, { passive: false });

		// force an update at start

		_this.update();

		return _this;
	}

	return OrbitControls;
}(__WEBPACK_IMPORTED_MODULE_4_three__["x" /* EventDispatcher */]);



/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fxRn"), __esModule: true };

/***/ }),

/***/ "BwfY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fWfb");
__webpack_require__("M6a0");
__webpack_require__("OYls");
__webpack_require__("QWe/");
module.exports = __webpack_require__("FeBl").Symbol;


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9bBU"), __esModule: true };

/***/ }),

/***/ "CFqi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),

/***/ "CGCf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function() {
    var idCount = 1;

    /**
     * Generates a new unique id in the context.
     * @public
     * @returns {number} A unique id in the context.
     */
    function generate() {
        return idCount++;
    }

    return {
        generate: generate
    };
};


/***/ }),

/***/ "CJli":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("pRCB");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),

/***/ "CXw9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var global = __webpack_require__("7KvD");
var ctx = __webpack_require__("+ZMJ");
var classof = __webpack_require__("RY/4");
var $export = __webpack_require__("kM2E");
var isObject = __webpack_require__("EqjI");
var aFunction = __webpack_require__("lOnJ");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var speciesConstructor = __webpack_require__("t8x9");
var task = __webpack_require__("L42u").set;
var microtask = __webpack_require__("82Mu")();
var newPromiseCapabilityModule = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");
var userAgent = __webpack_require__("iUbK");
var promiseResolve = __webpack_require__("fJUb");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("dSzd")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("xH/j")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("e6n0")($Promise, PROMISE);
__webpack_require__("bRrM")(PROMISE);
Wrapper = __webpack_require__("FeBl")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("dY0y")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "CbwA":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("kM2E");
var ownKeys = __webpack_require__("hg2J");
var toIObject = __webpack_require__("TcQ7");
var gOPD = __webpack_require__("LKZe");
var createProperty = __webpack_require__("fBQ2");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "Cdx3":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("sB3e");
var $keys = __webpack_require__("lktj");

__webpack_require__("uqUo")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "D437":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__("cGG2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_AxiosError_js__ = __webpack_require__("ydVi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_node_classes_FormData_js__ = __webpack_require__("Aeej");







// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isPlainObject(thing) || __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isArray(arr) && !arr.some(isVisitable);
}

var predicates = __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].toFlatObject(__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */], {}, null, function filter(prop) {
  return (/^is[A-Z]/.test(prop)
  );
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (__WEBPACK_IMPORTED_MODULE_5__platform_node_classes_FormData_js__["a" /* default */] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isUndefined(source[option]);
  });

  var metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  var visitor = options.visitor || defaultVisitor;
  var dots = options.dots;
  var indexes = options.indexes;
  var _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  var useBlob = _Blob && __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isSpecCompliantForm(formData);

  if (!__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isBlob(value)) {
      throw new __WEBPACK_IMPORTED_MODULE_4__core_AxiosError_js__["a" /* default */]('Blob is not supported. Use a Buffer instead.');
    }

    if (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isArrayBuffer(value) || __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    var arr = value;

    if (value && !path && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      if (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value);
      } else if (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isArray(value) && isFlatArray(value) || (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isFileList(value) || __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].endsWith(key, '[]')) && (arr = __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].toArray(value))) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isUndefined(el) || el === null) && formData.append(
          // eslint-disable-next-line no-nested-ternary
          indexes === true ? renderKey([key], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  var stack = [];

  var exposedHelpers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(predicates, {
    defaultVisitor: defaultVisitor,
    convertValue: convertValue,
    isVisitable: isVisitable
  });

  function build(value, path) {
    if (__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].forEach(value, function each(el, key) {
      var result = !(__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isUndefined(el) || el === null) && visitor.call(formData, el, __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isString(key) ? key.trim() : key, path, exposedHelpers);

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ __webpack_exports__["a"] = (toFormData);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "Dd8w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "E+Sk":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),

/***/ "E3Xu":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),

/***/ "EGZi":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "EqBC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var speciesConstructor = __webpack_require__("t8x9");
var promiseResolve = __webpack_require__("fJUb");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "EuP9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("sOR5")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "Ewe+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^(\+?49[ \.\-])?([\(]{1}[0-9]{1,6}[\)])?([0-9 \.\-\/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)2\d{7,9}$/,
  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[89]\d{7}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'id-ID': /^(\+?62|0[1-9])[\s|\d]+$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'ms-MY': /^(\+?6?01){1}(([145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /^(\+?55|0)\-?[1-9]{2}\-?[2-9]{1}\d{3,4}\-?\d{4}$/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'vi-VN': /^(\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/,
  'zh-CN': /^(\+?0?86\-?)?1[3456789]\d{9}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */

// aliases
phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];

function isMobilePhone(str, locale, options) {
  (0, _assertString2.default)(str);
  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }
  if (locale in phones) {
    return phones[locale].test(str);
  } else if (locale === 'any') {
    for (var key in phones) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];
        if (phone.test(str)) {
          return true;
        }
      }
    }
    return false;
  }
  throw new Error('Invalid locale \'' + locale + '\'');
}
module.exports = exports['default'];

/***/ }),

/***/ "F3HL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexbox__ = __webpack_require__("YxJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flexbox_item__ = __webpack_require__("3Lt7");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__flexbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__flexbox_item__["a"]; });





/***/ }),

/***/ "FQmK":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("wj1U"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "Ff/Y":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ "G5/o":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("uqUo")('getOwnPropertyNames', function () {
  return __webpack_require__("Rrel").f;
});


/***/ }),

/***/ "GpqH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("LBxF");

module.exports = function batchProcessorMaker(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var asyncProcess    = utils.getOption(options, "async", true);
    var autoProcess     = utils.getOption(options, "auto", true);

    if(autoProcess && !asyncProcess) {
        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
        asyncProcess = true;
    }

    var batch = Batch();
    var asyncFrameHandler;
    var isProcessing = false;

    function addFunction(level, fn) {
        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
            // This needs to be done before, since we're checking the size of the batch to be 0.
            processBatchAsync();
        }

        batch.add(level, fn);
    }

    function processBatch() {
        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
        isProcessing = true;
        while (batch.size()) {
            var processingBatch = batch;
            batch = Batch();
            processingBatch.process();
        }
        isProcessing = false;
    }

    function forceProcessBatch(localAsyncProcess) {
        if (isProcessing) {
            return;
        }

        if(localAsyncProcess === undefined) {
            localAsyncProcess = asyncProcess;
        }

        if(asyncFrameHandler) {
            cancelFrame(asyncFrameHandler);
            asyncFrameHandler = null;
        }

        if(localAsyncProcess) {
            processBatchAsync();
        } else {
            processBatch();
        }
    }

    function processBatchAsync() {
        asyncFrameHandler = requestFrame(processBatch);
    }

    function clearBatch() {
        batch           = {};
        batchSize       = 0;
        topLevel        = 0;
        bottomLevel     = 0;
    }

    function cancelFrame(listener) {
        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
        var cancel = clearTimeout;
        return cancel(listener);
    }

    function requestFrame(callback) {
        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
        var raf = function(fn) { return setTimeout(fn, 0); };
        return raf(callback);
    }

    return {
        add: addFunction,
        force: forceProcessBatch
    };
};

function Batch() {
    var batch       = {};
    var size        = 0;
    var topLevel    = 0;
    var bottomLevel = 0;

    function add(level, fn) {
        if(!fn) {
            fn = level;
            level = 0;
        }

        if(level > topLevel) {
            topLevel = level;
        } else if(level < bottomLevel) {
            bottomLevel = level;
        }

        if(!batch[level]) {
            batch[level] = [];
        }

        batch[level].push(fn);
        size++;
    }

    function process() {
        for(var level = bottomLevel; level <= topLevel; level++) {
            var fns = batch[level];

            for(var i = 0; i < fns.length; i++) {
                var fn = fns[i];
                fn();
            }
        }
    }

    function getSize() {
        return size;
    }

    return {
        add: add,
        process: process,
        size: getSize
    };
}


/***/ }),

/***/ "Gqr1":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),

/***/ "Gu7T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "HSQo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("CJli"), __esModule: true };

/***/ }),

/***/ "HYom":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),

/***/ "HpRW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("kM2E");
var aFunction = __webpack_require__("lOnJ");
var ctx = __webpack_require__("+ZMJ");
var forOf = __webpack_require__("NWt+");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "INCx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("q3gF"), __esModule: true };

/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "JP+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bind;


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

/***/ }),

/***/ "JSQk":
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
    if (true) {
        // Node/CommonJS
        module.exports = factory();
    } else if (typeof define === 'function' && define.amd) {
        // AMD
        define(factory);
    } else {
        // Browser globals (with support for web workers)
        var glob;

        try {
            glob = window;
        } catch (e) {
            glob = self;
        }

        glob.SparkMD5 = factory();
    }
}(function (undefined) {

    'use strict';

    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */

    /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */
    var add32 = function (a, b) {
        return (a + b) & 0xFFFFFFFF;
    },
        hex_chr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];


    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32((a << s) | (a >>> (32 - s)), b);
    }

    function md5cycle(x, k) {
        var a = x[0],
            b = x[1],
            c = x[2],
            d = x[3];

        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a  = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d  = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c  = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b  = (b << 22 | b >>> 10) + c | 0;

        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a  = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d  = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c  = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b  = (b << 20 | b >>> 12) + c | 0;

        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a  = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d  = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c  = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b  = (b << 23 | b >>> 9) + c | 0;

        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b  = (b << 21 |b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a  = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d  = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c  = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b  = (b << 21 | b >>> 11) + c | 0;

        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }

    function md5blk(s) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    }

    function md5blk_array(a) {
        var md5blks = [],
            i; /* Andy King said do it this way. */

        for (i = 0; i < 64; i += 4) {
            md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        }
        return md5blks;
    }

    function md51(s) {
        var n = s.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        length = s.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
        }
        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);
        return state;
    }

    function md51_array(a) {
        var n = a.length,
            state = [1732584193, -271733879, -1732584194, 271733878],
            i,
            length,
            tail,
            tmp,
            lo,
            hi;

        for (i = 64; i <= n; i += 64) {
            md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        }

        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = (i - 64) < n ? a.subarray(i - 64) : new Uint8Array(0);

        length = a.length;
        tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= a[i] << ((i % 4) << 3);
        }

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;

        md5cycle(state, tail);

        return state;
    }

    function rhex(n) {
        var s = '',
            j;
        for (j = 0; j < 4; j += 1) {
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0F] + hex_chr[(n >> (j * 8)) & 0x0F];
        }
        return s;
    }

    function hex(x) {
        var i;
        for (i = 0; i < x.length; i += 1) {
            x[i] = rhex(x[i]);
        }
        return x.join('');
    }

    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') {
        add32 = function (x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        };
    }

    // ---------------------------------------------------

    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */

    if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) {
        (function () {
            function clamp(val, length) {
                val = (val | 0) || 0;

                if (val < 0) {
                    return Math.max(val + length, 0);
                }

                return Math.min(val, length);
            }

            ArrayBuffer.prototype.slice = function (from, to) {
                var length = this.byteLength,
                    begin = clamp(from, length),
                    end = length,
                    num,
                    target,
                    targetArray,
                    sourceArray;

                if (to !== undefined) {
                    end = clamp(to, length);
                }

                if (begin > end) {
                    return new ArrayBuffer(0);
                }

                num = end - begin;
                target = new ArrayBuffer(num);
                targetArray = new Uint8Array(target);

                sourceArray = new Uint8Array(this, begin, num);
                targetArray.set(sourceArray);

                return target;
            };
        })();
    }

    // ---------------------------------------------------

    /**
     * Helpers.
     */

    function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) {
            str = unescape(encodeURIComponent(str));
        }

        return str;
    }

    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length,
           buff = new ArrayBuffer(length),
           arr = new Uint8Array(buff),
           i;

        for (i = 0; i < length; i += 1) {
            arr[i] = str.charCodeAt(i);
        }

        return returnUInt8Array ? arr : buff;
    }

    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }

    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);

        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);

        return returnUInt8Array ? result : result.buffer;
    }

    function hexToBinaryString(hex) {
        var bytes = [],
            length = hex.length,
            x;

        for (x = 0; x < length - 1; x += 2) {
            bytes.push(parseInt(hex.substr(x, 2), 16));
        }

        return String.fromCharCode.apply(String, bytes);
    }

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */

    function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }

    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.append = function (str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));

        return this;
    };

    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.appendBinary = function (contents) {
        this._buff += contents;
        this._length += contents.length;

        var length = this._buff.length,
            i;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        }

        this._buff = this._buff.substring(i - 64);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            i,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff.charCodeAt(i) << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = hex(this._hash);

        if (raw) {
            ret = hexToBinaryString(ret);
        }

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.reset = function () {
        this._buff = '';
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.prototype.getState = function () {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */
    SparkMD5.prototype.setState = function (state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;

        return this;
    };

    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */
    SparkMD5.prototype.destroy = function () {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };

    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */
    SparkMD5.prototype._finish = function (tail, length) {
        var i = length,
            tmp,
            lo,
            hi;

        tail[i >> 2] |= 0x80 << ((i % 4) << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for (i = 0; i < 16; i += 1) {
                tail[i] = 0;
            }
        }

        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;

        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };

    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.hash = function (str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };

    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.hashBinary = function (content, raw) {
        var hash = md51(content),
            ret = hex(hash);

        return raw ? hexToBinaryString(ret) : ret;
    };

    // ---------------------------------------------------

    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */
    SparkMD5.ArrayBuffer = function () {
        // call reset to init the instance
        this.reset();
    };

    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.append = function (arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true),
            length = buff.length,
            i;

        this._length += arr.byteLength;

        for (i = 64; i <= length; i += 64) {
            md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        }

        this._buff = (i - 64) < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);

        return this;
    };

    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */
    SparkMD5.ArrayBuffer.prototype.end = function (raw) {
        var buff = this._buff,
            length = buff.length,
            tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            i,
            ret;

        for (i = 0; i < length; i += 1) {
            tail[i >> 2] |= buff[i] << ((i % 4) << 3);
        }

        this._finish(tail, length);
        ret = hex(this._hash);

        if (raw) {
            ret = hexToBinaryString(ret);
        }

        this.reset();

        return ret;
    };

    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.reset = function () {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [1732584193, -271733879, -1732584194, 271733878];

        return this;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */
    SparkMD5.ArrayBuffer.prototype.getState = function () {
        var state = SparkMD5.prototype.getState.call(this);

        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);

        return state;
    };

    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */
    SparkMD5.ArrayBuffer.prototype.setState = function (state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);

        return SparkMD5.prototype.setState.call(this, state);
    };

    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;

    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;

    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */
    SparkMD5.ArrayBuffer.hash = function (arr, raw) {
        var hash = md51_array(new Uint8Array(arr)),
            ret = hex(hash);

        return raw ? hexToBinaryString(ret) : ret;
    };

    return SparkMD5;
}));


/***/ }),

/***/ "JWAb":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("kM2E");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "JkZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_dom__ = __webpack_require__("te2A");


var BODY_CLASS_NAME = 'vux-modal-open';
var CONTAINER_CLASS_NAME = 'vux-modal-open-for-container';
var VUX_VIEW_BOX_ELEMENT = '#vux_view_box_body';

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // some plugin may be imported before configPlugin, so we cannot get gloal config when component is created
    getLayout: function getLayout() {
      if (typeof window !== 'undefined') {
        if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
          return 'VIEW_BOX';
        }
      }
      return '';
    },
    addModalClassName: function addModalClassName() {
      if (typeof this.shouldPreventScroll === 'function' && this.shouldPreventScroll()) {
        return;
      }
      if (this.getLayout() === 'VIEW_BOX') {
        __WEBPACK_IMPORTED_MODULE_0__libs_dom__["a" /* default */].addClass(document.body, BODY_CLASS_NAME);
        __WEBPACK_IMPORTED_MODULE_0__libs_dom__["a" /* default */].addClass(document.querySelector(VUX_VIEW_BOX_ELEMENT), CONTAINER_CLASS_NAME);
      }
    },
    removeModalClassName: function removeModalClassName() {
      if (this.getLayout() === 'VIEW_BOX') {
        __WEBPACK_IMPORTED_MODULE_0__libs_dom__["a" /* default */].removeClass(document.body, BODY_CLASS_NAME);
        __WEBPACK_IMPORTED_MODULE_0__libs_dom__["a" /* default */].removeClass(document.querySelector(VUX_VIEW_BOX_ELEMENT), CONTAINER_CLASS_NAME);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeModalClassName();
  },
  deactivated: function deactivated() {
    this.removeModalClassName();
  }
});

/***/ }),

/***/ "JnrT":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 3.0.21
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : (function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			'delete': function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	})();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function (name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = ta.clientWidth;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			var originalHeight = ta.style.height;
			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = 'auto';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight !== styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map['delete'](ta);
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),

/***/ "K6ED":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("cnlX"), __esModule: true };

/***/ }),

/***/ "KRg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.uuid = Math.random().toString(36).substring(3, 8);
  }
});

/***/ }),

/***/ "Kh4W":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("dSzd");


/***/ }),

/***/ "Kh5d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("sB3e");
var $getPrototypeOf = __webpack_require__("PzxK");

__webpack_require__("uqUo")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "L42u":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var invoke = __webpack_require__("knuC");
var html = __webpack_require__("RPLV");
var cel = __webpack_require__("ON07");
var global = __webpack_require__("7KvD");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("R9M2")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "LBxF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

utils.getOption = getOption;

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "LIJb":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "LKZe":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("NpIQ");
var createDesc = __webpack_require__("X8DO");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var has = __webpack_require__("D2L2");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("+E39") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "LLCR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),

/***/ "LsKW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array) {
  return array.length === 1 ? array[0] : array.join(' ');
});

/***/ }),

/***/ "M6a0":
/***/ (function(module, exports) {



/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "Mhyx":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("/bQp");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "Ml+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACESFilmicToneMapping */
/* unused harmony export AddEquation */
/* unused harmony export AddOperation */
/* unused harmony export AdditiveAnimationBlendMode */
/* unused harmony export AdditiveBlending */
/* unused harmony export AlphaFormat */
/* unused harmony export AlwaysDepth */
/* unused harmony export AlwaysStencilFunc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmbientLight; });
/* unused harmony export AmbientLightProbe */
/* unused harmony export AnimationAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimationClip; });
/* unused harmony export AnimationLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnimationMixer; });
/* unused harmony export AnimationObjectGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AnimationUtils; });
/* unused harmony export ArcCurve */
/* unused harmony export ArrayCamera */
/* unused harmony export ArrowHelper */
/* unused harmony export Audio */
/* unused harmony export AudioAnalyser */
/* unused harmony export AudioContext */
/* unused harmony export AudioListener */
/* unused harmony export AudioLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AxesHelper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BackSide; });
/* unused harmony export BasicDepthPacking */
/* unused harmony export BasicShadowMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Bone; });
/* unused harmony export BooleanKeyframeTrack */
/* unused harmony export Box2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Box3; });
/* unused harmony export Box3Helper */
/* unused harmony export BoxBufferGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BoxGeometry; });
/* unused harmony export BoxHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BufferAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BufferGeometry; });
/* unused harmony export BufferGeometryLoader */
/* unused harmony export ByteType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Cache; });
/* unused harmony export Camera */
/* unused harmony export CameraHelper */
/* unused harmony export CanvasTexture */
/* unused harmony export CapsuleBufferGeometry */
/* unused harmony export CapsuleGeometry */
/* unused harmony export CatmullRomCurve3 */
/* unused harmony export CineonToneMapping */
/* unused harmony export CircleBufferGeometry */
/* unused harmony export CircleGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ClampToEdgeWrapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Clock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Color; });
/* unused harmony export ColorKeyframeTrack */
/* unused harmony export ColorManagement */
/* unused harmony export CompressedArrayTexture */
/* unused harmony export CompressedTexture */
/* unused harmony export CompressedTextureLoader */
/* unused harmony export ConeBufferGeometry */
/* unused harmony export ConeGeometry */
/* unused harmony export CubeCamera */
/* unused harmony export CubeReflectionMapping */
/* unused harmony export CubeRefractionMapping */
/* unused harmony export CubeTexture */
/* unused harmony export CubeTextureLoader */
/* unused harmony export CubeUVReflectionMapping */
/* unused harmony export CubicBezierCurve */
/* unused harmony export CubicBezierCurve3 */
/* unused harmony export CubicInterpolant */
/* unused harmony export CullFaceBack */
/* unused harmony export CullFaceFront */
/* unused harmony export CullFaceFrontBack */
/* unused harmony export CullFaceNone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Curve; });
/* unused harmony export CurvePath */
/* unused harmony export CustomBlending */
/* unused harmony export CustomToneMapping */
/* unused harmony export CylinderBufferGeometry */
/* unused harmony export CylinderGeometry */
/* unused harmony export Cylindrical */
/* unused harmony export Data3DTexture */
/* unused harmony export DataArrayTexture */
/* unused harmony export DataTexture */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DataTextureLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DataUtils; });
/* unused harmony export DecrementStencilOp */
/* unused harmony export DecrementWrapStencilOp */
/* unused harmony export DefaultLoadingManager */
/* unused harmony export DepthFormat */
/* unused harmony export DepthStencilFormat */
/* unused harmony export DepthTexture */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DirectionalLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DirectionalLightHelper; });
/* unused harmony export DiscreteInterpolant */
/* unused harmony export DisplayP3ColorSpace */
/* unused harmony export DodecahedronBufferGeometry */
/* unused harmony export DodecahedronGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DoubleSide; });
/* unused harmony export DstAlphaFactor */
/* unused harmony export DstColorFactor */
/* unused harmony export DynamicCopyUsage */
/* unused harmony export DynamicDrawUsage */
/* unused harmony export DynamicReadUsage */
/* unused harmony export EdgesGeometry */
/* unused harmony export EllipseCurve */
/* unused harmony export EqualDepth */
/* unused harmony export EqualStencilFunc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return EquirectangularReflectionMapping; });
/* unused harmony export EquirectangularRefractionMapping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return Euler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EventDispatcher; });
/* unused harmony export ExtrudeBufferGeometry */
/* unused harmony export ExtrudeGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FileLoader; });
/* unused harmony export Float16BufferAttribute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return Float32BufferAttribute; });
/* unused harmony export Float64BufferAttribute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FloatType; });
/* unused harmony export Fog */
/* unused harmony export FogExp2 */
/* unused harmony export FramebufferTexture */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FrontSide; });
/* unused harmony export Frustum */
/* unused harmony export GLBufferAttribute */
/* unused harmony export GLSL1 */
/* unused harmony export GLSL3 */
/* unused harmony export GreaterDepth */
/* unused harmony export GreaterEqualDepth */
/* unused harmony export GreaterEqualStencilFunc */
/* unused harmony export GreaterStencilFunc */
/* unused harmony export GridHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return Group; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HalfFloatType; });
/* unused harmony export HemisphereLight */
/* unused harmony export HemisphereLightHelper */
/* unused harmony export HemisphereLightProbe */
/* unused harmony export IcosahedronBufferGeometry */
/* unused harmony export IcosahedronGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ImageBitmapLoader; });
/* unused harmony export ImageLoader */
/* unused harmony export ImageUtils */
/* unused harmony export IncrementStencilOp */
/* unused harmony export IncrementWrapStencilOp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return InstancedBufferAttribute; });
/* unused harmony export InstancedBufferGeometry */
/* unused harmony export InstancedInterleavedBuffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return InstancedMesh; });
/* unused harmony export Int16BufferAttribute */
/* unused harmony export Int32BufferAttribute */
/* unused harmony export Int8BufferAttribute */
/* unused harmony export IntType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return InterleavedBuffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return InterleavedBufferAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return Interpolant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return InterpolateDiscrete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return InterpolateLinear; });
/* unused harmony export InterpolateSmooth */
/* unused harmony export InvertStencilOp */
/* unused harmony export KeepStencilOp */
/* unused harmony export KeyframeTrack */
/* unused harmony export LOD */
/* unused harmony export LatheBufferGeometry */
/* unused harmony export LatheGeometry */
/* unused harmony export Layers */
/* unused harmony export LessDepth */
/* unused harmony export LessEqualDepth */
/* unused harmony export LessEqualStencilFunc */
/* unused harmony export LessStencilFunc */
/* unused harmony export Light */
/* unused harmony export LightProbe */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return Line; });
/* unused harmony export Line3 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return LineBasicMaterial; });
/* unused harmony export LineCurve */
/* unused harmony export LineCurve3 */
/* unused harmony export LineDashedMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return LineLoop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return LineSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return LinearEncoding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return LinearFilter; });
/* unused harmony export LinearInterpolant */
/* unused harmony export LinearMipMapLinearFilter */
/* unused harmony export LinearMipMapNearestFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return LinearMipmapLinearFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return LinearMipmapNearestFilter; });
/* unused harmony export LinearSRGBColorSpace */
/* unused harmony export LinearToneMapping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return LoaderUtils; });
/* unused harmony export LoadingManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return LoopOnce; });
/* unused harmony export LoopPingPong */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return LoopRepeat; });
/* unused harmony export LuminanceAlphaFormat */
/* unused harmony export LuminanceFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MOUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return Material; });
/* unused harmony export MaterialLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return MathUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return Matrix3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return Matrix4; });
/* unused harmony export MaxEquation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return Mesh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return MeshBasicMaterial; });
/* unused harmony export MeshDepthMaterial */
/* unused harmony export MeshDistanceMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return MeshLambertMaterial; });
/* unused harmony export MeshMatcapMaterial */
/* unused harmony export MeshNormalMaterial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return MeshPhongMaterial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return MeshPhysicalMaterial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return MeshStandardMaterial; });
/* unused harmony export MeshToonMaterial */
/* unused harmony export MinEquation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return MirroredRepeatWrapping; });
/* unused harmony export MixOperation */
/* unused harmony export MultiplyBlending */
/* unused harmony export MultiplyOperation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return NearestFilter; });
/* unused harmony export NearestMipMapLinearFilter */
/* unused harmony export NearestMipMapNearestFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return NearestMipmapLinearFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return NearestMipmapNearestFilter; });
/* unused harmony export NeverDepth */
/* unused harmony export NeverStencilFunc */
/* unused harmony export NoBlending */
/* unused harmony export NoColorSpace */
/* unused harmony export NoToneMapping */
/* unused harmony export NormalAnimationBlendMode */
/* unused harmony export NormalBlending */
/* unused harmony export NotEqualDepth */
/* unused harmony export NotEqualStencilFunc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return NumberKeyframeTrack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return Object3D; });
/* unused harmony export ObjectLoader */
/* unused harmony export ObjectSpaceNormalMap */
/* unused harmony export OctahedronBufferGeometry */
/* unused harmony export OctahedronGeometry */
/* unused harmony export OneFactor */
/* unused harmony export OneMinusDstAlphaFactor */
/* unused harmony export OneMinusDstColorFactor */
/* unused harmony export OneMinusSrcAlphaFactor */
/* unused harmony export OneMinusSrcColorFactor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return OrthographicCamera; });
/* unused harmony export PCFShadowMap */
/* unused harmony export PCFSoftShadowMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return PMREMGenerator; });
/* unused harmony export Path */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return PerspectiveCamera; });
/* unused harmony export Plane */
/* unused harmony export PlaneBufferGeometry */
/* unused harmony export PlaneGeometry */
/* unused harmony export PlaneHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return PointLight; });
/* unused harmony export PointLightHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return Points; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return PointsMaterial; });
/* unused harmony export PolarGridHelper */
/* unused harmony export PolyhedronBufferGeometry */
/* unused harmony export PolyhedronGeometry */
/* unused harmony export PositionalAudio */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return PropertyBinding; });
/* unused harmony export PropertyMixer */
/* unused harmony export QuadraticBezierCurve */
/* unused harmony export QuadraticBezierCurve3 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return Quaternion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return QuaternionKeyframeTrack; });
/* unused harmony export QuaternionLinearInterpolant */
/* unused harmony export RED_GREEN_RGTC2_Format */
/* unused harmony export RED_RGTC1_Format */
/* unused harmony export REVISION */
/* unused harmony export RGBADepthPacking */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return RGBAFormat; });
/* unused harmony export RGBAIntegerFormat */
/* unused harmony export RGBA_ASTC_10x10_Format */
/* unused harmony export RGBA_ASTC_10x5_Format */
/* unused harmony export RGBA_ASTC_10x6_Format */
/* unused harmony export RGBA_ASTC_10x8_Format */
/* unused harmony export RGBA_ASTC_12x10_Format */
/* unused harmony export RGBA_ASTC_12x12_Format */
/* unused harmony export RGBA_ASTC_4x4_Format */
/* unused harmony export RGBA_ASTC_5x4_Format */
/* unused harmony export RGBA_ASTC_5x5_Format */
/* unused harmony export RGBA_ASTC_6x5_Format */
/* unused harmony export RGBA_ASTC_6x6_Format */
/* unused harmony export RGBA_ASTC_8x5_Format */
/* unused harmony export RGBA_ASTC_8x6_Format */
/* unused harmony export RGBA_ASTC_8x8_Format */
/* unused harmony export RGBA_BPTC_Format */
/* unused harmony export RGBA_ETC2_EAC_Format */
/* unused harmony export RGBA_PVRTC_2BPPV1_Format */
/* unused harmony export RGBA_PVRTC_4BPPV1_Format */
/* unused harmony export RGBA_S3TC_DXT1_Format */
/* unused harmony export RGBA_S3TC_DXT3_Format */
/* unused harmony export RGBA_S3TC_DXT5_Format */
/* unused harmony export RGB_ETC1_Format */
/* unused harmony export RGB_ETC2_Format */
/* unused harmony export RGB_PVRTC_2BPPV1_Format */
/* unused harmony export RGB_PVRTC_4BPPV1_Format */
/* unused harmony export RGB_S3TC_DXT1_Format */
/* unused harmony export RGFormat */
/* unused harmony export RGIntegerFormat */
/* unused harmony export RawShaderMaterial */
/* unused harmony export Ray */
/* unused harmony export Raycaster */
/* unused harmony export RectAreaLight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return RedFormat; });
/* unused harmony export RedIntegerFormat */
/* unused harmony export ReinhardToneMapping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return RepeatWrapping; });
/* unused harmony export ReplaceStencilOp */
/* unused harmony export ReverseSubtractEquation */
/* unused harmony export RingBufferGeometry */
/* unused harmony export RingGeometry */
/* unused harmony export SIGNED_RED_GREEN_RGTC2_Format */
/* unused harmony export SIGNED_RED_RGTC1_Format */
/* unused harmony export SRGBColorSpace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return Scene; });
/* unused harmony export ShaderChunk */
/* unused harmony export ShaderLib */
/* unused harmony export ShaderMaterial */
/* unused harmony export ShadowMaterial */
/* unused harmony export Shape */
/* unused harmony export ShapeBufferGeometry */
/* unused harmony export ShapeGeometry */
/* unused harmony export ShapePath */
/* unused harmony export ShapeUtils */
/* unused harmony export ShortType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return Skeleton; });
/* unused harmony export SkeletonHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SkinnedMesh; });
/* unused harmony export Source */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return Sphere; });
/* unused harmony export SphereBufferGeometry */
/* unused harmony export SphereGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return Spherical; });
/* unused harmony export SphericalHarmonics3 */
/* unused harmony export SplineCurve */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SpotLight; });
/* unused harmony export SpotLightHelper */
/* unused harmony export Sprite */
/* unused harmony export SpriteMaterial */
/* unused harmony export SrcAlphaFactor */
/* unused harmony export SrcAlphaSaturateFactor */
/* unused harmony export SrcColorFactor */
/* unused harmony export StaticCopyUsage */
/* unused harmony export StaticDrawUsage */
/* unused harmony export StaticReadUsage */
/* unused harmony export StereoCamera */
/* unused harmony export StreamCopyUsage */
/* unused harmony export StreamDrawUsage */
/* unused harmony export StreamReadUsage */
/* unused harmony export StringKeyframeTrack */
/* unused harmony export SubtractEquation */
/* unused harmony export SubtractiveBlending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return TOUCH; });
/* unused harmony export TangentSpaceNormalMap */
/* unused harmony export TetrahedronBufferGeometry */
/* unused harmony export TetrahedronGeometry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return Texture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return TextureLoader; });
/* unused harmony export TorusBufferGeometry */
/* unused harmony export TorusGeometry */
/* unused harmony export TorusKnotBufferGeometry */
/* unused harmony export TorusKnotGeometry */
/* unused harmony export Triangle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return TriangleFanDrawMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return TriangleStripDrawMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return TrianglesDrawMode; });
/* unused harmony export TubeBufferGeometry */
/* unused harmony export TubeGeometry */
/* unused harmony export TwoPassDoubleSide */
/* unused harmony export UVMapping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return Uint16BufferAttribute; });
/* unused harmony export Uint32BufferAttribute */
/* unused harmony export Uint8BufferAttribute */
/* unused harmony export Uint8ClampedBufferAttribute */
/* unused harmony export Uniform */
/* unused harmony export UniformsGroup */
/* unused harmony export UniformsLib */
/* unused harmony export UniformsUtils */
/* unused harmony export UnsignedByteType */
/* unused harmony export UnsignedInt248Type */
/* unused harmony export UnsignedIntType */
/* unused harmony export UnsignedShort4444Type */
/* unused harmony export UnsignedShort5551Type */
/* unused harmony export UnsignedShortType */
/* unused harmony export VSMShadowMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return Vector2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return Vector3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return Vector4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return VectorKeyframeTrack; });
/* unused harmony export VideoTexture */
/* unused harmony export WebGL1Renderer */
/* unused harmony export WebGL3DRenderTarget */
/* unused harmony export WebGLArrayRenderTarget */
/* unused harmony export WebGLCubeRenderTarget */
/* unused harmony export WebGLMultipleRenderTargets */
/* unused harmony export WebGLRenderTarget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return WebGLRenderer; });
/* unused harmony export WebGLUtils */
/* unused harmony export WireframeGeometry */
/* unused harmony export WrapAroundEnding */
/* unused harmony export ZeroCurvatureEnding */
/* unused harmony export ZeroFactor */
/* unused harmony export ZeroSlopeEnding */
/* unused harmony export ZeroStencilOp */
/* unused harmony export _SRGBAFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return sRGBEncoding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__("hiCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2__ = __webpack_require__("yI0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map__ = __webpack_require__("XFB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon__ = __webpack_require__("NnIC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_math_imul__ = __webpack_require__("qajy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass__);






























var _TO_LINEAR, _FROM_LINEAR;

/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
var REVISION = '151';
var MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
var TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
var CullFaceNone = 0;
var CullFaceBack = 1;
var CullFaceFront = 2;
var CullFaceFrontBack = 3;
var BasicShadowMap = 0;
var PCFShadowMap = 1;
var PCFSoftShadowMap = 2;
var VSMShadowMap = 3;
var FrontSide = 0;
var BackSide = 1;
var DoubleSide = 2;
var TwoPassDoubleSide = 2; // r149
var NoBlending = 0;
var NormalBlending = 1;
var AdditiveBlending = 2;
var SubtractiveBlending = 3;
var MultiplyBlending = 4;
var CustomBlending = 5;
var AddEquation = 100;
var SubtractEquation = 101;
var ReverseSubtractEquation = 102;
var MinEquation = 103;
var MaxEquation = 104;
var ZeroFactor = 200;
var OneFactor = 201;
var SrcColorFactor = 202;
var OneMinusSrcColorFactor = 203;
var SrcAlphaFactor = 204;
var OneMinusSrcAlphaFactor = 205;
var DstAlphaFactor = 206;
var OneMinusDstAlphaFactor = 207;
var DstColorFactor = 208;
var OneMinusDstColorFactor = 209;
var SrcAlphaSaturateFactor = 210;
var NeverDepth = 0;
var AlwaysDepth = 1;
var LessDepth = 2;
var LessEqualDepth = 3;
var EqualDepth = 4;
var GreaterEqualDepth = 5;
var GreaterDepth = 6;
var NotEqualDepth = 7;
var MultiplyOperation = 0;
var MixOperation = 1;
var AddOperation = 2;
var NoToneMapping = 0;
var LinearToneMapping = 1;
var ReinhardToneMapping = 2;
var CineonToneMapping = 3;
var ACESFilmicToneMapping = 4;
var CustomToneMapping = 5;

var UVMapping = 300;
var CubeReflectionMapping = 301;
var CubeRefractionMapping = 302;
var EquirectangularReflectionMapping = 303;
var EquirectangularRefractionMapping = 304;
var CubeUVReflectionMapping = 306;
var RepeatWrapping = 1000;
var ClampToEdgeWrapping = 1001;
var MirroredRepeatWrapping = 1002;
var NearestFilter = 1003;
var NearestMipmapNearestFilter = 1004;
var NearestMipMapNearestFilter = 1004;
var NearestMipmapLinearFilter = 1005;
var NearestMipMapLinearFilter = 1005;
var LinearFilter = 1006;
var LinearMipmapNearestFilter = 1007;
var LinearMipMapNearestFilter = 1007;
var LinearMipmapLinearFilter = 1008;
var LinearMipMapLinearFilter = 1008;
var UnsignedByteType = 1009;
var ByteType = 1010;
var ShortType = 1011;
var UnsignedShortType = 1012;
var IntType = 1013;
var UnsignedIntType = 1014;
var FloatType = 1015;
var HalfFloatType = 1016;
var UnsignedShort4444Type = 1017;
var UnsignedShort5551Type = 1018;
var UnsignedInt248Type = 1020;
var AlphaFormat = 1021;
var RGBAFormat = 1023;
var LuminanceFormat = 1024;
var LuminanceAlphaFormat = 1025;
var DepthFormat = 1026;
var DepthStencilFormat = 1027;
var RedFormat = 1028;
var RedIntegerFormat = 1029;
var RGFormat = 1030;
var RGIntegerFormat = 1031;
var RGBAIntegerFormat = 1033;

var RGB_S3TC_DXT1_Format = 33776;
var RGBA_S3TC_DXT1_Format = 33777;
var RGBA_S3TC_DXT3_Format = 33778;
var RGBA_S3TC_DXT5_Format = 33779;
var RGB_PVRTC_4BPPV1_Format = 35840;
var RGB_PVRTC_2BPPV1_Format = 35841;
var RGBA_PVRTC_4BPPV1_Format = 35842;
var RGBA_PVRTC_2BPPV1_Format = 35843;
var RGB_ETC1_Format = 36196;
var RGB_ETC2_Format = 37492;
var RGBA_ETC2_EAC_Format = 37496;
var RGBA_ASTC_4x4_Format = 37808;
var RGBA_ASTC_5x4_Format = 37809;
var RGBA_ASTC_5x5_Format = 37810;
var RGBA_ASTC_6x5_Format = 37811;
var RGBA_ASTC_6x6_Format = 37812;
var RGBA_ASTC_8x5_Format = 37813;
var RGBA_ASTC_8x6_Format = 37814;
var RGBA_ASTC_8x8_Format = 37815;
var RGBA_ASTC_10x5_Format = 37816;
var RGBA_ASTC_10x6_Format = 37817;
var RGBA_ASTC_10x8_Format = 37818;
var RGBA_ASTC_10x10_Format = 37819;
var RGBA_ASTC_12x10_Format = 37820;
var RGBA_ASTC_12x12_Format = 37821;
var RGBA_BPTC_Format = 36492;
var RED_RGTC1_Format = 36283;
var SIGNED_RED_RGTC1_Format = 36284;
var RED_GREEN_RGTC2_Format = 36285;
var SIGNED_RED_GREEN_RGTC2_Format = 36286;
var LoopOnce = 2200;
var LoopRepeat = 2201;
var LoopPingPong = 2202;
var InterpolateDiscrete = 2300;
var InterpolateLinear = 2301;
var InterpolateSmooth = 2302;
var ZeroCurvatureEnding = 2400;
var ZeroSlopeEnding = 2401;
var WrapAroundEnding = 2402;
var NormalAnimationBlendMode = 2500;
var AdditiveAnimationBlendMode = 2501;
var TrianglesDrawMode = 0;
var TriangleStripDrawMode = 1;
var TriangleFanDrawMode = 2;
var LinearEncoding = 3000;
var sRGBEncoding = 3001;
var BasicDepthPacking = 3200;
var RGBADepthPacking = 3201;
var TangentSpaceNormalMap = 0;
var ObjectSpaceNormalMap = 1;

// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
var NoColorSpace = '';
var SRGBColorSpace = 'srgb';
var LinearSRGBColorSpace = 'srgb-linear';
var DisplayP3ColorSpace = 'display-p3';

var ZeroStencilOp = 0;
var KeepStencilOp = 7680;
var ReplaceStencilOp = 7681;
var IncrementStencilOp = 7682;
var DecrementStencilOp = 7683;
var IncrementWrapStencilOp = 34055;
var DecrementWrapStencilOp = 34056;
var InvertStencilOp = 5386;

var NeverStencilFunc = 512;
var LessStencilFunc = 513;
var EqualStencilFunc = 514;
var LessEqualStencilFunc = 515;
var GreaterStencilFunc = 516;
var NotEqualStencilFunc = 517;
var GreaterEqualStencilFunc = 518;
var AlwaysStencilFunc = 519;

var StaticDrawUsage = 35044;
var DynamicDrawUsage = 35048;
var StreamDrawUsage = 35040;
var StaticReadUsage = 35045;
var DynamicReadUsage = 35049;
var StreamReadUsage = 35041;
var StaticCopyUsage = 35046;
var DynamicCopyUsage = 35050;
var StreamCopyUsage = 35042;

var GLSL1 = '100';
var GLSL3 = '300 es';

var _SRGBAFormat = 1035; // fallback for WebGL 1

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

var EventDispatcher = function () {
	function EventDispatcher() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, EventDispatcher);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(EventDispatcher, [{
		key: 'addEventListener',
		value: function addEventListener(type, listener) {

			if (this._listeners === undefined) this._listeners = {};

			var listeners = this._listeners;

			if (listeners[type] === undefined) {

				listeners[type] = [];
			}

			if (listeners[type].indexOf(listener) === -1) {

				listeners[type].push(listener);
			}
		}
	}, {
		key: 'hasEventListener',
		value: function hasEventListener(type, listener) {

			if (this._listeners === undefined) return false;

			var listeners = this._listeners;

			return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
		}
	}, {
		key: 'removeEventListener',
		value: function removeEventListener(type, listener) {

			if (this._listeners === undefined) return;

			var listeners = this._listeners;
			var listenerArray = listeners[type];

			if (listenerArray !== undefined) {

				var index = listenerArray.indexOf(listener);

				if (index !== -1) {

					listenerArray.splice(index, 1);
				}
			}
		}
	}, {
		key: 'dispatchEvent',
		value: function dispatchEvent(event) {

			if (this._listeners === undefined) return;

			var listeners = this._listeners;
			var listenerArray = listeners[event.type];

			if (listenerArray !== undefined) {

				event.target = this;

				// Make a copy, in case listeners are removed while iterating.
				var array = listenerArray.slice(0);

				for (var i = 0, l = array.length; i < l; i++) {

					array[i].call(this, event);
				}

				event.target = null;
			}
		}
	}]);

	return EventDispatcher;
}();

var _lut = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '0a', '0b', '0c', '0d', '0e', '0f', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '1a', '1b', '1c', '1d', '1e', '1f', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '2a', '2b', '2c', '2d', '2e', '2f', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '3a', '3b', '3c', '3d', '3e', '3f', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '4a', '4b', '4c', '4d', '4e', '4f', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '5a', '5b', '5c', '5d', '5e', '5f', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '6a', '6b', '6c', '6d', '6e', '6f', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '7a', '7b', '7c', '7d', '7e', '7f', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '8a', '8b', '8c', '8d', '8e', '8f', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '9a', '9b', '9c', '9d', '9e', '9f', 'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'b0', 'b1', 'b2', 'b3', 'b4', 'b5', 'b6', 'b7', 'b8', 'b9', 'ba', 'bb', 'bc', 'bd', 'be', 'bf', 'c0', 'c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'ca', 'cb', 'cc', 'cd', 'ce', 'cf', 'd0', 'd1', 'd2', 'd3', 'd4', 'd5', 'd6', 'd7', 'd8', 'd9', 'da', 'db', 'dc', 'dd', 'de', 'df', 'e0', 'e1', 'e2', 'e3', 'e4', 'e5', 'e6', 'e7', 'e8', 'e9', 'ea', 'eb', 'ec', 'ed', 'ee', 'ef', 'f0', 'f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'fa', 'fb', 'fc', 'fd', 'fe', 'ff'];

var _seed = 1234567;

var DEG2RAD = Math.PI / 180;
var RAD2DEG = 180 / Math.PI;

// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function generateUUID() {

	var d0 = Math.random() * 0xffffffff | 0;
	var d1 = Math.random() * 0xffffffff | 0;
	var d2 = Math.random() * 0xffffffff | 0;
	var d3 = Math.random() * 0xffffffff | 0;
	var uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff];

	// .toLowerCase() here flattens concatenated strings to save heap memory space.
	return uuid.toLowerCase();
}

function clamp(value, min, max) {

	return Math.max(min, Math.min(max, value));
}

// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function euclideanModulo(n, m) {

	return (n % m + m) % m;
}

// Linear mapping from range <a1, a2> to range <b1, b2>
function mapLinear(x, a1, a2, b1, b2) {

	return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}

// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function inverseLerp(x, y, value) {

	if (x !== y) {

		return (value - x) / (y - x);
	} else {

		return 0;
	}
}

// https://en.wikipedia.org/wiki/Linear_interpolation
function lerp(x, y, t) {

	return (1 - t) * x + t * y;
}

// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function damp(x, y, lambda, dt) {

	return lerp(x, y, 1 - Math.exp(-lambda * dt));
}

// https://www.desmos.com/calculator/vcsjnyz7x4
function pingpong(x) {
	var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;


	return length - Math.abs(euclideanModulo(x, length * 2) - length);
}

// http://en.wikipedia.org/wiki/Smoothstep
function smoothstep(x, min, max) {

	if (x <= min) return 0;
	if (x >= max) return 1;

	x = (x - min) / (max - min);

	return x * x * (3 - 2 * x);
}

function smootherstep(x, min, max) {

	if (x <= min) return 0;
	if (x >= max) return 1;

	x = (x - min) / (max - min);

	return x * x * x * (x * (x * 6 - 15) + 10);
}

// Random integer from <low, high> interval
function randInt(low, high) {

	return low + Math.floor(Math.random() * (high - low + 1));
}

// Random float from <low, high> interval
function randFloat(low, high) {

	return low + Math.random() * (high - low);
}

// Random float from <-range/2, range/2> interval
function randFloatSpread(range) {

	return range * (0.5 - Math.random());
}

// Deterministic pseudo-random float in the interval [ 0, 1 ]
function seededRandom(s) {

	if (s !== undefined) _seed = s;

	// Mulberry32 generator

	var t = _seed += 0x6D2B79F5;

	t = __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_math_imul___default()(t ^ t >>> 15, t | 1);

	t ^= t + __WEBPACK_IMPORTED_MODULE_26_babel_runtime_core_js_math_imul___default()(t ^ t >>> 7, t | 61);

	return ((t ^ t >>> 14) >>> 0) / 4294967296;
}

function degToRad(degrees) {

	return degrees * DEG2RAD;
}

function radToDeg(radians) {

	return radians * RAD2DEG;
}

function isPowerOfTwo(value) {

	return (value & value - 1) === 0 && value !== 0;
}

function ceilPowerOfTwo(value) {

	return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}

function floorPowerOfTwo(value) {

	return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}

function setQuaternionFromProperEuler(q, a, b, c, order) {

	// Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles

	// rotations are applied to the axes in the order specified by 'order'
	// rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
	// angles are in radians

	var cos = Math.cos;
	var sin = Math.sin;

	var c2 = cos(b / 2);
	var s2 = sin(b / 2);

	var c13 = cos((a + c) / 2);
	var s13 = sin((a + c) / 2);

	var c1_3 = cos((a - c) / 2);
	var s1_3 = sin((a - c) / 2);

	var c3_1 = cos((c - a) / 2);
	var s3_1 = sin((c - a) / 2);

	switch (order) {

		case 'XYX':
			q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
			break;

		case 'YZY':
			q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
			break;

		case 'ZXZ':
			q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
			break;

		case 'XZX':
			q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
			break;

		case 'YXY':
			q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
			break;

		case 'ZYZ':
			q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
			break;

		default:
			console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);

	}
}

function denormalize(value, array) {

	switch (array.constructor) {

		case Float32Array:

			return value;

		case Uint16Array:

			return value / 65535.0;

		case Uint8Array:

			return value / 255.0;

		case Int16Array:

			return Math.max(value / 32767.0, -1.0);

		case Int8Array:

			return Math.max(value / 127.0, -1.0);

		default:

			throw new Error('Invalid component type.');

	}
}

function normalize(value, array) {

	switch (array.constructor) {

		case Float32Array:

			return value;

		case Uint16Array:

			return Math.round(value * 65535.0);

		case Uint8Array:

			return Math.round(value * 255.0);

		case Int16Array:

			return Math.round(value * 32767.0);

		case Int8Array:

			return Math.round(value * 127.0);

		default:

			throw new Error('Invalid component type.');

	}
}

var MathUtils = {
	DEG2RAD: DEG2RAD,
	RAD2DEG: RAD2DEG,
	generateUUID: generateUUID,
	clamp: clamp,
	euclideanModulo: euclideanModulo,
	mapLinear: mapLinear,
	inverseLerp: inverseLerp,
	lerp: lerp,
	damp: damp,
	pingpong: pingpong,
	smoothstep: smoothstep,
	smootherstep: smootherstep,
	randInt: randInt,
	randFloat: randFloat,
	randFloatSpread: randFloatSpread,
	seededRandom: seededRandom,
	degToRad: degToRad,
	radToDeg: radToDeg,
	isPowerOfTwo: isPowerOfTwo,
	ceilPowerOfTwo: ceilPowerOfTwo,
	floorPowerOfTwo: floorPowerOfTwo,
	setQuaternionFromProperEuler: setQuaternionFromProperEuler,
	normalize: normalize,
	denormalize: denormalize
};

var Vector2 = function () {
	function Vector2() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Vector2);

		Vector2.prototype.isVector2 = true;

		this.x = x;
		this.y = y;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Vector2, [{
		key: 'set',
		value: function set(x, y) {

			this.x = x;
			this.y = y;

			return this;
		}
	}, {
		key: 'setScalar',
		value: function setScalar(scalar) {

			this.x = scalar;
			this.y = scalar;

			return this;
		}
	}, {
		key: 'setX',
		value: function setX(x) {

			this.x = x;

			return this;
		}
	}, {
		key: 'setY',
		value: function setY(y) {

			this.y = y;

			return this;
		}
	}, {
		key: 'setComponent',
		value: function setComponent(index, value) {

			switch (index) {

				case 0:
					this.x = value;break;
				case 1:
					this.y = value;break;
				default:
					throw new Error('index is out of range: ' + index);

			}

			return this;
		}
	}, {
		key: 'getComponent',
		value: function getComponent(index) {

			switch (index) {

				case 0:
					return this.x;
				case 1:
					return this.y;
				default:
					throw new Error('index is out of range: ' + index);

			}
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.x, this.y);
		}
	}, {
		key: 'copy',
		value: function copy(v) {

			this.x = v.x;
			this.y = v.y;

			return this;
		}
	}, {
		key: 'add',
		value: function add(v) {

			this.x += v.x;
			this.y += v.y;

			return this;
		}
	}, {
		key: 'addScalar',
		value: function addScalar(s) {

			this.x += s;
			this.y += s;

			return this;
		}
	}, {
		key: 'addVectors',
		value: function addVectors(a, b) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;

			return this;
		}
	}, {
		key: 'addScaledVector',
		value: function addScaledVector(v, s) {

			this.x += v.x * s;
			this.y += v.y * s;

			return this;
		}
	}, {
		key: 'sub',
		value: function sub(v) {

			this.x -= v.x;
			this.y -= v.y;

			return this;
		}
	}, {
		key: 'subScalar',
		value: function subScalar(s) {

			this.x -= s;
			this.y -= s;

			return this;
		}
	}, {
		key: 'subVectors',
		value: function subVectors(a, b) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(v) {

			this.x *= v.x;
			this.y *= v.y;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(scalar) {

			this.x *= scalar;
			this.y *= scalar;

			return this;
		}
	}, {
		key: 'divide',
		value: function divide(v) {

			this.x /= v.x;
			this.y /= v.y;

			return this;
		}
	}, {
		key: 'divideScalar',
		value: function divideScalar(scalar) {

			return this.multiplyScalar(1 / scalar);
		}
	}, {
		key: 'applyMatrix3',
		value: function applyMatrix3(m) {

			var x = this.x,
			    y = this.y;
			var e = m.elements;

			this.x = e[0] * x + e[3] * y + e[6];
			this.y = e[1] * x + e[4] * y + e[7];

			return this;
		}
	}, {
		key: 'min',
		value: function min(v) {

			this.x = Math.min(this.x, v.x);
			this.y = Math.min(this.y, v.y);

			return this;
		}
	}, {
		key: 'max',
		value: function max(v) {

			this.x = Math.max(this.x, v.x);
			this.y = Math.max(this.y, v.y);

			return this;
		}
	}, {
		key: 'clamp',
		value: function clamp(min, max) {

			// assumes min < max, componentwise

			this.x = Math.max(min.x, Math.min(max.x, this.x));
			this.y = Math.max(min.y, Math.min(max.y, this.y));

			return this;
		}
	}, {
		key: 'clampScalar',
		value: function clampScalar(minVal, maxVal) {

			this.x = Math.max(minVal, Math.min(maxVal, this.x));
			this.y = Math.max(minVal, Math.min(maxVal, this.y));

			return this;
		}
	}, {
		key: 'clampLength',
		value: function clampLength(min, max) {

			var length = this.length();

			return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
		}
	}, {
		key: 'floor',
		value: function floor() {

			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);

			return this;
		}
	}, {
		key: 'ceil',
		value: function ceil() {

			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);

			return this;
		}
	}, {
		key: 'round',
		value: function round() {

			this.x = Math.round(this.x);
			this.y = Math.round(this.y);

			return this;
		}
	}, {
		key: 'roundToZero',
		value: function roundToZero() {

			this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);

			return this;
		}
	}, {
		key: 'negate',
		value: function negate() {

			this.x = -this.x;
			this.y = -this.y;

			return this;
		}
	}, {
		key: 'dot',
		value: function dot(v) {

			return this.x * v.x + this.y * v.y;
		}
	}, {
		key: 'cross',
		value: function cross(v) {

			return this.x * v.y - this.y * v.x;
		}
	}, {
		key: 'lengthSq',
		value: function lengthSq() {

			return this.x * this.x + this.y * this.y;
		}
	}, {
		key: 'length',
		value: function length() {

			return Math.sqrt(this.x * this.x + this.y * this.y);
		}
	}, {
		key: 'manhattanLength',
		value: function manhattanLength() {

			return Math.abs(this.x) + Math.abs(this.y);
		}
	}, {
		key: 'normalize',
		value: function normalize() {

			return this.divideScalar(this.length() || 1);
		}
	}, {
		key: 'angle',
		value: function angle() {

			// computes the angle in radians with respect to the positive x-axis

			var angle = Math.atan2(-this.y, -this.x) + Math.PI;

			return angle;
		}
	}, {
		key: 'angleTo',
		value: function angleTo(v) {

			var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());

			if (denominator === 0) return Math.PI / 2;

			var theta = this.dot(v) / denominator;

			// clamp, to handle numerical problems

			return Math.acos(clamp(theta, -1, 1));
		}
	}, {
		key: 'distanceTo',
		value: function distanceTo(v) {

			return Math.sqrt(this.distanceToSquared(v));
		}
	}, {
		key: 'distanceToSquared',
		value: function distanceToSquared(v) {

			var dx = this.x - v.x,
			    dy = this.y - v.y;
			return dx * dx + dy * dy;
		}
	}, {
		key: 'manhattanDistanceTo',
		value: function manhattanDistanceTo(v) {

			return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
		}
	}, {
		key: 'setLength',
		value: function setLength(length) {

			return this.normalize().multiplyScalar(length);
		}
	}, {
		key: 'lerp',
		value: function lerp(v, alpha) {

			this.x += (v.x - this.x) * alpha;
			this.y += (v.y - this.y) * alpha;

			return this;
		}
	}, {
		key: 'lerpVectors',
		value: function lerpVectors(v1, v2, alpha) {

			this.x = v1.x + (v2.x - v1.x) * alpha;
			this.y = v1.y + (v2.y - v1.y) * alpha;

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(v) {

			return v.x === this.x && v.y === this.y;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this.x = array[offset];
			this.y = array[offset + 1];

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this.x;
			array[offset + 1] = this.y;

			return array;
		}
	}, {
		key: 'fromBufferAttribute',
		value: function fromBufferAttribute(attribute, index) {

			this.x = attribute.getX(index);
			this.y = attribute.getY(index);

			return this;
		}
	}, {
		key: 'rotateAround',
		value: function rotateAround(center, angle) {

			var c = Math.cos(angle),
			    s = Math.sin(angle);

			var x = this.x - center.x;
			var y = this.y - center.y;

			this.x = x * c - y * s + center.x;
			this.y = x * s + y * c + center.y;

			return this;
		}
	}, {
		key: 'random',
		value: function random() {

			this.x = Math.random();
			this.y = Math.random();

			return this;
		}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return this.x;

						case 2:
							_context2.next = 4;
							return this.y;

						case 4:
						case 'end':
							return _context2.stop();
					}
				}
			}, value, this);
		})
	}, {
		key: 'width',
		get: function get() {

			return this.x;
		},
		set: function set(value) {

			this.x = value;
		}
	}, {
		key: 'height',
		get: function get() {

			return this.y;
		},
		set: function set(value) {

			this.y = value;
		}
	}]);

	return Vector2;
}();

var Matrix3 = function () {
	function Matrix3() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Matrix3);

		Matrix3.prototype.isMatrix3 = true;

		this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Matrix3, [{
		key: 'set',
		value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {

			var te = this.elements;

			te[0] = n11;te[1] = n21;te[2] = n31;
			te[3] = n12;te[4] = n22;te[5] = n32;
			te[6] = n13;te[7] = n23;te[8] = n33;

			return this;
		}
	}, {
		key: 'identity',
		value: function identity() {

			this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(m) {

			var te = this.elements;
			var me = m.elements;

			te[0] = me[0];te[1] = me[1];te[2] = me[2];
			te[3] = me[3];te[4] = me[4];te[5] = me[5];
			te[6] = me[6];te[7] = me[7];te[8] = me[8];

			return this;
		}
	}, {
		key: 'extractBasis',
		value: function extractBasis(xAxis, yAxis, zAxis) {

			xAxis.setFromMatrix3Column(this, 0);
			yAxis.setFromMatrix3Column(this, 1);
			zAxis.setFromMatrix3Column(this, 2);

			return this;
		}
	}, {
		key: 'setFromMatrix4',
		value: function setFromMatrix4(m) {

			var me = m.elements;

			this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(m) {

			return this.multiplyMatrices(this, m);
		}
	}, {
		key: 'premultiply',
		value: function premultiply(m) {

			return this.multiplyMatrices(m, this);
		}
	}, {
		key: 'multiplyMatrices',
		value: function multiplyMatrices(a, b) {

			var ae = a.elements;
			var be = b.elements;
			var te = this.elements;

			var a11 = ae[0],
			    a12 = ae[3],
			    a13 = ae[6];
			var a21 = ae[1],
			    a22 = ae[4],
			    a23 = ae[7];
			var a31 = ae[2],
			    a32 = ae[5],
			    a33 = ae[8];

			var b11 = be[0],
			    b12 = be[3],
			    b13 = be[6];
			var b21 = be[1],
			    b22 = be[4],
			    b23 = be[7];
			var b31 = be[2],
			    b32 = be[5],
			    b33 = be[8];

			te[0] = a11 * b11 + a12 * b21 + a13 * b31;
			te[3] = a11 * b12 + a12 * b22 + a13 * b32;
			te[6] = a11 * b13 + a12 * b23 + a13 * b33;

			te[1] = a21 * b11 + a22 * b21 + a23 * b31;
			te[4] = a21 * b12 + a22 * b22 + a23 * b32;
			te[7] = a21 * b13 + a22 * b23 + a23 * b33;

			te[2] = a31 * b11 + a32 * b21 + a33 * b31;
			te[5] = a31 * b12 + a32 * b22 + a33 * b32;
			te[8] = a31 * b13 + a32 * b23 + a33 * b33;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(s) {

			var te = this.elements;

			te[0] *= s;te[3] *= s;te[6] *= s;
			te[1] *= s;te[4] *= s;te[7] *= s;
			te[2] *= s;te[5] *= s;te[8] *= s;

			return this;
		}
	}, {
		key: 'determinant',
		value: function determinant() {

			var te = this.elements;

			var a = te[0],
			    b = te[1],
			    c = te[2],
			    d = te[3],
			    e = te[4],
			    f = te[5],
			    g = te[6],
			    h = te[7],
			    i = te[8];

			return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
		}
	}, {
		key: 'invert',
		value: function invert() {

			var te = this.elements,
			    n11 = te[0],
			    n21 = te[1],
			    n31 = te[2],
			    n12 = te[3],
			    n22 = te[4],
			    n32 = te[5],
			    n13 = te[6],
			    n23 = te[7],
			    n33 = te[8],
			    t11 = n33 * n22 - n32 * n23,
			    t12 = n32 * n13 - n33 * n12,
			    t13 = n23 * n12 - n22 * n13,
			    det = n11 * t11 + n21 * t12 + n31 * t13;

			if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);

			var detInv = 1 / det;

			te[0] = t11 * detInv;
			te[1] = (n31 * n23 - n33 * n21) * detInv;
			te[2] = (n32 * n21 - n31 * n22) * detInv;

			te[3] = t12 * detInv;
			te[4] = (n33 * n11 - n31 * n13) * detInv;
			te[5] = (n31 * n12 - n32 * n11) * detInv;

			te[6] = t13 * detInv;
			te[7] = (n21 * n13 - n23 * n11) * detInv;
			te[8] = (n22 * n11 - n21 * n12) * detInv;

			return this;
		}
	}, {
		key: 'transpose',
		value: function transpose() {

			var tmp = void 0;
			var m = this.elements;

			tmp = m[1];m[1] = m[3];m[3] = tmp;
			tmp = m[2];m[2] = m[6];m[6] = tmp;
			tmp = m[5];m[5] = m[7];m[7] = tmp;

			return this;
		}
	}, {
		key: 'getNormalMatrix',
		value: function getNormalMatrix(matrix4) {

			return this.setFromMatrix4(matrix4).invert().transpose();
		}
	}, {
		key: 'transposeIntoArray',
		value: function transposeIntoArray(r) {

			var m = this.elements;

			r[0] = m[0];
			r[1] = m[3];
			r[2] = m[6];
			r[3] = m[1];
			r[4] = m[4];
			r[5] = m[7];
			r[6] = m[2];
			r[7] = m[5];
			r[8] = m[8];

			return this;
		}
	}, {
		key: 'setUvTransform',
		value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {

			var c = Math.cos(rotation);
			var s = Math.sin(rotation);

			this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);

			return this;
		}

		//

	}, {
		key: 'scale',
		value: function scale(sx, sy) {

			this.premultiply(_m3.makeScale(sx, sy));

			return this;
		}
	}, {
		key: 'rotate',
		value: function rotate(theta) {

			this.premultiply(_m3.makeRotation(-theta));

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(tx, ty) {

			this.premultiply(_m3.makeTranslation(tx, ty));

			return this;
		}

		// for 2D Transforms

	}, {
		key: 'makeTranslation',
		value: function makeTranslation(x, y) {

			this.set(1, 0, x, 0, 1, y, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeRotation',
		value: function makeRotation(theta) {

			// counterclockwise

			var c = Math.cos(theta);
			var s = Math.sin(theta);

			this.set(c, -s, 0, s, c, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeScale',
		value: function makeScale(x, y) {

			this.set(x, 0, 0, 0, y, 0, 0, 0, 1);

			return this;
		}

		//

	}, {
		key: 'equals',
		value: function equals(matrix) {

			var te = this.elements;
			var me = matrix.elements;

			for (var i = 0; i < 9; i++) {

				if (te[i] !== me[i]) return false;
			}

			return true;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			for (var i = 0; i < 9; i++) {

				this.elements[i] = array[i + offset];
			}

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			var te = this.elements;

			array[offset] = te[0];
			array[offset + 1] = te[1];
			array[offset + 2] = te[2];

			array[offset + 3] = te[3];
			array[offset + 4] = te[4];
			array[offset + 5] = te[5];

			array[offset + 6] = te[6];
			array[offset + 7] = te[7];
			array[offset + 8] = te[8];

			return array;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().fromArray(this.elements);
		}
	}]);

	return Matrix3;
}();

var _m3 = /*@__PURE__*/new Matrix3();

function arrayNeedsUint32(array) {

	// assumes larger values usually on last

	for (var i = array.length - 1; i >= 0; --i) {

		if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
	}

	return false;
}

var TYPED_ARRAYS = {
	Int8Array: Int8Array,
	Uint8Array: Uint8Array,
	Uint8ClampedArray: Uint8ClampedArray,
	Int16Array: Int16Array,
	Uint16Array: Uint16Array,
	Int32Array: Int32Array,
	Uint32Array: Uint32Array,
	Float32Array: Float32Array,
	Float64Array: Float64Array
};

function getTypedArray(type, buffer) {

	return new TYPED_ARRAYS[type](buffer);
}

function createElementNS(name) {

	return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}

function SRGBToLinear(c) {

	return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}

function LinearToSRGB(c) {

	return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}

/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */

var LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/new Matrix3().fromArray([0.8224621, 0.0331941, 0.0170827, 0.1775380, 0.9668058, 0.0723974, -0.0000001, 0.0000001, 0.9105199]);

var LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/new Matrix3().fromArray([1.2249401, -0.0420569, -0.0196376, -0.2249404, 1.0420571, -0.0786361, 0.0000001, 0.0000000, 1.0982735]);

function DisplayP3ToLinearSRGB(color) {

	// Display P3 uses the sRGB transfer functions
	return color.convertSRGBToLinear().applyMatrix3(LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}

function LinearSRGBToDisplayP3(color) {

	// Display P3 uses the sRGB transfer functions
	return color.applyMatrix3(LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
}

// Conversions from <source> to Linear-sRGB reference space.
var TO_LINEAR = (_TO_LINEAR = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_TO_LINEAR, LinearSRGBColorSpace, function (color) {
	return color;
}), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_TO_LINEAR, SRGBColorSpace, function (color) {
	return color.convertSRGBToLinear();
}), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_TO_LINEAR, DisplayP3ColorSpace, DisplayP3ToLinearSRGB), _TO_LINEAR);

// Conversions to <target> from Linear-sRGB reference space.
var FROM_LINEAR = (_FROM_LINEAR = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_FROM_LINEAR, LinearSRGBColorSpace, function (color) {
	return color;
}), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_FROM_LINEAR, SRGBColorSpace, function (color) {
	return color.convertLinearToSRGB();
}), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_FROM_LINEAR, DisplayP3ColorSpace, LinearSRGBToDisplayP3), _FROM_LINEAR);

var ColorManagement = {

	enabled: false,

	get legacyMode() {

		console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');

		return !this.enabled;
	},

	set legacyMode(legacyMode) {

		console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');

		this.enabled = !legacyMode;
	},

	get workingColorSpace() {

		return LinearSRGBColorSpace;
	},

	set workingColorSpace(colorSpace) {

		console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
	},

	convert: function convert(color, sourceColorSpace, targetColorSpace) {

		if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {

			return color;
		}

		var sourceToLinear = TO_LINEAR[sourceColorSpace];
		var targetFromLinear = FROM_LINEAR[targetColorSpace];

		if (sourceToLinear === undefined || targetFromLinear === undefined) {

			throw new Error('Unsupported color space conversion, "' + sourceColorSpace + '" to "' + targetColorSpace + '".');
		}

		return targetFromLinear(sourceToLinear(color));
	},

	fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {

		return this.convert(color, this.workingColorSpace, targetColorSpace);
	},

	toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {

		return this.convert(color, sourceColorSpace, this.workingColorSpace);
	}

};

var _canvas = void 0;

var ImageUtils = function () {
	function ImageUtils() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ImageUtils);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ImageUtils, null, [{
		key: 'getDataURL',
		value: function getDataURL(image) {

			if (/^data:/i.test(image.src)) {

				return image.src;
			}

			if (typeof HTMLCanvasElement === 'undefined') {

				return image.src;
			}

			var canvas = void 0;

			if (image instanceof HTMLCanvasElement) {

				canvas = image;
			} else {

				if (_canvas === undefined) _canvas = createElementNS('canvas');

				_canvas.width = image.width;
				_canvas.height = image.height;

				var context = _canvas.getContext('2d');

				if (image instanceof ImageData) {

					context.putImageData(image, 0, 0);
				} else {

					context.drawImage(image, 0, 0, image.width, image.height);
				}

				canvas = _canvas;
			}

			if (canvas.width > 2048 || canvas.height > 2048) {

				console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);

				return canvas.toDataURL('image/jpeg', 0.6);
			} else {

				return canvas.toDataURL('image/png');
			}
		}
	}, {
		key: 'sRGBToLinear',
		value: function sRGBToLinear(image) {

			if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {

				var canvas = createElementNS('canvas');

				canvas.width = image.width;
				canvas.height = image.height;

				var context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, image.width, image.height);

				var imageData = context.getImageData(0, 0, image.width, image.height);
				var data = imageData.data;

				for (var i = 0; i < data.length; i++) {

					data[i] = SRGBToLinear(data[i] / 255) * 255;
				}

				context.putImageData(imageData, 0, 0);

				return canvas;
			} else if (image.data) {

				var _data = image.data.slice(0);

				for (var _i = 0; _i < _data.length; _i++) {

					if (_data instanceof Uint8Array || _data instanceof Uint8ClampedArray) {

						_data[_i] = Math.floor(SRGBToLinear(_data[_i] / 255) * 255);
					} else {

						// assuming float

						_data[_i] = SRGBToLinear(_data[_i]);
					}
				}

				return {
					data: _data,
					width: image.width,
					height: image.height
				};
			} else {

				console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
				return image;
			}
		}
	}]);

	return ImageUtils;
}();

var Source = function () {
	function Source() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Source);

		this.isSource = true;

		this.uuid = generateUUID();

		this.data = data;

		this.version = 0;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Source, [{
		key: 'toJSON',
		value: function toJSON(meta) {

			var isRootObject = meta === undefined || typeof meta === 'string';

			if (!isRootObject && meta.images[this.uuid] !== undefined) {

				return meta.images[this.uuid];
			}

			var output = {
				uuid: this.uuid,
				url: ''
			};

			var data = this.data;

			if (data !== null) {

				var url = void 0;

				if (Array.isArray(data)) {

					// cube texture

					url = [];

					for (var i = 0, l = data.length; i < l; i++) {

						if (data[i].isDataTexture) {

							url.push(serializeImage(data[i].image));
						} else {

							url.push(serializeImage(data[i]));
						}
					}
				} else {

					// texture

					url = serializeImage(data);
				}

				output.url = url;
			}

			if (!isRootObject) {

				meta.images[this.uuid] = output;
			}

			return output;
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) this.version++;
		}
	}]);

	return Source;
}();

function serializeImage(image) {

	if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {

		// default images

		return ImageUtils.getDataURL(image);
	} else {

		if (image.data) {

			// images of DataTexture

			return {
				data: __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from___default()(image.data),
				width: image.width,
				height: image.height,
				type: image.data.constructor.name
			};
		} else {

			console.warn('THREE.Texture: Unable to serialize Texture.');
			return {};
		}
	}
}

var textureId = 0;

var Texture = function (_EventDispatcher) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Texture, _EventDispatcher);

	function Texture() {
		var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Texture.DEFAULT_IMAGE;
		var mapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Texture.DEFAULT_MAPPING;
		var wrapS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ClampToEdgeWrapping;
		var wrapT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ClampToEdgeWrapping;
		var magFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : LinearFilter;
		var minFilter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : LinearMipmapLinearFilter;
		var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : RGBAFormat;
		var type = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : UnsignedByteType;
		var anisotropy = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : Texture.DEFAULT_ANISOTROPY;
		var encoding = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : LinearEncoding;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Texture);

		var _this2 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Texture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Texture)).call(this));

		_this2.isTexture = true;

		Object.defineProperty(_this2, 'id', { value: textureId++ });

		_this2.uuid = generateUUID();

		_this2.name = '';

		_this2.source = new Source(image);
		_this2.mipmaps = [];

		_this2.mapping = mapping;
		_this2.channel = 0;

		_this2.wrapS = wrapS;
		_this2.wrapT = wrapT;

		_this2.magFilter = magFilter;
		_this2.minFilter = minFilter;

		_this2.anisotropy = anisotropy;

		_this2.format = format;
		_this2.internalFormat = null;
		_this2.type = type;

		_this2.offset = new Vector2(0, 0);
		_this2.repeat = new Vector2(1, 1);
		_this2.center = new Vector2(0, 0);
		_this2.rotation = 0;

		_this2.matrixAutoUpdate = true;
		_this2.matrix = new Matrix3();

		_this2.generateMipmaps = true;
		_this2.premultiplyAlpha = false;
		_this2.flipY = true;
		_this2.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)

		// Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
		//
		// Also changing the encoding after already used by a Material will not automatically make the Material
		// update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
		_this2.encoding = encoding;

		_this2.userData = {};

		_this2.version = 0;
		_this2.onUpdate = null;

		_this2.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
		_this2.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

		return _this2;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Texture, [{
		key: 'updateMatrix',
		value: function updateMatrix() {

			this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.name = source.name;

			this.source = source.source;
			this.mipmaps = source.mipmaps.slice(0);

			this.mapping = source.mapping;
			this.channel = source.channel;

			this.wrapS = source.wrapS;
			this.wrapT = source.wrapT;

			this.magFilter = source.magFilter;
			this.minFilter = source.minFilter;

			this.anisotropy = source.anisotropy;

			this.format = source.format;
			this.internalFormat = source.internalFormat;
			this.type = source.type;

			this.offset.copy(source.offset);
			this.repeat.copy(source.repeat);
			this.center.copy(source.center);
			this.rotation = source.rotation;

			this.matrixAutoUpdate = source.matrixAutoUpdate;
			this.matrix.copy(source.matrix);

			this.generateMipmaps = source.generateMipmaps;
			this.premultiplyAlpha = source.premultiplyAlpha;
			this.flipY = source.flipY;
			this.unpackAlignment = source.unpackAlignment;
			this.encoding = source.encoding;

			this.userData = JSON.parse(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(source.userData));

			this.needsUpdate = true;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var isRootObject = meta === undefined || typeof meta === 'string';

			if (!isRootObject && meta.textures[this.uuid] !== undefined) {

				return meta.textures[this.uuid];
			}

			var output = {

				metadata: {
					version: 4.5,
					type: 'Texture',
					generator: 'Texture.toJSON'
				},

				uuid: this.uuid,
				name: this.name,

				image: this.source.toJSON(meta).uuid,

				mapping: this.mapping,
				channel: this.channel,

				repeat: [this.repeat.x, this.repeat.y],
				offset: [this.offset.x, this.offset.y],
				center: [this.center.x, this.center.y],
				rotation: this.rotation,

				wrap: [this.wrapS, this.wrapT],

				format: this.format,
				internalFormat: this.internalFormat,
				type: this.type,
				encoding: this.encoding,

				minFilter: this.minFilter,
				magFilter: this.magFilter,
				anisotropy: this.anisotropy,

				flipY: this.flipY,

				generateMipmaps: this.generateMipmaps,
				premultiplyAlpha: this.premultiplyAlpha,
				unpackAlignment: this.unpackAlignment

			};

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(this.userData).length > 0) output.userData = this.userData;

			if (!isRootObject) {

				meta.textures[this.uuid] = output;
			}

			return output;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });
		}
	}, {
		key: 'transformUv',
		value: function transformUv(uv) {

			if (this.mapping !== UVMapping) return uv;

			uv.applyMatrix3(this.matrix);

			if (uv.x < 0 || uv.x > 1) {

				switch (this.wrapS) {

					case RepeatWrapping:

						uv.x = uv.x - Math.floor(uv.x);
						break;

					case ClampToEdgeWrapping:

						uv.x = uv.x < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if (Math.abs(Math.floor(uv.x) % 2) === 1) {

							uv.x = Math.ceil(uv.x) - uv.x;
						} else {

							uv.x = uv.x - Math.floor(uv.x);
						}

						break;

				}
			}

			if (uv.y < 0 || uv.y > 1) {

				switch (this.wrapT) {

					case RepeatWrapping:

						uv.y = uv.y - Math.floor(uv.y);
						break;

					case ClampToEdgeWrapping:

						uv.y = uv.y < 0 ? 0 : 1;
						break;

					case MirroredRepeatWrapping:

						if (Math.abs(Math.floor(uv.y) % 2) === 1) {

							uv.y = Math.ceil(uv.y) - uv.y;
						} else {

							uv.y = uv.y - Math.floor(uv.y);
						}

						break;

				}
			}

			if (this.flipY) {

				uv.y = 1 - uv.y;
			}

			return uv;
		}
	}, {
		key: 'image',
		get: function get() {

			return this.source.data;
		},
		set: function set() {
			var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


			this.source.data = value;
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) {

				this.version++;
				this.source.needsUpdate = true;
			}
		}
	}]);

	return Texture;
}(EventDispatcher);

Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.DEFAULT_ANISOTROPY = 1;

var Vector4 = function () {
	function Vector4() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Vector4);

		Vector4.prototype.isVector4 = true;

		this.x = x;
		this.y = y;
		this.z = z;
		this.w = w;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Vector4, [{
		key: 'set',
		value: function set(x, y, z, w) {

			this.x = x;
			this.y = y;
			this.z = z;
			this.w = w;

			return this;
		}
	}, {
		key: 'setScalar',
		value: function setScalar(scalar) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;
			this.w = scalar;

			return this;
		}
	}, {
		key: 'setX',
		value: function setX(x) {

			this.x = x;

			return this;
		}
	}, {
		key: 'setY',
		value: function setY(y) {

			this.y = y;

			return this;
		}
	}, {
		key: 'setZ',
		value: function setZ(z) {

			this.z = z;

			return this;
		}
	}, {
		key: 'setW',
		value: function setW(w) {

			this.w = w;

			return this;
		}
	}, {
		key: 'setComponent',
		value: function setComponent(index, value) {

			switch (index) {

				case 0:
					this.x = value;break;
				case 1:
					this.y = value;break;
				case 2:
					this.z = value;break;
				case 3:
					this.w = value;break;
				default:
					throw new Error('index is out of range: ' + index);

			}

			return this;
		}
	}, {
		key: 'getComponent',
		value: function getComponent(index) {

			switch (index) {

				case 0:
					return this.x;
				case 1:
					return this.y;
				case 2:
					return this.z;
				case 3:
					return this.w;
				default:
					throw new Error('index is out of range: ' + index);

			}
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.x, this.y, this.z, this.w);
		}
	}, {
		key: 'copy',
		value: function copy(v) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;
			this.w = v.w !== undefined ? v.w : 1;

			return this;
		}
	}, {
		key: 'add',
		value: function add(v) {

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;
			this.w += v.w;

			return this;
		}
	}, {
		key: 'addScalar',
		value: function addScalar(s) {

			this.x += s;
			this.y += s;
			this.z += s;
			this.w += s;

			return this;
		}
	}, {
		key: 'addVectors',
		value: function addVectors(a, b) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;
			this.w = a.w + b.w;

			return this;
		}
	}, {
		key: 'addScaledVector',
		value: function addScaledVector(v, s) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;
			this.w += v.w * s;

			return this;
		}
	}, {
		key: 'sub',
		value: function sub(v) {

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;
			this.w -= v.w;

			return this;
		}
	}, {
		key: 'subScalar',
		value: function subScalar(s) {

			this.x -= s;
			this.y -= s;
			this.z -= s;
			this.w -= s;

			return this;
		}
	}, {
		key: 'subVectors',
		value: function subVectors(a, b) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;
			this.w = a.w - b.w;

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(v) {

			this.x *= v.x;
			this.y *= v.y;
			this.z *= v.z;
			this.w *= v.w;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(scalar) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;
			this.w *= scalar;

			return this;
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(m) {

			var x = this.x,
			    y = this.y,
			    z = this.z,
			    w = this.w;
			var e = m.elements;

			this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
			this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
			this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
			this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;

			return this;
		}
	}, {
		key: 'divideScalar',
		value: function divideScalar(scalar) {

			return this.multiplyScalar(1 / scalar);
		}
	}, {
		key: 'setAxisAngleFromQuaternion',
		value: function setAxisAngleFromQuaternion(q) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm

			// q is assumed to be normalized

			this.w = 2 * Math.acos(q.w);

			var s = Math.sqrt(1 - q.w * q.w);

			if (s < 0.0001) {

				this.x = 1;
				this.y = 0;
				this.z = 0;
			} else {

				this.x = q.x / s;
				this.y = q.y / s;
				this.z = q.z / s;
			}

			return this;
		}
	}, {
		key: 'setAxisAngleFromRotationMatrix',
		value: function setAxisAngleFromRotationMatrix(m) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var angle = void 0,
			    x = void 0,
			    y = void 0,
			    z = void 0; // variables for result
			var epsilon = 0.01,
			    // margin to allow for rounding errors
			epsilon2 = 0.1,
			    // margin to distinguish between 0 and 180 degrees

			te = m.elements,
			    m11 = te[0],
			    m12 = te[4],
			    m13 = te[8],
			    m21 = te[1],
			    m22 = te[5],
			    m23 = te[9],
			    m31 = te[2],
			    m32 = te[6],
			    m33 = te[10];

			if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {

				// singularity found
				// first check for identity matrix which must have +1 for all terms
				// in leading diagonal and zero in other terms

				if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {

					// this singularity is identity matrix so angle = 0

					this.set(1, 0, 0, 0);

					return this; // zero angle, arbitrary axis
				}

				// otherwise this singularity is angle = 180

				angle = Math.PI;

				var xx = (m11 + 1) / 2;
				var yy = (m22 + 1) / 2;
				var zz = (m33 + 1) / 2;
				var xy = (m12 + m21) / 4;
				var xz = (m13 + m31) / 4;
				var yz = (m23 + m32) / 4;

				if (xx > yy && xx > zz) {

					// m11 is the largest diagonal term

					if (xx < epsilon) {

						x = 0;
						y = 0.707106781;
						z = 0.707106781;
					} else {

						x = Math.sqrt(xx);
						y = xy / x;
						z = xz / x;
					}
				} else if (yy > zz) {

					// m22 is the largest diagonal term

					if (yy < epsilon) {

						x = 0.707106781;
						y = 0;
						z = 0.707106781;
					} else {

						y = Math.sqrt(yy);
						x = xy / y;
						z = yz / y;
					}
				} else {

					// m33 is the largest diagonal term so base result on this

					if (zz < epsilon) {

						x = 0.707106781;
						y = 0.707106781;
						z = 0;
					} else {

						z = Math.sqrt(zz);
						x = xz / z;
						y = yz / z;
					}
				}

				this.set(x, y, z, angle);

				return this; // return 180 deg rotation
			}

			// as we have reached here there are no singularities so we can handle normally

			var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize

			if (Math.abs(s) < 0.001) s = 1;

			// prevent divide by zero, should not happen if matrix is orthogonal and should be
			// caught by singularity test above, but I've left it in just in case

			this.x = (m32 - m23) / s;
			this.y = (m13 - m31) / s;
			this.z = (m21 - m12) / s;
			this.w = Math.acos((m11 + m22 + m33 - 1) / 2);

			return this;
		}
	}, {
		key: 'min',
		value: function min(v) {

			this.x = Math.min(this.x, v.x);
			this.y = Math.min(this.y, v.y);
			this.z = Math.min(this.z, v.z);
			this.w = Math.min(this.w, v.w);

			return this;
		}
	}, {
		key: 'max',
		value: function max(v) {

			this.x = Math.max(this.x, v.x);
			this.y = Math.max(this.y, v.y);
			this.z = Math.max(this.z, v.z);
			this.w = Math.max(this.w, v.w);

			return this;
		}
	}, {
		key: 'clamp',
		value: function clamp(min, max) {

			// assumes min < max, componentwise

			this.x = Math.max(min.x, Math.min(max.x, this.x));
			this.y = Math.max(min.y, Math.min(max.y, this.y));
			this.z = Math.max(min.z, Math.min(max.z, this.z));
			this.w = Math.max(min.w, Math.min(max.w, this.w));

			return this;
		}
	}, {
		key: 'clampScalar',
		value: function clampScalar(minVal, maxVal) {

			this.x = Math.max(minVal, Math.min(maxVal, this.x));
			this.y = Math.max(minVal, Math.min(maxVal, this.y));
			this.z = Math.max(minVal, Math.min(maxVal, this.z));
			this.w = Math.max(minVal, Math.min(maxVal, this.w));

			return this;
		}
	}, {
		key: 'clampLength',
		value: function clampLength(min, max) {

			var length = this.length();

			return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
		}
	}, {
		key: 'floor',
		value: function floor() {

			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			this.z = Math.floor(this.z);
			this.w = Math.floor(this.w);

			return this;
		}
	}, {
		key: 'ceil',
		value: function ceil() {

			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			this.z = Math.ceil(this.z);
			this.w = Math.ceil(this.w);

			return this;
		}
	}, {
		key: 'round',
		value: function round() {

			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			this.z = Math.round(this.z);
			this.w = Math.round(this.w);

			return this;
		}
	}, {
		key: 'roundToZero',
		value: function roundToZero() {

			this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
			this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
			this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);

			return this;
		}
	}, {
		key: 'negate',
		value: function negate() {

			this.x = -this.x;
			this.y = -this.y;
			this.z = -this.z;
			this.w = -this.w;

			return this;
		}
	}, {
		key: 'dot',
		value: function dot(v) {

			return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
		}
	}, {
		key: 'lengthSq',
		value: function lengthSq() {

			return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
		}
	}, {
		key: 'length',
		value: function length() {

			return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
		}
	}, {
		key: 'manhattanLength',
		value: function manhattanLength() {

			return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
		}
	}, {
		key: 'normalize',
		value: function normalize() {

			return this.divideScalar(this.length() || 1);
		}
	}, {
		key: 'setLength',
		value: function setLength(length) {

			return this.normalize().multiplyScalar(length);
		}
	}, {
		key: 'lerp',
		value: function lerp(v, alpha) {

			this.x += (v.x - this.x) * alpha;
			this.y += (v.y - this.y) * alpha;
			this.z += (v.z - this.z) * alpha;
			this.w += (v.w - this.w) * alpha;

			return this;
		}
	}, {
		key: 'lerpVectors',
		value: function lerpVectors(v1, v2, alpha) {

			this.x = v1.x + (v2.x - v1.x) * alpha;
			this.y = v1.y + (v2.y - v1.y) * alpha;
			this.z = v1.z + (v2.z - v1.z) * alpha;
			this.w = v1.w + (v2.w - v1.w) * alpha;

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(v) {

			return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this.x = array[offset];
			this.y = array[offset + 1];
			this.z = array[offset + 2];
			this.w = array[offset + 3];

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this.x;
			array[offset + 1] = this.y;
			array[offset + 2] = this.z;
			array[offset + 3] = this.w;

			return array;
		}
	}, {
		key: 'fromBufferAttribute',
		value: function fromBufferAttribute(attribute, index) {

			this.x = attribute.getX(index);
			this.y = attribute.getY(index);
			this.z = attribute.getZ(index);
			this.w = attribute.getW(index);

			return this;
		}
	}, {
		key: 'random',
		value: function random() {

			this.x = Math.random();
			this.y = Math.random();
			this.z = Math.random();
			this.w = Math.random();

			return this;
		}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return this.x;

						case 2:
							_context3.next = 4;
							return this.y;

						case 4:
							_context3.next = 6;
							return this.z;

						case 6:
							_context3.next = 8;
							return this.w;

						case 8:
						case 'end':
							return _context3.stop();
					}
				}
			}, value, this);
		})
	}, {
		key: 'width',
		get: function get() {

			return this.z;
		},
		set: function set(value) {

			this.z = value;
		}
	}, {
		key: 'height',
		get: function get() {

			return this.w;
		},
		set: function set(value) {

			this.w = value;
		}
	}]);

	return Vector4;
}();

/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/


var WebGLRenderTarget = function (_EventDispatcher2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGLRenderTarget, _EventDispatcher2);

	function WebGLRenderTarget() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLRenderTarget);

		var _this3 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGLRenderTarget.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGLRenderTarget)).call(this));

		_this3.isWebGLRenderTarget = true;

		_this3.width = width;
		_this3.height = height;
		_this3.depth = 1;

		_this3.scissor = new Vector4(0, 0, width, height);
		_this3.scissorTest = false;

		_this3.viewport = new Vector4(0, 0, width, height);

		var image = { width: width, height: height, depth: 1 };

		_this3.texture = new Texture(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
		_this3.texture.isRenderTargetTexture = true;

		_this3.texture.flipY = false;
		_this3.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
		_this3.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
		_this3.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;

		_this3.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
		_this3.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;

		_this3.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;

		_this3.samples = options.samples !== undefined ? options.samples : 0;

		return _this3;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLRenderTarget, [{
		key: 'setSize',
		value: function setSize(width, height) {
			var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;


			if (this.width !== width || this.height !== height || this.depth !== depth) {

				this.width = width;
				this.height = height;
				this.depth = depth;

				this.texture.image.width = width;
				this.texture.image.height = height;
				this.texture.image.depth = depth;

				this.dispose();
			}

			this.viewport.set(0, 0, width, height);
			this.scissor.set(0, 0, width, height);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.width = source.width;
			this.height = source.height;
			this.depth = source.depth;

			this.viewport.copy(source.viewport);

			this.texture = source.texture.clone();
			this.texture.isRenderTargetTexture = true;

			// ensure image object is not shared, see #20328

			var image = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.texture.image);
			this.texture.source = new Source(image);

			this.depthBuffer = source.depthBuffer;
			this.stencilBuffer = source.stencilBuffer;

			if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();

			this.samples = source.samples;

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });
		}
	}]);

	return WebGLRenderTarget;
}(EventDispatcher);

var DataArrayTexture = function (_Texture) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DataArrayTexture, _Texture);

	function DataArrayTexture() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DataArrayTexture);

		var _this4 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DataArrayTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DataArrayTexture)).call(this, null));

		_this4.isDataArrayTexture = true;

		_this4.image = { data: data, width: width, height: height, depth: depth };

		_this4.magFilter = NearestFilter;
		_this4.minFilter = NearestFilter;

		_this4.wrapR = ClampToEdgeWrapping;

		_this4.generateMipmaps = false;
		_this4.flipY = false;
		_this4.unpackAlignment = 1;

		return _this4;
	}

	return DataArrayTexture;
}(Texture);

var WebGLArrayRenderTarget = function (_WebGLRenderTarget) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGLArrayRenderTarget, _WebGLRenderTarget);

	function WebGLArrayRenderTarget() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLArrayRenderTarget);

		var _this5 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGLArrayRenderTarget.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGLArrayRenderTarget)).call(this, width, height));

		_this5.isWebGLArrayRenderTarget = true;

		_this5.depth = depth;

		_this5.texture = new DataArrayTexture(null, width, height, depth);

		_this5.texture.isRenderTargetTexture = true;

		return _this5;
	}

	return WebGLArrayRenderTarget;
}(WebGLRenderTarget);

var Data3DTexture = function (_Texture2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Data3DTexture, _Texture2);

	function Data3DTexture() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Data3DTexture);

		var _this6 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Data3DTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Data3DTexture)).call(this, null));

		// We're going to add .setXXX() methods for setting properties later.
		// Users can still set in DataTexture3D directly.
		//
		//	const texture = new THREE.DataTexture3D( data, width, height, depth );
		// 	texture.anisotropy = 16;
		//
		// See #14839

		_this6.isData3DTexture = true;

		_this6.image = { data: data, width: width, height: height, depth: depth };

		_this6.magFilter = NearestFilter;
		_this6.minFilter = NearestFilter;

		_this6.wrapR = ClampToEdgeWrapping;

		_this6.generateMipmaps = false;
		_this6.flipY = false;
		_this6.unpackAlignment = 1;

		return _this6;
	}

	return Data3DTexture;
}(Texture);

var WebGL3DRenderTarget = function (_WebGLRenderTarget2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGL3DRenderTarget, _WebGLRenderTarget2);

	function WebGL3DRenderTarget() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGL3DRenderTarget);

		var _this7 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGL3DRenderTarget.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGL3DRenderTarget)).call(this, width, height));

		_this7.isWebGL3DRenderTarget = true;

		_this7.depth = depth;

		_this7.texture = new Data3DTexture(null, width, height, depth);

		_this7.texture.isRenderTargetTexture = true;

		return _this7;
	}

	return WebGL3DRenderTarget;
}(WebGLRenderTarget);

var WebGLMultipleRenderTargets = function (_WebGLRenderTarget3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGLMultipleRenderTargets, _WebGLRenderTarget3);

	function WebGLMultipleRenderTargets() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLMultipleRenderTargets);

		var _this8 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGLMultipleRenderTargets.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGLMultipleRenderTargets)).call(this, width, height, options));

		_this8.isWebGLMultipleRenderTargets = true;

		var texture = _this8.texture;

		_this8.texture = [];

		for (var i = 0; i < count; i++) {

			_this8.texture[i] = texture.clone();
			_this8.texture[i].isRenderTargetTexture = true;
		}

		return _this8;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLMultipleRenderTargets, [{
		key: 'setSize',
		value: function setSize(width, height) {
			var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;


			if (this.width !== width || this.height !== height || this.depth !== depth) {

				this.width = width;
				this.height = height;
				this.depth = depth;

				for (var i = 0, il = this.texture.length; i < il; i++) {

					this.texture[i].image.width = width;
					this.texture[i].image.height = height;
					this.texture[i].image.depth = depth;
				}

				this.dispose();
			}

			this.viewport.set(0, 0, width, height);
			this.scissor.set(0, 0, width, height);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.dispose();

			this.width = source.width;
			this.height = source.height;
			this.depth = source.depth;

			this.viewport.set(0, 0, this.width, this.height);
			this.scissor.set(0, 0, this.width, this.height);

			this.depthBuffer = source.depthBuffer;
			this.stencilBuffer = source.stencilBuffer;

			if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();

			this.texture.length = 0;

			for (var i = 0, il = source.texture.length; i < il; i++) {

				this.texture[i] = source.texture[i].clone();
				this.texture[i].isRenderTargetTexture = true;
			}

			return this;
		}
	}]);

	return WebGLMultipleRenderTargets;
}(WebGLRenderTarget);

var Quaternion = function () {
	function Quaternion() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Quaternion);

		this.isQuaternion = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._w = w;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Quaternion, [{
		key: 'set',
		value: function set(x, y, z, w) {

			this._x = x;
			this._y = y;
			this._z = z;
			this._w = w;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this._x, this._y, this._z, this._w);
		}
	}, {
		key: 'copy',
		value: function copy(quaternion) {

			this._x = quaternion.x;
			this._y = quaternion.y;
			this._z = quaternion.z;
			this._w = quaternion.w;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromEuler',
		value: function setFromEuler(euler, update) {

			var x = euler._x,
			    y = euler._y,
			    z = euler._z,
			    order = euler._order;

			// http://www.mathworks.com/matlabcentral/fileexchange/
			// 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
			//	content/SpinCalc.m

			var cos = Math.cos;
			var sin = Math.sin;

			var c1 = cos(x / 2);
			var c2 = cos(y / 2);
			var c3 = cos(z / 2);

			var s1 = sin(x / 2);
			var s2 = sin(y / 2);
			var s3 = sin(z / 2);

			switch (order) {

				case 'XYZ':
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
					break;

				case 'YXZ':
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
					break;

				case 'ZXY':
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
					break;

				case 'ZYX':
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
					break;

				case 'YZX':
					this._x = s1 * c2 * c3 + c1 * s2 * s3;
					this._y = c1 * s2 * c3 + s1 * c2 * s3;
					this._z = c1 * c2 * s3 - s1 * s2 * c3;
					this._w = c1 * c2 * c3 - s1 * s2 * s3;
					break;

				case 'XZY':
					this._x = s1 * c2 * c3 - c1 * s2 * s3;
					this._y = c1 * s2 * c3 - s1 * c2 * s3;
					this._z = c1 * c2 * s3 + s1 * s2 * c3;
					this._w = c1 * c2 * c3 + s1 * s2 * s3;
					break;

				default:
					console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);

			}

			if (update !== false) this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromAxisAngle',
		value: function setFromAxisAngle(axis, angle) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm

			// assumes axis is normalized

			var halfAngle = angle / 2,
			    s = Math.sin(halfAngle);

			this._x = axis.x * s;
			this._y = axis.y * s;
			this._z = axis.z * s;
			this._w = Math.cos(halfAngle);

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromRotationMatrix',
		value: function setFromRotationMatrix(m) {

			// http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements,
			    m11 = te[0],
			    m12 = te[4],
			    m13 = te[8],
			    m21 = te[1],
			    m22 = te[5],
			    m23 = te[9],
			    m31 = te[2],
			    m32 = te[6],
			    m33 = te[10],
			    trace = m11 + m22 + m33;

			if (trace > 0) {

				var s = 0.5 / Math.sqrt(trace + 1.0);

				this._w = 0.25 / s;
				this._x = (m32 - m23) * s;
				this._y = (m13 - m31) * s;
				this._z = (m21 - m12) * s;
			} else if (m11 > m22 && m11 > m33) {

				var _s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);

				this._w = (m32 - m23) / _s;
				this._x = 0.25 * _s;
				this._y = (m12 + m21) / _s;
				this._z = (m13 + m31) / _s;
			} else if (m22 > m33) {

				var _s2 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);

				this._w = (m13 - m31) / _s2;
				this._x = (m12 + m21) / _s2;
				this._y = 0.25 * _s2;
				this._z = (m23 + m32) / _s2;
			} else {

				var _s3 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);

				this._w = (m21 - m12) / _s3;
				this._x = (m13 + m31) / _s3;
				this._y = (m23 + m32) / _s3;
				this._z = 0.25 * _s3;
			}

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromUnitVectors',
		value: function setFromUnitVectors(vFrom, vTo) {

			// assumes direction vectors vFrom and vTo are normalized

			var r = vFrom.dot(vTo) + 1;

			if (r < __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

				// vFrom and vTo point in opposite directions

				r = 0;

				if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {

					this._x = -vFrom.y;
					this._y = vFrom.x;
					this._z = 0;
					this._w = r;
				} else {

					this._x = 0;
					this._y = -vFrom.z;
					this._z = vFrom.y;
					this._w = r;
				}
			} else {

				// crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3

				this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
				this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
				this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
				this._w = r;
			}

			return this.normalize();
		}
	}, {
		key: 'angleTo',
		value: function angleTo(q) {

			return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
		}
	}, {
		key: 'rotateTowards',
		value: function rotateTowards(q, step) {

			var angle = this.angleTo(q);

			if (angle === 0) return this;

			var t = Math.min(1, step / angle);

			this.slerp(q, t);

			return this;
		}
	}, {
		key: 'identity',
		value: function identity() {

			return this.set(0, 0, 0, 1);
		}
	}, {
		key: 'invert',
		value: function invert() {

			// quaternion is assumed to have unit length

			return this.conjugate();
		}
	}, {
		key: 'conjugate',
		value: function conjugate() {

			this._x *= -1;
			this._y *= -1;
			this._z *= -1;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'dot',
		value: function dot(v) {

			return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
		}
	}, {
		key: 'lengthSq',
		value: function lengthSq() {

			return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
		}
	}, {
		key: 'length',
		value: function length() {

			return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
		}
	}, {
		key: 'normalize',
		value: function normalize() {

			var l = this.length();

			if (l === 0) {

				this._x = 0;
				this._y = 0;
				this._z = 0;
				this._w = 1;
			} else {

				l = 1 / l;

				this._x = this._x * l;
				this._y = this._y * l;
				this._z = this._z * l;
				this._w = this._w * l;
			}

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(q) {

			return this.multiplyQuaternions(this, q);
		}
	}, {
		key: 'premultiply',
		value: function premultiply(q) {

			return this.multiplyQuaternions(q, this);
		}
	}, {
		key: 'multiplyQuaternions',
		value: function multiplyQuaternions(a, b) {

			// from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm

			var qax = a._x,
			    qay = a._y,
			    qaz = a._z,
			    qaw = a._w;
			var qbx = b._x,
			    qby = b._y,
			    qbz = b._z,
			    qbw = b._w;

			this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
			this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
			this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
			this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'slerp',
		value: function slerp(qb, t) {

			if (t === 0) return this;
			if (t === 1) return this.copy(qb);

			var x = this._x,
			    y = this._y,
			    z = this._z,
			    w = this._w;

			// http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

			var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

			if (cosHalfTheta < 0) {

				this._w = -qb._w;
				this._x = -qb._x;
				this._y = -qb._y;
				this._z = -qb._z;

				cosHalfTheta = -cosHalfTheta;
			} else {

				this.copy(qb);
			}

			if (cosHalfTheta >= 1.0) {

				this._w = w;
				this._x = x;
				this._y = y;
				this._z = z;

				return this;
			}

			var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

			if (sqrSinHalfTheta <= __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

				var s = 1 - t;
				this._w = s * w + t * this._w;
				this._x = s * x + t * this._x;
				this._y = s * y + t * this._y;
				this._z = s * z + t * this._z;

				this.normalize();
				this._onChangeCallback();

				return this;
			}

			var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
			var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
			var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
			    ratioB = Math.sin(t * halfTheta) / sinHalfTheta;

			this._w = w * ratioA + this._w * ratioB;
			this._x = x * ratioA + this._x * ratioB;
			this._y = y * ratioA + this._y * ratioB;
			this._z = z * ratioA + this._z * ratioB;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'slerpQuaternions',
		value: function slerpQuaternions(qa, qb, t) {

			return this.copy(qa).slerp(qb, t);
		}
	}, {
		key: 'random',
		value: function random() {

			// Derived from http://planning.cs.uiuc.edu/node198.html
			// Note, this source uses w, x, y, z ordering,
			// so we swap the order below.

			var u1 = Math.random();
			var sqrt1u1 = Math.sqrt(1 - u1);
			var sqrtu1 = Math.sqrt(u1);

			var u2 = 2 * Math.PI * Math.random();

			var u3 = 2 * Math.PI * Math.random();

			return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
		}
	}, {
		key: 'equals',
		value: function equals(quaternion) {

			return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this._x = array[offset];
			this._y = array[offset + 1];
			this._z = array[offset + 2];
			this._w = array[offset + 3];

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this._x;
			array[offset + 1] = this._y;
			array[offset + 2] = this._z;
			array[offset + 3] = this._w;

			return array;
		}
	}, {
		key: 'fromBufferAttribute',
		value: function fromBufferAttribute(attribute, index) {

			this._x = attribute.getX(index);
			this._y = attribute.getY(index);
			this._z = attribute.getZ(index);
			this._w = attribute.getW(index);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			return this.toArray();
		}
	}, {
		key: '_onChange',
		value: function _onChange(callback) {

			this._onChangeCallback = callback;

			return this;
		}
	}, {
		key: '_onChangeCallback',
		value: function _onChangeCallback() {}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return this._x;

						case 2:
							_context4.next = 4;
							return this._y;

						case 4:
							_context4.next = 6;
							return this._z;

						case 6:
							_context4.next = 8;
							return this._w;

						case 8:
						case 'end':
							return _context4.stop();
					}
				}
			}, value, this);
		})
	}, {
		key: 'x',
		get: function get() {

			return this._x;
		},
		set: function set(value) {

			this._x = value;
			this._onChangeCallback();
		}
	}, {
		key: 'y',
		get: function get() {

			return this._y;
		},
		set: function set(value) {

			this._y = value;
			this._onChangeCallback();
		}
	}, {
		key: 'z',
		get: function get() {

			return this._z;
		},
		set: function set(value) {

			this._z = value;
			this._onChangeCallback();
		}
	}, {
		key: 'w',
		get: function get() {

			return this._w;
		},
		set: function set(value) {

			this._w = value;
			this._onChangeCallback();
		}
	}], [{
		key: 'slerpFlat',
		value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {

			// fuzz-free, array-based Quaternion SLERP operation

			var x0 = src0[srcOffset0 + 0],
			    y0 = src0[srcOffset0 + 1],
			    z0 = src0[srcOffset0 + 2],
			    w0 = src0[srcOffset0 + 3];

			var x1 = src1[srcOffset1 + 0],
			    y1 = src1[srcOffset1 + 1],
			    z1 = src1[srcOffset1 + 2],
			    w1 = src1[srcOffset1 + 3];

			if (t === 0) {

				dst[dstOffset + 0] = x0;
				dst[dstOffset + 1] = y0;
				dst[dstOffset + 2] = z0;
				dst[dstOffset + 3] = w0;
				return;
			}

			if (t === 1) {

				dst[dstOffset + 0] = x1;
				dst[dstOffset + 1] = y1;
				dst[dstOffset + 2] = z1;
				dst[dstOffset + 3] = w1;
				return;
			}

			if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {

				var s = 1 - t;
				var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
				    dir = cos >= 0 ? 1 : -1,
				    sqrSin = 1 - cos * cos;

				// Skip the Slerp for tiny steps to avoid numeric problems:
				if (sqrSin > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

					var sin = Math.sqrt(sqrSin),
					    len = Math.atan2(sin, cos * dir);

					s = Math.sin(s * len) / sin;
					t = Math.sin(t * len) / sin;
				}

				var tDir = t * dir;

				x0 = x0 * s + x1 * tDir;
				y0 = y0 * s + y1 * tDir;
				z0 = z0 * s + z1 * tDir;
				w0 = w0 * s + w1 * tDir;

				// Normalize in case we just did a lerp:
				if (s === 1 - t) {

					var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);

					x0 *= f;
					y0 *= f;
					z0 *= f;
					w0 *= f;
				}
			}

			dst[dstOffset] = x0;
			dst[dstOffset + 1] = y0;
			dst[dstOffset + 2] = z0;
			dst[dstOffset + 3] = w0;
		}
	}, {
		key: 'multiplyQuaternionsFlat',
		value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {

			var x0 = src0[srcOffset0];
			var y0 = src0[srcOffset0 + 1];
			var z0 = src0[srcOffset0 + 2];
			var w0 = src0[srcOffset0 + 3];

			var x1 = src1[srcOffset1];
			var y1 = src1[srcOffset1 + 1];
			var z1 = src1[srcOffset1 + 2];
			var w1 = src1[srcOffset1 + 3];

			dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
			dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
			dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
			dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;

			return dst;
		}
	}]);

	return Quaternion;
}();

var Vector3 = function () {
	function Vector3() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Vector3);

		Vector3.prototype.isVector3 = true;

		this.x = x;
		this.y = y;
		this.z = z;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Vector3, [{
		key: 'set',
		value: function set(x, y, z) {

			if (z === undefined) z = this.z; // sprite.scale.set(x,y)

			this.x = x;
			this.y = y;
			this.z = z;

			return this;
		}
	}, {
		key: 'setScalar',
		value: function setScalar(scalar) {

			this.x = scalar;
			this.y = scalar;
			this.z = scalar;

			return this;
		}
	}, {
		key: 'setX',
		value: function setX(x) {

			this.x = x;

			return this;
		}
	}, {
		key: 'setY',
		value: function setY(y) {

			this.y = y;

			return this;
		}
	}, {
		key: 'setZ',
		value: function setZ(z) {

			this.z = z;

			return this;
		}
	}, {
		key: 'setComponent',
		value: function setComponent(index, value) {

			switch (index) {

				case 0:
					this.x = value;break;
				case 1:
					this.y = value;break;
				case 2:
					this.z = value;break;
				default:
					throw new Error('index is out of range: ' + index);

			}

			return this;
		}
	}, {
		key: 'getComponent',
		value: function getComponent(index) {

			switch (index) {

				case 0:
					return this.x;
				case 1:
					return this.y;
				case 2:
					return this.z;
				default:
					throw new Error('index is out of range: ' + index);

			}
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.x, this.y, this.z);
		}
	}, {
		key: 'copy',
		value: function copy(v) {

			this.x = v.x;
			this.y = v.y;
			this.z = v.z;

			return this;
		}
	}, {
		key: 'add',
		value: function add(v) {

			this.x += v.x;
			this.y += v.y;
			this.z += v.z;

			return this;
		}
	}, {
		key: 'addScalar',
		value: function addScalar(s) {

			this.x += s;
			this.y += s;
			this.z += s;

			return this;
		}
	}, {
		key: 'addVectors',
		value: function addVectors(a, b) {

			this.x = a.x + b.x;
			this.y = a.y + b.y;
			this.z = a.z + b.z;

			return this;
		}
	}, {
		key: 'addScaledVector',
		value: function addScaledVector(v, s) {

			this.x += v.x * s;
			this.y += v.y * s;
			this.z += v.z * s;

			return this;
		}
	}, {
		key: 'sub',
		value: function sub(v) {

			this.x -= v.x;
			this.y -= v.y;
			this.z -= v.z;

			return this;
		}
	}, {
		key: 'subScalar',
		value: function subScalar(s) {

			this.x -= s;
			this.y -= s;
			this.z -= s;

			return this;
		}
	}, {
		key: 'subVectors',
		value: function subVectors(a, b) {

			this.x = a.x - b.x;
			this.y = a.y - b.y;
			this.z = a.z - b.z;

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(v) {

			this.x *= v.x;
			this.y *= v.y;
			this.z *= v.z;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(scalar) {

			this.x *= scalar;
			this.y *= scalar;
			this.z *= scalar;

			return this;
		}
	}, {
		key: 'multiplyVectors',
		value: function multiplyVectors(a, b) {

			this.x = a.x * b.x;
			this.y = a.y * b.y;
			this.z = a.z * b.z;

			return this;
		}
	}, {
		key: 'applyEuler',
		value: function applyEuler(euler) {

			return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
		}
	}, {
		key: 'applyAxisAngle',
		value: function applyAxisAngle(axis, angle) {

			return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
		}
	}, {
		key: 'applyMatrix3',
		value: function applyMatrix3(m) {

			var x = this.x,
			    y = this.y,
			    z = this.z;
			var e = m.elements;

			this.x = e[0] * x + e[3] * y + e[6] * z;
			this.y = e[1] * x + e[4] * y + e[7] * z;
			this.z = e[2] * x + e[5] * y + e[8] * z;

			return this;
		}
	}, {
		key: 'applyNormalMatrix',
		value: function applyNormalMatrix(m) {

			return this.applyMatrix3(m).normalize();
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(m) {

			var x = this.x,
			    y = this.y,
			    z = this.z;
			var e = m.elements;

			var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);

			this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
			this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
			this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;

			return this;
		}
	}, {
		key: 'applyQuaternion',
		value: function applyQuaternion(q) {

			var x = this.x,
			    y = this.y,
			    z = this.z;
			var qx = q.x,
			    qy = q.y,
			    qz = q.z,
			    qw = q.w;

			// calculate quat * vector

			var ix = qw * x + qy * z - qz * y;
			var iy = qw * y + qz * x - qx * z;
			var iz = qw * z + qx * y - qy * x;
			var iw = -qx * x - qy * y - qz * z;

			// calculate result * inverse quat

			this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
			this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
			this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

			return this;
		}
	}, {
		key: 'project',
		value: function project(camera) {

			return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
		}
	}, {
		key: 'unproject',
		value: function unproject(camera) {

			return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
		}
	}, {
		key: 'transformDirection',
		value: function transformDirection(m) {

			// input: THREE.Matrix4 affine matrix
			// vector interpreted as a direction

			var x = this.x,
			    y = this.y,
			    z = this.z;
			var e = m.elements;

			this.x = e[0] * x + e[4] * y + e[8] * z;
			this.y = e[1] * x + e[5] * y + e[9] * z;
			this.z = e[2] * x + e[6] * y + e[10] * z;

			return this.normalize();
		}
	}, {
		key: 'divide',
		value: function divide(v) {

			this.x /= v.x;
			this.y /= v.y;
			this.z /= v.z;

			return this;
		}
	}, {
		key: 'divideScalar',
		value: function divideScalar(scalar) {

			return this.multiplyScalar(1 / scalar);
		}
	}, {
		key: 'min',
		value: function min(v) {

			this.x = Math.min(this.x, v.x);
			this.y = Math.min(this.y, v.y);
			this.z = Math.min(this.z, v.z);

			return this;
		}
	}, {
		key: 'max',
		value: function max(v) {

			this.x = Math.max(this.x, v.x);
			this.y = Math.max(this.y, v.y);
			this.z = Math.max(this.z, v.z);

			return this;
		}
	}, {
		key: 'clamp',
		value: function clamp(min, max) {

			// assumes min < max, componentwise

			this.x = Math.max(min.x, Math.min(max.x, this.x));
			this.y = Math.max(min.y, Math.min(max.y, this.y));
			this.z = Math.max(min.z, Math.min(max.z, this.z));

			return this;
		}
	}, {
		key: 'clampScalar',
		value: function clampScalar(minVal, maxVal) {

			this.x = Math.max(minVal, Math.min(maxVal, this.x));
			this.y = Math.max(minVal, Math.min(maxVal, this.y));
			this.z = Math.max(minVal, Math.min(maxVal, this.z));

			return this;
		}
	}, {
		key: 'clampLength',
		value: function clampLength(min, max) {

			var length = this.length();

			return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
		}
	}, {
		key: 'floor',
		value: function floor() {

			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			this.z = Math.floor(this.z);

			return this;
		}
	}, {
		key: 'ceil',
		value: function ceil() {

			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			this.z = Math.ceil(this.z);

			return this;
		}
	}, {
		key: 'round',
		value: function round() {

			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			this.z = Math.round(this.z);

			return this;
		}
	}, {
		key: 'roundToZero',
		value: function roundToZero() {

			this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
			this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
			this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);

			return this;
		}
	}, {
		key: 'negate',
		value: function negate() {

			this.x = -this.x;
			this.y = -this.y;
			this.z = -this.z;

			return this;
		}
	}, {
		key: 'dot',
		value: function dot(v) {

			return this.x * v.x + this.y * v.y + this.z * v.z;
		}

		// TODO lengthSquared?

	}, {
		key: 'lengthSq',
		value: function lengthSq() {

			return this.x * this.x + this.y * this.y + this.z * this.z;
		}
	}, {
		key: 'length',
		value: function length() {

			return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
		}
	}, {
		key: 'manhattanLength',
		value: function manhattanLength() {

			return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
		}
	}, {
		key: 'normalize',
		value: function normalize() {

			return this.divideScalar(this.length() || 1);
		}
	}, {
		key: 'setLength',
		value: function setLength(length) {

			return this.normalize().multiplyScalar(length);
		}
	}, {
		key: 'lerp',
		value: function lerp(v, alpha) {

			this.x += (v.x - this.x) * alpha;
			this.y += (v.y - this.y) * alpha;
			this.z += (v.z - this.z) * alpha;

			return this;
		}
	}, {
		key: 'lerpVectors',
		value: function lerpVectors(v1, v2, alpha) {

			this.x = v1.x + (v2.x - v1.x) * alpha;
			this.y = v1.y + (v2.y - v1.y) * alpha;
			this.z = v1.z + (v2.z - v1.z) * alpha;

			return this;
		}
	}, {
		key: 'cross',
		value: function cross(v) {

			return this.crossVectors(this, v);
		}
	}, {
		key: 'crossVectors',
		value: function crossVectors(a, b) {

			var ax = a.x,
			    ay = a.y,
			    az = a.z;
			var bx = b.x,
			    by = b.y,
			    bz = b.z;

			this.x = ay * bz - az * by;
			this.y = az * bx - ax * bz;
			this.z = ax * by - ay * bx;

			return this;
		}
	}, {
		key: 'projectOnVector',
		value: function projectOnVector(v) {

			var denominator = v.lengthSq();

			if (denominator === 0) return this.set(0, 0, 0);

			var scalar = v.dot(this) / denominator;

			return this.copy(v).multiplyScalar(scalar);
		}
	}, {
		key: 'projectOnPlane',
		value: function projectOnPlane(planeNormal) {

			_vector$b.copy(this).projectOnVector(planeNormal);

			return this.sub(_vector$b);
		}
	}, {
		key: 'reflect',
		value: function reflect(normal) {

			// reflect incident vector off plane orthogonal to normal
			// normal is assumed to have unit length

			return this.sub(_vector$b.copy(normal).multiplyScalar(2 * this.dot(normal)));
		}
	}, {
		key: 'angleTo',
		value: function angleTo(v) {

			var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());

			if (denominator === 0) return Math.PI / 2;

			var theta = this.dot(v) / denominator;

			// clamp, to handle numerical problems

			return Math.acos(clamp(theta, -1, 1));
		}
	}, {
		key: 'distanceTo',
		value: function distanceTo(v) {

			return Math.sqrt(this.distanceToSquared(v));
		}
	}, {
		key: 'distanceToSquared',
		value: function distanceToSquared(v) {

			var dx = this.x - v.x,
			    dy = this.y - v.y,
			    dz = this.z - v.z;

			return dx * dx + dy * dy + dz * dz;
		}
	}, {
		key: 'manhattanDistanceTo',
		value: function manhattanDistanceTo(v) {

			return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
		}
	}, {
		key: 'setFromSpherical',
		value: function setFromSpherical(s) {

			return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
		}
	}, {
		key: 'setFromSphericalCoords',
		value: function setFromSphericalCoords(radius, phi, theta) {

			var sinPhiRadius = Math.sin(phi) * radius;

			this.x = sinPhiRadius * Math.sin(theta);
			this.y = Math.cos(phi) * radius;
			this.z = sinPhiRadius * Math.cos(theta);

			return this;
		}
	}, {
		key: 'setFromCylindrical',
		value: function setFromCylindrical(c) {

			return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
		}
	}, {
		key: 'setFromCylindricalCoords',
		value: function setFromCylindricalCoords(radius, theta, y) {

			this.x = radius * Math.sin(theta);
			this.y = y;
			this.z = radius * Math.cos(theta);

			return this;
		}
	}, {
		key: 'setFromMatrixPosition',
		value: function setFromMatrixPosition(m) {

			var e = m.elements;

			this.x = e[12];
			this.y = e[13];
			this.z = e[14];

			return this;
		}
	}, {
		key: 'setFromMatrixScale',
		value: function setFromMatrixScale(m) {

			var sx = this.setFromMatrixColumn(m, 0).length();
			var sy = this.setFromMatrixColumn(m, 1).length();
			var sz = this.setFromMatrixColumn(m, 2).length();

			this.x = sx;
			this.y = sy;
			this.z = sz;

			return this;
		}
	}, {
		key: 'setFromMatrixColumn',
		value: function setFromMatrixColumn(m, index) {

			return this.fromArray(m.elements, index * 4);
		}
	}, {
		key: 'setFromMatrix3Column',
		value: function setFromMatrix3Column(m, index) {

			return this.fromArray(m.elements, index * 3);
		}
	}, {
		key: 'setFromEuler',
		value: function setFromEuler(e) {

			this.x = e._x;
			this.y = e._y;
			this.z = e._z;

			return this;
		}
	}, {
		key: 'setFromColor',
		value: function setFromColor(c) {

			this.x = c.r;
			this.y = c.g;
			this.z = c.b;

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(v) {

			return v.x === this.x && v.y === this.y && v.z === this.z;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this.x = array[offset];
			this.y = array[offset + 1];
			this.z = array[offset + 2];

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this.x;
			array[offset + 1] = this.y;
			array[offset + 2] = this.z;

			return array;
		}
	}, {
		key: 'fromBufferAttribute',
		value: function fromBufferAttribute(attribute, index) {

			this.x = attribute.getX(index);
			this.y = attribute.getY(index);
			this.z = attribute.getZ(index);

			return this;
		}
	}, {
		key: 'random',
		value: function random() {

			this.x = Math.random();
			this.y = Math.random();
			this.z = Math.random();

			return this;
		}
	}, {
		key: 'randomDirection',
		value: function randomDirection() {

			// Derived from https://mathworld.wolfram.com/SpherePointPicking.html

			var u = (Math.random() - 0.5) * 2;
			var t = Math.random() * Math.PI * 2;
			var f = Math.sqrt(1 - Math.pow(u, 2));

			this.x = f * Math.cos(t);
			this.y = f * Math.sin(t);
			this.z = u;

			return this;
		}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return this.x;

						case 2:
							_context5.next = 4;
							return this.y;

						case 4:
							_context5.next = 6;
							return this.z;

						case 6:
						case 'end':
							return _context5.stop();
					}
				}
			}, value, this);
		})
	}]);

	return Vector3;
}();

var _vector$b = /*@__PURE__*/new Vector3();
var _quaternion$4 = /*@__PURE__*/new Quaternion();

var Box3 = function () {
	function Box3() {
		var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3(+Infinity, +Infinity, +Infinity);
		var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(-Infinity, -Infinity, -Infinity);

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Box3);

		this.isBox3 = true;

		this.min = min;
		this.max = max;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Box3, [{
		key: 'set',
		value: function set(min, max) {

			this.min.copy(min);
			this.max.copy(max);

			return this;
		}
	}, {
		key: 'setFromArray',
		value: function setFromArray(array) {

			this.makeEmpty();

			for (var i = 0, il = array.length; i < il; i += 3) {

				this.expandByPoint(_vector$a.fromArray(array, i));
			}

			return this;
		}
	}, {
		key: 'setFromBufferAttribute',
		value: function setFromBufferAttribute(attribute) {

			this.makeEmpty();

			for (var i = 0, il = attribute.count; i < il; i++) {

				this.expandByPoint(_vector$a.fromBufferAttribute(attribute, i));
			}

			return this;
		}
	}, {
		key: 'setFromPoints',
		value: function setFromPoints(points) {

			this.makeEmpty();

			for (var i = 0, il = points.length; i < il; i++) {

				this.expandByPoint(points[i]);
			}

			return this;
		}
	}, {
		key: 'setFromCenterAndSize',
		value: function setFromCenterAndSize(center, size) {

			var halfSize = _vector$a.copy(size).multiplyScalar(0.5);

			this.min.copy(center).sub(halfSize);
			this.max.copy(center).add(halfSize);

			return this;
		}
	}, {
		key: 'setFromObject',
		value: function setFromObject(object) {
			var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			this.makeEmpty();

			return this.expandByObject(object, precise);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(box) {

			this.min.copy(box.min);
			this.max.copy(box.max);

			return this;
		}
	}, {
		key: 'makeEmpty',
		value: function makeEmpty() {

			this.min.x = this.min.y = this.min.z = +Infinity;
			this.max.x = this.max.y = this.max.z = -Infinity;

			return this;
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty() {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
		}
	}, {
		key: 'getCenter',
		value: function getCenter(target) {

			return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
		}
	}, {
		key: 'getSize',
		value: function getSize(target) {

			return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
		}
	}, {
		key: 'expandByPoint',
		value: function expandByPoint(point) {

			this.min.min(point);
			this.max.max(point);

			return this;
		}
	}, {
		key: 'expandByVector',
		value: function expandByVector(vector) {

			this.min.sub(vector);
			this.max.add(vector);

			return this;
		}
	}, {
		key: 'expandByScalar',
		value: function expandByScalar(scalar) {

			this.min.addScalar(-scalar);
			this.max.addScalar(scalar);

			return this;
		}
	}, {
		key: 'expandByObject',
		value: function expandByObject(object) {
			var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


			// Computes the world-axis-aligned bounding box of an object (including its children),
			// accounting for both the object's, and children's, world transforms

			object.updateWorldMatrix(false, false);

			if (object.boundingBox !== undefined) {

				if (object.boundingBox === null) {

					object.computeBoundingBox();
				}

				_box$3.copy(object.boundingBox);
				_box$3.applyMatrix4(object.matrixWorld);

				this.union(_box$3);
			} else {

				var geometry = object.geometry;

				if (geometry !== undefined) {

					if (precise && geometry.attributes !== undefined && geometry.attributes.position !== undefined) {

						var position = geometry.attributes.position;
						for (var i = 0, l = position.count; i < l; i++) {

							_vector$a.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
							this.expandByPoint(_vector$a);
						}
					} else {

						if (geometry.boundingBox === null) {

							geometry.computeBoundingBox();
						}

						_box$3.copy(geometry.boundingBox);
						_box$3.applyMatrix4(object.matrixWorld);

						this.union(_box$3);
					}
				}
			}

			var children = object.children;

			for (var _i2 = 0, _l = children.length; _i2 < _l; _i2++) {

				this.expandByObject(children[_i2], precise);
			}

			return this;
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point) {

			return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
		}
	}, {
		key: 'containsBox',
		value: function containsBox(box) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
		}
	}, {
		key: 'getParameter',
		value: function getParameter(point, target) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			// using 6 splitting planes to rule out intersections.
			return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
		}
	}, {
		key: 'intersectsSphere',
		value: function intersectsSphere(sphere) {

			// Find the point on the AABB closest to the sphere center.
			this.clampPoint(sphere.center, _vector$a);

			// If that point is inside the sphere, the AABB and sphere intersect.
			return _vector$a.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
		}
	}, {
		key: 'intersectsPlane',
		value: function intersectsPlane(plane) {

			// We compute the minimum and maximum dot product values. If those values
			// are on the same side (back or front) of the plane, then there is no intersection.

			var min = void 0,
			    max = void 0;

			if (plane.normal.x > 0) {

				min = plane.normal.x * this.min.x;
				max = plane.normal.x * this.max.x;
			} else {

				min = plane.normal.x * this.max.x;
				max = plane.normal.x * this.min.x;
			}

			if (plane.normal.y > 0) {

				min += plane.normal.y * this.min.y;
				max += plane.normal.y * this.max.y;
			} else {

				min += plane.normal.y * this.max.y;
				max += plane.normal.y * this.min.y;
			}

			if (plane.normal.z > 0) {

				min += plane.normal.z * this.min.z;
				max += plane.normal.z * this.max.z;
			} else {

				min += plane.normal.z * this.max.z;
				max += plane.normal.z * this.min.z;
			}

			return min <= -plane.constant && max >= -plane.constant;
		}
	}, {
		key: 'intersectsTriangle',
		value: function intersectsTriangle(triangle) {

			if (this.isEmpty()) {

				return false;
			}

			// compute box center and extents
			this.getCenter(_center);
			_extents.subVectors(this.max, _center);

			// translate triangle to aabb origin
			_v0$2.subVectors(triangle.a, _center);
			_v1$7.subVectors(triangle.b, _center);
			_v2$4.subVectors(triangle.c, _center);

			// compute edge vectors for triangle
			_f0.subVectors(_v1$7, _v0$2);
			_f1.subVectors(_v2$4, _v1$7);
			_f2.subVectors(_v0$2, _v2$4);

			// test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
			// make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
			// axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
			var axes = [0, -_f0.z, _f0.y, 0, -_f1.z, _f1.y, 0, -_f2.z, _f2.y, _f0.z, 0, -_f0.x, _f1.z, 0, -_f1.x, _f2.z, 0, -_f2.x, -_f0.y, _f0.x, 0, -_f1.y, _f1.x, 0, -_f2.y, _f2.x, 0];
			if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {

				return false;
			}

			// test 3 face normals from the aabb
			axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
			if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) {

				return false;
			}

			// finally testing the face normal of the triangle
			// use already existing triangle edge vectors here
			_triangleNormal.crossVectors(_f0, _f1);
			axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];

			return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
		}
	}, {
		key: 'clampPoint',
		value: function clampPoint(point, target) {

			return target.copy(point).clamp(this.min, this.max);
		}
	}, {
		key: 'distanceToPoint',
		value: function distanceToPoint(point) {

			return this.clampPoint(point, _vector$a).distanceTo(point);
		}
	}, {
		key: 'getBoundingSphere',
		value: function getBoundingSphere(target) {

			if (this.isEmpty()) {

				target.makeEmpty();
			} else {

				this.getCenter(target.center);

				target.radius = this.getSize(_vector$a).length() * 0.5;
			}

			return target;
		}
	}, {
		key: 'intersect',
		value: function intersect(box) {

			this.min.max(box.min);
			this.max.min(box.max);

			// ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
			if (this.isEmpty()) this.makeEmpty();

			return this;
		}
	}, {
		key: 'union',
		value: function union(box) {

			this.min.min(box.min);
			this.max.max(box.max);

			return this;
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix) {

			// transform of empty box is an empty box.
			if (this.isEmpty()) return this;

			// NOTE: I am using a binary pattern to specify all 2^3 combinations below
			_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
			_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
			_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
			_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
			_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
			_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
			_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
			_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111

			this.setFromPoints(_points);

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(offset) {

			this.min.add(offset);
			this.max.add(offset);

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(box) {

			return box.min.equals(this.min) && box.max.equals(this.max);
		}
	}]);

	return Box3;
}();

var _points = [
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3(),
/*@__PURE__*/new Vector3()];

var _vector$a = /*@__PURE__*/new Vector3();

var _box$3 = /*@__PURE__*/new Box3();

// triangle centered vertices

var _v0$2 = /*@__PURE__*/new Vector3();
var _v1$7 = /*@__PURE__*/new Vector3();
var _v2$4 = /*@__PURE__*/new Vector3();

// triangle edge vectors

var _f0 = /*@__PURE__*/new Vector3();
var _f1 = /*@__PURE__*/new Vector3();
var _f2 = /*@__PURE__*/new Vector3();

var _center = /*@__PURE__*/new Vector3();
var _extents = /*@__PURE__*/new Vector3();
var _triangleNormal = /*@__PURE__*/new Vector3();
var _testAxis = /*@__PURE__*/new Vector3();

function satForAxes(axes, v0, v1, v2, extents) {

	for (var i = 0, j = axes.length - 3; i <= j; i += 3) {

		_testAxis.fromArray(axes, i);
		// project the aabb onto the separating axis
		var r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
		// project all 3 vertices of the triangle onto the separating axis
		var p0 = v0.dot(_testAxis);
		var p1 = v1.dot(_testAxis);
		var p2 = v2.dot(_testAxis);
		// actual test, basically see if either of the most extreme of the triangle points intersects r
		if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {

			// points of the projected triangle are outside the projected half-length of the aabb
			// the axis is separating and we can exit
			return false;
		}
	}

	return true;
}

var _box$2 = /*@__PURE__*/new Box3();
var _v1$6 = /*@__PURE__*/new Vector3();
var _v2$3 = /*@__PURE__*/new Vector3();

var Sphere = function () {
	function Sphere() {
		var center = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Sphere);

		this.center = center;
		this.radius = radius;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Sphere, [{
		key: 'set',
		value: function set(center, radius) {

			this.center.copy(center);
			this.radius = radius;

			return this;
		}
	}, {
		key: 'setFromPoints',
		value: function setFromPoints(points, optionalCenter) {

			var center = this.center;

			if (optionalCenter !== undefined) {

				center.copy(optionalCenter);
			} else {

				_box$2.setFromPoints(points).getCenter(center);
			}

			var maxRadiusSq = 0;

			for (var i = 0, il = points.length; i < il; i++) {

				maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
			}

			this.radius = Math.sqrt(maxRadiusSq);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(sphere) {

			this.center.copy(sphere.center);
			this.radius = sphere.radius;

			return this;
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty() {

			return this.radius < 0;
		}
	}, {
		key: 'makeEmpty',
		value: function makeEmpty() {

			this.center.set(0, 0, 0);
			this.radius = -1;

			return this;
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point) {

			return point.distanceToSquared(this.center) <= this.radius * this.radius;
		}
	}, {
		key: 'distanceToPoint',
		value: function distanceToPoint(point) {

			return point.distanceTo(this.center) - this.radius;
		}
	}, {
		key: 'intersectsSphere',
		value: function intersectsSphere(sphere) {

			var radiusSum = this.radius + sphere.radius;

			return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			return box.intersectsSphere(this);
		}
	}, {
		key: 'intersectsPlane',
		value: function intersectsPlane(plane) {

			return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
		}
	}, {
		key: 'clampPoint',
		value: function clampPoint(point, target) {

			var deltaLengthSq = this.center.distanceToSquared(point);

			target.copy(point);

			if (deltaLengthSq > this.radius * this.radius) {

				target.sub(this.center).normalize();
				target.multiplyScalar(this.radius).add(this.center);
			}

			return target;
		}
	}, {
		key: 'getBoundingBox',
		value: function getBoundingBox(target) {

			if (this.isEmpty()) {

				// Empty sphere produces empty bounding box
				target.makeEmpty();
				return target;
			}

			target.set(this.center, this.center);
			target.expandByScalar(this.radius);

			return target;
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix) {

			this.center.applyMatrix4(matrix);
			this.radius = this.radius * matrix.getMaxScaleOnAxis();

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(offset) {

			this.center.add(offset);

			return this;
		}
	}, {
		key: 'expandByPoint',
		value: function expandByPoint(point) {

			if (this.isEmpty()) {

				this.center.copy(point);

				this.radius = 0;

				return this;
			}

			_v1$6.subVectors(point, this.center);

			var lengthSq = _v1$6.lengthSq();

			if (lengthSq > this.radius * this.radius) {

				// calculate the minimal sphere

				var length = Math.sqrt(lengthSq);

				var delta = (length - this.radius) * 0.5;

				this.center.addScaledVector(_v1$6, delta / length);

				this.radius += delta;
			}

			return this;
		}
	}, {
		key: 'union',
		value: function union(sphere) {

			if (sphere.isEmpty()) {

				return this;
			}

			if (this.isEmpty()) {

				this.copy(sphere);

				return this;
			}

			if (this.center.equals(sphere.center) === true) {

				this.radius = Math.max(this.radius, sphere.radius);
			} else {

				_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);

				this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));

				this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
			}

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(sphere) {

			return sphere.center.equals(this.center) && sphere.radius === this.radius;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Sphere;
}();

var _vector$9 = /*@__PURE__*/new Vector3();
var _segCenter = /*@__PURE__*/new Vector3();
var _segDir = /*@__PURE__*/new Vector3();
var _diff = /*@__PURE__*/new Vector3();

var _edge1 = /*@__PURE__*/new Vector3();
var _edge2 = /*@__PURE__*/new Vector3();
var _normal$1 = /*@__PURE__*/new Vector3();

var Ray = function () {
	function Ray() {
		var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(0, 0, -1);

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Ray);

		this.origin = origin;
		this.direction = direction;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Ray, [{
		key: 'set',
		value: function set(origin, direction) {

			this.origin.copy(origin);
			this.direction.copy(direction);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(ray) {

			this.origin.copy(ray.origin);
			this.direction.copy(ray.direction);

			return this;
		}
	}, {
		key: 'at',
		value: function at(t, target) {

			return target.copy(this.origin).addScaledVector(this.direction, t);
		}
	}, {
		key: 'lookAt',
		value: function lookAt(v) {

			this.direction.copy(v).sub(this.origin).normalize();

			return this;
		}
	}, {
		key: 'recast',
		value: function recast(t) {

			this.origin.copy(this.at(t, _vector$9));

			return this;
		}
	}, {
		key: 'closestPointToPoint',
		value: function closestPointToPoint(point, target) {

			target.subVectors(point, this.origin);

			var directionDistance = target.dot(this.direction);

			if (directionDistance < 0) {

				return target.copy(this.origin);
			}

			return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
		}
	}, {
		key: 'distanceToPoint',
		value: function distanceToPoint(point) {

			return Math.sqrt(this.distanceSqToPoint(point));
		}
	}, {
		key: 'distanceSqToPoint',
		value: function distanceSqToPoint(point) {

			var directionDistance = _vector$9.subVectors(point, this.origin).dot(this.direction);

			// point behind the ray

			if (directionDistance < 0) {

				return this.origin.distanceToSquared(point);
			}

			_vector$9.copy(this.origin).addScaledVector(this.direction, directionDistance);

			return _vector$9.distanceToSquared(point);
		}
	}, {
		key: 'distanceSqToSegment',
		value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {

			// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
			// It returns the min distance between the ray and the segment
			// defined by v0 and v1
			// It can also set two optional targets :
			// - The closest point on the ray
			// - The closest point on the segment

			_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
			_segDir.copy(v1).sub(v0).normalize();
			_diff.copy(this.origin).sub(_segCenter);

			var segExtent = v0.distanceTo(v1) * 0.5;
			var a01 = -this.direction.dot(_segDir);
			var b0 = _diff.dot(this.direction);
			var b1 = -_diff.dot(_segDir);
			var c = _diff.lengthSq();
			var det = Math.abs(1 - a01 * a01);
			var s0 = void 0,
			    s1 = void 0,
			    sqrDist = void 0,
			    extDet = void 0;

			if (det > 0) {

				// The ray and segment are not parallel.

				s0 = a01 * b1 - b0;
				s1 = a01 * b0 - b1;
				extDet = segExtent * det;

				if (s0 >= 0) {

					if (s1 >= -extDet) {

						if (s1 <= extDet) {

							// region 0
							// Minimum at interior points of ray and segment.

							var invDet = 1 / det;
							s0 *= invDet;
							s1 *= invDet;
							sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
						} else {

							// region 1

							s1 = segExtent;
							s0 = Math.max(0, -(a01 * s1 + b0));
							sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
						}
					} else {

						// region 5

						s1 = -segExtent;
						s0 = Math.max(0, -(a01 * s1 + b0));
						sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
					}
				} else {

					if (s1 <= -extDet) {

						// region 4

						s0 = Math.max(0, -(-a01 * segExtent + b0));
						s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
						sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
					} else if (s1 <= extDet) {

						// region 3

						s0 = 0;
						s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
						sqrDist = s1 * (s1 + 2 * b1) + c;
					} else {

						// region 2

						s0 = Math.max(0, -(a01 * segExtent + b0));
						s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
						sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
					}
				}
			} else {

				// Ray and segment are parallel.

				s1 = a01 > 0 ? -segExtent : segExtent;
				s0 = Math.max(0, -(a01 * s1 + b0));
				sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
			}

			if (optionalPointOnRay) {

				optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
			}

			if (optionalPointOnSegment) {

				optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
			}

			return sqrDist;
		}
	}, {
		key: 'intersectSphere',
		value: function intersectSphere(sphere, target) {

			_vector$9.subVectors(sphere.center, this.origin);
			var tca = _vector$9.dot(this.direction);
			var d2 = _vector$9.dot(_vector$9) - tca * tca;
			var radius2 = sphere.radius * sphere.radius;

			if (d2 > radius2) return null;

			var thc = Math.sqrt(radius2 - d2);

			// t0 = first intersect point - entrance on front of sphere
			var t0 = tca - thc;

			// t1 = second intersect point - exit point on back of sphere
			var t1 = tca + thc;

			// test to see if t1 is behind the ray - if so, return null
			if (t1 < 0) return null;

			// test to see if t0 is behind the ray:
			// if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
			// in order to always return an intersect point that is in front of the ray.
			if (t0 < 0) return this.at(t1, target);

			// else t0 is in front of the ray, so return the first collision point scaled by t0
			return this.at(t0, target);
		}
	}, {
		key: 'intersectsSphere',
		value: function intersectsSphere(sphere) {

			return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
		}
	}, {
		key: 'distanceToPlane',
		value: function distanceToPlane(plane) {

			var denominator = plane.normal.dot(this.direction);

			if (denominator === 0) {

				// line is coplanar, return origin
				if (plane.distanceToPoint(this.origin) === 0) {

					return 0;
				}

				// Null is preferable to undefined since undefined means.... it is undefined

				return null;
			}

			var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;

			// Return if the ray never intersects the plane

			return t >= 0 ? t : null;
		}
	}, {
		key: 'intersectPlane',
		value: function intersectPlane(plane, target) {

			var t = this.distanceToPlane(plane);

			if (t === null) {

				return null;
			}

			return this.at(t, target);
		}
	}, {
		key: 'intersectsPlane',
		value: function intersectsPlane(plane) {

			// check if the ray lies on the plane first

			var distToPoint = plane.distanceToPoint(this.origin);

			if (distToPoint === 0) {

				return true;
			}

			var denominator = plane.normal.dot(this.direction);

			if (denominator * distToPoint < 0) {

				return true;
			}

			// ray origin is behind the plane (and is pointing behind it)

			return false;
		}
	}, {
		key: 'intersectBox',
		value: function intersectBox(box, target) {

			var tmin = void 0,
			    tmax = void 0,
			    tymin = void 0,
			    tymax = void 0,
			    tzmin = void 0,
			    tzmax = void 0;

			var invdirx = 1 / this.direction.x,
			    invdiry = 1 / this.direction.y,
			    invdirz = 1 / this.direction.z;

			var origin = this.origin;

			if (invdirx >= 0) {

				tmin = (box.min.x - origin.x) * invdirx;
				tmax = (box.max.x - origin.x) * invdirx;
			} else {

				tmin = (box.max.x - origin.x) * invdirx;
				tmax = (box.min.x - origin.x) * invdirx;
			}

			if (invdiry >= 0) {

				tymin = (box.min.y - origin.y) * invdiry;
				tymax = (box.max.y - origin.y) * invdiry;
			} else {

				tymin = (box.max.y - origin.y) * invdiry;
				tymax = (box.min.y - origin.y) * invdiry;
			}

			if (tmin > tymax || tymin > tmax) return null;

			if (tymin > tmin || isNaN(tmin)) tmin = tymin;

			if (tymax < tmax || isNaN(tmax)) tmax = tymax;

			if (invdirz >= 0) {

				tzmin = (box.min.z - origin.z) * invdirz;
				tzmax = (box.max.z - origin.z) * invdirz;
			} else {

				tzmin = (box.max.z - origin.z) * invdirz;
				tzmax = (box.min.z - origin.z) * invdirz;
			}

			if (tmin > tzmax || tzmin > tmax) return null;

			if (tzmin > tmin || tmin !== tmin) tmin = tzmin;

			if (tzmax < tmax || tmax !== tmax) tmax = tzmax;

			//return point closest to the ray (positive side)

			if (tmax < 0) return null;

			return this.at(tmin >= 0 ? tmin : tmax, target);
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			return this.intersectBox(box, _vector$9) !== null;
		}
	}, {
		key: 'intersectTriangle',
		value: function intersectTriangle(a, b, c, backfaceCulling, target) {

			// Compute the offset origin, edges, and normal.

			// from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h

			_edge1.subVectors(b, a);
			_edge2.subVectors(c, a);
			_normal$1.crossVectors(_edge1, _edge2);

			// Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
			// E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
			//   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
			//   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
			//   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
			var DdN = this.direction.dot(_normal$1);
			var sign = void 0;

			if (DdN > 0) {

				if (backfaceCulling) return null;
				sign = 1;
			} else if (DdN < 0) {

				sign = -1;
				DdN = -DdN;
			} else {

				return null;
			}

			_diff.subVectors(this.origin, a);
			var DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));

			// b1 < 0, no intersection
			if (DdQxE2 < 0) {

				return null;
			}

			var DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));

			// b2 < 0, no intersection
			if (DdE1xQ < 0) {

				return null;
			}

			// b1+b2 > 1, no intersection
			if (DdQxE2 + DdE1xQ > DdN) {

				return null;
			}

			// Line intersects triangle, check if ray does.
			var QdN = -sign * _diff.dot(_normal$1);

			// t < 0, no intersection
			if (QdN < 0) {

				return null;
			}

			// Ray intersects triangle.
			return this.at(QdN / DdN, target);
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix4) {

			this.origin.applyMatrix4(matrix4);
			this.direction.transformDirection(matrix4);

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(ray) {

			return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Ray;
}();

var Matrix4 = function () {
	function Matrix4() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Matrix4);

		Matrix4.prototype.isMatrix4 = true;

		this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Matrix4, [{
		key: 'set',
		value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {

			var te = this.elements;

			te[0] = n11;te[4] = n12;te[8] = n13;te[12] = n14;
			te[1] = n21;te[5] = n22;te[9] = n23;te[13] = n24;
			te[2] = n31;te[6] = n32;te[10] = n33;te[14] = n34;
			te[3] = n41;te[7] = n42;te[11] = n43;te[15] = n44;

			return this;
		}
	}, {
		key: 'identity',
		value: function identity() {

			this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new Matrix4().fromArray(this.elements);
		}
	}, {
		key: 'copy',
		value: function copy(m) {

			var te = this.elements;
			var me = m.elements;

			te[0] = me[0];te[1] = me[1];te[2] = me[2];te[3] = me[3];
			te[4] = me[4];te[5] = me[5];te[6] = me[6];te[7] = me[7];
			te[8] = me[8];te[9] = me[9];te[10] = me[10];te[11] = me[11];
			te[12] = me[12];te[13] = me[13];te[14] = me[14];te[15] = me[15];

			return this;
		}
	}, {
		key: 'copyPosition',
		value: function copyPosition(m) {

			var te = this.elements,
			    me = m.elements;

			te[12] = me[12];
			te[13] = me[13];
			te[14] = me[14];

			return this;
		}
	}, {
		key: 'setFromMatrix3',
		value: function setFromMatrix3(m) {

			var me = m.elements;

			this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'extractBasis',
		value: function extractBasis(xAxis, yAxis, zAxis) {

			xAxis.setFromMatrixColumn(this, 0);
			yAxis.setFromMatrixColumn(this, 1);
			zAxis.setFromMatrixColumn(this, 2);

			return this;
		}
	}, {
		key: 'makeBasis',
		value: function makeBasis(xAxis, yAxis, zAxis) {

			this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'extractRotation',
		value: function extractRotation(m) {

			// this method does not support reflection matrices

			var te = this.elements;
			var me = m.elements;

			var scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
			var scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
			var scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();

			te[0] = me[0] * scaleX;
			te[1] = me[1] * scaleX;
			te[2] = me[2] * scaleX;
			te[3] = 0;

			te[4] = me[4] * scaleY;
			te[5] = me[5] * scaleY;
			te[6] = me[6] * scaleY;
			te[7] = 0;

			te[8] = me[8] * scaleZ;
			te[9] = me[9] * scaleZ;
			te[10] = me[10] * scaleZ;
			te[11] = 0;

			te[12] = 0;
			te[13] = 0;
			te[14] = 0;
			te[15] = 1;

			return this;
		}
	}, {
		key: 'makeRotationFromEuler',
		value: function makeRotationFromEuler(euler) {

			var te = this.elements;

			var x = euler.x,
			    y = euler.y,
			    z = euler.z;
			var a = Math.cos(x),
			    b = Math.sin(x);
			var c = Math.cos(y),
			    d = Math.sin(y);
			var e = Math.cos(z),
			    f = Math.sin(z);

			if (euler.order === 'XYZ') {

				var ae = a * e,
				    af = a * f,
				    be = b * e,
				    bf = b * f;

				te[0] = c * e;
				te[4] = -c * f;
				te[8] = d;

				te[1] = af + be * d;
				te[5] = ae - bf * d;
				te[9] = -b * c;

				te[2] = bf - ae * d;
				te[6] = be + af * d;
				te[10] = a * c;
			} else if (euler.order === 'YXZ') {

				var ce = c * e,
				    cf = c * f,
				    de = d * e,
				    df = d * f;

				te[0] = ce + df * b;
				te[4] = de * b - cf;
				te[8] = a * d;

				te[1] = a * f;
				te[5] = a * e;
				te[9] = -b;

				te[2] = cf * b - de;
				te[6] = df + ce * b;
				te[10] = a * c;
			} else if (euler.order === 'ZXY') {

				var _ce = c * e,
				    _cf = c * f,
				    _de = d * e,
				    _df = d * f;

				te[0] = _ce - _df * b;
				te[4] = -a * f;
				te[8] = _de + _cf * b;

				te[1] = _cf + _de * b;
				te[5] = a * e;
				te[9] = _df - _ce * b;

				te[2] = -a * d;
				te[6] = b;
				te[10] = a * c;
			} else if (euler.order === 'ZYX') {

				var _ae = a * e,
				    _af = a * f,
				    _be = b * e,
				    _bf = b * f;

				te[0] = c * e;
				te[4] = _be * d - _af;
				te[8] = _ae * d + _bf;

				te[1] = c * f;
				te[5] = _bf * d + _ae;
				te[9] = _af * d - _be;

				te[2] = -d;
				te[6] = b * c;
				te[10] = a * c;
			} else if (euler.order === 'YZX') {

				var ac = a * c,
				    ad = a * d,
				    bc = b * c,
				    bd = b * d;

				te[0] = c * e;
				te[4] = bd - ac * f;
				te[8] = bc * f + ad;

				te[1] = f;
				te[5] = a * e;
				te[9] = -b * e;

				te[2] = -d * e;
				te[6] = ad * f + bc;
				te[10] = ac - bd * f;
			} else if (euler.order === 'XZY') {

				var _ac = a * c,
				    _ad = a * d,
				    _bc = b * c,
				    _bd = b * d;

				te[0] = c * e;
				te[4] = -f;
				te[8] = d * e;

				te[1] = _ac * f + _bd;
				te[5] = a * e;
				te[9] = _ad * f - _bc;

				te[2] = _bc * f - _ad;
				te[6] = b * e;
				te[10] = _bd * f + _ac;
			}

			// bottom row
			te[3] = 0;
			te[7] = 0;
			te[11] = 0;

			// last column
			te[12] = 0;
			te[13] = 0;
			te[14] = 0;
			te[15] = 1;

			return this;
		}
	}, {
		key: 'makeRotationFromQuaternion',
		value: function makeRotationFromQuaternion(q) {

			return this.compose(_zero, q, _one);
		}
	}, {
		key: 'lookAt',
		value: function lookAt(eye, target, up) {

			var te = this.elements;

			_z.subVectors(eye, target);

			if (_z.lengthSq() === 0) {

				// eye and target are in the same position

				_z.z = 1;
			}

			_z.normalize();
			_x.crossVectors(up, _z);

			if (_x.lengthSq() === 0) {

				// up and z are parallel

				if (Math.abs(up.z) === 1) {

					_z.x += 0.0001;
				} else {

					_z.z += 0.0001;
				}

				_z.normalize();
				_x.crossVectors(up, _z);
			}

			_x.normalize();
			_y.crossVectors(_z, _x);

			te[0] = _x.x;te[4] = _y.x;te[8] = _z.x;
			te[1] = _x.y;te[5] = _y.y;te[9] = _z.y;
			te[2] = _x.z;te[6] = _y.z;te[10] = _z.z;

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(m) {

			return this.multiplyMatrices(this, m);
		}
	}, {
		key: 'premultiply',
		value: function premultiply(m) {

			return this.multiplyMatrices(m, this);
		}
	}, {
		key: 'multiplyMatrices',
		value: function multiplyMatrices(a, b) {

			var ae = a.elements;
			var be = b.elements;
			var te = this.elements;

			var a11 = ae[0],
			    a12 = ae[4],
			    a13 = ae[8],
			    a14 = ae[12];
			var a21 = ae[1],
			    a22 = ae[5],
			    a23 = ae[9],
			    a24 = ae[13];
			var a31 = ae[2],
			    a32 = ae[6],
			    a33 = ae[10],
			    a34 = ae[14];
			var a41 = ae[3],
			    a42 = ae[7],
			    a43 = ae[11],
			    a44 = ae[15];

			var b11 = be[0],
			    b12 = be[4],
			    b13 = be[8],
			    b14 = be[12];
			var b21 = be[1],
			    b22 = be[5],
			    b23 = be[9],
			    b24 = be[13];
			var b31 = be[2],
			    b32 = be[6],
			    b33 = be[10],
			    b34 = be[14];
			var b41 = be[3],
			    b42 = be[7],
			    b43 = be[11],
			    b44 = be[15];

			te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
			te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
			te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
			te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

			te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
			te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
			te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
			te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

			te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
			te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
			te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
			te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

			te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
			te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
			te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
			te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(s) {

			var te = this.elements;

			te[0] *= s;te[4] *= s;te[8] *= s;te[12] *= s;
			te[1] *= s;te[5] *= s;te[9] *= s;te[13] *= s;
			te[2] *= s;te[6] *= s;te[10] *= s;te[14] *= s;
			te[3] *= s;te[7] *= s;te[11] *= s;te[15] *= s;

			return this;
		}
	}, {
		key: 'determinant',
		value: function determinant() {

			var te = this.elements;

			var n11 = te[0],
			    n12 = te[4],
			    n13 = te[8],
			    n14 = te[12];
			var n21 = te[1],
			    n22 = te[5],
			    n23 = te[9],
			    n24 = te[13];
			var n31 = te[2],
			    n32 = te[6],
			    n33 = te[10],
			    n34 = te[14];
			var n41 = te[3],
			    n42 = te[7],
			    n43 = te[11],
			    n44 = te[15];

			//TODO: make this more efficient
			//( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

			return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
		}
	}, {
		key: 'transpose',
		value: function transpose() {

			var te = this.elements;
			var tmp = void 0;

			tmp = te[1];te[1] = te[4];te[4] = tmp;
			tmp = te[2];te[2] = te[8];te[8] = tmp;
			tmp = te[6];te[6] = te[9];te[9] = tmp;

			tmp = te[3];te[3] = te[12];te[12] = tmp;
			tmp = te[7];te[7] = te[13];te[13] = tmp;
			tmp = te[11];te[11] = te[14];te[14] = tmp;

			return this;
		}
	}, {
		key: 'setPosition',
		value: function setPosition(x, y, z) {

			var te = this.elements;

			if (x.isVector3) {

				te[12] = x.x;
				te[13] = x.y;
				te[14] = x.z;
			} else {

				te[12] = x;
				te[13] = y;
				te[14] = z;
			}

			return this;
		}
	}, {
		key: 'invert',
		value: function invert() {

			// based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
			var te = this.elements,
			    n11 = te[0],
			    n21 = te[1],
			    n31 = te[2],
			    n41 = te[3],
			    n12 = te[4],
			    n22 = te[5],
			    n32 = te[6],
			    n42 = te[7],
			    n13 = te[8],
			    n23 = te[9],
			    n33 = te[10],
			    n43 = te[11],
			    n14 = te[12],
			    n24 = te[13],
			    n34 = te[14],
			    n44 = te[15],
			    t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
			    t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
			    t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
			    t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;

			var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;

			if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);

			var detInv = 1 / det;

			te[0] = t11 * detInv;
			te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
			te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
			te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;

			te[4] = t12 * detInv;
			te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
			te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
			te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;

			te[8] = t13 * detInv;
			te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
			te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
			te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;

			te[12] = t14 * detInv;
			te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
			te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
			te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;

			return this;
		}
	}, {
		key: 'scale',
		value: function scale(v) {

			var te = this.elements;
			var x = v.x,
			    y = v.y,
			    z = v.z;

			te[0] *= x;te[4] *= y;te[8] *= z;
			te[1] *= x;te[5] *= y;te[9] *= z;
			te[2] *= x;te[6] *= y;te[10] *= z;
			te[3] *= x;te[7] *= y;te[11] *= z;

			return this;
		}
	}, {
		key: 'getMaxScaleOnAxis',
		value: function getMaxScaleOnAxis() {

			var te = this.elements;

			var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
			var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
			var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];

			return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
		}
	}, {
		key: 'makeTranslation',
		value: function makeTranslation(x, y, z) {

			this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeRotationX',
		value: function makeRotationX(theta) {

			var c = Math.cos(theta),
			    s = Math.sin(theta);

			this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeRotationY',
		value: function makeRotationY(theta) {

			var c = Math.cos(theta),
			    s = Math.sin(theta);

			this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeRotationZ',
		value: function makeRotationZ(theta) {

			var c = Math.cos(theta),
			    s = Math.sin(theta);

			this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeRotationAxis',
		value: function makeRotationAxis(axis, angle) {

			// Based on http://www.gamedev.net/reference/articles/article1199.asp

			var c = Math.cos(angle);
			var s = Math.sin(angle);
			var t = 1 - c;
			var x = axis.x,
			    y = axis.y,
			    z = axis.z;
			var tx = t * x,
			    ty = t * y;

			this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeScale',
		value: function makeScale(x, y, z) {

			this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'makeShear',
		value: function makeShear(xy, xz, yx, yz, zx, zy) {

			this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);

			return this;
		}
	}, {
		key: 'compose',
		value: function compose(position, quaternion, scale) {

			var te = this.elements;

			var x = quaternion._x,
			    y = quaternion._y,
			    z = quaternion._z,
			    w = quaternion._w;
			var x2 = x + x,
			    y2 = y + y,
			    z2 = z + z;
			var xx = x * x2,
			    xy = x * y2,
			    xz = x * z2;
			var yy = y * y2,
			    yz = y * z2,
			    zz = z * z2;
			var wx = w * x2,
			    wy = w * y2,
			    wz = w * z2;

			var sx = scale.x,
			    sy = scale.y,
			    sz = scale.z;

			te[0] = (1 - (yy + zz)) * sx;
			te[1] = (xy + wz) * sx;
			te[2] = (xz - wy) * sx;
			te[3] = 0;

			te[4] = (xy - wz) * sy;
			te[5] = (1 - (xx + zz)) * sy;
			te[6] = (yz + wx) * sy;
			te[7] = 0;

			te[8] = (xz + wy) * sz;
			te[9] = (yz - wx) * sz;
			te[10] = (1 - (xx + yy)) * sz;
			te[11] = 0;

			te[12] = position.x;
			te[13] = position.y;
			te[14] = position.z;
			te[15] = 1;

			return this;
		}
	}, {
		key: 'decompose',
		value: function decompose(position, quaternion, scale) {

			var te = this.elements;

			var sx = _v1$5.set(te[0], te[1], te[2]).length();
			var sy = _v1$5.set(te[4], te[5], te[6]).length();
			var sz = _v1$5.set(te[8], te[9], te[10]).length();

			// if determine is negative, we need to invert one scale
			var det = this.determinant();
			if (det < 0) sx = -sx;

			position.x = te[12];
			position.y = te[13];
			position.z = te[14];

			// scale the rotation part
			_m1$2.copy(this);

			var invSX = 1 / sx;
			var invSY = 1 / sy;
			var invSZ = 1 / sz;

			_m1$2.elements[0] *= invSX;
			_m1$2.elements[1] *= invSX;
			_m1$2.elements[2] *= invSX;

			_m1$2.elements[4] *= invSY;
			_m1$2.elements[5] *= invSY;
			_m1$2.elements[6] *= invSY;

			_m1$2.elements[8] *= invSZ;
			_m1$2.elements[9] *= invSZ;
			_m1$2.elements[10] *= invSZ;

			quaternion.setFromRotationMatrix(_m1$2);

			scale.x = sx;
			scale.y = sy;
			scale.z = sz;

			return this;
		}
	}, {
		key: 'makePerspective',
		value: function makePerspective(left, right, top, bottom, near, far) {

			var te = this.elements;
			var x = 2 * near / (right - left);
			var y = 2 * near / (top - bottom);

			var a = (right + left) / (right - left);
			var b = (top + bottom) / (top - bottom);
			var c = -(far + near) / (far - near);
			var d = -2 * far * near / (far - near);

			te[0] = x;te[4] = 0;te[8] = a;te[12] = 0;
			te[1] = 0;te[5] = y;te[9] = b;te[13] = 0;
			te[2] = 0;te[6] = 0;te[10] = c;te[14] = d;
			te[3] = 0;te[7] = 0;te[11] = -1;te[15] = 0;

			return this;
		}
	}, {
		key: 'makeOrthographic',
		value: function makeOrthographic(left, right, top, bottom, near, far) {

			var te = this.elements;
			var w = 1.0 / (right - left);
			var h = 1.0 / (top - bottom);
			var p = 1.0 / (far - near);

			var x = (right + left) * w;
			var y = (top + bottom) * h;
			var z = (far + near) * p;

			te[0] = 2 * w;te[4] = 0;te[8] = 0;te[12] = -x;
			te[1] = 0;te[5] = 2 * h;te[9] = 0;te[13] = -y;
			te[2] = 0;te[6] = 0;te[10] = -2 * p;te[14] = -z;
			te[3] = 0;te[7] = 0;te[11] = 0;te[15] = 1;

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(matrix) {

			var te = this.elements;
			var me = matrix.elements;

			for (var i = 0; i < 16; i++) {

				if (te[i] !== me[i]) return false;
			}

			return true;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			for (var i = 0; i < 16; i++) {

				this.elements[i] = array[i + offset];
			}

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			var te = this.elements;

			array[offset] = te[0];
			array[offset + 1] = te[1];
			array[offset + 2] = te[2];
			array[offset + 3] = te[3];

			array[offset + 4] = te[4];
			array[offset + 5] = te[5];
			array[offset + 6] = te[6];
			array[offset + 7] = te[7];

			array[offset + 8] = te[8];
			array[offset + 9] = te[9];
			array[offset + 10] = te[10];
			array[offset + 11] = te[11];

			array[offset + 12] = te[12];
			array[offset + 13] = te[13];
			array[offset + 14] = te[14];
			array[offset + 15] = te[15];

			return array;
		}
	}]);

	return Matrix4;
}();

var _v1$5 = /*@__PURE__*/new Vector3();
var _m1$2 = /*@__PURE__*/new Matrix4();
var _zero = /*@__PURE__*/new Vector3(0, 0, 0);
var _one = /*@__PURE__*/new Vector3(1, 1, 1);
var _x = /*@__PURE__*/new Vector3();
var _y = /*@__PURE__*/new Vector3();
var _z = /*@__PURE__*/new Vector3();

var _matrix = /*@__PURE__*/new Matrix4();
var _quaternion$3 = /*@__PURE__*/new Quaternion();

var Euler = function () {
	function Euler() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Euler.DEFAULT_ORDER;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Euler);

		this.isEuler = true;

		this._x = x;
		this._y = y;
		this._z = z;
		this._order = order;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Euler, [{
		key: 'set',
		value: function set(x, y, z) {
			var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;


			this._x = x;
			this._y = y;
			this._z = z;
			this._order = order;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this._x, this._y, this._z, this._order);
		}
	}, {
		key: 'copy',
		value: function copy(euler) {

			this._x = euler._x;
			this._y = euler._y;
			this._z = euler._z;
			this._order = euler._order;

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromRotationMatrix',
		value: function setFromRotationMatrix(m) {
			var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
			var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			var te = m.elements;
			var m11 = te[0],
			    m12 = te[4],
			    m13 = te[8];
			var m21 = te[1],
			    m22 = te[5],
			    m23 = te[9];
			var m31 = te[2],
			    m32 = te[6],
			    m33 = te[10];

			switch (order) {

				case 'XYZ':

					this._y = Math.asin(clamp(m13, -1, 1));

					if (Math.abs(m13) < 0.9999999) {

						this._x = Math.atan2(-m23, m33);
						this._z = Math.atan2(-m12, m11);
					} else {

						this._x = Math.atan2(m32, m22);
						this._z = 0;
					}

					break;

				case 'YXZ':

					this._x = Math.asin(-clamp(m23, -1, 1));

					if (Math.abs(m23) < 0.9999999) {

						this._y = Math.atan2(m13, m33);
						this._z = Math.atan2(m21, m22);
					} else {

						this._y = Math.atan2(-m31, m11);
						this._z = 0;
					}

					break;

				case 'ZXY':

					this._x = Math.asin(clamp(m32, -1, 1));

					if (Math.abs(m32) < 0.9999999) {

						this._y = Math.atan2(-m31, m33);
						this._z = Math.atan2(-m12, m22);
					} else {

						this._y = 0;
						this._z = Math.atan2(m21, m11);
					}

					break;

				case 'ZYX':

					this._y = Math.asin(-clamp(m31, -1, 1));

					if (Math.abs(m31) < 0.9999999) {

						this._x = Math.atan2(m32, m33);
						this._z = Math.atan2(m21, m11);
					} else {

						this._x = 0;
						this._z = Math.atan2(-m12, m22);
					}

					break;

				case 'YZX':

					this._z = Math.asin(clamp(m21, -1, 1));

					if (Math.abs(m21) < 0.9999999) {

						this._x = Math.atan2(-m23, m22);
						this._y = Math.atan2(-m31, m11);
					} else {

						this._x = 0;
						this._y = Math.atan2(m13, m33);
					}

					break;

				case 'XZY':

					this._z = Math.asin(-clamp(m12, -1, 1));

					if (Math.abs(m12) < 0.9999999) {

						this._x = Math.atan2(m32, m22);
						this._y = Math.atan2(m13, m11);
					} else {

						this._x = Math.atan2(-m23, m33);
						this._y = 0;
					}

					break;

				default:

					console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);

			}

			this._order = order;

			if (update === true) this._onChangeCallback();

			return this;
		}
	}, {
		key: 'setFromQuaternion',
		value: function setFromQuaternion(q, order, update) {

			_matrix.makeRotationFromQuaternion(q);

			return this.setFromRotationMatrix(_matrix, order, update);
		}
	}, {
		key: 'setFromVector3',
		value: function setFromVector3(v) {
			var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;


			return this.set(v.x, v.y, v.z, order);
		}
	}, {
		key: 'reorder',
		value: function reorder(newOrder) {

			// WARNING: this discards revolution information -bhouston

			_quaternion$3.setFromEuler(this);

			return this.setFromQuaternion(_quaternion$3, newOrder);
		}
	}, {
		key: 'equals',
		value: function equals(euler) {

			return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {

			this._x = array[0];
			this._y = array[1];
			this._z = array[2];
			if (array[3] !== undefined) this._order = array[3];

			this._onChangeCallback();

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this._x;
			array[offset + 1] = this._y;
			array[offset + 2] = this._z;
			array[offset + 3] = this._order;

			return array;
		}
	}, {
		key: '_onChange',
		value: function _onChange(callback) {

			this._onChangeCallback = callback;

			return this;
		}
	}, {
		key: '_onChangeCallback',
		value: function _onChangeCallback() {}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return this._x;

						case 2:
							_context6.next = 4;
							return this._y;

						case 4:
							_context6.next = 6;
							return this._z;

						case 6:
							_context6.next = 8;
							return this._order;

						case 8:
						case 'end':
							return _context6.stop();
					}
				}
			}, value, this);
		})
	}, {
		key: 'x',
		get: function get() {

			return this._x;
		},
		set: function set(value) {

			this._x = value;
			this._onChangeCallback();
		}
	}, {
		key: 'y',
		get: function get() {

			return this._y;
		},
		set: function set(value) {

			this._y = value;
			this._onChangeCallback();
		}
	}, {
		key: 'z',
		get: function get() {

			return this._z;
		},
		set: function set(value) {

			this._z = value;
			this._onChangeCallback();
		}
	}, {
		key: 'order',
		get: function get() {

			return this._order;
		},
		set: function set(value) {

			this._order = value;
			this._onChangeCallback();
		}
	}]);

	return Euler;
}();

Euler.DEFAULT_ORDER = 'XYZ';

var Layers = function () {
	function Layers() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Layers);

		this.mask = 1 | 0;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Layers, [{
		key: 'set',
		value: function set(channel) {

			this.mask = (1 << channel | 0) >>> 0;
		}
	}, {
		key: 'enable',
		value: function enable(channel) {

			this.mask |= 1 << channel | 0;
		}
	}, {
		key: 'enableAll',
		value: function enableAll() {

			this.mask = 0xffffffff | 0;
		}
	}, {
		key: 'toggle',
		value: function toggle(channel) {

			this.mask ^= 1 << channel | 0;
		}
	}, {
		key: 'disable',
		value: function disable(channel) {

			this.mask &= ~(1 << channel | 0);
		}
	}, {
		key: 'disableAll',
		value: function disableAll() {

			this.mask = 0;
		}
	}, {
		key: 'test',
		value: function test(layers) {

			return (this.mask & layers.mask) !== 0;
		}
	}, {
		key: 'isEnabled',
		value: function isEnabled(channel) {

			return (this.mask & (1 << channel | 0)) !== 0;
		}
	}]);

	return Layers;
}();

var _object3DId = 0;

var _v1$4 = /*@__PURE__*/new Vector3();
var _q1 = /*@__PURE__*/new Quaternion();
var _m1$1 = /*@__PURE__*/new Matrix4();
var _target = /*@__PURE__*/new Vector3();

var _position$3 = /*@__PURE__*/new Vector3();
var _scale$2 = /*@__PURE__*/new Vector3();
var _quaternion$2 = /*@__PURE__*/new Quaternion();

var _xAxis = /*@__PURE__*/new Vector3(1, 0, 0);
var _yAxis = /*@__PURE__*/new Vector3(0, 1, 0);
var _zAxis = /*@__PURE__*/new Vector3(0, 0, 1);

var _addedEvent = { type: 'added' };
var _removedEvent = { type: 'removed' };

var Object3D = function (_EventDispatcher3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Object3D, _EventDispatcher3);

	function Object3D() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Object3D);

		var _this9 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Object3D.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Object3D)).call(this));

		_this9.isObject3D = true;

		Object.defineProperty(_this9, 'id', { value: _object3DId++ });

		_this9.uuid = generateUUID();

		_this9.name = '';
		_this9.type = 'Object3D';

		_this9.parent = null;
		_this9.children = [];

		_this9.up = Object3D.DEFAULT_UP.clone();

		var position = new Vector3();
		var rotation = new Euler();
		var quaternion = new Quaternion();
		var scale = new Vector3(1, 1, 1);

		function onRotationChange() {

			quaternion.setFromEuler(rotation, false);
		}

		function onQuaternionChange() {

			rotation.setFromQuaternion(quaternion, undefined, false);
		}

		rotation._onChange(onRotationChange);
		quaternion._onChange(onQuaternionChange);

		__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_properties___default()(_this9, {
			position: {
				configurable: true,
				enumerable: true,
				value: position
			},
			rotation: {
				configurable: true,
				enumerable: true,
				value: rotation
			},
			quaternion: {
				configurable: true,
				enumerable: true,
				value: quaternion
			},
			scale: {
				configurable: true,
				enumerable: true,
				value: scale
			},
			modelViewMatrix: {
				value: new Matrix4()
			},
			normalMatrix: {
				value: new Matrix3()
			}
		});

		_this9.matrix = new Matrix4();
		_this9.matrixWorld = new Matrix4();

		_this9.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
		_this9.matrixWorldNeedsUpdate = false;

		_this9.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer

		_this9.layers = new Layers();
		_this9.visible = true;

		_this9.castShadow = false;
		_this9.receiveShadow = false;

		_this9.frustumCulled = true;
		_this9.renderOrder = 0;

		_this9.animations = [];

		_this9.userData = {};

		return _this9;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Object3D, [{
		key: 'onBeforeRender',
		value: function onBeforeRender() /* renderer, scene, camera, geometry, material, group */{}
	}, {
		key: 'onAfterRender',
		value: function onAfterRender() /* renderer, scene, camera, geometry, material, group */{}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix) {

			if (this.matrixAutoUpdate) this.updateMatrix();

			this.matrix.premultiply(matrix);

			this.matrix.decompose(this.position, this.quaternion, this.scale);
		}
	}, {
		key: 'applyQuaternion',
		value: function applyQuaternion(q) {

			this.quaternion.premultiply(q);

			return this;
		}
	}, {
		key: 'setRotationFromAxisAngle',
		value: function setRotationFromAxisAngle(axis, angle) {

			// assumes axis is normalized

			this.quaternion.setFromAxisAngle(axis, angle);
		}
	}, {
		key: 'setRotationFromEuler',
		value: function setRotationFromEuler(euler) {

			this.quaternion.setFromEuler(euler, true);
		}
	}, {
		key: 'setRotationFromMatrix',
		value: function setRotationFromMatrix(m) {

			// assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)

			this.quaternion.setFromRotationMatrix(m);
		}
	}, {
		key: 'setRotationFromQuaternion',
		value: function setRotationFromQuaternion(q) {

			// assumes q is normalized

			this.quaternion.copy(q);
		}
	}, {
		key: 'rotateOnAxis',
		value: function rotateOnAxis(axis, angle) {

			// rotate object on axis in object space
			// axis is assumed to be normalized

			_q1.setFromAxisAngle(axis, angle);

			this.quaternion.multiply(_q1);

			return this;
		}
	}, {
		key: 'rotateOnWorldAxis',
		value: function rotateOnWorldAxis(axis, angle) {

			// rotate object on axis in world space
			// axis is assumed to be normalized
			// method assumes no rotated parent

			_q1.setFromAxisAngle(axis, angle);

			this.quaternion.premultiply(_q1);

			return this;
		}
	}, {
		key: 'rotateX',
		value: function rotateX(angle) {

			return this.rotateOnAxis(_xAxis, angle);
		}
	}, {
		key: 'rotateY',
		value: function rotateY(angle) {

			return this.rotateOnAxis(_yAxis, angle);
		}
	}, {
		key: 'rotateZ',
		value: function rotateZ(angle) {

			return this.rotateOnAxis(_zAxis, angle);
		}
	}, {
		key: 'translateOnAxis',
		value: function translateOnAxis(axis, distance) {

			// translate object by distance along axis in object space
			// axis is assumed to be normalized

			_v1$4.copy(axis).applyQuaternion(this.quaternion);

			this.position.add(_v1$4.multiplyScalar(distance));

			return this;
		}
	}, {
		key: 'translateX',
		value: function translateX(distance) {

			return this.translateOnAxis(_xAxis, distance);
		}
	}, {
		key: 'translateY',
		value: function translateY(distance) {

			return this.translateOnAxis(_yAxis, distance);
		}
	}, {
		key: 'translateZ',
		value: function translateZ(distance) {

			return this.translateOnAxis(_zAxis, distance);
		}
	}, {
		key: 'localToWorld',
		value: function localToWorld(vector) {

			this.updateWorldMatrix(true, false);

			return vector.applyMatrix4(this.matrixWorld);
		}
	}, {
		key: 'worldToLocal',
		value: function worldToLocal(vector) {

			this.updateWorldMatrix(true, false);

			return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
		}
	}, {
		key: 'lookAt',
		value: function lookAt(x, y, z) {

			// This method does not support objects having non-uniformly-scaled parent(s)

			if (x.isVector3) {

				_target.copy(x);
			} else {

				_target.set(x, y, z);
			}

			var parent = this.parent;

			this.updateWorldMatrix(true, false);

			_position$3.setFromMatrixPosition(this.matrixWorld);

			if (this.isCamera || this.isLight) {

				_m1$1.lookAt(_position$3, _target, this.up);
			} else {

				_m1$1.lookAt(_target, _position$3, this.up);
			}

			this.quaternion.setFromRotationMatrix(_m1$1);

			if (parent) {

				_m1$1.extractRotation(parent.matrixWorld);
				_q1.setFromRotationMatrix(_m1$1);
				this.quaternion.premultiply(_q1.invert());
			}
		}
	}, {
		key: 'add',
		value: function add(object) {

			if (arguments.length > 1) {

				for (var i = 0; i < arguments.length; i++) {

					this.add(arguments[i]);
				}

				return this;
			}

			if (object === this) {

				console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
				return this;
			}

			if (object && object.isObject3D) {

				if (object.parent !== null) {

					object.parent.remove(object);
				}

				object.parent = this;
				this.children.push(object);

				object.dispatchEvent(_addedEvent);
			} else {

				console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
			}

			return this;
		}
	}, {
		key: 'remove',
		value: function remove(object) {

			if (arguments.length > 1) {

				for (var i = 0; i < arguments.length; i++) {

					this.remove(arguments[i]);
				}

				return this;
			}

			var index = this.children.indexOf(object);

			if (index !== -1) {

				object.parent = null;
				this.children.splice(index, 1);

				object.dispatchEvent(_removedEvent);
			}

			return this;
		}
	}, {
		key: 'removeFromParent',
		value: function removeFromParent() {

			var parent = this.parent;

			if (parent !== null) {

				parent.remove(this);
			}

			return this;
		}
	}, {
		key: 'clear',
		value: function clear() {

			for (var i = 0; i < this.children.length; i++) {

				var object = this.children[i];

				object.parent = null;

				object.dispatchEvent(_removedEvent);
			}

			this.children.length = 0;

			return this;
		}
	}, {
		key: 'attach',
		value: function attach(object) {

			// adds object as a child of this, while maintaining the object's world transform

			// Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)

			this.updateWorldMatrix(true, false);

			_m1$1.copy(this.matrixWorld).invert();

			if (object.parent !== null) {

				object.parent.updateWorldMatrix(true, false);

				_m1$1.multiply(object.parent.matrixWorld);
			}

			object.applyMatrix4(_m1$1);

			this.add(object);

			object.updateWorldMatrix(false, true);

			return this;
		}
	}, {
		key: 'getObjectById',
		value: function getObjectById(id) {

			return this.getObjectByProperty('id', id);
		}
	}, {
		key: 'getObjectByName',
		value: function getObjectByName(name) {

			return this.getObjectByProperty('name', name);
		}
	}, {
		key: 'getObjectByProperty',
		value: function getObjectByProperty(name, value) {

			if (this[name] === value) return this;

			for (var i = 0, l = this.children.length; i < l; i++) {

				var child = this.children[i];
				var object = child.getObjectByProperty(name, value);

				if (object !== undefined) {

					return object;
				}
			}

			return undefined;
		}
	}, {
		key: 'getObjectsByProperty',
		value: function getObjectsByProperty(name, value) {

			var result = [];

			if (this[name] === value) result.push(this);

			for (var i = 0, l = this.children.length; i < l; i++) {

				var childResult = this.children[i].getObjectsByProperty(name, value);

				if (childResult.length > 0) {

					result = result.concat(childResult);
				}
			}

			return result;
		}
	}, {
		key: 'getWorldPosition',
		value: function getWorldPosition(target) {

			this.updateWorldMatrix(true, false);

			return target.setFromMatrixPosition(this.matrixWorld);
		}
	}, {
		key: 'getWorldQuaternion',
		value: function getWorldQuaternion(target) {

			this.updateWorldMatrix(true, false);

			this.matrixWorld.decompose(_position$3, target, _scale$2);

			return target;
		}
	}, {
		key: 'getWorldScale',
		value: function getWorldScale(target) {

			this.updateWorldMatrix(true, false);

			this.matrixWorld.decompose(_position$3, _quaternion$2, target);

			return target;
		}
	}, {
		key: 'getWorldDirection',
		value: function getWorldDirection(target) {

			this.updateWorldMatrix(true, false);

			var e = this.matrixWorld.elements;

			return target.set(e[8], e[9], e[10]).normalize();
		}
	}, {
		key: 'raycast',
		value: function raycast() /* raycaster, intersects */{}
	}, {
		key: 'traverse',
		value: function traverse(callback) {

			callback(this);

			var children = this.children;

			for (var i = 0, l = children.length; i < l; i++) {

				children[i].traverse(callback);
			}
		}
	}, {
		key: 'traverseVisible',
		value: function traverseVisible(callback) {

			if (this.visible === false) return;

			callback(this);

			var children = this.children;

			for (var i = 0, l = children.length; i < l; i++) {

				children[i].traverseVisible(callback);
			}
		}
	}, {
		key: 'traverseAncestors',
		value: function traverseAncestors(callback) {

			var parent = this.parent;

			if (parent !== null) {

				callback(parent);

				parent.traverseAncestors(callback);
			}
		}
	}, {
		key: 'updateMatrix',
		value: function updateMatrix() {

			this.matrix.compose(this.position, this.quaternion, this.scale);

			this.matrixWorldNeedsUpdate = true;
		}
	}, {
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			if (this.matrixAutoUpdate) this.updateMatrix();

			if (this.matrixWorldNeedsUpdate || force) {

				if (this.parent === null) {

					this.matrixWorld.copy(this.matrix);
				} else {

					this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
				}

				this.matrixWorldNeedsUpdate = false;

				force = true;
			}

			// update children

			var children = this.children;

			for (var i = 0, l = children.length; i < l; i++) {

				var child = children[i];

				if (child.matrixWorldAutoUpdate === true || force === true) {

					child.updateMatrixWorld(force);
				}
			}
		}
	}, {
		key: 'updateWorldMatrix',
		value: function updateWorldMatrix(updateParents, updateChildren) {

			var parent = this.parent;

			if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) {

				parent.updateWorldMatrix(true, false);
			}

			if (this.matrixAutoUpdate) this.updateMatrix();

			if (this.parent === null) {

				this.matrixWorld.copy(this.matrix);
			} else {

				this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
			}

			// update children

			if (updateChildren === true) {

				var children = this.children;

				for (var i = 0, l = children.length; i < l; i++) {

					var child = children[i];

					if (child.matrixWorldAutoUpdate === true) {

						child.updateWorldMatrix(false, true);
					}
				}
			}
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			// meta is a string when called from JSON.stringify
			var isRootObject = meta === undefined || typeof meta === 'string';

			var output = {};

			// meta is a hash used to collect geometries, materials.
			// not providing it implies that this is the root object
			// being serialized.
			if (isRootObject) {

				// initialize meta obj
				meta = {
					geometries: {},
					materials: {},
					textures: {},
					images: {},
					shapes: {},
					skeletons: {},
					animations: {},
					nodes: {}
				};

				output.metadata = {
					version: 4.5,
					type: 'Object',
					generator: 'Object3D.toJSON'
				};
			}

			// standard Object3D serialization

			var object = {};

			object.uuid = this.uuid;
			object.type = this.type;

			if (this.name !== '') object.name = this.name;
			if (this.castShadow === true) object.castShadow = true;
			if (this.receiveShadow === true) object.receiveShadow = true;
			if (this.visible === false) object.visible = false;
			if (this.frustumCulled === false) object.frustumCulled = false;
			if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(this.userData).length > 0) object.userData = this.userData;

			object.layers = this.layers.mask;
			object.matrix = this.matrix.toArray();
			object.up = this.up.toArray();

			if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;

			// object specific properties

			if (this.isInstancedMesh) {

				object.type = 'InstancedMesh';
				object.count = this.count;
				object.instanceMatrix = this.instanceMatrix.toJSON();
				if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
			}

			//

			function serialize(library, element) {

				if (library[element.uuid] === undefined) {

					library[element.uuid] = element.toJSON(meta);
				}

				return element.uuid;
			}

			if (this.isScene) {

				if (this.background) {

					if (this.background.isColor) {

						object.background = this.background.toJSON();
					} else if (this.background.isTexture) {

						object.background = this.background.toJSON(meta).uuid;
					}
				}

				if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) {

					object.environment = this.environment.toJSON(meta).uuid;
				}
			} else if (this.isMesh || this.isLine || this.isPoints) {

				object.geometry = serialize(meta.geometries, this.geometry);

				var parameters = this.geometry.parameters;

				if (parameters !== undefined && parameters.shapes !== undefined) {

					var shapes = parameters.shapes;

					if (Array.isArray(shapes)) {

						for (var i = 0, l = shapes.length; i < l; i++) {

							var shape = shapes[i];

							serialize(meta.shapes, shape);
						}
					} else {

						serialize(meta.shapes, shapes);
					}
				}
			}

			if (this.isSkinnedMesh) {

				object.bindMode = this.bindMode;
				object.bindMatrix = this.bindMatrix.toArray();

				if (this.skeleton !== undefined) {

					serialize(meta.skeletons, this.skeleton);

					object.skeleton = this.skeleton.uuid;
				}
			}

			if (this.material !== undefined) {

				if (Array.isArray(this.material)) {

					var uuids = [];

					for (var _i3 = 0, _l2 = this.material.length; _i3 < _l2; _i3++) {

						uuids.push(serialize(meta.materials, this.material[_i3]));
					}

					object.material = uuids;
				} else {

					object.material = serialize(meta.materials, this.material);
				}
			}

			//

			if (this.children.length > 0) {

				object.children = [];

				for (var _i4 = 0; _i4 < this.children.length; _i4++) {

					object.children.push(this.children[_i4].toJSON(meta).object);
				}
			}

			//

			if (this.animations.length > 0) {

				object.animations = [];

				for (var _i5 = 0; _i5 < this.animations.length; _i5++) {

					var animation = this.animations[_i5];

					object.animations.push(serialize(meta.animations, animation));
				}
			}

			if (isRootObject) {

				var geometries = extractFromCache(meta.geometries);
				var materials = extractFromCache(meta.materials);
				var textures = extractFromCache(meta.textures);
				var images = extractFromCache(meta.images);
				var _shapes = extractFromCache(meta.shapes);
				var skeletons = extractFromCache(meta.skeletons);
				var animations = extractFromCache(meta.animations);
				var nodes = extractFromCache(meta.nodes);

				if (geometries.length > 0) output.geometries = geometries;
				if (materials.length > 0) output.materials = materials;
				if (textures.length > 0) output.textures = textures;
				if (images.length > 0) output.images = images;
				if (_shapes.length > 0) output.shapes = _shapes;
				if (skeletons.length > 0) output.skeletons = skeletons;
				if (animations.length > 0) output.animations = animations;
				if (nodes.length > 0) output.nodes = nodes;
			}

			output.object = object;

			return output;

			// extract data from the cache hash
			// remove metadata on each item
			// and return as array
			function extractFromCache(cache) {

				var values = [];
				for (var key in cache) {

					var data = cache[key];
					delete data.metadata;
					values.push(data);
				}

				return values;
			}
		}
	}, {
		key: 'clone',
		value: function clone(recursive) {

			return new this.constructor().copy(this, recursive);
		}
	}, {
		key: 'copy',
		value: function copy(source) {
			var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


			this.name = source.name;

			this.up.copy(source.up);

			this.position.copy(source.position);
			this.rotation.order = source.rotation.order;
			this.quaternion.copy(source.quaternion);
			this.scale.copy(source.scale);

			this.matrix.copy(source.matrix);
			this.matrixWorld.copy(source.matrixWorld);

			this.matrixAutoUpdate = source.matrixAutoUpdate;
			this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;

			this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;

			this.layers.mask = source.layers.mask;
			this.visible = source.visible;

			this.castShadow = source.castShadow;
			this.receiveShadow = source.receiveShadow;

			this.frustumCulled = source.frustumCulled;
			this.renderOrder = source.renderOrder;

			this.userData = JSON.parse(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(source.userData));

			if (recursive === true) {

				for (var i = 0; i < source.children.length; i++) {

					var child = source.children[i];
					this.add(child.clone());
				}
			}

			return this;
		}
	}]);

	return Object3D;
}(EventDispatcher);

Object3D.DEFAULT_UP = /*@__PURE__*/new Vector3(0, 1, 0);
Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;

var _v0$1 = /*@__PURE__*/new Vector3();
var _v1$3 = /*@__PURE__*/new Vector3();
var _v2$2 = /*@__PURE__*/new Vector3();
var _v3$1 = /*@__PURE__*/new Vector3();

var _vab = /*@__PURE__*/new Vector3();
var _vac = /*@__PURE__*/new Vector3();
var _vbc = /*@__PURE__*/new Vector3();
var _vap = /*@__PURE__*/new Vector3();
var _vbp = /*@__PURE__*/new Vector3();
var _vcp = /*@__PURE__*/new Vector3();

var warnedGetUV = false;

var Triangle = function () {
	function Triangle() {
		var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
		var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Triangle);

		this.a = a;
		this.b = b;
		this.c = c;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Triangle, [{
		key: 'set',
		value: function set(a, b, c) {

			this.a.copy(a);
			this.b.copy(b);
			this.c.copy(c);

			return this;
		}
	}, {
		key: 'setFromPointsAndIndices',
		value: function setFromPointsAndIndices(points, i0, i1, i2) {

			this.a.copy(points[i0]);
			this.b.copy(points[i1]);
			this.c.copy(points[i2]);

			return this;
		}
	}, {
		key: 'setFromAttributeAndIndices',
		value: function setFromAttributeAndIndices(attribute, i0, i1, i2) {

			this.a.fromBufferAttribute(attribute, i0);
			this.b.fromBufferAttribute(attribute, i1);
			this.c.fromBufferAttribute(attribute, i2);

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(triangle) {

			this.a.copy(triangle.a);
			this.b.copy(triangle.b);
			this.c.copy(triangle.c);

			return this;
		}
	}, {
		key: 'getArea',
		value: function getArea() {

			_v0$1.subVectors(this.c, this.b);
			_v1$3.subVectors(this.a, this.b);

			return _v0$1.cross(_v1$3).length() * 0.5;
		}
	}, {
		key: 'getMidpoint',
		value: function getMidpoint(target) {

			return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
		}
	}, {
		key: 'getNormal',
		value: function getNormal(target) {

			return Triangle.getNormal(this.a, this.b, this.c, target);
		}
	}, {
		key: 'getPlane',
		value: function getPlane(target) {

			return target.setFromCoplanarPoints(this.a, this.b, this.c);
		}
	}, {
		key: 'getBarycoord',
		value: function getBarycoord(point, target) {

			return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
		}
	}, {
		key: 'getUV',
		value: function getUV(point, uv1, uv2, uv3, target) {
			// @deprecated, r151

			if (warnedGetUV === false) {

				console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');

				warnedGetUV = true;
			}

			return Triangle.getInterpolation(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
		}
	}, {
		key: 'getInterpolation',
		value: function getInterpolation(point, v1, v2, v3, target) {

			return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point) {

			return Triangle.containsPoint(point, this.a, this.b, this.c);
		}
	}, {
		key: 'isFrontFacing',
		value: function isFrontFacing(direction) {

			return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			return box.intersectsTriangle(this);
		}
	}, {
		key: 'closestPointToPoint',
		value: function closestPointToPoint(p, target) {

			var a = this.a,
			    b = this.b,
			    c = this.c;
			var v = void 0,
			    w = void 0;

			// algorithm thanks to Real-Time Collision Detection by Christer Ericson,
			// published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
			// under the accompanying license; see chapter 5.1.5 for detailed explanation.
			// basically, we're distinguishing which of the voronoi regions of the triangle
			// the point lies in with the minimum amount of redundant computation.

			_vab.subVectors(b, a);
			_vac.subVectors(c, a);
			_vap.subVectors(p, a);
			var d1 = _vab.dot(_vap);
			var d2 = _vac.dot(_vap);
			if (d1 <= 0 && d2 <= 0) {

				// vertex region of A; barycentric coords (1, 0, 0)
				return target.copy(a);
			}

			_vbp.subVectors(p, b);
			var d3 = _vab.dot(_vbp);
			var d4 = _vac.dot(_vbp);
			if (d3 >= 0 && d4 <= d3) {

				// vertex region of B; barycentric coords (0, 1, 0)
				return target.copy(b);
			}

			var vc = d1 * d4 - d3 * d2;
			if (vc <= 0 && d1 >= 0 && d3 <= 0) {

				v = d1 / (d1 - d3);
				// edge region of AB; barycentric coords (1-v, v, 0)
				return target.copy(a).addScaledVector(_vab, v);
			}

			_vcp.subVectors(p, c);
			var d5 = _vab.dot(_vcp);
			var d6 = _vac.dot(_vcp);
			if (d6 >= 0 && d5 <= d6) {

				// vertex region of C; barycentric coords (0, 0, 1)
				return target.copy(c);
			}

			var vb = d5 * d2 - d1 * d6;
			if (vb <= 0 && d2 >= 0 && d6 <= 0) {

				w = d2 / (d2 - d6);
				// edge region of AC; barycentric coords (1-w, 0, w)
				return target.copy(a).addScaledVector(_vac, w);
			}

			var va = d3 * d6 - d5 * d4;
			if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {

				_vbc.subVectors(c, b);
				w = (d4 - d3) / (d4 - d3 + (d5 - d6));
				// edge region of BC; barycentric coords (0, 1-w, w)
				return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
			}

			// face region
			var denom = 1 / (va + vb + vc);
			// u = va * denom
			v = vb * denom;
			w = vc * denom;

			return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
		}
	}, {
		key: 'equals',
		value: function equals(triangle) {

			return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
		}
	}], [{
		key: 'getNormal',
		value: function getNormal(a, b, c, target) {

			target.subVectors(c, b);
			_v0$1.subVectors(a, b);
			target.cross(_v0$1);

			var targetLengthSq = target.lengthSq();
			if (targetLengthSq > 0) {

				return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
			}

			return target.set(0, 0, 0);
		}

		// static/instance method to calculate barycentric coordinates
		// based on: http://www.blackpawn.com/texts/pointinpoly/default.html

	}, {
		key: 'getBarycoord',
		value: function getBarycoord(point, a, b, c, target) {

			_v0$1.subVectors(c, a);
			_v1$3.subVectors(b, a);
			_v2$2.subVectors(point, a);

			var dot00 = _v0$1.dot(_v0$1);
			var dot01 = _v0$1.dot(_v1$3);
			var dot02 = _v0$1.dot(_v2$2);
			var dot11 = _v1$3.dot(_v1$3);
			var dot12 = _v1$3.dot(_v2$2);

			var denom = dot00 * dot11 - dot01 * dot01;

			// collinear or singular triangle
			if (denom === 0) {

				// arbitrary location outside of triangle?
				// not sure if this is the best idea, maybe should be returning undefined
				return target.set(-2, -1, -1);
			}

			var invDenom = 1 / denom;
			var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
			var v = (dot00 * dot12 - dot01 * dot02) * invDenom;

			// barycentric coordinates must always sum to 1
			return target.set(1 - u - v, v, u);
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point, a, b, c) {

			this.getBarycoord(point, a, b, c, _v3$1);

			return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
		}
	}, {
		key: 'getUV',
		value: function getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
			// @deprecated, r151

			if (warnedGetUV === false) {

				console.warn('THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation().');

				warnedGetUV = true;
			}

			return this.getInterpolation(point, p1, p2, p3, uv1, uv2, uv3, target);
		}
	}, {
		key: 'getInterpolation',
		value: function getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {

			this.getBarycoord(point, p1, p2, p3, _v3$1);

			target.setScalar(0);
			target.addScaledVector(v1, _v3$1.x);
			target.addScaledVector(v2, _v3$1.y);
			target.addScaledVector(v3, _v3$1.z);

			return target;
		}
	}, {
		key: 'isFrontFacing',
		value: function isFrontFacing(a, b, c, direction) {

			_v0$1.subVectors(c, b);
			_v1$3.subVectors(a, b);

			// strictly front facing
			return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
		}
	}]);

	return Triangle;
}();

var materialId = 0;

var Material = function (_EventDispatcher4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Material, _EventDispatcher4);

	function Material() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Material);

		var _this10 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Material.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Material)).call(this));

		_this10.isMaterial = true;

		Object.defineProperty(_this10, 'id', { value: materialId++ });

		_this10.uuid = generateUUID();

		_this10.name = '';
		_this10.type = 'Material';

		_this10.blending = NormalBlending;
		_this10.side = FrontSide;
		_this10.vertexColors = false;

		_this10.opacity = 1;
		_this10.transparent = false;

		_this10.blendSrc = SrcAlphaFactor;
		_this10.blendDst = OneMinusSrcAlphaFactor;
		_this10.blendEquation = AddEquation;
		_this10.blendSrcAlpha = null;
		_this10.blendDstAlpha = null;
		_this10.blendEquationAlpha = null;

		_this10.depthFunc = LessEqualDepth;
		_this10.depthTest = true;
		_this10.depthWrite = true;

		_this10.stencilWriteMask = 0xff;
		_this10.stencilFunc = AlwaysStencilFunc;
		_this10.stencilRef = 0;
		_this10.stencilFuncMask = 0xff;
		_this10.stencilFail = KeepStencilOp;
		_this10.stencilZFail = KeepStencilOp;
		_this10.stencilZPass = KeepStencilOp;
		_this10.stencilWrite = false;

		_this10.clippingPlanes = null;
		_this10.clipIntersection = false;
		_this10.clipShadows = false;

		_this10.shadowSide = null;

		_this10.colorWrite = true;

		_this10.precision = null; // override the renderer's default precision for this material

		_this10.polygonOffset = false;
		_this10.polygonOffsetFactor = 0;
		_this10.polygonOffsetUnits = 0;

		_this10.dithering = false;

		_this10.alphaToCoverage = false;
		_this10.premultipliedAlpha = false;
		_this10.forceSinglePass = false;

		_this10.visible = true;

		_this10.toneMapped = true;

		_this10.userData = {};

		_this10.version = 0;

		_this10._alphaTest = 0;

		return _this10;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Material, [{
		key: 'onBuild',
		value: function onBuild() /* shaderobject, renderer */{}
	}, {
		key: 'onBeforeRender',
		value: function onBeforeRender() /* renderer, scene, camera, geometry, object, group */{}
	}, {
		key: 'onBeforeCompile',
		value: function onBeforeCompile() /* shaderobject, renderer */{}
	}, {
		key: 'customProgramCacheKey',
		value: function customProgramCacheKey() {

			return this.onBeforeCompile.toString();
		}
	}, {
		key: 'setValues',
		value: function setValues(values) {

			if (values === undefined) return;

			for (var key in values) {

				var newValue = values[key];

				if (newValue === undefined) {

					console.warn('THREE.Material: parameter \'' + key + '\' has value of undefined.');
					continue;
				}

				var currentValue = this[key];

				if (currentValue === undefined) {

					console.warn('THREE.Material: \'' + key + '\' is not a property of THREE.' + this.type + '.');
					continue;
				}

				if (currentValue && currentValue.isColor) {

					currentValue.set(newValue);
				} else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) {

					currentValue.copy(newValue);
				} else {

					this[key] = newValue;
				}
			}
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var isRootObject = meta === undefined || typeof meta === 'string';

			if (isRootObject) {

				meta = {
					textures: {},
					images: {}
				};
			}

			var data = {
				metadata: {
					version: 4.5,
					type: 'Material',
					generator: 'Material.toJSON'
				}
			};

			// standard Material serialization
			data.uuid = this.uuid;
			data.type = this.type;

			if (this.name !== '') data.name = this.name;

			if (this.color && this.color.isColor) data.color = this.color.getHex();

			if (this.roughness !== undefined) data.roughness = this.roughness;
			if (this.metalness !== undefined) data.metalness = this.metalness;

			if (this.sheen !== undefined) data.sheen = this.sheen;
			if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
			if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
			if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
			if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;

			if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
			if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
			if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
			if (this.shininess !== undefined) data.shininess = this.shininess;
			if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
			if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;

			if (this.clearcoatMap && this.clearcoatMap.isTexture) {

				data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
			}

			if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {

				data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
			}

			if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {

				data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
				data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
			}

			if (this.iridescence !== undefined) data.iridescence = this.iridescence;
			if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
			if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;

			if (this.iridescenceMap && this.iridescenceMap.isTexture) {

				data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
			}

			if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) {

				data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
			}

			if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
			if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
			if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;

			if (this.lightMap && this.lightMap.isTexture) {

				data.lightMap = this.lightMap.toJSON(meta).uuid;
				data.lightMapIntensity = this.lightMapIntensity;
			}

			if (this.aoMap && this.aoMap.isTexture) {

				data.aoMap = this.aoMap.toJSON(meta).uuid;
				data.aoMapIntensity = this.aoMapIntensity;
			}

			if (this.bumpMap && this.bumpMap.isTexture) {

				data.bumpMap = this.bumpMap.toJSON(meta).uuid;
				data.bumpScale = this.bumpScale;
			}

			if (this.normalMap && this.normalMap.isTexture) {

				data.normalMap = this.normalMap.toJSON(meta).uuid;
				data.normalMapType = this.normalMapType;
				data.normalScale = this.normalScale.toArray();
			}

			if (this.displacementMap && this.displacementMap.isTexture) {

				data.displacementMap = this.displacementMap.toJSON(meta).uuid;
				data.displacementScale = this.displacementScale;
				data.displacementBias = this.displacementBias;
			}

			if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
			if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;

			if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
			if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
			if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
			if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;

			if (this.envMap && this.envMap.isTexture) {

				data.envMap = this.envMap.toJSON(meta).uuid;

				if (this.combine !== undefined) data.combine = this.combine;
			}

			if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
			if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
			if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;

			if (this.gradientMap && this.gradientMap.isTexture) {

				data.gradientMap = this.gradientMap.toJSON(meta).uuid;
			}

			if (this.transmission !== undefined) data.transmission = this.transmission;
			if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
			if (this.thickness !== undefined) data.thickness = this.thickness;
			if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
			if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
			if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();

			if (this.size !== undefined) data.size = this.size;
			if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
			if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;

			if (this.blending !== NormalBlending) data.blending = this.blending;
			if (this.side !== FrontSide) data.side = this.side;
			if (this.vertexColors) data.vertexColors = true;

			if (this.opacity < 1) data.opacity = this.opacity;
			if (this.transparent === true) data.transparent = this.transparent;

			data.depthFunc = this.depthFunc;
			data.depthTest = this.depthTest;
			data.depthWrite = this.depthWrite;
			data.colorWrite = this.colorWrite;

			data.stencilWrite = this.stencilWrite;
			data.stencilWriteMask = this.stencilWriteMask;
			data.stencilFunc = this.stencilFunc;
			data.stencilRef = this.stencilRef;
			data.stencilFuncMask = this.stencilFuncMask;
			data.stencilFail = this.stencilFail;
			data.stencilZFail = this.stencilZFail;
			data.stencilZPass = this.stencilZPass;

			// rotation (SpriteMaterial)
			if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;

			if (this.polygonOffset === true) data.polygonOffset = true;
			if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
			if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;

			if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
			if (this.dashSize !== undefined) data.dashSize = this.dashSize;
			if (this.gapSize !== undefined) data.gapSize = this.gapSize;
			if (this.scale !== undefined) data.scale = this.scale;

			if (this.dithering === true) data.dithering = true;

			if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
			if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
			if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
			if (this.forceSinglePass === true) data.forceSinglePass = this.forceSinglePass;

			if (this.wireframe === true) data.wireframe = this.wireframe;
			if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
			if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
			if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;

			if (this.flatShading === true) data.flatShading = this.flatShading;

			if (this.visible === false) data.visible = false;

			if (this.toneMapped === false) data.toneMapped = false;

			if (this.fog === false) data.fog = false;

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(this.userData).length > 0) data.userData = this.userData;

			// TODO: Copied from Object3D.toJSON

			function extractFromCache(cache) {

				var values = [];

				for (var key in cache) {

					var _data2 = cache[key];
					delete _data2.metadata;
					values.push(_data2);
				}

				return values;
			}

			if (isRootObject) {

				var textures = extractFromCache(meta.textures);
				var images = extractFromCache(meta.images);

				if (textures.length > 0) data.textures = textures;
				if (images.length > 0) data.images = images;
			}

			return data;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.name = source.name;

			this.blending = source.blending;
			this.side = source.side;
			this.vertexColors = source.vertexColors;

			this.opacity = source.opacity;
			this.transparent = source.transparent;

			this.blendSrc = source.blendSrc;
			this.blendDst = source.blendDst;
			this.blendEquation = source.blendEquation;
			this.blendSrcAlpha = source.blendSrcAlpha;
			this.blendDstAlpha = source.blendDstAlpha;
			this.blendEquationAlpha = source.blendEquationAlpha;

			this.depthFunc = source.depthFunc;
			this.depthTest = source.depthTest;
			this.depthWrite = source.depthWrite;

			this.stencilWriteMask = source.stencilWriteMask;
			this.stencilFunc = source.stencilFunc;
			this.stencilRef = source.stencilRef;
			this.stencilFuncMask = source.stencilFuncMask;
			this.stencilFail = source.stencilFail;
			this.stencilZFail = source.stencilZFail;
			this.stencilZPass = source.stencilZPass;
			this.stencilWrite = source.stencilWrite;

			var srcPlanes = source.clippingPlanes;
			var dstPlanes = null;

			if (srcPlanes !== null) {

				var n = srcPlanes.length;
				dstPlanes = new Array(n);

				for (var i = 0; i !== n; ++i) {

					dstPlanes[i] = srcPlanes[i].clone();
				}
			}

			this.clippingPlanes = dstPlanes;
			this.clipIntersection = source.clipIntersection;
			this.clipShadows = source.clipShadows;

			this.shadowSide = source.shadowSide;

			this.colorWrite = source.colorWrite;

			this.precision = source.precision;

			this.polygonOffset = source.polygonOffset;
			this.polygonOffsetFactor = source.polygonOffsetFactor;
			this.polygonOffsetUnits = source.polygonOffsetUnits;

			this.dithering = source.dithering;

			this.alphaTest = source.alphaTest;
			this.alphaToCoverage = source.alphaToCoverage;
			this.premultipliedAlpha = source.premultipliedAlpha;
			this.forceSinglePass = source.forceSinglePass;

			this.visible = source.visible;

			this.toneMapped = source.toneMapped;

			this.userData = JSON.parse(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(source.userData));

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });
		}
	}, {
		key: 'alphaTest',
		get: function get() {

			return this._alphaTest;
		},
		set: function set(value) {

			if (this._alphaTest > 0 !== value > 0) {

				this.version++;
			}

			this._alphaTest = value;
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) this.version++;
		}
	}]);

	return Material;
}(EventDispatcher);

var _colorKeywords = { 'aliceblue': 0xF0F8FF, 'antiquewhite': 0xFAEBD7, 'aqua': 0x00FFFF, 'aquamarine': 0x7FFFD4, 'azure': 0xF0FFFF,
	'beige': 0xF5F5DC, 'bisque': 0xFFE4C4, 'black': 0x000000, 'blanchedalmond': 0xFFEBCD, 'blue': 0x0000FF, 'blueviolet': 0x8A2BE2,
	'brown': 0xA52A2A, 'burlywood': 0xDEB887, 'cadetblue': 0x5F9EA0, 'chartreuse': 0x7FFF00, 'chocolate': 0xD2691E, 'coral': 0xFF7F50,
	'cornflowerblue': 0x6495ED, 'cornsilk': 0xFFF8DC, 'crimson': 0xDC143C, 'cyan': 0x00FFFF, 'darkblue': 0x00008B, 'darkcyan': 0x008B8B,
	'darkgoldenrod': 0xB8860B, 'darkgray': 0xA9A9A9, 'darkgreen': 0x006400, 'darkgrey': 0xA9A9A9, 'darkkhaki': 0xBDB76B, 'darkmagenta': 0x8B008B,
	'darkolivegreen': 0x556B2F, 'darkorange': 0xFF8C00, 'darkorchid': 0x9932CC, 'darkred': 0x8B0000, 'darksalmon': 0xE9967A, 'darkseagreen': 0x8FBC8F,
	'darkslateblue': 0x483D8B, 'darkslategray': 0x2F4F4F, 'darkslategrey': 0x2F4F4F, 'darkturquoise': 0x00CED1, 'darkviolet': 0x9400D3,
	'deeppink': 0xFF1493, 'deepskyblue': 0x00BFFF, 'dimgray': 0x696969, 'dimgrey': 0x696969, 'dodgerblue': 0x1E90FF, 'firebrick': 0xB22222,
	'floralwhite': 0xFFFAF0, 'forestgreen': 0x228B22, 'fuchsia': 0xFF00FF, 'gainsboro': 0xDCDCDC, 'ghostwhite': 0xF8F8FF, 'gold': 0xFFD700,
	'goldenrod': 0xDAA520, 'gray': 0x808080, 'green': 0x008000, 'greenyellow': 0xADFF2F, 'grey': 0x808080, 'honeydew': 0xF0FFF0, 'hotpink': 0xFF69B4,
	'indianred': 0xCD5C5C, 'indigo': 0x4B0082, 'ivory': 0xFFFFF0, 'khaki': 0xF0E68C, 'lavender': 0xE6E6FA, 'lavenderblush': 0xFFF0F5, 'lawngreen': 0x7CFC00,
	'lemonchiffon': 0xFFFACD, 'lightblue': 0xADD8E6, 'lightcoral': 0xF08080, 'lightcyan': 0xE0FFFF, 'lightgoldenrodyellow': 0xFAFAD2, 'lightgray': 0xD3D3D3,
	'lightgreen': 0x90EE90, 'lightgrey': 0xD3D3D3, 'lightpink': 0xFFB6C1, 'lightsalmon': 0xFFA07A, 'lightseagreen': 0x20B2AA, 'lightskyblue': 0x87CEFA,
	'lightslategray': 0x778899, 'lightslategrey': 0x778899, 'lightsteelblue': 0xB0C4DE, 'lightyellow': 0xFFFFE0, 'lime': 0x00FF00, 'limegreen': 0x32CD32,
	'linen': 0xFAF0E6, 'magenta': 0xFF00FF, 'maroon': 0x800000, 'mediumaquamarine': 0x66CDAA, 'mediumblue': 0x0000CD, 'mediumorchid': 0xBA55D3,
	'mediumpurple': 0x9370DB, 'mediumseagreen': 0x3CB371, 'mediumslateblue': 0x7B68EE, 'mediumspringgreen': 0x00FA9A, 'mediumturquoise': 0x48D1CC,
	'mediumvioletred': 0xC71585, 'midnightblue': 0x191970, 'mintcream': 0xF5FFFA, 'mistyrose': 0xFFE4E1, 'moccasin': 0xFFE4B5, 'navajowhite': 0xFFDEAD,
	'navy': 0x000080, 'oldlace': 0xFDF5E6, 'olive': 0x808000, 'olivedrab': 0x6B8E23, 'orange': 0xFFA500, 'orangered': 0xFF4500, 'orchid': 0xDA70D6,
	'palegoldenrod': 0xEEE8AA, 'palegreen': 0x98FB98, 'paleturquoise': 0xAFEEEE, 'palevioletred': 0xDB7093, 'papayawhip': 0xFFEFD5, 'peachpuff': 0xFFDAB9,
	'peru': 0xCD853F, 'pink': 0xFFC0CB, 'plum': 0xDDA0DD, 'powderblue': 0xB0E0E6, 'purple': 0x800080, 'rebeccapurple': 0x663399, 'red': 0xFF0000, 'rosybrown': 0xBC8F8F,
	'royalblue': 0x4169E1, 'saddlebrown': 0x8B4513, 'salmon': 0xFA8072, 'sandybrown': 0xF4A460, 'seagreen': 0x2E8B57, 'seashell': 0xFFF5EE,
	'sienna': 0xA0522D, 'silver': 0xC0C0C0, 'skyblue': 0x87CEEB, 'slateblue': 0x6A5ACD, 'slategray': 0x708090, 'slategrey': 0x708090, 'snow': 0xFFFAFA,
	'springgreen': 0x00FF7F, 'steelblue': 0x4682B4, 'tan': 0xD2B48C, 'teal': 0x008080, 'thistle': 0xD8BFD8, 'tomato': 0xFF6347, 'turquoise': 0x40E0D0,
	'violet': 0xEE82EE, 'wheat': 0xF5DEB3, 'white': 0xFFFFFF, 'whitesmoke': 0xF5F5F5, 'yellow': 0xFFFF00, 'yellowgreen': 0x9ACD32 };

var _hslA = { h: 0, s: 0, l: 0 };
var _hslB = { h: 0, s: 0, l: 0 };

function hue2rgb(p, q, t) {

	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
	return p;
}

var Color = function () {
	function Color(r, g, b) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Color);

		this.isColor = true;

		this.r = 1;
		this.g = 1;
		this.b = 1;

		if (g === undefined && b === undefined) {

			// r is THREE.Color, hex or string
			return this.set(r);
		}

		return this.setRGB(r, g, b);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Color, [{
		key: 'set',
		value: function set(value) {

			if (value && value.isColor) {

				this.copy(value);
			} else if (typeof value === 'number') {

				this.setHex(value);
			} else if (typeof value === 'string') {

				this.setStyle(value);
			}

			return this;
		}
	}, {
		key: 'setScalar',
		value: function setScalar(scalar) {

			this.r = scalar;
			this.g = scalar;
			this.b = scalar;

			return this;
		}
	}, {
		key: 'setHex',
		value: function setHex(hex) {
			var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;


			hex = Math.floor(hex);

			this.r = (hex >> 16 & 255) / 255;
			this.g = (hex >> 8 & 255) / 255;
			this.b = (hex & 255) / 255;

			ColorManagement.toWorkingColorSpace(this, colorSpace);

			return this;
		}
	}, {
		key: 'setRGB',
		value: function setRGB(r, g, b) {
			var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ColorManagement.workingColorSpace;


			this.r = r;
			this.g = g;
			this.b = b;

			ColorManagement.toWorkingColorSpace(this, colorSpace);

			return this;
		}
	}, {
		key: 'setHSL',
		value: function setHSL(h, s, l) {
			var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ColorManagement.workingColorSpace;


			// h,s,l ranges are in 0.0 - 1.0
			h = euclideanModulo(h, 1);
			s = clamp(s, 0, 1);
			l = clamp(l, 0, 1);

			if (s === 0) {

				this.r = this.g = this.b = l;
			} else {

				var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
				var q = 2 * l - p;

				this.r = hue2rgb(q, p, h + 1 / 3);
				this.g = hue2rgb(q, p, h);
				this.b = hue2rgb(q, p, h - 1 / 3);
			}

			ColorManagement.toWorkingColorSpace(this, colorSpace);

			return this;
		}
	}, {
		key: 'setStyle',
		value: function setStyle(style) {
			var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;


			function handleAlpha(string) {

				if (string === undefined) return;

				if (parseFloat(string) < 1) {

					console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
				}
			}

			var m = void 0;

			if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {

				// rgb / hsl

				var color = void 0;
				var name = m[1];
				var components = m[2];

				switch (name) {

					case 'rgb':
					case 'rgba':

						if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {

							// rgb(255,0,0) rgba(255,0,0,0.5)
							this.r = Math.min(255, parseInt(color[1], 10)) / 255;
							this.g = Math.min(255, parseInt(color[2], 10)) / 255;
							this.b = Math.min(255, parseInt(color[3], 10)) / 255;

							ColorManagement.toWorkingColorSpace(this, colorSpace);

							handleAlpha(color[4]);

							return this;
						}

						if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {

							// rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
							this.r = Math.min(100, parseInt(color[1], 10)) / 100;
							this.g = Math.min(100, parseInt(color[2], 10)) / 100;
							this.b = Math.min(100, parseInt(color[3], 10)) / 100;

							ColorManagement.toWorkingColorSpace(this, colorSpace);

							handleAlpha(color[4]);

							return this;
						}

						break;

					case 'hsl':
					case 'hsla':

						if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {

							// hsl(120,50%,50%) hsla(120,50%,50%,0.5)
							var h = parseFloat(color[1]) / 360;
							var s = parseFloat(color[2]) / 100;
							var l = parseFloat(color[3]) / 100;

							handleAlpha(color[4]);

							return this.setHSL(h, s, l, colorSpace);
						}

						break;

					default:

						console.warn('THREE.Color: Unknown color model ' + style);

				}
			} else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {

				// hex color

				var hex = m[1];
				var size = hex.length;

				if (size === 3) {

					// #ff0
					return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
				} else if (size === 6) {

					// #ff0000
					return this.setHex(parseInt(hex, 16), colorSpace);
				} else {

					console.warn('THREE.Color: Invalid hex color ' + style);
				}
			} else if (style && style.length > 0) {

				return this.setColorName(style, colorSpace);
			}

			return this;
		}
	}, {
		key: 'setColorName',
		value: function setColorName(style) {
			var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;


			// color keywords
			var hex = _colorKeywords[style.toLowerCase()];

			if (hex !== undefined) {

				// red
				this.setHex(hex, colorSpace);
			} else {

				// unknown color
				console.warn('THREE.Color: Unknown color ' + style);
			}

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.r, this.g, this.b);
		}
	}, {
		key: 'copy',
		value: function copy(color) {

			this.r = color.r;
			this.g = color.g;
			this.b = color.b;

			return this;
		}
	}, {
		key: 'copySRGBToLinear',
		value: function copySRGBToLinear(color) {

			this.r = SRGBToLinear(color.r);
			this.g = SRGBToLinear(color.g);
			this.b = SRGBToLinear(color.b);

			return this;
		}
	}, {
		key: 'copyLinearToSRGB',
		value: function copyLinearToSRGB(color) {

			this.r = LinearToSRGB(color.r);
			this.g = LinearToSRGB(color.g);
			this.b = LinearToSRGB(color.b);

			return this;
		}
	}, {
		key: 'convertSRGBToLinear',
		value: function convertSRGBToLinear() {

			this.copySRGBToLinear(this);

			return this;
		}
	}, {
		key: 'convertLinearToSRGB',
		value: function convertLinearToSRGB() {

			this.copyLinearToSRGB(this);

			return this;
		}
	}, {
		key: 'getHex',
		value: function getHex() {
			var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;


			ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);

			return clamp(_color.r * 255, 0, 255) << 16 ^ clamp(_color.g * 255, 0, 255) << 8 ^ clamp(_color.b * 255, 0, 255) << 0;
		}
	}, {
		key: 'getHexString',
		value: function getHexString() {
			var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;


			return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
		}
	}, {
		key: 'getHSL',
		value: function getHSL(target) {
			var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ColorManagement.workingColorSpace;


			// h,s,l ranges are in 0.0 - 1.0

			ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);

			var r = _color.r,
			    g = _color.g,
			    b = _color.b;

			var max = Math.max(r, g, b);
			var min = Math.min(r, g, b);

			var hue = void 0,
			    saturation = void 0;
			var lightness = (min + max) / 2.0;

			if (min === max) {

				hue = 0;
				saturation = 0;
			} else {

				var delta = max - min;

				saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);

				switch (max) {

					case r:
						hue = (g - b) / delta + (g < b ? 6 : 0);break;
					case g:
						hue = (b - r) / delta + 2;break;
					case b:
						hue = (r - g) / delta + 4;break;

				}

				hue /= 6;
			}

			target.h = hue;
			target.s = saturation;
			target.l = lightness;

			return target;
		}
	}, {
		key: 'getRGB',
		value: function getRGB(target) {
			var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ColorManagement.workingColorSpace;


			ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);

			target.r = _color.r;
			target.g = _color.g;
			target.b = _color.b;

			return target;
		}
	}, {
		key: 'getStyle',
		value: function getStyle() {
			var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;


			ColorManagement.fromWorkingColorSpace(_color.copy(this), colorSpace);

			var r = _color.r,
			    g = _color.g,
			    b = _color.b;

			if (colorSpace !== SRGBColorSpace) {

				// Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
				return 'color(' + colorSpace + ' ' + r.toFixed(3) + ' ' + g.toFixed(3) + ' ' + b.toFixed(3) + ')';
			}

			return 'rgb(' + (r * 255 | 0) + ',' + (g * 255 | 0) + ',' + (b * 255 | 0) + ')';
		}
	}, {
		key: 'offsetHSL',
		value: function offsetHSL(h, s, l) {

			this.getHSL(_hslA);

			_hslA.h += h;_hslA.s += s;_hslA.l += l;

			this.setHSL(_hslA.h, _hslA.s, _hslA.l);

			return this;
		}
	}, {
		key: 'add',
		value: function add(color) {

			this.r += color.r;
			this.g += color.g;
			this.b += color.b;

			return this;
		}
	}, {
		key: 'addColors',
		value: function addColors(color1, color2) {

			this.r = color1.r + color2.r;
			this.g = color1.g + color2.g;
			this.b = color1.b + color2.b;

			return this;
		}
	}, {
		key: 'addScalar',
		value: function addScalar(s) {

			this.r += s;
			this.g += s;
			this.b += s;

			return this;
		}
	}, {
		key: 'sub',
		value: function sub(color) {

			this.r = Math.max(0, this.r - color.r);
			this.g = Math.max(0, this.g - color.g);
			this.b = Math.max(0, this.b - color.b);

			return this;
		}
	}, {
		key: 'multiply',
		value: function multiply(color) {

			this.r *= color.r;
			this.g *= color.g;
			this.b *= color.b;

			return this;
		}
	}, {
		key: 'multiplyScalar',
		value: function multiplyScalar(s) {

			this.r *= s;
			this.g *= s;
			this.b *= s;

			return this;
		}
	}, {
		key: 'lerp',
		value: function lerp(color, alpha) {

			this.r += (color.r - this.r) * alpha;
			this.g += (color.g - this.g) * alpha;
			this.b += (color.b - this.b) * alpha;

			return this;
		}
	}, {
		key: 'lerpColors',
		value: function lerpColors(color1, color2, alpha) {

			this.r = color1.r + (color2.r - color1.r) * alpha;
			this.g = color1.g + (color2.g - color1.g) * alpha;
			this.b = color1.b + (color2.b - color1.b) * alpha;

			return this;
		}
	}, {
		key: 'lerpHSL',
		value: function lerpHSL(color, alpha) {

			this.getHSL(_hslA);
			color.getHSL(_hslB);

			var h = lerp(_hslA.h, _hslB.h, alpha);
			var s = lerp(_hslA.s, _hslB.s, alpha);
			var l = lerp(_hslA.l, _hslB.l, alpha);

			this.setHSL(h, s, l);

			return this;
		}
	}, {
		key: 'setFromVector3',
		value: function setFromVector3(v) {

			this.r = v.x;
			this.g = v.y;
			this.b = v.z;

			return this;
		}
	}, {
		key: 'applyMatrix3',
		value: function applyMatrix3(m) {

			var r = this.r,
			    g = this.g,
			    b = this.b;
			var e = m.elements;

			this.r = e[0] * r + e[3] * g + e[6] * b;
			this.g = e[1] * r + e[4] * g + e[7] * b;
			this.b = e[2] * r + e[5] * g + e[8] * b;

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(c) {

			return c.r === this.r && c.g === this.g && c.b === this.b;
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this.r = array[offset];
			this.g = array[offset + 1];
			this.b = array[offset + 2];

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			array[offset] = this.r;
			array[offset + 1] = this.g;
			array[offset + 2] = this.b;

			return array;
		}
	}, {
		key: 'fromBufferAttribute',
		value: function fromBufferAttribute(attribute, index) {

			this.r = attribute.getX(index);
			this.g = attribute.getY(index);
			this.b = attribute.getZ(index);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			return this.getHex();
		}
	}, {
		key: __WEBPACK_IMPORTED_MODULE_25_babel_runtime_core_js_symbol_iterator___default.a,
		value: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function value() {
			return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function value$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return this.r;

						case 2:
							_context7.next = 4;
							return this.g;

						case 4:
							_context7.next = 6;
							return this.b;

						case 6:
						case 'end':
							return _context7.stop();
					}
				}
			}, value, this);
		})
	}]);

	return Color;
}();

var _color = /*@__PURE__*/new Color();

Color.NAMES = _colorKeywords;

var MeshBasicMaterial = function (_Material) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshBasicMaterial, _Material);

	function MeshBasicMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshBasicMaterial);

		var _this11 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshBasicMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshBasicMaterial)).call(this));

		_this11.isMeshBasicMaterial = true;

		_this11.type = 'MeshBasicMaterial';

		_this11.color = new Color(0xffffff); // emissive

		_this11.map = null;

		_this11.lightMap = null;
		_this11.lightMapIntensity = 1.0;

		_this11.aoMap = null;
		_this11.aoMapIntensity = 1.0;

		_this11.specularMap = null;

		_this11.alphaMap = null;

		_this11.envMap = null;
		_this11.combine = MultiplyOperation;
		_this11.reflectivity = 1;
		_this11.refractionRatio = 0.98;

		_this11.wireframe = false;
		_this11.wireframeLinewidth = 1;
		_this11.wireframeLinecap = 'round';
		_this11.wireframeLinejoin = 'round';

		_this11.fog = true;

		_this11.setValues(parameters);

		return _this11;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshBasicMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshBasicMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshBasicMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;

			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;

			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;

			this.specularMap = source.specularMap;

			this.alphaMap = source.alphaMap;

			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshBasicMaterial;
}(Material);

// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf

var _tables = /*@__PURE__*/_generateTables();

function _generateTables() {

	// float32 to float16 helpers

	var buffer = new ArrayBuffer(4);
	var floatView = new Float32Array(buffer);
	var uint32View = new Uint32Array(buffer);

	var baseTable = new Uint32Array(512);
	var shiftTable = new Uint32Array(512);

	for (var i = 0; i < 256; ++i) {

		var e = i - 127;

		// very small number (0, -0)

		if (e < -27) {

			baseTable[i] = 0x0000;
			baseTable[i | 0x100] = 0x8000;
			shiftTable[i] = 24;
			shiftTable[i | 0x100] = 24;

			// small number (denorm)
		} else if (e < -14) {

			baseTable[i] = 0x0400 >> -e - 14;
			baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
			shiftTable[i] = -e - 1;
			shiftTable[i | 0x100] = -e - 1;

			// normal number
		} else if (e <= 15) {

			baseTable[i] = e + 15 << 10;
			baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
			shiftTable[i] = 13;
			shiftTable[i | 0x100] = 13;

			// large number (Infinity, -Infinity)
		} else if (e < 128) {

			baseTable[i] = 0x7c00;
			baseTable[i | 0x100] = 0xfc00;
			shiftTable[i] = 24;
			shiftTable[i | 0x100] = 24;

			// stay (NaN, Infinity, -Infinity)
		} else {

			baseTable[i] = 0x7c00;
			baseTable[i | 0x100] = 0xfc00;
			shiftTable[i] = 13;
			shiftTable[i | 0x100] = 13;
		}
	}

	// float16 to float32 helpers

	var mantissaTable = new Uint32Array(2048);
	var exponentTable = new Uint32Array(64);
	var offsetTable = new Uint32Array(64);

	for (var _i6 = 1; _i6 < 1024; ++_i6) {

		var m = _i6 << 13; // zero pad mantissa bits
		var _e = 0; // zero exponent

		// normalized
		while ((m & 0x00800000) === 0) {

			m <<= 1;
			_e -= 0x00800000; // decrement exponent
		}

		m &= ~0x00800000; // clear leading 1 bit
		_e += 0x38800000; // adjust bias

		mantissaTable[_i6] = m | _e;
	}

	for (var _i7 = 1024; _i7 < 2048; ++_i7) {

		mantissaTable[_i7] = 0x38000000 + (_i7 - 1024 << 13);
	}

	for (var _i8 = 1; _i8 < 31; ++_i8) {

		exponentTable[_i8] = _i8 << 23;
	}

	exponentTable[31] = 0x47800000;
	exponentTable[32] = 0x80000000;

	for (var _i9 = 33; _i9 < 63; ++_i9) {

		exponentTable[_i9] = 0x80000000 + (_i9 - 32 << 23);
	}

	exponentTable[63] = 0xc7800000;

	for (var _i10 = 1; _i10 < 64; ++_i10) {

		if (_i10 !== 32) {

			offsetTable[_i10] = 1024;
		}
	}

	return {
		floatView: floatView,
		uint32View: uint32View,
		baseTable: baseTable,
		shiftTable: shiftTable,
		mantissaTable: mantissaTable,
		exponentTable: exponentTable,
		offsetTable: offsetTable
	};
}

// float32 to float16

function toHalfFloat(val) {

	if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');

	val = clamp(val, -65504, 65504);

	_tables.floatView[0] = val;
	var f = _tables.uint32View[0];
	var e = f >> 23 & 0x1ff;
	return _tables.baseTable[e] + ((f & 0x007fffff) >> _tables.shiftTable[e]);
}

// float16 to float32

function fromHalfFloat(val) {

	var m = val >> 10;
	_tables.uint32View[0] = _tables.mantissaTable[_tables.offsetTable[m] + (val & 0x3ff)] + _tables.exponentTable[m];
	return _tables.floatView[0];
}

var DataUtils = {
	toHalfFloat: toHalfFloat,
	fromHalfFloat: fromHalfFloat
};

var _vector$8 = /*@__PURE__*/new Vector3();
var _vector2$1 = /*@__PURE__*/new Vector2();

var BufferAttribute = function () {
	function BufferAttribute(array, itemSize) {
		var normalized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BufferAttribute);

		if (Array.isArray(array)) {

			throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
		}

		this.isBufferAttribute = true;

		this.name = '';

		this.array = array;
		this.itemSize = itemSize;
		this.count = array !== undefined ? array.length / itemSize : 0;
		this.normalized = normalized;

		this.usage = StaticDrawUsage;
		this.updateRange = { offset: 0, count: -1 };

		this.version = 0;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(BufferAttribute, [{
		key: 'onUploadCallback',
		value: function onUploadCallback() {}
	}, {
		key: 'setUsage',
		value: function setUsage(value) {

			this.usage = value;

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.name = source.name;
			this.array = new source.array.constructor(source.array);
			this.itemSize = source.itemSize;
			this.count = source.count;
			this.normalized = source.normalized;

			this.usage = source.usage;

			return this;
		}
	}, {
		key: 'copyAt',
		value: function copyAt(index1, attribute, index2) {

			index1 *= this.itemSize;
			index2 *= attribute.itemSize;

			for (var i = 0, l = this.itemSize; i < l; i++) {

				this.array[index1 + i] = attribute.array[index2 + i];
			}

			return this;
		}
	}, {
		key: 'copyArray',
		value: function copyArray(array) {

			this.array.set(array);

			return this;
		}
	}, {
		key: 'applyMatrix3',
		value: function applyMatrix3(m) {

			if (this.itemSize === 2) {

				for (var i = 0, l = this.count; i < l; i++) {

					_vector2$1.fromBufferAttribute(this, i);
					_vector2$1.applyMatrix3(m);

					this.setXY(i, _vector2$1.x, _vector2$1.y);
				}
			} else if (this.itemSize === 3) {

				for (var _i11 = 0, _l3 = this.count; _i11 < _l3; _i11++) {

					_vector$8.fromBufferAttribute(this, _i11);
					_vector$8.applyMatrix3(m);

					this.setXYZ(_i11, _vector$8.x, _vector$8.y, _vector$8.z);
				}
			}

			return this;
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(m) {

			for (var i = 0, l = this.count; i < l; i++) {

				_vector$8.fromBufferAttribute(this, i);

				_vector$8.applyMatrix4(m);

				this.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
			}

			return this;
		}
	}, {
		key: 'applyNormalMatrix',
		value: function applyNormalMatrix(m) {

			for (var i = 0, l = this.count; i < l; i++) {

				_vector$8.fromBufferAttribute(this, i);

				_vector$8.applyNormalMatrix(m);

				this.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
			}

			return this;
		}
	}, {
		key: 'transformDirection',
		value: function transformDirection(m) {

			for (var i = 0, l = this.count; i < l; i++) {

				_vector$8.fromBufferAttribute(this, i);

				_vector$8.transformDirection(m);

				this.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
			}

			return this;
		}
	}, {
		key: 'set',
		value: function set(value) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			// Matching BufferAttribute constructor, do not normalize the array.
			this.array.set(value, offset);

			return this;
		}
	}, {
		key: 'getX',
		value: function getX(index) {

			var x = this.array[index * this.itemSize];

			if (this.normalized) x = denormalize(x, this.array);

			return x;
		}
	}, {
		key: 'setX',
		value: function setX(index, x) {

			if (this.normalized) x = normalize(x, this.array);

			this.array[index * this.itemSize] = x;

			return this;
		}
	}, {
		key: 'getY',
		value: function getY(index) {

			var y = this.array[index * this.itemSize + 1];

			if (this.normalized) y = denormalize(y, this.array);

			return y;
		}
	}, {
		key: 'setY',
		value: function setY(index, y) {

			if (this.normalized) y = normalize(y, this.array);

			this.array[index * this.itemSize + 1] = y;

			return this;
		}
	}, {
		key: 'getZ',
		value: function getZ(index) {

			var z = this.array[index * this.itemSize + 2];

			if (this.normalized) z = denormalize(z, this.array);

			return z;
		}
	}, {
		key: 'setZ',
		value: function setZ(index, z) {

			if (this.normalized) z = normalize(z, this.array);

			this.array[index * this.itemSize + 2] = z;

			return this;
		}
	}, {
		key: 'getW',
		value: function getW(index) {

			var w = this.array[index * this.itemSize + 3];

			if (this.normalized) w = denormalize(w, this.array);

			return w;
		}
	}, {
		key: 'setW',
		value: function setW(index, w) {

			if (this.normalized) w = normalize(w, this.array);

			this.array[index * this.itemSize + 3] = w;

			return this;
		}
	}, {
		key: 'setXY',
		value: function setXY(index, x, y) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
			}

			this.array[index + 0] = x;
			this.array[index + 1] = y;

			return this;
		}
	}, {
		key: 'setXYZ',
		value: function setXYZ(index, x, y, z) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
			}

			this.array[index + 0] = x;
			this.array[index + 1] = y;
			this.array[index + 2] = z;

			return this;
		}
	}, {
		key: 'setXYZW',
		value: function setXYZW(index, x, y, z, w) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
				w = normalize(w, this.array);
			}

			this.array[index + 0] = x;
			this.array[index + 1] = y;
			this.array[index + 2] = z;
			this.array[index + 3] = w;

			return this;
		}
	}, {
		key: 'onUpload',
		value: function onUpload(callback) {

			this.onUploadCallback = callback;

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.array, this.itemSize).copy(this);
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = {
				itemSize: this.itemSize,
				type: this.array.constructor.name,
				array: __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from___default()(this.array),
				normalized: this.normalized
			};

			if (this.name !== '') data.name = this.name;
			if (this.usage !== StaticDrawUsage) data.usage = this.usage;
			if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;

			return data;
		}
	}, {
		key: 'copyColorsArray',
		value: function copyColorsArray() {
			// @deprecated, r144

			console.error('THREE.BufferAttribute: copyColorsArray() was removed in r144.');
		}
	}, {
		key: 'copyVector2sArray',
		value: function copyVector2sArray() {
			// @deprecated, r144

			console.error('THREE.BufferAttribute: copyVector2sArray() was removed in r144.');
		}
	}, {
		key: 'copyVector3sArray',
		value: function copyVector3sArray() {
			// @deprecated, r144

			console.error('THREE.BufferAttribute: copyVector3sArray() was removed in r144.');
		}
	}, {
		key: 'copyVector4sArray',
		value: function copyVector4sArray() {
			// @deprecated, r144

			console.error('THREE.BufferAttribute: copyVector4sArray() was removed in r144.');
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) this.version++;
		}
	}]);

	return BufferAttribute;
}();

//

var Int8BufferAttribute = function (_BufferAttribute) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Int8BufferAttribute, _BufferAttribute);

	function Int8BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Int8BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Int8BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Int8BufferAttribute)).call(this, new Int8Array(array), itemSize, normalized));
	}

	return Int8BufferAttribute;
}(BufferAttribute);

var Uint8BufferAttribute = function (_BufferAttribute2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Uint8BufferAttribute, _BufferAttribute2);

	function Uint8BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Uint8BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Uint8BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Uint8BufferAttribute)).call(this, new Uint8Array(array), itemSize, normalized));
	}

	return Uint8BufferAttribute;
}(BufferAttribute);

var Uint8ClampedBufferAttribute = function (_BufferAttribute3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Uint8ClampedBufferAttribute, _BufferAttribute3);

	function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Uint8ClampedBufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Uint8ClampedBufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Uint8ClampedBufferAttribute)).call(this, new Uint8ClampedArray(array), itemSize, normalized));
	}

	return Uint8ClampedBufferAttribute;
}(BufferAttribute);

var Int16BufferAttribute = function (_BufferAttribute4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Int16BufferAttribute, _BufferAttribute4);

	function Int16BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Int16BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Int16BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Int16BufferAttribute)).call(this, new Int16Array(array), itemSize, normalized));
	}

	return Int16BufferAttribute;
}(BufferAttribute);

var Uint16BufferAttribute = function (_BufferAttribute5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Uint16BufferAttribute, _BufferAttribute5);

	function Uint16BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Uint16BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Uint16BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Uint16BufferAttribute)).call(this, new Uint16Array(array), itemSize, normalized));
	}

	return Uint16BufferAttribute;
}(BufferAttribute);

var Int32BufferAttribute = function (_BufferAttribute6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Int32BufferAttribute, _BufferAttribute6);

	function Int32BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Int32BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Int32BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Int32BufferAttribute)).call(this, new Int32Array(array), itemSize, normalized));
	}

	return Int32BufferAttribute;
}(BufferAttribute);

var Uint32BufferAttribute = function (_BufferAttribute7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Uint32BufferAttribute, _BufferAttribute7);

	function Uint32BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Uint32BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Uint32BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Uint32BufferAttribute)).call(this, new Uint32Array(array), itemSize, normalized));
	}

	return Uint32BufferAttribute;
}(BufferAttribute);

var Float16BufferAttribute = function (_BufferAttribute8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Float16BufferAttribute, _BufferAttribute8);

	function Float16BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Float16BufferAttribute);

		var _this19 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Float16BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Float16BufferAttribute)).call(this, new Uint16Array(array), itemSize, normalized));

		_this19.isFloat16BufferAttribute = true;

		return _this19;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Float16BufferAttribute, [{
		key: 'getX',
		value: function getX(index) {

			var x = fromHalfFloat(this.array[index * this.itemSize]);

			if (this.normalized) x = denormalize(x, this.array);

			return x;
		}
	}, {
		key: 'setX',
		value: function setX(index, x) {

			if (this.normalized) x = normalize(x, this.array);

			this.array[index * this.itemSize] = toHalfFloat(x);

			return this;
		}
	}, {
		key: 'getY',
		value: function getY(index) {

			var y = fromHalfFloat(this.array[index * this.itemSize + 1]);

			if (this.normalized) y = denormalize(y, this.array);

			return y;
		}
	}, {
		key: 'setY',
		value: function setY(index, y) {

			if (this.normalized) y = normalize(y, this.array);

			this.array[index * this.itemSize + 1] = toHalfFloat(y);

			return this;
		}
	}, {
		key: 'getZ',
		value: function getZ(index) {

			var z = fromHalfFloat(this.array[index * this.itemSize + 2]);

			if (this.normalized) z = denormalize(z, this.array);

			return z;
		}
	}, {
		key: 'setZ',
		value: function setZ(index, z) {

			if (this.normalized) z = normalize(z, this.array);

			this.array[index * this.itemSize + 2] = toHalfFloat(z);

			return this;
		}
	}, {
		key: 'getW',
		value: function getW(index) {

			var w = fromHalfFloat(this.array[index * this.itemSize + 3]);

			if (this.normalized) w = denormalize(w, this.array);

			return w;
		}
	}, {
		key: 'setW',
		value: function setW(index, w) {

			if (this.normalized) w = normalize(w, this.array);

			this.array[index * this.itemSize + 3] = toHalfFloat(w);

			return this;
		}
	}, {
		key: 'setXY',
		value: function setXY(index, x, y) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
			}

			this.array[index + 0] = toHalfFloat(x);
			this.array[index + 1] = toHalfFloat(y);

			return this;
		}
	}, {
		key: 'setXYZ',
		value: function setXYZ(index, x, y, z) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
			}

			this.array[index + 0] = toHalfFloat(x);
			this.array[index + 1] = toHalfFloat(y);
			this.array[index + 2] = toHalfFloat(z);

			return this;
		}
	}, {
		key: 'setXYZW',
		value: function setXYZW(index, x, y, z, w) {

			index *= this.itemSize;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
				w = normalize(w, this.array);
			}

			this.array[index + 0] = toHalfFloat(x);
			this.array[index + 1] = toHalfFloat(y);
			this.array[index + 2] = toHalfFloat(z);
			this.array[index + 3] = toHalfFloat(w);

			return this;
		}
	}]);

	return Float16BufferAttribute;
}(BufferAttribute);

var Float32BufferAttribute = function (_BufferAttribute9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Float32BufferAttribute, _BufferAttribute9);

	function Float32BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Float32BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Float32BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Float32BufferAttribute)).call(this, new Float32Array(array), itemSize, normalized));
	}

	return Float32BufferAttribute;
}(BufferAttribute);

var Float64BufferAttribute = function (_BufferAttribute10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Float64BufferAttribute, _BufferAttribute10);

	function Float64BufferAttribute(array, itemSize, normalized) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Float64BufferAttribute);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Float64BufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Float64BufferAttribute)).call(this, new Float64Array(array), itemSize, normalized));
	}

	return Float64BufferAttribute;
}(BufferAttribute);

var _id$1 = 0;

var _m1 = /*@__PURE__*/new Matrix4();
var _obj = /*@__PURE__*/new Object3D();
var _offset = /*@__PURE__*/new Vector3();
var _box$1 = /*@__PURE__*/new Box3();
var _boxMorphTargets = /*@__PURE__*/new Box3();
var _vector$7 = /*@__PURE__*/new Vector3();

var BufferGeometry = function (_EventDispatcher5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BufferGeometry, _EventDispatcher5);

	function BufferGeometry() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BufferGeometry);

		var _this22 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BufferGeometry)).call(this));

		_this22.isBufferGeometry = true;

		Object.defineProperty(_this22, 'id', { value: _id$1++ });

		_this22.uuid = generateUUID();

		_this22.name = '';
		_this22.type = 'BufferGeometry';

		_this22.index = null;
		_this22.attributes = {};

		_this22.morphAttributes = {};
		_this22.morphTargetsRelative = false;

		_this22.groups = [];

		_this22.boundingBox = null;
		_this22.boundingSphere = null;

		_this22.drawRange = { start: 0, count: Infinity };

		_this22.userData = {};

		return _this22;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(BufferGeometry, [{
		key: 'getIndex',
		value: function getIndex() {

			return this.index;
		}
	}, {
		key: 'setIndex',
		value: function setIndex(index) {

			if (Array.isArray(index)) {

				this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
			} else {

				this.index = index;
			}

			return this;
		}
	}, {
		key: 'getAttribute',
		value: function getAttribute(name) {

			return this.attributes[name];
		}
	}, {
		key: 'setAttribute',
		value: function setAttribute(name, attribute) {

			this.attributes[name] = attribute;

			return this;
		}
	}, {
		key: 'deleteAttribute',
		value: function deleteAttribute(name) {

			delete this.attributes[name];

			return this;
		}
	}, {
		key: 'hasAttribute',
		value: function hasAttribute(name) {

			return this.attributes[name] !== undefined;
		}
	}, {
		key: 'addGroup',
		value: function addGroup(start, count) {
			var materialIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


			this.groups.push({

				start: start,
				count: count,
				materialIndex: materialIndex

			});
		}
	}, {
		key: 'clearGroups',
		value: function clearGroups() {

			this.groups = [];
		}
	}, {
		key: 'setDrawRange',
		value: function setDrawRange(start, count) {

			this.drawRange.start = start;
			this.drawRange.count = count;
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix) {

			var position = this.attributes.position;

			if (position !== undefined) {

				position.applyMatrix4(matrix);

				position.needsUpdate = true;
			}

			var normal = this.attributes.normal;

			if (normal !== undefined) {

				var normalMatrix = new Matrix3().getNormalMatrix(matrix);

				normal.applyNormalMatrix(normalMatrix);

				normal.needsUpdate = true;
			}

			var tangent = this.attributes.tangent;

			if (tangent !== undefined) {

				tangent.transformDirection(matrix);

				tangent.needsUpdate = true;
			}

			if (this.boundingBox !== null) {

				this.computeBoundingBox();
			}

			if (this.boundingSphere !== null) {

				this.computeBoundingSphere();
			}

			return this;
		}
	}, {
		key: 'applyQuaternion',
		value: function applyQuaternion(q) {

			_m1.makeRotationFromQuaternion(q);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'rotateX',
		value: function rotateX(angle) {

			// rotate geometry around world x-axis

			_m1.makeRotationX(angle);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'rotateY',
		value: function rotateY(angle) {

			// rotate geometry around world y-axis

			_m1.makeRotationY(angle);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'rotateZ',
		value: function rotateZ(angle) {

			// rotate geometry around world z-axis

			_m1.makeRotationZ(angle);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(x, y, z) {

			// translate geometry

			_m1.makeTranslation(x, y, z);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'scale',
		value: function scale(x, y, z) {

			// scale geometry

			_m1.makeScale(x, y, z);

			this.applyMatrix4(_m1);

			return this;
		}
	}, {
		key: 'lookAt',
		value: function lookAt(vector) {

			_obj.lookAt(vector);

			_obj.updateMatrix();

			this.applyMatrix4(_obj.matrix);

			return this;
		}
	}, {
		key: 'center',
		value: function center() {

			this.computeBoundingBox();

			this.boundingBox.getCenter(_offset).negate();

			this.translate(_offset.x, _offset.y, _offset.z);

			return this;
		}
	}, {
		key: 'setFromPoints',
		value: function setFromPoints(points) {

			var position = [];

			for (var i = 0, l = points.length; i < l; i++) {

				var point = points[i];
				position.push(point.x, point.y, point.z || 0);
			}

			this.setAttribute('position', new Float32BufferAttribute(position, 3));

			return this;
		}
	}, {
		key: 'computeBoundingBox',
		value: function computeBoundingBox() {

			if (this.boundingBox === null) {

				this.boundingBox = new Box3();
			}

			var position = this.attributes.position;
			var morphAttributesPosition = this.morphAttributes.position;

			if (position && position.isGLBufferAttribute) {

				console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);

				this.boundingBox.set(new Vector3(-Infinity, -Infinity, -Infinity), new Vector3(+Infinity, +Infinity, +Infinity));

				return;
			}

			if (position !== undefined) {

				this.boundingBox.setFromBufferAttribute(position);

				// process morph attributes if present

				if (morphAttributesPosition) {

					for (var i = 0, il = morphAttributesPosition.length; i < il; i++) {

						var morphAttribute = morphAttributesPosition[i];
						_box$1.setFromBufferAttribute(morphAttribute);

						if (this.morphTargetsRelative) {

							_vector$7.addVectors(this.boundingBox.min, _box$1.min);
							this.boundingBox.expandByPoint(_vector$7);

							_vector$7.addVectors(this.boundingBox.max, _box$1.max);
							this.boundingBox.expandByPoint(_vector$7);
						} else {

							this.boundingBox.expandByPoint(_box$1.min);
							this.boundingBox.expandByPoint(_box$1.max);
						}
					}
				}
			} else {

				this.boundingBox.makeEmpty();
			}

			if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {

				console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
			}
		}
	}, {
		key: 'computeBoundingSphere',
		value: function computeBoundingSphere() {

			if (this.boundingSphere === null) {

				this.boundingSphere = new Sphere();
			}

			var position = this.attributes.position;
			var morphAttributesPosition = this.morphAttributes.position;

			if (position && position.isGLBufferAttribute) {

				console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);

				this.boundingSphere.set(new Vector3(), Infinity);

				return;
			}

			if (position) {

				// first, find the center of the bounding sphere

				var center = this.boundingSphere.center;

				_box$1.setFromBufferAttribute(position);

				// process morph attributes if present

				if (morphAttributesPosition) {

					for (var i = 0, il = morphAttributesPosition.length; i < il; i++) {

						var morphAttribute = morphAttributesPosition[i];
						_boxMorphTargets.setFromBufferAttribute(morphAttribute);

						if (this.morphTargetsRelative) {

							_vector$7.addVectors(_box$1.min, _boxMorphTargets.min);
							_box$1.expandByPoint(_vector$7);

							_vector$7.addVectors(_box$1.max, _boxMorphTargets.max);
							_box$1.expandByPoint(_vector$7);
						} else {

							_box$1.expandByPoint(_boxMorphTargets.min);
							_box$1.expandByPoint(_boxMorphTargets.max);
						}
					}
				}

				_box$1.getCenter(center);

				// second, try to find a boundingSphere with a radius smaller than the
				// boundingSphere of the boundingBox: sqrt(3) smaller in the best case

				var maxRadiusSq = 0;

				for (var _i12 = 0, _il = position.count; _i12 < _il; _i12++) {

					_vector$7.fromBufferAttribute(position, _i12);

					maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$7));
				}

				// process morph attributes if present

				if (morphAttributesPosition) {

					for (var _i13 = 0, _il2 = morphAttributesPosition.length; _i13 < _il2; _i13++) {

						var _morphAttribute = morphAttributesPosition[_i13];
						var morphTargetsRelative = this.morphTargetsRelative;

						for (var j = 0, jl = _morphAttribute.count; j < jl; j++) {

							_vector$7.fromBufferAttribute(_morphAttribute, j);

							if (morphTargetsRelative) {

								_offset.fromBufferAttribute(position, j);
								_vector$7.add(_offset);
							}

							maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$7));
						}
					}
				}

				this.boundingSphere.radius = Math.sqrt(maxRadiusSq);

				if (isNaN(this.boundingSphere.radius)) {

					console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
				}
			}
		}
	}, {
		key: 'computeTangents',
		value: function computeTangents() {

			var index = this.index;
			var attributes = this.attributes;

			// based on http://www.terathon.com/code/tangent.html
			// (per vertex tangents)

			if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {

				console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
				return;
			}

			var indices = index.array;
			var positions = attributes.position.array;
			var normals = attributes.normal.array;
			var uvs = attributes.uv.array;

			var nVertices = positions.length / 3;

			if (this.hasAttribute('tangent') === false) {

				this.setAttribute('tangent', new BufferAttribute(new Float32Array(4 * nVertices), 4));
			}

			var tangents = this.getAttribute('tangent').array;

			var tan1 = [],
			    tan2 = [];

			for (var i = 0; i < nVertices; i++) {

				tan1[i] = new Vector3();
				tan2[i] = new Vector3();
			}

			var vA = new Vector3(),
			    vB = new Vector3(),
			    vC = new Vector3(),
			    uvA = new Vector2(),
			    uvB = new Vector2(),
			    uvC = new Vector2(),
			    sdir = new Vector3(),
			    tdir = new Vector3();

			function handleTriangle(a, b, c) {

				vA.fromArray(positions, a * 3);
				vB.fromArray(positions, b * 3);
				vC.fromArray(positions, c * 3);

				uvA.fromArray(uvs, a * 2);
				uvB.fromArray(uvs, b * 2);
				uvC.fromArray(uvs, c * 2);

				vB.sub(vA);
				vC.sub(vA);

				uvB.sub(uvA);
				uvC.sub(uvA);

				var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);

				// silently ignore degenerate uv triangles having coincident or colinear vertices

				if (!isFinite(r)) return;

				sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
				tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);

				tan1[a].add(sdir);
				tan1[b].add(sdir);
				tan1[c].add(sdir);

				tan2[a].add(tdir);
				tan2[b].add(tdir);
				tan2[c].add(tdir);
			}

			var groups = this.groups;

			if (groups.length === 0) {

				groups = [{
					start: 0,
					count: indices.length
				}];
			}

			for (var _i14 = 0, il = groups.length; _i14 < il; ++_i14) {

				var group = groups[_i14];

				var start = group.start;
				var count = group.count;

				for (var j = start, jl = start + count; j < jl; j += 3) {

					handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
				}
			}

			var tmp = new Vector3(),
			    tmp2 = new Vector3();
			var n = new Vector3(),
			    n2 = new Vector3();

			function handleVertex(v) {

				n.fromArray(normals, v * 3);
				n2.copy(n);

				var t = tan1[v];

				// Gram-Schmidt orthogonalize

				tmp.copy(t);
				tmp.sub(n.multiplyScalar(n.dot(t))).normalize();

				// Calculate handedness

				tmp2.crossVectors(n2, t);
				var test = tmp2.dot(tan2[v]);
				var w = test < 0.0 ? -1.0 : 1.0;

				tangents[v * 4] = tmp.x;
				tangents[v * 4 + 1] = tmp.y;
				tangents[v * 4 + 2] = tmp.z;
				tangents[v * 4 + 3] = w;
			}

			for (var _i15 = 0, _il3 = groups.length; _i15 < _il3; ++_i15) {

				var _group = groups[_i15];

				var _start2 = _group.start;
				var _count = _group.count;

				for (var _j = _start2, _jl = _start2 + _count; _j < _jl; _j += 3) {

					handleVertex(indices[_j + 0]);
					handleVertex(indices[_j + 1]);
					handleVertex(indices[_j + 2]);
				}
			}
		}
	}, {
		key: 'computeVertexNormals',
		value: function computeVertexNormals() {

			var index = this.index;
			var positionAttribute = this.getAttribute('position');

			if (positionAttribute !== undefined) {

				var normalAttribute = this.getAttribute('normal');

				if (normalAttribute === undefined) {

					normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
					this.setAttribute('normal', normalAttribute);
				} else {

					// reset existing normals to zero

					for (var i = 0, il = normalAttribute.count; i < il; i++) {

						normalAttribute.setXYZ(i, 0, 0, 0);
					}
				}

				var pA = new Vector3(),
				    pB = new Vector3(),
				    pC = new Vector3();
				var nA = new Vector3(),
				    nB = new Vector3(),
				    nC = new Vector3();
				var cb = new Vector3(),
				    ab = new Vector3();

				// indexed elements

				if (index) {

					for (var _i16 = 0, _il4 = index.count; _i16 < _il4; _i16 += 3) {

						var vA = index.getX(_i16 + 0);
						var vB = index.getX(_i16 + 1);
						var vC = index.getX(_i16 + 2);

						pA.fromBufferAttribute(positionAttribute, vA);
						pB.fromBufferAttribute(positionAttribute, vB);
						pC.fromBufferAttribute(positionAttribute, vC);

						cb.subVectors(pC, pB);
						ab.subVectors(pA, pB);
						cb.cross(ab);

						nA.fromBufferAttribute(normalAttribute, vA);
						nB.fromBufferAttribute(normalAttribute, vB);
						nC.fromBufferAttribute(normalAttribute, vC);

						nA.add(cb);
						nB.add(cb);
						nC.add(cb);

						normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
						normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
						normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
					}
				} else {

					// non-indexed elements (unconnected triangle soup)

					for (var _i17 = 0, _il5 = positionAttribute.count; _i17 < _il5; _i17 += 3) {

						pA.fromBufferAttribute(positionAttribute, _i17 + 0);
						pB.fromBufferAttribute(positionAttribute, _i17 + 1);
						pC.fromBufferAttribute(positionAttribute, _i17 + 2);

						cb.subVectors(pC, pB);
						ab.subVectors(pA, pB);
						cb.cross(ab);

						normalAttribute.setXYZ(_i17 + 0, cb.x, cb.y, cb.z);
						normalAttribute.setXYZ(_i17 + 1, cb.x, cb.y, cb.z);
						normalAttribute.setXYZ(_i17 + 2, cb.x, cb.y, cb.z);
					}
				}

				this.normalizeNormals();

				normalAttribute.needsUpdate = true;
			}
		}
	}, {
		key: 'merge',
		value: function merge() {
			// @deprecated, r144

			console.error('THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeGeometries() instead.');
			return this;
		}
	}, {
		key: 'normalizeNormals',
		value: function normalizeNormals() {

			var normals = this.attributes.normal;

			for (var i = 0, il = normals.count; i < il; i++) {

				_vector$7.fromBufferAttribute(normals, i);

				_vector$7.normalize();

				normals.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
			}
		}
	}, {
		key: 'toNonIndexed',
		value: function toNonIndexed() {

			function convertBufferAttribute(attribute, indices) {

				var array = attribute.array;
				var itemSize = attribute.itemSize;
				var normalized = attribute.normalized;

				var array2 = new array.constructor(indices.length * itemSize);

				var index = 0,
				    index2 = 0;

				for (var i = 0, l = indices.length; i < l; i++) {

					if (attribute.isInterleavedBufferAttribute) {

						index = indices[i] * attribute.data.stride + attribute.offset;
					} else {

						index = indices[i] * itemSize;
					}

					for (var j = 0; j < itemSize; j++) {

						array2[index2++] = array[index++];
					}
				}

				return new BufferAttribute(array2, itemSize, normalized);
			}

			//

			if (this.index === null) {

				console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
				return this;
			}

			var geometry2 = new BufferGeometry();

			var indices = this.index.array;
			var attributes = this.attributes;

			// attributes

			for (var name in attributes) {

				var attribute = attributes[name];

				var newAttribute = convertBufferAttribute(attribute, indices);

				geometry2.setAttribute(name, newAttribute);
			}

			// morph attributes

			var morphAttributes = this.morphAttributes;

			for (var _name in morphAttributes) {

				var morphArray = [];
				var morphAttribute = morphAttributes[_name]; // morphAttribute: array of Float32BufferAttributes

				for (var i = 0, il = morphAttribute.length; i < il; i++) {

					var _attribute = morphAttribute[i];

					var _newAttribute = convertBufferAttribute(_attribute, indices);

					morphArray.push(_newAttribute);
				}

				geometry2.morphAttributes[_name] = morphArray;
			}

			geometry2.morphTargetsRelative = this.morphTargetsRelative;

			// groups

			var groups = this.groups;

			for (var _i18 = 0, l = groups.length; _i18 < l; _i18++) {

				var group = groups[_i18];
				geometry2.addGroup(group.start, group.count, group.materialIndex);
			}

			return geometry2;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = {
				metadata: {
					version: 4.5,
					type: 'BufferGeometry',
					generator: 'BufferGeometry.toJSON'
				}
			};

			// standard BufferGeometry serialization

			data.uuid = this.uuid;
			data.type = this.type;
			if (this.name !== '') data.name = this.name;
			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(this.userData).length > 0) data.userData = this.userData;

			if (this.parameters !== undefined) {

				var parameters = this.parameters;

				for (var key in parameters) {

					if (parameters[key] !== undefined) data[key] = parameters[key];
				}

				return data;
			}

			// for simplicity the code assumes attributes are not shared across geometries, see #15811

			data.data = { attributes: {} };

			var index = this.index;

			if (index !== null) {

				data.data.index = {
					type: index.array.constructor.name,
					array: Array.prototype.slice.call(index.array)
				};
			}

			var attributes = this.attributes;

			for (var _key in attributes) {

				var attribute = attributes[_key];

				data.data.attributes[_key] = attribute.toJSON(data.data);
			}

			var morphAttributes = {};
			var hasMorphAttributes = false;

			for (var _key2 in this.morphAttributes) {

				var attributeArray = this.morphAttributes[_key2];

				var array = [];

				for (var i = 0, il = attributeArray.length; i < il; i++) {

					var _attribute2 = attributeArray[i];

					array.push(_attribute2.toJSON(data.data));
				}

				if (array.length > 0) {

					morphAttributes[_key2] = array;

					hasMorphAttributes = true;
				}
			}

			if (hasMorphAttributes) {

				data.data.morphAttributes = morphAttributes;
				data.data.morphTargetsRelative = this.morphTargetsRelative;
			}

			var groups = this.groups;

			if (groups.length > 0) {

				data.data.groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_18_babel_runtime_core_js_json_stringify___default()(groups));
			}

			var boundingSphere = this.boundingSphere;

			if (boundingSphere !== null) {

				data.data.boundingSphere = {
					center: boundingSphere.center.toArray(),
					radius: boundingSphere.radius
				};
			}

			return data;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			// reset

			this.index = null;
			this.attributes = {};
			this.morphAttributes = {};
			this.groups = [];
			this.boundingBox = null;
			this.boundingSphere = null;

			// used for storing cloned, shared data

			var data = {};

			// name

			this.name = source.name;

			// index

			var index = source.index;

			if (index !== null) {

				this.setIndex(index.clone(data));
			}

			// attributes

			var attributes = source.attributes;

			for (var name in attributes) {

				var attribute = attributes[name];
				this.setAttribute(name, attribute.clone(data));
			}

			// morph attributes

			var morphAttributes = source.morphAttributes;

			for (var _name2 in morphAttributes) {

				var array = [];
				var morphAttribute = morphAttributes[_name2]; // morphAttribute: array of Float32BufferAttributes

				for (var i = 0, l = morphAttribute.length; i < l; i++) {

					array.push(morphAttribute[i].clone(data));
				}

				this.morphAttributes[_name2] = array;
			}

			this.morphTargetsRelative = source.morphTargetsRelative;

			// groups

			var groups = source.groups;

			for (var _i19 = 0, _l4 = groups.length; _i19 < _l4; _i19++) {

				var group = groups[_i19];
				this.addGroup(group.start, group.count, group.materialIndex);
			}

			// bounding box

			var boundingBox = source.boundingBox;

			if (boundingBox !== null) {

				this.boundingBox = boundingBox.clone();
			}

			// bounding sphere

			var boundingSphere = source.boundingSphere;

			if (boundingSphere !== null) {

				this.boundingSphere = boundingSphere.clone();
			}

			// draw range

			this.drawRange.start = source.drawRange.start;
			this.drawRange.count = source.drawRange.count;

			// user data

			this.userData = source.userData;

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });
		}
	}]);

	return BufferGeometry;
}(EventDispatcher);

var _inverseMatrix$2 = /*@__PURE__*/new Matrix4();
var _ray$2 = /*@__PURE__*/new Ray();
var _sphere$4 = /*@__PURE__*/new Sphere();
var _sphereHitAt = /*@__PURE__*/new Vector3();

var _vA$1 = /*@__PURE__*/new Vector3();
var _vB$1 = /*@__PURE__*/new Vector3();
var _vC$1 = /*@__PURE__*/new Vector3();

var _tempA = /*@__PURE__*/new Vector3();
var _morphA = /*@__PURE__*/new Vector3();

var _uvA$1 = /*@__PURE__*/new Vector2();
var _uvB$1 = /*@__PURE__*/new Vector2();
var _uvC$1 = /*@__PURE__*/new Vector2();

var _normalA = /*@__PURE__*/new Vector3();
var _normalB = /*@__PURE__*/new Vector3();
var _normalC = /*@__PURE__*/new Vector3();

var _intersectionPoint = /*@__PURE__*/new Vector3();
var _intersectionPointWorld = /*@__PURE__*/new Vector3();

var Mesh = function (_Object3D) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Mesh, _Object3D);

	function Mesh() {
		var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
		var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new MeshBasicMaterial();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Mesh);

		var _this23 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Mesh.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Mesh)).call(this));

		_this23.isMesh = true;

		_this23.type = 'Mesh';

		_this23.geometry = geometry;
		_this23.material = material;

		_this23.updateMorphTargets();

		return _this23;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Mesh, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Mesh.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Mesh.prototype), 'copy', this).call(this, source, recursive);

			if (source.morphTargetInfluences !== undefined) {

				this.morphTargetInfluences = source.morphTargetInfluences.slice();
			}

			if (source.morphTargetDictionary !== undefined) {

				this.morphTargetDictionary = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.morphTargetDictionary);
			}

			this.material = source.material;
			this.geometry = source.geometry;

			return this;
		}
	}, {
		key: 'updateMorphTargets',
		value: function updateMorphTargets() {

			var geometry = this.geometry;

			var morphAttributes = geometry.morphAttributes;
			var keys = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(morphAttributes);

			if (keys.length > 0) {

				var morphAttribute = morphAttributes[keys[0]];

				if (morphAttribute !== undefined) {

					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};

					for (var m = 0, ml = morphAttribute.length; m < ml; m++) {

						var name = morphAttribute[m].name || String(m);

						this.morphTargetInfluences.push(0);
						this.morphTargetDictionary[name] = m;
					}
				}
			}
		}
	}, {
		key: 'getVertexPosition',
		value: function getVertexPosition(index, target) {

			var geometry = this.geometry;
			var position = geometry.attributes.position;
			var morphPosition = geometry.morphAttributes.position;
			var morphTargetsRelative = geometry.morphTargetsRelative;

			target.fromBufferAttribute(position, index);

			var morphInfluences = this.morphTargetInfluences;

			if (morphPosition && morphInfluences) {

				_morphA.set(0, 0, 0);

				for (var i = 0, il = morphPosition.length; i < il; i++) {

					var influence = morphInfluences[i];
					var morphAttribute = morphPosition[i];

					if (influence === 0) continue;

					_tempA.fromBufferAttribute(morphAttribute, index);

					if (morphTargetsRelative) {

						_morphA.addScaledVector(_tempA, influence);
					} else {

						_morphA.addScaledVector(_tempA.sub(target), influence);
					}
				}

				target.add(_morphA);
			}

			if (this.isSkinnedMesh) {

				this.applyBoneTransform(index, target);
			}

			return target;
		}
	}, {
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			var geometry = this.geometry;
			var material = this.material;
			var matrixWorld = this.matrixWorld;

			if (material === undefined) return;

			// Checking boundingSphere distance to ray

			if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

			_sphere$4.copy(geometry.boundingSphere);
			_sphere$4.applyMatrix4(matrixWorld);

			_ray$2.copy(raycaster.ray).recast(raycaster.near);

			if (_sphere$4.containsPoint(_ray$2.origin) === false) {

				if (_ray$2.intersectSphere(_sphere$4, _sphereHitAt) === null) return;

				if (_ray$2.origin.distanceToSquared(_sphereHitAt) > Math.pow(raycaster.far - raycaster.near, 2)) return;
			}

			//

			_inverseMatrix$2.copy(matrixWorld).invert();
			_ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);

			// Check boundingBox before continuing

			if (geometry.boundingBox !== null) {

				if (_ray$2.intersectsBox(geometry.boundingBox) === false) return;
			}

			var intersection = void 0;

			var index = geometry.index;
			var position = geometry.attributes.position;
			var uv = geometry.attributes.uv;
			var uv2 = geometry.attributes.uv2;
			var normal = geometry.attributes.normal;
			var groups = geometry.groups;
			var drawRange = geometry.drawRange;

			if (index !== null) {

				// indexed buffer geometry

				if (Array.isArray(material)) {

					for (var i = 0, il = groups.length; i < il; i++) {

						var group = groups[i];
						var groupMaterial = material[group.materialIndex];

						var start = Math.max(group.start, drawRange.start);
						var end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));

						for (var j = start, jl = end; j < jl; j += 3) {

							var a = index.getX(j);
							var b = index.getX(j + 1);
							var c = index.getX(j + 2);

							intersection = checkGeometryIntersection(this, groupMaterial, raycaster, _ray$2, uv, uv2, normal, a, b, c);

							if (intersection) {

								intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
								intersection.face.materialIndex = group.materialIndex;
								intersects.push(intersection);
							}
						}
					}
				} else {

					var _start3 = Math.max(0, drawRange.start);
					var _end2 = Math.min(index.count, drawRange.start + drawRange.count);

					for (var _i20 = _start3, _il6 = _end2; _i20 < _il6; _i20 += 3) {

						var _a = index.getX(_i20);
						var _b = index.getX(_i20 + 1);
						var _c = index.getX(_i20 + 2);

						intersection = checkGeometryIntersection(this, material, raycaster, _ray$2, uv, uv2, normal, _a, _b, _c);

						if (intersection) {

							intersection.faceIndex = Math.floor(_i20 / 3); // triangle number in indexed buffer semantics
							intersects.push(intersection);
						}
					}
				}
			} else if (position !== undefined) {

				// non-indexed buffer geometry

				if (Array.isArray(material)) {

					for (var _i21 = 0, _il7 = groups.length; _i21 < _il7; _i21++) {

						var _group2 = groups[_i21];
						var _groupMaterial = material[_group2.materialIndex];

						var _start4 = Math.max(_group2.start, drawRange.start);
						var _end3 = Math.min(position.count, Math.min(_group2.start + _group2.count, drawRange.start + drawRange.count));

						for (var _j2 = _start4, _jl2 = _end3; _j2 < _jl2; _j2 += 3) {

							var _a2 = _j2;
							var _b2 = _j2 + 1;
							var _c2 = _j2 + 2;

							intersection = checkGeometryIntersection(this, _groupMaterial, raycaster, _ray$2, uv, uv2, normal, _a2, _b2, _c2);

							if (intersection) {

								intersection.faceIndex = Math.floor(_j2 / 3); // triangle number in non-indexed buffer semantics
								intersection.face.materialIndex = _group2.materialIndex;
								intersects.push(intersection);
							}
						}
					}
				} else {

					var _start5 = Math.max(0, drawRange.start);
					var _end4 = Math.min(position.count, drawRange.start + drawRange.count);

					for (var _i22 = _start5, _il8 = _end4; _i22 < _il8; _i22 += 3) {

						var _a3 = _i22;
						var _b3 = _i22 + 1;
						var _c3 = _i22 + 2;

						intersection = checkGeometryIntersection(this, material, raycaster, _ray$2, uv, uv2, normal, _a3, _b3, _c3);

						if (intersection) {

							intersection.faceIndex = Math.floor(_i22 / 3); // triangle number in non-indexed buffer semantics
							intersects.push(intersection);
						}
					}
				}
			}
		}
	}]);

	return Mesh;
}(Object3D);

function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {

	var intersect = void 0;

	if (material.side === BackSide) {

		intersect = ray.intersectTriangle(pC, pB, pA, true, point);
	} else {

		intersect = ray.intersectTriangle(pA, pB, pC, material.side === FrontSide, point);
	}

	if (intersect === null) return null;

	_intersectionPointWorld.copy(point);
	_intersectionPointWorld.applyMatrix4(object.matrixWorld);

	var distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);

	if (distance < raycaster.near || distance > raycaster.far) return null;

	return {
		distance: distance,
		point: _intersectionPointWorld.clone(),
		object: object
	};
}

function checkGeometryIntersection(object, material, raycaster, ray, uv, uv2, normal, a, b, c) {

	object.getVertexPosition(a, _vA$1);
	object.getVertexPosition(b, _vB$1);
	object.getVertexPosition(c, _vC$1);

	var intersection = checkIntersection(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);

	if (intersection) {

		if (uv) {

			_uvA$1.fromBufferAttribute(uv, a);
			_uvB$1.fromBufferAttribute(uv, b);
			_uvC$1.fromBufferAttribute(uv, c);

			intersection.uv = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2());
		}

		if (uv2) {

			_uvA$1.fromBufferAttribute(uv2, a);
			_uvB$1.fromBufferAttribute(uv2, b);
			_uvC$1.fromBufferAttribute(uv2, c);

			intersection.uv2 = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2());
		}

		if (normal) {

			_normalA.fromBufferAttribute(normal, a);
			_normalB.fromBufferAttribute(normal, b);
			_normalC.fromBufferAttribute(normal, c);

			intersection.normal = Triangle.getInterpolation(_intersectionPoint, _vA$1, _vB$1, _vC$1, _normalA, _normalB, _normalC, new Vector3());

			if (intersection.normal.dot(ray.direction) > 0) {

				intersection.normal.multiplyScalar(-1);
			}
		}

		var face = {
			a: a,
			b: b,
			c: c,
			normal: new Vector3(),
			materialIndex: 0
		};

		Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);

		intersection.face = face;
	}

	return intersection;
}

var BoxGeometry = function (_BufferGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BoxGeometry, _BufferGeometry);

	function BoxGeometry() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var widthSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
		var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
		var depthSegments = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BoxGeometry);

		var _this24 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BoxGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BoxGeometry)).call(this));

		_this24.type = 'BoxGeometry';

		_this24.parameters = {
			width: width,
			height: height,
			depth: depth,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			depthSegments: depthSegments
		};

		var scope = _this24;

		// segments

		widthSegments = Math.floor(widthSegments);
		heightSegments = Math.floor(heightSegments);
		depthSegments = Math.floor(depthSegments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var numberOfVertices = 0;
		var groupStart = 0;

		// build each side of the box geometry

		buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
		buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
		buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
		buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
		buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
		buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz

		// build geometry

		_this24.setIndex(indices);
		_this24.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this24.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this24.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {

			var segmentWidth = width / gridX;
			var segmentHeight = height / gridY;

			var widthHalf = width / 2;
			var heightHalf = height / 2;
			var depthHalf = depth / 2;

			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;

			var vertexCounter = 0;
			var groupCount = 0;

			var vector = new Vector3();

			// generate vertices, normals and uvs

			for (var iy = 0; iy < gridY1; iy++) {

				var y = iy * segmentHeight - heightHalf;

				for (var ix = 0; ix < gridX1; ix++) {

					var x = ix * segmentWidth - widthHalf;

					// set values to correct vector component

					vector[u] = x * udir;
					vector[v] = y * vdir;
					vector[w] = depthHalf;

					// now apply vector to vertex buffer

					vertices.push(vector.x, vector.y, vector.z);

					// set values to correct vector component

					vector[u] = 0;
					vector[v] = 0;
					vector[w] = depth > 0 ? 1 : -1;

					// now apply vector to normal buffer

					normals.push(vector.x, vector.y, vector.z);

					// uvs

					uvs.push(ix / gridX);
					uvs.push(1 - iy / gridY);

					// counters

					vertexCounter += 1;
				}
			}

			// indices

			// 1. you need three indices to draw a single face
			// 2. a single segment consists of two faces
			// 3. so we need to generate six (2*3) indices per segment

			for (var _iy = 0; _iy < gridY; _iy++) {

				for (var _ix = 0; _ix < gridX; _ix++) {

					var a = numberOfVertices + _ix + gridX1 * _iy;
					var b = numberOfVertices + _ix + gridX1 * (_iy + 1);
					var c = numberOfVertices + (_ix + 1) + gridX1 * (_iy + 1);
					var d = numberOfVertices + (_ix + 1) + gridX1 * _iy;

					// faces

					indices.push(a, b, d);
					indices.push(b, c, d);

					// increase counter

					groupCount += 6;
				}
			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup(groupStart, groupCount, materialIndex);

			// calculate new start value for groups

			groupStart += groupCount;

			// update total number of vertices

			numberOfVertices += vertexCounter;
		}

		return _this24;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(BoxGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(BoxGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BoxGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
		}
	}]);

	return BoxGeometry;
}(BufferGeometry);

/**
 * Uniform Utilities
 */

function cloneUniforms(src) {

	var dst = {};

	for (var u in src) {

		dst[u] = {};

		for (var p in src[u]) {

			var property = src[u][p];

			if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {

				if (property.isRenderTargetTexture) {

					console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
					dst[u][p] = null;
				} else {

					dst[u][p] = property.clone();
				}
			} else if (Array.isArray(property)) {

				dst[u][p] = property.slice();
			} else {

				dst[u][p] = property;
			}
		}
	}

	return dst;
}

function mergeUniforms(uniforms) {

	var merged = {};

	for (var u = 0; u < uniforms.length; u++) {

		var _tmp = cloneUniforms(uniforms[u]);

		for (var p in _tmp) {

			merged[p] = _tmp[p];
		}
	}

	return merged;
}

function cloneUniformsGroups(src) {

	var dst = [];

	for (var u = 0; u < src.length; u++) {

		dst.push(src[u].clone());
	}

	return dst;
}

function getUnlitUniformColorSpace(renderer) {

	if (renderer.getRenderTarget() === null) {

		// https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
		return renderer.outputEncoding === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
	}

	return LinearSRGBColorSpace;
}

// Legacy

var UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };

var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";

var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";

var ShaderMaterial = function (_Material2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ShaderMaterial, _Material2);

	function ShaderMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShaderMaterial);

		var _this25 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShaderMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShaderMaterial)).call(this));

		_this25.isShaderMaterial = true;

		_this25.type = 'ShaderMaterial';

		_this25.defines = {};
		_this25.uniforms = {};
		_this25.uniformsGroups = [];

		_this25.vertexShader = default_vertex;
		_this25.fragmentShader = default_fragment;

		_this25.linewidth = 1;

		_this25.wireframe = false;
		_this25.wireframeLinewidth = 1;

		_this25.fog = false; // set to use scene fog
		_this25.lights = false; // set to use scene lights
		_this25.clipping = false; // set to use user-defined clipping planes

		_this25.forceSinglePass = true;

		_this25.extensions = {
			derivatives: false, // set to use derivatives
			fragDepth: false, // set to use fragment depth values
			drawBuffers: false, // set to use draw buffers
			shaderTextureLOD: false // set to use shader texture LOD
		};

		// When rendered geometry doesn't include these attributes but the material does,
		// use these default values in WebGL. This avoids errors when buffer data is missing.
		_this25.defaultAttributeValues = {
			'color': [1, 1, 1],
			'uv': [0, 0],
			'uv2': [0, 0]
		};

		_this25.index0AttributeName = undefined;
		_this25.uniformsNeedUpdate = false;

		_this25.glslVersion = null;

		if (parameters !== undefined) {

			_this25.setValues(parameters);
		}

		return _this25;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ShaderMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ShaderMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShaderMaterial.prototype), 'copy', this).call(this, source);

			this.fragmentShader = source.fragmentShader;
			this.vertexShader = source.vertexShader;

			this.uniforms = cloneUniforms(source.uniforms);
			this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);

			this.defines = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.defines);

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;

			this.fog = source.fog;
			this.lights = source.lights;
			this.clipping = source.clipping;

			this.extensions = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.extensions);

			this.glslVersion = source.glslVersion;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ShaderMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShaderMaterial.prototype), 'toJSON', this).call(this, meta);

			data.glslVersion = this.glslVersion;
			data.uniforms = {};

			for (var name in this.uniforms) {

				var uniform = this.uniforms[name];
				var _value = uniform.value;

				if (_value && _value.isTexture) {

					data.uniforms[name] = {
						type: 't',
						value: _value.toJSON(meta).uuid
					};
				} else if (_value && _value.isColor) {

					data.uniforms[name] = {
						type: 'c',
						value: _value.getHex()
					};
				} else if (_value && _value.isVector2) {

					data.uniforms[name] = {
						type: 'v2',
						value: _value.toArray()
					};
				} else if (_value && _value.isVector3) {

					data.uniforms[name] = {
						type: 'v3',
						value: _value.toArray()
					};
				} else if (_value && _value.isVector4) {

					data.uniforms[name] = {
						type: 'v4',
						value: _value.toArray()
					};
				} else if (_value && _value.isMatrix3) {

					data.uniforms[name] = {
						type: 'm3',
						value: _value.toArray()
					};
				} else if (_value && _value.isMatrix4) {

					data.uniforms[name] = {
						type: 'm4',
						value: _value.toArray()
					};
				} else {

					data.uniforms[name] = {
						value: _value
					};

					// note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far
				}
			}

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(this.defines).length > 0) data.defines = this.defines;

			data.vertexShader = this.vertexShader;
			data.fragmentShader = this.fragmentShader;

			var extensions = {};

			for (var key in this.extensions) {

				if (this.extensions[key] === true) extensions[key] = true;
			}

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(extensions).length > 0) data.extensions = extensions;

			return data;
		}
	}]);

	return ShaderMaterial;
}(Material);

var Camera = function (_Object3D2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Camera, _Object3D2);

	function Camera() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Camera);

		var _this26 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Camera.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Camera)).call(this));

		_this26.isCamera = true;

		_this26.type = 'Camera';

		_this26.matrixWorldInverse = new Matrix4();

		_this26.projectionMatrix = new Matrix4();
		_this26.projectionMatrixInverse = new Matrix4();

		return _this26;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Camera, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Camera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Camera.prototype), 'copy', this).call(this, source, recursive);

			this.matrixWorldInverse.copy(source.matrixWorldInverse);

			this.projectionMatrix.copy(source.projectionMatrix);
			this.projectionMatrixInverse.copy(source.projectionMatrixInverse);

			return this;
		}
	}, {
		key: 'getWorldDirection',
		value: function getWorldDirection(target) {

			this.updateWorldMatrix(true, false);

			var e = this.matrixWorld.elements;

			return target.set(-e[8], -e[9], -e[10]).normalize();
		}
	}, {
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Camera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Camera.prototype), 'updateMatrixWorld', this).call(this, force);

			this.matrixWorldInverse.copy(this.matrixWorld).invert();
		}
	}, {
		key: 'updateWorldMatrix',
		value: function updateWorldMatrix(updateParents, updateChildren) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Camera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Camera.prototype), 'updateWorldMatrix', this).call(this, updateParents, updateChildren);

			this.matrixWorldInverse.copy(this.matrixWorld).invert();
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Camera;
}(Object3D);

var PerspectiveCamera = function (_Camera) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PerspectiveCamera, _Camera);

	function PerspectiveCamera() {
		var fov = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
		var aspect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
		var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2000;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PerspectiveCamera);

		var _this27 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PerspectiveCamera.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PerspectiveCamera)).call(this));

		_this27.isPerspectiveCamera = true;

		_this27.type = 'PerspectiveCamera';

		_this27.fov = fov;
		_this27.zoom = 1;

		_this27.near = near;
		_this27.far = far;
		_this27.focus = 10;

		_this27.aspect = aspect;
		_this27.view = null;

		_this27.filmGauge = 35; // width of the film (default in millimeters)
		_this27.filmOffset = 0; // horizontal film offset (same unit as gauge)

		_this27.updateProjectionMatrix();

		return _this27;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PerspectiveCamera, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PerspectiveCamera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PerspectiveCamera.prototype), 'copy', this).call(this, source, recursive);

			this.fov = source.fov;
			this.zoom = source.zoom;

			this.near = source.near;
			this.far = source.far;
			this.focus = source.focus;

			this.aspect = source.aspect;
			this.view = source.view === null ? null : __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.view);

			this.filmGauge = source.filmGauge;
			this.filmOffset = source.filmOffset;

			return this;
		}

		/**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */

	}, {
		key: 'setFocalLength',
		value: function setFocalLength(focalLength) {

			/** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */
			var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;

			this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
			this.updateProjectionMatrix();
		}

		/**
   * Calculates the focal length from the current .fov and .filmGauge.
   */

	}, {
		key: 'getFocalLength',
		value: function getFocalLength() {

			var vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);

			return 0.5 * this.getFilmHeight() / vExtentSlope;
		}
	}, {
		key: 'getEffectiveFOV',
		value: function getEffectiveFOV() {

			return RAD2DEG * 2 * Math.atan(Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom);
		}
	}, {
		key: 'getFilmWidth',
		value: function getFilmWidth() {

			// film not completely covered in portrait format (aspect < 1)
			return this.filmGauge * Math.min(this.aspect, 1);
		}
	}, {
		key: 'getFilmHeight',
		value: function getFilmHeight() {

			// film not completely covered in landscape format (aspect > 1)
			return this.filmGauge / Math.max(this.aspect, 1);
		}

		/**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */

	}, {
		key: 'setViewOffset',
		value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {

			this.aspect = fullWidth / fullHeight;

			if (this.view === null) {

				this.view = {
					enabled: true,
					fullWidth: 1,
					fullHeight: 1,
					offsetX: 0,
					offsetY: 0,
					width: 1,
					height: 1
				};
			}

			this.view.enabled = true;
			this.view.fullWidth = fullWidth;
			this.view.fullHeight = fullHeight;
			this.view.offsetX = x;
			this.view.offsetY = y;
			this.view.width = width;
			this.view.height = height;

			this.updateProjectionMatrix();
		}
	}, {
		key: 'clearViewOffset',
		value: function clearViewOffset() {

			if (this.view !== null) {

				this.view.enabled = false;
			}

			this.updateProjectionMatrix();
		}
	}, {
		key: 'updateProjectionMatrix',
		value: function updateProjectionMatrix() {

			var near = this.near;
			var top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
			var height = 2 * top;
			var width = this.aspect * height;
			var left = -0.5 * width;
			var view = this.view;

			if (this.view !== null && this.view.enabled) {

				var fullWidth = view.fullWidth,
				    fullHeight = view.fullHeight;

				left += view.offsetX * width / fullWidth;
				top -= view.offsetY * height / fullHeight;
				width *= view.width / fullWidth;
				height *= view.height / fullHeight;
			}

			var skew = this.filmOffset;
			if (skew !== 0) left += near * skew / this.getFilmWidth();

			this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);

			this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PerspectiveCamera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PerspectiveCamera.prototype), 'toJSON', this).call(this, meta);

			data.object.fov = this.fov;
			data.object.zoom = this.zoom;

			data.object.near = this.near;
			data.object.far = this.far;
			data.object.focus = this.focus;

			data.object.aspect = this.aspect;

			if (this.view !== null) data.object.view = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, this.view);

			data.object.filmGauge = this.filmGauge;
			data.object.filmOffset = this.filmOffset;

			return data;
		}
	}]);

	return PerspectiveCamera;
}(Camera);

var fov = -90; // negative fov is not an error
var aspect = 1;

var CubeCamera = function (_Object3D3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubeCamera, _Object3D3);

	function CubeCamera(near, far, renderTarget) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubeCamera);

		var _this28 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubeCamera.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubeCamera)).call(this));

		_this28.type = 'CubeCamera';

		_this28.renderTarget = renderTarget;

		var cameraPX = new PerspectiveCamera(fov, aspect, near, far);
		cameraPX.layers = _this28.layers;
		cameraPX.up.set(0, 1, 0);
		cameraPX.lookAt(1, 0, 0);
		_this28.add(cameraPX);

		var cameraNX = new PerspectiveCamera(fov, aspect, near, far);
		cameraNX.layers = _this28.layers;
		cameraNX.up.set(0, 1, 0);
		cameraNX.lookAt(-1, 0, 0);
		_this28.add(cameraNX);

		var cameraPY = new PerspectiveCamera(fov, aspect, near, far);
		cameraPY.layers = _this28.layers;
		cameraPY.up.set(0, 0, -1);
		cameraPY.lookAt(0, 1, 0);
		_this28.add(cameraPY);

		var cameraNY = new PerspectiveCamera(fov, aspect, near, far);
		cameraNY.layers = _this28.layers;
		cameraNY.up.set(0, 0, 1);
		cameraNY.lookAt(0, -1, 0);
		_this28.add(cameraNY);

		var cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
		cameraPZ.layers = _this28.layers;
		cameraPZ.up.set(0, 1, 0);
		cameraPZ.lookAt(0, 0, 1);
		_this28.add(cameraPZ);

		var cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
		cameraNZ.layers = _this28.layers;
		cameraNZ.up.set(0, 1, 0);
		cameraNZ.lookAt(0, 0, -1);
		_this28.add(cameraNZ);

		return _this28;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubeCamera, [{
		key: 'update',
		value: function update(renderer, scene) {

			if (this.parent === null) this.updateMatrixWorld();

			var renderTarget = this.renderTarget;

			var _children = __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_slicedToArray___default()(this.children, 6),
			    cameraPX = _children[0],
			    cameraNX = _children[1],
			    cameraPY = _children[2],
			    cameraNY = _children[3],
			    cameraPZ = _children[4],
			    cameraNZ = _children[5];

			var currentRenderTarget = renderer.getRenderTarget();

			var currentToneMapping = renderer.toneMapping;
			var currentXrEnabled = renderer.xr.enabled;

			renderer.toneMapping = NoToneMapping;
			renderer.xr.enabled = false;

			var generateMipmaps = renderTarget.texture.generateMipmaps;

			renderTarget.texture.generateMipmaps = false;

			renderer.setRenderTarget(renderTarget, 0);
			renderer.render(scene, cameraPX);

			renderer.setRenderTarget(renderTarget, 1);
			renderer.render(scene, cameraNX);

			renderer.setRenderTarget(renderTarget, 2);
			renderer.render(scene, cameraPY);

			renderer.setRenderTarget(renderTarget, 3);
			renderer.render(scene, cameraNY);

			renderer.setRenderTarget(renderTarget, 4);
			renderer.render(scene, cameraPZ);

			renderTarget.texture.generateMipmaps = generateMipmaps;

			renderer.setRenderTarget(renderTarget, 5);
			renderer.render(scene, cameraNZ);

			renderer.setRenderTarget(currentRenderTarget);

			renderer.toneMapping = currentToneMapping;
			renderer.xr.enabled = currentXrEnabled;

			renderTarget.texture.needsPMREMUpdate = true;
		}
	}]);

	return CubeCamera;
}(Object3D);

var CubeTexture = function (_Texture3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubeTexture, _Texture3);

	function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubeTexture);

		images = images !== undefined ? images : [];
		mapping = mapping !== undefined ? mapping : CubeReflectionMapping;

		var _this29 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubeTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubeTexture)).call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding));

		_this29.isCubeTexture = true;

		_this29.flipY = false;

		return _this29;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubeTexture, [{
		key: 'images',
		get: function get() {

			return this.image;
		},
		set: function set(value) {

			this.image = value;
		}
	}]);

	return CubeTexture;
}(Texture);

var WebGLCubeRenderTarget = function (_WebGLRenderTarget4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGLCubeRenderTarget, _WebGLRenderTarget4);

	function WebGLCubeRenderTarget() {
		var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLCubeRenderTarget);

		var _this30 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGLCubeRenderTarget.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGLCubeRenderTarget)).call(this, size, size, options));

		_this30.isWebGLCubeRenderTarget = true;

		var image = { width: size, height: size, depth: 1 };
		var images = [image, image, image, image, image, image];

		_this30.texture = new CubeTexture(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);

		// By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
		// in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
		// in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.

		// three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
		// and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
		// as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).

		_this30.texture.isRenderTargetTexture = true;

		_this30.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
		_this30.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;

		return _this30;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLCubeRenderTarget, [{
		key: 'fromEquirectangularTexture',
		value: function fromEquirectangularTexture(renderer, texture) {

			this.texture.type = texture.type;
			this.texture.encoding = texture.encoding;

			this.texture.generateMipmaps = texture.generateMipmaps;
			this.texture.minFilter = texture.minFilter;
			this.texture.magFilter = texture.magFilter;

			var shader = {

				uniforms: {
					tEquirect: { value: null }
				},

				vertexShader: /* glsl */'\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t',

				fragmentShader: /* glsl */'\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t'
			};

			var geometry = new BoxGeometry(5, 5, 5);

			var material = new ShaderMaterial({

				name: 'CubemapFromEquirect',

				uniforms: cloneUniforms(shader.uniforms),
				vertexShader: shader.vertexShader,
				fragmentShader: shader.fragmentShader,
				side: BackSide,
				blending: NoBlending

			});

			material.uniforms.tEquirect.value = texture;

			var mesh = new Mesh(geometry, material);

			var currentMinFilter = texture.minFilter;

			// Avoid blurred poles
			if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;

			var camera = new CubeCamera(1, 10, this);
			camera.update(renderer, mesh);

			texture.minFilter = currentMinFilter;

			mesh.geometry.dispose();
			mesh.material.dispose();

			return this;
		}
	}, {
		key: 'clear',
		value: function clear(renderer, color, depth, stencil) {

			var currentRenderTarget = renderer.getRenderTarget();

			for (var i = 0; i < 6; i++) {

				renderer.setRenderTarget(this, i);

				renderer.clear(color, depth, stencil);
			}

			renderer.setRenderTarget(currentRenderTarget);
		}
	}]);

	return WebGLCubeRenderTarget;
}(WebGLRenderTarget);

var _vector1 = /*@__PURE__*/new Vector3();
var _vector2 = /*@__PURE__*/new Vector3();
var _normalMatrix = /*@__PURE__*/new Matrix3();

var Plane = function () {
	function Plane() {
		var normal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3(1, 0, 0);
		var constant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Plane);

		this.isPlane = true;

		// normal is assumed to be normalized

		this.normal = normal;
		this.constant = constant;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Plane, [{
		key: 'set',
		value: function set(normal, constant) {

			this.normal.copy(normal);
			this.constant = constant;

			return this;
		}
	}, {
		key: 'setComponents',
		value: function setComponents(x, y, z, w) {

			this.normal.set(x, y, z);
			this.constant = w;

			return this;
		}
	}, {
		key: 'setFromNormalAndCoplanarPoint',
		value: function setFromNormalAndCoplanarPoint(normal, point) {

			this.normal.copy(normal);
			this.constant = -point.dot(this.normal);

			return this;
		}
	}, {
		key: 'setFromCoplanarPoints',
		value: function setFromCoplanarPoints(a, b, c) {

			var normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize();

			// Q: should an error be thrown if normal is zero (e.g. degenerate plane)?

			this.setFromNormalAndCoplanarPoint(normal, a);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(plane) {

			this.normal.copy(plane.normal);
			this.constant = plane.constant;

			return this;
		}
	}, {
		key: 'normalize',
		value: function normalize() {

			// Note: will lead to a divide by zero if the plane is invalid.

			var inverseNormalLength = 1.0 / this.normal.length();
			this.normal.multiplyScalar(inverseNormalLength);
			this.constant *= inverseNormalLength;

			return this;
		}
	}, {
		key: 'negate',
		value: function negate() {

			this.constant *= -1;
			this.normal.negate();

			return this;
		}
	}, {
		key: 'distanceToPoint',
		value: function distanceToPoint(point) {

			return this.normal.dot(point) + this.constant;
		}
	}, {
		key: 'distanceToSphere',
		value: function distanceToSphere(sphere) {

			return this.distanceToPoint(sphere.center) - sphere.radius;
		}
	}, {
		key: 'projectPoint',
		value: function projectPoint(point, target) {

			return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
		}
	}, {
		key: 'intersectLine',
		value: function intersectLine(line, target) {

			var direction = line.delta(_vector1);

			var denominator = this.normal.dot(direction);

			if (denominator === 0) {

				// line is coplanar, return origin
				if (this.distanceToPoint(line.start) === 0) {

					return target.copy(line.start);
				}

				// Unsure if this is the correct method to handle this case.
				return null;
			}

			var t = -(line.start.dot(this.normal) + this.constant) / denominator;

			if (t < 0 || t > 1) {

				return null;
			}

			return target.copy(line.start).addScaledVector(direction, t);
		}
	}, {
		key: 'intersectsLine',
		value: function intersectsLine(line) {

			// Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.

			var startSign = this.distanceToPoint(line.start);
			var endSign = this.distanceToPoint(line.end);

			return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			return box.intersectsPlane(this);
		}
	}, {
		key: 'intersectsSphere',
		value: function intersectsSphere(sphere) {

			return sphere.intersectsPlane(this);
		}
	}, {
		key: 'coplanarPoint',
		value: function coplanarPoint(target) {

			return target.copy(this.normal).multiplyScalar(-this.constant);
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix, optionalNormalMatrix) {

			var normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);

			var referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);

			var normal = this.normal.applyMatrix3(normalMatrix).normalize();

			this.constant = -referencePoint.dot(normal);

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(offset) {

			this.constant -= offset.dot(this.normal);

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(plane) {

			return plane.normal.equals(this.normal) && plane.constant === this.constant;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Plane;
}();

var _sphere$3 = /*@__PURE__*/new Sphere();
var _vector$6 = /*@__PURE__*/new Vector3();

var Frustum = function () {
	function Frustum() {
		var p0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Plane();
		var p1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Plane();
		var p2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Plane();
		var p3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Plane();
		var p4 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Plane();
		var p5 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Plane();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Frustum);

		this.planes = [p0, p1, p2, p3, p4, p5];
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Frustum, [{
		key: 'set',
		value: function set(p0, p1, p2, p3, p4, p5) {

			var planes = this.planes;

			planes[0].copy(p0);
			planes[1].copy(p1);
			planes[2].copy(p2);
			planes[3].copy(p3);
			planes[4].copy(p4);
			planes[5].copy(p5);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(frustum) {

			var planes = this.planes;

			for (var i = 0; i < 6; i++) {

				planes[i].copy(frustum.planes[i]);
			}

			return this;
		}
	}, {
		key: 'setFromProjectionMatrix',
		value: function setFromProjectionMatrix(m) {

			var planes = this.planes;
			var me = m.elements;
			var me0 = me[0],
			    me1 = me[1],
			    me2 = me[2],
			    me3 = me[3];
			var me4 = me[4],
			    me5 = me[5],
			    me6 = me[6],
			    me7 = me[7];
			var me8 = me[8],
			    me9 = me[9],
			    me10 = me[10],
			    me11 = me[11];
			var me12 = me[12],
			    me13 = me[13],
			    me14 = me[14],
			    me15 = me[15];

			planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
			planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
			planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
			planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
			planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
			planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();

			return this;
		}
	}, {
		key: 'intersectsObject',
		value: function intersectsObject(object) {

			if (object.boundingSphere !== undefined) {

				if (object.boundingSphere === null) object.computeBoundingSphere();

				_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
			} else {

				var geometry = object.geometry;

				if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

				_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
			}

			return this.intersectsSphere(_sphere$3);
		}
	}, {
		key: 'intersectsSprite',
		value: function intersectsSprite(sprite) {

			_sphere$3.center.set(0, 0, 0);
			_sphere$3.radius = 0.7071067811865476;
			_sphere$3.applyMatrix4(sprite.matrixWorld);

			return this.intersectsSphere(_sphere$3);
		}
	}, {
		key: 'intersectsSphere',
		value: function intersectsSphere(sphere) {

			var planes = this.planes;
			var center = sphere.center;
			var negRadius = -sphere.radius;

			for (var i = 0; i < 6; i++) {

				var distance = planes[i].distanceToPoint(center);

				if (distance < negRadius) {

					return false;
				}
			}

			return true;
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			var planes = this.planes;

			for (var i = 0; i < 6; i++) {

				var plane = planes[i];

				// corner at max distance

				_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
				_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
				_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;

				if (plane.distanceToPoint(_vector$6) < 0) {

					return false;
				}
			}

			return true;
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point) {

			var planes = this.planes;

			for (var i = 0; i < 6; i++) {

				if (planes[i].distanceToPoint(point) < 0) {

					return false;
				}
			}

			return true;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Frustum;
}();

function WebGLAnimation() {

	var context = null;
	var isAnimating = false;
	var animationLoop = null;
	var requestId = null;

	function onAnimationFrame(time, frame) {

		animationLoop(time, frame);

		requestId = context.requestAnimationFrame(onAnimationFrame);
	}

	return {

		start: function start() {

			if (isAnimating === true) return;
			if (animationLoop === null) return;

			requestId = context.requestAnimationFrame(onAnimationFrame);

			isAnimating = true;
		},

		stop: function stop() {

			context.cancelAnimationFrame(requestId);

			isAnimating = false;
		},

		setAnimationLoop: function setAnimationLoop(callback) {

			animationLoop = callback;
		},

		setContext: function setContext(value) {

			context = value;
		}

	};
}

function WebGLAttributes(gl, capabilities) {

	var isWebGL2 = capabilities.isWebGL2;

	var buffers = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function createBuffer(attribute, bufferType) {

		var array = attribute.array;
		var usage = attribute.usage;

		var buffer = gl.createBuffer();

		gl.bindBuffer(bufferType, buffer);
		gl.bufferData(bufferType, array, usage);

		attribute.onUploadCallback();

		var type = void 0;

		if (array instanceof Float32Array) {

			type = 5126;
		} else if (array instanceof Uint16Array) {

			if (attribute.isFloat16BufferAttribute) {

				if (isWebGL2) {

					type = 5131;
				} else {

					throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
				}
			} else {

				type = 5123;
			}
		} else if (array instanceof Int16Array) {

			type = 5122;
		} else if (array instanceof Uint32Array) {

			type = 5125;
		} else if (array instanceof Int32Array) {

			type = 5124;
		} else if (array instanceof Int8Array) {

			type = 5120;
		} else if (array instanceof Uint8Array) {

			type = 5121;
		} else if (array instanceof Uint8ClampedArray) {

			type = 5121;
		} else {

			throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
		}

		return {
			buffer: buffer,
			type: type,
			bytesPerElement: array.BYTES_PER_ELEMENT,
			version: attribute.version
		};
	}

	function updateBuffer(buffer, attribute, bufferType) {

		var array = attribute.array;
		var updateRange = attribute.updateRange;

		gl.bindBuffer(bufferType, buffer);

		if (updateRange.count === -1) {

			// Not using update ranges

			gl.bufferSubData(bufferType, 0, array);
		} else {

			if (isWebGL2) {

				gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
			} else {

				gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
			}

			updateRange.count = -1; // reset range
		}

		attribute.onUploadCallback();
	}

	//

	function get(attribute) {

		if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;

		return buffers.get(attribute);
	}

	function remove(attribute) {

		if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;

		var data = buffers.get(attribute);

		if (data) {

			gl.deleteBuffer(data.buffer);

			buffers.delete(attribute);
		}
	}

	function update(attribute, bufferType) {

		if (attribute.isGLBufferAttribute) {

			var cached = buffers.get(attribute);

			if (!cached || cached.version < attribute.version) {

				buffers.set(attribute, {
					buffer: attribute.buffer,
					type: attribute.type,
					bytesPerElement: attribute.elementSize,
					version: attribute.version
				});
			}

			return;
		}

		if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;

		var data = buffers.get(attribute);

		if (data === undefined) {

			buffers.set(attribute, createBuffer(attribute, bufferType));
		} else if (data.version < attribute.version) {

			updateBuffer(data.buffer, attribute, bufferType);

			data.version = attribute.version;
		}
	}

	return {

		get: get,
		remove: remove,
		update: update

	};
}

var PlaneGeometry = function (_BufferGeometry2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PlaneGeometry, _BufferGeometry2);

	function PlaneGeometry() {
		var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var widthSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PlaneGeometry);

		var _this31 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlaneGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PlaneGeometry)).call(this));

		_this31.type = 'PlaneGeometry';

		_this31.parameters = {
			width: width,
			height: height,
			widthSegments: widthSegments,
			heightSegments: heightSegments
		};

		var width_half = width / 2;
		var height_half = height / 2;

		var gridX = Math.floor(widthSegments);
		var gridY = Math.floor(heightSegments);

		var gridX1 = gridX + 1;
		var gridY1 = gridY + 1;

		var segment_width = width / gridX;
		var segment_height = height / gridY;

		//

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		for (var iy = 0; iy < gridY1; iy++) {

			var y = iy * segment_height - height_half;

			for (var ix = 0; ix < gridX1; ix++) {

				var x = ix * segment_width - width_half;

				vertices.push(x, -y, 0);

				normals.push(0, 0, 1);

				uvs.push(ix / gridX);
				uvs.push(1 - iy / gridY);
			}
		}

		for (var _iy2 = 0; _iy2 < gridY; _iy2++) {

			for (var _ix2 = 0; _ix2 < gridX; _ix2++) {

				var a = _ix2 + gridX1 * _iy2;
				var b = _ix2 + gridX1 * (_iy2 + 1);
				var c = _ix2 + 1 + gridX1 * (_iy2 + 1);
				var d = _ix2 + 1 + gridX1 * _iy2;

				indices.push(a, b, d);
				indices.push(b, c, d);
			}
		}

		_this31.setIndex(indices);
		_this31.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this31.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this31.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		return _this31;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PlaneGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PlaneGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PlaneGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
		}
	}]);

	return PlaneGeometry;
}(BufferGeometry);

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";

var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";

var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";

var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";

var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";

var begin_vertex = "vec3 transformed = vec3( position );";

var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";

var bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";

var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";

var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";

var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";

var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";

var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";

var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";

var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";

var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";

var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";

var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";

var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";

var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";

var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";

var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";

var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";

var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";

var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";

var encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";

var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";

var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";

var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";

var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";

var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";

var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";

var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";

var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";

var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";

var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";

var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";

var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";

var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";

var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";

var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";

var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";

var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";

var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";

var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";

var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";

var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif";

var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";

var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";

var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";

var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";

var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";

var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";

var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";

var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";

var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";

var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";

var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";

var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";

var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";

var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";

var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";

var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";

var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";

var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";

var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_NORMALMAP_TANGENTSPACE\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 geometryNormal = normal;";

var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";

var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";

var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";

var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";

var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";

var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";

var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";

var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";

var output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";

var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";

var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";

var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";

var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";

var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";

var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";

var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";

var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";

var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";

var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";

var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";

var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";

var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";

var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";

var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";

var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";

var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";

var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";

var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";

var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";

var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, vec2 fullSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\t\n\t\tvec2 lodFudge = pow( 1.95, lod ) / fullSize;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec2 fullSize = vec2( textureSize( sampler, 0 ) );\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), fullSize, floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), fullSize, ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";

var uv_pars_fragment = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_pars_vertex = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_UV2\n\tattribute vec2 uv2;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";

var uv_vertex = "#ifdef USE_UV\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";

var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";

var vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";

var fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";

var vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

var fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";

var vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";

var fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";

var vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";

var fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";

var vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";

var fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";

var vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";

var fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";

var vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

var fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

var vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";

var fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

var fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";

var fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";

var fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";

var vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

var fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";

var fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

var fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";

var vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";

var fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";

var vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";

var fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";

var vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";

var fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";

var ShaderChunk = {
	alphamap_fragment: alphamap_fragment,
	alphamap_pars_fragment: alphamap_pars_fragment,
	alphatest_fragment: alphatest_fragment,
	alphatest_pars_fragment: alphatest_pars_fragment,
	aomap_fragment: aomap_fragment,
	aomap_pars_fragment: aomap_pars_fragment,
	begin_vertex: begin_vertex,
	beginnormal_vertex: beginnormal_vertex,
	bsdfs: bsdfs,
	iridescence_fragment: iridescence_fragment,
	bumpmap_pars_fragment: bumpmap_pars_fragment,
	clipping_planes_fragment: clipping_planes_fragment,
	clipping_planes_pars_fragment: clipping_planes_pars_fragment,
	clipping_planes_pars_vertex: clipping_planes_pars_vertex,
	clipping_planes_vertex: clipping_planes_vertex,
	color_fragment: color_fragment,
	color_pars_fragment: color_pars_fragment,
	color_pars_vertex: color_pars_vertex,
	color_vertex: color_vertex,
	common: common,
	cube_uv_reflection_fragment: cube_uv_reflection_fragment,
	defaultnormal_vertex: defaultnormal_vertex,
	displacementmap_pars_vertex: displacementmap_pars_vertex,
	displacementmap_vertex: displacementmap_vertex,
	emissivemap_fragment: emissivemap_fragment,
	emissivemap_pars_fragment: emissivemap_pars_fragment,
	encodings_fragment: encodings_fragment,
	encodings_pars_fragment: encodings_pars_fragment,
	envmap_fragment: envmap_fragment,
	envmap_common_pars_fragment: envmap_common_pars_fragment,
	envmap_pars_fragment: envmap_pars_fragment,
	envmap_pars_vertex: envmap_pars_vertex,
	envmap_physical_pars_fragment: envmap_physical_pars_fragment,
	envmap_vertex: envmap_vertex,
	fog_vertex: fog_vertex,
	fog_pars_vertex: fog_pars_vertex,
	fog_fragment: fog_fragment,
	fog_pars_fragment: fog_pars_fragment,
	gradientmap_pars_fragment: gradientmap_pars_fragment,
	lightmap_fragment: lightmap_fragment,
	lightmap_pars_fragment: lightmap_pars_fragment,
	lights_lambert_fragment: lights_lambert_fragment,
	lights_lambert_pars_fragment: lights_lambert_pars_fragment,
	lights_pars_begin: lights_pars_begin,
	lights_toon_fragment: lights_toon_fragment,
	lights_toon_pars_fragment: lights_toon_pars_fragment,
	lights_phong_fragment: lights_phong_fragment,
	lights_phong_pars_fragment: lights_phong_pars_fragment,
	lights_physical_fragment: lights_physical_fragment,
	lights_physical_pars_fragment: lights_physical_pars_fragment,
	lights_fragment_begin: lights_fragment_begin,
	lights_fragment_maps: lights_fragment_maps,
	lights_fragment_end: lights_fragment_end,
	logdepthbuf_fragment: logdepthbuf_fragment,
	logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
	logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
	logdepthbuf_vertex: logdepthbuf_vertex,
	map_fragment: map_fragment,
	map_pars_fragment: map_pars_fragment,
	map_particle_fragment: map_particle_fragment,
	map_particle_pars_fragment: map_particle_pars_fragment,
	metalnessmap_fragment: metalnessmap_fragment,
	metalnessmap_pars_fragment: metalnessmap_pars_fragment,
	morphcolor_vertex: morphcolor_vertex,
	morphnormal_vertex: morphnormal_vertex,
	morphtarget_pars_vertex: morphtarget_pars_vertex,
	morphtarget_vertex: morphtarget_vertex,
	normal_fragment_begin: normal_fragment_begin,
	normal_fragment_maps: normal_fragment_maps,
	normal_pars_fragment: normal_pars_fragment,
	normal_pars_vertex: normal_pars_vertex,
	normal_vertex: normal_vertex,
	normalmap_pars_fragment: normalmap_pars_fragment,
	clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
	clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
	clearcoat_pars_fragment: clearcoat_pars_fragment,
	iridescence_pars_fragment: iridescence_pars_fragment,
	output_fragment: output_fragment,
	packing: packing,
	premultiplied_alpha_fragment: premultiplied_alpha_fragment,
	project_vertex: project_vertex,
	dithering_fragment: dithering_fragment,
	dithering_pars_fragment: dithering_pars_fragment,
	roughnessmap_fragment: roughnessmap_fragment,
	roughnessmap_pars_fragment: roughnessmap_pars_fragment,
	shadowmap_pars_fragment: shadowmap_pars_fragment,
	shadowmap_pars_vertex: shadowmap_pars_vertex,
	shadowmap_vertex: shadowmap_vertex,
	shadowmask_pars_fragment: shadowmask_pars_fragment,
	skinbase_vertex: skinbase_vertex,
	skinning_pars_vertex: skinning_pars_vertex,
	skinning_vertex: skinning_vertex,
	skinnormal_vertex: skinnormal_vertex,
	specularmap_fragment: specularmap_fragment,
	specularmap_pars_fragment: specularmap_pars_fragment,
	tonemapping_fragment: tonemapping_fragment,
	tonemapping_pars_fragment: tonemapping_pars_fragment,
	transmission_fragment: transmission_fragment,
	transmission_pars_fragment: transmission_pars_fragment,
	uv_pars_fragment: uv_pars_fragment,
	uv_pars_vertex: uv_pars_vertex,
	uv_vertex: uv_vertex,
	worldpos_vertex: worldpos_vertex,

	background_vert: vertex$h,
	background_frag: fragment$h,
	backgroundCube_vert: vertex$g,
	backgroundCube_frag: fragment$g,
	cube_vert: vertex$f,
	cube_frag: fragment$f,
	depth_vert: vertex$e,
	depth_frag: fragment$e,
	distanceRGBA_vert: vertex$d,
	distanceRGBA_frag: fragment$d,
	equirect_vert: vertex$c,
	equirect_frag: fragment$c,
	linedashed_vert: vertex$b,
	linedashed_frag: fragment$b,
	meshbasic_vert: vertex$a,
	meshbasic_frag: fragment$a,
	meshlambert_vert: vertex$9,
	meshlambert_frag: fragment$9,
	meshmatcap_vert: vertex$8,
	meshmatcap_frag: fragment$8,
	meshnormal_vert: vertex$7,
	meshnormal_frag: fragment$7,
	meshphong_vert: vertex$6,
	meshphong_frag: fragment$6,
	meshphysical_vert: vertex$5,
	meshphysical_frag: fragment$5,
	meshtoon_vert: vertex$4,
	meshtoon_frag: fragment$4,
	points_vert: vertex$3,
	points_frag: fragment$3,
	shadow_vert: vertex$2,
	shadow_frag: fragment$2,
	sprite_vert: vertex$1,
	sprite_frag: fragment$1
};

/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib = {

	common: {

		diffuse: { value: /*@__PURE__*/new Color(0xffffff) },
		opacity: { value: 1.0 },

		map: { value: null },
		mapTransform: { value: /*@__PURE__*/new Matrix3() },

		alphaMap: { value: null },
		alphaMapTransform: { value: /*@__PURE__*/new Matrix3() },

		alphaTest: { value: 0 }

	},

	specularmap: {

		specularMap: { value: null },
		specularMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	envmap: {

		envMap: { value: null },
		flipEnvMap: { value: -1 },
		reflectivity: { value: 1.0 }, // basic, lambert, phong
		ior: { value: 1.5 }, // physical
		refractionRatio: { value: 0.98 } // basic, lambert, phong

	},

	aomap: {

		aoMap: { value: null },
		aoMapIntensity: { value: 1 },
		aoMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	lightmap: {

		lightMap: { value: null },
		lightMapIntensity: { value: 1 },
		lightMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	bumpmap: {

		bumpMap: { value: null },
		bumpMapTransform: { value: /*@__PURE__*/new Matrix3() },
		bumpScale: { value: 1 }

	},

	normalmap: {

		normalMap: { value: null },
		normalMapTransform: { value: /*@__PURE__*/new Matrix3() },
		normalScale: { value: /*@__PURE__*/new Vector2(1, 1) }

	},

	displacementmap: {

		displacementMap: { value: null },
		displacementMapTransform: { value: /*@__PURE__*/new Matrix3() },
		displacementScale: { value: 1 },
		displacementBias: { value: 0 }

	},

	emissivemap: {

		emissiveMap: { value: null },
		emissiveMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	metalnessmap: {

		metalnessMap: { value: null },
		metalnessMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	roughnessmap: {

		roughnessMap: { value: null },
		roughnessMapTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	gradientmap: {

		gradientMap: { value: null }

	},

	fog: {

		fogDensity: { value: 0.00025 },
		fogNear: { value: 1 },
		fogFar: { value: 2000 },
		fogColor: { value: /*@__PURE__*/new Color(0xffffff) }

	},

	lights: {

		ambientLightColor: { value: [] },

		lightProbe: { value: [] },

		directionalLights: { value: [], properties: {
				direction: {},
				color: {}
			} },

		directionalLightShadows: { value: [], properties: {
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

		directionalShadowMap: { value: [] },
		directionalShadowMatrix: { value: [] },

		spotLights: { value: [], properties: {
				color: {},
				position: {},
				direction: {},
				distance: {},
				coneCos: {},
				penumbraCos: {},
				decay: {}
			} },

		spotLightShadows: { value: [], properties: {
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {}
			} },

		spotLightMap: { value: [] },
		spotShadowMap: { value: [] },
		spotLightMatrix: { value: [] },

		pointLights: { value: [], properties: {
				color: {},
				position: {},
				decay: {},
				distance: {}
			} },

		pointLightShadows: { value: [], properties: {
				shadowBias: {},
				shadowNormalBias: {},
				shadowRadius: {},
				shadowMapSize: {},
				shadowCameraNear: {},
				shadowCameraFar: {}
			} },

		pointShadowMap: { value: [] },
		pointShadowMatrix: { value: [] },

		hemisphereLights: { value: [], properties: {
				direction: {},
				skyColor: {},
				groundColor: {}
			} },

		// TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
		rectAreaLights: { value: [], properties: {
				color: {},
				position: {},
				width: {},
				height: {}
			} },

		ltc_1: { value: null },
		ltc_2: { value: null }

	},

	points: {

		diffuse: { value: /*@__PURE__*/new Color(0xffffff) },
		opacity: { value: 1.0 },
		size: { value: 1.0 },
		scale: { value: 1.0 },
		map: { value: null },
		alphaMap: { value: null },
		alphaTest: { value: 0 },
		uvTransform: { value: /*@__PURE__*/new Matrix3() }

	},

	sprite: {

		diffuse: { value: /*@__PURE__*/new Color(0xffffff) },
		opacity: { value: 1.0 },
		center: { value: /*@__PURE__*/new Vector2(0.5, 0.5) },
		rotation: { value: 0.0 },
		map: { value: null },
		mapTransform: { value: /*@__PURE__*/new Matrix3() },
		alphaMap: { value: null },
		alphaTest: { value: 0 }

	}

};

var ShaderLib = {

	basic: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.fog]),

		vertexShader: ShaderChunk.meshbasic_vert,
		fragmentShader: ShaderChunk.meshbasic_frag

	},

	lambert: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.fog, UniformsLib.lights, {
			emissive: { value: /*@__PURE__*/new Color(0x000000) }
		}]),

		vertexShader: ShaderChunk.meshlambert_vert,
		fragmentShader: ShaderChunk.meshlambert_frag

	},

	phong: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.fog, UniformsLib.lights, {
			emissive: { value: /*@__PURE__*/new Color(0x000000) },
			specular: { value: /*@__PURE__*/new Color(0x111111) },
			shininess: { value: 30 }
		}]),

		vertexShader: ShaderChunk.meshphong_vert,
		fragmentShader: ShaderChunk.meshphong_frag

	},

	standard: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.roughnessmap, UniformsLib.metalnessmap, UniformsLib.fog, UniformsLib.lights, {
			emissive: { value: /*@__PURE__*/new Color(0x000000) },
			roughness: { value: 1.0 },
			metalness: { value: 0.0 },
			envMapIntensity: { value: 1 // temporary
			} }]),

		vertexShader: ShaderChunk.meshphysical_vert,
		fragmentShader: ShaderChunk.meshphysical_frag

	},

	toon: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.gradientmap, UniformsLib.fog, UniformsLib.lights, {
			emissive: { value: /*@__PURE__*/new Color(0x000000) }
		}]),

		vertexShader: ShaderChunk.meshtoon_vert,
		fragmentShader: ShaderChunk.meshtoon_frag

	},

	matcap: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.fog, {
			matcap: { value: null }
		}]),

		vertexShader: ShaderChunk.meshmatcap_vert,
		fragmentShader: ShaderChunk.meshmatcap_frag

	},

	points: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.points, UniformsLib.fog]),

		vertexShader: ShaderChunk.points_vert,
		fragmentShader: ShaderChunk.points_frag

	},

	dashed: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.fog, {
			scale: { value: 1 },
			dashSize: { value: 1 },
			totalSize: { value: 2 }
		}]),

		vertexShader: ShaderChunk.linedashed_vert,
		fragmentShader: ShaderChunk.linedashed_frag

	},

	depth: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.displacementmap]),

		vertexShader: ShaderChunk.depth_vert,
		fragmentShader: ShaderChunk.depth_frag

	},

	normal: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, {
			opacity: { value: 1.0 }
		}]),

		vertexShader: ShaderChunk.meshnormal_vert,
		fragmentShader: ShaderChunk.meshnormal_frag

	},

	sprite: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.sprite, UniformsLib.fog]),

		vertexShader: ShaderChunk.sprite_vert,
		fragmentShader: ShaderChunk.sprite_frag

	},

	background: {

		uniforms: {
			uvTransform: { value: /*@__PURE__*/new Matrix3() },
			t2D: { value: null },
			backgroundIntensity: { value: 1 }
		},

		vertexShader: ShaderChunk.background_vert,
		fragmentShader: ShaderChunk.background_frag

	},

	backgroundCube: {

		uniforms: {
			envMap: { value: null },
			flipEnvMap: { value: -1 },
			backgroundBlurriness: { value: 0 },
			backgroundIntensity: { value: 1 }
		},

		vertexShader: ShaderChunk.backgroundCube_vert,
		fragmentShader: ShaderChunk.backgroundCube_frag

	},

	cube: {

		uniforms: {
			tCube: { value: null },
			tFlip: { value: -1 },
			opacity: { value: 1.0 }
		},

		vertexShader: ShaderChunk.cube_vert,
		fragmentShader: ShaderChunk.cube_frag

	},

	equirect: {

		uniforms: {
			tEquirect: { value: null }
		},

		vertexShader: ShaderChunk.equirect_vert,
		fragmentShader: ShaderChunk.equirect_frag

	},

	distanceRGBA: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.common, UniformsLib.displacementmap, {
			referencePosition: { value: /*@__PURE__*/new Vector3() },
			nearDistance: { value: 1 },
			farDistance: { value: 1000 }
		}]),

		vertexShader: ShaderChunk.distanceRGBA_vert,
		fragmentShader: ShaderChunk.distanceRGBA_frag

	},

	shadow: {

		uniforms: /*@__PURE__*/mergeUniforms([UniformsLib.lights, UniformsLib.fog, {
			color: { value: /*@__PURE__*/new Color(0x00000) },
			opacity: { value: 1.0 }
		}]),

		vertexShader: ShaderChunk.shadow_vert,
		fragmentShader: ShaderChunk.shadow_frag

	}

};

ShaderLib.physical = {

	uniforms: /*@__PURE__*/mergeUniforms([ShaderLib.standard.uniforms, {
		clearcoat: { value: 0 },
		clearcoatMap: { value: null },
		clearcoatMapTransform: { value: /*@__PURE__*/new Matrix3() },
		clearcoatNormalMap: { value: null },
		clearcoatNormalMapTransform: { value: /*@__PURE__*/new Matrix3() },
		clearcoatNormalScale: { value: /*@__PURE__*/new Vector2(1, 1) },
		clearcoatRoughness: { value: 0 },
		clearcoatRoughnessMap: { value: null },
		clearcoatRoughnessMapTransform: { value: /*@__PURE__*/new Matrix3() },
		iridescence: { value: 0 },
		iridescenceMap: { value: null },
		iridescenceMapTransform: { value: /*@__PURE__*/new Matrix3() },
		iridescenceIOR: { value: 1.3 },
		iridescenceThicknessMinimum: { value: 100 },
		iridescenceThicknessMaximum: { value: 400 },
		iridescenceThicknessMap: { value: null },
		iridescenceThicknessMapTransform: { value: /*@__PURE__*/new Matrix3() },
		sheen: { value: 0 },
		sheenColor: { value: /*@__PURE__*/new Color(0x000000) },
		sheenColorMap: { value: null },
		sheenColorMapTransform: { value: /*@__PURE__*/new Matrix3() },
		sheenRoughness: { value: 1 },
		sheenRoughnessMap: { value: null },
		sheenRoughnessMapTransform: { value: /*@__PURE__*/new Matrix3() },
		transmission: { value: 0 },
		transmissionMap: { value: null },
		transmissionMapTransform: { value: /*@__PURE__*/new Matrix3() },
		transmissionSamplerSize: { value: /*@__PURE__*/new Vector2() },
		transmissionSamplerMap: { value: null },
		thickness: { value: 0 },
		thicknessMap: { value: null },
		thicknessMapTransform: { value: /*@__PURE__*/new Matrix3() },
		attenuationDistance: { value: 0 },
		attenuationColor: { value: /*@__PURE__*/new Color(0x000000) },
		specularColor: { value: /*@__PURE__*/new Color(1, 1, 1) },
		specularColorMap: { value: null },
		specularColorMapTransform: { value: /*@__PURE__*/new Matrix3() },
		specularIntensity: { value: 1 },
		specularIntensityMap: { value: null },
		specularIntensityMapTransform: { value: /*@__PURE__*/new Matrix3() }
	}]),

	vertexShader: ShaderChunk.meshphysical_vert,
	fragmentShader: ShaderChunk.meshphysical_frag

};

var _rgb = { r: 0, b: 0, g: 0 };

function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {

	var clearColor = new Color(0x000000);
	var clearAlpha = alpha === true ? 0 : 1;

	var planeMesh = void 0;
	var boxMesh = void 0;

	var currentBackground = null;
	var currentBackgroundVersion = 0;
	var currentTonemapping = null;

	function render(renderList, scene) {

		var forceClear = false;
		var background = scene.isScene === true ? scene.background : null;

		if (background && background.isTexture) {

			var usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
			background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
		}

		// Ignore background in AR
		// TODO: Reconsider this.

		var xr = renderer.xr;
		var session = xr.getSession && xr.getSession();

		if (session && session.environmentBlendMode === 'additive') {

			background = null;
		}

		if (background === null) {

			setClear(clearColor, clearAlpha);
		} else if (background && background.isColor) {

			setClear(background, 1);
			forceClear = true;
		}

		if (renderer.autoClear || forceClear) {

			renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
		}

		if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {

			if (boxMesh === undefined) {

				boxMesh = new Mesh(new BoxGeometry(1, 1, 1), new ShaderMaterial({
					name: 'BackgroundCubeMaterial',
					uniforms: cloneUniforms(ShaderLib.backgroundCube.uniforms),
					vertexShader: ShaderLib.backgroundCube.vertexShader,
					fragmentShader: ShaderLib.backgroundCube.fragmentShader,
					side: BackSide,
					depthTest: false,
					depthWrite: false,
					fog: false
				}));

				boxMesh.geometry.deleteAttribute('normal');
				boxMesh.geometry.deleteAttribute('uv');

				boxMesh.onBeforeRender = function (renderer, scene, camera) {

					this.matrixWorld.copyPosition(camera.matrixWorld);
				};

				// add "envMap" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty(boxMesh.material, 'envMap', {

					get: function get() {

						return this.uniforms.envMap.value;
					}

				});

				objects.update(boxMesh);
			}

			boxMesh.material.uniforms.envMap.value = background;
			boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
			boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
			boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			boxMesh.material.toneMapped = background.encoding === sRGBEncoding ? false : true;

			if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {

				boxMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;
			}

			boxMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
		} else if (background && background.isTexture) {

			if (planeMesh === undefined) {

				planeMesh = new Mesh(new PlaneGeometry(2, 2), new ShaderMaterial({
					name: 'BackgroundMaterial',
					uniforms: cloneUniforms(ShaderLib.background.uniforms),
					vertexShader: ShaderLib.background.vertexShader,
					fragmentShader: ShaderLib.background.fragmentShader,
					side: FrontSide,
					depthTest: false,
					depthWrite: false,
					fog: false
				}));

				planeMesh.geometry.deleteAttribute('normal');

				// add "map" material property so the renderer can evaluate it like for built-in materials
				Object.defineProperty(planeMesh.material, 'map', {

					get: function get() {

						return this.uniforms.t2D.value;
					}

				});

				objects.update(planeMesh);
			}

			planeMesh.material.uniforms.t2D.value = background;
			planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
			planeMesh.material.toneMapped = background.encoding === sRGBEncoding ? false : true;

			if (background.matrixAutoUpdate === true) {

				background.updateMatrix();
			}

			planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);

			if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {

				planeMesh.material.needsUpdate = true;

				currentBackground = background;
				currentBackgroundVersion = background.version;
				currentTonemapping = renderer.toneMapping;
			}

			planeMesh.layers.enableAll();

			// push to the pre-sorted opaque render list
			renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
		}
	}

	function setClear(color, alpha) {

		color.getRGB(_rgb, getUnlitUniformColorSpace(renderer));

		state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha);
	}

	return {

		getClearColor: function getClearColor() {

			return clearColor;
		},
		setClearColor: function setClearColor(color) {
			var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;


			clearColor.set(color);
			clearAlpha = alpha;
			setClear(clearColor, clearAlpha);
		},
		getClearAlpha: function getClearAlpha() {

			return clearAlpha;
		},
		setClearAlpha: function setClearAlpha(alpha) {

			clearAlpha = alpha;
			setClear(clearColor, clearAlpha);
		},
		render: render

	};
}

function WebGLBindingStates(gl, extensions, attributes, capabilities) {

	var maxVertexAttributes = gl.getParameter(34921);

	var extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
	var vaoAvailable = capabilities.isWebGL2 || extension !== null;

	var bindingStates = {};

	var defaultState = createBindingState(null);
	var currentState = defaultState;
	var forceUpdate = false;

	function setup(object, material, program, geometry, index) {

		var updateBuffers = false;

		if (vaoAvailable) {

			var state = getBindingState(geometry, program, material);

			if (currentState !== state) {

				currentState = state;
				bindVertexArrayObject(currentState.object);
			}

			updateBuffers = needsUpdate(object, geometry, program, index);

			if (updateBuffers) saveCache(object, geometry, program, index);
		} else {

			var wireframe = material.wireframe === true;

			if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {

				currentState.geometry = geometry.id;
				currentState.program = program.id;
				currentState.wireframe = wireframe;

				updateBuffers = true;
			}
		}

		if (index !== null) {

			attributes.update(index, 34963);
		}

		if (updateBuffers || forceUpdate) {

			forceUpdate = false;

			setupVertexAttributes(object, material, program, geometry);

			if (index !== null) {

				gl.bindBuffer(34963, attributes.get(index).buffer);
			}
		}
	}

	function createVertexArrayObject() {

		if (capabilities.isWebGL2) return gl.createVertexArray();

		return extension.createVertexArrayOES();
	}

	function bindVertexArrayObject(vao) {

		if (capabilities.isWebGL2) return gl.bindVertexArray(vao);

		return extension.bindVertexArrayOES(vao);
	}

	function deleteVertexArrayObject(vao) {

		if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);

		return extension.deleteVertexArrayOES(vao);
	}

	function getBindingState(geometry, program, material) {

		var wireframe = material.wireframe === true;

		var programMap = bindingStates[geometry.id];

		if (programMap === undefined) {

			programMap = {};
			bindingStates[geometry.id] = programMap;
		}

		var stateMap = programMap[program.id];

		if (stateMap === undefined) {

			stateMap = {};
			programMap[program.id] = stateMap;
		}

		var state = stateMap[wireframe];

		if (state === undefined) {

			state = createBindingState(createVertexArrayObject());
			stateMap[wireframe] = state;
		}

		return state;
	}

	function createBindingState(vao) {

		var newAttributes = [];
		var enabledAttributes = [];
		var attributeDivisors = [];

		for (var i = 0; i < maxVertexAttributes; i++) {

			newAttributes[i] = 0;
			enabledAttributes[i] = 0;
			attributeDivisors[i] = 0;
		}

		return {

			// for backward compatibility on non-VAO support browser
			geometry: null,
			program: null,
			wireframe: false,

			newAttributes: newAttributes,
			enabledAttributes: enabledAttributes,
			attributeDivisors: attributeDivisors,
			object: vao,
			attributes: {},
			index: null

		};
	}

	function needsUpdate(object, geometry, program, index) {

		var cachedAttributes = currentState.attributes;
		var geometryAttributes = geometry.attributes;

		var attributesNum = 0;

		var programAttributes = program.getAttributes();

		for (var name in programAttributes) {

			var programAttribute = programAttributes[name];

			if (programAttribute.location >= 0) {

				var cachedAttribute = cachedAttributes[name];
				var geometryAttribute = geometryAttributes[name];

				if (geometryAttribute === undefined) {

					if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
					if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
				}

				if (cachedAttribute === undefined) return true;

				if (cachedAttribute.attribute !== geometryAttribute) return true;

				if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;

				attributesNum++;
			}
		}

		if (currentState.attributesNum !== attributesNum) return true;

		if (currentState.index !== index) return true;

		return false;
	}

	function saveCache(object, geometry, program, index) {

		var cache = {};
		var attributes = geometry.attributes;
		var attributesNum = 0;

		var programAttributes = program.getAttributes();

		for (var name in programAttributes) {

			var programAttribute = programAttributes[name];

			if (programAttribute.location >= 0) {

				var attribute = attributes[name];

				if (attribute === undefined) {

					if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
					if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
				}

				var data = {};
				data.attribute = attribute;

				if (attribute && attribute.data) {

					data.data = attribute.data;
				}

				cache[name] = data;

				attributesNum++;
			}
		}

		currentState.attributes = cache;
		currentState.attributesNum = attributesNum;

		currentState.index = index;
	}

	function initAttributes() {

		var newAttributes = currentState.newAttributes;

		for (var i = 0, il = newAttributes.length; i < il; i++) {

			newAttributes[i] = 0;
		}
	}

	function enableAttribute(attribute) {

		enableAttributeAndDivisor(attribute, 0);
	}

	function enableAttributeAndDivisor(attribute, meshPerAttribute) {

		var newAttributes = currentState.newAttributes;
		var enabledAttributes = currentState.enabledAttributes;
		var attributeDivisors = currentState.attributeDivisors;

		newAttributes[attribute] = 1;

		if (enabledAttributes[attribute] === 0) {

			gl.enableVertexAttribArray(attribute);
			enabledAttributes[attribute] = 1;
		}

		if (attributeDivisors[attribute] !== meshPerAttribute) {

			var _extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');

			_extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
			attributeDivisors[attribute] = meshPerAttribute;
		}
	}

	function disableUnusedAttributes() {

		var newAttributes = currentState.newAttributes;
		var enabledAttributes = currentState.enabledAttributes;

		for (var i = 0, il = enabledAttributes.length; i < il; i++) {

			if (enabledAttributes[i] !== newAttributes[i]) {

				gl.disableVertexAttribArray(i);
				enabledAttributes[i] = 0;
			}
		}
	}

	function vertexAttribPointer(index, size, type, normalized, stride, offset) {

		if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {

			gl.vertexAttribIPointer(index, size, type, stride, offset);
		} else {

			gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
		}
	}

	function setupVertexAttributes(object, material, program, geometry) {

		if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {

			if (extensions.get('ANGLE_instanced_arrays') === null) return;
		}

		initAttributes();

		var geometryAttributes = geometry.attributes;

		var programAttributes = program.getAttributes();

		var materialDefaultAttributeValues = material.defaultAttributeValues;

		for (var name in programAttributes) {

			var programAttribute = programAttributes[name];

			if (programAttribute.location >= 0) {

				var geometryAttribute = geometryAttributes[name];

				if (geometryAttribute === undefined) {

					if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
					if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
				}

				if (geometryAttribute !== undefined) {

					var normalized = geometryAttribute.normalized;
					var size = geometryAttribute.itemSize;

					var attribute = attributes.get(geometryAttribute);

					// TODO Attribute may not be available on context restore

					if (attribute === undefined) continue;

					var buffer = attribute.buffer;
					var type = attribute.type;
					var bytesPerElement = attribute.bytesPerElement;

					if (geometryAttribute.isInterleavedBufferAttribute) {

						var data = geometryAttribute.data;
						var stride = data.stride;
						var offset = geometryAttribute.offset;

						if (data.isInstancedInterleavedBuffer) {

							for (var i = 0; i < programAttribute.locationSize; i++) {

								enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
							}

							if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {

								geometry._maxInstanceCount = data.meshPerAttribute * data.count;
							}
						} else {

							for (var _i23 = 0; _i23 < programAttribute.locationSize; _i23++) {

								enableAttribute(programAttribute.location + _i23);
							}
						}

						gl.bindBuffer(34962, buffer);

						for (var _i24 = 0; _i24 < programAttribute.locationSize; _i24++) {

							vertexAttribPointer(programAttribute.location + _i24, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * _i24) * bytesPerElement);
						}
					} else {

						if (geometryAttribute.isInstancedBufferAttribute) {

							for (var _i25 = 0; _i25 < programAttribute.locationSize; _i25++) {

								enableAttributeAndDivisor(programAttribute.location + _i25, geometryAttribute.meshPerAttribute);
							}

							if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {

								geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
							}
						} else {

							for (var _i26 = 0; _i26 < programAttribute.locationSize; _i26++) {

								enableAttribute(programAttribute.location + _i26);
							}
						}

						gl.bindBuffer(34962, buffer);

						for (var _i27 = 0; _i27 < programAttribute.locationSize; _i27++) {

							vertexAttribPointer(programAttribute.location + _i27, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * _i27 * bytesPerElement);
						}
					}
				} else if (materialDefaultAttributeValues !== undefined) {

					var _value2 = materialDefaultAttributeValues[name];

					if (_value2 !== undefined) {

						switch (_value2.length) {

							case 2:
								gl.vertexAttrib2fv(programAttribute.location, _value2);
								break;

							case 3:
								gl.vertexAttrib3fv(programAttribute.location, _value2);
								break;

							case 4:
								gl.vertexAttrib4fv(programAttribute.location, _value2);
								break;

							default:
								gl.vertexAttrib1fv(programAttribute.location, _value2);

						}
					}
				}
			}
		}

		disableUnusedAttributes();
	}

	function dispose() {

		reset();

		for (var geometryId in bindingStates) {

			var programMap = bindingStates[geometryId];

			for (var programId in programMap) {

				var stateMap = programMap[programId];

				for (var wireframe in stateMap) {

					deleteVertexArrayObject(stateMap[wireframe].object);

					delete stateMap[wireframe];
				}

				delete programMap[programId];
			}

			delete bindingStates[geometryId];
		}
	}

	function releaseStatesOfGeometry(geometry) {

		if (bindingStates[geometry.id] === undefined) return;

		var programMap = bindingStates[geometry.id];

		for (var programId in programMap) {

			var stateMap = programMap[programId];

			for (var wireframe in stateMap) {

				deleteVertexArrayObject(stateMap[wireframe].object);

				delete stateMap[wireframe];
			}

			delete programMap[programId];
		}

		delete bindingStates[geometry.id];
	}

	function releaseStatesOfProgram(program) {

		for (var geometryId in bindingStates) {

			var programMap = bindingStates[geometryId];

			if (programMap[program.id] === undefined) continue;

			var stateMap = programMap[program.id];

			for (var wireframe in stateMap) {

				deleteVertexArrayObject(stateMap[wireframe].object);

				delete stateMap[wireframe];
			}

			delete programMap[program.id];
		}
	}

	function reset() {

		resetDefaultState();
		forceUpdate = true;

		if (currentState === defaultState) return;

		currentState = defaultState;
		bindVertexArrayObject(currentState.object);
	}

	// for backward-compatibility

	function resetDefaultState() {

		defaultState.geometry = null;
		defaultState.program = null;
		defaultState.wireframe = false;
	}

	return {

		setup: setup,
		reset: reset,
		resetDefaultState: resetDefaultState,
		dispose: dispose,
		releaseStatesOfGeometry: releaseStatesOfGeometry,
		releaseStatesOfProgram: releaseStatesOfProgram,

		initAttributes: initAttributes,
		enableAttribute: enableAttribute,
		disableUnusedAttributes: disableUnusedAttributes

	};
}

function WebGLBufferRenderer(gl, extensions, info, capabilities) {

	var isWebGL2 = capabilities.isWebGL2;

	var mode = void 0;

	function setMode(value) {

		mode = value;
	}

	function render(start, count) {

		gl.drawArrays(mode, start, count);

		info.update(count, mode, 1);
	}

	function renderInstances(start, count, primcount) {

		if (primcount === 0) return;

		var extension = void 0,
		    methodName = void 0;

		if (isWebGL2) {

			extension = gl;
			methodName = 'drawArraysInstanced';
		} else {

			extension = extensions.get('ANGLE_instanced_arrays');
			methodName = 'drawArraysInstancedANGLE';

			if (extension === null) {

				console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
				return;
			}
		}

		extension[methodName](mode, start, count, primcount);

		info.update(count, mode, primcount);
	}

	//

	this.setMode = setMode;
	this.render = render;
	this.renderInstances = renderInstances;
}

function WebGLCapabilities(gl, extensions, parameters) {

	var maxAnisotropy = void 0;

	function getMaxAnisotropy() {

		if (maxAnisotropy !== undefined) return maxAnisotropy;

		if (extensions.has('EXT_texture_filter_anisotropic') === true) {

			var extension = extensions.get('EXT_texture_filter_anisotropic');

			maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
		} else {

			maxAnisotropy = 0;
		}

		return maxAnisotropy;
	}

	function getMaxPrecision(precision) {

		if (precision === 'highp') {

			if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {

				return 'highp';
			}

			precision = 'mediump';
		}

		if (precision === 'mediump') {

			if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {

				return 'mediump';
			}
		}

		return 'lowp';
	}

	var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl.constructor.name === 'WebGL2RenderingContext';

	var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
	var maxPrecision = getMaxPrecision(precision);

	if (maxPrecision !== precision) {

		console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
		precision = maxPrecision;
	}

	var drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');

	var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;

	var maxTextures = gl.getParameter(34930);
	var maxVertexTextures = gl.getParameter(35660);
	var maxTextureSize = gl.getParameter(3379);
	var maxCubemapSize = gl.getParameter(34076);

	var maxAttributes = gl.getParameter(34921);
	var maxVertexUniforms = gl.getParameter(36347);
	var maxVaryings = gl.getParameter(36348);
	var maxFragmentUniforms = gl.getParameter(36349);

	var vertexTextures = maxVertexTextures > 0;
	var floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
	var floatVertexTextures = vertexTextures && floatFragmentTextures;

	var maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;

	return {

		isWebGL2: isWebGL2,

		drawBuffers: drawBuffers,

		getMaxAnisotropy: getMaxAnisotropy,
		getMaxPrecision: getMaxPrecision,

		precision: precision,
		logarithmicDepthBuffer: logarithmicDepthBuffer,

		maxTextures: maxTextures,
		maxVertexTextures: maxVertexTextures,
		maxTextureSize: maxTextureSize,
		maxCubemapSize: maxCubemapSize,

		maxAttributes: maxAttributes,
		maxVertexUniforms: maxVertexUniforms,
		maxVaryings: maxVaryings,
		maxFragmentUniforms: maxFragmentUniforms,

		vertexTextures: vertexTextures,
		floatFragmentTextures: floatFragmentTextures,
		floatVertexTextures: floatVertexTextures,

		maxSamples: maxSamples

	};
}

function WebGLClipping(properties) {

	var scope = this;

	var globalState = null,
	    numGlobalPlanes = 0,
	    localClippingEnabled = false,
	    renderingShadows = false;

	var plane = new Plane(),
	    viewNormalMatrix = new Matrix3(),
	    uniform = { value: null, needsUpdate: false };

	this.uniform = uniform;
	this.numPlanes = 0;
	this.numIntersection = 0;

	this.init = function (planes, enableLocalClipping) {

		var enabled = planes.length !== 0 || enableLocalClipping ||
		// enable state of previous frame - the clipping code has to
		// run another frame in order to reset the state:
		numGlobalPlanes !== 0 || localClippingEnabled;

		localClippingEnabled = enableLocalClipping;

		numGlobalPlanes = planes.length;

		return enabled;
	};

	this.beginShadows = function () {

		renderingShadows = true;
		projectPlanes(null);
	};

	this.endShadows = function () {

		renderingShadows = false;
	};

	this.setGlobalState = function (planes, camera) {

		globalState = projectPlanes(planes, camera, 0);
	};

	this.setState = function (material, camera, useCache) {

		var planes = material.clippingPlanes,
		    clipIntersection = material.clipIntersection,
		    clipShadows = material.clipShadows;

		var materialProperties = properties.get(material);

		if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {

			// there's no local clipping

			if (renderingShadows) {

				// there's no global clipping

				projectPlanes(null);
			} else {

				resetGlobalState();
			}
		} else {

			var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
			    lGlobal = nGlobal * 4;

			var dstArray = materialProperties.clippingState || null;

			uniform.value = dstArray; // ensure unique state

			dstArray = projectPlanes(planes, camera, lGlobal, useCache);

			for (var i = 0; i !== lGlobal; ++i) {

				dstArray[i] = globalState[i];
			}

			materialProperties.clippingState = dstArray;
			this.numIntersection = clipIntersection ? this.numPlanes : 0;
			this.numPlanes += nGlobal;
		}
	};

	function resetGlobalState() {

		if (uniform.value !== globalState) {

			uniform.value = globalState;
			uniform.needsUpdate = numGlobalPlanes > 0;
		}

		scope.numPlanes = numGlobalPlanes;
		scope.numIntersection = 0;
	}

	function projectPlanes(planes, camera, dstOffset, skipTransform) {

		var nPlanes = planes !== null ? planes.length : 0;
		var dstArray = null;

		if (nPlanes !== 0) {

			dstArray = uniform.value;

			if (skipTransform !== true || dstArray === null) {

				var flatSize = dstOffset + nPlanes * 4,
				    viewMatrix = camera.matrixWorldInverse;

				viewNormalMatrix.getNormalMatrix(viewMatrix);

				if (dstArray === null || dstArray.length < flatSize) {

					dstArray = new Float32Array(flatSize);
				}

				for (var i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4) {

					plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);

					plane.normal.toArray(dstArray, i4);
					dstArray[i4 + 3] = plane.constant;
				}
			}

			uniform.value = dstArray;
			uniform.needsUpdate = true;
		}

		scope.numPlanes = nPlanes;
		scope.numIntersection = 0;

		return dstArray;
	}
}

function WebGLCubeMaps(renderer) {

	var cubemaps = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function mapTextureMapping(texture, mapping) {

		if (mapping === EquirectangularReflectionMapping) {

			texture.mapping = CubeReflectionMapping;
		} else if (mapping === EquirectangularRefractionMapping) {

			texture.mapping = CubeRefractionMapping;
		}

		return texture;
	}

	function get(texture) {

		if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {

			var mapping = texture.mapping;

			if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {

				if (cubemaps.has(texture)) {

					var cubemap = cubemaps.get(texture).texture;
					return mapTextureMapping(cubemap, texture.mapping);
				} else {

					var image = texture.image;

					if (image && image.height > 0) {

						var renderTarget = new WebGLCubeRenderTarget(image.height / 2);
						renderTarget.fromEquirectangularTexture(renderer, texture);
						cubemaps.set(texture, renderTarget);

						texture.addEventListener('dispose', onTextureDispose);

						return mapTextureMapping(renderTarget.texture, texture.mapping);
					} else {

						// image not yet ready. try the conversion next frame

						return null;
					}
				}
			}
		}

		return texture;
	}

	function onTextureDispose(event) {

		var texture = event.target;

		texture.removeEventListener('dispose', onTextureDispose);

		var cubemap = cubemaps.get(texture);

		if (cubemap !== undefined) {

			cubemaps.delete(texture);
			cubemap.dispose();
		}
	}

	function dispose() {

		cubemaps = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	}

	return {
		get: get,
		dispose: dispose
	};
}

var OrthographicCamera = function (_Camera2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(OrthographicCamera, _Camera2);

	function OrthographicCamera() {
		var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
		var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var bottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
		var near = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.1;
		var far = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2000;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, OrthographicCamera);

		var _this32 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OrthographicCamera.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(OrthographicCamera)).call(this));

		_this32.isOrthographicCamera = true;

		_this32.type = 'OrthographicCamera';

		_this32.zoom = 1;
		_this32.view = null;

		_this32.left = left;
		_this32.right = right;
		_this32.top = top;
		_this32.bottom = bottom;

		_this32.near = near;
		_this32.far = far;

		_this32.updateProjectionMatrix();

		return _this32;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(OrthographicCamera, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(OrthographicCamera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(OrthographicCamera.prototype), 'copy', this).call(this, source, recursive);

			this.left = source.left;
			this.right = source.right;
			this.top = source.top;
			this.bottom = source.bottom;
			this.near = source.near;
			this.far = source.far;

			this.zoom = source.zoom;
			this.view = source.view === null ? null : __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.view);

			return this;
		}
	}, {
		key: 'setViewOffset',
		value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {

			if (this.view === null) {

				this.view = {
					enabled: true,
					fullWidth: 1,
					fullHeight: 1,
					offsetX: 0,
					offsetY: 0,
					width: 1,
					height: 1
				};
			}

			this.view.enabled = true;
			this.view.fullWidth = fullWidth;
			this.view.fullHeight = fullHeight;
			this.view.offsetX = x;
			this.view.offsetY = y;
			this.view.width = width;
			this.view.height = height;

			this.updateProjectionMatrix();
		}
	}, {
		key: 'clearViewOffset',
		value: function clearViewOffset() {

			if (this.view !== null) {

				this.view.enabled = false;
			}

			this.updateProjectionMatrix();
		}
	}, {
		key: 'updateProjectionMatrix',
		value: function updateProjectionMatrix() {

			var dx = (this.right - this.left) / (2 * this.zoom);
			var dy = (this.top - this.bottom) / (2 * this.zoom);
			var cx = (this.right + this.left) / 2;
			var cy = (this.top + this.bottom) / 2;

			var left = cx - dx;
			var right = cx + dx;
			var top = cy + dy;
			var bottom = cy - dy;

			if (this.view !== null && this.view.enabled) {

				var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
				var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;

				left += scaleW * this.view.offsetX;
				right = left + scaleW * this.view.width;
				top -= scaleH * this.view.offsetY;
				bottom = top - scaleH * this.view.height;
			}

			this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);

			this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(OrthographicCamera.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(OrthographicCamera.prototype), 'toJSON', this).call(this, meta);

			data.object.zoom = this.zoom;
			data.object.left = this.left;
			data.object.right = this.right;
			data.object.top = this.top;
			data.object.bottom = this.bottom;
			data.object.near = this.near;
			data.object.far = this.far;

			if (this.view !== null) data.object.view = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, this.view);

			return data;
		}
	}]);

	return OrthographicCamera;
}(Camera);

var LOD_MIN = 4;

// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
var EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];

// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
var MAX_SAMPLES = 20;

var _flatCamera = /*@__PURE__*/new OrthographicCamera();
var _clearColor = /*@__PURE__*/new Color();
var _oldTarget = null;

// Golden Ratio
var PHI = (1 + Math.sqrt(5)) / 2;
var INV_PHI = 1 / PHI;

// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
var _axisDirections = [
/*@__PURE__*/new Vector3(1, 1, 1),
/*@__PURE__*/new Vector3(-1, 1, 1),
/*@__PURE__*/new Vector3(1, 1, -1),
/*@__PURE__*/new Vector3(-1, 1, -1),
/*@__PURE__*/new Vector3(0, PHI, INV_PHI),
/*@__PURE__*/new Vector3(0, PHI, -INV_PHI),
/*@__PURE__*/new Vector3(INV_PHI, 0, PHI),
/*@__PURE__*/new Vector3(-INV_PHI, 0, PHI),
/*@__PURE__*/new Vector3(PHI, INV_PHI, 0),
/*@__PURE__*/new Vector3(-PHI, INV_PHI, 0)];

/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/

var PMREMGenerator = function () {
	function PMREMGenerator(renderer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PMREMGenerator);

		this._renderer = renderer;
		this._pingPongRenderTarget = null;

		this._lodMax = 0;
		this._cubeSize = 0;
		this._lodPlanes = [];
		this._sizeLods = [];
		this._sigmas = [];

		this._blurMaterial = null;
		this._cubemapMaterial = null;
		this._equirectMaterial = null;

		this._compileMaterial(this._blurMaterial);
	}

	/**
  * Generates a PMREM from a supplied Scene, which can be faster than using an
  * image if networking bandwidth is low. Optional sigma specifies a blur radius
  * in radians to be applied to the scene before PMREM generation. Optional near
  * and far planes ensure the scene is rendered in its entirety (the cubeCamera
  * is placed at the origin).
  */


	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PMREMGenerator, [{
		key: 'fromScene',
		value: function fromScene(scene) {
			var sigma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
			var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
			var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;


			_oldTarget = this._renderer.getRenderTarget();

			this._setSize(256);

			var cubeUVRenderTarget = this._allocateTargets();
			cubeUVRenderTarget.depthBuffer = true;

			this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);

			if (sigma > 0) {

				this._blur(cubeUVRenderTarget, 0, 0, sigma);
			}

			this._applyPMREM(cubeUVRenderTarget);
			this._cleanup(cubeUVRenderTarget);

			return cubeUVRenderTarget;
		}

		/**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   */

	}, {
		key: 'fromEquirectangular',
		value: function fromEquirectangular(equirectangular) {
			var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


			return this._fromTexture(equirectangular, renderTarget);
		}

		/**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   */

	}, {
		key: 'fromCubemap',
		value: function fromCubemap(cubemap) {
			var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


			return this._fromTexture(cubemap, renderTarget);
		}

		/**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */

	}, {
		key: 'compileCubemapShader',
		value: function compileCubemapShader() {

			if (this._cubemapMaterial === null) {

				this._cubemapMaterial = _getCubemapMaterial();
				this._compileMaterial(this._cubemapMaterial);
			}
		}

		/**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */

	}, {
		key: 'compileEquirectangularShader',
		value: function compileEquirectangularShader() {

			if (this._equirectMaterial === null) {

				this._equirectMaterial = _getEquirectMaterial();
				this._compileMaterial(this._equirectMaterial);
			}
		}

		/**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */

	}, {
		key: 'dispose',
		value: function dispose() {

			this._dispose();

			if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
			if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
		}

		// private interface

	}, {
		key: '_setSize',
		value: function _setSize(cubeSize) {

			this._lodMax = Math.floor(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2___default()(cubeSize));
			this._cubeSize = Math.pow(2, this._lodMax);
		}
	}, {
		key: '_dispose',
		value: function _dispose() {

			if (this._blurMaterial !== null) this._blurMaterial.dispose();

			if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();

			for (var i = 0; i < this._lodPlanes.length; i++) {

				this._lodPlanes[i].dispose();
			}
		}
	}, {
		key: '_cleanup',
		value: function _cleanup(outputTarget) {

			this._renderer.setRenderTarget(_oldTarget);
			outputTarget.scissorTest = false;
			_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
		}
	}, {
		key: '_fromTexture',
		value: function _fromTexture(texture, renderTarget) {

			if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {

				this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
			} else {
				// Equirectangular

				this._setSize(texture.image.width / 4);
			}

			_oldTarget = this._renderer.getRenderTarget();

			var cubeUVRenderTarget = renderTarget || this._allocateTargets();
			this._textureToCubeUV(texture, cubeUVRenderTarget);
			this._applyPMREM(cubeUVRenderTarget);
			this._cleanup(cubeUVRenderTarget);

			return cubeUVRenderTarget;
		}
	}, {
		key: '_allocateTargets',
		value: function _allocateTargets() {

			var width = 3 * Math.max(this._cubeSize, 16 * 7);
			var height = 4 * this._cubeSize;

			var params = {
				magFilter: LinearFilter,
				minFilter: LinearFilter,
				generateMipmaps: false,
				type: HalfFloatType,
				format: RGBAFormat,
				encoding: LinearEncoding,
				depthBuffer: false
			};

			var cubeUVRenderTarget = _createRenderTarget(width, height, params);

			if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {

				if (this._pingPongRenderTarget !== null) {

					this._dispose();
				}

				this._pingPongRenderTarget = _createRenderTarget(width, height, params);

				var _lodMax = this._lodMax;

				var _createPlanes2 = _createPlanes(_lodMax);

				this._sizeLods = _createPlanes2.sizeLods;
				this._lodPlanes = _createPlanes2.lodPlanes;
				this._sigmas = _createPlanes2.sigmas;


				this._blurMaterial = _getBlurShader(_lodMax, width, height);
			}

			return cubeUVRenderTarget;
		}
	}, {
		key: '_compileMaterial',
		value: function _compileMaterial(material) {

			var tmpMesh = new Mesh(this._lodPlanes[0], material);
			this._renderer.compile(tmpMesh, _flatCamera);
		}
	}, {
		key: '_sceneToCubeUV',
		value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {

			var fov = 90;
			var aspect = 1;
			var cubeCamera = new PerspectiveCamera(fov, aspect, near, far);
			var upSign = [1, -1, 1, 1, 1, 1];
			var forwardSign = [1, 1, 1, -1, -1, -1];
			var renderer = this._renderer;

			var originalAutoClear = renderer.autoClear;
			var toneMapping = renderer.toneMapping;
			renderer.getClearColor(_clearColor);

			renderer.toneMapping = NoToneMapping;
			renderer.autoClear = false;

			var backgroundMaterial = new MeshBasicMaterial({
				name: 'PMREM.Background',
				side: BackSide,
				depthWrite: false,
				depthTest: false
			});

			var backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);

			var useSolidColor = false;
			var background = scene.background;

			if (background) {

				if (background.isColor) {

					backgroundMaterial.color.copy(background);
					scene.background = null;
					useSolidColor = true;
				}
			} else {

				backgroundMaterial.color.copy(_clearColor);
				useSolidColor = true;
			}

			for (var i = 0; i < 6; i++) {

				var col = i % 3;

				if (col === 0) {

					cubeCamera.up.set(0, upSign[i], 0);
					cubeCamera.lookAt(forwardSign[i], 0, 0);
				} else if (col === 1) {

					cubeCamera.up.set(0, 0, upSign[i]);
					cubeCamera.lookAt(0, forwardSign[i], 0);
				} else {

					cubeCamera.up.set(0, upSign[i], 0);
					cubeCamera.lookAt(0, 0, forwardSign[i]);
				}

				var size = this._cubeSize;

				_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);

				renderer.setRenderTarget(cubeUVRenderTarget);

				if (useSolidColor) {

					renderer.render(backgroundBox, cubeCamera);
				}

				renderer.render(scene, cubeCamera);
			}

			backgroundBox.geometry.dispose();
			backgroundBox.material.dispose();

			renderer.toneMapping = toneMapping;
			renderer.autoClear = originalAutoClear;
			scene.background = background;
		}
	}, {
		key: '_textureToCubeUV',
		value: function _textureToCubeUV(texture, cubeUVRenderTarget) {

			var renderer = this._renderer;

			var isCubeTexture = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;

			if (isCubeTexture) {

				if (this._cubemapMaterial === null) {

					this._cubemapMaterial = _getCubemapMaterial();
				}

				this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
			} else {

				if (this._equirectMaterial === null) {

					this._equirectMaterial = _getEquirectMaterial();
				}
			}

			var material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
			var mesh = new Mesh(this._lodPlanes[0], material);

			var uniforms = material.uniforms;

			uniforms['envMap'].value = texture;

			var size = this._cubeSize;

			_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);

			renderer.setRenderTarget(cubeUVRenderTarget);
			renderer.render(mesh, _flatCamera);
		}
	}, {
		key: '_applyPMREM',
		value: function _applyPMREM(cubeUVRenderTarget) {

			var renderer = this._renderer;
			var autoClear = renderer.autoClear;
			renderer.autoClear = false;

			for (var i = 1; i < this._lodPlanes.length; i++) {

				var sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);

				var poleAxis = _axisDirections[(i - 1) % _axisDirections.length];

				this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
			}

			renderer.autoClear = autoClear;
		}

		/**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */

	}, {
		key: '_blur',
		value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {

			var pingPongRenderTarget = this._pingPongRenderTarget;

			this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);

			this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
		}
	}, {
		key: '_halfBlur',
		value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {

			var renderer = this._renderer;
			var blurMaterial = this._blurMaterial;

			if (direction !== 'latitudinal' && direction !== 'longitudinal') {

				console.error('blur direction must be either latitudinal or longitudinal!');
			}

			// Number of standard deviations at which to cut off the discrete approximation.
			var STANDARD_DEVIATIONS = 3;

			var blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
			var blurUniforms = blurMaterial.uniforms;

			var pixels = this._sizeLods[lodIn] - 1;
			var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
			var sigmaPixels = sigmaRadians / radiansPerPixel;
			var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;

			if (samples > MAX_SAMPLES) {

				console.warn('sigmaRadians, ' + sigmaRadians + ', is too large and will clip, as it requested ' + samples + ' samples when the maximum is set to ' + MAX_SAMPLES);
			}

			var weights = [];
			var sum = 0;

			for (var i = 0; i < MAX_SAMPLES; ++i) {

				var _x145 = i / sigmaPixels;
				var weight = Math.exp(-_x145 * _x145 / 2);
				weights.push(weight);

				if (i === 0) {

					sum += weight;
				} else if (i < samples) {

					sum += 2 * weight;
				}
			}

			for (var _i28 = 0; _i28 < weights.length; _i28++) {

				weights[_i28] = weights[_i28] / sum;
			}

			blurUniforms['envMap'].value = targetIn.texture;
			blurUniforms['samples'].value = samples;
			blurUniforms['weights'].value = weights;
			blurUniforms['latitudinal'].value = direction === 'latitudinal';

			if (poleAxis) {

				blurUniforms['poleAxis'].value = poleAxis;
			}

			var _lodMax = this._lodMax;

			blurUniforms['dTheta'].value = radiansPerPixel;
			blurUniforms['mipInt'].value = _lodMax - lodIn;

			var outputSize = this._sizeLods[lodOut];
			var x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
			var y = 4 * (this._cubeSize - outputSize);

			_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
			renderer.setRenderTarget(targetOut);
			renderer.render(blurMesh, _flatCamera);
		}
	}]);

	return PMREMGenerator;
}();

function _createPlanes(lodMax) {

	var lodPlanes = [];
	var sizeLods = [];
	var sigmas = [];

	var lod = lodMax;

	var totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;

	for (var i = 0; i < totalLods; i++) {

		var sizeLod = Math.pow(2, lod);
		sizeLods.push(sizeLod);
		var sigma = 1.0 / sizeLod;

		if (i > lodMax - LOD_MIN) {

			sigma = EXTRA_LOD_SIGMA[i - lodMax + LOD_MIN - 1];
		} else if (i === 0) {

			sigma = 0;
		}

		sigmas.push(sigma);

		var texelSize = 1.0 / (sizeLod - 2);
		var min = -texelSize;
		var max = 1 + texelSize;
		var uv1 = [min, min, max, min, max, max, min, min, max, max, min, max];

		var cubeFaces = 6;
		var _vertices = 6;
		var positionSize = 3;
		var uvSize = 2;
		var faceIndexSize = 1;

		var position = new Float32Array(positionSize * _vertices * cubeFaces);
		var uv = new Float32Array(uvSize * _vertices * cubeFaces);
		var faceIndex = new Float32Array(faceIndexSize * _vertices * cubeFaces);

		for (var face = 0; face < cubeFaces; face++) {

			var x = face % 3 * 2 / 3 - 1;
			var y = face > 2 ? 0 : -1;
			var coordinates = [x, y, 0, x + 2 / 3, y, 0, x + 2 / 3, y + 1, 0, x, y, 0, x + 2 / 3, y + 1, 0, x, y + 1, 0];
			position.set(coordinates, positionSize * _vertices * face);
			uv.set(uv1, uvSize * _vertices * face);
			var fill = [face, face, face, face, face, face];
			faceIndex.set(fill, faceIndexSize * _vertices * face);
		}

		var planes = new BufferGeometry();
		planes.setAttribute('position', new BufferAttribute(position, positionSize));
		planes.setAttribute('uv', new BufferAttribute(uv, uvSize));
		planes.setAttribute('faceIndex', new BufferAttribute(faceIndex, faceIndexSize));
		lodPlanes.push(planes);

		if (lod > LOD_MIN) {

			lod--;
		}
	}

	return { lodPlanes: lodPlanes, sizeLods: sizeLods, sigmas: sigmas };
}

function _createRenderTarget(width, height, params) {

	var cubeUVRenderTarget = new WebGLRenderTarget(width, height, params);
	cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
	cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
	cubeUVRenderTarget.scissorTest = true;
	return cubeUVRenderTarget;
}

function _setViewport(target, x, y, width, height) {

	target.viewport.set(x, y, width, height);
	target.scissor.set(x, y, width, height);
}

function _getBlurShader(lodMax, width, height) {

	var weights = new Float32Array(MAX_SAMPLES);
	var poleAxis = new Vector3(0, 1, 0);
	var shaderMaterial = new ShaderMaterial({

		name: 'SphericalGaussianBlur',

		defines: {
			'n': MAX_SAMPLES,
			'CUBEUV_TEXEL_WIDTH': 1.0 / width,
			'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
			'CUBEUV_MAX_MIP': lodMax + '.0'
		},

		uniforms: {
			'envMap': { value: null },
			'samples': { value: 1 },
			'weights': { value: weights },
			'latitudinal': { value: false },
			'dTheta': { value: 0 },
			'mipInt': { value: 0 },
			'poleAxis': { value: poleAxis }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */'\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues\' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t',

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	});

	return shaderMaterial;
}

function _getEquirectMaterial() {

	return new ShaderMaterial({

		name: 'EquirectangularToCubeUV',

		uniforms: {
			'envMap': { value: null }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */'\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t',

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	});
}

function _getCubemapMaterial() {

	return new ShaderMaterial({

		name: 'CubemapToCubeUV',

		uniforms: {
			'envMap': { value: null },
			'flipEnvMap': { value: -1 }
		},

		vertexShader: _getCommonVertexShader(),

		fragmentShader: /* glsl */'\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t',

		blending: NoBlending,
		depthTest: false,
		depthWrite: false

	});
}

function _getCommonVertexShader() {

	return (/* glsl */'\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t'
	);
}

function WebGLCubeUVMaps(renderer) {

	var cubeUVmaps = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	var pmremGenerator = null;

	function get(texture) {

		if (texture && texture.isTexture) {

			var mapping = texture.mapping;

			var isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
			var isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;

			// equirect/cube map to cubeUV conversion

			if (isEquirectMap || isCubeMap) {

				if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {

					texture.needsPMREMUpdate = false;

					var renderTarget = cubeUVmaps.get(texture);

					if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);

					renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
					cubeUVmaps.set(texture, renderTarget);

					return renderTarget.texture;
				} else {

					if (cubeUVmaps.has(texture)) {

						return cubeUVmaps.get(texture).texture;
					} else {

						var image = texture.image;

						if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {

							if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);

							var _renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
							cubeUVmaps.set(texture, _renderTarget);

							texture.addEventListener('dispose', onTextureDispose);

							return _renderTarget.texture;
						} else {

							// image not yet ready. try the conversion next frame

							return null;
						}
					}
				}
			}
		}

		return texture;
	}

	function isCubeTextureComplete(image) {

		var count = 0;
		var length = 6;

		for (var i = 0; i < length; i++) {

			if (image[i] !== undefined) count++;
		}

		return count === length;
	}

	function onTextureDispose(event) {

		var texture = event.target;

		texture.removeEventListener('dispose', onTextureDispose);

		var cubemapUV = cubeUVmaps.get(texture);

		if (cubemapUV !== undefined) {

			cubeUVmaps.delete(texture);
			cubemapUV.dispose();
		}
	}

	function dispose() {

		cubeUVmaps = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

		if (pmremGenerator !== null) {

			pmremGenerator.dispose();
			pmremGenerator = null;
		}
	}

	return {
		get: get,
		dispose: dispose
	};
}

function WebGLExtensions(gl) {

	var extensions = {};

	function getExtension(name) {

		if (extensions[name] !== undefined) {

			return extensions[name];
		}

		var extension = void 0;

		switch (name) {

			case 'WEBGL_depth_texture':
				extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
				break;

			case 'EXT_texture_filter_anisotropic':
				extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
				break;

			case 'WEBGL_compressed_texture_s3tc':
				extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
				break;

			case 'WEBGL_compressed_texture_pvrtc':
				extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
				break;

			default:
				extension = gl.getExtension(name);

		}

		extensions[name] = extension;

		return extension;
	}

	return {

		has: function has(name) {

			return getExtension(name) !== null;
		},

		init: function init(capabilities) {

			if (capabilities.isWebGL2) {

				getExtension('EXT_color_buffer_float');
			} else {

				getExtension('WEBGL_depth_texture');
				getExtension('OES_texture_float');
				getExtension('OES_texture_half_float');
				getExtension('OES_texture_half_float_linear');
				getExtension('OES_standard_derivatives');
				getExtension('OES_element_index_uint');
				getExtension('OES_vertex_array_object');
				getExtension('ANGLE_instanced_arrays');
			}

			getExtension('OES_texture_float_linear');
			getExtension('EXT_color_buffer_half_float');
			getExtension('WEBGL_multisampled_render_to_texture');
		},

		get: function get(name) {

			var extension = getExtension(name);

			if (extension === null) {

				console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
			}

			return extension;
		}

	};
}

function WebGLGeometries(gl, attributes, info, bindingStates) {

	var geometries = {};
	var wireframeAttributes = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function onGeometryDispose(event) {

		var geometry = event.target;

		if (geometry.index !== null) {

			attributes.remove(geometry.index);
		}

		for (var name in geometry.attributes) {

			attributes.remove(geometry.attributes[name]);
		}

		geometry.removeEventListener('dispose', onGeometryDispose);

		delete geometries[geometry.id];

		var attribute = wireframeAttributes.get(geometry);

		if (attribute) {

			attributes.remove(attribute);
			wireframeAttributes.delete(geometry);
		}

		bindingStates.releaseStatesOfGeometry(geometry);

		if (geometry.isInstancedBufferGeometry === true) {

			delete geometry._maxInstanceCount;
		}

		//

		info.memory.geometries--;
	}

	function get(object, geometry) {

		if (geometries[geometry.id] === true) return geometry;

		geometry.addEventListener('dispose', onGeometryDispose);

		geometries[geometry.id] = true;

		info.memory.geometries++;

		return geometry;
	}

	function update(geometry) {

		var geometryAttributes = geometry.attributes;

		// Updating index buffer in VAO now. See WebGLBindingStates.

		for (var name in geometryAttributes) {

			attributes.update(geometryAttributes[name], 34962);
		}

		// morph targets

		var morphAttributes = geometry.morphAttributes;

		for (var _name3 in morphAttributes) {

			var array = morphAttributes[_name3];

			for (var i = 0, l = array.length; i < l; i++) {

				attributes.update(array[i], 34962);
			}
		}
	}

	function updateWireframeAttribute(geometry) {

		var indices = [];

		var geometryIndex = geometry.index;
		var geometryPosition = geometry.attributes.position;
		var version = 0;

		if (geometryIndex !== null) {

			var array = geometryIndex.array;
			version = geometryIndex.version;

			for (var i = 0, l = array.length; i < l; i += 3) {

				var a = array[i + 0];
				var b = array[i + 1];
				var c = array[i + 2];

				indices.push(a, b, b, c, c, a);
			}
		} else {

			var _array = geometryPosition.array;
			version = geometryPosition.version;

			for (var _i29 = 0, _l5 = _array.length / 3 - 1; _i29 < _l5; _i29 += 3) {

				var _a4 = _i29 + 0;
				var _b4 = _i29 + 1;
				var _c4 = _i29 + 2;

				indices.push(_a4, _b4, _b4, _c4, _c4, _a4);
			}
		}

		var attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
		attribute.version = version;

		// Updating index buffer in VAO now. See WebGLBindingStates

		//

		var previousAttribute = wireframeAttributes.get(geometry);

		if (previousAttribute) attributes.remove(previousAttribute);

		//

		wireframeAttributes.set(geometry, attribute);
	}

	function getWireframeAttribute(geometry) {

		var currentAttribute = wireframeAttributes.get(geometry);

		if (currentAttribute) {

			var geometryIndex = geometry.index;

			if (geometryIndex !== null) {

				// if the attribute is obsolete, create a new one

				if (currentAttribute.version < geometryIndex.version) {

					updateWireframeAttribute(geometry);
				}
			}
		} else {

			updateWireframeAttribute(geometry);
		}

		return wireframeAttributes.get(geometry);
	}

	return {

		get: get,
		update: update,

		getWireframeAttribute: getWireframeAttribute

	};
}

function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {

	var isWebGL2 = capabilities.isWebGL2;

	var mode = void 0;

	function setMode(value) {

		mode = value;
	}

	var type = void 0,
	    bytesPerElement = void 0;

	function setIndex(value) {

		type = value.type;
		bytesPerElement = value.bytesPerElement;
	}

	function render(start, count) {

		gl.drawElements(mode, count, type, start * bytesPerElement);

		info.update(count, mode, 1);
	}

	function renderInstances(start, count, primcount) {

		if (primcount === 0) return;

		var extension = void 0,
		    methodName = void 0;

		if (isWebGL2) {

			extension = gl;
			methodName = 'drawElementsInstanced';
		} else {

			extension = extensions.get('ANGLE_instanced_arrays');
			methodName = 'drawElementsInstancedANGLE';

			if (extension === null) {

				console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
				return;
			}
		}

		extension[methodName](mode, count, type, start * bytesPerElement, primcount);

		info.update(count, mode, primcount);
	}

	//

	this.setMode = setMode;
	this.setIndex = setIndex;
	this.render = render;
	this.renderInstances = renderInstances;
}

function WebGLInfo(gl) {

	var memory = {
		geometries: 0,
		textures: 0
	};

	var render = {
		frame: 0,
		calls: 0,
		triangles: 0,
		points: 0,
		lines: 0
	};

	function update(count, mode, instanceCount) {

		render.calls++;

		switch (mode) {

			case 4:
				render.triangles += instanceCount * (count / 3);
				break;

			case 1:
				render.lines += instanceCount * (count / 2);
				break;

			case 3:
				render.lines += instanceCount * (count - 1);
				break;

			case 2:
				render.lines += instanceCount * count;
				break;

			case 0:
				render.points += instanceCount * count;
				break;

			default:
				console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
				break;

		}
	}

	function reset() {

		render.frame++;
		render.calls = 0;
		render.triangles = 0;
		render.points = 0;
		render.lines = 0;
	}

	return {
		memory: memory,
		render: render,
		programs: null,
		autoReset: true,
		reset: reset,
		update: update
	};
}

function numericalSort(a, b) {

	return a[0] - b[0];
}

function absNumericalSort(a, b) {

	return Math.abs(b[1]) - Math.abs(a[1]);
}

function WebGLMorphtargets(gl, capabilities, textures) {

	var influencesList = {};
	var morphInfluences = new Float32Array(8);
	var morphTextures = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	var morph = new Vector4();

	var workInfluences = [];

	for (var i = 0; i < 8; i++) {

		workInfluences[i] = [i, 0];
	}

	function update(object, geometry, program) {

		var objectInfluences = object.morphTargetInfluences;

		if (capabilities.isWebGL2 === true) {

			// instead of using attributes, the WebGL 2 code path encodes morph targets
			// into an array of data textures. Each layer represents a single morph target.

			var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
			var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;

			var entry = morphTextures.get(geometry);

			if (entry === undefined || entry.count !== morphTargetsCount) {
				var disposeTexture = function disposeTexture() {

					_texture.dispose();

					morphTextures.delete(geometry);

					geometry.removeEventListener('dispose', disposeTexture);
				};

				if (entry !== undefined) entry.texture.dispose();

				var hasMorphPosition = geometry.morphAttributes.position !== undefined;
				var hasMorphNormals = geometry.morphAttributes.normal !== undefined;
				var hasMorphColors = geometry.morphAttributes.color !== undefined;

				var morphTargets = geometry.morphAttributes.position || [];
				var morphNormals = geometry.morphAttributes.normal || [];
				var morphColors = geometry.morphAttributes.color || [];

				var vertexDataCount = 0;

				if (hasMorphPosition === true) vertexDataCount = 1;
				if (hasMorphNormals === true) vertexDataCount = 2;
				if (hasMorphColors === true) vertexDataCount = 3;

				var width = geometry.attributes.position.count * vertexDataCount;
				var height = 1;

				if (width > capabilities.maxTextureSize) {

					height = Math.ceil(width / capabilities.maxTextureSize);
					width = capabilities.maxTextureSize;
				}

				var buffer = new Float32Array(width * height * 4 * morphTargetsCount);

				var _texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
				_texture.type = FloatType;
				_texture.needsUpdate = true;

				// fill buffer

				var vertexDataStride = vertexDataCount * 4;

				for (var _i30 = 0; _i30 < morphTargetsCount; _i30++) {

					var morphTarget = morphTargets[_i30];
					var morphNormal = morphNormals[_i30];
					var morphColor = morphColors[_i30];

					var offset = width * height * 4 * _i30;

					for (var j = 0; j < morphTarget.count; j++) {

						var stride = j * vertexDataStride;

						if (hasMorphPosition === true) {

							morph.fromBufferAttribute(morphTarget, j);

							buffer[offset + stride + 0] = morph.x;
							buffer[offset + stride + 1] = morph.y;
							buffer[offset + stride + 2] = morph.z;
							buffer[offset + stride + 3] = 0;
						}

						if (hasMorphNormals === true) {

							morph.fromBufferAttribute(morphNormal, j);

							buffer[offset + stride + 4] = morph.x;
							buffer[offset + stride + 5] = morph.y;
							buffer[offset + stride + 6] = morph.z;
							buffer[offset + stride + 7] = 0;
						}

						if (hasMorphColors === true) {

							morph.fromBufferAttribute(morphColor, j);

							buffer[offset + stride + 8] = morph.x;
							buffer[offset + stride + 9] = morph.y;
							buffer[offset + stride + 10] = morph.z;
							buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
						}
					}
				}

				entry = {
					count: morphTargetsCount,
					texture: _texture,
					size: new Vector2(width, height)
				};

				morphTextures.set(geometry, entry);

				geometry.addEventListener('dispose', disposeTexture);
			}

			//

			var morphInfluencesSum = 0;

			for (var _i31 = 0; _i31 < objectInfluences.length; _i31++) {

				morphInfluencesSum += objectInfluences[_i31];
			}

			var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;

			program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
			program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);

			program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
			program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
		} else {

			// When object doesn't have morph target influences defined, we treat it as a 0-length array
			// This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences

			var length = objectInfluences === undefined ? 0 : objectInfluences.length;

			var influences = influencesList[geometry.id];

			if (influences === undefined || influences.length !== length) {

				// initialise list

				influences = [];

				for (var _i32 = 0; _i32 < length; _i32++) {

					influences[_i32] = [_i32, 0];
				}

				influencesList[geometry.id] = influences;
			}

			// Collect influences

			for (var _i33 = 0; _i33 < length; _i33++) {

				var influence = influences[_i33];

				influence[0] = _i33;
				influence[1] = objectInfluences[_i33];
			}

			influences.sort(absNumericalSort);

			for (var _i34 = 0; _i34 < 8; _i34++) {

				if (_i34 < length && influences[_i34][1]) {

					workInfluences[_i34][0] = influences[_i34][0];
					workInfluences[_i34][1] = influences[_i34][1];
				} else {

					workInfluences[_i34][0] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_max_safe_integer___default.a;
					workInfluences[_i34][1] = 0;
				}
			}

			workInfluences.sort(numericalSort);

			var _morphTargets = geometry.morphAttributes.position;
			var _morphNormals = geometry.morphAttributes.normal;

			var _morphInfluencesSum = 0;

			for (var _i35 = 0; _i35 < 8; _i35++) {

				var _influence = workInfluences[_i35];
				var index = _influence[0];
				var _value3 = _influence[1];

				if (index !== __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_max_safe_integer___default.a && _value3) {

					if (_morphTargets && geometry.getAttribute('morphTarget' + _i35) !== _morphTargets[index]) {

						geometry.setAttribute('morphTarget' + _i35, _morphTargets[index]);
					}

					if (_morphNormals && geometry.getAttribute('morphNormal' + _i35) !== _morphNormals[index]) {

						geometry.setAttribute('morphNormal' + _i35, _morphNormals[index]);
					}

					morphInfluences[_i35] = _value3;
					_morphInfluencesSum += _value3;
				} else {

					if (_morphTargets && geometry.hasAttribute('morphTarget' + _i35) === true) {

						geometry.deleteAttribute('morphTarget' + _i35);
					}

					if (_morphNormals && geometry.hasAttribute('morphNormal' + _i35) === true) {

						geometry.deleteAttribute('morphNormal' + _i35);
					}

					morphInfluences[_i35] = 0;
				}
			}

			// GLSL shader uses formula baseinfluence * base + sum(target * influence)
			// This allows us to switch between absolute morphs and relative morphs without changing shader code
			// When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
			var _morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - _morphInfluencesSum;

			program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', _morphBaseInfluence);
			program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
		}
	}

	return {

		update: update

	};
}

function WebGLObjects(gl, geometries, attributes, info) {

	var updateMap = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function update(object) {

		var frame = info.render.frame;

		var geometry = object.geometry;
		var buffergeometry = geometries.get(object, geometry);

		// Update once per frame

		if (updateMap.get(buffergeometry) !== frame) {

			geometries.update(buffergeometry);

			updateMap.set(buffergeometry, frame);
		}

		if (object.isInstancedMesh) {

			if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) {

				object.addEventListener('dispose', onInstancedMeshDispose);
			}

			attributes.update(object.instanceMatrix, 34962);

			if (object.instanceColor !== null) {

				attributes.update(object.instanceColor, 34962);
			}
		}

		return buffergeometry;
	}

	function dispose() {

		updateMap = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	}

	function onInstancedMeshDispose(event) {

		var instancedMesh = event.target;

		instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);

		attributes.remove(instancedMesh.instanceMatrix);

		if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
	}

	return {

		update: update,
		dispose: dispose

	};
}

/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */

var emptyTexture = /*@__PURE__*/new Texture();
var emptyArrayTexture = /*@__PURE__*/new DataArrayTexture();
var empty3dTexture = /*@__PURE__*/new Data3DTexture();
var emptyCubeTexture = /*@__PURE__*/new CubeTexture();

// --- Utilities ---

// Array Caches (provide typed arrays for temporary by size)

var arrayCacheF32 = [];
var arrayCacheI32 = [];

// Float32Array caches used for uploading Matrix uniforms

var mat4array = new Float32Array(16);
var mat3array = new Float32Array(9);
var mat2array = new Float32Array(4);

// Flattening for arrays of vectors and matrices

function flatten(array, nBlocks, blockSize) {

	var firstElem = array[0];

	if (firstElem <= 0 || firstElem > 0) return array;
	// unoptimized: ! isNaN( firstElem )
	// see http://jacksondunstan.com/articles/983

	var n = nBlocks * blockSize;
	var r = arrayCacheF32[n];

	if (r === undefined) {

		r = new Float32Array(n);
		arrayCacheF32[n] = r;
	}

	if (nBlocks !== 0) {

		firstElem.toArray(r, 0);

		for (var i = 1, offset = 0; i !== nBlocks; ++i) {

			offset += blockSize;
			array[i].toArray(r, offset);
		}
	}

	return r;
}

function arraysEqual(a, b) {

	if (a.length !== b.length) return false;

	for (var i = 0, l = a.length; i < l; i++) {

		if (a[i] !== b[i]) return false;
	}

	return true;
}

function copyArray(a, b) {

	for (var i = 0, l = b.length; i < l; i++) {

		a[i] = b[i];
	}
}

// Texture unit allocation

function allocTexUnits(textures, n) {

	var r = arrayCacheI32[n];

	if (r === undefined) {

		r = new Int32Array(n);
		arrayCacheI32[n] = r;
	}

	for (var i = 0; i !== n; ++i) {

		r[i] = textures.allocateTextureUnit();
	}

	return r;
}

// --- Setters ---

// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.

// Single scalar

function setValueV1f(gl, v) {

	var cache = this.cache;

	if (cache[0] === v) return;

	gl.uniform1f(this.addr, v);

	cache[0] = v;
}

// Single float vector (from flat array or THREE.VectorN)

function setValueV2f(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y) {

			gl.uniform2f(this.addr, v.x, v.y);

			cache[0] = v.x;
			cache[1] = v.y;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform2fv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV3f(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {

			gl.uniform3f(this.addr, v.x, v.y, v.z);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
		}
	} else if (v.r !== undefined) {

		if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {

			gl.uniform3f(this.addr, v.r, v.g, v.b);

			cache[0] = v.r;
			cache[1] = v.g;
			cache[2] = v.b;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform3fv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV4f(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {

			gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
			cache[3] = v.w;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform4fv(this.addr, v);

		copyArray(cache, v);
	}
}

// Single matrix (from flat array or THREE.MatrixN)

function setValueM2(gl, v) {

	var cache = this.cache;
	var elements = v.elements;

	if (elements === undefined) {

		if (arraysEqual(cache, v)) return;

		gl.uniformMatrix2fv(this.addr, false, v);

		copyArray(cache, v);
	} else {

		if (arraysEqual(cache, elements)) return;

		mat2array.set(elements);

		gl.uniformMatrix2fv(this.addr, false, mat2array);

		copyArray(cache, elements);
	}
}

function setValueM3(gl, v) {

	var cache = this.cache;
	var elements = v.elements;

	if (elements === undefined) {

		if (arraysEqual(cache, v)) return;

		gl.uniformMatrix3fv(this.addr, false, v);

		copyArray(cache, v);
	} else {

		if (arraysEqual(cache, elements)) return;

		mat3array.set(elements);

		gl.uniformMatrix3fv(this.addr, false, mat3array);

		copyArray(cache, elements);
	}
}

function setValueM4(gl, v) {

	var cache = this.cache;
	var elements = v.elements;

	if (elements === undefined) {

		if (arraysEqual(cache, v)) return;

		gl.uniformMatrix4fv(this.addr, false, v);

		copyArray(cache, v);
	} else {

		if (arraysEqual(cache, elements)) return;

		mat4array.set(elements);

		gl.uniformMatrix4fv(this.addr, false, mat4array);

		copyArray(cache, elements);
	}
}

// Single integer / boolean

function setValueV1i(gl, v) {

	var cache = this.cache;

	if (cache[0] === v) return;

	gl.uniform1i(this.addr, v);

	cache[0] = v;
}

// Single integer / boolean vector (from flat array or THREE.VectorN)

function setValueV2i(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y) {

			gl.uniform2i(this.addr, v.x, v.y);

			cache[0] = v.x;
			cache[1] = v.y;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform2iv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV3i(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {

			gl.uniform3i(this.addr, v.x, v.y, v.z);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform3iv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV4i(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {

			gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
			cache[3] = v.w;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform4iv(this.addr, v);

		copyArray(cache, v);
	}
}

// Single unsigned integer

function setValueV1ui(gl, v) {

	var cache = this.cache;

	if (cache[0] === v) return;

	gl.uniform1ui(this.addr, v);

	cache[0] = v;
}

// Single unsigned integer vector (from flat array or THREE.VectorN)

function setValueV2ui(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y) {

			gl.uniform2ui(this.addr, v.x, v.y);

			cache[0] = v.x;
			cache[1] = v.y;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform2uiv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV3ui(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {

			gl.uniform3ui(this.addr, v.x, v.y, v.z);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform3uiv(this.addr, v);

		copyArray(cache, v);
	}
}

function setValueV4ui(gl, v) {

	var cache = this.cache;

	if (v.x !== undefined) {

		if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {

			gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);

			cache[0] = v.x;
			cache[1] = v.y;
			cache[2] = v.z;
			cache[3] = v.w;
		}
	} else {

		if (arraysEqual(cache, v)) return;

		gl.uniform4uiv(this.addr, v);

		copyArray(cache, v);
	}
}

// Single texture (2D / Cube)

function setValueT1(gl, v, textures) {

	var cache = this.cache;
	var unit = textures.allocateTextureUnit();

	if (cache[0] !== unit) {

		gl.uniform1i(this.addr, unit);
		cache[0] = unit;
	}

	textures.setTexture2D(v || emptyTexture, unit);
}

function setValueT3D1(gl, v, textures) {

	var cache = this.cache;
	var unit = textures.allocateTextureUnit();

	if (cache[0] !== unit) {

		gl.uniform1i(this.addr, unit);
		cache[0] = unit;
	}

	textures.setTexture3D(v || empty3dTexture, unit);
}

function setValueT6(gl, v, textures) {

	var cache = this.cache;
	var unit = textures.allocateTextureUnit();

	if (cache[0] !== unit) {

		gl.uniform1i(this.addr, unit);
		cache[0] = unit;
	}

	textures.setTextureCube(v || emptyCubeTexture, unit);
}

function setValueT2DArray1(gl, v, textures) {

	var cache = this.cache;
	var unit = textures.allocateTextureUnit();

	if (cache[0] !== unit) {

		gl.uniform1i(this.addr, unit);
		cache[0] = unit;
	}

	textures.setTexture2DArray(v || emptyArrayTexture, unit);
}

// Helper to pick the right setter for the singular case

function getSingularSetter(type) {

	switch (type) {

		case 0x1406:
			return setValueV1f; // FLOAT
		case 0x8b50:
			return setValueV2f; // _VEC2
		case 0x8b51:
			return setValueV3f; // _VEC3
		case 0x8b52:
			return setValueV4f; // _VEC4

		case 0x8b5a:
			return setValueM2; // _MAT2
		case 0x8b5b:
			return setValueM3; // _MAT3
		case 0x8b5c:
			return setValueM4; // _MAT4

		case 0x1404:case 0x8b56:
			return setValueV1i; // INT, BOOL
		case 0x8b53:case 0x8b57:
			return setValueV2i; // _VEC2
		case 0x8b54:case 0x8b58:
			return setValueV3i; // _VEC3
		case 0x8b55:case 0x8b59:
			return setValueV4i; // _VEC4

		case 0x1405:
			return setValueV1ui; // UINT
		case 0x8dc6:
			return setValueV2ui; // _VEC2
		case 0x8dc7:
			return setValueV3ui; // _VEC3
		case 0x8dc8:
			return setValueV4ui; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62:
			// SAMPLER_2D_SHADOW
			return setValueT1;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3:
			// UNSIGNED_INT_SAMPLER_3D
			return setValueT3D1;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5:
			// SAMPLER_CUBE_SHADOW
			return setValueT6;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4:
			// SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArray1;

	}
}

// Array of scalars

function setValueV1fArray(gl, v) {

	gl.uniform1fv(this.addr, v);
}

// Array of vectors (from flat array or array of THREE.VectorN)

function setValueV2fArray(gl, v) {

	var data = flatten(v, this.size, 2);

	gl.uniform2fv(this.addr, data);
}

function setValueV3fArray(gl, v) {

	var data = flatten(v, this.size, 3);

	gl.uniform3fv(this.addr, data);
}

function setValueV4fArray(gl, v) {

	var data = flatten(v, this.size, 4);

	gl.uniform4fv(this.addr, data);
}

// Array of matrices (from flat array or array of THREE.MatrixN)

function setValueM2Array(gl, v) {

	var data = flatten(v, this.size, 4);

	gl.uniformMatrix2fv(this.addr, false, data);
}

function setValueM3Array(gl, v) {

	var data = flatten(v, this.size, 9);

	gl.uniformMatrix3fv(this.addr, false, data);
}

function setValueM4Array(gl, v) {

	var data = flatten(v, this.size, 16);

	gl.uniformMatrix4fv(this.addr, false, data);
}

// Array of integer / boolean

function setValueV1iArray(gl, v) {

	gl.uniform1iv(this.addr, v);
}

// Array of integer / boolean vectors (from flat array)

function setValueV2iArray(gl, v) {

	gl.uniform2iv(this.addr, v);
}

function setValueV3iArray(gl, v) {

	gl.uniform3iv(this.addr, v);
}

function setValueV4iArray(gl, v) {

	gl.uniform4iv(this.addr, v);
}

// Array of unsigned integer

function setValueV1uiArray(gl, v) {

	gl.uniform1uiv(this.addr, v);
}

// Array of unsigned integer vectors (from flat array)

function setValueV2uiArray(gl, v) {

	gl.uniform2uiv(this.addr, v);
}

function setValueV3uiArray(gl, v) {

	gl.uniform3uiv(this.addr, v);
}

function setValueV4uiArray(gl, v) {

	gl.uniform4uiv(this.addr, v);
}

// Array of textures (2D / 3D / Cube / 2DArray)

function setValueT1Array(gl, v, textures) {

	var cache = this.cache;

	var n = v.length;

	var units = allocTexUnits(textures, n);

	if (!arraysEqual(cache, units)) {

		gl.uniform1iv(this.addr, units);

		copyArray(cache, units);
	}

	for (var i = 0; i !== n; ++i) {

		textures.setTexture2D(v[i] || emptyTexture, units[i]);
	}
}

function setValueT3DArray(gl, v, textures) {

	var cache = this.cache;

	var n = v.length;

	var units = allocTexUnits(textures, n);

	if (!arraysEqual(cache, units)) {

		gl.uniform1iv(this.addr, units);

		copyArray(cache, units);
	}

	for (var i = 0; i !== n; ++i) {

		textures.setTexture3D(v[i] || empty3dTexture, units[i]);
	}
}

function setValueT6Array(gl, v, textures) {

	var cache = this.cache;

	var n = v.length;

	var units = allocTexUnits(textures, n);

	if (!arraysEqual(cache, units)) {

		gl.uniform1iv(this.addr, units);

		copyArray(cache, units);
	}

	for (var i = 0; i !== n; ++i) {

		textures.setTextureCube(v[i] || emptyCubeTexture, units[i]);
	}
}

function setValueT2DArrayArray(gl, v, textures) {

	var cache = this.cache;

	var n = v.length;

	var units = allocTexUnits(textures, n);

	if (!arraysEqual(cache, units)) {

		gl.uniform1iv(this.addr, units);

		copyArray(cache, units);
	}

	for (var i = 0; i !== n; ++i) {

		textures.setTexture2DArray(v[i] || emptyArrayTexture, units[i]);
	}
}

// Helper to pick the right setter for a pure (bottom-level) array

function getPureArraySetter(type) {

	switch (type) {

		case 0x1406:
			return setValueV1fArray; // FLOAT
		case 0x8b50:
			return setValueV2fArray; // _VEC2
		case 0x8b51:
			return setValueV3fArray; // _VEC3
		case 0x8b52:
			return setValueV4fArray; // _VEC4

		case 0x8b5a:
			return setValueM2Array; // _MAT2
		case 0x8b5b:
			return setValueM3Array; // _MAT3
		case 0x8b5c:
			return setValueM4Array; // _MAT4

		case 0x1404:case 0x8b56:
			return setValueV1iArray; // INT, BOOL
		case 0x8b53:case 0x8b57:
			return setValueV2iArray; // _VEC2
		case 0x8b54:case 0x8b58:
			return setValueV3iArray; // _VEC3
		case 0x8b55:case 0x8b59:
			return setValueV4iArray; // _VEC4

		case 0x1405:
			return setValueV1uiArray; // UINT
		case 0x8dc6:
			return setValueV2uiArray; // _VEC2
		case 0x8dc7:
			return setValueV3uiArray; // _VEC3
		case 0x8dc8:
			return setValueV4uiArray; // _VEC4

		case 0x8b5e: // SAMPLER_2D
		case 0x8d66: // SAMPLER_EXTERNAL_OES
		case 0x8dca: // INT_SAMPLER_2D
		case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D
		case 0x8b62:
			// SAMPLER_2D_SHADOW
			return setValueT1Array;

		case 0x8b5f: // SAMPLER_3D
		case 0x8dcb: // INT_SAMPLER_3D
		case 0x8dd3:
			// UNSIGNED_INT_SAMPLER_3D
			return setValueT3DArray;

		case 0x8b60: // SAMPLER_CUBE
		case 0x8dcc: // INT_SAMPLER_CUBE
		case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE
		case 0x8dc5:
			// SAMPLER_CUBE_SHADOW
			return setValueT6Array;

		case 0x8dc1: // SAMPLER_2D_ARRAY
		case 0x8dcf: // INT_SAMPLER_2D_ARRAY
		case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY
		case 0x8dc4:
			// SAMPLER_2D_ARRAY_SHADOW
			return setValueT2DArrayArray;

	}
}

// --- Uniform Classes ---

var SingleUniform = function SingleUniform(id, activeInfo, addr) {
	__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SingleUniform);

	this.id = id;
	this.addr = addr;
	this.cache = [];
	this.setValue = getSingularSetter(activeInfo.type);

	// this.path = activeInfo.name; // DEBUG
};

var PureArrayUniform = function PureArrayUniform(id, activeInfo, addr) {
	__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PureArrayUniform);

	this.id = id;
	this.addr = addr;
	this.cache = [];
	this.size = activeInfo.size;
	this.setValue = getPureArraySetter(activeInfo.type);

	// this.path = activeInfo.name; // DEBUG
};

var StructuredUniform = function () {
	function StructuredUniform(id) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, StructuredUniform);

		this.id = id;

		this.seq = [];
		this.map = {};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(StructuredUniform, [{
		key: 'setValue',
		value: function setValue(gl, value, textures) {

			var seq = this.seq;

			for (var i = 0, n = seq.length; i !== n; ++i) {

				var u = seq[i];
				u.setValue(gl, value[u.id], textures);
			}
		}
	}]);

	return StructuredUniform;
}();

// --- Top-level ---

// Parser - builds up the property tree from the path strings

var RePathPart = /(\w+)(\])?(\[|\.)?/g;

// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform(container, uniformObject) {

	container.seq.push(uniformObject);
	container.map[uniformObject.id] = uniformObject;
}

function parseUniform(activeInfo, addr, container) {

	var path = activeInfo.name,
	    pathLength = path.length;

	// reset RegExp object, because of the early exit of a previous run
	RePathPart.lastIndex = 0;

	while (true) {

		var match = RePathPart.exec(path),
		    matchEnd = RePathPart.lastIndex;

		var _id2 = match[1];
		var idIsIndex = match[2] === ']',
		    subscript = match[3];

		if (idIsIndex) _id2 = _id2 | 0; // convert to integer

		if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {

			// bare name or "pure" bottom-level array "[0]" suffix

			addUniform(container, subscript === undefined ? new SingleUniform(_id2, activeInfo, addr) : new PureArrayUniform(_id2, activeInfo, addr));

			break;
		} else {

			// step into inner node / create it in case it doesn't exist

			var map = container.map;
			var next = map[_id2];

			if (next === undefined) {

				next = new StructuredUniform(_id2);
				addUniform(container, next);
			}

			container = next;
		}
	}
}

// Root Container

var WebGLUniforms = function () {
	function WebGLUniforms(gl, program) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLUniforms);

		this.seq = [];
		this.map = {};

		var n = gl.getProgramParameter(program, 35718);

		for (var i = 0; i < n; ++i) {

			var info = gl.getActiveUniform(program, i),
			    addr = gl.getUniformLocation(program, info.name);

			parseUniform(info, addr, this);
		}
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLUniforms, [{
		key: 'setValue',
		value: function setValue(gl, name, value, textures) {

			var u = this.map[name];

			if (u !== undefined) u.setValue(gl, value, textures);
		}
	}, {
		key: 'setOptional',
		value: function setOptional(gl, object, name) {

			var v = object[name];

			if (v !== undefined) this.setValue(gl, name, v);
		}
	}], [{
		key: 'upload',
		value: function upload(gl, seq, values, textures) {

			for (var i = 0, _n = seq.length; i !== _n; ++i) {

				var u = seq[i],
				    v = values[u.id];

				if (v.needsUpdate !== false) {

					// note: always updating when .needsUpdate is undefined
					u.setValue(gl, v.value, textures);
				}
			}
		}
	}, {
		key: 'seqWithValue',
		value: function seqWithValue(seq, values) {

			var r = [];

			for (var i = 0, _n2 = seq.length; i !== _n2; ++i) {

				var u = seq[i];
				if (u.id in values) r.push(u);
			}

			return r;
		}
	}]);

	return WebGLUniforms;
}();

function WebGLShader(gl, type, string) {

	var shader = gl.createShader(type);

	gl.shaderSource(shader, string);
	gl.compileShader(shader);

	return shader;
}

var programIdCount = 0;

function handleSource(string, errorLine) {

	var lines = string.split('\n');
	var lines2 = [];

	var from = Math.max(errorLine - 6, 0);
	var to = Math.min(errorLine + 6, lines.length);

	for (var i = from; i < to; i++) {

		var line = i + 1;
		lines2.push((line === errorLine ? '>' : ' ') + ' ' + line + ': ' + lines[i]);
	}

	return lines2.join('\n');
}

function getEncodingComponents(encoding) {

	switch (encoding) {

		case LinearEncoding:
			return ['Linear', '( value )'];
		case sRGBEncoding:
			return ['sRGB', '( value )'];
		default:
			console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
			return ['Linear', '( value )'];

	}
}

function getShaderErrors(gl, shader, type) {

	var status = gl.getShaderParameter(shader, 35713);
	var errors = gl.getShaderInfoLog(shader).trim();

	if (status && errors === '') return '';

	var errorMatches = /ERROR: 0:(\d+)/.exec(errors);
	if (errorMatches) {

		// --enable-privileged-webgl-extension
		// console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );

		var errorLine = parseInt(errorMatches[1]);
		return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource(gl.getShaderSource(shader), errorLine);
	} else {

		return errors;
	}
}

function getTexelEncodingFunction(functionName, encoding) {

	var components = getEncodingComponents(encoding);
	return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}

function getToneMappingFunction(functionName, toneMapping) {

	var toneMappingName = void 0;

	switch (toneMapping) {

		case LinearToneMapping:
			toneMappingName = 'Linear';
			break;

		case ReinhardToneMapping:
			toneMappingName = 'Reinhard';
			break;

		case CineonToneMapping:
			toneMappingName = 'OptimizedCineon';
			break;

		case ACESFilmicToneMapping:
			toneMappingName = 'ACESFilmic';
			break;

		case CustomToneMapping:
			toneMappingName = 'Custom';
			break;

		default:
			console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
			toneMappingName = 'Linear';

	}

	return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}

function generateExtensions(parameters) {

	var chunks = [parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.normalMapTangentSpace || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '', (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '', parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '', (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''];

	return chunks.filter(filterEmptyLine).join('\n');
}

function generateDefines(defines) {

	var chunks = [];

	for (var name in defines) {

		var _value4 = defines[name];

		if (_value4 === false) continue;

		chunks.push('#define ' + name + ' ' + _value4);
	}

	return chunks.join('\n');
}

function fetchAttributeLocations(gl, program) {

	var attributes = {};

	var n = gl.getProgramParameter(program, 35721);

	for (var i = 0; i < n; i++) {

		var info = gl.getActiveAttrib(program, i);
		var name = info.name;

		var locationSize = 1;
		if (info.type === 35674) locationSize = 2;
		if (info.type === 35675) locationSize = 3;
		if (info.type === 35676) locationSize = 4;

		// console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

		attributes[name] = {
			type: info.type,
			location: gl.getAttribLocation(program, name),
			locationSize: locationSize
		};
	}

	return attributes;
}

function filterEmptyLine(string) {

	return string !== '';
}

function replaceLightNums(string, parameters) {

	var numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;

	return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}

function replaceClippingPlaneNums(string, parameters) {

	return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}

// Resolve Includes

var includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;

function resolveIncludes(string) {

	return string.replace(includePattern, includeReplacer);
}

function includeReplacer(match, include) {

	var string = ShaderChunk[include];

	if (string === undefined) {

		throw new Error('Can not resolve #include <' + include + '>');
	}

	return resolveIncludes(string);
}

// Unroll Loops

var unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function unrollLoops(string) {

	return string.replace(unrollLoopPattern, loopReplacer);
}

function loopReplacer(match, start, end, snippet) {

	var string = '';

	for (var i = parseInt(start); i < parseInt(end); i++) {

		string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
	}

	return string;
}

//

function generatePrecision(parameters) {

	var precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';

	if (parameters.precision === 'highp') {

		precisionstring += '\n#define HIGH_PRECISION';
	} else if (parameters.precision === 'mediump') {

		precisionstring += '\n#define MEDIUM_PRECISION';
	} else if (parameters.precision === 'lowp') {

		precisionstring += '\n#define LOW_PRECISION';
	}

	return precisionstring;
}

function generateShadowMapTypeDefine(parameters) {

	var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

	if (parameters.shadowMapType === PCFShadowMap) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
	} else if (parameters.shadowMapType === PCFSoftShadowMap) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
	} else if (parameters.shadowMapType === VSMShadowMap) {

		shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
	}

	return shadowMapTypeDefine;
}

function generateEnvMapTypeDefine(parameters) {

	var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';

	if (parameters.envMap) {

		switch (parameters.envMapMode) {

			case CubeReflectionMapping:
			case CubeRefractionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
				break;

			case CubeUVReflectionMapping:
				envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
				break;

		}
	}

	return envMapTypeDefine;
}

function generateEnvMapModeDefine(parameters) {

	var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';

	if (parameters.envMap) {

		switch (parameters.envMapMode) {

			case CubeRefractionMapping:

				envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
				break;

		}
	}

	return envMapModeDefine;
}

function generateEnvMapBlendingDefine(parameters) {

	var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';

	if (parameters.envMap) {

		switch (parameters.combine) {

			case MultiplyOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
				break;

			case MixOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
				break;

			case AddOperation:
				envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
				break;

		}
	}

	return envMapBlendingDefine;
}

function generateCubeUVSize(parameters) {

	var imageHeight = parameters.envMapCubeUVHeight;

	if (imageHeight === null) return null;

	var maxMip = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2___default()(imageHeight) - 2;

	var texelHeight = 1.0 / imageHeight;

	var texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));

	return { texelWidth: texelWidth, texelHeight: texelHeight, maxMip: maxMip };
}

function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {

	// TODO Send this event to Three.js DevTools
	// console.log( 'WebGLProgram', cacheKey );

	var gl = renderer.getContext();

	var defines = parameters.defines;

	var vertexShader = parameters.vertexShader;
	var fragmentShader = parameters.fragmentShader;

	var shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
	var envMapTypeDefine = generateEnvMapTypeDefine(parameters);
	var envMapModeDefine = generateEnvMapModeDefine(parameters);
	var envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
	var envMapCubeUVSize = generateCubeUVSize(parameters);

	var customExtensions = parameters.isWebGL2 ? '' : generateExtensions(parameters);

	var customDefines = generateDefines(defines);

	var program = gl.createProgram();

	var prefixVertex = void 0,
	    prefixFragment = void 0;
	var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';

	if (parameters.isRawShaderMaterial) {

		prefixVertex = [customDefines].filter(filterEmptyLine).join('\n');

		if (prefixVertex.length > 0) {

			prefixVertex += '\n';
		}

		prefixFragment = [customExtensions, customDefines].filter(filterEmptyLine).join('\n');

		if (prefixFragment.length > 0) {

			prefixFragment += '\n';
		}
	} else {

		prefixVertex = [generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.instancing ? '#define USE_INSTANCING' : '', parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '', parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '', parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '', parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '', parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',

		//

		parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '', parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '', parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '', parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '', parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '', parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '', parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '', parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '', parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '', parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '', parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '', parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '', parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '', parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '', parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '', parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '', parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '', parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '', parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '', parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '', parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '', parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',

		//

		parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs2 ? '#define USE_UV2' : '', parameters.pointsUvs ? '#define USE_POINTS_UV' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.skinning ? '#define USE_SKINNING' : '', parameters.morphTargets ? '#define USE_MORPHTARGETS' : '', parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '', parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 modelMatrix;', 'uniform mat4 modelViewMatrix;', 'uniform mat4 projectionMatrix;', 'uniform mat4 viewMatrix;', 'uniform mat3 normalMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', '#ifdef USE_INSTANCING', '	attribute mat4 instanceMatrix;', '#endif', '#ifdef USE_INSTANCING_COLOR', '	attribute vec3 instanceColor;', '#endif', 'attribute vec3 position;', 'attribute vec3 normal;', 'attribute vec2 uv;', '#ifdef USE_TANGENT', '	attribute vec4 tangent;', '#endif', '#if defined( USE_COLOR_ALPHA )', '	attribute vec4 color;', '#elif defined( USE_COLOR )', '	attribute vec3 color;', '#endif', '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )', '	attribute vec3 morphTarget0;', '	attribute vec3 morphTarget1;', '	attribute vec3 morphTarget2;', '	attribute vec3 morphTarget3;', '	#ifdef USE_MORPHNORMALS', '		attribute vec3 morphNormal0;', '		attribute vec3 morphNormal1;', '		attribute vec3 morphNormal2;', '		attribute vec3 morphNormal3;', '	#else', '		attribute vec3 morphTarget4;', '		attribute vec3 morphTarget5;', '		attribute vec3 morphTarget6;', '		attribute vec3 morphTarget7;', '	#endif', '#endif', '#ifdef USE_SKINNING', '	attribute vec4 skinIndex;', '	attribute vec4 skinWeight;', '#endif', '\n'].filter(filterEmptyLine).join('\n');

		prefixFragment = [customExtensions, generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.matcap ? '#define USE_MATCAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapTypeDefine : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.envMap ? '#define ' + envMapBlendingDefine : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '', envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '', parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.clearcoat ? '#define USE_CLEARCOAT' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.iridescence ? '#define USE_IRIDESCENCE' : '', parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '', parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.alphaTest ? '#define USE_ALPHATEST' : '', parameters.sheen ? '#define USE_SHEEN' : '', parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '', parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs2 ? '#define USE_UV2' : '', parameters.pointsUvs ? '#define USE_POINTS_UV' : '', parameters.gradientMap ? '#define USE_GRADIENTMAP' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '', parameters.useLegacyLights ? '#define LEGACY_LIGHTS' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 viewMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', parameters.toneMapping !== NoToneMapping ? '#define TONE_MAPPING' : '', parameters.toneMapping !== NoToneMapping ? ShaderChunk['tonemapping_pars_fragment'] : '', // this code is required here because it is used by the toneMapping() function defined below
		parameters.toneMapping !== NoToneMapping ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '', parameters.dithering ? '#define DITHERING' : '', parameters.opaque ? '#define OPAQUE' : '', ShaderChunk['encodings_pars_fragment'], // this code is required here because it is used by the various encoding/decoding function defined below
		getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding), parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '', '\n'].filter(filterEmptyLine).join('\n');
	}

	vertexShader = resolveIncludes(vertexShader);
	vertexShader = replaceLightNums(vertexShader, parameters);
	vertexShader = replaceClippingPlaneNums(vertexShader, parameters);

	fragmentShader = resolveIncludes(fragmentShader);
	fragmentShader = replaceLightNums(fragmentShader, parameters);
	fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);

	vertexShader = unrollLoops(vertexShader);
	fragmentShader = unrollLoops(fragmentShader);

	if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {

		// GLSL 3.0 conversion for built-in materials and ShaderMaterial

		versionString = '#version 300 es\n';

		prefixVertex = ['precision mediump sampler2DArray;', '#define attribute in', '#define varying out', '#define texture2D texture'].join('\n') + '\n' + prefixVertex;

		prefixFragment = ['#define varying in', parameters.glslVersion === GLSL3 ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;', parameters.glslVersion === GLSL3 ? '' : '#define gl_FragColor pc_fragColor', '#define gl_FragDepthEXT gl_FragDepth', '#define texture2D texture', '#define textureCube texture', '#define texture2DProj textureProj', '#define texture2DLodEXT textureLod', '#define texture2DProjLodEXT textureProjLod', '#define textureCubeLodEXT textureLod', '#define texture2DGradEXT textureGrad', '#define texture2DProjGradEXT textureProjGrad', '#define textureCubeGradEXT textureGrad'].join('\n') + '\n' + prefixFragment;
	}

	var vertexGlsl = versionString + prefixVertex + vertexShader;
	var fragmentGlsl = versionString + prefixFragment + fragmentShader;

	// console.log( '*VERTEX*', vertexGlsl );
	// console.log( '*FRAGMENT*', fragmentGlsl );

	var glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
	var glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);

	gl.attachShader(program, glVertexShader);
	gl.attachShader(program, glFragmentShader);

	// Force a particular attribute to index 0.

	if (parameters.index0AttributeName !== undefined) {

		gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
	} else if (parameters.morphTargets === true) {

		// programs with morphTargets displace position out of attribute 0
		gl.bindAttribLocation(program, 0, 'position');
	}

	gl.linkProgram(program);

	// check for link errors
	if (renderer.debug.checkShaderErrors) {

		var programLog = gl.getProgramInfoLog(program).trim();
		var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
		var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();

		var runnable = true;
		var haveDiagnostics = true;

		if (gl.getProgramParameter(program, 35714) === false) {

			runnable = false;

			if (typeof renderer.debug.onShaderError === 'function') {

				renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
			} else {

				// default error reporting

				var vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
				var fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');

				console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, 35715) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
			}
		} else if (programLog !== '') {

			console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
		} else if (vertexLog === '' || fragmentLog === '') {

			haveDiagnostics = false;
		}

		if (haveDiagnostics) {

			this.diagnostics = {

				runnable: runnable,

				programLog: programLog,

				vertexShader: {

					log: vertexLog,
					prefix: prefixVertex

				},

				fragmentShader: {

					log: fragmentLog,
					prefix: prefixFragment

				}

			};
		}
	}

	// Clean up

	// Crashes in iOS9 and iOS10. #18402
	// gl.detachShader( program, glVertexShader );
	// gl.detachShader( program, glFragmentShader );

	gl.deleteShader(glVertexShader);
	gl.deleteShader(glFragmentShader);

	// set up caching for uniform locations

	var cachedUniforms = void 0;

	this.getUniforms = function () {

		if (cachedUniforms === undefined) {

			cachedUniforms = new WebGLUniforms(gl, program);
		}

		return cachedUniforms;
	};

	// set up caching for attribute locations

	var cachedAttributes = void 0;

	this.getAttributes = function () {

		if (cachedAttributes === undefined) {

			cachedAttributes = fetchAttributeLocations(gl, program);
		}

		return cachedAttributes;
	};

	// free resource

	this.destroy = function () {

		bindingStates.releaseStatesOfProgram(this);

		gl.deleteProgram(program);
		this.program = undefined;
	};

	//

	this.name = parameters.shaderName;
	this.id = programIdCount++;
	this.cacheKey = cacheKey;
	this.usedTimes = 1;
	this.program = program;
	this.vertexShader = glVertexShader;
	this.fragmentShader = glFragmentShader;

	return this;
}

var _id = 0;

var WebGLShaderCache = function () {
	function WebGLShaderCache() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLShaderCache);

		this.shaderCache = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a();
		this.materialCache = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a();
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLShaderCache, [{
		key: 'update',
		value: function update(material) {

			var vertexShader = material.vertexShader;
			var fragmentShader = material.fragmentShader;

			var vertexShaderStage = this._getShaderStage(vertexShader);
			var fragmentShaderStage = this._getShaderStage(fragmentShader);

			var materialShaders = this._getShaderCacheForMaterial(material);

			if (materialShaders.has(vertexShaderStage) === false) {

				materialShaders.add(vertexShaderStage);
				vertexShaderStage.usedTimes++;
			}

			if (materialShaders.has(fragmentShaderStage) === false) {

				materialShaders.add(fragmentShaderStage);
				fragmentShaderStage.usedTimes++;
			}

			return this;
		}
	}, {
		key: 'remove',
		value: function remove(material) {

			var materialShaders = this.materialCache.get(material);

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(materialShaders), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var shaderStage = _step.value;


					shaderStage.usedTimes--;

					if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.materialCache.delete(material);

			return this;
		}
	}, {
		key: 'getVertexShaderID',
		value: function getVertexShaderID(material) {

			return this._getShaderStage(material.vertexShader).id;
		}
	}, {
		key: 'getFragmentShaderID',
		value: function getFragmentShaderID(material) {

			return this._getShaderStage(material.fragmentShader).id;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.shaderCache.clear();
			this.materialCache.clear();
		}
	}, {
		key: '_getShaderCacheForMaterial',
		value: function _getShaderCacheForMaterial(material) {

			var cache = this.materialCache;
			var set = cache.get(material);

			if (set === undefined) {

				set = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();
				cache.set(material, set);
			}

			return set;
		}
	}, {
		key: '_getShaderStage',
		value: function _getShaderStage(code) {

			var cache = this.shaderCache;
			var stage = cache.get(code);

			if (stage === undefined) {

				stage = new WebGLShaderStage(code);
				cache.set(code, stage);
			}

			return stage;
		}
	}]);

	return WebGLShaderCache;
}();

var WebGLShaderStage = function WebGLShaderStage(code) {
	__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLShaderStage);

	this.id = _id++;

	this.code = code;
	this.usedTimes = 0;
};

function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {

	var _programLayers = new Layers();
	var _customShaders = new WebGLShaderCache();
	var programs = [];

	var IS_WEBGL2 = capabilities.isWebGL2;
	var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
	var SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;

	var precision = capabilities.precision;

	var shaderIDs = {
		MeshDepthMaterial: 'depth',
		MeshDistanceMaterial: 'distanceRGBA',
		MeshNormalMaterial: 'normal',
		MeshBasicMaterial: 'basic',
		MeshLambertMaterial: 'lambert',
		MeshPhongMaterial: 'phong',
		MeshToonMaterial: 'toon',
		MeshStandardMaterial: 'physical',
		MeshPhysicalMaterial: 'physical',
		MeshMatcapMaterial: 'matcap',
		LineBasicMaterial: 'basic',
		LineDashedMaterial: 'dashed',
		PointsMaterial: 'points',
		ShadowMaterial: 'shadow',
		SpriteMaterial: 'sprite'
	};

	function getChannel(value) {

		if (value === 1) return 'uv2';

		return 'uv';
	}

	function getParameters(material, lights, shadows, scene, object) {

		var fog = scene.fog;
		var geometry = object.geometry;
		var environment = material.isMeshStandardMaterial ? scene.environment : null;

		var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
		var envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;

		var shaderID = shaderIDs[material.type];

		// heuristics to create shader parameters according to lights in the scene
		// (not to blow over maxLights budget)

		if (material.precision !== null) {

			precision = capabilities.getMaxPrecision(material.precision);

			if (precision !== material.precision) {

				console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
			}
		}

		//

		var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
		var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;

		var morphTextureStride = 0;

		if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
		if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
		if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;

		//

		var vertexShader = void 0,
		    fragmentShader = void 0;
		var customVertexShaderID = void 0,
		    customFragmentShaderID = void 0;

		if (shaderID) {

			var shader = ShaderLib[shaderID];

			vertexShader = shader.vertexShader;
			fragmentShader = shader.fragmentShader;
		} else {

			vertexShader = material.vertexShader;
			fragmentShader = material.fragmentShader;

			_customShaders.update(material);

			customVertexShaderID = _customShaders.getVertexShaderID(material);
			customFragmentShaderID = _customShaders.getFragmentShaderID(material);
		}

		var currentRenderTarget = renderer.getRenderTarget();

		var IS_INSTANCEDMESH = object.isInstancedMesh === true;

		var HAS_MAP = !!material.map;
		var HAS_MATCAP = !!material.matcap;
		var HAS_ENVMAP = !!envMap;
		var HAS_AOMAP = !!material.aoMap;
		var HAS_LIGHTMAP = !!material.lightMap;
		var HAS_BUMPMAP = !!material.bumpMap;
		var HAS_NORMALMAP = !!material.normalMap;
		var HAS_DISPLACEMENTMAP = !!material.displacementMap;
		var HAS_EMISSIVEMAP = !!material.emissiveMap;

		var HAS_METALNESSMAP = !!material.metalnessMap;
		var HAS_ROUGHNESSMAP = !!material.roughnessMap;

		var HAS_CLEARCOAT = material.clearcoat > 0;
		var HAS_IRIDESCENCE = material.iridescence > 0;
		var HAS_SHEEN = material.sheen > 0;
		var HAS_TRANSMISSION = material.transmission > 0;

		var HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
		var HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
		var HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;

		var HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
		var HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;

		var HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
		var HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;

		var HAS_SPECULARMAP = !!material.specularMap;
		var HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
		var HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;

		var HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
		var HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;

		var HAS_GRADIENTMAP = !!material.gradientMap;

		var HAS_ALPHAMAP = !!material.alphaMap;

		var HAS_ALPHATEST = material.alphaTest > 0;

		var HAS_EXTENSIONS = !!material.extensions;

		var HAS_ATTRIBUTE_UV2 = !!geometry.attributes.uv2;

		var parameters = {

			isWebGL2: IS_WEBGL2,

			shaderID: shaderID,
			shaderName: material.type,

			vertexShader: vertexShader,
			fragmentShader: fragmentShader,
			defines: material.defines,

			customVertexShaderID: customVertexShaderID,
			customFragmentShaderID: customFragmentShaderID,

			isRawShaderMaterial: material.isRawShaderMaterial === true,
			glslVersion: material.glslVersion,

			precision: precision,

			instancing: IS_INSTANCEDMESH,
			instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,

			supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
			outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : LinearEncoding,

			map: HAS_MAP,
			matcap: HAS_MATCAP,
			envMap: HAS_ENVMAP,
			envMapMode: HAS_ENVMAP && envMap.mapping,
			envMapCubeUVHeight: envMapCubeUVHeight,
			aoMap: HAS_AOMAP,
			lightMap: HAS_LIGHTMAP,
			bumpMap: HAS_BUMPMAP,
			normalMap: HAS_NORMALMAP,
			displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
			emissiveMap: HAS_EMISSIVEMAP,

			normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === ObjectSpaceNormalMap,
			normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === TangentSpaceNormalMap,

			decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && material.map.encoding === sRGBEncoding,

			metalnessMap: HAS_METALNESSMAP,
			roughnessMap: HAS_ROUGHNESSMAP,

			clearcoat: HAS_CLEARCOAT,
			clearcoatMap: HAS_CLEARCOATMAP,
			clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
			clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,

			iridescence: HAS_IRIDESCENCE,
			iridescenceMap: HAS_IRIDESCENCEMAP,
			iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,

			sheen: HAS_SHEEN,
			sheenColorMap: HAS_SHEEN_COLORMAP,
			sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,

			specularMap: HAS_SPECULARMAP,
			specularColorMap: HAS_SPECULAR_COLORMAP,
			specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,

			transmission: HAS_TRANSMISSION,
			transmissionMap: HAS_TRANSMISSIONMAP,
			thicknessMap: HAS_THICKNESSMAP,

			gradientMap: HAS_GRADIENTMAP,

			opaque: material.transparent === false && material.blending === NormalBlending,

			alphaMap: HAS_ALPHAMAP,
			alphaTest: HAS_ALPHATEST,

			combine: material.combine,

			//

			mapUv: HAS_MAP && getChannel(material.map.channel),
			aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
			lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
			bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
			normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
			displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
			emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),

			metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
			roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),

			clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
			clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
			clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),

			iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
			iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),

			sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
			sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),

			specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
			specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
			specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),

			transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
			thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),

			alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),

			//

			vertexTangents: HAS_NORMALMAP && !!geometry.attributes.tangent,
			vertexColors: material.vertexColors,
			vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
			vertexUvs2: HAS_ATTRIBUTE_UV2,

			pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),

			fog: !!fog,
			useFog: material.fog === true,
			fogExp2: fog && fog.isFogExp2,

			flatShading: material.flatShading === true,

			sizeAttenuation: material.sizeAttenuation === true,
			logarithmicDepthBuffer: logarithmicDepthBuffer,

			skinning: object.isSkinnedMesh === true,

			morphTargets: geometry.morphAttributes.position !== undefined,
			morphNormals: geometry.morphAttributes.normal !== undefined,
			morphColors: geometry.morphAttributes.color !== undefined,
			morphTargetsCount: morphTargetsCount,
			morphTextureStride: morphTextureStride,

			numDirLights: lights.directional.length,
			numPointLights: lights.point.length,
			numSpotLights: lights.spot.length,
			numSpotLightMaps: lights.spotLightMap.length,
			numRectAreaLights: lights.rectArea.length,
			numHemiLights: lights.hemi.length,

			numDirLightShadows: lights.directionalShadowMap.length,
			numPointLightShadows: lights.pointShadowMap.length,
			numSpotLightShadows: lights.spotShadowMap.length,
			numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,

			numClippingPlanes: clipping.numPlanes,
			numClipIntersection: clipping.numIntersection,

			dithering: material.dithering,

			shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
			shadowMapType: renderer.shadowMap.type,

			toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
			useLegacyLights: renderer.useLegacyLights,

			premultipliedAlpha: material.premultipliedAlpha,

			doubleSided: material.side === DoubleSide,
			flipSided: material.side === BackSide,

			useDepthPacking: material.depthPacking >= 0,
			depthPacking: material.depthPacking || 0,

			index0AttributeName: material.index0AttributeName,

			extensionDerivatives: HAS_EXTENSIONS && material.extensions.derivatives === true,
			extensionFragDepth: HAS_EXTENSIONS && material.extensions.fragDepth === true,
			extensionDrawBuffers: HAS_EXTENSIONS && material.extensions.drawBuffers === true,
			extensionShaderTextureLOD: HAS_EXTENSIONS && material.extensions.shaderTextureLOD === true,

			rendererExtensionFragDepth: IS_WEBGL2 || extensions.has('EXT_frag_depth'),
			rendererExtensionDrawBuffers: IS_WEBGL2 || extensions.has('WEBGL_draw_buffers'),
			rendererExtensionShaderTextureLod: IS_WEBGL2 || extensions.has('EXT_shader_texture_lod'),

			customProgramCacheKey: material.customProgramCacheKey()

		};

		return parameters;
	}

	function getProgramCacheKey(parameters) {

		var array = [];

		if (parameters.shaderID) {

			array.push(parameters.shaderID);
		} else {

			array.push(parameters.customVertexShaderID);
			array.push(parameters.customFragmentShaderID);
		}

		if (parameters.defines !== undefined) {

			for (var name in parameters.defines) {

				array.push(name);
				array.push(parameters.defines[name]);
			}
		}

		if (parameters.isRawShaderMaterial === false) {

			getProgramCacheKeyParameters(array, parameters);
			getProgramCacheKeyBooleans(array, parameters);
			array.push(renderer.outputEncoding);
		}

		array.push(parameters.customProgramCacheKey);

		return array.join();
	}

	function getProgramCacheKeyParameters(array, parameters) {

		array.push(parameters.precision);
		array.push(parameters.outputEncoding);
		array.push(parameters.envMapMode);
		array.push(parameters.envMapCubeUVHeight);
		array.push(parameters.mapUv);
		array.push(parameters.alphaMapUv);
		array.push(parameters.lightMapUv);
		array.push(parameters.aoMapUv);
		array.push(parameters.bumpMapUv);
		array.push(parameters.normalMapUv);
		array.push(parameters.displacementMapUv);
		array.push(parameters.emissiveMapUv);
		array.push(parameters.metalnessMapUv);
		array.push(parameters.roughnessMapUv);
		array.push(parameters.clearcoatMapUv);
		array.push(parameters.clearcoatNormalMapUv);
		array.push(parameters.clearcoatRoughnessMapUv);
		array.push(parameters.iridescenceMapUv);
		array.push(parameters.iridescenceThicknessMapUv);
		array.push(parameters.sheenColorMapUv);
		array.push(parameters.sheenRoughnessMapUv);
		array.push(parameters.specularMapUv);
		array.push(parameters.specularColorMapUv);
		array.push(parameters.specularIntensityMapUv);
		array.push(parameters.transmissionMapUv);
		array.push(parameters.thicknessMapUv);
		array.push(parameters.combine);
		array.push(parameters.fogExp2);
		array.push(parameters.sizeAttenuation);
		array.push(parameters.morphTargetsCount);
		array.push(parameters.morphAttributeCount);
		array.push(parameters.numDirLights);
		array.push(parameters.numPointLights);
		array.push(parameters.numSpotLights);
		array.push(parameters.numSpotLightMaps);
		array.push(parameters.numHemiLights);
		array.push(parameters.numRectAreaLights);
		array.push(parameters.numDirLightShadows);
		array.push(parameters.numPointLightShadows);
		array.push(parameters.numSpotLightShadows);
		array.push(parameters.numSpotLightShadowsWithMaps);
		array.push(parameters.shadowMapType);
		array.push(parameters.toneMapping);
		array.push(parameters.numClippingPlanes);
		array.push(parameters.numClipIntersection);
		array.push(parameters.depthPacking);
	}

	function getProgramCacheKeyBooleans(array, parameters) {

		_programLayers.disableAll();

		if (parameters.isWebGL2) _programLayers.enable(0);
		if (parameters.supportsVertexTextures) _programLayers.enable(1);
		if (parameters.instancing) _programLayers.enable(2);
		if (parameters.instancingColor) _programLayers.enable(3);
		if (parameters.matcap) _programLayers.enable(4);
		if (parameters.envMap) _programLayers.enable(5);
		if (parameters.normalMapObjectSpace) _programLayers.enable(6);
		if (parameters.normalMapTangentSpace) _programLayers.enable(7);
		if (parameters.clearcoat) _programLayers.enable(8);
		if (parameters.iridescence) _programLayers.enable(9);
		if (parameters.alphaTest) _programLayers.enable(10);
		if (parameters.vertexColors) _programLayers.enable(11);
		if (parameters.vertexAlphas) _programLayers.enable(12);
		if (parameters.vertexUvs2) _programLayers.enable(13);
		if (parameters.vertexTangents) _programLayers.enable(14);

		array.push(_programLayers.mask);
		_programLayers.disableAll();

		if (parameters.fog) _programLayers.enable(0);
		if (parameters.useFog) _programLayers.enable(1);
		if (parameters.flatShading) _programLayers.enable(2);
		if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
		if (parameters.skinning) _programLayers.enable(4);
		if (parameters.morphTargets) _programLayers.enable(5);
		if (parameters.morphNormals) _programLayers.enable(6);
		if (parameters.morphColors) _programLayers.enable(7);
		if (parameters.premultipliedAlpha) _programLayers.enable(8);
		if (parameters.shadowMapEnabled) _programLayers.enable(9);
		if (parameters.useLegacyLights) _programLayers.enable(10);
		if (parameters.doubleSided) _programLayers.enable(11);
		if (parameters.flipSided) _programLayers.enable(12);
		if (parameters.useDepthPacking) _programLayers.enable(13);
		if (parameters.dithering) _programLayers.enable(14);
		if (parameters.transmission) _programLayers.enable(15);
		if (parameters.sheen) _programLayers.enable(16);
		if (parameters.decodeVideoTexture) _programLayers.enable(17);
		if (parameters.opaque) _programLayers.enable(18);
		if (parameters.pointsUvs) _programLayers.enable(19);

		array.push(_programLayers.mask);
	}

	function getUniforms(material) {

		var shaderID = shaderIDs[material.type];
		var uniforms = void 0;

		if (shaderID) {

			var shader = ShaderLib[shaderID];
			uniforms = UniformsUtils.clone(shader.uniforms);
		} else {

			uniforms = material.uniforms;
		}

		return uniforms;
	}

	function acquireProgram(parameters, cacheKey) {

		var program = void 0;

		// Check if code has been already compiled
		for (var p = 0, pl = programs.length; p < pl; p++) {

			var preexistingProgram = programs[p];

			if (preexistingProgram.cacheKey === cacheKey) {

				program = preexistingProgram;
				++program.usedTimes;

				break;
			}
		}

		if (program === undefined) {

			program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
			programs.push(program);
		}

		return program;
	}

	function releaseProgram(program) {

		if (--program.usedTimes === 0) {

			// Remove from unordered set
			var i = programs.indexOf(program);
			programs[i] = programs[programs.length - 1];
			programs.pop();

			// Free WebGL resources
			program.destroy();
		}
	}

	function releaseShaderCache(material) {

		_customShaders.remove(material);
	}

	function dispose() {

		_customShaders.dispose();
	}

	return {
		getParameters: getParameters,
		getProgramCacheKey: getProgramCacheKey,
		getUniforms: getUniforms,
		acquireProgram: acquireProgram,
		releaseProgram: releaseProgram,
		releaseShaderCache: releaseShaderCache,
		// Exposed for resource monitoring & error feedback via renderer.info:
		programs: programs,
		dispose: dispose
	};
}

function WebGLProperties() {

	var properties = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function get(object) {

		var map = properties.get(object);

		if (map === undefined) {

			map = {};
			properties.set(object, map);
		}

		return map;
	}

	function remove(object) {

		properties.delete(object);
	}

	function update(object, key, value) {

		properties.get(object)[key] = value;
	}

	function dispose() {

		properties = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	}

	return {
		get: get,
		remove: remove,
		update: update,
		dispose: dispose
	};
}

function painterSortStable(a, b) {

	if (a.groupOrder !== b.groupOrder) {

		return a.groupOrder - b.groupOrder;
	} else if (a.renderOrder !== b.renderOrder) {

		return a.renderOrder - b.renderOrder;
	} else if (a.material.id !== b.material.id) {

		return a.material.id - b.material.id;
	} else if (a.z !== b.z) {

		return a.z - b.z;
	} else {

		return a.id - b.id;
	}
}

function reversePainterSortStable(a, b) {

	if (a.groupOrder !== b.groupOrder) {

		return a.groupOrder - b.groupOrder;
	} else if (a.renderOrder !== b.renderOrder) {

		return a.renderOrder - b.renderOrder;
	} else if (a.z !== b.z) {

		return b.z - a.z;
	} else {

		return a.id - b.id;
	}
}

function WebGLRenderList() {

	var renderItems = [];
	var renderItemsIndex = 0;

	var opaque = [];
	var transmissive = [];
	var transparent = [];

	function init() {

		renderItemsIndex = 0;

		opaque.length = 0;
		transmissive.length = 0;
		transparent.length = 0;
	}

	function getNextRenderItem(object, geometry, material, groupOrder, z, group) {

		var renderItem = renderItems[renderItemsIndex];

		if (renderItem === undefined) {

			renderItem = {
				id: object.id,
				object: object,
				geometry: geometry,
				material: material,
				groupOrder: groupOrder,
				renderOrder: object.renderOrder,
				z: z,
				group: group
			};

			renderItems[renderItemsIndex] = renderItem;
		} else {

			renderItem.id = object.id;
			renderItem.object = object;
			renderItem.geometry = geometry;
			renderItem.material = material;
			renderItem.groupOrder = groupOrder;
			renderItem.renderOrder = object.renderOrder;
			renderItem.z = z;
			renderItem.group = group;
		}

		renderItemsIndex++;

		return renderItem;
	}

	function push(object, geometry, material, groupOrder, z, group) {

		var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);

		if (material.transmission > 0.0) {

			transmissive.push(renderItem);
		} else if (material.transparent === true) {

			transparent.push(renderItem);
		} else {

			opaque.push(renderItem);
		}
	}

	function unshift(object, geometry, material, groupOrder, z, group) {

		var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);

		if (material.transmission > 0.0) {

			transmissive.unshift(renderItem);
		} else if (material.transparent === true) {

			transparent.unshift(renderItem);
		} else {

			opaque.unshift(renderItem);
		}
	}

	function sort(customOpaqueSort, customTransparentSort) {

		if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
		if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
		if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
	}

	function finish() {

		// Clear references from inactive renderItems in the list

		for (var i = renderItemsIndex, il = renderItems.length; i < il; i++) {

			var renderItem = renderItems[i];

			if (renderItem.id === null) break;

			renderItem.id = null;
			renderItem.object = null;
			renderItem.geometry = null;
			renderItem.material = null;
			renderItem.group = null;
		}
	}

	return {

		opaque: opaque,
		transmissive: transmissive,
		transparent: transparent,

		init: init,
		push: push,
		unshift: unshift,
		finish: finish,

		sort: sort
	};
}

function WebGLRenderLists() {

	var lists = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function get(scene, renderCallDepth) {

		var listArray = lists.get(scene);
		var list = void 0;

		if (listArray === undefined) {

			list = new WebGLRenderList();
			lists.set(scene, [list]);
		} else {

			if (renderCallDepth >= listArray.length) {

				list = new WebGLRenderList();
				listArray.push(list);
			} else {

				list = listArray[renderCallDepth];
			}
		}

		return list;
	}

	function dispose() {

		lists = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	}

	return {
		get: get,
		dispose: dispose
	};
}

function UniformsCache() {

	var lights = {};

	return {

		get: function get(light) {

			if (lights[light.id] !== undefined) {

				return lights[light.id];
			}

			var uniforms = void 0;

			switch (light.type) {

				case 'DirectionalLight':
					uniforms = {
						direction: new Vector3(),
						color: new Color()
					};
					break;

				case 'SpotLight':
					uniforms = {
						position: new Vector3(),
						direction: new Vector3(),
						color: new Color(),
						distance: 0,
						coneCos: 0,
						penumbraCos: 0,
						decay: 0
					};
					break;

				case 'PointLight':
					uniforms = {
						position: new Vector3(),
						color: new Color(),
						distance: 0,
						decay: 0
					};
					break;

				case 'HemisphereLight':
					uniforms = {
						direction: new Vector3(),
						skyColor: new Color(),
						groundColor: new Color()
					};
					break;

				case 'RectAreaLight':
					uniforms = {
						color: new Color(),
						position: new Vector3(),
						halfWidth: new Vector3(),
						halfHeight: new Vector3()
					};
					break;

			}

			lights[light.id] = uniforms;

			return uniforms;
		}

	};
}

function ShadowUniformsCache() {

	var lights = {};

	return {

		get: function get(light) {

			if (lights[light.id] !== undefined) {

				return lights[light.id];
			}

			var uniforms = void 0;

			switch (light.type) {

				case 'DirectionalLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'SpotLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2()
					};
					break;

				case 'PointLight':
					uniforms = {
						shadowBias: 0,
						shadowNormalBias: 0,
						shadowRadius: 1,
						shadowMapSize: new Vector2(),
						shadowCameraNear: 1,
						shadowCameraFar: 1000
					};
					break;

				// TODO (abelnation): set RectAreaLight shadow uniforms

			}

			lights[light.id] = uniforms;

			return uniforms;
		}

	};
}

var nextVersion = 0;

function shadowCastingAndTexturingLightsFirst(lightA, lightB) {

	return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}

function WebGLLights(extensions, capabilities) {

	var cache = new UniformsCache();

	var shadowCache = ShadowUniformsCache();

	var state = {

		version: 0,

		hash: {
			directionalLength: -1,
			pointLength: -1,
			spotLength: -1,
			rectAreaLength: -1,
			hemiLength: -1,

			numDirectionalShadows: -1,
			numPointShadows: -1,
			numSpotShadows: -1,
			numSpotMaps: -1
		},

		ambient: [0, 0, 0],
		probe: [],
		directional: [],
		directionalShadow: [],
		directionalShadowMap: [],
		directionalShadowMatrix: [],
		spot: [],
		spotLightMap: [],
		spotShadow: [],
		spotShadowMap: [],
		spotLightMatrix: [],
		rectArea: [],
		rectAreaLTC1: null,
		rectAreaLTC2: null,
		point: [],
		pointShadow: [],
		pointShadowMap: [],
		pointShadowMatrix: [],
		hemi: [],
		numSpotLightShadowsWithMaps: 0

	};

	for (var i = 0; i < 9; i++) {
		state.probe.push(new Vector3());
	}var vector3 = new Vector3();
	var matrix4 = new Matrix4();
	var matrix42 = new Matrix4();

	function setup(lights, useLegacyLights) {

		var r = 0,
		    g = 0,
		    b = 0;

		for (var _i36 = 0; _i36 < 9; _i36++) {
			state.probe[_i36].set(0, 0, 0);
		}var directionalLength = 0;
		var pointLength = 0;
		var spotLength = 0;
		var rectAreaLength = 0;
		var hemiLength = 0;

		var numDirectionalShadows = 0;
		var numPointShadows = 0;
		var numSpotShadows = 0;
		var numSpotMaps = 0;
		var numSpotShadowsWithMaps = 0;

		// ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
		lights.sort(shadowCastingAndTexturingLightsFirst);

		// artist-friendly light intensity scaling factor
		var scaleFactor = useLegacyLights === true ? Math.PI : 1;

		for (var _i37 = 0, l = lights.length; _i37 < l; _i37++) {

			var light = lights[_i37];

			var color = light.color;
			var intensity = light.intensity;
			var distance = light.distance;

			var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;

			if (light.isAmbientLight) {

				r += color.r * intensity * scaleFactor;
				g += color.g * intensity * scaleFactor;
				b += color.b * intensity * scaleFactor;
			} else if (light.isLightProbe) {

				for (var j = 0; j < 9; j++) {

					state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
				}
			} else if (light.isDirectionalLight) {

				var uniforms = cache.get(light);

				uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);

				if (light.castShadow) {

					var shadow = light.shadow;

					var shadowUniforms = shadowCache.get(light);

					shadowUniforms.shadowBias = shadow.bias;
					shadowUniforms.shadowNormalBias = shadow.normalBias;
					shadowUniforms.shadowRadius = shadow.radius;
					shadowUniforms.shadowMapSize = shadow.mapSize;

					state.directionalShadow[directionalLength] = shadowUniforms;
					state.directionalShadowMap[directionalLength] = shadowMap;
					state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;

					numDirectionalShadows++;
				}

				state.directional[directionalLength] = uniforms;

				directionalLength++;
			} else if (light.isSpotLight) {

				var _uniforms = cache.get(light);

				_uniforms.position.setFromMatrixPosition(light.matrixWorld);

				_uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
				_uniforms.distance = distance;

				_uniforms.coneCos = Math.cos(light.angle);
				_uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
				_uniforms.decay = light.decay;

				state.spot[spotLength] = _uniforms;

				var _shadow = light.shadow;

				if (light.map) {

					state.spotLightMap[numSpotMaps] = light.map;
					numSpotMaps++;

					// make sure the lightMatrix is up to date
					// TODO : do it if required only
					_shadow.updateMatrices(light);

					if (light.castShadow) numSpotShadowsWithMaps++;
				}

				state.spotLightMatrix[spotLength] = _shadow.matrix;

				if (light.castShadow) {

					var _shadowUniforms = shadowCache.get(light);

					_shadowUniforms.shadowBias = _shadow.bias;
					_shadowUniforms.shadowNormalBias = _shadow.normalBias;
					_shadowUniforms.shadowRadius = _shadow.radius;
					_shadowUniforms.shadowMapSize = _shadow.mapSize;

					state.spotShadow[spotLength] = _shadowUniforms;
					state.spotShadowMap[spotLength] = shadowMap;

					numSpotShadows++;
				}

				spotLength++;
			} else if (light.isRectAreaLight) {

				var _uniforms2 = cache.get(light);

				_uniforms2.color.copy(color).multiplyScalar(intensity);

				_uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);
				_uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);

				state.rectArea[rectAreaLength] = _uniforms2;

				rectAreaLength++;
			} else if (light.isPointLight) {

				var _uniforms3 = cache.get(light);

				_uniforms3.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
				_uniforms3.distance = light.distance;
				_uniforms3.decay = light.decay;

				if (light.castShadow) {

					var _shadow2 = light.shadow;

					var _shadowUniforms2 = shadowCache.get(light);

					_shadowUniforms2.shadowBias = _shadow2.bias;
					_shadowUniforms2.shadowNormalBias = _shadow2.normalBias;
					_shadowUniforms2.shadowRadius = _shadow2.radius;
					_shadowUniforms2.shadowMapSize = _shadow2.mapSize;
					_shadowUniforms2.shadowCameraNear = _shadow2.camera.near;
					_shadowUniforms2.shadowCameraFar = _shadow2.camera.far;

					state.pointShadow[pointLength] = _shadowUniforms2;
					state.pointShadowMap[pointLength] = shadowMap;
					state.pointShadowMatrix[pointLength] = light.shadow.matrix;

					numPointShadows++;
				}

				state.point[pointLength] = _uniforms3;

				pointLength++;
			} else if (light.isHemisphereLight) {

				var _uniforms4 = cache.get(light);

				_uniforms4.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
				_uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);

				state.hemi[hemiLength] = _uniforms4;

				hemiLength++;
			}
		}

		if (rectAreaLength > 0) {

			if (capabilities.isWebGL2) {

				// WebGL 2

				state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
				state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
			} else {

				// WebGL 1

				if (extensions.has('OES_texture_float_linear') === true) {

					state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
					state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
				} else if (extensions.has('OES_texture_half_float_linear') === true) {

					state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
					state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
				} else {

					console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
				}
			}
		}

		state.ambient[0] = r;
		state.ambient[1] = g;
		state.ambient[2] = b;

		var hash = state.hash;

		if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {

			state.directional.length = directionalLength;
			state.spot.length = spotLength;
			state.rectArea.length = rectAreaLength;
			state.point.length = pointLength;
			state.hemi.length = hemiLength;

			state.directionalShadow.length = numDirectionalShadows;
			state.directionalShadowMap.length = numDirectionalShadows;
			state.pointShadow.length = numPointShadows;
			state.pointShadowMap.length = numPointShadows;
			state.spotShadow.length = numSpotShadows;
			state.spotShadowMap.length = numSpotShadows;
			state.directionalShadowMatrix.length = numDirectionalShadows;
			state.pointShadowMatrix.length = numPointShadows;
			state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
			state.spotLightMap.length = numSpotMaps;
			state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;

			hash.directionalLength = directionalLength;
			hash.pointLength = pointLength;
			hash.spotLength = spotLength;
			hash.rectAreaLength = rectAreaLength;
			hash.hemiLength = hemiLength;

			hash.numDirectionalShadows = numDirectionalShadows;
			hash.numPointShadows = numPointShadows;
			hash.numSpotShadows = numSpotShadows;
			hash.numSpotMaps = numSpotMaps;

			state.version = nextVersion++;
		}
	}

	function setupView(lights, camera) {

		var directionalLength = 0;
		var pointLength = 0;
		var spotLength = 0;
		var rectAreaLength = 0;
		var hemiLength = 0;

		var viewMatrix = camera.matrixWorldInverse;

		for (var _i38 = 0, l = lights.length; _i38 < l; _i38++) {

			var light = lights[_i38];

			if (light.isDirectionalLight) {

				var uniforms = state.directional[directionalLength];

				uniforms.direction.setFromMatrixPosition(light.matrixWorld);
				vector3.setFromMatrixPosition(light.target.matrixWorld);
				uniforms.direction.sub(vector3);
				uniforms.direction.transformDirection(viewMatrix);

				directionalLength++;
			} else if (light.isSpotLight) {

				var _uniforms5 = state.spot[spotLength];

				_uniforms5.position.setFromMatrixPosition(light.matrixWorld);
				_uniforms5.position.applyMatrix4(viewMatrix);

				_uniforms5.direction.setFromMatrixPosition(light.matrixWorld);
				vector3.setFromMatrixPosition(light.target.matrixWorld);
				_uniforms5.direction.sub(vector3);
				_uniforms5.direction.transformDirection(viewMatrix);

				spotLength++;
			} else if (light.isRectAreaLight) {

				var _uniforms6 = state.rectArea[rectAreaLength];

				_uniforms6.position.setFromMatrixPosition(light.matrixWorld);
				_uniforms6.position.applyMatrix4(viewMatrix);

				// extract local rotation of light to derive width/height half vectors
				matrix42.identity();
				matrix4.copy(light.matrixWorld);
				matrix4.premultiply(viewMatrix);
				matrix42.extractRotation(matrix4);

				_uniforms6.halfWidth.set(light.width * 0.5, 0.0, 0.0);
				_uniforms6.halfHeight.set(0.0, light.height * 0.5, 0.0);

				_uniforms6.halfWidth.applyMatrix4(matrix42);
				_uniforms6.halfHeight.applyMatrix4(matrix42);

				rectAreaLength++;
			} else if (light.isPointLight) {

				var _uniforms7 = state.point[pointLength];

				_uniforms7.position.setFromMatrixPosition(light.matrixWorld);
				_uniforms7.position.applyMatrix4(viewMatrix);

				pointLength++;
			} else if (light.isHemisphereLight) {

				var _uniforms8 = state.hemi[hemiLength];

				_uniforms8.direction.setFromMatrixPosition(light.matrixWorld);
				_uniforms8.direction.transformDirection(viewMatrix);

				hemiLength++;
			}
		}
	}

	return {
		setup: setup,
		setupView: setupView,
		state: state
	};
}

function WebGLRenderState(extensions, capabilities) {

	var lights = new WebGLLights(extensions, capabilities);

	var lightsArray = [];
	var shadowsArray = [];

	function init() {

		lightsArray.length = 0;
		shadowsArray.length = 0;
	}

	function pushLight(light) {

		lightsArray.push(light);
	}

	function pushShadow(shadowLight) {

		shadowsArray.push(shadowLight);
	}

	function setupLights(useLegacyLights) {

		lights.setup(lightsArray, useLegacyLights);
	}

	function setupLightsView(camera) {

		lights.setupView(lightsArray, camera);
	}

	var state = {
		lightsArray: lightsArray,
		shadowsArray: shadowsArray,

		lights: lights
	};

	return {
		init: init,
		state: state,
		setupLights: setupLights,
		setupLightsView: setupLightsView,

		pushLight: pushLight,
		pushShadow: pushShadow
	};
}

function WebGLRenderStates(extensions, capabilities) {

	var renderStates = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	function get(scene) {
		var renderCallDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


		var renderStateArray = renderStates.get(scene);
		var renderState = void 0;

		if (renderStateArray === undefined) {

			renderState = new WebGLRenderState(extensions, capabilities);
			renderStates.set(scene, [renderState]);
		} else {

			if (renderCallDepth >= renderStateArray.length) {

				renderState = new WebGLRenderState(extensions, capabilities);
				renderStateArray.push(renderState);
			} else {

				renderState = renderStateArray[renderCallDepth];
			}
		}

		return renderState;
	}

	function dispose() {

		renderStates = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	}

	return {
		get: get,
		dispose: dispose
	};
}

var MeshDepthMaterial = function (_Material3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshDepthMaterial, _Material3);

	function MeshDepthMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshDepthMaterial);

		var _this33 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshDepthMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshDepthMaterial)).call(this));

		_this33.isMeshDepthMaterial = true;

		_this33.type = 'MeshDepthMaterial';

		_this33.depthPacking = BasicDepthPacking;

		_this33.map = null;

		_this33.alphaMap = null;

		_this33.displacementMap = null;
		_this33.displacementScale = 1;
		_this33.displacementBias = 0;

		_this33.wireframe = false;
		_this33.wireframeLinewidth = 1;

		_this33.setValues(parameters);

		return _this33;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshDepthMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshDepthMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshDepthMaterial.prototype), 'copy', this).call(this, source);

			this.depthPacking = source.depthPacking;

			this.map = source.map;

			this.alphaMap = source.alphaMap;

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;

			return this;
		}
	}]);

	return MeshDepthMaterial;
}(Material);

var MeshDistanceMaterial = function (_Material4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshDistanceMaterial, _Material4);

	function MeshDistanceMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshDistanceMaterial);

		var _this34 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshDistanceMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshDistanceMaterial)).call(this));

		_this34.isMeshDistanceMaterial = true;

		_this34.type = 'MeshDistanceMaterial';

		_this34.map = null;

		_this34.alphaMap = null;

		_this34.displacementMap = null;
		_this34.displacementScale = 1;
		_this34.displacementBias = 0;

		_this34.setValues(parameters);

		return _this34;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshDistanceMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshDistanceMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshDistanceMaterial.prototype), 'copy', this).call(this, source);

			this.map = source.map;

			this.alphaMap = source.alphaMap;

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			return this;
		}
	}]);

	return MeshDistanceMaterial;
}(Material);

var vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";

var fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";

function WebGLShadowMap(_renderer, _objects, _capabilities) {
	var _shadowSide;

	var _frustum = new Frustum();

	var _shadowMapSize = new Vector2(),
	    _viewportSize = new Vector2(),
	    _viewport = new Vector4(),
	    _depthMaterial = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }),
	    _distanceMaterial = new MeshDistanceMaterial(),
	    _materialCache = {},
	    _maxTextureSize = _capabilities.maxTextureSize;

	var shadowSide = (_shadowSide = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_shadowSide, FrontSide, BackSide), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_shadowSide, BackSide, FrontSide), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_shadowSide, DoubleSide, DoubleSide), _shadowSide);

	var shadowMaterialVertical = new ShaderMaterial({
		defines: {
			VSM_SAMPLES: 8
		},
		uniforms: {
			shadow_pass: { value: null },
			resolution: { value: new Vector2() },
			radius: { value: 4.0 }
		},

		vertexShader: vertex,
		fragmentShader: fragment

	});

	var shadowMaterialHorizontal = shadowMaterialVertical.clone();
	shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;

	var fullScreenTri = new BufferGeometry();
	fullScreenTri.setAttribute('position', new BufferAttribute(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3));

	var fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);

	var scope = this;

	this.enabled = false;

	this.autoUpdate = true;
	this.needsUpdate = false;

	this.type = PCFShadowMap;

	this.render = function (lights, scene, camera) {

		if (scope.enabled === false) return;
		if (scope.autoUpdate === false && scope.needsUpdate === false) return;

		if (lights.length === 0) return;

		var currentRenderTarget = _renderer.getRenderTarget();
		var activeCubeFace = _renderer.getActiveCubeFace();
		var activeMipmapLevel = _renderer.getActiveMipmapLevel();

		var _state = _renderer.state;

		// Set GL state for depth map.
		_state.setBlending(NoBlending);
		_state.buffers.color.setClear(1, 1, 1, 1);
		_state.buffers.depth.setTest(true);
		_state.setScissorTest(false);

		// render depth map

		for (var i = 0, il = lights.length; i < il; i++) {

			var light = lights[i];
			var shadow = light.shadow;

			if (shadow === undefined) {

				console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
				continue;
			}

			if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;

			_shadowMapSize.copy(shadow.mapSize);

			var shadowFrameExtents = shadow.getFrameExtents();

			_shadowMapSize.multiply(shadowFrameExtents);

			_viewportSize.copy(shadow.mapSize);

			if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {

				if (_shadowMapSize.x > _maxTextureSize) {

					_viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
					_shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
					shadow.mapSize.x = _viewportSize.x;
				}

				if (_shadowMapSize.y > _maxTextureSize) {

					_viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
					_shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
					shadow.mapSize.y = _viewportSize.y;
				}
			}

			if (shadow.map === null) {

				var pars = this.type !== VSMShadowMap ? { minFilter: NearestFilter, magFilter: NearestFilter } : {};

				shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
				shadow.map.texture.name = light.name + '.shadowMap';

				shadow.camera.updateProjectionMatrix();
			}

			_renderer.setRenderTarget(shadow.map);
			_renderer.clear();

			var viewportCount = shadow.getViewportCount();

			for (var vp = 0; vp < viewportCount; vp++) {

				var viewport = shadow.getViewport(vp);

				_viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);

				_state.viewport(_viewport);

				shadow.updateMatrices(light, vp);

				_frustum = shadow.getFrustum();

				renderObject(scene, camera, shadow.camera, light, this.type);
			}

			// do blur pass for VSM

			if (shadow.isPointLightShadow !== true && this.type === VSMShadowMap) {

				VSMPass(shadow, camera);
			}

			shadow.needsUpdate = false;
		}

		scope.needsUpdate = false;

		_renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
	};

	function VSMPass(shadow, camera) {

		var geometry = _objects.update(fullScreenMesh);

		if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {

			shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
			shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;

			shadowMaterialVertical.needsUpdate = true;
			shadowMaterialHorizontal.needsUpdate = true;
		}

		if (shadow.mapPass === null) {

			shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
		}

		// vertical pass

		shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
		shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialVertical.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget(shadow.mapPass);
		_renderer.clear();
		_renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);

		// horizontal pass

		shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
		shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
		shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
		_renderer.setRenderTarget(shadow.map);
		_renderer.clear();
		_renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
	}

	function getDepthMaterial(object, material, light, type) {

		var result = null;

		var customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;

		if (customMaterial !== undefined) {

			result = customMaterial;
		} else {

			result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;

			if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {

				// in this case we need a unique material instance reflecting the
				// appropriate state

				var keyA = result.uuid,
				    keyB = material.uuid;

				var materialsForVariant = _materialCache[keyA];

				if (materialsForVariant === undefined) {

					materialsForVariant = {};
					_materialCache[keyA] = materialsForVariant;
				}

				var cachedMaterial = materialsForVariant[keyB];

				if (cachedMaterial === undefined) {

					cachedMaterial = result.clone();
					materialsForVariant[keyB] = cachedMaterial;
				}

				result = cachedMaterial;
			}
		}

		result.visible = material.visible;
		result.wireframe = material.wireframe;

		if (type === VSMShadowMap) {

			result.side = material.shadowSide !== null ? material.shadowSide : material.side;
		} else {

			result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
		}

		result.alphaMap = material.alphaMap;
		result.alphaTest = material.alphaTest;
		result.map = material.map;

		result.clipShadows = material.clipShadows;
		result.clippingPlanes = material.clippingPlanes;
		result.clipIntersection = material.clipIntersection;

		result.displacementMap = material.displacementMap;
		result.displacementScale = material.displacementScale;
		result.displacementBias = material.displacementBias;

		result.wireframeLinewidth = material.wireframeLinewidth;
		result.linewidth = material.linewidth;

		if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {

			var materialProperties = _renderer.properties.get(result);
			materialProperties.light = light;
		}

		return result;
	}

	function renderObject(object, camera, shadowCamera, light, type) {

		if (object.visible === false) return;

		var visible = object.layers.test(camera.layers);

		if (visible && (object.isMesh || object.isLine || object.isPoints)) {

			if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {

				object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);

				var geometry = _objects.update(object);
				var material = object.material;

				if (Array.isArray(material)) {

					var groups = geometry.groups;

					for (var k = 0, kl = groups.length; k < kl; k++) {

						var group = groups[k];
						var groupMaterial = material[group.materialIndex];

						if (groupMaterial && groupMaterial.visible) {

							var depthMaterial = getDepthMaterial(object, groupMaterial, light, type);

							_renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
						}
					}
				} else if (material.visible) {

					var _depthMaterial2 = getDepthMaterial(object, material, light, type);

					_renderer.renderBufferDirect(shadowCamera, null, geometry, _depthMaterial2, object, null);
				}
			}
		}

		var children = object.children;

		for (var i = 0, l = children.length; i < l; i++) {

			renderObject(children[i], camera, shadowCamera, light, type);
		}
	}
}

function WebGLState(gl, extensions, capabilities) {
	var _equationToGL, _factorToGL;

	var isWebGL2 = capabilities.isWebGL2;

	function ColorBuffer() {

		var locked = false;

		var color = new Vector4();
		var currentColorMask = null;
		var currentColorClear = new Vector4(0, 0, 0, 0);

		return {

			setMask: function setMask(colorMask) {

				if (currentColorMask !== colorMask && !locked) {

					gl.colorMask(colorMask, colorMask, colorMask, colorMask);
					currentColorMask = colorMask;
				}
			},

			setLocked: function setLocked(lock) {

				locked = lock;
			},

			setClear: function setClear(r, g, b, a, premultipliedAlpha) {

				if (premultipliedAlpha === true) {

					r *= a;g *= a;b *= a;
				}

				color.set(r, g, b, a);

				if (currentColorClear.equals(color) === false) {

					gl.clearColor(r, g, b, a);
					currentColorClear.copy(color);
				}
			},

			reset: function reset() {

				locked = false;

				currentColorMask = null;
				currentColorClear.set(-1, 0, 0, 0); // set to invalid state
			}

		};
	}

	function DepthBuffer() {

		var locked = false;

		var currentDepthMask = null;
		var currentDepthFunc = null;
		var currentDepthClear = null;

		return {

			setTest: function setTest(depthTest) {

				if (depthTest) {

					enable(2929);
				} else {

					disable(2929);
				}
			},

			setMask: function setMask(depthMask) {

				if (currentDepthMask !== depthMask && !locked) {

					gl.depthMask(depthMask);
					currentDepthMask = depthMask;
				}
			},

			setFunc: function setFunc(depthFunc) {

				if (currentDepthFunc !== depthFunc) {

					switch (depthFunc) {

						case NeverDepth:

							gl.depthFunc(512);
							break;

						case AlwaysDepth:

							gl.depthFunc(519);
							break;

						case LessDepth:

							gl.depthFunc(513);
							break;

						case LessEqualDepth:

							gl.depthFunc(515);
							break;

						case EqualDepth:

							gl.depthFunc(514);
							break;

						case GreaterEqualDepth:

							gl.depthFunc(518);
							break;

						case GreaterDepth:

							gl.depthFunc(516);
							break;

						case NotEqualDepth:

							gl.depthFunc(517);
							break;

						default:

							gl.depthFunc(515);

					}

					currentDepthFunc = depthFunc;
				}
			},

			setLocked: function setLocked(lock) {

				locked = lock;
			},

			setClear: function setClear(depth) {

				if (currentDepthClear !== depth) {

					gl.clearDepth(depth);
					currentDepthClear = depth;
				}
			},

			reset: function reset() {

				locked = false;

				currentDepthMask = null;
				currentDepthFunc = null;
				currentDepthClear = null;
			}

		};
	}

	function StencilBuffer() {

		var locked = false;

		var currentStencilMask = null;
		var currentStencilFunc = null;
		var currentStencilRef = null;
		var currentStencilFuncMask = null;
		var currentStencilFail = null;
		var currentStencilZFail = null;
		var currentStencilZPass = null;
		var currentStencilClear = null;

		return {

			setTest: function setTest(stencilTest) {

				if (!locked) {

					if (stencilTest) {

						enable(2960);
					} else {

						disable(2960);
					}
				}
			},

			setMask: function setMask(stencilMask) {

				if (currentStencilMask !== stencilMask && !locked) {

					gl.stencilMask(stencilMask);
					currentStencilMask = stencilMask;
				}
			},

			setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {

				if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {

					gl.stencilFunc(stencilFunc, stencilRef, stencilMask);

					currentStencilFunc = stencilFunc;
					currentStencilRef = stencilRef;
					currentStencilFuncMask = stencilMask;
				}
			},

			setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {

				if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {

					gl.stencilOp(stencilFail, stencilZFail, stencilZPass);

					currentStencilFail = stencilFail;
					currentStencilZFail = stencilZFail;
					currentStencilZPass = stencilZPass;
				}
			},

			setLocked: function setLocked(lock) {

				locked = lock;
			},

			setClear: function setClear(stencil) {

				if (currentStencilClear !== stencil) {

					gl.clearStencil(stencil);
					currentStencilClear = stencil;
				}
			},

			reset: function reset() {

				locked = false;

				currentStencilMask = null;
				currentStencilFunc = null;
				currentStencilRef = null;
				currentStencilFuncMask = null;
				currentStencilFail = null;
				currentStencilZFail = null;
				currentStencilZPass = null;
				currentStencilClear = null;
			}

		};
	}

	//

	var colorBuffer = new ColorBuffer();
	var depthBuffer = new DepthBuffer();
	var stencilBuffer = new StencilBuffer();

	var uboBindings = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	var uboProgramMap = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

	var enabledCapabilities = {};

	var currentBoundFramebuffers = {};
	var currentDrawbuffers = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	var defaultDrawbuffers = [];

	var currentProgram = null;

	var currentBlendingEnabled = false;
	var currentBlending = null;
	var currentBlendEquation = null;
	var currentBlendSrc = null;
	var currentBlendDst = null;
	var currentBlendEquationAlpha = null;
	var currentBlendSrcAlpha = null;
	var currentBlendDstAlpha = null;
	var currentPremultipledAlpha = false;

	var currentFlipSided = null;
	var currentCullFace = null;

	var currentLineWidth = null;

	var currentPolygonOffsetFactor = null;
	var currentPolygonOffsetUnits = null;

	var maxTextures = gl.getParameter(35661);

	var lineWidthAvailable = false;
	var version = 0;
	var glVersion = gl.getParameter(7938);

	if (glVersion.indexOf('WebGL') !== -1) {

		version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
		lineWidthAvailable = version >= 1.0;
	} else if (glVersion.indexOf('OpenGL ES') !== -1) {

		version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
		lineWidthAvailable = version >= 2.0;
	}

	var currentTextureSlot = null;
	var currentBoundTextures = {};

	var scissorParam = gl.getParameter(3088);
	var viewportParam = gl.getParameter(2978);

	var currentScissor = new Vector4().fromArray(scissorParam);
	var currentViewport = new Vector4().fromArray(viewportParam);

	function createTexture(type, target, count) {

		var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
		var texture = gl.createTexture();

		gl.bindTexture(type, texture);
		gl.texParameteri(type, 10241, 9728);
		gl.texParameteri(type, 10240, 9728);

		for (var i = 0; i < count; i++) {

			gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
		}

		return texture;
	}

	var emptyTextures = {};
	emptyTextures[3553] = createTexture(3553, 3553, 1);
	emptyTextures[34067] = createTexture(34067, 34069, 6);

	// init

	colorBuffer.setClear(0, 0, 0, 1);
	depthBuffer.setClear(1);
	stencilBuffer.setClear(0);

	enable(2929);
	depthBuffer.setFunc(LessEqualDepth);

	setFlipSided(false);
	setCullFace(CullFaceBack);
	enable(2884);

	setBlending(NoBlending);

	//

	function enable(id) {

		if (enabledCapabilities[id] !== true) {

			gl.enable(id);
			enabledCapabilities[id] = true;
		}
	}

	function disable(id) {

		if (enabledCapabilities[id] !== false) {

			gl.disable(id);
			enabledCapabilities[id] = false;
		}
	}

	function bindFramebuffer(target, framebuffer) {

		if (currentBoundFramebuffers[target] !== framebuffer) {

			gl.bindFramebuffer(target, framebuffer);

			currentBoundFramebuffers[target] = framebuffer;

			if (isWebGL2) {

				// 36009 is equivalent to 36160

				if (target === 36009) {

					currentBoundFramebuffers[36160] = framebuffer;
				}

				if (target === 36160) {

					currentBoundFramebuffers[36009] = framebuffer;
				}
			}

			return true;
		}

		return false;
	}

	function drawBuffers(renderTarget, framebuffer) {

		var drawBuffers = defaultDrawbuffers;

		var needsUpdate = false;

		if (renderTarget) {

			drawBuffers = currentDrawbuffers.get(framebuffer);

			if (drawBuffers === undefined) {

				drawBuffers = [];
				currentDrawbuffers.set(framebuffer, drawBuffers);
			}

			if (renderTarget.isWebGLMultipleRenderTargets) {

				var textures = renderTarget.texture;

				if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {

					for (var i = 0, il = textures.length; i < il; i++) {

						drawBuffers[i] = 36064 + i;
					}

					drawBuffers.length = textures.length;

					needsUpdate = true;
				}
			} else {

				if (drawBuffers[0] !== 36064) {

					drawBuffers[0] = 36064;

					needsUpdate = true;
				}
			}
		} else {

			if (drawBuffers[0] !== 1029) {

				drawBuffers[0] = 1029;

				needsUpdate = true;
			}
		}

		if (needsUpdate) {

			if (capabilities.isWebGL2) {

				gl.drawBuffers(drawBuffers);
			} else {

				extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
			}
		}
	}

	function useProgram(program) {

		if (currentProgram !== program) {

			gl.useProgram(program);

			currentProgram = program;

			return true;
		}

		return false;
	}

	var equationToGL = (_equationToGL = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_equationToGL, AddEquation, 32774), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_equationToGL, SubtractEquation, 32778), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_equationToGL, ReverseSubtractEquation, 32779), _equationToGL);

	if (isWebGL2) {

		equationToGL[MinEquation] = 32775;
		equationToGL[MaxEquation] = 32776;
	} else {

		var extension = extensions.get('EXT_blend_minmax');

		if (extension !== null) {

			equationToGL[MinEquation] = extension.MIN_EXT;
			equationToGL[MaxEquation] = extension.MAX_EXT;
		}
	}

	var factorToGL = (_factorToGL = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, ZeroFactor, 0), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, OneFactor, 1), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, SrcColorFactor, 768), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, SrcAlphaFactor, 770), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, SrcAlphaSaturateFactor, 776), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, DstColorFactor, 774), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, DstAlphaFactor, 772), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, OneMinusSrcColorFactor, 769), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, OneMinusSrcAlphaFactor, 771), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, OneMinusDstColorFactor, 775), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_factorToGL, OneMinusDstAlphaFactor, 773), _factorToGL);

	function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {

		if (blending === NoBlending) {

			if (currentBlendingEnabled === true) {

				disable(3042);
				currentBlendingEnabled = false;
			}

			return;
		}

		if (currentBlendingEnabled === false) {

			enable(3042);
			currentBlendingEnabled = true;
		}

		if (blending !== CustomBlending) {

			if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {

				if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {

					gl.blendEquation(32774);

					currentBlendEquation = AddEquation;
					currentBlendEquationAlpha = AddEquation;
				}

				if (premultipliedAlpha) {

					switch (blending) {

						case NormalBlending:
							gl.blendFuncSeparate(1, 771, 1, 771);
							break;

						case AdditiveBlending:
							gl.blendFunc(1, 1);
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate(0, 769, 0, 1);
							break;

						case MultiplyBlending:
							gl.blendFuncSeparate(0, 768, 0, 770);
							break;

						default:
							console.error('THREE.WebGLState: Invalid blending: ', blending);
							break;

					}
				} else {

					switch (blending) {

						case NormalBlending:
							gl.blendFuncSeparate(770, 771, 1, 771);
							break;

						case AdditiveBlending:
							gl.blendFunc(770, 1);
							break;

						case SubtractiveBlending:
							gl.blendFuncSeparate(0, 769, 0, 1);
							break;

						case MultiplyBlending:
							gl.blendFunc(0, 768);
							break;

						default:
							console.error('THREE.WebGLState: Invalid blending: ', blending);
							break;

					}
				}

				currentBlendSrc = null;
				currentBlendDst = null;
				currentBlendSrcAlpha = null;
				currentBlendDstAlpha = null;

				currentBlending = blending;
				currentPremultipledAlpha = premultipliedAlpha;
			}

			return;
		}

		// custom blending

		blendEquationAlpha = blendEquationAlpha || blendEquation;
		blendSrcAlpha = blendSrcAlpha || blendSrc;
		blendDstAlpha = blendDstAlpha || blendDst;

		if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {

			gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);

			currentBlendEquation = blendEquation;
			currentBlendEquationAlpha = blendEquationAlpha;
		}

		if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {

			gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);

			currentBlendSrc = blendSrc;
			currentBlendDst = blendDst;
			currentBlendSrcAlpha = blendSrcAlpha;
			currentBlendDstAlpha = blendDstAlpha;
		}

		currentBlending = blending;
		currentPremultipledAlpha = false;
	}

	function setMaterial(material, frontFaceCW) {

		material.side === DoubleSide ? disable(2884) : enable(2884);

		var flipSided = material.side === BackSide;
		if (frontFaceCW) flipSided = !flipSided;

		setFlipSided(flipSided);

		material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);

		depthBuffer.setFunc(material.depthFunc);
		depthBuffer.setTest(material.depthTest);
		depthBuffer.setMask(material.depthWrite);
		colorBuffer.setMask(material.colorWrite);

		var stencilWrite = material.stencilWrite;
		stencilBuffer.setTest(stencilWrite);
		if (stencilWrite) {

			stencilBuffer.setMask(material.stencilWriteMask);
			stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
			stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
		}

		setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);

		material.alphaToCoverage === true ? enable(32926) : disable(32926);
	}

	//

	function setFlipSided(flipSided) {

		if (currentFlipSided !== flipSided) {

			if (flipSided) {

				gl.frontFace(2304);
			} else {

				gl.frontFace(2305);
			}

			currentFlipSided = flipSided;
		}
	}

	function setCullFace(cullFace) {

		if (cullFace !== CullFaceNone) {

			enable(2884);

			if (cullFace !== currentCullFace) {

				if (cullFace === CullFaceBack) {

					gl.cullFace(1029);
				} else if (cullFace === CullFaceFront) {

					gl.cullFace(1028);
				} else {

					gl.cullFace(1032);
				}
			}
		} else {

			disable(2884);
		}

		currentCullFace = cullFace;
	}

	function setLineWidth(width) {

		if (width !== currentLineWidth) {

			if (lineWidthAvailable) gl.lineWidth(width);

			currentLineWidth = width;
		}
	}

	function setPolygonOffset(polygonOffset, factor, units) {

		if (polygonOffset) {

			enable(32823);

			if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {

				gl.polygonOffset(factor, units);

				currentPolygonOffsetFactor = factor;
				currentPolygonOffsetUnits = units;
			}
		} else {

			disable(32823);
		}
	}

	function setScissorTest(scissorTest) {

		if (scissorTest) {

			enable(3089);
		} else {

			disable(3089);
		}
	}

	// texture

	function activeTexture(webglSlot) {

		if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;

		if (currentTextureSlot !== webglSlot) {

			gl.activeTexture(webglSlot);
			currentTextureSlot = webglSlot;
		}
	}

	function bindTexture(webglType, webglTexture, webglSlot) {

		if (webglSlot === undefined) {

			if (currentTextureSlot === null) {

				webglSlot = 33984 + maxTextures - 1;
			} else {

				webglSlot = currentTextureSlot;
			}
		}

		var boundTexture = currentBoundTextures[webglSlot];

		if (boundTexture === undefined) {

			boundTexture = { type: undefined, texture: undefined };
			currentBoundTextures[webglSlot] = boundTexture;
		}

		if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {

			if (currentTextureSlot !== webglSlot) {

				gl.activeTexture(webglSlot);
				currentTextureSlot = webglSlot;
			}

			gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);

			boundTexture.type = webglType;
			boundTexture.texture = webglTexture;
		}
	}

	function unbindTexture() {

		var boundTexture = currentBoundTextures[currentTextureSlot];

		if (boundTexture !== undefined && boundTexture.type !== undefined) {

			gl.bindTexture(boundTexture.type, null);

			boundTexture.type = undefined;
			boundTexture.texture = undefined;
		}
	}

	function compressedTexImage2D() {

		try {

			gl.compressedTexImage2D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function compressedTexImage3D() {

		try {

			gl.compressedTexImage3D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texSubImage2D() {

		try {

			gl.texSubImage2D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texSubImage3D() {

		try {

			gl.texSubImage3D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function compressedTexSubImage2D() {

		try {

			gl.compressedTexSubImage2D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function compressedTexSubImage3D() {

		try {

			gl.compressedTexSubImage3D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texStorage2D() {

		try {

			gl.texStorage2D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texStorage3D() {

		try {

			gl.texStorage3D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texImage2D() {

		try {

			gl.texImage2D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	function texImage3D() {

		try {

			gl.texImage3D.apply(gl, arguments);
		} catch (error) {

			console.error('THREE.WebGLState:', error);
		}
	}

	//

	function scissor(scissor) {

		if (currentScissor.equals(scissor) === false) {

			gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
			currentScissor.copy(scissor);
		}
	}

	function viewport(viewport) {

		if (currentViewport.equals(viewport) === false) {

			gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
			currentViewport.copy(viewport);
		}
	}

	function updateUBOMapping(uniformsGroup, program) {

		var mapping = uboProgramMap.get(program);

		if (mapping === undefined) {

			mapping = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();

			uboProgramMap.set(program, mapping);
		}

		var blockIndex = mapping.get(uniformsGroup);

		if (blockIndex === undefined) {

			blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);

			mapping.set(uniformsGroup, blockIndex);
		}
	}

	function uniformBlockBinding(uniformsGroup, program) {

		var mapping = uboProgramMap.get(program);
		var blockIndex = mapping.get(uniformsGroup);

		if (uboBindings.get(program) !== blockIndex) {

			// bind shader specific block index to global block point
			gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);

			uboBindings.set(program, blockIndex);
		}
	}

	//

	function reset() {

		// reset state

		gl.disable(3042);
		gl.disable(2884);
		gl.disable(2929);
		gl.disable(32823);
		gl.disable(3089);
		gl.disable(2960);
		gl.disable(32926);

		gl.blendEquation(32774);
		gl.blendFunc(1, 0);
		gl.blendFuncSeparate(1, 0, 1, 0);

		gl.colorMask(true, true, true, true);
		gl.clearColor(0, 0, 0, 0);

		gl.depthMask(true);
		gl.depthFunc(513);
		gl.clearDepth(1);

		gl.stencilMask(0xffffffff);
		gl.stencilFunc(519, 0, 0xffffffff);
		gl.stencilOp(7680, 7680, 7680);
		gl.clearStencil(0);

		gl.cullFace(1029);
		gl.frontFace(2305);

		gl.polygonOffset(0, 0);

		gl.activeTexture(33984);

		gl.bindFramebuffer(36160, null);

		if (isWebGL2 === true) {

			gl.bindFramebuffer(36009, null);
			gl.bindFramebuffer(36008, null);
		}

		gl.useProgram(null);

		gl.lineWidth(1);

		gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
		gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);

		// reset internals

		enabledCapabilities = {};

		currentTextureSlot = null;
		currentBoundTextures = {};

		currentBoundFramebuffers = {};
		currentDrawbuffers = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
		defaultDrawbuffers = [];

		currentProgram = null;

		currentBlendingEnabled = false;
		currentBlending = null;
		currentBlendEquation = null;
		currentBlendSrc = null;
		currentBlendDst = null;
		currentBlendEquationAlpha = null;
		currentBlendSrcAlpha = null;
		currentBlendDstAlpha = null;
		currentPremultipledAlpha = false;

		currentFlipSided = null;
		currentCullFace = null;

		currentLineWidth = null;

		currentPolygonOffsetFactor = null;
		currentPolygonOffsetUnits = null;

		currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
		currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);

		colorBuffer.reset();
		depthBuffer.reset();
		stencilBuffer.reset();
	}

	return {

		buffers: {
			color: colorBuffer,
			depth: depthBuffer,
			stencil: stencilBuffer
		},

		enable: enable,
		disable: disable,

		bindFramebuffer: bindFramebuffer,
		drawBuffers: drawBuffers,

		useProgram: useProgram,

		setBlending: setBlending,
		setMaterial: setMaterial,

		setFlipSided: setFlipSided,
		setCullFace: setCullFace,

		setLineWidth: setLineWidth,
		setPolygonOffset: setPolygonOffset,

		setScissorTest: setScissorTest,

		activeTexture: activeTexture,
		bindTexture: bindTexture,
		unbindTexture: unbindTexture,
		compressedTexImage2D: compressedTexImage2D,
		compressedTexImage3D: compressedTexImage3D,
		texImage2D: texImage2D,
		texImage3D: texImage3D,

		updateUBOMapping: updateUBOMapping,
		uniformBlockBinding: uniformBlockBinding,

		texStorage2D: texStorage2D,
		texStorage3D: texStorage3D,
		texSubImage2D: texSubImage2D,
		texSubImage3D: texSubImage3D,
		compressedTexSubImage2D: compressedTexSubImage2D,
		compressedTexSubImage3D: compressedTexSubImage3D,

		scissor: scissor,
		viewport: viewport,

		reset: reset

	};
}

function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
	var _wrappingToGL, _filterToGL;

	var isWebGL2 = capabilities.isWebGL2;
	var maxTextures = capabilities.maxTextures;
	var maxCubemapSize = capabilities.maxCubemapSize;
	var maxTextureSize = capabilities.maxTextureSize;
	var maxSamples = capabilities.maxSamples;
	var multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
	var supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);

	var _videoTextures = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a();
	var _canvas = void 0;

	var _sources = new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_weak_map___default.a(); // maps WebglTexture objects to instances of Source

	// cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
	// also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
	// Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).

	var useOffscreenCanvas = false;

	try {

		useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined'
		// eslint-disable-next-line compat/compat
		&& new OffscreenCanvas(1, 1).getContext('2d') !== null;
	} catch (err) {

		// Ignore any errors

	}

	function createCanvas(width, height) {

		// Use OffscreenCanvas when available. Specially needed in web workers

		return useOffscreenCanvas ?
		// eslint-disable-next-line compat/compat
		new OffscreenCanvas(width, height) : createElementNS('canvas');
	}

	function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {

		var scale = 1;

		// handle case if texture exceeds max size

		if (image.width > maxSize || image.height > maxSize) {

			scale = maxSize / Math.max(image.width, image.height);
		}

		// only perform resize if necessary

		if (scale < 1 || needsPowerOfTwo === true) {

			// only perform resize for certain image types

			if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {

				var floor = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;

				var width = floor(scale * image.width);
				var height = floor(scale * image.height);

				if (_canvas === undefined) _canvas = createCanvas(width, height);

				// cube textures can't reuse the same canvas

				var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;

				canvas.width = width;
				canvas.height = height;

				var context = canvas.getContext('2d');
				context.drawImage(image, 0, 0, width, height);

				console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');

				return canvas;
			} else {

				if ('data' in image) {

					console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
				}

				return image;
			}
		}

		return image;
	}

	function isPowerOfTwo$1(image) {

		return isPowerOfTwo(image.width) && isPowerOfTwo(image.height);
	}

	function textureNeedsPowerOfTwo(texture) {

		if (isWebGL2) return false;

		return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
	}

	function textureNeedsGenerateMipmaps(texture, supportsMips) {

		return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
	}

	function generateMipmap(target) {

		_gl.generateMipmap(target);
	}

	function getInternalFormat(internalFormatName, glFormat, glType, encoding) {
		var forceLinearEncoding = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


		if (isWebGL2 === false) return glFormat;

		if (internalFormatName !== null) {

			if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];

			console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
		}

		var internalFormat = glFormat;

		if (glFormat === 6403) {

			if (glType === 5126) internalFormat = 33326;
			if (glType === 5131) internalFormat = 33325;
			if (glType === 5121) internalFormat = 33321;
		}

		if (glFormat === 33319) {

			if (glType === 5126) internalFormat = 33328;
			if (glType === 5131) internalFormat = 33327;
			if (glType === 5121) internalFormat = 33323;
		}

		if (glFormat === 6408) {

			if (glType === 5126) internalFormat = 34836;
			if (glType === 5131) internalFormat = 34842;
			if (glType === 5121) internalFormat = encoding === sRGBEncoding && forceLinearEncoding === false ? 35907 : 32856;
			if (glType === 32819) internalFormat = 32854;
			if (glType === 32820) internalFormat = 32855;
		}

		if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) {

			extensions.get('EXT_color_buffer_float');
		}

		return internalFormat;
	}

	function getMipLevels(texture, image, supportsMips) {

		if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {

			return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_math_log2___default()(Math.max(image.width, image.height)) + 1;
		} else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) {

			// user-defined mipmaps

			return texture.mipmaps.length;
		} else if (texture.isCompressedTexture && Array.isArray(texture.image)) {

			return image.mipmaps.length;
		} else {

			// texture without mipmaps (only base level)

			return 1;
		}
	}

	// Fallback filters for non-power-of-2 textures

	function filterFallback(f) {

		if (f === NearestFilter || f === NearestMipmapNearestFilter || f === NearestMipmapLinearFilter) {

			return 9728;
		}

		return 9729;
	}

	//

	function onTextureDispose(event) {

		var texture = event.target;

		texture.removeEventListener('dispose', onTextureDispose);

		deallocateTexture(texture);

		if (texture.isVideoTexture) {

			_videoTextures.delete(texture);
		}
	}

	function onRenderTargetDispose(event) {

		var renderTarget = event.target;

		renderTarget.removeEventListener('dispose', onRenderTargetDispose);

		deallocateRenderTarget(renderTarget);
	}

	//

	function deallocateTexture(texture) {

		var textureProperties = properties.get(texture);

		if (textureProperties.__webglInit === undefined) return;

		// check if it's necessary to remove the WebGLTexture object

		var source = texture.source;
		var webglTextures = _sources.get(source);

		if (webglTextures) {

			var webglTexture = webglTextures[textureProperties.__cacheKey];
			webglTexture.usedTimes--;

			// the WebGLTexture object is not used anymore, remove it

			if (webglTexture.usedTimes === 0) {

				deleteTexture(texture);
			}

			// remove the weak map entry if no WebGLTexture uses the source anymore

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(webglTextures).length === 0) {

				_sources.delete(source);
			}
		}

		properties.remove(texture);
	}

	function deleteTexture(texture) {

		var textureProperties = properties.get(texture);
		_gl.deleteTexture(textureProperties.__webglTexture);

		var source = texture.source;
		var webglTextures = _sources.get(source);
		delete webglTextures[textureProperties.__cacheKey];

		info.memory.textures--;
	}

	function deallocateRenderTarget(renderTarget) {

		var texture = renderTarget.texture;

		var renderTargetProperties = properties.get(renderTarget);
		var textureProperties = properties.get(texture);

		if (textureProperties.__webglTexture !== undefined) {

			_gl.deleteTexture(textureProperties.__webglTexture);

			info.memory.textures--;
		}

		if (renderTarget.depthTexture) {

			renderTarget.depthTexture.dispose();
		}

		if (renderTarget.isWebGLCubeRenderTarget) {

			for (var i = 0; i < 6; i++) {

				_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
				if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
			}
		} else {

			_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
			if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
			if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);

			if (renderTargetProperties.__webglColorRenderbuffer) {

				for (var _i39 = 0; _i39 < renderTargetProperties.__webglColorRenderbuffer.length; _i39++) {

					if (renderTargetProperties.__webglColorRenderbuffer[_i39]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[_i39]);
				}
			}

			if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
		}

		if (renderTarget.isWebGLMultipleRenderTargets) {

			for (var _i40 = 0, il = texture.length; _i40 < il; _i40++) {

				var attachmentProperties = properties.get(texture[_i40]);

				if (attachmentProperties.__webglTexture) {

					_gl.deleteTexture(attachmentProperties.__webglTexture);

					info.memory.textures--;
				}

				properties.remove(texture[_i40]);
			}
		}

		properties.remove(texture);
		properties.remove(renderTarget);
	}

	//

	var textureUnits = 0;

	function resetTextureUnits() {

		textureUnits = 0;
	}

	function allocateTextureUnit() {

		var textureUnit = textureUnits;

		if (textureUnit >= maxTextures) {

			console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
		}

		textureUnits += 1;

		return textureUnit;
	}

	function getTextureCacheKey(texture) {

		var array = [];

		array.push(texture.wrapS);
		array.push(texture.wrapT);
		array.push(texture.wrapR || 0);
		array.push(texture.magFilter);
		array.push(texture.minFilter);
		array.push(texture.anisotropy);
		array.push(texture.internalFormat);
		array.push(texture.format);
		array.push(texture.type);
		array.push(texture.generateMipmaps);
		array.push(texture.premultiplyAlpha);
		array.push(texture.flipY);
		array.push(texture.unpackAlignment);
		array.push(texture.encoding);

		return array.join();
	}

	//

	function setTexture2D(texture, slot) {

		var textureProperties = properties.get(texture);

		if (texture.isVideoTexture) updateVideoTexture(texture);

		if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {

			var image = texture.image;

			if (image === null) {

				console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
			} else if (image.complete === false) {

				console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
			} else {

				uploadTexture(textureProperties, texture, slot);
				return;
			}
		}

		state.bindTexture(3553, textureProperties.__webglTexture, 33984 + slot);
	}

	function setTexture2DArray(texture, slot) {

		var textureProperties = properties.get(texture);

		if (texture.version > 0 && textureProperties.__version !== texture.version) {

			uploadTexture(textureProperties, texture, slot);
			return;
		}

		state.bindTexture(35866, textureProperties.__webglTexture, 33984 + slot);
	}

	function setTexture3D(texture, slot) {

		var textureProperties = properties.get(texture);

		if (texture.version > 0 && textureProperties.__version !== texture.version) {

			uploadTexture(textureProperties, texture, slot);
			return;
		}

		state.bindTexture(32879, textureProperties.__webglTexture, 33984 + slot);
	}

	function setTextureCube(texture, slot) {

		var textureProperties = properties.get(texture);

		if (texture.version > 0 && textureProperties.__version !== texture.version) {

			uploadCubeTexture(textureProperties, texture, slot);
			return;
		}

		state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);
	}

	var wrappingToGL = (_wrappingToGL = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_wrappingToGL, RepeatWrapping, 10497), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_wrappingToGL, ClampToEdgeWrapping, 33071), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_wrappingToGL, MirroredRepeatWrapping, 33648), _wrappingToGL);

	var filterToGL = (_filterToGL = {}, __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, NearestFilter, 9728), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, NearestMipmapNearestFilter, 9984), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, NearestMipmapLinearFilter, 9986), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, LinearFilter, 9729), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, LinearMipmapNearestFilter, 9985), __WEBPACK_IMPORTED_MODULE_23_babel_runtime_helpers_defineProperty___default()(_filterToGL, LinearMipmapLinearFilter, 9987), _filterToGL);

	function setTextureParameters(textureType, texture, supportsMips) {

		if (supportsMips) {

			_gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
			_gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);

			if (textureType === 32879 || textureType === 35866) {

				_gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
			}

			_gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
			_gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
		} else {

			_gl.texParameteri(textureType, 10242, 33071);
			_gl.texParameteri(textureType, 10243, 33071);

			if (textureType === 32879 || textureType === 35866) {

				_gl.texParameteri(textureType, 32882, 33071);
			}

			if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) {

				console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
			}

			_gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
			_gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));

			if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {

				console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
			}
		}

		if (extensions.has('EXT_texture_filter_anisotropic') === true) {

			var extension = extensions.get('EXT_texture_filter_anisotropic');

			if (texture.magFilter === NearestFilter) return;
			if (texture.minFilter !== NearestMipmapLinearFilter && texture.minFilter !== LinearMipmapLinearFilter) return;
			if (texture.type === FloatType && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
			if (isWebGL2 === false && texture.type === HalfFloatType && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only

			if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {

				_gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
				properties.get(texture).__currentAnisotropy = texture.anisotropy;
			}
		}
	}

	function initTexture(textureProperties, texture) {

		var forceUpload = false;

		if (textureProperties.__webglInit === undefined) {

			textureProperties.__webglInit = true;

			texture.addEventListener('dispose', onTextureDispose);
		}

		// create Source <-> WebGLTextures mapping if necessary

		var source = texture.source;
		var webglTextures = _sources.get(source);

		if (webglTextures === undefined) {

			webglTextures = {};
			_sources.set(source, webglTextures);
		}

		// check if there is already a WebGLTexture object for the given texture parameters

		var textureCacheKey = getTextureCacheKey(texture);

		if (textureCacheKey !== textureProperties.__cacheKey) {

			// if not, create a new instance of WebGLTexture

			if (webglTextures[textureCacheKey] === undefined) {

				// create new entry

				webglTextures[textureCacheKey] = {
					texture: _gl.createTexture(),
					usedTimes: 0
				};

				info.memory.textures++;

				// when a new instance of WebGLTexture was created, a texture upload is required
				// even if the image contents are identical

				forceUpload = true;
			}

			webglTextures[textureCacheKey].usedTimes++;

			// every time the texture cache key changes, it's necessary to check if an instance of
			// WebGLTexture can be deleted in order to avoid a memory leak.

			var webglTexture = webglTextures[textureProperties.__cacheKey];

			if (webglTexture !== undefined) {

				webglTextures[textureProperties.__cacheKey].usedTimes--;

				if (webglTexture.usedTimes === 0) {

					deleteTexture(texture);
				}
			}

			// store references to cache key and WebGLTexture object

			textureProperties.__cacheKey = textureCacheKey;
			textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
		}

		return forceUpload;
	}

	function uploadTexture(textureProperties, texture, slot) {

		var textureType = 3553;

		if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = 35866;
		if (texture.isData3DTexture) textureType = 32879;

		var forceUpload = initTexture(textureProperties, texture);
		var source = texture.source;

		state.bindTexture(textureType, textureProperties.__webglTexture, 33984 + slot);

		var sourceProperties = properties.get(source);

		if (source.version !== sourceProperties.__version || forceUpload === true) {

			state.activeTexture(33984 + slot);

			_gl.pixelStorei(37440, texture.flipY);
			_gl.pixelStorei(37441, texture.premultiplyAlpha);
			_gl.pixelStorei(3317, texture.unpackAlignment);
			_gl.pixelStorei(37443, 0);

			var needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
			var image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
			image = verifyColorSpace(texture, image);

			var supportsMips = isPowerOfTwo$1(image) || isWebGL2,
			    glFormat = utils.convert(texture.format, texture.encoding);

			var glType = utils.convert(texture.type),
			    glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);

			setTextureParameters(textureType, texture, supportsMips);

			var mipmap = void 0;
			var mipmaps = texture.mipmaps;

			var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
			var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
			var levels = getMipLevels(texture, image, supportsMips);

			if (texture.isDepthTexture) {

				// populate depth texture with dummy data

				glInternalFormat = 6402;

				if (isWebGL2) {

					if (texture.type === FloatType) {

						glInternalFormat = 36012;
					} else if (texture.type === UnsignedIntType) {

						glInternalFormat = 33190;
					} else if (texture.type === UnsignedInt248Type) {

						glInternalFormat = 35056;
					} else {

						glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
					}
				} else {

					if (texture.type === FloatType) {

						console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
					}
				}

				// validation checks for WebGL 1

				if (texture.format === DepthFormat && glInternalFormat === 6402) {

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {

						console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');

						texture.type = UnsignedIntType;
						glType = utils.convert(texture.type);
					}
				}

				if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {

					// Depth stencil textures need the DEPTH_STENCIL internal format
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					glInternalFormat = 34041;

					// The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
					// DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
					// (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
					if (texture.type !== UnsignedInt248Type) {

						console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');

						texture.type = UnsignedInt248Type;
						glType = utils.convert(texture.type);
					}
				}

				//

				if (allocateMemory) {

					if (useTexStorage) {

						state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
					} else {

						state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
					}
				}
			} else if (texture.isDataTexture) {

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if (mipmaps.length > 0 && supportsMips) {

					if (useTexStorage && allocateMemory) {

						state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
					}

					for (var i = 0, il = mipmaps.length; i < il; i++) {

						mipmap = mipmaps[i];

						if (useTexStorage) {

							state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
						} else {

							state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
						}
					}

					texture.generateMipmaps = false;
				} else {

					if (useTexStorage) {

						if (allocateMemory) {

							state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
						}

						state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
					} else {

						state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
					}
				}
			} else if (texture.isCompressedTexture) {

				if (texture.isCompressedArrayTexture) {

					if (useTexStorage && allocateMemory) {

						state.texStorage3D(35866, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
					}

					for (var _i41 = 0, _il9 = mipmaps.length; _i41 < _il9; _i41++) {

						mipmap = mipmaps[_i41];

						if (texture.format !== RGBAFormat) {

							if (glFormat !== null) {

								if (useTexStorage) {

									state.compressedTexSubImage3D(35866, _i41, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data, 0, 0);
								} else {

									state.compressedTexImage3D(35866, _i41, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
								}
							} else {

								console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
							}
						} else {

							if (useTexStorage) {

								state.texSubImage3D(35866, _i41, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
							} else {

								state.texImage3D(35866, _i41, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
							}
						}
					}
				} else {

					if (useTexStorage && allocateMemory) {

						state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
					}

					for (var _i42 = 0, _il10 = mipmaps.length; _i42 < _il10; _i42++) {

						mipmap = mipmaps[_i42];

						if (texture.format !== RGBAFormat) {

							if (glFormat !== null) {

								if (useTexStorage) {

									state.compressedTexSubImage2D(3553, _i42, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
								} else {

									state.compressedTexImage2D(3553, _i42, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
								}
							} else {

								console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
							}
						} else {

							if (useTexStorage) {

								state.texSubImage2D(3553, _i42, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
							} else {

								state.texImage2D(3553, _i42, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
							}
						}
					}
				}
			} else if (texture.isDataArrayTexture) {

				if (useTexStorage) {

					if (allocateMemory) {

						state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
					}

					state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
				} else {

					state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
				}
			} else if (texture.isData3DTexture) {

				if (useTexStorage) {

					if (allocateMemory) {

						state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
					}

					state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
				} else {

					state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
				}
			} else if (texture.isFramebufferTexture) {

				if (allocateMemory) {

					if (useTexStorage) {

						state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
					} else {

						var width = image.width,
						    height = image.height;

						for (var _i43 = 0; _i43 < levels; _i43++) {

							state.texImage2D(3553, _i43, glInternalFormat, width, height, 0, glFormat, glType, null);

							width >>= 1;
							height >>= 1;
						}
					}
				}
			} else {

				// regular Texture (image, video, canvas)

				// use manually created mipmaps if available
				// if there are no manual mipmaps
				// set 0 level mipmap and then use GL to generate other mipmap levels

				if (mipmaps.length > 0 && supportsMips) {

					if (useTexStorage && allocateMemory) {

						state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
					}

					for (var _i44 = 0, _il11 = mipmaps.length; _i44 < _il11; _i44++) {

						mipmap = mipmaps[_i44];

						if (useTexStorage) {

							state.texSubImage2D(3553, _i44, 0, 0, glFormat, glType, mipmap);
						} else {

							state.texImage2D(3553, _i44, glInternalFormat, glFormat, glType, mipmap);
						}
					}

					texture.generateMipmaps = false;
				} else {

					if (useTexStorage) {

						if (allocateMemory) {

							state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
						}

						state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
					} else {

						state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
					}
				}
			}

			if (textureNeedsGenerateMipmaps(texture, supportsMips)) {

				generateMipmap(textureType);
			}

			sourceProperties.__version = source.version;

			if (texture.onUpdate) texture.onUpdate(texture);
		}

		textureProperties.__version = texture.version;
	}

	function uploadCubeTexture(textureProperties, texture, slot) {

		if (texture.image.length !== 6) return;

		var forceUpload = initTexture(textureProperties, texture);
		var source = texture.source;

		state.bindTexture(34067, textureProperties.__webglTexture, 33984 + slot);

		var sourceProperties = properties.get(source);

		if (source.version !== sourceProperties.__version || forceUpload === true) {

			state.activeTexture(33984 + slot);

			_gl.pixelStorei(37440, texture.flipY);
			_gl.pixelStorei(37441, texture.premultiplyAlpha);
			_gl.pixelStorei(3317, texture.unpackAlignment);
			_gl.pixelStorei(37443, 0);

			var isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
			var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;

			var cubeImage = [];

			for (var i = 0; i < 6; i++) {

				if (!isCompressed && !isDataTexture) {

					cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
				} else {

					cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
				}

				cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
			}

			var image = cubeImage[0],
			    supportsMips = isPowerOfTwo$1(image) || isWebGL2,
			    glFormat = utils.convert(texture.format, texture.encoding),
			    glType = utils.convert(texture.type),
			    glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);

			var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
			var allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
			var levels = getMipLevels(texture, image, supportsMips);

			setTextureParameters(34067, texture, supportsMips);

			var mipmaps = void 0;

			if (isCompressed) {

				if (useTexStorage && allocateMemory) {

					state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
				}

				for (var _i45 = 0; _i45 < 6; _i45++) {

					mipmaps = cubeImage[_i45].mipmaps;

					for (var j = 0; j < mipmaps.length; j++) {

						var mipmap = mipmaps[j];

						if (texture.format !== RGBAFormat) {

							if (glFormat !== null) {

								if (useTexStorage) {

									state.compressedTexSubImage2D(34069 + _i45, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
								} else {

									state.compressedTexImage2D(34069 + _i45, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
								}
							} else {

								console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
							}
						} else {

							if (useTexStorage) {

								state.texSubImage2D(34069 + _i45, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
							} else {

								state.texImage2D(34069 + _i45, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
							}
						}
					}
				}
			} else {

				mipmaps = texture.mipmaps;

				if (useTexStorage && allocateMemory) {

					// TODO: Uniformly handle mipmap definitions
					// Normal textures and compressed cube textures define base level + mips with their mipmap array
					// Uncompressed cube textures use their mipmap array only for mips (no base level)

					if (mipmaps.length > 0) levels++;

					state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
				}

				for (var _i46 = 0; _i46 < 6; _i46++) {

					if (isDataTexture) {

						if (useTexStorage) {

							state.texSubImage2D(34069 + _i46, 0, 0, 0, cubeImage[_i46].width, cubeImage[_i46].height, glFormat, glType, cubeImage[_i46].data);
						} else {

							state.texImage2D(34069 + _i46, 0, glInternalFormat, cubeImage[_i46].width, cubeImage[_i46].height, 0, glFormat, glType, cubeImage[_i46].data);
						}

						for (var _j3 = 0; _j3 < mipmaps.length; _j3++) {

							var _mipmap = mipmaps[_j3];
							var mipmapImage = _mipmap.image[_i46].image;

							if (useTexStorage) {

								state.texSubImage2D(34069 + _i46, _j3 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
							} else {

								state.texImage2D(34069 + _i46, _j3 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
							}
						}
					} else {

						if (useTexStorage) {

							state.texSubImage2D(34069 + _i46, 0, 0, 0, glFormat, glType, cubeImage[_i46]);
						} else {

							state.texImage2D(34069 + _i46, 0, glInternalFormat, glFormat, glType, cubeImage[_i46]);
						}

						for (var _j4 = 0; _j4 < mipmaps.length; _j4++) {

							var _mipmap2 = mipmaps[_j4];

							if (useTexStorage) {

								state.texSubImage2D(34069 + _i46, _j4 + 1, 0, 0, glFormat, glType, _mipmap2.image[_i46]);
							} else {

								state.texImage2D(34069 + _i46, _j4 + 1, glInternalFormat, glFormat, glType, _mipmap2.image[_i46]);
							}
						}
					}
				}
			}

			if (textureNeedsGenerateMipmaps(texture, supportsMips)) {

				// We assume images for cube map have the same size.
				generateMipmap(34067);
			}

			sourceProperties.__version = source.version;

			if (texture.onUpdate) texture.onUpdate(texture);
		}

		textureProperties.__version = texture.version;
	}

	// Render targets

	// Setup storage for target texture and bind it to correct framebuffer
	function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {

		var glFormat = utils.convert(texture.format, texture.encoding);
		var glType = utils.convert(texture.type);
		var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
		var renderTargetProperties = properties.get(renderTarget);

		if (!renderTargetProperties.__hasExternalTextures) {

			if (textureTarget === 32879 || textureTarget === 35866) {

				state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
			} else {

				state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
			}
		}

		state.bindFramebuffer(36160, framebuffer);

		if (useMultisampledRTT(renderTarget)) {

			multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
		} else if (textureTarget === 3553 || textureTarget >= 34069 && textureTarget <= 34074) {
			// see #24753

			_gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
		}

		state.bindFramebuffer(36160, null);
	}

	// Setup storage for internal depth/stencil buffers and bind to correct framebuffer
	function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {

		_gl.bindRenderbuffer(36161, renderbuffer);

		if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {

			var glInternalFormat = 33189;

			if (isMultisample || useMultisampledRTT(renderTarget)) {

				var depthTexture = renderTarget.depthTexture;

				if (depthTexture && depthTexture.isDepthTexture) {

					if (depthTexture.type === FloatType) {

						glInternalFormat = 36012;
					} else if (depthTexture.type === UnsignedIntType) {

						glInternalFormat = 33190;
					}
				}

				var samples = getRenderTargetSamples(renderTarget);

				if (useMultisampledRTT(renderTarget)) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
				} else {

					_gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
				}
			} else {

				_gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
			}

			_gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
		} else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {

			var _samples = getRenderTargetSamples(renderTarget);

			if (isMultisample && useMultisampledRTT(renderTarget) === false) {

				_gl.renderbufferStorageMultisample(36161, _samples, 35056, renderTarget.width, renderTarget.height);
			} else if (useMultisampledRTT(renderTarget)) {

				multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples, 35056, renderTarget.width, renderTarget.height);
			} else {

				_gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
			}

			_gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
		} else {

			var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];

			for (var i = 0; i < textures.length; i++) {

				var _texture2 = textures[i];

				var glFormat = utils.convert(_texture2.format, _texture2.encoding);
				var glType = utils.convert(_texture2.type);
				var _glInternalFormat = getInternalFormat(_texture2.internalFormat, glFormat, glType, _texture2.encoding);
				var _samples2 = getRenderTargetSamples(renderTarget);

				if (isMultisample && useMultisampledRTT(renderTarget) === false) {

					_gl.renderbufferStorageMultisample(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
				} else if (useMultisampledRTT(renderTarget)) {

					multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
				} else {

					_gl.renderbufferStorage(36161, _glInternalFormat, renderTarget.width, renderTarget.height);
				}
			}
		}

		_gl.bindRenderbuffer(36161, null);
	}

	// Setup resources for a Depth Texture for a FBO (needs an extension)
	function setupDepthTexture(framebuffer, renderTarget) {

		var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
		if (isCube) throw new Error('Depth Texture with cube render targets is not supported');

		state.bindFramebuffer(36160, framebuffer);

		if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {

			throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
		}

		// upload an empty depth texture with framebuffer size
		if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {

			renderTarget.depthTexture.image.width = renderTarget.width;
			renderTarget.depthTexture.image.height = renderTarget.height;
			renderTarget.depthTexture.needsUpdate = true;
		}

		setTexture2D(renderTarget.depthTexture, 0);

		var webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
		var samples = getRenderTargetSamples(renderTarget);

		if (renderTarget.depthTexture.format === DepthFormat) {

			if (useMultisampledRTT(renderTarget)) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
			} else {

				_gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
			}
		} else if (renderTarget.depthTexture.format === DepthStencilFormat) {

			if (useMultisampledRTT(renderTarget)) {

				multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
			} else {

				_gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
			}
		} else {

			throw new Error('Unknown depthTexture format');
		}
	}

	// Setup GL resources for a non-texture depth buffer
	function setupDepthRenderbuffer(renderTarget) {

		var renderTargetProperties = properties.get(renderTarget);
		var isCube = renderTarget.isWebGLCubeRenderTarget === true;

		if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {

			if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');

			setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
		} else {

			if (isCube) {

				renderTargetProperties.__webglDepthbuffer = [];

				for (var i = 0; i < 6; i++) {

					state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
					renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
					setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
				}
			} else {

				state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
				renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
				setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
			}
		}

		state.bindFramebuffer(36160, null);
	}

	// rebind framebuffer with external textures
	function rebindTextures(renderTarget, colorTexture, depthTexture) {

		var renderTargetProperties = properties.get(renderTarget);

		if (colorTexture !== undefined) {

			setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
		}

		if (depthTexture !== undefined) {

			setupDepthRenderbuffer(renderTarget);
		}
	}

	// Set up GL resources for the render target
	function setupRenderTarget(renderTarget) {

		var texture = renderTarget.texture;

		var renderTargetProperties = properties.get(renderTarget);
		var textureProperties = properties.get(texture);

		renderTarget.addEventListener('dispose', onRenderTargetDispose);

		if (renderTarget.isWebGLMultipleRenderTargets !== true) {

			if (textureProperties.__webglTexture === undefined) {

				textureProperties.__webglTexture = _gl.createTexture();
			}

			textureProperties.__version = texture.version;
			info.memory.textures++;
		}

		var isCube = renderTarget.isWebGLCubeRenderTarget === true;
		var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
		var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;

		// Setup framebuffer

		if (isCube) {

			renderTargetProperties.__webglFramebuffer = [];

			for (var i = 0; i < 6; i++) {

				renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
			}
		} else {

			renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

			if (isMultipleRenderTargets) {

				if (capabilities.drawBuffers) {

					var textures = renderTarget.texture;

					for (var _i47 = 0, il = textures.length; _i47 < il; _i47++) {

						var attachmentProperties = properties.get(textures[_i47]);

						if (attachmentProperties.__webglTexture === undefined) {

							attachmentProperties.__webglTexture = _gl.createTexture();

							info.memory.textures++;
						}
					}
				} else {

					console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
				}
			}

			if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {

				var _textures = isMultipleRenderTargets ? texture : [texture];

				renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
				renderTargetProperties.__webglColorRenderbuffer = [];

				state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);

				for (var _i48 = 0; _i48 < _textures.length; _i48++) {

					var _texture3 = _textures[_i48];
					renderTargetProperties.__webglColorRenderbuffer[_i48] = _gl.createRenderbuffer();

					_gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[_i48]);

					var glFormat = utils.convert(_texture3.format, _texture3.encoding);
					var glType = utils.convert(_texture3.type);
					var glInternalFormat = getInternalFormat(_texture3.internalFormat, glFormat, glType, _texture3.encoding, renderTarget.isXRRenderTarget === true);
					var samples = getRenderTargetSamples(renderTarget);
					_gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);

					_gl.framebufferRenderbuffer(36160, 36064 + _i48, 36161, renderTargetProperties.__webglColorRenderbuffer[_i48]);
				}

				_gl.bindRenderbuffer(36161, null);

				if (renderTarget.depthBuffer) {

					renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
					setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
				}

				state.bindFramebuffer(36160, null);
			}
		}

		// Setup color buffer

		if (isCube) {

			state.bindTexture(34067, textureProperties.__webglTexture);
			setTextureParameters(34067, texture, supportsMips);

			for (var _i49 = 0; _i49 < 6; _i49++) {

				setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[_i49], renderTarget, texture, 36064, 34069 + _i49);
			}

			if (textureNeedsGenerateMipmaps(texture, supportsMips)) {

				generateMipmap(34067);
			}

			state.unbindTexture();
		} else if (isMultipleRenderTargets) {

			var _textures2 = renderTarget.texture;

			for (var _i50 = 0, _il12 = _textures2.length; _i50 < _il12; _i50++) {

				var attachment = _textures2[_i50];
				var _attachmentProperties = properties.get(attachment);

				state.bindTexture(3553, _attachmentProperties.__webglTexture);
				setTextureParameters(3553, attachment, supportsMips);
				setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + _i50, 3553);

				if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {

					generateMipmap(3553);
				}
			}

			state.unbindTexture();
		} else {

			var glTextureType = 3553;

			if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {

				if (isWebGL2) {

					glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
				} else {

					console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
				}
			}

			state.bindTexture(glTextureType, textureProperties.__webglTexture);
			setTextureParameters(glTextureType, texture, supportsMips);
			setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);

			if (textureNeedsGenerateMipmaps(texture, supportsMips)) {

				generateMipmap(glTextureType);
			}

			state.unbindTexture();
		}

		// Setup depth and stencil buffers

		if (renderTarget.depthBuffer) {

			setupDepthRenderbuffer(renderTarget);
		}
	}

	function updateRenderTargetMipmap(renderTarget) {

		var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;

		var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];

		for (var i = 0, il = textures.length; i < il; i++) {

			var _texture4 = textures[i];

			if (textureNeedsGenerateMipmaps(_texture4, supportsMips)) {

				var target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
				var webglTexture = properties.get(_texture4).__webglTexture;

				state.bindTexture(target, webglTexture);
				generateMipmap(target);
				state.unbindTexture();
			}
		}
	}

	function updateMultisampleRenderTarget(renderTarget) {

		if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {

			var textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [renderTarget.texture];
			var width = renderTarget.width;
			var height = renderTarget.height;
			var mask = 16384;
			var invalidationArray = [];
			var depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
			var renderTargetProperties = properties.get(renderTarget);
			var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;

			// If MRT we need to remove FBO attachments
			if (isMultipleRenderTargets) {

				for (var i = 0; i < textures.length; i++) {

					state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
					_gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);

					state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
					_gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
				}
			}

			state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
			state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);

			for (var _i51 = 0; _i51 < textures.length; _i51++) {

				invalidationArray.push(36064 + _i51);

				if (renderTarget.depthBuffer) {

					invalidationArray.push(depthStyle);
				}

				var ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;

				if (ignoreDepthValues === false) {

					if (renderTarget.depthBuffer) mask |= 256;
					if (renderTarget.stencilBuffer) mask |= 1024;
				}

				if (isMultipleRenderTargets) {

					_gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[_i51]);
				}

				if (ignoreDepthValues === true) {

					_gl.invalidateFramebuffer(36008, [depthStyle]);
					_gl.invalidateFramebuffer(36009, [depthStyle]);
				}

				if (isMultipleRenderTargets) {

					var webglTexture = properties.get(textures[_i51]).__webglTexture;
					_gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
				}

				_gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);

				if (supportsInvalidateFramebuffer) {

					_gl.invalidateFramebuffer(36008, invalidationArray);
				}
			}

			state.bindFramebuffer(36008, null);
			state.bindFramebuffer(36009, null);

			// If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
			if (isMultipleRenderTargets) {

				for (var _i52 = 0; _i52 < textures.length; _i52++) {

					state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
					_gl.framebufferRenderbuffer(36160, 36064 + _i52, 36161, renderTargetProperties.__webglColorRenderbuffer[_i52]);

					var _webglTexture = properties.get(textures[_i52]).__webglTexture;

					state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
					_gl.framebufferTexture2D(36009, 36064 + _i52, 3553, _webglTexture, 0);
				}
			}

			state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
		}
	}

	function getRenderTargetSamples(renderTarget) {

		return Math.min(maxSamples, renderTarget.samples);
	}

	function useMultisampledRTT(renderTarget) {

		var renderTargetProperties = properties.get(renderTarget);

		return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
	}

	function updateVideoTexture(texture) {

		var frame = info.render.frame;

		// Check the last frame we updated the VideoTexture

		if (_videoTextures.get(texture) !== frame) {

			_videoTextures.set(texture, frame);
			texture.update();
		}
	}

	function verifyColorSpace(texture, image) {

		var encoding = texture.encoding;
		var format = texture.format;
		var type = texture.type;

		if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === _SRGBAFormat) return image;

		if (encoding !== LinearEncoding) {

			// sRGB

			if (encoding === sRGBEncoding) {

				if (isWebGL2 === false) {

					// in WebGL 1, try to use EXT_sRGB extension and unsized formats

					if (extensions.has('EXT_sRGB') === true && format === RGBAFormat) {

						texture.format = _SRGBAFormat;

						// it's not possible to generate mips in WebGL 1 with this extension

						texture.minFilter = LinearFilter;
						texture.generateMipmaps = false;
					} else {

						// slow fallback (CPU decode)

						image = ImageUtils.sRGBToLinear(image);
					}
				} else {

					// in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format

					if (format !== RGBAFormat || type !== UnsignedByteType) {

						console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
					}
				}
			} else {

				console.error('THREE.WebGLTextures: Unsupported texture encoding:', encoding);
			}
		}

		return image;
	}

	//

	this.allocateTextureUnit = allocateTextureUnit;
	this.resetTextureUnits = resetTextureUnits;

	this.setTexture2D = setTexture2D;
	this.setTexture2DArray = setTexture2DArray;
	this.setTexture3D = setTexture3D;
	this.setTextureCube = setTextureCube;
	this.rebindTextures = rebindTextures;
	this.setupRenderTarget = setupRenderTarget;
	this.updateRenderTargetMipmap = updateRenderTargetMipmap;
	this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
	this.setupDepthRenderbuffer = setupDepthRenderbuffer;
	this.setupFrameBufferTexture = setupFrameBufferTexture;
	this.useMultisampledRTT = useMultisampledRTT;
}

function WebGLUtils(gl, extensions, capabilities) {

	var isWebGL2 = capabilities.isWebGL2;

	function convert(p) {
		var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


		var extension = void 0;

		if (p === UnsignedByteType) return 5121;
		if (p === UnsignedShort4444Type) return 32819;
		if (p === UnsignedShort5551Type) return 32820;

		if (p === ByteType) return 5120;
		if (p === ShortType) return 5122;
		if (p === UnsignedShortType) return 5123;
		if (p === IntType) return 5124;
		if (p === UnsignedIntType) return 5125;
		if (p === FloatType) return 5126;

		if (p === HalfFloatType) {

			if (isWebGL2) return 5131;

			extension = extensions.get('OES_texture_half_float');

			if (extension !== null) {

				return extension.HALF_FLOAT_OES;
			} else {

				return null;
			}
		}

		if (p === AlphaFormat) return 6406;
		if (p === RGBAFormat) return 6408;
		if (p === LuminanceFormat) return 6409;
		if (p === LuminanceAlphaFormat) return 6410;
		if (p === DepthFormat) return 6402;
		if (p === DepthStencilFormat) return 34041;

		// WebGL 1 sRGB fallback

		if (p === _SRGBAFormat) {

			extension = extensions.get('EXT_sRGB');

			if (extension !== null) {

				return extension.SRGB_ALPHA_EXT;
			} else {

				return null;
			}
		}

		// WebGL2 formats.

		if (p === RedFormat) return 6403;
		if (p === RedIntegerFormat) return 36244;
		if (p === RGFormat) return 33319;
		if (p === RGIntegerFormat) return 33320;
		if (p === RGBAIntegerFormat) return 36249;

		// S3TC

		if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {

			if (encoding === sRGBEncoding) {

				extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');

				if (extension !== null) {

					if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
					if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
					if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
					if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
				} else {

					return null;
				}
			} else {

				extension = extensions.get('WEBGL_compressed_texture_s3tc');

				if (extension !== null) {

					if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
					if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
					if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
					if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
				} else {

					return null;
				}
			}
		}

		// PVRTC

		if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {

			extension = extensions.get('WEBGL_compressed_texture_pvrtc');

			if (extension !== null) {

				if (p === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
				if (p === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
				if (p === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
				if (p === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
			} else {

				return null;
			}
		}

		// ETC1

		if (p === RGB_ETC1_Format) {

			extension = extensions.get('WEBGL_compressed_texture_etc1');

			if (extension !== null) {

				return extension.COMPRESSED_RGB_ETC1_WEBGL;
			} else {

				return null;
			}
		}

		// ETC2

		if (p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {

			extension = extensions.get('WEBGL_compressed_texture_etc');

			if (extension !== null) {

				if (p === RGB_ETC2_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
				if (p === RGBA_ETC2_EAC_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
			} else {

				return null;
			}
		}

		// ASTC

		if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format) {

			extension = extensions.get('WEBGL_compressed_texture_astc');

			if (extension !== null) {

				if (p === RGBA_ASTC_4x4_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
				if (p === RGBA_ASTC_5x4_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
				if (p === RGBA_ASTC_5x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
				if (p === RGBA_ASTC_6x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
				if (p === RGBA_ASTC_6x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
				if (p === RGBA_ASTC_8x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
				if (p === RGBA_ASTC_8x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
				if (p === RGBA_ASTC_8x8_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
				if (p === RGBA_ASTC_10x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
				if (p === RGBA_ASTC_10x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
				if (p === RGBA_ASTC_10x8_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
				if (p === RGBA_ASTC_10x10_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
				if (p === RGBA_ASTC_12x10_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
				if (p === RGBA_ASTC_12x12_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
			} else {

				return null;
			}
		}

		// BPTC

		if (p === RGBA_BPTC_Format) {

			extension = extensions.get('EXT_texture_compression_bptc');

			if (extension !== null) {

				if (p === RGBA_BPTC_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
			} else {

				return null;
			}
		}

		// RGTC

		if (p === RED_RGTC1_Format || p === SIGNED_RED_RGTC1_Format || p === RED_GREEN_RGTC2_Format || p === SIGNED_RED_GREEN_RGTC2_Format) {

			extension = extensions.get('EXT_texture_compression_rgtc');

			if (extension !== null) {

				if (p === RGBA_BPTC_Format) return extension.COMPRESSED_RED_RGTC1_EXT;
				if (p === SIGNED_RED_RGTC1_Format) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
				if (p === RED_GREEN_RGTC2_Format) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
				if (p === SIGNED_RED_GREEN_RGTC2_Format) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
			} else {

				return null;
			}
		}

		//

		if (p === UnsignedInt248Type) {

			if (isWebGL2) return 34042;

			extension = extensions.get('WEBGL_depth_texture');

			if (extension !== null) {

				return extension.UNSIGNED_INT_24_8_WEBGL;
			} else {

				return null;
			}
		}

		// if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)

		return gl[p] !== undefined ? gl[p] : null;
	}

	return { convert: convert };
}

var ArrayCamera = function (_PerspectiveCamera) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ArrayCamera, _PerspectiveCamera);

	function ArrayCamera() {
		var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ArrayCamera);

		var _this35 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrayCamera.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ArrayCamera)).call(this));

		_this35.isArrayCamera = true;

		_this35.cameras = array;

		return _this35;
	}

	return ArrayCamera;
}(PerspectiveCamera);

var Group = function (_Object3D4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Group, _Object3D4);

	function Group() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Group);

		var _this36 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Group.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Group)).call(this));

		_this36.isGroup = true;

		_this36.type = 'Group';

		return _this36;
	}

	return Group;
}(Object3D);

var _moveEvent = { type: 'move' };

var WebXRController = function () {
	function WebXRController() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebXRController);

		this._targetRay = null;
		this._grip = null;
		this._hand = null;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebXRController, [{
		key: 'getHandSpace',
		value: function getHandSpace() {

			if (this._hand === null) {

				this._hand = new Group();
				this._hand.matrixAutoUpdate = false;
				this._hand.visible = false;

				this._hand.joints = {};
				this._hand.inputState = { pinching: false };
			}

			return this._hand;
		}
	}, {
		key: 'getTargetRaySpace',
		value: function getTargetRaySpace() {

			if (this._targetRay === null) {

				this._targetRay = new Group();
				this._targetRay.matrixAutoUpdate = false;
				this._targetRay.visible = false;
				this._targetRay.hasLinearVelocity = false;
				this._targetRay.linearVelocity = new Vector3();
				this._targetRay.hasAngularVelocity = false;
				this._targetRay.angularVelocity = new Vector3();
			}

			return this._targetRay;
		}
	}, {
		key: 'getGripSpace',
		value: function getGripSpace() {

			if (this._grip === null) {

				this._grip = new Group();
				this._grip.matrixAutoUpdate = false;
				this._grip.visible = false;
				this._grip.hasLinearVelocity = false;
				this._grip.linearVelocity = new Vector3();
				this._grip.hasAngularVelocity = false;
				this._grip.angularVelocity = new Vector3();
			}

			return this._grip;
		}
	}, {
		key: 'dispatchEvent',
		value: function dispatchEvent(event) {

			if (this._targetRay !== null) {

				this._targetRay.dispatchEvent(event);
			}

			if (this._grip !== null) {

				this._grip.dispatchEvent(event);
			}

			if (this._hand !== null) {

				this._hand.dispatchEvent(event);
			}

			return this;
		}
	}, {
		key: 'connect',
		value: function connect(inputSource) {

			if (inputSource && inputSource.hand) {

				var hand = this._hand;

				if (hand) {
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {

						for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(inputSource.hand.values()), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var inputjoint = _step2.value;


							// Initialize hand with joints when connected
							this._getHandJoint(hand, inputjoint);
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}
			}

			this.dispatchEvent({ type: 'connected', data: inputSource });

			return this;
		}
	}, {
		key: 'disconnect',
		value: function disconnect(inputSource) {

			this.dispatchEvent({ type: 'disconnected', data: inputSource });

			if (this._targetRay !== null) {

				this._targetRay.visible = false;
			}

			if (this._grip !== null) {

				this._grip.visible = false;
			}

			if (this._hand !== null) {

				this._hand.visible = false;
			}

			return this;
		}
	}, {
		key: 'update',
		value: function update(inputSource, frame, referenceSpace) {

			var inputPose = null;
			var gripPose = null;
			var handPose = null;

			var targetRay = this._targetRay;
			var grip = this._grip;
			var hand = this._hand;

			if (inputSource && frame.session.visibilityState !== 'visible-blurred') {

				if (hand && inputSource.hand) {

					handPose = true;

					var _iteratorNormalCompletion3 = true;
					var _didIteratorError3 = false;
					var _iteratorError3 = undefined;

					try {
						for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(inputSource.hand.values()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
							var inputjoint = _step3.value;


							// Update the joints groups with the XRJoint poses
							var jointPose = frame.getJointPose(inputjoint, referenceSpace);

							// The transform of this joint will be updated with the joint pose on each frame
							var joint = this._getHandJoint(hand, inputjoint);

							if (jointPose !== null) {

								joint.matrix.fromArray(jointPose.transform.matrix);
								joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
								joint.jointRadius = jointPose.radius;
							}

							joint.visible = jointPose !== null;
						}

						// Custom events

						// Check pinchz
					} catch (err) {
						_didIteratorError3 = true;
						_iteratorError3 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion3 && _iterator3.return) {
								_iterator3.return();
							}
						} finally {
							if (_didIteratorError3) {
								throw _iteratorError3;
							}
						}
					}

					var indexTip = hand.joints['index-finger-tip'];
					var thumbTip = hand.joints['thumb-tip'];
					var distance = indexTip.position.distanceTo(thumbTip.position);

					var distanceToPinch = 0.02;
					var threshold = 0.005;

					if (hand.inputState.pinching && distance > distanceToPinch + threshold) {

						hand.inputState.pinching = false;
						this.dispatchEvent({
							type: 'pinchend',
							handedness: inputSource.handedness,
							target: this
						});
					} else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {

						hand.inputState.pinching = true;
						this.dispatchEvent({
							type: 'pinchstart',
							handedness: inputSource.handedness,
							target: this
						});
					}
				} else {

					if (grip !== null && inputSource.gripSpace) {

						gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);

						if (gripPose !== null) {

							grip.matrix.fromArray(gripPose.transform.matrix);
							grip.matrix.decompose(grip.position, grip.rotation, grip.scale);

							if (gripPose.linearVelocity) {

								grip.hasLinearVelocity = true;
								grip.linearVelocity.copy(gripPose.linearVelocity);
							} else {

								grip.hasLinearVelocity = false;
							}

							if (gripPose.angularVelocity) {

								grip.hasAngularVelocity = true;
								grip.angularVelocity.copy(gripPose.angularVelocity);
							} else {

								grip.hasAngularVelocity = false;
							}
						}
					}
				}

				if (targetRay !== null) {

					inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);

					// Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
					if (inputPose === null && gripPose !== null) {

						inputPose = gripPose;
					}

					if (inputPose !== null) {

						targetRay.matrix.fromArray(inputPose.transform.matrix);
						targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);

						if (inputPose.linearVelocity) {

							targetRay.hasLinearVelocity = true;
							targetRay.linearVelocity.copy(inputPose.linearVelocity);
						} else {

							targetRay.hasLinearVelocity = false;
						}

						if (inputPose.angularVelocity) {

							targetRay.hasAngularVelocity = true;
							targetRay.angularVelocity.copy(inputPose.angularVelocity);
						} else {

							targetRay.hasAngularVelocity = false;
						}

						this.dispatchEvent(_moveEvent);
					}
				}
			}

			if (targetRay !== null) {

				targetRay.visible = inputPose !== null;
			}

			if (grip !== null) {

				grip.visible = gripPose !== null;
			}

			if (hand !== null) {

				hand.visible = handPose !== null;
			}

			return this;
		}

		// private method

	}, {
		key: '_getHandJoint',
		value: function _getHandJoint(hand, inputjoint) {

			if (hand.joints[inputjoint.jointName] === undefined) {

				var joint = new Group();
				joint.matrixAutoUpdate = false;
				joint.visible = false;
				hand.joints[inputjoint.jointName] = joint;

				hand.add(joint);
			}

			return hand.joints[inputjoint.jointName];
		}
	}]);

	return WebXRController;
}();

var DepthTexture = function (_Texture4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DepthTexture, _Texture4);

	function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DepthTexture);

		format = format !== undefined ? format : DepthFormat;

		if (format !== DepthFormat && format !== DepthStencilFormat) {

			throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
		}

		if (type === undefined && format === DepthFormat) type = UnsignedIntType;
		if (type === undefined && format === DepthStencilFormat) type = UnsignedInt248Type;

		var _this37 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DepthTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DepthTexture)).call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy));

		_this37.isDepthTexture = true;

		_this37.image = { width: width, height: height };

		_this37.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
		_this37.minFilter = minFilter !== undefined ? minFilter : NearestFilter;

		_this37.flipY = false;
		_this37.generateMipmaps = false;

		return _this37;
	}

	return DepthTexture;
}(Texture);

var WebXRManager = function (_EventDispatcher6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebXRManager, _EventDispatcher6);

	function WebXRManager(renderer, gl) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebXRManager);

		var _this38 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebXRManager.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebXRManager)).call(this));

		var scope = _this38;

		var session = null;
		var framebufferScaleFactor = 1.0;

		var referenceSpace = null;
		var referenceSpaceType = 'local-floor';
		// Set default foveation to maximum.
		var foveation = 1.0;
		var customReferenceSpace = null;

		var pose = null;
		var glBinding = null;
		var glProjLayer = null;
		var glBaseLayer = null;
		var xrFrame = null;
		var attributes = gl.getContextAttributes();
		var initialRenderTarget = null;
		var newRenderTarget = null;

		var controllers = [];
		var controllerInputSources = [];

		var planes = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();
		var planesLastChangedTimes = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a();

		//

		var cameraL = new PerspectiveCamera();
		cameraL.layers.enable(1);
		cameraL.viewport = new Vector4();

		var cameraR = new PerspectiveCamera();
		cameraR.layers.enable(2);
		cameraR.viewport = new Vector4();

		var cameras = [cameraL, cameraR];

		var cameraVR = new ArrayCamera();
		cameraVR.layers.enable(1);
		cameraVR.layers.enable(2);

		var _currentDepthNear = null;
		var _currentDepthFar = null;

		//

		_this38.cameraAutoUpdate = true;
		_this38.enabled = false;

		_this38.isPresenting = false;

		_this38.getController = function (index) {

			var controller = controllers[index];

			if (controller === undefined) {

				controller = new WebXRController();
				controllers[index] = controller;
			}

			return controller.getTargetRaySpace();
		};

		_this38.getControllerGrip = function (index) {

			var controller = controllers[index];

			if (controller === undefined) {

				controller = new WebXRController();
				controllers[index] = controller;
			}

			return controller.getGripSpace();
		};

		_this38.getHand = function (index) {

			var controller = controllers[index];

			if (controller === undefined) {

				controller = new WebXRController();
				controllers[index] = controller;
			}

			return controller.getHandSpace();
		};

		//

		function onSessionEvent(event) {

			var controllerIndex = controllerInputSources.indexOf(event.inputSource);

			if (controllerIndex === -1) {

				return;
			}

			var controller = controllers[controllerIndex];

			if (controller !== undefined) {

				controller.dispatchEvent({ type: event.type, data: event.inputSource });
			}
		}

		function onSessionEnd() {

			session.removeEventListener('select', onSessionEvent);
			session.removeEventListener('selectstart', onSessionEvent);
			session.removeEventListener('selectend', onSessionEvent);
			session.removeEventListener('squeeze', onSessionEvent);
			session.removeEventListener('squeezestart', onSessionEvent);
			session.removeEventListener('squeezeend', onSessionEvent);
			session.removeEventListener('end', onSessionEnd);
			session.removeEventListener('inputsourceschange', onInputSourcesChange);

			for (var i = 0; i < controllers.length; i++) {

				var inputSource = controllerInputSources[i];

				if (inputSource === null) continue;

				controllerInputSources[i] = null;

				controllers[i].disconnect(inputSource);
			}

			_currentDepthNear = null;
			_currentDepthFar = null;

			// restore framebuffer/rendering state

			renderer.setRenderTarget(initialRenderTarget);

			glBaseLayer = null;
			glProjLayer = null;
			glBinding = null;
			session = null;
			newRenderTarget = null;

			//

			animation.stop();

			scope.isPresenting = false;

			scope.dispatchEvent({ type: 'sessionend' });
		}

		_this38.setFramebufferScaleFactor = function (value) {

			framebufferScaleFactor = value;

			if (scope.isPresenting === true) {

				console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
			}
		};

		_this38.setReferenceSpaceType = function (value) {

			referenceSpaceType = value;

			if (scope.isPresenting === true) {

				console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
			}
		};

		_this38.getReferenceSpace = function () {

			return customReferenceSpace || referenceSpace;
		};

		_this38.setReferenceSpace = function (space) {

			customReferenceSpace = space;
		};

		_this38.getBaseLayer = function () {

			return glProjLayer !== null ? glProjLayer : glBaseLayer;
		};

		_this38.getBinding = function () {

			return glBinding;
		};

		_this38.getFrame = function () {

			return xrFrame;
		};

		_this38.getSession = function () {

			return session;
		};

		_this38.setSession = function () {
			var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee(value) {
				var layerInit, depthFormat, depthType, glDepthFormat, projectionlayerInit, renderTargetProperties;
				return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:

								session = value;

								if (!(session !== null)) {
									_context8.next = 25;
									break;
								}

								initialRenderTarget = renderer.getRenderTarget();

								session.addEventListener('select', onSessionEvent);
								session.addEventListener('selectstart', onSessionEvent);
								session.addEventListener('selectend', onSessionEvent);
								session.addEventListener('squeeze', onSessionEvent);
								session.addEventListener('squeezestart', onSessionEvent);
								session.addEventListener('squeezeend', onSessionEvent);
								session.addEventListener('end', onSessionEnd);
								session.addEventListener('inputsourceschange', onInputSourcesChange);

								if (!(attributes.xrCompatible !== true)) {
									_context8.next = 14;
									break;
								}

								_context8.next = 14;
								return gl.makeXRCompatible();

							case 14:

								if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
									layerInit = {
										antialias: session.renderState.layers === undefined ? attributes.antialias : true,
										alpha: attributes.alpha,
										depth: attributes.depth,
										stencil: attributes.stencil,
										framebufferScaleFactor: framebufferScaleFactor
									};


									glBaseLayer = new XRWebGLLayer(session, gl, layerInit);

									session.updateRenderState({ baseLayer: glBaseLayer });

									newRenderTarget = new WebGLRenderTarget(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
										format: RGBAFormat,
										type: UnsignedByteType,
										encoding: renderer.outputEncoding,
										stencilBuffer: attributes.stencil
									});
								} else {
									depthFormat = null;
									depthType = null;
									glDepthFormat = null;


									if (attributes.depth) {

										glDepthFormat = attributes.stencil ? 35056 : 33190;
										depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
										depthType = attributes.stencil ? UnsignedInt248Type : UnsignedIntType;
									}

									projectionlayerInit = {
										colorFormat: 32856,
										depthFormat: glDepthFormat,
										scaleFactor: framebufferScaleFactor
									};


									glBinding = new XRWebGLBinding(session, gl);

									glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);

									session.updateRenderState({ layers: [glProjLayer] });

									newRenderTarget = new WebGLRenderTarget(glProjLayer.textureWidth, glProjLayer.textureHeight, {
										format: RGBAFormat,
										type: UnsignedByteType,
										depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
										stencilBuffer: attributes.stencil,
										encoding: renderer.outputEncoding,
										samples: attributes.antialias ? 4 : 0
									});

									renderTargetProperties = renderer.properties.get(newRenderTarget);

									renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
								}

								newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278

								this.setFoveation(foveation);

								customReferenceSpace = null;
								_context8.next = 20;
								return session.requestReferenceSpace(referenceSpaceType);

							case 20:
								referenceSpace = _context8.sent;


								animation.setContext(session);
								animation.start();

								scope.isPresenting = true;

								scope.dispatchEvent({ type: 'sessionstart' });

							case 25:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee, this);
			}));

			return function (_x150) {
				return _ref.apply(this, arguments);
			};
		}();

		function onInputSourcesChange(event) {

			// Notify disconnected

			for (var i = 0; i < event.removed.length; i++) {

				var inputSource = event.removed[i];
				var index = controllerInputSources.indexOf(inputSource);

				if (index >= 0) {

					controllerInputSources[index] = null;
					controllers[index].disconnect(inputSource);
				}
			}

			// Notify connected

			for (var _i53 = 0; _i53 < event.added.length; _i53++) {

				var _inputSource = event.added[_i53];

				var controllerIndex = controllerInputSources.indexOf(_inputSource);

				if (controllerIndex === -1) {

					// Assign input source a controller that currently has no input source

					for (var _i54 = 0; _i54 < controllers.length; _i54++) {

						if (_i54 >= controllerInputSources.length) {

							controllerInputSources.push(_inputSource);
							controllerIndex = _i54;
							break;
						} else if (controllerInputSources[_i54] === null) {

							controllerInputSources[_i54] = _inputSource;
							controllerIndex = _i54;
							break;
						}
					}

					// If all controllers do currently receive input we ignore new ones

					if (controllerIndex === -1) break;
				}

				var controller = controllers[controllerIndex];

				if (controller) {

					controller.connect(_inputSource);
				}
			}
		}

		//

		var cameraLPos = new Vector3();
		var cameraRPos = new Vector3();

		/**
   * Assumes 2 cameras that are parallel and share an X-axis, and that
   * the cameras' projection and world matrices have already been set.
   * And that near and far planes are identical for both cameras.
   * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
   */
		function setProjectionFromUnion(camera, cameraL, cameraR) {

			cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
			cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);

			var ipd = cameraLPos.distanceTo(cameraRPos);

			var projL = cameraL.projectionMatrix.elements;
			var projR = cameraR.projectionMatrix.elements;

			// VR systems will have identical far and near planes, and
			// most likely identical top and bottom frustum extents.
			// Use the left camera for these values.
			var near = projL[14] / (projL[10] - 1);
			var far = projL[14] / (projL[10] + 1);
			var topFov = (projL[9] + 1) / projL[5];
			var bottomFov = (projL[9] - 1) / projL[5];

			var leftFov = (projL[8] - 1) / projL[0];
			var rightFov = (projR[8] + 1) / projR[0];
			var left = near * leftFov;
			var right = near * rightFov;

			// Calculate the new camera's position offset from the
			// left camera. xOffset should be roughly half `ipd`.
			var zOffset = ipd / (-leftFov + rightFov);
			var xOffset = zOffset * -leftFov;

			// TODO: Better way to apply this offset?
			cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
			camera.translateX(xOffset);
			camera.translateZ(zOffset);
			camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
			camera.matrixWorldInverse.copy(camera.matrixWorld).invert();

			// Find the union of the frustum values of the cameras and scale
			// the values so that the near plane's position does not change in world space,
			// although must now be relative to the new union camera.
			var near2 = near + zOffset;
			var far2 = far + zOffset;
			var left2 = left - xOffset;
			var right2 = right + (ipd - xOffset);
			var top2 = topFov * far / far2 * near2;
			var bottom2 = bottomFov * far / far2 * near2;

			camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
			camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
		}

		function updateCamera(camera, parent) {

			if (parent === null) {

				camera.matrixWorld.copy(camera.matrix);
			} else {

				camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
			}

			camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
		}

		_this38.updateCamera = function (camera) {

			if (session === null) return;

			cameraVR.near = cameraR.near = cameraL.near = camera.near;
			cameraVR.far = cameraR.far = cameraL.far = camera.far;

			if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {

				// Note that the new renderState won't apply until the next frame. See #18320

				session.updateRenderState({
					depthNear: cameraVR.near,
					depthFar: cameraVR.far
				});

				_currentDepthNear = cameraVR.near;
				_currentDepthFar = cameraVR.far;
			}

			var parent = camera.parent;
			var cameras = cameraVR.cameras;

			updateCamera(cameraVR, parent);

			for (var i = 0; i < cameras.length; i++) {

				updateCamera(cameras[i], parent);
			}

			// update projection matrix for proper view frustum culling

			if (cameras.length === 2) {

				setProjectionFromUnion(cameraVR, cameraL, cameraR);
			} else {

				// assume single camera setup (AR)

				cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
			}

			// update user camera and its children

			updateUserCamera(camera, cameraVR, parent);
		};

		function updateUserCamera(camera, cameraVR, parent) {

			if (parent === null) {

				camera.matrix.copy(cameraVR.matrixWorld);
			} else {

				camera.matrix.copy(parent.matrixWorld);
				camera.matrix.invert();
				camera.matrix.multiply(cameraVR.matrixWorld);
			}

			camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
			camera.updateMatrixWorld(true);

			var children = camera.children;

			for (var i = 0, l = children.length; i < l; i++) {

				children[i].updateMatrixWorld(true);
			}

			camera.projectionMatrix.copy(cameraVR.projectionMatrix);
			camera.projectionMatrixInverse.copy(cameraVR.projectionMatrixInverse);

			if (camera.isPerspectiveCamera) {

				camera.fov = RAD2DEG * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
				camera.zoom = 1;
			}
		}

		_this38.getCamera = function () {

			return cameraVR;
		};

		_this38.getFoveation = function () {

			if (glProjLayer === null && glBaseLayer === null) {

				return undefined;
			}

			return foveation;
		};

		_this38.setFoveation = function (value) {

			// 0 = no foveation = full resolution
			// 1 = maximum foveation = the edges render at lower resolution

			foveation = value;

			if (glProjLayer !== null) {

				glProjLayer.fixedFoveation = value;
			}

			if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) {

				glBaseLayer.fixedFoveation = value;
			}
		};

		_this38.getPlanes = function () {

			return planes;
		};

		// Animation Loop

		var onAnimationFrameCallback = null;

		function onAnimationFrame(time, frame) {

			pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
			xrFrame = frame;

			if (pose !== null) {

				var views = pose.views;

				if (glBaseLayer !== null) {

					renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
					renderer.setRenderTarget(newRenderTarget);
				}

				var cameraVRNeedsUpdate = false;

				// check if it's necessary to rebuild cameraVR's camera list

				if (views.length !== cameraVR.cameras.length) {

					cameraVR.cameras.length = 0;
					cameraVRNeedsUpdate = true;
				}

				for (var i = 0; i < views.length; i++) {

					var view = views[i];

					var viewport = null;

					if (glBaseLayer !== null) {

						viewport = glBaseLayer.getViewport(view);
					} else {

						var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
						viewport = glSubImage.viewport;

						// For side-by-side projection, we only produce a single texture for both eyes.
						if (i === 0) {

							renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);

							renderer.setRenderTarget(newRenderTarget);
						}
					}

					var camera = cameras[i];

					if (camera === undefined) {

						camera = new PerspectiveCamera();
						camera.layers.enable(i);
						camera.viewport = new Vector4();
						cameras[i] = camera;
					}

					camera.matrix.fromArray(view.transform.matrix);
					camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
					camera.projectionMatrix.fromArray(view.projectionMatrix);
					camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
					camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);

					if (i === 0) {

						cameraVR.matrix.copy(camera.matrix);
						cameraVR.matrix.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
					}

					if (cameraVRNeedsUpdate === true) {

						cameraVR.cameras.push(camera);
					}
				}
			}

			//

			for (var _i55 = 0; _i55 < controllers.length; _i55++) {

				var inputSource = controllerInputSources[_i55];
				var controller = controllers[_i55];

				if (inputSource !== null && controller !== undefined) {

					controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
				}
			}

			if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);

			if (frame.detectedPlanes) {

				scope.dispatchEvent({ type: 'planesdetected', data: frame.detectedPlanes });

				var planesToRemove = null;

				var _iteratorNormalCompletion4 = true;
				var _didIteratorError4 = false;
				var _iteratorError4 = undefined;

				try {
					for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(planes), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
						var plane = _step4.value;


						if (!frame.detectedPlanes.has(plane)) {

							if (planesToRemove === null) {

								planesToRemove = [];
							}

							planesToRemove.push(plane);
						}
					}
				} catch (err) {
					_didIteratorError4 = true;
					_iteratorError4 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion4 && _iterator4.return) {
							_iterator4.return();
						}
					} finally {
						if (_didIteratorError4) {
							throw _iteratorError4;
						}
					}
				}

				if (planesToRemove !== null) {
					var _iteratorNormalCompletion5 = true;
					var _didIteratorError5 = false;
					var _iteratorError5 = undefined;

					try {

						for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(planesToRemove), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
							var _plane = _step5.value;


							planes.delete(_plane);
							planesLastChangedTimes.delete(_plane);
							scope.dispatchEvent({ type: 'planeremoved', data: _plane });
						}
					} catch (err) {
						_didIteratorError5 = true;
						_iteratorError5 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion5 && _iterator5.return) {
								_iterator5.return();
							}
						} finally {
							if (_didIteratorError5) {
								throw _iteratorError5;
							}
						}
					}
				}

				var _iteratorNormalCompletion6 = true;
				var _didIteratorError6 = false;
				var _iteratorError6 = undefined;

				try {
					for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(frame.detectedPlanes), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
						var _plane2 = _step6.value;


						if (!planes.has(_plane2)) {

							planes.add(_plane2);
							planesLastChangedTimes.set(_plane2, frame.lastChangedTime);
							scope.dispatchEvent({ type: 'planeadded', data: _plane2 });
						} else {

							var lastKnownTime = planesLastChangedTimes.get(_plane2);

							if (_plane2.lastChangedTime > lastKnownTime) {

								planesLastChangedTimes.set(_plane2, _plane2.lastChangedTime);
								scope.dispatchEvent({ type: 'planechanged', data: _plane2 });
							}
						}
					}
				} catch (err) {
					_didIteratorError6 = true;
					_iteratorError6 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion6 && _iterator6.return) {
							_iterator6.return();
						}
					} finally {
						if (_didIteratorError6) {
							throw _iteratorError6;
						}
					}
				}
			}

			xrFrame = null;
		}

		var animation = new WebGLAnimation();

		animation.setAnimationLoop(onAnimationFrame);

		_this38.setAnimationLoop = function (callback) {

			onAnimationFrameCallback = callback;
		};

		_this38.dispose = function () {};

		return _this38;
	}

	return WebXRManager;
}(EventDispatcher);

function WebGLMaterials(renderer, properties) {

	function refreshTransformUniform(map, uniform) {

		if (map.matrixAutoUpdate === true) {

			map.updateMatrix();
		}

		uniform.value.copy(map.matrix);
	}

	function refreshFogUniforms(uniforms, fog) {

		fog.color.getRGB(uniforms.fogColor.value, getUnlitUniformColorSpace(renderer));

		if (fog.isFog) {

			uniforms.fogNear.value = fog.near;
			uniforms.fogFar.value = fog.far;
		} else if (fog.isFogExp2) {

			uniforms.fogDensity.value = fog.density;
		}
	}

	function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {

		if (material.isMeshBasicMaterial) {

			refreshUniformsCommon(uniforms, material);
		} else if (material.isMeshLambertMaterial) {

			refreshUniformsCommon(uniforms, material);
		} else if (material.isMeshToonMaterial) {

			refreshUniformsCommon(uniforms, material);
			refreshUniformsToon(uniforms, material);
		} else if (material.isMeshPhongMaterial) {

			refreshUniformsCommon(uniforms, material);
			refreshUniformsPhong(uniforms, material);
		} else if (material.isMeshStandardMaterial) {

			refreshUniformsCommon(uniforms, material);
			refreshUniformsStandard(uniforms, material);

			if (material.isMeshPhysicalMaterial) {

				refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
			}
		} else if (material.isMeshMatcapMaterial) {

			refreshUniformsCommon(uniforms, material);
			refreshUniformsMatcap(uniforms, material);
		} else if (material.isMeshDepthMaterial) {

			refreshUniformsCommon(uniforms, material);
		} else if (material.isMeshDistanceMaterial) {

			refreshUniformsCommon(uniforms, material);
			refreshUniformsDistance(uniforms, material);
		} else if (material.isMeshNormalMaterial) {

			refreshUniformsCommon(uniforms, material);
		} else if (material.isLineBasicMaterial) {

			refreshUniformsLine(uniforms, material);

			if (material.isLineDashedMaterial) {

				refreshUniformsDash(uniforms, material);
			}
		} else if (material.isPointsMaterial) {

			refreshUniformsPoints(uniforms, material, pixelRatio, height);
		} else if (material.isSpriteMaterial) {

			refreshUniformsSprites(uniforms, material);
		} else if (material.isShadowMaterial) {

			uniforms.color.value.copy(material.color);
			uniforms.opacity.value = material.opacity;
		} else if (material.isShaderMaterial) {

			material.uniformsNeedUpdate = false; // #15581
		}
	}

	function refreshUniformsCommon(uniforms, material) {

		uniforms.opacity.value = material.opacity;

		if (material.color) {

			uniforms.diffuse.value.copy(material.color);
		}

		if (material.emissive) {

			uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
		}

		if (material.map) {

			uniforms.map.value = material.map;

			refreshTransformUniform(material.map, uniforms.mapTransform);
		}

		if (material.alphaMap) {

			uniforms.alphaMap.value = material.alphaMap;

			refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
		}

		if (material.bumpMap) {

			uniforms.bumpMap.value = material.bumpMap;

			refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);

			uniforms.bumpScale.value = material.bumpScale;

			if (material.side === BackSide) {

				uniforms.bumpScale.value *= -1;
			}
		}

		if (material.normalMap) {

			uniforms.normalMap.value = material.normalMap;

			refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);

			uniforms.normalScale.value.copy(material.normalScale);

			if (material.side === BackSide) {

				uniforms.normalScale.value.negate();
			}
		}

		if (material.displacementMap) {

			uniforms.displacementMap.value = material.displacementMap;

			refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);

			uniforms.displacementScale.value = material.displacementScale;
			uniforms.displacementBias.value = material.displacementBias;
		}

		if (material.emissiveMap) {

			uniforms.emissiveMap.value = material.emissiveMap;

			refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
		}

		if (material.specularMap) {

			uniforms.specularMap.value = material.specularMap;

			refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
		}

		if (material.alphaTest > 0) {

			uniforms.alphaTest.value = material.alphaTest;
		}

		var envMap = properties.get(material).envMap;

		if (envMap) {

			uniforms.envMap.value = envMap;

			uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;

			uniforms.reflectivity.value = material.reflectivity;
			uniforms.ior.value = material.ior;
			uniforms.refractionRatio.value = material.refractionRatio;
		}

		if (material.lightMap) {

			uniforms.lightMap.value = material.lightMap;

			// artist-friendly light intensity scaling factor
			var scaleFactor = renderer.useLegacyLights === true ? Math.PI : 1;

			uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;

			refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
		}

		if (material.aoMap) {

			uniforms.aoMap.value = material.aoMap;
			uniforms.aoMapIntensity.value = material.aoMapIntensity;

			refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
		}
	}

	function refreshUniformsLine(uniforms, material) {

		uniforms.diffuse.value.copy(material.color);
		uniforms.opacity.value = material.opacity;

		if (material.map) {

			uniforms.map.value = material.map;

			refreshTransformUniform(material.map, uniforms.mapTransform);
		}
	}

	function refreshUniformsDash(uniforms, material) {

		uniforms.dashSize.value = material.dashSize;
		uniforms.totalSize.value = material.dashSize + material.gapSize;
		uniforms.scale.value = material.scale;
	}

	function refreshUniformsPoints(uniforms, material, pixelRatio, height) {

		uniforms.diffuse.value.copy(material.color);
		uniforms.opacity.value = material.opacity;
		uniforms.size.value = material.size * pixelRatio;
		uniforms.scale.value = height * 0.5;

		if (material.map) {

			uniforms.map.value = material.map;

			refreshTransformUniform(material.map, uniforms.uvTransform);
		}

		if (material.alphaMap) {

			uniforms.alphaMap.value = material.alphaMap;
		}

		if (material.alphaTest > 0) {

			uniforms.alphaTest.value = material.alphaTest;
		}
	}

	function refreshUniformsSprites(uniforms, material) {

		uniforms.diffuse.value.copy(material.color);
		uniforms.opacity.value = material.opacity;
		uniforms.rotation.value = material.rotation;

		if (material.map) {

			uniforms.map.value = material.map;

			refreshTransformUniform(material.map, uniforms.mapTransform);
		}

		if (material.alphaMap) {

			uniforms.alphaMap.value = material.alphaMap;
		}

		if (material.alphaTest > 0) {

			uniforms.alphaTest.value = material.alphaTest;
		}
	}

	function refreshUniformsPhong(uniforms, material) {

		uniforms.specular.value.copy(material.specular);
		uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
	}

	function refreshUniformsToon(uniforms, material) {

		if (material.gradientMap) {

			uniforms.gradientMap.value = material.gradientMap;
		}
	}

	function refreshUniformsStandard(uniforms, material) {

		uniforms.metalness.value = material.metalness;

		if (material.metalnessMap) {

			uniforms.metalnessMap.value = material.metalnessMap;

			refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
		}

		uniforms.roughness.value = material.roughness;

		if (material.roughnessMap) {

			uniforms.roughnessMap.value = material.roughnessMap;

			refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
		}

		var envMap = properties.get(material).envMap;

		if (envMap) {

			//uniforms.envMap.value = material.envMap; // part of uniforms common
			uniforms.envMapIntensity.value = material.envMapIntensity;
		}
	}

	function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {

		uniforms.ior.value = material.ior; // also part of uniforms common

		if (material.sheen > 0) {

			uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);

			uniforms.sheenRoughness.value = material.sheenRoughness;

			if (material.sheenColorMap) {

				uniforms.sheenColorMap.value = material.sheenColorMap;

				refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
			}

			if (material.sheenRoughnessMap) {

				uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;

				refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
			}
		}

		if (material.clearcoat > 0) {

			uniforms.clearcoat.value = material.clearcoat;
			uniforms.clearcoatRoughness.value = material.clearcoatRoughness;

			if (material.clearcoatMap) {

				uniforms.clearcoatMap.value = material.clearcoatMap;

				refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
			}

			if (material.clearcoatRoughnessMap) {

				uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;

				refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
			}

			if (material.clearcoatNormalMap) {

				uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;

				refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);

				uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);

				if (material.side === BackSide) {

					uniforms.clearcoatNormalScale.value.negate();
				}
			}
		}

		if (material.iridescence > 0) {

			uniforms.iridescence.value = material.iridescence;
			uniforms.iridescenceIOR.value = material.iridescenceIOR;
			uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
			uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];

			if (material.iridescenceMap) {

				uniforms.iridescenceMap.value = material.iridescenceMap;

				refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
			}

			if (material.iridescenceThicknessMap) {

				uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;

				refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
			}
		}

		if (material.transmission > 0) {

			uniforms.transmission.value = material.transmission;
			uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
			uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);

			if (material.transmissionMap) {

				uniforms.transmissionMap.value = material.transmissionMap;

				refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
			}

			uniforms.thickness.value = material.thickness;

			if (material.thicknessMap) {

				uniforms.thicknessMap.value = material.thicknessMap;

				refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
			}

			uniforms.attenuationDistance.value = material.attenuationDistance;
			uniforms.attenuationColor.value.copy(material.attenuationColor);
		}

		uniforms.specularIntensity.value = material.specularIntensity;
		uniforms.specularColor.value.copy(material.specularColor);

		if (material.specularColorMap) {

			uniforms.specularColorMap.value = material.specularColorMap;

			refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
		}

		if (material.specularIntensityMap) {

			uniforms.specularIntensityMap.value = material.specularIntensityMap;

			refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
		}
	}

	function refreshUniformsMatcap(uniforms, material) {

		if (material.matcap) {

			uniforms.matcap.value = material.matcap;
		}
	}

	function refreshUniformsDistance(uniforms, material) {

		var light = properties.get(material).light;

		uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
		uniforms.nearDistance.value = light.shadow.camera.near;
		uniforms.farDistance.value = light.shadow.camera.far;
	}

	return {
		refreshFogUniforms: refreshFogUniforms,
		refreshMaterialUniforms: refreshMaterialUniforms
	};
}

function WebGLUniformsGroups(gl, info, capabilities, state) {

	var buffers = {};
	var updateList = {};
	var allocatedBindingPoints = [];

	var maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(35375) : 0; // binding points are global whereas block indices are per shader program

	function bind(uniformsGroup, program) {

		var webglProgram = program.program;
		state.uniformBlockBinding(uniformsGroup, webglProgram);
	}

	function update(uniformsGroup, program) {

		var buffer = buffers[uniformsGroup.id];

		if (buffer === undefined) {

			prepareUniformsGroup(uniformsGroup);

			buffer = createBuffer(uniformsGroup);
			buffers[uniformsGroup.id] = buffer;

			uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
		}

		// ensure to update the binding points/block indices mapping for this program

		var webglProgram = program.program;
		state.updateUBOMapping(uniformsGroup, webglProgram);

		// update UBO once per frame

		var frame = info.render.frame;

		if (updateList[uniformsGroup.id] !== frame) {

			updateBufferData(uniformsGroup);

			updateList[uniformsGroup.id] = frame;
		}
	}

	function createBuffer(uniformsGroup) {

		// the setup of an UBO is independent of a particular shader program but global

		var bindingPointIndex = allocateBindingPointIndex();
		uniformsGroup.__bindingPointIndex = bindingPointIndex;

		var buffer = gl.createBuffer();
		var size = uniformsGroup.__size;
		var usage = uniformsGroup.usage;

		gl.bindBuffer(35345, buffer);
		gl.bufferData(35345, size, usage);
		gl.bindBuffer(35345, null);
		gl.bindBufferBase(35345, bindingPointIndex, buffer);

		return buffer;
	}

	function allocateBindingPointIndex() {

		for (var i = 0; i < maxBindingPoints; i++) {

			if (allocatedBindingPoints.indexOf(i) === -1) {

				allocatedBindingPoints.push(i);
				return i;
			}
		}

		console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');

		return 0;
	}

	function updateBufferData(uniformsGroup) {

		var buffer = buffers[uniformsGroup.id];
		var uniforms = uniformsGroup.uniforms;
		var cache = uniformsGroup.__cache;

		gl.bindBuffer(35345, buffer);

		for (var i = 0, il = uniforms.length; i < il; i++) {

			var uniform = uniforms[i];

			// partly update the buffer if necessary

			if (hasUniformChanged(uniform, i, cache) === true) {

				var offset = uniform.__offset;

				var values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];

				var arrayOffset = 0;

				for (var _i56 = 0; _i56 < values.length; _i56++) {

					var _value5 = values[_i56];

					var _info = getUniformSize(_value5);

					if (typeof _value5 === 'number') {

						uniform.__data[0] = _value5;
						gl.bufferSubData(35345, offset + arrayOffset, uniform.__data);
					} else if (_value5.isMatrix3) {

						// manually converting 3x3 to 3x4

						uniform.__data[0] = _value5.elements[0];
						uniform.__data[1] = _value5.elements[1];
						uniform.__data[2] = _value5.elements[2];
						uniform.__data[3] = _value5.elements[0];
						uniform.__data[4] = _value5.elements[3];
						uniform.__data[5] = _value5.elements[4];
						uniform.__data[6] = _value5.elements[5];
						uniform.__data[7] = _value5.elements[0];
						uniform.__data[8] = _value5.elements[6];
						uniform.__data[9] = _value5.elements[7];
						uniform.__data[10] = _value5.elements[8];
						uniform.__data[11] = _value5.elements[0];
					} else {

						_value5.toArray(uniform.__data, arrayOffset);

						arrayOffset += _info.storage / Float32Array.BYTES_PER_ELEMENT;
					}
				}

				gl.bufferSubData(35345, offset, uniform.__data);
			}
		}

		gl.bindBuffer(35345, null);
	}

	function hasUniformChanged(uniform, index, cache) {

		var value = uniform.value;

		if (cache[index] === undefined) {

			// cache entry does not exist so far

			if (typeof value === 'number') {

				cache[index] = value;
			} else {

				var values = Array.isArray(value) ? value : [value];

				var tempValues = [];

				for (var i = 0; i < values.length; i++) {

					tempValues.push(values[i].clone());
				}

				cache[index] = tempValues;
			}

			return true;
		} else {

			// compare current value with cached entry

			if (typeof value === 'number') {

				if (cache[index] !== value) {

					cache[index] = value;
					return true;
				}
			} else {

				var cachedObjects = Array.isArray(cache[index]) ? cache[index] : [cache[index]];
				var _values = Array.isArray(value) ? value : [value];

				for (var _i57 = 0; _i57 < cachedObjects.length; _i57++) {

					var cachedObject = cachedObjects[_i57];

					if (cachedObject.equals(_values[_i57]) === false) {

						cachedObject.copy(_values[_i57]);
						return true;
					}
				}
			}
		}

		return false;
	}

	function prepareUniformsGroup(uniformsGroup) {

		// determine total buffer size according to the STD140 layout
		// Hint: STD140 is the only supported layout in WebGL 2

		var uniforms = uniformsGroup.uniforms;

		var offset = 0; // global buffer offset in bytes
		var chunkSize = 16; // size of a chunk in bytes
		var chunkOffset = 0; // offset within a single chunk in bytes

		for (var i = 0, l = uniforms.length; i < l; i++) {

			var uniform = uniforms[i];

			var infos = {
				boundary: 0, // bytes
				storage: 0 // bytes
			};

			var values = Array.isArray(uniform.value) ? uniform.value : [uniform.value];

			for (var j = 0, jl = values.length; j < jl; j++) {

				var _value6 = values[j];

				var _info2 = getUniformSize(_value6);

				infos.boundary += _info2.boundary;
				infos.storage += _info2.storage;
			}

			// the following two properties will be used for partial buffer updates

			uniform.__data = new Float32Array(infos.storage / Float32Array.BYTES_PER_ELEMENT);
			uniform.__offset = offset;

			//

			if (i > 0) {

				chunkOffset = offset % chunkSize;

				var remainingSizeInChunk = chunkSize - chunkOffset;

				// check for chunk overflow

				if (chunkOffset !== 0 && remainingSizeInChunk - infos.boundary < 0) {

					// add padding and adjust offset

					offset += chunkSize - chunkOffset;
					uniform.__offset = offset;
				}
			}

			offset += infos.storage;
		}

		// ensure correct final padding

		chunkOffset = offset % chunkSize;

		if (chunkOffset > 0) offset += chunkSize - chunkOffset;

		//

		uniformsGroup.__size = offset;
		uniformsGroup.__cache = {};

		return this;
	}

	function getUniformSize(value) {

		var info = {
			boundary: 0, // bytes
			storage: 0 // bytes
		};

		// determine sizes according to STD140

		if (typeof value === 'number') {

			// float/int

			info.boundary = 4;
			info.storage = 4;
		} else if (value.isVector2) {

			// vec2

			info.boundary = 8;
			info.storage = 8;
		} else if (value.isVector3 || value.isColor) {

			// vec3

			info.boundary = 16;
			info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
		} else if (value.isVector4) {

			// vec4

			info.boundary = 16;
			info.storage = 16;
		} else if (value.isMatrix3) {

			// mat3 (in STD140 a 3x3 matrix is represented as 3x4)

			info.boundary = 48;
			info.storage = 48;
		} else if (value.isMatrix4) {

			// mat4

			info.boundary = 64;
			info.storage = 64;
		} else if (value.isTexture) {

			console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
		} else {

			console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
		}

		return info;
	}

	function onUniformsGroupsDispose(event) {

		var uniformsGroup = event.target;

		uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);

		var index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
		allocatedBindingPoints.splice(index, 1);

		gl.deleteBuffer(buffers[uniformsGroup.id]);

		delete buffers[uniformsGroup.id];
		delete updateList[uniformsGroup.id];
	}

	function dispose() {

		for (var _id3 in buffers) {

			gl.deleteBuffer(buffers[_id3]);
		}

		allocatedBindingPoints = [];
		buffers = {};
		updateList = {};
	}

	return {

		bind: bind,
		update: update,

		dispose: dispose

	};
}

function createCanvasElement() {

	var canvas = createElementNS('canvas');
	canvas.style.display = 'block';
	return canvas;
}

var WebGLRenderer = function () {
	function WebGLRenderer() {
		var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGLRenderer);

		var _parameters$canvas = parameters.canvas,
		    canvas = _parameters$canvas === undefined ? createCanvasElement() : _parameters$canvas,
		    _parameters$context = parameters.context,
		    context = _parameters$context === undefined ? null : _parameters$context,
		    _parameters$depth = parameters.depth,
		    depth = _parameters$depth === undefined ? true : _parameters$depth,
		    _parameters$stencil = parameters.stencil,
		    stencil = _parameters$stencil === undefined ? true : _parameters$stencil,
		    _parameters$alpha = parameters.alpha,
		    alpha = _parameters$alpha === undefined ? false : _parameters$alpha,
		    _parameters$antialias = parameters.antialias,
		    antialias = _parameters$antialias === undefined ? false : _parameters$antialias,
		    _parameters$premultip = parameters.premultipliedAlpha,
		    premultipliedAlpha = _parameters$premultip === undefined ? true : _parameters$premultip,
		    _parameters$preserveD = parameters.preserveDrawingBuffer,
		    preserveDrawingBuffer = _parameters$preserveD === undefined ? false : _parameters$preserveD,
		    _parameters$powerPref = parameters.powerPreference,
		    powerPreference = _parameters$powerPref === undefined ? 'default' : _parameters$powerPref,
		    _parameters$failIfMaj = parameters.failIfMajorPerformanceCaveat,
		    failIfMajorPerformanceCaveat = _parameters$failIfMaj === undefined ? false : _parameters$failIfMaj;


		this.isWebGLRenderer = true;

		var _alpha = void 0;

		if (context !== null) {

			_alpha = context.getContextAttributes().alpha;
		} else {

			_alpha = alpha;
		}

		var currentRenderList = null;
		var currentRenderState = null;

		// render() can be called from within a callback triggered by another render.
		// We track this so that the nested render call gets its list and state isolated from the parent render call.

		var renderListStack = [];
		var renderStateStack = [];

		// public properties

		this.domElement = canvas;

		// Debug configuration container
		this.debug = {

			/**
    * Enables error checking and reporting when shader programs are being compiled
    * @type {boolean}
    */
			checkShaderErrors: true,
			/**
    * Callback for custom error reporting.
    * @type {?Function}
    */
			onShaderError: null
		};

		// clearing

		this.autoClear = true;
		this.autoClearColor = true;
		this.autoClearDepth = true;
		this.autoClearStencil = true;

		// scene graph

		this.sortObjects = true;

		// user-defined clipping

		this.clippingPlanes = [];
		this.localClippingEnabled = false;

		// physically based shading

		this.outputEncoding = LinearEncoding;

		// physical lights

		this.useLegacyLights = true;

		// tone mapping

		this.toneMapping = NoToneMapping;
		this.toneMappingExposure = 1.0;

		// internal properties

		var _this = this;

		var _isContextLost = false;

		// internal state cache

		var _currentActiveCubeFace = 0;
		var _currentActiveMipmapLevel = 0;
		var _currentRenderTarget = null;
		var _currentMaterialId = -1;

		var _currentCamera = null;

		var _currentViewport = new Vector4();
		var _currentScissor = new Vector4();
		var _currentScissorTest = null;

		//

		var _width = canvas.width;
		var _height = canvas.height;

		var _pixelRatio = 1;
		var _opaqueSort = null;
		var _transparentSort = null;

		var _viewport = new Vector4(0, 0, _width, _height);
		var _scissor = new Vector4(0, 0, _width, _height);
		var _scissorTest = false;

		// frustum

		var _frustum = new Frustum();

		// clipping

		var _clippingEnabled = false;
		var _localClippingEnabled = false;

		// transmission

		var _transmissionRenderTarget = null;

		// camera matrices cache

		var _projScreenMatrix = new Matrix4();

		var _vector3 = new Vector3();

		var _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };

		function getTargetPixelRatio() {

			return _currentRenderTarget === null ? _pixelRatio : 1;
		}

		// initialize

		var _gl = context;

		function getContext(contextNames, contextAttributes) {

			for (var i = 0; i < contextNames.length; i++) {

				var contextName = contextNames[i];
				var _context9 = canvas.getContext(contextName, contextAttributes);
				if (_context9 !== null) return _context9;
			}

			return null;
		}

		try {

			var contextAttributes = {
				alpha: true,
				depth: depth,
				stencil: stencil,
				antialias: antialias,
				premultipliedAlpha: premultipliedAlpha,
				preserveDrawingBuffer: preserveDrawingBuffer,
				powerPreference: powerPreference,
				failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
			};

			// OffscreenCanvas does not have setAttribute, see #22811
			if ('setAttribute' in canvas) canvas.setAttribute('data-engine', 'three.js r' + REVISION);

			// event listeners must be registered before WebGL context is created, see #12753
			canvas.addEventListener('webglcontextlost', onContextLost, false);
			canvas.addEventListener('webglcontextrestored', onContextRestore, false);
			canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);

			if (_gl === null) {

				var contextNames = ['webgl2', 'webgl', 'experimental-webgl'];

				if (_this.isWebGL1Renderer === true) {

					contextNames.shift();
				}

				_gl = getContext(contextNames, contextAttributes);

				if (_gl === null) {

					if (getContext(contextNames)) {

						throw new Error('Error creating WebGL context with your selected attributes.');
					} else {

						throw new Error('Error creating WebGL context.');
					}
				}
			}

			// Some experimental-webgl implementations do not have getShaderPrecisionFormat

			if (_gl.getShaderPrecisionFormat === undefined) {

				_gl.getShaderPrecisionFormat = function () {

					return { 'rangeMin': 1, 'rangeMax': 1, 'precision': 1 };
				};
			}
		} catch (error) {

			console.error('THREE.WebGLRenderer: ' + error.message);
			throw error;
		}

		var extensions = void 0,
		    capabilities = void 0,
		    state = void 0,
		    info = void 0;
		var properties = void 0,
		    textures = void 0,
		    cubemaps = void 0,
		    cubeuvmaps = void 0,
		    attributes = void 0,
		    geometries = void 0,
		    objects = void 0;
		var programCache = void 0,
		    materials = void 0,
		    renderLists = void 0,
		    renderStates = void 0,
		    clipping = void 0,
		    shadowMap = void 0;

		var background = void 0,
		    morphtargets = void 0,
		    bufferRenderer = void 0,
		    indexedBufferRenderer = void 0;

		var utils = void 0,
		    bindingStates = void 0,
		    uniformsGroups = void 0;

		function initGLContext() {

			extensions = new WebGLExtensions(_gl);

			capabilities = new WebGLCapabilities(_gl, extensions, parameters);

			extensions.init(capabilities);

			utils = new WebGLUtils(_gl, extensions, capabilities);

			state = new WebGLState(_gl, extensions, capabilities);

			info = new WebGLInfo();
			properties = new WebGLProperties();
			textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
			cubemaps = new WebGLCubeMaps(_this);
			cubeuvmaps = new WebGLCubeUVMaps(_this);
			attributes = new WebGLAttributes(_gl, capabilities);
			bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
			geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
			objects = new WebGLObjects(_gl, geometries, attributes, info);
			morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
			clipping = new WebGLClipping(properties);
			programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
			materials = new WebGLMaterials(_this, properties);
			renderLists = new WebGLRenderLists();
			renderStates = new WebGLRenderStates(extensions, capabilities);
			background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
			shadowMap = new WebGLShadowMap(_this, objects, capabilities);
			uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);

			bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
			indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);

			info.programs = programCache.programs;

			_this.capabilities = capabilities;
			_this.extensions = extensions;
			_this.properties = properties;
			_this.renderLists = renderLists;
			_this.shadowMap = shadowMap;
			_this.state = state;
			_this.info = info;
		}

		initGLContext();

		// xr

		var xr = new WebXRManager(_this, _gl);

		this.xr = xr;

		// API

		this.getContext = function () {

			return _gl;
		};

		this.getContextAttributes = function () {

			return _gl.getContextAttributes();
		};

		this.forceContextLoss = function () {

			var extension = extensions.get('WEBGL_lose_context');
			if (extension) extension.loseContext();
		};

		this.forceContextRestore = function () {

			var extension = extensions.get('WEBGL_lose_context');
			if (extension) extension.restoreContext();
		};

		this.getPixelRatio = function () {

			return _pixelRatio;
		};

		this.setPixelRatio = function (value) {

			if (value === undefined) return;

			_pixelRatio = value;

			this.setSize(_width, _height, false);
		};

		this.getSize = function (target) {

			return target.set(_width, _height);
		};

		this.setSize = function (width, height) {
			var updateStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


			if (xr.isPresenting) {

				console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
				return;
			}

			_width = width;
			_height = height;

			canvas.width = Math.floor(width * _pixelRatio);
			canvas.height = Math.floor(height * _pixelRatio);

			if (updateStyle === true) {

				canvas.style.width = width + 'px';
				canvas.style.height = height + 'px';
			}

			this.setViewport(0, 0, width, height);
		};

		this.getDrawingBufferSize = function (target) {

			return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
		};

		this.setDrawingBufferSize = function (width, height, pixelRatio) {

			_width = width;
			_height = height;

			_pixelRatio = pixelRatio;

			canvas.width = Math.floor(width * pixelRatio);
			canvas.height = Math.floor(height * pixelRatio);

			this.setViewport(0, 0, width, height);
		};

		this.getCurrentViewport = function (target) {

			return target.copy(_currentViewport);
		};

		this.getViewport = function (target) {

			return target.copy(_viewport);
		};

		this.setViewport = function (x, y, width, height) {

			if (x.isVector4) {

				_viewport.set(x.x, x.y, x.z, x.w);
			} else {

				_viewport.set(x, y, width, height);
			}

			state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
		};

		this.getScissor = function (target) {

			return target.copy(_scissor);
		};

		this.setScissor = function (x, y, width, height) {

			if (x.isVector4) {

				_scissor.set(x.x, x.y, x.z, x.w);
			} else {

				_scissor.set(x, y, width, height);
			}

			state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
		};

		this.getScissorTest = function () {

			return _scissorTest;
		};

		this.setScissorTest = function (boolean) {

			state.setScissorTest(_scissorTest = boolean);
		};

		this.setOpaqueSort = function (method) {

			_opaqueSort = method;
		};

		this.setTransparentSort = function (method) {

			_transparentSort = method;
		};

		// Clearing

		this.getClearColor = function (target) {

			return target.copy(background.getClearColor());
		};

		this.setClearColor = function () {

			background.setClearColor.apply(background, arguments);
		};

		this.getClearAlpha = function () {

			return background.getClearAlpha();
		};

		this.setClearAlpha = function () {

			background.setClearAlpha.apply(background, arguments);
		};

		this.clear = function () {
			var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
			var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var stencil = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


			var bits = 0;

			if (color) bits |= 16384;
			if (depth) bits |= 256;
			if (stencil) bits |= 1024;

			_gl.clear(bits);
		};

		this.clearColor = function () {

			this.clear(true, false, false);
		};

		this.clearDepth = function () {

			this.clear(false, true, false);
		};

		this.clearStencil = function () {

			this.clear(false, false, true);
		};

		//

		this.dispose = function () {

			canvas.removeEventListener('webglcontextlost', onContextLost, false);
			canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
			canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);

			renderLists.dispose();
			renderStates.dispose();
			properties.dispose();
			cubemaps.dispose();
			cubeuvmaps.dispose();
			objects.dispose();
			bindingStates.dispose();
			uniformsGroups.dispose();
			programCache.dispose();

			xr.dispose();

			xr.removeEventListener('sessionstart', onXRSessionStart);
			xr.removeEventListener('sessionend', onXRSessionEnd);

			if (_transmissionRenderTarget) {

				_transmissionRenderTarget.dispose();
				_transmissionRenderTarget = null;
			}

			animation.stop();
		};

		// Events

		function onContextLost(event) {

			event.preventDefault();

			console.log('THREE.WebGLRenderer: Context Lost.');

			_isContextLost = true;
		}

		function onContextRestore() /* event */{

			console.log('THREE.WebGLRenderer: Context Restored.');

			_isContextLost = false;

			var infoAutoReset = info.autoReset;
			var shadowMapEnabled = shadowMap.enabled;
			var shadowMapAutoUpdate = shadowMap.autoUpdate;
			var shadowMapNeedsUpdate = shadowMap.needsUpdate;
			var shadowMapType = shadowMap.type;

			initGLContext();

			info.autoReset = infoAutoReset;
			shadowMap.enabled = shadowMapEnabled;
			shadowMap.autoUpdate = shadowMapAutoUpdate;
			shadowMap.needsUpdate = shadowMapNeedsUpdate;
			shadowMap.type = shadowMapType;
		}

		function onContextCreationError(event) {

			console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
		}

		function onMaterialDispose(event) {

			var material = event.target;

			material.removeEventListener('dispose', onMaterialDispose);

			deallocateMaterial(material);
		}

		// Buffer deallocation

		function deallocateMaterial(material) {

			releaseMaterialProgramReferences(material);

			properties.remove(material);
		}

		function releaseMaterialProgramReferences(material) {

			var programs = properties.get(material).programs;

			if (programs !== undefined) {

				programs.forEach(function (program) {

					programCache.releaseProgram(program);
				});

				if (material.isShaderMaterial) {

					programCache.releaseShaderCache(material);
				}
			}
		}

		// Buffer rendering

		this.renderBufferDirect = function (camera, scene, geometry, material, object, group) {

			if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)

			var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;

			var program = setProgram(camera, scene, geometry, material, object);

			state.setMaterial(material, frontFaceCW);

			//

			var index = geometry.index;
			var rangeFactor = 1;

			if (material.wireframe === true) {

				index = geometries.getWireframeAttribute(geometry);
				rangeFactor = 2;
			}

			//

			var drawRange = geometry.drawRange;
			var position = geometry.attributes.position;

			var drawStart = drawRange.start * rangeFactor;
			var drawEnd = (drawRange.start + drawRange.count) * rangeFactor;

			if (group !== null) {

				drawStart = Math.max(drawStart, group.start * rangeFactor);
				drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
			}

			if (index !== null) {

				drawStart = Math.max(drawStart, 0);
				drawEnd = Math.min(drawEnd, index.count);
			} else if (position !== undefined && position !== null) {

				drawStart = Math.max(drawStart, 0);
				drawEnd = Math.min(drawEnd, position.count);
			}

			var drawCount = drawEnd - drawStart;

			if (drawCount < 0 || drawCount === Infinity) return;

			//

			bindingStates.setup(object, material, program, geometry, index);

			var attribute = void 0;
			var renderer = bufferRenderer;

			if (index !== null) {

				attribute = attributes.get(index);

				renderer = indexedBufferRenderer;
				renderer.setIndex(attribute);
			}

			//

			if (object.isMesh) {

				if (material.wireframe === true) {

					state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
					renderer.setMode(1);
				} else {

					renderer.setMode(4);
				}
			} else if (object.isLine) {

				var lineWidth = material.linewidth;

				if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material

				state.setLineWidth(lineWidth * getTargetPixelRatio());

				if (object.isLineSegments) {

					renderer.setMode(1);
				} else if (object.isLineLoop) {

					renderer.setMode(2);
				} else {

					renderer.setMode(3);
				}
			} else if (object.isPoints) {

				renderer.setMode(0);
			} else if (object.isSprite) {

				renderer.setMode(4);
			}

			if (object.isInstancedMesh) {

				renderer.renderInstances(drawStart, drawCount, object.count);
			} else if (geometry.isInstancedBufferGeometry) {

				var maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
				var instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);

				renderer.renderInstances(drawStart, drawCount, instanceCount);
			} else {

				renderer.render(drawStart, drawCount);
			}
		};

		// Compile

		this.compile = function (scene, camera) {

			function prepare(material, scene, object) {

				if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {

					material.side = BackSide;
					material.needsUpdate = true;
					getProgram(material, scene, object);

					material.side = FrontSide;
					material.needsUpdate = true;
					getProgram(material, scene, object);

					material.side = DoubleSide;
				} else {

					getProgram(material, scene, object);
				}
			}

			currentRenderState = renderStates.get(scene);
			currentRenderState.init();

			renderStateStack.push(currentRenderState);

			scene.traverseVisible(function (object) {

				if (object.isLight && object.layers.test(camera.layers)) {

					currentRenderState.pushLight(object);

					if (object.castShadow) {

						currentRenderState.pushShadow(object);
					}
				}
			});

			currentRenderState.setupLights(_this.useLegacyLights);

			scene.traverse(function (object) {

				var material = object.material;

				if (material) {

					if (Array.isArray(material)) {

						for (var i = 0; i < material.length; i++) {

							var material2 = material[i];

							prepare(material2, scene, object);
						}
					} else {

						prepare(material, scene, object);
					}
				}
			});

			renderStateStack.pop();
			currentRenderState = null;
		};

		// Animation Loop

		var onAnimationFrameCallback = null;

		function onAnimationFrame(time) {

			if (onAnimationFrameCallback) onAnimationFrameCallback(time);
		}

		function onXRSessionStart() {

			animation.stop();
		}

		function onXRSessionEnd() {

			animation.start();
		}

		var animation = new WebGLAnimation();
		animation.setAnimationLoop(onAnimationFrame);

		if (typeof self !== 'undefined') animation.setContext(self);

		this.setAnimationLoop = function (callback) {

			onAnimationFrameCallback = callback;
			xr.setAnimationLoop(callback);

			callback === null ? animation.stop() : animation.start();
		};

		xr.addEventListener('sessionstart', onXRSessionStart);
		xr.addEventListener('sessionend', onXRSessionEnd);

		// Rendering

		this.render = function (scene, camera) {

			if (camera !== undefined && camera.isCamera !== true) {

				console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
				return;
			}

			if (_isContextLost === true) return;

			// update scene graph

			if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();

			// update camera matrices and frustum

			if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();

			if (xr.enabled === true && xr.isPresenting === true) {

				if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);

				camera = xr.getCamera(); // use XR camera for rendering
			}

			//
			if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);

			currentRenderState = renderStates.get(scene, renderStateStack.length);
			currentRenderState.init();

			renderStateStack.push(currentRenderState);

			_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
			_frustum.setFromProjectionMatrix(_projScreenMatrix);

			_localClippingEnabled = this.localClippingEnabled;
			_clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);

			currentRenderList = renderLists.get(scene, renderListStack.length);
			currentRenderList.init();

			renderListStack.push(currentRenderList);

			projectObject(scene, camera, 0, _this.sortObjects);

			currentRenderList.finish();

			if (_this.sortObjects === true) {

				currentRenderList.sort(_opaqueSort, _transparentSort);
			}

			//

			if (_clippingEnabled === true) clipping.beginShadows();

			var shadowsArray = currentRenderState.state.shadowsArray;

			shadowMap.render(shadowsArray, scene, camera);

			if (_clippingEnabled === true) clipping.endShadows();

			//

			if (this.info.autoReset === true) this.info.reset();

			//

			background.render(currentRenderList, scene);

			// render scene

			currentRenderState.setupLights(_this.useLegacyLights);

			if (camera.isArrayCamera) {

				var _cameras = camera.cameras;

				for (var i = 0, l = _cameras.length; i < l; i++) {

					var camera2 = _cameras[i];

					renderScene(currentRenderList, scene, camera2, camera2.viewport);
				}
			} else {

				renderScene(currentRenderList, scene, camera);
			}

			//

			if (_currentRenderTarget !== null) {

				// resolve multisample renderbuffers to a single-sample texture if necessary

				textures.updateMultisampleRenderTarget(_currentRenderTarget);

				// Generate mipmap if we're using any kind of mipmap filtering

				textures.updateRenderTargetMipmap(_currentRenderTarget);
			}

			//

			if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);

			// _gl.finish();

			bindingStates.resetDefaultState();
			_currentMaterialId = -1;
			_currentCamera = null;

			renderStateStack.pop();

			if (renderStateStack.length > 0) {

				currentRenderState = renderStateStack[renderStateStack.length - 1];
			} else {

				currentRenderState = null;
			}

			renderListStack.pop();

			if (renderListStack.length > 0) {

				currentRenderList = renderListStack[renderListStack.length - 1];
			} else {

				currentRenderList = null;
			}
		};

		function projectObject(object, camera, groupOrder, sortObjects) {

			if (object.visible === false) return;

			var visible = object.layers.test(camera.layers);

			if (visible) {

				if (object.isGroup) {

					groupOrder = object.renderOrder;
				} else if (object.isLOD) {

					if (object.autoUpdate === true) object.update(camera);
				} else if (object.isLight) {

					currentRenderState.pushLight(object);

					if (object.castShadow) {

						currentRenderState.pushShadow(object);
					}
				} else if (object.isSprite) {

					if (!object.frustumCulled || _frustum.intersectsSprite(object)) {

						if (sortObjects) {

							_vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
						}

						var geometry = objects.update(object);
						var material = object.material;

						if (material.visible) {

							currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
						}
					}
				} else if (object.isMesh || object.isLine || object.isPoints) {

					if (object.isSkinnedMesh) {

						// update skeleton only once in a frame

						if (object.skeleton.frame !== info.render.frame) {

							object.skeleton.update();
							object.skeleton.frame = info.render.frame;
						}
					}

					if (!object.frustumCulled || _frustum.intersectsObject(object)) {

						if (sortObjects) {

							_vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
						}

						var _geometry2 = objects.update(object);
						var _material = object.material;

						if (Array.isArray(_material)) {

							var groups = _geometry2.groups;

							for (var i = 0, l = groups.length; i < l; i++) {

								var group = groups[i];
								var groupMaterial = _material[group.materialIndex];

								if (groupMaterial && groupMaterial.visible) {

									currentRenderList.push(object, _geometry2, groupMaterial, groupOrder, _vector3.z, group);
								}
							}
						} else if (_material.visible) {

							currentRenderList.push(object, _geometry2, _material, groupOrder, _vector3.z, null);
						}
					}
				}
			}

			var children = object.children;

			for (var _i58 = 0, _l6 = children.length; _i58 < _l6; _i58++) {

				projectObject(children[_i58], camera, groupOrder, sortObjects);
			}
		}

		function renderScene(currentRenderList, scene, camera, viewport) {

			var opaqueObjects = currentRenderList.opaque;
			var transmissiveObjects = currentRenderList.transmissive;
			var transparentObjects = currentRenderList.transparent;

			currentRenderState.setupLightsView(camera);

			if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);

			if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);

			if (viewport) state.viewport(_currentViewport.copy(viewport));

			if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
			if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
			if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);

			// Ensure depth buffer writing is enabled so it can be cleared on next render

			state.buffers.depth.setTest(true);
			state.buffers.depth.setMask(true);
			state.buffers.color.setMask(true);

			state.setPolygonOffset(false);
		}

		function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {

			if (_transmissionRenderTarget === null) {

				var isWebGL2 = capabilities.isWebGL2;

				_transmissionRenderTarget = new WebGLRenderTarget(1024, 1024, {
					generateMipmaps: true,
					type: extensions.has('EXT_color_buffer_half_float') ? HalfFloatType : UnsignedByteType,
					minFilter: LinearMipmapLinearFilter,
					samples: isWebGL2 && antialias === true ? 4 : 0
				});

				// debug

				/*
    const geometry = new PlaneGeometry();
    const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );
    	const mesh = new Mesh( geometry, material );
    scene.add( mesh );
    */
			}

			//

			var currentRenderTarget = _this.getRenderTarget();
			_this.setRenderTarget(_transmissionRenderTarget);
			_this.clear();

			// Turn off the features which can affect the frag color for opaque objects pass.
			// Otherwise they are applied twice in opaque objects pass and transmission objects pass.
			var currentToneMapping = _this.toneMapping;
			_this.toneMapping = NoToneMapping;

			renderObjects(opaqueObjects, scene, camera);

			textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
			textures.updateRenderTargetMipmap(_transmissionRenderTarget);

			var renderTargetNeedsUpdate = false;

			for (var i = 0, l = transmissiveObjects.length; i < l; i++) {

				var renderItem = transmissiveObjects[i];

				var object = renderItem.object;
				var geometry = renderItem.geometry;
				var material = renderItem.material;
				var group = renderItem.group;

				if (material.side === DoubleSide && object.layers.test(camera.layers)) {

					var currentSide = material.side;

					material.side = BackSide;
					material.needsUpdate = true;

					renderObject(object, scene, camera, geometry, material, group);

					material.side = currentSide;
					material.needsUpdate = true;

					renderTargetNeedsUpdate = true;
				}
			}

			if (renderTargetNeedsUpdate === true) {

				textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
				textures.updateRenderTargetMipmap(_transmissionRenderTarget);
			}

			_this.setRenderTarget(currentRenderTarget);

			_this.toneMapping = currentToneMapping;
		}

		function renderObjects(renderList, scene, camera) {

			var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

			for (var i = 0, l = renderList.length; i < l; i++) {

				var renderItem = renderList[i];

				var object = renderItem.object;
				var geometry = renderItem.geometry;
				var material = overrideMaterial === null ? renderItem.material : overrideMaterial;
				var group = renderItem.group;

				if (object.layers.test(camera.layers)) {

					renderObject(object, scene, camera, geometry, material, group);
				}
			}
		}

		function renderObject(object, scene, camera, geometry, material, group) {

			object.onBeforeRender(_this, scene, camera, geometry, material, group);

			object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
			object.normalMatrix.getNormalMatrix(object.modelViewMatrix);

			material.onBeforeRender(_this, scene, camera, geometry, object, group);

			if (material.transparent === true && material.side === DoubleSide && material.forceSinglePass === false) {

				material.side = BackSide;
				material.needsUpdate = true;
				_this.renderBufferDirect(camera, scene, geometry, material, object, group);

				material.side = FrontSide;
				material.needsUpdate = true;
				_this.renderBufferDirect(camera, scene, geometry, material, object, group);

				material.side = DoubleSide;
			} else {

				_this.renderBufferDirect(camera, scene, geometry, material, object, group);
			}

			object.onAfterRender(_this, scene, camera, geometry, material, group);
		}

		function getProgram(material, scene, object) {

			if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			var materialProperties = properties.get(material);

			var lights = currentRenderState.state.lights;
			var shadowsArray = currentRenderState.state.shadowsArray;

			var lightsStateVersion = lights.state.version;

			var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
			var programCacheKey = programCache.getProgramCacheKey(parameters);

			var programs = materialProperties.programs;

			// always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change

			materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
			materialProperties.fog = scene.fog;
			materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);

			if (programs === undefined) {

				// new material

				material.addEventListener('dispose', onMaterialDispose);

				programs = new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a();
				materialProperties.programs = programs;
			}

			var program = programs.get(programCacheKey);

			if (program !== undefined) {

				// early out if program and light state is identical

				if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {

					updateCommonMaterialProperties(material, parameters);

					return program;
				}
			} else {

				parameters.uniforms = programCache.getUniforms(material);

				material.onBuild(object, parameters, _this);

				material.onBeforeCompile(parameters, _this);

				program = programCache.acquireProgram(parameters, programCacheKey);
				programs.set(programCacheKey, program);

				materialProperties.uniforms = parameters.uniforms;
			}

			var uniforms = materialProperties.uniforms;

			if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {

				uniforms.clippingPlanes = clipping.uniform;
			}

			updateCommonMaterialProperties(material, parameters);

			// store the light setup it was created for

			materialProperties.needsLights = materialNeedsLights(material);
			materialProperties.lightsStateVersion = lightsStateVersion;

			if (materialProperties.needsLights) {

				// wire up the material to this renderer's lighting state

				uniforms.ambientLightColor.value = lights.state.ambient;
				uniforms.lightProbe.value = lights.state.probe;
				uniforms.directionalLights.value = lights.state.directional;
				uniforms.directionalLightShadows.value = lights.state.directionalShadow;
				uniforms.spotLights.value = lights.state.spot;
				uniforms.spotLightShadows.value = lights.state.spotShadow;
				uniforms.rectAreaLights.value = lights.state.rectArea;
				uniforms.ltc_1.value = lights.state.rectAreaLTC1;
				uniforms.ltc_2.value = lights.state.rectAreaLTC2;
				uniforms.pointLights.value = lights.state.point;
				uniforms.pointLightShadows.value = lights.state.pointShadow;
				uniforms.hemisphereLights.value = lights.state.hemi;

				uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
				uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
				uniforms.spotShadowMap.value = lights.state.spotShadowMap;
				uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
				uniforms.spotLightMap.value = lights.state.spotLightMap;
				uniforms.pointShadowMap.value = lights.state.pointShadowMap;
				uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
				// TODO (abelnation): add area lights shadow info to uniforms
			}

			var progUniforms = program.getUniforms();
			var uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);

			materialProperties.currentProgram = program;
			materialProperties.uniformsList = uniformsList;

			return program;
		}

		function updateCommonMaterialProperties(material, parameters) {

			var materialProperties = properties.get(material);

			materialProperties.outputEncoding = parameters.outputEncoding;
			materialProperties.instancing = parameters.instancing;
			materialProperties.skinning = parameters.skinning;
			materialProperties.morphTargets = parameters.morphTargets;
			materialProperties.morphNormals = parameters.morphNormals;
			materialProperties.morphColors = parameters.morphColors;
			materialProperties.morphTargetsCount = parameters.morphTargetsCount;
			materialProperties.numClippingPlanes = parameters.numClippingPlanes;
			materialProperties.numIntersection = parameters.numClipIntersection;
			materialProperties.vertexAlphas = parameters.vertexAlphas;
			materialProperties.vertexTangents = parameters.vertexTangents;
			materialProperties.toneMapping = parameters.toneMapping;
		}

		function setProgram(camera, scene, geometry, material, object) {

			if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

			textures.resetTextureUnits();

			var fog = scene.fog;
			var environment = material.isMeshStandardMaterial ? scene.environment : null;
			var encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : LinearEncoding;
			var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
			var vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
			var vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
			var morphTargets = !!geometry.morphAttributes.position;
			var morphNormals = !!geometry.morphAttributes.normal;
			var morphColors = !!geometry.morphAttributes.color;
			var toneMapping = material.toneMapped ? _this.toneMapping : NoToneMapping;

			var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
			var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;

			var materialProperties = properties.get(material);
			var lights = currentRenderState.state.lights;

			if (_clippingEnabled === true) {

				if (_localClippingEnabled === true || camera !== _currentCamera) {

					var useCache = camera === _currentCamera && material.id === _currentMaterialId;

					// we might want to call this function with some ClippingGroup
					// object instead of the material, once it becomes feasible
					// (#8465, #8379)
					clipping.setState(material, camera, useCache);
				}
			}

			//

			var needsProgramChange = false;

			if (material.version === materialProperties.__version) {

				if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {

					needsProgramChange = true;
				} else if (materialProperties.outputEncoding !== encoding) {

					needsProgramChange = true;
				} else if (object.isInstancedMesh && materialProperties.instancing === false) {

					needsProgramChange = true;
				} else if (!object.isInstancedMesh && materialProperties.instancing === true) {

					needsProgramChange = true;
				} else if (object.isSkinnedMesh && materialProperties.skinning === false) {

					needsProgramChange = true;
				} else if (!object.isSkinnedMesh && materialProperties.skinning === true) {

					needsProgramChange = true;
				} else if (materialProperties.envMap !== envMap) {

					needsProgramChange = true;
				} else if (material.fog === true && materialProperties.fog !== fog) {

					needsProgramChange = true;
				} else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {

					needsProgramChange = true;
				} else if (materialProperties.vertexAlphas !== vertexAlphas) {

					needsProgramChange = true;
				} else if (materialProperties.vertexTangents !== vertexTangents) {

					needsProgramChange = true;
				} else if (materialProperties.morphTargets !== morphTargets) {

					needsProgramChange = true;
				} else if (materialProperties.morphNormals !== morphNormals) {

					needsProgramChange = true;
				} else if (materialProperties.morphColors !== morphColors) {

					needsProgramChange = true;
				} else if (materialProperties.toneMapping !== toneMapping) {

					needsProgramChange = true;
				} else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) {

					needsProgramChange = true;
				}
			} else {

				needsProgramChange = true;
				materialProperties.__version = material.version;
			}

			//

			var program = materialProperties.currentProgram;

			if (needsProgramChange === true) {

				program = getProgram(material, scene, object);
			}

			var refreshProgram = false;
			var refreshMaterial = false;
			var refreshLights = false;

			var p_uniforms = program.getUniforms(),
			    m_uniforms = materialProperties.uniforms;

			if (state.useProgram(program.program)) {

				refreshProgram = true;
				refreshMaterial = true;
				refreshLights = true;
			}

			if (material.id !== _currentMaterialId) {

				_currentMaterialId = material.id;

				refreshMaterial = true;
			}

			if (refreshProgram || _currentCamera !== camera) {

				p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);

				if (capabilities.logarithmicDepthBuffer) {

					p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
				}

				if (_currentCamera !== camera) {

					_currentCamera = camera;

					// lighting uniforms depend on the camera so enforce an update
					// now, in case this material supports lights - or later, when
					// the next material that does gets activated:

					refreshMaterial = true; // set to true on material change
					refreshLights = true; // remains set until update done
				}

				// load material specific uniforms
				// (shader material also gets them for the sake of genericity)

				if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {

					var uCamPos = p_uniforms.map.cameraPosition;

					if (uCamPos !== undefined) {

						uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
					}
				}

				if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {

					p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
				}

				if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) {

					p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
				}
			}

			// skinning and morph target uniforms must be set even if material didn't change
			// auto-setting of texture unit for bone and morph texture must go before other textures
			// otherwise textures used for skinning and morphing can take over texture units reserved for other material textures

			if (object.isSkinnedMesh) {

				p_uniforms.setOptional(_gl, object, 'bindMatrix');
				p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');

				var skeleton = object.skeleton;

				if (skeleton) {

					if (capabilities.floatVertexTextures) {

						if (skeleton.boneTexture === null) skeleton.computeBoneTexture();

						p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
						p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
					} else {

						console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
					}
				}
			}

			var morphAttributes = geometry.morphAttributes;

			if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) {

				morphtargets.update(object, geometry, program);
			}

			if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {

				materialProperties.receiveShadow = object.receiveShadow;
				p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
			}

			// https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512

			if (material.isMeshGouraudMaterial && material.envMap !== null) {

				m_uniforms.envMap.value = envMap;

				m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
			}

			if (refreshMaterial) {

				p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);

				if (materialProperties.needsLights) {

					// the current material requires lighting info

					// note: all lighting uniforms are always set correctly
					// they simply reference the renderer's state for their
					// values
					//
					// use the current material's .needsUpdate flags to set
					// the GL state when required

					markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
				}

				// refresh uniforms common to several materials

				if (fog && material.fog === true) {

					materials.refreshFogUniforms(m_uniforms, fog);
				}

				materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);

				WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
			}

			if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {

				WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
				material.uniformsNeedUpdate = false;
			}

			if (material.isSpriteMaterial) {

				p_uniforms.setValue(_gl, 'center', object.center);
			}

			// common matrices

			p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
			p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
			p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);

			// UBOs

			if (material.isShaderMaterial || material.isRawShaderMaterial) {

				var groups = material.uniformsGroups;

				for (var i = 0, l = groups.length; i < l; i++) {

					if (capabilities.isWebGL2) {

						var group = groups[i];

						uniformsGroups.update(group, program);
						uniformsGroups.bind(group, program);
					} else {

						console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
					}
				}
			}

			return program;
		}

		// If uniforms are marked as clean, they don't need to be loaded to the GPU.

		function markUniformsLightsNeedsUpdate(uniforms, value) {

			uniforms.ambientLightColor.needsUpdate = value;
			uniforms.lightProbe.needsUpdate = value;

			uniforms.directionalLights.needsUpdate = value;
			uniforms.directionalLightShadows.needsUpdate = value;
			uniforms.pointLights.needsUpdate = value;
			uniforms.pointLightShadows.needsUpdate = value;
			uniforms.spotLights.needsUpdate = value;
			uniforms.spotLightShadows.needsUpdate = value;
			uniforms.rectAreaLights.needsUpdate = value;
			uniforms.hemisphereLights.needsUpdate = value;
		}

		function materialNeedsLights(material) {

			return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
		}

		this.getActiveCubeFace = function () {

			return _currentActiveCubeFace;
		};

		this.getActiveMipmapLevel = function () {

			return _currentActiveMipmapLevel;
		};

		this.getRenderTarget = function () {

			return _currentRenderTarget;
		};

		this.setRenderTargetTextures = function (renderTarget, colorTexture, depthTexture) {

			properties.get(renderTarget.texture).__webglTexture = colorTexture;
			properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;

			var renderTargetProperties = properties.get(renderTarget);
			renderTargetProperties.__hasExternalTextures = true;

			if (renderTargetProperties.__hasExternalTextures) {

				renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;

				if (!renderTargetProperties.__autoAllocateDepthBuffer) {

					// The multisample_render_to_texture extension doesn't work properly if there
					// are midframe flushes and an external depth buffer. Disable use of the extension.
					if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {

						console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
						renderTargetProperties.__useRenderToTexture = false;
					}
				}
			}
		};

		this.setRenderTargetFramebuffer = function (renderTarget, defaultFramebuffer) {

			var renderTargetProperties = properties.get(renderTarget);
			renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
			renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
		};

		this.setRenderTarget = function (renderTarget) {
			var activeCubeFace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
			var activeMipmapLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


			_currentRenderTarget = renderTarget;
			_currentActiveCubeFace = activeCubeFace;
			_currentActiveMipmapLevel = activeMipmapLevel;

			var useDefaultFramebuffer = true;
			var framebuffer = null;
			var isCube = false;
			var isRenderTarget3D = false;

			if (renderTarget) {

				var renderTargetProperties = properties.get(renderTarget);

				if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {

					// We need to make sure to rebind the framebuffer.
					state.bindFramebuffer(36160, null);
					useDefaultFramebuffer = false;
				} else if (renderTargetProperties.__webglFramebuffer === undefined) {

					textures.setupRenderTarget(renderTarget);
				} else if (renderTargetProperties.__hasExternalTextures) {

					// Color and depth texture must be rebound in order for the swapchain to update.
					textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
				}

				var _texture5 = renderTarget.texture;

				if (_texture5.isData3DTexture || _texture5.isDataArrayTexture || _texture5.isCompressedArrayTexture) {

					isRenderTarget3D = true;
				}

				var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;

				if (renderTarget.isWebGLCubeRenderTarget) {

					framebuffer = __webglFramebuffer[activeCubeFace];
					isCube = true;
				} else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {

					framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
				} else {

					framebuffer = __webglFramebuffer;
				}

				_currentViewport.copy(renderTarget.viewport);
				_currentScissor.copy(renderTarget.scissor);
				_currentScissorTest = renderTarget.scissorTest;
			} else {

				_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
				_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
				_currentScissorTest = _scissorTest;
			}

			var framebufferBound = state.bindFramebuffer(36160, framebuffer);

			if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) {

				state.drawBuffers(renderTarget, framebuffer);
			}

			state.viewport(_currentViewport);
			state.scissor(_currentScissor);
			state.setScissorTest(_currentScissorTest);

			if (isCube) {

				var textureProperties = properties.get(renderTarget.texture);
				_gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
			} else if (isRenderTarget3D) {

				var _textureProperties = properties.get(renderTarget.texture);
				var layer = activeCubeFace || 0;
				_gl.framebufferTextureLayer(36160, 36064, _textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
			}

			_currentMaterialId = -1; // reset current material to ensure correct uniform bindings
		};

		this.readRenderTargetPixels = function (renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {

			if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {

				console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
				return;
			}

			var framebuffer = properties.get(renderTarget).__webglFramebuffer;

			if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) {

				framebuffer = framebuffer[activeCubeFaceIndex];
			}

			if (framebuffer) {

				state.bindFramebuffer(36160, framebuffer);

				try {

					var _texture6 = renderTarget.texture;
					var textureFormat = _texture6.format;
					var textureType = _texture6.type;

					if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== _gl.getParameter(35739)) {

						console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
						return;
					}

					var halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));

					if (textureType !== UnsignedByteType && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
					!(textureType === FloatType && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
					!halfFloatSupportedByExt) {

						console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
						return;
					}

					// the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)

					if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {

						_gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
					}
				} finally {

					// restore framebuffer of current render target if necessary

					var _framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
					state.bindFramebuffer(36160, _framebuffer);
				}
			}
		};

		this.copyFramebufferToTexture = function (position, texture) {
			var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


			var levelScale = Math.pow(2, -level);
			var width = Math.floor(texture.image.width * levelScale);
			var height = Math.floor(texture.image.height * levelScale);

			textures.setTexture2D(texture, 0);

			_gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);

			state.unbindTexture();
		};

		this.copyTextureToTexture = function (position, srcTexture, dstTexture) {
			var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;


			var width = srcTexture.image.width;
			var height = srcTexture.image.height;
			var glFormat = utils.convert(dstTexture.format);
			var glType = utils.convert(dstTexture.type);

			textures.setTexture2D(dstTexture, 0);

			// As another texture upload may have changed pixelStorei
			// parameters, make sure they are correct for the dstTexture
			_gl.pixelStorei(37440, dstTexture.flipY);
			_gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
			_gl.pixelStorei(3317, dstTexture.unpackAlignment);

			if (srcTexture.isDataTexture) {

				_gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
			} else {

				if (srcTexture.isCompressedTexture) {

					_gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
				} else {

					_gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
				}
			}

			// Generate mipmaps only when copying level 0
			if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);

			state.unbindTexture();
		};

		this.copyTextureToTexture3D = function (sourceBox, position, srcTexture, dstTexture) {
			var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


			if (_this.isWebGL1Renderer) {

				console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
				return;
			}

			var width = sourceBox.max.x - sourceBox.min.x + 1;
			var height = sourceBox.max.y - sourceBox.min.y + 1;
			var depth = sourceBox.max.z - sourceBox.min.z + 1;
			var glFormat = utils.convert(dstTexture.format);
			var glType = utils.convert(dstTexture.type);
			var glTarget = void 0;

			if (dstTexture.isData3DTexture) {

				textures.setTexture3D(dstTexture, 0);
				glTarget = 32879;
			} else if (dstTexture.isDataArrayTexture) {

				textures.setTexture2DArray(dstTexture, 0);
				glTarget = 35866;
			} else {

				console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
				return;
			}

			_gl.pixelStorei(37440, dstTexture.flipY);
			_gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
			_gl.pixelStorei(3317, dstTexture.unpackAlignment);

			var unpackRowLen = _gl.getParameter(3314);
			var unpackImageHeight = _gl.getParameter(32878);
			var unpackSkipPixels = _gl.getParameter(3316);
			var unpackSkipRows = _gl.getParameter(3315);
			var unpackSkipImages = _gl.getParameter(32877);

			var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;

			_gl.pixelStorei(3314, image.width);
			_gl.pixelStorei(32878, image.height);
			_gl.pixelStorei(3316, sourceBox.min.x);
			_gl.pixelStorei(3315, sourceBox.min.y);
			_gl.pixelStorei(32877, sourceBox.min.z);

			if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {

				_gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
			} else {

				if (srcTexture.isCompressedArrayTexture) {

					console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
					_gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
				} else {

					_gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
				}
			}

			_gl.pixelStorei(3314, unpackRowLen);
			_gl.pixelStorei(32878, unpackImageHeight);
			_gl.pixelStorei(3316, unpackSkipPixels);
			_gl.pixelStorei(3315, unpackSkipRows);
			_gl.pixelStorei(32877, unpackSkipImages);

			// Generate mipmaps only when copying level 0
			if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);

			state.unbindTexture();
		};

		this.initTexture = function (texture) {

			if (texture.isCubeTexture) {

				textures.setTextureCube(texture, 0);
			} else if (texture.isData3DTexture) {

				textures.setTexture3D(texture, 0);
			} else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) {

				textures.setTexture2DArray(texture, 0);
			} else {

				textures.setTexture2D(texture, 0);
			}

			state.unbindTexture();
		};

		this.resetState = function () {

			_currentActiveCubeFace = 0;
			_currentActiveMipmapLevel = 0;
			_currentRenderTarget = null;

			state.reset();
			bindingStates.reset();
		};

		if (typeof __THREE_DEVTOOLS__ !== 'undefined') {

			__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: this }));
		}
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WebGLRenderer, [{
		key: 'physicallyCorrectLights',
		get: function get() {
			// @deprecated, r150

			console.warn('THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
			return !this.useLegacyLights;
		},
		set: function set(value) {
			// @deprecated, r150

			console.warn('THREE.WebGLRenderer: the property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead.');
			this.useLegacyLights = !value;
		}
	}]);

	return WebGLRenderer;
}();

var WebGL1Renderer = function (_WebGLRenderer) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WebGL1Renderer, _WebGLRenderer);

	function WebGL1Renderer() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WebGL1Renderer);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebGL1Renderer.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WebGL1Renderer)).apply(this, arguments));
	}

	return WebGL1Renderer;
}(WebGLRenderer);

WebGL1Renderer.prototype.isWebGL1Renderer = true;

var FogExp2 = function () {
	function FogExp2(color) {
		var density = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.00025;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, FogExp2);

		this.isFogExp2 = true;

		this.name = '';

		this.color = new Color(color);
		this.density = density;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(FogExp2, [{
		key: 'clone',
		value: function clone() {

			return new FogExp2(this.color, this.density);
		}
	}, {
		key: 'toJSON',
		value: function toJSON() /* meta */{

			return {
				type: 'FogExp2',
				color: this.color.getHex(),
				density: this.density
			};
		}
	}]);

	return FogExp2;
}();

var Fog = function () {
	function Fog(color) {
		var near = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var far = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Fog);

		this.isFog = true;

		this.name = '';

		this.color = new Color(color);

		this.near = near;
		this.far = far;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Fog, [{
		key: 'clone',
		value: function clone() {

			return new Fog(this.color, this.near, this.far);
		}
	}, {
		key: 'toJSON',
		value: function toJSON() /* meta */{

			return {
				type: 'Fog',
				color: this.color.getHex(),
				near: this.near,
				far: this.far
			};
		}
	}]);

	return Fog;
}();

var Scene = function (_Object3D5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Scene, _Object3D5);

	function Scene() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Scene);

		var _this40 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Scene.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Scene)).call(this));

		_this40.isScene = true;

		_this40.type = 'Scene';

		_this40.background = null;
		_this40.environment = null;
		_this40.fog = null;

		_this40.backgroundBlurriness = 0;
		_this40.backgroundIntensity = 1;

		_this40.overrideMaterial = null;

		if (typeof __THREE_DEVTOOLS__ !== 'undefined') {

			__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', { detail: _this40 }));
		}

		return _this40;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Scene, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Scene.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Scene.prototype), 'copy', this).call(this, source, recursive);

			if (source.background !== null) this.background = source.background.clone();
			if (source.environment !== null) this.environment = source.environment.clone();
			if (source.fog !== null) this.fog = source.fog.clone();

			this.backgroundBlurriness = source.backgroundBlurriness;
			this.backgroundIntensity = source.backgroundIntensity;

			if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();

			this.matrixAutoUpdate = source.matrixAutoUpdate;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Scene.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Scene.prototype), 'toJSON', this).call(this, meta);

			if (this.fog !== null) data.object.fog = this.fog.toJSON();
			if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
			if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;

			return data;
		}
	}, {
		key: 'autoUpdate',
		get: function get() {
			// @deprecated, r144

			console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
			return this.matrixWorldAutoUpdate;
		},
		set: function set(value) {
			// @deprecated, r144

			console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
			this.matrixWorldAutoUpdate = value;
		}
	}]);

	return Scene;
}(Object3D);

var InterleavedBuffer = function () {
	function InterleavedBuffer(array, stride) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InterleavedBuffer);

		this.isInterleavedBuffer = true;

		this.array = array;
		this.stride = stride;
		this.count = array !== undefined ? array.length / stride : 0;

		this.usage = StaticDrawUsage;
		this.updateRange = { offset: 0, count: -1 };

		this.version = 0;

		this.uuid = generateUUID();
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InterleavedBuffer, [{
		key: 'onUploadCallback',
		value: function onUploadCallback() {}
	}, {
		key: 'setUsage',
		value: function setUsage(value) {

			this.usage = value;

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.array = new source.array.constructor(source.array);
			this.count = source.count;
			this.stride = source.stride;
			this.usage = source.usage;

			return this;
		}
	}, {
		key: 'copyAt',
		value: function copyAt(index1, attribute, index2) {

			index1 *= this.stride;
			index2 *= attribute.stride;

			for (var i = 0, l = this.stride; i < l; i++) {

				this.array[index1 + i] = attribute.array[index2 + i];
			}

			return this;
		}
	}, {
		key: 'set',
		value: function set(value) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			this.array.set(value, offset);

			return this;
		}
	}, {
		key: 'clone',
		value: function clone(data) {

			if (data.arrayBuffers === undefined) {

				data.arrayBuffers = {};
			}

			if (this.array.buffer._uuid === undefined) {

				this.array.buffer._uuid = generateUUID();
			}

			if (data.arrayBuffers[this.array.buffer._uuid] === undefined) {

				data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
			}

			var array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);

			var ib = new this.constructor(array, this.stride);
			ib.setUsage(this.usage);

			return ib;
		}
	}, {
		key: 'onUpload',
		value: function onUpload(callback) {

			this.onUploadCallback = callback;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(data) {

			if (data.arrayBuffers === undefined) {

				data.arrayBuffers = {};
			}

			// generate UUID for array buffer if necessary

			if (this.array.buffer._uuid === undefined) {

				this.array.buffer._uuid = generateUUID();
			}

			if (data.arrayBuffers[this.array.buffer._uuid] === undefined) {

				data.arrayBuffers[this.array.buffer._uuid] = __WEBPACK_IMPORTED_MODULE_22_babel_runtime_core_js_array_from___default()(new Uint32Array(this.array.buffer));
			}

			//

			return {
				uuid: this.uuid,
				buffer: this.array.buffer._uuid,
				type: this.array.constructor.name,
				stride: this.stride
			};
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) this.version++;
		}
	}]);

	return InterleavedBuffer;
}();

var _vector$5 = /*@__PURE__*/new Vector3();

var InterleavedBufferAttribute = function () {
	function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset) {
		var normalized = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InterleavedBufferAttribute);

		this.isInterleavedBufferAttribute = true;

		this.name = '';

		this.data = interleavedBuffer;
		this.itemSize = itemSize;
		this.offset = offset;

		this.normalized = normalized;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InterleavedBufferAttribute, [{
		key: 'applyMatrix4',
		value: function applyMatrix4(m) {

			for (var i = 0, l = this.data.count; i < l; i++) {

				_vector$5.fromBufferAttribute(this, i);

				_vector$5.applyMatrix4(m);

				this.setXYZ(i, _vector$5.x, _vector$5.y, _vector$5.z);
			}

			return this;
		}
	}, {
		key: 'applyNormalMatrix',
		value: function applyNormalMatrix(m) {

			for (var i = 0, l = this.count; i < l; i++) {

				_vector$5.fromBufferAttribute(this, i);

				_vector$5.applyNormalMatrix(m);

				this.setXYZ(i, _vector$5.x, _vector$5.y, _vector$5.z);
			}

			return this;
		}
	}, {
		key: 'transformDirection',
		value: function transformDirection(m) {

			for (var i = 0, l = this.count; i < l; i++) {

				_vector$5.fromBufferAttribute(this, i);

				_vector$5.transformDirection(m);

				this.setXYZ(i, _vector$5.x, _vector$5.y, _vector$5.z);
			}

			return this;
		}
	}, {
		key: 'setX',
		value: function setX(index, x) {

			if (this.normalized) x = normalize(x, this.array);

			this.data.array[index * this.data.stride + this.offset] = x;

			return this;
		}
	}, {
		key: 'setY',
		value: function setY(index, y) {

			if (this.normalized) y = normalize(y, this.array);

			this.data.array[index * this.data.stride + this.offset + 1] = y;

			return this;
		}
	}, {
		key: 'setZ',
		value: function setZ(index, z) {

			if (this.normalized) z = normalize(z, this.array);

			this.data.array[index * this.data.stride + this.offset + 2] = z;

			return this;
		}
	}, {
		key: 'setW',
		value: function setW(index, w) {

			if (this.normalized) w = normalize(w, this.array);

			this.data.array[index * this.data.stride + this.offset + 3] = w;

			return this;
		}
	}, {
		key: 'getX',
		value: function getX(index) {

			var x = this.data.array[index * this.data.stride + this.offset];

			if (this.normalized) x = denormalize(x, this.array);

			return x;
		}
	}, {
		key: 'getY',
		value: function getY(index) {

			var y = this.data.array[index * this.data.stride + this.offset + 1];

			if (this.normalized) y = denormalize(y, this.array);

			return y;
		}
	}, {
		key: 'getZ',
		value: function getZ(index) {

			var z = this.data.array[index * this.data.stride + this.offset + 2];

			if (this.normalized) z = denormalize(z, this.array);

			return z;
		}
	}, {
		key: 'getW',
		value: function getW(index) {

			var w = this.data.array[index * this.data.stride + this.offset + 3];

			if (this.normalized) w = denormalize(w, this.array);

			return w;
		}
	}, {
		key: 'setXY',
		value: function setXY(index, x, y) {

			index = index * this.data.stride + this.offset;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
			}

			this.data.array[index + 0] = x;
			this.data.array[index + 1] = y;

			return this;
		}
	}, {
		key: 'setXYZ',
		value: function setXYZ(index, x, y, z) {

			index = index * this.data.stride + this.offset;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
			}

			this.data.array[index + 0] = x;
			this.data.array[index + 1] = y;
			this.data.array[index + 2] = z;

			return this;
		}
	}, {
		key: 'setXYZW',
		value: function setXYZW(index, x, y, z, w) {

			index = index * this.data.stride + this.offset;

			if (this.normalized) {

				x = normalize(x, this.array);
				y = normalize(y, this.array);
				z = normalize(z, this.array);
				w = normalize(w, this.array);
			}

			this.data.array[index + 0] = x;
			this.data.array[index + 1] = y;
			this.data.array[index + 2] = z;
			this.data.array[index + 3] = w;

			return this;
		}
	}, {
		key: 'clone',
		value: function clone(data) {

			if (data === undefined) {

				console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');

				var array = [];

				for (var i = 0; i < this.count; i++) {

					var index = i * this.data.stride + this.offset;

					for (var j = 0; j < this.itemSize; j++) {

						array.push(this.data.array[index + j]);
					}
				}

				return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
			} else {

				if (data.interleavedBuffers === undefined) {

					data.interleavedBuffers = {};
				}

				if (data.interleavedBuffers[this.data.uuid] === undefined) {

					data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
				}

				return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
			}
		}
	}, {
		key: 'toJSON',
		value: function toJSON(data) {

			if (data === undefined) {

				console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');

				var array = [];

				for (var i = 0; i < this.count; i++) {

					var index = i * this.data.stride + this.offset;

					for (var j = 0; j < this.itemSize; j++) {

						array.push(this.data.array[index + j]);
					}
				}

				// de-interleave data and save it as an ordinary buffer attribute for now

				return {
					itemSize: this.itemSize,
					type: this.array.constructor.name,
					array: array,
					normalized: this.normalized
				};
			} else {

				// save as true interleaved attribute

				if (data.interleavedBuffers === undefined) {

					data.interleavedBuffers = {};
				}

				if (data.interleavedBuffers[this.data.uuid] === undefined) {

					data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
				}

				return {
					isInterleavedBufferAttribute: true,
					itemSize: this.itemSize,
					data: this.data.uuid,
					offset: this.offset,
					normalized: this.normalized
				};
			}
		}
	}, {
		key: 'count',
		get: function get() {

			return this.data.count;
		}
	}, {
		key: 'array',
		get: function get() {

			return this.data.array;
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			this.data.needsUpdate = value;
		}
	}]);

	return InterleavedBufferAttribute;
}();

var SpriteMaterial = function (_Material5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SpriteMaterial, _Material5);

	function SpriteMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SpriteMaterial);

		var _this41 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpriteMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpriteMaterial)).call(this));

		_this41.isSpriteMaterial = true;

		_this41.type = 'SpriteMaterial';

		_this41.color = new Color(0xffffff);

		_this41.map = null;

		_this41.alphaMap = null;

		_this41.rotation = 0;

		_this41.sizeAttenuation = true;

		_this41.transparent = true;

		_this41.fog = true;

		_this41.setValues(parameters);

		return _this41;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SpriteMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SpriteMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpriteMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;

			this.alphaMap = source.alphaMap;

			this.rotation = source.rotation;

			this.sizeAttenuation = source.sizeAttenuation;

			this.fog = source.fog;

			return this;
		}
	}]);

	return SpriteMaterial;
}(Material);

var _geometry = void 0;

var _intersectPoint = /*@__PURE__*/new Vector3();
var _worldScale = /*@__PURE__*/new Vector3();
var _mvPosition = /*@__PURE__*/new Vector3();

var _alignedPosition = /*@__PURE__*/new Vector2();
var _rotatedPosition = /*@__PURE__*/new Vector2();
var _viewWorldMatrix = /*@__PURE__*/new Matrix4();

var _vA = /*@__PURE__*/new Vector3();
var _vB = /*@__PURE__*/new Vector3();
var _vC = /*@__PURE__*/new Vector3();

var _uvA = /*@__PURE__*/new Vector2();
var _uvB = /*@__PURE__*/new Vector2();
var _uvC = /*@__PURE__*/new Vector2();

var Sprite = function (_Object3D6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Sprite, _Object3D6);

	function Sprite(material) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Sprite);

		var _this42 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Sprite.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Sprite)).call(this));

		_this42.isSprite = true;

		_this42.type = 'Sprite';

		if (_geometry === undefined) {

			_geometry = new BufferGeometry();

			var float32Array = new Float32Array([-0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1, -0.5, 0.5, 0, 0, 1]);

			var interleavedBuffer = new InterleavedBuffer(float32Array, 5);

			_geometry.setIndex([0, 1, 2, 0, 2, 3]);
			_geometry.setAttribute('position', new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
			_geometry.setAttribute('uv', new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
		}

		_this42.geometry = _geometry;
		_this42.material = material !== undefined ? material : new SpriteMaterial();

		_this42.center = new Vector2(0.5, 0.5);

		return _this42;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Sprite, [{
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			if (raycaster.camera === null) {

				console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
			}

			_worldScale.setFromMatrixScale(this.matrixWorld);

			_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
			this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);

			_mvPosition.setFromMatrixPosition(this.modelViewMatrix);

			if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {

				_worldScale.multiplyScalar(-_mvPosition.z);
			}

			var rotation = this.material.rotation;
			var sin = void 0,
			    cos = void 0;

			if (rotation !== 0) {

				cos = Math.cos(rotation);
				sin = Math.sin(rotation);
			}

			var center = this.center;

			transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
			transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
			transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);

			_uvA.set(0, 0);
			_uvB.set(1, 0);
			_uvC.set(1, 1);

			// check first triangle
			var intersect = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);

			if (intersect === null) {

				// check second triangle
				transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
				_uvB.set(0, 1);

				intersect = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
				if (intersect === null) {

					return;
				}
			}

			var distance = raycaster.ray.origin.distanceTo(_intersectPoint);

			if (distance < raycaster.near || distance > raycaster.far) return;

			intersects.push({

				distance: distance,
				point: _intersectPoint.clone(),
				uv: Triangle.getInterpolation(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2()),
				face: null,
				object: this

			});
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Sprite.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Sprite.prototype), 'copy', this).call(this, source, recursive);

			if (source.center !== undefined) this.center.copy(source.center);

			this.material = source.material;

			return this;
		}
	}]);

	return Sprite;
}(Object3D);

function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {

	// compute position in camera space
	_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);

	// to check if rotation is not zero
	if (sin !== undefined) {

		_rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
		_rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
	} else {

		_rotatedPosition.copy(_alignedPosition);
	}

	vertexPosition.copy(mvPosition);
	vertexPosition.x += _rotatedPosition.x;
	vertexPosition.y += _rotatedPosition.y;

	// transform to world space
	vertexPosition.applyMatrix4(_viewWorldMatrix);
}

var _v1$2 = /*@__PURE__*/new Vector3();
var _v2$1 = /*@__PURE__*/new Vector3();

var LOD = function (_Object3D7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LOD, _Object3D7);

	function LOD() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LOD);

		var _this43 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LOD.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LOD)).call(this));

		_this43._currentLevel = 0;

		_this43.type = 'LOD';

		__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_object_define_properties___default()(_this43, {
			levels: {
				enumerable: true,
				value: []
			},
			isLOD: {
				value: true
			}
		});

		_this43.autoUpdate = true;

		return _this43;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LOD, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LOD.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LOD.prototype), 'copy', this).call(this, source, false);

			var levels = source.levels;

			for (var i = 0, l = levels.length; i < l; i++) {

				var level = levels[i];

				this.addLevel(level.object.clone(), level.distance, level.hysteresis);
			}

			this.autoUpdate = source.autoUpdate;

			return this;
		}
	}, {
		key: 'addLevel',
		value: function addLevel(object) {
			var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
			var hysteresis = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


			distance = Math.abs(distance);

			var levels = this.levels;

			var l = void 0;

			for (l = 0; l < levels.length; l++) {

				if (distance < levels[l].distance) {

					break;
				}
			}

			levels.splice(l, 0, { distance: distance, hysteresis: hysteresis, object: object });

			this.add(object);

			return this;
		}
	}, {
		key: 'getCurrentLevel',
		value: function getCurrentLevel() {

			return this._currentLevel;
		}
	}, {
		key: 'getObjectForDistance',
		value: function getObjectForDistance(distance) {

			var levels = this.levels;

			if (levels.length > 0) {

				var i = void 0,
				    l = void 0;

				for (i = 1, l = levels.length; i < l; i++) {

					var levelDistance = levels[i].distance;

					if (levels[i].object.visible) {

						levelDistance -= levelDistance * levels[i].hysteresis;
					}

					if (distance < levelDistance) {

						break;
					}
				}

				return levels[i - 1].object;
			}

			return null;
		}
	}, {
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			var levels = this.levels;

			if (levels.length > 0) {

				_v1$2.setFromMatrixPosition(this.matrixWorld);

				var distance = raycaster.ray.origin.distanceTo(_v1$2);

				this.getObjectForDistance(distance).raycast(raycaster, intersects);
			}
		}
	}, {
		key: 'update',
		value: function update(camera) {

			var levels = this.levels;

			if (levels.length > 1) {

				_v1$2.setFromMatrixPosition(camera.matrixWorld);
				_v2$1.setFromMatrixPosition(this.matrixWorld);

				var distance = _v1$2.distanceTo(_v2$1) / camera.zoom;

				levels[0].object.visible = true;

				var i = void 0,
				    l = void 0;

				for (i = 1, l = levels.length; i < l; i++) {

					var levelDistance = levels[i].distance;

					if (levels[i].object.visible) {

						levelDistance -= levelDistance * levels[i].hysteresis;
					}

					if (distance >= levelDistance) {

						levels[i - 1].object.visible = false;
						levels[i].object.visible = true;
					} else {

						break;
					}
				}

				this._currentLevel = i - 1;

				for (; i < l; i++) {

					levels[i].object.visible = false;
				}
			}
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LOD.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LOD.prototype), 'toJSON', this).call(this, meta);

			if (this.autoUpdate === false) data.object.autoUpdate = false;

			data.object.levels = [];

			var levels = this.levels;

			for (var i = 0, l = levels.length; i < l; i++) {

				var level = levels[i];

				data.object.levels.push({
					object: level.object.uuid,
					distance: level.distance,
					hysteresis: level.hysteresis
				});
			}

			return data;
		}
	}]);

	return LOD;
}(Object3D);

var _basePosition = /*@__PURE__*/new Vector3();

var _skinIndex = /*@__PURE__*/new Vector4();
var _skinWeight = /*@__PURE__*/new Vector4();

var _vector3 = /*@__PURE__*/new Vector3();
var _matrix4 = /*@__PURE__*/new Matrix4();
var _vertex = /*@__PURE__*/new Vector3();

var SkinnedMesh = function (_Mesh) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SkinnedMesh, _Mesh);

	function SkinnedMesh(geometry, material) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SkinnedMesh);

		var _this44 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkinnedMesh.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SkinnedMesh)).call(this, geometry, material));

		_this44.isSkinnedMesh = true;

		_this44.type = 'SkinnedMesh';

		_this44.bindMode = 'attached';
		_this44.bindMatrix = new Matrix4();
		_this44.bindMatrixInverse = new Matrix4();

		_this44.boundingBox = null;
		_this44.boundingSphere = null;

		return _this44;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SkinnedMesh, [{
		key: 'computeBoundingBox',
		value: function computeBoundingBox() {

			var geometry = this.geometry;

			if (this.boundingBox === null) {

				this.boundingBox = new Box3();
			}

			this.boundingBox.makeEmpty();

			var positionAttribute = geometry.getAttribute('position');

			for (var i = 0; i < positionAttribute.count; i++) {

				_vertex.fromBufferAttribute(positionAttribute, i);
				this.applyBoneTransform(i, _vertex);
				this.boundingBox.expandByPoint(_vertex);
			}
		}
	}, {
		key: 'computeBoundingSphere',
		value: function computeBoundingSphere() {

			var geometry = this.geometry;

			if (this.boundingSphere === null) {

				this.boundingSphere = new Sphere();
			}

			this.boundingSphere.makeEmpty();

			var positionAttribute = geometry.getAttribute('position');

			for (var i = 0; i < positionAttribute.count; i++) {

				_vertex.fromBufferAttribute(positionAttribute, i);
				this.applyBoneTransform(i, _vertex);
				this.boundingSphere.expandByPoint(_vertex);
			}
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SkinnedMesh.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SkinnedMesh.prototype), 'copy', this).call(this, source, recursive);

			this.bindMode = source.bindMode;
			this.bindMatrix.copy(source.bindMatrix);
			this.bindMatrixInverse.copy(source.bindMatrixInverse);

			this.skeleton = source.skeleton;

			return this;
		}
	}, {
		key: 'bind',
		value: function bind(skeleton, bindMatrix) {

			this.skeleton = skeleton;

			if (bindMatrix === undefined) {

				this.updateMatrixWorld(true);

				this.skeleton.calculateInverses();

				bindMatrix = this.matrixWorld;
			}

			this.bindMatrix.copy(bindMatrix);
			this.bindMatrixInverse.copy(bindMatrix).invert();
		}
	}, {
		key: 'pose',
		value: function pose() {

			this.skeleton.pose();
		}
	}, {
		key: 'normalizeSkinWeights',
		value: function normalizeSkinWeights() {

			var vector = new Vector4();

			var skinWeight = this.geometry.attributes.skinWeight;

			for (var i = 0, l = skinWeight.count; i < l; i++) {

				vector.fromBufferAttribute(skinWeight, i);

				var scale = 1.0 / vector.manhattanLength();

				if (scale !== Infinity) {

					vector.multiplyScalar(scale);
				} else {

					vector.set(1, 0, 0, 0); // do something reasonable
				}

				skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
			}
		}
	}, {
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SkinnedMesh.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SkinnedMesh.prototype), 'updateMatrixWorld', this).call(this, force);

			if (this.bindMode === 'attached') {

				this.bindMatrixInverse.copy(this.matrixWorld).invert();
			} else if (this.bindMode === 'detached') {

				this.bindMatrixInverse.copy(this.bindMatrix).invert();
			} else {

				console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
			}
		}
	}, {
		key: 'applyBoneTransform',
		value: function applyBoneTransform(index, vector) {

			var skeleton = this.skeleton;
			var geometry = this.geometry;

			_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
			_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);

			_basePosition.copy(vector).applyMatrix4(this.bindMatrix);

			vector.set(0, 0, 0);

			for (var i = 0; i < 4; i++) {

				var weight = _skinWeight.getComponent(i);

				if (weight !== 0) {

					var boneIndex = _skinIndex.getComponent(i);

					_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);

					vector.addScaledVector(_vector3.copy(_basePosition).applyMatrix4(_matrix4), weight);
				}
			}

			return vector.applyMatrix4(this.bindMatrixInverse);
		}
	}, {
		key: 'boneTransform',
		value: function boneTransform(index, vector) {
			// @deprecated, r151

			console.warn('THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151.');
			return this.applyBoneTransform(index, vector);
		}
	}]);

	return SkinnedMesh;
}(Mesh);

var Bone = function (_Object3D8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Bone, _Object3D8);

	function Bone() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Bone);

		var _this45 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Bone.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Bone)).call(this));

		_this45.isBone = true;

		_this45.type = 'Bone';

		return _this45;
	}

	return Bone;
}(Object3D);

var DataTexture = function (_Texture5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DataTexture, _Texture5);

	function DataTexture() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var format = arguments[3];
		var type = arguments[4];
		var mapping = arguments[5];
		var wrapS = arguments[6];
		var wrapT = arguments[7];
		var magFilter = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : NearestFilter;
		var minFilter = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : NearestFilter;
		var anisotropy = arguments[10];
		var encoding = arguments[11];

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DataTexture);

		var _this46 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DataTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DataTexture)).call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding));

		_this46.isDataTexture = true;

		_this46.image = { data: data, width: width, height: height };

		_this46.generateMipmaps = false;
		_this46.flipY = false;
		_this46.unpackAlignment = 1;

		return _this46;
	}

	return DataTexture;
}(Texture);

var _offsetMatrix = /*@__PURE__*/new Matrix4();
var _identityMatrix = /*@__PURE__*/new Matrix4();

var Skeleton = function () {
	function Skeleton() {
		var bones = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var boneInverses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Skeleton);

		this.uuid = generateUUID();

		this.bones = bones.slice(0);
		this.boneInverses = boneInverses;
		this.boneMatrices = null;

		this.boneTexture = null;
		this.boneTextureSize = 0;

		this.frame = -1;

		this.init();
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Skeleton, [{
		key: 'init',
		value: function init() {

			var bones = this.bones;
			var boneInverses = this.boneInverses;

			this.boneMatrices = new Float32Array(bones.length * 16);

			// calculate inverse bone matrices if necessary

			if (boneInverses.length === 0) {

				this.calculateInverses();
			} else {

				// handle special case

				if (bones.length !== boneInverses.length) {

					console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');

					this.boneInverses = [];

					for (var i = 0, il = this.bones.length; i < il; i++) {

						this.boneInverses.push(new Matrix4());
					}
				}
			}
		}
	}, {
		key: 'calculateInverses',
		value: function calculateInverses() {

			this.boneInverses.length = 0;

			for (var i = 0, il = this.bones.length; i < il; i++) {

				var inverse = new Matrix4();

				if (this.bones[i]) {

					inverse.copy(this.bones[i].matrixWorld).invert();
				}

				this.boneInverses.push(inverse);
			}
		}
	}, {
		key: 'pose',
		value: function pose() {

			// recover the bind-time world matrices

			for (var i = 0, il = this.bones.length; i < il; i++) {

				var bone = this.bones[i];

				if (bone) {

					bone.matrixWorld.copy(this.boneInverses[i]).invert();
				}
			}

			// compute the local matrices, positions, rotations and scales

			for (var _i59 = 0, _il13 = this.bones.length; _i59 < _il13; _i59++) {

				var _bone = this.bones[_i59];

				if (_bone) {

					if (_bone.parent && _bone.parent.isBone) {

						_bone.matrix.copy(_bone.parent.matrixWorld).invert();
						_bone.matrix.multiply(_bone.matrixWorld);
					} else {

						_bone.matrix.copy(_bone.matrixWorld);
					}

					_bone.matrix.decompose(_bone.position, _bone.quaternion, _bone.scale);
				}
			}
		}
	}, {
		key: 'update',
		value: function update() {

			var bones = this.bones;
			var boneInverses = this.boneInverses;
			var boneMatrices = this.boneMatrices;
			var boneTexture = this.boneTexture;

			// flatten bone matrices to array

			for (var i = 0, il = bones.length; i < il; i++) {

				// compute the offset between the current and the original transform

				var matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;

				_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
				_offsetMatrix.toArray(boneMatrices, i * 16);
			}

			if (boneTexture !== null) {

				boneTexture.needsUpdate = true;
			}
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new Skeleton(this.bones, this.boneInverses);
		}
	}, {
		key: 'computeBoneTexture',
		value: function computeBoneTexture() {

			// layout (1 matrix = 4 pixels)
			//      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
			//  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
			//       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
			//       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
			//       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)

			var size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
			size = ceilPowerOfTwo(size);
			size = Math.max(size, 4);

			var boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
			boneMatrices.set(this.boneMatrices); // copy current values

			var boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
			boneTexture.needsUpdate = true;

			this.boneMatrices = boneMatrices;
			this.boneTexture = boneTexture;
			this.boneTextureSize = size;

			return this;
		}
	}, {
		key: 'getBoneByName',
		value: function getBoneByName(name) {

			for (var i = 0, il = this.bones.length; i < il; i++) {

				var bone = this.bones[i];

				if (bone.name === name) {

					return bone;
				}
			}

			return undefined;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			if (this.boneTexture !== null) {

				this.boneTexture.dispose();

				this.boneTexture = null;
			}
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json, bones) {

			this.uuid = json.uuid;

			for (var i = 0, l = json.bones.length; i < l; i++) {

				var uuid = json.bones[i];
				var bone = bones[uuid];

				if (bone === undefined) {

					console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
					bone = new Bone();
				}

				this.bones.push(bone);
				this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i]));
			}

			this.init();

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = {
				metadata: {
					version: 4.5,
					type: 'Skeleton',
					generator: 'Skeleton.toJSON'
				},
				bones: [],
				boneInverses: []
			};

			data.uuid = this.uuid;

			var bones = this.bones;
			var boneInverses = this.boneInverses;

			for (var i = 0, l = bones.length; i < l; i++) {

				var bone = bones[i];
				data.bones.push(bone.uuid);

				var boneInverse = boneInverses[i];
				data.boneInverses.push(boneInverse.toArray());
			}

			return data;
		}
	}]);

	return Skeleton;
}();

var InstancedBufferAttribute = function (_BufferAttribute11) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(InstancedBufferAttribute, _BufferAttribute11);

	function InstancedBufferAttribute(array, itemSize, normalized) {
		var meshPerAttribute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InstancedBufferAttribute);

		var _this47 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InstancedBufferAttribute.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferAttribute)).call(this, array, itemSize, normalized));

		_this47.isInstancedBufferAttribute = true;

		_this47.meshPerAttribute = meshPerAttribute;

		return _this47;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InstancedBufferAttribute, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedBufferAttribute.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferAttribute.prototype), 'copy', this).call(this, source);

			this.meshPerAttribute = source.meshPerAttribute;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedBufferAttribute.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferAttribute.prototype), 'toJSON', this).call(this);

			data.meshPerAttribute = this.meshPerAttribute;

			data.isInstancedBufferAttribute = true;

			return data;
		}
	}]);

	return InstancedBufferAttribute;
}(BufferAttribute);

var _instanceLocalMatrix = /*@__PURE__*/new Matrix4();
var _instanceWorldMatrix = /*@__PURE__*/new Matrix4();

var _instanceIntersects = [];

var _box3 = /*@__PURE__*/new Box3();
var _identity = /*@__PURE__*/new Matrix4();
var _mesh = /*@__PURE__*/new Mesh();
var _sphere$2 = /*@__PURE__*/new Sphere();

var InstancedMesh = function (_Mesh2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(InstancedMesh, _Mesh2);

	function InstancedMesh(geometry, material, count) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InstancedMesh);

		var _this48 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InstancedMesh.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedMesh)).call(this, geometry, material));

		_this48.isInstancedMesh = true;

		_this48.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count * 16), 16);
		_this48.instanceColor = null;

		_this48.count = count;

		_this48.boundingBox = null;
		_this48.boundingSphere = null;

		for (var i = 0; i < count; i++) {

			_this48.setMatrixAt(i, _identity);
		}

		return _this48;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InstancedMesh, [{
		key: 'computeBoundingBox',
		value: function computeBoundingBox() {

			var geometry = this.geometry;
			var count = this.count;

			if (this.boundingBox === null) {

				this.boundingBox = new Box3();
			}

			if (geometry.boundingBox === null) {

				geometry.computeBoundingBox();
			}

			this.boundingBox.makeEmpty();

			for (var i = 0; i < count; i++) {

				this.getMatrixAt(i, _instanceLocalMatrix);

				_box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix);

				this.boundingBox.union(_box3);
			}
		}
	}, {
		key: 'computeBoundingSphere',
		value: function computeBoundingSphere() {

			var geometry = this.geometry;
			var count = this.count;

			if (this.boundingSphere === null) {

				this.boundingSphere = new Sphere();
			}

			if (geometry.boundingSphere === null) {

				geometry.computeBoundingSphere();
			}

			this.boundingSphere.makeEmpty();

			for (var i = 0; i < count; i++) {

				this.getMatrixAt(i, _instanceLocalMatrix);

				_sphere$2.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix);

				this.boundingSphere.union(_sphere$2);
			}
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedMesh.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedMesh.prototype), 'copy', this).call(this, source, recursive);

			this.instanceMatrix.copy(source.instanceMatrix);

			if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();

			this.count = source.count;

			return this;
		}
	}, {
		key: 'getColorAt',
		value: function getColorAt(index, color) {

			color.fromArray(this.instanceColor.array, index * 3);
		}
	}, {
		key: 'getMatrixAt',
		value: function getMatrixAt(index, matrix) {

			matrix.fromArray(this.instanceMatrix.array, index * 16);
		}
	}, {
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			var matrixWorld = this.matrixWorld;
			var raycastTimes = this.count;

			_mesh.geometry = this.geometry;
			_mesh.material = this.material;

			if (_mesh.material === undefined) return;

			// test with bounding sphere first

			if (this.boundingSphere === null) this.computeBoundingSphere();

			_sphere$2.copy(this.boundingSphere);
			_sphere$2.applyMatrix4(matrixWorld);

			if (raycaster.ray.intersectsSphere(_sphere$2) === false) return;

			// now test each instance

			for (var instanceId = 0; instanceId < raycastTimes; instanceId++) {

				// calculate the world matrix for each instance

				this.getMatrixAt(instanceId, _instanceLocalMatrix);

				_instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);

				// the mesh represents this single instance

				_mesh.matrixWorld = _instanceWorldMatrix;

				_mesh.raycast(raycaster, _instanceIntersects);

				// process the result of raycast

				for (var i = 0, l = _instanceIntersects.length; i < l; i++) {

					var intersect = _instanceIntersects[i];
					intersect.instanceId = instanceId;
					intersect.object = this;
					intersects.push(intersect);
				}

				_instanceIntersects.length = 0;
			}
		}
	}, {
		key: 'setColorAt',
		value: function setColorAt(index, color) {

			if (this.instanceColor === null) {

				this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3), 3);
			}

			color.toArray(this.instanceColor.array, index * 3);
		}
	}, {
		key: 'setMatrixAt',
		value: function setMatrixAt(index, matrix) {

			matrix.toArray(this.instanceMatrix.array, index * 16);
		}
	}, {
		key: 'updateMorphTargets',
		value: function updateMorphTargets() {}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });
		}
	}]);

	return InstancedMesh;
}(Mesh);

var LineBasicMaterial = function (_Material6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineBasicMaterial, _Material6);

	function LineBasicMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineBasicMaterial);

		var _this49 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineBasicMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineBasicMaterial)).call(this));

		_this49.isLineBasicMaterial = true;

		_this49.type = 'LineBasicMaterial';

		_this49.color = new Color(0xffffff);

		_this49.map = null;

		_this49.linewidth = 1;
		_this49.linecap = 'round';
		_this49.linejoin = 'round';

		_this49.fog = true;

		_this49.setValues(parameters);

		return _this49;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LineBasicMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineBasicMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineBasicMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;

			this.linewidth = source.linewidth;
			this.linecap = source.linecap;
			this.linejoin = source.linejoin;

			this.fog = source.fog;

			return this;
		}
	}]);

	return LineBasicMaterial;
}(Material);

var _start$1 = /*@__PURE__*/new Vector3();
var _end$1 = /*@__PURE__*/new Vector3();
var _inverseMatrix$1 = /*@__PURE__*/new Matrix4();
var _ray$1 = /*@__PURE__*/new Ray();
var _sphere$1 = /*@__PURE__*/new Sphere();

var Line = function (_Object3D9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Line, _Object3D9);

	function Line() {
		var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
		var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LineBasicMaterial();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Line);

		var _this50 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Line.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Line)).call(this));

		_this50.isLine = true;

		_this50.type = 'Line';

		_this50.geometry = geometry;
		_this50.material = material;

		_this50.updateMorphTargets();

		return _this50;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Line, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Line.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Line.prototype), 'copy', this).call(this, source, recursive);

			this.material = source.material;
			this.geometry = source.geometry;

			return this;
		}
	}, {
		key: 'computeLineDistances',
		value: function computeLineDistances() {

			var geometry = this.geometry;

			// we assume non-indexed geometry

			if (geometry.index === null) {

				var positionAttribute = geometry.attributes.position;
				var lineDistances = [0];

				for (var i = 1, l = positionAttribute.count; i < l; i++) {

					_start$1.fromBufferAttribute(positionAttribute, i - 1);
					_end$1.fromBufferAttribute(positionAttribute, i);

					lineDistances[i] = lineDistances[i - 1];
					lineDistances[i] += _start$1.distanceTo(_end$1);
				}

				geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
			} else {

				console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
			}

			return this;
		}
	}, {
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;
			var threshold = raycaster.params.Line.threshold;
			var drawRange = geometry.drawRange;

			// Checking boundingSphere distance to ray

			if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

			_sphere$1.copy(geometry.boundingSphere);
			_sphere$1.applyMatrix4(matrixWorld);
			_sphere$1.radius += threshold;

			if (raycaster.ray.intersectsSphere(_sphere$1) === false) return;

			//

			_inverseMatrix$1.copy(matrixWorld).invert();
			_ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);

			var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
			var localThresholdSq = localThreshold * localThreshold;

			var vStart = new Vector3();
			var vEnd = new Vector3();
			var interSegment = new Vector3();
			var interRay = new Vector3();
			var step = this.isLineSegments ? 2 : 1;

			var index = geometry.index;
			var attributes = geometry.attributes;
			var positionAttribute = attributes.position;

			if (index !== null) {

				var start = Math.max(0, drawRange.start);
				var end = Math.min(index.count, drawRange.start + drawRange.count);

				for (var i = start, l = end - 1; i < l; i += step) {

					var a = index.getX(i);
					var b = index.getX(i + 1);

					vStart.fromBufferAttribute(positionAttribute, a);
					vEnd.fromBufferAttribute(positionAttribute, b);

					var distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

					if (distSq > localThresholdSq) continue;

					interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation

					var distance = raycaster.ray.origin.distanceTo(interRay);

					if (distance < raycaster.near || distance > raycaster.far) continue;

					intersects.push({

						distance: distance,
						// What do we want? intersection point on the ray or on the segment??
						// point: raycaster.ray.at( distance ),
						point: interSegment.clone().applyMatrix4(this.matrixWorld),
						index: i,
						face: null,
						faceIndex: null,
						object: this

					});
				}
			} else {

				var _start6 = Math.max(0, drawRange.start);
				var _end5 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);

				for (var _i60 = _start6, _l7 = _end5 - 1; _i60 < _l7; _i60 += step) {

					vStart.fromBufferAttribute(positionAttribute, _i60);
					vEnd.fromBufferAttribute(positionAttribute, _i60 + 1);

					var _distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

					if (_distSq > localThresholdSq) continue;

					interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation

					var _distance = raycaster.ray.origin.distanceTo(interRay);

					if (_distance < raycaster.near || _distance > raycaster.far) continue;

					intersects.push({

						distance: _distance,
						// What do we want? intersection point on the ray or on the segment??
						// point: raycaster.ray.at( distance ),
						point: interSegment.clone().applyMatrix4(this.matrixWorld),
						index: _i60,
						face: null,
						faceIndex: null,
						object: this

					});
				}
			}
		}
	}, {
		key: 'updateMorphTargets',
		value: function updateMorphTargets() {

			var geometry = this.geometry;

			var morphAttributes = geometry.morphAttributes;
			var keys = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(morphAttributes);

			if (keys.length > 0) {

				var morphAttribute = morphAttributes[keys[0]];

				if (morphAttribute !== undefined) {

					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};

					for (var m = 0, ml = morphAttribute.length; m < ml; m++) {

						var name = morphAttribute[m].name || String(m);

						this.morphTargetInfluences.push(0);
						this.morphTargetDictionary[name] = m;
					}
				}
			}
		}
	}]);

	return Line;
}(Object3D);

var _start = /*@__PURE__*/new Vector3();
var _end = /*@__PURE__*/new Vector3();

var LineSegments = function (_Line) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineSegments, _Line);

	function LineSegments(geometry, material) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineSegments);

		var _this51 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineSegments.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineSegments)).call(this, geometry, material));

		_this51.isLineSegments = true;

		_this51.type = 'LineSegments';

		return _this51;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LineSegments, [{
		key: 'computeLineDistances',
		value: function computeLineDistances() {

			var geometry = this.geometry;

			// we assume non-indexed geometry

			if (geometry.index === null) {

				var positionAttribute = geometry.attributes.position;
				var lineDistances = [];

				for (var i = 0, l = positionAttribute.count; i < l; i += 2) {

					_start.fromBufferAttribute(positionAttribute, i);
					_end.fromBufferAttribute(positionAttribute, i + 1);

					lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
					lineDistances[i + 1] = lineDistances[i] + _start.distanceTo(_end);
				}

				geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
			} else {

				console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
			}

			return this;
		}
	}]);

	return LineSegments;
}(Line);

var LineLoop = function (_Line2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineLoop, _Line2);

	function LineLoop(geometry, material) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineLoop);

		var _this52 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineLoop.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineLoop)).call(this, geometry, material));

		_this52.isLineLoop = true;

		_this52.type = 'LineLoop';

		return _this52;
	}

	return LineLoop;
}(Line);

var PointsMaterial = function (_Material7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PointsMaterial, _Material7);

	function PointsMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PointsMaterial);

		var _this53 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PointsMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointsMaterial)).call(this));

		_this53.isPointsMaterial = true;

		_this53.type = 'PointsMaterial';

		_this53.color = new Color(0xffffff);

		_this53.map = null;

		_this53.alphaMap = null;

		_this53.size = 1;
		_this53.sizeAttenuation = true;

		_this53.fog = true;

		_this53.setValues(parameters);

		return _this53;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PointsMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PointsMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointsMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;

			this.alphaMap = source.alphaMap;

			this.size = source.size;
			this.sizeAttenuation = source.sizeAttenuation;

			this.fog = source.fog;

			return this;
		}
	}]);

	return PointsMaterial;
}(Material);

var _inverseMatrix = /*@__PURE__*/new Matrix4();
var _ray = /*@__PURE__*/new Ray();
var _sphere = /*@__PURE__*/new Sphere();
var _position$2 = /*@__PURE__*/new Vector3();

var Points = function (_Object3D10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Points, _Object3D10);

	function Points() {
		var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
		var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new PointsMaterial();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Points);

		var _this54 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Points.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Points)).call(this));

		_this54.isPoints = true;

		_this54.type = 'Points';

		_this54.geometry = geometry;
		_this54.material = material;

		_this54.updateMorphTargets();

		return _this54;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Points, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Points.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Points.prototype), 'copy', this).call(this, source, recursive);

			this.material = source.material;
			this.geometry = source.geometry;

			return this;
		}
	}, {
		key: 'raycast',
		value: function raycast(raycaster, intersects) {

			var geometry = this.geometry;
			var matrixWorld = this.matrixWorld;
			var threshold = raycaster.params.Points.threshold;
			var drawRange = geometry.drawRange;

			// Checking boundingSphere distance to ray

			if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

			_sphere.copy(geometry.boundingSphere);
			_sphere.applyMatrix4(matrixWorld);
			_sphere.radius += threshold;

			if (raycaster.ray.intersectsSphere(_sphere) === false) return;

			//

			_inverseMatrix.copy(matrixWorld).invert();
			_ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);

			var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
			var localThresholdSq = localThreshold * localThreshold;

			var index = geometry.index;
			var attributes = geometry.attributes;
			var positionAttribute = attributes.position;

			if (index !== null) {

				var start = Math.max(0, drawRange.start);
				var end = Math.min(index.count, drawRange.start + drawRange.count);

				for (var i = start, il = end; i < il; i++) {

					var a = index.getX(i);

					_position$2.fromBufferAttribute(positionAttribute, a);

					testPoint(_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
				}
			} else {

				var _start7 = Math.max(0, drawRange.start);
				var _end6 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);

				for (var _i61 = _start7, l = _end6; _i61 < l; _i61++) {

					_position$2.fromBufferAttribute(positionAttribute, _i61);

					testPoint(_position$2, _i61, localThresholdSq, matrixWorld, raycaster, intersects, this);
				}
			}
		}
	}, {
		key: 'updateMorphTargets',
		value: function updateMorphTargets() {

			var geometry = this.geometry;

			var morphAttributes = geometry.morphAttributes;
			var keys = __WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(morphAttributes);

			if (keys.length > 0) {

				var morphAttribute = morphAttributes[keys[0]];

				if (morphAttribute !== undefined) {

					this.morphTargetInfluences = [];
					this.morphTargetDictionary = {};

					for (var m = 0, ml = morphAttribute.length; m < ml; m++) {

						var name = morphAttribute[m].name || String(m);

						this.morphTargetInfluences.push(0);
						this.morphTargetDictionary[name] = m;
					}
				}
			}
		}
	}]);

	return Points;
}(Object3D);

function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {

	var rayPointDistanceSq = _ray.distanceSqToPoint(point);

	if (rayPointDistanceSq < localThresholdSq) {

		var intersectPoint = new Vector3();

		_ray.closestPointToPoint(point, intersectPoint);
		intersectPoint.applyMatrix4(matrixWorld);

		var distance = raycaster.ray.origin.distanceTo(intersectPoint);

		if (distance < raycaster.near || distance > raycaster.far) return;

		intersects.push({

			distance: distance,
			distanceToRay: Math.sqrt(rayPointDistanceSq),
			point: intersectPoint,
			index: index,
			face: null,
			object: object

		});
	}
}

var VideoTexture = function (_Texture6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(VideoTexture, _Texture6);

	function VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, VideoTexture);

		var _this55 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(VideoTexture)).call(this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy));

		_this55.isVideoTexture = true;

		_this55.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
		_this55.magFilter = magFilter !== undefined ? magFilter : LinearFilter;

		_this55.generateMipmaps = false;

		var scope = _this55;

		function updateVideo() {

			scope.needsUpdate = true;
			video.requestVideoFrameCallback(updateVideo);
		}

		if ('requestVideoFrameCallback' in video) {

			video.requestVideoFrameCallback(updateVideo);
		}

		return _this55;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(VideoTexture, [{
		key: 'clone',
		value: function clone() {

			return new this.constructor(this.image).copy(this);
		}
	}, {
		key: 'update',
		value: function update() {

			var video = this.image;
			var hasVideoFrameCallback = 'requestVideoFrameCallback' in video;

			if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {

				this.needsUpdate = true;
			}
		}
	}]);

	return VideoTexture;
}(Texture);

var FramebufferTexture = function (_Texture7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(FramebufferTexture, _Texture7);

	function FramebufferTexture(width, height, format) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, FramebufferTexture);

		var _this56 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FramebufferTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(FramebufferTexture)).call(this, { width: width, height: height }));

		_this56.isFramebufferTexture = true;

		_this56.format = format;

		_this56.magFilter = NearestFilter;
		_this56.minFilter = NearestFilter;

		_this56.generateMipmaps = false;

		_this56.needsUpdate = true;

		return _this56;
	}

	return FramebufferTexture;
}(Texture);

var CompressedTexture = function (_Texture8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CompressedTexture, _Texture8);

	function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CompressedTexture);

		var _this57 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompressedTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CompressedTexture)).call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding));

		_this57.isCompressedTexture = true;

		_this57.image = { width: width, height: height };
		_this57.mipmaps = mipmaps;

		// no flipping for cube textures
		// (also flipping doesn't work for compressed textures )

		_this57.flipY = false;

		// can't generate mipmaps for compressed textures
		// mips must be embedded in DDS files

		_this57.generateMipmaps = false;

		return _this57;
	}

	return CompressedTexture;
}(Texture);

var CompressedArrayTexture = function (_CompressedTexture) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CompressedArrayTexture, _CompressedTexture);

	function CompressedArrayTexture(mipmaps, width, height, depth, format, type) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CompressedArrayTexture);

		var _this58 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompressedArrayTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CompressedArrayTexture)).call(this, mipmaps, width, height, format, type));

		_this58.isCompressedArrayTexture = true;
		_this58.image.depth = depth;
		_this58.wrapR = ClampToEdgeWrapping;

		return _this58;
	}

	return CompressedArrayTexture;
}(CompressedTexture);

var CanvasTexture = function (_Texture9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CanvasTexture, _Texture9);

	function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CanvasTexture);

		var _this59 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CanvasTexture.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CanvasTexture)).call(this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy));

		_this59.isCanvasTexture = true;

		_this59.needsUpdate = true;

		return _this59;
	}

	return CanvasTexture;
}(Texture);

/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/

var Curve = function () {
	function Curve() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Curve);

		this.type = 'Curve';

		this.arcLengthDivisions = 200;
	}

	// Virtual base class method to overwrite and implement in subclasses
	//	- t [0 .. 1]

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Curve, [{
		key: 'getPoint',
		value: function getPoint() /* t, optionalTarget */{

			console.warn('THREE.Curve: .getPoint() not implemented.');
			return null;
		}

		// Get point at relative position in curve according to arc length
		// - u [0 .. 1]

	}, {
		key: 'getPointAt',
		value: function getPointAt(u, optionalTarget) {

			var t = this.getUtoTmapping(u);
			return this.getPoint(t, optionalTarget);
		}

		// Get sequence of points using getPoint( t )

	}, {
		key: 'getPoints',
		value: function getPoints() {
			var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;


			var points = [];

			for (var d = 0; d <= divisions; d++) {

				points.push(this.getPoint(d / divisions));
			}

			return points;
		}

		// Get sequence of points using getPointAt( u )

	}, {
		key: 'getSpacedPoints',
		value: function getSpacedPoints() {
			var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;


			var points = [];

			for (var d = 0; d <= divisions; d++) {

				points.push(this.getPointAt(d / divisions));
			}

			return points;
		}

		// Get total curve arc length

	}, {
		key: 'getLength',
		value: function getLength() {

			var lengths = this.getLengths();
			return lengths[lengths.length - 1];
		}

		// Get list of cumulative segment lengths

	}, {
		key: 'getLengths',
		value: function getLengths() {
			var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;


			if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {

				return this.cacheArcLengths;
			}

			this.needsUpdate = false;

			var cache = [];
			var current = void 0,
			    last = this.getPoint(0);
			var sum = 0;

			cache.push(0);

			for (var p = 1; p <= divisions; p++) {

				current = this.getPoint(p / divisions);
				sum += current.distanceTo(last);
				cache.push(sum);
				last = current;
			}

			this.cacheArcLengths = cache;

			return cache; // { sums: cache, sum: sum }; Sum is in the last element.
		}
	}, {
		key: 'updateArcLengths',
		value: function updateArcLengths() {

			this.needsUpdate = true;
			this.getLengths();
		}

		// Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

	}, {
		key: 'getUtoTmapping',
		value: function getUtoTmapping(u, distance) {

			var arcLengths = this.getLengths();

			var i = 0;
			var il = arcLengths.length;

			var targetArcLength = void 0; // The targeted u distance value to get

			if (distance) {

				targetArcLength = distance;
			} else {

				targetArcLength = u * arcLengths[il - 1];
			}

			// binary search for the index with largest value smaller than target u distance

			var low = 0,
			    high = il - 1,
			    comparison = void 0;

			while (low <= high) {

				i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

				comparison = arcLengths[i] - targetArcLength;

				if (comparison < 0) {

					low = i + 1;
				} else if (comparison > 0) {

					high = i - 1;
				} else {

					high = i;
					break;

					// DONE
				}
			}

			i = high;

			if (arcLengths[i] === targetArcLength) {

				return i / (il - 1);
			}

			// we could get finer grain at lengths, or use simple interpolation between two points

			var lengthBefore = arcLengths[i];
			var lengthAfter = arcLengths[i + 1];

			var segmentLength = lengthAfter - lengthBefore;

			// determine where we are between the 'before' and 'after' points

			var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;

			// add that fractional amount to t

			var t = (i + segmentFraction) / (il - 1);

			return t;
		}

		// Returns a unit vector tangent at t
		// In case any sub curve does not implement its tangent derivation,
		// 2 points a small delta apart will be used to find its gradient
		// which seems to give a reasonable approximation

	}, {
		key: 'getTangent',
		value: function getTangent(t, optionalTarget) {

			var delta = 0.0001;
			var t1 = t - delta;
			var t2 = t + delta;

			// Capping in case of danger

			if (t1 < 0) t1 = 0;
			if (t2 > 1) t2 = 1;

			var pt1 = this.getPoint(t1);
			var pt2 = this.getPoint(t2);

			var tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());

			tangent.copy(pt2).sub(pt1).normalize();

			return tangent;
		}
	}, {
		key: 'getTangentAt',
		value: function getTangentAt(u, optionalTarget) {

			var t = this.getUtoTmapping(u);
			return this.getTangent(t, optionalTarget);
		}
	}, {
		key: 'computeFrenetFrames',
		value: function computeFrenetFrames(segments, closed) {

			// see http://www.cs.indiana.edu/pub/techreports/TR425.pdf

			var normal = new Vector3();

			var tangents = [];
			var normals = [];
			var binormals = [];

			var vec = new Vector3();
			var mat = new Matrix4();

			// compute the tangent vectors for each segment on the curve

			for (var i = 0; i <= segments; i++) {

				var u = i / segments;

				tangents[i] = this.getTangentAt(u, new Vector3());
			}

			// select an initial normal vector perpendicular to the first tangent vector,
			// and in the direction of the minimum tangent xyz component

			normals[0] = new Vector3();
			binormals[0] = new Vector3();
			var min = Number.MAX_VALUE;
			var tx = Math.abs(tangents[0].x);
			var ty = Math.abs(tangents[0].y);
			var tz = Math.abs(tangents[0].z);

			if (tx <= min) {

				min = tx;
				normal.set(1, 0, 0);
			}

			if (ty <= min) {

				min = ty;
				normal.set(0, 1, 0);
			}

			if (tz <= min) {

				normal.set(0, 0, 1);
			}

			vec.crossVectors(tangents[0], normal).normalize();

			normals[0].crossVectors(tangents[0], vec);
			binormals[0].crossVectors(tangents[0], normals[0]);

			// compute the slowly-varying normal and binormal vectors for each segment on the curve

			for (var _i62 = 1; _i62 <= segments; _i62++) {

				normals[_i62] = normals[_i62 - 1].clone();

				binormals[_i62] = binormals[_i62 - 1].clone();

				vec.crossVectors(tangents[_i62 - 1], tangents[_i62]);

				if (vec.length() > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

					vec.normalize();

					var theta = Math.acos(clamp(tangents[_i62 - 1].dot(tangents[_i62]), -1, 1)); // clamp for floating pt errors

					normals[_i62].applyMatrix4(mat.makeRotationAxis(vec, theta));
				}

				binormals[_i62].crossVectors(tangents[_i62], normals[_i62]);
			}

			// if the curve is closed, postprocess the vectors so the first and last normal vectors are the same

			if (closed === true) {

				var _theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
				_theta /= segments;

				if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {

					_theta = -_theta;
				}

				for (var _i63 = 1; _i63 <= segments; _i63++) {

					// twist a little...
					normals[_i63].applyMatrix4(mat.makeRotationAxis(tangents[_i63], _theta * _i63));
					binormals[_i63].crossVectors(tangents[_i63], normals[_i63]);
				}
			}

			return {
				tangents: tangents,
				normals: normals,
				binormals: binormals
			};
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.arcLengthDivisions = source.arcLengthDivisions;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = {
				metadata: {
					version: 4.5,
					type: 'Curve',
					generator: 'Curve.toJSON'
				}
			};

			data.arcLengthDivisions = this.arcLengthDivisions;
			data.type = this.type;

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			this.arcLengthDivisions = json.arcLengthDivisions;

			return this;
		}
	}]);

	return Curve;
}();

var EllipseCurve = function (_Curve) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(EllipseCurve, _Curve);

	function EllipseCurve() {
		var aX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
		var aY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var xRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var yRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
		var aStartAngle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
		var aEndAngle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;
		var aClockwise = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
		var aRotation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, EllipseCurve);

		var _this60 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EllipseCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EllipseCurve)).call(this));

		_this60.isEllipseCurve = true;

		_this60.type = 'EllipseCurve';

		_this60.aX = aX;
		_this60.aY = aY;

		_this60.xRadius = xRadius;
		_this60.yRadius = yRadius;

		_this60.aStartAngle = aStartAngle;
		_this60.aEndAngle = aEndAngle;

		_this60.aClockwise = aClockwise;

		_this60.aRotation = aRotation;

		return _this60;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(EllipseCurve, [{
		key: 'getPoint',
		value: function getPoint(t, optionalTarget) {

			var point = optionalTarget || new Vector2();

			var twoPi = Math.PI * 2;
			var deltaAngle = this.aEndAngle - this.aStartAngle;
			var samePoints = Math.abs(deltaAngle) < __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a;

			// ensures that deltaAngle is 0 .. 2 PI
			while (deltaAngle < 0) {
				deltaAngle += twoPi;
			}while (deltaAngle > twoPi) {
				deltaAngle -= twoPi;
			}if (deltaAngle < __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

				if (samePoints) {

					deltaAngle = 0;
				} else {

					deltaAngle = twoPi;
				}
			}

			if (this.aClockwise === true && !samePoints) {

				if (deltaAngle === twoPi) {

					deltaAngle = -twoPi;
				} else {

					deltaAngle = deltaAngle - twoPi;
				}
			}

			var angle = this.aStartAngle + t * deltaAngle;
			var x = this.aX + this.xRadius * Math.cos(angle);
			var y = this.aY + this.yRadius * Math.sin(angle);

			if (this.aRotation !== 0) {

				var cos = Math.cos(this.aRotation);
				var sin = Math.sin(this.aRotation);

				var tx = x - this.aX;
				var ty = y - this.aY;

				// Rotate the point about the center of the ellipse.
				x = tx * cos - ty * sin + this.aX;
				y = tx * sin + ty * cos + this.aY;
			}

			return point.set(x, y);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(EllipseCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EllipseCurve.prototype), 'copy', this).call(this, source);

			this.aX = source.aX;
			this.aY = source.aY;

			this.xRadius = source.xRadius;
			this.yRadius = source.yRadius;

			this.aStartAngle = source.aStartAngle;
			this.aEndAngle = source.aEndAngle;

			this.aClockwise = source.aClockwise;

			this.aRotation = source.aRotation;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(EllipseCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EllipseCurve.prototype), 'toJSON', this).call(this);

			data.aX = this.aX;
			data.aY = this.aY;

			data.xRadius = this.xRadius;
			data.yRadius = this.yRadius;

			data.aStartAngle = this.aStartAngle;
			data.aEndAngle = this.aEndAngle;

			data.aClockwise = this.aClockwise;

			data.aRotation = this.aRotation;

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(EllipseCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EllipseCurve.prototype), 'fromJSON', this).call(this, json);

			this.aX = json.aX;
			this.aY = json.aY;

			this.xRadius = json.xRadius;
			this.yRadius = json.yRadius;

			this.aStartAngle = json.aStartAngle;
			this.aEndAngle = json.aEndAngle;

			this.aClockwise = json.aClockwise;

			this.aRotation = json.aRotation;

			return this;
		}
	}]);

	return EllipseCurve;
}(Curve);

var ArcCurve = function (_EllipseCurve) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ArcCurve, _EllipseCurve);

	function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ArcCurve);

		var _this61 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArcCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ArcCurve)).call(this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise));

		_this61.isArcCurve = true;

		_this61.type = 'ArcCurve';

		return _this61;
	}

	return ArcCurve;
}(EllipseCurve);

/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */

/*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/

function CubicPoly() {

	var c0 = 0,
	    c1 = 0,
	    c2 = 0,
	    c3 = 0;

	/*
  * Compute coefficients for a cubic polynomial
  *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
  * such that
  *   p(0) = x0, p(1) = x1
  *  and
  *   p'(0) = t0, p'(1) = t1.
  */
	function init(x0, x1, t0, t1) {

		c0 = x0;
		c1 = t0;
		c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
		c3 = 2 * x0 - 2 * x1 + t0 + t1;
	}

	return {

		initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {

			init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
		},

		initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {

			// compute tangents when parameterized in [t1,t2]
			var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
			var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;

			// rescale tangents for parametrization in [0,1]
			t1 *= dt1;
			t2 *= dt1;

			init(x1, x2, t1, t2);
		},

		calc: function calc(t) {

			var t2 = t * t;
			var t3 = t2 * t;
			return c0 + c1 * t + c2 * t2 + c3 * t3;
		}

	};
}

//

var tmp = /*@__PURE__*/new Vector3();
var px = /*@__PURE__*/new CubicPoly();
var py = /*@__PURE__*/new CubicPoly();
var pz = /*@__PURE__*/new CubicPoly();

var CatmullRomCurve3 = function (_Curve2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CatmullRomCurve3, _Curve2);

	function CatmullRomCurve3() {
		var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
		var curveType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'centripetal';
		var tension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CatmullRomCurve3);

		var _this62 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CatmullRomCurve3.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CatmullRomCurve3)).call(this));

		_this62.isCatmullRomCurve3 = true;

		_this62.type = 'CatmullRomCurve3';

		_this62.points = points;
		_this62.closed = closed;
		_this62.curveType = curveType;
		_this62.tension = tension;

		return _this62;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CatmullRomCurve3, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();


			var point = optionalTarget;

			var points = this.points;
			var l = points.length;

			var p = (l - (this.closed ? 0 : 1)) * t;
			var intPoint = Math.floor(p);
			var weight = p - intPoint;

			if (this.closed) {

				intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
			} else if (weight === 0 && intPoint === l - 1) {

				intPoint = l - 2;
				weight = 1;
			}

			var p0 = void 0,
			    p3 = void 0; // 4 points (p1 & p2 defined below)

			if (this.closed || intPoint > 0) {

				p0 = points[(intPoint - 1) % l];
			} else {

				// extrapolate first point
				tmp.subVectors(points[0], points[1]).add(points[0]);
				p0 = tmp;
			}

			var p1 = points[intPoint % l];
			var p2 = points[(intPoint + 1) % l];

			if (this.closed || intPoint + 2 < l) {

				p3 = points[(intPoint + 2) % l];
			} else {

				// extrapolate last point
				tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
				p3 = tmp;
			}

			if (this.curveType === 'centripetal' || this.curveType === 'chordal') {

				// init Centripetal / Chordal Catmull-Rom
				var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
				var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
				var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
				var dt2 = Math.pow(p2.distanceToSquared(p3), pow);

				// safety check for repeated points
				if (dt1 < 1e-4) dt1 = 1.0;
				if (dt0 < 1e-4) dt0 = dt1;
				if (dt2 < 1e-4) dt2 = dt1;

				px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
				py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
				pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
			} else if (this.curveType === 'catmullrom') {

				px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
				py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
				pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
			}

			point.set(px.calc(weight), py.calc(weight), pz.calc(weight));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CatmullRomCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CatmullRomCurve3.prototype), 'copy', this).call(this, source);

			this.points = [];

			for (var i = 0, l = source.points.length; i < l; i++) {

				var point = source.points[i];

				this.points.push(point.clone());
			}

			this.closed = source.closed;
			this.curveType = source.curveType;
			this.tension = source.tension;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CatmullRomCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CatmullRomCurve3.prototype), 'toJSON', this).call(this);

			data.points = [];

			for (var i = 0, l = this.points.length; i < l; i++) {

				var point = this.points[i];
				data.points.push(point.toArray());
			}

			data.closed = this.closed;
			data.curveType = this.curveType;
			data.tension = this.tension;

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CatmullRomCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CatmullRomCurve3.prototype), 'fromJSON', this).call(this, json);

			this.points = [];

			for (var i = 0, l = json.points.length; i < l; i++) {

				var point = json.points[i];
				this.points.push(new Vector3().fromArray(point));
			}

			this.closed = json.closed;
			this.curveType = json.curveType;
			this.tension = json.tension;

			return this;
		}
	}]);

	return CatmullRomCurve3;
}(Curve);

/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */

function CatmullRom(t, p0, p1, p2, p3) {

	var v0 = (p2 - p0) * 0.5;
	var v1 = (p3 - p1) * 0.5;
	var t2 = t * t;
	var t3 = t * t2;
	return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}

//

function QuadraticBezierP0(t, p) {

	var k = 1 - t;
	return k * k * p;
}

function QuadraticBezierP1(t, p) {

	return 2 * (1 - t) * t * p;
}

function QuadraticBezierP2(t, p) {

	return t * t * p;
}

function QuadraticBezier(t, p0, p1, p2) {

	return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
}

//

function CubicBezierP0(t, p) {

	var k = 1 - t;
	return k * k * k * p;
}

function CubicBezierP1(t, p) {

	var k = 1 - t;
	return 3 * k * k * t * p;
}

function CubicBezierP2(t, p) {

	return 3 * (1 - t) * t * t * p;
}

function CubicBezierP3(t, p) {

	return t * t * t * p;
}

function CubicBezier(t, p0, p1, p2, p3) {

	return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}

var CubicBezierCurve = function (_Curve3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubicBezierCurve, _Curve3);

	function CubicBezierCurve() {
		var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
		var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
		var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector2();
		var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Vector2();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubicBezierCurve);

		var _this63 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubicBezierCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve)).call(this));

		_this63.isCubicBezierCurve = true;

		_this63.type = 'CubicBezierCurve';

		_this63.v0 = v0;
		_this63.v1 = v1;
		_this63.v2 = v2;
		_this63.v3 = v3;

		return _this63;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubicBezierCurve, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();


			var point = optionalTarget;

			var v0 = this.v0,
			    v1 = this.v1,
			    v2 = this.v2,
			    v3 = this.v3;

			point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve.prototype), 'copy', this).call(this, source);

			this.v0.copy(source.v0);
			this.v1.copy(source.v1);
			this.v2.copy(source.v2);
			this.v3.copy(source.v3);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve.prototype), 'toJSON', this).call(this);

			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
			data.v3 = this.v3.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve.prototype), 'fromJSON', this).call(this, json);

			this.v0.fromArray(json.v0);
			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);
			this.v3.fromArray(json.v3);

			return this;
		}
	}]);

	return CubicBezierCurve;
}(Curve);

var CubicBezierCurve3 = function (_Curve4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubicBezierCurve3, _Curve4);

	function CubicBezierCurve3() {
		var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
		var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();
		var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Vector3();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubicBezierCurve3);

		var _this64 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubicBezierCurve3.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve3)).call(this));

		_this64.isCubicBezierCurve3 = true;

		_this64.type = 'CubicBezierCurve3';

		_this64.v0 = v0;
		_this64.v1 = v1;
		_this64.v2 = v2;
		_this64.v3 = v3;

		return _this64;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubicBezierCurve3, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();


			var point = optionalTarget;

			var v0 = this.v0,
			    v1 = this.v1,
			    v2 = this.v2,
			    v3 = this.v3;

			point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve3.prototype), 'copy', this).call(this, source);

			this.v0.copy(source.v0);
			this.v1.copy(source.v1);
			this.v2.copy(source.v2);
			this.v3.copy(source.v3);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve3.prototype), 'toJSON', this).call(this);

			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();
			data.v3 = this.v3.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CubicBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicBezierCurve3.prototype), 'fromJSON', this).call(this, json);

			this.v0.fromArray(json.v0);
			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);
			this.v3.fromArray(json.v3);

			return this;
		}
	}]);

	return CubicBezierCurve3;
}(Curve);

var LineCurve = function (_Curve5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineCurve, _Curve5);

	function LineCurve() {
		var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
		var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineCurve);

		var _this65 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve)).call(this));

		_this65.isLineCurve = true;

		_this65.type = 'LineCurve';

		_this65.v1 = v1;
		_this65.v2 = v2;

		return _this65;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LineCurve, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();


			var point = optionalTarget;

			if (t === 1) {

				point.copy(this.v2);
			} else {

				point.copy(this.v2).sub(this.v1);
				point.multiplyScalar(t).add(this.v1);
			}

			return point;
		}

		// Line curve is linear, so we can overwrite default getPointAt

	}, {
		key: 'getPointAt',
		value: function getPointAt(u, optionalTarget) {

			return this.getPoint(u, optionalTarget);
		}
	}, {
		key: 'getTangent',
		value: function getTangent(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();


			return optionalTarget.subVectors(this.v2, this.v1).normalize();
		}
	}, {
		key: 'getTangentAt',
		value: function getTangentAt(u, optionalTarget) {

			return this.getTangent(u, optionalTarget);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve.prototype), 'copy', this).call(this, source);

			this.v1.copy(source.v1);
			this.v2.copy(source.v2);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve.prototype), 'toJSON', this).call(this);

			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve.prototype), 'fromJSON', this).call(this, json);

			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);

			return this;
		}
	}]);

	return LineCurve;
}(Curve);

var LineCurve3 = function (_Curve6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineCurve3, _Curve6);

	function LineCurve3() {
		var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineCurve3);

		var _this66 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineCurve3.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve3)).call(this));

		_this66.isLineCurve3 = true;

		_this66.type = 'LineCurve3';

		_this66.v1 = v1;
		_this66.v2 = v2;

		return _this66;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LineCurve3, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();


			var point = optionalTarget;

			if (t === 1) {

				point.copy(this.v2);
			} else {

				point.copy(this.v2).sub(this.v1);
				point.multiplyScalar(t).add(this.v1);
			}

			return point;
		}
		// Line curve is linear, so we can overwrite default getPointAt

	}, {
		key: 'getPointAt',
		value: function getPointAt(u, optionalTarget) {

			return this.getPoint(u, optionalTarget);
		}
	}, {
		key: 'getTangent',
		value: function getTangent(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();


			return optionalTarget.subVectors(this.v2, this.v1).normalize();
		}
	}, {
		key: 'getTangentAt',
		value: function getTangentAt(u, optionalTarget) {

			return this.getTangent(u, optionalTarget);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve3.prototype), 'copy', this).call(this, source);

			this.v1.copy(source.v1);
			this.v2.copy(source.v2);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve3.prototype), 'toJSON', this).call(this);

			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineCurve3.prototype), 'fromJSON', this).call(this, json);

			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);

			return this;
		}
	}]);

	return LineCurve3;
}(Curve);

var QuadraticBezierCurve = function (_Curve7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(QuadraticBezierCurve, _Curve7);

	function QuadraticBezierCurve() {
		var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
		var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
		var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector2();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, QuadraticBezierCurve);

		var _this67 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuadraticBezierCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve)).call(this));

		_this67.isQuadraticBezierCurve = true;

		_this67.type = 'QuadraticBezierCurve';

		_this67.v0 = v0;
		_this67.v1 = v1;
		_this67.v2 = v2;

		return _this67;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(QuadraticBezierCurve, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();


			var point = optionalTarget;

			var v0 = this.v0,
			    v1 = this.v1,
			    v2 = this.v2;

			point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve.prototype), 'copy', this).call(this, source);

			this.v0.copy(source.v0);
			this.v1.copy(source.v1);
			this.v2.copy(source.v2);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve.prototype), 'toJSON', this).call(this);

			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve.prototype), 'fromJSON', this).call(this, json);

			this.v0.fromArray(json.v0);
			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);

			return this;
		}
	}]);

	return QuadraticBezierCurve;
}(Curve);

var QuadraticBezierCurve3 = function (_Curve8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(QuadraticBezierCurve3, _Curve8);

	function QuadraticBezierCurve3() {
		var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
		var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, QuadraticBezierCurve3);

		var _this68 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuadraticBezierCurve3.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve3)).call(this));

		_this68.isQuadraticBezierCurve3 = true;

		_this68.type = 'QuadraticBezierCurve3';

		_this68.v0 = v0;
		_this68.v1 = v1;
		_this68.v2 = v2;

		return _this68;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(QuadraticBezierCurve3, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();


			var point = optionalTarget;

			var v0 = this.v0,
			    v1 = this.v1,
			    v2 = this.v2;

			point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve3.prototype), 'copy', this).call(this, source);

			this.v0.copy(source.v0);
			this.v1.copy(source.v1);
			this.v2.copy(source.v2);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve3.prototype), 'toJSON', this).call(this);

			data.v0 = this.v0.toArray();
			data.v1 = this.v1.toArray();
			data.v2 = this.v2.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(QuadraticBezierCurve3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuadraticBezierCurve3.prototype), 'fromJSON', this).call(this, json);

			this.v0.fromArray(json.v0);
			this.v1.fromArray(json.v1);
			this.v2.fromArray(json.v2);

			return this;
		}
	}]);

	return QuadraticBezierCurve3;
}(Curve);

var SplineCurve = function (_Curve9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SplineCurve, _Curve9);

	function SplineCurve() {
		var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SplineCurve);

		var _this69 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SplineCurve.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SplineCurve)).call(this));

		_this69.isSplineCurve = true;

		_this69.type = 'SplineCurve';

		_this69.points = points;

		return _this69;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SplineCurve, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();


			var point = optionalTarget;

			var points = this.points;
			var p = (points.length - 1) * t;

			var intPoint = Math.floor(p);
			var weight = p - intPoint;

			var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
			var p1 = points[intPoint];
			var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
			var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];

			point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));

			return point;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SplineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SplineCurve.prototype), 'copy', this).call(this, source);

			this.points = [];

			for (var i = 0, l = source.points.length; i < l; i++) {

				var point = source.points[i];

				this.points.push(point.clone());
			}

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SplineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SplineCurve.prototype), 'toJSON', this).call(this);

			data.points = [];

			for (var i = 0, l = this.points.length; i < l; i++) {

				var point = this.points[i];
				data.points.push(point.toArray());
			}

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SplineCurve.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SplineCurve.prototype), 'fromJSON', this).call(this, json);

			this.points = [];

			for (var i = 0, l = json.points.length; i < l; i++) {

				var point = json.points[i];
				this.points.push(new Vector2().fromArray(point));
			}

			return this;
		}
	}]);

	return SplineCurve;
}(Curve);

var Curves = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze___default()({
	__proto__: null,
	ArcCurve: ArcCurve,
	CatmullRomCurve3: CatmullRomCurve3,
	CubicBezierCurve: CubicBezierCurve,
	CubicBezierCurve3: CubicBezierCurve3,
	EllipseCurve: EllipseCurve,
	LineCurve: LineCurve,
	LineCurve3: LineCurve3,
	QuadraticBezierCurve: QuadraticBezierCurve,
	QuadraticBezierCurve3: QuadraticBezierCurve3,
	SplineCurve: SplineCurve
});

/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

var CurvePath = function (_Curve10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CurvePath, _Curve10);

	function CurvePath() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CurvePath);

		var _this70 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CurvePath.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CurvePath)).call(this));

		_this70.type = 'CurvePath';

		_this70.curves = [];
		_this70.autoClose = false; // Automatically closes the path

		return _this70;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CurvePath, [{
		key: 'add',
		value: function add(curve) {

			this.curves.push(curve);
		}
	}, {
		key: 'closePath',
		value: function closePath() {

			// Add a line curve if start and end of lines are not connected
			var startPoint = this.curves[0].getPoint(0);
			var endPoint = this.curves[this.curves.length - 1].getPoint(1);

			if (!startPoint.equals(endPoint)) {

				this.curves.push(new LineCurve(endPoint, startPoint));
			}
		}

		// To get accurate point with reference to
		// entire path distance at time t,
		// following has to be done:

		// 1. Length of each sub path have to be known
		// 2. Locate and identify type of curve
		// 3. Get t for the curve
		// 4. Return curve.getPointAt(t')

	}, {
		key: 'getPoint',
		value: function getPoint(t, optionalTarget) {

			var d = t * this.getLength();
			var curveLengths = this.getCurveLengths();
			var i = 0;

			// To think about boundaries points.

			while (i < curveLengths.length) {

				if (curveLengths[i] >= d) {

					var diff = curveLengths[i] - d;
					var curve = this.curves[i];

					var segmentLength = curve.getLength();
					var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;

					return curve.getPointAt(u, optionalTarget);
				}

				i++;
			}

			return null;

			// loop where sum != 0, sum > d , sum+1 <d
		}

		// We cannot use the default THREE.Curve getPoint() with getLength() because in
		// THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
		// getPoint() depends on getLength

	}, {
		key: 'getLength',
		value: function getLength() {

			var lens = this.getCurveLengths();
			return lens[lens.length - 1];
		}

		// cacheLengths must be recalculated.

	}, {
		key: 'updateArcLengths',
		value: function updateArcLengths() {

			this.needsUpdate = true;
			this.cacheLengths = null;
			this.getCurveLengths();
		}

		// Compute lengths and cache them
		// We cannot overwrite getLengths() because UtoT mapping uses it.

	}, {
		key: 'getCurveLengths',
		value: function getCurveLengths() {

			// We use cache values if curves and cache array are same length

			if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {

				return this.cacheLengths;
			}

			// Get length of sub-curve
			// Push sums into cached array

			var lengths = [];
			var sums = 0;

			for (var i = 0, l = this.curves.length; i < l; i++) {

				sums += this.curves[i].getLength();
				lengths.push(sums);
			}

			this.cacheLengths = lengths;

			return lengths;
		}
	}, {
		key: 'getSpacedPoints',
		value: function getSpacedPoints() {
			var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;


			var points = [];

			for (var i = 0; i <= divisions; i++) {

				points.push(this.getPoint(i / divisions));
			}

			if (this.autoClose) {

				points.push(points[0]);
			}

			return points;
		}
	}, {
		key: 'getPoints',
		value: function getPoints() {
			var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;


			var points = [];
			var last = void 0;

			for (var i = 0, curves = this.curves; i < curves.length; i++) {

				var curve = curves[i];
				var resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;

				var pts = curve.getPoints(resolution);

				for (var j = 0; j < pts.length; j++) {

					var point = pts[j];

					if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates

					points.push(point);
					last = point;
				}
			}

			if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {

				points.push(points[0]);
			}

			return points;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CurvePath.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CurvePath.prototype), 'copy', this).call(this, source);

			this.curves = [];

			for (var i = 0, l = source.curves.length; i < l; i++) {

				var curve = source.curves[i];

				this.curves.push(curve.clone());
			}

			this.autoClose = source.autoClose;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CurvePath.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CurvePath.prototype), 'toJSON', this).call(this);

			data.autoClose = this.autoClose;
			data.curves = [];

			for (var i = 0, l = this.curves.length; i < l; i++) {

				var curve = this.curves[i];
				data.curves.push(curve.toJSON());
			}

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CurvePath.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CurvePath.prototype), 'fromJSON', this).call(this, json);

			this.autoClose = json.autoClose;
			this.curves = [];

			for (var i = 0, l = json.curves.length; i < l; i++) {

				var curve = json.curves[i];
				this.curves.push(new Curves[curve.type]().fromJSON(curve));
			}

			return this;
		}
	}]);

	return CurvePath;
}(Curve);

var Path = function (_CurvePath) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Path, _CurvePath);

	function Path(points) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Path);

		var _this71 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Path.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Path)).call(this));

		_this71.type = 'Path';

		_this71.currentPoint = new Vector2();

		if (points) {

			_this71.setFromPoints(points);
		}

		return _this71;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Path, [{
		key: 'setFromPoints',
		value: function setFromPoints(points) {

			this.moveTo(points[0].x, points[0].y);

			for (var i = 1, l = points.length; i < l; i++) {

				this.lineTo(points[i].x, points[i].y);
			}

			return this;
		}
	}, {
		key: 'moveTo',
		value: function moveTo(x, y) {

			this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?

			return this;
		}
	}, {
		key: 'lineTo',
		value: function lineTo(x, y) {

			var curve = new LineCurve(this.currentPoint.clone(), new Vector2(x, y));
			this.curves.push(curve);

			this.currentPoint.set(x, y);

			return this;
		}
	}, {
		key: 'quadraticCurveTo',
		value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {

			var curve = new QuadraticBezierCurve(this.currentPoint.clone(), new Vector2(aCPx, aCPy), new Vector2(aX, aY));

			this.curves.push(curve);

			this.currentPoint.set(aX, aY);

			return this;
		}
	}, {
		key: 'bezierCurveTo',
		value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {

			var curve = new CubicBezierCurve(this.currentPoint.clone(), new Vector2(aCP1x, aCP1y), new Vector2(aCP2x, aCP2y), new Vector2(aX, aY));

			this.curves.push(curve);

			this.currentPoint.set(aX, aY);

			return this;
		}
	}, {
		key: 'splineThru',
		value: function splineThru(pts /*Array of Vector*/) {

			var npts = [this.currentPoint.clone()].concat(pts);

			var curve = new SplineCurve(npts);
			this.curves.push(curve);

			this.currentPoint.copy(pts[pts.length - 1]);

			return this;
		}
	}, {
		key: 'arc',
		value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);

			return this;
		}
	}, {
		key: 'absarc',
		value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {

			this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);

			return this;
		}
	}, {
		key: 'ellipse',
		value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {

			var x0 = this.currentPoint.x;
			var y0 = this.currentPoint.y;

			this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);

			return this;
		}
	}, {
		key: 'absellipse',
		value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {

			var curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);

			if (this.curves.length > 0) {

				// if a previous curve is present, attempt to join
				var firstPoint = curve.getPoint(0);

				if (!firstPoint.equals(this.currentPoint)) {

					this.lineTo(firstPoint.x, firstPoint.y);
				}
			}

			this.curves.push(curve);

			var lastPoint = curve.getPoint(1);
			this.currentPoint.copy(lastPoint);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Path.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Path.prototype), 'copy', this).call(this, source);

			this.currentPoint.copy(source.currentPoint);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Path.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Path.prototype), 'toJSON', this).call(this);

			data.currentPoint = this.currentPoint.toArray();

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Path.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Path.prototype), 'fromJSON', this).call(this, json);

			this.currentPoint.fromArray(json.currentPoint);

			return this;
		}
	}]);

	return Path;
}(CurvePath);

var LatheGeometry = function (_BufferGeometry3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LatheGeometry, _BufferGeometry3);

	function LatheGeometry() {
		var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [new Vector2(0, -0.5), new Vector2(0.5, 0), new Vector2(0, 0.5)];
		var segments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
		var phiStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var phiLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LatheGeometry);

		var _this72 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LatheGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LatheGeometry)).call(this));

		_this72.type = 'LatheGeometry';

		_this72.parameters = {
			points: points,
			segments: segments,
			phiStart: phiStart,
			phiLength: phiLength
		};

		segments = Math.floor(segments);

		// clamp phiLength so it's in range of [ 0, 2PI ]

		phiLength = clamp(phiLength, 0, Math.PI * 2);

		// buffers

		var indices = [];
		var vertices = [];
		var uvs = [];
		var initNormals = [];
		var normals = [];

		// helper variables

		var inverseSegments = 1.0 / segments;
		var vertex = new Vector3();
		var uv = new Vector2();
		var normal = new Vector3();
		var curNormal = new Vector3();
		var prevNormal = new Vector3();
		var dx = 0;
		var dy = 0;

		// pre-compute normals for initial "meridian"

		for (var j = 0; j <= points.length - 1; j++) {

			switch (j) {

				case 0:
					// special handling for 1st vertex on path

					dx = points[j + 1].x - points[j].x;
					dy = points[j + 1].y - points[j].y;

					normal.x = dy * 1.0;
					normal.y = -dx;
					normal.z = dy * 0.0;

					prevNormal.copy(normal);

					normal.normalize();

					initNormals.push(normal.x, normal.y, normal.z);

					break;

				case points.length - 1:
					// special handling for last Vertex on path

					initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);

					break;

				default:
					// default handling for all vertices in between

					dx = points[j + 1].x - points[j].x;
					dy = points[j + 1].y - points[j].y;

					normal.x = dy * 1.0;
					normal.y = -dx;
					normal.z = dy * 0.0;

					curNormal.copy(normal);

					normal.x += prevNormal.x;
					normal.y += prevNormal.y;
					normal.z += prevNormal.z;

					normal.normalize();

					initNormals.push(normal.x, normal.y, normal.z);

					prevNormal.copy(curNormal);

			}
		}

		// generate vertices, uvs and normals

		for (var i = 0; i <= segments; i++) {

			var phi = phiStart + i * inverseSegments * phiLength;

			var sin = Math.sin(phi);
			var cos = Math.cos(phi);

			for (var _j5 = 0; _j5 <= points.length - 1; _j5++) {

				// vertex

				vertex.x = points[_j5].x * sin;
				vertex.y = points[_j5].y;
				vertex.z = points[_j5].x * cos;

				vertices.push(vertex.x, vertex.y, vertex.z);

				// uv

				uv.x = i / segments;
				uv.y = _j5 / (points.length - 1);

				uvs.push(uv.x, uv.y);

				// normal

				var x = initNormals[3 * _j5 + 0] * sin;
				var y = initNormals[3 * _j5 + 1];
				var z = initNormals[3 * _j5 + 0] * cos;

				normals.push(x, y, z);
			}
		}

		// indices

		for (var _i64 = 0; _i64 < segments; _i64++) {

			for (var _j6 = 0; _j6 < points.length - 1; _j6++) {

				var base = _j6 + _i64 * points.length;

				var a = base;
				var b = base + points.length;
				var c = base + points.length + 1;
				var d = base + 1;

				// faces

				indices.push(a, b, d);
				indices.push(c, d, b);
			}
		}

		// build geometry

		_this72.setIndex(indices);
		_this72.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this72.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
		_this72.setAttribute('normal', new Float32BufferAttribute(normals, 3));

		return _this72;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LatheGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LatheGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LatheGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
		}
	}]);

	return LatheGeometry;
}(BufferGeometry);

var CapsuleGeometry = function (_LatheGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CapsuleGeometry, _LatheGeometry);

	function CapsuleGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var capSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
		var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CapsuleGeometry);

		var path = new Path();
		path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
		path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);

		var _this73 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CapsuleGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CapsuleGeometry)).call(this, path.getPoints(capSegments), radialSegments));

		_this73.type = 'CapsuleGeometry';

		_this73.parameters = {
			radius: radius,
			height: length,
			capSegments: capSegments,
			radialSegments: radialSegments
		};

		return _this73;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CapsuleGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new CapsuleGeometry(data.radius, data.length, data.capSegments, data.radialSegments);
		}
	}]);

	return CapsuleGeometry;
}(LatheGeometry);

var CircleGeometry = function (_BufferGeometry4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CircleGeometry, _BufferGeometry4);

	function CircleGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var segments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
		var thetaStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var thetaLength = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CircleGeometry);

		var _this74 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CircleGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CircleGeometry)).call(this));

		_this74.type = 'CircleGeometry';

		_this74.parameters = {
			radius: radius,
			segments: segments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		segments = Math.max(3, segments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var vertex = new Vector3();
		var uv = new Vector2();

		// center point

		vertices.push(0, 0, 0);
		normals.push(0, 0, 1);
		uvs.push(0.5, 0.5);

		for (var s = 0, i = 3; s <= segments; s++, i += 3) {

			var segment = thetaStart + s / segments * thetaLength;

			// vertex

			vertex.x = radius * Math.cos(segment);
			vertex.y = radius * Math.sin(segment);

			vertices.push(vertex.x, vertex.y, vertex.z);

			// normal

			normals.push(0, 0, 1);

			// uvs

			uv.x = (vertices[i] / radius + 1) / 2;
			uv.y = (vertices[i + 1] / radius + 1) / 2;

			uvs.push(uv.x, uv.y);
		}

		// indices

		for (var _i65 = 1; _i65 <= segments; _i65++) {

			indices.push(_i65, _i65 + 1, 0);
		}

		// build geometry

		_this74.setIndex(indices);
		_this74.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this74.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this74.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		return _this74;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CircleGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CircleGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CircleGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
		}
	}]);

	return CircleGeometry;
}(BufferGeometry);

var CylinderGeometry = function (_BufferGeometry5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CylinderGeometry, _BufferGeometry5);

	function CylinderGeometry() {
		var radiusTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var radiusBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 32;
		var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
		var openEnded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
		var thetaStart = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
		var thetaLength = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CylinderGeometry);

		var _this75 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CylinderGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CylinderGeometry)).call(this));

		_this75.type = 'CylinderGeometry';

		_this75.parameters = {
			radiusTop: radiusTop,
			radiusBottom: radiusBottom,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		var scope = _this75;

		radialSegments = Math.floor(radialSegments);
		heightSegments = Math.floor(heightSegments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var index = 0;
		var indexArray = [];
		var halfHeight = height / 2;
		var groupStart = 0;

		// generate geometry

		generateTorso();

		if (openEnded === false) {

			if (radiusTop > 0) generateCap(true);
			if (radiusBottom > 0) generateCap(false);
		}

		// build geometry

		_this75.setIndex(indices);
		_this75.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this75.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this75.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		function generateTorso() {

			var normal = new Vector3();
			var vertex = new Vector3();

			var groupCount = 0;

			// this will be used to calculate the normal
			var slope = (radiusBottom - radiusTop) / height;

			// generate vertices, normals and uvs

			for (var y = 0; y <= heightSegments; y++) {

				var indexRow = [];

				var v = y / heightSegments;

				// calculate the radius of the current row

				var radius = v * (radiusBottom - radiusTop) + radiusTop;

				for (var x = 0; x <= radialSegments; x++) {

					var u = x / radialSegments;

					var theta = u * thetaLength + thetaStart;

					var sinTheta = Math.sin(theta);
					var cosTheta = Math.cos(theta);

					// vertex

					vertex.x = radius * sinTheta;
					vertex.y = -v * height + halfHeight;
					vertex.z = radius * cosTheta;
					vertices.push(vertex.x, vertex.y, vertex.z);

					// normal

					normal.set(sinTheta, slope, cosTheta).normalize();
					normals.push(normal.x, normal.y, normal.z);

					// uv

					uvs.push(u, 1 - v);

					// save index of vertex in respective row

					indexRow.push(index++);
				}

				// now save vertices of the row in our index array

				indexArray.push(indexRow);
			}

			// generate indices

			for (var _x246 = 0; _x246 < radialSegments; _x246++) {

				for (var _y2 = 0; _y2 < heightSegments; _y2++) {

					// we use the index array to access the correct indices

					var a = indexArray[_y2][_x246];
					var b = indexArray[_y2 + 1][_x246];
					var c = indexArray[_y2 + 1][_x246 + 1];
					var d = indexArray[_y2][_x246 + 1];

					// faces

					indices.push(a, b, d);
					indices.push(b, c, d);

					// update group counter

					groupCount += 6;
				}
			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup(groupStart, groupCount, 0);

			// calculate new start value for groups

			groupStart += groupCount;
		}

		function generateCap(top) {

			// save the index of the first center vertex
			var centerIndexStart = index;

			var uv = new Vector2();
			var vertex = new Vector3();

			var groupCount = 0;

			var radius = top === true ? radiusTop : radiusBottom;
			var sign = top === true ? 1 : -1;

			// first we generate the center vertex data of the cap.
			// because the geometry needs one set of uvs per face,
			// we must generate a center vertex per face/segment

			for (var x = 1; x <= radialSegments; x++) {

				// vertex

				vertices.push(0, halfHeight * sign, 0);

				// normal

				normals.push(0, sign, 0);

				// uv

				uvs.push(0.5, 0.5);

				// increase index

				index++;
			}

			// save the index of the last center vertex
			var centerIndexEnd = index;

			// now we generate the surrounding vertices, normals and uvs

			for (var _x247 = 0; _x247 <= radialSegments; _x247++) {

				var u = _x247 / radialSegments;
				var theta = u * thetaLength + thetaStart;

				var cosTheta = Math.cos(theta);
				var sinTheta = Math.sin(theta);

				// vertex

				vertex.x = radius * sinTheta;
				vertex.y = halfHeight * sign;
				vertex.z = radius * cosTheta;
				vertices.push(vertex.x, vertex.y, vertex.z);

				// normal

				normals.push(0, sign, 0);

				// uv

				uv.x = cosTheta * 0.5 + 0.5;
				uv.y = sinTheta * 0.5 * sign + 0.5;
				uvs.push(uv.x, uv.y);

				// increase index

				index++;
			}

			// generate indices

			for (var _x248 = 0; _x248 < radialSegments; _x248++) {

				var c = centerIndexStart + _x248;
				var i = centerIndexEnd + _x248;

				if (top === true) {

					// face top

					indices.push(i, i + 1, c);
				} else {

					// face bottom

					indices.push(i + 1, i, c);
				}

				groupCount += 3;
			}

			// add a group to the geometry. this will ensure multi material support

			scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);

			// calculate new start value for groups

			groupStart += groupCount;
		}

		return _this75;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CylinderGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(CylinderGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CylinderGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
		}
	}]);

	return CylinderGeometry;
}(BufferGeometry);

var ConeGeometry = function (_CylinderGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ConeGeometry, _CylinderGeometry);

	function ConeGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var radialSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 32;
		var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
		var openEnded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
		var thetaStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
		var thetaLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ConeGeometry);

		var _this76 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConeGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ConeGeometry)).call(this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength));

		_this76.type = 'ConeGeometry';

		_this76.parameters = {
			radius: radius,
			height: height,
			radialSegments: radialSegments,
			heightSegments: heightSegments,
			openEnded: openEnded,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		return _this76;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ConeGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
		}
	}]);

	return ConeGeometry;
}(CylinderGeometry);

var PolyhedronGeometry = function (_BufferGeometry6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PolyhedronGeometry, _BufferGeometry6);

	function PolyhedronGeometry() {
		var vertices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
		var indices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PolyhedronGeometry);

		var _this77 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PolyhedronGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PolyhedronGeometry)).call(this));

		_this77.type = 'PolyhedronGeometry';

		_this77.parameters = {
			vertices: vertices,
			indices: indices,
			radius: radius,
			detail: detail
		};

		// default buffer data

		var vertexBuffer = [];
		var uvBuffer = [];

		// the subdivision creates the vertex buffer data

		subdivide(detail);

		// all vertices should lie on a conceptual sphere with a given radius

		applyRadius(radius);

		// finally, create the uv data

		generateUVs();

		// build non-indexed geometry

		_this77.setAttribute('position', new Float32BufferAttribute(vertexBuffer, 3));
		_this77.setAttribute('normal', new Float32BufferAttribute(vertexBuffer.slice(), 3));
		_this77.setAttribute('uv', new Float32BufferAttribute(uvBuffer, 2));

		if (detail === 0) {

			_this77.computeVertexNormals(); // flat normals
		} else {

			_this77.normalizeNormals(); // smooth normals
		}

		// helper functions

		function subdivide(detail) {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			// iterate over all faces and apply a subdivision with the given detail value

			for (var i = 0; i < indices.length; i += 3) {

				// get the vertices of the face

				getVertexByIndex(indices[i + 0], a);
				getVertexByIndex(indices[i + 1], b);
				getVertexByIndex(indices[i + 2], c);

				// perform subdivision

				subdivideFace(a, b, c, detail);
			}
		}

		function subdivideFace(a, b, c, detail) {

			var cols = detail + 1;

			// we use this multidimensional array as a data structure for creating the subdivision

			var v = [];

			// construct all of the vertices for this subdivision

			for (var i = 0; i <= cols; i++) {

				v[i] = [];

				var aj = a.clone().lerp(c, i / cols);
				var bj = b.clone().lerp(c, i / cols);

				var rows = cols - i;

				for (var j = 0; j <= rows; j++) {

					if (j === 0 && i === cols) {

						v[i][j] = aj;
					} else {

						v[i][j] = aj.clone().lerp(bj, j / rows);
					}
				}
			}

			// construct all of the faces

			for (var _i66 = 0; _i66 < cols; _i66++) {

				for (var _j7 = 0; _j7 < 2 * (cols - _i66) - 1; _j7++) {

					var k = Math.floor(_j7 / 2);

					if (_j7 % 2 === 0) {

						pushVertex(v[_i66][k + 1]);
						pushVertex(v[_i66 + 1][k]);
						pushVertex(v[_i66][k]);
					} else {

						pushVertex(v[_i66][k + 1]);
						pushVertex(v[_i66 + 1][k + 1]);
						pushVertex(v[_i66 + 1][k]);
					}
				}
			}
		}

		function applyRadius(radius) {

			var vertex = new Vector3();

			// iterate over the entire buffer and apply the radius to each vertex

			for (var i = 0; i < vertexBuffer.length; i += 3) {

				vertex.x = vertexBuffer[i + 0];
				vertex.y = vertexBuffer[i + 1];
				vertex.z = vertexBuffer[i + 2];

				vertex.normalize().multiplyScalar(radius);

				vertexBuffer[i + 0] = vertex.x;
				vertexBuffer[i + 1] = vertex.y;
				vertexBuffer[i + 2] = vertex.z;
			}
		}

		function generateUVs() {

			var vertex = new Vector3();

			for (var i = 0; i < vertexBuffer.length; i += 3) {

				vertex.x = vertexBuffer[i + 0];
				vertex.y = vertexBuffer[i + 1];
				vertex.z = vertexBuffer[i + 2];

				var u = azimuth(vertex) / 2 / Math.PI + 0.5;
				var v = inclination(vertex) / Math.PI + 0.5;
				uvBuffer.push(u, 1 - v);
			}

			correctUVs();

			correctSeam();
		}

		function correctSeam() {

			// handle case when face straddles the seam, see #3269

			for (var i = 0; i < uvBuffer.length; i += 6) {

				// uv data of a single face

				var x0 = uvBuffer[i + 0];
				var x1 = uvBuffer[i + 2];
				var x2 = uvBuffer[i + 4];

				var max = Math.max(x0, x1, x2);
				var min = Math.min(x0, x1, x2);

				// 0.9 is somewhat arbitrary

				if (max > 0.9 && min < 0.1) {

					if (x0 < 0.2) uvBuffer[i + 0] += 1;
					if (x1 < 0.2) uvBuffer[i + 2] += 1;
					if (x2 < 0.2) uvBuffer[i + 4] += 1;
				}
			}
		}

		function pushVertex(vertex) {

			vertexBuffer.push(vertex.x, vertex.y, vertex.z);
		}

		function getVertexByIndex(index, vertex) {

			var stride = index * 3;

			vertex.x = vertices[stride + 0];
			vertex.y = vertices[stride + 1];
			vertex.z = vertices[stride + 2];
		}

		function correctUVs() {

			var a = new Vector3();
			var b = new Vector3();
			var c = new Vector3();

			var centroid = new Vector3();

			var uvA = new Vector2();
			var uvB = new Vector2();
			var uvC = new Vector2();

			for (var i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6) {

				a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
				b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
				c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);

				uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
				uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
				uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);

				centroid.copy(a).add(b).add(c).divideScalar(3);

				var azi = azimuth(centroid);

				correctUV(uvA, j + 0, a, azi);
				correctUV(uvB, j + 2, b, azi);
				correctUV(uvC, j + 4, c, azi);
			}
		}

		function correctUV(uv, stride, vector, azimuth) {

			if (azimuth < 0 && uv.x === 1) {

				uvBuffer[stride] = uv.x - 1;
			}

			if (vector.x === 0 && vector.z === 0) {

				uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
			}
		}

		// Angle around the Y axis, counter-clockwise when looking from above.

		function azimuth(vector) {

			return Math.atan2(vector.z, -vector.x);
		}

		// Angle above the XZ plane.

		function inclination(vector) {

			return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
		}

		return _this77;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PolyhedronGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PolyhedronGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PolyhedronGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
		}
	}]);

	return PolyhedronGeometry;
}(BufferGeometry);

var DodecahedronGeometry = function (_PolyhedronGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DodecahedronGeometry, _PolyhedronGeometry);

	function DodecahedronGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DodecahedronGeometry);

		var t = (1 + Math.sqrt(5)) / 2;
		var r = 1 / t;

		var vertices = [

		// (±1, ±1, ±1)
		-1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1,

		// (0, ±1/φ, ±φ)
		0, -r, -t, 0, -r, t, 0, r, -t, 0, r, t,

		// (±1/φ, ±φ, 0)
		-r, -t, 0, -r, t, 0, r, -t, 0, r, t, 0,

		// (±φ, 0, ±1/φ)
		-t, 0, -r, t, 0, -r, -t, 0, r, t, 0, r];

		var indices = [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9];

		var _this78 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DodecahedronGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DodecahedronGeometry)).call(this, vertices, indices, radius, detail));

		_this78.type = 'DodecahedronGeometry';

		_this78.parameters = {
			radius: radius,
			detail: detail
		};

		return _this78;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(DodecahedronGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new DodecahedronGeometry(data.radius, data.detail);
		}
	}]);

	return DodecahedronGeometry;
}(PolyhedronGeometry);

var _v0 = /*@__PURE__*/new Vector3();
var _v1$1 = /*@__PURE__*/new Vector3();
var _normal = /*@__PURE__*/new Vector3();
var _triangle = /*@__PURE__*/new Triangle();

var EdgesGeometry = function (_BufferGeometry7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(EdgesGeometry, _BufferGeometry7);

	function EdgesGeometry() {
		var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var thresholdAngle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, EdgesGeometry);

		var _this79 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EdgesGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EdgesGeometry)).call(this));

		_this79.type = 'EdgesGeometry';

		_this79.parameters = {
			geometry: geometry,
			thresholdAngle: thresholdAngle
		};

		if (geometry !== null) {

			var precisionPoints = 4;
			var precision = Math.pow(10, precisionPoints);
			var thresholdDot = Math.cos(DEG2RAD * thresholdAngle);

			var indexAttr = geometry.getIndex();
			var positionAttr = geometry.getAttribute('position');
			var indexCount = indexAttr ? indexAttr.count : positionAttr.count;

			var indexArr = [0, 0, 0];
			var vertKeys = ['a', 'b', 'c'];
			var hashes = new Array(3);

			var edgeData = {};
			var _vertices2 = [];
			for (var i = 0; i < indexCount; i += 3) {

				if (indexAttr) {

					indexArr[0] = indexAttr.getX(i);
					indexArr[1] = indexAttr.getX(i + 1);
					indexArr[2] = indexAttr.getX(i + 2);
				} else {

					indexArr[0] = i;
					indexArr[1] = i + 1;
					indexArr[2] = i + 2;
				}

				var a = _triangle.a,
				    b = _triangle.b,
				    c = _triangle.c;

				a.fromBufferAttribute(positionAttr, indexArr[0]);
				b.fromBufferAttribute(positionAttr, indexArr[1]);
				c.fromBufferAttribute(positionAttr, indexArr[2]);
				_triangle.getNormal(_normal);

				// create hashes for the edge from the vertices
				hashes[0] = Math.round(a.x * precision) + ',' + Math.round(a.y * precision) + ',' + Math.round(a.z * precision);
				hashes[1] = Math.round(b.x * precision) + ',' + Math.round(b.y * precision) + ',' + Math.round(b.z * precision);
				hashes[2] = Math.round(c.x * precision) + ',' + Math.round(c.y * precision) + ',' + Math.round(c.z * precision);

				// skip degenerate triangles
				if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {

					continue;
				}

				// iterate over every edge
				for (var j = 0; j < 3; j++) {

					// get the first and next vertex making up the edge
					var jNext = (j + 1) % 3;
					var vecHash0 = hashes[j];
					var vecHash1 = hashes[jNext];
					var v0 = _triangle[vertKeys[j]];
					var v1 = _triangle[vertKeys[jNext]];

					var hash = vecHash0 + '_' + vecHash1;
					var reverseHash = vecHash1 + '_' + vecHash0;

					if (reverseHash in edgeData && edgeData[reverseHash]) {

						// if we found a sibling edge add it into the vertex array if
						// it meets the angle threshold and delete the edge from the map.
						if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {

							_vertices2.push(v0.x, v0.y, v0.z);
							_vertices2.push(v1.x, v1.y, v1.z);
						}

						edgeData[reverseHash] = null;
					} else if (!(hash in edgeData)) {

						// if we've already got an edge here then skip adding a new one
						edgeData[hash] = {

							index0: indexArr[j],
							index1: indexArr[jNext],
							normal: _normal.clone()

						};
					}
				}
			}

			// iterate over all remaining, unmatched edges and add them to the vertex array
			for (var key in edgeData) {

				if (edgeData[key]) {
					var _edgeData$key = edgeData[key],
					    index0 = _edgeData$key.index0,
					    index1 = _edgeData$key.index1;

					_v0.fromBufferAttribute(positionAttr, index0);
					_v1$1.fromBufferAttribute(positionAttr, index1);

					_vertices2.push(_v0.x, _v0.y, _v0.z);
					_vertices2.push(_v1$1.x, _v1$1.y, _v1$1.z);
				}
			}

			_this79.setAttribute('position', new Float32BufferAttribute(_vertices2, 3));
		}

		return _this79;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(EdgesGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(EdgesGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(EdgesGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}]);

	return EdgesGeometry;
}(BufferGeometry);

var Shape = function (_Path) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Shape, _Path);

	function Shape(points) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Shape);

		var _this80 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Shape.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Shape)).call(this, points));

		_this80.uuid = generateUUID();

		_this80.type = 'Shape';

		_this80.holes = [];

		return _this80;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Shape, [{
		key: 'getPointsHoles',
		value: function getPointsHoles(divisions) {

			var holesPts = [];

			for (var i = 0, l = this.holes.length; i < l; i++) {

				holesPts[i] = this.holes[i].getPoints(divisions);
			}

			return holesPts;
		}

		// get points of shape and holes (keypoints based on segments parameter)

	}, {
		key: 'extractPoints',
		value: function extractPoints(divisions) {

			return {

				shape: this.getPoints(divisions),
				holes: this.getPointsHoles(divisions)

			};
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Shape.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Shape.prototype), 'copy', this).call(this, source);

			this.holes = [];

			for (var i = 0, l = source.holes.length; i < l; i++) {

				var hole = source.holes[i];

				this.holes.push(hole.clone());
			}

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Shape.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Shape.prototype), 'toJSON', this).call(this);

			data.uuid = this.uuid;
			data.holes = [];

			for (var i = 0, l = this.holes.length; i < l; i++) {

				var hole = this.holes[i];
				data.holes.push(hole.toJSON());
			}

			return data;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Shape.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Shape.prototype), 'fromJSON', this).call(this, json);

			this.uuid = json.uuid;
			this.holes = [];

			for (var i = 0, l = json.holes.length; i < l; i++) {

				var hole = json.holes[i];
				this.holes.push(new Path().fromJSON(hole));
			}

			return this;
		}
	}]);

	return Shape;
}(Path);

/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */

var Earcut = {

	triangulate: function triangulate(data, holeIndices) {
		var dim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;


		var hasHoles = holeIndices && holeIndices.length;
		var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
		var outerNode = linkedList(data, 0, outerLen, dim, true);
		var triangles = [];

		if (!outerNode || outerNode.next === outerNode.prev) return triangles;

		var minX = void 0,
		    minY = void 0,
		    maxX = void 0,
		    maxY = void 0,
		    x = void 0,
		    y = void 0,
		    invSize = void 0;

		if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

		// if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
		if (data.length > 80 * dim) {

			minX = maxX = data[0];
			minY = maxY = data[1];

			for (var i = dim; i < outerLen; i += dim) {

				x = data[i];
				y = data[i + 1];
				if (x < minX) minX = x;
				if (y < minY) minY = y;
				if (x > maxX) maxX = x;
				if (y > maxY) maxY = y;
			}

			// minX, minY and invSize are later used to transform coords into integers for z-order calculation
			invSize = Math.max(maxX - minX, maxY - minY);
			invSize = invSize !== 0 ? 32767 / invSize : 0;
		}

		earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);

		return triangles;
	}

};

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {

	var i = void 0,
	    last = void 0;

	if (clockwise === signedArea(data, start, end, dim) > 0) {

		for (i = start; i < end; i += dim) {
			last = insertNode(i, data[i], data[i + 1], last);
		}
	} else {

		for (i = end - dim; i >= start; i -= dim) {
			last = insertNode(i, data[i], data[i + 1], last);
		}
	}

	if (last && equals(last, last.next)) {

		removeNode(last);
		last = last.next;
	}

	return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {

	if (!start) return start;
	if (!end) end = start;

	var p = start,
	    again = void 0;
	do {

		again = false;

		if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {

			removeNode(p);
			p = end = p.prev;
			if (p === p.next) break;
			again = true;
		} else {

			p = p.next;
		}
	} while (again || p !== end);

	return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {

	if (!ear) return;

	// interlink polygon nodes in z-order
	if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

	var stop = ear,
	    prev = void 0,
	    next = void 0;

	// iterate through ears, slicing them one by one
	while (ear.prev !== ear.next) {

		prev = ear.prev;
		next = ear.next;

		if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {

			// cut off the triangle
			triangles.push(prev.i / dim | 0);
			triangles.push(ear.i / dim | 0);
			triangles.push(next.i / dim | 0);

			removeNode(ear);

			// skipping the next vertex leads to less sliver triangles
			ear = next.next;
			stop = next.next;

			continue;
		}

		ear = next;

		// if we looped through the whole remaining polygon and can't find any more ears
		if (ear === stop) {

			// try filtering points and slicing again
			if (!pass) {

				earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

				// if this didn't work, try curing all small self-intersections locally
			} else if (pass === 1) {

				ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
				earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

				// as a last resort, try splitting the remaining polygon into two
			} else if (pass === 2) {

				splitEarcut(ear, triangles, dim, minX, minY, invSize);
			}

			break;
		}
	}
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {

	var a = ear.prev,
	    b = ear,
	    c = ear.next;

	if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

	// now make sure we don't have other points inside the potential ear
	var ax = a.x,
	    bx = b.x,
	    cx = c.x,
	    ay = a.y,
	    by = b.y,
	    cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx,
	    y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy,
	    x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx,
	    y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;

	var p = c.next;
	while (p !== a) {

		if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
		p = p.next;
	}

	return true;
}

function isEarHashed(ear, minX, minY, invSize) {

	var a = ear.prev,
	    b = ear,
	    c = ear.next;

	if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

	var ax = a.x,
	    bx = b.x,
	    cx = c.x,
	    ay = a.y,
	    by = b.y,
	    cy = c.y;

	// triangle bbox; min & max are calculated like this for speed
	var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx,
	    y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy,
	    x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx,
	    y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;

	// z-order range for the current triangle bbox;
	var minZ = zOrder(x0, y0, minX, minY, invSize),
	    maxZ = zOrder(x1, y1, minX, minY, invSize);

	var p = ear.prevZ,
	    n = ear.nextZ;

	// look for points inside the triangle in both directions
	while (p && p.z >= minZ && n && n.z <= maxZ) {

		if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
		p = p.prevZ;

		if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
		n = n.nextZ;
	}

	// look for remaining points in decreasing z-order
	while (p && p.z >= minZ) {

		if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
		p = p.prevZ;
	}

	// look for remaining points in increasing z-order
	while (n && n.z <= maxZ) {

		if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
		n = n.nextZ;
	}

	return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {

	var p = start;
	do {

		var a = p.prev,
		    b = p.next.next;

		if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

			triangles.push(a.i / dim | 0);
			triangles.push(p.i / dim | 0);
			triangles.push(b.i / dim | 0);

			// remove two nodes involved
			removeNode(p);
			removeNode(p.next);

			p = start = b;
		}

		p = p.next;
	} while (p !== start);

	return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {

	// look for a valid diagonal that divides the polygon into two
	var a = start;
	do {

		var b = a.next.next;
		while (b !== a.prev) {

			if (a.i !== b.i && isValidDiagonal(a, b)) {

				// split the polygon in two by the diagonal
				var c = splitPolygon(a, b);

				// filter colinear points around the cuts
				a = filterPoints(a, a.next);
				c = filterPoints(c, c.next);

				// run earcut on each half
				earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
				earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
				return;
			}

			b = b.next;
		}

		a = a.next;
	} while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {

	var queue = [];
	var i = void 0,
	    len = void 0,
	    start = void 0,
	    end = void 0,
	    list = void 0;

	for (i = 0, len = holeIndices.length; i < len; i++) {

		start = holeIndices[i] * dim;
		end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
		list = linkedList(data, start, end, dim, false);
		if (list === list.next) list.steiner = true;
		queue.push(getLeftmost(list));
	}

	queue.sort(compareX);

	// process holes from left to right
	for (i = 0; i < queue.length; i++) {

		outerNode = eliminateHole(queue[i], outerNode);
	}

	return outerNode;
}

function compareX(a, b) {

	return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and link it
function eliminateHole(hole, outerNode) {

	var bridge = findHoleBridge(hole, outerNode);
	if (!bridge) {

		return outerNode;
	}

	var bridgeReverse = splitPolygon(bridge, hole);

	// filter collinear points around the cuts
	filterPoints(bridgeReverse, bridgeReverse.next);
	return filterPoints(bridge, bridge.next);
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {

	var p = outerNode,
	    qx = -Infinity,
	    m = void 0;

	var hx = hole.x,
	    hy = hole.y;

	// find a segment intersected by a ray from the hole's leftmost point to the left;
	// segment's endpoint with lesser x will be potential connection point
	do {

		if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {

			var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
			if (x <= hx && x > qx) {

				qx = x;
				m = p.x < p.next.x ? p : p.next;
				if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
			}
		}

		p = p.next;
	} while (p !== outerNode);

	if (!m) return null;

	// look for points inside the triangle of hole point, segment intersection and endpoint;
	// if there are no points found, we have a valid connection;
	// otherwise choose the point of the minimum angle with the ray as connection point

	var stop = m,
	    mx = m.x,
	    my = m.y;
	var tanMin = Infinity,
	    tan = void 0;

	p = m;

	do {

		if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

			tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

			if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {

				m = p;
				tanMin = tan;
			}
		}

		p = p.next;
	} while (p !== stop);

	return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {

	return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {

	var p = start;
	do {

		if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
		p.prevZ = p.prev;
		p.nextZ = p.next;
		p = p.next;
	} while (p !== start);

	p.prevZ.nextZ = null;
	p.prevZ = null;

	sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {

	var i = void 0,
	    p = void 0,
	    q = void 0,
	    e = void 0,
	    tail = void 0,
	    numMerges = void 0,
	    pSize = void 0,
	    qSize = void 0,
	    inSize = 1;

	do {

		p = list;
		list = null;
		tail = null;
		numMerges = 0;

		while (p) {

			numMerges++;
			q = p;
			pSize = 0;
			for (i = 0; i < inSize; i++) {

				pSize++;
				q = q.nextZ;
				if (!q) break;
			}

			qSize = inSize;

			while (pSize > 0 || qSize > 0 && q) {

				if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {

					e = p;
					p = p.nextZ;
					pSize--;
				} else {

					e = q;
					q = q.nextZ;
					qSize--;
				}

				if (tail) tail.nextZ = e;else list = e;

				e.prevZ = tail;
				tail = e;
			}

			p = q;
		}

		tail.nextZ = null;
		inSize *= 2;
	} while (numMerges > 1);

	return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {

	// coords are transformed into non-negative 15-bit integer range
	x = (x - minX) * invSize | 0;
	y = (y - minY) * invSize | 0;

	x = (x | x << 8) & 0x00FF00FF;
	x = (x | x << 4) & 0x0F0F0F0F;
	x = (x | x << 2) & 0x33333333;
	x = (x | x << 1) & 0x55555555;

	y = (y | y << 8) & 0x00FF00FF;
	y = (y | y << 4) & 0x0F0F0F0F;
	y = (y | y << 2) & 0x33333333;
	y = (y | y << 1) & 0x55555555;

	return x | y << 1;
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {

	var p = start,
	    leftmost = start;
	do {

		if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
		p = p.next;
	} while (p !== start);

	return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {

	return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {

	return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && ( // dones't intersect other edges
	locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && ( // locally visible
	area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
	equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {

	return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {

	return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {

	var o1 = sign(area(p1, q1, p2));
	var o2 = sign(area(p1, q1, q2));
	var o3 = sign(area(p2, q2, p1));
	var o4 = sign(area(p2, q2, q1));

	if (o1 !== o2 && o3 !== o4) return true; // general case

	if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
	if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
	if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
	if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

	return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {

	return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {

	return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {

	var p = a;
	do {

		if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
		p = p.next;
	} while (p !== a);

	return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {

	return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {

	var p = a,
	    inside = false;
	var px = (a.x + b.x) / 2,
	    py = (a.y + b.y) / 2;
	do {

		if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
		p = p.next;
	} while (p !== a);

	return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {

	var a2 = new Node(a.i, a.x, a.y),
	    b2 = new Node(b.i, b.x, b.y),
	    an = a.next,
	    bp = b.prev;

	a.next = b;
	b.prev = a;

	a2.next = an;
	an.prev = a2;

	b2.next = a2;
	a2.prev = b2;

	bp.next = b2;
	b2.prev = bp;

	return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {

	var p = new Node(i, x, y);

	if (!last) {

		p.prev = p;
		p.next = p;
	} else {

		p.next = last.next;
		p.prev = last;
		last.next.prev = p;
		last.next = p;
	}

	return p;
}

function removeNode(p) {

	p.next.prev = p.prev;
	p.prev.next = p.next;

	if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {

	// vertex index in coordinates array
	this.i = i;

	// vertex coordinates
	this.x = x;
	this.y = y;

	// previous and next vertex nodes in a polygon ring
	this.prev = null;
	this.next = null;

	// z-order curve value
	this.z = 0;

	// previous and next nodes in z-order
	this.prevZ = null;
	this.nextZ = null;

	// indicates whether this is a steiner point
	this.steiner = false;
}

function signedArea(data, start, end, dim) {

	var sum = 0;
	for (var i = start, j = end - dim; i < end; i += dim) {

		sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
		j = i;
	}

	return sum;
}

var ShapeUtils = function () {
	function ShapeUtils() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShapeUtils);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ShapeUtils, null, [{
		key: 'area',


		// calculate area of the contour polygon

		value: function area(contour) {

			var n = contour.length;
			var a = 0.0;

			for (var p = n - 1, q = 0; q < n; p = q++) {

				a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
			}

			return a * 0.5;
		}
	}, {
		key: 'isClockWise',
		value: function isClockWise(pts) {

			return ShapeUtils.area(pts) < 0;
		}
	}, {
		key: 'triangulateShape',
		value: function triangulateShape(contour, holes) {

			var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
			var holeIndices = []; // array of hole indices
			var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]

			removeDupEndPts(contour);
			addContour(vertices, contour);

			//

			var holeIndex = contour.length;

			holes.forEach(removeDupEndPts);

			for (var i = 0; i < holes.length; i++) {

				holeIndices.push(holeIndex);
				holeIndex += holes[i].length;
				addContour(vertices, holes[i]);
			}

			//

			var triangles = Earcut.triangulate(vertices, holeIndices);

			//

			for (var _i67 = 0; _i67 < triangles.length; _i67 += 3) {

				faces.push(triangles.slice(_i67, _i67 + 3));
			}

			return faces;
		}
	}]);

	return ShapeUtils;
}();

function removeDupEndPts(points) {

	var l = points.length;

	if (l > 2 && points[l - 1].equals(points[0])) {

		points.pop();
	}
}

function addContour(vertices, contour) {

	for (var i = 0; i < contour.length; i++) {

		vertices.push(contour[i].x);
		vertices.push(contour[i].y);
	}
}

/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */

var ExtrudeGeometry = function (_BufferGeometry8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ExtrudeGeometry, _BufferGeometry8);

	function ExtrudeGeometry() {
		var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Shape([new Vector2(0.5, 0.5), new Vector2(-0.5, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]);
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ExtrudeGeometry);

		var _this81 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExtrudeGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ExtrudeGeometry)).call(this));

		_this81.type = 'ExtrudeGeometry';

		_this81.parameters = {
			shapes: shapes,
			options: options
		};

		shapes = Array.isArray(shapes) ? shapes : [shapes];

		var scope = _this81;

		var verticesArray = [];
		var uvArray = [];

		for (var i = 0, l = shapes.length; i < l; i++) {

			var shape = shapes[i];
			addShape(shape);
		}

		// build geometry

		_this81.setAttribute('position', new Float32BufferAttribute(verticesArray, 3));
		_this81.setAttribute('uv', new Float32BufferAttribute(uvArray, 2));

		_this81.computeVertexNormals();

		// functions

		function addShape(shape) {

			var placeholder = [];

			// options

			var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
			var steps = options.steps !== undefined ? options.steps : 1;
			var depth = options.depth !== undefined ? options.depth : 1;

			var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
			var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
			var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
			var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
			var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;

			var extrudePath = options.extrudePath;

			var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;

			//

			var extrudePts = void 0,
			    extrudeByPath = false;
			var splineTube = void 0,
			    binormal = void 0,
			    normal = void 0,
			    position2 = void 0;

			if (extrudePath) {

				extrudePts = extrudePath.getSpacedPoints(steps);

				extrudeByPath = true;
				bevelEnabled = false; // bevels not supported for path extrusion

				// SETUP TNB variables

				// TODO1 - have a .isClosed in spline?

				splineTube = extrudePath.computeFrenetFrames(steps, false);

				// console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

				binormal = new Vector3();
				normal = new Vector3();
				position2 = new Vector3();
			}

			// Safeguards if bevels are not enabled

			if (!bevelEnabled) {

				bevelSegments = 0;
				bevelThickness = 0;
				bevelSize = 0;
				bevelOffset = 0;
			}

			// Variables initialization

			var shapePoints = shape.extractPoints(curveSegments);

			var vertices = shapePoints.shape;
			var holes = shapePoints.holes;

			var reverse = !ShapeUtils.isClockWise(vertices);

			if (reverse) {

				vertices = vertices.reverse();

				// Maybe we should also check if holes are in the opposite direction, just to be safe ...

				for (var h = 0, hl = holes.length; h < hl; h++) {

					var ahole = holes[h];

					if (ShapeUtils.isClockWise(ahole)) {

						holes[h] = ahole.reverse();
					}
				}
			}

			var faces = ShapeUtils.triangulateShape(vertices, holes);

			/* Vertices */

			var contour = vertices; // vertices has all points but contour has only points of circumference

			for (var _h = 0, _hl = holes.length; _h < _hl; _h++) {

				var _ahole = holes[_h];

				vertices = vertices.concat(_ahole);
			}

			function scalePt2(pt, vec, size) {

				if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');

				return pt.clone().addScaledVector(vec, size);
			}

			var vlen = vertices.length,
			    flen = faces.length;

			// Find directions for point movement


			function getBevelVec(inPt, inPrev, inNext) {

				// computes for inPt the corresponding point inPt' on a new contour
				//   shifted by 1 unit (length of normalized vector) to the left
				// if we walk along contour clockwise, this new contour is outside the old one
				//
				// inPt' is the intersection of the two lines parallel to the two
				//  adjacent edges of inPt at a distance of 1 unit on the left side.

				var v_trans_x = void 0,
				    v_trans_y = void 0,
				    shrink_by = void 0; // resulting translation vector for inPt

				// good reading for geometry algorithms (here: line-line intersection)
				// http://geomalgorithms.com/a05-_intersect-1.html

				var v_prev_x = inPt.x - inPrev.x,
				    v_prev_y = inPt.y - inPrev.y;
				var v_next_x = inNext.x - inPt.x,
				    v_next_y = inNext.y - inPt.y;

				var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;

				// check for collinear edges
				var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;

				if (Math.abs(collinear0) > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

					// not collinear

					// length of vectors for normalizing

					var v_prev_len = Math.sqrt(v_prev_lensq);
					var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);

					// shift adjacent points by unit vectors to the left

					var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
					var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;

					var ptNextShift_x = inNext.x - v_next_y / v_next_len;
					var ptNextShift_y = inNext.y + v_next_x / v_next_len;

					// scaling factor for v_prev to intersection point

					var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);

					// vector from inPt to intersection point

					v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
					v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;

					// Don't normalize!, otherwise sharp corners become ugly
					//  but prevent crazy spikes
					var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
					if (v_trans_lensq <= 2) {

						return new Vector2(v_trans_x, v_trans_y);
					} else {

						shrink_by = Math.sqrt(v_trans_lensq / 2);
					}
				} else {

					// handle special case of collinear edges

					var direction_eq = false; // assumes: opposite

					if (v_prev_x > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

						if (v_next_x > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

							direction_eq = true;
						}
					} else {

						if (v_prev_x < -__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

							if (v_next_x < -__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

								direction_eq = true;
							}
						} else {

							if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign___default()(v_prev_y) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign___default()(v_next_y)) {

								direction_eq = true;
							}
						}
					}

					if (direction_eq) {

						// console.log("Warning: lines are a straight sequence");
						v_trans_x = -v_prev_y;
						v_trans_y = v_prev_x;
						shrink_by = Math.sqrt(v_prev_lensq);
					} else {

						// console.log("Warning: lines are a straight spike");
						v_trans_x = v_prev_x;
						v_trans_y = v_prev_y;
						shrink_by = Math.sqrt(v_prev_lensq / 2);
					}
				}

				return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
			}

			var contourMovements = [];

			for (var _i68 = 0, il = contour.length, j = il - 1, k = _i68 + 1; _i68 < il; _i68++, j++, k++) {

				if (j === il) j = 0;
				if (k === il) k = 0;

				//  (j)---(i)---(k)
				// console.log('i,j,k', i, j , k)

				contourMovements[_i68] = getBevelVec(contour[_i68], contour[j], contour[k]);
			}

			var holesMovements = [];
			var oneHoleMovements = void 0,
			    verticesMovements = contourMovements.concat();

			for (var _h2 = 0, _hl2 = holes.length; _h2 < _hl2; _h2++) {

				var _ahole2 = holes[_h2];

				oneHoleMovements = [];

				for (var _i69 = 0, _il14 = _ahole2.length, _j8 = _il14 - 1, _k = _i69 + 1; _i69 < _il14; _i69++, _j8++, _k++) {

					if (_j8 === _il14) _j8 = 0;
					if (_k === _il14) _k = 0;

					//  (j)---(i)---(k)
					oneHoleMovements[_i69] = getBevelVec(_ahole2[_i69], _ahole2[_j8], _ahole2[_k]);
				}

				holesMovements.push(oneHoleMovements);
				verticesMovements = verticesMovements.concat(oneHoleMovements);
			}

			// Loop bevelSegments, 1 for the front, 1 for the back

			for (var b = 0; b < bevelSegments; b++) {

				//for ( b = bevelSegments; b > 0; b -- ) {

				var t = b / bevelSegments;
				var z = bevelThickness * Math.cos(t * Math.PI / 2);
				var _bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;

				// contract shape

				for (var _i70 = 0, _il15 = contour.length; _i70 < _il15; _i70++) {

					var vert = scalePt2(contour[_i70], contourMovements[_i70], _bs);

					v(vert.x, vert.y, -z);
				}

				// expand holes

				for (var _h3 = 0, _hl3 = holes.length; _h3 < _hl3; _h3++) {

					var _ahole3 = holes[_h3];
					oneHoleMovements = holesMovements[_h3];

					for (var _i71 = 0, _il16 = _ahole3.length; _i71 < _il16; _i71++) {

						var _vert = scalePt2(_ahole3[_i71], oneHoleMovements[_i71], _bs);

						v(_vert.x, _vert.y, -z);
					}
				}
			}

			var bs = bevelSize + bevelOffset;

			// Back facing vertices

			for (var _i72 = 0; _i72 < vlen; _i72++) {

				var _vert2 = bevelEnabled ? scalePt2(vertices[_i72], verticesMovements[_i72], bs) : vertices[_i72];

				if (!extrudeByPath) {

					v(_vert2.x, _vert2.y, 0);
				} else {

					// v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );

					normal.copy(splineTube.normals[0]).multiplyScalar(_vert2.x);
					binormal.copy(splineTube.binormals[0]).multiplyScalar(_vert2.y);

					position2.copy(extrudePts[0]).add(normal).add(binormal);

					v(position2.x, position2.y, position2.z);
				}
			}

			// Add stepped vertices...
			// Including front facing vertices

			for (var s = 1; s <= steps; s++) {

				for (var _i73 = 0; _i73 < vlen; _i73++) {

					var _vert3 = bevelEnabled ? scalePt2(vertices[_i73], verticesMovements[_i73], bs) : vertices[_i73];

					if (!extrudeByPath) {

						v(_vert3.x, _vert3.y, depth / steps * s);
					} else {

						// v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );

						normal.copy(splineTube.normals[s]).multiplyScalar(_vert3.x);
						binormal.copy(splineTube.binormals[s]).multiplyScalar(_vert3.y);

						position2.copy(extrudePts[s]).add(normal).add(binormal);

						v(position2.x, position2.y, position2.z);
					}
				}
			}

			// Add bevel segments planes

			//for ( b = 1; b <= bevelSegments; b ++ ) {
			for (var _b5 = bevelSegments - 1; _b5 >= 0; _b5--) {

				var _t = _b5 / bevelSegments;
				var _z2 = bevelThickness * Math.cos(_t * Math.PI / 2);
				var _bs2 = bevelSize * Math.sin(_t * Math.PI / 2) + bevelOffset;

				// contract shape

				for (var _i74 = 0, _il17 = contour.length; _i74 < _il17; _i74++) {

					var _vert4 = scalePt2(contour[_i74], contourMovements[_i74], _bs2);
					v(_vert4.x, _vert4.y, depth + _z2);
				}

				// expand holes

				for (var _h4 = 0, _hl4 = holes.length; _h4 < _hl4; _h4++) {

					var _ahole4 = holes[_h4];
					oneHoleMovements = holesMovements[_h4];

					for (var _i75 = 0, _il18 = _ahole4.length; _i75 < _il18; _i75++) {

						var _vert5 = scalePt2(_ahole4[_i75], oneHoleMovements[_i75], _bs2);

						if (!extrudeByPath) {

							v(_vert5.x, _vert5.y, depth + _z2);
						} else {

							v(_vert5.x, _vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + _z2);
						}
					}
				}
			}

			/* Faces */

			// Top and bottom faces

			buildLidFaces();

			// Sides faces

			buildSideFaces();

			/////  Internal functions

			function buildLidFaces() {

				var start = verticesArray.length / 3;

				if (bevelEnabled) {

					var layer = 0; // steps + 1
					var offset = vlen * layer;

					// Bottom faces

					for (var _i76 = 0; _i76 < flen; _i76++) {

						var face = faces[_i76];
						f3(face[2] + offset, face[1] + offset, face[0] + offset);
					}

					layer = steps + bevelSegments * 2;
					offset = vlen * layer;

					// Top faces

					for (var _i77 = 0; _i77 < flen; _i77++) {

						var _face = faces[_i77];
						f3(_face[0] + offset, _face[1] + offset, _face[2] + offset);
					}
				} else {

					// Bottom faces

					for (var _i78 = 0; _i78 < flen; _i78++) {

						var _face2 = faces[_i78];
						f3(_face2[2], _face2[1], _face2[0]);
					}

					// Top faces

					for (var _i79 = 0; _i79 < flen; _i79++) {

						var _face3 = faces[_i79];
						f3(_face3[0] + vlen * steps, _face3[1] + vlen * steps, _face3[2] + vlen * steps);
					}
				}

				scope.addGroup(start, verticesArray.length / 3 - start, 0);
			}

			// Create faces for the z-sides of the shape

			function buildSideFaces() {

				var start = verticesArray.length / 3;
				var layeroffset = 0;
				sidewalls(contour, layeroffset);
				layeroffset += contour.length;

				for (var _h5 = 0, _hl5 = holes.length; _h5 < _hl5; _h5++) {

					var _ahole5 = holes[_h5];
					sidewalls(_ahole5, layeroffset);

					//, true
					layeroffset += _ahole5.length;
				}

				scope.addGroup(start, verticesArray.length / 3 - start, 1);
			}

			function sidewalls(contour, layeroffset) {

				var i = contour.length;

				while (--i >= 0) {

					var _j9 = i;
					var _k2 = i - 1;
					if (_k2 < 0) _k2 = contour.length - 1;

					//console.log('b', i,j, i-1, k,vertices.length);

					for (var _s4 = 0, sl = steps + bevelSegments * 2; _s4 < sl; _s4++) {

						var slen1 = vlen * _s4;
						var slen2 = vlen * (_s4 + 1);

						var a = layeroffset + _j9 + slen1,
						    _b6 = layeroffset + _k2 + slen1,
						    c = layeroffset + _k2 + slen2,
						    d = layeroffset + _j9 + slen2;

						f4(a, _b6, c, d);
					}
				}
			}

			function v(x, y, z) {

				placeholder.push(x);
				placeholder.push(y);
				placeholder.push(z);
			}

			function f3(a, b, c) {

				addVertex(a);
				addVertex(b);
				addVertex(c);

				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);

				addUV(uvs[0]);
				addUV(uvs[1]);
				addUV(uvs[2]);
			}

			function f4(a, b, c, d) {

				addVertex(a);
				addVertex(b);
				addVertex(d);

				addVertex(b);
				addVertex(c);
				addVertex(d);

				var nextIndex = verticesArray.length / 3;
				var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);

				addUV(uvs[0]);
				addUV(uvs[1]);
				addUV(uvs[3]);

				addUV(uvs[1]);
				addUV(uvs[2]);
				addUV(uvs[3]);
			}

			function addVertex(index) {

				verticesArray.push(placeholder[index * 3 + 0]);
				verticesArray.push(placeholder[index * 3 + 1]);
				verticesArray.push(placeholder[index * 3 + 2]);
			}

			function addUV(vector2) {

				uvArray.push(vector2.x);
				uvArray.push(vector2.y);
			}
		}

		return _this81;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ExtrudeGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ExtrudeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ExtrudeGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ExtrudeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ExtrudeGeometry.prototype), 'toJSON', this).call(this);

			var shapes = this.parameters.shapes;
			var options = this.parameters.options;

			return toJSON$1(shapes, options, data);
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data, shapes) {

			var geometryShapes = [];

			for (var j = 0, jl = data.shapes.length; j < jl; j++) {

				var shape = shapes[data.shapes[j]];

				geometryShapes.push(shape);
			}

			var extrudePath = data.options.extrudePath;

			if (extrudePath !== undefined) {

				data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
			}

			return new ExtrudeGeometry(geometryShapes, data.options);
		}
	}]);

	return ExtrudeGeometry;
}(BufferGeometry);

var WorldUVGenerator = {

	generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {

		var a_x = vertices[indexA * 3];
		var a_y = vertices[indexA * 3 + 1];
		var b_x = vertices[indexB * 3];
		var b_y = vertices[indexB * 3 + 1];
		var c_x = vertices[indexC * 3];
		var c_y = vertices[indexC * 3 + 1];

		return [new Vector2(a_x, a_y), new Vector2(b_x, b_y), new Vector2(c_x, c_y)];
	},

	generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {

		var a_x = vertices[indexA * 3];
		var a_y = vertices[indexA * 3 + 1];
		var a_z = vertices[indexA * 3 + 2];
		var b_x = vertices[indexB * 3];
		var b_y = vertices[indexB * 3 + 1];
		var b_z = vertices[indexB * 3 + 2];
		var c_x = vertices[indexC * 3];
		var c_y = vertices[indexC * 3 + 1];
		var c_z = vertices[indexC * 3 + 2];
		var d_x = vertices[indexD * 3];
		var d_y = vertices[indexD * 3 + 1];
		var d_z = vertices[indexD * 3 + 2];

		if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {

			return [new Vector2(a_x, 1 - a_z), new Vector2(b_x, 1 - b_z), new Vector2(c_x, 1 - c_z), new Vector2(d_x, 1 - d_z)];
		} else {

			return [new Vector2(a_y, 1 - a_z), new Vector2(b_y, 1 - b_z), new Vector2(c_y, 1 - c_z), new Vector2(d_y, 1 - d_z)];
		}
	}

};

function toJSON$1(shapes, options, data) {

	data.shapes = [];

	if (Array.isArray(shapes)) {

		for (var i = 0, l = shapes.length; i < l; i++) {

			var shape = shapes[i];

			data.shapes.push(shape.uuid);
		}
	} else {

		data.shapes.push(shapes.uuid);
	}

	data.options = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, options);

	if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();

	return data;
}

var IcosahedronGeometry = function (_PolyhedronGeometry2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(IcosahedronGeometry, _PolyhedronGeometry2);

	function IcosahedronGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, IcosahedronGeometry);

		var t = (1 + Math.sqrt(5)) / 2;

		var vertices = [-1, t, 0, 1, t, 0, -1, -t, 0, 1, -t, 0, 0, -1, t, 0, 1, t, 0, -1, -t, 0, 1, -t, t, 0, -1, t, 0, 1, -t, 0, -1, -t, 0, 1];

		var indices = [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1];

		var _this82 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IcosahedronGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(IcosahedronGeometry)).call(this, vertices, indices, radius, detail));

		_this82.type = 'IcosahedronGeometry';

		_this82.parameters = {
			radius: radius,
			detail: detail
		};

		return _this82;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(IcosahedronGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new IcosahedronGeometry(data.radius, data.detail);
		}
	}]);

	return IcosahedronGeometry;
}(PolyhedronGeometry);

var OctahedronGeometry = function (_PolyhedronGeometry3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(OctahedronGeometry, _PolyhedronGeometry3);

	function OctahedronGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, OctahedronGeometry);

		var vertices = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1];

		var indices = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2];

		var _this83 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OctahedronGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(OctahedronGeometry)).call(this, vertices, indices, radius, detail));

		_this83.type = 'OctahedronGeometry';

		_this83.parameters = {
			radius: radius,
			detail: detail
		};

		return _this83;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(OctahedronGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new OctahedronGeometry(data.radius, data.detail);
		}
	}]);

	return OctahedronGeometry;
}(PolyhedronGeometry);

var RingGeometry = function (_BufferGeometry9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(RingGeometry, _BufferGeometry9);

	function RingGeometry() {
		var innerRadius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
		var outerRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var thetaSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 32;
		var phiSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
		var thetaStart = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
		var thetaLength = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, RingGeometry);

		var _this84 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RingGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RingGeometry)).call(this));

		_this84.type = 'RingGeometry';

		_this84.parameters = {
			innerRadius: innerRadius,
			outerRadius: outerRadius,
			thetaSegments: thetaSegments,
			phiSegments: phiSegments,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		thetaSegments = Math.max(3, thetaSegments);
		phiSegments = Math.max(1, phiSegments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// some helper variables

		var radius = innerRadius;
		var radiusStep = (outerRadius - innerRadius) / phiSegments;
		var vertex = new Vector3();
		var uv = new Vector2();

		// generate vertices, normals and uvs

		for (var j = 0; j <= phiSegments; j++) {

			for (var i = 0; i <= thetaSegments; i++) {

				// values are generate from the inside of the ring to the outside

				var segment = thetaStart + i / thetaSegments * thetaLength;

				// vertex

				vertex.x = radius * Math.cos(segment);
				vertex.y = radius * Math.sin(segment);

				vertices.push(vertex.x, vertex.y, vertex.z);

				// normal

				normals.push(0, 0, 1);

				// uv

				uv.x = (vertex.x / outerRadius + 1) / 2;
				uv.y = (vertex.y / outerRadius + 1) / 2;

				uvs.push(uv.x, uv.y);
			}

			// increase the radius for next row of vertices

			radius += radiusStep;
		}

		// indices

		for (var _j10 = 0; _j10 < phiSegments; _j10++) {

			var thetaSegmentLevel = _j10 * (thetaSegments + 1);

			for (var _i80 = 0; _i80 < thetaSegments; _i80++) {

				var _segment = _i80 + thetaSegmentLevel;

				var a = _segment;
				var b = _segment + thetaSegments + 1;
				var c = _segment + thetaSegments + 2;
				var d = _segment + 1;

				// faces

				indices.push(a, b, d);
				indices.push(b, c, d);
			}
		}

		// build geometry

		_this84.setIndex(indices);
		_this84.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this84.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this84.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		return _this84;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(RingGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(RingGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RingGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
		}
	}]);

	return RingGeometry;
}(BufferGeometry);

var ShapeGeometry = function (_BufferGeometry10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ShapeGeometry, _BufferGeometry10);

	function ShapeGeometry() {
		var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Shape([new Vector2(0, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]);
		var curveSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShapeGeometry);

		var _this85 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShapeGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShapeGeometry)).call(this));

		_this85.type = 'ShapeGeometry';

		_this85.parameters = {
			shapes: shapes,
			curveSegments: curveSegments
		};

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var groupStart = 0;
		var groupCount = 0;

		// allow single and array values for "shapes" parameter

		if (Array.isArray(shapes) === false) {

			addShape(shapes);
		} else {

			for (var i = 0; i < shapes.length; i++) {

				addShape(shapes[i]);

				_this85.addGroup(groupStart, groupCount, i); // enables MultiMaterial support

				groupStart += groupCount;
				groupCount = 0;
			}
		}

		// build geometry

		_this85.setIndex(indices);
		_this85.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this85.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this85.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		// helper functions

		function addShape(shape) {

			var indexOffset = vertices.length / 3;
			var points = shape.extractPoints(curveSegments);

			var shapeVertices = points.shape;
			var shapeHoles = points.holes;

			// check direction of vertices

			if (ShapeUtils.isClockWise(shapeVertices) === false) {

				shapeVertices = shapeVertices.reverse();
			}

			for (var _i81 = 0, l = shapeHoles.length; _i81 < l; _i81++) {

				var shapeHole = shapeHoles[_i81];

				if (ShapeUtils.isClockWise(shapeHole) === true) {

					shapeHoles[_i81] = shapeHole.reverse();
				}
			}

			var faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);

			// join vertices of inner and outer paths to a single array

			for (var _i82 = 0, _l8 = shapeHoles.length; _i82 < _l8; _i82++) {

				var _shapeHole = shapeHoles[_i82];
				shapeVertices = shapeVertices.concat(_shapeHole);
			}

			// vertices, normals, uvs

			for (var _i83 = 0, _l9 = shapeVertices.length; _i83 < _l9; _i83++) {

				var _vertex2 = shapeVertices[_i83];

				vertices.push(_vertex2.x, _vertex2.y, 0);
				normals.push(0, 0, 1);
				uvs.push(_vertex2.x, _vertex2.y); // world uvs
			}

			// indices

			for (var _i84 = 0, _l10 = faces.length; _i84 < _l10; _i84++) {

				var face = faces[_i84];

				var a = face[0] + indexOffset;
				var b = face[1] + indexOffset;
				var c = face[2] + indexOffset;

				indices.push(a, b, c);
				groupCount += 3;
			}
		}

		return _this85;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ShapeGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ShapeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShapeGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ShapeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShapeGeometry.prototype), 'toJSON', this).call(this);

			var shapes = this.parameters.shapes;

			return _toJSON(shapes, data);
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data, shapes) {

			var geometryShapes = [];

			for (var j = 0, jl = data.shapes.length; j < jl; j++) {

				var shape = shapes[data.shapes[j]];

				geometryShapes.push(shape);
			}

			return new ShapeGeometry(geometryShapes, data.curveSegments);
		}
	}]);

	return ShapeGeometry;
}(BufferGeometry);

function _toJSON(shapes, data) {

	data.shapes = [];

	if (Array.isArray(shapes)) {

		for (var i = 0, l = shapes.length; i < l; i++) {

			var shape = shapes[i];

			data.shapes.push(shape.uuid);
		}
	} else {

		data.shapes.push(shapes.uuid);
	}

	return data;
}

var SphereGeometry = function (_BufferGeometry11) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SphereGeometry, _BufferGeometry11);

	function SphereGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var widthSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
		var heightSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
		var phiStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
		var phiLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;
		var thetaStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
		var thetaLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SphereGeometry);

		var _this86 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SphereGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SphereGeometry)).call(this));

		_this86.type = 'SphereGeometry';

		_this86.parameters = {
			radius: radius,
			widthSegments: widthSegments,
			heightSegments: heightSegments,
			phiStart: phiStart,
			phiLength: phiLength,
			thetaStart: thetaStart,
			thetaLength: thetaLength
		};

		widthSegments = Math.max(3, Math.floor(widthSegments));
		heightSegments = Math.max(2, Math.floor(heightSegments));

		var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);

		var index = 0;
		var grid = [];

		var vertex = new Vector3();
		var normal = new Vector3();

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// generate vertices, normals and uvs

		for (var iy = 0; iy <= heightSegments; iy++) {

			var verticesRow = [];

			var v = iy / heightSegments;

			// special case for the poles

			var uOffset = 0;

			if (iy === 0 && thetaStart === 0) {

				uOffset = 0.5 / widthSegments;
			} else if (iy === heightSegments && thetaEnd === Math.PI) {

				uOffset = -0.5 / widthSegments;
			}

			for (var ix = 0; ix <= widthSegments; ix++) {

				var u = ix / widthSegments;

				// vertex

				vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
				vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
				vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);

				vertices.push(vertex.x, vertex.y, vertex.z);

				// normal

				normal.copy(vertex).normalize();
				normals.push(normal.x, normal.y, normal.z);

				// uv

				uvs.push(u + uOffset, 1 - v);

				verticesRow.push(index++);
			}

			grid.push(verticesRow);
		}

		// indices

		for (var _iy3 = 0; _iy3 < heightSegments; _iy3++) {

			for (var _ix3 = 0; _ix3 < widthSegments; _ix3++) {

				var a = grid[_iy3][_ix3 + 1];
				var b = grid[_iy3][_ix3];
				var c = grid[_iy3 + 1][_ix3];
				var d = grid[_iy3 + 1][_ix3 + 1];

				if (_iy3 !== 0 || thetaStart > 0) indices.push(a, b, d);
				if (_iy3 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
			}
		}

		// build geometry

		_this86.setIndex(indices);
		_this86.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this86.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this86.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		return _this86;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SphereGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SphereGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SphereGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
		}
	}]);

	return SphereGeometry;
}(BufferGeometry);

var TetrahedronGeometry = function (_PolyhedronGeometry4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TetrahedronGeometry, _PolyhedronGeometry4);

	function TetrahedronGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TetrahedronGeometry);

		var vertices = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1];

		var indices = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1];

		var _this87 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TetrahedronGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TetrahedronGeometry)).call(this, vertices, indices, radius, detail));

		_this87.type = 'TetrahedronGeometry';

		_this87.parameters = {
			radius: radius,
			detail: detail
		};

		return _this87;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(TetrahedronGeometry, null, [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new TetrahedronGeometry(data.radius, data.detail);
		}
	}]);

	return TetrahedronGeometry;
}(PolyhedronGeometry);

var TorusGeometry = function (_BufferGeometry12) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TorusGeometry, _BufferGeometry12);

	function TorusGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var tube = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
		var radialSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;
		var tubularSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 48;
		var arc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TorusGeometry);

		var _this88 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TorusGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusGeometry)).call(this));

		_this88.type = 'TorusGeometry';

		_this88.parameters = {
			radius: radius,
			tube: tube,
			radialSegments: radialSegments,
			tubularSegments: tubularSegments,
			arc: arc
		};

		radialSegments = Math.floor(radialSegments);
		tubularSegments = Math.floor(tubularSegments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var center = new Vector3();
		var vertex = new Vector3();
		var normal = new Vector3();

		// generate vertices, normals and uvs

		for (var j = 0; j <= radialSegments; j++) {

			for (var i = 0; i <= tubularSegments; i++) {

				var u = i / tubularSegments * arc;
				var v = j / radialSegments * Math.PI * 2;

				// vertex

				vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
				vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
				vertex.z = tube * Math.sin(v);

				vertices.push(vertex.x, vertex.y, vertex.z);

				// normal

				center.x = radius * Math.cos(u);
				center.y = radius * Math.sin(u);
				normal.subVectors(vertex, center).normalize();

				normals.push(normal.x, normal.y, normal.z);

				// uv

				uvs.push(i / tubularSegments);
				uvs.push(j / radialSegments);
			}
		}

		// generate indices

		for (var _j11 = 1; _j11 <= radialSegments; _j11++) {

			for (var _i85 = 1; _i85 <= tubularSegments; _i85++) {

				// indices

				var a = (tubularSegments + 1) * _j11 + _i85 - 1;
				var b = (tubularSegments + 1) * (_j11 - 1) + _i85 - 1;
				var c = (tubularSegments + 1) * (_j11 - 1) + _i85;
				var d = (tubularSegments + 1) * _j11 + _i85;

				// faces

				indices.push(a, b, d);
				indices.push(b, c, d);
			}
		}

		// build geometry

		_this88.setIndex(indices);
		_this88.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this88.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this88.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		return _this88;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(TorusGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(TorusGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
		}
	}]);

	return TorusGeometry;
}(BufferGeometry);

var TorusKnotGeometry = function (_BufferGeometry13) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TorusKnotGeometry, _BufferGeometry13);

	function TorusKnotGeometry() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var tube = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
		var tubularSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 64;
		var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
		var p = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 2;
		var q = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 3;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TorusKnotGeometry);

		var _this89 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TorusKnotGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusKnotGeometry)).call(this));

		_this89.type = 'TorusKnotGeometry';

		_this89.parameters = {
			radius: radius,
			tube: tube,
			tubularSegments: tubularSegments,
			radialSegments: radialSegments,
			p: p,
			q: q
		};

		tubularSegments = Math.floor(tubularSegments);
		radialSegments = Math.floor(radialSegments);

		// buffers

		var indices = [];
		var vertices = [];
		var normals = [];
		var uvs = [];

		// helper variables

		var vertex = new Vector3();
		var normal = new Vector3();

		var P1 = new Vector3();
		var P2 = new Vector3();

		var B = new Vector3();
		var T = new Vector3();
		var N = new Vector3();

		// generate vertices, normals and uvs

		for (var i = 0; i <= tubularSegments; ++i) {

			// the radian "u" is used to calculate the position on the torus curve of the current tubular segment

			var u = i / tubularSegments * p * Math.PI * 2;

			// now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
			// these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions

			calculatePositionOnCurve(u, p, q, radius, P1);
			calculatePositionOnCurve(u + 0.01, p, q, radius, P2);

			// calculate orthonormal basis

			T.subVectors(P2, P1);
			N.addVectors(P2, P1);
			B.crossVectors(T, N);
			N.crossVectors(B, T);

			// normalize B, N. T can be ignored, we don't use it

			B.normalize();
			N.normalize();

			for (var j = 0; j <= radialSegments; ++j) {

				// now calculate the vertices. they are nothing more than an extrusion of the torus curve.
				// because we extrude a shape in the xy-plane, there is no need to calculate a z-value.

				var v = j / radialSegments * Math.PI * 2;
				var cx = -tube * Math.cos(v);
				var cy = tube * Math.sin(v);

				// now calculate the final vertex position.
				// first we orient the extrusion with our basis vectors, then we add it to the current position on the curve

				vertex.x = P1.x + (cx * N.x + cy * B.x);
				vertex.y = P1.y + (cx * N.y + cy * B.y);
				vertex.z = P1.z + (cx * N.z + cy * B.z);

				vertices.push(vertex.x, vertex.y, vertex.z);

				// normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)

				normal.subVectors(vertex, P1).normalize();

				normals.push(normal.x, normal.y, normal.z);

				// uv

				uvs.push(i / tubularSegments);
				uvs.push(j / radialSegments);
			}
		}

		// generate indices

		for (var _j12 = 1; _j12 <= tubularSegments; _j12++) {

			for (var _i86 = 1; _i86 <= radialSegments; _i86++) {

				// indices

				var a = (radialSegments + 1) * (_j12 - 1) + (_i86 - 1);
				var b = (radialSegments + 1) * _j12 + (_i86 - 1);
				var c = (radialSegments + 1) * _j12 + _i86;
				var d = (radialSegments + 1) * (_j12 - 1) + _i86;

				// faces

				indices.push(a, b, d);
				indices.push(b, c, d);
			}
		}

		// build geometry

		_this89.setIndex(indices);
		_this89.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this89.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this89.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		// this function calculates the current position on the torus curve

		function calculatePositionOnCurve(u, p, q, radius, position) {

			var cu = Math.cos(u);
			var su = Math.sin(u);
			var quOverP = q / p * u;
			var cs = Math.cos(quOverP);

			position.x = radius * (2 + cs) * 0.5 * cu;
			position.y = radius * (2 + cs) * su * 0.5;
			position.z = radius * Math.sin(quOverP) * 0.5;
		}

		return _this89;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(TorusKnotGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(TorusKnotGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusKnotGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
		}
	}]);

	return TorusKnotGeometry;
}(BufferGeometry);

var TubeGeometry = function (_BufferGeometry14) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TubeGeometry, _BufferGeometry14);

	function TubeGeometry() {
		var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new QuadraticBezierCurve3(new Vector3(-1, -1, 0), new Vector3(-1, 1, 0), new Vector3(1, 1, 0));
		var tubularSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
		var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
		var closed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TubeGeometry);

		var _this90 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TubeGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TubeGeometry)).call(this));

		_this90.type = 'TubeGeometry';

		_this90.parameters = {
			path: path,
			tubularSegments: tubularSegments,
			radius: radius,
			radialSegments: radialSegments,
			closed: closed
		};

		var frames = path.computeFrenetFrames(tubularSegments, closed);

		// expose internals

		_this90.tangents = frames.tangents;
		_this90.normals = frames.normals;
		_this90.binormals = frames.binormals;

		// helper variables

		var vertex = new Vector3();
		var normal = new Vector3();
		var uv = new Vector2();
		var P = new Vector3();

		// buffer

		var vertices = [];
		var normals = [];
		var uvs = [];
		var indices = [];

		// create buffer data

		generateBufferData();

		// build geometry

		_this90.setIndex(indices);
		_this90.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		_this90.setAttribute('normal', new Float32BufferAttribute(normals, 3));
		_this90.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

		// functions

		function generateBufferData() {

			for (var i = 0; i < tubularSegments; i++) {

				generateSegment(i);
			}

			// if the geometry is not closed, generate the last row of vertices and normals
			// at the regular position on the given path
			//
			// if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)

			generateSegment(closed === false ? tubularSegments : 0);

			// uvs are generated in a separate function.
			// this makes it easy compute correct values for closed geometries

			generateUVs();

			// finally create faces

			generateIndices();
		}

		function generateSegment(i) {

			// we use getPointAt to sample evenly distributed points from the given path

			P = path.getPointAt(i / tubularSegments, P);

			// retrieve corresponding normal and binormal

			var N = frames.normals[i];
			var B = frames.binormals[i];

			// generate normals and vertices for the current segment

			for (var j = 0; j <= radialSegments; j++) {

				var v = j / radialSegments * Math.PI * 2;

				var sin = Math.sin(v);
				var cos = -Math.cos(v);

				// normal

				normal.x = cos * N.x + sin * B.x;
				normal.y = cos * N.y + sin * B.y;
				normal.z = cos * N.z + sin * B.z;
				normal.normalize();

				normals.push(normal.x, normal.y, normal.z);

				// vertex

				vertex.x = P.x + radius * normal.x;
				vertex.y = P.y + radius * normal.y;
				vertex.z = P.z + radius * normal.z;

				vertices.push(vertex.x, vertex.y, vertex.z);
			}
		}

		function generateIndices() {

			for (var j = 1; j <= tubularSegments; j++) {

				for (var i = 1; i <= radialSegments; i++) {

					var a = (radialSegments + 1) * (j - 1) + (i - 1);
					var b = (radialSegments + 1) * j + (i - 1);
					var c = (radialSegments + 1) * j + i;
					var d = (radialSegments + 1) * (j - 1) + i;

					// faces

					indices.push(a, b, d);
					indices.push(b, c, d);
				}
			}
		}

		function generateUVs() {

			for (var i = 0; i <= tubularSegments; i++) {

				for (var j = 0; j <= radialSegments; j++) {

					uv.x = i / tubularSegments;
					uv.y = j / radialSegments;

					uvs.push(uv.x, uv.y);
				}
			}
		}

		return _this90;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(TubeGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(TubeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TubeGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(TubeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TubeGeometry.prototype), 'toJSON', this).call(this);

			data.path = this.parameters.path.toJSON();

			return data;
		}
	}], [{
		key: 'fromJSON',
		value: function fromJSON(data) {

			// This only works for built-in curves (e.g. CatmullRomCurve3).
			// User defined curves or instances of CurvePath will not be deserialized.
			return new TubeGeometry(new Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
		}
	}]);

	return TubeGeometry;
}(BufferGeometry);

var WireframeGeometry = function (_BufferGeometry15) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(WireframeGeometry, _BufferGeometry15);

	function WireframeGeometry() {
		var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, WireframeGeometry);

		var _this91 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WireframeGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WireframeGeometry)).call(this));

		_this91.type = 'WireframeGeometry';

		_this91.parameters = {
			geometry: geometry
		};

		if (geometry !== null) {

			// buffer

			var _vertices3 = [];
			var edges = new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a();

			// helper variables

			var start = new Vector3();
			var end = new Vector3();

			if (geometry.index !== null) {

				// indexed BufferGeometry

				var position = geometry.attributes.position;
				var _indices = geometry.index;
				var groups = geometry.groups;

				if (groups.length === 0) {

					groups = [{ start: 0, count: _indices.count, materialIndex: 0 }];
				}

				// create a data structure that contains all edges without duplicates

				for (var o = 0, ol = groups.length; o < ol; ++o) {

					var group = groups[o];

					var _groupStart = group.start;
					var _groupCount = group.count;

					for (var i = _groupStart, l = _groupStart + _groupCount; i < l; i += 3) {

						for (var j = 0; j < 3; j++) {

							var index1 = _indices.getX(i + j);
							var index2 = _indices.getX(i + (j + 1) % 3);

							start.fromBufferAttribute(position, index1);
							end.fromBufferAttribute(position, index2);

							if (isUniqueEdge(start, end, edges) === true) {

								_vertices3.push(start.x, start.y, start.z);
								_vertices3.push(end.x, end.y, end.z);
							}
						}
					}
				}
			} else {

				// non-indexed BufferGeometry

				var _position2 = geometry.attributes.position;

				for (var _i87 = 0, _l11 = _position2.count / 3; _i87 < _l11; _i87++) {

					for (var _j13 = 0; _j13 < 3; _j13++) {

						// three edges per triangle, an edge is represented as (index1, index2)
						// e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)

						var _index = 3 * _i87 + _j13;
						var _index2 = 3 * _i87 + (_j13 + 1) % 3;

						start.fromBufferAttribute(_position2, _index);
						end.fromBufferAttribute(_position2, _index2);

						if (isUniqueEdge(start, end, edges) === true) {

							_vertices3.push(start.x, start.y, start.z);
							_vertices3.push(end.x, end.y, end.z);
						}
					}
				}
			}

			// build geometry

			_this91.setAttribute('position', new Float32BufferAttribute(_vertices3, 3));
		}

		return _this91;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(WireframeGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(WireframeGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(WireframeGeometry.prototype), 'copy', this).call(this, source);

			this.parameters = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, source.parameters);

			return this;
		}
	}]);

	return WireframeGeometry;
}(BufferGeometry);

function isUniqueEdge(start, end, edges) {

	var hash1 = start.x + ',' + start.y + ',' + start.z + '-' + end.x + ',' + end.y + ',' + end.z;
	var hash2 = end.x + ',' + end.y + ',' + end.z + '-' + start.x + ',' + start.y + ',' + start.z; // coincident edge

	if (edges.has(hash1) === true || edges.has(hash2) === true) {

		return false;
	} else {

		edges.add(hash1);
		edges.add(hash2);
		return true;
	}
}

var Geometries = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_freeze___default()({
	__proto__: null,
	BoxGeometry: BoxGeometry,
	CapsuleGeometry: CapsuleGeometry,
	CircleGeometry: CircleGeometry,
	ConeGeometry: ConeGeometry,
	CylinderGeometry: CylinderGeometry,
	DodecahedronGeometry: DodecahedronGeometry,
	EdgesGeometry: EdgesGeometry,
	ExtrudeGeometry: ExtrudeGeometry,
	IcosahedronGeometry: IcosahedronGeometry,
	LatheGeometry: LatheGeometry,
	OctahedronGeometry: OctahedronGeometry,
	PlaneGeometry: PlaneGeometry,
	PolyhedronGeometry: PolyhedronGeometry,
	RingGeometry: RingGeometry,
	ShapeGeometry: ShapeGeometry,
	SphereGeometry: SphereGeometry,
	TetrahedronGeometry: TetrahedronGeometry,
	TorusGeometry: TorusGeometry,
	TorusKnotGeometry: TorusKnotGeometry,
	TubeGeometry: TubeGeometry,
	WireframeGeometry: WireframeGeometry
});

var ShadowMaterial = function (_Material8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ShadowMaterial, _Material8);

	function ShadowMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShadowMaterial);

		var _this92 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShadowMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShadowMaterial)).call(this));

		_this92.isShadowMaterial = true;

		_this92.type = 'ShadowMaterial';

		_this92.color = new Color(0x000000);
		_this92.transparent = true;

		_this92.fog = true;

		_this92.setValues(parameters);

		return _this92;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ShadowMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ShadowMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShadowMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.fog = source.fog;

			return this;
		}
	}]);

	return ShadowMaterial;
}(Material);

var RawShaderMaterial = function (_ShaderMaterial) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(RawShaderMaterial, _ShaderMaterial);

	function RawShaderMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, RawShaderMaterial);

		var _this93 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RawShaderMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RawShaderMaterial)).call(this, parameters));

		_this93.isRawShaderMaterial = true;

		_this93.type = 'RawShaderMaterial';

		return _this93;
	}

	return RawShaderMaterial;
}(ShaderMaterial);

var MeshStandardMaterial = function (_Material9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshStandardMaterial, _Material9);

	function MeshStandardMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshStandardMaterial);

		var _this94 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshStandardMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshStandardMaterial)).call(this));

		_this94.isMeshStandardMaterial = true;

		_this94.defines = { 'STANDARD': '' };

		_this94.type = 'MeshStandardMaterial';

		_this94.color = new Color(0xffffff); // diffuse
		_this94.roughness = 1.0;
		_this94.metalness = 0.0;

		_this94.map = null;

		_this94.lightMap = null;
		_this94.lightMapIntensity = 1.0;

		_this94.aoMap = null;
		_this94.aoMapIntensity = 1.0;

		_this94.emissive = new Color(0x000000);
		_this94.emissiveIntensity = 1.0;
		_this94.emissiveMap = null;

		_this94.bumpMap = null;
		_this94.bumpScale = 1;

		_this94.normalMap = null;
		_this94.normalMapType = TangentSpaceNormalMap;
		_this94.normalScale = new Vector2(1, 1);

		_this94.displacementMap = null;
		_this94.displacementScale = 1;
		_this94.displacementBias = 0;

		_this94.roughnessMap = null;

		_this94.metalnessMap = null;

		_this94.alphaMap = null;

		_this94.envMap = null;
		_this94.envMapIntensity = 1.0;

		_this94.wireframe = false;
		_this94.wireframeLinewidth = 1;
		_this94.wireframeLinecap = 'round';
		_this94.wireframeLinejoin = 'round';

		_this94.flatShading = false;

		_this94.fog = true;

		_this94.setValues(parameters);

		return _this94;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshStandardMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshStandardMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshStandardMaterial.prototype), 'copy', this).call(this, source);

			this.defines = { 'STANDARD': '' };

			this.color.copy(source.color);
			this.roughness = source.roughness;
			this.metalness = source.metalness;

			this.map = source.map;

			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;

			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;

			this.emissive.copy(source.emissive);
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.roughnessMap = source.roughnessMap;

			this.metalnessMap = source.metalnessMap;

			this.alphaMap = source.alphaMap;

			this.envMap = source.envMap;
			this.envMapIntensity = source.envMapIntensity;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;

			this.flatShading = source.flatShading;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshStandardMaterial;
}(Material);

var MeshPhysicalMaterial = function (_MeshStandardMaterial) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshPhysicalMaterial, _MeshStandardMaterial);

	function MeshPhysicalMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshPhysicalMaterial);

		var _this95 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshPhysicalMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshPhysicalMaterial)).call(this));

		_this95.isMeshPhysicalMaterial = true;

		_this95.defines = {

			'STANDARD': '',
			'PHYSICAL': ''

		};

		_this95.type = 'MeshPhysicalMaterial';

		_this95.clearcoatMap = null;
		_this95.clearcoatRoughness = 0.0;
		_this95.clearcoatRoughnessMap = null;
		_this95.clearcoatNormalScale = new Vector2(1, 1);
		_this95.clearcoatNormalMap = null;

		_this95.ior = 1.5;

		Object.defineProperty(_this95, 'reflectivity', {
			get: function get() {

				return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
			},
			set: function set(reflectivity) {

				this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
			}
		});

		_this95.iridescenceMap = null;
		_this95.iridescenceIOR = 1.3;
		_this95.iridescenceThicknessRange = [100, 400];
		_this95.iridescenceThicknessMap = null;

		_this95.sheenColor = new Color(0x000000);
		_this95.sheenColorMap = null;
		_this95.sheenRoughness = 1.0;
		_this95.sheenRoughnessMap = null;

		_this95.transmissionMap = null;

		_this95.thickness = 0;
		_this95.thicknessMap = null;
		_this95.attenuationDistance = Infinity;
		_this95.attenuationColor = new Color(1, 1, 1);

		_this95.specularIntensity = 1.0;
		_this95.specularIntensityMap = null;
		_this95.specularColor = new Color(1, 1, 1);
		_this95.specularColorMap = null;

		_this95._sheen = 0.0;
		_this95._clearcoat = 0;
		_this95._iridescence = 0;
		_this95._transmission = 0;

		_this95.setValues(parameters);

		return _this95;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshPhysicalMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshPhysicalMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshPhysicalMaterial.prototype), 'copy', this).call(this, source);

			this.defines = {

				'STANDARD': '',
				'PHYSICAL': ''

			};

			this.clearcoat = source.clearcoat;
			this.clearcoatMap = source.clearcoatMap;
			this.clearcoatRoughness = source.clearcoatRoughness;
			this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
			this.clearcoatNormalMap = source.clearcoatNormalMap;
			this.clearcoatNormalScale.copy(source.clearcoatNormalScale);

			this.ior = source.ior;

			this.iridescence = source.iridescence;
			this.iridescenceMap = source.iridescenceMap;
			this.iridescenceIOR = source.iridescenceIOR;
			this.iridescenceThicknessRange = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(source.iridescenceThicknessRange));
			this.iridescenceThicknessMap = source.iridescenceThicknessMap;

			this.sheen = source.sheen;
			this.sheenColor.copy(source.sheenColor);
			this.sheenColorMap = source.sheenColorMap;
			this.sheenRoughness = source.sheenRoughness;
			this.sheenRoughnessMap = source.sheenRoughnessMap;

			this.transmission = source.transmission;
			this.transmissionMap = source.transmissionMap;

			this.thickness = source.thickness;
			this.thicknessMap = source.thicknessMap;
			this.attenuationDistance = source.attenuationDistance;
			this.attenuationColor.copy(source.attenuationColor);

			this.specularIntensity = source.specularIntensity;
			this.specularIntensityMap = source.specularIntensityMap;
			this.specularColor.copy(source.specularColor);
			this.specularColorMap = source.specularColorMap;

			return this;
		}
	}, {
		key: 'sheen',
		get: function get() {

			return this._sheen;
		},
		set: function set(value) {

			if (this._sheen > 0 !== value > 0) {

				this.version++;
			}

			this._sheen = value;
		}
	}, {
		key: 'clearcoat',
		get: function get() {

			return this._clearcoat;
		},
		set: function set(value) {

			if (this._clearcoat > 0 !== value > 0) {

				this.version++;
			}

			this._clearcoat = value;
		}
	}, {
		key: 'iridescence',
		get: function get() {

			return this._iridescence;
		},
		set: function set(value) {

			if (this._iridescence > 0 !== value > 0) {

				this.version++;
			}

			this._iridescence = value;
		}
	}, {
		key: 'transmission',
		get: function get() {

			return this._transmission;
		},
		set: function set(value) {

			if (this._transmission > 0 !== value > 0) {

				this.version++;
			}

			this._transmission = value;
		}
	}]);

	return MeshPhysicalMaterial;
}(MeshStandardMaterial);

var MeshPhongMaterial = function (_Material10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshPhongMaterial, _Material10);

	function MeshPhongMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshPhongMaterial);

		var _this96 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshPhongMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshPhongMaterial)).call(this));

		_this96.isMeshPhongMaterial = true;

		_this96.type = 'MeshPhongMaterial';

		_this96.color = new Color(0xffffff); // diffuse
		_this96.specular = new Color(0x111111);
		_this96.shininess = 30;

		_this96.map = null;

		_this96.lightMap = null;
		_this96.lightMapIntensity = 1.0;

		_this96.aoMap = null;
		_this96.aoMapIntensity = 1.0;

		_this96.emissive = new Color(0x000000);
		_this96.emissiveIntensity = 1.0;
		_this96.emissiveMap = null;

		_this96.bumpMap = null;
		_this96.bumpScale = 1;

		_this96.normalMap = null;
		_this96.normalMapType = TangentSpaceNormalMap;
		_this96.normalScale = new Vector2(1, 1);

		_this96.displacementMap = null;
		_this96.displacementScale = 1;
		_this96.displacementBias = 0;

		_this96.specularMap = null;

		_this96.alphaMap = null;

		_this96.envMap = null;
		_this96.combine = MultiplyOperation;
		_this96.reflectivity = 1;
		_this96.refractionRatio = 0.98;

		_this96.wireframe = false;
		_this96.wireframeLinewidth = 1;
		_this96.wireframeLinecap = 'round';
		_this96.wireframeLinejoin = 'round';

		_this96.flatShading = false;

		_this96.fog = true;

		_this96.setValues(parameters);

		return _this96;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshPhongMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshPhongMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshPhongMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);
			this.specular.copy(source.specular);
			this.shininess = source.shininess;

			this.map = source.map;

			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;

			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;

			this.emissive.copy(source.emissive);
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.specularMap = source.specularMap;

			this.alphaMap = source.alphaMap;

			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;

			this.flatShading = source.flatShading;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshPhongMaterial;
}(Material);

var MeshToonMaterial = function (_Material11) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshToonMaterial, _Material11);

	function MeshToonMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshToonMaterial);

		var _this97 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshToonMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshToonMaterial)).call(this));

		_this97.isMeshToonMaterial = true;

		_this97.defines = { 'TOON': '' };

		_this97.type = 'MeshToonMaterial';

		_this97.color = new Color(0xffffff);

		_this97.map = null;
		_this97.gradientMap = null;

		_this97.lightMap = null;
		_this97.lightMapIntensity = 1.0;

		_this97.aoMap = null;
		_this97.aoMapIntensity = 1.0;

		_this97.emissive = new Color(0x000000);
		_this97.emissiveIntensity = 1.0;
		_this97.emissiveMap = null;

		_this97.bumpMap = null;
		_this97.bumpScale = 1;

		_this97.normalMap = null;
		_this97.normalMapType = TangentSpaceNormalMap;
		_this97.normalScale = new Vector2(1, 1);

		_this97.displacementMap = null;
		_this97.displacementScale = 1;
		_this97.displacementBias = 0;

		_this97.alphaMap = null;

		_this97.wireframe = false;
		_this97.wireframeLinewidth = 1;
		_this97.wireframeLinecap = 'round';
		_this97.wireframeLinejoin = 'round';

		_this97.fog = true;

		_this97.setValues(parameters);

		return _this97;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshToonMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshToonMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshToonMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;
			this.gradientMap = source.gradientMap;

			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;

			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;

			this.emissive.copy(source.emissive);
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.alphaMap = source.alphaMap;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshToonMaterial;
}(Material);

var MeshNormalMaterial = function (_Material12) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshNormalMaterial, _Material12);

	function MeshNormalMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshNormalMaterial);

		var _this98 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshNormalMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshNormalMaterial)).call(this));

		_this98.isMeshNormalMaterial = true;

		_this98.type = 'MeshNormalMaterial';

		_this98.bumpMap = null;
		_this98.bumpScale = 1;

		_this98.normalMap = null;
		_this98.normalMapType = TangentSpaceNormalMap;
		_this98.normalScale = new Vector2(1, 1);

		_this98.displacementMap = null;
		_this98.displacementScale = 1;
		_this98.displacementBias = 0;

		_this98.wireframe = false;
		_this98.wireframeLinewidth = 1;

		_this98.flatShading = false;

		_this98.setValues(parameters);

		return _this98;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshNormalMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshNormalMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshNormalMaterial.prototype), 'copy', this).call(this, source);

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;

			this.flatShading = source.flatShading;

			return this;
		}
	}]);

	return MeshNormalMaterial;
}(Material);

var MeshLambertMaterial = function (_Material13) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshLambertMaterial, _Material13);

	function MeshLambertMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshLambertMaterial);

		var _this99 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshLambertMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshLambertMaterial)).call(this));

		_this99.isMeshLambertMaterial = true;

		_this99.type = 'MeshLambertMaterial';

		_this99.color = new Color(0xffffff); // diffuse

		_this99.map = null;

		_this99.lightMap = null;
		_this99.lightMapIntensity = 1.0;

		_this99.aoMap = null;
		_this99.aoMapIntensity = 1.0;

		_this99.emissive = new Color(0x000000);
		_this99.emissiveIntensity = 1.0;
		_this99.emissiveMap = null;

		_this99.bumpMap = null;
		_this99.bumpScale = 1;

		_this99.normalMap = null;
		_this99.normalMapType = TangentSpaceNormalMap;
		_this99.normalScale = new Vector2(1, 1);

		_this99.displacementMap = null;
		_this99.displacementScale = 1;
		_this99.displacementBias = 0;

		_this99.specularMap = null;

		_this99.alphaMap = null;

		_this99.envMap = null;
		_this99.combine = MultiplyOperation;
		_this99.reflectivity = 1;
		_this99.refractionRatio = 0.98;

		_this99.wireframe = false;
		_this99.wireframeLinewidth = 1;
		_this99.wireframeLinecap = 'round';
		_this99.wireframeLinejoin = 'round';

		_this99.flatShading = false;

		_this99.fog = true;

		_this99.setValues(parameters);

		return _this99;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshLambertMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshLambertMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshLambertMaterial.prototype), 'copy', this).call(this, source);

			this.color.copy(source.color);

			this.map = source.map;

			this.lightMap = source.lightMap;
			this.lightMapIntensity = source.lightMapIntensity;

			this.aoMap = source.aoMap;
			this.aoMapIntensity = source.aoMapIntensity;

			this.emissive.copy(source.emissive);
			this.emissiveMap = source.emissiveMap;
			this.emissiveIntensity = source.emissiveIntensity;

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.specularMap = source.specularMap;

			this.alphaMap = source.alphaMap;

			this.envMap = source.envMap;
			this.combine = source.combine;
			this.reflectivity = source.reflectivity;
			this.refractionRatio = source.refractionRatio;

			this.wireframe = source.wireframe;
			this.wireframeLinewidth = source.wireframeLinewidth;
			this.wireframeLinecap = source.wireframeLinecap;
			this.wireframeLinejoin = source.wireframeLinejoin;

			this.flatShading = source.flatShading;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshLambertMaterial;
}(Material);

var MeshMatcapMaterial = function (_Material14) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MeshMatcapMaterial, _Material14);

	function MeshMatcapMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MeshMatcapMaterial);

		var _this100 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MeshMatcapMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshMatcapMaterial)).call(this));

		_this100.isMeshMatcapMaterial = true;

		_this100.defines = { 'MATCAP': '' };

		_this100.type = 'MeshMatcapMaterial';

		_this100.color = new Color(0xffffff); // diffuse

		_this100.matcap = null;

		_this100.map = null;

		_this100.bumpMap = null;
		_this100.bumpScale = 1;

		_this100.normalMap = null;
		_this100.normalMapType = TangentSpaceNormalMap;
		_this100.normalScale = new Vector2(1, 1);

		_this100.displacementMap = null;
		_this100.displacementScale = 1;
		_this100.displacementBias = 0;

		_this100.alphaMap = null;

		_this100.flatShading = false;

		_this100.fog = true;

		_this100.setValues(parameters);

		return _this100;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MeshMatcapMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(MeshMatcapMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MeshMatcapMaterial.prototype), 'copy', this).call(this, source);

			this.defines = { 'MATCAP': '' };

			this.color.copy(source.color);

			this.matcap = source.matcap;

			this.map = source.map;

			this.bumpMap = source.bumpMap;
			this.bumpScale = source.bumpScale;

			this.normalMap = source.normalMap;
			this.normalMapType = source.normalMapType;
			this.normalScale.copy(source.normalScale);

			this.displacementMap = source.displacementMap;
			this.displacementScale = source.displacementScale;
			this.displacementBias = source.displacementBias;

			this.alphaMap = source.alphaMap;

			this.flatShading = source.flatShading;

			this.fog = source.fog;

			return this;
		}
	}]);

	return MeshMatcapMaterial;
}(Material);

var LineDashedMaterial = function (_LineBasicMaterial) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LineDashedMaterial, _LineBasicMaterial);

	function LineDashedMaterial(parameters) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LineDashedMaterial);

		var _this101 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LineDashedMaterial.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineDashedMaterial)).call(this));

		_this101.isLineDashedMaterial = true;

		_this101.type = 'LineDashedMaterial';

		_this101.scale = 1;
		_this101.dashSize = 3;
		_this101.gapSize = 1;

		_this101.setValues(parameters);

		return _this101;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LineDashedMaterial, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LineDashedMaterial.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LineDashedMaterial.prototype), 'copy', this).call(this, source);

			this.scale = source.scale;
			this.dashSize = source.dashSize;
			this.gapSize = source.gapSize;

			return this;
		}
	}]);

	return LineDashedMaterial;
}(LineBasicMaterial);

// same as Array.prototype.slice, but also works on typed arrays


function arraySlice(array, from, to) {

	if (isTypedArray(array)) {

		// in ios9 array.subarray(from, undefined) will return empty array
		// but array.subarray(from) or array.subarray(from, len) is correct
		return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
	}

	return array.slice(from, to);
}

// converts an array to a specific type
function convertArray(array, type, forceClone) {

	if (!array || // let 'undefined' and 'null' pass
	!forceClone && array.constructor === type) return array;

	if (typeof type.BYTES_PER_ELEMENT === 'number') {

		return new type(array); // create typed array
	}

	return Array.prototype.slice.call(array); // create Array
}

function isTypedArray(object) {

	return ArrayBuffer.isView(object) && !(object instanceof DataView);
}

// returns an array by which times and values can be sorted
function getKeyframeOrder(times) {

	function compareTime(i, j) {

		return times[i] - times[j];
	}

	var n = times.length;
	var result = new Array(n);
	for (var i = 0; i !== n; ++i) {
		result[i] = i;
	}result.sort(compareTime);

	return result;
}

// uses the array previously returned by 'getKeyframeOrder' to sort data
function sortedArray(values, stride, order) {

	var nValues = values.length;
	var result = new values.constructor(nValues);

	for (var i = 0, dstOffset = 0; dstOffset !== nValues; ++i) {

		var srcOffset = order[i] * stride;

		for (var j = 0; j !== stride; ++j) {

			result[dstOffset++] = values[srcOffset + j];
		}
	}

	return result;
}

// function for parsing AOS keyframe formats
function flattenJSON(jsonKeys, times, values, valuePropertyName) {

	var i = 1,
	    key = jsonKeys[0];

	while (key !== undefined && key[valuePropertyName] === undefined) {

		key = jsonKeys[i++];
	}

	if (key === undefined) return; // no data

	var value = key[valuePropertyName];
	if (value === undefined) return; // no data

	if (Array.isArray(value)) {

		do {

			value = key[valuePropertyName];

			if (value !== undefined) {

				times.push(key.time);
				values.push.apply(values, value); // push all elements
			}

			key = jsonKeys[i++];
		} while (key !== undefined);
	} else if (value.toArray !== undefined) {

		// ...assume THREE.Math-ish

		do {

			value = key[valuePropertyName];

			if (value !== undefined) {

				times.push(key.time);
				value.toArray(values, values.length);
			}

			key = jsonKeys[i++];
		} while (key !== undefined);
	} else {

		// otherwise push as-is

		do {

			value = key[valuePropertyName];

			if (value !== undefined) {

				times.push(key.time);
				values.push(value);
			}

			key = jsonKeys[i++];
		} while (key !== undefined);
	}
}

function subclip(sourceClip, name, startFrame, endFrame) {
	var fps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;


	var clip = sourceClip.clone();

	clip.name = name;

	var tracks = [];

	for (var i = 0; i < clip.tracks.length; ++i) {

		var track = clip.tracks[i];
		var valueSize = track.getValueSize();

		var times = [];
		var values = [];

		for (var j = 0; j < track.times.length; ++j) {

			var frame = track.times[j] * fps;

			if (frame < startFrame || frame >= endFrame) continue;

			times.push(track.times[j]);

			for (var k = 0; k < valueSize; ++k) {

				values.push(track.values[j * valueSize + k]);
			}
		}

		if (times.length === 0) continue;

		track.times = convertArray(times, track.times.constructor);
		track.values = convertArray(values, track.values.constructor);

		tracks.push(track);
	}

	clip.tracks = tracks;

	// find minimum .times value across all tracks in the trimmed clip

	var minStartTime = Infinity;

	for (var _i88 = 0; _i88 < clip.tracks.length; ++_i88) {

		if (minStartTime > clip.tracks[_i88].times[0]) {

			minStartTime = clip.tracks[_i88].times[0];
		}
	}

	// shift all tracks such that clip begins at t=0

	for (var _i89 = 0; _i89 < clip.tracks.length; ++_i89) {

		clip.tracks[_i89].shift(-1 * minStartTime);
	}

	clip.resetDuration();

	return clip;
}

function makeClipAdditive(targetClip) {
	var referenceFrame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	var referenceClip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : targetClip;
	var fps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;


	if (fps <= 0) fps = 30;

	var numTracks = referenceClip.tracks.length;
	var referenceTime = referenceFrame / fps;

	// Make each track's values relative to the values at the reference frame

	var _loop = function _loop(i) {

		var referenceTrack = referenceClip.tracks[i];
		var referenceTrackType = referenceTrack.ValueTypeName;

		// Skip this track if it's non-numeric
		if (referenceTrackType === 'bool' || referenceTrackType === 'string') return 'continue';

		// Find the track in the target clip whose name and type matches the reference track
		var targetTrack = targetClip.tracks.find(function (track) {

			return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
		});

		if (targetTrack === undefined) return 'continue';

		var referenceOffset = 0;
		var referenceValueSize = referenceTrack.getValueSize();

		if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {

			referenceOffset = referenceValueSize / 3;
		}

		var targetOffset = 0;
		var targetValueSize = targetTrack.getValueSize();

		if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {

			targetOffset = targetValueSize / 3;
		}

		var lastIndex = referenceTrack.times.length - 1;
		var referenceValue = void 0;

		// Find the value to subtract out of the track
		if (referenceTime <= referenceTrack.times[0]) {

			// Reference frame is earlier than the first keyframe, so just use the first keyframe
			var startIndex = referenceOffset;
			var endIndex = referenceValueSize - referenceOffset;
			referenceValue = arraySlice(referenceTrack.values, startIndex, endIndex);
		} else if (referenceTime >= referenceTrack.times[lastIndex]) {

			// Reference frame is after the last keyframe, so just use the last keyframe
			var _startIndex = lastIndex * referenceValueSize + referenceOffset;
			var _endIndex = _startIndex + referenceValueSize - referenceOffset;
			referenceValue = arraySlice(referenceTrack.values, _startIndex, _endIndex);
		} else {

			// Interpolate to the reference value
			var interpolant = referenceTrack.createInterpolant();
			var _startIndex2 = referenceOffset;
			var _endIndex2 = referenceValueSize - referenceOffset;
			interpolant.evaluate(referenceTime);
			referenceValue = arraySlice(interpolant.resultBuffer, _startIndex2, _endIndex2);
		}

		// Conjugate the quaternion
		if (referenceTrackType === 'quaternion') {

			var referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
			referenceQuat.toArray(referenceValue);
		}

		// Subtract the reference value from all of the track values

		var numTimes = targetTrack.times.length;
		for (var j = 0; j < numTimes; ++j) {

			var valueStart = j * targetValueSize + targetOffset;

			if (referenceTrackType === 'quaternion') {

				// Multiply the conjugate for quaternion track types
				Quaternion.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
			} else {

				var valueEnd = targetValueSize - targetOffset * 2;

				// Subtract each value for all other numeric track types
				for (var k = 0; k < valueEnd; ++k) {

					targetTrack.values[valueStart + k] -= referenceValue[k];
				}
			}
		}
	};

	for (var i = 0; i < numTracks; ++i) {
		var _ret = _loop(i);

		if (_ret === 'continue') continue;
	}

	targetClip.blendMode = AdditiveAnimationBlendMode;

	return targetClip;
}

var AnimationUtils = {
	arraySlice: arraySlice,
	convertArray: convertArray,
	isTypedArray: isTypedArray,
	getKeyframeOrder: getKeyframeOrder,
	sortedArray: sortedArray,
	flattenJSON: flattenJSON,
	subclip: subclip,
	makeClipAdditive: makeClipAdditive
};

/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */

var Interpolant = function () {
	function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Interpolant);

		this.parameterPositions = parameterPositions;
		this._cachedIndex = 0;

		this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
		this.sampleValues = sampleValues;
		this.valueSize = sampleSize;

		this.settings = null;
		this.DefaultSettings_ = {};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Interpolant, [{
		key: 'evaluate',
		value: function evaluate(t) {

			var pp = this.parameterPositions;
			var i1 = this._cachedIndex,
			    t1 = pp[i1],
			    t0 = pp[i1 - 1];

			validate_interval: {

				seek: {

					var right = void 0;

					linear_scan: {

						//- See http://jsperf.com/comparison-to-undefined/3
						//- slower code:
						//-
						//- 				if ( t >= t1 || t1 === undefined ) {
						forward_scan: if (!(t < t1)) {

							for (var giveUpAt = i1 + 2;;) {

								if (t1 === undefined) {

									if (t < t0) break forward_scan;

									// after end

									i1 = pp.length;
									this._cachedIndex = i1;
									return this.copySampleValue_(i1 - 1);
								}

								if (i1 === giveUpAt) break; // this loop

								t0 = t1;
								t1 = pp[++i1];

								if (t < t1) {

									// we have arrived at the sought interval
									break seek;
								}
							}

							// prepare binary search on the right side of the index
							right = pp.length;
							break linear_scan;
						}

						//- slower code:
						//-					if ( t < t0 || t0 === undefined ) {
						if (!(t >= t0)) {

							// looping?

							var t1global = pp[1];

							if (t < t1global) {

								i1 = 2; // + 1, using the scan for the details
								t0 = t1global;
							}

							// linear reverse scan

							for (var _giveUpAt = i1 - 2;;) {

								if (t0 === undefined) {

									// before start

									this._cachedIndex = 0;
									return this.copySampleValue_(0);
								}

								if (i1 === _giveUpAt) break; // this loop

								t1 = t0;
								t0 = pp[--i1 - 1];

								if (t >= t0) {

									// we have arrived at the sought interval
									break seek;
								}
							}

							// prepare binary search on the left side of the index
							right = i1;
							i1 = 0;
							break linear_scan;
						}

						// the interval is valid

						break validate_interval;
					} // linear scan

					// binary search

					while (i1 < right) {

						var mid = i1 + right >>> 1;

						if (t < pp[mid]) {

							right = mid;
						} else {

							i1 = mid + 1;
						}
					}

					t1 = pp[i1];
					t0 = pp[i1 - 1];

					// check boundary cases, again

					if (t0 === undefined) {

						this._cachedIndex = 0;
						return this.copySampleValue_(0);
					}

					if (t1 === undefined) {

						i1 = pp.length;
						this._cachedIndex = i1;
						return this.copySampleValue_(i1 - 1);
					}
				} // seek

				this._cachedIndex = i1;

				this.intervalChanged_(i1, t0, t1);
			} // validate_interval

			return this.interpolate_(i1, t0, t, t1);
		}
	}, {
		key: 'getSettings_',
		value: function getSettings_() {

			return this.settings || this.DefaultSettings_;
		}
	}, {
		key: 'copySampleValue_',
		value: function copySampleValue_(index) {

			// copies a sample value to the result buffer

			var result = this.resultBuffer,
			    values = this.sampleValues,
			    stride = this.valueSize,
			    offset = index * stride;

			for (var i = 0; i !== stride; ++i) {

				result[i] = values[offset + i];
			}

			return result;
		}

		// Template methods for derived classes:

	}, {
		key: 'interpolate_',
		value: function interpolate_() /* i1, t0, t, t1 */{

			throw new Error('call to abstract method');
			// implementations shall return this.resultBuffer
		}
	}, {
		key: 'intervalChanged_',
		value: function intervalChanged_() /* i1, t0, t1 */{

			// empty

		}
	}]);

	return Interpolant;
}();

/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */

var CubicInterpolant = function (_Interpolant) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubicInterpolant, _Interpolant);

	function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubicInterpolant);

		var _this102 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubicInterpolant.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubicInterpolant)).call(this, parameterPositions, sampleValues, sampleSize, resultBuffer));

		_this102._weightPrev = -0;
		_this102._offsetPrev = -0;
		_this102._weightNext = -0;
		_this102._offsetNext = -0;

		_this102.DefaultSettings_ = {

			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding

		};

		return _this102;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubicInterpolant, [{
		key: 'intervalChanged_',
		value: function intervalChanged_(i1, t0, t1) {

			var pp = this.parameterPositions;
			var iPrev = i1 - 2,
			    iNext = i1 + 1,
			    tPrev = pp[iPrev],
			    tNext = pp[iNext];

			if (tPrev === undefined) {

				switch (this.getSettings_().endingStart) {

					case ZeroSlopeEnding:

						// f'(t0) = 0
						iPrev = i1;
						tPrev = 2 * t0 - t1;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iPrev = pp.length - 2;
						tPrev = t0 + pp[iPrev] - pp[iPrev + 1];

						break;

					default:
						// ZeroCurvatureEnding

						// f''(t0) = 0 a.k.a. Natural Spline
						iPrev = i1;
						tPrev = t1;

				}
			}

			if (tNext === undefined) {

				switch (this.getSettings_().endingEnd) {

					case ZeroSlopeEnding:

						// f'(tN) = 0
						iNext = i1;
						tNext = 2 * t1 - t0;

						break;

					case WrapAroundEnding:

						// use the other end of the curve
						iNext = 1;
						tNext = t1 + pp[1] - pp[0];

						break;

					default:
						// ZeroCurvatureEnding

						// f''(tN) = 0, a.k.a. Natural Spline
						iNext = i1 - 1;
						tNext = t0;

				}
			}

			var halfDt = (t1 - t0) * 0.5,
			    stride = this.valueSize;

			this._weightPrev = halfDt / (t0 - tPrev);
			this._weightNext = halfDt / (tNext - t1);
			this._offsetPrev = iPrev * stride;
			this._offsetNext = iNext * stride;
		}
	}, {
		key: 'interpolate_',
		value: function interpolate_(i1, t0, t, t1) {

			var result = this.resultBuffer,
			    values = this.sampleValues,
			    stride = this.valueSize,
			    o1 = i1 * stride,
			    o0 = o1 - stride,
			    oP = this._offsetPrev,
			    oN = this._offsetNext,
			    wP = this._weightPrev,
			    wN = this._weightNext,
			    p = (t - t0) / (t1 - t0),
			    pp = p * p,
			    ppp = pp * p;

			// evaluate polynomials

			var sP = -wP * ppp + 2 * wP * pp - wP * p;
			var s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
			var s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
			var sN = wN * ppp - wN * pp;

			// combine data linearly

			for (var i = 0; i !== stride; ++i) {

				result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
			}

			return result;
		}
	}]);

	return CubicInterpolant;
}(Interpolant);

var LinearInterpolant = function (_Interpolant2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LinearInterpolant, _Interpolant2);

	function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LinearInterpolant);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LinearInterpolant.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LinearInterpolant)).call(this, parameterPositions, sampleValues, sampleSize, resultBuffer));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LinearInterpolant, [{
		key: 'interpolate_',
		value: function interpolate_(i1, t0, t, t1) {

			var result = this.resultBuffer,
			    values = this.sampleValues,
			    stride = this.valueSize,
			    offset1 = i1 * stride,
			    offset0 = offset1 - stride,
			    weight1 = (t - t0) / (t1 - t0),
			    weight0 = 1 - weight1;

			for (var i = 0; i !== stride; ++i) {

				result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
			}

			return result;
		}
	}]);

	return LinearInterpolant;
}(Interpolant);

/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */

var DiscreteInterpolant = function (_Interpolant3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DiscreteInterpolant, _Interpolant3);

	function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DiscreteInterpolant);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DiscreteInterpolant.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DiscreteInterpolant)).call(this, parameterPositions, sampleValues, sampleSize, resultBuffer));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(DiscreteInterpolant, [{
		key: 'interpolate_',
		value: function interpolate_(i1 /*, t0, t, t1 */) {

			return this.copySampleValue_(i1 - 1);
		}
	}]);

	return DiscreteInterpolant;
}(Interpolant);

var KeyframeTrack = function () {
	function KeyframeTrack(name, times, values, interpolation) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, KeyframeTrack);

		if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
		if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);

		this.name = name;

		this.times = convertArray(times, this.TimeBufferType);
		this.values = convertArray(values, this.ValueBufferType);

		this.setInterpolation(interpolation || this.DefaultInterpolation);
	}

	// Serialization (in static context, because of constructor invocation
	// and automatic invocation of .toJSON):

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(KeyframeTrack, [{
		key: 'InterpolantFactoryMethodDiscrete',
		value: function InterpolantFactoryMethodDiscrete(result) {

			return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
		}
	}, {
		key: 'InterpolantFactoryMethodLinear',
		value: function InterpolantFactoryMethodLinear(result) {

			return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
		}
	}, {
		key: 'InterpolantFactoryMethodSmooth',
		value: function InterpolantFactoryMethodSmooth(result) {

			return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
		}
	}, {
		key: 'setInterpolation',
		value: function setInterpolation(interpolation) {

			var factoryMethod = void 0;

			switch (interpolation) {

				case InterpolateDiscrete:

					factoryMethod = this.InterpolantFactoryMethodDiscrete;

					break;

				case InterpolateLinear:

					factoryMethod = this.InterpolantFactoryMethodLinear;

					break;

				case InterpolateSmooth:

					factoryMethod = this.InterpolantFactoryMethodSmooth;

					break;

			}

			if (factoryMethod === undefined) {

				var message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;

				if (this.createInterpolant === undefined) {

					// fall back to default, unless the default itself is messed up
					if (interpolation !== this.DefaultInterpolation) {

						this.setInterpolation(this.DefaultInterpolation);
					} else {

						throw new Error(message); // fatal, in this case
					}
				}

				console.warn('THREE.KeyframeTrack:', message);
				return this;
			}

			this.createInterpolant = factoryMethod;

			return this;
		}
	}, {
		key: 'getInterpolation',
		value: function getInterpolation() {

			switch (this.createInterpolant) {

				case this.InterpolantFactoryMethodDiscrete:

					return InterpolateDiscrete;

				case this.InterpolantFactoryMethodLinear:

					return InterpolateLinear;

				case this.InterpolantFactoryMethodSmooth:

					return InterpolateSmooth;

			}
		}
	}, {
		key: 'getValueSize',
		value: function getValueSize() {

			return this.values.length / this.times.length;
		}

		// move all keyframes either forwards or backwards in time

	}, {
		key: 'shift',
		value: function shift(timeOffset) {

			if (timeOffset !== 0.0) {

				var times = this.times;

				for (var i = 0, _n3 = times.length; i !== _n3; ++i) {

					times[i] += timeOffset;
				}
			}

			return this;
		}

		// scale all keyframe times by a factor (useful for frame <-> seconds conversions)

	}, {
		key: 'scale',
		value: function scale(timeScale) {

			if (timeScale !== 1.0) {

				var times = this.times;

				for (var i = 0, _n4 = times.length; i !== _n4; ++i) {

					times[i] *= timeScale;
				}
			}

			return this;
		}

		// removes keyframes before and after animation without changing any values within the range [startTime, endTime].
		// IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values

	}, {
		key: 'trim',
		value: function trim(startTime, endTime) {

			var times = this.times,
			    nKeys = times.length;

			var from = 0,
			    to = nKeys - 1;

			while (from !== nKeys && times[from] < startTime) {

				++from;
			}

			while (to !== -1 && times[to] > endTime) {

				--to;
			}

			++to; // inclusive -> exclusive bound

			if (from !== 0 || to !== nKeys) {

				// empty tracks are forbidden, so keep at least one keyframe
				if (from >= to) {

					to = Math.max(to, 1);
					from = to - 1;
				}

				var stride = this.getValueSize();
				this.times = arraySlice(times, from, to);
				this.values = arraySlice(this.values, from * stride, to * stride);
			}

			return this;
		}

		// ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable

	}, {
		key: 'validate',
		value: function validate() {

			var valid = true;

			var valueSize = this.getValueSize();
			if (valueSize - Math.floor(valueSize) !== 0) {

				console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
				valid = false;
			}

			var times = this.times,
			    values = this.values,
			    nKeys = times.length;

			if (nKeys === 0) {

				console.error('THREE.KeyframeTrack: Track is empty.', this);
				valid = false;
			}

			var prevTime = null;

			for (var i = 0; i !== nKeys; i++) {

				var currTime = times[i];

				if (typeof currTime === 'number' && isNaN(currTime)) {

					console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
					valid = false;
					break;
				}

				if (prevTime !== null && prevTime > currTime) {

					console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
					valid = false;
					break;
				}

				prevTime = currTime;
			}

			if (values !== undefined) {

				if (isTypedArray(values)) {

					for (var _i90 = 0, _n5 = values.length; _i90 !== _n5; ++_i90) {

						var _value7 = values[_i90];

						if (isNaN(_value7)) {

							console.error('THREE.KeyframeTrack: Value is not a valid number.', this, _i90, _value7);
							valid = false;
							break;
						}
					}
				}
			}

			return valid;
		}

		// removes equivalent sequential keys as common in morph target sequences
		// (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)

	}, {
		key: 'optimize',
		value: function optimize() {

			// times or values may be shared with other tracks, so overwriting is unsafe
			var times = arraySlice(this.times),
			    values = arraySlice(this.values),
			    stride = this.getValueSize(),
			    smoothInterpolation = this.getInterpolation() === InterpolateSmooth,
			    lastIndex = times.length - 1;

			var writeIndex = 1;

			for (var i = 1; i < lastIndex; ++i) {

				var keep = false;

				var time = times[i];
				var timeNext = times[i + 1];

				// remove adjacent keyframes scheduled at the same time

				if (time !== timeNext && (i !== 1 || time !== times[0])) {

					if (!smoothInterpolation) {

						// remove unnecessary keyframes same as their neighbors

						var offset = i * stride,
						    offsetP = offset - stride,
						    offsetN = offset + stride;

						for (var j = 0; j !== stride; ++j) {

							var _value8 = values[offset + j];

							if (_value8 !== values[offsetP + j] || _value8 !== values[offsetN + j]) {

								keep = true;
								break;
							}
						}
					} else {

						keep = true;
					}
				}

				// in-place compaction

				if (keep) {

					if (i !== writeIndex) {

						times[writeIndex] = times[i];

						var readOffset = i * stride,
						    writeOffset = writeIndex * stride;

						for (var _j14 = 0; _j14 !== stride; ++_j14) {

							values[writeOffset + _j14] = values[readOffset + _j14];
						}
					}

					++writeIndex;
				}
			}

			// flush last keyframe (compaction looks ahead)

			if (lastIndex > 0) {

				times[writeIndex] = times[lastIndex];

				for (var _readOffset = lastIndex * stride, _writeOffset = writeIndex * stride, _j15 = 0; _j15 !== stride; ++_j15) {

					values[_writeOffset + _j15] = values[_readOffset + _j15];
				}

				++writeIndex;
			}

			if (writeIndex !== times.length) {

				this.times = arraySlice(times, 0, writeIndex);
				this.values = arraySlice(values, 0, writeIndex * stride);
			} else {

				this.times = times;
				this.values = values;
			}

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			var times = arraySlice(this.times, 0);
			var values = arraySlice(this.values, 0);

			var TypedKeyframeTrack = this.constructor;
			var track = new TypedKeyframeTrack(this.name, times, values);

			// Interpolant argument to constructor is not saved, so copy the factory method directly.
			track.createInterpolant = this.createInterpolant;

			return track;
		}
	}], [{
		key: 'toJSON',
		value: function toJSON(track) {

			var trackType = track.constructor;

			var json = void 0;

			// derived classes can define a static toJSON method
			if (trackType.toJSON !== this.toJSON) {

				json = trackType.toJSON(track);
			} else {

				// by default, we assume the data can be serialized as-is
				json = {

					'name': track.name,
					'times': convertArray(track.times, Array),
					'values': convertArray(track.values, Array)

				};

				var interpolation = track.getInterpolation();

				if (interpolation !== track.DefaultInterpolation) {

					json.interpolation = interpolation;
				}
			}

			json.type = track.ValueTypeName; // mandatory

			return json;
		}
	}]);

	return KeyframeTrack;
}();

KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;

/**
 * A Track of Boolean keyframe values.
 */

var BooleanKeyframeTrack = function (_KeyframeTrack) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BooleanKeyframeTrack, _KeyframeTrack);

	function BooleanKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BooleanKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BooleanKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BooleanKeyframeTrack)).apply(this, arguments));
	}

	return BooleanKeyframeTrack;
}(KeyframeTrack);

BooleanKeyframeTrack.prototype.ValueTypeName = 'bool';
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of keyframe values that represent color.
 */

var ColorKeyframeTrack = function (_KeyframeTrack2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ColorKeyframeTrack, _KeyframeTrack2);

	function ColorKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ColorKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColorKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ColorKeyframeTrack)).apply(this, arguments));
	}

	return ColorKeyframeTrack;
}(KeyframeTrack);

ColorKeyframeTrack.prototype.ValueTypeName = 'color';

/**
 * A Track of numeric keyframe values.
 */

var NumberKeyframeTrack = function (_KeyframeTrack3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(NumberKeyframeTrack, _KeyframeTrack3);

	function NumberKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, NumberKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NumberKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(NumberKeyframeTrack)).apply(this, arguments));
	}

	return NumberKeyframeTrack;
}(KeyframeTrack);

NumberKeyframeTrack.prototype.ValueTypeName = 'number';

/**
 * Spherical linear unit quaternion interpolant.
 */

var QuaternionLinearInterpolant = function (_Interpolant4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(QuaternionLinearInterpolant, _Interpolant4);

	function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, QuaternionLinearInterpolant);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuaternionLinearInterpolant.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuaternionLinearInterpolant)).call(this, parameterPositions, sampleValues, sampleSize, resultBuffer));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(QuaternionLinearInterpolant, [{
		key: 'interpolate_',
		value: function interpolate_(i1, t0, t, t1) {

			var result = this.resultBuffer,
			    values = this.sampleValues,
			    stride = this.valueSize,
			    alpha = (t - t0) / (t1 - t0);

			var offset = i1 * stride;

			for (var end = offset + stride; offset !== end; offset += 4) {

				Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
			}

			return result;
		}
	}]);

	return QuaternionLinearInterpolant;
}(Interpolant);

/**
 * A Track of quaternion keyframe values.
 */


var QuaternionKeyframeTrack = function (_KeyframeTrack4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(QuaternionKeyframeTrack, _KeyframeTrack4);

	function QuaternionKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, QuaternionKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuaternionKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(QuaternionKeyframeTrack)).apply(this, arguments));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(QuaternionKeyframeTrack, [{
		key: 'InterpolantFactoryMethodLinear',
		value: function InterpolantFactoryMethodLinear(result) {

			return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
		}
	}]);

	return QuaternionKeyframeTrack;
}(KeyframeTrack);

QuaternionKeyframeTrack.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track that interpolates Strings
 */

var StringKeyframeTrack = function (_KeyframeTrack5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(StringKeyframeTrack, _KeyframeTrack5);

	function StringKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, StringKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StringKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(StringKeyframeTrack)).apply(this, arguments));
	}

	return StringKeyframeTrack;
}(KeyframeTrack);

StringKeyframeTrack.prototype.ValueTypeName = 'string';
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;

/**
 * A Track of vectored keyframe values.
 */

var VectorKeyframeTrack = function (_KeyframeTrack6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(VectorKeyframeTrack, _KeyframeTrack6);

	function VectorKeyframeTrack() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, VectorKeyframeTrack);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VectorKeyframeTrack.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(VectorKeyframeTrack)).apply(this, arguments));
	}

	return VectorKeyframeTrack;
}(KeyframeTrack);

VectorKeyframeTrack.prototype.ValueTypeName = 'vector';

var AnimationClip = function () {
	function AnimationClip(name) {
		var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
		var tracks = arguments[2];
		var blendMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : NormalAnimationBlendMode;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AnimationClip);

		this.name = name;
		this.tracks = tracks;
		this.duration = duration;
		this.blendMode = blendMode;

		this.uuid = generateUUID();

		// this means it should figure out its duration by scanning the tracks
		if (this.duration < 0) {

			this.resetDuration();
		}
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AnimationClip, [{
		key: 'resetDuration',
		value: function resetDuration() {

			var tracks = this.tracks;
			var duration = 0;

			for (var i = 0, _n6 = tracks.length; i !== _n6; ++i) {

				var track = this.tracks[i];

				duration = Math.max(duration, track.times[track.times.length - 1]);
			}

			this.duration = duration;

			return this;
		}
	}, {
		key: 'trim',
		value: function trim() {

			for (var i = 0; i < this.tracks.length; i++) {

				this.tracks[i].trim(0, this.duration);
			}

			return this;
		}
	}, {
		key: 'validate',
		value: function validate() {

			var valid = true;

			for (var i = 0; i < this.tracks.length; i++) {

				valid = valid && this.tracks[i].validate();
			}

			return valid;
		}
	}, {
		key: 'optimize',
		value: function optimize() {

			for (var i = 0; i < this.tracks.length; i++) {

				this.tracks[i].optimize();
			}

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			var tracks = [];

			for (var i = 0; i < this.tracks.length; i++) {

				tracks.push(this.tracks[i].clone());
			}

			return new this.constructor(this.name, this.duration, tracks, this.blendMode);
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			return this.constructor.toJSON(this);
		}
	}], [{
		key: 'parse',
		value: function parse(json) {

			var tracks = [],
			    jsonTracks = json.tracks,
			    frameTime = 1.0 / (json.fps || 1.0);

			for (var i = 0, _n7 = jsonTracks.length; i !== _n7; ++i) {

				tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
			}

			var clip = new this(json.name, json.duration, tracks, json.blendMode);
			clip.uuid = json.uuid;

			return clip;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(clip) {

			var tracks = [],
			    clipTracks = clip.tracks;

			var json = {

				'name': clip.name,
				'duration': clip.duration,
				'tracks': tracks,
				'uuid': clip.uuid,
				'blendMode': clip.blendMode

			};

			for (var i = 0, _n8 = clipTracks.length; i !== _n8; ++i) {

				tracks.push(KeyframeTrack.toJSON(clipTracks[i]));
			}

			return json;
		}
	}, {
		key: 'CreateFromMorphTargetSequence',
		value: function CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {

			var numMorphTargets = morphTargetSequence.length;
			var tracks = [];

			for (var i = 0; i < numMorphTargets; i++) {

				var times = [];
				var values = [];

				times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);

				values.push(0, 1, 0);

				var order = getKeyframeOrder(times);
				times = sortedArray(times, 1, order);
				values = sortedArray(values, 1, order);

				// if there is a key at the first frame, duplicate it as the
				// last frame as well for perfect loop.
				if (!noLoop && times[0] === 0) {

					times.push(numMorphTargets);
					values.push(values[0]);
				}

				tracks.push(new NumberKeyframeTrack('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
			}

			return new this(name, -1, tracks);
		}
	}, {
		key: 'findByName',
		value: function findByName(objectOrClipArray, name) {

			var clipArray = objectOrClipArray;

			if (!Array.isArray(objectOrClipArray)) {

				var o = objectOrClipArray;
				clipArray = o.geometry && o.geometry.animations || o.animations;
			}

			for (var i = 0; i < clipArray.length; i++) {

				if (clipArray[i].name === name) {

					return clipArray[i];
				}
			}

			return null;
		}
	}, {
		key: 'CreateClipsFromMorphTargetSequences',
		value: function CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {

			var animationToMorphTargets = {};

			// tested with https://regex101.com/ on trick sequences
			// such flamingo_flyA_003, flamingo_run1_003, crdeath0059
			var pattern = /^([\w-]*?)([\d]+)$/;

			// sort morph target names into animation groups based
			// patterns like Walk_001, Walk_002, Run_001, Run_002
			for (var i = 0, il = morphTargets.length; i < il; i++) {

				var morphTarget = morphTargets[i];
				var parts = morphTarget.name.match(pattern);

				if (parts && parts.length > 1) {

					var name = parts[1];

					var animationMorphTargets = animationToMorphTargets[name];

					if (!animationMorphTargets) {

						animationToMorphTargets[name] = animationMorphTargets = [];
					}

					animationMorphTargets.push(morphTarget);
				}
			}

			var clips = [];

			for (var _name4 in animationToMorphTargets) {

				clips.push(this.CreateFromMorphTargetSequence(_name4, animationToMorphTargets[_name4], fps, noLoop));
			}

			return clips;
		}

		// parse the animation.hierarchy format

	}, {
		key: 'parseAnimation',
		value: function parseAnimation(animation, bones) {

			if (!animation) {

				console.error('THREE.AnimationClip: No animation in JSONLoader data.');
				return null;
			}

			var addNonemptyTrack = function addNonemptyTrack(trackType, trackName, animationKeys, propertyName, destTracks) {

				// only return track if there are actually keys.
				if (animationKeys.length !== 0) {

					var times = [];
					var values = [];

					flattenJSON(animationKeys, times, values, propertyName);

					// empty keys are filtered out, so check again
					if (times.length !== 0) {

						destTracks.push(new trackType(trackName, times, values));
					}
				}
			};

			var tracks = [];

			var clipName = animation.name || 'default';
			var fps = animation.fps || 30;
			var blendMode = animation.blendMode;

			// automatic length determination in AnimationClip.
			var duration = animation.length || -1;

			var hierarchyTracks = animation.hierarchy || [];

			for (var h = 0; h < hierarchyTracks.length; h++) {

				var animationKeys = hierarchyTracks[h].keys;

				// skip empty tracks
				if (!animationKeys || animationKeys.length === 0) continue;

				// process morph targets
				if (animationKeys[0].morphTargets) {

					// figure out all morph targets used in this track
					var morphTargetNames = {};

					var k = void 0;

					for (k = 0; k < animationKeys.length; k++) {

						if (animationKeys[k].morphTargets) {

							for (var m = 0; m < animationKeys[k].morphTargets.length; m++) {

								morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
							}
						}
					}

					// create a track for each morph target with all zero
					// morphTargetInfluences except for the keys in which
					// the morphTarget is named.
					for (var morphTargetName in morphTargetNames) {

						var times = [];
						var values = [];

						for (var _m = 0; _m !== animationKeys[k].morphTargets.length; ++_m) {

							var animationKey = animationKeys[k];

							times.push(animationKey.time);
							values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
						}

						tracks.push(new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values));
					}

					duration = morphTargetNames.length * fps;
				} else {

					// ...assume skeletal animation

					var boneName = '.bones[' + bones[h].name + ']';

					addNonemptyTrack(VectorKeyframeTrack, boneName + '.position', animationKeys, 'pos', tracks);

					addNonemptyTrack(QuaternionKeyframeTrack, boneName + '.quaternion', animationKeys, 'rot', tracks);

					addNonemptyTrack(VectorKeyframeTrack, boneName + '.scale', animationKeys, 'scl', tracks);
				}
			}

			if (tracks.length === 0) {

				return null;
			}

			var clip = new this(clipName, duration, tracks, blendMode);

			return clip;
		}
	}]);

	return AnimationClip;
}();

function getTrackTypeForValueTypeName(typeName) {

	switch (typeName.toLowerCase()) {

		case 'scalar':
		case 'double':
		case 'float':
		case 'number':
		case 'integer':

			return NumberKeyframeTrack;

		case 'vector':
		case 'vector2':
		case 'vector3':
		case 'vector4':

			return VectorKeyframeTrack;

		case 'color':

			return ColorKeyframeTrack;

		case 'quaternion':

			return QuaternionKeyframeTrack;

		case 'bool':
		case 'boolean':

			return BooleanKeyframeTrack;

		case 'string':

			return StringKeyframeTrack;

	}

	throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}

function parseKeyframeTrack(json) {

	if (json.type === undefined) {

		throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
	}

	var trackType = getTrackTypeForValueTypeName(json.type);

	if (json.times === undefined) {

		var times = [],
		    values = [];

		flattenJSON(json.keys, times, values, 'value');

		json.times = times;
		json.values = values;
	}

	// derived classes can define a static parse method
	if (trackType.parse !== undefined) {

		return trackType.parse(json);
	} else {

		// by default, we assume a constructor compatible with the base
		return new trackType(json.name, json.times, json.values, json.interpolation);
	}
}

var Cache = {

	enabled: false,

	files: {},

	add: function add(key, file) {

		if (this.enabled === false) return;

		// console.log( 'THREE.Cache', 'Adding key:', key );

		this.files[key] = file;
	},

	get: function get(key) {

		if (this.enabled === false) return;

		// console.log( 'THREE.Cache', 'Checking key:', key );

		return this.files[key];
	},

	remove: function remove(key) {

		delete this.files[key];
	},

	clear: function clear() {

		this.files = {};
	}

};

var LoadingManager = function LoadingManager(onLoad, onProgress, onError) {
	__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LoadingManager);

	var scope = this;

	var isLoading = false;
	var itemsLoaded = 0;
	var itemsTotal = 0;
	var urlModifier = undefined;
	var handlers = [];

	// Refer to #5689 for the reason why we don't set .onStart
	// in the constructor

	this.onStart = undefined;
	this.onLoad = onLoad;
	this.onProgress = onProgress;
	this.onError = onError;

	this.itemStart = function (url) {

		itemsTotal++;

		if (isLoading === false) {

			if (scope.onStart !== undefined) {

				scope.onStart(url, itemsLoaded, itemsTotal);
			}
		}

		isLoading = true;
	};

	this.itemEnd = function (url) {

		itemsLoaded++;

		if (scope.onProgress !== undefined) {

			scope.onProgress(url, itemsLoaded, itemsTotal);
		}

		if (itemsLoaded === itemsTotal) {

			isLoading = false;

			if (scope.onLoad !== undefined) {

				scope.onLoad();
			}
		}
	};

	this.itemError = function (url) {

		if (scope.onError !== undefined) {

			scope.onError(url);
		}
	};

	this.resolveURL = function (url) {

		if (urlModifier) {

			return urlModifier(url);
		}

		return url;
	};

	this.setURLModifier = function (transform) {

		urlModifier = transform;

		return this;
	};

	this.addHandler = function (regex, loader) {

		handlers.push(regex, loader);

		return this;
	};

	this.removeHandler = function (regex) {

		var index = handlers.indexOf(regex);

		if (index !== -1) {

			handlers.splice(index, 2);
		}

		return this;
	};

	this.getHandler = function (file) {

		for (var i = 0, l = handlers.length; i < l; i += 2) {

			var regex = handlers[i];
			var loader = handlers[i + 1];

			if (regex.global) regex.lastIndex = 0; // see #17920

			if (regex.test(file)) {

				return loader;
			}
		}

		return null;
	};
};

var DefaultLoadingManager = /*@__PURE__*/new LoadingManager();

var Loader = function () {
	function Loader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Loader);

		this.manager = manager !== undefined ? manager : DefaultLoadingManager;

		this.crossOrigin = 'anonymous';
		this.withCredentials = false;
		this.path = '';
		this.resourcePath = '';
		this.requestHeader = {};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Loader, [{
		key: 'load',
		value: function load() /* url, onLoad, onProgress, onError */{}
	}, {
		key: 'loadAsync',
		value: function loadAsync(url, onProgress) {

			var scope = this;

			return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

				scope.load(url, resolve, onProgress, reject);
			});
		}
	}, {
		key: 'parse',
		value: function parse() /* data */{}
	}, {
		key: 'setCrossOrigin',
		value: function setCrossOrigin(crossOrigin) {

			this.crossOrigin = crossOrigin;
			return this;
		}
	}, {
		key: 'setWithCredentials',
		value: function setWithCredentials(value) {

			this.withCredentials = value;
			return this;
		}
	}, {
		key: 'setPath',
		value: function setPath(path) {

			this.path = path;
			return this;
		}
	}, {
		key: 'setResourcePath',
		value: function setResourcePath(resourcePath) {

			this.resourcePath = resourcePath;
			return this;
		}
	}, {
		key: 'setRequestHeader',
		value: function setRequestHeader(requestHeader) {

			this.requestHeader = requestHeader;
			return this;
		}
	}]);

	return Loader;
}();

var loading = {};

var HttpError = function (_Error) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(HttpError, _Error);

	function HttpError(message, response) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, HttpError);

		var _this112 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HttpError.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(HttpError)).call(this, message));

		_this112.response = response;

		return _this112;
	}

	return HttpError;
}(Error);

var FileLoader = function (_Loader) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(FileLoader, _Loader);

	function FileLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, FileLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FileLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(FileLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(FileLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {
			var _this114 = this;

			if (url === undefined) url = '';

			if (this.path !== undefined) url = this.path + url;

			url = this.manager.resolveURL(url);

			var cached = Cache.get(url);

			if (cached !== undefined) {

				this.manager.itemStart(url);

				setTimeout(function () {

					if (onLoad) onLoad(cached);

					_this114.manager.itemEnd(url);
				}, 0);

				return cached;
			}

			// Check if request is duplicate

			if (loading[url] !== undefined) {

				loading[url].push({

					onLoad: onLoad,
					onProgress: onProgress,
					onError: onError

				});

				return;
			}

			// Initialise array for duplicate requests
			loading[url] = [];

			loading[url].push({
				onLoad: onLoad,
				onProgress: onProgress,
				onError: onError
			});

			// create request
			var req = new Request(url, {
				headers: new Headers(this.requestHeader),
				credentials: this.withCredentials ? 'include' : 'same-origin'
				// An abort controller could be added within a future PR
			});

			// record states ( avoid data race )
			var mimeType = this.mimeType;
			var responseType = this.responseType;

			// start the fetch
			fetch(req).then(function (response) {

				if (response.status === 200 || response.status === 0) {

					// Some browsers return HTTP Status 0 when using non-http protocol
					// e.g. 'file://' or 'data://'. Handle as success.

					if (response.status === 0) {

						console.warn('THREE.FileLoader: HTTP Status 0 received.');
					}

					// Workaround: Checking if response.body === undefined for Alipay browser #23548

					if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) {

						return response;
					}

					var callbacks = loading[url];
					var reader = response.body.getReader();

					// Nginx needs X-File-Size check
					// https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
					var contentLength = response.headers.get('Content-Length') || response.headers.get('X-File-Size');
					var total = contentLength ? parseInt(contentLength) : 0;
					var lengthComputable = total !== 0;
					var loaded = 0;

					// periodically read data into the new stream tracking while download progress
					var stream = new ReadableStream({
						start: function start(controller) {

							readData();

							function readData() {

								reader.read().then(function (_ref2) {
									var done = _ref2.done,
									    value = _ref2.value;


									if (done) {

										controller.close();
									} else {

										loaded += value.byteLength;

										var event = new ProgressEvent('progress', { lengthComputable: lengthComputable, loaded: loaded, total: total });
										for (var i = 0, il = callbacks.length; i < il; i++) {

											var callback = callbacks[i];
											if (callback.onProgress) callback.onProgress(event);
										}

										controller.enqueue(value);
										readData();
									}
								});
							}
						}
					});

					return new Response(stream);
				} else {

					throw new HttpError('fetch for "' + response.url + '" responded with ' + response.status + ': ' + response.statusText, response);
				}
			}).then(function (response) {

				switch (responseType) {

					case 'arraybuffer':

						return response.arrayBuffer();

					case 'blob':

						return response.blob();

					case 'document':

						return response.text().then(function (text) {

							var parser = new DOMParser();
							return parser.parseFromString(text, mimeType);
						});

					case 'json':

						return response.json();

					default:

						if (mimeType === undefined) {

							return response.text();
						} else {

							// sniff encoding
							var re = /charset="?([^;"\s]*)"?/i;
							var exec = re.exec(mimeType);
							var label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
							var decoder = new TextDecoder(label);
							return response.arrayBuffer().then(function (ab) {
								return decoder.decode(ab);
							});
						}

				}
			}).then(function (data) {

				// Add to cache only on HTTP success, so that we do not cache
				// error response bodies as proper responses to requests.
				Cache.add(url, data);

				var callbacks = loading[url];
				delete loading[url];

				for (var i = 0, il = callbacks.length; i < il; i++) {

					var callback = callbacks[i];
					if (callback.onLoad) callback.onLoad(data);
				}
			}).catch(function (err) {

				// Abort errors and other errors are handled the same

				var callbacks = loading[url];

				if (callbacks === undefined) {

					// When onLoad was called and url was deleted in `loading`
					_this114.manager.itemError(url);
					throw err;
				}

				delete loading[url];

				for (var i = 0, il = callbacks.length; i < il; i++) {

					var callback = callbacks[i];
					if (callback.onError) callback.onError(err);
				}

				_this114.manager.itemError(url);
			}).finally(function () {

				_this114.manager.itemEnd(url);
			});

			this.manager.itemStart(url);
		}
	}, {
		key: 'setResponseType',
		value: function setResponseType(value) {

			this.responseType = value;
			return this;
		}
	}, {
		key: 'setMimeType',
		value: function setMimeType(value) {

			this.mimeType = value;
			return this;
		}
	}]);

	return FileLoader;
}(Loader);

var AnimationLoader = function (_Loader2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AnimationLoader, _Loader2);

	function AnimationLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AnimationLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimationLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AnimationLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AnimationLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var loader = new FileLoader(this.manager);
			loader.setPath(this.path);
			loader.setRequestHeader(this.requestHeader);
			loader.setWithCredentials(this.withCredentials);
			loader.load(url, function (text) {

				try {

					onLoad(scope.parse(JSON.parse(text)));
				} catch (e) {

					if (onError) {

						onError(e);
					} else {

						console.error(e);
					}

					scope.manager.itemError(url);
				}
			}, onProgress, onError);
		}
	}, {
		key: 'parse',
		value: function parse(json) {

			var animations = [];

			for (var i = 0; i < json.length; i++) {

				var clip = AnimationClip.parse(json[i]);

				animations.push(clip);
			}

			return animations;
		}
	}]);

	return AnimationLoader;
}(Loader);

/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

var CompressedTextureLoader = function (_Loader3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CompressedTextureLoader, _Loader3);

	function CompressedTextureLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CompressedTextureLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompressedTextureLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CompressedTextureLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CompressedTextureLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var images = [];

			var texture = new CompressedTexture();

			var loader = new FileLoader(this.manager);
			loader.setPath(this.path);
			loader.setResponseType('arraybuffer');
			loader.setRequestHeader(this.requestHeader);
			loader.setWithCredentials(scope.withCredentials);

			var loaded = 0;

			function loadTexture(i) {

				loader.load(url[i], function (buffer) {

					var texDatas = scope.parse(buffer, true);

					images[i] = {
						width: texDatas.width,
						height: texDatas.height,
						format: texDatas.format,
						mipmaps: texDatas.mipmaps
					};

					loaded += 1;

					if (loaded === 6) {

						if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;

						texture.image = images;
						texture.format = texDatas.format;
						texture.needsUpdate = true;

						if (onLoad) onLoad(texture);
					}
				}, onProgress, onError);
			}

			if (Array.isArray(url)) {

				for (var i = 0, il = url.length; i < il; ++i) {

					loadTexture(i);
				}
			} else {

				// compressed cubemap texture stored in a single DDS file

				loader.load(url, function (buffer) {

					var texDatas = scope.parse(buffer, true);

					if (texDatas.isCubemap) {

						var faces = texDatas.mipmaps.length / texDatas.mipmapCount;

						for (var f = 0; f < faces; f++) {

							images[f] = { mipmaps: [] };

							for (var _i91 = 0; _i91 < texDatas.mipmapCount; _i91++) {

								images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + _i91]);
								images[f].format = texDatas.format;
								images[f].width = texDatas.width;
								images[f].height = texDatas.height;
							}
						}

						texture.image = images;
					} else {

						texture.image.width = texDatas.width;
						texture.image.height = texDatas.height;
						texture.mipmaps = texDatas.mipmaps;
					}

					if (texDatas.mipmapCount === 1) {

						texture.minFilter = LinearFilter;
					}

					texture.format = texDatas.format;
					texture.needsUpdate = true;

					if (onLoad) onLoad(texture);
				}, onProgress, onError);
			}

			return texture;
		}
	}]);

	return CompressedTextureLoader;
}(Loader);

var ImageLoader = function (_Loader4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ImageLoader, _Loader4);

	function ImageLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ImageLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImageLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ImageLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ImageLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			if (this.path !== undefined) url = this.path + url;

			url = this.manager.resolveURL(url);

			var scope = this;

			var cached = Cache.get(url);

			if (cached !== undefined) {

				scope.manager.itemStart(url);

				setTimeout(function () {

					if (onLoad) onLoad(cached);

					scope.manager.itemEnd(url);
				}, 0);

				return cached;
			}

			var image = createElementNS('img');

			function onImageLoad() {

				removeEventListeners();

				Cache.add(url, this);

				if (onLoad) onLoad(this);

				scope.manager.itemEnd(url);
			}

			function onImageError(event) {

				removeEventListeners();

				if (onError) onError(event);

				scope.manager.itemError(url);
				scope.manager.itemEnd(url);
			}

			function removeEventListeners() {

				image.removeEventListener('load', onImageLoad, false);
				image.removeEventListener('error', onImageError, false);
			}

			image.addEventListener('load', onImageLoad, false);
			image.addEventListener('error', onImageError, false);

			if (url.slice(0, 5) !== 'data:') {

				if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
			}

			scope.manager.itemStart(url);

			image.src = url;

			return image;
		}
	}]);

	return ImageLoader;
}(Loader);

var CubeTextureLoader = function (_Loader5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CubeTextureLoader, _Loader5);

	function CubeTextureLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CubeTextureLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CubeTextureLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CubeTextureLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CubeTextureLoader, [{
		key: 'load',
		value: function load(urls, onLoad, onProgress, onError) {

			var texture = new CubeTexture();

			var loader = new ImageLoader(this.manager);
			loader.setCrossOrigin(this.crossOrigin);
			loader.setPath(this.path);

			var loaded = 0;

			function loadTexture(i) {

				loader.load(urls[i], function (image) {

					texture.images[i] = image;

					loaded++;

					if (loaded === 6) {

						texture.needsUpdate = true;

						if (onLoad) onLoad(texture);
					}
				}, undefined, onError);
			}

			for (var i = 0; i < urls.length; ++i) {

				loadTexture(i);
			}

			return texture;
		}
	}]);

	return CubeTextureLoader;
}(Loader);

/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */

var DataTextureLoader = function (_Loader6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DataTextureLoader, _Loader6);

	function DataTextureLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DataTextureLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DataTextureLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DataTextureLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(DataTextureLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var texture = new DataTexture();

			var loader = new FileLoader(this.manager);
			loader.setResponseType('arraybuffer');
			loader.setRequestHeader(this.requestHeader);
			loader.setPath(this.path);
			loader.setWithCredentials(scope.withCredentials);
			loader.load(url, function (buffer) {

				var texData = scope.parse(buffer);

				if (!texData) return;

				if (texData.image !== undefined) {

					texture.image = texData.image;
				} else if (texData.data !== undefined) {

					texture.image.width = texData.width;
					texture.image.height = texData.height;
					texture.image.data = texData.data;
				}

				texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
				texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;

				texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
				texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;

				texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;

				if (texData.encoding !== undefined) {

					texture.encoding = texData.encoding;
				}

				if (texData.flipY !== undefined) {

					texture.flipY = texData.flipY;
				}

				if (texData.format !== undefined) {

					texture.format = texData.format;
				}

				if (texData.type !== undefined) {

					texture.type = texData.type;
				}

				if (texData.mipmaps !== undefined) {

					texture.mipmaps = texData.mipmaps;
					texture.minFilter = LinearMipmapLinearFilter; // presumably...
				}

				if (texData.mipmapCount === 1) {

					texture.minFilter = LinearFilter;
				}

				if (texData.generateMipmaps !== undefined) {

					texture.generateMipmaps = texData.generateMipmaps;
				}

				texture.needsUpdate = true;

				if (onLoad) onLoad(texture, texData);
			}, onProgress, onError);

			return texture;
		}
	}]);

	return DataTextureLoader;
}(Loader);

var TextureLoader = function (_Loader7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TextureLoader, _Loader7);

	function TextureLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TextureLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TextureLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TextureLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(TextureLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var texture = new Texture();

			var loader = new ImageLoader(this.manager);
			loader.setCrossOrigin(this.crossOrigin);
			loader.setPath(this.path);

			loader.load(url, function (image) {

				texture.image = image;
				texture.needsUpdate = true;

				if (onLoad !== undefined) {

					onLoad(texture);
				}
			}, onProgress, onError);

			return texture;
		}
	}]);

	return TextureLoader;
}(Loader);

var Light = function (_Object3D11) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Light, _Object3D11);

	function Light(color) {
		var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Light);

		var _this121 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Light.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Light)).call(this));

		_this121.isLight = true;

		_this121.type = 'Light';

		_this121.color = new Color(color);
		_this121.intensity = intensity;

		return _this121;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Light, [{
		key: 'dispose',
		value: function dispose() {

			// Empty here in base class; some subclasses override.

		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Light.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Light.prototype), 'copy', this).call(this, source, recursive);

			this.color.copy(source.color);
			this.intensity = source.intensity;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Light.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Light.prototype), 'toJSON', this).call(this, meta);

			data.object.color = this.color.getHex();
			data.object.intensity = this.intensity;

			if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();

			if (this.distance !== undefined) data.object.distance = this.distance;
			if (this.angle !== undefined) data.object.angle = this.angle;
			if (this.decay !== undefined) data.object.decay = this.decay;
			if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;

			if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();

			return data;
		}
	}]);

	return Light;
}(Object3D);

var HemisphereLight = function (_Light) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(HemisphereLight, _Light);

	function HemisphereLight(skyColor, groundColor, intensity) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, HemisphereLight);

		var _this122 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HemisphereLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(HemisphereLight)).call(this, skyColor, intensity));

		_this122.isHemisphereLight = true;

		_this122.type = 'HemisphereLight';

		_this122.position.copy(Object3D.DEFAULT_UP);
		_this122.updateMatrix();

		_this122.groundColor = new Color(groundColor);

		return _this122;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(HemisphereLight, [{
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(HemisphereLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(HemisphereLight.prototype), 'copy', this).call(this, source, recursive);

			this.groundColor.copy(source.groundColor);

			return this;
		}
	}]);

	return HemisphereLight;
}(Light);

var _projScreenMatrix$1 = /*@__PURE__*/new Matrix4();
var _lightPositionWorld$1 = /*@__PURE__*/new Vector3();
var _lookTarget$1 = /*@__PURE__*/new Vector3();

var LightShadow = function () {
	function LightShadow(camera) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LightShadow);

		this.camera = camera;

		this.bias = 0;
		this.normalBias = 0;
		this.radius = 1;
		this.blurSamples = 8;

		this.mapSize = new Vector2(512, 512);

		this.map = null;
		this.mapPass = null;
		this.matrix = new Matrix4();

		this.autoUpdate = true;
		this.needsUpdate = false;

		this._frustum = new Frustum();
		this._frameExtents = new Vector2(1, 1);

		this._viewportCount = 1;

		this._viewports = [new Vector4(0, 0, 1, 1)];
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LightShadow, [{
		key: 'getViewportCount',
		value: function getViewportCount() {

			return this._viewportCount;
		}
	}, {
		key: 'getFrustum',
		value: function getFrustum() {

			return this._frustum;
		}
	}, {
		key: 'updateMatrices',
		value: function updateMatrices(light) {

			var shadowCamera = this.camera;
			var shadowMatrix = this.matrix;

			_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
			shadowCamera.position.copy(_lightPositionWorld$1);

			_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
			shadowCamera.lookAt(_lookTarget$1);
			shadowCamera.updateMatrixWorld();

			_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
			this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);

			shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);

			shadowMatrix.multiply(_projScreenMatrix$1);
		}
	}, {
		key: 'getViewport',
		value: function getViewport(viewportIndex) {

			return this._viewports[viewportIndex];
		}
	}, {
		key: 'getFrameExtents',
		value: function getFrameExtents() {

			return this._frameExtents;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			if (this.map) {

				this.map.dispose();
			}

			if (this.mapPass) {

				this.mapPass.dispose();
			}
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.camera = source.camera.clone();

			this.bias = source.bias;
			this.radius = source.radius;

			this.mapSize.copy(source.mapSize);

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var object = {};

			if (this.bias !== 0) object.bias = this.bias;
			if (this.normalBias !== 0) object.normalBias = this.normalBias;
			if (this.radius !== 1) object.radius = this.radius;
			if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();

			object.camera = this.camera.toJSON(false).object;
			delete object.camera.matrix;

			return object;
		}
	}]);

	return LightShadow;
}();

var SpotLightShadow = function (_LightShadow) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SpotLightShadow, _LightShadow);

	function SpotLightShadow() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SpotLightShadow);

		var _this123 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpotLightShadow.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLightShadow)).call(this, new PerspectiveCamera(50, 1, 0.5, 500)));

		_this123.isSpotLightShadow = true;

		_this123.focus = 1;

		return _this123;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SpotLightShadow, [{
		key: 'updateMatrices',
		value: function updateMatrices(light) {

			var camera = this.camera;

			var fov = RAD2DEG * 2 * light.angle * this.focus;
			var aspect = this.mapSize.width / this.mapSize.height;
			var far = light.distance || camera.far;

			if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {

				camera.fov = fov;
				camera.aspect = aspect;
				camera.far = far;
				camera.updateProjectionMatrix();
			}

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SpotLightShadow.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLightShadow.prototype), 'updateMatrices', this).call(this, light);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SpotLightShadow.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLightShadow.prototype), 'copy', this).call(this, source);

			this.focus = source.focus;

			return this;
		}
	}]);

	return SpotLightShadow;
}(LightShadow);

var SpotLight = function (_Light2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SpotLight, _Light2);

	function SpotLight(color, intensity) {
		var distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var angle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 3;
		var penumbra = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
		var decay = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SpotLight);

		var _this124 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpotLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLight)).call(this, color, intensity));

		_this124.isSpotLight = true;

		_this124.type = 'SpotLight';

		_this124.position.copy(Object3D.DEFAULT_UP);
		_this124.updateMatrix();

		_this124.target = new Object3D();

		_this124.distance = distance;
		_this124.angle = angle;
		_this124.penumbra = penumbra;
		_this124.decay = decay;

		_this124.map = null;

		_this124.shadow = new SpotLightShadow();

		return _this124;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SpotLight, [{
		key: 'dispose',
		value: function dispose() {

			this.shadow.dispose();
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SpotLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLight.prototype), 'copy', this).call(this, source, recursive);

			this.distance = source.distance;
			this.angle = source.angle;
			this.penumbra = source.penumbra;
			this.decay = source.decay;

			this.target = source.target.clone();

			this.shadow = source.shadow.clone();

			return this;
		}
	}, {
		key: 'power',
		get: function get() {

			// compute the light's luminous power (in lumens) from its intensity (in candela)
			// by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
			return this.intensity * Math.PI;
		},
		set: function set(power) {

			// set the light's intensity (in candela) from the desired luminous power (in lumens)
			this.intensity = power / Math.PI;
		}
	}]);

	return SpotLight;
}(Light);

var _projScreenMatrix = /*@__PURE__*/new Matrix4();
var _lightPositionWorld = /*@__PURE__*/new Vector3();
var _lookTarget = /*@__PURE__*/new Vector3();

var PointLightShadow = function (_LightShadow2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PointLightShadow, _LightShadow2);

	function PointLightShadow() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PointLightShadow);

		var _this125 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PointLightShadow.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointLightShadow)).call(this, new PerspectiveCamera(90, 1, 0.5, 500)));

		_this125.isPointLightShadow = true;

		_this125._frameExtents = new Vector2(4, 2);

		_this125._viewportCount = 6;

		_this125._viewports = [
		// These viewports map a cube-map onto a 2D texture with the
		// following orientation:
		//
		//  xzXZ
		//   y Y
		//
		// X - Positive x direction
		// x - Negative x direction
		// Y - Positive y direction
		// y - Negative y direction
		// Z - Positive z direction
		// z - Negative z direction

		// positive X
		new Vector4(2, 1, 1, 1),
		// negative X
		new Vector4(0, 1, 1, 1),
		// positive Z
		new Vector4(3, 1, 1, 1),
		// negative Z
		new Vector4(1, 1, 1, 1),
		// positive Y
		new Vector4(3, 0, 1, 1),
		// negative Y
		new Vector4(1, 0, 1, 1)];

		_this125._cubeDirections = [new Vector3(1, 0, 0), new Vector3(-1, 0, 0), new Vector3(0, 0, 1), new Vector3(0, 0, -1), new Vector3(0, 1, 0), new Vector3(0, -1, 0)];

		_this125._cubeUps = [new Vector3(0, 1, 0), new Vector3(0, 1, 0), new Vector3(0, 1, 0), new Vector3(0, 1, 0), new Vector3(0, 0, 1), new Vector3(0, 0, -1)];

		return _this125;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PointLightShadow, [{
		key: 'updateMatrices',
		value: function updateMatrices(light) {
			var viewportIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			var camera = this.camera;
			var shadowMatrix = this.matrix;

			var far = light.distance || camera.far;

			if (far !== camera.far) {

				camera.far = far;
				camera.updateProjectionMatrix();
			}

			_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
			camera.position.copy(_lightPositionWorld);

			_lookTarget.copy(camera.position);
			_lookTarget.add(this._cubeDirections[viewportIndex]);
			camera.up.copy(this._cubeUps[viewportIndex]);
			camera.lookAt(_lookTarget);
			camera.updateMatrixWorld();

			shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);

			_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
			this._frustum.setFromProjectionMatrix(_projScreenMatrix);
		}
	}]);

	return PointLightShadow;
}(LightShadow);

var PointLight = function (_Light3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PointLight, _Light3);

	function PointLight(color, intensity) {
		var distance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var decay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PointLight);

		var _this126 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PointLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointLight)).call(this, color, intensity));

		_this126.isPointLight = true;

		_this126.type = 'PointLight';

		_this126.distance = distance;
		_this126.decay = decay;

		_this126.shadow = new PointLightShadow();

		return _this126;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PointLight, [{
		key: 'dispose',
		value: function dispose() {

			this.shadow.dispose();
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PointLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointLight.prototype), 'copy', this).call(this, source, recursive);

			this.distance = source.distance;
			this.decay = source.decay;

			this.shadow = source.shadow.clone();

			return this;
		}
	}, {
		key: 'power',
		get: function get() {

			// compute the light's luminous power (in lumens) from its intensity (in candela)
			// for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
			return this.intensity * 4 * Math.PI;
		},
		set: function set(power) {

			// set the light's intensity (in candela) from the desired luminous power (in lumens)
			this.intensity = power / (4 * Math.PI);
		}
	}]);

	return PointLight;
}(Light);

var DirectionalLightShadow = function (_LightShadow3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DirectionalLightShadow, _LightShadow3);

	function DirectionalLightShadow() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DirectionalLightShadow);

		var _this127 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DirectionalLightShadow.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DirectionalLightShadow)).call(this, new OrthographicCamera(-5, 5, 5, -5, 0.5, 500)));

		_this127.isDirectionalLightShadow = true;

		return _this127;
	}

	return DirectionalLightShadow;
}(LightShadow);

var DirectionalLight = function (_Light4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DirectionalLight, _Light4);

	function DirectionalLight(color, intensity) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DirectionalLight);

		var _this128 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DirectionalLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DirectionalLight)).call(this, color, intensity));

		_this128.isDirectionalLight = true;

		_this128.type = 'DirectionalLight';

		_this128.position.copy(Object3D.DEFAULT_UP);
		_this128.updateMatrix();

		_this128.target = new Object3D();

		_this128.shadow = new DirectionalLightShadow();

		return _this128;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(DirectionalLight, [{
		key: 'dispose',
		value: function dispose() {

			this.shadow.dispose();
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(DirectionalLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DirectionalLight.prototype), 'copy', this).call(this, source);

			this.target = source.target.clone();
			this.shadow = source.shadow.clone();

			return this;
		}
	}]);

	return DirectionalLight;
}(Light);

var AmbientLight = function (_Light5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AmbientLight, _Light5);

	function AmbientLight(color, intensity) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AmbientLight);

		var _this129 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AmbientLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AmbientLight)).call(this, color, intensity));

		_this129.isAmbientLight = true;

		_this129.type = 'AmbientLight';

		return _this129;
	}

	return AmbientLight;
}(Light);

var RectAreaLight = function (_Light6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(RectAreaLight, _Light6);

	function RectAreaLight(color, intensity) {
		var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
		var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, RectAreaLight);

		var _this130 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RectAreaLight.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RectAreaLight)).call(this, color, intensity));

		_this130.isRectAreaLight = true;

		_this130.type = 'RectAreaLight';

		_this130.width = width;
		_this130.height = height;

		return _this130;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(RectAreaLight, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(RectAreaLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RectAreaLight.prototype), 'copy', this).call(this, source);

			this.width = source.width;
			this.height = source.height;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(RectAreaLight.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RectAreaLight.prototype), 'toJSON', this).call(this, meta);

			data.object.width = this.width;
			data.object.height = this.height;

			return data;
		}
	}, {
		key: 'power',
		get: function get() {

			// compute the light's luminous power (in lumens) from its intensity (in nits)
			return this.intensity * this.width * this.height * Math.PI;
		},
		set: function set(power) {

			// set the light's intensity (in nits) from the desired luminous power (in lumens)
			this.intensity = power / (this.width * this.height * Math.PI);
		}
	}]);

	return RectAreaLight;
}(Light);

/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */

// 3-band SH defined by 9 coefficients

var SphericalHarmonics3 = function () {
	function SphericalHarmonics3() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SphericalHarmonics3);

		this.isSphericalHarmonics3 = true;

		this.coefficients = [];

		for (var i = 0; i < 9; i++) {

			this.coefficients.push(new Vector3());
		}
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SphericalHarmonics3, [{
		key: 'set',
		value: function set(coefficients) {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].copy(coefficients[i]);
			}

			return this;
		}
	}, {
		key: 'zero',
		value: function zero() {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].set(0, 0, 0);
			}

			return this;
		}

		// get the radiance in the direction of the normal
		// target is a Vector3

	}, {
		key: 'getAt',
		value: function getAt(normal, target) {

			// normal is assumed to be unit length

			var x = normal.x,
			    y = normal.y,
			    z = normal.z;

			var coeff = this.coefficients;

			// band 0
			target.copy(coeff[0]).multiplyScalar(0.282095);

			// band 1
			target.addScaledVector(coeff[1], 0.488603 * y);
			target.addScaledVector(coeff[2], 0.488603 * z);
			target.addScaledVector(coeff[3], 0.488603 * x);

			// band 2
			target.addScaledVector(coeff[4], 1.092548 * (x * y));
			target.addScaledVector(coeff[5], 1.092548 * (y * z));
			target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
			target.addScaledVector(coeff[7], 1.092548 * (x * z));
			target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));

			return target;
		}

		// get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
		// target is a Vector3
		// https://graphics.stanford.edu/papers/envmap/envmap.pdf

	}, {
		key: 'getIrradianceAt',
		value: function getIrradianceAt(normal, target) {

			// normal is assumed to be unit length

			var x = normal.x,
			    y = normal.y,
			    z = normal.z;

			var coeff = this.coefficients;

			// band 0
			target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095

			// band 1
			target.addScaledVector(coeff[1], 2.0 * 0.511664 * y); // ( 2 * π / 3 ) * 0.488603
			target.addScaledVector(coeff[2], 2.0 * 0.511664 * z);
			target.addScaledVector(coeff[3], 2.0 * 0.511664 * x);

			// band 2
			target.addScaledVector(coeff[4], 2.0 * 0.429043 * x * y); // ( π / 4 ) * 1.092548
			target.addScaledVector(coeff[5], 2.0 * 0.429043 * y * z);
			target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
			target.addScaledVector(coeff[7], 2.0 * 0.429043 * x * z);
			target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274

			return target;
		}
	}, {
		key: 'add',
		value: function add(sh) {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].add(sh.coefficients[i]);
			}

			return this;
		}
	}, {
		key: 'addScaledSH',
		value: function addScaledSH(sh, s) {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].addScaledVector(sh.coefficients[i], s);
			}

			return this;
		}
	}, {
		key: 'scale',
		value: function scale(s) {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].multiplyScalar(s);
			}

			return this;
		}
	}, {
		key: 'lerp',
		value: function lerp(sh, alpha) {

			for (var i = 0; i < 9; i++) {

				this.coefficients[i].lerp(sh.coefficients[i], alpha);
			}

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(sh) {

			for (var i = 0; i < 9; i++) {

				if (!this.coefficients[i].equals(sh.coefficients[i])) {

					return false;
				}
			}

			return true;
		}
	}, {
		key: 'copy',
		value: function copy(sh) {

			return this.set(sh.coefficients);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'fromArray',
		value: function fromArray(array) {
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			var coefficients = this.coefficients;

			for (var i = 0; i < 9; i++) {

				coefficients[i].fromArray(array, offset + i * 3);
			}

			return this;
		}
	}, {
		key: 'toArray',
		value: function toArray() {
			var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


			var coefficients = this.coefficients;

			for (var i = 0; i < 9; i++) {

				coefficients[i].toArray(array, offset + i * 3);
			}

			return array;
		}

		// evaluate the basis functions
		// shBasis is an Array[ 9 ]

	}], [{
		key: 'getBasisAt',
		value: function getBasisAt(normal, shBasis) {

			// normal is assumed to be unit length

			var x = normal.x,
			    y = normal.y,
			    z = normal.z;

			// band 0
			shBasis[0] = 0.282095;

			// band 1
			shBasis[1] = 0.488603 * y;
			shBasis[2] = 0.488603 * z;
			shBasis[3] = 0.488603 * x;

			// band 2
			shBasis[4] = 1.092548 * x * y;
			shBasis[5] = 1.092548 * y * z;
			shBasis[6] = 0.315392 * (3 * z * z - 1);
			shBasis[7] = 1.092548 * x * z;
			shBasis[8] = 0.546274 * (x * x - y * y);
		}
	}]);

	return SphericalHarmonics3;
}();

var LightProbe = function (_Light7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LightProbe, _Light7);

	function LightProbe() {
		var sh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new SphericalHarmonics3();
		var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LightProbe);

		var _this131 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LightProbe.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LightProbe)).call(this, undefined, intensity));

		_this131.isLightProbe = true;

		_this131.sh = sh;

		return _this131;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LightProbe, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LightProbe.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LightProbe.prototype), 'copy', this).call(this, source);

			this.sh.copy(source.sh);

			return this;
		}
	}, {
		key: 'fromJSON',
		value: function fromJSON(json) {

			this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
			this.sh.fromArray(json.sh);

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(meta) {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(LightProbe.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LightProbe.prototype), 'toJSON', this).call(this, meta);

			data.object.sh = this.sh.toArray();

			return data;
		}
	}]);

	return LightProbe;
}(Light);

var MaterialLoader = function (_Loader8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(MaterialLoader, _Loader8);

	function MaterialLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, MaterialLoader);

		var _this132 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MaterialLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(MaterialLoader)).call(this, manager));

		_this132.textures = {};

		return _this132;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(MaterialLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var loader = new FileLoader(scope.manager);
			loader.setPath(scope.path);
			loader.setRequestHeader(scope.requestHeader);
			loader.setWithCredentials(scope.withCredentials);
			loader.load(url, function (text) {

				try {

					onLoad(scope.parse(JSON.parse(text)));
				} catch (e) {

					if (onError) {

						onError(e);
					} else {

						console.error(e);
					}

					scope.manager.itemError(url);
				}
			}, onProgress, onError);
		}
	}, {
		key: 'parse',
		value: function parse(json) {

			var textures = this.textures;

			function getTexture(name) {

				if (textures[name] === undefined) {

					console.warn('THREE.MaterialLoader: Undefined texture', name);
				}

				return textures[name];
			}

			var material = MaterialLoader.createMaterialFromType(json.type);

			if (json.uuid !== undefined) material.uuid = json.uuid;
			if (json.name !== undefined) material.name = json.name;
			if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
			if (json.roughness !== undefined) material.roughness = json.roughness;
			if (json.metalness !== undefined) material.metalness = json.metalness;
			if (json.sheen !== undefined) material.sheen = json.sheen;
			if (json.sheenColor !== undefined) material.sheenColor = new Color().setHex(json.sheenColor);
			if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
			if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
			if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
			if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
			if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
			if (json.shininess !== undefined) material.shininess = json.shininess;
			if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
			if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
			if (json.iridescence !== undefined) material.iridescence = json.iridescence;
			if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
			if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
			if (json.transmission !== undefined) material.transmission = json.transmission;
			if (json.thickness !== undefined) material.thickness = json.thickness;
			if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
			if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
			if (json.fog !== undefined) material.fog = json.fog;
			if (json.flatShading !== undefined) material.flatShading = json.flatShading;
			if (json.blending !== undefined) material.blending = json.blending;
			if (json.combine !== undefined) material.combine = json.combine;
			if (json.side !== undefined) material.side = json.side;
			if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
			if (json.opacity !== undefined) material.opacity = json.opacity;
			if (json.transparent !== undefined) material.transparent = json.transparent;
			if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
			if (json.depthTest !== undefined) material.depthTest = json.depthTest;
			if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
			if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;

			if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
			if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
			if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
			if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
			if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
			if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
			if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
			if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;

			if (json.wireframe !== undefined) material.wireframe = json.wireframe;
			if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
			if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
			if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;

			if (json.rotation !== undefined) material.rotation = json.rotation;

			if (json.linewidth !== 1) material.linewidth = json.linewidth;
			if (json.dashSize !== undefined) material.dashSize = json.dashSize;
			if (json.gapSize !== undefined) material.gapSize = json.gapSize;
			if (json.scale !== undefined) material.scale = json.scale;

			if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
			if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
			if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;

			if (json.dithering !== undefined) material.dithering = json.dithering;

			if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
			if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
			if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;

			if (json.visible !== undefined) material.visible = json.visible;

			if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;

			if (json.userData !== undefined) material.userData = json.userData;

			if (json.vertexColors !== undefined) {

				if (typeof json.vertexColors === 'number') {

					material.vertexColors = json.vertexColors > 0 ? true : false;
				} else {

					material.vertexColors = json.vertexColors;
				}
			}

			// Shader Material

			if (json.uniforms !== undefined) {

				for (var name in json.uniforms) {

					var uniform = json.uniforms[name];

					material.uniforms[name] = {};

					switch (uniform.type) {

						case 't':
							material.uniforms[name].value = getTexture(uniform.value);
							break;

						case 'c':
							material.uniforms[name].value = new Color().setHex(uniform.value);
							break;

						case 'v2':
							material.uniforms[name].value = new Vector2().fromArray(uniform.value);
							break;

						case 'v3':
							material.uniforms[name].value = new Vector3().fromArray(uniform.value);
							break;

						case 'v4':
							material.uniforms[name].value = new Vector4().fromArray(uniform.value);
							break;

						case 'm3':
							material.uniforms[name].value = new Matrix3().fromArray(uniform.value);
							break;

						case 'm4':
							material.uniforms[name].value = new Matrix4().fromArray(uniform.value);
							break;

						default:
							material.uniforms[name].value = uniform.value;

					}
				}
			}

			if (json.defines !== undefined) material.defines = json.defines;
			if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
			if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
			if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;

			if (json.extensions !== undefined) {

				for (var key in json.extensions) {

					material.extensions[key] = json.extensions[key];
				}
			}

			// for PointsMaterial

			if (json.size !== undefined) material.size = json.size;
			if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;

			// maps

			if (json.map !== undefined) material.map = getTexture(json.map);
			if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);

			if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);

			if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
			if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;

			if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
			if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
			if (json.normalScale !== undefined) {

				var normalScale = json.normalScale;

				if (Array.isArray(normalScale) === false) {

					// Blender exporter used to export a scalar. See #7459

					normalScale = [normalScale, normalScale];
				}

				material.normalScale = new Vector2().fromArray(normalScale);
			}

			if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
			if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
			if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;

			if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
			if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);

			if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
			if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;

			if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
			if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
			if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);

			if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
			if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;

			if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
			if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;

			if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
			if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;

			if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
			if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;

			if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);

			if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
			if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
			if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
			if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new Vector2().fromArray(json.clearcoatNormalScale);

			if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
			if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);

			if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
			if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);

			if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
			if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);

			return material;
		}
	}, {
		key: 'setTextures',
		value: function setTextures(value) {

			this.textures = value;
			return this;
		}
	}], [{
		key: 'createMaterialFromType',
		value: function createMaterialFromType(type) {

			var materialLib = {
				ShadowMaterial: ShadowMaterial,
				SpriteMaterial: SpriteMaterial,
				RawShaderMaterial: RawShaderMaterial,
				ShaderMaterial: ShaderMaterial,
				PointsMaterial: PointsMaterial,
				MeshPhysicalMaterial: MeshPhysicalMaterial,
				MeshStandardMaterial: MeshStandardMaterial,
				MeshPhongMaterial: MeshPhongMaterial,
				MeshToonMaterial: MeshToonMaterial,
				MeshNormalMaterial: MeshNormalMaterial,
				MeshLambertMaterial: MeshLambertMaterial,
				MeshDepthMaterial: MeshDepthMaterial,
				MeshDistanceMaterial: MeshDistanceMaterial,
				MeshBasicMaterial: MeshBasicMaterial,
				MeshMatcapMaterial: MeshMatcapMaterial,
				LineDashedMaterial: LineDashedMaterial,
				LineBasicMaterial: LineBasicMaterial,
				Material: Material
			};

			return new materialLib[type]();
		}
	}]);

	return MaterialLoader;
}(Loader);

var LoaderUtils = function () {
	function LoaderUtils() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LoaderUtils);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(LoaderUtils, null, [{
		key: 'decodeText',
		value: function decodeText(array) {

			if (typeof TextDecoder !== 'undefined') {

				return new TextDecoder().decode(array);
			}

			// Avoid the String.fromCharCode.apply(null, array) shortcut, which
			// throws a "maximum call stack size exceeded" error for large arrays.

			var s = '';

			for (var i = 0, il = array.length; i < il; i++) {

				// Implicitly assumes little-endian.
				s += String.fromCharCode(array[i]);
			}

			try {

				// merges multi-byte utf-8 characters.

				return decodeURIComponent(escape(s));
			} catch (e) {
				// see #16358

				return s;
			}
		}
	}, {
		key: 'extractUrlBase',
		value: function extractUrlBase(url) {

			var index = url.lastIndexOf('/');

			if (index === -1) return './';

			return url.slice(0, index + 1);
		}
	}, {
		key: 'resolveURL',
		value: function resolveURL(url, path) {

			// Invalid URL
			if (typeof url !== 'string' || url === '') return '';

			// Host Relative URL
			if (/^https?:\/\//i.test(path) && /^\//.test(url)) {

				path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
			}

			// Absolute URL http://,https://,//
			if (/^(https?:)?\/\//i.test(url)) return url;

			// Data URI
			if (/^data:.*,.*$/i.test(url)) return url;

			// Blob URL
			if (/^blob:.*$/i.test(url)) return url;

			// Relative URL
			return path + url;
		}
	}]);

	return LoaderUtils;
}();

var InstancedBufferGeometry = function (_BufferGeometry16) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(InstancedBufferGeometry, _BufferGeometry16);

	function InstancedBufferGeometry() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InstancedBufferGeometry);

		var _this133 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InstancedBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferGeometry)).call(this));

		_this133.isInstancedBufferGeometry = true;

		_this133.type = 'InstancedBufferGeometry';
		_this133.instanceCount = Infinity;

		return _this133;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InstancedBufferGeometry, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedBufferGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferGeometry.prototype), 'copy', this).call(this, source);

			this.instanceCount = source.instanceCount;

			return this;
		}
	}, {
		key: 'toJSON',
		value: function toJSON() {

			var data = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedBufferGeometry.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedBufferGeometry.prototype), 'toJSON', this).call(this);

			data.instanceCount = this.instanceCount;

			data.isInstancedBufferGeometry = true;

			return data;
		}
	}]);

	return InstancedBufferGeometry;
}(BufferGeometry);

var BufferGeometryLoader = function (_Loader9) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BufferGeometryLoader, _Loader9);

	function BufferGeometryLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BufferGeometryLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BufferGeometryLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BufferGeometryLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(BufferGeometryLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var loader = new FileLoader(scope.manager);
			loader.setPath(scope.path);
			loader.setRequestHeader(scope.requestHeader);
			loader.setWithCredentials(scope.withCredentials);
			loader.load(url, function (text) {

				try {

					onLoad(scope.parse(JSON.parse(text)));
				} catch (e) {

					if (onError) {

						onError(e);
					} else {

						console.error(e);
					}

					scope.manager.itemError(url);
				}
			}, onProgress, onError);
		}
	}, {
		key: 'parse',
		value: function parse(json) {

			var interleavedBufferMap = {};
			var arrayBufferMap = {};

			function getInterleavedBuffer(json, uuid) {

				if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];

				var interleavedBuffers = json.interleavedBuffers;
				var interleavedBuffer = interleavedBuffers[uuid];

				var buffer = getArrayBuffer(json, interleavedBuffer.buffer);

				var array = getTypedArray(interleavedBuffer.type, buffer);
				var ib = new InterleavedBuffer(array, interleavedBuffer.stride);
				ib.uuid = interleavedBuffer.uuid;

				interleavedBufferMap[uuid] = ib;

				return ib;
			}

			function getArrayBuffer(json, uuid) {

				if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];

				var arrayBuffers = json.arrayBuffers;
				var arrayBuffer = arrayBuffers[uuid];

				var ab = new Uint32Array(arrayBuffer).buffer;

				arrayBufferMap[uuid] = ab;

				return ab;
			}

			var geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();

			var index = json.data.index;

			if (index !== undefined) {

				var typedArray = getTypedArray(index.type, index.array);
				geometry.setIndex(new BufferAttribute(typedArray, 1));
			}

			var attributes = json.data.attributes;

			for (var key in attributes) {

				var attribute = attributes[key];
				var bufferAttribute = void 0;

				if (attribute.isInterleavedBufferAttribute) {

					var interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
					bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
				} else {

					var _typedArray = getTypedArray(attribute.type, attribute.array);
					var bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
					bufferAttribute = new bufferAttributeConstr(_typedArray, attribute.itemSize, attribute.normalized);
				}

				if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
				if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);

				if (attribute.updateRange !== undefined) {

					bufferAttribute.updateRange.offset = attribute.updateRange.offset;
					bufferAttribute.updateRange.count = attribute.updateRange.count;
				}

				geometry.setAttribute(key, bufferAttribute);
			}

			var morphAttributes = json.data.morphAttributes;

			if (morphAttributes) {

				for (var _key3 in morphAttributes) {

					var attributeArray = morphAttributes[_key3];

					var array = [];

					for (var i = 0, il = attributeArray.length; i < il; i++) {

						var _attribute3 = attributeArray[i];
						var _bufferAttribute = void 0;

						if (_attribute3.isInterleavedBufferAttribute) {

							var _interleavedBuffer = getInterleavedBuffer(json.data, _attribute3.data);
							_bufferAttribute = new InterleavedBufferAttribute(_interleavedBuffer, _attribute3.itemSize, _attribute3.offset, _attribute3.normalized);
						} else {

							var _typedArray2 = getTypedArray(_attribute3.type, _attribute3.array);
							_bufferAttribute = new BufferAttribute(_typedArray2, _attribute3.itemSize, _attribute3.normalized);
						}

						if (_attribute3.name !== undefined) _bufferAttribute.name = _attribute3.name;
						array.push(_bufferAttribute);
					}

					geometry.morphAttributes[_key3] = array;
				}
			}

			var morphTargetsRelative = json.data.morphTargetsRelative;

			if (morphTargetsRelative) {

				geometry.morphTargetsRelative = true;
			}

			var groups = json.data.groups || json.data.drawcalls || json.data.offsets;

			if (groups !== undefined) {

				for (var _i92 = 0, _n9 = groups.length; _i92 !== _n9; ++_i92) {

					var group = groups[_i92];

					geometry.addGroup(group.start, group.count, group.materialIndex);
				}
			}

			var boundingSphere = json.data.boundingSphere;

			if (boundingSphere !== undefined) {

				var _center2 = new Vector3();

				if (boundingSphere.center !== undefined) {

					_center2.fromArray(boundingSphere.center);
				}

				geometry.boundingSphere = new Sphere(_center2, boundingSphere.radius);
			}

			if (json.name) geometry.name = json.name;
			if (json.userData) geometry.userData = json.userData;

			return geometry;
		}
	}]);

	return BufferGeometryLoader;
}(Loader);

var ObjectLoader = function (_Loader10) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ObjectLoader, _Loader10);

	function ObjectLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ObjectLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ObjectLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ObjectLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ObjectLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;
			this.resourcePath = this.resourcePath || path;

			var loader = new FileLoader(this.manager);
			loader.setPath(this.path);
			loader.setRequestHeader(this.requestHeader);
			loader.setWithCredentials(this.withCredentials);
			loader.load(url, function (text) {

				var json = null;

				try {

					json = JSON.parse(text);
				} catch (error) {

					if (onError !== undefined) onError(error);

					console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);

					return;
				}

				var metadata = json.metadata;

				if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {

					if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));

					console.error('THREE.ObjectLoader: Can\'t load ' + url);
					return;
				}

				scope.parse(json, onLoad);
			}, onProgress, onError);
		}
	}, {
		key: 'loadAsync',
		value: function () {
			var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee2(url, onProgress) {
				var scope, path, loader, text, json, metadata;
				return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								scope = this;
								path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;

								this.resourcePath = this.resourcePath || path;

								loader = new FileLoader(this.manager);

								loader.setPath(this.path);
								loader.setRequestHeader(this.requestHeader);
								loader.setWithCredentials(this.withCredentials);

								_context10.next = 9;
								return loader.loadAsync(url, onProgress);

							case 9:
								text = _context10.sent;
								json = JSON.parse(text);
								metadata = json.metadata;

								if (!(metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry')) {
									_context10.next = 14;
									break;
								}

								throw new Error('THREE.ObjectLoader: Can\'t load ' + url);

							case 14:
								_context10.next = 16;
								return scope.parseAsync(json);

							case 16:
								return _context10.abrupt('return', _context10.sent);

							case 17:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee2, this);
			}));

			function loadAsync(_x326, _x327) {
				return _ref3.apply(this, arguments);
			}

			return loadAsync;
		}()
	}, {
		key: 'parse',
		value: function parse(json, onLoad) {

			var animations = this.parseAnimations(json.animations);
			var shapes = this.parseShapes(json.shapes);
			var geometries = this.parseGeometries(json.geometries, shapes);

			var images = this.parseImages(json.images, function () {

				if (onLoad !== undefined) onLoad(object);
			});

			var textures = this.parseTextures(json.textures, images);
			var materials = this.parseMaterials(json.materials, textures);

			var object = this.parseObject(json.object, geometries, materials, textures, animations);
			var skeletons = this.parseSkeletons(json.skeletons, object);

			this.bindSkeletons(object, skeletons);

			//

			if (onLoad !== undefined) {

				var hasImages = false;

				for (var uuid in images) {

					if (images[uuid].data instanceof HTMLImageElement) {

						hasImages = true;
						break;
					}
				}

				if (hasImages === false) onLoad(object);
			}

			return object;
		}
	}, {
		key: 'parseAsync',
		value: function () {
			var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee3(json) {
				var animations, shapes, geometries, images, textures, materials, object, skeletons;
				return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context11) {
					while (1) {
						switch (_context11.prev = _context11.next) {
							case 0:
								animations = this.parseAnimations(json.animations);
								shapes = this.parseShapes(json.shapes);
								geometries = this.parseGeometries(json.geometries, shapes);
								_context11.next = 5;
								return this.parseImagesAsync(json.images);

							case 5:
								images = _context11.sent;
								textures = this.parseTextures(json.textures, images);
								materials = this.parseMaterials(json.materials, textures);
								object = this.parseObject(json.object, geometries, materials, textures, animations);
								skeletons = this.parseSkeletons(json.skeletons, object);


								this.bindSkeletons(object, skeletons);

								return _context11.abrupt('return', object);

							case 12:
							case 'end':
								return _context11.stop();
						}
					}
				}, _callee3, this);
			}));

			function parseAsync(_x328) {
				return _ref4.apply(this, arguments);
			}

			return parseAsync;
		}()
	}, {
		key: 'parseShapes',
		value: function parseShapes(json) {

			var shapes = {};

			if (json !== undefined) {

				for (var i = 0, l = json.length; i < l; i++) {

					var shape = new Shape().fromJSON(json[i]);

					shapes[shape.uuid] = shape;
				}
			}

			return shapes;
		}
	}, {
		key: 'parseSkeletons',
		value: function parseSkeletons(json, object) {

			var skeletons = {};
			var bones = {};

			// generate bone lookup table

			object.traverse(function (child) {

				if (child.isBone) bones[child.uuid] = child;
			});

			// create skeletons

			if (json !== undefined) {

				for (var i = 0, l = json.length; i < l; i++) {

					var skeleton = new Skeleton().fromJSON(json[i], bones);

					skeletons[skeleton.uuid] = skeleton;
				}
			}

			return skeletons;
		}
	}, {
		key: 'parseGeometries',
		value: function parseGeometries(json, shapes) {

			var geometries = {};

			if (json !== undefined) {

				var bufferGeometryLoader = new BufferGeometryLoader();

				for (var i = 0, l = json.length; i < l; i++) {

					var geometry = void 0;
					var data = json[i];

					switch (data.type) {

						case 'BufferGeometry':
						case 'InstancedBufferGeometry':

							geometry = bufferGeometryLoader.parse(data);
							break;

						default:

							if (data.type in Geometries) {

								geometry = Geometries[data.type].fromJSON(data, shapes);
							} else {

								console.warn('THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"');
							}

					}

					geometry.uuid = data.uuid;

					if (data.name !== undefined) geometry.name = data.name;
					if (data.userData !== undefined) geometry.userData = data.userData;

					geometries[data.uuid] = geometry;
				}
			}

			return geometries;
		}
	}, {
		key: 'parseMaterials',
		value: function parseMaterials(json, textures) {

			var cache = {}; // MultiMaterial
			var materials = {};

			if (json !== undefined) {

				var loader = new MaterialLoader();
				loader.setTextures(textures);

				for (var i = 0, l = json.length; i < l; i++) {

					var data = json[i];

					if (cache[data.uuid] === undefined) {

						cache[data.uuid] = loader.parse(data);
					}

					materials[data.uuid] = cache[data.uuid];
				}
			}

			return materials;
		}
	}, {
		key: 'parseAnimations',
		value: function parseAnimations(json) {

			var animations = {};

			if (json !== undefined) {

				for (var i = 0; i < json.length; i++) {

					var data = json[i];

					var clip = AnimationClip.parse(data);

					animations[clip.uuid] = clip;
				}
			}

			return animations;
		}
	}, {
		key: 'parseImages',
		value: function parseImages(json, onLoad) {

			var scope = this;
			var images = {};

			var loader = void 0;

			function loadImage(url) {

				scope.manager.itemStart(url);

				return loader.load(url, function () {

					scope.manager.itemEnd(url);
				}, undefined, function () {

					scope.manager.itemError(url);
					scope.manager.itemEnd(url);
				});
			}

			function deserializeImage(image) {

				if (typeof image === 'string') {

					var url = image;

					var path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;

					return loadImage(path);
				} else {

					if (image.data) {

						return {
							data: getTypedArray(image.type, image.data),
							width: image.width,
							height: image.height
						};
					} else {

						return null;
					}
				}
			}

			if (json !== undefined && json.length > 0) {

				var manager = new LoadingManager(onLoad);

				loader = new ImageLoader(manager);
				loader.setCrossOrigin(this.crossOrigin);

				for (var i = 0, il = json.length; i < il; i++) {

					var image = json[i];
					var url = image.url;

					if (Array.isArray(url)) {

						// load array of images e.g CubeTexture

						var imageArray = [];

						for (var j = 0, jl = url.length; j < jl; j++) {

							var currentUrl = url[j];

							var deserializedImage = deserializeImage(currentUrl);

							if (deserializedImage !== null) {

								if (deserializedImage instanceof HTMLImageElement) {

									imageArray.push(deserializedImage);
								} else {

									// special case: handle array of data textures for cube textures

									imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
								}
							}
						}

						images[image.uuid] = new Source(imageArray);
					} else {

						// load single image

						var _deserializedImage = deserializeImage(image.url);
						images[image.uuid] = new Source(_deserializedImage);
					}
				}
			}

			return images;
		}
	}, {
		key: 'parseImagesAsync',
		value: function () {
			var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee5(json) {
				var deserializeImage = function () {
					var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.mark(function _callee4(image) {
						var url, path;
						return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context12) {
							while (1) {
								switch (_context12.prev = _context12.next) {
									case 0:
										if (!(typeof image === 'string')) {
											_context12.next = 8;
											break;
										}

										url = image;
										path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
										_context12.next = 5;
										return loader.loadAsync(path);

									case 5:
										return _context12.abrupt('return', _context12.sent);

									case 8:
										if (!image.data) {
											_context12.next = 12;
											break;
										}

										return _context12.abrupt('return', {
											data: getTypedArray(image.type, image.data),
											width: image.width,
											height: image.height
										});

									case 12:
										return _context12.abrupt('return', null);

									case 13:
									case 'end':
										return _context12.stop();
								}
							}
						}, _callee4, this);
					}));

					return function deserializeImage(_x330) {
						return _ref6.apply(this, arguments);
					};
				}();

				var scope, images, loader, i, il, image, url, imageArray, j, jl, currentUrl, deserializedImage, _deserializedImage2;

				return __WEBPACK_IMPORTED_MODULE_24_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context13) {
					while (1) {
						switch (_context13.prev = _context13.next) {
							case 0:
								scope = this;
								images = {};
								loader = void 0;

								if (!(json !== undefined && json.length > 0)) {
									_context13.next = 32;
									break;
								}

								loader = new ImageLoader(this.manager);
								loader.setCrossOrigin(this.crossOrigin);

								i = 0, il = json.length;

							case 7:
								if (!(i < il)) {
									_context13.next = 32;
									break;
								}

								image = json[i];
								url = image.url;

								if (!Array.isArray(url)) {
									_context13.next = 25;
									break;
								}

								// load array of images e.g CubeTexture

								imageArray = [];
								j = 0, jl = url.length;

							case 13:
								if (!(j < jl)) {
									_context13.next = 22;
									break;
								}

								currentUrl = url[j];
								_context13.next = 17;
								return deserializeImage(currentUrl);

							case 17:
								deserializedImage = _context13.sent;


								if (deserializedImage !== null) {

									if (deserializedImage instanceof HTMLImageElement) {

										imageArray.push(deserializedImage);
									} else {

										// special case: handle array of data textures for cube textures

										imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
									}
								}

							case 19:
								j++;
								_context13.next = 13;
								break;

							case 22:

								images[image.uuid] = new Source(imageArray);

								_context13.next = 29;
								break;

							case 25:
								_context13.next = 27;
								return deserializeImage(image.url);

							case 27:
								_deserializedImage2 = _context13.sent;

								images[image.uuid] = new Source(_deserializedImage2);

							case 29:
								i++;
								_context13.next = 7;
								break;

							case 32:
								return _context13.abrupt('return', images);

							case 33:
							case 'end':
								return _context13.stop();
						}
					}
				}, _callee5, this);
			}));

			function parseImagesAsync(_x329) {
				return _ref5.apply(this, arguments);
			}

			return parseImagesAsync;
		}()
	}, {
		key: 'parseTextures',
		value: function parseTextures(json, images) {

			function parseConstant(value, type) {

				if (typeof value === 'number') return value;

				console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);

				return type[value];
			}

			var textures = {};

			if (json !== undefined) {

				for (var i = 0, l = json.length; i < l; i++) {

					var data = json[i];

					if (data.image === undefined) {

						console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
					}

					if (images[data.image] === undefined) {

						console.warn('THREE.ObjectLoader: Undefined image', data.image);
					}

					var source = images[data.image];
					var image = source.data;

					var _texture7 = void 0;

					if (Array.isArray(image)) {

						_texture7 = new CubeTexture();

						if (image.length === 6) _texture7.needsUpdate = true;
					} else {

						if (image && image.data) {

							_texture7 = new DataTexture();
						} else {

							_texture7 = new Texture();
						}

						if (image) _texture7.needsUpdate = true; // textures can have undefined image data
					}

					_texture7.source = source;

					_texture7.uuid = data.uuid;

					if (data.name !== undefined) _texture7.name = data.name;

					if (data.mapping !== undefined) _texture7.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
					if (data.channel !== undefined) _texture7.channel = data.channel;

					if (data.offset !== undefined) _texture7.offset.fromArray(data.offset);
					if (data.repeat !== undefined) _texture7.repeat.fromArray(data.repeat);
					if (data.center !== undefined) _texture7.center.fromArray(data.center);
					if (data.rotation !== undefined) _texture7.rotation = data.rotation;

					if (data.wrap !== undefined) {

						_texture7.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
						_texture7.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
					}

					if (data.format !== undefined) _texture7.format = data.format;
					if (data.internalFormat !== undefined) _texture7.internalFormat = data.internalFormat;
					if (data.type !== undefined) _texture7.type = data.type;
					if (data.encoding !== undefined) _texture7.encoding = data.encoding;

					if (data.minFilter !== undefined) _texture7.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
					if (data.magFilter !== undefined) _texture7.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
					if (data.anisotropy !== undefined) _texture7.anisotropy = data.anisotropy;

					if (data.flipY !== undefined) _texture7.flipY = data.flipY;

					if (data.generateMipmaps !== undefined) _texture7.generateMipmaps = data.generateMipmaps;
					if (data.premultiplyAlpha !== undefined) _texture7.premultiplyAlpha = data.premultiplyAlpha;
					if (data.unpackAlignment !== undefined) _texture7.unpackAlignment = data.unpackAlignment;

					if (data.userData !== undefined) _texture7.userData = data.userData;

					textures[data.uuid] = _texture7;
				}
			}

			return textures;
		}
	}, {
		key: 'parseObject',
		value: function parseObject(data, geometries, materials, textures, animations) {

			var object = void 0;

			function getGeometry(name) {

				if (geometries[name] === undefined) {

					console.warn('THREE.ObjectLoader: Undefined geometry', name);
				}

				return geometries[name];
			}

			function getMaterial(name) {

				if (name === undefined) return undefined;

				if (Array.isArray(name)) {

					var array = [];

					for (var i = 0, l = name.length; i < l; i++) {

						var uuid = name[i];

						if (materials[uuid] === undefined) {

							console.warn('THREE.ObjectLoader: Undefined material', uuid);
						}

						array.push(materials[uuid]);
					}

					return array;
				}

				if (materials[name] === undefined) {

					console.warn('THREE.ObjectLoader: Undefined material', name);
				}

				return materials[name];
			}

			function getTexture(uuid) {

				if (textures[uuid] === undefined) {

					console.warn('THREE.ObjectLoader: Undefined texture', uuid);
				}

				return textures[uuid];
			}

			var geometry = void 0,
			    material = void 0;

			switch (data.type) {

				case 'Scene':

					object = new Scene();

					if (data.background !== undefined) {

						if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(data.background)) {

							object.background = new Color(data.background);
						} else {

							object.background = getTexture(data.background);
						}
					}

					if (data.environment !== undefined) {

						object.environment = getTexture(data.environment);
					}

					if (data.fog !== undefined) {

						if (data.fog.type === 'Fog') {

							object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
						} else if (data.fog.type === 'FogExp2') {

							object.fog = new FogExp2(data.fog.color, data.fog.density);
						}
					}

					if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
					if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;

					break;

				case 'PerspectiveCamera':

					object = new PerspectiveCamera(data.fov, data.aspect, data.near, data.far);

					if (data.focus !== undefined) object.focus = data.focus;
					if (data.zoom !== undefined) object.zoom = data.zoom;
					if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
					if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
					if (data.view !== undefined) object.view = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, data.view);

					break;

				case 'OrthographicCamera':

					object = new OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);

					if (data.zoom !== undefined) object.zoom = data.zoom;
					if (data.view !== undefined) object.view = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()({}, data.view);

					break;

				case 'AmbientLight':

					object = new AmbientLight(data.color, data.intensity);

					break;

				case 'DirectionalLight':

					object = new DirectionalLight(data.color, data.intensity);

					break;

				case 'PointLight':

					object = new PointLight(data.color, data.intensity, data.distance, data.decay);

					break;

				case 'RectAreaLight':

					object = new RectAreaLight(data.color, data.intensity, data.width, data.height);

					break;

				case 'SpotLight':

					object = new SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);

					break;

				case 'HemisphereLight':

					object = new HemisphereLight(data.color, data.groundColor, data.intensity);

					break;

				case 'LightProbe':

					object = new LightProbe().fromJSON(data);

					break;

				case 'SkinnedMesh':

					geometry = getGeometry(data.geometry);
					material = getMaterial(data.material);

					object = new SkinnedMesh(geometry, material);

					if (data.bindMode !== undefined) object.bindMode = data.bindMode;
					if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
					if (data.skeleton !== undefined) object.skeleton = data.skeleton;

					break;

				case 'Mesh':

					geometry = getGeometry(data.geometry);
					material = getMaterial(data.material);

					object = new Mesh(geometry, material);

					break;

				case 'InstancedMesh':

					geometry = getGeometry(data.geometry);
					material = getMaterial(data.material);
					var count = data.count;
					var instanceMatrix = data.instanceMatrix;
					var instanceColor = data.instanceColor;

					object = new InstancedMesh(geometry, material, count);
					object.instanceMatrix = new InstancedBufferAttribute(new Float32Array(instanceMatrix.array), 16);
					if (instanceColor !== undefined) object.instanceColor = new InstancedBufferAttribute(new Float32Array(instanceColor.array), instanceColor.itemSize);

					break;

				case 'LOD':

					object = new LOD();

					break;

				case 'Line':

					object = new Line(getGeometry(data.geometry), getMaterial(data.material));

					break;

				case 'LineLoop':

					object = new LineLoop(getGeometry(data.geometry), getMaterial(data.material));

					break;

				case 'LineSegments':

					object = new LineSegments(getGeometry(data.geometry), getMaterial(data.material));

					break;

				case 'PointCloud':
				case 'Points':

					object = new Points(getGeometry(data.geometry), getMaterial(data.material));

					break;

				case 'Sprite':

					object = new Sprite(getMaterial(data.material));

					break;

				case 'Group':

					object = new Group();

					break;

				case 'Bone':

					object = new Bone();

					break;

				default:

					object = new Object3D();

			}

			object.uuid = data.uuid;

			if (data.name !== undefined) object.name = data.name;

			if (data.matrix !== undefined) {

				object.matrix.fromArray(data.matrix);

				if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
				if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
			} else {

				if (data.position !== undefined) object.position.fromArray(data.position);
				if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
				if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
				if (data.scale !== undefined) object.scale.fromArray(data.scale);
			}

			if (data.up !== undefined) object.up.fromArray(data.up);

			if (data.castShadow !== undefined) object.castShadow = data.castShadow;
			if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;

			if (data.shadow) {

				if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
				if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
				if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
				if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
				if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
			}

			if (data.visible !== undefined) object.visible = data.visible;
			if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
			if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
			if (data.userData !== undefined) object.userData = data.userData;
			if (data.layers !== undefined) object.layers.mask = data.layers;

			if (data.children !== undefined) {

				var children = data.children;

				for (var i = 0; i < children.length; i++) {

					object.add(this.parseObject(children[i], geometries, materials, textures, animations));
				}
			}

			if (data.animations !== undefined) {

				var objectAnimations = data.animations;

				for (var _i93 = 0; _i93 < objectAnimations.length; _i93++) {

					var uuid = objectAnimations[_i93];

					object.animations.push(animations[uuid]);
				}
			}

			if (data.type === 'LOD') {

				if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;

				var levels = data.levels;

				for (var l = 0; l < levels.length; l++) {

					var level = levels[l];
					var child = object.getObjectByProperty('uuid', level.object);

					if (child !== undefined) {

						object.addLevel(child, level.distance, level.hysteresis);
					}
				}
			}

			return object;
		}
	}, {
		key: 'bindSkeletons',
		value: function bindSkeletons(object, skeletons) {

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(skeletons).length === 0) return;

			object.traverse(function (child) {

				if (child.isSkinnedMesh === true && child.skeleton !== undefined) {

					var skeleton = skeletons[child.skeleton];

					if (skeleton === undefined) {

						console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
					} else {

						child.bind(skeleton, child.bindMatrix);
					}
				}
			});
		}
	}]);

	return ObjectLoader;
}(Loader);

var TEXTURE_MAPPING = {
	UVMapping: UVMapping,
	CubeReflectionMapping: CubeReflectionMapping,
	CubeRefractionMapping: CubeRefractionMapping,
	EquirectangularReflectionMapping: EquirectangularReflectionMapping,
	EquirectangularRefractionMapping: EquirectangularRefractionMapping,
	CubeUVReflectionMapping: CubeUVReflectionMapping
};

var TEXTURE_WRAPPING = {
	RepeatWrapping: RepeatWrapping,
	ClampToEdgeWrapping: ClampToEdgeWrapping,
	MirroredRepeatWrapping: MirroredRepeatWrapping
};

var TEXTURE_FILTER = {
	NearestFilter: NearestFilter,
	NearestMipmapNearestFilter: NearestMipmapNearestFilter,
	NearestMipmapLinearFilter: NearestMipmapLinearFilter,
	LinearFilter: LinearFilter,
	LinearMipmapNearestFilter: LinearMipmapNearestFilter,
	LinearMipmapLinearFilter: LinearMipmapLinearFilter
};

var ImageBitmapLoader = function (_Loader11) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ImageBitmapLoader, _Loader11);

	function ImageBitmapLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ImageBitmapLoader);

		var _this136 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImageBitmapLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ImageBitmapLoader)).call(this, manager));

		_this136.isImageBitmapLoader = true;

		if (typeof createImageBitmap === 'undefined') {

			console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
		}

		if (typeof fetch === 'undefined') {

			console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
		}

		_this136.options = { premultiplyAlpha: 'none' };

		return _this136;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ImageBitmapLoader, [{
		key: 'setOptions',
		value: function setOptions(options) {

			this.options = options;

			return this;
		}
	}, {
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			if (url === undefined) url = '';

			if (this.path !== undefined) url = this.path + url;

			url = this.manager.resolveURL(url);

			var scope = this;

			var cached = Cache.get(url);

			if (cached !== undefined) {

				scope.manager.itemStart(url);

				setTimeout(function () {

					if (onLoad) onLoad(cached);

					scope.manager.itemEnd(url);
				}, 0);

				return cached;
			}

			var fetchOptions = {};
			fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
			fetchOptions.headers = this.requestHeader;

			fetch(url, fetchOptions).then(function (res) {

				return res.blob();
			}).then(function (blob) {

				return createImageBitmap(blob, __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_object_assign___default()(scope.options, { colorSpaceConversion: 'none' }));
			}).then(function (imageBitmap) {

				Cache.add(url, imageBitmap);

				if (onLoad) onLoad(imageBitmap);

				scope.manager.itemEnd(url);
			}).catch(function (e) {

				if (onError) onError(e);

				scope.manager.itemError(url);
				scope.manager.itemEnd(url);
			});

			scope.manager.itemStart(url);
		}
	}]);

	return ImageBitmapLoader;
}(Loader);

var _context = void 0;

var AudioContext = function () {
	function AudioContext() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AudioContext);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AudioContext, null, [{
		key: 'getContext',
		value: function getContext() {

			if (_context === undefined) {

				_context = new (window.AudioContext || window.webkitAudioContext)();
			}

			return _context;
		}
	}, {
		key: 'setContext',
		value: function setContext(value) {

			_context = value;
		}
	}]);

	return AudioContext;
}();

var AudioLoader = function (_Loader12) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AudioLoader, _Loader12);

	function AudioLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AudioLoader);

		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AudioLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AudioLoader)).call(this, manager));
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AudioLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var loader = new FileLoader(this.manager);
			loader.setResponseType('arraybuffer');
			loader.setPath(this.path);
			loader.setRequestHeader(this.requestHeader);
			loader.setWithCredentials(this.withCredentials);
			loader.load(url, function (buffer) {

				try {

					// Create a copy of the buffer. The `decodeAudioData` method
					// detaches the buffer when complete, preventing reuse.
					var bufferCopy = buffer.slice(0);

					var context = AudioContext.getContext();
					context.decodeAudioData(bufferCopy, function (audioBuffer) {

						onLoad(audioBuffer);
					});
				} catch (e) {

					if (onError) {

						onError(e);
					} else {

						console.error(e);
					}

					scope.manager.itemError(url);
				}
			}, onProgress, onError);
		}
	}]);

	return AudioLoader;
}(Loader);

var HemisphereLightProbe = function (_LightProbe) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(HemisphereLightProbe, _LightProbe);

	function HemisphereLightProbe(skyColor, groundColor) {
		var intensity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, HemisphereLightProbe);

		var _this138 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HemisphereLightProbe.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(HemisphereLightProbe)).call(this, undefined, intensity));

		_this138.isHemisphereLightProbe = true;

		var color1 = new Color().set(skyColor);
		var color2 = new Color().set(groundColor);

		var sky = new Vector3(color1.r, color1.g, color1.b);
		var ground = new Vector3(color2.r, color2.g, color2.b);

		// without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
		var c0 = Math.sqrt(Math.PI);
		var c1 = c0 * Math.sqrt(0.75);

		_this138.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
		_this138.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);

		return _this138;
	}

	return HemisphereLightProbe;
}(LightProbe);

var AmbientLightProbe = function (_LightProbe2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AmbientLightProbe, _LightProbe2);

	function AmbientLightProbe(color) {
		var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AmbientLightProbe);

		var _this139 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AmbientLightProbe.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AmbientLightProbe)).call(this, undefined, intensity));

		_this139.isAmbientLightProbe = true;

		var color1 = new Color().set(color);

		// without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
		_this139.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));

		return _this139;
	}

	return AmbientLightProbe;
}(LightProbe);

var _eyeRight = /*@__PURE__*/new Matrix4();
var _eyeLeft = /*@__PURE__*/new Matrix4();
var _projectionMatrix = /*@__PURE__*/new Matrix4();

var StereoCamera = function () {
	function StereoCamera() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, StereoCamera);

		this.type = 'StereoCamera';

		this.aspect = 1;

		this.eyeSep = 0.064;

		this.cameraL = new PerspectiveCamera();
		this.cameraL.layers.enable(1);
		this.cameraL.matrixAutoUpdate = false;

		this.cameraR = new PerspectiveCamera();
		this.cameraR.layers.enable(2);
		this.cameraR.matrixAutoUpdate = false;

		this._cache = {
			focus: null,
			fov: null,
			aspect: null,
			near: null,
			far: null,
			zoom: null,
			eyeSep: null
		};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(StereoCamera, [{
		key: 'update',
		value: function update(camera) {

			var cache = this._cache;

			var needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;

			if (needsUpdate) {

				cache.focus = camera.focus;
				cache.fov = camera.fov;
				cache.aspect = camera.aspect * this.aspect;
				cache.near = camera.near;
				cache.far = camera.far;
				cache.zoom = camera.zoom;
				cache.eyeSep = this.eyeSep;

				// Off-axis stereoscopic effect based on
				// http://paulbourke.net/stereographics/stereorender/

				_projectionMatrix.copy(camera.projectionMatrix);
				var eyeSepHalf = cache.eyeSep / 2;
				var eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
				var ymax = cache.near * Math.tan(DEG2RAD * cache.fov * 0.5) / cache.zoom;
				var xmin = void 0,
				    xmax = void 0;

				// translate xOffset

				_eyeLeft.elements[12] = -eyeSepHalf;
				_eyeRight.elements[12] = eyeSepHalf;

				// for left eye

				xmin = -ymax * cache.aspect + eyeSepOnProjection;
				xmax = ymax * cache.aspect + eyeSepOnProjection;

				_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
				_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);

				this.cameraL.projectionMatrix.copy(_projectionMatrix);

				// for right eye

				xmin = -ymax * cache.aspect - eyeSepOnProjection;
				xmax = ymax * cache.aspect - eyeSepOnProjection;

				_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
				_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);

				this.cameraR.projectionMatrix.copy(_projectionMatrix);
			}

			this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
			this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
		}
	}]);

	return StereoCamera;
}();

var Clock = function () {
	function Clock() {
		var autoStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Clock);

		this.autoStart = autoStart;

		this.startTime = 0;
		this.oldTime = 0;
		this.elapsedTime = 0;

		this.running = false;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Clock, [{
		key: 'start',
		value: function start() {

			this.startTime = now();

			this.oldTime = this.startTime;
			this.elapsedTime = 0;
			this.running = true;
		}
	}, {
		key: 'stop',
		value: function stop() {

			this.getElapsedTime();
			this.running = false;
			this.autoStart = false;
		}
	}, {
		key: 'getElapsedTime',
		value: function getElapsedTime() {

			this.getDelta();
			return this.elapsedTime;
		}
	}, {
		key: 'getDelta',
		value: function getDelta() {

			var diff = 0;

			if (this.autoStart && !this.running) {

				this.start();
				return 0;
			}

			if (this.running) {

				var newTime = now();

				diff = (newTime - this.oldTime) / 1000;
				this.oldTime = newTime;

				this.elapsedTime += diff;
			}

			return diff;
		}
	}]);

	return Clock;
}();

function now() {

	return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}

var _position$1 = /*@__PURE__*/new Vector3();
var _quaternion$1 = /*@__PURE__*/new Quaternion();
var _scale$1 = /*@__PURE__*/new Vector3();
var _orientation$1 = /*@__PURE__*/new Vector3();

var AudioListener = function (_Object3D12) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AudioListener, _Object3D12);

	function AudioListener() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AudioListener);

		var _this140 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AudioListener.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AudioListener)).call(this));

		_this140.type = 'AudioListener';

		_this140.context = AudioContext.getContext();

		_this140.gain = _this140.context.createGain();
		_this140.gain.connect(_this140.context.destination);

		_this140.filter = null;

		_this140.timeDelta = 0;

		// private

		_this140._clock = new Clock();

		return _this140;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AudioListener, [{
		key: 'getInput',
		value: function getInput() {

			return this.gain;
		}
	}, {
		key: 'removeFilter',
		value: function removeFilter() {

			if (this.filter !== null) {

				this.gain.disconnect(this.filter);
				this.filter.disconnect(this.context.destination);
				this.gain.connect(this.context.destination);
				this.filter = null;
			}

			return this;
		}
	}, {
		key: 'getFilter',
		value: function getFilter() {

			return this.filter;
		}
	}, {
		key: 'setFilter',
		value: function setFilter(value) {

			if (this.filter !== null) {

				this.gain.disconnect(this.filter);
				this.filter.disconnect(this.context.destination);
			} else {

				this.gain.disconnect(this.context.destination);
			}

			this.filter = value;
			this.gain.connect(this.filter);
			this.filter.connect(this.context.destination);

			return this;
		}
	}, {
		key: 'getMasterVolume',
		value: function getMasterVolume() {

			return this.gain.gain.value;
		}
	}, {
		key: 'setMasterVolume',
		value: function setMasterVolume(value) {

			this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);

			return this;
		}
	}, {
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(AudioListener.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AudioListener.prototype), 'updateMatrixWorld', this).call(this, force);

			var listener = this.context.listener;
			var up = this.up;

			this.timeDelta = this._clock.getDelta();

			this.matrixWorld.decompose(_position$1, _quaternion$1, _scale$1);

			_orientation$1.set(0, 0, -1).applyQuaternion(_quaternion$1);

			if (listener.positionX) {

				// code path for Chrome (see #14393)

				var endTime = this.context.currentTime + this.timeDelta;

				listener.positionX.linearRampToValueAtTime(_position$1.x, endTime);
				listener.positionY.linearRampToValueAtTime(_position$1.y, endTime);
				listener.positionZ.linearRampToValueAtTime(_position$1.z, endTime);
				listener.forwardX.linearRampToValueAtTime(_orientation$1.x, endTime);
				listener.forwardY.linearRampToValueAtTime(_orientation$1.y, endTime);
				listener.forwardZ.linearRampToValueAtTime(_orientation$1.z, endTime);
				listener.upX.linearRampToValueAtTime(up.x, endTime);
				listener.upY.linearRampToValueAtTime(up.y, endTime);
				listener.upZ.linearRampToValueAtTime(up.z, endTime);
			} else {

				listener.setPosition(_position$1.x, _position$1.y, _position$1.z);
				listener.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z);
			}
		}
	}]);

	return AudioListener;
}(Object3D);

var Audio = function (_Object3D13) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Audio, _Object3D13);

	function Audio(listener) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Audio);

		var _this141 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Audio.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Audio)).call(this));

		_this141.type = 'Audio';

		_this141.listener = listener;
		_this141.context = listener.context;

		_this141.gain = _this141.context.createGain();
		_this141.gain.connect(listener.getInput());

		_this141.autoplay = false;

		_this141.buffer = null;
		_this141.detune = 0;
		_this141.loop = false;
		_this141.loopStart = 0;
		_this141.loopEnd = 0;
		_this141.offset = 0;
		_this141.duration = undefined;
		_this141.playbackRate = 1;
		_this141.isPlaying = false;
		_this141.hasPlaybackControl = true;
		_this141.source = null;
		_this141.sourceType = 'empty';

		_this141._startedAt = 0;
		_this141._progress = 0;
		_this141._connected = false;

		_this141.filters = [];

		return _this141;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Audio, [{
		key: 'getOutput',
		value: function getOutput() {

			return this.gain;
		}
	}, {
		key: 'setNodeSource',
		value: function setNodeSource(audioNode) {

			this.hasPlaybackControl = false;
			this.sourceType = 'audioNode';
			this.source = audioNode;
			this.connect();

			return this;
		}
	}, {
		key: 'setMediaElementSource',
		value: function setMediaElementSource(mediaElement) {

			this.hasPlaybackControl = false;
			this.sourceType = 'mediaNode';
			this.source = this.context.createMediaElementSource(mediaElement);
			this.connect();

			return this;
		}
	}, {
		key: 'setMediaStreamSource',
		value: function setMediaStreamSource(mediaStream) {

			this.hasPlaybackControl = false;
			this.sourceType = 'mediaStreamNode';
			this.source = this.context.createMediaStreamSource(mediaStream);
			this.connect();

			return this;
		}
	}, {
		key: 'setBuffer',
		value: function setBuffer(audioBuffer) {

			this.buffer = audioBuffer;
			this.sourceType = 'buffer';

			if (this.autoplay) this.play();

			return this;
		}
	}, {
		key: 'play',
		value: function play() {
			var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


			if (this.isPlaying === true) {

				console.warn('THREE.Audio: Audio is already playing.');
				return;
			}

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return;
			}

			this._startedAt = this.context.currentTime + delay;

			var source = this.context.createBufferSource();
			source.buffer = this.buffer;
			source.loop = this.loop;
			source.loopStart = this.loopStart;
			source.loopEnd = this.loopEnd;
			source.onended = this.onEnded.bind(this);
			source.start(this._startedAt, this._progress + this.offset, this.duration);

			this.isPlaying = true;

			this.source = source;

			this.setDetune(this.detune);
			this.setPlaybackRate(this.playbackRate);

			return this.connect();
		}
	}, {
		key: 'pause',
		value: function pause() {

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return;
			}

			if (this.isPlaying === true) {

				// update current progress

				this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;

				if (this.loop === true) {

					// ensure _progress does not exceed duration with looped audios

					this._progress = this._progress % (this.duration || this.buffer.duration);
				}

				this.source.stop();
				this.source.onended = null;

				this.isPlaying = false;
			}

			return this;
		}
	}, {
		key: 'stop',
		value: function stop() {

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return;
			}

			this._progress = 0;

			if (this.source !== null) {

				this.source.stop();
				this.source.onended = null;
			}

			this.isPlaying = false;

			return this;
		}
	}, {
		key: 'connect',
		value: function connect() {

			if (this.filters.length > 0) {

				this.source.connect(this.filters[0]);

				for (var i = 1, l = this.filters.length; i < l; i++) {

					this.filters[i - 1].connect(this.filters[i]);
				}

				this.filters[this.filters.length - 1].connect(this.getOutput());
			} else {

				this.source.connect(this.getOutput());
			}

			this._connected = true;

			return this;
		}
	}, {
		key: 'disconnect',
		value: function disconnect() {

			if (this.filters.length > 0) {

				this.source.disconnect(this.filters[0]);

				for (var i = 1, l = this.filters.length; i < l; i++) {

					this.filters[i - 1].disconnect(this.filters[i]);
				}

				this.filters[this.filters.length - 1].disconnect(this.getOutput());
			} else {

				this.source.disconnect(this.getOutput());
			}

			this._connected = false;

			return this;
		}
	}, {
		key: 'getFilters',
		value: function getFilters() {

			return this.filters;
		}
	}, {
		key: 'setFilters',
		value: function setFilters(value) {

			if (!value) value = [];

			if (this._connected === true) {

				this.disconnect();
				this.filters = value.slice();
				this.connect();
			} else {

				this.filters = value.slice();
			}

			return this;
		}
	}, {
		key: 'setDetune',
		value: function setDetune(value) {

			this.detune = value;

			if (this.source.detune === undefined) return; // only set detune when available

			if (this.isPlaying === true) {

				this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
			}

			return this;
		}
	}, {
		key: 'getDetune',
		value: function getDetune() {

			return this.detune;
		}
	}, {
		key: 'getFilter',
		value: function getFilter() {

			return this.getFilters()[0];
		}
	}, {
		key: 'setFilter',
		value: function setFilter(filter) {

			return this.setFilters(filter ? [filter] : []);
		}
	}, {
		key: 'setPlaybackRate',
		value: function setPlaybackRate(value) {

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return;
			}

			this.playbackRate = value;

			if (this.isPlaying === true) {

				this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
			}

			return this;
		}
	}, {
		key: 'getPlaybackRate',
		value: function getPlaybackRate() {

			return this.playbackRate;
		}
	}, {
		key: 'onEnded',
		value: function onEnded() {

			this.isPlaying = false;
		}
	}, {
		key: 'getLoop',
		value: function getLoop() {

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return false;
			}

			return this.loop;
		}
	}, {
		key: 'setLoop',
		value: function setLoop(value) {

			if (this.hasPlaybackControl === false) {

				console.warn('THREE.Audio: this Audio has no playback control.');
				return;
			}

			this.loop = value;

			if (this.isPlaying === true) {

				this.source.loop = this.loop;
			}

			return this;
		}
	}, {
		key: 'setLoopStart',
		value: function setLoopStart(value) {

			this.loopStart = value;

			return this;
		}
	}, {
		key: 'setLoopEnd',
		value: function setLoopEnd(value) {

			this.loopEnd = value;

			return this;
		}
	}, {
		key: 'getVolume',
		value: function getVolume() {

			return this.gain.gain.value;
		}
	}, {
		key: 'setVolume',
		value: function setVolume(value) {

			this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);

			return this;
		}
	}]);

	return Audio;
}(Object3D);

var _position = /*@__PURE__*/new Vector3();
var _quaternion = /*@__PURE__*/new Quaternion();
var _scale = /*@__PURE__*/new Vector3();
var _orientation = /*@__PURE__*/new Vector3();

var PositionalAudio = function (_Audio) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PositionalAudio, _Audio);

	function PositionalAudio(listener) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PositionalAudio);

		var _this142 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PositionalAudio.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PositionalAudio)).call(this, listener));

		_this142.panner = _this142.context.createPanner();
		_this142.panner.panningModel = 'HRTF';
		_this142.panner.connect(_this142.gain);

		return _this142;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PositionalAudio, [{
		key: 'disconnect',
		value: function disconnect() {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PositionalAudio.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PositionalAudio.prototype), 'disconnect', this).call(this);

			this.panner.disconnect(this.gain);
		}
	}, {
		key: 'getOutput',
		value: function getOutput() {

			return this.panner;
		}
	}, {
		key: 'getRefDistance',
		value: function getRefDistance() {

			return this.panner.refDistance;
		}
	}, {
		key: 'setRefDistance',
		value: function setRefDistance(value) {

			this.panner.refDistance = value;

			return this;
		}
	}, {
		key: 'getRolloffFactor',
		value: function getRolloffFactor() {

			return this.panner.rolloffFactor;
		}
	}, {
		key: 'setRolloffFactor',
		value: function setRolloffFactor(value) {

			this.panner.rolloffFactor = value;

			return this;
		}
	}, {
		key: 'getDistanceModel',
		value: function getDistanceModel() {

			return this.panner.distanceModel;
		}
	}, {
		key: 'setDistanceModel',
		value: function setDistanceModel(value) {

			this.panner.distanceModel = value;

			return this;
		}
	}, {
		key: 'getMaxDistance',
		value: function getMaxDistance() {

			return this.panner.maxDistance;
		}
	}, {
		key: 'setMaxDistance',
		value: function setMaxDistance(value) {

			this.panner.maxDistance = value;

			return this;
		}
	}, {
		key: 'setDirectionalCone',
		value: function setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {

			this.panner.coneInnerAngle = coneInnerAngle;
			this.panner.coneOuterAngle = coneOuterAngle;
			this.panner.coneOuterGain = coneOuterGain;

			return this;
		}
	}, {
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PositionalAudio.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PositionalAudio.prototype), 'updateMatrixWorld', this).call(this, force);

			if (this.hasPlaybackControl === true && this.isPlaying === false) return;

			this.matrixWorld.decompose(_position, _quaternion, _scale);

			_orientation.set(0, 0, 1).applyQuaternion(_quaternion);

			var panner = this.panner;

			if (panner.positionX) {

				// code path for Chrome and Firefox (see #14393)

				var endTime = this.context.currentTime + this.listener.timeDelta;

				panner.positionX.linearRampToValueAtTime(_position.x, endTime);
				panner.positionY.linearRampToValueAtTime(_position.y, endTime);
				panner.positionZ.linearRampToValueAtTime(_position.z, endTime);
				panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
				panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
				panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
			} else {

				panner.setPosition(_position.x, _position.y, _position.z);
				panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
			}
		}
	}]);

	return PositionalAudio;
}(Audio);

var AudioAnalyser = function () {
	function AudioAnalyser(audio) {
		var fftSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2048;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AudioAnalyser);

		this.analyser = audio.context.createAnalyser();
		this.analyser.fftSize = fftSize;

		this.data = new Uint8Array(this.analyser.frequencyBinCount);

		audio.getOutput().connect(this.analyser);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AudioAnalyser, [{
		key: 'getFrequencyData',
		value: function getFrequencyData() {

			this.analyser.getByteFrequencyData(this.data);

			return this.data;
		}
	}, {
		key: 'getAverageFrequency',
		value: function getAverageFrequency() {

			var value = 0;
			var data = this.getFrequencyData();

			for (var i = 0; i < data.length; i++) {

				value += data[i];
			}

			return value / data.length;
		}
	}]);

	return AudioAnalyser;
}();

var PropertyMixer = function () {
	function PropertyMixer(binding, typeName, valueSize) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PropertyMixer);

		this.binding = binding;
		this.valueSize = valueSize;

		var mixFunction = void 0,
		    mixFunctionAdditive = void 0,
		    setIdentity = void 0;

		// buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
		//
		// interpolators can use .buffer as their .result
		// the data then goes to 'incoming'
		//
		// 'accu0' and 'accu1' are used frame-interleaved for
		// the cumulative result and are compared to detect
		// changes
		//
		// 'orig' stores the original state of the property
		//
		// 'add' is used for additive cumulative results
		//
		// 'work' is optional and is only present for quaternion types. It is used
		// to store intermediate quaternion multiplication results

		switch (typeName) {

			case 'quaternion':
				mixFunction = this._slerp;
				mixFunctionAdditive = this._slerpAdditive;
				setIdentity = this._setAdditiveIdentityQuaternion;

				this.buffer = new Float64Array(valueSize * 6);
				this._workIndex = 5;
				break;

			case 'string':
			case 'bool':
				mixFunction = this._select;

				// Use the regular mix function and for additive on these types,
				// additive is not relevant for non-numeric types
				mixFunctionAdditive = this._select;

				setIdentity = this._setAdditiveIdentityOther;

				this.buffer = new Array(valueSize * 5);
				break;

			default:
				mixFunction = this._lerp;
				mixFunctionAdditive = this._lerpAdditive;
				setIdentity = this._setAdditiveIdentityNumeric;

				this.buffer = new Float64Array(valueSize * 5);

		}

		this._mixBufferRegion = mixFunction;
		this._mixBufferRegionAdditive = mixFunctionAdditive;
		this._setIdentity = setIdentity;
		this._origIndex = 3;
		this._addIndex = 4;

		this.cumulativeWeight = 0;
		this.cumulativeWeightAdditive = 0;

		this.useCount = 0;
		this.referenceCount = 0;
	}

	// accumulate data in the 'incoming' region into 'accu<i>'


	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PropertyMixer, [{
		key: 'accumulate',
		value: function accumulate(accuIndex, weight) {

			// note: happily accumulating nothing when weight = 0, the caller knows
			// the weight and shouldn't have made the call in the first place

			var buffer = this.buffer,
			    stride = this.valueSize,
			    offset = accuIndex * stride + stride;

			var currentWeight = this.cumulativeWeight;

			if (currentWeight === 0) {

				// accuN := incoming * weight

				for (var i = 0; i !== stride; ++i) {

					buffer[offset + i] = buffer[i];
				}

				currentWeight = weight;
			} else {

				// accuN := accuN + incoming * weight

				currentWeight += weight;
				var mix = weight / currentWeight;
				this._mixBufferRegion(buffer, offset, 0, mix, stride);
			}

			this.cumulativeWeight = currentWeight;
		}

		// accumulate data in the 'incoming' region into 'add'

	}, {
		key: 'accumulateAdditive',
		value: function accumulateAdditive(weight) {

			var buffer = this.buffer,
			    stride = this.valueSize,
			    offset = stride * this._addIndex;

			if (this.cumulativeWeightAdditive === 0) {

				// add = identity

				this._setIdentity();
			}

			// add := add + incoming * weight

			this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
			this.cumulativeWeightAdditive += weight;
		}

		// apply the state of 'accu<i>' to the binding when accus differ

	}, {
		key: 'apply',
		value: function apply(accuIndex) {

			var stride = this.valueSize,
			    buffer = this.buffer,
			    offset = accuIndex * stride + stride,
			    weight = this.cumulativeWeight,
			    weightAdditive = this.cumulativeWeightAdditive,
			    binding = this.binding;

			this.cumulativeWeight = 0;
			this.cumulativeWeightAdditive = 0;

			if (weight < 1) {

				// accuN := accuN + original * ( 1 - cumulativeWeight )

				var originalValueOffset = stride * this._origIndex;

				this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
			}

			if (weightAdditive > 0) {

				// accuN := accuN + additive accuN

				this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
			}

			for (var i = stride, e = stride + stride; i !== e; ++i) {

				if (buffer[i] !== buffer[i + stride]) {

					// value has changed -> update scene graph

					binding.setValue(buffer, offset);
					break;
				}
			}
		}

		// remember the state of the bound property and copy it to both accus

	}, {
		key: 'saveOriginalState',
		value: function saveOriginalState() {

			var binding = this.binding;

			var buffer = this.buffer,
			    stride = this.valueSize,
			    originalValueOffset = stride * this._origIndex;

			binding.getValue(buffer, originalValueOffset);

			// accu[0..1] := orig -- initially detect changes against the original
			for (var i = stride, e = originalValueOffset; i !== e; ++i) {

				buffer[i] = buffer[originalValueOffset + i % stride];
			}

			// Add to identity for additive
			this._setIdentity();

			this.cumulativeWeight = 0;
			this.cumulativeWeightAdditive = 0;
		}

		// apply the state previously taken via 'saveOriginalState' to the binding

	}, {
		key: 'restoreOriginalState',
		value: function restoreOriginalState() {

			var originalValueOffset = this.valueSize * 3;
			this.binding.setValue(this.buffer, originalValueOffset);
		}
	}, {
		key: '_setAdditiveIdentityNumeric',
		value: function _setAdditiveIdentityNumeric() {

			var startIndex = this._addIndex * this.valueSize;
			var endIndex = startIndex + this.valueSize;

			for (var i = startIndex; i < endIndex; i++) {

				this.buffer[i] = 0;
			}
		}
	}, {
		key: '_setAdditiveIdentityQuaternion',
		value: function _setAdditiveIdentityQuaternion() {

			this._setAdditiveIdentityNumeric();
			this.buffer[this._addIndex * this.valueSize + 3] = 1;
		}
	}, {
		key: '_setAdditiveIdentityOther',
		value: function _setAdditiveIdentityOther() {

			var startIndex = this._origIndex * this.valueSize;
			var targetIndex = this._addIndex * this.valueSize;

			for (var i = 0; i < this.valueSize; i++) {

				this.buffer[targetIndex + i] = this.buffer[startIndex + i];
			}
		}

		// mix functions

	}, {
		key: '_select',
		value: function _select(buffer, dstOffset, srcOffset, t, stride) {

			if (t >= 0.5) {

				for (var i = 0; i !== stride; ++i) {

					buffer[dstOffset + i] = buffer[srcOffset + i];
				}
			}
		}
	}, {
		key: '_slerp',
		value: function _slerp(buffer, dstOffset, srcOffset, t) {

			Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
		}
	}, {
		key: '_slerpAdditive',
		value: function _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {

			var workOffset = this._workIndex * stride;

			// Store result in intermediate buffer offset
			Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);

			// Slerp to the intermediate result
			Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
		}
	}, {
		key: '_lerp',
		value: function _lerp(buffer, dstOffset, srcOffset, t, stride) {

			var s = 1 - t;

			for (var i = 0; i !== stride; ++i) {

				var j = dstOffset + i;

				buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
			}
		}
	}, {
		key: '_lerpAdditive',
		value: function _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {

			for (var i = 0; i !== stride; ++i) {

				var j = dstOffset + i;

				buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
			}
		}
	}]);

	return PropertyMixer;
}();

// Characters [].:/ are reserved for track binding syntax.


var _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
var _reservedRe = new RegExp('[' + _RESERVED_CHARS_RE + ']', 'g');

// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
var _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
var _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']';

// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
var _directoryRe = /*@__PURE__*//((?:WC+[\/:])*)/.source.replace('WC', _wordChar);

// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
var _nodeRe = /*@__PURE__*//(WCOD+)?/.source.replace('WCOD', _wordCharOrDot);

// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
var _objectRe = /*@__PURE__*//(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar);

// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
var _propertyRe = /*@__PURE__*//\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);

var _trackRe = new RegExp('' + '^' + _directoryRe + _nodeRe + _objectRe + _propertyRe + '$');

var _supportedObjectNames = ['material', 'materials', 'bones', 'map'];

var Composite = function () {
	function Composite(targetGroup, path, optionalParsedPath) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Composite);

		var parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);

		this._targetGroup = targetGroup;
		this._bindings = targetGroup.subscribe_(path, parsedPath);
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Composite, [{
		key: 'getValue',
		value: function getValue(array, offset) {

			this.bind(); // bind all binding

			var firstValidIndex = this._targetGroup.nCachedObjects_,
			    binding = this._bindings[firstValidIndex];

			// and only call .getValue on the first
			if (binding !== undefined) binding.getValue(array, offset);
		}
	}, {
		key: 'setValue',
		value: function setValue(array, offset) {

			var bindings = this._bindings;

			for (var i = this._targetGroup.nCachedObjects_, _n10 = bindings.length; i !== _n10; ++i) {

				bindings[i].setValue(array, offset);
			}
		}
	}, {
		key: 'bind',
		value: function bind() {

			var bindings = this._bindings;

			for (var i = this._targetGroup.nCachedObjects_, _n11 = bindings.length; i !== _n11; ++i) {

				bindings[i].bind();
			}
		}
	}, {
		key: 'unbind',
		value: function unbind() {

			var bindings = this._bindings;

			for (var i = this._targetGroup.nCachedObjects_, _n12 = bindings.length; i !== _n12; ++i) {

				bindings[i].unbind();
			}
		}
	}]);

	return Composite;
}();

// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.


var PropertyBinding = function () {
	function PropertyBinding(rootNode, path, parsedPath) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PropertyBinding);

		this.path = path;
		this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);

		this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);

		this.rootNode = rootNode;

		// initial state of these methods that calls 'bind'
		this.getValue = this._getValue_unbound;
		this.setValue = this._setValue_unbound;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PropertyBinding, [{
		key: '_getValue_unavailable',


		// these are used to "bind" a nonexistent property
		value: function _getValue_unavailable() {}
	}, {
		key: '_setValue_unavailable',
		value: function _setValue_unavailable() {}

		// Getters

	}, {
		key: '_getValue_direct',
		value: function _getValue_direct(buffer, offset) {

			buffer[offset] = this.targetObject[this.propertyName];
		}
	}, {
		key: '_getValue_array',
		value: function _getValue_array(buffer, offset) {

			var source = this.resolvedProperty;

			for (var i = 0, _n13 = source.length; i !== _n13; ++i) {

				buffer[offset++] = source[i];
			}
		}
	}, {
		key: '_getValue_arrayElement',
		value: function _getValue_arrayElement(buffer, offset) {

			buffer[offset] = this.resolvedProperty[this.propertyIndex];
		}
	}, {
		key: '_getValue_toArray',
		value: function _getValue_toArray(buffer, offset) {

			this.resolvedProperty.toArray(buffer, offset);
		}

		// Direct

	}, {
		key: '_setValue_direct',
		value: function _setValue_direct(buffer, offset) {

			this.targetObject[this.propertyName] = buffer[offset];
		}
	}, {
		key: '_setValue_direct_setNeedsUpdate',
		value: function _setValue_direct_setNeedsUpdate(buffer, offset) {

			this.targetObject[this.propertyName] = buffer[offset];
			this.targetObject.needsUpdate = true;
		}
	}, {
		key: '_setValue_direct_setMatrixWorldNeedsUpdate',
		value: function _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {

			this.targetObject[this.propertyName] = buffer[offset];
			this.targetObject.matrixWorldNeedsUpdate = true;
		}

		// EntireArray

	}, {
		key: '_setValue_array',
		value: function _setValue_array(buffer, offset) {

			var dest = this.resolvedProperty;

			for (var i = 0, _n14 = dest.length; i !== _n14; ++i) {

				dest[i] = buffer[offset++];
			}
		}
	}, {
		key: '_setValue_array_setNeedsUpdate',
		value: function _setValue_array_setNeedsUpdate(buffer, offset) {

			var dest = this.resolvedProperty;

			for (var i = 0, _n15 = dest.length; i !== _n15; ++i) {

				dest[i] = buffer[offset++];
			}

			this.targetObject.needsUpdate = true;
		}
	}, {
		key: '_setValue_array_setMatrixWorldNeedsUpdate',
		value: function _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {

			var dest = this.resolvedProperty;

			for (var i = 0, _n16 = dest.length; i !== _n16; ++i) {

				dest[i] = buffer[offset++];
			}

			this.targetObject.matrixWorldNeedsUpdate = true;
		}

		// ArrayElement

	}, {
		key: '_setValue_arrayElement',
		value: function _setValue_arrayElement(buffer, offset) {

			this.resolvedProperty[this.propertyIndex] = buffer[offset];
		}
	}, {
		key: '_setValue_arrayElement_setNeedsUpdate',
		value: function _setValue_arrayElement_setNeedsUpdate(buffer, offset) {

			this.resolvedProperty[this.propertyIndex] = buffer[offset];
			this.targetObject.needsUpdate = true;
		}
	}, {
		key: '_setValue_arrayElement_setMatrixWorldNeedsUpdate',
		value: function _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {

			this.resolvedProperty[this.propertyIndex] = buffer[offset];
			this.targetObject.matrixWorldNeedsUpdate = true;
		}

		// HasToFromArray

	}, {
		key: '_setValue_fromArray',
		value: function _setValue_fromArray(buffer, offset) {

			this.resolvedProperty.fromArray(buffer, offset);
		}
	}, {
		key: '_setValue_fromArray_setNeedsUpdate',
		value: function _setValue_fromArray_setNeedsUpdate(buffer, offset) {

			this.resolvedProperty.fromArray(buffer, offset);
			this.targetObject.needsUpdate = true;
		}
	}, {
		key: '_setValue_fromArray_setMatrixWorldNeedsUpdate',
		value: function _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {

			this.resolvedProperty.fromArray(buffer, offset);
			this.targetObject.matrixWorldNeedsUpdate = true;
		}
	}, {
		key: '_getValue_unbound',
		value: function _getValue_unbound(targetArray, offset) {

			this.bind();
			this.getValue(targetArray, offset);
		}
	}, {
		key: '_setValue_unbound',
		value: function _setValue_unbound(sourceArray, offset) {

			this.bind();
			this.setValue(sourceArray, offset);
		}

		// create getter / setter pair for a property in the scene graph

	}, {
		key: 'bind',
		value: function bind() {

			var targetObject = this.node;
			var parsedPath = this.parsedPath;

			var objectName = parsedPath.objectName;
			var propertyName = parsedPath.propertyName;
			var propertyIndex = parsedPath.propertyIndex;

			if (!targetObject) {

				targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);

				this.node = targetObject;
			}

			// set fail state so we can just 'return' on error
			this.getValue = this._getValue_unavailable;
			this.setValue = this._setValue_unavailable;

			// ensure there is a value node
			if (!targetObject) {

				console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
				return;
			}

			if (objectName) {

				var objectIndex = parsedPath.objectIndex;

				// special cases were we need to reach deeper into the hierarchy to get the face materials....
				switch (objectName) {

					case 'materials':

						if (!targetObject.material) {

							console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
							return;
						}

						if (!targetObject.material.materials) {

							console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
							return;
						}

						targetObject = targetObject.material.materials;

						break;

					case 'bones':

						if (!targetObject.skeleton) {

							console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
							return;
						}

						// potential future optimization: skip this if propertyIndex is already an integer
						// and convert the integer string to a true integer.

						targetObject = targetObject.skeleton.bones;

						// support resolving morphTarget names into indices.
						for (var i = 0; i < targetObject.length; i++) {

							if (targetObject[i].name === objectIndex) {

								objectIndex = i;
								break;
							}
						}

						break;

					case 'map':

						if ('map' in targetObject) {

							targetObject = targetObject.map;
							break;
						}

						if (!targetObject.material) {

							console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
							return;
						}

						if (!targetObject.material.map) {

							console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
							return;
						}

						targetObject = targetObject.material.map;
						break;

					default:

						if (targetObject[objectName] === undefined) {

							console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
							return;
						}

						targetObject = targetObject[objectName];

				}

				if (objectIndex !== undefined) {

					if (targetObject[objectIndex] === undefined) {

						console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
						return;
					}

					targetObject = targetObject[objectIndex];
				}
			}

			// resolve property
			var nodeProperty = targetObject[propertyName];

			if (nodeProperty === undefined) {

				var nodeName = parsedPath.nodeName;

				console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
				return;
			}

			// determine versioning scheme
			var versioning = this.Versioning.None;

			this.targetObject = targetObject;

			if (targetObject.needsUpdate !== undefined) {
				// material

				versioning = this.Versioning.NeedsUpdate;
			} else if (targetObject.matrixWorldNeedsUpdate !== undefined) {
				// node transform

				versioning = this.Versioning.MatrixWorldNeedsUpdate;
			}

			// determine how the property gets bound
			var bindingType = this.BindingType.Direct;

			if (propertyIndex !== undefined) {

				// access a sub element of the property array (only primitives are supported right now)

				if (propertyName === 'morphTargetInfluences') {

					// potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.

					// support resolving morphTarget names into indices.
					if (!targetObject.geometry) {

						console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
						return;
					}

					if (!targetObject.geometry.morphAttributes) {

						console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
						return;
					}

					if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) {

						propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
					}
				}

				bindingType = this.BindingType.ArrayElement;

				this.resolvedProperty = nodeProperty;
				this.propertyIndex = propertyIndex;
			} else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {

				// must use copy for Object3D.Euler/Quaternion

				bindingType = this.BindingType.HasFromToArray;

				this.resolvedProperty = nodeProperty;
			} else if (Array.isArray(nodeProperty)) {

				bindingType = this.BindingType.EntireArray;

				this.resolvedProperty = nodeProperty;
			} else {

				this.propertyName = propertyName;
			}

			// select getter / setter
			this.getValue = this.GetterByBindingType[bindingType];
			this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
		}
	}, {
		key: 'unbind',
		value: function unbind() {

			this.node = null;

			// back to the prototype version of getValue / setValue
			// note: avoiding to mutate the shape of 'this' via 'delete'
			this.getValue = this._getValue_unbound;
			this.setValue = this._setValue_unbound;
		}
	}], [{
		key: 'create',
		value: function create(root, path, parsedPath) {

			if (!(root && root.isAnimationObjectGroup)) {

				return new PropertyBinding(root, path, parsedPath);
			} else {

				return new PropertyBinding.Composite(root, path, parsedPath);
			}
		}

		/**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */

	}, {
		key: 'sanitizeNodeName',
		value: function sanitizeNodeName(name) {

			return name.replace(/\s/g, '_').replace(_reservedRe, '');
		}
	}, {
		key: 'parseTrackName',
		value: function parseTrackName(trackName) {

			var matches = _trackRe.exec(trackName);

			if (matches === null) {

				throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
			}

			var results = {
				// directoryName: matches[ 1 ], // (tschw) currently unused
				nodeName: matches[2],
				objectName: matches[3],
				objectIndex: matches[4],
				propertyName: matches[5], // required
				propertyIndex: matches[6]
			};

			var lastDot = results.nodeName && results.nodeName.lastIndexOf('.');

			if (lastDot !== undefined && lastDot !== -1) {

				var objectName = results.nodeName.substring(lastDot + 1);

				// Object names must be checked against an allowlist. Otherwise, there
				// is no way to parse 'foo.bar.baz': 'baz' must be a property, but
				// 'bar' could be the objectName, or part of a nodeName (which can
				// include '.' characters).
				if (_supportedObjectNames.indexOf(objectName) !== -1) {

					results.nodeName = results.nodeName.substring(0, lastDot);
					results.objectName = objectName;
				}
			}

			if (results.propertyName === null || results.propertyName.length === 0) {

				throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
			}

			return results;
		}
	}, {
		key: 'findNode',
		value: function findNode(root, nodeName) {

			if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) {

				return root;
			}

			// search into skeleton bones.
			if (root.skeleton) {

				var bone = root.skeleton.getBoneByName(nodeName);

				if (bone !== undefined) {

					return bone;
				}
			}

			// search into node subtree.
			if (root.children) {

				var searchNodeSubtree = function searchNodeSubtree(children) {

					for (var i = 0; i < children.length; i++) {

						var childNode = children[i];

						if (childNode.name === nodeName || childNode.uuid === nodeName) {

							return childNode;
						}

						var result = searchNodeSubtree(childNode.children);

						if (result) return result;
					}

					return null;
				};

				var subTreeNode = searchNodeSubtree(root.children);

				if (subTreeNode) {

					return subTreeNode;
				}
			}

			return null;
		}
	}]);

	return PropertyBinding;
}();

PropertyBinding.Composite = Composite;

PropertyBinding.prototype.BindingType = {
	Direct: 0,
	EntireArray: 1,
	ArrayElement: 2,
	HasFromToArray: 3
};

PropertyBinding.prototype.Versioning = {
	None: 0,
	NeedsUpdate: 1,
	MatrixWorldNeedsUpdate: 2
};

PropertyBinding.prototype.GetterByBindingType = [PropertyBinding.prototype._getValue_direct, PropertyBinding.prototype._getValue_array, PropertyBinding.prototype._getValue_arrayElement, PropertyBinding.prototype._getValue_toArray];

PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [[
// Direct
PropertyBinding.prototype._setValue_direct, PropertyBinding.prototype._setValue_direct_setNeedsUpdate, PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate], [

// EntireArray

PropertyBinding.prototype._setValue_array, PropertyBinding.prototype._setValue_array_setNeedsUpdate, PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate], [

// ArrayElement
PropertyBinding.prototype._setValue_arrayElement, PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate, PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate], [

// HasToFromArray
PropertyBinding.prototype._setValue_fromArray, PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate, PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]];

/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */

var AnimationObjectGroup = function () {
	function AnimationObjectGroup() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AnimationObjectGroup);

		this.isAnimationObjectGroup = true;

		this.uuid = generateUUID();

		// cached objects followed by the active ones
		this._objects = Array.prototype.slice.call(arguments);

		this.nCachedObjects_ = 0; // threshold
		// note: read by PropertyBinding.Composite

		var indices = {};
		this._indicesByUUID = indices; // for bookkeeping

		for (var i = 0, _n17 = arguments.length; i !== _n17; ++i) {

			indices[arguments[i].uuid] = i;
		}

		this._paths = []; // inside: string
		this._parsedPaths = []; // inside: { we don't care, here }
		this._bindings = []; // inside: Array< PropertyBinding >
		this._bindingsIndicesByPath = {}; // inside: indices in these arrays

		var scope = this;

		this.stats = {

			objects: {
				get total() {

					return scope._objects.length;
				},
				get inUse() {

					return this.total - scope.nCachedObjects_;
				}
			},
			get bindingsPerObject() {

				return scope._bindings.length;
			}

		};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AnimationObjectGroup, [{
		key: 'add',
		value: function add() {

			var objects = this._objects,
			    indicesByUUID = this._indicesByUUID,
			    paths = this._paths,
			    parsedPaths = this._parsedPaths,
			    bindings = this._bindings,
			    nBindings = bindings.length;

			var knownObject = undefined,
			    nObjects = objects.length,
			    nCachedObjects = this.nCachedObjects_;

			for (var i = 0, _n18 = arguments.length; i !== _n18; ++i) {

				var _object = arguments[i],
				    uuid = _object.uuid;
				var _index3 = indicesByUUID[uuid];

				if (_index3 === undefined) {

					// unknown object -> add it to the ACTIVE region

					_index3 = nObjects++;
					indicesByUUID[uuid] = _index3;
					objects.push(_object);

					// accounting is done, now do the same for all bindings

					for (var j = 0, m = nBindings; j !== m; ++j) {

						bindings[j].push(new PropertyBinding(_object, paths[j], parsedPaths[j]));
					}
				} else if (_index3 < nCachedObjects) {

					knownObject = objects[_index3];

					// move existing object to the ACTIVE region

					var firstActiveIndex = --nCachedObjects,
					    lastCachedObject = objects[firstActiveIndex];

					indicesByUUID[lastCachedObject.uuid] = _index3;
					objects[_index3] = lastCachedObject;

					indicesByUUID[uuid] = firstActiveIndex;
					objects[firstActiveIndex] = _object;

					// accounting is done, now do the same for all bindings

					for (var _j16 = 0, _m2 = nBindings; _j16 !== _m2; ++_j16) {

						var bindingsForPath = bindings[_j16],
						    lastCached = bindingsForPath[firstActiveIndex];

						var binding = bindingsForPath[_index3];

						bindingsForPath[_index3] = lastCached;

						if (binding === undefined) {

							// since we do not bother to create new bindings
							// for objects that are cached, the binding may
							// or may not exist

							binding = new PropertyBinding(_object, paths[_j16], parsedPaths[_j16]);
						}

						bindingsForPath[firstActiveIndex] = binding;
					}
				} else if (objects[_index3] !== knownObject) {

					console.error('THREE.AnimationObjectGroup: Different objects with the same UUID ' + 'detected. Clean the caches or recreate your infrastructure when reloading scenes.');
				} // else the object is already where we want it to be
			} // for arguments

			this.nCachedObjects_ = nCachedObjects;
		}
	}, {
		key: 'remove',
		value: function remove() {

			var objects = this._objects,
			    indicesByUUID = this._indicesByUUID,
			    bindings = this._bindings,
			    nBindings = bindings.length;

			var nCachedObjects = this.nCachedObjects_;

			for (var i = 0, _n19 = arguments.length; i !== _n19; ++i) {

				var _object2 = arguments[i],
				    uuid = _object2.uuid,
				    _index4 = indicesByUUID[uuid];

				if (_index4 !== undefined && _index4 >= nCachedObjects) {

					// move existing object into the CACHED region

					var lastCachedIndex = nCachedObjects++,
					    firstActiveObject = objects[lastCachedIndex];

					indicesByUUID[firstActiveObject.uuid] = _index4;
					objects[_index4] = firstActiveObject;

					indicesByUUID[uuid] = lastCachedIndex;
					objects[lastCachedIndex] = _object2;

					// accounting is done, now do the same for all bindings

					for (var j = 0, m = nBindings; j !== m; ++j) {

						var bindingsForPath = bindings[j],
						    firstActive = bindingsForPath[lastCachedIndex],
						    binding = bindingsForPath[_index4];

						bindingsForPath[_index4] = firstActive;
						bindingsForPath[lastCachedIndex] = binding;
					}
				}
			} // for arguments

			this.nCachedObjects_ = nCachedObjects;
		}

		// remove & forget

	}, {
		key: 'uncache',
		value: function uncache() {

			var objects = this._objects,
			    indicesByUUID = this._indicesByUUID,
			    bindings = this._bindings,
			    nBindings = bindings.length;

			var nCachedObjects = this.nCachedObjects_,
			    nObjects = objects.length;

			for (var i = 0, _n20 = arguments.length; i !== _n20; ++i) {

				var _object3 = arguments[i],
				    uuid = _object3.uuid,
				    _index5 = indicesByUUID[uuid];

				if (_index5 !== undefined) {

					delete indicesByUUID[uuid];

					if (_index5 < nCachedObjects) {

						// object is cached, shrink the CACHED region

						var firstActiveIndex = --nCachedObjects,
						    lastCachedObject = objects[firstActiveIndex],
						    _lastIndex = --nObjects,
						    lastObject = objects[_lastIndex];

						// last cached object takes this object's place
						indicesByUUID[lastCachedObject.uuid] = _index5;
						objects[_index5] = lastCachedObject;

						// last object goes to the activated slot and pop
						indicesByUUID[lastObject.uuid] = firstActiveIndex;
						objects[firstActiveIndex] = lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for (var j = 0, m = nBindings; j !== m; ++j) {

							var bindingsForPath = bindings[j],
							    lastCached = bindingsForPath[firstActiveIndex],
							    last = bindingsForPath[_lastIndex];

							bindingsForPath[_index5] = lastCached;
							bindingsForPath[firstActiveIndex] = last;
							bindingsForPath.pop();
						}
					} else {

						// object is active, just swap with the last and pop

						var _lastIndex2 = --nObjects,
						    _lastObject = objects[_lastIndex2];

						if (_lastIndex2 > 0) {

							indicesByUUID[_lastObject.uuid] = _index5;
						}

						objects[_index5] = _lastObject;
						objects.pop();

						// accounting is done, now do the same for all bindings

						for (var _j17 = 0, _m4 = nBindings; _j17 !== _m4; ++_j17) {

							var _bindingsForPath = bindings[_j17];

							_bindingsForPath[_index5] = _bindingsForPath[_lastIndex2];
							_bindingsForPath.pop();
						}
					} // cached or active
				} // if object is known
			} // for arguments

			this.nCachedObjects_ = nCachedObjects;
		}

		// Internal interface used by befriended PropertyBinding.Composite:

	}, {
		key: 'subscribe_',
		value: function subscribe_(path, parsedPath) {

			// returns an array of bindings for the given path that is changed
			// according to the contained objects in the group

			var indicesByPath = this._bindingsIndicesByPath;
			var index = indicesByPath[path];
			var bindings = this._bindings;

			if (index !== undefined) return bindings[index];

			var paths = this._paths,
			    parsedPaths = this._parsedPaths,
			    objects = this._objects,
			    nObjects = objects.length,
			    nCachedObjects = this.nCachedObjects_,
			    bindingsForPath = new Array(nObjects);

			index = bindings.length;

			indicesByPath[path] = index;

			paths.push(path);
			parsedPaths.push(parsedPath);
			bindings.push(bindingsForPath);

			for (var i = nCachedObjects, _n21 = objects.length; i !== _n21; ++i) {

				var _object4 = objects[i];
				bindingsForPath[i] = new PropertyBinding(_object4, path, parsedPath);
			}

			return bindingsForPath;
		}
	}, {
		key: 'unsubscribe_',
		value: function unsubscribe_(path) {

			// tells the group to forget about a property path and no longer
			// update the array previously obtained with 'subscribe_'

			var indicesByPath = this._bindingsIndicesByPath,
			    index = indicesByPath[path];

			if (index !== undefined) {

				var paths = this._paths,
				    parsedPaths = this._parsedPaths,
				    bindings = this._bindings,
				    lastBindingsIndex = bindings.length - 1,
				    lastBindings = bindings[lastBindingsIndex],
				    lastBindingsPath = path[lastBindingsIndex];

				indicesByPath[lastBindingsPath] = index;

				bindings[index] = lastBindings;
				bindings.pop();

				parsedPaths[index] = parsedPaths[lastBindingsIndex];
				parsedPaths.pop();

				paths[index] = paths[lastBindingsIndex];
				paths.pop();
			}
		}
	}]);

	return AnimationObjectGroup;
}();

var AnimationAction = function () {
	function AnimationAction(mixer, clip) {
		var localRoot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var blendMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : clip.blendMode;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AnimationAction);

		this._mixer = mixer;
		this._clip = clip;
		this._localRoot = localRoot;
		this.blendMode = blendMode;

		var tracks = clip.tracks,
		    nTracks = tracks.length,
		    interpolants = new Array(nTracks);

		var interpolantSettings = {
			endingStart: ZeroCurvatureEnding,
			endingEnd: ZeroCurvatureEnding
		};

		for (var i = 0; i !== nTracks; ++i) {

			var interpolant = tracks[i].createInterpolant(null);
			interpolants[i] = interpolant;
			interpolant.settings = interpolantSettings;
		}

		this._interpolantSettings = interpolantSettings;

		this._interpolants = interpolants; // bound by the mixer

		// inside: PropertyMixer (managed by the mixer)
		this._propertyBindings = new Array(nTracks);

		this._cacheIndex = null; // for the memory manager
		this._byClipCacheIndex = null; // for the memory manager

		this._timeScaleInterpolant = null;
		this._weightInterpolant = null;

		this.loop = LoopRepeat;
		this._loopCount = -1;

		// global mixer time when the action is to be started
		// it's set back to 'null' upon start of the action
		this._startTime = null;

		// scaled local time of the action
		// gets clamped or wrapped to 0..clip.duration according to loop
		this.time = 0;

		this.timeScale = 1;
		this._effectiveTimeScale = 1;

		this.weight = 1;
		this._effectiveWeight = 1;

		this.repetitions = Infinity; // no. of repetitions when looping

		this.paused = false; // true -> zero effective time scale
		this.enabled = true; // false -> zero effective weight

		this.clampWhenFinished = false; // keep feeding the last frame?

		this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
		this.zeroSlopeAtEnd = true; // clips for start, loop and end
	}

	// State & Scheduling

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AnimationAction, [{
		key: 'play',
		value: function play() {

			this._mixer._activateAction(this);

			return this;
		}
	}, {
		key: 'stop',
		value: function stop() {

			this._mixer._deactivateAction(this);

			return this.reset();
		}
	}, {
		key: 'reset',
		value: function reset() {

			this.paused = false;
			this.enabled = true;

			this.time = 0; // restart clip
			this._loopCount = -1; // forget previous loops
			this._startTime = null; // forget scheduling

			return this.stopFading().stopWarping();
		}
	}, {
		key: 'isRunning',
		value: function isRunning() {

			return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
		}

		// return true when play has been called

	}, {
		key: 'isScheduled',
		value: function isScheduled() {

			return this._mixer._isActiveAction(this);
		}
	}, {
		key: 'startAt',
		value: function startAt(time) {

			this._startTime = time;

			return this;
		}
	}, {
		key: 'setLoop',
		value: function setLoop(mode, repetitions) {

			this.loop = mode;
			this.repetitions = repetitions;

			return this;
		}

		// Weight

		// set the weight stopping any scheduled fading
		// although .enabled = false yields an effective weight of zero, this
		// method does *not* change .enabled, because it would be confusing

	}, {
		key: 'setEffectiveWeight',
		value: function setEffectiveWeight(weight) {

			this.weight = weight;

			// note: same logic as when updated at runtime
			this._effectiveWeight = this.enabled ? weight : 0;

			return this.stopFading();
		}

		// return the weight considering fading and .enabled

	}, {
		key: 'getEffectiveWeight',
		value: function getEffectiveWeight() {

			return this._effectiveWeight;
		}
	}, {
		key: 'fadeIn',
		value: function fadeIn(duration) {

			return this._scheduleFading(duration, 0, 1);
		}
	}, {
		key: 'fadeOut',
		value: function fadeOut(duration) {

			return this._scheduleFading(duration, 1, 0);
		}
	}, {
		key: 'crossFadeFrom',
		value: function crossFadeFrom(fadeOutAction, duration, warp) {

			fadeOutAction.fadeOut(duration);
			this.fadeIn(duration);

			if (warp) {

				var fadeInDuration = this._clip.duration,
				    fadeOutDuration = fadeOutAction._clip.duration,
				    startEndRatio = fadeOutDuration / fadeInDuration,
				    endStartRatio = fadeInDuration / fadeOutDuration;

				fadeOutAction.warp(1.0, startEndRatio, duration);
				this.warp(endStartRatio, 1.0, duration);
			}

			return this;
		}
	}, {
		key: 'crossFadeTo',
		value: function crossFadeTo(fadeInAction, duration, warp) {

			return fadeInAction.crossFadeFrom(this, duration, warp);
		}
	}, {
		key: 'stopFading',
		value: function stopFading() {

			var weightInterpolant = this._weightInterpolant;

			if (weightInterpolant !== null) {

				this._weightInterpolant = null;
				this._mixer._takeBackControlInterpolant(weightInterpolant);
			}

			return this;
		}

		// Time Scale Control

		// set the time scale stopping any scheduled warping
		// although .paused = true yields an effective time scale of zero, this
		// method does *not* change .paused, because it would be confusing

	}, {
		key: 'setEffectiveTimeScale',
		value: function setEffectiveTimeScale(timeScale) {

			this.timeScale = timeScale;
			this._effectiveTimeScale = this.paused ? 0 : timeScale;

			return this.stopWarping();
		}

		// return the time scale considering warping and .paused

	}, {
		key: 'getEffectiveTimeScale',
		value: function getEffectiveTimeScale() {

			return this._effectiveTimeScale;
		}
	}, {
		key: 'setDuration',
		value: function setDuration(duration) {

			this.timeScale = this._clip.duration / duration;

			return this.stopWarping();
		}
	}, {
		key: 'syncWith',
		value: function syncWith(action) {

			this.time = action.time;
			this.timeScale = action.timeScale;

			return this.stopWarping();
		}
	}, {
		key: 'halt',
		value: function halt(duration) {

			return this.warp(this._effectiveTimeScale, 0, duration);
		}
	}, {
		key: 'warp',
		value: function warp(startTimeScale, endTimeScale, duration) {

			var mixer = this._mixer,
			    now = mixer.time,
			    timeScale = this.timeScale;

			var interpolant = this._timeScaleInterpolant;

			if (interpolant === null) {

				interpolant = mixer._lendControlInterpolant();
				this._timeScaleInterpolant = interpolant;
			}

			var times = interpolant.parameterPositions,
			    values = interpolant.sampleValues;

			times[0] = now;
			times[1] = now + duration;

			values[0] = startTimeScale / timeScale;
			values[1] = endTimeScale / timeScale;

			return this;
		}
	}, {
		key: 'stopWarping',
		value: function stopWarping() {

			var timeScaleInterpolant = this._timeScaleInterpolant;

			if (timeScaleInterpolant !== null) {

				this._timeScaleInterpolant = null;
				this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
			}

			return this;
		}

		// Object Accessors

	}, {
		key: 'getMixer',
		value: function getMixer() {

			return this._mixer;
		}
	}, {
		key: 'getClip',
		value: function getClip() {

			return this._clip;
		}
	}, {
		key: 'getRoot',
		value: function getRoot() {

			return this._localRoot || this._mixer._root;
		}

		// Interna

	}, {
		key: '_update',
		value: function _update(time, deltaTime, timeDirection, accuIndex) {

			// called by the mixer

			if (!this.enabled) {

				// call ._updateWeight() to update ._effectiveWeight

				this._updateWeight(time);
				return;
			}

			var startTime = this._startTime;

			if (startTime !== null) {

				// check for scheduled start of action

				var timeRunning = (time - startTime) * timeDirection;
				if (timeRunning < 0 || timeDirection === 0) {

					deltaTime = 0;
				} else {

					this._startTime = null; // unschedule
					deltaTime = timeDirection * timeRunning;
				}
			}

			// apply time scale and advance time

			deltaTime *= this._updateTimeScale(time);
			var clipTime = this._updateTime(deltaTime);

			// note: _updateTime may disable the action resulting in
			// an effective weight of 0

			var weight = this._updateWeight(time);

			if (weight > 0) {

				var _interpolants = this._interpolants;
				var propertyMixers = this._propertyBindings;

				switch (this.blendMode) {

					case AdditiveAnimationBlendMode:

						for (var j = 0, m = _interpolants.length; j !== m; ++j) {

							_interpolants[j].evaluate(clipTime);
							propertyMixers[j].accumulateAdditive(weight);
						}

						break;

					case NormalAnimationBlendMode:
					default:

						for (var _j18 = 0, _m5 = _interpolants.length; _j18 !== _m5; ++_j18) {

							_interpolants[_j18].evaluate(clipTime);
							propertyMixers[_j18].accumulate(accuIndex, weight);
						}

				}
			}
		}
	}, {
		key: '_updateWeight',
		value: function _updateWeight(time) {

			var weight = 0;

			if (this.enabled) {

				weight = this.weight;
				var interpolant = this._weightInterpolant;

				if (interpolant !== null) {

					var interpolantValue = interpolant.evaluate(time)[0];

					weight *= interpolantValue;

					if (time > interpolant.parameterPositions[1]) {

						this.stopFading();

						if (interpolantValue === 0) {

							// faded out, disable
							this.enabled = false;
						}
					}
				}
			}

			this._effectiveWeight = weight;
			return weight;
		}
	}, {
		key: '_updateTimeScale',
		value: function _updateTimeScale(time) {

			var timeScale = 0;

			if (!this.paused) {

				timeScale = this.timeScale;

				var interpolant = this._timeScaleInterpolant;

				if (interpolant !== null) {

					var interpolantValue = interpolant.evaluate(time)[0];

					timeScale *= interpolantValue;

					if (time > interpolant.parameterPositions[1]) {

						this.stopWarping();

						if (timeScale === 0) {

							// motion has halted, pause
							this.paused = true;
						} else {

							// warp done - apply final time scale
							this.timeScale = timeScale;
						}
					}
				}
			}

			this._effectiveTimeScale = timeScale;
			return timeScale;
		}
	}, {
		key: '_updateTime',
		value: function _updateTime(deltaTime) {

			var duration = this._clip.duration;
			var loop = this.loop;

			var time = this.time + deltaTime;
			var loopCount = this._loopCount;

			var pingPong = loop === LoopPingPong;

			if (deltaTime === 0) {

				if (loopCount === -1) return time;

				return pingPong && (loopCount & 1) === 1 ? duration - time : time;
			}

			if (loop === LoopOnce) {

				if (loopCount === -1) {

					// just started

					this._loopCount = 0;
					this._setEndings(true, true, false);
				}

				handle_stop: {

					if (time >= duration) {

						time = duration;
					} else if (time < 0) {

						time = 0;
					} else {

						this.time = time;

						break handle_stop;
					}

					if (this.clampWhenFinished) this.paused = true;else this.enabled = false;

					this.time = time;

					this._mixer.dispatchEvent({
						type: 'finished', action: this,
						direction: deltaTime < 0 ? -1 : 1
					});
				}
			} else {
				// repetitive Repeat or PingPong

				if (loopCount === -1) {

					// just started

					if (deltaTime >= 0) {

						loopCount = 0;

						this._setEndings(true, this.repetitions === 0, pingPong);
					} else {

						// when looping in reverse direction, the initial
						// transition through zero counts as a repetition,
						// so leave loopCount at -1

						this._setEndings(this.repetitions === 0, true, pingPong);
					}
				}

				if (time >= duration || time < 0) {

					// wrap around

					var loopDelta = Math.floor(time / duration); // signed
					time -= duration * loopDelta;

					loopCount += Math.abs(loopDelta);

					var pending = this.repetitions - loopCount;

					if (pending <= 0) {

						// have to stop (switch state, clamp time, fire event)

						if (this.clampWhenFinished) this.paused = true;else this.enabled = false;

						time = deltaTime > 0 ? duration : 0;

						this.time = time;

						this._mixer.dispatchEvent({
							type: 'finished', action: this,
							direction: deltaTime > 0 ? 1 : -1
						});
					} else {

						// keep running

						if (pending === 1) {

							// entering the last round

							var atStart = deltaTime < 0;
							this._setEndings(atStart, !atStart, pingPong);
						} else {

							this._setEndings(false, false, pingPong);
						}

						this._loopCount = loopCount;

						this.time = time;

						this._mixer.dispatchEvent({
							type: 'loop', action: this, loopDelta: loopDelta
						});
					}
				} else {

					this.time = time;
				}

				if (pingPong && (loopCount & 1) === 1) {

					// invert time for the "pong round"

					return duration - time;
				}
			}

			return time;
		}
	}, {
		key: '_setEndings',
		value: function _setEndings(atStart, atEnd, pingPong) {

			var settings = this._interpolantSettings;

			if (pingPong) {

				settings.endingStart = ZeroSlopeEnding;
				settings.endingEnd = ZeroSlopeEnding;
			} else {

				// assuming for LoopOnce atStart == atEnd == true

				if (atStart) {

					settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
				} else {

					settings.endingStart = WrapAroundEnding;
				}

				if (atEnd) {

					settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
				} else {

					settings.endingEnd = WrapAroundEnding;
				}
			}
		}
	}, {
		key: '_scheduleFading',
		value: function _scheduleFading(duration, weightNow, weightThen) {

			var mixer = this._mixer,
			    now = mixer.time;
			var interpolant = this._weightInterpolant;

			if (interpolant === null) {

				interpolant = mixer._lendControlInterpolant();
				this._weightInterpolant = interpolant;
			}

			var times = interpolant.parameterPositions,
			    values = interpolant.sampleValues;

			times[0] = now;
			values[0] = weightNow;
			times[1] = now + duration;
			values[1] = weightThen;

			return this;
		}
	}]);

	return AnimationAction;
}();

var _controlInterpolantsResultBuffer = new Float32Array(1);

var AnimationMixer = function (_EventDispatcher7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AnimationMixer, _EventDispatcher7);

	function AnimationMixer(root) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AnimationMixer);

		var _this143 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimationMixer.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AnimationMixer)).call(this));

		_this143._root = root;
		_this143._initMemoryManager();
		_this143._accuIndex = 0;
		_this143.time = 0;
		_this143.timeScale = 1.0;

		return _this143;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AnimationMixer, [{
		key: '_bindAction',
		value: function _bindAction(action, prototypeAction) {

			var root = action._localRoot || this._root,
			    tracks = action._clip.tracks,
			    nTracks = tracks.length,
			    bindings = action._propertyBindings,
			    interpolants = action._interpolants,
			    rootUuid = root.uuid,
			    bindingsByRoot = this._bindingsByRootAndName;

			var bindingsByName = bindingsByRoot[rootUuid];

			if (bindingsByName === undefined) {

				bindingsByName = {};
				bindingsByRoot[rootUuid] = bindingsByName;
			}

			for (var i = 0; i !== nTracks; ++i) {

				var track = tracks[i],
				    trackName = track.name;

				var binding = bindingsByName[trackName];

				if (binding !== undefined) {

					++binding.referenceCount;
					bindings[i] = binding;
				} else {

					binding = bindings[i];

					if (binding !== undefined) {

						// existing binding, make sure the cache knows

						if (binding._cacheIndex === null) {

							++binding.referenceCount;
							this._addInactiveBinding(binding, rootUuid, trackName);
						}

						continue;
					}

					var path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;

					binding = new PropertyMixer(PropertyBinding.create(root, trackName, path), track.ValueTypeName, track.getValueSize());

					++binding.referenceCount;
					this._addInactiveBinding(binding, rootUuid, trackName);

					bindings[i] = binding;
				}

				interpolants[i].resultBuffer = binding.buffer;
			}
		}
	}, {
		key: '_activateAction',
		value: function _activateAction(action) {

			if (!this._isActiveAction(action)) {

				if (action._cacheIndex === null) {

					// this action has been forgotten by the cache, but the user
					// appears to be still using it -> rebind

					var rootUuid = (action._localRoot || this._root).uuid,
					    clipUuid = action._clip.uuid,
					    actionsForClip = this._actionsByClip[clipUuid];

					this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);

					this._addInactiveAction(action, clipUuid, rootUuid);
				}

				var bindings = action._propertyBindings;

				// increment reference counts / sort out state
				for (var i = 0, _n22 = bindings.length; i !== _n22; ++i) {

					var binding = bindings[i];

					if (binding.useCount++ === 0) {

						this._lendBinding(binding);
						binding.saveOriginalState();
					}
				}

				this._lendAction(action);
			}
		}
	}, {
		key: '_deactivateAction',
		value: function _deactivateAction(action) {

			if (this._isActiveAction(action)) {

				var bindings = action._propertyBindings;

				// decrement reference counts / sort out state
				for (var i = 0, _n23 = bindings.length; i !== _n23; ++i) {

					var binding = bindings[i];

					if (--binding.useCount === 0) {

						binding.restoreOriginalState();
						this._takeBackBinding(binding);
					}
				}

				this._takeBackAction(action);
			}
		}

		// Memory manager

	}, {
		key: '_initMemoryManager',
		value: function _initMemoryManager() {

			this._actions = []; // 'nActiveActions' followed by inactive ones
			this._nActiveActions = 0;

			this._actionsByClip = {};
			// inside:
			// {
			// 	knownActions: Array< AnimationAction > - used as prototypes
			// 	actionByRoot: AnimationAction - lookup
			// }


			this._bindings = []; // 'nActiveBindings' followed by inactive ones
			this._nActiveBindings = 0;

			this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >


			this._controlInterpolants = []; // same game as above
			this._nActiveControlInterpolants = 0;

			var scope = this;

			this.stats = {

				actions: {
					get total() {

						return scope._actions.length;
					},
					get inUse() {

						return scope._nActiveActions;
					}
				},
				bindings: {
					get total() {

						return scope._bindings.length;
					},
					get inUse() {

						return scope._nActiveBindings;
					}
				},
				controlInterpolants: {
					get total() {

						return scope._controlInterpolants.length;
					},
					get inUse() {

						return scope._nActiveControlInterpolants;
					}
				}

			};
		}

		// Memory management for AnimationAction objects

	}, {
		key: '_isActiveAction',
		value: function _isActiveAction(action) {

			var index = action._cacheIndex;
			return index !== null && index < this._nActiveActions;
		}
	}, {
		key: '_addInactiveAction',
		value: function _addInactiveAction(action, clipUuid, rootUuid) {

			var actions = this._actions,
			    actionsByClip = this._actionsByClip;

			var actionsForClip = actionsByClip[clipUuid];

			if (actionsForClip === undefined) {

				actionsForClip = {

					knownActions: [action],
					actionByRoot: {}

				};

				action._byClipCacheIndex = 0;

				actionsByClip[clipUuid] = actionsForClip;
			} else {

				var knownActions = actionsForClip.knownActions;

				action._byClipCacheIndex = knownActions.length;
				knownActions.push(action);
			}

			action._cacheIndex = actions.length;
			actions.push(action);

			actionsForClip.actionByRoot[rootUuid] = action;
		}
	}, {
		key: '_removeInactiveAction',
		value: function _removeInactiveAction(action) {

			var actions = this._actions,
			    lastInactiveAction = actions[actions.length - 1],
			    cacheIndex = action._cacheIndex;

			lastInactiveAction._cacheIndex = cacheIndex;
			actions[cacheIndex] = lastInactiveAction;
			actions.pop();

			action._cacheIndex = null;

			var clipUuid = action._clip.uuid,
			    actionsByClip = this._actionsByClip,
			    actionsForClip = actionsByClip[clipUuid],
			    knownActionsForClip = actionsForClip.knownActions,
			    lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1],
			    byClipCacheIndex = action._byClipCacheIndex;

			lastKnownAction._byClipCacheIndex = byClipCacheIndex;
			knownActionsForClip[byClipCacheIndex] = lastKnownAction;
			knownActionsForClip.pop();

			action._byClipCacheIndex = null;

			var actionByRoot = actionsForClip.actionByRoot,
			    rootUuid = (action._localRoot || this._root).uuid;

			delete actionByRoot[rootUuid];

			if (knownActionsForClip.length === 0) {

				delete actionsByClip[clipUuid];
			}

			this._removeInactiveBindingsForAction(action);
		}
	}, {
		key: '_removeInactiveBindingsForAction',
		value: function _removeInactiveBindingsForAction(action) {

			var bindings = action._propertyBindings;

			for (var i = 0, _n24 = bindings.length; i !== _n24; ++i) {

				var binding = bindings[i];

				if (--binding.referenceCount === 0) {

					this._removeInactiveBinding(binding);
				}
			}
		}
	}, {
		key: '_lendAction',
		value: function _lendAction(action) {

			// [ active actions |  inactive actions  ]
			// [  active actions >| inactive actions ]
			//                 s        a
			//                  <-swap->
			//                 a        s

			var actions = this._actions,
			    prevIndex = action._cacheIndex,
			    lastActiveIndex = this._nActiveActions++,
			    firstInactiveAction = actions[lastActiveIndex];

			action._cacheIndex = lastActiveIndex;
			actions[lastActiveIndex] = action;

			firstInactiveAction._cacheIndex = prevIndex;
			actions[prevIndex] = firstInactiveAction;
		}
	}, {
		key: '_takeBackAction',
		value: function _takeBackAction(action) {

			// [  active actions  | inactive actions ]
			// [ active actions |< inactive actions  ]
			//        a        s
			//         <-swap->
			//        s        a

			var actions = this._actions,
			    prevIndex = action._cacheIndex,
			    firstInactiveIndex = --this._nActiveActions,
			    lastActiveAction = actions[firstInactiveIndex];

			action._cacheIndex = firstInactiveIndex;
			actions[firstInactiveIndex] = action;

			lastActiveAction._cacheIndex = prevIndex;
			actions[prevIndex] = lastActiveAction;
		}

		// Memory management for PropertyMixer objects

	}, {
		key: '_addInactiveBinding',
		value: function _addInactiveBinding(binding, rootUuid, trackName) {

			var bindingsByRoot = this._bindingsByRootAndName,
			    bindings = this._bindings;

			var bindingByName = bindingsByRoot[rootUuid];

			if (bindingByName === undefined) {

				bindingByName = {};
				bindingsByRoot[rootUuid] = bindingByName;
			}

			bindingByName[trackName] = binding;

			binding._cacheIndex = bindings.length;
			bindings.push(binding);
		}
	}, {
		key: '_removeInactiveBinding',
		value: function _removeInactiveBinding(binding) {

			var bindings = this._bindings,
			    propBinding = binding.binding,
			    rootUuid = propBinding.rootNode.uuid,
			    trackName = propBinding.path,
			    bindingsByRoot = this._bindingsByRootAndName,
			    bindingByName = bindingsByRoot[rootUuid],
			    lastInactiveBinding = bindings[bindings.length - 1],
			    cacheIndex = binding._cacheIndex;

			lastInactiveBinding._cacheIndex = cacheIndex;
			bindings[cacheIndex] = lastInactiveBinding;
			bindings.pop();

			delete bindingByName[trackName];

			if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_core_js_object_keys___default()(bindingByName).length === 0) {

				delete bindingsByRoot[rootUuid];
			}
		}
	}, {
		key: '_lendBinding',
		value: function _lendBinding(binding) {

			var bindings = this._bindings,
			    prevIndex = binding._cacheIndex,
			    lastActiveIndex = this._nActiveBindings++,
			    firstInactiveBinding = bindings[lastActiveIndex];

			binding._cacheIndex = lastActiveIndex;
			bindings[lastActiveIndex] = binding;

			firstInactiveBinding._cacheIndex = prevIndex;
			bindings[prevIndex] = firstInactiveBinding;
		}
	}, {
		key: '_takeBackBinding',
		value: function _takeBackBinding(binding) {

			var bindings = this._bindings,
			    prevIndex = binding._cacheIndex,
			    firstInactiveIndex = --this._nActiveBindings,
			    lastActiveBinding = bindings[firstInactiveIndex];

			binding._cacheIndex = firstInactiveIndex;
			bindings[firstInactiveIndex] = binding;

			lastActiveBinding._cacheIndex = prevIndex;
			bindings[prevIndex] = lastActiveBinding;
		}

		// Memory management of Interpolants for weight and time scale

	}, {
		key: '_lendControlInterpolant',
		value: function _lendControlInterpolant() {

			var interpolants = this._controlInterpolants,
			    lastActiveIndex = this._nActiveControlInterpolants++;

			var interpolant = interpolants[lastActiveIndex];

			if (interpolant === undefined) {

				interpolant = new LinearInterpolant(new Float32Array(2), new Float32Array(2), 1, _controlInterpolantsResultBuffer);

				interpolant.__cacheIndex = lastActiveIndex;
				interpolants[lastActiveIndex] = interpolant;
			}

			return interpolant;
		}
	}, {
		key: '_takeBackControlInterpolant',
		value: function _takeBackControlInterpolant(interpolant) {

			var interpolants = this._controlInterpolants,
			    prevIndex = interpolant.__cacheIndex,
			    firstInactiveIndex = --this._nActiveControlInterpolants,
			    lastActiveInterpolant = interpolants[firstInactiveIndex];

			interpolant.__cacheIndex = firstInactiveIndex;
			interpolants[firstInactiveIndex] = interpolant;

			lastActiveInterpolant.__cacheIndex = prevIndex;
			interpolants[prevIndex] = lastActiveInterpolant;
		}

		// return an action for a clip optionally using a custom root target
		// object (this method allocates a lot of dynamic memory in case a
		// previously unknown clip/root combination is specified)

	}, {
		key: 'clipAction',
		value: function clipAction(clip, optionalRoot, blendMode) {

			var root = optionalRoot || this._root,
			    rootUuid = root.uuid;

			var clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip;

			var clipUuid = clipObject !== null ? clipObject.uuid : clip;

			var actionsForClip = this._actionsByClip[clipUuid];
			var prototypeAction = null;

			if (blendMode === undefined) {

				if (clipObject !== null) {

					blendMode = clipObject.blendMode;
				} else {

					blendMode = NormalAnimationBlendMode;
				}
			}

			if (actionsForClip !== undefined) {

				var existingAction = actionsForClip.actionByRoot[rootUuid];

				if (existingAction !== undefined && existingAction.blendMode === blendMode) {

					return existingAction;
				}

				// we know the clip, so we don't have to parse all
				// the bindings again but can just copy
				prototypeAction = actionsForClip.knownActions[0];

				// also, take the clip from the prototype action
				if (clipObject === null) clipObject = prototypeAction._clip;
			}

			// clip must be known when specified via string
			if (clipObject === null) return null;

			// allocate all resources required to run it
			var newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);

			this._bindAction(newAction, prototypeAction);

			// and make the action known to the memory manager
			this._addInactiveAction(newAction, clipUuid, rootUuid);

			return newAction;
		}

		// get an existing action

	}, {
		key: 'existingAction',
		value: function existingAction(clip, optionalRoot) {

			var root = optionalRoot || this._root,
			    rootUuid = root.uuid,
			    clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip,
			    clipUuid = clipObject ? clipObject.uuid : clip,
			    actionsForClip = this._actionsByClip[clipUuid];

			if (actionsForClip !== undefined) {

				return actionsForClip.actionByRoot[rootUuid] || null;
			}

			return null;
		}

		// deactivates all previously scheduled actions

	}, {
		key: 'stopAllAction',
		value: function stopAllAction() {

			var actions = this._actions,
			    nActions = this._nActiveActions;

			for (var i = nActions - 1; i >= 0; --i) {

				actions[i].stop();
			}

			return this;
		}

		// advance the time and update apply the animation

	}, {
		key: 'update',
		value: function update(deltaTime) {

			deltaTime *= this.timeScale;

			var actions = this._actions,
			    nActions = this._nActiveActions,
			    time = this.time += deltaTime,
			    timeDirection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_math_sign___default()(deltaTime),
			    accuIndex = this._accuIndex ^= 1;

			// run active actions

			for (var i = 0; i !== nActions; ++i) {

				var action = actions[i];

				action._update(time, deltaTime, timeDirection, accuIndex);
			}

			// update scene graph

			var bindings = this._bindings,
			    nBindings = this._nActiveBindings;

			for (var _i94 = 0; _i94 !== nBindings; ++_i94) {

				bindings[_i94].apply(accuIndex);
			}

			return this;
		}

		// Allows you to seek to a specific time in an animation.

	}, {
		key: 'setTime',
		value: function setTime(timeInSeconds) {

			this.time = 0; // Zero out time attribute for AnimationMixer object;
			for (var i = 0; i < this._actions.length; i++) {

				this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
			}

			return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
		}

		// return this mixer's root target object

	}, {
		key: 'getRoot',
		value: function getRoot() {

			return this._root;
		}

		// free all resources specific to a particular clip

	}, {
		key: 'uncacheClip',
		value: function uncacheClip(clip) {

			var actions = this._actions,
			    clipUuid = clip.uuid,
			    actionsByClip = this._actionsByClip,
			    actionsForClip = actionsByClip[clipUuid];

			if (actionsForClip !== undefined) {

				// note: just calling _removeInactiveAction would mess up the
				// iteration state and also require updating the state we can
				// just throw away

				var actionsToRemove = actionsForClip.knownActions;

				for (var i = 0, _n25 = actionsToRemove.length; i !== _n25; ++i) {

					var action = actionsToRemove[i];

					this._deactivateAction(action);

					var cacheIndex = action._cacheIndex,
					    lastInactiveAction = actions[actions.length - 1];

					action._cacheIndex = null;
					action._byClipCacheIndex = null;

					lastInactiveAction._cacheIndex = cacheIndex;
					actions[cacheIndex] = lastInactiveAction;
					actions.pop();

					this._removeInactiveBindingsForAction(action);
				}

				delete actionsByClip[clipUuid];
			}
		}

		// free all resources specific to a particular root target object

	}, {
		key: 'uncacheRoot',
		value: function uncacheRoot(root) {

			var rootUuid = root.uuid,
			    actionsByClip = this._actionsByClip;

			for (var clipUuid in actionsByClip) {

				var actionByRoot = actionsByClip[clipUuid].actionByRoot,
				    action = actionByRoot[rootUuid];

				if (action !== undefined) {

					this._deactivateAction(action);
					this._removeInactiveAction(action);
				}
			}

			var bindingsByRoot = this._bindingsByRootAndName,
			    bindingByName = bindingsByRoot[rootUuid];

			if (bindingByName !== undefined) {

				for (var trackName in bindingByName) {

					var binding = bindingByName[trackName];
					binding.restoreOriginalState();
					this._removeInactiveBinding(binding);
				}
			}
		}

		// remove a targeted clip from the cache

	}, {
		key: 'uncacheAction',
		value: function uncacheAction(clip, optionalRoot) {

			var action = this.existingAction(clip, optionalRoot);

			if (action !== null) {

				this._deactivateAction(action);
				this._removeInactiveAction(action);
			}
		}
	}]);

	return AnimationMixer;
}(EventDispatcher);

var Uniform = function () {
	function Uniform(value) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Uniform);

		this.value = value;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Uniform, [{
		key: 'clone',
		value: function clone() {

			return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
		}
	}]);

	return Uniform;
}();

var id = 0;

var UniformsGroup = function (_EventDispatcher8) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(UniformsGroup, _EventDispatcher8);

	function UniformsGroup() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, UniformsGroup);

		var _this144 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UniformsGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(UniformsGroup)).call(this));

		_this144.isUniformsGroup = true;

		Object.defineProperty(_this144, 'id', { value: id++ });

		_this144.name = '';

		_this144.usage = StaticDrawUsage;
		_this144.uniforms = [];

		return _this144;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(UniformsGroup, [{
		key: 'add',
		value: function add(uniform) {

			this.uniforms.push(uniform);

			return this;
		}
	}, {
		key: 'remove',
		value: function remove(uniform) {

			var index = this.uniforms.indexOf(uniform);

			if (index !== -1) this.uniforms.splice(index, 1);

			return this;
		}
	}, {
		key: 'setName',
		value: function setName(name) {

			this.name = name;

			return this;
		}
	}, {
		key: 'setUsage',
		value: function setUsage(value) {

			this.usage = value;

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.dispatchEvent({ type: 'dispose' });

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			this.name = source.name;
			this.usage = source.usage;

			var uniformsSource = source.uniforms;

			this.uniforms.length = 0;

			for (var i = 0, l = uniformsSource.length; i < l; i++) {

				this.uniforms.push(uniformsSource[i].clone());
			}

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return UniformsGroup;
}(EventDispatcher);

var InstancedInterleavedBuffer = function (_InterleavedBuffer) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(InstancedInterleavedBuffer, _InterleavedBuffer);

	function InstancedInterleavedBuffer(array, stride) {
		var meshPerAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, InstancedInterleavedBuffer);

		var _this145 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InstancedInterleavedBuffer.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedInterleavedBuffer)).call(this, array, stride));

		_this145.isInstancedInterleavedBuffer = true;

		_this145.meshPerAttribute = meshPerAttribute;

		return _this145;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(InstancedInterleavedBuffer, [{
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedInterleavedBuffer.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedInterleavedBuffer.prototype), 'copy', this).call(this, source);

			this.meshPerAttribute = source.meshPerAttribute;

			return this;
		}
	}, {
		key: 'clone',
		value: function clone(data) {

			var ib = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedInterleavedBuffer.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedInterleavedBuffer.prototype), 'clone', this).call(this, data);

			ib.meshPerAttribute = this.meshPerAttribute;

			return ib;
		}
	}, {
		key: 'toJSON',
		value: function toJSON(data) {

			var json = __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(InstancedInterleavedBuffer.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(InstancedInterleavedBuffer.prototype), 'toJSON', this).call(this, data);

			json.isInstancedInterleavedBuffer = true;
			json.meshPerAttribute = this.meshPerAttribute;

			return json;
		}
	}]);

	return InstancedInterleavedBuffer;
}(InterleavedBuffer);

var GLBufferAttribute = function () {
	function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, GLBufferAttribute);

		this.isGLBufferAttribute = true;

		this.name = '';

		this.buffer = buffer;
		this.type = type;
		this.itemSize = itemSize;
		this.elementSize = elementSize;
		this.count = count;

		this.version = 0;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(GLBufferAttribute, [{
		key: 'setBuffer',
		value: function setBuffer(buffer) {

			this.buffer = buffer;

			return this;
		}
	}, {
		key: 'setType',
		value: function setType(type, elementSize) {

			this.type = type;
			this.elementSize = elementSize;

			return this;
		}
	}, {
		key: 'setItemSize',
		value: function setItemSize(itemSize) {

			this.itemSize = itemSize;

			return this;
		}
	}, {
		key: 'setCount',
		value: function setCount(count) {

			this.count = count;

			return this;
		}
	}, {
		key: 'needsUpdate',
		set: function set(value) {

			if (value === true) this.version++;
		}
	}]);

	return GLBufferAttribute;
}();

var Raycaster = function () {
	function Raycaster(origin, direction) {
		var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
		var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Raycaster);

		this.ray = new Ray(origin, direction);
		// direction is assumed to be normalized (for accurate distance calculations)

		this.near = near;
		this.far = far;
		this.camera = null;
		this.layers = new Layers();

		this.params = {
			Mesh: {},
			Line: { threshold: 1 },
			LOD: {},
			Points: { threshold: 1 },
			Sprite: {}
		};
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Raycaster, [{
		key: 'set',
		value: function set(origin, direction) {

			// direction is assumed to be normalized (for accurate distance calculations)

			this.ray.set(origin, direction);
		}
	}, {
		key: 'setFromCamera',
		value: function setFromCamera(coords, camera) {

			if (camera.isPerspectiveCamera) {

				this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
				this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
				this.camera = camera;
			} else if (camera.isOrthographicCamera) {

				this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
				this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
				this.camera = camera;
			} else {

				console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
			}
		}
	}, {
		key: 'intersectObject',
		value: function intersectObject(object) {
			var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];


			_intersectObject(object, this, intersects, recursive);

			intersects.sort(ascSort);

			return intersects;
		}
	}, {
		key: 'intersectObjects',
		value: function intersectObjects(objects) {
			var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
			var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];


			for (var i = 0, l = objects.length; i < l; i++) {

				_intersectObject(objects[i], this, intersects, recursive);
			}

			intersects.sort(ascSort);

			return intersects;
		}
	}]);

	return Raycaster;
}();

function ascSort(a, b) {

	return a.distance - b.distance;
}

function _intersectObject(object, raycaster, intersects, recursive) {

	if (object.layers.test(raycaster.layers)) {

		object.raycast(raycaster, intersects);
	}

	if (recursive === true) {

		var children = object.children;

		for (var i = 0, l = children.length; i < l; i++) {

			_intersectObject(children[i], raycaster, intersects, true);
		}
	}
}

/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */

var Spherical = function () {
	function Spherical() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var phi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var theta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Spherical);

		this.radius = radius;
		this.phi = phi; // polar angle
		this.theta = theta; // azimuthal angle

		return this;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Spherical, [{
		key: 'set',
		value: function set(radius, phi, theta) {

			this.radius = radius;
			this.phi = phi;
			this.theta = theta;

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(other) {

			this.radius = other.radius;
			this.phi = other.phi;
			this.theta = other.theta;

			return this;
		}

		// restrict phi to be between EPS and PI-EPS

	}, {
		key: 'makeSafe',
		value: function makeSafe() {

			var EPS = 0.000001;
			this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));

			return this;
		}
	}, {
		key: 'setFromVector3',
		value: function setFromVector3(v) {

			return this.setFromCartesianCoords(v.x, v.y, v.z);
		}
	}, {
		key: 'setFromCartesianCoords',
		value: function setFromCartesianCoords(x, y, z) {

			this.radius = Math.sqrt(x * x + y * y + z * z);

			if (this.radius === 0) {

				this.theta = 0;
				this.phi = 0;
			} else {

				this.theta = Math.atan2(x, z);
				this.phi = Math.acos(clamp(y / this.radius, -1, 1));
			}

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Spherical;
}();

/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */

var Cylindrical = function () {
	function Cylindrical() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var theta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
		var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Cylindrical);

		this.radius = radius; // distance from the origin to a point in the x-z plane
		this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
		this.y = y; // height above the x-z plane

		return this;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Cylindrical, [{
		key: 'set',
		value: function set(radius, theta, y) {

			this.radius = radius;
			this.theta = theta;
			this.y = y;

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(other) {

			this.radius = other.radius;
			this.theta = other.theta;
			this.y = other.y;

			return this;
		}
	}, {
		key: 'setFromVector3',
		value: function setFromVector3(v) {

			return this.setFromCartesianCoords(v.x, v.y, v.z);
		}
	}, {
		key: 'setFromCartesianCoords',
		value: function setFromCartesianCoords(x, y, z) {

			this.radius = Math.sqrt(x * x + z * z);
			this.theta = Math.atan2(x, z);
			this.y = y;

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Cylindrical;
}();

var _vector$4 = /*@__PURE__*/new Vector2();

var Box2 = function () {
	function Box2() {
		var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2(+Infinity, +Infinity);
		var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2(-Infinity, -Infinity);

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Box2);

		this.isBox2 = true;

		this.min = min;
		this.max = max;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Box2, [{
		key: 'set',
		value: function set(min, max) {

			this.min.copy(min);
			this.max.copy(max);

			return this;
		}
	}, {
		key: 'setFromPoints',
		value: function setFromPoints(points) {

			this.makeEmpty();

			for (var i = 0, il = points.length; i < il; i++) {

				this.expandByPoint(points[i]);
			}

			return this;
		}
	}, {
		key: 'setFromCenterAndSize',
		value: function setFromCenterAndSize(center, size) {

			var halfSize = _vector$4.copy(size).multiplyScalar(0.5);
			this.min.copy(center).sub(halfSize);
			this.max.copy(center).add(halfSize);

			return this;
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}, {
		key: 'copy',
		value: function copy(box) {

			this.min.copy(box.min);
			this.max.copy(box.max);

			return this;
		}
	}, {
		key: 'makeEmpty',
		value: function makeEmpty() {

			this.min.x = this.min.y = +Infinity;
			this.max.x = this.max.y = -Infinity;

			return this;
		}
	}, {
		key: 'isEmpty',
		value: function isEmpty() {

			// this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes

			return this.max.x < this.min.x || this.max.y < this.min.y;
		}
	}, {
		key: 'getCenter',
		value: function getCenter(target) {

			return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
		}
	}, {
		key: 'getSize',
		value: function getSize(target) {

			return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
		}
	}, {
		key: 'expandByPoint',
		value: function expandByPoint(point) {

			this.min.min(point);
			this.max.max(point);

			return this;
		}
	}, {
		key: 'expandByVector',
		value: function expandByVector(vector) {

			this.min.sub(vector);
			this.max.add(vector);

			return this;
		}
	}, {
		key: 'expandByScalar',
		value: function expandByScalar(scalar) {

			this.min.addScalar(-scalar);
			this.max.addScalar(scalar);

			return this;
		}
	}, {
		key: 'containsPoint',
		value: function containsPoint(point) {

			return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
		}
	}, {
		key: 'containsBox',
		value: function containsBox(box) {

			return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
		}
	}, {
		key: 'getParameter',
		value: function getParameter(point, target) {

			// This can potentially have a divide by zero if the box
			// has a size dimension of 0.

			return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
		}
	}, {
		key: 'intersectsBox',
		value: function intersectsBox(box) {

			// using 4 splitting planes to rule out intersections

			return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
		}
	}, {
		key: 'clampPoint',
		value: function clampPoint(point, target) {

			return target.copy(point).clamp(this.min, this.max);
		}
	}, {
		key: 'distanceToPoint',
		value: function distanceToPoint(point) {

			return this.clampPoint(point, _vector$4).distanceTo(point);
		}
	}, {
		key: 'intersect',
		value: function intersect(box) {

			this.min.max(box.min);
			this.max.min(box.max);

			if (this.isEmpty()) this.makeEmpty();

			return this;
		}
	}, {
		key: 'union',
		value: function union(box) {

			this.min.min(box.min);
			this.max.max(box.max);

			return this;
		}
	}, {
		key: 'translate',
		value: function translate(offset) {

			this.min.add(offset);
			this.max.add(offset);

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(box) {

			return box.min.equals(this.min) && box.max.equals(this.max);
		}
	}]);

	return Box2;
}();

var _startP = /*@__PURE__*/new Vector3();
var _startEnd = /*@__PURE__*/new Vector3();

var Line3 = function () {
	function Line3() {
		var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
		var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Line3);

		this.start = start;
		this.end = end;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Line3, [{
		key: 'set',
		value: function set(start, end) {

			this.start.copy(start);
			this.end.copy(end);

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(line) {

			this.start.copy(line.start);
			this.end.copy(line.end);

			return this;
		}
	}, {
		key: 'getCenter',
		value: function getCenter(target) {

			return target.addVectors(this.start, this.end).multiplyScalar(0.5);
		}
	}, {
		key: 'delta',
		value: function delta(target) {

			return target.subVectors(this.end, this.start);
		}
	}, {
		key: 'distanceSq',
		value: function distanceSq() {

			return this.start.distanceToSquared(this.end);
		}
	}, {
		key: 'distance',
		value: function distance() {

			return this.start.distanceTo(this.end);
		}
	}, {
		key: 'at',
		value: function at(t, target) {

			return this.delta(target).multiplyScalar(t).add(this.start);
		}
	}, {
		key: 'closestPointToPointParameter',
		value: function closestPointToPointParameter(point, clampToLine) {

			_startP.subVectors(point, this.start);
			_startEnd.subVectors(this.end, this.start);

			var startEnd2 = _startEnd.dot(_startEnd);
			var startEnd_startP = _startEnd.dot(_startP);

			var t = startEnd_startP / startEnd2;

			if (clampToLine) {

				t = clamp(t, 0, 1);
			}

			return t;
		}
	}, {
		key: 'closestPointToPoint',
		value: function closestPointToPoint(point, clampToLine, target) {

			var t = this.closestPointToPointParameter(point, clampToLine);

			return this.delta(target).multiplyScalar(t).add(this.start);
		}
	}, {
		key: 'applyMatrix4',
		value: function applyMatrix4(matrix) {

			this.start.applyMatrix4(matrix);
			this.end.applyMatrix4(matrix);

			return this;
		}
	}, {
		key: 'equals',
		value: function equals(line) {

			return line.start.equals(this.start) && line.end.equals(this.end);
		}
	}, {
		key: 'clone',
		value: function clone() {

			return new this.constructor().copy(this);
		}
	}]);

	return Line3;
}();

var _vector$3 = /*@__PURE__*/new Vector3();

var SpotLightHelper = function (_Object3D14) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SpotLightHelper, _Object3D14);

	function SpotLightHelper(light, color) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SpotLightHelper);

		var _this146 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpotLightHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SpotLightHelper)).call(this));

		_this146.light = light;

		_this146.matrix = light.matrixWorld;
		_this146.matrixAutoUpdate = false;

		_this146.color = color;

		_this146.type = 'SpotLightHelper';

		var geometry = new BufferGeometry();

		var positions = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1];

		for (var i = 0, j = 1, l = 32; i < l; i++, j++) {

			var p1 = i / l * Math.PI * 2;
			var p2 = j / l * Math.PI * 2;

			positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
		}

		geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));

		var material = new LineBasicMaterial({ fog: false, toneMapped: false });

		_this146.cone = new LineSegments(geometry, material);
		_this146.add(_this146.cone);

		_this146.update();

		return _this146;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SpotLightHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.cone.geometry.dispose();
			this.cone.material.dispose();
		}
	}, {
		key: 'update',
		value: function update() {

			this.light.updateWorldMatrix(true, false);
			this.light.target.updateWorldMatrix(true, false);

			var coneLength = this.light.distance ? this.light.distance : 1000;
			var coneWidth = coneLength * Math.tan(this.light.angle);

			this.cone.scale.set(coneWidth, coneWidth, coneLength);

			_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);

			this.cone.lookAt(_vector$3);

			if (this.color !== undefined) {

				this.cone.material.color.set(this.color);
			} else {

				this.cone.material.color.copy(this.light.color);
			}
		}
	}]);

	return SpotLightHelper;
}(Object3D);

var _vector$2 = /*@__PURE__*/new Vector3();
var _boneMatrix = /*@__PURE__*/new Matrix4();
var _matrixWorldInv = /*@__PURE__*/new Matrix4();

var SkeletonHelper = function (_LineSegments) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SkeletonHelper, _LineSegments);

	function SkeletonHelper(object) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SkeletonHelper);

		var bones = getBoneList(object);

		var geometry = new BufferGeometry();

		var vertices = [];
		var colors = [];

		var color1 = new Color(0, 0, 1);
		var color2 = new Color(0, 1, 0);

		for (var i = 0; i < bones.length; i++) {

			var bone = bones[i];

			if (bone.parent && bone.parent.isBone) {

				vertices.push(0, 0, 0);
				vertices.push(0, 0, 0);
				colors.push(color1.r, color1.g, color1.b);
				colors.push(color2.r, color2.g, color2.b);
			}
		}

		geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

		var material = new LineBasicMaterial({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });

		var _this147 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonHelper)).call(this, geometry, material));

		_this147.isSkeletonHelper = true;

		_this147.type = 'SkeletonHelper';

		_this147.root = object;
		_this147.bones = bones;

		_this147.matrix = object.matrixWorld;
		_this147.matrixAutoUpdate = false;

		return _this147;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(SkeletonHelper, [{
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			var bones = this.bones;

			var geometry = this.geometry;
			var position = geometry.getAttribute('position');

			_matrixWorldInv.copy(this.root.matrixWorld).invert();

			for (var i = 0, j = 0; i < bones.length; i++) {

				var bone = bones[i];

				if (bone.parent && bone.parent.isBone) {

					_boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
					_vector$2.setFromMatrixPosition(_boneMatrix);
					position.setXYZ(j, _vector$2.x, _vector$2.y, _vector$2.z);

					_boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
					_vector$2.setFromMatrixPosition(_boneMatrix);
					position.setXYZ(j + 1, _vector$2.x, _vector$2.y, _vector$2.z);

					j += 2;
				}
			}

			geometry.getAttribute('position').needsUpdate = true;

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(SkeletonHelper.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonHelper.prototype), 'updateMatrixWorld', this).call(this, force);
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return SkeletonHelper;
}(LineSegments);

function getBoneList(object) {

	var boneList = [];

	if (object.isBone === true) {

		boneList.push(object);
	}

	for (var i = 0; i < object.children.length; i++) {

		boneList.push.apply(boneList, getBoneList(object.children[i]));
	}

	return boneList;
}

var PointLightHelper = function (_Mesh3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PointLightHelper, _Mesh3);

	function PointLightHelper(light, sphereSize, color) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PointLightHelper);

		var geometry = new SphereGeometry(sphereSize, 4, 2);
		var material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });

		var _this148 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PointLightHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PointLightHelper)).call(this, geometry, material));

		_this148.light = light;

		_this148.color = color;

		_this148.type = 'PointLightHelper';

		_this148.matrix = _this148.light.matrixWorld;
		_this148.matrixAutoUpdate = false;

		_this148.update();

		/*
  // TODO: delete this comment?
  const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
  const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );
  this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
  this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );
  const d = light.distance;
  if ( d === 0.0 ) {
  	this.lightDistance.visible = false;
  } else {
  	this.lightDistance.scale.set( d, d, d );
  }
  this.add( this.lightDistance );
  */

		return _this148;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PointLightHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}, {
		key: 'update',
		value: function update() {

			this.light.updateWorldMatrix(true, false);

			if (this.color !== undefined) {

				this.material.color.set(this.color);
			} else {

				this.material.color.copy(this.light.color);
			}

			/*
   const d = this.light.distance;
   	if ( d === 0.0 ) {
   		this.lightDistance.visible = false;
   	} else {
   		this.lightDistance.visible = true;
   	this.lightDistance.scale.set( d, d, d );
   	}
   */
		}
	}]);

	return PointLightHelper;
}(Mesh);

var _vector$1 = /*@__PURE__*/new Vector3();
var _color1 = /*@__PURE__*/new Color();
var _color2 = /*@__PURE__*/new Color();

var HemisphereLightHelper = function (_Object3D15) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(HemisphereLightHelper, _Object3D15);

	function HemisphereLightHelper(light, size, color) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, HemisphereLightHelper);

		var _this149 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HemisphereLightHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(HemisphereLightHelper)).call(this));

		_this149.light = light;

		_this149.matrix = light.matrixWorld;
		_this149.matrixAutoUpdate = false;

		_this149.color = color;

		_this149.type = 'HemisphereLightHelper';

		var geometry = new OctahedronGeometry(size);
		geometry.rotateY(Math.PI * 0.5);

		_this149.material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });
		if (_this149.color === undefined) _this149.material.vertexColors = true;

		var position = geometry.getAttribute('position');
		var colors = new Float32Array(position.count * 3);

		geometry.setAttribute('color', new BufferAttribute(colors, 3));

		_this149.add(new Mesh(geometry, _this149.material));

		_this149.update();

		return _this149;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(HemisphereLightHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.children[0].geometry.dispose();
			this.children[0].material.dispose();
		}
	}, {
		key: 'update',
		value: function update() {

			var mesh = this.children[0];

			if (this.color !== undefined) {

				this.material.color.set(this.color);
			} else {

				var _colors = mesh.geometry.getAttribute('color');

				_color1.copy(this.light.color);
				_color2.copy(this.light.groundColor);

				for (var i = 0, l = _colors.count; i < l; i++) {

					var color = i < l / 2 ? _color1 : _color2;

					_colors.setXYZ(i, color.r, color.g, color.b);
				}

				_colors.needsUpdate = true;
			}

			this.light.updateWorldMatrix(true, false);

			mesh.lookAt(_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
		}
	}]);

	return HemisphereLightHelper;
}(Object3D);

var GridHelper = function (_LineSegments2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(GridHelper, _LineSegments2);

	function GridHelper() {
		var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
		var divisions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
		var color1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0x444444;
		var color2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0x888888;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, GridHelper);

		color1 = new Color(color1);
		color2 = new Color(color2);

		var center = divisions / 2;
		var step = size / divisions;
		var halfSize = size / 2;

		var vertices = [],
		    colors = [];

		for (var i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step) {

			vertices.push(-halfSize, 0, k, halfSize, 0, k);
			vertices.push(k, 0, -halfSize, k, 0, halfSize);

			var color = i === center ? color1 : color2;

			color.toArray(colors, j);j += 3;
			color.toArray(colors, j);j += 3;
			color.toArray(colors, j);j += 3;
			color.toArray(colors, j);j += 3;
		}

		var geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

		var material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });

		var _this150 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GridHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(GridHelper)).call(this, geometry, material));

		_this150.type = 'GridHelper';

		return _this150;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(GridHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return GridHelper;
}(LineSegments);

var PolarGridHelper = function (_LineSegments3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PolarGridHelper, _LineSegments3);

	function PolarGridHelper() {
		var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
		var sectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
		var rings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
		var divisions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 64;
		var color1 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0x444444;
		var color2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0x888888;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PolarGridHelper);

		color1 = new Color(color1);
		color2 = new Color(color2);

		var vertices = [];
		var colors = [];

		// create the sectors

		if (sectors > 1) {

			for (var i = 0; i < sectors; i++) {

				var v = i / sectors * (Math.PI * 2);

				var x = Math.sin(v) * radius;
				var z = Math.cos(v) * radius;

				vertices.push(0, 0, 0);
				vertices.push(x, 0, z);

				var color = i & 1 ? color1 : color2;

				colors.push(color.r, color.g, color.b);
				colors.push(color.r, color.g, color.b);
			}
		}

		// create the rings

		for (var _i95 = 0; _i95 < rings; _i95++) {

			var _color3 = _i95 & 1 ? color1 : color2;

			var r = radius - radius / rings * _i95;

			for (var j = 0; j < divisions; j++) {

				// first vertex

				var _v = j / divisions * (Math.PI * 2);

				var _x365 = Math.sin(_v) * r;
				var _z3 = Math.cos(_v) * r;

				vertices.push(_x365, 0, _z3);
				colors.push(_color3.r, _color3.g, _color3.b);

				// second vertex

				_v = (j + 1) / divisions * (Math.PI * 2);

				_x365 = Math.sin(_v) * r;
				_z3 = Math.cos(_v) * r;

				vertices.push(_x365, 0, _z3);
				colors.push(_color3.r, _color3.g, _color3.b);
			}
		}

		var geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

		var material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });

		var _this151 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PolarGridHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PolarGridHelper)).call(this, geometry, material));

		_this151.type = 'PolarGridHelper';

		return _this151;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PolarGridHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return PolarGridHelper;
}(LineSegments);

var _v1 = /*@__PURE__*/new Vector3();
var _v2 = /*@__PURE__*/new Vector3();
var _v3 = /*@__PURE__*/new Vector3();

var DirectionalLightHelper = function (_Object3D16) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DirectionalLightHelper, _Object3D16);

	function DirectionalLightHelper(light, size, color) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DirectionalLightHelper);

		var _this152 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DirectionalLightHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DirectionalLightHelper)).call(this));

		_this152.light = light;

		_this152.matrix = light.matrixWorld;
		_this152.matrixAutoUpdate = false;

		_this152.color = color;

		_this152.type = 'DirectionalLightHelper';

		if (size === undefined) size = 1;

		var geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute([-size, size, 0, size, size, 0, size, -size, 0, -size, -size, 0, -size, size, 0], 3));

		var material = new LineBasicMaterial({ fog: false, toneMapped: false });

		_this152.lightPlane = new Line(geometry, material);
		_this152.add(_this152.lightPlane);

		geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));

		_this152.targetLine = new Line(geometry, material);
		_this152.add(_this152.targetLine);

		_this152.update();

		return _this152;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(DirectionalLightHelper, [{
		key: 'dispose',
		value: function dispose() {

			this.lightPlane.geometry.dispose();
			this.lightPlane.material.dispose();
			this.targetLine.geometry.dispose();
			this.targetLine.material.dispose();
		}
	}, {
		key: 'update',
		value: function update() {

			this.light.updateWorldMatrix(true, false);
			this.light.target.updateWorldMatrix(true, false);

			_v1.setFromMatrixPosition(this.light.matrixWorld);
			_v2.setFromMatrixPosition(this.light.target.matrixWorld);
			_v3.subVectors(_v2, _v1);

			this.lightPlane.lookAt(_v2);

			if (this.color !== undefined) {

				this.lightPlane.material.color.set(this.color);
				this.targetLine.material.color.set(this.color);
			} else {

				this.lightPlane.material.color.copy(this.light.color);
				this.targetLine.material.color.copy(this.light.color);
			}

			this.targetLine.lookAt(_v2);
			this.targetLine.scale.z = _v3.length();
		}
	}]);

	return DirectionalLightHelper;
}(Object3D);

var _vector = /*@__PURE__*/new Vector3();
var _camera = /*@__PURE__*/new Camera();

/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */

var CameraHelper = function (_LineSegments4) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CameraHelper, _LineSegments4);

	function CameraHelper(camera) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CameraHelper);

		var geometry = new BufferGeometry();
		var material = new LineBasicMaterial({ color: 0xffffff, vertexColors: true, toneMapped: false });

		var vertices = [];
		var colors = [];

		var pointMap = {};

		// near

		addLine('n1', 'n2');
		addLine('n2', 'n4');
		addLine('n4', 'n3');
		addLine('n3', 'n1');

		// far

		addLine('f1', 'f2');
		addLine('f2', 'f4');
		addLine('f4', 'f3');
		addLine('f3', 'f1');

		// sides

		addLine('n1', 'f1');
		addLine('n2', 'f2');
		addLine('n3', 'f3');
		addLine('n4', 'f4');

		// cone

		addLine('p', 'n1');
		addLine('p', 'n2');
		addLine('p', 'n3');
		addLine('p', 'n4');

		// up

		addLine('u1', 'u2');
		addLine('u2', 'u3');
		addLine('u3', 'u1');

		// target

		addLine('c', 't');
		addLine('p', 'c');

		// cross

		addLine('cn1', 'cn2');
		addLine('cn3', 'cn4');

		addLine('cf1', 'cf2');
		addLine('cf3', 'cf4');

		function addLine(a, b) {

			addPoint(a);
			addPoint(b);
		}

		function addPoint(id) {

			vertices.push(0, 0, 0);
			colors.push(0, 0, 0);

			if (pointMap[id] === undefined) {

				pointMap[id] = [];
			}

			pointMap[id].push(vertices.length / 3 - 1);
		}

		geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

		var _this153 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CameraHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CameraHelper)).call(this, geometry, material));

		_this153.type = 'CameraHelper';

		_this153.camera = camera;
		if (_this153.camera.updateProjectionMatrix) _this153.camera.updateProjectionMatrix();

		_this153.matrix = camera.matrixWorld;
		_this153.matrixAutoUpdate = false;

		_this153.pointMap = pointMap;

		_this153.update();

		// colors

		var colorFrustum = new Color(0xffaa00);
		var colorCone = new Color(0xff0000);
		var colorUp = new Color(0x00aaff);
		var colorTarget = new Color(0xffffff);
		var colorCross = new Color(0x333333);

		_this153.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);

		return _this153;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(CameraHelper, [{
		key: 'setColors',
		value: function setColors(frustum, cone, up, target, cross) {

			var geometry = this.geometry;

			var colorAttribute = geometry.getAttribute('color');

			// near

			colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
			colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
			colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
			colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1

			// far

			colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
			colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
			colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
			colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1

			// sides

			colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
			colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
			colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
			colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4

			// cone

			colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
			colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
			colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
			colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4

			// up

			colorAttribute.setXYZ(32, up.r, up.g, up.b);colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
			colorAttribute.setXYZ(34, up.r, up.g, up.b);colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
			colorAttribute.setXYZ(36, up.r, up.g, up.b);colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1

			// target

			colorAttribute.setXYZ(38, target.r, target.g, target.b);colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
			colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c

			// cross

			colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
			colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4

			colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
			colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4

			colorAttribute.needsUpdate = true;
		}
	}, {
		key: 'update',
		value: function update() {

			var geometry = this.geometry;
			var pointMap = this.pointMap;

			var w = 1,
			    h = 1;

			// we need just camera projection matrix inverse
			// world matrix must be identity

			_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);

			// center / target

			setPoint('c', pointMap, geometry, _camera, 0, 0, -1);
			setPoint('t', pointMap, geometry, _camera, 0, 0, 1);

			// near

			setPoint('n1', pointMap, geometry, _camera, -w, -h, -1);
			setPoint('n2', pointMap, geometry, _camera, w, -h, -1);
			setPoint('n3', pointMap, geometry, _camera, -w, h, -1);
			setPoint('n4', pointMap, geometry, _camera, w, h, -1);

			// far

			setPoint('f1', pointMap, geometry, _camera, -w, -h, 1);
			setPoint('f2', pointMap, geometry, _camera, w, -h, 1);
			setPoint('f3', pointMap, geometry, _camera, -w, h, 1);
			setPoint('f4', pointMap, geometry, _camera, w, h, 1);

			// up

			setPoint('u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, -1);
			setPoint('u2', pointMap, geometry, _camera, -w * 0.7, h * 1.1, -1);
			setPoint('u3', pointMap, geometry, _camera, 0, h * 2, -1);

			// cross

			setPoint('cf1', pointMap, geometry, _camera, -w, 0, 1);
			setPoint('cf2', pointMap, geometry, _camera, w, 0, 1);
			setPoint('cf3', pointMap, geometry, _camera, 0, -h, 1);
			setPoint('cf4', pointMap, geometry, _camera, 0, h, 1);

			setPoint('cn1', pointMap, geometry, _camera, -w, 0, -1);
			setPoint('cn2', pointMap, geometry, _camera, w, 0, -1);
			setPoint('cn3', pointMap, geometry, _camera, 0, -h, -1);
			setPoint('cn4', pointMap, geometry, _camera, 0, h, -1);

			geometry.getAttribute('position').needsUpdate = true;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return CameraHelper;
}(LineSegments);

function setPoint(point, pointMap, geometry, camera, x, y, z) {

	_vector.set(x, y, z).unproject(camera);

	var points = pointMap[point];

	if (points !== undefined) {

		var position = geometry.getAttribute('position');

		for (var i = 0, l = points.length; i < l; i++) {

			position.setXYZ(points[i], _vector.x, _vector.y, _vector.z);
		}
	}
}

var _box = /*@__PURE__*/new Box3();

var BoxHelper = function (_LineSegments5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BoxHelper, _LineSegments5);

	function BoxHelper(object) {
		var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffff00;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BoxHelper);

		var indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
		var positions = new Float32Array(8 * 3);

		var geometry = new BufferGeometry();
		geometry.setIndex(new BufferAttribute(indices, 1));
		geometry.setAttribute('position', new BufferAttribute(positions, 3));

		var _this154 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BoxHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BoxHelper)).call(this, geometry, new LineBasicMaterial({ color: color, toneMapped: false })));

		_this154.object = object;
		_this154.type = 'BoxHelper';

		_this154.matrixAutoUpdate = false;

		_this154.update();

		return _this154;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(BoxHelper, [{
		key: 'update',
		value: function update(object) {

			if (object !== undefined) {

				console.warn('THREE.BoxHelper: .update() has no longer arguments.');
			}

			if (this.object !== undefined) {

				_box.setFromObject(this.object);
			}

			if (_box.isEmpty()) return;

			var min = _box.min;
			var max = _box.max;

			/*
   	5____4
   1/___0/|
   | 6__|_7
   2/___3/
   	0: max.x, max.y, max.z
   1: min.x, max.y, max.z
   2: min.x, min.y, max.z
   3: max.x, min.y, max.z
   4: max.x, max.y, min.z
   5: min.x, max.y, min.z
   6: min.x, min.y, min.z
   7: max.x, min.y, min.z
   */

			var position = this.geometry.attributes.position;
			var array = position.array;

			array[0] = max.x;array[1] = max.y;array[2] = max.z;
			array[3] = min.x;array[4] = max.y;array[5] = max.z;
			array[6] = min.x;array[7] = min.y;array[8] = max.z;
			array[9] = max.x;array[10] = min.y;array[11] = max.z;
			array[12] = max.x;array[13] = max.y;array[14] = min.z;
			array[15] = min.x;array[16] = max.y;array[17] = min.z;
			array[18] = min.x;array[19] = min.y;array[20] = min.z;
			array[21] = max.x;array[22] = min.y;array[23] = min.z;

			position.needsUpdate = true;

			this.geometry.computeBoundingSphere();
		}
	}, {
		key: 'setFromObject',
		value: function setFromObject(object) {

			this.object = object;
			this.update();

			return this;
		}
	}, {
		key: 'copy',
		value: function copy(source, recursive) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(BoxHelper.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BoxHelper.prototype), 'copy', this).call(this, source, recursive);

			this.object = source.object;

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return BoxHelper;
}(LineSegments);

var Box3Helper = function (_LineSegments6) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(Box3Helper, _LineSegments6);

	function Box3Helper(box) {
		var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0xffff00;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, Box3Helper);

		var indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);

		var positions = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1];

		var geometry = new BufferGeometry();

		geometry.setIndex(new BufferAttribute(indices, 1));

		geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));

		var _this155 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Box3Helper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Box3Helper)).call(this, geometry, new LineBasicMaterial({ color: color, toneMapped: false })));

		_this155.box = box;

		_this155.type = 'Box3Helper';

		_this155.geometry.computeBoundingSphere();

		return _this155;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(Box3Helper, [{
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			var box = this.box;

			if (box.isEmpty()) return;

			box.getCenter(this.position);

			box.getSize(this.scale);

			this.scale.multiplyScalar(0.5);

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(Box3Helper.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(Box3Helper.prototype), 'updateMatrixWorld', this).call(this, force);
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return Box3Helper;
}(LineSegments);

var PlaneHelper = function (_Line3) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PlaneHelper, _Line3);

	function PlaneHelper(plane) {
		var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
		var hex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0xffff00;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PlaneHelper);

		var color = hex;

		var positions = [1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0];

		var geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
		geometry.computeBoundingSphere();

		var _this156 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlaneHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PlaneHelper)).call(this, geometry, new LineBasicMaterial({ color: color, toneMapped: false })));

		_this156.type = 'PlaneHelper';

		_this156.plane = plane;

		_this156.size = size;

		var positions2 = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0];

		var geometry2 = new BufferGeometry();
		geometry2.setAttribute('position', new Float32BufferAttribute(positions2, 3));
		geometry2.computeBoundingSphere();

		_this156.add(new Mesh(geometry2, new MeshBasicMaterial({ color: color, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false })));

		return _this156;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(PlaneHelper, [{
		key: 'updateMatrixWorld',
		value: function updateMatrixWorld(force) {

			this.position.set(0, 0, 0);

			this.scale.set(0.5 * this.size, 0.5 * this.size, 1);

			this.lookAt(this.plane.normal);

			this.translateZ(-this.plane.constant);

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(PlaneHelper.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PlaneHelper.prototype), 'updateMatrixWorld', this).call(this, force);
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
			this.children[0].geometry.dispose();
			this.children[0].material.dispose();
		}
	}]);

	return PlaneHelper;
}(Line);

var _axis = /*@__PURE__*/new Vector3();
var _lineGeometry = void 0,
    _coneGeometry = void 0;

var ArrowHelper = function (_Object3D17) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ArrowHelper, _Object3D17);

	// dir is assumed to be normalized

	function ArrowHelper() {
		var dir = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3(0, 0, 1);
		var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(0, 0, 0);
		var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
		var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0xffff00;
		var headLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : length * 0.2;
		var headWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : headLength * 0.2;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ArrowHelper);

		var _this157 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrowHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ArrowHelper)).call(this));

		_this157.type = 'ArrowHelper';

		if (_lineGeometry === undefined) {

			_lineGeometry = new BufferGeometry();
			_lineGeometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));

			_coneGeometry = new CylinderGeometry(0, 0.5, 1, 5, 1);
			_coneGeometry.translate(0, -0.5, 0);
		}

		_this157.position.copy(origin);

		_this157.line = new Line(_lineGeometry, new LineBasicMaterial({ color: color, toneMapped: false }));
		_this157.line.matrixAutoUpdate = false;
		_this157.add(_this157.line);

		_this157.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({ color: color, toneMapped: false }));
		_this157.cone.matrixAutoUpdate = false;
		_this157.add(_this157.cone);

		_this157.setDirection(dir);
		_this157.setLength(length, headLength, headWidth);

		return _this157;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ArrowHelper, [{
		key: 'setDirection',
		value: function setDirection(dir) {

			// dir is assumed to be normalized

			if (dir.y > 0.99999) {

				this.quaternion.set(0, 0, 0, 1);
			} else if (dir.y < -0.99999) {

				this.quaternion.set(1, 0, 0, 0);
			} else {

				_axis.set(dir.z, 0, -dir.x).normalize();

				var radians = Math.acos(dir.y);

				this.quaternion.setFromAxisAngle(_axis, radians);
			}
		}
	}, {
		key: 'setLength',
		value: function setLength(length) {
			var headLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : length * 0.2;
			var headWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : headLength * 0.2;


			this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
			this.line.updateMatrix();

			this.cone.scale.set(headWidth, headLength, headWidth);
			this.cone.position.y = length;
			this.cone.updateMatrix();
		}
	}, {
		key: 'setColor',
		value: function setColor(color) {

			this.line.material.color.set(color);
			this.cone.material.color.set(color);
		}
	}, {
		key: 'copy',
		value: function copy(source) {

			__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_get___default()(ArrowHelper.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ArrowHelper.prototype), 'copy', this).call(this, source, false);

			this.line.copy(source.line);
			this.cone.copy(source.cone);

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.line.geometry.dispose();
			this.line.material.dispose();
			this.cone.geometry.dispose();
			this.cone.material.dispose();
		}
	}]);

	return ArrowHelper;
}(Object3D);

var AxesHelper = function (_LineSegments7) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(AxesHelper, _LineSegments7);

	function AxesHelper() {
		var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, AxesHelper);

		var vertices = [0, 0, 0, size, 0, 0, 0, 0, 0, 0, size, 0, 0, 0, 0, 0, 0, size];

		var colors = [1, 0, 0, 1, 0.6, 0, 0, 1, 0, 0.6, 1, 0, 0, 0, 1, 0, 0.6, 1];

		var geometry = new BufferGeometry();
		geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
		geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));

		var material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });

		var _this158 = __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AxesHelper.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(AxesHelper)).call(this, geometry, material));

		_this158.type = 'AxesHelper';

		return _this158;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(AxesHelper, [{
		key: 'setColors',
		value: function setColors(xAxisColor, yAxisColor, zAxisColor) {

			var color = new Color();
			var array = this.geometry.attributes.color.array;

			color.set(xAxisColor);
			color.toArray(array, 0);
			color.toArray(array, 3);

			color.set(yAxisColor);
			color.toArray(array, 6);
			color.toArray(array, 9);

			color.set(zAxisColor);
			color.toArray(array, 12);
			color.toArray(array, 15);

			this.geometry.attributes.color.needsUpdate = true;

			return this;
		}
	}, {
		key: 'dispose',
		value: function dispose() {

			this.geometry.dispose();
			this.material.dispose();
		}
	}]);

	return AxesHelper;
}(LineSegments);

var ShapePath = function () {
	function ShapePath() {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShapePath);

		this.type = 'ShapePath';

		this.color = new Color();

		this.subPaths = [];
		this.currentPath = null;
	}

	__WEBPACK_IMPORTED_MODULE_28_babel_runtime_helpers_createClass___default()(ShapePath, [{
		key: 'moveTo',
		value: function moveTo(x, y) {

			this.currentPath = new Path();
			this.subPaths.push(this.currentPath);
			this.currentPath.moveTo(x, y);

			return this;
		}
	}, {
		key: 'lineTo',
		value: function lineTo(x, y) {

			this.currentPath.lineTo(x, y);

			return this;
		}
	}, {
		key: 'quadraticCurveTo',
		value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {

			this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);

			return this;
		}
	}, {
		key: 'bezierCurveTo',
		value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {

			this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);

			return this;
		}
	}, {
		key: 'splineThru',
		value: function splineThru(pts) {

			this.currentPath.splineThru(pts);

			return this;
		}
	}, {
		key: 'toShapes',
		value: function toShapes(isCCW) {

			function toShapesNoHoles(inSubpaths) {

				var shapes = [];

				for (var i = 0, l = inSubpaths.length; i < l; i++) {

					var _tmpPath = inSubpaths[i];

					var _tmpShape = new Shape();
					_tmpShape.curves = _tmpPath.curves;

					shapes.push(_tmpShape);
				}

				return shapes;
			}

			function isPointInsidePolygon(inPt, inPolygon) {

				var polyLen = inPolygon.length;

				// inPt on polygon contour => immediate success    or
				// toggling of inside/outside at every single! intersection point of an edge
				//  with the horizontal line through inPt, left of inPt
				//  not counting lowerY endpoints of edges and whole edges on that line
				var inside = false;
				for (var p = polyLen - 1, q = 0; q < polyLen; p = q++) {

					var edgeLowPt = inPolygon[p];
					var edgeHighPt = inPolygon[q];

					var edgeDx = edgeHighPt.x - edgeLowPt.x;
					var edgeDy = edgeHighPt.y - edgeLowPt.y;

					if (Math.abs(edgeDy) > __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_number_epsilon___default.a) {

						// not parallel
						if (edgeDy < 0) {

							edgeLowPt = inPolygon[q];edgeDx = -edgeDx;
							edgeHighPt = inPolygon[p];edgeDy = -edgeDy;
						}

						if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;

						if (inPt.y === edgeLowPt.y) {

							if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
							// continue;				// no intersection or edgeLowPt => doesn't count !!!
						} else {

							var perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
							if (perpEdge === 0) return true; // inPt is on contour ?
							if (perpEdge < 0) continue;
							inside = !inside; // true intersection left of inPt
						}
					} else {

						// parallel or collinear
						if (inPt.y !== edgeLowPt.y) continue; // parallel
						// edge lies on the same horizontal line as inPt
						if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
						// continue;
					}
				}

				return inside;
			}

			var isClockWise = ShapeUtils.isClockWise;

			var subPaths = this.subPaths;
			if (subPaths.length === 0) return [];

			var solid = void 0,
			    tmpPath = void 0,
			    tmpShape = void 0;
			var shapes = [];

			if (subPaths.length === 1) {

				tmpPath = subPaths[0];
				tmpShape = new Shape();
				tmpShape.curves = tmpPath.curves;
				shapes.push(tmpShape);
				return shapes;
			}

			var holesFirst = !isClockWise(subPaths[0].getPoints());
			holesFirst = isCCW ? !holesFirst : holesFirst;

			// console.log("Holes first", holesFirst);

			var betterShapeHoles = [];
			var newShapes = [];
			var newShapeHoles = [];
			var mainIdx = 0;
			var tmpPoints = void 0;

			newShapes[mainIdx] = undefined;
			newShapeHoles[mainIdx] = [];

			for (var i = 0, l = subPaths.length; i < l; i++) {

				tmpPath = subPaths[i];
				tmpPoints = tmpPath.getPoints();
				solid = isClockWise(tmpPoints);
				solid = isCCW ? !solid : solid;

				if (solid) {

					if (!holesFirst && newShapes[mainIdx]) mainIdx++;

					newShapes[mainIdx] = { s: new Shape(), p: tmpPoints };
					newShapes[mainIdx].s.curves = tmpPath.curves;

					if (holesFirst) mainIdx++;
					newShapeHoles[mainIdx] = [];

					//console.log('cw', i);
				} else {

					newShapeHoles[mainIdx].push({ h: tmpPath, p: tmpPoints[0] });

					//console.log('ccw', i);
				}
			}

			// only Holes? -> probably all Shapes with wrong orientation
			if (!newShapes[0]) return toShapesNoHoles(subPaths);

			if (newShapes.length > 1) {

				var ambiguous = false;
				var toChange = 0;

				for (var sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {

					betterShapeHoles[sIdx] = [];
				}

				for (var _sIdx = 0, _sLen = newShapes.length; _sIdx < _sLen; _sIdx++) {

					var sho = newShapeHoles[_sIdx];

					for (var hIdx = 0; hIdx < sho.length; hIdx++) {

						var ho = sho[hIdx];
						var hole_unassigned = true;

						for (var s2Idx = 0; s2Idx < newShapes.length; s2Idx++) {

							if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {

								if (_sIdx !== s2Idx) toChange++;

								if (hole_unassigned) {

									hole_unassigned = false;
									betterShapeHoles[s2Idx].push(ho);
								} else {

									ambiguous = true;
								}
							}
						}

						if (hole_unassigned) {

							betterShapeHoles[_sIdx].push(ho);
						}
					}
				}

				if (toChange > 0 && ambiguous === false) {

					newShapeHoles = betterShapeHoles;
				}
			}

			var tmpHoles = void 0;

			for (var _i96 = 0, il = newShapes.length; _i96 < il; _i96++) {

				tmpShape = newShapes[_i96].s;
				shapes.push(tmpShape);
				tmpHoles = newShapeHoles[_i96];

				for (var j = 0, jl = tmpHoles.length; j < jl; j++) {

					tmpShape.holes.push(tmpHoles[j].h);
				}
			}

			//console.log("shape", shapes);

			return shapes;
		}
	}]);

	return ShapePath;
}();

var BoxBufferGeometry = function (_BoxGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(BoxBufferGeometry, _BoxGeometry);

	// @deprecated, r144

	function BoxBufferGeometry(width, height, depth, widthSegments, heightSegments, depthSegments) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, BoxBufferGeometry);

		console.warn('THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BoxBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(BoxBufferGeometry)).call(this, width, height, depth, widthSegments, heightSegments, depthSegments));
	}

	return BoxBufferGeometry;
}(BoxGeometry);

var CapsuleBufferGeometry = function (_CapsuleGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CapsuleBufferGeometry, _CapsuleGeometry);

	// @deprecated, r144

	function CapsuleBufferGeometry(radius, length, capSegments, radialSegments) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CapsuleBufferGeometry);

		console.warn('THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CapsuleBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CapsuleBufferGeometry)).call(this, radius, length, capSegments, radialSegments));
	}

	return CapsuleBufferGeometry;
}(CapsuleGeometry);

var CircleBufferGeometry = function (_CircleGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CircleBufferGeometry, _CircleGeometry);

	// @deprecated, r144

	function CircleBufferGeometry(radius, segments, thetaStart, thetaLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CircleBufferGeometry);

		console.warn('THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CircleBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CircleBufferGeometry)).call(this, radius, segments, thetaStart, thetaLength));
	}

	return CircleBufferGeometry;
}(CircleGeometry);

var ConeBufferGeometry = function (_ConeGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ConeBufferGeometry, _ConeGeometry);

	// @deprecated, r144

	function ConeBufferGeometry(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ConeBufferGeometry);

		console.warn('THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConeBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ConeBufferGeometry)).call(this, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength));
	}

	return ConeBufferGeometry;
}(ConeGeometry);

var CylinderBufferGeometry = function (_CylinderGeometry2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(CylinderBufferGeometry, _CylinderGeometry2);

	// @deprecated, r144

	function CylinderBufferGeometry(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, CylinderBufferGeometry);

		console.warn('THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CylinderBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(CylinderBufferGeometry)).call(this, radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength));
	}

	return CylinderBufferGeometry;
}(CylinderGeometry);

var DodecahedronBufferGeometry = function (_DodecahedronGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(DodecahedronBufferGeometry, _DodecahedronGeometry);

	// @deprecated, r144

	function DodecahedronBufferGeometry(radius, detail) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, DodecahedronBufferGeometry);

		console.warn('THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DodecahedronBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(DodecahedronBufferGeometry)).call(this, radius, detail));
	}

	return DodecahedronBufferGeometry;
}(DodecahedronGeometry);

var ExtrudeBufferGeometry = function (_ExtrudeGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ExtrudeBufferGeometry, _ExtrudeGeometry);

	// @deprecated, r144

	function ExtrudeBufferGeometry(shapes, options) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ExtrudeBufferGeometry);

		console.warn('THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExtrudeBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ExtrudeBufferGeometry)).call(this, shapes, options));
	}

	return ExtrudeBufferGeometry;
}(ExtrudeGeometry);

var IcosahedronBufferGeometry = function (_IcosahedronGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(IcosahedronBufferGeometry, _IcosahedronGeometry);

	// @deprecated, r144

	function IcosahedronBufferGeometry(radius, detail) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, IcosahedronBufferGeometry);

		console.warn('THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IcosahedronBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(IcosahedronBufferGeometry)).call(this, radius, detail));
	}

	return IcosahedronBufferGeometry;
}(IcosahedronGeometry);

var LatheBufferGeometry = function (_LatheGeometry2) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(LatheBufferGeometry, _LatheGeometry2);

	// @deprecated, r144

	function LatheBufferGeometry(points, segments, phiStart, phiLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, LatheBufferGeometry);

		console.warn('THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LatheBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(LatheBufferGeometry)).call(this, points, segments, phiStart, phiLength));
	}

	return LatheBufferGeometry;
}(LatheGeometry);

var OctahedronBufferGeometry = function (_OctahedronGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(OctahedronBufferGeometry, _OctahedronGeometry);

	// @deprecated, r144

	function OctahedronBufferGeometry(radius, detail) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, OctahedronBufferGeometry);

		console.warn('THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OctahedronBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(OctahedronBufferGeometry)).call(this, radius, detail));
	}

	return OctahedronBufferGeometry;
}(OctahedronGeometry);

var PlaneBufferGeometry = function (_PlaneGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PlaneBufferGeometry, _PlaneGeometry);

	// @deprecated, r144

	function PlaneBufferGeometry(width, height, widthSegments, heightSegments) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PlaneBufferGeometry);

		console.warn('THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlaneBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PlaneBufferGeometry)).call(this, width, height, widthSegments, heightSegments));
	}

	return PlaneBufferGeometry;
}(PlaneGeometry);

var PolyhedronBufferGeometry = function (_PolyhedronGeometry5) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(PolyhedronBufferGeometry, _PolyhedronGeometry5);

	// @deprecated, r144

	function PolyhedronBufferGeometry(vertices, indices, radius, detail) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, PolyhedronBufferGeometry);

		console.warn('THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PolyhedronBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(PolyhedronBufferGeometry)).call(this, vertices, indices, radius, detail));
	}

	return PolyhedronBufferGeometry;
}(PolyhedronGeometry);

var RingBufferGeometry = function (_RingGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(RingBufferGeometry, _RingGeometry);

	// @deprecated, r144

	function RingBufferGeometry(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, RingBufferGeometry);

		console.warn('THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RingBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(RingBufferGeometry)).call(this, innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength));
	}

	return RingBufferGeometry;
}(RingGeometry);

var ShapeBufferGeometry = function (_ShapeGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(ShapeBufferGeometry, _ShapeGeometry);

	// @deprecated, r144

	function ShapeBufferGeometry(shapes, curveSegments) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, ShapeBufferGeometry);

		console.warn('THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShapeBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(ShapeBufferGeometry)).call(this, shapes, curveSegments));
	}

	return ShapeBufferGeometry;
}(ShapeGeometry);

var SphereBufferGeometry = function (_SphereGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(SphereBufferGeometry, _SphereGeometry);

	// @deprecated, r144

	function SphereBufferGeometry(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, SphereBufferGeometry);

		console.warn('THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SphereBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(SphereBufferGeometry)).call(this, radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength));
	}

	return SphereBufferGeometry;
}(SphereGeometry);

var TetrahedronBufferGeometry = function (_TetrahedronGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TetrahedronBufferGeometry, _TetrahedronGeometry);

	// @deprecated, r144

	function TetrahedronBufferGeometry(radius, detail) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TetrahedronBufferGeometry);

		console.warn('THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TetrahedronBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TetrahedronBufferGeometry)).call(this, radius, detail));
	}

	return TetrahedronBufferGeometry;
}(TetrahedronGeometry);

var TorusBufferGeometry = function (_TorusGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TorusBufferGeometry, _TorusGeometry);

	// @deprecated, r144

	function TorusBufferGeometry(radius, tube, radialSegments, tubularSegments, arc) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TorusBufferGeometry);

		console.warn('THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TorusBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusBufferGeometry)).call(this, radius, tube, radialSegments, tubularSegments, arc));
	}

	return TorusBufferGeometry;
}(TorusGeometry);

var TorusKnotBufferGeometry = function (_TorusKnotGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TorusKnotBufferGeometry, _TorusKnotGeometry);

	// @deprecated, r144

	function TorusKnotBufferGeometry(radius, tube, tubularSegments, radialSegments, p, q) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TorusKnotBufferGeometry);

		console.warn('THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TorusKnotBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TorusKnotBufferGeometry)).call(this, radius, tube, tubularSegments, radialSegments, p, q));
	}

	return TorusKnotBufferGeometry;
}(TorusKnotGeometry);

var TubeBufferGeometry = function (_TubeGeometry) {
	__WEBPACK_IMPORTED_MODULE_21_babel_runtime_helpers_inherits___default()(TubeBufferGeometry, _TubeGeometry);

	// @deprecated, r144

	function TubeBufferGeometry(path, tubularSegments, radius, radialSegments, closed) {
		__WEBPACK_IMPORTED_MODULE_27_babel_runtime_helpers_classCallCheck___default()(this, TubeBufferGeometry);

		console.warn('THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.');
		return __WEBPACK_IMPORTED_MODULE_20_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TubeBufferGeometry.__proto__ || __WEBPACK_IMPORTED_MODULE_19_babel_runtime_core_js_object_get_prototype_of___default()(TubeBufferGeometry)).call(this, path, tubularSegments, radius, radialSegments, closed));
	}

	return TubeBufferGeometry;
}(TubeGeometry);

if (typeof __THREE_DEVTOOLS__ !== 'undefined') {

	__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', { detail: {
			revision: REVISION
		} }));
}

if (typeof window !== 'undefined') {

	if (window.__THREE__) {

		console.warn('WARNING: Multiple instances of Three.js being imported.');
	} else {

		window.__THREE__ = REVISION;
	}
}



/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "NE4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_map__ = __webpack_require__("diSF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_array_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find__ = __webpack_require__("NXHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find__);



/* harmony default export */ __webpack_exports__["a"] = (function (value, list, delimiter) {
  if (value && !list.length) {
    return '';
  }
  if (!delimiter) {
    delimiter = ' ';
  }

  var rs = __WEBPACK_IMPORTED_MODULE_0_array_map___default()(value, function (one, index) {
    if (list.length && Object.prototype.toString.call(list[0]) === '[object Array]') {
      return __WEBPACK_IMPORTED_MODULE_1_array_find___default()(list[index], function (item) {
        return item.value === one;
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_array_find___default()(list, function (item) {
        return item.value === one;
      });
    }
  });
  rs = rs.filter(function (one) {
    return typeof one !== 'undefined';
  });
  return __WEBPACK_IMPORTED_MODULE_0_array_map___default()(rs, function (one) {
    return one.name;
  }).join(delimiter).replace('--', '');
});

/***/ }),

/***/ "NLm3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Zujg");
module.exports = __webpack_require__("FeBl").Math.sign;


/***/ }),

/***/ "NWt+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("+ZMJ");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var anObject = __webpack_require__("77Pl");
var toLength = __webpack_require__("QRG4");
var getIterFn = __webpack_require__("3fs2");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "NXHL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function find(array, predicate, context) {
  if (typeof Array.prototype.find === 'function') {
    return array.find(predicate, context);
  }

  context = context || this;
  var length = array.length;
  var i;

  if (typeof predicate !== 'function') {
    throw new TypeError(predicate + ' is not a function');
  }

  for (i = 0; i < length; i++) {
    if (predicate.call(context, array[i], i, array)) {
      return array[i];
    }
  }
}

module.exports = find;


/***/ }),

/***/ "NnIC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("mcHG"), __esModule: true };

/***/ }),

/***/ "NpIQ":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "O4R0":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+MLA");
module.exports = __webpack_require__("FeBl").Object.freeze;


/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "OFgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    // fix for ssr
    if (false) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[VUX] 当前版本组件要求 vux-loader 更新到最新版本');
      }
    } else if (false) {
      // eslint-disable-line
      this.uuid = createId();
    }
  },
  data: function data() {
    return {
      uuid: createId()
    };
  }
});

function createId() {
  return Math.random().toString(36).substring(3, 8);
}

/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "OPyX":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("HpRW")('WeakMap');


/***/ }),

/***/ "OYls":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('asyncIterator');


/***/ }),

/***/ "Og1S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global console: false */

/**
 * Reporter that handles the reporting of logs, warnings and errors.
 * @public
 * @param {boolean} quiet Tells if the reporter should be quiet or not.
 */
module.exports = function(quiet) {
    function noop() {
        //Does nothing.
    }

    var reporter = {
        log: noop,
        warn: noop,
        error: noop
    };

    if(!quiet && window.console) {
        var attachFunction = function(reporter, name) {
            //The proxy is needed to be able to call the method with the console context,
            //since we cannot use bind.
            reporter[name] = function reporterProxy() {
                var f = console[name];
                if (f.apply) { //IE9 does not support console.log.apply :)
                    f.apply(console, arguments);
                } else {
                    for (var i = 0; i < arguments.length; i++) {
                        f(arguments[i]);
                    }
                }
            };
        };

        attachFunction(reporter, "log");
        attachFunction(reporter, "warn");
        attachFunction(reporter, "error");
    }

    return reporter;
};

/***/ }),

/***/ "OvRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("oM7Q"), __esModule: true };

/***/ }),

/***/ "PIk1":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ "Pf15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "PlIm":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("+tPU");
__webpack_require__("aY9x");
__webpack_require__("tGP/");
__webpack_require__("OPyX");
module.exports = __webpack_require__("FeBl").WeakMap;


/***/ }),

/***/ "PzxK":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("D2L2");
var toObject = __webpack_require__("sB3e");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "QA75":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("1J88"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),

/***/ "QLyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Stats = function Stats() {

	var mode = 0;

	var container = document.createElement('div');
	container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
	container.addEventListener('click', function (event) {

		event.preventDefault();
		showPanel(++mode % container.children.length);
	}, false);

	//

	function addPanel(panel) {

		container.appendChild(panel.dom);
		return panel;
	}

	function showPanel(id) {

		for (var i = 0; i < container.children.length; i++) {

			container.children[i].style.display = i === id ? 'block' : 'none';
		}

		mode = id;
	}

	//

	var beginTime = (performance || Date).now(),
	    prevTime = beginTime,
	    frames = 0;

	var fpsPanel = addPanel(new Stats.Panel('FPS', '#0ff', '#002'));
	var msPanel = addPanel(new Stats.Panel('MS', '#0f0', '#020'));

	if (self.performance && self.performance.memory) {

		var memPanel = addPanel(new Stats.Panel('MB', '#f08', '#201'));
	}

	showPanel(0);

	return {

		REVISION: 16,

		dom: container,

		addPanel: addPanel,
		showPanel: showPanel,

		begin: function begin() {

			beginTime = (performance || Date).now();
		},

		end: function end() {

			frames++;

			var time = (performance || Date).now();

			msPanel.update(time - beginTime, 200);

			if (time >= prevTime + 1000) {

				fpsPanel.update(frames * 1000 / (time - prevTime), 100);

				prevTime = time;
				frames = 0;

				if (memPanel) {

					var memory = performance.memory;
					memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
				}
			}

			return time;
		},

		update: function update() {

			beginTime = this.end();
		},

		// Backwards Compatibility

		domElement: container,
		setMode: showPanel

	};
};

Stats.Panel = function (name, fg, bg) {

	var min = Infinity,
	    max = 0,
	    round = Math.round;
	var PR = round(window.devicePixelRatio || 1);

	var WIDTH = 80 * PR,
	    HEIGHT = 48 * PR,
	    TEXT_X = 3 * PR,
	    TEXT_Y = 2 * PR,
	    GRAPH_X = 3 * PR,
	    GRAPH_Y = 15 * PR,
	    GRAPH_WIDTH = 74 * PR,
	    GRAPH_HEIGHT = 30 * PR;

	var canvas = document.createElement('canvas');
	canvas.width = WIDTH;
	canvas.height = HEIGHT;
	canvas.style.cssText = 'width:80px;height:48px';

	var context = canvas.getContext('2d');
	context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
	context.textBaseline = 'top';

	context.fillStyle = bg;
	context.fillRect(0, 0, WIDTH, HEIGHT);

	context.fillStyle = fg;
	context.fillText(name, TEXT_X, TEXT_Y);
	context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

	context.fillStyle = bg;
	context.globalAlpha = 0.9;
	context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);

	return {

		dom: canvas,

		update: function update(value, maxValue) {

			min = Math.min(min, value);
			max = Math.max(max, value);

			context.fillStyle = bg;
			context.globalAlpha = 1;
			context.fillRect(0, 0, WIDTH, GRAPH_Y);
			context.fillStyle = fg;
			context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);

			context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);

			context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);

			context.fillStyle = bg;
			context.globalAlpha = 0.9;
			context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
		}

	};
};

/* harmony default export */ __webpack_exports__["a"] = (Stats);

/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "QWe/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("crlp")('observable');


/***/ }),

/***/ "R4wc":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("kM2E");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("To3L") });


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RJDW":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("vGyT");
module.exports = __webpack_require__("FeBl").Math.imul;


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "RRo+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("c45H"), __esModule: true };

/***/ }),

/***/ "RY/4":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("R9M2");
var TAG = __webpack_require__("dSzd")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "Rrel":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("TcQ7");
var gOPN = __webpack_require__("n0T6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "S1QW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
 */



var forEach = __webpack_require__("dbB1").forEach;

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;
    var hasState        = options.stateHandler.hasState;
    var idHandler       = options.idHandler;

    if (!batchProcessor) {
        throw new Error("Missing required dependency: batchProcessor");
    }

    if (!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    //TODO: Could this perhaps be done at installation time?
    var scrollbarSizes = getScrollbarSizes();

    var styleId = "erd_scroll_detection_scrollbar_style";
    var detectionContainerClass = "erd_scroll_detection_container";

    function initDocument(targetDocument) {
        // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
        // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
        injectScrollStyle(targetDocument, styleId, detectionContainerClass);
    }

    initDocument(window.document);

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    function getScrollbarSizes() {
        var width = 500;
        var height = 500;

        var child = document.createElement("div");
        child.style.cssText = buildCssTextString(["position: absolute", "width: " + width*2 + "px", "height: " + height*2 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        var container = document.createElement("div");
        container.style.cssText = buildCssTextString(["position: absolute", "width: " + width + "px", "height: " + height + "px", "overflow: scroll", "visibility: none", "top: " + -width*3 + "px", "left: " + -height*3 + "px", "visibility: hidden", "margin: 0", "padding: 0"]);

        container.appendChild(child);

        document.body.insertBefore(container, document.body.firstChild);

        var widthSize = width - container.clientWidth;
        var heightSize = height - container.clientHeight;

        document.body.removeChild(container);

        return {
            width: widthSize,
            height: heightSize
        };
    }

    function injectScrollStyle(targetDocument, styleId, containerClass) {
        function injectStyle(style, method) {
            method = method || function (element) {
                targetDocument.head.appendChild(element);
            };

            var styleElement = targetDocument.createElement("style");
            styleElement.innerHTML = style;
            styleElement.id = styleId;
            method(styleElement);
            return styleElement;
        }

        if (!targetDocument.getElementById(styleId)) {
            var containerAnimationClass = containerClass + "_animation";
            var containerAnimationActiveClass = containerClass + "_animation_active";
            var style = "/* Created by the element-resize-detector library. */\n";
            style += "." + containerClass + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n";
            style += "." + containerAnimationActiveClass + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + containerAnimationClass, "animation-name: " + containerAnimationClass]) + " }\n";
            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
            injectStyle(style);
        }
    }

    function addAnimationClass(element) {
        element.className += " " + detectionContainerClass + "_animation_active";
    }

    function addEvent(el, name, cb) {
        if (el.addEventListener) {
            el.addEventListener(name, cb);
        } else if(el.attachEvent) {
            el.attachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to add event listeners.");
        }
    }

    function removeEvent(el, name, cb) {
        if (el.removeEventListener) {
            el.removeEventListener(name, cb);
        } else if(el.detachEvent) {
            el.detachEvent("on" + name, cb);
        } else {
            return reporter.error("[scroll] Don't know how to remove event listeners.");
        }
    }

    function getExpandElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
    }

    function getShrinkElement(element) {
        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        var listeners = getState(element).listeners;

        if (!listeners.push) {
            throw new Error("Cannot add listener to an element that is not detectable.");
        }

        getState(element).listeners.push(listener);
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};

        function debug() {
            if (options.debug) {
                var args = Array.prototype.slice.call(arguments);
                args.unshift(idHandler.get(element), "Scroll: ");
                if (reporter.log.apply) {
                    reporter.log.apply(null, args);
                } else {
                    for (var i = 0; i < args.length; i++) {
                        reporter.log(args[i]);
                    }
                }
            }
        }

        function isDetached(element) {
            function isInDocument(element) {
                var isInShadowRoot = element.getRootNode && element.getRootNode().contains(element);
                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element) || isInShadowRoot;
            }

            if (!isInDocument(element)) {
                return true;
            }

            // FireFox returns null style in hidden iframes. See https://github.com/wnr/element-resize-detector/issues/68 and https://bugzilla.mozilla.org/show_bug.cgi?id=795520
            if (window.getComputedStyle(element) === null) {
                return true;
            }

            return false;
        }

        function isUnrendered(element) {
            // Check the absolute positioned container since the top level container is display: inline.
            var container = getState(element).container.childNodes[0];
            var style = window.getComputedStyle(container);
            return !style.width || style.width.indexOf("px") === -1; //Can only compute pixel value when rendered.
        }

        function getStyle() {
            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
            var elementStyle            = window.getComputedStyle(element);
            var style                   = {};
            style.position              = elementStyle.position;
            style.width                 = element.offsetWidth;
            style.height                = element.offsetHeight;
            style.top                   = elementStyle.top;
            style.right                 = elementStyle.right;
            style.bottom                = elementStyle.bottom;
            style.left                  = elementStyle.left;
            style.widthCSS              = elementStyle.width;
            style.heightCSS             = elementStyle.height;
            return style;
        }

        function storeStartSize() {
            var style = getStyle();
            getState(element).startSize = {
                width: style.width,
                height: style.height
            };
            debug("Element start size", getState(element).startSize);
        }

        function initListeners() {
            getState(element).listeners = [];
        }

        function storeStyle() {
            debug("storeStyle invoked.");
            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getStyle();
            getState(element).style = style;
        }

        function storeCurrentSize(element, width, height) {
            getState(element).lastWidth = width;
            getState(element).lastHeight  = height;
        }

        function getExpandChildElement(element) {
            return getExpandElement(element).childNodes[0];
        }

        function getWidthOffset() {
            return 2 * scrollbarSizes.width + 1;
        }

        function getHeightOffset() {
            return 2 * scrollbarSizes.height + 1;
        }

        function getExpandWidth(width) {
            return width + 10 + getWidthOffset();
        }

        function getExpandHeight(height) {
            return height + 10 + getHeightOffset();
        }

        function getShrinkWidth(width) {
            return width * 2 + getWidthOffset();
        }

        function getShrinkHeight(height) {
            return height * 2 + getHeightOffset();
        }

        function positionScrollbars(element, width, height) {
            var expand          = getExpandElement(element);
            var shrink          = getShrinkElement(element);
            var expandWidth     = getExpandWidth(width);
            var expandHeight    = getExpandHeight(height);
            var shrinkWidth     = getShrinkWidth(width);
            var shrinkHeight    = getShrinkHeight(height);
            expand.scrollLeft   = expandWidth;
            expand.scrollTop    = expandHeight;
            shrink.scrollLeft   = shrinkWidth;
            shrink.scrollTop    = shrinkHeight;
        }

        function injectContainerElement() {
            var container = getState(element).container;

            if (!container) {
                container                   = document.createElement("div");
                container.className         = detectionContainerClass;
                container.style.cssText     = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]);
                getState(element).container = container;
                addAnimationClass(container);
                element.appendChild(container);

                var onAnimationStart = function () {
                    getState(element).onRendered && getState(element).onRendered();
                };

                addEvent(container, "animationstart", onAnimationStart);

                // Store the event handler here so that they may be removed when uninstall is called.
                // See uninstall function for an explanation why it is needed.
                getState(element).onAnimationStart = onAnimationStart;
            }

            return container;
        }

        function injectScrollElements() {
            function alterPositionStyles() {
                var style = getState(element).style;

                if(style.position === "static") {
                    element.style.setProperty("position", "relative",options.important ? "important" : "");

                    var removeRelativeStyles = function(reporter, element, style, property) {
                        function getNumericalValue(value) {
                            return value.replace(/[^-\d\.]/g, "");
                        }

                        var value = style[property];

                        if(value !== "auto" && getNumericalValue(value) !== "0") {
                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                            element.style[property] = 0;
                        }
                    };

                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                    removeRelativeStyles(reporter, element, style, "top");
                    removeRelativeStyles(reporter, element, style, "right");
                    removeRelativeStyles(reporter, element, style, "bottom");
                    removeRelativeStyles(reporter, element, style, "left");
                }
            }

            function getLeftTopBottomRightCssText(left, top, bottom, right) {
                left = (!left ? "0" : (left + "px"));
                top = (!top ? "0" : (top + "px"));
                bottom = (!bottom ? "0" : (bottom + "px"));
                right = (!right ? "0" : (right + "px"));

                return ["left: " + left, "top: " + top, "right: " + right, "bottom: " + bottom];
            }

            debug("Injecting elements");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            alterPositionStyles();

            var rootContainer = getState(element).container;

            if (!rootContainer) {
                rootContainer = injectContainerElement();
            }

            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
            // the targeted element.
            // When the bug is resolved, "containerContainer" may be removed.

            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.

            var scrollbarWidth          = scrollbarSizes.width;
            var scrollbarHeight         = scrollbarSizes.height;
            var containerContainerStyle = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]);
            var containerStyle          = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth)));
            var expandStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var shrinkStyle             = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]);
            var expandChildStyle        = buildCssTextString(["position: absolute", "left: 0", "top: 0"]);
            var shrinkChildStyle        = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]);

            var containerContainer      = document.createElement("div");
            var container               = document.createElement("div");
            var expand                  = document.createElement("div");
            var expandChild             = document.createElement("div");
            var shrink                  = document.createElement("div");
            var shrinkChild             = document.createElement("div");

            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
            containerContainer.dir              = "ltr";

            containerContainer.style.cssText    = containerContainerStyle;
            containerContainer.className        = detectionContainerClass;
            container.className                 = detectionContainerClass;
            container.style.cssText             = containerStyle;
            expand.style.cssText                = expandStyle;
            expandChild.style.cssText           = expandChildStyle;
            shrink.style.cssText                = shrinkStyle;
            shrinkChild.style.cssText           = shrinkChildStyle;

            expand.appendChild(expandChild);
            shrink.appendChild(shrinkChild);
            container.appendChild(expand);
            container.appendChild(shrink);
            containerContainer.appendChild(container);
            rootContainer.appendChild(containerContainer);

            function onExpandScroll() {
                var state = getState(element);
                if (state && state.onExpand) {
                    state.onExpand();
                } else {
                    debug("Aborting expand scroll handler: element has been uninstalled");
                }
            }

            function onShrinkScroll() {
                var state = getState(element);
                if (state && state.onShrink) {
                    state.onShrink();
                } else {
                    debug("Aborting shrink scroll handler: element has been uninstalled");
                }
            }

            addEvent(expand, "scroll", onExpandScroll);
            addEvent(shrink, "scroll", onShrinkScroll);

            // Store the event handlers here so that they may be removed when uninstall is called.
            // See uninstall function for an explanation why it is needed.
            getState(element).onExpandScroll = onExpandScroll;
            getState(element).onShrinkScroll = onShrinkScroll;
        }

        function registerListenersAndPositionElements() {
            function updateChildSizes(element, width, height) {
                var expandChild             = getExpandChildElement(element);
                var expandWidth             = getExpandWidth(width);
                var expandHeight            = getExpandHeight(height);
                expandChild.style.setProperty("width", expandWidth + "px", options.important ? "important" : "");
                expandChild.style.setProperty("height", expandHeight + "px", options.important ? "important" : "");
            }

            function updateDetectorElements(done) {
                var width           = element.offsetWidth;
                var height          = element.offsetHeight;

                // Check whether the size has actually changed since last time the algorithm ran. If not, some steps may be skipped.
                var sizeChanged = width !== getState(element).lastWidth || height !== getState(element).lastHeight;

                debug("Storing current size", width, height);

                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
                // Otherwise the if-check in handleScroll is useless.
                storeCurrentSize(element, width, height);

                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.

                batchProcessor.add(0, function performUpdateChildSizes() {
                    if (!sizeChanged) {
                        return;
                    }

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    if (options.debug) {
                        var w = element.offsetWidth;
                        var h = element.offsetHeight;

                        if (w !== width || h !== height) {
                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
                        }
                    }

                    updateChildSizes(element, width, height);
                });

                batchProcessor.add(1, function updateScrollbars() {
                    // This function needs to be invoked event though the size is unchanged. The element could have been resized very quickly and then
                    // been restored to the original size, which will have changed the scrollbar positions.

                    if (!getState(element)) {
                        debug("Aborting because element has been uninstalled");
                        return;
                    }

                    if (!areElementsInjected()) {
                        debug("Aborting because element container has not been initialized");
                        return;
                    }

                    positionScrollbars(element, width, height);
                });

                if (sizeChanged && done) {
                    batchProcessor.add(2, function () {
                        if (!getState(element)) {
                            debug("Aborting because element has been uninstalled");
                            return;
                        }

                        if (!areElementsInjected()) {
                          debug("Aborting because element container has not been initialized");
                          return;
                        }

                        done();
                    });
                }
            }

            function areElementsInjected() {
                return !!getState(element).container;
            }

            function notifyListenersIfNeeded() {
                function isFirstNotify() {
                    return getState(element).lastNotifiedWidth === undefined;
                }

                debug("notifyListenersIfNeeded invoked");

                var state = getState(element);

                // Don't notify if the current size is the start size, and this is the first notification.
                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
                }

                // Don't notify if the size already has been notified.
                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
                    return debug("Not notifying: Size already notified");
                }


                debug("Current size not notified, notifying...");
                state.lastNotifiedWidth = state.lastWidth;
                state.lastNotifiedHeight = state.lastHeight;
                forEach(getState(element).listeners, function (listener) {
                    listener(element);
                });
            }

            function handleRender() {
                debug("startanimation triggered.");

                if (isUnrendered(element)) {
                    debug("Ignoring since element is still unrendered...");
                    return;
                }

                debug("Element rendered.");
                var expand = getExpandElement(element);
                var shrink = getShrinkElement(element);
                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
                    debug("Scrollbars out of sync. Updating detector elements...");
                    updateDetectorElements(notifyListenersIfNeeded);
                }
            }

            function handleScroll() {
                debug("Scroll detected.");

                if (isUnrendered(element)) {
                    // Element is still unrendered. Skip this scroll event.
                    debug("Scroll event fired while unrendered. Ignoring...");
                    return;
                }

                updateDetectorElements(notifyListenersIfNeeded);
            }

            debug("registerListenersAndPositionElements invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            getState(element).onRendered = handleRender;
            getState(element).onExpand = handleScroll;
            getState(element).onShrink = handleScroll;

            var style = getState(element).style;
            updateChildSizes(element, style.width, style.height);
        }

        function finalizeDomMutation() {
            debug("finalizeDomMutation invoked.");

            if (!getState(element)) {
                debug("Aborting because element has been uninstalled");
                return;
            }

            var style = getState(element).style;
            storeCurrentSize(element, style.width, style.height);
            positionScrollbars(element, style.width, style.height);
        }

        function ready() {
            callback(element);
        }

        function install() {
            debug("Installing...");
            initListeners();
            storeStartSize();

            batchProcessor.add(0, storeStyle);
            batchProcessor.add(1, injectScrollElements);
            batchProcessor.add(2, registerListenersAndPositionElements);
            batchProcessor.add(3, finalizeDomMutation);
            batchProcessor.add(4, ready);
        }

        debug("Making detectable...");

        if (isDetached(element)) {
            debug("Element is detached");

            injectContainerElement();

            debug("Waiting until element is attached...");

            getState(element).onRendered = function () {
                debug("Element is now attached");
                install();
            };
        } else {
            install();
        }
    }

    function uninstall(element) {
        var state = getState(element);

        if (!state) {
            // Uninstall has been called on a non-erd element.
            return;
        }

        // Uninstall may have been called in the following scenarios:
        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
        // So to be on the safe side, let's check for each thing before removing.

        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);

        state.container && element.removeChild(state.container);
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall,
        initDocument: initDocument
    };
};


/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SCI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Deflate */
/* unused harmony export AsyncDeflate */
/* unused harmony export deflate */
/* unused harmony export deflateSync */
/* unused harmony export Inflate */
/* unused harmony export AsyncInflate */
/* unused harmony export inflate */
/* unused harmony export inflateSync */
/* unused harmony export Gzip */
/* unused harmony export AsyncGzip */
/* unused harmony export gzip */
/* unused harmony export gzipSync */
/* unused harmony export Gunzip */
/* unused harmony export AsyncGunzip */
/* unused harmony export gunzip */
/* unused harmony export gunzipSync */
/* unused harmony export Zlib */
/* unused harmony export AsyncZlib */
/* unused harmony export zlib */
/* unused harmony export zlibSync */
/* unused harmony export Unzlib */
/* unused harmony export AsyncUnzlib */
/* unused harmony export unzlib */
/* harmony export (immutable) */ __webpack_exports__["a"] = unzlibSync;
/* unused harmony export compress */
/* unused harmony export AsyncCompress */
/* unused harmony export compressSync */
/* unused harmony export Compress */
/* unused harmony export Decompress */
/* unused harmony export AsyncDecompress */
/* unused harmony export decompress */
/* unused harmony export decompressSync */
/* unused harmony export DecodeUTF8 */
/* unused harmony export EncodeUTF8 */
/* unused harmony export strToU8 */
/* unused harmony export strFromU8 */
/* unused harmony export ZipPassThrough */
/* unused harmony export ZipDeflate */
/* unused harmony export AsyncZipDeflate */
/* unused harmony export Zip */
/* unused harmony export zip */
/* unused harmony export zipSync */
/* unused harmony export UnzipPassThrough */
/* unused harmony export UnzipInflate */
/* unused harmony export AsyncUnzipInflate */
/* unused harmony export Unzip */
/* unused harmony export unzip */
/* unused harmony export unzipSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.6.9
*/

// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var durl = function durl(c) {
    return URL.createObjectURL(new Blob([c], { type: 'text/javascript' }));
};
var cwk = function cwk(u) {
    return new Worker(u);
};
try {
    URL.revokeObjectURL(durl(''));
} catch (e) {
    // We're in Deno or a very old browser
    durl = function durl(c) {
        return 'data:application/javascript;charset=UTF-8,' + encodeURI(c);
    };
    // If Deno, this is necessary; if not, this changes nothing
    cwk = function cwk(u) {
        return new Worker(u, { type: 'module' });
    };
}
var wk = function wk(c, id, msg, transfer, cb) {
    var w = cwk(ch2[id] || (ch2[id] = durl(c)));
    w.onerror = function (e) {
        return cb(e.error, null);
    };
    w.onmessage = function (e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array,
    u16 = Uint16Array,
    u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */0, 0, /* impossible */0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function freb(eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = j - b[i] << 5 | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2),
    fl = _a[0],
    revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0),
    fd = _b[0],
    revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = function hMap(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i) {
        ++l[cd[i] - 1];
    } // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = le[i - 1] + l[i - 1] << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = i << 4 | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    } else {
        co = new u16(s);
        for (i = 0; i < s; ++i) {
            if (cd[i]) {
                co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
            }
        }
    }
    return co;
};
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i) {
    flt[i] = 8;
}for (var i = 144; i < 256; ++i) {
    flt[i] = 9;
}for (var i = 256; i < 280; ++i) {
    flt[i] = 7;
}for (var i = 280; i < 288; ++i) {
    flt[i] = 8;
} // fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i) {
    fdt[i] = 5;
} // fixed length map
var flm = /*#__PURE__*/hMap(flt, 9, 0),
    flrm = /*#__PURE__*/hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/hMap(fdt, 5, 0),
    fdrm = /*#__PURE__*/hMap(fdt, 5, 1);
// find max of array
var max = function max(a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m) m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function bits(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function bits16(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var shft = function shft(p) {
    return (p / 8 | 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function slc(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function inflt(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && !st.l && sl < 5) return buf || new u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function cbuf(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0,
        pos = st.p || 0,
        bt = st.b || 0,
        lm = st.l,
        dm = st.d,
        lbt = st.m,
        dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4,
                    l = dat[s - 4] | dat[s - 3] << 8,
                    t = s + l;
                if (t > sl) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257,
                    hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt),
                    clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    } else {
                        //  copy   count
                        var c = 0,
                            n = 0;
                        if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--) {
                            ldt[i++] = c;
                        }
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit),
                    dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            } else throw 'invalid block type';
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1,
            dms = (1 << dbt) - 1;
        var lpos = pos;
        for (;; lpos = pos) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms],
                sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
            if (!c) throw 'invalid length/literal';
            if (sym < 256) buf[bt++] = sym;else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257,
                        b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms],
                    dsym = d >>> 4;
                if (!d) throw 'invalid distance';
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function wbits(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function wbits16(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function hTree(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i]) t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [et, 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0],
        r = t[1],
        i0 = 0,
        i1 = 1,
        i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym) maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0,
            dt = 0;
        //    left            cost
        var lft = mbt - mb,
            cst = 1 << lft;
        t2.sort(function (a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;else ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function ln(n, l, d) {
    return n.s == -1 ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var lc = function lc(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s]) {}
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0,
        cln = c[0],
        cls = 1;
    var w = function w(v) {
        cl[cli++] = v;
    };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s) ++cls;else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138) {
                    w(32754);
                }if (cls > 2) {
                    w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                    cls = 0;
                }
            } else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6) {
                    w(8304);
                }if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
            }
            while (cls--) {
                w(cln);
            }cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function clen(cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i) {
        l += cf[i] * cl[i];
    }return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function wfblk(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i) {
        out[o + i + 4] = dat[i];
    }return (o + 4 + s) * 8;
};
// writes a block
var wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15),
        dlt = _a[0],
        mlb = _a[1];
    var _b = hTree(df, 15),
        ddt = _b[0],
        mdb = _b[1];
    var _c = lc(dlt),
        lclt = _c[0],
        nlc = _c[1];
    var _d = lc(ddt),
        lcdt = _d[0],
        ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i) {
        lcfreq[lclt[i] & 31]++;
    }for (var i = 0; i < lcdt.length; ++i) {
        lcfreq[lcdt[i] & 31]++;
    }var _e = hTree(lcfreq, 7),
        lct = _e[0],
        mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc) {}
    var flen = bl + 5 << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i) {
            wbits(out, p + 3 * i, lct[clim[i]]);
        }p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = syms[i] >>> 18 & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) wbits(out, p, syms[i] >>> 23 & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) wbits16(out, p, syms[i] >>> 5 & 8191), p += fdeb[dst];
        } else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            } else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    } else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13,
            c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768),
            head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3),
            bs2_1 = 2 * bs1_1;
        var hsh = function hsh(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288),
            df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0,
            eb = 0,
            i = 0,
            li = 0,
            wi = 0,
            bs = 0;
        for (; i < s; ++i) {
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767,
                pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j) {
                        lf[j] = 0;
                    }for (var j = 0; j < 30; ++j) {
                        df[j] = 0;
                    }
                }
                //  len    dist   chain
                var l = 2,
                    d = 0,
                    ch_1 = c,
                    dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl) {}
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | revfl[l] << 18 | revfd[d];
                    var lin = revfl[l] & 31,
                        din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = wfblk(w, pos + 1, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/function () {
    var t = new u32(256);
    for (var i = 0; i < 256; ++i) {
        var c = i,
            k = 9;
        while (--k) {
            c = (c & 1 && 0xEDB88320) ^ c >>> 1;
        }t[i] = c;
    }
    return t;
}();
// CRC32
var crc = function crc() {
    var c = -1;
    return {
        p: function p(d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i) {
                cr = crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            }c = cr;
        },
        d: function d() {
            return ~c;
        }
    };
};
// Alder32
var adler = function adler() {
    var a = 1,
        b = 0;
    return {
        p: function p(d) {
            // closures have awful performance
            var n = a,
                m = b;
            var l = d.length;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 2655, l);
                for (; i < e; ++i) {
                    m += n += d[i];
                }n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function d() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
;
// deflate with opts
var dopt = function dopt(dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var mrg = function mrg(a, b) {
    var o = {};
    for (var k in a) {
        o[k] = a[k];
    }for (var k in b) {
        o[k] = b[k];
    }return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function wcln(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i],
            k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for (var t in v.prototype) {
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                    }
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [fnStr, td];
};
var ch = [];
// clone bufs
var cbfs = function cbfs(v) {
    var tl = [];
    for (var k in v) {
        if (v[k] instanceof u8 || v[k] instanceof u16 || v[k] instanceof u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    }
    return tl;
};
// use a worker to execute code
var wrkr = function wrkr(fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = '',
            td_1 = {},
            m = fns.length - 1;
        for (var i = 0; i < m; ++i) {
            _a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        }ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function bInflt() {
    return [u8, u16, u32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, hMap, max, bits, bits16, shft, slc, inflt, inflateSync, pbf, gu8];
};
var bDflt = function bDflt() {
    return [u8, u16, u32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf];
};
// gzip extra
var gze = function gze() {
    return [gzh, gzhl, wbytes, crc, crct];
};
// gunzip extra
var guze = function guze() {
    return [gzs, gzl];
};
// zlib extra
var zle = function zle() {
    return [zlh, wbytes, adler];
};
// unzlib extra
var zule = function zule() {
    return [zlv];
};
// post buf
var pbf = function pbf(msg) {
    return postMessage(msg, [msg.buffer]);
};
// get u8
var gu8 = function gu8(o) {
    return o && o.size && new u8(o.size);
};
// async helper
var cbify = function cbify(dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([dat, opts], opts.consume ? [dat.buffer] : []);
    return function () {
        w.terminate();
    };
};
// auto stream
var astrm = function astrm(strm) {
    strm.ondata = function (dat, final) {
        return postMessage([dat, final], [dat.buffer]);
    };
    return function (ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var astrmify = function astrmify(fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function (d, f) {
        if (t) throw 'stream finished';
        if (!strm.ondata) throw 'no stream handler';
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () {
        w.terminate();
    };
};
// read 2 bytes
var b2 = function b2(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var b4 = function b4(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var b8 = function b8(d, b) {
    return b4(d, b) + b4(d, b + 4) * 4294967296;
};
// write bytes
var wbytes = function wbytes(d, b, v) {
    for (; v; ++b) {
        d[b] = v, v >>>= 8;
    }
};
// gzip header
var gzh = function gzh(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i) {
            c[i + 10] = fn.charCodeAt(i);
        }
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function gzs(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]) {}
    return st + (flg & 2);
};
// gzip length
var gzl = function gzl(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var gzhl = function gzhl(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var zlh = function zlh(c, o) {
    var lv = o.level,
        fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var zlv = function zlv(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw 'invalid zlib data';
    if (d[1] & 32) throw 'invalid zlib data: preset dictionaries not supported';
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/function () {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/function () {
    function AsyncDeflate(opts, cb) {
        astrmify([bDflt, function () {
            return [astrm, Deflate];
        }], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();

function deflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bDflt], function (ev) {
        return pbf(deflateSync(ev.data[0], ev.data[1]));
    }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    return dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/function () {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */
    function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function (c) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function (final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/function () {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([bInflt, function () {
            return [astrm, Inflate];
        }], this, 0, function () {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();

function inflate(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bInflt], function (ev) {
        return pbf(inflateSync(ev.data[0], gu8(ev.data[1])));
    }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v) gzh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/function () {
    function AsyncGzip(opts, cb) {
        astrmify([bDflt, gze, function () {
            return [astrm, Deflate, Gzip];
        }], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();

function gzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bDflt, gze, function () {
        return [gzipSync];
    }], function (ev) {
        return pbf(gzipSync(ev.data[0], ev.data[1]));
    }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (!opts) opts = {};
    var c = crc(),
        l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8),
        s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */
var Gunzip = /*#__PURE__*/function () {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */
    function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}();

/**
 * Asynchronous streaming GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/function () {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([bInflt, guze, function () {
            return [astrm, Inflate, Gunzip];
        }], this, 0, function () {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();

function gunzip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bInflt, guze, function () {
        return [gunzipSync];
    }], function (ev) {
        return pbf(gunzipSync(ev.data[0]));
    }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) zlh(raw, this.o), this.v = 0;
        if (f) wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/function () {
    function AsyncZlib(opts, cb) {
        astrmify([bDflt, zle, function () {
            return [astrm, Deflate, Zlib];
        }], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();

function zlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bDflt, zle, function () {
        return [zlibSync];
    }], function (ev) {
        return pbf(zlibSync(ev.data[0], ev.data[1]));
    }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (!opts) opts = {};
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/function () {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */
    function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}();

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/function () {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([bInflt, zule, function () {
            return [astrm, Inflate, Unzlib];
        }], this, 0, function () {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();

function unzlib(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return cbify(data, opts, [bInflt, zule, function () {
        return [unzlibSync];
    }], function (ev) {
        return pbf(unzlibSync(ev.data[0], gu8(ev.data[1])));
    }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)

// Default algorithm for compression (used because having a known output size allows faster decompression)

/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/function () {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */
    function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata) throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function cb() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/function () {
    /**
    * Creates an asynchronous decompression stream
    * @param cb The callback to call whenever data is decompressed
    */
    function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();

function decompress(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzip(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflate(data, opts, cb) : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function decompressSync(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? gunzipSync(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? inflateSync(data, out) : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function fltn(d, p, t, o) {
    for (var k in d) {
        var val = d[k],
            n = p + k;
        if (val instanceof u8) t[n] = [val, o];else if (Array.isArray(val)) t[n] = [val[0], mrg(o, val[1])];else fltn(val, n + '/', t, o);
    }
};
// text encoder
var te = typeof TextEncoder != 'undefined' && /*#__PURE__*/new TextEncoder();
// text decoder
var td = typeof TextDecoder != 'undefined' && /*#__PURE__*/new TextDecoder();
// text decoder stream
var tds = 0;
try {
    td.decode(et, { stream: true });
    tds = 1;
} catch (e) {}
// decode UTF8
var dutf8 = function dutf8(d) {
    for (var r = '', i = 0;;) {
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [r, slc(d, i - 1)];
        if (!eb) r += String.fromCharCode(c);else if (eb == 3) {
            c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        } else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */
var DecodeUTF8 = /*#__PURE__*/function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */
    function DecodeUTF8(cb) {
        this.ondata = cb;
        if (tds) this.t = new TextDecoder();else this.p = et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    DecodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata) throw 'no callback';
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, { stream: true }), final);
            if (final) {
                if (this.t.decode().length) throw 'invalid utf-8 data';
                this.t = null;
            }
            return;
        }
        if (!this.p) throw 'stream finished';
        var dat = new u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = dutf8(dat),
            ch = _a[0],
            np = _a[1];
        if (final) {
            if (np.length) throw 'invalid utf-8 data';
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();

/**
 * Streaming UTF-8 encoding
 */
var EncodeUTF8 = /*#__PURE__*/function () {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */
    function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */
    EncodeUTF8.prototype.push = function (chunk, final) {
        if (!this.ondata) throw 'no callback';
        if (this.d) throw 'stream finished';
        this.ondata(strToU8(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();

/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    if (latin1) {
        var ar_1 = new u8(str.length);
        for (var i = 0; i < str.length; ++i) {
            ar_1[i] = str.charCodeAt(i);
        }return ar_1;
    }
    if (te) return te.encode(str);
    var l = str.length;
    var ar = new u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function w(v) {
        ar[ai++] = v;
    };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);else if (c > 55295 && c < 57344) c = 65536 + (c & 1023 << 10) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    if (latin1) {
        var r = '';
        for (var i = 0; i < dat.length; i += 16384) {
            r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        }return r;
    } else if (td) return td.decode(dat);else {
        var _a = dutf8(dat),
            out = _a[0],
            ext = _a[1];
        if (ext.length) throw 'invalid utf-8 data';
        return out;
    }
}
;
// deflate bit flag
var dbf = function dbf(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var slzh = function slzh(d, b) {
    return b + 30 + b2(d, b + 26) + b2(d, b + 28);
};
// read zip header
var zh = function zh(d, b, z) {
    var fnl = b2(d, b + 28),
        fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)),
        es = b + 46 + fnl,
        bs = b4(d, b + 20);
    var _a = z && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)],
        sc = _a[0],
        su = _a[1],
        off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function z64e(d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2)) {}
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
};
// extra field length
var exfl = function exfl(ex) {
    var le = 0;
    if (ex) {
        for (var k in ex) {
            var l = ex[k].length;
            if (l > 65535) throw 'extra field too long';
            le += l + 4;
        }
    }
    return le;
};
// write zip header
var wzh = function wzh(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length,
        ex = f.extra,
        col = co && co.length;
    var exl = exfl(ex);
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime),
        y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw 'date not in range 1980-2099';
    wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        wbytes(d, b, f.crc);
        wbytes(d, b + 4, c);
        wbytes(d, b + 8, f.size);
    }
    wbytes(d, b + 12, fl);
    wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        wbytes(d, b, col);
        wbytes(d, b + 6, f.attrs);
        wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) {
        for (var k in ex) {
            var exf = ex[k],
                l = exf.length;
            wbytes(d, b, +k);
            wbytes(d, b + 2, l);
            d.set(exf, b + 4), b += 4 + l;
        }
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var wzf = function wzf(o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */
var ZipPassThrough = /*#__PURE__*/function () {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */
    function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.process = function (chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipPassThrough.prototype.push = function (chunk, final) {
        if (!this.ondata) throw 'no callback - add to ZIP archive before pushing';
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();

// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */
var ZipDeflate = /*#__PURE__*/function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new Deflate(opts, function (dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
    }
    ZipDeflate.prototype.process = function (chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    ZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();

/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */
var AsyncZipDeflate = /*#__PURE__*/function () {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */
    function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        ZipPassThrough.call(this, filename);
        this.d = new AsyncDeflate(opts, function (err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function (chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncZipDeflate.prototype.push = function (chunk, final) {
        ZipPassThrough.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();

// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */
var Zip = /*#__PURE__*/function () {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */
    function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */
    Zip.prototype.add = function (file) {
        var _this_1 = this;
        if (this.d & 2) throw 'stream finished';
        var f = strToU8(file.filename),
            fl = f.length;
        var com = file.comment,
            o = com && strToU8(com);
        var u = fl != file.filename.length || o && com.length != o.length;
        var hl = fl + exfl(file.extra) + 30;
        if (fl > 65535) throw 'filename too long';
        var header = new u8(hl);
        wzh(header, 0, file, f, u);
        var chks = [header];
        var pAll = function pAll() {
            for (var _i = 0, chks_1 = chks; _i < chks_1.length; _i++) {
                var chk = chks_1[_i];
                _this_1.ondata(null, chk, false);
            }
            chks = [];
        };
        var tr = this.d;
        this.d = 0;
        var ind = this.u.length;
        var uf = mrg(file, {
            f: f,
            u: u,
            o: o,
            t: function t() {
                if (file.terminate) file.terminate();
            },
            r: function r() {
                pAll();
                if (tr) {
                    var nxt = _this_1.u[ind + 1];
                    if (nxt) nxt.r();else _this_1.d = 1;
                }
                tr = 1;
            }
        });
        var cl = 0;
        file.ondata = function (err, dat, final) {
            if (err) {
                _this_1.ondata(err, dat, final);
                _this_1.terminate();
            } else {
                cl += dat.length;
                chks.push(dat);
                if (final) {
                    var dd = new u8(16);
                    wbytes(dd, 0, 0x8074B50);
                    wbytes(dd, 4, file.crc);
                    wbytes(dd, 8, cl);
                    wbytes(dd, 12, file.size);
                    chks.push(dd);
                    uf.c = cl, uf.b = hl + cl + 16, uf.crc = file.crc, uf.size = file.size;
                    if (tr) uf.r();
                    tr = 1;
                } else if (tr) pAll();
            }
        };
        this.u.push(uf);
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */
    Zip.prototype.end = function () {
        var _this_1 = this;
        if (this.d & 2) {
            if (this.d & 1) throw 'stream finishing';
            throw 'stream finished';
        }
        if (this.d) this.e();else this.u.push({
            r: function r() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function t() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function () {
        var bt = 0,
            l = 0,
            tl = 0;
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            tl += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new u8(tl + 22);
        for (var _b = 0, _c = this.u; _b < _c.length; _b++) {
            var f = _c[_b];
            wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */
    Zip.prototype.terminate = function () {
        for (var _i = 0, _a = this.u; _i < _a.length; _i++) {
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();

function zip(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    var r = {};
    fltn(data, '', r, opts);
    var k = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(r);
    var lft = k.length,
        o = 0,
        tot = 0;
    var slft = lft,
        files = new Array(lft);
    var term = [];
    var tAll = function tAll() {
        for (var i = 0; i < term.length; ++i) {
            term[i]();
        }
    };
    var cbf = function cbf() {
        var out = new u8(tot + 22),
            oe = o,
            cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                var l = f.c.length;
                wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cb(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function _loop_1(i) {
        var fn = k[i];
        var _a = r[fn],
            file = _a[0],
            p = _a[1];
        var c = crc(),
            size = file.length;
        c.p(file);
        var f = strToU8(fn),
            s = f.length;
        var com = p.comment,
            m = com && strToU8(com),
            ms = m && m.length;
        var exl = exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function cbl(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (! --lft) cbf();
            }
        };
        if (s > 65535) cbl('filename too long', null);
        if (!compression) cbl(null, file);else if (size < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            } catch (e) {
                cbl(e, null);
            }
        } else term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn],
            file = _a[0],
            p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = strToU8(fn),
            s = f.length;
        var com = p.comment,
            m = com && strToU8(com),
            ms = m && m.length;
        var exl = exfl(p.extra);
        if (s > 65535) throw 'filename too long';
        var d = compression ? deflateSync(file, p) : file,
            l = d.length;
        var c = crc();
        c.p(file);
        files.push(mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new u8(tot + 22),
        oe = o,
        cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + exfl(f.extra);
        out.set(f.c, f.o + badd);
        wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */
var UnzipPassThrough = /*#__PURE__*/function () {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function (data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();

/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */
var UnzipInflate = /*#__PURE__*/function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function UnzipInflate() {
        var _this_1 = this;
        this.i = new Inflate(function (dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function (data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, data, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();

/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */
var AsyncUnzipInflate = /*#__PURE__*/function () {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */
    function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) {
            this.i = new Inflate(function (dat, final) {
                _this_1.ondata(null, dat, final);
            });
        } else {
            this.i = new AsyncInflate(function (err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function (data, final) {
        if (this.i.terminate) data = slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();

/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */
var Unzip = /*#__PURE__*/function () {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */
    function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: UnzipPassThrough
        };
        this.p = et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzip.prototype.push = function (chunk, final) {
        var _this_1 = this;
        if (!this.onfile) throw 'no callback';
        if (!this.p) throw 'stream finished';
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0,
                i = 0,
                is = void 0,
                buf = void 0;
            if (!this.p.length) buf = chunk;else if (!chunk.length) buf = this.p;else {
                buf = new u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length,
                oc = this.c,
                add = oc && this.d;
            var _loop_2 = function _loop_2() {
                var _a;
                var sig = b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = b2(buf, i + 6),
                        cmp_1 = b2(buf, i + 8),
                        u = bf & 2048,
                        dd = bf & 8,
                        fnl = b2(buf, i + 26),
                        es = b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_2 = [];
                        this_1.k.unshift(chks_2);
                        f = 2;
                        var sc_1 = b4(buf, i + 18),
                            su_1 = b4(buf, i + 22);
                        var fn_1 = strFromU8(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) {
                            _a = dd ? [-2] : z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        } else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function start() {
                                if (!file_1.ondata) throw 'no callback';
                                if (!sc_1) file_1.ondata(null, et, true);else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) throw 'unknown compression type ' + cmp_1;
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function (err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for (var _i = 0, chks_3 = chks_2; _i < chks_3.length; _i++) {
                                        var dat = chks_3[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_2 && _this_1.c) _this_1.d = d_1;else d_1.push(et, true);
                                }
                            },
                            terminate: function terminate() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for (; i < l - 4; ++i) {
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - (b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) throw 'invalid zip file';
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */
    Unzip.prototype.register = function (decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();

/**
 * Asynchronously decompresses a ZIP archive
 * @param data The raw compressed ZIP file
 * @param cb The callback to call with the decompressed files
 * @returns A function that can be used to immediately terminate the unzipping
 */
function unzip(data, cb) {
    if (typeof cb != 'function') throw 'no callback';
    var term = [];
    var tAll = function tAll() {
        for (var i = 0; i < term.length; ++i) {
            term[i]();
        }
    };
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cb('invalid zip file', null);
            return;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50) {
            cb('invalid zip file', null);
            return;
        }
        c = lft = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var _loop_3 = function _loop_3(i) {
        var _a = zh(data, o, z),
            c_1 = _a[0],
            sc = _a[1],
            su = _a[2],
            fn = _a[3],
            no = _a[4],
            off = _a[5],
            b = slzh(data, off);
        o = no;
        var cbl = function cbl(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (! --lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, slc(data, b, b + sc));else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) {
                try {
                    cbl(null, inflateSync(infl, new u8(su)));
                } catch (e) {
                    cbl(e, null);
                }
            } else term.push(inflate(infl, { size: su }, cbl));
        } else cbl('unknown compression type ' + c_1, null);
    };
    for (var i = 0; i < c; ++i) {
        _loop_3(i);
    }
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @returns The decompressed files
 */
function unzipSync(data) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) throw 'invalid zip file';
    }
    ;
    var c = b2(data, e + 8);
    if (!c) return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z),
            c_2 = _a[0],
            sc = _a[1],
            su = _a[2],
            fn = _a[3],
            no = _a[4],
            off = _a[5],
            b = slzh(data, off);
        o = no;
        if (!c_2) files[fn] = slc(data, b, b + sc);else if (c_2 == 8) files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));else throw 'unknown compression type ' + c_2;
    }
    return files;
}

/***/ }),

/***/ "SKY5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Resize detection strategy that injects objects to elements in order to detect resize events.
 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
 */



var browserDetector = __webpack_require__("Saiw");

module.exports = function(options) {
    options             = options || {};
    var reporter        = options.reporter;
    var batchProcessor  = options.batchProcessor;
    var getState        = options.stateHandler.getState;

    if(!reporter) {
        throw new Error("Missing required dependency: reporter.");
    }

    /**
     * Adds a resize event listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
     */
    function addListener(element, listener) {
        function listenerProxy() {
            listener(element);
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support object, but supports the resize event directly on elements.
            getState(element).object = {
                proxy: listenerProxy
            };
            element.attachEvent("onresize", listenerProxy);
        } else {
            var object = getObject(element);

            if(!object) {
                throw new Error("Element is not detectable by this strategy.");
            }

            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
        }
    }

    function buildCssTextString(rules) {
        var seperator = options.important ? " !important; " : "; ";

        return (rules.join(seperator) + seperator).trim();
    }

    /**
     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
     * @private
     * @param {object} options Optional options object.
     * @param {element} element The element to make detectable
     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
     */
    function makeDetectable(options, element, callback) {
        if (!callback) {
            callback = element;
            element = options;
            options = null;
        }

        options = options || {};
        var debug = options.debug;

        function injectObject(element, callback) {
            var OBJECT_STYLE = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]);

            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.

            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
            var positionCheckPerformed = false;

            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
            var style = window.getComputedStyle(element);
            var width = element.offsetWidth;
            var height = element.offsetHeight;

            getState(element).startSize = {
                width: width,
                height: height
            };

            function mutateDom() {
                function alterPositionStyles() {
                    if(style.position === "static") {
                        element.style.setProperty("position", "relative", options.important ? "important" : "");

                        var removeRelativeStyles = function(reporter, element, style, property) {
                            function getNumericalValue(value) {
                                return value.replace(/[^-\d\.]/g, "");
                            }

                            var value = style[property];

                            if(value !== "auto" && getNumericalValue(value) !== "0") {
                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
                                element.style.setProperty(property, "0", options.important ? "important" : "");
                            }
                        };

                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
                        removeRelativeStyles(reporter, element, style, "top");
                        removeRelativeStyles(reporter, element, style, "right");
                        removeRelativeStyles(reporter, element, style, "bottom");
                        removeRelativeStyles(reporter, element, style, "left");
                    }
                }

                function onObjectLoad() {
                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
                    if (!positionCheckPerformed) {
                        alterPositionStyles();
                    }

                    /*jshint validthis: true */

                    function getDocument(element, callback) {
                        //Opera 12 seem to call the object.onload before the actual document has been created.
                        //So if it is not present, poll it with an timeout until it is present.
                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
                        if(!element.contentDocument) {
                            var state = getState(element);
                            if (state.checkForObjectDocumentTimeoutId) {
                                window.clearTimeout(state.checkForObjectDocumentTimeoutId);
                            }
                            state.checkForObjectDocumentTimeoutId = setTimeout(function checkForObjectDocument() {
                                state.checkForObjectDocumentTimeoutId = 0;
                                getDocument(element, callback);
                            }, 100);

                            return;
                        }

                        callback(element.contentDocument);
                    }

                    //Mutating the object element here seems to fire another load event.
                    //Mutating the inner document of the object element is fine though.
                    var objectElement = this;

                    //Create the style element to be added to the object.
                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
                        //Notify that the element is ready to be listened to.
                        callback(element);
                    });
                }

                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
                if (style.position !== "") {
                    alterPositionStyles(style);
                    positionCheckPerformed = true;
                }

                //Add an object element as a child to the target element that will be listened to for resize events.
                var object = document.createElement("object");
                object.style.cssText = OBJECT_STYLE;
                object.tabIndex = -1;
                object.type = "text/html";
                object.setAttribute("aria-hidden", "true");
                object.onload = onObjectLoad;

                //Safari: This must occur before adding the object to the DOM.
                //IE: Does not like that this happens before, even if it is also added after.
                if(!browserDetector.isIE()) {
                    object.data = "about:blank";
                }

                if (!getState(element)) {
                    // The element has been uninstalled before the actual loading happened.
                    return;
                }

                element.appendChild(object);
                getState(element).object = object;

                //IE: This must occur after adding the object to the DOM.
                if(browserDetector.isIE()) {
                    object.data = "about:blank";
                }
            }

            if(batchProcessor) {
                batchProcessor.add(mutateDom);
            } else {
                mutateDom();
            }
        }

        if(browserDetector.isIE(8)) {
            //IE 8 does not support objects properly. Luckily they do support the resize event.
            //So do not inject the object and notify that the element is already ready to be listened to.
            //The event handler for the resize event is attached in the utils.addListener instead.
            callback(element);
        } else {
            injectObject(element, callback);
        }
    }

    /**
     * Returns the child object of the target element.
     * @private
     * @param {element} element The target element.
     * @returns The object element of the target.
     */
    function getObject(element) {
        return getState(element).object;
    }

    function uninstall(element) {
        if (!getState(element)) {
            return;
        }

        var object = getObject(element);

        if (!object) {
            return;
        }

        if (browserDetector.isIE(8)) {
            element.detachEvent("onresize", object.proxy);
        } else {
            element.removeChild(object);
        }

        if (getState(element).checkForObjectDocumentTimeoutId) {
            window.clearTimeout(getState(element).checkForObjectDocumentTimeoutId);
        }

        delete getState(element).object;
    }

    return {
        makeDetectable: makeDetectable,
        addListener: addListener,
        uninstall: uninstall
    };
};


/***/ }),

/***/ "Saiw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var detector = module.exports = {};

detector.isIE = function(version) {
    function isAnyIeVersion() {
        var agent = navigator.userAgent.toLowerCase();
        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
    }

    if(!isAnyIeVersion()) {
        return false;
    }

    if(!version) {
        return true;
    }

    //Shamelessly stolen from https://gist.github.com/padolsey/527683
    var ieVersion = (function(){
        var undef,
            v = 3,
            div = document.createElement("div"),
            all = div.getElementsByTagName("i");

        do {
            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
        }
        while (all[0]);

        return v > 4 ? v : undef;
    }());

    return version === ieVersion;
};

detector.isLegacyOpera = function() {
    return !!window.opera;
};


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "SldL":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "T9FJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__("Ml+6");

// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/fflate.module.js
var fflate_module = __webpack_require__("SCI+");

// CONCATENATED MODULE: ./node_modules/three/examples/jsm/curves/NURBSUtils.js


/**
 * NURBS utils
 *
 * See NURBSCurve and NURBSSurface.
 **/

/**************************************************************
 *	NURBS Utils
 **************************************************************/

/*
Finds knot vector span.

p : degree
u : parametric value
U : knot vector

returns the span
*/
function findSpan(p, u, U) {

	var n = U.length - p - 1;

	if (u >= U[n]) {

		return n - 1;
	}

	if (u <= U[p]) {

		return p;
	}

	var low = p;
	var high = n;
	var mid = Math.floor((low + high) / 2);

	while (u < U[mid] || u >= U[mid + 1]) {

		if (u < U[mid]) {

			high = mid;
		} else {

			low = mid;
		}

		mid = Math.floor((low + high) / 2);
	}

	return mid;
}

/*
Calculate basis functions. See The NURBS Book, page 70, algorithm A2.2

span : span in which u lies
u    : parametric point
p    : degree
U    : knot vector

returns array[p+1] with basis functions values.
*/
function calcBasisFunctions(span, u, p, U) {

	var N = [];
	var left = [];
	var right = [];
	N[0] = 1.0;

	for (var j = 1; j <= p; ++j) {

		left[j] = u - U[span + 1 - j];
		right[j] = U[span + j] - u;

		var saved = 0.0;

		for (var r = 0; r < j; ++r) {

			var rv = right[r + 1];
			var lv = left[j - r];
			var temp = N[r] / (rv + lv);
			N[r] = saved + rv * temp;
			saved = lv * temp;
		}

		N[j] = saved;
	}

	return N;
}

/*
Calculate B-Spline curve points. See The NURBS Book, page 82, algorithm A3.1.

p : degree of B-Spline
U : knot vector
P : control points (x, y, z, w)
u : parametric point

returns point for given u
*/
function calcBSplinePoint(p, U, P, u) {

	var span = findSpan(p, u, U);
	var N = calcBasisFunctions(span, u, p, U);
	var C = new three_module["_42" /* Vector4 */](0, 0, 0, 0);

	for (var j = 0; j <= p; ++j) {

		var point = P[span - p + j];
		var Nj = N[j];
		var wNj = point.w * Nj;
		C.x += point.x * wNj;
		C.y += point.y * wNj;
		C.z += point.z * wNj;
		C.w += point.w * Nj;
	}

	return C;
}

/*
Calculate basis functions derivatives. See The NURBS Book, page 72, algorithm A2.3.

span : span in which u lies
u    : parametric point
p    : degree
n    : number of derivatives to calculate
U    : knot vector

returns array[n+1][p+1] with basis functions derivatives
*/
function calcBasisFunctionDerivatives(span, u, p, n, U) {

	var zeroArr = [];
	for (var i = 0; i <= p; ++i) {
		zeroArr[i] = 0.0;
	}var ders = [];

	for (var _i = 0; _i <= n; ++_i) {
		ders[_i] = zeroArr.slice(0);
	}var ndu = [];

	for (var _i2 = 0; _i2 <= p; ++_i2) {
		ndu[_i2] = zeroArr.slice(0);
	}ndu[0][0] = 1.0;

	var left = zeroArr.slice(0);
	var right = zeroArr.slice(0);

	for (var j = 1; j <= p; ++j) {

		left[j] = u - U[span + 1 - j];
		right[j] = U[span + j] - u;

		var saved = 0.0;

		for (var _r = 0; _r < j; ++_r) {

			var rv = right[_r + 1];
			var lv = left[j - _r];
			ndu[j][_r] = rv + lv;

			var temp = ndu[_r][j - 1] / ndu[j][_r];
			ndu[_r][j] = saved + rv * temp;
			saved = lv * temp;
		}

		ndu[j][j] = saved;
	}

	for (var _j = 0; _j <= p; ++_j) {

		ders[0][_j] = ndu[_j][p];
	}

	for (var _r2 = 0; _r2 <= p; ++_r2) {

		var s1 = 0;
		var s2 = 1;

		var a = [];
		for (var _i3 = 0; _i3 <= p; ++_i3) {

			a[_i3] = zeroArr.slice(0);
		}

		a[0][0] = 1.0;

		for (var k = 1; k <= n; ++k) {

			var d = 0.0;
			var rk = _r2 - k;
			var pk = p - k;

			if (_r2 >= k) {

				a[s2][0] = a[s1][0] / ndu[pk + 1][rk];
				d = a[s2][0] * ndu[rk][pk];
			}

			var j1 = rk >= -1 ? 1 : -rk;
			var j2 = _r2 - 1 <= pk ? k - 1 : p - _r2;

			for (var _j3 = j1; _j3 <= j2; ++_j3) {

				a[s2][_j3] = (a[s1][_j3] - a[s1][_j3 - 1]) / ndu[pk + 1][rk + _j3];
				d += a[s2][_j3] * ndu[rk + _j3][pk];
			}

			if (_r2 <= pk) {

				a[s2][k] = -a[s1][k - 1] / ndu[pk + 1][_r2];
				d += a[s2][k] * ndu[_r2][pk];
			}

			ders[k][_r2] = d;

			var _j2 = s1;
			s1 = s2;
			s2 = _j2;
		}
	}

	var r = p;

	for (var _k = 1; _k <= n; ++_k) {

		for (var _j4 = 0; _j4 <= p; ++_j4) {

			ders[_k][_j4] *= r;
		}

		r *= p - _k;
	}

	return ders;
}

/*
	Calculate derivatives of a B-Spline. See The NURBS Book, page 93, algorithm A3.2.

	p  : degree
	U  : knot vector
	P  : control points
	u  : Parametric points
	nd : number of derivatives

	returns array[d+1] with derivatives
	*/
function calcBSplineDerivatives(p, U, P, u, nd) {

	var du = nd < p ? nd : p;
	var CK = [];
	var span = findSpan(p, u, U);
	var nders = calcBasisFunctionDerivatives(span, u, p, du, U);
	var Pw = [];

	for (var i = 0; i < P.length; ++i) {

		var point = P[i].clone();
		var w = point.w;

		point.x *= w;
		point.y *= w;
		point.z *= w;

		Pw[i] = point;
	}

	for (var k = 0; k <= du; ++k) {

		var _point = Pw[span - p].clone().multiplyScalar(nders[k][0]);

		for (var j = 1; j <= p; ++j) {

			_point.add(Pw[span - p + j].clone().multiplyScalar(nders[k][j]));
		}

		CK[k] = _point;
	}

	for (var _k2 = du + 1; _k2 <= nd + 1; ++_k2) {

		CK[_k2] = new three_module["_42" /* Vector4 */](0, 0, 0);
	}

	return CK;
}

/*
Calculate "K over I"

returns k!/(i!(k-i)!)
*/
function calcKoverI(k, i) {

	var nom = 1;

	for (var j = 2; j <= k; ++j) {

		nom *= j;
	}

	var denom = 1;

	for (var _j5 = 2; _j5 <= i; ++_j5) {

		denom *= _j5;
	}

	for (var _j6 = 2; _j6 <= k - i; ++_j6) {

		denom *= _j6;
	}

	return nom / denom;
}

/*
Calculate derivatives (0-nd) of rational curve. See The NURBS Book, page 127, algorithm A4.2.

Pders : result of function calcBSplineDerivatives

returns array with derivatives for rational curve.
*/
function calcRationalCurveDerivatives(Pders) {

	var nd = Pders.length;
	var Aders = [];
	var wders = [];

	for (var i = 0; i < nd; ++i) {

		var point = Pders[i];
		Aders[i] = new three_module["_41" /* Vector3 */](point.x, point.y, point.z);
		wders[i] = point.w;
	}

	var CK = [];

	for (var k = 0; k < nd; ++k) {

		var v = Aders[k].clone();

		for (var _i4 = 1; _i4 <= k; ++_i4) {

			v.sub(CK[k - _i4].clone().multiplyScalar(calcKoverI(k, _i4) * wders[_i4]));
		}

		CK[k] = v.divideScalar(wders[0]);
	}

	return CK;
}

/*
Calculate NURBS curve derivatives. See The NURBS Book, page 127, algorithm A4.2.

p  : degree
U  : knot vector
P  : control points in homogeneous space
u  : parametric points
nd : number of derivatives

returns array with derivatives.
*/
function calcNURBSDerivatives(p, U, P, u, nd) {

	var Pders = calcBSplineDerivatives(p, U, P, u, nd);
	return calcRationalCurveDerivatives(Pders);
}

/*
Calculate rational B-Spline surface point. See The NURBS Book, page 134, algorithm A4.3.

p1, p2 : degrees of B-Spline surface
U1, U2 : knot vectors
P      : control points (x, y, z, w)
u, v   : parametric values

returns point for given (u, v)
*/
function calcSurfacePoint(p, q, U, V, P, u, v, target) {

	var uspan = findSpan(p, u, U);
	var vspan = findSpan(q, v, V);
	var Nu = calcBasisFunctions(uspan, u, p, U);
	var Nv = calcBasisFunctions(vspan, v, q, V);
	var temp = [];

	for (var l = 0; l <= q; ++l) {

		temp[l] = new three_module["_42" /* Vector4 */](0, 0, 0, 0);
		for (var k = 0; k <= p; ++k) {

			var point = P[uspan - p + k][vspan - q + l].clone();
			var w = point.w;
			point.x *= w;
			point.y *= w;
			point.z *= w;
			temp[l].add(point.multiplyScalar(Nu[k]));
		}
	}

	var Sw = new three_module["_42" /* Vector4 */](0, 0, 0, 0);
	for (var _l = 0; _l <= q; ++_l) {

		Sw.add(temp[_l].multiplyScalar(Nv[_l]));
	}

	Sw.divideScalar(Sw.w);
	target.set(Sw.x, Sw.y, Sw.z);
}


// CONCATENATED MODULE: ./node_modules/three/examples/jsm/curves/NURBSCurve.js








/**
 * NURBS curve object
 *
 * Derives from Curve, overriding getPoint and getTangent.
 *
 * Implementation is based on (x, y [, z=0 [, w=1]]) control points with w=weight.
 *
 **/

var NURBSCurve_NURBSCurve = function (_Curve) {
	inherits_default()(NURBSCurve, _Curve);

	function NURBSCurve(degree, knots /* array of reals */
	, controlPoints /* array of Vector(2|3|4) */
	, startKnot /* index in knots */
	, endKnot /* index in knots */
	) {
		classCallCheck_default()(this, NURBSCurve);

		var _this = possibleConstructorReturn_default()(this, (NURBSCurve.__proto__ || get_prototype_of_default()(NURBSCurve)).call(this));

		_this.degree = degree;
		_this.knots = knots;
		_this.controlPoints = [];
		// Used by periodic NURBS to remove hidden spans
		_this.startKnot = startKnot || 0;
		_this.endKnot = endKnot || _this.knots.length - 1;

		for (var i = 0; i < controlPoints.length; ++i) {

			// ensure Vector4 for control points
			var point = controlPoints[i];
			_this.controlPoints[i] = new three_module["_42" /* Vector4 */](point.x, point.y, point.z, point.w);
		}

		return _this;
	}

	createClass_default()(NURBSCurve, [{
		key: 'getPoint',
		value: function getPoint(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new three_module["_41" /* Vector3 */]();


			var point = optionalTarget;

			var u = this.knots[this.startKnot] + t * (this.knots[this.endKnot] - this.knots[this.startKnot]); // linear mapping t->u

			// following results in (wx, wy, wz, w) homogeneous point
			var hpoint = calcBSplinePoint(this.degree, this.knots, this.controlPoints, u);

			if (hpoint.w !== 1.0) {

				// project to 3D space: (wx, wy, wz, w) -> (x, y, z, 1)
				hpoint.divideScalar(hpoint.w);
			}

			return point.set(hpoint.x, hpoint.y, hpoint.z);
		}
	}, {
		key: 'getTangent',
		value: function getTangent(t) {
			var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new three_module["_41" /* Vector3 */]();


			var tangent = optionalTarget;

			var u = this.knots[0] + t * (this.knots[this.knots.length - 1] - this.knots[0]);
			var ders = calcNURBSDerivatives(this.degree, this.knots, this.controlPoints, u, 1);
			tangent.copy(ders[1]).normalize();

			return tangent;
		}
	}]);

	return NURBSCurve;
}(three_module["p" /* Curve */]);


// CONCATENATED MODULE: ./node_modules/three/examples/jsm/loaders/FBXLoader.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FBXLoader_FBXLoader; });












/**
 * Loader loads FBX file and generates Group representing FBX scene.
 * Requires FBX file to be >= 7.0 and in ASCII or >= 6400 in Binary format
 * Versions lower than this may load but will probably have errors
 *
 * Needs Support:
 *  Morph normals / blend shape normals
 *
 * FBX format references:
 * 	https://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_index_html (C++ SDK reference)
 *
 * Binary format specification:
 *	https://code.blender.org/2013/08/fbx-binary-file-format-specification/
 */

var fbxTree = void 0;
var connections = void 0;
var sceneGraph = void 0;

var FBXLoader_FBXLoader = function (_Loader) {
	inherits_default()(FBXLoader, _Loader);

	function FBXLoader(manager) {
		classCallCheck_default()(this, FBXLoader);

		return possibleConstructorReturn_default()(this, (FBXLoader.__proto__ || get_prototype_of_default()(FBXLoader)).call(this, manager));
	}

	createClass_default()(FBXLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var path = scope.path === '' ? three_module["V" /* LoaderUtils */].extractUrlBase(url) : scope.path;

			var loader = new three_module["y" /* FileLoader */](this.manager);
			loader.setPath(scope.path);
			loader.setResponseType('arraybuffer');
			loader.setRequestHeader(scope.requestHeader);
			loader.setWithCredentials(scope.withCredentials);

			loader.load(url, function (buffer) {

				try {

					onLoad(scope.parse(buffer, path));
				} catch (e) {

					if (onError) {

						onError(e);
					} else {

						console.error(e);
					}

					scope.manager.itemError(url);
				}
			}, onProgress, onError);
		}
	}, {
		key: 'parse',
		value: function parse(FBXBuffer, path) {

			if (isFbxFormatBinary(FBXBuffer)) {

				fbxTree = new FBXLoader_BinaryParser().parse(FBXBuffer);
			} else {

				var FBXText = convertArrayBufferToString(FBXBuffer);

				if (!isFbxFormatASCII(FBXText)) {

					throw new Error('THREE.FBXLoader: Unknown format.');
				}

				if (getFbxVersion(FBXText) < 7000) {

					throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + getFbxVersion(FBXText));
				}

				fbxTree = new FBXLoader_TextParser().parse(FBXText);
			}

			// console.log( fbxTree );

			var textureLoader = new three_module["_35" /* TextureLoader */](this.manager).setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);

			return new FBXLoader_FBXTreeParser(textureLoader, this.manager).parse(fbxTree);
		}
	}]);

	return FBXLoader;
}(three_module["U" /* Loader */]);

// Parse the FBXTree object returned by the BinaryParser or TextParser and return a Group


var FBXLoader_FBXTreeParser = function () {
	function FBXTreeParser(textureLoader, manager) {
		classCallCheck_default()(this, FBXTreeParser);

		this.textureLoader = textureLoader;
		this.manager = manager;
	}

	createClass_default()(FBXTreeParser, [{
		key: 'parse',
		value: function parse() {

			connections = this.parseConnections();

			var images = this.parseImages();
			var textures = this.parseTextures(images);
			var materials = this.parseMaterials(textures);
			var deformers = this.parseDeformers();
			var geometryMap = new FBXLoader_GeometryParser().parse(deformers);

			this.parseScene(deformers, geometryMap, materials);

			return sceneGraph;
		}

		// Parses FBXTree.Connections which holds parent-child connections between objects (e.g. material -> texture, model->geometry )
		// and details the connection type

	}, {
		key: 'parseConnections',
		value: function parseConnections() {

			var connectionMap = new map_default.a();

			if ('Connections' in fbxTree) {

				var rawConnections = fbxTree.Connections.connections;

				rawConnections.forEach(function (rawConnection) {

					var fromID = rawConnection[0];
					var toID = rawConnection[1];
					var relationship = rawConnection[2];

					if (!connectionMap.has(fromID)) {

						connectionMap.set(fromID, {
							parents: [],
							children: []
						});
					}

					var parentRelationship = { ID: toID, relationship: relationship };
					connectionMap.get(fromID).parents.push(parentRelationship);

					if (!connectionMap.has(toID)) {

						connectionMap.set(toID, {
							parents: [],
							children: []
						});
					}

					var childRelationship = { ID: fromID, relationship: relationship };
					connectionMap.get(toID).children.push(childRelationship);
				});
			}

			return connectionMap;
		}

		// Parse FBXTree.Objects.Video for embedded image data
		// These images are connected to textures in FBXTree.Objects.Textures
		// via FBXTree.Connections.

	}, {
		key: 'parseImages',
		value: function parseImages() {

			var images = {};
			var blobs = {};

			if ('Video' in fbxTree.Objects) {

				var videoNodes = fbxTree.Objects.Video;

				for (var nodeID in videoNodes) {

					var videoNode = videoNodes[nodeID];

					var id = parseInt(nodeID);

					images[id] = videoNode.RelativeFilename || videoNode.Filename;

					// raw image data is in videoNode.Content
					if ('Content' in videoNode) {

						var arrayBufferContent = videoNode.Content instanceof ArrayBuffer && videoNode.Content.byteLength > 0;
						var base64Content = typeof videoNode.Content === 'string' && videoNode.Content !== '';

						if (arrayBufferContent || base64Content) {

							var image = this.parseImage(videoNodes[nodeID]);

							blobs[videoNode.RelativeFilename || videoNode.Filename] = image;
						}
					}
				}
			}

			for (var _id in images) {

				var filename = images[_id];

				if (blobs[filename] !== undefined) images[_id] = blobs[filename];else images[_id] = images[_id].split('\\').pop();
			}

			return images;
		}

		// Parse embedded image data in FBXTree.Video.Content

	}, {
		key: 'parseImage',
		value: function parseImage(videoNode) {

			var content = videoNode.Content;
			var fileName = videoNode.RelativeFilename || videoNode.Filename;
			var extension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();

			var type = void 0;

			switch (extension) {

				case 'bmp':

					type = 'image/bmp';
					break;

				case 'jpg':
				case 'jpeg':

					type = 'image/jpeg';
					break;

				case 'png':

					type = 'image/png';
					break;

				case 'tif':

					type = 'image/tiff';
					break;

				case 'tga':

					if (this.manager.getHandler('.tga') === null) {

						console.warn('FBXLoader: TGA loader not found, skipping ', fileName);
					}

					type = 'image/tga';
					break;

				default:

					console.warn('FBXLoader: Image type "' + extension + '" is not supported.');
					return;

			}

			if (typeof content === 'string') {
				// ASCII format

				return 'data:' + type + ';base64,' + content;
			} else {
				// Binary Format

				var array = new Uint8Array(content);
				return window.URL.createObjectURL(new Blob([array], { type: type }));
			}
		}

		// Parse nodes in FBXTree.Objects.Texture
		// These contain details such as UV scaling, cropping, rotation etc and are connected
		// to images in FBXTree.Objects.Video

	}, {
		key: 'parseTextures',
		value: function parseTextures(images) {

			var textureMap = new map_default.a();

			if ('Texture' in fbxTree.Objects) {

				var textureNodes = fbxTree.Objects.Texture;
				for (var nodeID in textureNodes) {

					var texture = this.parseTexture(textureNodes[nodeID], images);
					textureMap.set(parseInt(nodeID), texture);
				}
			}

			return textureMap;
		}

		// Parse individual node in FBXTree.Objects.Texture

	}, {
		key: 'parseTexture',
		value: function parseTexture(textureNode, images) {

			var texture = this.loadTexture(textureNode, images);

			texture.ID = textureNode.id;

			texture.name = textureNode.attrName;

			var wrapModeU = textureNode.WrapModeU;
			var wrapModeV = textureNode.WrapModeV;

			var valueU = wrapModeU !== undefined ? wrapModeU.value : 0;
			var valueV = wrapModeV !== undefined ? wrapModeV.value : 0;

			// http://download.autodesk.com/us/fbx/SDKdocs/FBX_SDK_Help/files/fbxsdkref/class_k_fbx_texture.html#889640e63e2e681259ea81061b85143a
			// 0: repeat(default), 1: clamp

			texture.wrapS = valueU === 0 ? three_module["_26" /* RepeatWrapping */] : three_module["m" /* ClampToEdgeWrapping */];
			texture.wrapT = valueV === 0 ? three_module["_26" /* RepeatWrapping */] : three_module["m" /* ClampToEdgeWrapping */];

			if ('Scaling' in textureNode) {

				var values = textureNode.Scaling.value;

				texture.repeat.x = values[0];
				texture.repeat.y = values[1];
			}

			if ('Translation' in textureNode) {

				var _values = textureNode.Translation.value;

				texture.offset.x = _values[0];
				texture.offset.y = _values[1];
			}

			return texture;
		}

		// load a texture specified as a blob or data URI, or via an external URL using TextureLoader

	}, {
		key: 'loadTexture',
		value: function loadTexture(textureNode, images) {

			var fileName = void 0;

			var currentPath = this.textureLoader.path;

			var children = connections.get(textureNode.id).children;

			if (children !== undefined && children.length > 0 && images[children[0].ID] !== undefined) {

				fileName = images[children[0].ID];

				if (fileName.indexOf('blob:') === 0 || fileName.indexOf('data:') === 0) {

					this.textureLoader.setPath(undefined);
				}
			}

			var texture = void 0;

			var extension = textureNode.FileName.slice(-3).toLowerCase();

			if (extension === 'tga') {

				var loader = this.manager.getHandler('.tga');

				if (loader === null) {

					console.warn('FBXLoader: TGA loader not found, creating placeholder texture for', textureNode.RelativeFilename);
					texture = new three_module["_34" /* Texture */]();
				} else {

					loader.setPath(this.textureLoader.path);
					texture = loader.load(fileName);
				}
			} else if (extension === 'psd') {

				console.warn('FBXLoader: PSD textures are not supported, creating placeholder texture for', textureNode.RelativeFilename);
				texture = new three_module["_34" /* Texture */]();
			} else {

				texture = this.textureLoader.load(fileName);
			}

			this.textureLoader.setPath(currentPath);

			return texture;
		}

		// Parse nodes in FBXTree.Objects.Material

	}, {
		key: 'parseMaterials',
		value: function parseMaterials(textureMap) {

			var materialMap = new map_default.a();

			if ('Material' in fbxTree.Objects) {

				var materialNodes = fbxTree.Objects.Material;

				for (var nodeID in materialNodes) {

					var material = this.parseMaterial(materialNodes[nodeID], textureMap);

					if (material !== null) materialMap.set(parseInt(nodeID), material);
				}
			}

			return materialMap;
		}

		// Parse single node in FBXTree.Objects.Material
		// Materials are connected to texture maps in FBXTree.Objects.Textures
		// FBX format currently only supports Lambert and Phong shading models

	}, {
		key: 'parseMaterial',
		value: function parseMaterial(materialNode, textureMap) {

			var ID = materialNode.id;
			var name = materialNode.attrName;
			var type = materialNode.ShadingModel;

			// Case where FBX wraps shading model in property object.
			if ((typeof type === 'undefined' ? 'undefined' : typeof_default()(type)) === 'object') {

				type = type.value;
			}

			// Ignore unused materials which don't have any connections.
			if (!connections.has(ID)) return null;

			var parameters = this.parseParameters(materialNode, textureMap, ID);

			var material = void 0;

			switch (type.toLowerCase()) {

				case 'phong':
					material = new three_module["_6" /* MeshPhongMaterial */]();
					break;
				case 'lambert':
					material = new three_module["_5" /* MeshLambertMaterial */]();
					break;
				default:
					console.warn('THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.', type);
					material = new three_module["_6" /* MeshPhongMaterial */]();
					break;

			}

			material.setValues(parameters);
			material.name = name;

			return material;
		}

		// Parse FBX material and return parameters suitable for a three.js material
		// Also parse the texture map and return any textures associated with the material

	}, {
		key: 'parseParameters',
		value: function parseParameters(materialNode, textureMap, ID) {

			var parameters = {};

			if (materialNode.BumpFactor) {

				parameters.bumpScale = materialNode.BumpFactor.value;
			}

			if (materialNode.Diffuse) {

				parameters.color = new three_module["o" /* Color */]().fromArray(materialNode.Diffuse.value).convertSRGBToLinear();
			} else if (materialNode.DiffuseColor && (materialNode.DiffuseColor.type === 'Color' || materialNode.DiffuseColor.type === 'ColorRGB')) {

				// The blender exporter exports diffuse here instead of in materialNode.Diffuse
				parameters.color = new three_module["o" /* Color */]().fromArray(materialNode.DiffuseColor.value).convertSRGBToLinear();
			}

			if (materialNode.DisplacementFactor) {

				parameters.displacementScale = materialNode.DisplacementFactor.value;
			}

			if (materialNode.Emissive) {

				parameters.emissive = new three_module["o" /* Color */]().fromArray(materialNode.Emissive.value).convertSRGBToLinear();
			} else if (materialNode.EmissiveColor && (materialNode.EmissiveColor.type === 'Color' || materialNode.EmissiveColor.type === 'ColorRGB')) {

				// The blender exporter exports emissive color here instead of in materialNode.Emissive
				parameters.emissive = new three_module["o" /* Color */]().fromArray(materialNode.EmissiveColor.value).convertSRGBToLinear();
			}

			if (materialNode.EmissiveFactor) {

				parameters.emissiveIntensity = parseFloat(materialNode.EmissiveFactor.value);
			}

			if (materialNode.Opacity) {

				parameters.opacity = parseFloat(materialNode.Opacity.value);
			}

			if (parameters.opacity < 1.0) {

				parameters.transparent = true;
			}

			if (materialNode.ReflectionFactor) {

				parameters.reflectivity = materialNode.ReflectionFactor.value;
			}

			if (materialNode.Shininess) {

				parameters.shininess = materialNode.Shininess.value;
			}

			if (materialNode.Specular) {

				parameters.specular = new three_module["o" /* Color */]().fromArray(materialNode.Specular.value).convertSRGBToLinear();
			} else if (materialNode.SpecularColor && materialNode.SpecularColor.type === 'Color') {

				// The blender exporter exports specular color here instead of in materialNode.Specular
				parameters.specular = new three_module["o" /* Color */]().fromArray(materialNode.SpecularColor.value).convertSRGBToLinear();
			}

			var scope = this;
			connections.get(ID).children.forEach(function (child) {

				var type = child.relationship;

				switch (type) {

					case 'Bump':
						parameters.bumpMap = scope.getTexture(textureMap, child.ID);
						break;

					case 'Maya|TEX_ao_map':
						parameters.aoMap = scope.getTexture(textureMap, child.ID);
						break;

					case 'DiffuseColor':
					case 'Maya|TEX_color_map':
						parameters.map = scope.getTexture(textureMap, child.ID);
						if (parameters.map !== undefined) {

							parameters.map.encoding = three_module["_45" /* sRGBEncoding */];
						}

						break;

					case 'DisplacementColor':
						parameters.displacementMap = scope.getTexture(textureMap, child.ID);
						break;

					case 'EmissiveColor':
						parameters.emissiveMap = scope.getTexture(textureMap, child.ID);
						if (parameters.emissiveMap !== undefined) {

							parameters.emissiveMap.encoding = three_module["_45" /* sRGBEncoding */];
						}

						break;

					case 'NormalMap':
					case 'Maya|TEX_normal_map':
						parameters.normalMap = scope.getTexture(textureMap, child.ID);
						break;

					case 'ReflectionColor':
						parameters.envMap = scope.getTexture(textureMap, child.ID);
						if (parameters.envMap !== undefined) {

							parameters.envMap.mapping = three_module["v" /* EquirectangularReflectionMapping */];
							parameters.envMap.encoding = three_module["_45" /* sRGBEncoding */];
						}

						break;

					case 'SpecularColor':
						parameters.specularMap = scope.getTexture(textureMap, child.ID);
						if (parameters.specularMap !== undefined) {

							parameters.specularMap.encoding = three_module["_45" /* sRGBEncoding */];
						}

						break;

					case 'TransparentColor':
					case 'TransparencyFactor':
						parameters.alphaMap = scope.getTexture(textureMap, child.ID);
						parameters.transparent = true;
						break;

					case 'AmbientColor':
					case 'ShininessExponent': // AKA glossiness map
					case 'SpecularFactor': // AKA specularLevel
					case 'VectorDisplacementColor': // NOTE: Seems to be a copy of DisplacementColor
					default:
						console.warn('THREE.FBXLoader: %s map is not supported in three.js, skipping texture.', type);
						break;

				}
			});

			return parameters;
		}

		// get a texture from the textureMap for use by a material.

	}, {
		key: 'getTexture',
		value: function getTexture(textureMap, id) {

			// if the texture is a layered texture, just use the first layer and issue a warning
			if ('LayeredTexture' in fbxTree.Objects && id in fbxTree.Objects.LayeredTexture) {

				console.warn('THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.');
				id = connections.get(id).children[0].ID;
			}

			return textureMap.get(id);
		}

		// Parse nodes in FBXTree.Objects.Deformer
		// Deformer node can contain skinning or Vertex Cache animation data, however only skinning is supported here
		// Generates map of Skeleton-like objects for use later when generating and binding skeletons.

	}, {
		key: 'parseDeformers',
		value: function parseDeformers() {

			var skeletons = {};
			var morphTargets = {};

			if ('Deformer' in fbxTree.Objects) {

				var DeformerNodes = fbxTree.Objects.Deformer;

				for (var nodeID in DeformerNodes) {

					var deformerNode = DeformerNodes[nodeID];

					var relationships = connections.get(parseInt(nodeID));

					if (deformerNode.attrType === 'Skin') {

						var skeleton = this.parseSkeleton(relationships, DeformerNodes);
						skeleton.ID = nodeID;

						if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: skeleton attached to more than one geometry is not supported.');
						skeleton.geometryID = relationships.parents[0].ID;

						skeletons[nodeID] = skeleton;
					} else if (deformerNode.attrType === 'BlendShape') {

						var morphTarget = {
							id: nodeID
						};

						morphTarget.rawTargets = this.parseMorphTargets(relationships, DeformerNodes);
						morphTarget.id = nodeID;

						if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: morph target attached to more than one geometry is not supported.');

						morphTargets[nodeID] = morphTarget;
					}
				}
			}

			return {

				skeletons: skeletons,
				morphTargets: morphTargets

			};
		}

		// Parse single nodes in FBXTree.Objects.Deformer
		// The top level skeleton node has type 'Skin' and sub nodes have type 'Cluster'
		// Each skin node represents a skeleton and each cluster node represents a bone

	}, {
		key: 'parseSkeleton',
		value: function parseSkeleton(relationships, deformerNodes) {

			var rawBones = [];

			relationships.children.forEach(function (child) {

				var boneNode = deformerNodes[child.ID];

				if (boneNode.attrType !== 'Cluster') return;

				var rawBone = {

					ID: child.ID,
					indices: [],
					weights: [],
					transformLink: new three_module["_2" /* Matrix4 */]().fromArray(boneNode.TransformLink.a)
					// transform: new Matrix4().fromArray( boneNode.Transform.a ),
					// linkMode: boneNode.Mode,

				};

				if ('Indexes' in boneNode) {

					rawBone.indices = boneNode.Indexes.a;
					rawBone.weights = boneNode.Weights.a;
				}

				rawBones.push(rawBone);
			});

			return {

				rawBones: rawBones,
				bones: []

			};
		}

		// The top level morph deformer node has type "BlendShape" and sub nodes have type "BlendShapeChannel"

	}, {
		key: 'parseMorphTargets',
		value: function parseMorphTargets(relationships, deformerNodes) {

			var rawMorphTargets = [];

			for (var i = 0; i < relationships.children.length; i++) {

				var child = relationships.children[i];

				var morphTargetNode = deformerNodes[child.ID];

				var rawMorphTarget = {

					name: morphTargetNode.attrName,
					initialWeight: morphTargetNode.DeformPercent,
					id: morphTargetNode.id,
					fullWeights: morphTargetNode.FullWeights.a

				};

				if (morphTargetNode.attrType !== 'BlendShapeChannel') return;

				rawMorphTarget.geoID = connections.get(parseInt(child.ID)).children.filter(function (child) {

					return child.relationship === undefined;
				})[0].ID;

				rawMorphTargets.push(rawMorphTarget);
			}

			return rawMorphTargets;
		}

		// create the main Group() to be returned by the loader

	}, {
		key: 'parseScene',
		value: function parseScene(deformers, geometryMap, materialMap) {

			sceneGraph = new three_module["C" /* Group */]();

			var modelMap = this.parseModels(deformers.skeletons, geometryMap, materialMap);

			var modelNodes = fbxTree.Objects.Model;

			var scope = this;
			modelMap.forEach(function (model) {

				var modelNode = modelNodes[model.ID];
				scope.setLookAtProperties(model, modelNode);

				var parentConnections = connections.get(model.ID).parents;

				parentConnections.forEach(function (connection) {

					var parent = modelMap.get(connection.ID);
					if (parent !== undefined) parent.add(model);
				});

				if (model.parent === null) {

					sceneGraph.add(model);
				}
			});

			this.bindSkeleton(deformers.skeletons, geometryMap, modelMap);

			this.createAmbientLight();

			sceneGraph.traverse(function (node) {

				if (node.userData.transformData) {

					if (node.parent) {

						node.userData.transformData.parentMatrix = node.parent.matrix;
						node.userData.transformData.parentMatrixWorld = node.parent.matrixWorld;
					}

					var transform = generateTransform(node.userData.transformData);

					node.applyMatrix4(transform);
					node.updateWorldMatrix();
				}
			});

			var animations = new FBXLoader_AnimationParser().parse();

			// if all the models where already combined in a single group, just return that
			if (sceneGraph.children.length === 1 && sceneGraph.children[0].isGroup) {

				sceneGraph.children[0].animations = animations;
				sceneGraph = sceneGraph.children[0];
			}

			sceneGraph.animations = animations;
		}

		// parse nodes in FBXTree.Objects.Model

	}, {
		key: 'parseModels',
		value: function parseModels(skeletons, geometryMap, materialMap) {

			var modelMap = new map_default.a();
			var modelNodes = fbxTree.Objects.Model;

			for (var nodeID in modelNodes) {

				var id = parseInt(nodeID);
				var node = modelNodes[nodeID];
				var relationships = connections.get(id);

				var model = this.buildSkeleton(relationships, skeletons, id, node.attrName);

				if (!model) {

					switch (node.attrType) {

						case 'Camera':
							model = this.createCamera(relationships);
							break;
						case 'Light':
							model = this.createLight(relationships);
							break;
						case 'Mesh':
							model = this.createMesh(relationships, geometryMap, materialMap);
							break;
						case 'NurbsCurve':
							model = this.createCurve(relationships, geometryMap);
							break;
						case 'LimbNode':
						case 'Root':
							model = new three_module["g" /* Bone */]();
							break;
						case 'Null':
						default:
							model = new three_module["C" /* Group */]();
							break;

					}

					model.name = node.attrName ? three_module["_21" /* PropertyBinding */].sanitizeNodeName(node.attrName) : '';

					model.ID = id;
				}

				this.getTransformData(model, node);
				modelMap.set(id, model);
			}

			return modelMap;
		}
	}, {
		key: 'buildSkeleton',
		value: function buildSkeleton(relationships, skeletons, id, name) {

			var bone = null;

			relationships.parents.forEach(function (parent) {
				var _loop = function _loop(ID) {

					var skeleton = skeletons[ID];

					skeleton.rawBones.forEach(function (rawBone, i) {

						if (rawBone.ID === parent.ID) {

							var subBone = bone;
							bone = new three_module["g" /* Bone */]();

							bone.matrixWorld.copy(rawBone.transformLink);

							// set name and id here - otherwise in cases where "subBone" is created it will not have a name / id

							bone.name = name ? three_module["_21" /* PropertyBinding */].sanitizeNodeName(name) : '';
							bone.ID = id;

							skeleton.bones[i] = bone;

							// In cases where a bone is shared between multiple meshes
							// duplicate the bone here and and it as a child of the first bone
							if (subBone !== null) {

								bone.add(subBone);
							}
						}
					});
				};

				for (var ID in skeletons) {
					_loop(ID);
				}
			});

			return bone;
		}

		// create a PerspectiveCamera or OrthographicCamera

	}, {
		key: 'createCamera',
		value: function createCamera(relationships) {

			var model = void 0;
			var cameraAttribute = void 0;

			relationships.children.forEach(function (child) {

				var attr = fbxTree.Objects.NodeAttribute[child.ID];

				if (attr !== undefined) {

					cameraAttribute = attr;
				}
			});

			if (cameraAttribute === undefined) {

				model = new three_module["_14" /* Object3D */]();
			} else {

				var type = 0;
				if (cameraAttribute.CameraProjectionType !== undefined && cameraAttribute.CameraProjectionType.value === 1) {

					type = 1;
				}

				var nearClippingPlane = 1;
				if (cameraAttribute.NearPlane !== undefined) {

					nearClippingPlane = cameraAttribute.NearPlane.value / 1000;
				}

				var farClippingPlane = 1000;
				if (cameraAttribute.FarPlane !== undefined) {

					farClippingPlane = cameraAttribute.FarPlane.value / 1000;
				}

				var width = window.innerWidth;
				var height = window.innerHeight;

				if (cameraAttribute.AspectWidth !== undefined && cameraAttribute.AspectHeight !== undefined) {

					width = cameraAttribute.AspectWidth.value;
					height = cameraAttribute.AspectHeight.value;
				}

				var aspect = width / height;

				var fov = 45;
				if (cameraAttribute.FieldOfView !== undefined) {

					fov = cameraAttribute.FieldOfView.value;
				}

				var focalLength = cameraAttribute.FocalLength ? cameraAttribute.FocalLength.value : null;

				switch (type) {

					case 0:
						// Perspective
						model = new three_module["_17" /* PerspectiveCamera */](fov, aspect, nearClippingPlane, farClippingPlane);
						if (focalLength !== null) model.setFocalLength(focalLength);
						break;

					case 1:
						// Orthographic
						model = new three_module["_15" /* OrthographicCamera */](-width / 2, width / 2, height / 2, -height / 2, nearClippingPlane, farClippingPlane);
						break;

					default:
						console.warn('THREE.FBXLoader: Unknown camera type ' + type + '.');
						model = new three_module["_14" /* Object3D */]();
						break;

				}
			}

			return model;
		}

		// Create a DirectionalLight, PointLight or SpotLight

	}, {
		key: 'createLight',
		value: function createLight(relationships) {

			var model = void 0;
			var lightAttribute = void 0;

			relationships.children.forEach(function (child) {

				var attr = fbxTree.Objects.NodeAttribute[child.ID];

				if (attr !== undefined) {

					lightAttribute = attr;
				}
			});

			if (lightAttribute === undefined) {

				model = new three_module["_14" /* Object3D */]();
			} else {

				var type = void 0;

				// LightType can be undefined for Point lights
				if (lightAttribute.LightType === undefined) {

					type = 0;
				} else {

					type = lightAttribute.LightType.value;
				}

				var color = 0xffffff;

				if (lightAttribute.Color !== undefined) {

					color = new three_module["o" /* Color */]().fromArray(lightAttribute.Color.value).convertSRGBToLinear();
				}

				var intensity = lightAttribute.Intensity === undefined ? 1 : lightAttribute.Intensity.value / 100;

				// light disabled
				if (lightAttribute.CastLightOnObject !== undefined && lightAttribute.CastLightOnObject.value === 0) {

					intensity = 0;
				}

				var distance = 0;
				if (lightAttribute.FarAttenuationEnd !== undefined) {

					if (lightAttribute.EnableFarAttenuation !== undefined && lightAttribute.EnableFarAttenuation.value === 0) {

						distance = 0;
					} else {

						distance = lightAttribute.FarAttenuationEnd.value;
					}
				}

				// TODO: could this be calculated linearly from FarAttenuationStart to FarAttenuationEnd?
				var decay = 1;

				switch (type) {

					case 0:
						// Point
						model = new three_module["_18" /* PointLight */](color, intensity, distance, decay);
						break;

					case 1:
						// Directional
						model = new three_module["s" /* DirectionalLight */](color, intensity);
						break;

					case 2:
						// Spot
						var angle = Math.PI / 3;

						if (lightAttribute.InnerAngle !== undefined) {

							angle = three_module["_0" /* MathUtils */].degToRad(lightAttribute.InnerAngle.value);
						}

						var penumbra = 0;
						if (lightAttribute.OuterAngle !== undefined) {

							// TODO: this is not correct - FBX calculates outer and inner angle in degrees
							// with OuterAngle > InnerAngle && OuterAngle <= Math.PI
							// while three.js uses a penumbra between (0, 1) to attenuate the inner angle
							penumbra = three_module["_0" /* MathUtils */].degToRad(lightAttribute.OuterAngle.value);
							penumbra = Math.max(penumbra, 1);
						}

						model = new three_module["_32" /* SpotLight */](color, intensity, distance, angle, penumbra, decay);
						break;

					default:
						console.warn('THREE.FBXLoader: Unknown light type ' + lightAttribute.LightType.value + ', defaulting to a PointLight.');
						model = new three_module["_18" /* PointLight */](color, intensity);
						break;

				}

				if (lightAttribute.CastShadows !== undefined && lightAttribute.CastShadows.value === 1) {

					model.castShadow = true;
				}
			}

			return model;
		}
	}, {
		key: 'createMesh',
		value: function createMesh(relationships, geometryMap, materialMap) {

			var model = void 0;
			var geometry = null;
			var material = null;
			var materials = [];

			// get geometry and materials(s) from connections
			relationships.children.forEach(function (child) {

				if (geometryMap.has(child.ID)) {

					geometry = geometryMap.get(child.ID);
				}

				if (materialMap.has(child.ID)) {

					materials.push(materialMap.get(child.ID));
				}
			});

			if (materials.length > 1) {

				material = materials;
			} else if (materials.length > 0) {

				material = materials[0];
			} else {

				material = new three_module["_6" /* MeshPhongMaterial */]({ color: 0xcccccc });
				materials.push(material);
			}

			if ('color' in geometry.attributes) {

				materials.forEach(function (material) {

					material.vertexColors = true;
				});
			}

			if (geometry.FBX_Deformer) {

				model = new three_module["_29" /* SkinnedMesh */](geometry, material);
				model.normalizeSkinWeights();
			} else {

				model = new three_module["_3" /* Mesh */](geometry, material);
			}

			return model;
		}
	}, {
		key: 'createCurve',
		value: function createCurve(relationships, geometryMap) {

			var geometry = relationships.children.reduce(function (geo, child) {

				if (geometryMap.has(child.ID)) geo = geometryMap.get(child.ID);

				return geo;
			}, null);

			// FBX does not list materials for Nurbs lines, so we'll just put our own in here.
			var material = new three_module["N" /* LineBasicMaterial */]({ color: 0x3300ff, linewidth: 1 });
			return new three_module["M" /* Line */](geometry, material);
		}

		// parse the model node for transform data

	}, {
		key: 'getTransformData',
		value: function getTransformData(model, modelNode) {

			var transformData = {};

			if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);

			if ('RotationOrder' in modelNode) transformData.eulerOrder = getEulerOrder(modelNode.RotationOrder.value);else transformData.eulerOrder = 'ZYX';

			if ('Lcl_Translation' in modelNode) transformData.translation = modelNode.Lcl_Translation.value;

			if ('PreRotation' in modelNode) transformData.preRotation = modelNode.PreRotation.value;
			if ('Lcl_Rotation' in modelNode) transformData.rotation = modelNode.Lcl_Rotation.value;
			if ('PostRotation' in modelNode) transformData.postRotation = modelNode.PostRotation.value;

			if ('Lcl_Scaling' in modelNode) transformData.scale = modelNode.Lcl_Scaling.value;

			if ('ScalingOffset' in modelNode) transformData.scalingOffset = modelNode.ScalingOffset.value;
			if ('ScalingPivot' in modelNode) transformData.scalingPivot = modelNode.ScalingPivot.value;

			if ('RotationOffset' in modelNode) transformData.rotationOffset = modelNode.RotationOffset.value;
			if ('RotationPivot' in modelNode) transformData.rotationPivot = modelNode.RotationPivot.value;

			model.userData.transformData = transformData;
		}
	}, {
		key: 'setLookAtProperties',
		value: function setLookAtProperties(model, modelNode) {

			if ('LookAtProperty' in modelNode) {

				var children = connections.get(model.ID).children;

				children.forEach(function (child) {

					if (child.relationship === 'LookAtProperty') {

						var lookAtTarget = fbxTree.Objects.Model[child.ID];

						if ('Lcl_Translation' in lookAtTarget) {

							var pos = lookAtTarget.Lcl_Translation.value;

							// DirectionalLight, SpotLight
							if (model.target !== undefined) {

								model.target.position.fromArray(pos);
								sceneGraph.add(model.target);
							} else {
								// Cameras and other Object3Ds

								model.lookAt(new three_module["_41" /* Vector3 */]().fromArray(pos));
							}
						}
					}
				});
			}
		}
	}, {
		key: 'bindSkeleton',
		value: function bindSkeleton(skeletons, geometryMap, modelMap) {

			var bindMatrices = this.parsePoseNodes();

			var _loop2 = function _loop2(ID) {

				var skeleton = skeletons[ID];

				var parents = connections.get(parseInt(skeleton.ID)).parents;

				parents.forEach(function (parent) {

					if (geometryMap.has(parent.ID)) {

						var geoID = parent.ID;
						var geoRelationships = connections.get(geoID);

						geoRelationships.parents.forEach(function (geoConnParent) {

							if (modelMap.has(geoConnParent.ID)) {

								var model = modelMap.get(geoConnParent.ID);

								model.bind(new three_module["_28" /* Skeleton */](skeleton.bones), bindMatrices[geoConnParent.ID]);
							}
						});
					}
				});
			};

			for (var ID in skeletons) {
				_loop2(ID);
			}
		}
	}, {
		key: 'parsePoseNodes',
		value: function parsePoseNodes() {

			var bindMatrices = {};

			if ('Pose' in fbxTree.Objects) {

				var BindPoseNode = fbxTree.Objects.Pose;

				for (var nodeID in BindPoseNode) {

					if (BindPoseNode[nodeID].attrType === 'BindPose' && BindPoseNode[nodeID].NbPoseNodes > 0) {

						var poseNodes = BindPoseNode[nodeID].PoseNode;

						if (Array.isArray(poseNodes)) {

							poseNodes.forEach(function (poseNode) {

								bindMatrices[poseNode.Node] = new three_module["_2" /* Matrix4 */]().fromArray(poseNode.Matrix.a);
							});
						} else {

							bindMatrices[poseNodes.Node] = new three_module["_2" /* Matrix4 */]().fromArray(poseNodes.Matrix.a);
						}
					}
				}
			}

			return bindMatrices;
		}

		// Parse ambient color in FBXTree.GlobalSettings - if it's not set to black (default), create an ambient light

	}, {
		key: 'createAmbientLight',
		value: function createAmbientLight() {

			if ('GlobalSettings' in fbxTree && 'AmbientColor' in fbxTree.GlobalSettings) {

				var ambientColor = fbxTree.GlobalSettings.AmbientColor.value;
				var r = ambientColor[0];
				var g = ambientColor[1];
				var b = ambientColor[2];

				if (r !== 0 || g !== 0 || b !== 0) {

					var color = new three_module["o" /* Color */](r, g, b).convertSRGBToLinear();
					sceneGraph.add(new three_module["a" /* AmbientLight */](color, 1));
				}
			}
		}
	}]);

	return FBXTreeParser;
}();

// parse Geometry data from FBXTree and return map of BufferGeometries


var FBXLoader_GeometryParser = function () {
	function GeometryParser() {
		classCallCheck_default()(this, GeometryParser);

		this.negativeMaterialIndices = false;
	}

	// Parse nodes in FBXTree.Objects.Geometry


	createClass_default()(GeometryParser, [{
		key: 'parse',
		value: function parse(deformers) {

			var geometryMap = new map_default.a();

			if ('Geometry' in fbxTree.Objects) {

				var geoNodes = fbxTree.Objects.Geometry;

				for (var nodeID in geoNodes) {

					var relationships = connections.get(parseInt(nodeID));
					var geo = this.parseGeometry(relationships, geoNodes[nodeID], deformers);

					geometryMap.set(parseInt(nodeID), geo);
				}
			}

			// report warnings

			if (this.negativeMaterialIndices === true) {

				console.warn('THREE.FBXLoader: The FBX file contains invalid (negative) material indices. The asset might not render as expected.');
			}

			return geometryMap;
		}

		// Parse single node in FBXTree.Objects.Geometry

	}, {
		key: 'parseGeometry',
		value: function parseGeometry(relationships, geoNode, deformers) {

			switch (geoNode.attrType) {

				case 'Mesh':
					return this.parseMeshGeometry(relationships, geoNode, deformers);
					break;

				case 'NurbsCurve':
					return this.parseNurbsGeometry(geoNode);
					break;

			}
		}

		// Parse single node mesh geometry in FBXTree.Objects.Geometry

	}, {
		key: 'parseMeshGeometry',
		value: function parseMeshGeometry(relationships, geoNode, deformers) {

			var skeletons = deformers.skeletons;
			var morphTargets = [];

			var modelNodes = relationships.parents.map(function (parent) {

				return fbxTree.Objects.Model[parent.ID];
			});

			// don't create geometry if it is not associated with any models
			if (modelNodes.length === 0) return;

			var skeleton = relationships.children.reduce(function (skeleton, child) {

				if (skeletons[child.ID] !== undefined) skeleton = skeletons[child.ID];

				return skeleton;
			}, null);

			relationships.children.forEach(function (child) {

				if (deformers.morphTargets[child.ID] !== undefined) {

					morphTargets.push(deformers.morphTargets[child.ID]);
				}
			});

			// Assume one model and get the preRotation from that
			// if there is more than one model associated with the geometry this may cause problems
			var modelNode = modelNodes[0];

			var transformData = {};

			if ('RotationOrder' in modelNode) transformData.eulerOrder = getEulerOrder(modelNode.RotationOrder.value);
			if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);

			if ('GeometricTranslation' in modelNode) transformData.translation = modelNode.GeometricTranslation.value;
			if ('GeometricRotation' in modelNode) transformData.rotation = modelNode.GeometricRotation.value;
			if ('GeometricScaling' in modelNode) transformData.scale = modelNode.GeometricScaling.value;

			var transform = generateTransform(transformData);

			return this.genGeometry(geoNode, skeleton, morphTargets, transform);
		}

		// Generate a BufferGeometry from a node in FBXTree.Objects.Geometry

	}, {
		key: 'genGeometry',
		value: function genGeometry(geoNode, skeleton, morphTargets, preTransform) {

			var geo = new three_module["k" /* BufferGeometry */]();
			if (geoNode.attrName) geo.name = geoNode.attrName;

			var geoInfo = this.parseGeoNode(geoNode, skeleton);
			var buffers = this.genBuffers(geoInfo);

			var positionAttribute = new three_module["z" /* Float32BufferAttribute */](buffers.vertex, 3);

			positionAttribute.applyMatrix4(preTransform);

			geo.setAttribute('position', positionAttribute);

			if (buffers.colors.length > 0) {

				geo.setAttribute('color', new three_module["z" /* Float32BufferAttribute */](buffers.colors, 3));
			}

			if (skeleton) {

				geo.setAttribute('skinIndex', new three_module["_39" /* Uint16BufferAttribute */](buffers.weightsIndices, 4));

				geo.setAttribute('skinWeight', new three_module["z" /* Float32BufferAttribute */](buffers.vertexWeights, 4));

				// used later to bind the skeleton to the model
				geo.FBX_Deformer = skeleton;
			}

			if (buffers.normal.length > 0) {

				var normalMatrix = new three_module["_1" /* Matrix3 */]().getNormalMatrix(preTransform);

				var normalAttribute = new three_module["z" /* Float32BufferAttribute */](buffers.normal, 3);
				normalAttribute.applyNormalMatrix(normalMatrix);

				geo.setAttribute('normal', normalAttribute);
			}

			buffers.uvs.forEach(function (uvBuffer, i) {

				// subsequent uv buffers are called 'uv1', 'uv2', ...
				var name = 'uv' + (i + 1).toString();

				// the first uv buffer is just called 'uv'
				if (i === 0) {

					name = 'uv';
				}

				geo.setAttribute(name, new three_module["z" /* Float32BufferAttribute */](buffers.uvs[i], 2));
			});

			if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {

				// Convert the material indices of each vertex into rendering groups on the geometry.
				var prevMaterialIndex = buffers.materialIndex[0];
				var startIndex = 0;

				buffers.materialIndex.forEach(function (currentIndex, i) {

					if (currentIndex !== prevMaterialIndex) {

						geo.addGroup(startIndex, i - startIndex, prevMaterialIndex);

						prevMaterialIndex = currentIndex;
						startIndex = i;
					}
				});

				// the loop above doesn't add the last group, do that here.
				if (geo.groups.length > 0) {

					var lastGroup = geo.groups[geo.groups.length - 1];
					var lastIndex = lastGroup.start + lastGroup.count;

					if (lastIndex !== buffers.materialIndex.length) {

						geo.addGroup(lastIndex, buffers.materialIndex.length - lastIndex, prevMaterialIndex);
					}
				}

				// case where there are multiple materials but the whole geometry is only
				// using one of them
				if (geo.groups.length === 0) {

					geo.addGroup(0, buffers.materialIndex.length, buffers.materialIndex[0]);
				}
			}

			this.addMorphTargets(geo, geoNode, morphTargets, preTransform);

			return geo;
		}
	}, {
		key: 'parseGeoNode',
		value: function parseGeoNode(geoNode, skeleton) {

			var geoInfo = {};

			geoInfo.vertexPositions = geoNode.Vertices !== undefined ? geoNode.Vertices.a : [];
			geoInfo.vertexIndices = geoNode.PolygonVertexIndex !== undefined ? geoNode.PolygonVertexIndex.a : [];

			if (geoNode.LayerElementColor) {

				geoInfo.color = this.parseVertexColors(geoNode.LayerElementColor[0]);
			}

			if (geoNode.LayerElementMaterial) {

				geoInfo.material = this.parseMaterialIndices(geoNode.LayerElementMaterial[0]);
			}

			if (geoNode.LayerElementNormal) {

				geoInfo.normal = this.parseNormals(geoNode.LayerElementNormal[0]);
			}

			if (geoNode.LayerElementUV) {

				geoInfo.uv = [];

				var i = 0;
				while (geoNode.LayerElementUV[i]) {

					if (geoNode.LayerElementUV[i].UV) {

						geoInfo.uv.push(this.parseUVs(geoNode.LayerElementUV[i]));
					}

					i++;
				}
			}

			geoInfo.weightTable = {};

			if (skeleton !== null) {

				geoInfo.skeleton = skeleton;

				skeleton.rawBones.forEach(function (rawBone, i) {

					// loop over the bone's vertex indices and weights
					rawBone.indices.forEach(function (index, j) {

						if (geoInfo.weightTable[index] === undefined) geoInfo.weightTable[index] = [];

						geoInfo.weightTable[index].push({

							id: i,
							weight: rawBone.weights[j]

						});
					});
				});
			}

			return geoInfo;
		}
	}, {
		key: 'genBuffers',
		value: function genBuffers(geoInfo) {

			var buffers = {
				vertex: [],
				normal: [],
				colors: [],
				uvs: [],
				materialIndex: [],
				vertexWeights: [],
				weightsIndices: []
			};

			var polygonIndex = 0;
			var faceLength = 0;
			var displayedWeightsWarning = false;

			// these will hold data for a single face
			var facePositionIndexes = [];
			var faceNormals = [];
			var faceColors = [];
			var faceUVs = [];
			var faceWeights = [];
			var faceWeightIndices = [];

			var scope = this;
			geoInfo.vertexIndices.forEach(function (vertexIndex, polygonVertexIndex) {

				var materialIndex = void 0;
				var endOfFace = false;

				// Face index and vertex index arrays are combined in a single array
				// A cube with quad faces looks like this:
				// PolygonVertexIndex: *24 {
				//  a: 0, 1, 3, -3, 2, 3, 5, -5, 4, 5, 7, -7, 6, 7, 1, -1, 1, 7, 5, -4, 6, 0, 2, -5
				//  }
				// Negative numbers mark the end of a face - first face here is 0, 1, 3, -3
				// to find index of last vertex bit shift the index: ^ - 1
				if (vertexIndex < 0) {

					vertexIndex = vertexIndex ^ -1; // equivalent to ( x * -1 ) - 1
					endOfFace = true;
				}

				var weightIndices = [];
				var weights = [];

				facePositionIndexes.push(vertexIndex * 3, vertexIndex * 3 + 1, vertexIndex * 3 + 2);

				if (geoInfo.color) {

					var data = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.color);

					faceColors.push(data[0], data[1], data[2]);
				}

				if (geoInfo.skeleton) {

					if (geoInfo.weightTable[vertexIndex] !== undefined) {

						geoInfo.weightTable[vertexIndex].forEach(function (wt) {

							weights.push(wt.weight);
							weightIndices.push(wt.id);
						});
					}

					if (weights.length > 4) {

						if (!displayedWeightsWarning) {

							console.warn('THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.');
							displayedWeightsWarning = true;
						}

						var wIndex = [0, 0, 0, 0];
						var Weight = [0, 0, 0, 0];

						weights.forEach(function (weight, weightIndex) {

							var currentWeight = weight;
							var currentIndex = weightIndices[weightIndex];

							Weight.forEach(function (comparedWeight, comparedWeightIndex, comparedWeightArray) {

								if (currentWeight > comparedWeight) {

									comparedWeightArray[comparedWeightIndex] = currentWeight;
									currentWeight = comparedWeight;

									var tmp = wIndex[comparedWeightIndex];
									wIndex[comparedWeightIndex] = currentIndex;
									currentIndex = tmp;
								}
							});
						});

						weightIndices = wIndex;
						weights = Weight;
					}

					// if the weight array is shorter than 4 pad with 0s
					while (weights.length < 4) {

						weights.push(0);
						weightIndices.push(0);
					}

					for (var i = 0; i < 4; ++i) {

						faceWeights.push(weights[i]);
						faceWeightIndices.push(weightIndices[i]);
					}
				}

				if (geoInfo.normal) {

					var _data = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.normal);

					faceNormals.push(_data[0], _data[1], _data[2]);
				}

				if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {

					materialIndex = getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.material)[0];

					if (materialIndex < 0) {

						scope.negativeMaterialIndices = true;
						materialIndex = 0; // fallback
					}
				}

				if (geoInfo.uv) {

					geoInfo.uv.forEach(function (uv, i) {

						var data = getData(polygonVertexIndex, polygonIndex, vertexIndex, uv);

						if (faceUVs[i] === undefined) {

							faceUVs[i] = [];
						}

						faceUVs[i].push(data[0]);
						faceUVs[i].push(data[1]);
					});
				}

				faceLength++;

				if (endOfFace) {

					if (faceLength > 4) console.warn('THREE.FBXLoader: Polygons with more than four sides are not supported. Make sure to triangulate the geometry during export.');

					scope.genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength);

					polygonIndex++;
					faceLength = 0;

					// reset arrays for the next face
					facePositionIndexes = [];
					faceNormals = [];
					faceColors = [];
					faceUVs = [];
					faceWeights = [];
					faceWeightIndices = [];
				}
			});

			return buffers;
		}

		// Generate data for a single face in a geometry. If the face is a quad then split it into 2 tris

	}, {
		key: 'genFace',
		value: function genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength) {
			var _loop3 = function _loop3(i) {

				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[0]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[1]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[2]]);

				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3 + 1]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3 + 2]]);

				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3 + 1]]);
				buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3 + 2]]);

				if (geoInfo.skeleton) {

					buffers.vertexWeights.push(faceWeights[0]);
					buffers.vertexWeights.push(faceWeights[1]);
					buffers.vertexWeights.push(faceWeights[2]);
					buffers.vertexWeights.push(faceWeights[3]);

					buffers.vertexWeights.push(faceWeights[(i - 1) * 4]);
					buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 1]);
					buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 2]);
					buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 3]);

					buffers.vertexWeights.push(faceWeights[i * 4]);
					buffers.vertexWeights.push(faceWeights[i * 4 + 1]);
					buffers.vertexWeights.push(faceWeights[i * 4 + 2]);
					buffers.vertexWeights.push(faceWeights[i * 4 + 3]);

					buffers.weightsIndices.push(faceWeightIndices[0]);
					buffers.weightsIndices.push(faceWeightIndices[1]);
					buffers.weightsIndices.push(faceWeightIndices[2]);
					buffers.weightsIndices.push(faceWeightIndices[3]);

					buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4]);
					buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 1]);
					buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 2]);
					buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 3]);

					buffers.weightsIndices.push(faceWeightIndices[i * 4]);
					buffers.weightsIndices.push(faceWeightIndices[i * 4 + 1]);
					buffers.weightsIndices.push(faceWeightIndices[i * 4 + 2]);
					buffers.weightsIndices.push(faceWeightIndices[i * 4 + 3]);
				}

				if (geoInfo.color) {

					buffers.colors.push(faceColors[0]);
					buffers.colors.push(faceColors[1]);
					buffers.colors.push(faceColors[2]);

					buffers.colors.push(faceColors[(i - 1) * 3]);
					buffers.colors.push(faceColors[(i - 1) * 3 + 1]);
					buffers.colors.push(faceColors[(i - 1) * 3 + 2]);

					buffers.colors.push(faceColors[i * 3]);
					buffers.colors.push(faceColors[i * 3 + 1]);
					buffers.colors.push(faceColors[i * 3 + 2]);
				}

				if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {

					buffers.materialIndex.push(materialIndex);
					buffers.materialIndex.push(materialIndex);
					buffers.materialIndex.push(materialIndex);
				}

				if (geoInfo.normal) {

					buffers.normal.push(faceNormals[0]);
					buffers.normal.push(faceNormals[1]);
					buffers.normal.push(faceNormals[2]);

					buffers.normal.push(faceNormals[(i - 1) * 3]);
					buffers.normal.push(faceNormals[(i - 1) * 3 + 1]);
					buffers.normal.push(faceNormals[(i - 1) * 3 + 2]);

					buffers.normal.push(faceNormals[i * 3]);
					buffers.normal.push(faceNormals[i * 3 + 1]);
					buffers.normal.push(faceNormals[i * 3 + 2]);
				}

				if (geoInfo.uv) {

					geoInfo.uv.forEach(function (uv, j) {

						if (buffers.uvs[j] === undefined) buffers.uvs[j] = [];

						buffers.uvs[j].push(faceUVs[j][0]);
						buffers.uvs[j].push(faceUVs[j][1]);

						buffers.uvs[j].push(faceUVs[j][(i - 1) * 2]);
						buffers.uvs[j].push(faceUVs[j][(i - 1) * 2 + 1]);

						buffers.uvs[j].push(faceUVs[j][i * 2]);
						buffers.uvs[j].push(faceUVs[j][i * 2 + 1]);
					});
				}
			};

			for (var i = 2; i < faceLength; i++) {
				_loop3(i);
			}
		}
	}, {
		key: 'addMorphTargets',
		value: function addMorphTargets(parentGeo, parentGeoNode, morphTargets, preTransform) {

			if (morphTargets.length === 0) return;

			parentGeo.morphTargetsRelative = true;

			parentGeo.morphAttributes.position = [];
			// parentGeo.morphAttributes.normal = []; // not implemented

			var scope = this;
			morphTargets.forEach(function (morphTarget) {

				morphTarget.rawTargets.forEach(function (rawTarget) {

					var morphGeoNode = fbxTree.Objects.Geometry[rawTarget.geoID];

					if (morphGeoNode !== undefined) {

						scope.genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, rawTarget.name);
					}
				});
			});
		}

		// a morph geometry node is similar to a standard  node, and the node is also contained
		// in FBXTree.Objects.Geometry, however it can only have attributes for position, normal
		// and a special attribute Index defining which vertices of the original geometry are affected
		// Normal and position attributes only have data for the vertices that are affected by the morph

	}, {
		key: 'genMorphGeometry',
		value: function genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, name) {

			var vertexIndices = parentGeoNode.PolygonVertexIndex !== undefined ? parentGeoNode.PolygonVertexIndex.a : [];

			var morphPositionsSparse = morphGeoNode.Vertices !== undefined ? morphGeoNode.Vertices.a : [];
			var indices = morphGeoNode.Indexes !== undefined ? morphGeoNode.Indexes.a : [];

			var length = parentGeo.attributes.position.count * 3;
			var morphPositions = new Float32Array(length);

			for (var i = 0; i < indices.length; i++) {

				var morphIndex = indices[i] * 3;

				morphPositions[morphIndex] = morphPositionsSparse[i * 3];
				morphPositions[morphIndex + 1] = morphPositionsSparse[i * 3 + 1];
				morphPositions[morphIndex + 2] = morphPositionsSparse[i * 3 + 2];
			}

			// TODO: add morph normal support
			var morphGeoInfo = {
				vertexIndices: vertexIndices,
				vertexPositions: morphPositions

			};

			var morphBuffers = this.genBuffers(morphGeoInfo);

			var positionAttribute = new three_module["z" /* Float32BufferAttribute */](morphBuffers.vertex, 3);
			positionAttribute.name = name || morphGeoNode.attrName;

			positionAttribute.applyMatrix4(preTransform);

			parentGeo.morphAttributes.position.push(positionAttribute);
		}

		// Parse normal from FBXTree.Objects.Geometry.LayerElementNormal if it exists

	}, {
		key: 'parseNormals',
		value: function parseNormals(NormalNode) {

			var mappingType = NormalNode.MappingInformationType;
			var referenceType = NormalNode.ReferenceInformationType;
			var buffer = NormalNode.Normals.a;
			var indexBuffer = [];
			if (referenceType === 'IndexToDirect') {

				if ('NormalIndex' in NormalNode) {

					indexBuffer = NormalNode.NormalIndex.a;
				} else if ('NormalsIndex' in NormalNode) {

					indexBuffer = NormalNode.NormalsIndex.a;
				}
			}

			return {
				dataSize: 3,
				buffer: buffer,
				indices: indexBuffer,
				mappingType: mappingType,
				referenceType: referenceType
			};
		}

		// Parse UVs from FBXTree.Objects.Geometry.LayerElementUV if it exists

	}, {
		key: 'parseUVs',
		value: function parseUVs(UVNode) {

			var mappingType = UVNode.MappingInformationType;
			var referenceType = UVNode.ReferenceInformationType;
			var buffer = UVNode.UV.a;
			var indexBuffer = [];
			if (referenceType === 'IndexToDirect') {

				indexBuffer = UVNode.UVIndex.a;
			}

			return {
				dataSize: 2,
				buffer: buffer,
				indices: indexBuffer,
				mappingType: mappingType,
				referenceType: referenceType
			};
		}

		// Parse Vertex Colors from FBXTree.Objects.Geometry.LayerElementColor if it exists

	}, {
		key: 'parseVertexColors',
		value: function parseVertexColors(ColorNode) {

			var mappingType = ColorNode.MappingInformationType;
			var referenceType = ColorNode.ReferenceInformationType;
			var buffer = ColorNode.Colors.a;
			var indexBuffer = [];
			if (referenceType === 'IndexToDirect') {

				indexBuffer = ColorNode.ColorIndex.a;
			}

			for (var i = 0, c = new three_module["o" /* Color */](); i < buffer.length; i += 4) {

				c.fromArray(buffer, i).convertSRGBToLinear().toArray(buffer, i);
			}

			return {
				dataSize: 4,
				buffer: buffer,
				indices: indexBuffer,
				mappingType: mappingType,
				referenceType: referenceType
			};
		}

		// Parse mapping and material data in FBXTree.Objects.Geometry.LayerElementMaterial if it exists

	}, {
		key: 'parseMaterialIndices',
		value: function parseMaterialIndices(MaterialNode) {

			var mappingType = MaterialNode.MappingInformationType;
			var referenceType = MaterialNode.ReferenceInformationType;

			if (mappingType === 'NoMappingInformation') {

				return {
					dataSize: 1,
					buffer: [0],
					indices: [0],
					mappingType: 'AllSame',
					referenceType: referenceType
				};
			}

			var materialIndexBuffer = MaterialNode.Materials.a;

			// Since materials are stored as indices, there's a bit of a mismatch between FBX and what
			// we expect.So we create an intermediate buffer that points to the index in the buffer,
			// for conforming with the other functions we've written for other data.
			var materialIndices = [];

			for (var i = 0; i < materialIndexBuffer.length; ++i) {

				materialIndices.push(i);
			}

			return {
				dataSize: 1,
				buffer: materialIndexBuffer,
				indices: materialIndices,
				mappingType: mappingType,
				referenceType: referenceType
			};
		}

		// Generate a NurbGeometry from a node in FBXTree.Objects.Geometry

	}, {
		key: 'parseNurbsGeometry',
		value: function parseNurbsGeometry(geoNode) {

			var order = parseInt(geoNode.Order);

			if (isNaN(order)) {

				console.error('THREE.FBXLoader: Invalid Order %s given for geometry ID: %s', geoNode.Order, geoNode.id);
				return new three_module["k" /* BufferGeometry */]();
			}

			var degree = order - 1;

			var knots = geoNode.KnotVector.a;
			var controlPoints = [];
			var pointsValues = geoNode.Points.a;

			for (var i = 0, l = pointsValues.length; i < l; i += 4) {

				controlPoints.push(new three_module["_42" /* Vector4 */]().fromArray(pointsValues, i));
			}

			var startKnot = void 0,
			    endKnot = void 0;

			if (geoNode.Form === 'Closed') {

				controlPoints.push(controlPoints[0]);
			} else if (geoNode.Form === 'Periodic') {

				startKnot = degree;
				endKnot = knots.length - 1 - startKnot;

				for (var _i = 0; _i < degree; ++_i) {

					controlPoints.push(controlPoints[_i]);
				}
			}

			var curve = new NURBSCurve_NURBSCurve(degree, knots, controlPoints, startKnot, endKnot);
			var points = curve.getPoints(controlPoints.length * 12);

			return new three_module["k" /* BufferGeometry */]().setFromPoints(points);
		}
	}]);

	return GeometryParser;
}();

// parse animation data from FBXTree


var FBXLoader_AnimationParser = function () {
	function AnimationParser() {
		classCallCheck_default()(this, AnimationParser);
	}

	createClass_default()(AnimationParser, [{
		key: 'parse',


		// take raw animation clips and turn them into three.js animation clips
		value: function parse() {

			var animationClips = [];

			var rawClips = this.parseClips();

			if (rawClips !== undefined) {

				for (var key in rawClips) {

					var rawClip = rawClips[key];

					var clip = this.addClip(rawClip);

					animationClips.push(clip);
				}
			}

			return animationClips;
		}
	}, {
		key: 'parseClips',
		value: function parseClips() {

			// since the actual transformation data is stored in FBXTree.Objects.AnimationCurve,
			// if this is undefined we can safely assume there are no animations
			if (fbxTree.Objects.AnimationCurve === undefined) return undefined;

			var curveNodesMap = this.parseAnimationCurveNodes();

			this.parseAnimationCurves(curveNodesMap);

			var layersMap = this.parseAnimationLayers(curveNodesMap);
			var rawClips = this.parseAnimStacks(layersMap);

			return rawClips;
		}

		// parse nodes in FBXTree.Objects.AnimationCurveNode
		// each AnimationCurveNode holds data for an animation transform for a model (e.g. left arm rotation )
		// and is referenced by an AnimationLayer

	}, {
		key: 'parseAnimationCurveNodes',
		value: function parseAnimationCurveNodes() {

			var rawCurveNodes = fbxTree.Objects.AnimationCurveNode;

			var curveNodesMap = new map_default.a();

			for (var nodeID in rawCurveNodes) {

				var rawCurveNode = rawCurveNodes[nodeID];

				if (rawCurveNode.attrName.match(/S|R|T|DeformPercent/) !== null) {

					var curveNode = {

						id: rawCurveNode.id,
						attr: rawCurveNode.attrName,
						curves: {}

					};

					curveNodesMap.set(curveNode.id, curveNode);
				}
			}

			return curveNodesMap;
		}

		// parse nodes in FBXTree.Objects.AnimationCurve and connect them up to
		// previously parsed AnimationCurveNodes. Each AnimationCurve holds data for a single animated
		// axis ( e.g. times and values of x rotation)

	}, {
		key: 'parseAnimationCurves',
		value: function parseAnimationCurves(curveNodesMap) {

			var rawCurves = fbxTree.Objects.AnimationCurve;

			// TODO: Many values are identical up to roundoff error, but won't be optimised
			// e.g. position times: [0, 0.4, 0. 8]
			// position values: [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.235384487103147e-7, 93.67520904541016, -0.9982695579528809]
			// clearly, this should be optimised to
			// times: [0], positions [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809]
			// this shows up in nearly every FBX file, and generally time array is length > 100

			for (var nodeID in rawCurves) {

				var animationCurve = {

					id: rawCurves[nodeID].id,
					times: rawCurves[nodeID].KeyTime.a.map(convertFBXTimeToSeconds),
					values: rawCurves[nodeID].KeyValueFloat.a

				};

				var relationships = connections.get(animationCurve.id);

				if (relationships !== undefined) {

					var animationCurveID = relationships.parents[0].ID;
					var animationCurveRelationship = relationships.parents[0].relationship;

					if (animationCurveRelationship.match(/X/)) {

						curveNodesMap.get(animationCurveID).curves['x'] = animationCurve;
					} else if (animationCurveRelationship.match(/Y/)) {

						curveNodesMap.get(animationCurveID).curves['y'] = animationCurve;
					} else if (animationCurveRelationship.match(/Z/)) {

						curveNodesMap.get(animationCurveID).curves['z'] = animationCurve;
					} else if (animationCurveRelationship.match(/DeformPercent/) && curveNodesMap.has(animationCurveID)) {

						curveNodesMap.get(animationCurveID).curves['morph'] = animationCurve;
					}
				}
			}
		}

		// parse nodes in FBXTree.Objects.AnimationLayer. Each layers holds references
		// to various AnimationCurveNodes and is referenced by an AnimationStack node
		// note: theoretically a stack can have multiple layers, however in practice there always seems to be one per stack

	}, {
		key: 'parseAnimationLayers',
		value: function parseAnimationLayers(curveNodesMap) {

			var rawLayers = fbxTree.Objects.AnimationLayer;

			var layersMap = new map_default.a();

			var _loop4 = function _loop4(nodeID) {

				var layerCurveNodes = [];

				var connection = connections.get(parseInt(nodeID));

				if (connection !== undefined) {

					// all the animationCurveNodes used in the layer
					var children = connection.children;

					children.forEach(function (child, i) {

						if (curveNodesMap.has(child.ID)) {

							var curveNode = curveNodesMap.get(child.ID);

							// check that the curves are defined for at least one axis, otherwise ignore the curveNode
							if (curveNode.curves.x !== undefined || curveNode.curves.y !== undefined || curveNode.curves.z !== undefined) {

								if (layerCurveNodes[i] === undefined) {

									var modelID = connections.get(child.ID).parents.filter(function (parent) {

										return parent.relationship !== undefined;
									})[0].ID;

									if (modelID !== undefined) {

										var rawModel = fbxTree.Objects.Model[modelID.toString()];

										if (rawModel === undefined) {

											console.warn('THREE.FBXLoader: Encountered a unused curve.', child);
											return;
										}

										var node = {

											modelName: rawModel.attrName ? three_module["_21" /* PropertyBinding */].sanitizeNodeName(rawModel.attrName) : '',
											ID: rawModel.id,
											initialPosition: [0, 0, 0],
											initialRotation: [0, 0, 0],
											initialScale: [1, 1, 1]

										};

										sceneGraph.traverse(function (child) {

											if (child.ID === rawModel.id) {

												node.transform = child.matrix;

												if (child.userData.transformData) node.eulerOrder = child.userData.transformData.eulerOrder;
											}
										});

										if (!node.transform) node.transform = new three_module["_2" /* Matrix4 */]();

										// if the animated model is pre rotated, we'll have to apply the pre rotations to every
										// animation value as well
										if ('PreRotation' in rawModel) node.preRotation = rawModel.PreRotation.value;
										if ('PostRotation' in rawModel) node.postRotation = rawModel.PostRotation.value;

										layerCurveNodes[i] = node;
									}
								}

								if (layerCurveNodes[i]) layerCurveNodes[i][curveNode.attr] = curveNode;
							} else if (curveNode.curves.morph !== undefined) {

								if (layerCurveNodes[i] === undefined) {

									var deformerID = connections.get(child.ID).parents.filter(function (parent) {

										return parent.relationship !== undefined;
									})[0].ID;

									var morpherID = connections.get(deformerID).parents[0].ID;
									var geoID = connections.get(morpherID).parents[0].ID;

									// assuming geometry is not used in more than one model
									var _modelID = connections.get(geoID).parents[0].ID;

									var _rawModel = fbxTree.Objects.Model[_modelID];

									var _node = {

										modelName: _rawModel.attrName ? three_module["_21" /* PropertyBinding */].sanitizeNodeName(_rawModel.attrName) : '',
										morphName: fbxTree.Objects.Deformer[deformerID].attrName

									};

									layerCurveNodes[i] = _node;
								}

								layerCurveNodes[i][curveNode.attr] = curveNode;
							}
						}
					});

					layersMap.set(parseInt(nodeID), layerCurveNodes);
				}
			};

			for (var nodeID in rawLayers) {
				_loop4(nodeID);
			}

			return layersMap;
		}

		// parse nodes in FBXTree.Objects.AnimationStack. These are the top level node in the animation
		// hierarchy. Each Stack node will be used to create a AnimationClip

	}, {
		key: 'parseAnimStacks',
		value: function parseAnimStacks(layersMap) {

			var rawStacks = fbxTree.Objects.AnimationStack;

			// connect the stacks (clips) up to the layers
			var rawClips = {};

			for (var nodeID in rawStacks) {

				var children = connections.get(parseInt(nodeID)).children;

				if (children.length > 1) {

					// it seems like stacks will always be associated with a single layer. But just in case there are files
					// where there are multiple layers per stack, we'll display a warning
					console.warn('THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.');
				}

				var layer = layersMap.get(children[0].ID);

				rawClips[nodeID] = {

					name: rawStacks[nodeID].attrName,
					layer: layer

				};
			}

			return rawClips;
		}
	}, {
		key: 'addClip',
		value: function addClip(rawClip) {

			var tracks = [];

			var scope = this;
			rawClip.layer.forEach(function (rawTracks) {

				tracks = tracks.concat(scope.generateTracks(rawTracks));
			});

			return new three_module["b" /* AnimationClip */](rawClip.name, -1, tracks);
		}
	}, {
		key: 'generateTracks',
		value: function generateTracks(rawTracks) {

			var tracks = [];

			var initialPosition = new three_module["_41" /* Vector3 */]();
			var initialRotation = new three_module["_22" /* Quaternion */]();
			var initialScale = new three_module["_41" /* Vector3 */]();

			if (rawTracks.transform) rawTracks.transform.decompose(initialPosition, initialRotation, initialScale);

			initialPosition = initialPosition.toArray();
			initialRotation = new three_module["w" /* Euler */]().setFromQuaternion(initialRotation, rawTracks.eulerOrder).toArray();
			initialScale = initialScale.toArray();

			if (rawTracks.T !== undefined && keys_default()(rawTracks.T.curves).length > 0) {

				var positionTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.T.curves, initialPosition, 'position');
				if (positionTrack !== undefined) tracks.push(positionTrack);
			}

			if (rawTracks.R !== undefined && keys_default()(rawTracks.R.curves).length > 0) {

				var rotationTrack = this.generateRotationTrack(rawTracks.modelName, rawTracks.R.curves, initialRotation, rawTracks.preRotation, rawTracks.postRotation, rawTracks.eulerOrder);
				if (rotationTrack !== undefined) tracks.push(rotationTrack);
			}

			if (rawTracks.S !== undefined && keys_default()(rawTracks.S.curves).length > 0) {

				var scaleTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.S.curves, initialScale, 'scale');
				if (scaleTrack !== undefined) tracks.push(scaleTrack);
			}

			if (rawTracks.DeformPercent !== undefined) {

				var morphTrack = this.generateMorphTrack(rawTracks);
				if (morphTrack !== undefined) tracks.push(morphTrack);
			}

			return tracks;
		}
	}, {
		key: 'generateVectorTrack',
		value: function generateVectorTrack(modelName, curves, initialValue, type) {

			var times = this.getTimesForAllAxes(curves);
			var values = this.getKeyframeTrackValues(times, curves, initialValue);

			return new three_module["_43" /* VectorKeyframeTrack */](modelName + '.' + type, times, values);
		}
	}, {
		key: 'generateRotationTrack',
		value: function generateRotationTrack(modelName, curves, initialValue, preRotation, postRotation, eulerOrder) {

			if (curves.x !== undefined) {

				this.interpolateRotations(curves.x);
				curves.x.values = curves.x.values.map(three_module["_0" /* MathUtils */].degToRad);
			}

			if (curves.y !== undefined) {

				this.interpolateRotations(curves.y);
				curves.y.values = curves.y.values.map(three_module["_0" /* MathUtils */].degToRad);
			}

			if (curves.z !== undefined) {

				this.interpolateRotations(curves.z);
				curves.z.values = curves.z.values.map(three_module["_0" /* MathUtils */].degToRad);
			}

			var times = this.getTimesForAllAxes(curves);
			var values = this.getKeyframeTrackValues(times, curves, initialValue);

			if (preRotation !== undefined) {

				preRotation = preRotation.map(three_module["_0" /* MathUtils */].degToRad);
				preRotation.push(eulerOrder);

				preRotation = new three_module["w" /* Euler */]().fromArray(preRotation);
				preRotation = new three_module["_22" /* Quaternion */]().setFromEuler(preRotation);
			}

			if (postRotation !== undefined) {

				postRotation = postRotation.map(three_module["_0" /* MathUtils */].degToRad);
				postRotation.push(eulerOrder);

				postRotation = new three_module["w" /* Euler */]().fromArray(postRotation);
				postRotation = new three_module["_22" /* Quaternion */]().setFromEuler(postRotation).invert();
			}

			var quaternion = new three_module["_22" /* Quaternion */]();
			var euler = new three_module["w" /* Euler */]();

			var quaternionValues = [];

			for (var i = 0; i < values.length; i += 3) {

				euler.set(values[i], values[i + 1], values[i + 2], eulerOrder);

				quaternion.setFromEuler(euler);

				if (preRotation !== undefined) quaternion.premultiply(preRotation);
				if (postRotation !== undefined) quaternion.multiply(postRotation);

				quaternion.toArray(quaternionValues, i / 3 * 4);
			}

			return new three_module["_23" /* QuaternionKeyframeTrack */](modelName + '.quaternion', times, quaternionValues);
		}
	}, {
		key: 'generateMorphTrack',
		value: function generateMorphTrack(rawTracks) {

			var curves = rawTracks.DeformPercent.curves.morph;
			var values = curves.values.map(function (val) {

				return val / 100;
			});

			var morphNum = sceneGraph.getObjectByName(rawTracks.modelName).morphTargetDictionary[rawTracks.morphName];

			return new three_module["_13" /* NumberKeyframeTrack */](rawTracks.modelName + '.morphTargetInfluences[' + morphNum + ']', curves.times, values);
		}

		// For all animated objects, times are defined separately for each axis
		// Here we'll combine the times into one sorted array without duplicates

	}, {
		key: 'getTimesForAllAxes',
		value: function getTimesForAllAxes(curves) {

			var times = [];

			// first join together the times for each axis, if defined
			if (curves.x !== undefined) times = times.concat(curves.x.times);
			if (curves.y !== undefined) times = times.concat(curves.y.times);
			if (curves.z !== undefined) times = times.concat(curves.z.times);

			// then sort them
			times = times.sort(function (a, b) {

				return a - b;
			});

			// and remove duplicates
			if (times.length > 1) {

				var targetIndex = 1;
				var lastValue = times[0];
				for (var i = 1; i < times.length; i++) {

					var currentValue = times[i];
					if (currentValue !== lastValue) {

						times[targetIndex] = currentValue;
						lastValue = currentValue;
						targetIndex++;
					}
				}

				times = times.slice(0, targetIndex);
			}

			return times;
		}
	}, {
		key: 'getKeyframeTrackValues',
		value: function getKeyframeTrackValues(times, curves, initialValue) {

			var prevValue = initialValue;

			var values = [];

			var xIndex = -1;
			var yIndex = -1;
			var zIndex = -1;

			times.forEach(function (time) {

				if (curves.x) xIndex = curves.x.times.indexOf(time);
				if (curves.y) yIndex = curves.y.times.indexOf(time);
				if (curves.z) zIndex = curves.z.times.indexOf(time);

				// if there is an x value defined for this frame, use that
				if (xIndex !== -1) {

					var xValue = curves.x.values[xIndex];
					values.push(xValue);
					prevValue[0] = xValue;
				} else {

					// otherwise use the x value from the previous frame
					values.push(prevValue[0]);
				}

				if (yIndex !== -1) {

					var yValue = curves.y.values[yIndex];
					values.push(yValue);
					prevValue[1] = yValue;
				} else {

					values.push(prevValue[1]);
				}

				if (zIndex !== -1) {

					var zValue = curves.z.values[zIndex];
					values.push(zValue);
					prevValue[2] = zValue;
				} else {

					values.push(prevValue[2]);
				}
			});

			return values;
		}

		// Rotations are defined as Euler angles which can have values  of any size
		// These will be converted to quaternions which don't support values greater than
		// PI, so we'll interpolate large rotations

	}, {
		key: 'interpolateRotations',
		value: function interpolateRotations(curve) {

			for (var i = 1; i < curve.values.length; i++) {

				var initialValue = curve.values[i - 1];
				var valuesSpan = curve.values[i] - initialValue;

				var absoluteSpan = Math.abs(valuesSpan);

				if (absoluteSpan >= 180) {

					var numSubIntervals = absoluteSpan / 180;

					var step = valuesSpan / numSubIntervals;
					var nextValue = initialValue + step;

					var initialTime = curve.times[i - 1];
					var timeSpan = curve.times[i] - initialTime;
					var interval = timeSpan / numSubIntervals;
					var nextTime = initialTime + interval;

					var interpolatedTimes = [];
					var interpolatedValues = [];

					while (nextTime < curve.times[i]) {

						interpolatedTimes.push(nextTime);
						nextTime += interval;

						interpolatedValues.push(nextValue);
						nextValue += step;
					}

					curve.times = inject(curve.times, i, interpolatedTimes);
					curve.values = inject(curve.values, i, interpolatedValues);
				}
			}
		}
	}]);

	return AnimationParser;
}();

// parse an FBX file in ASCII format


var FBXLoader_TextParser = function () {
	function TextParser() {
		classCallCheck_default()(this, TextParser);
	}

	createClass_default()(TextParser, [{
		key: 'getPrevNode',
		value: function getPrevNode() {

			return this.nodeStack[this.currentIndent - 2];
		}
	}, {
		key: 'getCurrentNode',
		value: function getCurrentNode() {

			return this.nodeStack[this.currentIndent - 1];
		}
	}, {
		key: 'getCurrentProp',
		value: function getCurrentProp() {

			return this.currentProp;
		}
	}, {
		key: 'pushStack',
		value: function pushStack(node) {

			this.nodeStack.push(node);
			this.currentIndent += 1;
		}
	}, {
		key: 'popStack',
		value: function popStack() {

			this.nodeStack.pop();
			this.currentIndent -= 1;
		}
	}, {
		key: 'setCurrentProp',
		value: function setCurrentProp(val, name) {

			this.currentProp = val;
			this.currentPropName = name;
		}
	}, {
		key: 'parse',
		value: function parse(text) {

			this.currentIndent = 0;

			this.allNodes = new FBXLoader_FBXTree();
			this.nodeStack = [];
			this.currentProp = [];
			this.currentPropName = '';

			var scope = this;

			var split = text.split(/[\r\n]+/);

			split.forEach(function (line, i) {

				var matchComment = line.match(/^[\s\t]*;/);
				var matchEmpty = line.match(/^[\s\t]*$/);

				if (matchComment || matchEmpty) return;

				var matchBeginning = line.match('^\\t{' + scope.currentIndent + '}(\\w+):(.*){', '');
				var matchProperty = line.match('^\\t{' + scope.currentIndent + '}(\\w+):[\\s\\t\\r\\n](.*)');
				var matchEnd = line.match('^\\t{' + (scope.currentIndent - 1) + '}}');

				if (matchBeginning) {

					scope.parseNodeBegin(line, matchBeginning);
				} else if (matchProperty) {

					scope.parseNodeProperty(line, matchProperty, split[++i]);
				} else if (matchEnd) {

					scope.popStack();
				} else if (line.match(/^[^\s\t}]/)) {

					// large arrays are split over multiple lines terminated with a ',' character
					// if this is encountered the line needs to be joined to the previous line
					scope.parseNodePropertyContinued(line);
				}
			});

			return this.allNodes;
		}
	}, {
		key: 'parseNodeBegin',
		value: function parseNodeBegin(line, property) {

			var nodeName = property[1].trim().replace(/^"/, '').replace(/"$/, '');

			var nodeAttrs = property[2].split(',').map(function (attr) {

				return attr.trim().replace(/^"/, '').replace(/"$/, '');
			});

			var node = { name: nodeName };
			var attrs = this.parseNodeAttr(nodeAttrs);

			var currentNode = this.getCurrentNode();

			// a top node
			if (this.currentIndent === 0) {

				this.allNodes.add(nodeName, node);
			} else {
				// a subnode

				// if the subnode already exists, append it
				if (nodeName in currentNode) {

					// special case Pose needs PoseNodes as an array
					if (nodeName === 'PoseNode') {

						currentNode.PoseNode.push(node);
					} else if (currentNode[nodeName].id !== undefined) {

						currentNode[nodeName] = {};
						currentNode[nodeName][currentNode[nodeName].id] = currentNode[nodeName];
					}

					if (attrs.id !== '') currentNode[nodeName][attrs.id] = node;
				} else if (typeof attrs.id === 'number') {

					currentNode[nodeName] = {};
					currentNode[nodeName][attrs.id] = node;
				} else if (nodeName !== 'Properties70') {

					if (nodeName === 'PoseNode') currentNode[nodeName] = [node];else currentNode[nodeName] = node;
				}
			}

			if (typeof attrs.id === 'number') node.id = attrs.id;
			if (attrs.name !== '') node.attrName = attrs.name;
			if (attrs.type !== '') node.attrType = attrs.type;

			this.pushStack(node);
		}
	}, {
		key: 'parseNodeAttr',
		value: function parseNodeAttr(attrs) {

			var id = attrs[0];

			if (attrs[0] !== '') {

				id = parseInt(attrs[0]);

				if (isNaN(id)) {

					id = attrs[0];
				}
			}

			var name = '',
			    type = '';

			if (attrs.length > 1) {

				name = attrs[1].replace(/^(\w+)::/, '');
				type = attrs[2];
			}

			return { id: id, name: name, type: type };
		}
	}, {
		key: 'parseNodeProperty',
		value: function parseNodeProperty(line, property, contentLine) {

			var propName = property[1].replace(/^"/, '').replace(/"$/, '').trim();
			var propValue = property[2].replace(/^"/, '').replace(/"$/, '').trim();

			// for special case: base64 image data follows "Content: ," line
			//	Content: ,
			//	 "/9j/4RDaRXhpZgAATU0A..."
			if (propName === 'Content' && propValue === ',') {

				propValue = contentLine.replace(/"/g, '').replace(/,$/, '').trim();
			}

			var currentNode = this.getCurrentNode();
			var parentName = currentNode.name;

			if (parentName === 'Properties70') {

				this.parseNodeSpecialProperty(line, propName, propValue);
				return;
			}

			// Connections
			if (propName === 'C') {

				var connProps = propValue.split(',').slice(1);
				var from = parseInt(connProps[0]);
				var to = parseInt(connProps[1]);

				var rest = propValue.split(',').slice(3);

				rest = rest.map(function (elem) {

					return elem.trim().replace(/^"/, '');
				});

				propName = 'connections';
				propValue = [from, to];
				append(propValue, rest);

				if (currentNode[propName] === undefined) {

					currentNode[propName] = [];
				}
			}

			// Node
			if (propName === 'Node') currentNode.id = propValue;

			// connections
			if (propName in currentNode && Array.isArray(currentNode[propName])) {

				currentNode[propName].push(propValue);
			} else {

				if (propName !== 'a') currentNode[propName] = propValue;else currentNode.a = propValue;
			}

			this.setCurrentProp(currentNode, propName);

			// convert string to array, unless it ends in ',' in which case more will be added to it
			if (propName === 'a' && propValue.slice(-1) !== ',') {

				currentNode.a = parseNumberArray(propValue);
			}
		}
	}, {
		key: 'parseNodePropertyContinued',
		value: function parseNodePropertyContinued(line) {

			var currentNode = this.getCurrentNode();

			currentNode.a += line;

			// if the line doesn't end in ',' we have reached the end of the property value
			// so convert the string to an array
			if (line.slice(-1) !== ',') {

				currentNode.a = parseNumberArray(currentNode.a);
			}
		}

		// parse "Property70"

	}, {
		key: 'parseNodeSpecialProperty',
		value: function parseNodeSpecialProperty(line, propName, propValue) {

			// split this
			// P: "Lcl Scaling", "Lcl Scaling", "", "A",1,1,1
			// into array like below
			// ["Lcl Scaling", "Lcl Scaling", "", "A", "1,1,1" ]
			var props = propValue.split('",').map(function (prop) {

				return prop.trim().replace(/^\"/, '').replace(/\s/, '_');
			});

			var innerPropName = props[0];
			var innerPropType1 = props[1];
			var innerPropType2 = props[2];
			var innerPropFlag = props[3];
			var innerPropValue = props[4];

			// cast values where needed, otherwise leave as strings
			switch (innerPropType1) {

				case 'int':
				case 'enum':
				case 'bool':
				case 'ULongLong':
				case 'double':
				case 'Number':
				case 'FieldOfView':
					innerPropValue = parseFloat(innerPropValue);
					break;

				case 'Color':
				case 'ColorRGB':
				case 'Vector3D':
				case 'Lcl_Translation':
				case 'Lcl_Rotation':
				case 'Lcl_Scaling':
					innerPropValue = parseNumberArray(innerPropValue);
					break;

			}

			// CAUTION: these props must append to parent's parent
			this.getPrevNode()[innerPropName] = {

				'type': innerPropType1,
				'type2': innerPropType2,
				'flag': innerPropFlag,
				'value': innerPropValue

			};

			this.setCurrentProp(this.getPrevNode(), innerPropName);
		}
	}]);

	return TextParser;
}();

// Parse an FBX file in Binary format


var FBXLoader_BinaryParser = function () {
	function BinaryParser() {
		classCallCheck_default()(this, BinaryParser);
	}

	createClass_default()(BinaryParser, [{
		key: 'parse',
		value: function parse(buffer) {

			var reader = new FBXLoader_BinaryReader(buffer);
			reader.skip(23); // skip magic 23 bytes

			var version = reader.getUint32();

			if (version < 6400) {

				throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + version);
			}

			var allNodes = new FBXLoader_FBXTree();

			while (!this.endOfContent(reader)) {

				var node = this.parseNode(reader, version);
				if (node !== null) allNodes.add(node.name, node);
			}

			return allNodes;
		}

		// Check if reader has reached the end of content.

	}, {
		key: 'endOfContent',
		value: function endOfContent(reader) {

			// footer size: 160bytes + 16-byte alignment padding
			// - 16bytes: magic
			// - padding til 16-byte alignment (at least 1byte?)
			//	(seems like some exporters embed fixed 15 or 16bytes?)
			// - 4bytes: magic
			// - 4bytes: version
			// - 120bytes: zero
			// - 16bytes: magic
			if (reader.size() % 16 === 0) {

				return (reader.getOffset() + 160 + 16 & ~0xf) >= reader.size();
			} else {

				return reader.getOffset() + 160 + 16 >= reader.size();
			}
		}

		// recursively parse nodes until the end of the file is reached

	}, {
		key: 'parseNode',
		value: function parseNode(reader, version) {

			var node = {};

			// The first three data sizes depends on version.
			var endOffset = version >= 7500 ? reader.getUint64() : reader.getUint32();
			var numProperties = version >= 7500 ? reader.getUint64() : reader.getUint32();

			version >= 7500 ? reader.getUint64() : reader.getUint32(); // the returned propertyListLen is not used

			var nameLen = reader.getUint8();
			var name = reader.getString(nameLen);

			// Regards this node as NULL-record if endOffset is zero
			if (endOffset === 0) return null;

			var propertyList = [];

			for (var i = 0; i < numProperties; i++) {

				propertyList.push(this.parseProperty(reader));
			}

			// Regards the first three elements in propertyList as id, attrName, and attrType
			var id = propertyList.length > 0 ? propertyList[0] : '';
			var attrName = propertyList.length > 1 ? propertyList[1] : '';
			var attrType = propertyList.length > 2 ? propertyList[2] : '';

			// check if this node represents just a single property
			// like (name, 0) set or (name2, [0, 1, 2]) set of {name: 0, name2: [0, 1, 2]}
			node.singleProperty = numProperties === 1 && reader.getOffset() === endOffset ? true : false;

			while (endOffset > reader.getOffset()) {

				var subNode = this.parseNode(reader, version);

				if (subNode !== null) this.parseSubNode(name, node, subNode);
			}

			node.propertyList = propertyList; // raw property list used by parent

			if (typeof id === 'number') node.id = id;
			if (attrName !== '') node.attrName = attrName;
			if (attrType !== '') node.attrType = attrType;
			if (name !== '') node.name = name;

			return node;
		}
	}, {
		key: 'parseSubNode',
		value: function parseSubNode(name, node, subNode) {

			// special case: child node is single property
			if (subNode.singleProperty === true) {

				var value = subNode.propertyList[0];

				if (Array.isArray(value)) {

					node[subNode.name] = subNode;

					subNode.a = value;
				} else {

					node[subNode.name] = value;
				}
			} else if (name === 'Connections' && subNode.name === 'C') {

				var array = [];

				subNode.propertyList.forEach(function (property, i) {

					// first Connection is FBX type (OO, OP, etc.). We'll discard these
					if (i !== 0) array.push(property);
				});

				if (node.connections === undefined) {

					node.connections = [];
				}

				node.connections.push(array);
			} else if (subNode.name === 'Properties70') {

				var keys = keys_default()(subNode);

				keys.forEach(function (key) {

					node[key] = subNode[key];
				});
			} else if (name === 'Properties70' && subNode.name === 'P') {

				var innerPropName = subNode.propertyList[0];
				var innerPropType1 = subNode.propertyList[1];
				var innerPropType2 = subNode.propertyList[2];
				var innerPropFlag = subNode.propertyList[3];
				var innerPropValue = void 0;

				if (innerPropName.indexOf('Lcl ') === 0) innerPropName = innerPropName.replace('Lcl ', 'Lcl_');
				if (innerPropType1.indexOf('Lcl ') === 0) innerPropType1 = innerPropType1.replace('Lcl ', 'Lcl_');

				if (innerPropType1 === 'Color' || innerPropType1 === 'ColorRGB' || innerPropType1 === 'Vector' || innerPropType1 === 'Vector3D' || innerPropType1.indexOf('Lcl_') === 0) {

					innerPropValue = [subNode.propertyList[4], subNode.propertyList[5], subNode.propertyList[6]];
				} else {

					innerPropValue = subNode.propertyList[4];
				}

				// this will be copied to parent, see above
				node[innerPropName] = {

					'type': innerPropType1,
					'type2': innerPropType2,
					'flag': innerPropFlag,
					'value': innerPropValue

				};
			} else if (node[subNode.name] === undefined) {

				if (typeof subNode.id === 'number') {

					node[subNode.name] = {};
					node[subNode.name][subNode.id] = subNode;
				} else {

					node[subNode.name] = subNode;
				}
			} else {

				if (subNode.name === 'PoseNode') {

					if (!Array.isArray(node[subNode.name])) {

						node[subNode.name] = [node[subNode.name]];
					}

					node[subNode.name].push(subNode);
				} else if (node[subNode.name][subNode.id] === undefined) {

					node[subNode.name][subNode.id] = subNode;
				}
			}
		}
	}, {
		key: 'parseProperty',
		value: function parseProperty(reader) {

			var type = reader.getString(1);
			var length = void 0;

			switch (type) {

				case 'C':
					return reader.getBoolean();

				case 'D':
					return reader.getFloat64();

				case 'F':
					return reader.getFloat32();

				case 'I':
					return reader.getInt32();

				case 'L':
					return reader.getInt64();

				case 'R':
					length = reader.getUint32();
					return reader.getArrayBuffer(length);

				case 'S':
					length = reader.getUint32();
					return reader.getString(length);

				case 'Y':
					return reader.getInt16();

				case 'b':
				case 'c':
				case 'd':
				case 'f':
				case 'i':
				case 'l':

					var arrayLength = reader.getUint32();
					var encoding = reader.getUint32(); // 0: non-compressed, 1: compressed
					var compressedLength = reader.getUint32();

					if (encoding === 0) {

						switch (type) {

							case 'b':
							case 'c':
								return reader.getBooleanArray(arrayLength);

							case 'd':
								return reader.getFloat64Array(arrayLength);

							case 'f':
								return reader.getFloat32Array(arrayLength);

							case 'i':
								return reader.getInt32Array(arrayLength);

							case 'l':
								return reader.getInt64Array(arrayLength);

						}
					}

					var data = fflate_module["a" /* unzlibSync */](new Uint8Array(reader.getArrayBuffer(compressedLength)));
					var reader2 = new FBXLoader_BinaryReader(data.buffer);

					switch (type) {

						case 'b':
						case 'c':
							return reader2.getBooleanArray(arrayLength);

						case 'd':
							return reader2.getFloat64Array(arrayLength);

						case 'f':
							return reader2.getFloat32Array(arrayLength);

						case 'i':
							return reader2.getInt32Array(arrayLength);

						case 'l':
							return reader2.getInt64Array(arrayLength);

					}

					break; // cannot happen but is required by the DeepScan

				default:
					throw new Error('THREE.FBXLoader: Unknown property type ' + type);

			}
		}
	}]);

	return BinaryParser;
}();

var FBXLoader_BinaryReader = function () {
	function BinaryReader(buffer, littleEndian) {
		classCallCheck_default()(this, BinaryReader);

		this.dv = new DataView(buffer);
		this.offset = 0;
		this.littleEndian = littleEndian !== undefined ? littleEndian : true;
		this._textDecoder = new TextDecoder();
	}

	createClass_default()(BinaryReader, [{
		key: 'getOffset',
		value: function getOffset() {

			return this.offset;
		}
	}, {
		key: 'size',
		value: function size() {

			return this.dv.buffer.byteLength;
		}
	}, {
		key: 'skip',
		value: function skip(length) {

			this.offset += length;
		}

		// seems like true/false representation depends on exporter.
		// true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
		// then sees LSB.

	}, {
		key: 'getBoolean',
		value: function getBoolean() {

			return (this.getUint8() & 1) === 1;
		}
	}, {
		key: 'getBooleanArray',
		value: function getBooleanArray(size) {

			var a = [];

			for (var i = 0; i < size; i++) {

				a.push(this.getBoolean());
			}

			return a;
		}
	}, {
		key: 'getUint8',
		value: function getUint8() {

			var value = this.dv.getUint8(this.offset);
			this.offset += 1;
			return value;
		}
	}, {
		key: 'getInt16',
		value: function getInt16() {

			var value = this.dv.getInt16(this.offset, this.littleEndian);
			this.offset += 2;
			return value;
		}
	}, {
		key: 'getInt32',
		value: function getInt32() {

			var value = this.dv.getInt32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		}
	}, {
		key: 'getInt32Array',
		value: function getInt32Array(size) {

			var a = [];

			for (var i = 0; i < size; i++) {

				a.push(this.getInt32());
			}

			return a;
		}
	}, {
		key: 'getUint32',
		value: function getUint32() {

			var value = this.dv.getUint32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		}

		// JavaScript doesn't support 64-bit integer so calculate this here
		// 1 << 32 will return 1 so using multiply operation instead here.
		// There's a possibility that this method returns wrong value if the value
		// is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
		// TODO: safely handle 64-bit integer

	}, {
		key: 'getInt64',
		value: function getInt64() {

			var low = void 0,
			    high = void 0;

			if (this.littleEndian) {

				low = this.getUint32();
				high = this.getUint32();
			} else {

				high = this.getUint32();
				low = this.getUint32();
			}

			// calculate negative value
			if (high & 0x80000000) {

				high = ~high & 0xFFFFFFFF;
				low = ~low & 0xFFFFFFFF;

				if (low === 0xFFFFFFFF) high = high + 1 & 0xFFFFFFFF;

				low = low + 1 & 0xFFFFFFFF;

				return -(high * 0x100000000 + low);
			}

			return high * 0x100000000 + low;
		}
	}, {
		key: 'getInt64Array',
		value: function getInt64Array(size) {

			var a = [];

			for (var i = 0; i < size; i++) {

				a.push(this.getInt64());
			}

			return a;
		}

		// Note: see getInt64() comment

	}, {
		key: 'getUint64',
		value: function getUint64() {

			var low = void 0,
			    high = void 0;

			if (this.littleEndian) {

				low = this.getUint32();
				high = this.getUint32();
			} else {

				high = this.getUint32();
				low = this.getUint32();
			}

			return high * 0x100000000 + low;
		}
	}, {
		key: 'getFloat32',
		value: function getFloat32() {

			var value = this.dv.getFloat32(this.offset, this.littleEndian);
			this.offset += 4;
			return value;
		}
	}, {
		key: 'getFloat32Array',
		value: function getFloat32Array(size) {

			var a = [];

			for (var i = 0; i < size; i++) {

				a.push(this.getFloat32());
			}

			return a;
		}
	}, {
		key: 'getFloat64',
		value: function getFloat64() {

			var value = this.dv.getFloat64(this.offset, this.littleEndian);
			this.offset += 8;
			return value;
		}
	}, {
		key: 'getFloat64Array',
		value: function getFloat64Array(size) {

			var a = [];

			for (var i = 0; i < size; i++) {

				a.push(this.getFloat64());
			}

			return a;
		}
	}, {
		key: 'getArrayBuffer',
		value: function getArrayBuffer(size) {

			var value = this.dv.buffer.slice(this.offset, this.offset + size);
			this.offset += size;
			return value;
		}
	}, {
		key: 'getString',
		value: function getString(size) {

			var start = this.offset;
			var a = new Uint8Array(this.dv.buffer, start, size);

			this.skip(size);

			var nullByte = a.indexOf(0);
			if (nullByte >= 0) a = new Uint8Array(this.dv.buffer, start, nullByte);

			return this._textDecoder.decode(a);
		}
	}]);

	return BinaryReader;
}();

// FBXTree holds a representation of the FBX data, returned by the TextParser ( FBX ASCII format)
// and BinaryParser( FBX Binary format)


var FBXLoader_FBXTree = function () {
	function FBXTree() {
		classCallCheck_default()(this, FBXTree);
	}

	createClass_default()(FBXTree, [{
		key: 'add',
		value: function add(key, val) {

			this[key] = val;
		}
	}]);

	return FBXTree;
}();

// ************** UTILITY FUNCTIONS **************

function isFbxFormatBinary(buffer) {

	var CORRECT = 'Kaydara FBX Binary  \0';

	return buffer.byteLength >= CORRECT.length && CORRECT === convertArrayBufferToString(buffer, 0, CORRECT.length);
}

function isFbxFormatASCII(text) {

	var CORRECT = ['K', 'a', 'y', 'd', 'a', 'r', 'a', '\\', 'F', 'B', 'X', '\\', 'B', 'i', 'n', 'a', 'r', 'y', '\\', '\\'];

	var cursor = 0;

	function read(offset) {

		var result = text[offset - 1];
		text = text.slice(cursor + offset);
		cursor++;
		return result;
	}

	for (var i = 0; i < CORRECT.length; ++i) {

		var num = read(1);
		if (num === CORRECT[i]) {

			return false;
		}
	}

	return true;
}

function getFbxVersion(text) {

	var versionRegExp = /FBXVersion: (\d+)/;
	var match = text.match(versionRegExp);

	if (match) {

		var version = parseInt(match[1]);
		return version;
	}

	throw new Error('THREE.FBXLoader: Cannot find the version number for the file given.');
}

// Converts FBX ticks into real time seconds.
function convertFBXTimeToSeconds(time) {

	return time / 46186158000;
}

var dataArray = [];

// extracts the data from the correct position in the FBX array based on indexing type
function getData(polygonVertexIndex, polygonIndex, vertexIndex, infoObject) {

	var index = void 0;

	switch (infoObject.mappingType) {

		case 'ByPolygonVertex':
			index = polygonVertexIndex;
			break;
		case 'ByPolygon':
			index = polygonIndex;
			break;
		case 'ByVertice':
			index = vertexIndex;
			break;
		case 'AllSame':
			index = infoObject.indices[0];
			break;
		default:
			console.warn('THREE.FBXLoader: unknown attribute mapping type ' + infoObject.mappingType);

	}

	if (infoObject.referenceType === 'IndexToDirect') index = infoObject.indices[index];

	var from = index * infoObject.dataSize;
	var to = from + infoObject.dataSize;

	return slice(dataArray, infoObject.buffer, from, to);
}

var tempEuler = new three_module["w" /* Euler */]();
var tempVec = new three_module["_41" /* Vector3 */]();

// generate transformation from FBX transform data
// ref: https://help.autodesk.com/view/FBX/2017/ENU/?guid=__files_GUID_10CDD63C_79C1_4F2D_BB28_AD2BE65A02ED_htm
// ref: http://docs.autodesk.com/FBX/2014/ENU/FBX-SDK-Documentation/index.html?url=cpp_ref/_transformations_2main_8cxx-example.html,topicNumber=cpp_ref__transformations_2main_8cxx_example_htmlfc10a1e1-b18d-4e72-9dc0-70d0f1959f5e
function generateTransform(transformData) {

	var lTranslationM = new three_module["_2" /* Matrix4 */]();
	var lPreRotationM = new three_module["_2" /* Matrix4 */]();
	var lRotationM = new three_module["_2" /* Matrix4 */]();
	var lPostRotationM = new three_module["_2" /* Matrix4 */]();

	var lScalingM = new three_module["_2" /* Matrix4 */]();
	var lScalingPivotM = new three_module["_2" /* Matrix4 */]();
	var lScalingOffsetM = new three_module["_2" /* Matrix4 */]();
	var lRotationOffsetM = new three_module["_2" /* Matrix4 */]();
	var lRotationPivotM = new three_module["_2" /* Matrix4 */]();

	var lParentGX = new three_module["_2" /* Matrix4 */]();
	var lParentLX = new three_module["_2" /* Matrix4 */]();
	var lGlobalT = new three_module["_2" /* Matrix4 */]();

	var inheritType = transformData.inheritType ? transformData.inheritType : 0;

	if (transformData.translation) lTranslationM.setPosition(tempVec.fromArray(transformData.translation));

	if (transformData.preRotation) {

		var array = transformData.preRotation.map(three_module["_0" /* MathUtils */].degToRad);
		array.push(transformData.eulerOrder || three_module["w" /* Euler */].DEFAULT_ORDER);
		lPreRotationM.makeRotationFromEuler(tempEuler.fromArray(array));
	}

	if (transformData.rotation) {

		var _array = transformData.rotation.map(three_module["_0" /* MathUtils */].degToRad);
		_array.push(transformData.eulerOrder || three_module["w" /* Euler */].DEFAULT_ORDER);
		lRotationM.makeRotationFromEuler(tempEuler.fromArray(_array));
	}

	if (transformData.postRotation) {

		var _array2 = transformData.postRotation.map(three_module["_0" /* MathUtils */].degToRad);
		_array2.push(transformData.eulerOrder || three_module["w" /* Euler */].DEFAULT_ORDER);
		lPostRotationM.makeRotationFromEuler(tempEuler.fromArray(_array2));
		lPostRotationM.invert();
	}

	if (transformData.scale) lScalingM.scale(tempVec.fromArray(transformData.scale));

	// Pivots and offsets
	if (transformData.scalingOffset) lScalingOffsetM.setPosition(tempVec.fromArray(transformData.scalingOffset));
	if (transformData.scalingPivot) lScalingPivotM.setPosition(tempVec.fromArray(transformData.scalingPivot));
	if (transformData.rotationOffset) lRotationOffsetM.setPosition(tempVec.fromArray(transformData.rotationOffset));
	if (transformData.rotationPivot) lRotationPivotM.setPosition(tempVec.fromArray(transformData.rotationPivot));

	// parent transform
	if (transformData.parentMatrixWorld) {

		lParentLX.copy(transformData.parentMatrix);
		lParentGX.copy(transformData.parentMatrixWorld);
	}

	var lLRM = lPreRotationM.clone().multiply(lRotationM).multiply(lPostRotationM);
	// Global Rotation
	var lParentGRM = new three_module["_2" /* Matrix4 */]();
	lParentGRM.extractRotation(lParentGX);

	// Global Shear*Scaling
	var lParentTM = new three_module["_2" /* Matrix4 */]();
	lParentTM.copyPosition(lParentGX);

	var lParentGRSM = lParentTM.clone().invert().multiply(lParentGX);
	var lParentGSM = lParentGRM.clone().invert().multiply(lParentGRSM);
	var lLSM = lScalingM;

	var lGlobalRS = new three_module["_2" /* Matrix4 */]();

	if (inheritType === 0) {

		lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM).multiply(lLSM);
	} else if (inheritType === 1) {

		lGlobalRS.copy(lParentGRM).multiply(lParentGSM).multiply(lLRM).multiply(lLSM);
	} else {

		var lParentLSM = new three_module["_2" /* Matrix4 */]().scale(new three_module["_41" /* Vector3 */]().setFromMatrixScale(lParentLX));
		var lParentLSM_inv = lParentLSM.clone().invert();
		var lParentGSM_noLocal = lParentGSM.clone().multiply(lParentLSM_inv);

		lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM_noLocal).multiply(lLSM);
	}

	var lRotationPivotM_inv = lRotationPivotM.clone().invert();
	var lScalingPivotM_inv = lScalingPivotM.clone().invert();
	// Calculate the local transform matrix
	var lTransform = lTranslationM.clone().multiply(lRotationOffsetM).multiply(lRotationPivotM).multiply(lPreRotationM).multiply(lRotationM).multiply(lPostRotationM).multiply(lRotationPivotM_inv).multiply(lScalingOffsetM).multiply(lScalingPivotM).multiply(lScalingM).multiply(lScalingPivotM_inv);

	var lLocalTWithAllPivotAndOffsetInfo = new three_module["_2" /* Matrix4 */]().copyPosition(lTransform);

	var lGlobalTranslation = lParentGX.clone().multiply(lLocalTWithAllPivotAndOffsetInfo);
	lGlobalT.copyPosition(lGlobalTranslation);

	lTransform = lGlobalT.clone().multiply(lGlobalRS);

	// from global to local
	lTransform.premultiply(lParentGX.invert());

	return lTransform;
}

// Returns the three.js intrinsic Euler order corresponding to FBX extrinsic Euler order
// ref: http://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_class_fbx_euler_html
function getEulerOrder(order) {

	order = order || 0;

	var enums = ['ZYX', // -> XYZ extrinsic
	'YZX', // -> XZY extrinsic
	'XZY', // -> YZX extrinsic
	'ZXY', // -> YXZ extrinsic
	'YXZ', // -> ZXY extrinsic
	'XYZ'];

	if (order === 6) {

		console.warn('THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.');
		return enums[0];
	}

	return enums[order];
}

// Parses comma separated list of numbers and returns them an array.
// Used internally by the TextParser
function parseNumberArray(value) {

	var array = value.split(',').map(function (val) {

		return parseFloat(val);
	});

	return array;
}

function convertArrayBufferToString(buffer, from, to) {

	if (from === undefined) from = 0;
	if (to === undefined) to = buffer.byteLength;

	return new TextDecoder().decode(new Uint8Array(buffer, from, to));
}

function append(a, b) {

	for (var i = 0, j = a.length, l = b.length; i < l; i++, j++) {

		a[j] = b[i];
	}
}

function slice(a, b, from, to) {

	for (var i = from, j = 0; i < to; i++, j++) {

		a[j] = b[i];
	}

	return a;
}

// inject array a2 into array a1 at index
function inject(a1, index, a2) {

	return a1.slice(0, index).concat(a2).concat(a1.slice(index));
}



/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "TmV0":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fZOM");
module.exports = __webpack_require__("FeBl").Object.values;


/***/ }),

/***/ "To3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("+E39");
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
var toObject = __webpack_require__("sB3e");
var IObject = __webpack_require__("MU5D");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("S82l")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "Trqf":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),

/***/ "U5ju":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("CXw9");
__webpack_require__("EqBC");
__webpack_require__("jKW+");
module.exports = __webpack_require__("FeBl").Promise;


/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "UvrK":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("kM2E");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("m9gC")('Map') });


/***/ }),

/***/ "V3tA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("R4wc");
module.exports = __webpack_require__("FeBl").Object.assign;


/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W3Iv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("wEtr"), __esModule: true };

/***/ }),

/***/ "X0uZ":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("kM2E");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "XFB5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("PlIm"), __esModule: true };

/***/ }),

/***/ "XVP1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("xH/j");
var getWeak = __webpack_require__("06OY").getWeak;
var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var anInstance = __webpack_require__("2KxR");
var forOf = __webpack_require__("NWt+");
var createArrayMethod = __webpack_require__("ALrJ");
var $has = __webpack_require__("D2L2");
var validate = __webpack_require__("LIJb");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "Xc4G":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "Xd32":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("5PlU");


/***/ }),

/***/ "Xjd4":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("9Bbf")('Map');


/***/ }),

/***/ "Xlla":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-slick-carousel"] = factory();
	else
		root["vue-slick-carousel"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0497":
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "217d":
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3b81":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42a0":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6ea2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("890c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "88bc":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "890c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8e95":
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__("c195");
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ "9020":
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a48b":
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__("0497");

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a623":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $every = __webpack_require__("b727").every;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "bcf7":
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__("9020");
var each = __webpack_require__("217d").each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c195":
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__("bcf7");
var Util = __webpack_require__("217d");
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c832":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "eaf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3b81");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f013":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdb2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7fe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/json2mq/index.js
var json2mq = __webpack_require__("a48b");
var json2mq_default = /*#__PURE__*/__webpack_require__.n(json2mq);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/mixinPropsUpdated.vue?vue&type=script&lang=js&



/* harmony default export */ var mixinPropsUpdatedvue_type_script_lang_js_ = ({
  computed: {
    isPropsUpdated: function isPropsUpdated() {
      var _this = this;

      // Read props that need to be listened for changes.
      Object.keys(this.$props).forEach(function (key) {
        return _this[key];
      }); // Return a different value each time. `Date.now()` is not guaranteed to be unique.
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      return this.updateSwitch = !this.updateSwitch;
    }
  },
  watch: {
    isPropsUpdated: function isPropsUpdated() {
      if (typeof this.onPropsUpdated === 'function') {
        this.onPropsUpdated();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixinPropsUpdated.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mixinPropsUpdatedvue_type_script_lang_js_ = (mixinPropsUpdatedvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/mixinPropsUpdated.vue
var mixinPropsUpdated_render, staticRenderFns




/* normalize component */

var component = normalizeComponent(
  src_mixinPropsUpdatedvue_type_script_lang_js_,
  mixinPropsUpdated_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mixinPropsUpdated = (component.exports);
// EXTERNAL MODULE: ./node_modules/lodash.pick/index.js
var lodash_pick = __webpack_require__("88bc");
var lodash_pick_default = /*#__PURE__*/__webpack_require__.n(lodash_pick);

// EXTERNAL MODULE: ./node_modules/lodash.assign/index.js
var lodash_assign = __webpack_require__("42a0");
var lodash_assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./node_modules/lodash.get/index.js
var lodash_get = __webpack_require__("c832");
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);

// CONCATENATED MODULE: ./src/vNodeUtils.js





var vNodeUtils_mergeVNodeData = function mergeVNodeData(vnode, name, obj) {
  if (!vnode) {
    return;
  }

  vnode.data = vnode.data || {};
  vnode.data[name] = _objectSpread2({}, vnode.data[name], {}, obj);
};
var setVNodeData = function setVNodeData(vnode, name, value) {
  if (!vnode) {
    return;
  }

  vnode.data = vnode.data || {};
  vnode.data[name] = value;
};
var DATA_KEYS = ['class', 'staticClass', 'style', 'attrs', 'props', 'domProps', 'on', 'nativeOn', 'directives', 'scopesSlots', 'slot', 'ref', 'key'];

function mutateKey(key) {
  return '' + key + "-cloned-cid";
}

function extractData(vnode, isComp) {
  var data = lodash_pick_default()(vnode.data, DATA_KEYS);

  if (isComp) {
    var cOpts = vnode.componentOptions;
    lodash_assign_default()(data, {
      props: cOpts.propsData,
      on: cOpts.listeners
    });
  }

  if (data.key) {
    data.key = mutateKey(data.key);
  }

  return data;
}

var cloneVNode = function cloneVNode(vnode) {
  // use the context that the original vnode was created in.
  var h = vnode.context && vnode.context.$createElement;
  var isComp = !!vnode.componentOptions;
  var isText = !vnode.tag; // this will also match comments but those will be dropped, essentially

  var children = isComp ? vnode.componentOptions.children : vnode.children;
  if (isText) return vnode.text;
  var data = extractData(vnode, isComp);
  var tag = isComp ? vnode.componentOptions.Ctor : vnode.tag;
  var childNodes = children ? children.map(function (c) {
    return cloneVNode(c);
  }) : undefined;
  return h(tag, data, childNodes);
};
var vNodeUtils_copyClassesFrom = function copyClassesFrom(vnode, from) {
  var _from$data = from.data,
      data = _from$data === void 0 ? {} : _from$data;
  setVNodeData(vnode, 'staticClass', data.staticClass);
  vNodeUtils_mergeVNodeData(vnode, 'class', _objectSpread2({}, data.class, {}, from));
};
var vNodeUtils_getData = function getData(vnode, path, defaultValue) {
  if (!vnode) {
    return;
  }

  var data = vnode.data || {};
  return typeof path === 'undefined' ? data : lodash_get_default()(data, path, defaultValue);
};
var vNodeUtils_getStyle = function getStyle(vnode) {
  return _objectSpread2({}, vNodeUtils_getData(vnode, 'staticStyle', {}), {}, vNodeUtils_getData(vnode, 'style', {}));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// CONCATENATED MODULE: ./src/innerSliderUtils.js















var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};
var innerSliderUtils_keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match('TEXTAREA|INPUT|SELECT') || !accessibility) return '';
  if (e.keyCode === 37) return rtl ? 'next' : 'previous';
  if (e.keyCode === 39) return rtl ? 'previous' : 'next';
  return '';
};
var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return 'left';
    }

    return 'right';
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return 'right';
    }

    return 'left';
  }
};
var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};
var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
}; // startIndex that needs to be present

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
};
var innerSliderUtils_changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === 'previous') {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === 'next') {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === 'dots') {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === 'children') {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread2({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === 'left') {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === 'right') {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === 'index') {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};
var filterUndefined = function filterUndefined(props) {
  return Object.keys(props).filter(function (key) {
    return props[key] !== undefined;
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
var filterUndefinedOrNull = function filterUndefinedOrNull(props) {
  return Object.keys(props).filter(function (key) {
    return props[key] !== undefined && props[key] !== null;
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
var innerSliderUtils_swipeStart = function swipeStart(e, swipe, draggable) {
  if (!swipe || !draggable && e.type.indexOf('mouse') !== -1) return '';
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var innerSliderUtils_swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left' || !canGoNext(spec) && swipeDirection === 'left') {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state['edgeDragged'] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state['swiped'] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread2({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state['swiping'] = true;
    e.preventDefault();
  }

  return state;
};
var innerSliderUtils_swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case 'left':
      case 'up':
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state['currentDirection'] = 0;
        break;

      case 'right':
      case 'down':
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state['currentDirection'] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state['triggerSlideHandler'] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state['trackStyle'] = getTrackAnimateCSS(_objectSpread2({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};
var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};
var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};
var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll('.slick-slide');
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
}; // given an object and a list of keys, return new object with given keys

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};
var PROP_KEYS = {
  TRACK: ['fade', 'cssEase', 'speed', 'infinite', 'centerMode', 'currentSlide', 'lazyLoad', 'lazyLoadedList', 'rtl', 'slideWidth', 'slideHeight', 'listHeight', 'vertical', 'slidesToShow', 'slidesToScroll', 'slideCount', 'trackStyle', 'variableWidth', 'unslick', 'centerPadding'],
  DOT: ['dotsClass', 'slideCount', 'slidesToShow', 'currentSlide', 'slidesToScroll', 'children', 'customPaging', 'infinite'],
  ARROW: ['infinite', 'centerMode', 'currentSlide', 'slideCount', 'slidesToShow', 'prevArrow', 'nextArrow']
}; // whether or not we can go next

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
};
var innerSliderUtils_slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread2({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread2({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread2({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread2({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
}; // get width of an element

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return 'left';
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return 'right';
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return 'up';
    } else {
      return 'down';
    }
  }

  return 'vertical';
}; // get initialized state

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = spec.children.length;
  var listWidth = Math.ceil(getWidth(spec.listRef));
  var trackWidth = Math.ceil(getWidth(spec.trackRef));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === 'string' && spec.centerPadding.slice(-1) === '%') {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = spec.listRef && getHeight(spec.listRef.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state['autoplaying'] = 'playing';
  }

  return state;
};
var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef.$el;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};
var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing:', spec);
}; // eslint-disable-line no-console

var innerSliderUtils_getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: '',
    WebkitTransition: ''
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
    var transform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
    var msTransform = !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)';
    style = _objectSpread2({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style['top'] = spec.left;
    } else {
      style['left'] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth + 'px';
  if (trackHeight) style.height = trackHeight + 'px'; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + 'px';
    } else {
      style.marginTop = spec.left + 'px';
    }
  }

  return style;
};
var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
  var style = innerSliderUtils_getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
    style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = 'top ' + spec.speed + 'ms ' + spec.cssEase;
    } else {
      style.transition = 'left ' + spec.speed + 'ms ' + spec.cssEase;
    }
  }

  return style;
};
// CONCATENATED MODULE: ./src/defaultProps.js



var defaultProps_props = {
  accessibility: {
    type: Boolean,
    default: true
  },
  adaptiveHeight: {
    type: Boolean,
    default: false
  },
  arrows: {
    type: Boolean,
    default: true
  },
  asNavFor: {
    type: Object,
    default: null
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  autoplaySpeed: {
    type: Number,
    default: 3000
  },
  centerMode: {
    type: Boolean,
    default: false
  },
  centerPadding: {
    type: String,
    default: '50px'
  },
  cssEase: {
    type: String,
    default: 'ease'
  },
  dots: {
    type: Boolean,
    default: false
  },
  dotsClass: {
    type: String,
    default: 'slick-dots'
  },
  draggable: {
    type: Boolean,
    default: true
  },
  edgeFriction: {
    type: Number,
    default: 0.35
  },
  fade: {
    type: Boolean,
    default: false
  },
  focusOnSelect: {
    type: Boolean,
    default: false
  },
  infinite: {
    type: Boolean,
    default: true
  },
  initialSlide: {
    type: Number,
    default: 0
  },
  lazyLoad: {
    type: String,
    default: null
  },
  pauseOnDotsHover: {
    type: Boolean,
    default: false
  },
  pauseOnFocus: {
    type: Boolean,
    default: false
  },
  pauseOnHover: {
    type: Boolean,
    default: true
  },
  responsive: {
    type: Array,
    default: null
  },
  rows: {
    type: Number,
    default: 1
  },
  rtl: {
    type: Boolean,
    default: false
  },
  slidesPerRow: {
    type: Number,
    default: 1
  },
  slidesToScroll: {
    type: Number,
    default: 1
  },
  slidesToShow: {
    type: Number,
    default: 1
  },
  speed: {
    type: Number,
    default: 500
  },
  swipe: {
    type: Boolean,
    default: true
  },
  swipeToSlide: {
    type: Boolean,
    default: false
  },
  touchMove: {
    type: Boolean,
    default: true
  },
  touchThreshold: {
    type: Number,
    default: 5
  },
  useCSS: {
    type: Boolean,
    default: true
  },
  useTransform: {
    type: Boolean,
    default: true
  },
  variableWidth: {
    type: Boolean,
    default: false
  },
  vertical: {
    type: Boolean,
    default: false
  },
  waitForAnimate: {
    type: Boolean,
    default: true
  }
};
var defaultValues = Object.keys(defaultProps_props).reduce(function (acc, key) {
  acc[key] = defaultProps_props[key].default;
  return acc;
}, {});
var types = Object.keys(defaultProps_props).reduce(function (acc, key) {
  acc[key] = defaultProps_props[key].type;
  return acc;
}, {});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js


function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js



function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("6dd8");

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("f7fe");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderTrack.vue?vue&type=script&lang=js&








var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned,
    'slick-current': slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = typeof spec.slideWidth === 'number' ? "".concat(spec.slideWidth, "px") : spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';

    if (spec.vertical) {
      style.top = "".concat(-spec.index * parseInt(spec.slideHeight), "px");
    } else {
      style.left = "".concat(-spec.index * parseInt(spec.slideWidth), "px");
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key != null && String(child.key) || fallbackKey;
};

/* harmony default export */ var SliderTrackvue_type_script_lang_js_ = ({
  name: 'SliderTrack',
  props: PROP_KEYS.TRACK,
  methods: {
    cloneSlide: function cloneSlide(slide, options) {
      var _this = this;

      var clone = cloneVNode(slide);
      clone.key = options.key;
      vNodeUtils_mergeVNodeData(clone, 'class', options.class);
      vNodeUtils_mergeVNodeData(clone, 'attrs', options.attrs);
      vNodeUtils_mergeVNodeData(clone, 'style', options.style);
      vNodeUtils_mergeVNodeData(clone, 'on', {
        click: function click(e) {
          vNodeUtils_getData(slide, 'on.click', function () {})(e);

          _this.$emit('childClicked', options.childOnClickOptions);
        }
      });
      return clone;
    },
    renderSlides: function renderSlides(spec, children) {
      var _this2 = this;

      var h = this.$createElement;
      var key;
      var slides = [];
      var preCloneSlides = [];
      var postCloneSlides = [];
      var childrenCount = children.length;
      var startIndex = lazyStartIndex(spec);
      var endIndex = lazyEndIndex(spec);
      children.forEach(function (elem, index) {
        var child;
        var childOnClickOptions = {
          message: 'children',
          index: index,
          slidesToScroll: spec.slidesToScroll,
          currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide

        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
          child = elem;
        } else {
          child = h("div");
        }

        var childStyle = getSlideStyle(_objectSpread2({}, spec, {
          index: index
        }));
        var slideClasses = getSlideClasses(_objectSpread2({}, spec, {
          index: index
        })); // push a cloned element of the desired slide

        slides.push(_this2.cloneSlide(child, {
          key: 'original' + getKey(child, index),
          class: slideClasses,
          style: _objectSpread2({
            outline: 'none'
          }, childStyle),
          attrs: {
            tabIndex: '-1',
            'data-index': index,
            'aria-hidden': "".concat(!slideClasses['slick-active'])
          },
          childOnClickOptions: childOnClickOptions
        })); // if slide needs to be precloned or postcloned

        if (spec.infinite && spec.fade === false && childrenCount > spec.slidesToShow) {
          var preCloneNo = childrenCount - index;

          if (preCloneNo <= getPreClones(spec) && childrenCount !== spec.slidesToShow) {
            key = -preCloneNo;

            if (key >= startIndex) {
              child = elem;
            }

            slideClasses = getSlideClasses(_objectSpread2({}, spec, {
              index: key
            }));
            preCloneSlides.push(_this2.cloneSlide(child, {
              key: 'precloned' + getKey(child, key),
              class: slideClasses,
              style: childStyle,
              attrs: {
                tabIndex: '-1',
                'data-index': key,
                'aria-hidden': "".concat(!slideClasses['slick-active'])
              },
              childOnClickOptions: childOnClickOptions
            }));
          }

          if (childrenCount !== spec.slidesToShow) {
            key = childrenCount + index;

            if (key < endIndex) {
              child = elem;
            }

            slideClasses = getSlideClasses(_objectSpread2({}, spec, {
              index: key
            }));
            postCloneSlides.push(_this2.cloneSlide(child, {
              key: 'postcloned' + getKey(child, key),
              class: slideClasses,
              style: childStyle,
              attrs: {
                tabIndex: '-1',
                'data-index': key,
                'aria-hidden': "".concat(!slideClasses['slick-active'])
              },
              childOnClickOptions: childOnClickOptions
            }));
          }
        }
      }, this);

      if (spec.rtl) {
        return preCloneSlides.concat(slides, postCloneSlides).reverse();
      } else {
        return preCloneSlides.concat(slides, postCloneSlides);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var slides = this.renderSlides(this.$props, this.$slots.default);
    return h("div", {
      "class": {
        'slick-track': true,
        'slick-center': this.$props.centerMode
      },
      "style": this.trackStyle
    }, [slides]);
  }
});
// CONCATENATED MODULE: ./src/SliderTrack.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderTrackvue_type_script_lang_js_ = (SliderTrackvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/SliderTrack.vue?vue&type=style&index=0&id=e4caeaf8&scoped=true&lang=css&
var SliderTrackvue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css_ = __webpack_require__("6ea2");

// CONCATENATED MODULE: ./src/SliderTrack.vue
var SliderTrack_render, SliderTrack_staticRenderFns





/* normalize component */

var SliderTrack_component = normalizeComponent(
  src_SliderTrackvue_type_script_lang_js_,
  SliderTrack_render,
  SliderTrack_staticRenderFns,
  false,
  null,
  "e4caeaf8",
  null
  
)

/* harmony default export */ var SliderTrack = (SliderTrack_component.exports);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderArrow.vue?vue&type=script&lang=js&




/* harmony default export */ var SliderArrowvue_type_script_lang_js_ = ({
  name: 'SliderArrow',
  props: [].concat(_toConsumableArray(PROP_KEYS.ARROW), ['type']),
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var classes = {
      'slick-arrow': true
    };
    var clickable = true;
    var arrow;
    var option = {
      currentSlide: this.currentSlide,
      slideCount: this.slideCount
    };

    if (this.type === 'previous') {
      classes['slick-prev'] = true;

      if (!this.infinite && (this.currentSlide === 0 || this.slideCount <= this.slidesToShow)) {
        classes['slick-disabled'] = true;
        clickable = false;
      }

      option.key = '0';
      arrow = this.prevArrow ? this.prevArrow(option)[0] : h("button", {
        "attrs": {
          "type": "button",
          "data-role": "none"
        },
        "style": "display: block;"
      }, ["Previous"]);
    } else {
      classes['slick-next'] = true;

      if (!canGoNext(this.$props)) {
        classes['slick-disabled'] = true;
        clickable = false;
      }

      option.key = '1';
      arrow = this.nextArrow ? this.nextArrow(option)[0] : h("button", {
        "attrs": {
          "type": "button",
          "data-role": "none"
        },
        "style": "display: block;"
      }, ["Next"]);
    }

    setVNodeData(arrow, 'key', option.key);
    vNodeUtils_mergeVNodeData(arrow, 'class', classes);
    vNodeUtils_mergeVNodeData(arrow, 'on', {
      click: function click() {
        if (clickable) {
          _this.$emit('arrowClicked', {
            message: _this.type
          });
        }
      }
    });
    return arrow;
  }
});
// CONCATENATED MODULE: ./src/SliderArrow.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderArrowvue_type_script_lang_js_ = (SliderArrowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/SliderArrow.vue?vue&type=style&index=0&id=21137603&scoped=true&lang=css&
var SliderArrowvue_type_style_index_0_id_21137603_scoped_true_lang_css_ = __webpack_require__("f013");

// CONCATENATED MODULE: ./src/SliderArrow.vue
var SliderArrow_render, SliderArrow_staticRenderFns





/* normalize component */

var SliderArrow_component = normalizeComponent(
  src_SliderArrowvue_type_script_lang_js_,
  SliderArrow_render,
  SliderArrow_staticRenderFns,
  false,
  null,
  "21137603",
  null
  
)

/* harmony default export */ var SliderArrow = (SliderArrow_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderDots.vue?vue&type=script&lang=js&







var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

/* harmony default export */ var SliderDotsvue_type_script_lang_js_ = ({
  name: 'SliderDots',
  props: PROP_KEYS.DOT,
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var dotCount = getDotCount({
      slideCount: this.slideCount,
      slidesToScroll: this.slidesToScroll,
      slidesToShow: this.slidesToShow,
      infinite: this.infinite
    }); // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458

    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
      var leftBound = i * _this.slidesToScroll;
      var rightBound = i * _this.slidesToScroll + (_this.slidesToScroll - 1);
      var className = {
        'slick-active': _this.currentSlide >= leftBound && _this.currentSlide <= rightBound
      };
      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this.slidesToScroll,
        currentSlide: _this.currentSlide
      };
      var customPaging = _this.customPaging ? _this.customPaging(i)[0] : h("button", [i + 1]);
      return h("li", {
        "key": i,
        "class": className,
        "on": {
          "click": function click() {
            return _this.$emit('dotClicked', dotOptions);
          }
        }
      }, [customPaging]);
    });
    var wrapperStyle = {
      display: 'block'
    };

    var wrapperClass = _defineProperty({}, this.dotsClass, true);

    return h("ul", {
      "style": wrapperStyle,
      "class": wrapperClass
    }, [dots]);
  }
});
// CONCATENATED MODULE: ./src/SliderDots.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderDotsvue_type_script_lang_js_ = (SliderDotsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/SliderDots.vue
var SliderDots_render, SliderDots_staticRenderFns




/* normalize component */

var SliderDots_component = normalizeComponent(
  src_SliderDotsvue_type_script_lang_js_,
  SliderDots_render,
  SliderDots_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SliderDots = (SliderDots_component.exports);
// CONCATENATED MODULE: ./src/initialState.js
/* harmony default export */ var initialState = ({
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/InnerSlider.vue?vue&type=script&lang=js&























/* harmony default export */ var InnerSlidervue_type_script_lang_js_ = ({
  name: 'InnerSlider',
  components: {
    SliderTrack: SliderTrack,
    SliderArrow: SliderArrow,
    SliderDots: SliderDots
  },
  mixins: [mixinPropsUpdated],
  inheritAttrs: false,
  props: _objectSpread2({}, defaultProps_props, {
    unslick: {
      type: Boolean,
      default: false
    },
    prevArrow: Function,
    nextArrow: Function,
    customPaging: Function
  }),
  data: function data() {
    return _objectSpread2({}, initialState, {
      currentSlide: this.initialSlide
    });
  },
  computed: {
    slideCount: function slideCount() {
      return this.$slots.default.length;
    },
    spec: function spec() {
      return _objectSpread2({}, this.$props, {}, this.$data, {
        slideCount: this.slideCount
      });
    }
  },
  created: function created() {
    // non-reactive data
    this.callbackTimers = [];
    this.clickable = true;
    this.debouncedResize = null;
    this.ssrInit();
    this.$parent.$emit('init');

    if (this.lazyLoad) {
      var slidesToLoad = getOnDemandLazySlides(this.spec);

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var spec = _objectSpread2({
      listRef: this.$refs.list,
      trackRef: this.$refs.track,
      children: this.$slots.default
    }, this.$props);

    this.updateState(spec, true);
    this.adaptHeight();

    if (this.autoPlay) {
      this.autoPlay('update');
    }

    if (this.lazyLoad === 'progressive') {
      this.lazyLoadTimer = setInterval(this.progressiveLazyLoad, 1000);
    }

    this.ro = new ResizeObserver_es["a" /* default */](function () {
      if (_this.animating) {
        _this.onWindowResized(false); // don't set trackStyle hence don't break animation


        _this.callbackTimers.push(setTimeout(function () {
          return _this.onWindowResized();
        }, _this.speed));
      } else {
        _this.onWindowResized();
      }
    });
    this.ro.observe(this.$refs.list);
    Array.prototype.forEach.call(this.$refs.list.querySelectorAll('.slick-slide'), function (slide) {
      slide.onfocus = _this.pauseOnFocus ? _this.onSlideFocus : null;
      slide.onblur = _this.pauseOnFocus ? _this.onSlideBlur : null;
    });

    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  updated: function updated() {
    this.checkImagesLoad();
    this.$parent.$emit('reInit');

    if (this.lazyLoad) {
      var slidesToLoad = getOnDemandLazySlides(_objectSpread2({}, this.$props, {}, this.$data));

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }
    }

    this.adaptHeight();
  },
  beforeDestroy: function beforeDestroy() {
    this.ro.unobserve(this.$refs.list);

    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }

    if (this.lazyLoadTimer) {
      clearInterval(this.lazyLoadTimer);
    }

    if (this.callbackTimers.length) {
      this.callbackTimers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.callbackTimers = [];
    }

    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }

    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
    }
  },
  methods: {
    onPropsUpdated: function onPropsUpdated() {
      var nextProps = this.$props;

      var spec = _objectSpread2({
        listRef: this.$refs.list,
        trackRef: this.$refs.track,
        children: this.$slots.default
      }, nextProps, {}, this.$data);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(this.$props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === 'object' || typeof nextProps[key] === 'function') {
          continue;
        }

        if (nextProps[key] !== this.$props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      this.updateState(spec, setTrackStyle);

      if (this.currentSlide >= this.slideCount) {
        this.changeSlide({
          message: 'index',
          index: this.slideCount - nextProps.slidesToShow,
          currentSlide: this.currentSlide
        });
      }

      if (nextProps.autoplay) {
        this.autoPlay('update');
      } else {
        this.pause('paused');
      }
    },
    updateState: function updateState(spec, setTrackStyle) {
      var updatedState = initializedState(spec);
      spec = _objectSpread2({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = getTrackLeft(spec);
      spec = _objectSpread2({}, spec, {
        left: targetLeft
      });
      var trackStyle = innerSliderUtils_getTrackCSS(spec);

      if (setTrackStyle || this.slideCount !== spec.children.length) {
        updatedState['trackStyle'] = trackStyle;
      }

      Object.assign(this.$data, updatedState);
    },
    adaptHeight: function adaptHeight() {
      if (this.adaptiveHeight && this.$refs.list) {
        var elem = this.$refs.list.querySelector("[data-index=\"".concat(this.currentSlide, "\"]"));
        this.$refs.list.style.height = getHeight(elem) + 'px';
      }
    },
    ssrInit: function ssrInit() {
      var preClones = getPreClones(this.spec);
      var postClones = getPostClones(this.spec);

      if (this.variableWidth) {
        var trackWidth = [],
            trackLeft = [];
        var childrenWidths = [];
        this.$slots.default.forEach(function (child) {
          var _getStyle = vNodeUtils_getStyle(child),
              width = _getStyle.width;

          childrenWidths.push(width);
          trackWidth.push(width);
        });

        for (var i = 0; i < preClones; i++) {
          trackLeft.push(childrenWidths[childrenWidths.length - 1 - i]);
          trackWidth.push(childrenWidths[childrenWidths.length - 1 - i]);
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          trackWidth.push(childrenWidths[_i2]);
        }

        for (var _i3 = 0; _i3 < this.currentSlide; _i3++) {
          trackLeft.push(childrenWidths[_i3]);
        } // filter undefined


        trackWidth = trackWidth.filter(function (o) {
          return o;
        });
        trackLeft = trackLeft.filter(function (o) {
          return o;
        });
        var trackStyle = {
          width: "calc(".concat(trackWidth.join(' + '), ")"),
          left: "calc(".concat(trackLeft.map(function (o) {
            return "-".concat(o);
          }).join(' + '), ")")
        };

        if (this.centerMode) {
          var currentWidth = childrenWidths[this.currentSlide];
          trackStyle.left = "calc(".concat(trackLeft.map(function (o) {
            return "-".concat(o);
          }).join(' + '), " + (100% - ").concat(currentWidth, ") / 2 )");
        }

        this.trackStyle = trackStyle;
      } else {
        var slideCount = preClones + postClones + this.slideCount;

        var _trackWidth = 100 / this.slidesToShow * slideCount;

        var slideWidth = 100 / slideCount;

        var _trackLeft = -slideWidth * (preClones + this.currentSlide) * _trackWidth / 100;

        if (this.centerMode) {
          _trackLeft += (100 - slideWidth * _trackWidth / 100) / 2;
        }

        this.slideWidth = slideWidth + '%';
        this.trackStyle = {
          width: _trackWidth + '%',
          left: _trackLeft + '%'
        };
      }
    },
    slideHandler: function slideHandler(index) {
      var _this2 = this;

      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var asNavFor = this.asNavFor,
          speed = this.speed; // capture currentslide before state is updated

      var currentSlide = this.currentSlide;

      var _slideHandler2 = innerSliderUtils_slideHandler(_objectSpread2({
        index: index
      }, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        useCSS: this.useCSS && !dontAnimate
      })),
          state = _slideHandler2.state,
          nextState = _slideHandler2.nextState;

      if (!state) return;
      this.$parent.$emit('beforeChange', currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this2.lazyLoadedList.indexOf(value) < 0;
      });

      if (slidesToLoad.length) {
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }

      Object.assign(this.$data, state);

      if (asNavFor) {
        asNavFor.goTo(index);
      }

      if (!nextState) return;
      this.animationEndCallback = setTimeout(function () {
        var animating = nextState.animating,
            firstBatch = _objectWithoutProperties(nextState, ["animating"]);

        Object.assign(_this2.$data, firstBatch);

        _this2.callbackTimers.push(setTimeout(function () {
          _this2.animating = animating;
        }, 10));

        _this2.$parent.$emit('afterChange', state.currentSlide); // delete this.animationEndCallback


        _this2.animationEndCallback = undefined;
      }, speed);
    },
    onWindowResized: function onWindowResized(setTrackStyle) {
      var _this3 = this;

      if (this.debouncedResize) this.debouncedResize.cancel();
      this.debouncedResize = lodash_debounce_default()(function () {
        return _this3.resizeWindow(setTrackStyle);
      }, 50);
      this.debouncedResize();
    },
    resizeWindow: function resizeWindow() {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!(this.$refs.track && this.$refs.track.$el)) {
        return;
      }

      var spec = _objectSpread2({
        listRef: this.$refs.list,
        trackRef: this.$refs.track,
        children: this.$slots.default
      }, this.$props, {}, this.$data);

      this.updateState(spec, setTrackStyle);

      if (this.autoplay) {
        this.autoPlay('update');
      } else {
        this.pause('paused');
      } // animating state should be cleared while resizing, otherwise autoplay stops working


      this.animating = false;
      clearTimeout(this.animationEndCallback); // delete this.animationEndCallback

      this.animationEndCallback = undefined;
    },
    checkImagesLoad: function checkImagesLoad() {
      var _this4 = this;

      var images = this.$refs.list.querySelectorAll('.slick-slide img');
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this4.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this4.lazyLoad) {
            image.onload = function () {
              _this4.adaptHeight();

              _this4.callbackTimers.push(setTimeout(_this4.onWindowResized, _this4.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();

              _this4.$parent.$emit('lazyLoadError');
            };
          }
        }
      });
    },
    progressiveLazyLoad: function progressiveLazyLoad() {
      var slidesToLoad = [];

      var spec = _objectSpread2({}, this.$props, {}, this.$data);

      for (var index = this.currentSlide; index < this.slideCount + getPostClones(spec); index++) {
        if (this.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = this.currentSlide - 1; _index >= -getPreClones(spec); _index--) {
        if (this.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      } else {
        if (this.lazyLoadTimer) {
          clearInterval(this.lazyLoadTimer); // delete this.lazyLoadTimer;

          this.lazyLoadTimer = undefined;
        }
      }
    },
    clickHandler: function clickHandler(e) {
      if (this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      this.clickable = true;
    },
    keyHandler: function keyHandler(e) {
      var dir = innerSliderUtils_keyHandler(e, this.accessibility, this.rtl);

      dir !== '' && this.changeSlide({
        message: dir
      });
    },
    changeSlide: function changeSlide(options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread2({}, this.$props, {}, this.$data);

      var targetSlide = innerSliderUtils_changeSlide(spec, options);

      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        this.slideHandler(targetSlide, dontAnimate);
      } else {
        this.slideHandler(targetSlide);
      }
    },
    swipeStart: function swipeStart(e) {
      if (this.verticalSwiping) {
        this.disableBodyScroll();
      }

      var state = innerSliderUtils_swipeStart(e, this.swipe, this.draggable);

      if (state !== '') {
        Object.assign(this.$data, state);
      }
    },
    swipeMove: function swipeMove(e) {
      var _this5 = this;

      var state = innerSliderUtils_swipeMove(e, _objectSpread2({}, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        listRef: this.$refs.list,
        slideIndex: this.currentSlide,
        onEdge: function onEdge(e) {
          return _this5.$parent.$emit('edge', e);
        },
        swipeEvent: function swipeEvent(e) {
          return _this5.$parent.$emit('swipe', e);
        }
      }));

      if (!state) return;

      if (state['swiping']) {
        this.clickable = false;
      }

      Object.assign(this.$data, state);
    },
    swipeEnd: function swipeEnd(e) {
      var state = innerSliderUtils_swipeEnd(e, _objectSpread2({}, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        listRef: this.$refs.list,
        slideIndex: this.currentSlide
      }));

      if (!state) return;
      var triggerSlideHandler = state['triggerSlideHandler']; // delete state["triggerSlideHandler"];

      this.triggerSlideHandler = undefined;
      Object.assign(this.$data, state);
      if (triggerSlideHandler === undefined) return;
      this.slideHandler(triggerSlideHandler);

      if (this.verticalSwiping) {
        this.enableBodyScroll();
      }
    },
    prev: function prev() {
      var _this6 = this;

      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      this.callbackTimers.push(setTimeout(function () {
        return _this6.changeSlide({
          message: 'previous'
        });
      }, 0));
    },
    next: function next() {
      var _this7 = this;

      this.callbackTimers.push(setTimeout(function () {
        return _this7.changeSlide({
          message: 'next'
        });
      }, 0));
    },
    goTo: function goTo(slide) {
      var _this8 = this;

      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return '';
      this.callbackTimers.push(setTimeout(function () {
        return _this8.changeSlide({
          message: 'index',
          index: slide,
          currentSlide: _this8.currentSlide
        }, dontAnimate);
      }, 0));
    },
    play: function play() {
      var nextIndex;

      if (this.rtl) {
        nextIndex = this.currentSlide - this.slidesToScroll;
      } else {
        if (canGoNext(_objectSpread2({}, this.$props, {}, this.$data))) {
          nextIndex = this.currentSlide + this.slidesToScroll;
        } else {
          return false;
        }
      }

      this.slideHandler(nextIndex);
    },
    autoPlay: function autoPlay(playType) {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
      }

      var autoplaying = this.autoplaying;

      if (playType === 'update') {
        if (autoplaying === 'hovered' || autoplaying === 'focused' || autoplaying === 'paused') {
          return;
        }
      } else if (playType === 'leave') {
        if (autoplaying === 'paused' || autoplaying === 'focused') {
          return;
        }
      } else if (playType === 'blur') {
        if (autoplaying === 'paused' || autoplaying === 'hovered') {
          return;
        }
      }

      this.autoplayTimer = setInterval(this.play, this.autoplaySpeed + 50);
      this.autoplaying = 'playing';
    },
    pause: function pause(pauseType) {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      var autoplaying = this.autoplaying;

      if (pauseType === 'paused') {
        this.autoplaying = 'paused';
      } else if (pauseType === 'focused') {
        if (autoplaying === 'hovered' || autoplaying === 'playing') {
          this.autoplaying = 'focused';
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === 'playing') {
          this.autoplaying = 'hovered';
        }
      }
    },
    onDotsOver: function onDotsOver() {
      this.autoplay && this.pause('hovered');
    },
    onDotsLeave: function onDotsLeave() {
      this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
    },
    onTrackOver: function onTrackOver() {
      this.autoplay && this.pause('hovered');
    },
    onTrackLeave: function onTrackLeave() {
      this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
    },
    onSlideFocus: function onSlideFocus() {
      this.autoplay && this.pause('focused');
    },
    onSlideBlur: function onSlideBlur() {
      this.autoplay && this.autoplaying === 'focused' && this.autoPlay('blur');
    },
    selectHandler: function selectHandler(options) {
      if (this.focusOnSelect) {
        this.changeSlide(options);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var className = {
      'slick-slider': true,
      'slick-initialized': true,
      'slick-vertical': this.vertical
    };
    var trackProps = extractObject(this.spec, PROP_KEYS.TRACK);
    trackProps = filterUndefined(_objectSpread2({}, trackProps));
    var pauseOnHover = this.pauseOnHover;
    var trackNativeOn = filterUndefined({
      mouseenter: pauseOnHover ? this.onTrackOver : undefined,
      mouseover: pauseOnHover ? this.onTrackOver : undefined,
      mouseleave: pauseOnHover ? this.onTrackLeave : undefined
    });
    var dots;

    if (this.dots === true && this.slideCount >= this.slidesToShow) {
      var dotProps = extractObject(this.spec, PROP_KEYS.DOT);
      var pauseOnDotsHover = this.pauseOnDotsHover;
      var dotNativeOn = filterUndefined({
        mouseenter: pauseOnDotsHover ? this.onDotsLeave : undefined,
        mouseover: pauseOnDotsHover ? this.onDotsOver : undefined,
        mouseleave: pauseOnDotsHover ? this.onDotsLeave : undefined
      });
      dots = h(SliderDots, {
        "props": _objectSpread2({}, dotProps),
        "nativeOn": _objectSpread2({}, dotNativeOn),
        "on": {
          "dotClicked": this.changeSlide
        }
      });
    }

    var prevArrow, nextArrow;
    var arrowProps = extractObject(this.spec, PROP_KEYS.ARROW);

    if (this.arrows) {
      prevArrow = h(SliderArrow, {
        "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
          type: 'previous'
        })),
        "on": {
          "arrowClicked": this.changeSlide
        }
      });
      nextArrow = h(SliderArrow, {
        "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
          type: 'next'
        })),
        "on": {
          "arrowClicked": this.changeSlide
        }
      });
    }

    var verticalHeightStyle = {};

    if (this.vertical) {
      verticalHeightStyle = {
        height: "".concat(this.listHeight, "px")
      };
    }

    var centerPaddingStyle = {};

    if (this.vertical === false) {
      if (this.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.centerPadding
        };
      }
    } else {
      if (this.centerMode === true) {
        centerPaddingStyle = {
          padding: this.centerPadding + ' 0px'
        };
      }
    }

    var listStyle = _objectSpread2({}, this.$parent.$vnode.data.style);

    if (!this.unslick) {
      listStyle = _objectSpread2({}, listStyle, {}, filterUndefinedOrNull(verticalHeightStyle), {}, centerPaddingStyle);
    }

    var accessibility = this.accessibility,
        dragging = this.dragging,
        touchMove = this.touchMove;
    var listOn = filterUndefined({
      click: this.clickHandler,
      mousedown: touchMove ? this.swipeStart : undefined,
      mousemove: dragging && touchMove ? this.swipeMove : undefined,
      mouseup: touchMove ? this.swipeEnd : undefined,
      mouseleave: dragging && touchMove ? this.swipeEnd : undefined,
      touchstart: touchMove ? this.swipeStart : undefined,
      touchmove: dragging && touchMove ? this.swipeMove : undefined,
      touchend: touchMove ? this.swipeEnd : undefined,
      touchcancel: dragging && touchMove ? this.swipeEnd : undefined,
      keydown: accessibility ? this.keyHandler : undefined
    });
    return h("div", {
      "class": className,
      "attrs": {
        "dir": !this.unslick ? 'ltr' : false
      }
    }, [!this.unslick ? prevArrow : '', h("div", {
      "ref": "list",
      "class": 'slick-list',
      "on": _objectSpread2({}, listOn),
      "style": listStyle
    }, [h(SliderTrack, {
      "ref": "track",
      "props": _objectSpread2({}, trackProps),
      "nativeOn": _objectSpread2({}, trackNativeOn),
      "on": {
        "childClicked": this.selectHandler
      }
    }, [this.$slots.default])]), !this.unslick ? nextArrow : '', !this.unslick ? dots : '']);
  }
});
// CONCATENATED MODULE: ./src/InnerSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_InnerSlidervue_type_script_lang_js_ = (InnerSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/InnerSlider.vue?vue&type=style&index=0&id=3d1a4f76&scoped=true&lang=css&
var InnerSlidervue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css_ = __webpack_require__("eaf9");

// CONCATENATED MODULE: ./src/InnerSlider.vue
var InnerSlider_render, InnerSlider_staticRenderFns





/* normalize component */

var InnerSlider_component = normalizeComponent(
  src_InnerSlidervue_type_script_lang_js_,
  InnerSlider_render,
  InnerSlider_staticRenderFns,
  false,
  null,
  "3d1a4f76",
  null
  
)

/* harmony default export */ var InnerSlider = (InnerSlider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VueSlickCarousel.vue?vue&type=script&lang=js&















var enquire = canUseDOM() && __webpack_require__("8e95");

/* harmony default export */ var VueSlickCarouselvue_type_script_lang_js_ = ({
  name: 'VueSlickCarousel',
  components: {
    InnerSlider: InnerSlider
  },
  mixins: [mixinPropsUpdated],
  inheritAttrs: false,
  props: defaultProps_props,
  data: function data() {
    return {
      breakpoint: null
    };
  },
  computed: {
    settings: function settings() {
      var _this = this;

      var props = filterUndefined(this.$props);
      var settings;
      var newProps;

      if (this.breakpoint) {
        newProps = this.responsive.filter(function (resp) {
          return resp.breakpoint === _this.breakpoint;
        });
        settings = newProps[0].settings === 'unslick' ? 'unslick' : _objectSpread2({}, defaultValues, {}, props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread2({}, defaultValues, {}, props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // rows and slidesPerRow logic is handled here


      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        // eslint-disable-next-line no-console
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      return settings;
    }
  },
  created: function created() {
    this.makeBreakpoints();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearBreakpoints();
  },
  methods: {
    prev: function prev() {
      this.$refs.innerSlider.prev();
    },
    next: function next() {
      this.$refs.innerSlider.next();
    },
    goTo: function goTo(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.$refs.innerSlider.goTo(slide, dontAnimate);
    },
    pause: function pause() {
      this.$refs.innerSlider.pause('paused');
    },
    play: function play() {
      this.$refs.innerSlider.autoPlay('play');
    },
    onPropsUpdated: function onPropsUpdated() {
      this.clearBreakpoints();
      this.makeBreakpoints();
    },
    clearBreakpoints: function clearBreakpoints() {
      this.responsiveMediaHandlers.forEach(function (obj) {
        return enquire.unregister(obj.query, obj.handler);
      });
      this.responsiveMediaHandlers = [];
    },
    media: function media(query, handler) {
      // javascript handler for  css media query
      // when not using server side rendering
      if (!canUseDOM()) {
        return;
      }

      enquire.register(query, handler);
      this.responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    },
    makeBreakpoints: function makeBreakpoints() {
      var _this2 = this;

      this.breakpoint = null;
      this.responsiveMediaHandlers = []; // handles responsive breakpoints

      if (this.responsive) {
        var breakpoints = this.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var mediaQuery = json2mq_default()({
            minWidth: index === 0 ? 0 : breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });

          _this2.media(mediaQuery, function () {
            _this2.breakpoint = breakpoint;
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = json2mq_default()({
          minWidth: breakpoints.slice(-1)[0]
        });
        this.media(query, function () {
          _this2.breakpoint = null;
        });
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var settings = this.settings;
    var children = this.$slots.default || [];

    if (settings === 'unslick') {
      return h("div", {
        "class": "regular slider"
      }, [children]);
    }

    settings.prevArrow = this.$scopedSlots.prevArrow;
    settings.nextArrow = this.$scopedSlots.nextArrow;
    settings.customPaging = this.$scopedSlots.customPaging;
    children = children.filter(function (child) {
      return !!child.tag;
    });
    var newChildren = [];
    var currentWidth = null;

    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];

      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];

        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && vNodeUtils_getStyle(children[k])) {
            currentWidth = vNodeUtils_getStyle(children[k]).width;
          }

          if (k >= children.length) break;
          var clonedVNode = cloneVNode(children[k]);
          setVNodeData(clonedVNode, 'key', 100 * i + 10 * j + k);
          vNodeUtils_mergeVNodeData(clonedVNode, 'attrs', {
            tabIndex: -1
          });
          vNodeUtils_mergeVNodeData(clonedVNode, 'style', {
            width: "".concat(100 / settings.slidesPerRow, "%"),
            display: 'inline-block'
          });
          row.push(clonedVNode);
        }

        newSlide.push(h("div", {
          "key": 10 * i + j
        }, [row]));
      }

      if (settings.variableWidth) {
        newChildren.push(h("div", {
          "key": i,
          "style": {
            width: currentWidth
          }
        }, [newSlide]));
      } else {
        newChildren.push(h("div", {
          "key": i
        }, [newSlide]));
      }
    }

    if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }

    return h(InnerSlider, {
      "ref": "innerSlider",
      "props": _objectSpread2({}, settings),
      "key": Object.values(settings).join('')
    }, [newChildren]);
  }
});
// CONCATENATED MODULE: ./src/VueSlickCarousel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_VueSlickCarouselvue_type_script_lang_js_ = (VueSlickCarouselvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/VueSlickCarousel.vue
var VueSlickCarousel_render, VueSlickCarousel_staticRenderFns




/* normalize component */

var VueSlickCarousel_component = normalizeComponent(
  src_VueSlickCarouselvue_type_script_lang_js_,
  VueSlickCarousel_render,
  VueSlickCarousel_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VueSlickCarousel = (VueSlickCarousel_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (VueSlickCarousel);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdb2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vue-slick-carousel.umd.js.map

/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("jyFz");


/***/ }),

/***/ "Y+qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loading__ = __webpack_require__("Bfwr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_plugin_helper__ = __webpack_require__("+Ixu");




var $vm = void 0;
var watcher = void 0;
var delayTime = null;

var plugin = {
  install: function install(vue, options) {
    var Loading = vue.extend(__WEBPACK_IMPORTED_MODULE_1__components_loading__["a" /* default */]);

    if (!$vm) {
      $vm = new Loading({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }

    var loading = {
      show: function show() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        // destroy watcher
        watcher && watcher();
        if (typeof options === 'string') {
          $vm.text = options;
        } else if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_2__libs_plugin_helper__["a" /* mergeOptions */])($vm, options);
        }
        if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === 'object' && options.onShow || options.onHide) {
          watcher = $vm.$watch('show', function (val) {
            val && options.onShow && options.onShow($vm);
            val === false && options.onHide && options.onHide($vm);
          });
        }
        delayTime && clearTimeout(delayTime);
        delayTime = setTimeout(function () {
          $vm.show = true;
        }, options.delay || 0);
      },
      hide: function hide() {
        if (delayTime) {
          clearTimeout(delayTime);
          delayTime = null;
        }
        $vm.show = false;
      },
      isVisible: function isVisible() {
        return $vm.show;
      }
    };

    // all Vux's plugins are included in this.$vux
    if (!vue.$vux) {
      vue.$vux = {
        loading: loading
      };
    } else {
      vue.$vux.loading = loading;
    }

    vue.mixin({
      created: function created() {
        this.$vux = vue.$vux;
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (plugin);
var install = plugin.install;

/***/ }),

/***/ "Y5Mq":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("kM2E");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "YeRv":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "ZaQb":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("EqjI");
var anObject = __webpack_require__("77Pl");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("+ZMJ")(Function.call, __webpack_require__("LKZe").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "Zor0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// used by radio and popup-radio

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    options: {
      type: Array,
      required: true
    },
    value: [String, Number],
    fillMode: {
      type: Boolean,
      default: false
    },
    fillPlaceholder: {
      type: String,
      default: '其他'
    },
    fillLabel: {
      type: String,
      default: '其他'
    },
    disabled: Boolean,
    selectedLabelStyle: Object
  };
});

/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Zujg":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("kM2E");

$export($export.S, 'Math', { sign: __webpack_require__("9iXT") });


/***/ }),

/***/ "Zx67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fS6E"), __esModule: true };

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("/n6Q"), __esModule: true };

/***/ }),

/***/ "a1FJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("1Obu"), __esModule: true };

/***/ }),

/***/ "aFK5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("gAsd"), __esModule: true };

/***/ }),

/***/ "aY9x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var each = __webpack_require__("ALrJ")(0);
var redefine = __webpack_require__("880/");
var meta = __webpack_require__("06OY");
var assign = __webpack_require__("To3L");
var weak = __webpack_require__("XVP1");
var isObject = __webpack_require__("EqjI");
var validate = __webpack_require__("LIJb");
var NATIVE_WEAK_MAP = __webpack_require__("LIJb");
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("qo66")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "bBGs":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("Ff/Y"), __webpack_require__("PIk1"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "bRrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var dP = __webpack_require__("evD5");
var DESCRIPTORS = __webpack_require__("+E39");
var SPECIES = __webpack_require__("dSzd")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "bqnK":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("HpRW")('Map');


/***/ }),

/***/ "c/Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("5zde"), __esModule: true };

/***/ }),

/***/ "c45H":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1alW");
module.exports = __webpack_require__("FeBl").Number.isInteger;


/***/ }),

/***/ "cEdU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function (value) {
  if (!value) {
    return false;
  }
  return Object.prototype.toString.call(value) === '[object Array]';
});

/***/ }),

/***/ "cGG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__ = __webpack_require__("AMV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptors__ = __webpack_require__("jJmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_is_iterable__ = __webpack_require__("us/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_is_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_is_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol_to_string_tag__ = __webpack_require__("a1FJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol_to_string_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol_to_string_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_bind_js__ = __webpack_require__("JP+z");
















// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;
var getPrototypeOf = __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default.a;


var kindOf = function (cache) {
  return function (thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
}(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default()(null));

var kindOfTest = function kindOfTest(type) {
  type = type.toLowerCase();
  return function (thing) {
    return kindOf(thing) === type;
  };
};

var typeOfTest = function typeOfTest(type) {
  return function (thing) {
    return (typeof thing === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(thing)) === type;
  };
};

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
var isArray = Array.isArray;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */

var isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result = void 0;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
var isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
var isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
var isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
var isObject = function isObject(thing) {
  return thing !== null && (typeof thing === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(thing)) === 'object';
};

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
var isBoolean = function isBoolean(thing) {
  return thing === true || thing === false;
};

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
var isPlainObject = function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_get_prototype_of___default()(prototype) === null) && !(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol_to_string_tag___default.a in val) && !__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_is_iterable___default()(val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
var isStream = function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
};

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
var isFormData = function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (typeof FormData === 'function' && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
var trim = function trim(str) {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$allOwnKeys = _ref.allOwnKeys,
      allOwnKeys = _ref$allOwnKeys === undefined ? false : _ref$allOwnKeys;

  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  var i = void 0;
  var l = void 0;

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_typeof___default()(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    var keys = allOwnKeys ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_names___default()(obj) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(obj);
    var len = keys.length;
    var key = void 0;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  var keys = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(obj);
  var i = keys.length;
  var _key = void 0;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

var _global = function () {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
}();

var isContextDefined = function isContextDefined(context) {
  return !isUndefined(context) && context !== _global;
};

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var _ref2 = isContextDefined(this) && this || {},
      caseless = _ref2.caseless;

  var result = {};
  var assignValue = function assignValue(val, key) {
    var targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (var i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
var extend = function extend(a, b, thisArg) {
  var _ref3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      allOwnKeys = _ref3.allOwnKeys;

  forEach(b, function (val, key) {
    if (thisArg && isFunction(val)) {
      a[key] = Object(__WEBPACK_IMPORTED_MODULE_12__helpers_bind_js__["a" /* default */])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys: allOwnKeys });
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
var stripBOM = function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
var inherits = function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_create___default()(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
var toFlatObject = function toFlatObject(sourceObj, destObj, filter, propFilter) {
  var props = void 0;
  var i = void 0;
  var prop = void 0;
  var merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_names___default()(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
var endsWith = function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};

/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
var toArray = function toArray(thing) {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  var i = thing.length;
  if (!isNumber(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
var isTypedArray = function (TypedArray) {
  // eslint-disable-next-line func-names
  return function (thing) {
    return TypedArray && thing instanceof TypedArray;
  };
}(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
var forEachEntry = function forEachEntry(obj, fn) {
  var generator = obj && obj[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a];

  var iterator = generator.call(obj);

  var result = void 0;

  while ((result = iterator.next()) && !result.done) {
    var pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
var matchAll = function matchAll(regExp, str) {
  var matches = void 0;
  var arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
var isHTMLForm = kindOfTest('HTMLFormElement');

var toCamelCase = function toCamelCase(str) {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};

/* Creating a function that will check if an object has a property. */
var hasOwnProperty = function (_ref4) {
  var hasOwnProperty = _ref4.hasOwnProperty;
  return function (obj, prop) {
    return hasOwnProperty.call(obj, prop);
  };
}(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
var isRegExp = kindOfTest('RegExp');

var reduceDescriptors = function reduceDescriptors(obj, reducer) {
  var descriptors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptors___default()(obj);
  var reducedDescriptors = {};

  forEach(descriptors, function (descriptor, name) {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_define_properties___default()(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

var freezeMethods = function freezeMethods(obj) {
  reduceDescriptors(obj, function (descriptor, name) {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    var value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = function () {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

var toObjectSet = function toObjectSet(arrayOrString, delimiter) {
  var obj = {};

  var define = function define(arr) {
    arr.forEach(function (value) {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

var noop = function noop() {};

var toFiniteNumber = function toFiniteNumber(value, defaultValue) {
  value = +value;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_finite___default()(value) ? value : defaultValue;
};

var ALPHA = 'abcdefghijklmnopqrstuvwxyz';

var DIGIT = '0123456789';

var ALPHABET = {
  DIGIT: DIGIT,
  ALPHA: ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

var generateString = function generateString() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
  var alphabet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALPHABET.ALPHA_DIGIT;

  var str = '';
  var length = alphabet.length;

  while (size--) {
    str += alphabet[Math.random() * length | 0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol_to_string_tag___default.a] === 'FormData' && thing[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol_iterator___default.a]);
}

var toJSONObject = function toJSONObject(obj) {
  var stack = new Array(10);

  var visit = function visit(source, i) {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if (!('toJSON' in source)) {
        stack[i] = source;
        var target = isArray(source) ? [] : {};

        forEach(source, function (value, key) {
          var reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isBoolean: isBoolean,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isRegExp: isRegExp,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isTypedArray: isTypedArray,
  isFileList: isFileList,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  forEachEntry: forEachEntry,
  matchAll: matchAll,
  isHTMLForm: isHTMLForm,
  hasOwnProperty: hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: reduceDescriptors,
  freezeMethods: freezeMethods,
  toObjectSet: toObjectSet,
  toCamelCase: toCamelCase,
  noop: noop,
  toFiniteNumber: toFiniteNumber,
  findKey: findKey,
  global: _global,
  isContextDefined: isContextDefined,
  ALPHABET: ALPHABET,
  generateString: generateString,
  isSpecCompliantForm: isSpecCompliantForm,
  toJSONObject: toJSONObject
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "cddD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = __webpack_require__("fcJk");

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__("LLCR");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),

/***/ "cnlX":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("iInB");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "crlp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var LIBRARY = __webpack_require__("O4g8");
var wksExt = __webpack_require__("Kh4W");
var defineProperty = __webpack_require__("evD5").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "csbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RoomEnvironment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_three__ = __webpack_require__("Ml+6");







/**
 * https://github.com/google/model-viewer/blob/master/packages/model-viewer/src/three-components/EnvironmentScene.ts
 */



var RoomEnvironment = function (_Scene) {
	__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(RoomEnvironment, _Scene);

	function RoomEnvironment() {
		__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RoomEnvironment);

		var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RoomEnvironment.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RoomEnvironment)).call(this));

		var geometry = new __WEBPACK_IMPORTED_MODULE_7_three__["i" /* BoxGeometry */]();
		geometry.deleteAttribute('uv');

		var roomMaterial = new __WEBPACK_IMPORTED_MODULE_7_three__["_8" /* MeshStandardMaterial */]({ side: __WEBPACK_IMPORTED_MODULE_7_three__["f" /* BackSide */] });
		var boxMaterial = new __WEBPACK_IMPORTED_MODULE_7_three__["_8" /* MeshStandardMaterial */]();

		var mainLight = new __WEBPACK_IMPORTED_MODULE_7_three__["_18" /* PointLight */](0xffffff, 5.0, 28, 2);
		mainLight.position.set(0.418, 16.199, 0.300);
		_this.add(mainLight);

		var room = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, roomMaterial);
		room.position.set(-0.757, 13.219, 0.717);
		room.scale.set(31.713, 28.305, 28.591);
		_this.add(room);

		var box1 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box1.position.set(-10.906, 2.009, 1.846);
		box1.rotation.set(0, -0.195, 0);
		box1.scale.set(2.328, 7.905, 4.651);
		_this.add(box1);

		var box2 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box2.position.set(-5.607, -0.754, -0.758);
		box2.rotation.set(0, 0.994, 0);
		box2.scale.set(1.970, 1.534, 3.955);
		_this.add(box2);

		var box3 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box3.position.set(6.167, 0.857, 7.803);
		box3.rotation.set(0, 0.561, 0);
		box3.scale.set(3.927, 6.285, 3.687);
		_this.add(box3);

		var box4 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box4.position.set(-2.017, 0.018, 6.124);
		box4.rotation.set(0, 0.333, 0);
		box4.scale.set(2.002, 4.566, 2.064);
		_this.add(box4);

		var box5 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box5.position.set(2.291, -0.756, -2.621);
		box5.rotation.set(0, -0.286, 0);
		box5.scale.set(1.546, 1.552, 1.496);
		_this.add(box5);

		var box6 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, boxMaterial);
		box6.position.set(-2.193, -0.369, -5.547);
		box6.rotation.set(0, 0.516, 0);
		box6.scale.set(3.875, 3.487, 2.986);
		_this.add(box6);

		// -x right
		var light1 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(50));
		light1.position.set(-16.116, 14.37, 8.208);
		light1.scale.set(0.1, 2.428, 2.739);
		_this.add(light1);

		// -x left
		var light2 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(50));
		light2.position.set(-16.109, 18.021, -8.207);
		light2.scale.set(0.1, 2.425, 2.751);
		_this.add(light2);

		// +x
		var light3 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(17));
		light3.position.set(14.904, 12.198, -1.832);
		light3.scale.set(0.15, 4.265, 6.331);
		_this.add(light3);

		// +z
		var light4 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(43));
		light4.position.set(-0.462, 8.89, 14.520);
		light4.scale.set(4.38, 5.441, 0.088);
		_this.add(light4);

		// -z
		var light5 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(20));
		light5.position.set(3.235, 11.486, -12.541);
		light5.scale.set(2.5, 2.0, 0.1);
		_this.add(light5);

		// +y
		var light6 = new __WEBPACK_IMPORTED_MODULE_7_three__["_3" /* Mesh */](geometry, createAreaLightMaterial(100));
		light6.position.set(0.0, 20.0, 0.0);
		light6.scale.set(1.0, 0.1, 1.0);
		_this.add(light6);

		return _this;
	}

	__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RoomEnvironment, [{
		key: 'dispose',
		value: function dispose() {

			var resources = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();

			this.traverse(function (object) {

				if (object.isMesh) {

					resources.add(object.geometry);
					resources.add(object.material);
				}
			});

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(resources), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var resource = _step.value;


					resource.dispose();
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}]);

	return RoomEnvironment;
}(__WEBPACK_IMPORTED_MODULE_7_three__["_27" /* Scene */]);

function createAreaLightMaterial(intensity) {

	var material = new __WEBPACK_IMPORTED_MODULE_7_three__["_4" /* MeshBasicMaterial */]();
	material.color.setScalar(intensity);
	return material;
}



/***/ }),

/***/ "d7EF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("us/S");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "dNDb":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "dSOO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("X0uZ");
module.exports = 0x1fffffffffffff;


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dUh9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(idHandler) {
    var eventListeners = {};

    /**
     * Gets all listeners for the given element.
     * @public
     * @param {element} element The element to get all listeners for.
     * @returns All listeners for the given element.
     */
    function getListeners(element) {
        var id = idHandler.get(element);

        if (id === undefined) {
            return [];
        }

        return eventListeners[id] || [];
    }

    /**
     * Stores the given listener for the given element. Will not actually add the listener to the element.
     * @public
     * @param {element} element The element that should have the listener added.
     * @param {function} listener The callback that the element has added.
     */
    function addListener(element, listener) {
        var id = idHandler.get(element);

        if(!eventListeners[id]) {
            eventListeners[id] = [];
        }

        eventListeners[id].push(listener);
    }

    function removeListener(element, listener) {
        var listeners = getListeners(element);
        for (var i = 0, len = listeners.length; i < len; ++i) {
            if (listeners[i] === listener) {
              listeners.splice(i, 1);
              break;
            }
        }
    }

    function removeAllListeners(element) {
      var listeners = getListeners(element);
      if (!listeners) { return; }
      listeners.length = 0;
    }

    return {
        get: getListeners,
        add: addListener,
        removeListener: removeListener,
        removeAllListeners: removeAllListeners
    };
};


/***/ }),

/***/ "dY0y":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("dSzd")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "dbB1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = module.exports = {};

/**
 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
 * @public
 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
 */
utils.forEach = function(collection, callback) {
    for(var i = 0; i < collection.length; i++) {
        var result = callback(collection[i]);
        if(result) {
            return result;
        }
    }
};


/***/ }),

/***/ "diSF":
/***/ (function(module, exports) {

module.exports = function (xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        var x = xs[i];
        if (hasOwn.call(xs, i)) res.push(f(x, i, xs));
    }
    return res;
};

var hasOwn = Object.prototype.hasOwnProperty;


/***/ }),

/***/ "drMw":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("O4g8") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "eaw8":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("kM2E");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "exGp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "exh5":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("kM2E");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("ZaQb").set });


/***/ }),

/***/ "f6Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixin_uuid__ = __webpack_require__("OFgA");


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixin_uuid__["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.handleChangeEvent = false;
  },

  computed: {
    dirty: {
      get: function get() {
        return !this.pristine;
      },
      set: function set(newValue) {
        this.pristine = !newValue;
      }
    },
    invalid: function invalid() {
      return !this.valid;
    }
  },
  methods: {
    setTouched: function setTouched() {
      this.touched = true;
    }
  },
  watch: {
    value: function value(newVal) {
      if (this.pristine === true) {
        this.pristine = false;
      }
      if (!this.handleChangeEvent) {
        this.$emit('on-change', newVal);
        this.$emit('input', newVal);
      }
    }
  },
  data: function data() {
    return {
      errors: {},
      pristine: true,
      touched: false
    };
  }
});

/***/ }),

/***/ "fBQ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "fGru":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("wj1U"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),

/***/ "fJUb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var newPromiseCapability = __webpack_require__("qARP");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "fS6E":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Kh5d");
module.exports = __webpack_require__("FeBl").Object.getPrototypeOf;


/***/ }),

/***/ "fWfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7KvD");
var has = __webpack_require__("D2L2");
var DESCRIPTORS = __webpack_require__("+E39");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var META = __webpack_require__("06OY").KEY;
var $fails = __webpack_require__("S82l");
var shared = __webpack_require__("e8AB");
var setToStringTag = __webpack_require__("e6n0");
var uid = __webpack_require__("3Eo+");
var wks = __webpack_require__("dSzd");
var wksExt = __webpack_require__("Kh4W");
var wksDefine = __webpack_require__("crlp");
var enumKeys = __webpack_require__("Xc4G");
var isArray = __webpack_require__("7UMu");
var anObject = __webpack_require__("77Pl");
var isObject = __webpack_require__("EqjI");
var toObject = __webpack_require__("sB3e");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var createDesc = __webpack_require__("X8DO");
var _create = __webpack_require__("Yobk");
var gOPNExt = __webpack_require__("Rrel");
var $GOPD = __webpack_require__("LKZe");
var $GOPS = __webpack_require__("1kS7");
var $DP = __webpack_require__("evD5");
var $keys = __webpack_require__("lktj");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("n0T6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("NpIQ").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("O4g8")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("hJx8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "fZOM":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("kM2E");
var $values = __webpack_require__("mbce")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("jFbC"), __esModule: true };

/***/ }),

/***/ "fcJk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fxRn":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+tPU");
__webpack_require__("zQR9");
module.exports = __webpack_require__("g8Ux");


/***/ }),

/***/ "g8Ux":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var get = __webpack_require__("3fs2");
module.exports = __webpack_require__("FeBl").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "gAsd":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("G5/o");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),

/***/ "gRE1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("TmV0"), __esModule: true };

/***/ }),

/***/ "gSvA":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("kM2E");
var $entries = __webpack_require__("mbce")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "gg4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXRLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__ = __webpack_require__("2QDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_three__ = __webpack_require__("Ml+6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_fflate_module_js__ = __webpack_require__("SCI+");











/**
 * OpenEXR loader currently supports uncompressed, ZIP(S), RLE, PIZ and DWA/B compression.
 * Supports reading as UnsignedByte, HalfFloat and Float type data texture.
 *
 * Referred to the original Industrial Light & Magic OpenEXR implementation and the TinyEXR / Syoyo Fujita
 * implementation, so I have preserved their copyright notices.
 */

// /*
// Copyright (c) 2014 - 2017, Syoyo Fujita
// All rights reserved.

// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//     * Redistributions of source code must retain the above copyright
//       notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//     * Neither the name of the Syoyo Fujita nor the
//       names of its contributors may be used to endorse or promote products
//       derived from this software without specific prior written permission.

// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
// ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
// WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
// DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
// DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
// (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
// LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
// ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
// SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
// */

// // TinyEXR contains some OpenEXR code, which is licensed under ------------

// ///////////////////////////////////////////////////////////////////////////
// //
// // Copyright (c) 2002, Industrial Light & Magic, a division of Lucas
// // Digital Ltd. LLC
// //
// // All rights reserved.
// //
// // Redistribution and use in source and binary forms, with or without
// // modification, are permitted provided that the following conditions are
// // met:
// // *       Redistributions of source code must retain the above copyright
// // notice, this list of conditions and the following disclaimer.
// // *       Redistributions in binary form must reproduce the above
// // copyright notice, this list of conditions and the following disclaimer
// // in the documentation and/or other materials provided with the
// // distribution.
// // *       Neither the name of Industrial Light & Magic nor the names of
// // its contributors may be used to endorse or promote products derived
// // from this software without specific prior written permission.
// //
// // THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// // "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// // LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// // A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// // OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// // SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// // LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// // DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// // THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// // (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// // OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
// //
// ///////////////////////////////////////////////////////////////////////////

// // End of OpenEXR license -------------------------------------------------

var EXRLoader = function (_DataTextureLoader) {
	__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(EXRLoader, _DataTextureLoader);

	function EXRLoader(manager) {
		__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, EXRLoader);

		var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EXRLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(EXRLoader)).call(this, manager));

		_this.type = __WEBPACK_IMPORTED_MODULE_8_three__["D" /* HalfFloatType */];

		return _this;
	}

	__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(EXRLoader, [{
		key: 'parse',
		value: function parse(buffer) {

			var USHORT_RANGE = 1 << 16;
			var BITMAP_SIZE = USHORT_RANGE >> 3;

			var HUF_ENCBITS = 16; // literal (value) bit length
			var HUF_DECBITS = 14; // decoding bit size (>= 8)

			var HUF_ENCSIZE = (1 << HUF_ENCBITS) + 1; // encoding table size
			var HUF_DECSIZE = 1 << HUF_DECBITS; // decoding table size
			var HUF_DECMASK = HUF_DECSIZE - 1;

			var NBITS = 16;
			var A_OFFSET = 1 << NBITS - 1;
			var MOD_MASK = (1 << NBITS) - 1;

			var SHORT_ZEROCODE_RUN = 59;
			var LONG_ZEROCODE_RUN = 63;
			var SHORTEST_LONG_RUN = 2 + LONG_ZEROCODE_RUN - SHORT_ZEROCODE_RUN;

			var ULONG_SIZE = 8;
			var FLOAT32_SIZE = 4;
			var INT32_SIZE = 4;
			var INT16_SIZE = 2;
			var INT8_SIZE = 1;

			var STATIC_HUFFMAN = 0;
			var DEFLATE = 1;

			var UNKNOWN = 0;
			var LOSSY_DCT = 1;
			var RLE = 2;

			var logBase = Math.pow(2.7182818, 2.2);

			function reverseLutFromBitmap(bitmap, lut) {

				var k = 0;

				for (var i = 0; i < USHORT_RANGE; ++i) {

					if (i == 0 || bitmap[i >> 3] & 1 << (i & 7)) {

						lut[k++] = i;
					}
				}

				var n = k - 1;

				while (k < USHORT_RANGE) {
					lut[k++] = 0;
				}return n;
			}

			function hufClearDecTable(hdec) {

				for (var i = 0; i < HUF_DECSIZE; i++) {

					hdec[i] = {};
					hdec[i].len = 0;
					hdec[i].lit = 0;
					hdec[i].p = null;
				}
			}

			var getBitsReturn = { l: 0, c: 0, lc: 0 };

			function getBits(nBits, c, lc, uInt8Array, inOffset) {

				while (lc < nBits) {

					c = c << 8 | parseUint8Array(uInt8Array, inOffset);
					lc += 8;
				}

				lc -= nBits;

				getBitsReturn.l = c >> lc & (1 << nBits) - 1;
				getBitsReturn.c = c;
				getBitsReturn.lc = lc;
			}

			var hufTableBuffer = new Array(59);

			function hufCanonicalCodeTable(hcode) {

				for (var i = 0; i <= 58; ++i) {
					hufTableBuffer[i] = 0;
				}for (var _i = 0; _i < HUF_ENCSIZE; ++_i) {
					hufTableBuffer[hcode[_i]] += 1;
				}var c = 0;

				for (var _i2 = 58; _i2 > 0; --_i2) {

					var nc = c + hufTableBuffer[_i2] >> 1;
					hufTableBuffer[_i2] = c;
					c = nc;
				}

				for (var _i3 = 0; _i3 < HUF_ENCSIZE; ++_i3) {

					var l = hcode[_i3];
					if (l > 0) hcode[_i3] = l | hufTableBuffer[l]++ << 6;
				}
			}

			function hufUnpackEncTable(uInt8Array, inOffset, ni, im, iM, hcode) {

				var p = inOffset;
				var c = 0;
				var lc = 0;

				for (; im <= iM; im++) {

					if (p.value - inOffset.value > ni) return false;

					getBits(6, c, lc, uInt8Array, p);

					var l = getBitsReturn.l;
					c = getBitsReturn.c;
					lc = getBitsReturn.lc;

					hcode[im] = l;

					if (l == LONG_ZEROCODE_RUN) {

						if (p.value - inOffset.value > ni) {

							throw new Error('Something wrong with hufUnpackEncTable');
						}

						getBits(8, c, lc, uInt8Array, p);

						var zerun = getBitsReturn.l + SHORTEST_LONG_RUN;
						c = getBitsReturn.c;
						lc = getBitsReturn.lc;

						if (im + zerun > iM + 1) {

							throw new Error('Something wrong with hufUnpackEncTable');
						}

						while (zerun--) {
							hcode[im++] = 0;
						}im--;
					} else if (l >= SHORT_ZEROCODE_RUN) {

						var _zerun = l - SHORT_ZEROCODE_RUN + 2;

						if (im + _zerun > iM + 1) {

							throw new Error('Something wrong with hufUnpackEncTable');
						}

						while (_zerun--) {
							hcode[im++] = 0;
						}im--;
					}
				}

				hufCanonicalCodeTable(hcode);
			}

			function hufLength(code) {

				return code & 63;
			}

			function hufCode(code) {

				return code >> 6;
			}

			function hufBuildDecTable(hcode, im, iM, hdecod) {

				for (; im <= iM; im++) {

					var c = hufCode(hcode[im]);
					var l = hufLength(hcode[im]);

					if (c >> l) {

						throw new Error('Invalid table entry');
					}

					if (l > HUF_DECBITS) {

						var pl = hdecod[c >> l - HUF_DECBITS];

						if (pl.len) {

							throw new Error('Invalid table entry');
						}

						pl.lit++;

						if (pl.p) {

							var p = pl.p;
							pl.p = new Array(pl.lit);

							for (var i = 0; i < pl.lit - 1; ++i) {

								pl.p[i] = p[i];
							}
						} else {

							pl.p = new Array(1);
						}

						pl.p[pl.lit - 1] = im;
					} else if (l) {

						var plOffset = 0;

						for (var _i4 = 1 << HUF_DECBITS - l; _i4 > 0; _i4--) {

							var _pl = hdecod[(c << HUF_DECBITS - l) + plOffset];

							if (_pl.len || _pl.p) {

								throw new Error('Invalid table entry');
							}

							_pl.len = l;
							_pl.lit = im;

							plOffset++;
						}
					}
				}

				return true;
			}

			var getCharReturn = { c: 0, lc: 0 };

			function getChar(c, lc, uInt8Array, inOffset) {

				c = c << 8 | parseUint8Array(uInt8Array, inOffset);
				lc += 8;

				getCharReturn.c = c;
				getCharReturn.lc = lc;
			}

			var getCodeReturn = { c: 0, lc: 0 };

			function getCode(po, rlc, c, lc, uInt8Array, inOffset, outBuffer, outBufferOffset, outBufferEndOffset) {

				if (po == rlc) {

					if (lc < 8) {

						getChar(c, lc, uInt8Array, inOffset);
						c = getCharReturn.c;
						lc = getCharReturn.lc;
					}

					lc -= 8;

					var cs = c >> lc;
					cs = new Uint8Array([cs])[0];

					if (outBufferOffset.value + cs > outBufferEndOffset) {

						return false;
					}

					var s = outBuffer[outBufferOffset.value - 1];

					while (cs-- > 0) {

						outBuffer[outBufferOffset.value++] = s;
					}
				} else if (outBufferOffset.value < outBufferEndOffset) {

					outBuffer[outBufferOffset.value++] = po;
				} else {

					return false;
				}

				getCodeReturn.c = c;
				getCodeReturn.lc = lc;
			}

			function UInt16(value) {

				return value & 0xFFFF;
			}

			function Int16(value) {

				var ref = UInt16(value);
				return ref > 0x7FFF ? ref - 0x10000 : ref;
			}

			var wdec14Return = { a: 0, b: 0 };

			function wdec14(l, h) {

				var ls = Int16(l);
				var hs = Int16(h);

				var hi = hs;
				var ai = ls + (hi & 1) + (hi >> 1);

				var as = ai;
				var bs = ai - hi;

				wdec14Return.a = as;
				wdec14Return.b = bs;
			}

			function wdec16(l, h) {

				var m = UInt16(l);
				var d = UInt16(h);

				var bb = m - (d >> 1) & MOD_MASK;
				var aa = d + bb - A_OFFSET & MOD_MASK;

				wdec14Return.a = aa;
				wdec14Return.b = bb;
			}

			function wav2Decode(buffer, j, nx, ox, ny, oy, mx) {

				var w14 = mx < 1 << 14;
				var n = nx > ny ? ny : nx;
				var p = 1;
				var p2 = void 0;
				var py = void 0;

				while (p <= n) {
					p <<= 1;
				}p >>= 1;
				p2 = p;
				p >>= 1;

				while (p >= 1) {

					py = 0;
					var ey = py + oy * (ny - p2);
					var oy1 = oy * p;
					var oy2 = oy * p2;
					var ox1 = ox * p;
					var ox2 = ox * p2;
					var i00 = void 0,
					    i01 = void 0,
					    i10 = void 0,
					    i11 = void 0;

					for (; py <= ey; py += oy2) {

						var px = py;
						var ex = py + ox * (nx - p2);

						for (; px <= ex; px += ox2) {

							var p01 = px + ox1;
							var p10 = px + oy1;
							var p11 = p10 + ox1;

							if (w14) {

								wdec14(buffer[px + j], buffer[p10 + j]);

								i00 = wdec14Return.a;
								i10 = wdec14Return.b;

								wdec14(buffer[p01 + j], buffer[p11 + j]);

								i01 = wdec14Return.a;
								i11 = wdec14Return.b;

								wdec14(i00, i01);

								buffer[px + j] = wdec14Return.a;
								buffer[p01 + j] = wdec14Return.b;

								wdec14(i10, i11);

								buffer[p10 + j] = wdec14Return.a;
								buffer[p11 + j] = wdec14Return.b;
							} else {

								wdec16(buffer[px + j], buffer[p10 + j]);

								i00 = wdec14Return.a;
								i10 = wdec14Return.b;

								wdec16(buffer[p01 + j], buffer[p11 + j]);

								i01 = wdec14Return.a;
								i11 = wdec14Return.b;

								wdec16(i00, i01);

								buffer[px + j] = wdec14Return.a;
								buffer[p01 + j] = wdec14Return.b;

								wdec16(i10, i11);

								buffer[p10 + j] = wdec14Return.a;
								buffer[p11 + j] = wdec14Return.b;
							}
						}

						if (nx & p) {

							var _p = px + oy1;

							if (w14) wdec14(buffer[px + j], buffer[_p + j]);else wdec16(buffer[px + j], buffer[_p + j]);

							i00 = wdec14Return.a;
							buffer[_p + j] = wdec14Return.b;

							buffer[px + j] = i00;
						}
					}

					if (ny & p) {

						var _px = py;
						var _ex = py + ox * (nx - p2);

						for (; _px <= _ex; _px += ox2) {

							var _p2 = _px + ox1;

							if (w14) wdec14(buffer[_px + j], buffer[_p2 + j]);else wdec16(buffer[_px + j], buffer[_p2 + j]);

							i00 = wdec14Return.a;
							buffer[_p2 + j] = wdec14Return.b;

							buffer[_px + j] = i00;
						}
					}

					p2 = p;
					p >>= 1;
				}

				return py;
			}

			function hufDecode(encodingTable, decodingTable, uInt8Array, inOffset, ni, rlc, no, outBuffer, outOffset) {

				var c = 0;
				var lc = 0;
				var outBufferEndOffset = no;
				var inOffsetEnd = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_trunc___default()(inOffset.value + (ni + 7) / 8);

				while (inOffset.value < inOffsetEnd) {

					getChar(c, lc, uInt8Array, inOffset);

					c = getCharReturn.c;
					lc = getCharReturn.lc;

					while (lc >= HUF_DECBITS) {

						var index = c >> lc - HUF_DECBITS & HUF_DECMASK;
						var pl = decodingTable[index];

						if (pl.len) {

							lc -= pl.len;

							getCode(pl.lit, rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);

							c = getCodeReturn.c;
							lc = getCodeReturn.lc;
						} else {

							if (!pl.p) {

								throw new Error('hufDecode issues');
							}

							var j = void 0;

							for (j = 0; j < pl.lit; j++) {

								var l = hufLength(encodingTable[pl.p[j]]);

								while (lc < l && inOffset.value < inOffsetEnd) {

									getChar(c, lc, uInt8Array, inOffset);

									c = getCharReturn.c;
									lc = getCharReturn.lc;
								}

								if (lc >= l) {

									if (hufCode(encodingTable[pl.p[j]]) == (c >> lc - l & (1 << l) - 1)) {

										lc -= l;

										getCode(pl.p[j], rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);

										c = getCodeReturn.c;
										lc = getCodeReturn.lc;

										break;
									}
								}
							}

							if (j == pl.lit) {

								throw new Error('hufDecode issues');
							}
						}
					}
				}

				var i = 8 - ni & 7;

				c >>= i;
				lc -= i;

				while (lc > 0) {

					var _pl2 = decodingTable[c << HUF_DECBITS - lc & HUF_DECMASK];

					if (_pl2.len) {

						lc -= _pl2.len;

						getCode(_pl2.lit, rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);

						c = getCodeReturn.c;
						lc = getCodeReturn.lc;
					} else {

						throw new Error('hufDecode issues');
					}
				}

				return true;
			}

			function hufUncompress(uInt8Array, inDataView, inOffset, nCompressed, outBuffer, nRaw) {

				var outOffset = { value: 0 };
				var initialInOffset = inOffset.value;

				var im = parseUint32(inDataView, inOffset);
				var iM = parseUint32(inDataView, inOffset);

				inOffset.value += 4;

				var nBits = parseUint32(inDataView, inOffset);

				inOffset.value += 4;

				if (im < 0 || im >= HUF_ENCSIZE || iM < 0 || iM >= HUF_ENCSIZE) {

					throw new Error('Something wrong with HUF_ENCSIZE');
				}

				var freq = new Array(HUF_ENCSIZE);
				var hdec = new Array(HUF_DECSIZE);

				hufClearDecTable(hdec);

				var ni = nCompressed - (inOffset.value - initialInOffset);

				hufUnpackEncTable(uInt8Array, inOffset, ni, im, iM, freq);

				if (nBits > 8 * (nCompressed - (inOffset.value - initialInOffset))) {

					throw new Error('Something wrong with hufUncompress');
				}

				hufBuildDecTable(freq, im, iM, hdec);

				hufDecode(freq, hdec, uInt8Array, inOffset, nBits, iM, nRaw, outBuffer, outOffset);
			}

			function applyLut(lut, data, nData) {

				for (var i = 0; i < nData; ++i) {

					data[i] = lut[data[i]];
				}
			}

			function predictor(source) {

				for (var t = 1; t < source.length; t++) {

					var d = source[t - 1] + source[t] - 128;
					source[t] = d;
				}
			}

			function interleaveScalar(source, out) {

				var t1 = 0;
				var t2 = Math.floor((source.length + 1) / 2);
				var s = 0;
				var stop = source.length - 1;

				while (true) {

					if (s > stop) break;
					out[s++] = source[t1++];

					if (s > stop) break;
					out[s++] = source[t2++];
				}
			}

			function decodeRunLength(source) {

				var size = source.byteLength;
				var out = new Array();
				var p = 0;

				var reader = new DataView(source);

				while (size > 0) {

					var l = reader.getInt8(p++);

					if (l < 0) {

						var count = -l;
						size -= count + 1;

						for (var i = 0; i < count; i++) {

							out.push(reader.getUint8(p++));
						}
					} else {

						var _count = l;
						size -= 2;

						var value = reader.getUint8(p++);

						for (var _i5 = 0; _i5 < _count + 1; _i5++) {

							out.push(value);
						}
					}
				}

				return out;
			}

			function lossyDctDecode(cscSet, rowPtrs, channelData, acBuffer, dcBuffer, outBuffer) {

				var dataView = new DataView(outBuffer.buffer);

				var width = channelData[cscSet.idx[0]].width;
				var height = channelData[cscSet.idx[0]].height;

				var numComp = 3;

				var numFullBlocksX = Math.floor(width / 8.0);
				var numBlocksX = Math.ceil(width / 8.0);
				var numBlocksY = Math.ceil(height / 8.0);
				var leftoverX = width - (numBlocksX - 1) * 8;
				var leftoverY = height - (numBlocksY - 1) * 8;

				var currAcComp = { value: 0 };
				var currDcComp = new Array(numComp);
				var dctData = new Array(numComp);
				var halfZigBlock = new Array(numComp);
				var rowBlock = new Array(numComp);
				var rowOffsets = new Array(numComp);

				for (var comp = 0; comp < numComp; ++comp) {

					rowOffsets[comp] = rowPtrs[cscSet.idx[comp]];
					currDcComp[comp] = comp < 1 ? 0 : currDcComp[comp - 1] + numBlocksX * numBlocksY;
					dctData[comp] = new Float32Array(64);
					halfZigBlock[comp] = new Uint16Array(64);
					rowBlock[comp] = new Uint16Array(numBlocksX * 64);
				}

				for (var blocky = 0; blocky < numBlocksY; ++blocky) {

					var maxY = 8;

					if (blocky == numBlocksY - 1) maxY = leftoverY;

					var maxX = 8;

					for (var blockx = 0; blockx < numBlocksX; ++blockx) {

						if (blockx == numBlocksX - 1) maxX = leftoverX;

						for (var _comp = 0; _comp < numComp; ++_comp) {

							halfZigBlock[_comp].fill(0);

							// set block DC component
							halfZigBlock[_comp][0] = dcBuffer[currDcComp[_comp]++];
							// set block AC components
							unRleAC(currAcComp, acBuffer, halfZigBlock[_comp]);

							// UnZigZag block to float
							unZigZag(halfZigBlock[_comp], dctData[_comp]);
							// decode float dct
							dctInverse(dctData[_comp]);
						}

						if (numComp == 3) {

							csc709Inverse(dctData);
						}

						for (var _comp2 = 0; _comp2 < numComp; ++_comp2) {

							convertToHalf(dctData[_comp2], rowBlock[_comp2], blockx * 64);
						}
					} // blockx

					var _offset = 0;

					for (var _comp3 = 0; _comp3 < numComp; ++_comp3) {

						var type = channelData[cscSet.idx[_comp3]].type;

						for (var y = 8 * blocky; y < 8 * blocky + maxY; ++y) {

							_offset = rowOffsets[_comp3][y];

							for (var _blockx = 0; _blockx < numFullBlocksX; ++_blockx) {

								var src = _blockx * 64 + (y & 0x7) * 8;

								dataView.setUint16(_offset + 0 * INT16_SIZE * type, rowBlock[_comp3][src + 0], true);
								dataView.setUint16(_offset + 1 * INT16_SIZE * type, rowBlock[_comp3][src + 1], true);
								dataView.setUint16(_offset + 2 * INT16_SIZE * type, rowBlock[_comp3][src + 2], true);
								dataView.setUint16(_offset + 3 * INT16_SIZE * type, rowBlock[_comp3][src + 3], true);

								dataView.setUint16(_offset + 4 * INT16_SIZE * type, rowBlock[_comp3][src + 4], true);
								dataView.setUint16(_offset + 5 * INT16_SIZE * type, rowBlock[_comp3][src + 5], true);
								dataView.setUint16(_offset + 6 * INT16_SIZE * type, rowBlock[_comp3][src + 6], true);
								dataView.setUint16(_offset + 7 * INT16_SIZE * type, rowBlock[_comp3][src + 7], true);

								_offset += 8 * INT16_SIZE * type;
							}
						}

						// handle partial X blocks
						if (numFullBlocksX != numBlocksX) {

							for (var _y = 8 * blocky; _y < 8 * blocky + maxY; ++_y) {

								var _offset2 = rowOffsets[_comp3][_y] + 8 * numFullBlocksX * INT16_SIZE * type;
								var _src = numFullBlocksX * 64 + (_y & 0x7) * 8;

								for (var x = 0; x < maxX; ++x) {

									dataView.setUint16(_offset2 + x * INT16_SIZE * type, rowBlock[_comp3][_src + x], true);
								}
							}
						}
					} // comp
				} // blocky

				var halfRow = new Uint16Array(width);
				dataView = new DataView(outBuffer.buffer);

				// convert channels back to float, if needed
				for (var _comp4 = 0; _comp4 < numComp; ++_comp4) {

					channelData[cscSet.idx[_comp4]].decoded = true;
					var _type = channelData[cscSet.idx[_comp4]].type;

					if (channelData[_comp4].type != 2) continue;

					for (var _y2 = 0; _y2 < height; ++_y2) {

						var _offset3 = rowOffsets[_comp4][_y2];

						for (var _x = 0; _x < width; ++_x) {

							halfRow[_x] = dataView.getUint16(_offset3 + _x * INT16_SIZE * _type, true);
						}

						for (var _x2 = 0; _x2 < width; ++_x2) {

							dataView.setFloat32(_offset3 + _x2 * INT16_SIZE * _type, decodeFloat16(halfRow[_x2]), true);
						}
					}
				}
			}

			function unRleAC(currAcComp, acBuffer, halfZigBlock) {

				var acValue = void 0;
				var dctComp = 1;

				while (dctComp < 64) {

					acValue = acBuffer[currAcComp.value];

					if (acValue == 0xff00) {

						dctComp = 64;
					} else if (acValue >> 8 == 0xff) {

						dctComp += acValue & 0xff;
					} else {

						halfZigBlock[dctComp] = acValue;
						dctComp++;
					}

					currAcComp.value++;
				}
			}

			function unZigZag(src, dst) {

				dst[0] = decodeFloat16(src[0]);
				dst[1] = decodeFloat16(src[1]);
				dst[2] = decodeFloat16(src[5]);
				dst[3] = decodeFloat16(src[6]);
				dst[4] = decodeFloat16(src[14]);
				dst[5] = decodeFloat16(src[15]);
				dst[6] = decodeFloat16(src[27]);
				dst[7] = decodeFloat16(src[28]);
				dst[8] = decodeFloat16(src[2]);
				dst[9] = decodeFloat16(src[4]);

				dst[10] = decodeFloat16(src[7]);
				dst[11] = decodeFloat16(src[13]);
				dst[12] = decodeFloat16(src[16]);
				dst[13] = decodeFloat16(src[26]);
				dst[14] = decodeFloat16(src[29]);
				dst[15] = decodeFloat16(src[42]);
				dst[16] = decodeFloat16(src[3]);
				dst[17] = decodeFloat16(src[8]);
				dst[18] = decodeFloat16(src[12]);
				dst[19] = decodeFloat16(src[17]);

				dst[20] = decodeFloat16(src[25]);
				dst[21] = decodeFloat16(src[30]);
				dst[22] = decodeFloat16(src[41]);
				dst[23] = decodeFloat16(src[43]);
				dst[24] = decodeFloat16(src[9]);
				dst[25] = decodeFloat16(src[11]);
				dst[26] = decodeFloat16(src[18]);
				dst[27] = decodeFloat16(src[24]);
				dst[28] = decodeFloat16(src[31]);
				dst[29] = decodeFloat16(src[40]);

				dst[30] = decodeFloat16(src[44]);
				dst[31] = decodeFloat16(src[53]);
				dst[32] = decodeFloat16(src[10]);
				dst[33] = decodeFloat16(src[19]);
				dst[34] = decodeFloat16(src[23]);
				dst[35] = decodeFloat16(src[32]);
				dst[36] = decodeFloat16(src[39]);
				dst[37] = decodeFloat16(src[45]);
				dst[38] = decodeFloat16(src[52]);
				dst[39] = decodeFloat16(src[54]);

				dst[40] = decodeFloat16(src[20]);
				dst[41] = decodeFloat16(src[22]);
				dst[42] = decodeFloat16(src[33]);
				dst[43] = decodeFloat16(src[38]);
				dst[44] = decodeFloat16(src[46]);
				dst[45] = decodeFloat16(src[51]);
				dst[46] = decodeFloat16(src[55]);
				dst[47] = decodeFloat16(src[60]);
				dst[48] = decodeFloat16(src[21]);
				dst[49] = decodeFloat16(src[34]);

				dst[50] = decodeFloat16(src[37]);
				dst[51] = decodeFloat16(src[47]);
				dst[52] = decodeFloat16(src[50]);
				dst[53] = decodeFloat16(src[56]);
				dst[54] = decodeFloat16(src[59]);
				dst[55] = decodeFloat16(src[61]);
				dst[56] = decodeFloat16(src[35]);
				dst[57] = decodeFloat16(src[36]);
				dst[58] = decodeFloat16(src[48]);
				dst[59] = decodeFloat16(src[49]);

				dst[60] = decodeFloat16(src[57]);
				dst[61] = decodeFloat16(src[58]);
				dst[62] = decodeFloat16(src[62]);
				dst[63] = decodeFloat16(src[63]);
			}

			function dctInverse(data) {

				var a = 0.5 * Math.cos(3.14159 / 4.0);
				var b = 0.5 * Math.cos(3.14159 / 16.0);
				var c = 0.5 * Math.cos(3.14159 / 8.0);
				var d = 0.5 * Math.cos(3.0 * 3.14159 / 16.0);
				var e = 0.5 * Math.cos(5.0 * 3.14159 / 16.0);
				var f = 0.5 * Math.cos(3.0 * 3.14159 / 8.0);
				var g = 0.5 * Math.cos(7.0 * 3.14159 / 16.0);

				var alpha = new Array(4);
				var beta = new Array(4);
				var theta = new Array(4);
				var gamma = new Array(4);

				for (var row = 0; row < 8; ++row) {

					var rowPtr = row * 8;

					alpha[0] = c * data[rowPtr + 2];
					alpha[1] = f * data[rowPtr + 2];
					alpha[2] = c * data[rowPtr + 6];
					alpha[3] = f * data[rowPtr + 6];

					beta[0] = b * data[rowPtr + 1] + d * data[rowPtr + 3] + e * data[rowPtr + 5] + g * data[rowPtr + 7];
					beta[1] = d * data[rowPtr + 1] - g * data[rowPtr + 3] - b * data[rowPtr + 5] - e * data[rowPtr + 7];
					beta[2] = e * data[rowPtr + 1] - b * data[rowPtr + 3] + g * data[rowPtr + 5] + d * data[rowPtr + 7];
					beta[3] = g * data[rowPtr + 1] - e * data[rowPtr + 3] + d * data[rowPtr + 5] - b * data[rowPtr + 7];

					theta[0] = a * (data[rowPtr + 0] + data[rowPtr + 4]);
					theta[3] = a * (data[rowPtr + 0] - data[rowPtr + 4]);
					theta[1] = alpha[0] + alpha[3];
					theta[2] = alpha[1] - alpha[2];

					gamma[0] = theta[0] + theta[1];
					gamma[1] = theta[3] + theta[2];
					gamma[2] = theta[3] - theta[2];
					gamma[3] = theta[0] - theta[1];

					data[rowPtr + 0] = gamma[0] + beta[0];
					data[rowPtr + 1] = gamma[1] + beta[1];
					data[rowPtr + 2] = gamma[2] + beta[2];
					data[rowPtr + 3] = gamma[3] + beta[3];

					data[rowPtr + 4] = gamma[3] - beta[3];
					data[rowPtr + 5] = gamma[2] - beta[2];
					data[rowPtr + 6] = gamma[1] - beta[1];
					data[rowPtr + 7] = gamma[0] - beta[0];
				}

				for (var column = 0; column < 8; ++column) {

					alpha[0] = c * data[16 + column];
					alpha[1] = f * data[16 + column];
					alpha[2] = c * data[48 + column];
					alpha[3] = f * data[48 + column];

					beta[0] = b * data[8 + column] + d * data[24 + column] + e * data[40 + column] + g * data[56 + column];
					beta[1] = d * data[8 + column] - g * data[24 + column] - b * data[40 + column] - e * data[56 + column];
					beta[2] = e * data[8 + column] - b * data[24 + column] + g * data[40 + column] + d * data[56 + column];
					beta[3] = g * data[8 + column] - e * data[24 + column] + d * data[40 + column] - b * data[56 + column];

					theta[0] = a * (data[column] + data[32 + column]);
					theta[3] = a * (data[column] - data[32 + column]);

					theta[1] = alpha[0] + alpha[3];
					theta[2] = alpha[1] - alpha[2];

					gamma[0] = theta[0] + theta[1];
					gamma[1] = theta[3] + theta[2];
					gamma[2] = theta[3] - theta[2];
					gamma[3] = theta[0] - theta[1];

					data[0 + column] = gamma[0] + beta[0];
					data[8 + column] = gamma[1] + beta[1];
					data[16 + column] = gamma[2] + beta[2];
					data[24 + column] = gamma[3] + beta[3];

					data[32 + column] = gamma[3] - beta[3];
					data[40 + column] = gamma[2] - beta[2];
					data[48 + column] = gamma[1] - beta[1];
					data[56 + column] = gamma[0] - beta[0];
				}
			}

			function csc709Inverse(data) {

				for (var i = 0; i < 64; ++i) {

					var y = data[0][i];
					var cb = data[1][i];
					var cr = data[2][i];

					data[0][i] = y + 1.5747 * cr;
					data[1][i] = y - 0.1873 * cb - 0.4682 * cr;
					data[2][i] = y + 1.8556 * cb;
				}
			}

			function convertToHalf(src, dst, idx) {

				for (var i = 0; i < 64; ++i) {

					dst[idx + i] = __WEBPACK_IMPORTED_MODULE_8_three__["r" /* DataUtils */].toHalfFloat(toLinear(src[i]));
				}
			}

			function toLinear(float) {

				if (float <= 1) {

					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(float) * Math.pow(Math.abs(float), 2.2);
				} else {

					return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_sign___default()(float) * Math.pow(logBase, Math.abs(float) - 1.0);
				}
			}

			function uncompressRAW(info) {

				return new DataView(info.array.buffer, info.offset.value, info.size);
			}

			function uncompressRLE(info) {

				var compressed = info.viewer.buffer.slice(info.offset.value, info.offset.value + info.size);

				var rawBuffer = new Uint8Array(decodeRunLength(compressed));
				var tmpBuffer = new Uint8Array(rawBuffer.length);

				predictor(rawBuffer); // revert predictor

				interleaveScalar(rawBuffer, tmpBuffer); // interleave pixels

				return new DataView(tmpBuffer.buffer);
			}

			function uncompressZIP(info) {

				var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);

				var rawBuffer = __WEBPACK_IMPORTED_MODULE_9__libs_fflate_module_js__["a" /* unzlibSync */](compressed);
				var tmpBuffer = new Uint8Array(rawBuffer.length);

				predictor(rawBuffer); // revert predictor

				interleaveScalar(rawBuffer, tmpBuffer); // interleave pixels

				return new DataView(tmpBuffer.buffer);
			}

			function uncompressPIZ(info) {

				var inDataView = info.viewer;
				var inOffset = { value: info.offset.value };

				var outBuffer = new Uint16Array(info.width * info.scanlineBlockSize * (info.channels * info.type));
				var bitmap = new Uint8Array(BITMAP_SIZE);

				// Setup channel info
				var outBufferEnd = 0;
				var pizChannelData = new Array(info.channels);
				for (var i = 0; i < info.channels; i++) {

					pizChannelData[i] = {};
					pizChannelData[i]['start'] = outBufferEnd;
					pizChannelData[i]['end'] = pizChannelData[i]['start'];
					pizChannelData[i]['nx'] = info.width;
					pizChannelData[i]['ny'] = info.lines;
					pizChannelData[i]['size'] = info.type;

					outBufferEnd += pizChannelData[i].nx * pizChannelData[i].ny * pizChannelData[i].size;
				}

				// Read range compression data

				var minNonZero = parseUint16(inDataView, inOffset);
				var maxNonZero = parseUint16(inDataView, inOffset);

				if (maxNonZero >= BITMAP_SIZE) {

					throw new Error('Something is wrong with PIZ_COMPRESSION BITMAP_SIZE');
				}

				if (minNonZero <= maxNonZero) {

					for (var _i6 = 0; _i6 < maxNonZero - minNonZero + 1; _i6++) {

						bitmap[_i6 + minNonZero] = parseUint8(inDataView, inOffset);
					}
				}

				// Reverse LUT
				var lut = new Uint16Array(USHORT_RANGE);
				var maxValue = reverseLutFromBitmap(bitmap, lut);

				var length = parseUint32(inDataView, inOffset);

				// Huffman decoding
				hufUncompress(info.array, inDataView, inOffset, length, outBuffer, outBufferEnd);

				// Wavelet decoding
				for (var _i7 = 0; _i7 < info.channels; ++_i7) {

					var cd = pizChannelData[_i7];

					for (var j = 0; j < pizChannelData[_i7].size; ++j) {

						wav2Decode(outBuffer, cd.start + j, cd.nx, cd.size, cd.ny, cd.nx * cd.size, maxValue);
					}
				}

				// Expand the pixel data to their original range
				applyLut(lut, outBuffer, outBufferEnd);

				// Rearrange the pixel data into the format expected by the caller.
				var tmpOffset = 0;
				var tmpBuffer = new Uint8Array(outBuffer.buffer.byteLength);
				for (var y = 0; y < info.lines; y++) {

					for (var c = 0; c < info.channels; c++) {

						var _cd = pizChannelData[c];

						var n = _cd.nx * _cd.size;
						var cp = new Uint8Array(outBuffer.buffer, _cd.end * INT16_SIZE, n * INT16_SIZE);

						tmpBuffer.set(cp, tmpOffset);
						tmpOffset += n * INT16_SIZE;
						_cd.end += n;
					}
				}

				return new DataView(tmpBuffer.buffer);
			}

			function uncompressPXR(info) {

				var compressed = info.array.slice(info.offset.value, info.offset.value + info.size);

				var rawBuffer = __WEBPACK_IMPORTED_MODULE_9__libs_fflate_module_js__["a" /* unzlibSync */](compressed);

				var sz = info.lines * info.channels * info.width;
				var tmpBuffer = info.type == 1 ? new Uint16Array(sz) : new Uint32Array(sz);

				var tmpBufferEnd = 0;
				var writePtr = 0;
				var ptr = new Array(4);

				for (var y = 0; y < info.lines; y++) {

					for (var c = 0; c < info.channels; c++) {

						var pixel = 0;

						switch (info.type) {

							case 1:

								ptr[0] = tmpBufferEnd;
								ptr[1] = ptr[0] + info.width;
								tmpBufferEnd = ptr[1] + info.width;

								for (var j = 0; j < info.width; ++j) {

									var diff = rawBuffer[ptr[0]++] << 8 | rawBuffer[ptr[1]++];

									pixel += diff;

									tmpBuffer[writePtr] = pixel;
									writePtr++;
								}

								break;

							case 2:

								ptr[0] = tmpBufferEnd;
								ptr[1] = ptr[0] + info.width;
								ptr[2] = ptr[1] + info.width;
								tmpBufferEnd = ptr[2] + info.width;

								for (var _j = 0; _j < info.width; ++_j) {

									var _diff = rawBuffer[ptr[0]++] << 24 | rawBuffer[ptr[1]++] << 16 | rawBuffer[ptr[2]++] << 8;

									pixel += _diff;

									tmpBuffer[writePtr] = pixel;
									writePtr++;
								}

								break;

						}
					}
				}

				return new DataView(tmpBuffer.buffer);
			}

			function uncompressDWA(info) {

				var inDataView = info.viewer;
				var inOffset = { value: info.offset.value };
				var outBuffer = new Uint8Array(info.width * info.lines * (info.channels * info.type * INT16_SIZE));

				// Read compression header information
				var dwaHeader = {

					version: parseInt64(inDataView, inOffset),
					unknownUncompressedSize: parseInt64(inDataView, inOffset),
					unknownCompressedSize: parseInt64(inDataView, inOffset),
					acCompressedSize: parseInt64(inDataView, inOffset),
					dcCompressedSize: parseInt64(inDataView, inOffset),
					rleCompressedSize: parseInt64(inDataView, inOffset),
					rleUncompressedSize: parseInt64(inDataView, inOffset),
					rleRawSize: parseInt64(inDataView, inOffset),
					totalAcUncompressedCount: parseInt64(inDataView, inOffset),
					totalDcUncompressedCount: parseInt64(inDataView, inOffset),
					acCompression: parseInt64(inDataView, inOffset)

				};

				if (dwaHeader.version < 2) throw new Error('EXRLoader.parse: ' + EXRHeader.compression + ' version ' + dwaHeader.version + ' is unsupported');

				// Read channel ruleset information
				var channelRules = new Array();
				var ruleSize = parseUint16(inDataView, inOffset) - INT16_SIZE;

				while (ruleSize > 0) {

					var name = parseNullTerminatedString(inDataView.buffer, inOffset);
					var value = parseUint8(inDataView, inOffset);
					var compression = value >> 2 & 3;
					var csc = (value >> 4) - 1;
					var index = new Int8Array([csc])[0];
					var type = parseUint8(inDataView, inOffset);

					channelRules.push({
						name: name,
						index: index,
						type: type,
						compression: compression
					});

					ruleSize -= name.length + 3;
				}

				// Classify channels
				var channels = EXRHeader.channels;
				var channelData = new Array(info.channels);

				for (var i = 0; i < info.channels; ++i) {

					var cd = channelData[i] = {};
					var channel = channels[i];

					cd.name = channel.name;
					cd.compression = UNKNOWN;
					cd.decoded = false;
					cd.type = channel.pixelType;
					cd.pLinear = channel.pLinear;
					cd.width = info.width;
					cd.height = info.lines;
				}

				var cscSet = {
					idx: new Array(3)
				};

				for (var _offset4 = 0; _offset4 < info.channels; ++_offset4) {

					var _cd2 = channelData[_offset4];

					for (var _i8 = 0; _i8 < channelRules.length; ++_i8) {

						var rule = channelRules[_i8];

						if (_cd2.name == rule.name) {

							_cd2.compression = rule.compression;

							if (rule.index >= 0) {

								cscSet.idx[rule.index] = _offset4;
							}

							_cd2.offset = _offset4;
						}
					}
				}

				var acBuffer = void 0,
				    dcBuffer = void 0,
				    rleBuffer = void 0;

				// Read DCT - AC component data
				if (dwaHeader.acCompressedSize > 0) {

					switch (dwaHeader.acCompression) {

						case STATIC_HUFFMAN:

							acBuffer = new Uint16Array(dwaHeader.totalAcUncompressedCount);
							hufUncompress(info.array, inDataView, inOffset, dwaHeader.acCompressedSize, acBuffer, dwaHeader.totalAcUncompressedCount);
							break;

						case DEFLATE:

							var compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.totalAcUncompressedCount);
							var data = __WEBPACK_IMPORTED_MODULE_9__libs_fflate_module_js__["a" /* unzlibSync */](compressed);
							acBuffer = new Uint16Array(data.buffer);
							inOffset.value += dwaHeader.totalAcUncompressedCount;
							break;

					}
				}

				// Read DCT - DC component data
				if (dwaHeader.dcCompressedSize > 0) {

					var zlibInfo = {
						array: info.array,
						offset: inOffset,
						size: dwaHeader.dcCompressedSize
					};
					dcBuffer = new Uint16Array(uncompressZIP(zlibInfo).buffer);
					inOffset.value += dwaHeader.dcCompressedSize;
				}

				// Read RLE compressed data
				if (dwaHeader.rleRawSize > 0) {

					var _compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.rleCompressedSize);
					var _data = __WEBPACK_IMPORTED_MODULE_9__libs_fflate_module_js__["a" /* unzlibSync */](_compressed);
					rleBuffer = decodeRunLength(_data.buffer);

					inOffset.value += dwaHeader.rleCompressedSize;
				}

				// Prepare outbuffer data offset
				var outBufferEnd = 0;
				var rowOffsets = new Array(channelData.length);
				for (var _i9 = 0; _i9 < rowOffsets.length; ++_i9) {

					rowOffsets[_i9] = new Array();
				}

				for (var y = 0; y < info.lines; ++y) {

					for (var chan = 0; chan < channelData.length; ++chan) {

						rowOffsets[chan].push(outBufferEnd);
						outBufferEnd += channelData[chan].width * info.type * INT16_SIZE;
					}
				}

				// Lossy DCT decode RGB channels
				lossyDctDecode(cscSet, rowOffsets, channelData, acBuffer, dcBuffer, outBuffer);

				// Decode other channels
				for (var _i10 = 0; _i10 < channelData.length; ++_i10) {

					var _cd3 = channelData[_i10];

					if (_cd3.decoded) continue;

					switch (_cd3.compression) {

						case RLE:

							var row = 0;
							var rleOffset = 0;

							for (var _y3 = 0; _y3 < info.lines; ++_y3) {

								var rowOffsetBytes = rowOffsets[_i10][row];

								for (var x = 0; x < _cd3.width; ++x) {

									for (var byte = 0; byte < INT16_SIZE * _cd3.type; ++byte) {

										outBuffer[rowOffsetBytes++] = rleBuffer[rleOffset + byte * _cd3.width * _cd3.height];
									}

									rleOffset++;
								}

								row++;
							}

							break;

						case LOSSY_DCT: // skip

						default:
							throw new Error('EXRLoader.parse: unsupported channel compression');

					}
				}

				return new DataView(outBuffer.buffer);
			}

			function parseNullTerminatedString(buffer, offset) {

				var uintBuffer = new Uint8Array(buffer);
				var endOffset = 0;

				while (uintBuffer[offset.value + endOffset] != 0) {

					endOffset += 1;
				}

				var stringValue = new TextDecoder().decode(uintBuffer.slice(offset.value, offset.value + endOffset));

				offset.value = offset.value + endOffset + 1;

				return stringValue;
			}

			function parseFixedLengthString(buffer, offset, size) {

				var stringValue = new TextDecoder().decode(new Uint8Array(buffer).slice(offset.value, offset.value + size));

				offset.value = offset.value + size;

				return stringValue;
			}

			function parseRational(dataView, offset) {

				var x = parseInt32(dataView, offset);
				var y = parseUint32(dataView, offset);

				return [x, y];
			}

			function parseTimecode(dataView, offset) {

				var x = parseUint32(dataView, offset);
				var y = parseUint32(dataView, offset);

				return [x, y];
			}

			function parseInt32(dataView, offset) {

				var Int32 = dataView.getInt32(offset.value, true);

				offset.value = offset.value + INT32_SIZE;

				return Int32;
			}

			function parseUint32(dataView, offset) {

				var Uint32 = dataView.getUint32(offset.value, true);

				offset.value = offset.value + INT32_SIZE;

				return Uint32;
			}

			function parseUint8Array(uInt8Array, offset) {

				var Uint8 = uInt8Array[offset.value];

				offset.value = offset.value + INT8_SIZE;

				return Uint8;
			}

			function parseUint8(dataView, offset) {

				var Uint8 = dataView.getUint8(offset.value);

				offset.value = offset.value + INT8_SIZE;

				return Uint8;
			}

			var parseInt64 = function parseInt64(dataView, offset) {

				var int = void 0;

				if ('getBigInt64' in DataView.prototype) {

					int = Number(dataView.getBigInt64(offset.value, true));
				} else {

					int = dataView.getUint32(offset.value + 4, true) + Number(dataView.getUint32(offset.value, true) << 32);
				}

				offset.value += ULONG_SIZE;

				return int;
			};

			function parseFloat32(dataView, offset) {

				var float = dataView.getFloat32(offset.value, true);

				offset.value += FLOAT32_SIZE;

				return float;
			}

			function decodeFloat32(dataView, offset) {

				return __WEBPACK_IMPORTED_MODULE_8_three__["r" /* DataUtils */].toHalfFloat(parseFloat32(dataView, offset));
			}

			// https://stackoverflow.com/questions/5678432/decompressing-half-precision-floats-in-javascript
			function decodeFloat16(binary) {

				var exponent = (binary & 0x7C00) >> 10,
				    fraction = binary & 0x03FF;

				return (binary >> 15 ? -1 : 1) * (exponent ? exponent === 0x1F ? fraction ? NaN : Infinity : Math.pow(2, exponent - 15) * (1 + fraction / 0x400) : 6.103515625e-5 * (fraction / 0x400));
			}

			function parseUint16(dataView, offset) {

				var Uint16 = dataView.getUint16(offset.value, true);

				offset.value += INT16_SIZE;

				return Uint16;
			}

			function parseFloat16(buffer, offset) {

				return decodeFloat16(parseUint16(buffer, offset));
			}

			function parseChlist(dataView, buffer, offset, size) {

				var startOffset = offset.value;
				var channels = [];

				while (offset.value < startOffset + size - 1) {

					var name = parseNullTerminatedString(buffer, offset);
					var pixelType = parseInt32(dataView, offset);
					var pLinear = parseUint8(dataView, offset);
					offset.value += 3; // reserved, three chars
					var xSampling = parseInt32(dataView, offset);
					var ySampling = parseInt32(dataView, offset);

					channels.push({
						name: name,
						pixelType: pixelType,
						pLinear: pLinear,
						xSampling: xSampling,
						ySampling: ySampling
					});
				}

				offset.value += 1;

				return channels;
			}

			function parseChromaticities(dataView, offset) {

				var redX = parseFloat32(dataView, offset);
				var redY = parseFloat32(dataView, offset);
				var greenX = parseFloat32(dataView, offset);
				var greenY = parseFloat32(dataView, offset);
				var blueX = parseFloat32(dataView, offset);
				var blueY = parseFloat32(dataView, offset);
				var whiteX = parseFloat32(dataView, offset);
				var whiteY = parseFloat32(dataView, offset);

				return { redX: redX, redY: redY, greenX: greenX, greenY: greenY, blueX: blueX, blueY: blueY, whiteX: whiteX, whiteY: whiteY };
			}

			function parseCompression(dataView, offset) {

				var compressionCodes = ['NO_COMPRESSION', 'RLE_COMPRESSION', 'ZIPS_COMPRESSION', 'ZIP_COMPRESSION', 'PIZ_COMPRESSION', 'PXR24_COMPRESSION', 'B44_COMPRESSION', 'B44A_COMPRESSION', 'DWAA_COMPRESSION', 'DWAB_COMPRESSION'];

				var compression = parseUint8(dataView, offset);

				return compressionCodes[compression];
			}

			function parseBox2i(dataView, offset) {

				var xMin = parseUint32(dataView, offset);
				var yMin = parseUint32(dataView, offset);
				var xMax = parseUint32(dataView, offset);
				var yMax = parseUint32(dataView, offset);

				return { xMin: xMin, yMin: yMin, xMax: xMax, yMax: yMax };
			}

			function parseLineOrder(dataView, offset) {

				var lineOrders = ['INCREASING_Y'];

				var lineOrder = parseUint8(dataView, offset);

				return lineOrders[lineOrder];
			}

			function parseV2f(dataView, offset) {

				var x = parseFloat32(dataView, offset);
				var y = parseFloat32(dataView, offset);

				return [x, y];
			}

			function parseV3f(dataView, offset) {

				var x = parseFloat32(dataView, offset);
				var y = parseFloat32(dataView, offset);
				var z = parseFloat32(dataView, offset);

				return [x, y, z];
			}

			function parseValue(dataView, buffer, offset, type, size) {

				if (type === 'string' || type === 'stringvector' || type === 'iccProfile') {

					return parseFixedLengthString(buffer, offset, size);
				} else if (type === 'chlist') {

					return parseChlist(dataView, buffer, offset, size);
				} else if (type === 'chromaticities') {

					return parseChromaticities(dataView, offset);
				} else if (type === 'compression') {

					return parseCompression(dataView, offset);
				} else if (type === 'box2i') {

					return parseBox2i(dataView, offset);
				} else if (type === 'lineOrder') {

					return parseLineOrder(dataView, offset);
				} else if (type === 'float') {

					return parseFloat32(dataView, offset);
				} else if (type === 'v2f') {

					return parseV2f(dataView, offset);
				} else if (type === 'v3f') {

					return parseV3f(dataView, offset);
				} else if (type === 'int') {

					return parseInt32(dataView, offset);
				} else if (type === 'rational') {

					return parseRational(dataView, offset);
				} else if (type === 'timecode') {

					return parseTimecode(dataView, offset);
				} else if (type === 'preview') {

					offset.value += size;
					return 'skipped';
				} else {

					offset.value += size;
					return undefined;
				}
			}

			function parseHeader(dataView, buffer, offset) {

				var EXRHeader = {};

				if (dataView.getUint32(0, true) != 20000630) {
					// magic

					throw new Error('THREE.EXRLoader: provided file doesn\'t appear to be in OpenEXR format.');
				}

				EXRHeader.version = dataView.getUint8(4);

				var spec = dataView.getUint8(5); // fullMask

				EXRHeader.spec = {
					singleTile: !!(spec & 2),
					longName: !!(spec & 4),
					deepFormat: !!(spec & 8),
					multiPart: !!(spec & 16)
				};

				// start of header

				offset.value = 8; // start at 8 - after pre-amble

				var keepReading = true;

				while (keepReading) {

					var attributeName = parseNullTerminatedString(buffer, offset);

					if (attributeName == 0) {

						keepReading = false;
					} else {

						var attributeType = parseNullTerminatedString(buffer, offset);
						var attributeSize = parseUint32(dataView, offset);
						var attributeValue = parseValue(dataView, buffer, offset, attributeType, attributeSize);

						if (attributeValue === undefined) {

							console.warn('EXRLoader.parse: skipped unknown header attribute type \'' + attributeType + '\'.');
						} else {

							EXRHeader[attributeName] = attributeValue;
						}
					}
				}

				if ((spec & ~0x04) != 0) {
					// unsupported tiled, deep-image, multi-part

					console.error('EXRHeader:', EXRHeader);
					throw new Error('THREE.EXRLoader: provided file is currently unsupported.');
				}

				return EXRHeader;
			}

			function setupDecoder(EXRHeader, dataView, uInt8Array, offset, outputType) {

				var EXRDecoder = {
					size: 0,
					viewer: dataView,
					array: uInt8Array,
					offset: offset,
					width: EXRHeader.dataWindow.xMax - EXRHeader.dataWindow.xMin + 1,
					height: EXRHeader.dataWindow.yMax - EXRHeader.dataWindow.yMin + 1,
					channels: EXRHeader.channels.length,
					bytesPerLine: null,
					lines: null,
					inputSize: null,
					type: EXRHeader.channels[0].pixelType,
					uncompress: null,
					getter: null,
					format: null,
					encoding: null
				};

				switch (EXRHeader.compression) {

					case 'NO_COMPRESSION':
						EXRDecoder.lines = 1;
						EXRDecoder.uncompress = uncompressRAW;
						break;

					case 'RLE_COMPRESSION':
						EXRDecoder.lines = 1;
						EXRDecoder.uncompress = uncompressRLE;
						break;

					case 'ZIPS_COMPRESSION':
						EXRDecoder.lines = 1;
						EXRDecoder.uncompress = uncompressZIP;
						break;

					case 'ZIP_COMPRESSION':
						EXRDecoder.lines = 16;
						EXRDecoder.uncompress = uncompressZIP;
						break;

					case 'PIZ_COMPRESSION':
						EXRDecoder.lines = 32;
						EXRDecoder.uncompress = uncompressPIZ;
						break;

					case 'PXR24_COMPRESSION':
						EXRDecoder.lines = 16;
						EXRDecoder.uncompress = uncompressPXR;
						break;

					case 'DWAA_COMPRESSION':
						EXRDecoder.lines = 32;
						EXRDecoder.uncompress = uncompressDWA;
						break;

					case 'DWAB_COMPRESSION':
						EXRDecoder.lines = 256;
						EXRDecoder.uncompress = uncompressDWA;
						break;

					default:
						throw new Error('EXRLoader.parse: ' + EXRHeader.compression + ' is unsupported');

				}

				EXRDecoder.scanlineBlockSize = EXRDecoder.lines;

				if (EXRDecoder.type == 1) {

					// half
					switch (outputType) {

						case __WEBPACK_IMPORTED_MODULE_8_three__["A" /* FloatType */]:
							EXRDecoder.getter = parseFloat16;
							EXRDecoder.inputSize = INT16_SIZE;
							break;

						case __WEBPACK_IMPORTED_MODULE_8_three__["D" /* HalfFloatType */]:
							EXRDecoder.getter = parseUint16;
							EXRDecoder.inputSize = INT16_SIZE;
							break;

					}
				} else if (EXRDecoder.type == 2) {

					// float
					switch (outputType) {

						case __WEBPACK_IMPORTED_MODULE_8_three__["A" /* FloatType */]:
							EXRDecoder.getter = parseFloat32;
							EXRDecoder.inputSize = FLOAT32_SIZE;
							break;

						case __WEBPACK_IMPORTED_MODULE_8_three__["D" /* HalfFloatType */]:
							EXRDecoder.getter = decodeFloat32;
							EXRDecoder.inputSize = FLOAT32_SIZE;

					}
				} else {

					throw new Error('EXRLoader.parse: unsupported pixelType ' + EXRDecoder.type + ' for ' + EXRHeader.compression + '.');
				}

				EXRDecoder.blockCount = (EXRHeader.dataWindow.yMax + 1) / EXRDecoder.scanlineBlockSize;

				for (var i = 0; i < EXRDecoder.blockCount; i++) {
					parseInt64(dataView, offset);
				} // scanlineOffset

				// we should be passed the scanline offset table, ready to start reading pixel data.

				// RGB images will be converted to RGBA format, preventing software emulation in select devices.
				EXRDecoder.outputChannels = EXRDecoder.channels == 3 ? 4 : EXRDecoder.channels;
				var size = EXRDecoder.width * EXRDecoder.height * EXRDecoder.outputChannels;

				switch (outputType) {

					case __WEBPACK_IMPORTED_MODULE_8_three__["A" /* FloatType */]:
						EXRDecoder.byteArray = new Float32Array(size);

						// Fill initially with 1s for the alpha value if the texture is not RGBA, RGB values will be overwritten
						if (EXRDecoder.channels < EXRDecoder.outputChannels) EXRDecoder.byteArray.fill(1, 0, size);

						break;

					case __WEBPACK_IMPORTED_MODULE_8_three__["D" /* HalfFloatType */]:
						EXRDecoder.byteArray = new Uint16Array(size);

						if (EXRDecoder.channels < EXRDecoder.outputChannels) EXRDecoder.byteArray.fill(0x3C00, 0, size); // Uint16Array holds half float data, 0x3C00 is 1

						break;

					default:
						console.error('THREE.EXRLoader: unsupported type: ', outputType);
						break;

				}

				EXRDecoder.bytesPerLine = EXRDecoder.width * EXRDecoder.inputSize * EXRDecoder.channels;

				if (EXRDecoder.outputChannels == 4) {

					EXRDecoder.format = __WEBPACK_IMPORTED_MODULE_8_three__["_24" /* RGBAFormat */];
					EXRDecoder.encoding = __WEBPACK_IMPORTED_MODULE_8_three__["Q" /* LinearEncoding */];
				} else {

					EXRDecoder.format = __WEBPACK_IMPORTED_MODULE_8_three__["_25" /* RedFormat */];
					EXRDecoder.encoding = __WEBPACK_IMPORTED_MODULE_8_three__["Q" /* LinearEncoding */];
				}

				return EXRDecoder;
			}

			// start parsing file [START]

			var bufferDataView = new DataView(buffer);
			var uInt8Array = new Uint8Array(buffer);
			var offset = { value: 0 };

			// get header information and validate format.
			var EXRHeader = parseHeader(bufferDataView, buffer, offset);

			// get input compression information and prepare decoding.
			var EXRDecoder = setupDecoder(EXRHeader, bufferDataView, uInt8Array, offset, this.type);

			var tmpOffset = { value: 0 };
			var channelOffsets = { R: 0, G: 1, B: 2, A: 3, Y: 0 };

			for (var scanlineBlockIdx = 0; scanlineBlockIdx < EXRDecoder.height / EXRDecoder.scanlineBlockSize; scanlineBlockIdx++) {

				var line = parseUint32(bufferDataView, offset); // line_no
				EXRDecoder.size = parseUint32(bufferDataView, offset); // data_len
				EXRDecoder.lines = line + EXRDecoder.scanlineBlockSize > EXRDecoder.height ? EXRDecoder.height - line : EXRDecoder.scanlineBlockSize;

				var isCompressed = EXRDecoder.size < EXRDecoder.lines * EXRDecoder.bytesPerLine;
				var viewer = isCompressed ? EXRDecoder.uncompress(EXRDecoder) : uncompressRAW(EXRDecoder);

				offset.value += EXRDecoder.size;

				for (var line_y = 0; line_y < EXRDecoder.scanlineBlockSize; line_y++) {

					var true_y = line_y + scanlineBlockIdx * EXRDecoder.scanlineBlockSize;
					if (true_y >= EXRDecoder.height) break;

					for (var channelID = 0; channelID < EXRDecoder.channels; channelID++) {

						var cOff = channelOffsets[EXRHeader.channels[channelID].name];

						for (var x = 0; x < EXRDecoder.width; x++) {

							tmpOffset.value = (line_y * (EXRDecoder.channels * EXRDecoder.width) + channelID * EXRDecoder.width + x) * EXRDecoder.inputSize;
							var outIndex = (EXRDecoder.height - 1 - true_y) * (EXRDecoder.width * EXRDecoder.outputChannels) + x * EXRDecoder.outputChannels + cOff;
							EXRDecoder.byteArray[outIndex] = EXRDecoder.getter(viewer, tmpOffset);
						}
					}
				}
			}

			return {
				header: EXRHeader,
				width: EXRDecoder.width,
				height: EXRDecoder.height,
				data: EXRDecoder.byteArray,
				format: EXRDecoder.format,
				encoding: EXRDecoder.encoding,
				type: this.type
			};
		}
	}, {
		key: 'setDataType',
		value: function setDataType(value) {

			this.type = value;
			return this;
		}
	}, {
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			function onLoadCallback(texture, texData) {

				texture.encoding = texData.encoding;
				texture.minFilter = __WEBPACK_IMPORTED_MODULE_8_three__["R" /* LinearFilter */];
				texture.magFilter = __WEBPACK_IMPORTED_MODULE_8_three__["R" /* LinearFilter */];
				texture.generateMipmaps = false;
				texture.flipY = false;

				if (onLoad) onLoad(texture, texData);
			}

			return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(EXRLoader.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(EXRLoader.prototype), 'load', this).call(this, url, onLoadCallback, onProgress, onError);
		}
	}]);

	return EXRLoader;
}(__WEBPACK_IMPORTED_MODULE_8_three__["q" /* DataTextureLoader */]);



/***/ }),

/***/ "gkUh":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("uFh6"), __webpack_require__("gykg"), __webpack_require__("wj1U"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),

/***/ "gykg":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ "h65t":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var defined = __webpack_require__("52gC");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "hV/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/get.js
var get = __webpack_require__("yEsh");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__("Ml+6");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/math/log10.js
var log10 = __webpack_require__("j9JH");
var log10_default = /*#__PURE__*/__webpack_require__.n(log10);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// CONCATENATED MODULE: ./node_modules/three/examples/jsm/utils/BufferGeometryUtils.js







function computeMikkTSpaceTangents(geometry, MikkTSpace) {
	var negateSign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


	if (!MikkTSpace || !MikkTSpace.isReady) {

		throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
	}

	if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) {

		throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
	}

	function getAttributeArray(attribute) {

		if (attribute.normalized || attribute.isInterleavedBufferAttribute) {

			var dstArray = new Float32Array(attribute.getCount() * attribute.itemSize);

			for (var i = 0, j = 0; i < attribute.getCount(); i++) {

				dstArray[j++] = attribute.getX(i);
				dstArray[j++] = attribute.getY(i);

				if (attribute.itemSize > 2) {

					dstArray[j++] = attribute.getZ(i);
				}
			}

			return dstArray;
		}

		if (attribute.array instanceof Float32Array) {

			return attribute.array;
		}

		return new Float32Array(attribute.array);
	}

	// MikkTSpace algorithm requires non-indexed input.

	var _geometry = geometry.index ? geometry.toNonIndexed() : geometry;

	// Compute vertex tangents.

	var tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));

	// Texture coordinate convention of glTF differs from the apparent
	// default of the MikkTSpace library; .w component must be flipped.

	if (negateSign) {

		for (var i = 3; i < tangents.length; i += 4) {

			tangents[i] *= -1;
		}
	}

	//

	_geometry.setAttribute('tangent', new three_module["j" /* BufferAttribute */](tangents, 4));

	if (geometry !== _geometry) {

		geometry.copy(_geometry);
	}

	return geometry;
}

/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */
function mergeGeometries(geometries) {
	var useGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	var isIndexed = geometries[0].index !== null;

	var attributesUsed = new set_default.a(keys_default()(geometries[0].attributes));
	var morphAttributesUsed = new set_default.a(keys_default()(geometries[0].morphAttributes));

	var attributes = {};
	var morphAttributes = {};

	var morphTargetsRelative = geometries[0].morphTargetsRelative;

	var mergedGeometry = new three_module["k" /* BufferGeometry */]();

	var offset = 0;

	for (var i = 0; i < geometries.length; ++i) {

		var geometry = geometries[i];
		var attributesCount = 0;

		// ensure that all geometries are indexed, or none

		if (isIndexed !== (geometry.index !== null)) {

			console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
			return null;
		}

		// gather attributes, exit early if they're different

		for (var name in geometry.attributes) {

			if (!attributesUsed.has(name)) {

				console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
				return null;
			}

			if (attributes[name] === undefined) attributes[name] = [];

			attributes[name].push(geometry.attributes[name]);

			attributesCount++;
		}

		// ensure geometries have the same number of attributes

		if (attributesCount !== attributesUsed.size) {

			console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
			return null;
		}

		// gather morph attributes, exit early if they're different

		if (morphTargetsRelative !== geometry.morphTargetsRelative) {

			console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
			return null;
		}

		for (var _name in geometry.morphAttributes) {

			if (!morphAttributesUsed.has(_name)) {

				console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
				return null;
			}

			if (morphAttributes[_name] === undefined) morphAttributes[_name] = [];

			morphAttributes[_name].push(geometry.morphAttributes[_name]);
		}

		if (useGroups) {

			var count = void 0;

			if (isIndexed) {

				count = geometry.index.count;
			} else if (geometry.attributes.position !== undefined) {

				count = geometry.attributes.position.count;
			} else {

				console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
				return null;
			}

			mergedGeometry.addGroup(offset, count, i);

			offset += count;
		}
	}

	// merge indices

	if (isIndexed) {

		var indexOffset = 0;
		var mergedIndex = [];

		for (var _i = 0; _i < geometries.length; ++_i) {

			var index = geometries[_i].index;

			for (var j = 0; j < index.count; ++j) {

				mergedIndex.push(index.getX(j) + indexOffset);
			}

			indexOffset += geometries[_i].attributes.position.count;
		}

		mergedGeometry.setIndex(mergedIndex);
	}

	// merge attributes

	for (var _name2 in attributes) {

		var mergedAttribute = mergeAttributes(attributes[_name2]);

		if (!mergedAttribute) {

			console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + _name2 + ' attribute.');
			return null;
		}

		mergedGeometry.setAttribute(_name2, mergedAttribute);
	}

	// merge morph attributes

	for (var _name3 in morphAttributes) {

		var numMorphTargets = morphAttributes[_name3][0].length;

		if (numMorphTargets === 0) break;

		mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
		mergedGeometry.morphAttributes[_name3] = [];

		for (var _i2 = 0; _i2 < numMorphTargets; ++_i2) {

			var morphAttributesToMerge = [];

			for (var _j = 0; _j < morphAttributes[_name3].length; ++_j) {

				morphAttributesToMerge.push(morphAttributes[_name3][_j][_i2]);
			}

			var mergedMorphAttribute = mergeAttributes(morphAttributesToMerge);

			if (!mergedMorphAttribute) {

				console.error('THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the ' + _name3 + ' morphAttribute.');
				return null;
			}

			mergedGeometry.morphAttributes[_name3].push(mergedMorphAttribute);
		}
	}

	return mergedGeometry;
}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */
function mergeAttributes(attributes) {

	var TypedArray = void 0;
	var itemSize = void 0;
	var normalized = void 0;
	var arrayLength = 0;

	for (var i = 0; i < attributes.length; ++i) {

		var attribute = attributes[i];

		if (attribute.isInterleavedBufferAttribute) {

			console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.');
			return null;
		}

		if (TypedArray === undefined) TypedArray = attribute.array.constructor;
		if (TypedArray !== attribute.array.constructor) {

			console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
			return null;
		}

		if (itemSize === undefined) itemSize = attribute.itemSize;
		if (itemSize !== attribute.itemSize) {

			console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
			return null;
		}

		if (normalized === undefined) normalized = attribute.normalized;
		if (normalized !== attribute.normalized) {

			console.error('THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
			return null;
		}

		arrayLength += attribute.array.length;
	}

	var array = new TypedArray(arrayLength);
	var offset = 0;

	for (var _i3 = 0; _i3 < attributes.length; ++_i3) {

		array.set(attributes[_i3].array, offset);

		offset += attributes[_i3].array.length;
	}

	return new three_module["j" /* BufferAttribute */](array, itemSize, normalized);
}

/**
 * @param {BufferAttribute}
 * @return {BufferAttribute}
 */
function deepCloneAttribute(attribute) {

	if (attribute.isInstancedInterleavedBufferAttribute || attribute.isInterleavedBufferAttribute) {

		return deinterleaveAttribute(attribute);
	}

	if (attribute.isInstancedBufferAttribute) {

		return new three_module["F" /* InstancedBufferAttribute */]().copy(attribute);
	}

	return new three_module["j" /* BufferAttribute */]().copy(attribute);
}

/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */
function interleaveAttributes(attributes) {

	// Interleaves the provided attributes into an InterleavedBuffer and returns
	// a set of InterleavedBufferAttributes for each attribute
	var TypedArray = void 0;
	var arrayLength = 0;
	var stride = 0;

	// calculate the length and type of the interleavedBuffer
	for (var i = 0, l = attributes.length; i < l; ++i) {

		var attribute = attributes[i];

		if (TypedArray === undefined) TypedArray = attribute.array.constructor;
		if (TypedArray !== attribute.array.constructor) {

			console.error('AttributeBuffers of different types cannot be interleaved');
			return null;
		}

		arrayLength += attribute.array.length;
		stride += attribute.itemSize;
	}

	// Create the set of buffer attributes
	var interleavedBuffer = new three_module["H" /* InterleavedBuffer */](new TypedArray(arrayLength), stride);
	var offset = 0;
	var res = [];
	var getters = ['getX', 'getY', 'getZ', 'getW'];
	var setters = ['setX', 'setY', 'setZ', 'setW'];

	for (var j = 0, _l = attributes.length; j < _l; j++) {

		var _attribute = attributes[j];
		var itemSize = _attribute.itemSize;
		var count = _attribute.count;
		var iba = new three_module["I" /* InterleavedBufferAttribute */](interleavedBuffer, itemSize, offset, _attribute.normalized);
		res.push(iba);

		offset += itemSize;

		// Move the data for each attribute into the new interleavedBuffer
		// at the appropriate offset
		for (var c = 0; c < count; c++) {

			for (var k = 0; k < itemSize; k++) {

				iba[setters[k]](c, _attribute[getters[k]](c));
			}
		}
	}

	return res;
}

// returns a new, non-interleaved version of the provided attribute
function deinterleaveAttribute(attribute) {

	var cons = attribute.data.array.constructor;
	var count = attribute.count;
	var itemSize = attribute.itemSize;
	var normalized = attribute.normalized;

	var array = new cons(count * itemSize);
	var newAttribute = void 0;
	if (attribute.isInstancedInterleavedBufferAttribute) {

		newAttribute = new three_module["F" /* InstancedBufferAttribute */](array, itemSize, normalized, attribute.meshPerAttribute);
	} else {

		newAttribute = new three_module["j" /* BufferAttribute */](array, itemSize, normalized);
	}

	for (var i = 0; i < count; i++) {

		newAttribute.setX(i, attribute.getX(i));

		if (itemSize >= 2) {

			newAttribute.setY(i, attribute.getY(i));
		}

		if (itemSize >= 3) {

			newAttribute.setZ(i, attribute.getZ(i));
		}

		if (itemSize >= 4) {

			newAttribute.setW(i, attribute.getW(i));
		}
	}

	return newAttribute;
}

// deinterleaves all attributes on the geometry
function deinterleaveGeometry(geometry) {

	var attributes = geometry.attributes;
	var morphTargets = geometry.morphTargets;
	var attrMap = new map_default.a();

	for (var key in attributes) {

		var attr = attributes[key];
		if (attr.isInterleavedBufferAttribute) {

			if (!attrMap.has(attr)) {

				attrMap.set(attr, deinterleaveAttribute(attr));
			}

			attributes[key] = attrMap.get(attr);
		}
	}

	for (var _key in morphTargets) {

		var _attr = morphTargets[_key];
		if (_attr.isInterleavedBufferAttribute) {

			if (!attrMap.has(_attr)) {

				attrMap.set(_attr, deinterleaveAttribute(_attr));
			}

			morphTargets[_key] = attrMap.get(_attr);
		}
	}
}

/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */
function estimateBytesUsed(geometry) {

	// Return the estimated memory used by this geometry in bytes
	// Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
	// for InterleavedBufferAttributes.
	var mem = 0;
	for (var name in geometry.attributes) {

		var attr = geometry.getAttribute(name);
		mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
	}

	var indices = geometry.getIndex();
	mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
	return mem;
}

/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry}
 */
function mergeVertices(geometry) {
	var tolerance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e-4;


	tolerance = Math.max(tolerance, epsilon_default.a);

	// Generate an index buffer if the geometry doesn't have one, or optimize it
	// if it's already available.
	var hashToIndex = {};
	var indices = geometry.getIndex();
	var positions = geometry.getAttribute('position');
	var vertexCount = indices ? indices.count : positions.count;

	// next value for triangle indices
	var nextIndex = 0;

	// attributes and new attribute arrays
	var attributeNames = keys_default()(geometry.attributes);
	var tmpAttributes = {};
	var tmpMorphAttributes = {};
	var newIndices = [];
	var getters = ['getX', 'getY', 'getZ', 'getW'];
	var setters = ['setX', 'setY', 'setZ', 'setW'];

	// Initialize the arrays, allocating space conservatively. Extra
	// space will be trimmed in the last step.
	for (var i = 0, l = attributeNames.length; i < l; i++) {

		var name = attributeNames[i];
		var attr = geometry.attributes[name];

		tmpAttributes[name] = new three_module["j" /* BufferAttribute */](new attr.array.constructor(attr.count * attr.itemSize), attr.itemSize, attr.normalized);

		var morphAttr = geometry.morphAttributes[name];
		if (morphAttr) {

			tmpMorphAttributes[name] = new three_module["j" /* BufferAttribute */](new morphAttr.array.constructor(morphAttr.count * morphAttr.itemSize), morphAttr.itemSize, morphAttr.normalized);
		}
	}

	// convert the error tolerance to an amount of decimal places to truncate to
	var decimalShift = log10_default()(1 / tolerance);
	var shiftMultiplier = Math.pow(10, decimalShift);
	for (var _i4 = 0; _i4 < vertexCount; _i4++) {

		var index = indices ? indices.getX(_i4) : _i4;

		// Generate a hash for the vertex attributes at the current index 'i'
		var hash = '';
		for (var j = 0, _l2 = attributeNames.length; j < _l2; j++) {

			var _name4 = attributeNames[j];
			var attribute = geometry.getAttribute(_name4);
			var itemSize = attribute.itemSize;

			for (var k = 0; k < itemSize; k++) {

				// double tilde truncates the decimal value
				hash += ~~(attribute[getters[k]](index) * shiftMultiplier) + ',';
			}
		}

		// Add another reference to the vertex if it's already
		// used by another index
		if (hash in hashToIndex) {

			newIndices.push(hashToIndex[hash]);
		} else {

			// copy data to the new index in the temporary attributes
			for (var _j2 = 0, _l3 = attributeNames.length; _j2 < _l3; _j2++) {

				var _name5 = attributeNames[_j2];
				var _attribute2 = geometry.getAttribute(_name5);
				var _morphAttr = geometry.morphAttributes[_name5];
				var _itemSize = _attribute2.itemSize;
				var newarray = tmpAttributes[_name5];
				var newMorphArrays = tmpMorphAttributes[_name5];

				for (var _k = 0; _k < _itemSize; _k++) {

					var getterFunc = getters[_k];
					var setterFunc = setters[_k];
					newarray[setterFunc](nextIndex, _attribute2[getterFunc](index));

					if (_morphAttr) {

						for (var m = 0, ml = _morphAttr.length; m < ml; m++) {

							newMorphArrays[m][setterFunc](nextIndex, _morphAttr[m][getterFunc](index));
						}
					}
				}
			}

			hashToIndex[hash] = nextIndex;
			newIndices.push(nextIndex);
			nextIndex++;
		}
	}

	// generate result BufferGeometry
	var result = geometry.clone();
	for (var _name6 in geometry.attributes) {

		var tmpAttribute = tmpAttributes[_name6];

		result.setAttribute(_name6, new three_module["j" /* BufferAttribute */](tmpAttribute.array.slice(0, nextIndex * tmpAttribute.itemSize), tmpAttribute.itemSize, tmpAttribute.normalized));

		if (!(_name6 in tmpMorphAttributes)) continue;

		for (var _j3 = 0; _j3 < tmpMorphAttributes[_name6].length; _j3++) {

			var tmpMorphAttribute = tmpMorphAttributes[_name6][_j3];

			result.morphAttributes[_name6][_j3] = new three_module["j" /* BufferAttribute */](tmpMorphAttribute.array.slice(0, nextIndex * tmpMorphAttribute.itemSize), tmpMorphAttribute.itemSize, tmpMorphAttribute.normalized);
		}
	}

	// indices

	result.setIndex(newIndices);

	return result;
}

/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry}
 */
function toTrianglesDrawMode(geometry, drawMode) {

	if (drawMode === three_module["_38" /* TrianglesDrawMode */]) {

		console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
		return geometry;
	}

	if (drawMode === three_module["_36" /* TriangleFanDrawMode */] || drawMode === three_module["_37" /* TriangleStripDrawMode */]) {

		var index = geometry.getIndex();

		// generate index if not present

		if (index === null) {

			var indices = [];

			var position = geometry.getAttribute('position');

			if (position !== undefined) {

				for (var i = 0; i < position.count; i++) {

					indices.push(i);
				}

				geometry.setIndex(indices);
				index = geometry.getIndex();
			} else {

				console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
				return geometry;
			}
		}

		//

		var numberOfTriangles = index.count - 2;
		var newIndices = [];

		if (drawMode === three_module["_36" /* TriangleFanDrawMode */]) {

			// gl.TRIANGLE_FAN

			for (var _i5 = 1; _i5 <= numberOfTriangles; _i5++) {

				newIndices.push(index.getX(0));
				newIndices.push(index.getX(_i5));
				newIndices.push(index.getX(_i5 + 1));
			}
		} else {

			// gl.TRIANGLE_STRIP

			for (var _i6 = 0; _i6 < numberOfTriangles; _i6++) {

				if (_i6 % 2 === 0) {

					newIndices.push(index.getX(_i6));
					newIndices.push(index.getX(_i6 + 1));
					newIndices.push(index.getX(_i6 + 2));
				} else {

					newIndices.push(index.getX(_i6 + 2));
					newIndices.push(index.getX(_i6 + 1));
					newIndices.push(index.getX(_i6));
				}
			}
		}

		if (newIndices.length / 3 !== numberOfTriangles) {

			console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
		}

		// build final geometry

		var newGeometry = geometry.clone();
		newGeometry.setIndex(newIndices);
		newGeometry.clearGroups();

		return newGeometry;
	} else {

		console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
		return geometry;
	}
}

/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */
function computeMorphedAttributes(object) {

	var _vA = new three_module["_41" /* Vector3 */]();
	var _vB = new three_module["_41" /* Vector3 */]();
	var _vC = new three_module["_41" /* Vector3 */]();

	var _tempA = new three_module["_41" /* Vector3 */]();
	var _tempB = new three_module["_41" /* Vector3 */]();
	var _tempC = new three_module["_41" /* Vector3 */]();

	var _morphA = new three_module["_41" /* Vector3 */]();
	var _morphB = new three_module["_41" /* Vector3 */]();
	var _morphC = new three_module["_41" /* Vector3 */]();

	function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {

		_vA.fromBufferAttribute(attribute, a);
		_vB.fromBufferAttribute(attribute, b);
		_vC.fromBufferAttribute(attribute, c);

		var morphInfluences = object.morphTargetInfluences;

		if (morphAttribute && morphInfluences) {

			_morphA.set(0, 0, 0);
			_morphB.set(0, 0, 0);
			_morphC.set(0, 0, 0);

			for (var _i7 = 0, _il = morphAttribute.length; _i7 < _il; _i7++) {

				var influence = morphInfluences[_i7];
				var morph = morphAttribute[_i7];

				if (influence === 0) continue;

				_tempA.fromBufferAttribute(morph, a);
				_tempB.fromBufferAttribute(morph, b);
				_tempC.fromBufferAttribute(morph, c);

				if (morphTargetsRelative) {

					_morphA.addScaledVector(_tempA, influence);
					_morphB.addScaledVector(_tempB, influence);
					_morphC.addScaledVector(_tempC, influence);
				} else {

					_morphA.addScaledVector(_tempA.sub(_vA), influence);
					_morphB.addScaledVector(_tempB.sub(_vB), influence);
					_morphC.addScaledVector(_tempC.sub(_vC), influence);
				}
			}

			_vA.add(_morphA);
			_vB.add(_morphB);
			_vC.add(_morphC);
		}

		if (object.isSkinnedMesh) {

			object.applyBoneTransform(a, _vA);
			object.applyBoneTransform(b, _vB);
			object.applyBoneTransform(c, _vC);
		}

		modifiedAttributeArray[a * 3 + 0] = _vA.x;
		modifiedAttributeArray[a * 3 + 1] = _vA.y;
		modifiedAttributeArray[a * 3 + 2] = _vA.z;
		modifiedAttributeArray[b * 3 + 0] = _vB.x;
		modifiedAttributeArray[b * 3 + 1] = _vB.y;
		modifiedAttributeArray[b * 3 + 2] = _vB.z;
		modifiedAttributeArray[c * 3 + 0] = _vC.x;
		modifiedAttributeArray[c * 3 + 1] = _vC.y;
		modifiedAttributeArray[c * 3 + 2] = _vC.z;
	}

	var geometry = object.geometry;
	var material = object.material;

	var a = void 0,
	    b = void 0,
	    c = void 0;
	var index = geometry.index;
	var positionAttribute = geometry.attributes.position;
	var morphPosition = geometry.morphAttributes.position;
	var morphTargetsRelative = geometry.morphTargetsRelative;
	var normalAttribute = geometry.attributes.normal;
	var morphNormal = geometry.morphAttributes.position;

	var groups = geometry.groups;
	var drawRange = geometry.drawRange;
	var i = void 0,
	    j = void 0,
	    il = void 0,
	    jl = void 0;
	var group = void 0;
	var start = void 0,
	    end = void 0;

	var modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
	var modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);

	if (index !== null) {

		// indexed buffer geometry

		if (Array.isArray(material)) {

			for (i = 0, il = groups.length; i < il; i++) {

				group = groups[i];

				start = Math.max(group.start, drawRange.start);
				end = Math.min(group.start + group.count, drawRange.start + drawRange.count);

				for (j = start, jl = end; j < jl; j += 3) {

					a = index.getX(j);
					b = index.getX(j + 1);
					c = index.getX(j + 2);

					_calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);

					_calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
				}
			}
		} else {

			start = Math.max(0, drawRange.start);
			end = Math.min(index.count, drawRange.start + drawRange.count);

			for (i = start, il = end; i < il; i += 3) {

				a = index.getX(i);
				b = index.getX(i + 1);
				c = index.getX(i + 2);

				_calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);

				_calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
			}
		}
	} else {

		// non-indexed buffer geometry

		if (Array.isArray(material)) {

			for (i = 0, il = groups.length; i < il; i++) {

				group = groups[i];

				start = Math.max(group.start, drawRange.start);
				end = Math.min(group.start + group.count, drawRange.start + drawRange.count);

				for (j = start, jl = end; j < jl; j += 3) {

					a = j;
					b = j + 1;
					c = j + 2;

					_calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);

					_calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
				}
			}
		} else {

			start = Math.max(0, drawRange.start);
			end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);

			for (i = start, il = end; i < il; i += 3) {

				a = i;
				b = i + 1;
				c = i + 2;

				_calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);

				_calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
			}
		}
	}

	var morphedPositionAttribute = new three_module["z" /* Float32BufferAttribute */](modifiedPosition, 3);
	var morphedNormalAttribute = new three_module["z" /* Float32BufferAttribute */](modifiedNormal, 3);

	return {

		positionAttribute: positionAttribute,
		normalAttribute: normalAttribute,
		morphedPositionAttribute: morphedPositionAttribute,
		morphedNormalAttribute: morphedNormalAttribute

	};
}

function mergeGroups(geometry) {

	if (geometry.groups.length === 0) {

		console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
		return geometry;
	}

	var groups = geometry.groups;

	// sort groups by material index

	groups = groups.sort(function (a, b) {

		if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;

		return a.start - b.start;
	});

	// create index for non-indexed geometries

	if (geometry.getIndex() === null) {

		var positionAttribute = geometry.getAttribute('position');
		var indices = [];

		for (var i = 0; i < positionAttribute.count; i += 3) {

			indices.push(i, i + 1, i + 2);
		}

		geometry.setIndex(indices);
	}

	// sort index

	var index = geometry.getIndex();

	var newIndices = [];

	for (var _i8 = 0; _i8 < groups.length; _i8++) {

		var group = groups[_i8];

		var groupStart = group.start;
		var groupLength = groupStart + group.count;

		for (var j = groupStart; j < groupLength; j++) {

			newIndices.push(index.getX(j));
		}
	}

	geometry.dispose(); // Required to force buffer recreation
	geometry.setIndex(newIndices);

	// update groups indices

	var start = 0;

	for (var _i9 = 0; _i9 < groups.length; _i9++) {

		var _group = groups[_i9];

		_group.start = start;
		start += _group.count;
	}

	// merge groups

	var currentGroup = groups[0];

	geometry.groups = [currentGroup];

	for (var _i10 = 1; _i10 < groups.length; _i10++) {

		var _group2 = groups[_i10];

		if (currentGroup.materialIndex === _group2.materialIndex) {

			currentGroup.count += _group2.count;
		} else {

			currentGroup = _group2;
			geometry.groups.push(currentGroup);
		}
	}

	return geometry;
}

// Creates a new, non-indexed geometry with smooth normals everywhere except faces that meet at
// an angle greater than the crease angle.
function toCreasedNormals(geometry) /* 60 degrees */{
	var creaseAngle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.PI / 3;


	var creaseDot = Math.cos(creaseAngle);
	var hashMultiplier = (1 + 1e-10) * 1e2;

	// reusable vertors
	var verts = [new three_module["_41" /* Vector3 */](), new three_module["_41" /* Vector3 */](), new three_module["_41" /* Vector3 */]()];
	var tempVec1 = new three_module["_41" /* Vector3 */]();
	var tempVec2 = new three_module["_41" /* Vector3 */]();
	var tempNorm = new three_module["_41" /* Vector3 */]();
	var tempNorm2 = new three_module["_41" /* Vector3 */]();

	// hashes a vector
	function hashVertex(v) {

		var x = ~~(v.x * hashMultiplier);
		var y = ~~(v.y * hashMultiplier);
		var z = ~~(v.z * hashMultiplier);
		return x + ',' + y + ',' + z;
	}

	var resultGeometry = geometry.toNonIndexed();
	var posAttr = resultGeometry.attributes.position;
	var vertexMap = {};

	// find all the normals shared by commonly located vertices
	for (var i = 0, l = posAttr.count / 3; i < l; i++) {

		var i3 = 3 * i;
		var a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
		var b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
		var c = verts[2].fromBufferAttribute(posAttr, i3 + 2);

		tempVec1.subVectors(c, b);
		tempVec2.subVectors(a, b);

		// add the normal to the map for all vertices
		var normal = new three_module["_41" /* Vector3 */]().crossVectors(tempVec1, tempVec2).normalize();
		for (var n = 0; n < 3; n++) {

			var vert = verts[n];
			var hash = hashVertex(vert);
			if (!(hash in vertexMap)) {

				vertexMap[hash] = [];
			}

			vertexMap[hash].push(normal);
		}
	}

	// average normals from all vertices that share a common location if they are within the
	// provided crease threshold
	var normalArray = new Float32Array(posAttr.count * 3);
	var normAttr = new three_module["j" /* BufferAttribute */](normalArray, 3, false);
	for (var _i11 = 0, _l4 = posAttr.count / 3; _i11 < _l4; _i11++) {

		// get the face normal for this vertex
		var _i12 = 3 * _i11;
		var _a = verts[0].fromBufferAttribute(posAttr, _i12 + 0);
		var _b = verts[1].fromBufferAttribute(posAttr, _i12 + 1);
		var _c = verts[2].fromBufferAttribute(posAttr, _i12 + 2);

		tempVec1.subVectors(_c, _b);
		tempVec2.subVectors(_a, _b);

		tempNorm.crossVectors(tempVec1, tempVec2).normalize();

		// average all normals that meet the threshold and set the normal value
		for (var _n = 0; _n < 3; _n++) {

			var _vert = verts[_n];
			var _hash = hashVertex(_vert);
			var otherNormals = vertexMap[_hash];
			tempNorm2.set(0, 0, 0);

			for (var k = 0, lk = otherNormals.length; k < lk; k++) {

				var otherNorm = otherNormals[k];
				if (tempNorm.dot(otherNorm) > creaseDot) {

					tempNorm2.add(otherNorm);
				}
			}

			tempNorm2.normalize();
			normAttr.setXYZ(_i12 + _n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
		}
	}

	resultGeometry.setAttribute('normal', normAttr);
	return resultGeometry;
}

function mergeBufferGeometries(geometries) {
	var useGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	console.warn('THREE.BufferGeometryUtils: mergeBufferGeometries() has been renamed to mergeGeometries().'); // @deprecated, r151
	return mergeGeometries(geometries, useGroups);
}

function mergeBufferAttributes(attributes) {

	console.warn('THREE.BufferGeometryUtils: mergeBufferAttributes() has been renamed to mergeAttributes().'); // @deprecated, r151
	return mergeAttributes(attributes);
}


// CONCATENATED MODULE: ./node_modules/three/examples/jsm/loaders/GLTFLoader.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLTFLoader_GLTFLoader; });

















var GLTFLoader_GLTFLoader = function (_Loader) {
	inherits_default()(GLTFLoader, _Loader);

	function GLTFLoader(manager) {
		classCallCheck_default()(this, GLTFLoader);

		var _this = possibleConstructorReturn_default()(this, (GLTFLoader.__proto__ || get_prototype_of_default()(GLTFLoader)).call(this, manager));

		_this.dracoLoader = null;
		_this.ktx2Loader = null;
		_this.meshoptDecoder = null;

		_this.pluginCallbacks = [];

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsClearcoatExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFTextureBasisUExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFTextureWebPExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFTextureAVIFExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsSheenExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsTransmissionExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsVolumeExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsIorExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsEmissiveStrengthExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsSpecularExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMaterialsIridescenceExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFLightsExtension(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMeshoptCompression(parser);
		});

		_this.register(function (parser) {

			return new GLTFLoader_GLTFMeshGpuInstancing(parser);
		});

		return _this;
	}

	createClass_default()(GLTFLoader, [{
		key: 'load',
		value: function load(url, onLoad, onProgress, onError) {

			var scope = this;

			var resourcePath = void 0;

			if (this.resourcePath !== '') {

				resourcePath = this.resourcePath;
			} else if (this.path !== '') {

				resourcePath = this.path;
			} else {

				resourcePath = three_module["V" /* LoaderUtils */].extractUrlBase(url);
			}

			// Tells the LoadingManager to track an extra item, which resolves after
			// the model is fully loaded. This means the count of items loaded will
			// be incorrect, but ensures manager.onLoad() does not fire early.
			this.manager.itemStart(url);

			var _onError = function _onError(e) {

				if (onError) {

					onError(e);
				} else {

					console.error(e);
				}

				scope.manager.itemError(url);
				scope.manager.itemEnd(url);
			};

			var loader = new three_module["y" /* FileLoader */](this.manager);

			loader.setPath(this.path);
			loader.setResponseType('arraybuffer');
			loader.setRequestHeader(this.requestHeader);
			loader.setWithCredentials(this.withCredentials);

			loader.load(url, function (data) {

				try {

					scope.parse(data, resourcePath, function (gltf) {

						onLoad(gltf);

						scope.manager.itemEnd(url);
					}, _onError);
				} catch (e) {

					_onError(e);
				}
			}, onProgress, _onError);
		}
	}, {
		key: 'setDRACOLoader',
		value: function setDRACOLoader(dracoLoader) {

			this.dracoLoader = dracoLoader;
			return this;
		}
	}, {
		key: 'setDDSLoader',
		value: function setDDSLoader() {

			throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
		}
	}, {
		key: 'setKTX2Loader',
		value: function setKTX2Loader(ktx2Loader) {

			this.ktx2Loader = ktx2Loader;
			return this;
		}
	}, {
		key: 'setMeshoptDecoder',
		value: function setMeshoptDecoder(meshoptDecoder) {

			this.meshoptDecoder = meshoptDecoder;
			return this;
		}
	}, {
		key: 'register',
		value: function register(callback) {

			if (this.pluginCallbacks.indexOf(callback) === -1) {

				this.pluginCallbacks.push(callback);
			}

			return this;
		}
	}, {
		key: 'unregister',
		value: function unregister(callback) {

			if (this.pluginCallbacks.indexOf(callback) !== -1) {

				this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
			}

			return this;
		}
	}, {
		key: 'parse',
		value: function parse(data, path, onLoad, onError) {

			var json = void 0;
			var extensions = {};
			var plugins = {};
			var textDecoder = new TextDecoder();

			if (typeof data === 'string') {

				json = JSON.parse(data);
			} else if (data instanceof ArrayBuffer) {

				var magic = textDecoder.decode(new Uint8Array(data, 0, 4));

				if (magic === BINARY_EXTENSION_HEADER_MAGIC) {

					try {

						extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFLoader_GLTFBinaryExtension(data);
					} catch (error) {

						if (onError) onError(error);
						return;
					}

					json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
				} else {

					json = JSON.parse(textDecoder.decode(data));
				}
			} else {

				json = data;
			}

			if (json.asset === undefined || json.asset.version[0] < 2) {

				if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
				return;
			}

			var parser = new GLTFLoader_GLTFParser(json, {

				path: path || this.resourcePath || '',
				crossOrigin: this.crossOrigin,
				requestHeader: this.requestHeader,
				manager: this.manager,
				ktx2Loader: this.ktx2Loader,
				meshoptDecoder: this.meshoptDecoder

			});

			parser.fileLoader.setRequestHeader(this.requestHeader);

			for (var i = 0; i < this.pluginCallbacks.length; i++) {

				var plugin = this.pluginCallbacks[i](parser);
				plugins[plugin.name] = plugin;

				// Workaround to avoid determining as unknown extension
				// in addUnknownExtensionsToUserData().
				// Remove this workaround if we move all the existing
				// extension handlers to plugin system
				extensions[plugin.name] = true;
			}

			if (json.extensionsUsed) {

				for (var _i = 0; _i < json.extensionsUsed.length; ++_i) {

					var extensionName = json.extensionsUsed[_i];
					var extensionsRequired = json.extensionsRequired || [];

					switch (extensionName) {

						case EXTENSIONS.KHR_MATERIALS_UNLIT:
							extensions[extensionName] = new GLTFLoader_GLTFMaterialsUnlitExtension();
							break;

						case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
							extensions[extensionName] = new GLTFLoader_GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
							break;

						case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
							extensions[extensionName] = new GLTFLoader_GLTFTextureTransformExtension();
							break;

						case EXTENSIONS.KHR_MESH_QUANTIZATION:
							extensions[extensionName] = new GLTFLoader_GLTFMeshQuantizationExtension();
							break;

						default:

							if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) {

								console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
							}

					}
				}
			}

			parser.setExtensions(extensions);
			parser.setPlugins(plugins);
			parser.parse(onLoad, onError);
		}
	}, {
		key: 'parseAsync',
		value: function parseAsync(data, path) {

			var scope = this;

			return new promise_default.a(function (resolve, reject) {

				scope.parse(data, path, resolve, reject);
			});
		}
	}]);

	return GLTFLoader;
}(three_module["U" /* Loader */]);

/* GLTFREGISTRY */

function GLTFRegistry() {

	var objects = {};

	return {

		get: function get(key) {

			return objects[key];
		},

		add: function add(key, object) {

			objects[key] = object;
		},

		remove: function remove(key) {

			delete objects[key];
		},

		removeAll: function removeAll() {

			objects = {};
		}

	};
}

/*********************************/
/********** EXTENSIONS ***********/
/*********************************/

var EXTENSIONS = {
	KHR_BINARY_GLTF: 'KHR_binary_glTF',
	KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
	KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
	KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
	KHR_MATERIALS_IOR: 'KHR_materials_ior',
	KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
	KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
	KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
	KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
	KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
	KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
	KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
	KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
	KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
	KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
	EXT_TEXTURE_WEBP: 'EXT_texture_webp',
	EXT_TEXTURE_AVIF: 'EXT_texture_avif',
	EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
	EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};

/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */

var GLTFLoader_GLTFLightsExtension = function () {
	function GLTFLightsExtension(parser) {
		classCallCheck_default()(this, GLTFLightsExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;

		// Object3D instance caches
		this.cache = { refs: {}, uses: {} };
	}

	createClass_default()(GLTFLightsExtension, [{
		key: '_markDefs',
		value: function _markDefs() {

			var parser = this.parser;
			var nodeDefs = this.parser.json.nodes || [];

			for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {

				var nodeDef = nodeDefs[nodeIndex];

				if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) {

					parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
				}
			}
		}
	}, {
		key: '_loadLight',
		value: function _loadLight(lightIndex) {

			var parser = this.parser;
			var cacheKey = 'light:' + lightIndex;
			var dependency = parser.cache.get(cacheKey);

			if (dependency) return dependency;

			var json = parser.json;
			var extensions = json.extensions && json.extensions[this.name] || {};
			var lightDefs = extensions.lights || [];
			var lightDef = lightDefs[lightIndex];
			var lightNode = void 0;

			var color = new three_module["o" /* Color */](0xffffff);

			if (lightDef.color !== undefined) color.fromArray(lightDef.color);

			var range = lightDef.range !== undefined ? lightDef.range : 0;

			switch (lightDef.type) {

				case 'directional':
					lightNode = new three_module["s" /* DirectionalLight */](color);
					lightNode.target.position.set(0, 0, -1);
					lightNode.add(lightNode.target);
					break;

				case 'point':
					lightNode = new three_module["_18" /* PointLight */](color);
					lightNode.distance = range;
					break;

				case 'spot':
					lightNode = new three_module["_32" /* SpotLight */](color);
					lightNode.distance = range;
					// Handle spotlight properties.
					lightDef.spot = lightDef.spot || {};
					lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
					lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
					lightNode.angle = lightDef.spot.outerConeAngle;
					lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
					lightNode.target.position.set(0, 0, -1);
					lightNode.add(lightNode.target);
					break;

				default:
					throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);

			}

			// Some lights (e.g. spot) default to a position other than the origin. Reset the position
			// here, because node-level parsing will only override position if explicitly specified.
			lightNode.position.set(0, 0, 0);

			lightNode.decay = 2;

			assignExtrasToUserData(lightNode, lightDef);

			if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;

			lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);

			dependency = promise_default.a.resolve(lightNode);

			parser.cache.add(cacheKey, dependency);

			return dependency;
		}
	}, {
		key: 'getDependency',
		value: function getDependency(type, index) {

			if (type !== 'light') return;

			return this._loadLight(index);
		}
	}, {
		key: 'createNodeAttachment',
		value: function createNodeAttachment(nodeIndex) {

			var self = this;
			var parser = this.parser;
			var json = parser.json;
			var nodeDef = json.nodes[nodeIndex];
			var lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
			var lightIndex = lightDef.light;

			if (lightIndex === undefined) return null;

			return this._loadLight(lightIndex).then(function (light) {

				return parser._getNodeRef(self.cache, lightIndex, light);
			});
		}
	}]);

	return GLTFLightsExtension;
}();

/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */


var GLTFLoader_GLTFMaterialsUnlitExtension = function () {
	function GLTFMaterialsUnlitExtension() {
		classCallCheck_default()(this, GLTFMaterialsUnlitExtension);

		this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
	}

	createClass_default()(GLTFMaterialsUnlitExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType() {

			return three_module["_4" /* MeshBasicMaterial */];
		}
	}, {
		key: 'extendParams',
		value: function extendParams(materialParams, materialDef, parser) {

			var pending = [];

			materialParams.color = new three_module["o" /* Color */](1.0, 1.0, 1.0);
			materialParams.opacity = 1.0;

			var metallicRoughness = materialDef.pbrMetallicRoughness;

			if (metallicRoughness) {

				if (Array.isArray(metallicRoughness.baseColorFactor)) {

					var array = metallicRoughness.baseColorFactor;

					materialParams.color.fromArray(array);
					materialParams.opacity = array[3];
				}

				if (metallicRoughness.baseColorTexture !== undefined) {

					pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, three_module["_45" /* sRGBEncoding */]));
				}
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsUnlitExtension;
}();

/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */


var GLTFLoader_GLTFMaterialsEmissiveStrengthExtension = function () {
	function GLTFMaterialsEmissiveStrengthExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsEmissiveStrengthExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
	}

	createClass_default()(GLTFMaterialsEmissiveStrengthExtension, [{
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var emissiveStrength = materialDef.extensions[this.name].emissiveStrength;

			if (emissiveStrength !== undefined) {

				materialParams.emissiveIntensity = emissiveStrength;
			}

			return promise_default.a.resolve();
		}
	}]);

	return GLTFMaterialsEmissiveStrengthExtension;
}();

/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */


var GLTFLoader_GLTFMaterialsClearcoatExtension = function () {
	function GLTFMaterialsClearcoatExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsClearcoatExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
	}

	createClass_default()(GLTFMaterialsClearcoatExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			var extension = materialDef.extensions[this.name];

			if (extension.clearcoatFactor !== undefined) {

				materialParams.clearcoat = extension.clearcoatFactor;
			}

			if (extension.clearcoatTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
			}

			if (extension.clearcoatRoughnessFactor !== undefined) {

				materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
			}

			if (extension.clearcoatRoughnessTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
			}

			if (extension.clearcoatNormalTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));

				if (extension.clearcoatNormalTexture.scale !== undefined) {

					var scale = extension.clearcoatNormalTexture.scale;

					materialParams.clearcoatNormalScale = new three_module["_40" /* Vector2 */](scale, scale);
				}
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsClearcoatExtension;
}();

/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */


var GLTFLoader_GLTFMaterialsIridescenceExtension = function () {
	function GLTFMaterialsIridescenceExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsIridescenceExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
	}

	createClass_default()(GLTFMaterialsIridescenceExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			var extension = materialDef.extensions[this.name];

			if (extension.iridescenceFactor !== undefined) {

				materialParams.iridescence = extension.iridescenceFactor;
			}

			if (extension.iridescenceTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
			}

			if (extension.iridescenceIor !== undefined) {

				materialParams.iridescenceIOR = extension.iridescenceIor;
			}

			if (materialParams.iridescenceThicknessRange === undefined) {

				materialParams.iridescenceThicknessRange = [100, 400];
			}

			if (extension.iridescenceThicknessMinimum !== undefined) {

				materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
			}

			if (extension.iridescenceThicknessMaximum !== undefined) {

				materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
			}

			if (extension.iridescenceThicknessTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsIridescenceExtension;
}();

/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */


var GLTFLoader_GLTFMaterialsSheenExtension = function () {
	function GLTFMaterialsSheenExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsSheenExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
	}

	createClass_default()(GLTFMaterialsSheenExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			materialParams.sheenColor = new three_module["o" /* Color */](0, 0, 0);
			materialParams.sheenRoughness = 0;
			materialParams.sheen = 1;

			var extension = materialDef.extensions[this.name];

			if (extension.sheenColorFactor !== undefined) {

				materialParams.sheenColor.fromArray(extension.sheenColorFactor);
			}

			if (extension.sheenRoughnessFactor !== undefined) {

				materialParams.sheenRoughness = extension.sheenRoughnessFactor;
			}

			if (extension.sheenColorTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, three_module["_45" /* sRGBEncoding */]));
			}

			if (extension.sheenRoughnessTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsSheenExtension;
}();

/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */


var GLTFLoader_GLTFMaterialsTransmissionExtension = function () {
	function GLTFMaterialsTransmissionExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsTransmissionExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
	}

	createClass_default()(GLTFMaterialsTransmissionExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			var extension = materialDef.extensions[this.name];

			if (extension.transmissionFactor !== undefined) {

				materialParams.transmission = extension.transmissionFactor;
			}

			if (extension.transmissionTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsTransmissionExtension;
}();

/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */


var GLTFLoader_GLTFMaterialsVolumeExtension = function () {
	function GLTFMaterialsVolumeExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsVolumeExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
	}

	createClass_default()(GLTFMaterialsVolumeExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			var extension = materialDef.extensions[this.name];

			materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;

			if (extension.thicknessTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
			}

			materialParams.attenuationDistance = extension.attenuationDistance || Infinity;

			var colorArray = extension.attenuationColor || [1, 1, 1];
			materialParams.attenuationColor = new three_module["o" /* Color */](colorArray[0], colorArray[1], colorArray[2]);

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsVolumeExtension;
}();

/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */


var GLTFLoader_GLTFMaterialsIorExtension = function () {
	function GLTFMaterialsIorExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsIorExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_IOR;
	}

	createClass_default()(GLTFMaterialsIorExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var extension = materialDef.extensions[this.name];

			materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;

			return promise_default.a.resolve();
		}
	}]);

	return GLTFMaterialsIorExtension;
}();

/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */


var GLTFLoader_GLTFMaterialsSpecularExtension = function () {
	function GLTFMaterialsSpecularExtension(parser) {
		classCallCheck_default()(this, GLTFMaterialsSpecularExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
	}

	createClass_default()(GLTFMaterialsSpecularExtension, [{
		key: 'getMaterialType',
		value: function getMaterialType(materialIndex) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;

			return three_module["_7" /* MeshPhysicalMaterial */];
		}
	}, {
		key: 'extendMaterialParams',
		value: function extendMaterialParams(materialIndex, materialParams) {

			var parser = this.parser;
			var materialDef = parser.json.materials[materialIndex];

			if (!materialDef.extensions || !materialDef.extensions[this.name]) {

				return promise_default.a.resolve();
			}

			var pending = [];

			var extension = materialDef.extensions[this.name];

			materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;

			if (extension.specularTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
			}

			var colorArray = extension.specularColorFactor || [1, 1, 1];
			materialParams.specularColor = new three_module["o" /* Color */](colorArray[0], colorArray[1], colorArray[2]);

			if (extension.specularColorTexture !== undefined) {

				pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, three_module["_45" /* sRGBEncoding */]));
			}

			return promise_default.a.all(pending);
		}
	}]);

	return GLTFMaterialsSpecularExtension;
}();

/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */


var GLTFLoader_GLTFTextureBasisUExtension = function () {
	function GLTFTextureBasisUExtension(parser) {
		classCallCheck_default()(this, GLTFTextureBasisUExtension);

		this.parser = parser;
		this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
	}

	createClass_default()(GLTFTextureBasisUExtension, [{
		key: 'loadTexture',
		value: function loadTexture(textureIndex) {

			var parser = this.parser;
			var json = parser.json;

			var textureDef = json.textures[textureIndex];

			if (!textureDef.extensions || !textureDef.extensions[this.name]) {

				return null;
			}

			var extension = textureDef.extensions[this.name];
			var loader = parser.options.ktx2Loader;

			if (!loader) {

				if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {

					throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
				} else {

					// Assumes that the extension is optional and that a fallback texture is present
					return null;
				}
			}

			return parser.loadTextureImage(textureIndex, extension.source, loader);
		}
	}]);

	return GLTFTextureBasisUExtension;
}();

/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */


var GLTFLoader_GLTFTextureWebPExtension = function () {
	function GLTFTextureWebPExtension(parser) {
		classCallCheck_default()(this, GLTFTextureWebPExtension);

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
		this.isSupported = null;
	}

	createClass_default()(GLTFTextureWebPExtension, [{
		key: 'loadTexture',
		value: function loadTexture(textureIndex) {

			var name = this.name;
			var parser = this.parser;
			var json = parser.json;

			var textureDef = json.textures[textureIndex];

			if (!textureDef.extensions || !textureDef.extensions[name]) {

				return null;
			}

			var extension = textureDef.extensions[name];
			var source = json.images[extension.source];

			var loader = parser.textureLoader;
			if (source.uri) {

				var handler = parser.options.manager.getHandler(source.uri);
				if (handler !== null) loader = handler;
			}

			return this.detectSupport().then(function (isSupported) {

				if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);

				if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {

					throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
				}

				// Fall back to PNG or JPEG.
				return parser.loadTexture(textureIndex);
			});
		}
	}, {
		key: 'detectSupport',
		value: function detectSupport() {

			if (!this.isSupported) {

				this.isSupported = new promise_default.a(function (resolve) {

					var image = new Image();

					// Lossy test image. Support for lossy images doesn't guarantee support for all
					// WebP images, unfortunately.
					image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';

					image.onload = image.onerror = function () {

						resolve(image.height === 1);
					};
				});
			}

			return this.isSupported;
		}
	}]);

	return GLTFTextureWebPExtension;
}();

/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */


var GLTFLoader_GLTFTextureAVIFExtension = function () {
	function GLTFTextureAVIFExtension(parser) {
		classCallCheck_default()(this, GLTFTextureAVIFExtension);

		this.parser = parser;
		this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
		this.isSupported = null;
	}

	createClass_default()(GLTFTextureAVIFExtension, [{
		key: 'loadTexture',
		value: function loadTexture(textureIndex) {

			var name = this.name;
			var parser = this.parser;
			var json = parser.json;

			var textureDef = json.textures[textureIndex];

			if (!textureDef.extensions || !textureDef.extensions[name]) {

				return null;
			}

			var extension = textureDef.extensions[name];
			var source = json.images[extension.source];

			var loader = parser.textureLoader;
			if (source.uri) {

				var handler = parser.options.manager.getHandler(source.uri);
				if (handler !== null) loader = handler;
			}

			return this.detectSupport().then(function (isSupported) {

				if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);

				if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) {

					throw new Error('THREE.GLTFLoader: AVIF required by asset but unsupported.');
				}

				// Fall back to PNG or JPEG.
				return parser.loadTexture(textureIndex);
			});
		}
	}, {
		key: 'detectSupport',
		value: function detectSupport() {

			if (!this.isSupported) {

				this.isSupported = new promise_default.a(function (resolve) {

					var image = new Image();

					// Lossy test image.
					image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
					image.onload = image.onerror = function () {

						resolve(image.height === 1);
					};
				});
			}

			return this.isSupported;
		}
	}]);

	return GLTFTextureAVIFExtension;
}();

/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */


var GLTFLoader_GLTFMeshoptCompression = function () {
	function GLTFMeshoptCompression(parser) {
		classCallCheck_default()(this, GLTFMeshoptCompression);

		this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
		this.parser = parser;
	}

	createClass_default()(GLTFMeshoptCompression, [{
		key: 'loadBufferView',
		value: function loadBufferView(index) {

			var json = this.parser.json;
			var bufferView = json.bufferViews[index];

			if (bufferView.extensions && bufferView.extensions[this.name]) {

				var extensionDef = bufferView.extensions[this.name];

				var buffer = this.parser.getDependency('buffer', extensionDef.buffer);
				var decoder = this.parser.options.meshoptDecoder;

				if (!decoder || !decoder.supported) {

					if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {

						throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
					} else {

						// Assumes that the extension is optional and that fallback buffer data is present
						return null;
					}
				}

				return buffer.then(function (res) {

					var byteOffset = extensionDef.byteOffset || 0;
					var byteLength = extensionDef.byteLength || 0;

					var count = extensionDef.count;
					var stride = extensionDef.byteStride;

					var source = new Uint8Array(res, byteOffset, byteLength);

					if (decoder.decodeGltfBufferAsync) {

						return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function (res) {

							return res.buffer;
						});
					} else {

						// Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
						return decoder.ready.then(function () {

							var result = new ArrayBuffer(count * stride);
							decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
							return result;
						});
					}
				});
			} else {

				return null;
			}
		}
	}]);

	return GLTFMeshoptCompression;
}();

/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */


var GLTFLoader_GLTFMeshGpuInstancing = function () {
	function GLTFMeshGpuInstancing(parser) {
		classCallCheck_default()(this, GLTFMeshGpuInstancing);

		this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
		this.parser = parser;
	}

	createClass_default()(GLTFMeshGpuInstancing, [{
		key: 'createNodeMesh',
		value: function createNodeMesh(nodeIndex) {
			var _this2 = this;

			var json = this.parser.json;
			var nodeDef = json.nodes[nodeIndex];

			if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) {

				return null;
			}

			var meshDef = json.meshes[nodeDef.mesh];

			// No Points or Lines + Instancing support yet

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = get_iterator_default()(meshDef.primitives), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var primitive = _step.value;


					if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) {

						return null;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			var extensionDef = nodeDef.extensions[this.name];
			var attributesDef = extensionDef.attributes;

			// @TODO: Can we support InstancedMesh + SkinnedMesh?

			var pending = [];
			var attributes = {};

			var _loop = function _loop(key) {

				pending.push(_this2.parser.getDependency('accessor', attributesDef[key]).then(function (accessor) {

					attributes[key] = accessor;
					return attributes[key];
				}));
			};

			for (var key in attributesDef) {
				_loop(key);
			}

			if (pending.length < 1) {

				return null;
			}

			pending.push(this.parser.createNodeMesh(nodeIndex));

			return promise_default.a.all(pending).then(function (results) {

				var nodeObject = results.pop();
				var meshes = nodeObject.isGroup ? nodeObject.children : [nodeObject];
				var count = results[0].count; // All attribute counts should be same
				var instancedMeshes = [];

				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;

				try {
					for (var _iterator2 = get_iterator_default()(meshes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var mesh = _step2.value;


						// Temporal variables
						var m = new three_module["_2" /* Matrix4 */]();
						var p = new three_module["_41" /* Vector3 */]();
						var q = new three_module["_22" /* Quaternion */]();
						var s = new three_module["_41" /* Vector3 */](1, 1, 1);

						var instancedMesh = new three_module["G" /* InstancedMesh */](mesh.geometry, mesh.material, count);

						for (var i = 0; i < count; i++) {

							if (attributes.TRANSLATION) {

								p.fromBufferAttribute(attributes.TRANSLATION, i);
							}

							if (attributes.ROTATION) {

								q.fromBufferAttribute(attributes.ROTATION, i);
							}

							if (attributes.SCALE) {

								s.fromBufferAttribute(attributes.SCALE, i);
							}

							instancedMesh.setMatrixAt(i, m.compose(p, q, s));
						}

						// Add instance attributes to the geometry, excluding TRS.
						for (var attributeName in attributes) {

							if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') {

								mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
							}
						}

						// Just in case
						three_module["_14" /* Object3D */].prototype.copy.call(instancedMesh, mesh);

						_this2.parser.assignFinalMaterial(instancedMesh);

						instancedMeshes.push(instancedMesh);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}

				if (nodeObject.isGroup) {

					nodeObject.clear();

					nodeObject.add.apply(nodeObject, instancedMeshes);

					return nodeObject;
				}

				return instancedMeshes[0];
			});
		}
	}]);

	return GLTFMeshGpuInstancing;
}();

/* BINARY EXTENSION */


var BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
var BINARY_EXTENSION_HEADER_LENGTH = 12;
var BINARY_EXTENSION_CHUNK_TYPES = { JSON: 0x4E4F534A, BIN: 0x004E4942 };

var GLTFLoader_GLTFBinaryExtension = function GLTFBinaryExtension(data) {
	classCallCheck_default()(this, GLTFBinaryExtension);

	this.name = EXTENSIONS.KHR_BINARY_GLTF;
	this.content = null;
	this.body = null;

	var headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
	var textDecoder = new TextDecoder();

	this.header = {
		magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
		version: headerView.getUint32(4, true),
		length: headerView.getUint32(8, true)
	};

	if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {

		throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
	} else if (this.header.version < 2.0) {

		throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
	}

	var chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
	var chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
	var chunkIndex = 0;

	while (chunkIndex < chunkContentsLength) {

		var chunkLength = chunkView.getUint32(chunkIndex, true);
		chunkIndex += 4;

		var chunkType = chunkView.getUint32(chunkIndex, true);
		chunkIndex += 4;

		if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {

			var contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
			this.content = textDecoder.decode(contentArray);
		} else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {

			var byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
			this.body = data.slice(byteOffset, byteOffset + chunkLength);
		}

		// Clients must ignore chunks with unknown types.

		chunkIndex += chunkLength;
	}

	if (this.content === null) {

		throw new Error('THREE.GLTFLoader: JSON content not found.');
	}
};

/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */


var GLTFLoader_GLTFDracoMeshCompressionExtension = function () {
	function GLTFDracoMeshCompressionExtension(json, dracoLoader) {
		classCallCheck_default()(this, GLTFDracoMeshCompressionExtension);

		if (!dracoLoader) {

			throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
		}

		this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
		this.json = json;
		this.dracoLoader = dracoLoader;
		this.dracoLoader.preload();
	}

	createClass_default()(GLTFDracoMeshCompressionExtension, [{
		key: 'decodePrimitive',
		value: function decodePrimitive(primitive, parser) {

			var json = this.json;
			var dracoLoader = this.dracoLoader;
			var bufferViewIndex = primitive.extensions[this.name].bufferView;
			var gltfAttributeMap = primitive.extensions[this.name].attributes;
			var threeAttributeMap = {};
			var attributeNormalizedMap = {};
			var attributeTypeMap = {};

			for (var attributeName in gltfAttributeMap) {

				var threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();

				threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
			}

			for (var _attributeName in primitive.attributes) {

				var _threeAttributeName = ATTRIBUTES[_attributeName] || _attributeName.toLowerCase();

				if (gltfAttributeMap[_attributeName] !== undefined) {

					var accessorDef = json.accessors[primitive.attributes[_attributeName]];
					var componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

					attributeTypeMap[_threeAttributeName] = componentType.name;
					attributeNormalizedMap[_threeAttributeName] = accessorDef.normalized === true;
				}
			}

			return parser.getDependency('bufferView', bufferViewIndex).then(function (bufferView) {

				return new promise_default.a(function (resolve) {

					dracoLoader.decodeDracoFile(bufferView, function (geometry) {

						for (var _attributeName2 in geometry.attributes) {

							var attribute = geometry.attributes[_attributeName2];
							var normalized = attributeNormalizedMap[_attributeName2];

							if (normalized !== undefined) attribute.normalized = normalized;
						}

						resolve(geometry);
					}, threeAttributeMap, attributeTypeMap);
				});
			});
		}
	}]);

	return GLTFDracoMeshCompressionExtension;
}();

/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */


var GLTFLoader_GLTFTextureTransformExtension = function () {
	function GLTFTextureTransformExtension() {
		classCallCheck_default()(this, GLTFTextureTransformExtension);

		this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
	}

	createClass_default()(GLTFTextureTransformExtension, [{
		key: 'extendTexture',
		value: function extendTexture(texture, transform) {

			if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) {

				// See https://github.com/mrdoob/three.js/issues/21819.
				return texture;
			}

			texture = texture.clone();

			if (transform.texCoord !== undefined) {

				texture.channel = transform.texCoord;
			}

			if (transform.offset !== undefined) {

				texture.offset.fromArray(transform.offset);
			}

			if (transform.rotation !== undefined) {

				texture.rotation = transform.rotation;
			}

			if (transform.scale !== undefined) {

				texture.repeat.fromArray(transform.scale);
			}

			texture.needsUpdate = true;

			return texture;
		}
	}]);

	return GLTFTextureTransformExtension;
}();

/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */


var GLTFLoader_GLTFMeshQuantizationExtension = function GLTFMeshQuantizationExtension() {
	classCallCheck_default()(this, GLTFMeshQuantizationExtension);

	this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
};

/*********************************/
/********** INTERPOLATION ********/
/*********************************/

// Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation


var GLTFLoader_GLTFCubicSplineInterpolant = function (_Interpolant) {
	inherits_default()(GLTFCubicSplineInterpolant, _Interpolant);

	function GLTFCubicSplineInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
		classCallCheck_default()(this, GLTFCubicSplineInterpolant);

		return possibleConstructorReturn_default()(this, (GLTFCubicSplineInterpolant.__proto__ || get_prototype_of_default()(GLTFCubicSplineInterpolant)).call(this, parameterPositions, sampleValues, sampleSize, resultBuffer));
	}

	createClass_default()(GLTFCubicSplineInterpolant, [{
		key: 'copySampleValue_',
		value: function copySampleValue_(index) {

			// Copies a sample value to the result buffer. See description of glTF
			// CUBICSPLINE values layout in interpolate_() function below.

			var result = this.resultBuffer,
			    values = this.sampleValues,
			    valueSize = this.valueSize,
			    offset = index * valueSize * 3 + valueSize;

			for (var i = 0; i !== valueSize; i++) {

				result[i] = values[offset + i];
			}

			return result;
		}
	}, {
		key: 'interpolate_',
		value: function interpolate_(i1, t0, t, t1) {

			var result = this.resultBuffer;
			var values = this.sampleValues;
			var stride = this.valueSize;

			var stride2 = stride * 2;
			var stride3 = stride * 3;

			var td = t1 - t0;

			var p = (t - t0) / td;
			var pp = p * p;
			var ppp = pp * p;

			var offset1 = i1 * stride3;
			var offset0 = offset1 - stride3;

			var s2 = -2 * ppp + 3 * pp;
			var s3 = ppp - pp;
			var s0 = 1 - s2;
			var s1 = s3 - pp + p;

			// Layout of keyframe output values for CUBICSPLINE animations:
			//   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
			for (var i = 0; i !== stride; i++) {

				var p0 = values[offset0 + i + stride]; // splineVertex_k
				var m0 = values[offset0 + i + stride2] * td; // outTangent_k * (t_k+1 - t_k)
				var p1 = values[offset1 + i + stride]; // splineVertex_k+1
				var m1 = values[offset1 + i] * td; // inTangent_k+1 * (t_k+1 - t_k)

				result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
			}

			return result;
		}
	}]);

	return GLTFCubicSplineInterpolant;
}(three_module["J" /* Interpolant */]);

var _q = new three_module["_22" /* Quaternion */]();

var GLTFLoader_GLTFCubicSplineQuaternionInterpolant = function (_GLTFCubicSplineInter) {
	inherits_default()(GLTFCubicSplineQuaternionInterpolant, _GLTFCubicSplineInter);

	function GLTFCubicSplineQuaternionInterpolant() {
		classCallCheck_default()(this, GLTFCubicSplineQuaternionInterpolant);

		return possibleConstructorReturn_default()(this, (GLTFCubicSplineQuaternionInterpolant.__proto__ || get_prototype_of_default()(GLTFCubicSplineQuaternionInterpolant)).apply(this, arguments));
	}

	createClass_default()(GLTFCubicSplineQuaternionInterpolant, [{
		key: 'interpolate_',
		value: function interpolate_(i1, t0, t, t1) {

			var result = get_default()(GLTFCubicSplineQuaternionInterpolant.prototype.__proto__ || get_prototype_of_default()(GLTFCubicSplineQuaternionInterpolant.prototype), 'interpolate_', this).call(this, i1, t0, t, t1);

			_q.fromArray(result).normalize().toArray(result);

			return result;
		}
	}]);

	return GLTFCubicSplineQuaternionInterpolant;
}(GLTFLoader_GLTFCubicSplineInterpolant);

/*********************************/
/********** INTERNALS ************/
/*********************************/

/* CONSTANTS */

var WEBGL_CONSTANTS = {
	FLOAT: 5126,
	//FLOAT_MAT2: 35674,
	FLOAT_MAT3: 35675,
	FLOAT_MAT4: 35676,
	FLOAT_VEC2: 35664,
	FLOAT_VEC3: 35665,
	FLOAT_VEC4: 35666,
	LINEAR: 9729,
	REPEAT: 10497,
	SAMPLER_2D: 35678,
	POINTS: 0,
	LINES: 1,
	LINE_LOOP: 2,
	LINE_STRIP: 3,
	TRIANGLES: 4,
	TRIANGLE_STRIP: 5,
	TRIANGLE_FAN: 6,
	UNSIGNED_BYTE: 5121,
	UNSIGNED_SHORT: 5123
};

var WEBGL_COMPONENT_TYPES = {
	5120: Int8Array,
	5121: Uint8Array,
	5122: Int16Array,
	5123: Uint16Array,
	5125: Uint32Array,
	5126: Float32Array
};

var WEBGL_FILTERS = {
	9728: three_module["_10" /* NearestFilter */],
	9729: three_module["R" /* LinearFilter */],
	9984: three_module["_12" /* NearestMipmapNearestFilter */],
	9985: three_module["T" /* LinearMipmapNearestFilter */],
	9986: three_module["_11" /* NearestMipmapLinearFilter */],
	9987: three_module["S" /* LinearMipmapLinearFilter */]
};

var WEBGL_WRAPPINGS = {
	33071: three_module["m" /* ClampToEdgeWrapping */],
	33648: three_module["_9" /* MirroredRepeatWrapping */],
	10497: three_module["_26" /* RepeatWrapping */]
};

var WEBGL_TYPE_SIZES = {
	'SCALAR': 1,
	'VEC2': 2,
	'VEC3': 3,
	'VEC4': 4,
	'MAT2': 4,
	'MAT3': 9,
	'MAT4': 16
};

var ATTRIBUTES = {
	POSITION: 'position',
	NORMAL: 'normal',
	TANGENT: 'tangent',
	TEXCOORD_0: 'uv',
	TEXCOORD_1: 'uv2',
	COLOR_0: 'color',
	WEIGHTS_0: 'skinWeight',
	JOINTS_0: 'skinIndex'
};

var PATH_PROPERTIES = {
	scale: 'scale',
	translation: 'position',
	rotation: 'quaternion',
	weights: 'morphTargetInfluences'
};

var INTERPOLATION = {
	CUBICSPLINE: undefined, // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
	// keyframe track will be initialized with a default interpolation type, then modified.
	LINEAR: three_module["L" /* InterpolateLinear */],
	STEP: three_module["K" /* InterpolateDiscrete */]
};

var ALPHA_MODES = {
	OPAQUE: 'OPAQUE',
	MASK: 'MASK',
	BLEND: 'BLEND'
};

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */
function createDefaultMaterial(cache) {

	if (cache['DefaultMaterial'] === undefined) {

		cache['DefaultMaterial'] = new three_module["_8" /* MeshStandardMaterial */]({
			color: 0xFFFFFF,
			emissive: 0x000000,
			metalness: 1,
			roughness: 1,
			transparent: false,
			depthTest: true,
			side: three_module["B" /* FrontSide */]
		});
	}

	return cache['DefaultMaterial'];
}

function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {

	// Add unknown glTF extensions to an object's userData.

	for (var name in objectDef.extensions) {

		if (knownExtensions[name] === undefined) {

			object.userData.gltfExtensions = object.userData.gltfExtensions || {};
			object.userData.gltfExtensions[name] = objectDef.extensions[name];
		}
	}
}

/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */
function assignExtrasToUserData(object, gltfDef) {

	if (gltfDef.extras !== undefined) {

		if (typeof_default()(gltfDef.extras) === 'object') {

			assign_default()(object.userData, gltfDef.extras);
		} else {

			console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
		}
	}
}

/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addMorphTargets(geometry, targets, parser) {

	var hasMorphPosition = false;
	var hasMorphNormal = false;
	var hasMorphColor = false;

	for (var i = 0, il = targets.length; i < il; i++) {

		var target = targets[i];

		if (target.POSITION !== undefined) hasMorphPosition = true;
		if (target.NORMAL !== undefined) hasMorphNormal = true;
		if (target.COLOR_0 !== undefined) hasMorphColor = true;

		if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
	}

	if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return promise_default.a.resolve(geometry);

	var pendingPositionAccessors = [];
	var pendingNormalAccessors = [];
	var pendingColorAccessors = [];

	for (var _i2 = 0, _il = targets.length; _i2 < _il; _i2++) {

		var _target = targets[_i2];

		if (hasMorphPosition) {

			var pendingAccessor = _target.POSITION !== undefined ? parser.getDependency('accessor', _target.POSITION) : geometry.attributes.position;

			pendingPositionAccessors.push(pendingAccessor);
		}

		if (hasMorphNormal) {

			var _pendingAccessor = _target.NORMAL !== undefined ? parser.getDependency('accessor', _target.NORMAL) : geometry.attributes.normal;

			pendingNormalAccessors.push(_pendingAccessor);
		}

		if (hasMorphColor) {

			var _pendingAccessor2 = _target.COLOR_0 !== undefined ? parser.getDependency('accessor', _target.COLOR_0) : geometry.attributes.color;

			pendingColorAccessors.push(_pendingAccessor2);
		}
	}

	return promise_default.a.all([promise_default.a.all(pendingPositionAccessors), promise_default.a.all(pendingNormalAccessors), promise_default.a.all(pendingColorAccessors)]).then(function (accessors) {

		var morphPositions = accessors[0];
		var morphNormals = accessors[1];
		var morphColors = accessors[2];

		if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
		if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
		if (hasMorphColor) geometry.morphAttributes.color = morphColors;
		geometry.morphTargetsRelative = true;

		return geometry;
	});
}

/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */
function updateMorphTargets(mesh, meshDef) {

	mesh.updateMorphTargets();

	if (meshDef.weights !== undefined) {

		for (var i = 0, il = meshDef.weights.length; i < il; i++) {

			mesh.morphTargetInfluences[i] = meshDef.weights[i];
		}
	}

	// .extras has user-defined data, so check that .extras.targetNames is an array.
	if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {

		var targetNames = meshDef.extras.targetNames;

		if (mesh.morphTargetInfluences.length === targetNames.length) {

			mesh.morphTargetDictionary = {};

			for (var _i3 = 0, _il2 = targetNames.length; _i3 < _il2; _i3++) {

				mesh.morphTargetDictionary[targetNames[_i3]] = _i3;
			}
		} else {

			console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
		}
	}
}

function createPrimitiveKey(primitiveDef) {

	var dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
	var geometryKey = void 0;

	if (dracoExtension) {

		geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + createAttributesKey(dracoExtension.attributes);
	} else {

		geometryKey = primitiveDef.indices + ':' + createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
	}

	return geometryKey;
}

function createAttributesKey(attributes) {

	var attributesKey = '';

	var keys = keys_default()(attributes).sort();

	for (var i = 0, il = keys.length; i < il; i++) {

		attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
	}

	return attributesKey;
}

function getNormalizedComponentScale(constructor) {

	// Reference:
	// https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data

	switch (constructor) {

		case Int8Array:
			return 1 / 127;

		case Uint8Array:
			return 1 / 255;

		case Int16Array:
			return 1 / 32767;

		case Uint16Array:
			return 1 / 65535;

		default:
			throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');

	}
}

function getImageURIMimeType(uri) {

	if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
	if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';

	return 'image/png';
}

var _identityMatrix = new three_module["_2" /* Matrix4 */]();

/* GLTF PARSER */

var GLTFLoader_GLTFParser = function () {
	function GLTFParser() {
		var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		classCallCheck_default()(this, GLTFParser);

		this.json = json;
		this.extensions = {};
		this.plugins = {};
		this.options = options;

		// loader object cache
		this.cache = new GLTFRegistry();

		// associations between Three.js objects and glTF elements
		this.associations = new map_default.a();

		// BufferGeometry caching
		this.primitiveCache = {};

		// Node cache
		this.nodeCache = {};

		// Object3D instance caches
		this.meshCache = { refs: {}, uses: {} };
		this.cameraCache = { refs: {}, uses: {} };
		this.lightCache = { refs: {}, uses: {} };

		this.sourceCache = {};
		this.textureCache = {};

		// Track node names, to ensure no duplicates
		this.nodeNamesUsed = {};

		// Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
		// expensive work of uploading a texture to the GPU off the main thread.

		var isSafari = false;
		var isFirefox = false;
		var firefoxVersion = -1;

		if (typeof navigator !== 'undefined') {

			isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
			isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
			firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
		}

		if (typeof createImageBitmap === 'undefined' || isSafari || isFirefox && firefoxVersion < 98) {

			this.textureLoader = new three_module["_35" /* TextureLoader */](this.options.manager);
		} else {

			this.textureLoader = new three_module["E" /* ImageBitmapLoader */](this.options.manager);
		}

		this.textureLoader.setCrossOrigin(this.options.crossOrigin);
		this.textureLoader.setRequestHeader(this.options.requestHeader);

		this.fileLoader = new three_module["y" /* FileLoader */](this.options.manager);
		this.fileLoader.setResponseType('arraybuffer');

		if (this.options.crossOrigin === 'use-credentials') {

			this.fileLoader.setWithCredentials(true);
		}
	}

	createClass_default()(GLTFParser, [{
		key: 'setExtensions',
		value: function setExtensions(extensions) {

			this.extensions = extensions;
		}
	}, {
		key: 'setPlugins',
		value: function setPlugins(plugins) {

			this.plugins = plugins;
		}
	}, {
		key: 'parse',
		value: function parse(onLoad, onError) {

			var parser = this;
			var json = this.json;
			var extensions = this.extensions;

			// Clear the loader cache
			this.cache.removeAll();
			this.nodeCache = {};

			// Mark the special nodes/meshes in json for efficient parse
			this._invokeAll(function (ext) {

				return ext._markDefs && ext._markDefs();
			});

			promise_default.a.all(this._invokeAll(function (ext) {

				return ext.beforeRoot && ext.beforeRoot();
			})).then(function () {

				return promise_default.a.all([parser.getDependencies('scene'), parser.getDependencies('animation'), parser.getDependencies('camera')]);
			}).then(function (dependencies) {

				var result = {
					scene: dependencies[0][json.scene || 0],
					scenes: dependencies[0],
					animations: dependencies[1],
					cameras: dependencies[2],
					asset: json.asset,
					parser: parser,
					userData: {}
				};

				addUnknownExtensionsToUserData(extensions, result, json);

				assignExtrasToUserData(result, json);

				promise_default.a.all(parser._invokeAll(function (ext) {

					return ext.afterRoot && ext.afterRoot(result);
				})).then(function () {

					onLoad(result);
				});
			}).catch(onError);
		}

		/**
   * Marks the special nodes/meshes in json for efficient parse.
   */

	}, {
		key: '_markDefs',
		value: function _markDefs() {

			var nodeDefs = this.json.nodes || [];
			var skinDefs = this.json.skins || [];
			var meshDefs = this.json.meshes || [];

			// Nothing in the node definition indicates whether it is a Bone or an
			// Object3D. Use the skins' joint references to mark bones.
			for (var skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {

				var joints = skinDefs[skinIndex].joints;

				for (var i = 0, il = joints.length; i < il; i++) {

					nodeDefs[joints[i]].isBone = true;
				}
			}

			// Iterate over all nodes, marking references to shared resources,
			// as well as skeleton joints.
			for (var nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {

				var nodeDef = nodeDefs[nodeIndex];

				if (nodeDef.mesh !== undefined) {

					this._addNodeRef(this.meshCache, nodeDef.mesh);

					// Nothing in the mesh definition indicates whether it is
					// a SkinnedMesh or Mesh. Use the node's mesh reference
					// to mark SkinnedMesh if node has skin.
					if (nodeDef.skin !== undefined) {

						meshDefs[nodeDef.mesh].isSkinnedMesh = true;
					}
				}

				if (nodeDef.camera !== undefined) {

					this._addNodeRef(this.cameraCache, nodeDef.camera);
				}
			}
		}

		/**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */

	}, {
		key: '_addNodeRef',
		value: function _addNodeRef(cache, index) {

			if (index === undefined) return;

			if (cache.refs[index] === undefined) {

				cache.refs[index] = cache.uses[index] = 0;
			}

			cache.refs[index]++;
		}

		/** Returns a reference to a shared resource, cloning it if necessary. */

	}, {
		key: '_getNodeRef',
		value: function _getNodeRef(cache, index, object) {
			var _this5 = this;

			if (cache.refs[index] <= 1) return object;

			var ref = object.clone();

			// Propagates mappings to the cloned object, prevents mappings on the
			// original object from being lost.
			var updateMappings = function updateMappings(original, clone) {

				var mappings = _this5.associations.get(original);
				if (mappings != null) {

					_this5.associations.set(clone, mappings);
				}

				var _iteratorNormalCompletion3 = true;
				var _didIteratorError3 = false;
				var _iteratorError3 = undefined;

				try {
					for (var _iterator3 = get_iterator_default()(original.children.entries()), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
						var _ref = _step3.value;

						var _ref2 = slicedToArray_default()(_ref, 2);

						var i = _ref2[0];
						var child = _ref2[1];


						updateMappings(child, clone.children[i]);
					}
				} catch (err) {
					_didIteratorError3 = true;
					_iteratorError3 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion3 && _iterator3.return) {
							_iterator3.return();
						}
					} finally {
						if (_didIteratorError3) {
							throw _iteratorError3;
						}
					}
				}
			};

			updateMappings(object, ref);

			ref.name += '_instance_' + cache.uses[index]++;

			return ref;
		}
	}, {
		key: '_invokeOne',
		value: function _invokeOne(func) {

			var extensions = values_default()(this.plugins);
			extensions.push(this);

			for (var i = 0; i < extensions.length; i++) {

				var result = func(extensions[i]);

				if (result) return result;
			}

			return null;
		}
	}, {
		key: '_invokeAll',
		value: function _invokeAll(func) {

			var extensions = values_default()(this.plugins);
			extensions.unshift(this);

			var pending = [];

			for (var i = 0; i < extensions.length; i++) {

				var result = func(extensions[i]);

				if (result) pending.push(result);
			}

			return pending;
		}

		/**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */

	}, {
		key: 'getDependency',
		value: function getDependency(type, index) {

			var cacheKey = type + ':' + index;
			var dependency = this.cache.get(cacheKey);

			if (!dependency) {

				switch (type) {

					case 'scene':
						dependency = this.loadScene(index);
						break;

					case 'node':
						dependency = this._invokeOne(function (ext) {

							return ext.loadNode && ext.loadNode(index);
						});
						break;

					case 'mesh':
						dependency = this._invokeOne(function (ext) {

							return ext.loadMesh && ext.loadMesh(index);
						});
						break;

					case 'accessor':
						dependency = this.loadAccessor(index);
						break;

					case 'bufferView':
						dependency = this._invokeOne(function (ext) {

							return ext.loadBufferView && ext.loadBufferView(index);
						});
						break;

					case 'buffer':
						dependency = this.loadBuffer(index);
						break;

					case 'material':
						dependency = this._invokeOne(function (ext) {

							return ext.loadMaterial && ext.loadMaterial(index);
						});
						break;

					case 'texture':
						dependency = this._invokeOne(function (ext) {

							return ext.loadTexture && ext.loadTexture(index);
						});
						break;

					case 'skin':
						dependency = this.loadSkin(index);
						break;

					case 'animation':
						dependency = this._invokeOne(function (ext) {

							return ext.loadAnimation && ext.loadAnimation(index);
						});
						break;

					case 'camera':
						dependency = this.loadCamera(index);
						break;

					default:
						dependency = this._invokeOne(function (ext) {

							return ext != this && ext.getDependency && ext.getDependency(type, index);
						});

						if (!dependency) {

							throw new Error('Unknown type: ' + type);
						}

						break;

				}

				this.cache.add(cacheKey, dependency);
			}

			return dependency;
		}

		/**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */

	}, {
		key: 'getDependencies',
		value: function getDependencies(type) {

			var dependencies = this.cache.get(type);

			if (!dependencies) {

				var parser = this;
				var defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];

				dependencies = promise_default.a.all(defs.map(function (def, index) {

					return parser.getDependency(type, index);
				}));

				this.cache.add(type, dependencies);
			}

			return dependencies;
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */

	}, {
		key: 'loadBuffer',
		value: function loadBuffer(bufferIndex) {

			var bufferDef = this.json.buffers[bufferIndex];
			var loader = this.fileLoader;

			if (bufferDef.type && bufferDef.type !== 'arraybuffer') {

				throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
			}

			// If present, GLB container is required to be the first buffer.
			if (bufferDef.uri === undefined && bufferIndex === 0) {

				return promise_default.a.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
			}

			var options = this.options;

			return new promise_default.a(function (resolve, reject) {

				loader.load(three_module["V" /* LoaderUtils */].resolveURL(bufferDef.uri, options.path), resolve, undefined, function () {

					reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
				});
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */

	}, {
		key: 'loadBufferView',
		value: function loadBufferView(bufferViewIndex) {

			var bufferViewDef = this.json.bufferViews[bufferViewIndex];

			return this.getDependency('buffer', bufferViewDef.buffer).then(function (buffer) {

				var byteLength = bufferViewDef.byteLength || 0;
				var byteOffset = bufferViewDef.byteOffset || 0;
				return buffer.slice(byteOffset, byteOffset + byteLength);
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */

	}, {
		key: 'loadAccessor',
		value: function loadAccessor(accessorIndex) {

			var parser = this;
			var json = this.json;

			var accessorDef = this.json.accessors[accessorIndex];

			if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {

				var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
				var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
				var normalized = accessorDef.normalized === true;

				var array = new TypedArray(accessorDef.count * itemSize);
				return promise_default.a.resolve(new three_module["j" /* BufferAttribute */](array, itemSize, normalized));
			}

			var pendingBufferViews = [];

			if (accessorDef.bufferView !== undefined) {

				pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
			} else {

				pendingBufferViews.push(null);
			}

			if (accessorDef.sparse !== undefined) {

				pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
				pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
			}

			return promise_default.a.all(pendingBufferViews).then(function (bufferViews) {

				var bufferView = bufferViews[0];

				var itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
				var TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];

				// For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
				var elementBytes = TypedArray.BYTES_PER_ELEMENT;
				var itemBytes = elementBytes * itemSize;
				var byteOffset = accessorDef.byteOffset || 0;
				var byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
				var normalized = accessorDef.normalized === true;
				var array = void 0,
				    bufferAttribute = void 0;

				// The buffer is not interleaved if the stride is the item size in bytes.
				if (byteStride && byteStride !== itemBytes) {

					// Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
					// This makes sure that IBA.count reflects accessor.count properly
					var ibSlice = Math.floor(byteOffset / byteStride);
					var ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
					var ib = parser.cache.get(ibCacheKey);

					if (!ib) {

						array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);

						// Integer parameters to IB/IBA are in array elements, not bytes.
						ib = new three_module["H" /* InterleavedBuffer */](array, byteStride / elementBytes);

						parser.cache.add(ibCacheKey, ib);
					}

					bufferAttribute = new three_module["I" /* InterleavedBufferAttribute */](ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
				} else {

					if (bufferView === null) {

						array = new TypedArray(accessorDef.count * itemSize);
					} else {

						array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
					}

					bufferAttribute = new three_module["j" /* BufferAttribute */](array, itemSize, normalized);
				}

				// https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
				if (accessorDef.sparse !== undefined) {

					var itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
					var TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];

					var byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
					var byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;

					var sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
					var sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);

					if (bufferView !== null) {

						// Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
						bufferAttribute = new three_module["j" /* BufferAttribute */](bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
					}

					for (var i = 0, il = sparseIndices.length; i < il; i++) {

						var index = sparseIndices[i];

						bufferAttribute.setX(index, sparseValues[i * itemSize]);
						if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
						if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
						if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
						if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
					}
				}

				return bufferAttribute;
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */

	}, {
		key: 'loadTexture',
		value: function loadTexture(textureIndex) {

			var json = this.json;
			var options = this.options;
			var textureDef = json.textures[textureIndex];
			var sourceIndex = textureDef.source;
			var sourceDef = json.images[sourceIndex];

			var loader = this.textureLoader;

			if (sourceDef.uri) {

				var handler = options.manager.getHandler(sourceDef.uri);
				if (handler !== null) loader = handler;
			}

			return this.loadTextureImage(textureIndex, sourceIndex, loader);
		}
	}, {
		key: 'loadTextureImage',
		value: function loadTextureImage(textureIndex, sourceIndex, loader) {

			var parser = this;
			var json = this.json;

			var textureDef = json.textures[textureIndex];
			var sourceDef = json.images[sourceIndex];

			var cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;

			if (this.textureCache[cacheKey]) {

				// See https://github.com/mrdoob/three.js/issues/21559.
				return this.textureCache[cacheKey];
			}

			var promise = this.loadImageSource(sourceIndex, loader).then(function (texture) {

				texture.flipY = false;

				texture.name = textureDef.name || sourceDef.name || '';

				if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) {

					texture.name = sourceDef.uri;
				}

				var samplers = json.samplers || {};
				var sampler = samplers[textureDef.sampler] || {};

				texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || three_module["R" /* LinearFilter */];
				texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || three_module["S" /* LinearMipmapLinearFilter */];
				texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || three_module["_26" /* RepeatWrapping */];
				texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || three_module["_26" /* RepeatWrapping */];

				parser.associations.set(texture, { textures: textureIndex });

				return texture;
			}).catch(function () {

				return null;
			});

			this.textureCache[cacheKey] = promise;

			return promise;
		}
	}, {
		key: 'loadImageSource',
		value: function loadImageSource(sourceIndex, loader) {

			var parser = this;
			var json = this.json;
			var options = this.options;

			if (this.sourceCache[sourceIndex] !== undefined) {

				return this.sourceCache[sourceIndex].then(function (texture) {
					return texture.clone();
				});
			}

			var sourceDef = json.images[sourceIndex];

			var URL = self.URL || self.webkitURL;

			var sourceURI = sourceDef.uri || '';
			var isObjectURL = false;

			if (sourceDef.bufferView !== undefined) {

				// Load binary image data from bufferView, if provided.

				sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function (bufferView) {

					isObjectURL = true;
					var blob = new Blob([bufferView], { type: sourceDef.mimeType });
					sourceURI = URL.createObjectURL(blob);
					return sourceURI;
				});
			} else if (sourceDef.uri === undefined) {

				throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
			}

			var promise = promise_default.a.resolve(sourceURI).then(function (sourceURI) {

				return new promise_default.a(function (resolve, reject) {

					var onLoad = resolve;

					if (loader.isImageBitmapLoader === true) {

						onLoad = function onLoad(imageBitmap) {

							var texture = new three_module["_34" /* Texture */](imageBitmap);
							texture.needsUpdate = true;

							resolve(texture);
						};
					}

					loader.load(three_module["V" /* LoaderUtils */].resolveURL(sourceURI, options.path), onLoad, undefined, reject);
				});
			}).then(function (texture) {

				// Clean up resources and configure Texture.

				if (isObjectURL === true) {

					URL.revokeObjectURL(sourceURI);
				}

				texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);

				return texture;
			}).catch(function (error) {

				console.error('THREE.GLTFLoader: Couldn\'t load texture', sourceURI);
				throw error;
			});

			this.sourceCache[sourceIndex] = promise;
			return promise;
		}

		/**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */

	}, {
		key: 'assignTexture',
		value: function assignTexture(materialParams, mapName, mapDef, encoding) {

			var parser = this;

			return this.getDependency('texture', mapDef.index).then(function (texture) {

				if (!texture) return null;

				if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {

					texture = texture.clone();
					texture.channel = mapDef.texCoord;
				}

				if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {

					var transform = mapDef.extensions !== undefined ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;

					if (transform) {

						var gltfReference = parser.associations.get(texture);
						texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
						parser.associations.set(texture, gltfReference);
					}
				}

				if (encoding !== undefined) {

					texture.encoding = encoding;
				}

				materialParams[mapName] = texture;

				return texture;
			});
		}

		/**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */

	}, {
		key: 'assignFinalMaterial',
		value: function assignFinalMaterial(mesh) {

			var geometry = mesh.geometry;
			var material = mesh.material;

			var useDerivativeTangents = geometry.attributes.tangent === undefined;
			var useVertexColors = geometry.attributes.color !== undefined;
			var useFlatShading = geometry.attributes.normal === undefined;

			if (mesh.isPoints) {

				var cacheKey = 'PointsMaterial:' + material.uuid;

				var pointsMaterial = this.cache.get(cacheKey);

				if (!pointsMaterial) {

					pointsMaterial = new three_module["_20" /* PointsMaterial */]();
					three_module["Z" /* Material */].prototype.copy.call(pointsMaterial, material);
					pointsMaterial.color.copy(material.color);
					pointsMaterial.map = material.map;
					pointsMaterial.sizeAttenuation = false; // glTF spec says points should be 1px

					this.cache.add(cacheKey, pointsMaterial);
				}

				material = pointsMaterial;
			} else if (mesh.isLine) {

				var _cacheKey = 'LineBasicMaterial:' + material.uuid;

				var lineMaterial = this.cache.get(_cacheKey);

				if (!lineMaterial) {

					lineMaterial = new three_module["N" /* LineBasicMaterial */]();
					three_module["Z" /* Material */].prototype.copy.call(lineMaterial, material);
					lineMaterial.color.copy(material.color);
					lineMaterial.map = material.map;

					this.cache.add(_cacheKey, lineMaterial);
				}

				material = lineMaterial;
			}

			// Clone the material if it will be modified
			if (useDerivativeTangents || useVertexColors || useFlatShading) {

				var _cacheKey2 = 'ClonedMaterial:' + material.uuid + ':';

				if (useDerivativeTangents) _cacheKey2 += 'derivative-tangents:';
				if (useVertexColors) _cacheKey2 += 'vertex-colors:';
				if (useFlatShading) _cacheKey2 += 'flat-shading:';

				var cachedMaterial = this.cache.get(_cacheKey2);

				if (!cachedMaterial) {

					cachedMaterial = material.clone();

					if (useVertexColors) cachedMaterial.vertexColors = true;
					if (useFlatShading) cachedMaterial.flatShading = true;

					if (useDerivativeTangents) {

						// https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
						if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
						if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
					}

					this.cache.add(_cacheKey2, cachedMaterial);

					this.associations.set(cachedMaterial, this.associations.get(material));
				}

				material = cachedMaterial;
			}

			mesh.material = material;
		}
	}, {
		key: 'getMaterialType',
		value: function getMaterialType() /* materialIndex */{

			return three_module["_8" /* MeshStandardMaterial */];
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */

	}, {
		key: 'loadMaterial',
		value: function loadMaterial(materialIndex) {

			var parser = this;
			var json = this.json;
			var extensions = this.extensions;
			var materialDef = json.materials[materialIndex];

			var materialType = void 0;
			var materialParams = {};
			var materialExtensions = materialDef.extensions || {};

			var pending = [];

			if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {

				var kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
				materialType = kmuExtension.getMaterialType();
				pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
			} else {

				// Specification:
				// https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material

				var metallicRoughness = materialDef.pbrMetallicRoughness || {};

				materialParams.color = new three_module["o" /* Color */](1.0, 1.0, 1.0);
				materialParams.opacity = 1.0;

				if (Array.isArray(metallicRoughness.baseColorFactor)) {

					var array = metallicRoughness.baseColorFactor;

					materialParams.color.fromArray(array);
					materialParams.opacity = array[3];
				}

				if (metallicRoughness.baseColorTexture !== undefined) {

					pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, three_module["_45" /* sRGBEncoding */]));
				}

				materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
				materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;

				if (metallicRoughness.metallicRoughnessTexture !== undefined) {

					pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
					pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
				}

				materialType = this._invokeOne(function (ext) {

					return ext.getMaterialType && ext.getMaterialType(materialIndex);
				});

				pending.push(promise_default.a.all(this._invokeAll(function (ext) {

					return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
				})));
			}

			if (materialDef.doubleSided === true) {

				materialParams.side = three_module["u" /* DoubleSide */];
			}

			var alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;

			if (alphaMode === ALPHA_MODES.BLEND) {

				materialParams.transparent = true;

				// See: https://github.com/mrdoob/three.js/issues/17706
				materialParams.depthWrite = false;
			} else {

				materialParams.transparent = false;

				if (alphaMode === ALPHA_MODES.MASK) {

					materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
				}
			}

			if (materialDef.normalTexture !== undefined && materialType !== three_module["_4" /* MeshBasicMaterial */]) {

				pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));

				materialParams.normalScale = new three_module["_40" /* Vector2 */](1, 1);

				if (materialDef.normalTexture.scale !== undefined) {

					var scale = materialDef.normalTexture.scale;

					materialParams.normalScale.set(scale, scale);
				}
			}

			if (materialDef.occlusionTexture !== undefined && materialType !== three_module["_4" /* MeshBasicMaterial */]) {

				pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));

				if (materialDef.occlusionTexture.strength !== undefined) {

					materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
				}
			}

			if (materialDef.emissiveFactor !== undefined && materialType !== three_module["_4" /* MeshBasicMaterial */]) {

				materialParams.emissive = new three_module["o" /* Color */]().fromArray(materialDef.emissiveFactor);
			}

			if (materialDef.emissiveTexture !== undefined && materialType !== three_module["_4" /* MeshBasicMaterial */]) {

				pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, three_module["_45" /* sRGBEncoding */]));
			}

			return promise_default.a.all(pending).then(function () {

				var material = new materialType(materialParams);

				if (materialDef.name) material.name = materialDef.name;

				assignExtrasToUserData(material, materialDef);

				parser.associations.set(material, { materials: materialIndex });

				if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);

				return material;
			});
		}

		/** When Object3D instances are targeted by animation, they need unique names. */

	}, {
		key: 'createUniqueName',
		value: function createUniqueName(originalName) {

			var sanitizedName = three_module["_21" /* PropertyBinding */].sanitizeNodeName(originalName || '');

			var name = sanitizedName;

			for (var i = 1; this.nodeNamesUsed[name]; ++i) {

				name = sanitizedName + '_' + i;
			}

			this.nodeNamesUsed[name] = true;

			return name;
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */

	}, {
		key: 'loadGeometries',
		value: function loadGeometries(primitives) {

			var parser = this;
			var extensions = this.extensions;
			var cache = this.primitiveCache;

			function createDracoPrimitive(primitive) {

				return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function (geometry) {

					return addPrimitiveAttributes(geometry, primitive, parser);
				});
			}

			var pending = [];

			for (var i = 0, il = primitives.length; i < il; i++) {

				var primitive = primitives[i];
				var cacheKey = createPrimitiveKey(primitive);

				// See if we've already created this geometry
				var cached = cache[cacheKey];

				if (cached) {

					// Use the cached geometry if it exists
					pending.push(cached.promise);
				} else {

					var geometryPromise = void 0;

					if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) {

						// Use DRACO geometry if available
						geometryPromise = createDracoPrimitive(primitive);
					} else {

						// Otherwise create a new geometry
						geometryPromise = addPrimitiveAttributes(new three_module["k" /* BufferGeometry */](), primitive, parser);
					}

					// Cache this geometry
					cache[cacheKey] = { primitive: primitive, promise: geometryPromise };

					pending.push(geometryPromise);
				}
			}

			return promise_default.a.all(pending);
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */

	}, {
		key: 'loadMesh',
		value: function loadMesh(meshIndex) {

			var parser = this;
			var json = this.json;
			var extensions = this.extensions;

			var meshDef = json.meshes[meshIndex];
			var primitives = meshDef.primitives;

			var pending = [];

			for (var i = 0, il = primitives.length; i < il; i++) {

				var material = primitives[i].material === undefined ? createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);

				pending.push(material);
			}

			pending.push(parser.loadGeometries(primitives));

			return promise_default.a.all(pending).then(function (results) {

				var materials = results.slice(0, results.length - 1);
				var geometries = results[results.length - 1];

				var meshes = [];

				for (var _i4 = 0, _il3 = geometries.length; _i4 < _il3; _i4++) {

					var geometry = geometries[_i4];
					var primitive = primitives[_i4];

					// 1. create Mesh

					var mesh = void 0;

					var _material = materials[_i4];

					if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {

						// .isSkinnedMesh isn't in glTF spec. See ._markDefs()
						mesh = meshDef.isSkinnedMesh === true ? new three_module["_29" /* SkinnedMesh */](geometry, _material) : new three_module["_3" /* Mesh */](geometry, _material);

						if (mesh.isSkinnedMesh === true) {

							// normalize skin weights to fix malformed assets (see #15319)
							mesh.normalizeSkinWeights();
						}

						if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {

							mesh.geometry = toTrianglesDrawMode(mesh.geometry, three_module["_37" /* TriangleStripDrawMode */]);
						} else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {

							mesh.geometry = toTrianglesDrawMode(mesh.geometry, three_module["_36" /* TriangleFanDrawMode */]);
						}
					} else if (primitive.mode === WEBGL_CONSTANTS.LINES) {

						mesh = new three_module["P" /* LineSegments */](geometry, _material);
					} else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {

						mesh = new three_module["M" /* Line */](geometry, _material);
					} else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {

						mesh = new three_module["O" /* LineLoop */](geometry, _material);
					} else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {

						mesh = new three_module["_19" /* Points */](geometry, _material);
					} else {

						throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
					}

					if (keys_default()(mesh.geometry.morphAttributes).length > 0) {

						updateMorphTargets(mesh, meshDef);
					}

					mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);

					assignExtrasToUserData(mesh, meshDef);

					if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);

					parser.assignFinalMaterial(mesh);

					meshes.push(mesh);
				}

				for (var _i5 = 0, _il4 = meshes.length; _i5 < _il4; _i5++) {

					parser.associations.set(meshes[_i5], {
						meshes: meshIndex,
						primitives: _i5
					});
				}

				if (meshes.length === 1) {

					return meshes[0];
				}

				var group = new three_module["C" /* Group */]();

				parser.associations.set(group, { meshes: meshIndex });

				for (var _i6 = 0, _il5 = meshes.length; _i6 < _il5; _i6++) {

					group.add(meshes[_i6]);
				}

				return group;
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */

	}, {
		key: 'loadCamera',
		value: function loadCamera(cameraIndex) {

			var camera = void 0;
			var cameraDef = this.json.cameras[cameraIndex];
			var params = cameraDef[cameraDef.type];

			if (!params) {

				console.warn('THREE.GLTFLoader: Missing camera parameters.');
				return;
			}

			if (cameraDef.type === 'perspective') {

				camera = new three_module["_17" /* PerspectiveCamera */](three_module["_0" /* MathUtils */].radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
			} else if (cameraDef.type === 'orthographic') {

				camera = new three_module["_15" /* OrthographicCamera */](-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
			}

			if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);

			assignExtrasToUserData(camera, cameraDef);

			return promise_default.a.resolve(camera);
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */

	}, {
		key: 'loadSkin',
		value: function loadSkin(skinIndex) {

			var skinDef = this.json.skins[skinIndex];

			var pending = [];

			for (var i = 0, il = skinDef.joints.length; i < il; i++) {

				pending.push(this._loadNodeShallow(skinDef.joints[i]));
			}

			if (skinDef.inverseBindMatrices !== undefined) {

				pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
			} else {

				pending.push(null);
			}

			return promise_default.a.all(pending).then(function (results) {

				var inverseBindMatrices = results.pop();
				var jointNodes = results;

				// Note that bones (joint nodes) may or may not be in the
				// scene graph at this time.

				var bones = [];
				var boneInverses = [];

				for (var _i7 = 0, _il6 = jointNodes.length; _i7 < _il6; _i7++) {

					var jointNode = jointNodes[_i7];

					if (jointNode) {

						bones.push(jointNode);

						var mat = new three_module["_2" /* Matrix4 */]();

						if (inverseBindMatrices !== null) {

							mat.fromArray(inverseBindMatrices.array, _i7 * 16);
						}

						boneInverses.push(mat);
					} else {

						console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[_i7]);
					}
				}

				return new three_module["_28" /* Skeleton */](bones, boneInverses);
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */

	}, {
		key: 'loadAnimation',
		value: function loadAnimation(animationIndex) {

			var json = this.json;

			var animationDef = json.animations[animationIndex];
			var animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;

			var pendingNodes = [];
			var pendingInputAccessors = [];
			var pendingOutputAccessors = [];
			var pendingSamplers = [];
			var pendingTargets = [];

			for (var i = 0, il = animationDef.channels.length; i < il; i++) {

				var channel = animationDef.channels[i];
				var sampler = animationDef.samplers[channel.sampler];
				var target = channel.target;
				var name = target.node;
				var input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
				var output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;

				if (target.node === undefined) continue;

				pendingNodes.push(this.getDependency('node', name));
				pendingInputAccessors.push(this.getDependency('accessor', input));
				pendingOutputAccessors.push(this.getDependency('accessor', output));
				pendingSamplers.push(sampler);
				pendingTargets.push(target);
			}

			return promise_default.a.all([promise_default.a.all(pendingNodes), promise_default.a.all(pendingInputAccessors), promise_default.a.all(pendingOutputAccessors), promise_default.a.all(pendingSamplers), promise_default.a.all(pendingTargets)]).then(function (dependencies) {

				var nodes = dependencies[0];
				var inputAccessors = dependencies[1];
				var outputAccessors = dependencies[2];
				var samplers = dependencies[3];
				var targets = dependencies[4];

				var tracks = [];

				var _loop2 = function _loop2(_i8, _il7) {

					var node = nodes[_i8];
					var inputAccessor = inputAccessors[_i8];
					var outputAccessor = outputAccessors[_i8];
					var sampler = samplers[_i8];
					var target = targets[_i8];

					if (node === undefined) return 'continue';

					node.updateMatrix();

					var TypedKeyframeTrack = void 0;

					switch (PATH_PROPERTIES[target.path]) {

						case PATH_PROPERTIES.weights:

							TypedKeyframeTrack = three_module["_13" /* NumberKeyframeTrack */];
							break;

						case PATH_PROPERTIES.rotation:

							TypedKeyframeTrack = three_module["_23" /* QuaternionKeyframeTrack */];
							break;

						case PATH_PROPERTIES.position:
						case PATH_PROPERTIES.scale:
						default:

							TypedKeyframeTrack = three_module["_43" /* VectorKeyframeTrack */];
							break;

					}

					var targetName = node.name ? node.name : node.uuid;

					var interpolation = sampler.interpolation !== undefined ? INTERPOLATION[sampler.interpolation] : three_module["L" /* InterpolateLinear */];

					var targetNames = [];

					if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {

						node.traverse(function (object) {

							if (object.morphTargetInfluences) {

								targetNames.push(object.name ? object.name : object.uuid);
							}
						});
					} else {

						targetNames.push(targetName);
					}

					var outputArray = outputAccessor.array;

					if (outputAccessor.normalized) {

						var scale = getNormalizedComponentScale(outputArray.constructor);
						var scaled = new Float32Array(outputArray.length);

						for (var j = 0, jl = outputArray.length; j < jl; j++) {

							scaled[j] = outputArray[j] * scale;
						}

						outputArray = scaled;
					}

					for (var _j = 0, _jl = targetNames.length; _j < _jl; _j++) {

						var track = new TypedKeyframeTrack(targetNames[_j] + '.' + PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);

						// Override interpolation with custom factory method.
						if (sampler.interpolation === 'CUBICSPLINE') {

							track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {

								// A CUBICSPLINE keyframe in glTF has three output values for each input value,
								// representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
								// must be divided by three to get the interpolant's sampleSize argument.

								var interpolantType = this instanceof three_module["_23" /* QuaternionKeyframeTrack */] ? GLTFLoader_GLTFCubicSplineQuaternionInterpolant : GLTFLoader_GLTFCubicSplineInterpolant;

								return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
							};

							// Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
							track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
						}

						tracks.push(track);
					}
				};

				for (var _i8 = 0, _il7 = nodes.length; _i8 < _il7; _i8++) {
					var _ret2 = _loop2(_i8, _il7);

					if (_ret2 === 'continue') continue;
				}

				return new three_module["b" /* AnimationClip */](animationName, undefined, tracks);
			});
		}
	}, {
		key: 'createNodeMesh',
		value: function createNodeMesh(nodeIndex) {

			var json = this.json;
			var parser = this;
			var nodeDef = json.nodes[nodeIndex];

			if (nodeDef.mesh === undefined) return null;

			return parser.getDependency('mesh', nodeDef.mesh).then(function (mesh) {

				var node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);

				// if weights are provided on the node, override weights on the mesh.
				if (nodeDef.weights !== undefined) {

					node.traverse(function (o) {

						if (!o.isMesh) return;

						for (var i = 0, il = nodeDef.weights.length; i < il; i++) {

							o.morphTargetInfluences[i] = nodeDef.weights[i];
						}
					});
				}

				return node;
			});
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */

	}, {
		key: 'loadNode',
		value: function loadNode(nodeIndex) {

			var json = this.json;
			var parser = this;

			var nodeDef = json.nodes[nodeIndex];

			var nodePending = parser._loadNodeShallow(nodeIndex);

			var childPending = [];
			var childrenDef = nodeDef.children || [];

			for (var i = 0, il = childrenDef.length; i < il; i++) {

				childPending.push(parser.getDependency('node', childrenDef[i]));
			}

			var skeletonPending = nodeDef.skin === undefined ? promise_default.a.resolve(null) : parser.getDependency('skin', nodeDef.skin);

			return promise_default.a.all([nodePending, promise_default.a.all(childPending), skeletonPending]).then(function (results) {

				var node = results[0];
				var children = results[1];
				var skeleton = results[2];

				if (skeleton !== null) {

					// This full traverse should be fine because
					// child glTF nodes have not been added to this node yet.
					node.traverse(function (mesh) {

						if (!mesh.isSkinnedMesh) return;

						mesh.bind(skeleton, _identityMatrix);
					});
				}

				for (var _i9 = 0, _il8 = children.length; _i9 < _il8; _i9++) {

					node.add(children[_i9]);
				}

				return node;
			});
		}

		// ._loadNodeShallow() parses a single node.
		// skin and child nodes are created and added in .loadNode() (no '_' prefix).

	}, {
		key: '_loadNodeShallow',
		value: function _loadNodeShallow(nodeIndex) {

			var json = this.json;
			var extensions = this.extensions;
			var parser = this;

			// This method is called from .loadNode() and .loadSkin().
			// Cache a node to avoid duplication.

			if (this.nodeCache[nodeIndex] !== undefined) {

				return this.nodeCache[nodeIndex];
			}

			var nodeDef = json.nodes[nodeIndex];

			// reserve node's name before its dependencies, so the root has the intended name.
			var nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';

			var pending = [];

			var meshPromise = parser._invokeOne(function (ext) {

				return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
			});

			if (meshPromise) {

				pending.push(meshPromise);
			}

			if (nodeDef.camera !== undefined) {

				pending.push(parser.getDependency('camera', nodeDef.camera).then(function (camera) {

					return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
				}));
			}

			parser._invokeAll(function (ext) {

				return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
			}).forEach(function (promise) {

				pending.push(promise);
			});

			this.nodeCache[nodeIndex] = promise_default.a.all(pending).then(function (objects) {

				var node = void 0;

				// .isBone isn't in glTF spec. See ._markDefs
				if (nodeDef.isBone === true) {

					node = new three_module["g" /* Bone */]();
				} else if (objects.length > 1) {

					node = new three_module["C" /* Group */]();
				} else if (objects.length === 1) {

					node = objects[0];
				} else {

					node = new three_module["_14" /* Object3D */]();
				}

				if (node !== objects[0]) {

					for (var i = 0, il = objects.length; i < il; i++) {

						node.add(objects[i]);
					}
				}

				if (nodeDef.name) {

					node.userData.name = nodeDef.name;
					node.name = nodeName;
				}

				assignExtrasToUserData(node, nodeDef);

				if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);

				if (nodeDef.matrix !== undefined) {

					var matrix = new three_module["_2" /* Matrix4 */]();
					matrix.fromArray(nodeDef.matrix);
					node.applyMatrix4(matrix);
				} else {

					if (nodeDef.translation !== undefined) {

						node.position.fromArray(nodeDef.translation);
					}

					if (nodeDef.rotation !== undefined) {

						node.quaternion.fromArray(nodeDef.rotation);
					}

					if (nodeDef.scale !== undefined) {

						node.scale.fromArray(nodeDef.scale);
					}
				}

				if (!parser.associations.has(node)) {

					parser.associations.set(node, {});
				}

				parser.associations.get(node).nodes = nodeIndex;

				return node;
			});

			return this.nodeCache[nodeIndex];
		}

		/**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */

	}, {
		key: 'loadScene',
		value: function loadScene(sceneIndex) {

			var extensions = this.extensions;
			var sceneDef = this.json.scenes[sceneIndex];
			var parser = this;

			// Loader returns Group, not Scene.
			// See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
			var scene = new three_module["C" /* Group */]();
			if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);

			assignExtrasToUserData(scene, sceneDef);

			if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);

			var nodeIds = sceneDef.nodes || [];

			var pending = [];

			for (var i = 0, il = nodeIds.length; i < il; i++) {

				pending.push(parser.getDependency('node', nodeIds[i]));
			}

			return promise_default.a.all(pending).then(function (nodes) {

				for (var _i10 = 0, _il9 = nodes.length; _i10 < _il9; _i10++) {

					scene.add(nodes[_i10]);
				}

				// Removes dangling associations, associations that reference a node that
				// didn't make it into the scene.
				var reduceAssociations = function reduceAssociations(node) {

					var reducedAssociations = new map_default.a();

					var _iteratorNormalCompletion4 = true;
					var _didIteratorError4 = false;
					var _iteratorError4 = undefined;

					try {
						for (var _iterator4 = get_iterator_default()(parser.associations), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
							var _ref3 = _step4.value;

							var _ref4 = slicedToArray_default()(_ref3, 2);

							var key = _ref4[0];
							var value = _ref4[1];


							if (key instanceof three_module["Z" /* Material */] || key instanceof three_module["_34" /* Texture */]) {

								reducedAssociations.set(key, value);
							}
						}
					} catch (err) {
						_didIteratorError4 = true;
						_iteratorError4 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion4 && _iterator4.return) {
								_iterator4.return();
							}
						} finally {
							if (_didIteratorError4) {
								throw _iteratorError4;
							}
						}
					}

					node.traverse(function (node) {

						var mappings = parser.associations.get(node);

						if (mappings != null) {

							reducedAssociations.set(node, mappings);
						}
					});

					return reducedAssociations;
				};

				parser.associations = reduceAssociations(scene);

				return scene;
			});
		}
	}]);

	return GLTFParser;
}();

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */


function computeBounds(geometry, primitiveDef, parser) {

	var attributes = primitiveDef.attributes;

	var box = new three_module["h" /* Box3 */]();

	if (attributes.POSITION !== undefined) {

		var accessor = parser.json.accessors[attributes.POSITION];

		var min = accessor.min;
		var max = accessor.max;

		// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

		if (min !== undefined && max !== undefined) {

			box.set(new three_module["_41" /* Vector3 */](min[0], min[1], min[2]), new three_module["_41" /* Vector3 */](max[0], max[1], max[2]));

			if (accessor.normalized) {

				var boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
				box.min.multiplyScalar(boxScale);
				box.max.multiplyScalar(boxScale);
			}
		} else {

			console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');

			return;
		}
	} else {

		return;
	}

	var targets = primitiveDef.targets;

	if (targets !== undefined) {

		var maxDisplacement = new three_module["_41" /* Vector3 */]();
		var vector = new three_module["_41" /* Vector3 */]();

		for (var i = 0, il = targets.length; i < il; i++) {

			var target = targets[i];

			if (target.POSITION !== undefined) {

				var _accessor = parser.json.accessors[target.POSITION];
				var _min = _accessor.min;
				var _max = _accessor.max;

				// glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.

				if (_min !== undefined && _max !== undefined) {

					// we need to get max of absolute components because target weight is [-1,1]
					vector.setX(Math.max(Math.abs(_min[0]), Math.abs(_max[0])));
					vector.setY(Math.max(Math.abs(_min[1]), Math.abs(_max[1])));
					vector.setZ(Math.max(Math.abs(_min[2]), Math.abs(_max[2])));

					if (_accessor.normalized) {

						var _boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[_accessor.componentType]);
						vector.multiplyScalar(_boxScale);
					}

					// Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
					// to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
					// are used to implement key-frame animations and as such only two are active at a time - this results in very large
					// boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
					maxDisplacement.max(vector);
				} else {

					console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
				}
			}
		}

		// As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
		box.expandByVector(maxDisplacement);
	}

	geometry.boundingBox = box;

	var sphere = new three_module["_30" /* Sphere */]();

	box.getCenter(sphere.center);
	sphere.radius = box.min.distanceTo(box.max) / 2;

	geometry.boundingSphere = sphere;
}

/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */
function addPrimitiveAttributes(geometry, primitiveDef, parser) {

	var attributes = primitiveDef.attributes;

	var pending = [];

	function assignAttributeAccessor(accessorIndex, attributeName) {

		return parser.getDependency('accessor', accessorIndex).then(function (accessor) {

			geometry.setAttribute(attributeName, accessor);
		});
	}

	for (var gltfAttributeName in attributes) {

		var threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();

		// Skip attributes already provided by e.g. Draco extension.
		if (threeAttributeName in geometry.attributes) continue;

		pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
	}

	if (primitiveDef.indices !== undefined && !geometry.index) {

		var accessor = parser.getDependency('accessor', primitiveDef.indices).then(function (accessor) {

			geometry.setIndex(accessor);
		});

		pending.push(accessor);
	}

	assignExtrasToUserData(geometry, primitiveDef);

	computeBounds(geometry, primitiveDef, parser);

	return promise_default.a.all(pending).then(function () {

		return primitiveDef.targets !== undefined ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
	});
}



/***/ }),

/***/ "hg2J":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("n0T6");
var gOPS = __webpack_require__("1kS7");
var anObject = __webpack_require__("77Pl");
var Reflect = __webpack_require__("7KvD").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "hiCB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("dSOO"), __esModule: true };

/***/ }),

/***/ "hjGT":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),

/***/ "i/C/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("exh5");
module.exports = __webpack_require__("FeBl").Object.setPrototypeOf;


/***/ }),

/***/ "iInB":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("TcQ7");
var $getOwnPropertyDescriptor = __webpack_require__("LKZe").f;

__webpack_require__("uqUo")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "iUbK":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "ifoU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("3C/1"), __esModule: true };

/***/ }),

/***/ "iggS":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("eaw8");
module.exports = __webpack_require__("FeBl").Math.log10;


/***/ }),

/***/ "ioQ5":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("HpRW")('Set');


/***/ }),

/***/ "j9JH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("iggS"), __esModule: true };

/***/ }),

/***/ "jFbC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Cdx3");
module.exports = __webpack_require__("FeBl").Object.keys;


/***/ }),

/***/ "jJmG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("kXEU"), __esModule: true };

/***/ }),

/***/ "jKW+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("kM2E");
var newPromiseCapability = __webpack_require__("qARP");
var perform = __webpack_require__("dNDb");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "jYc2":
/***/ (function(module, exports, __webpack_require__) {

var UA = __webpack_require__("z2B9");
module.exports = function (ua) {
    var uaData = new UA(ua);
    var match;
    var tmpMatch;
    // handle mobile device
    if (uaData.device.type === 'mobile' || uaData.device.type === 'tablet') {

        // get manufacturer through the key words
        if (match = ua.match(/(ZTE|Samsung|Motorola|HTC|Coolpad|Huawei|Lenovo|LG|Sony Ericsson|Oppo|TCL|Vivo|Sony|Meizu|Nokia)/i)) {
            uaData.device.manufacturer = match[1];
            if (uaData.device.model && uaData.device.model.indexOf(match[1]) >= 0) {
                uaData.device.model = uaData.device.model.replace(match[1], '');
            }
        }
        // handle Apple
        // 苹果就这3种iPod iPad iPhone
        if (match = ua.match(/(iPod|iPad|iPhone)/i)) {
            uaData.device.manufacturer = 'Apple';
            uaData.device.model = match[1];
        }
        // handle Samsung
        // 特殊型号可能以xxx-开头 或者直接空格接型号 兼容build结尾或直接)结尾
        // Galaxy nexus才是三星 nexus是google手机
        // 三星手机类型：galaxy xxx|SM-xxx|GT-xxx|SCH-xxx|SGH-xxx|SPH-xxx|SHW-xxx  若这些均未匹配到，则启用在中关村在线爬取到的机型白名单进行判断
        else if (match = ua.match(/[-\s](Galaxy[\s-_]nexus|Galaxy[\s-_]\w*[\s-_]\w*|Galaxy[\s-_]\w*|SM-\w*|GT-\w*|s[cgp]h-\w*|shw-\w*|ATIV|i9070|omnia|s7568|A3000|A3009|A5000|A5009|A7000|A7009|A8000|C101|C1116|C1158|E400|E500F|E7000|E7009|G3139D|G3502|G3502i|G3508|G3508J|G3508i|G3509|G3509i|G3558|G3559|G3568V|G3586V|G3589W|G3606|G3608|G3609|G3812|G388F|G5108|G5108Q|G5109|G5306W|G5308W|G5309W|G550|G600|G7106|G7108|G7108V|G7109|G7200|G720NO|G7508Q|G7509|G8508S|G8509V|G9006V|G9006W|G9008V|G9008W|G9009D|G9009W|G9198|G9200|G9208|G9209|G9250|G9280|I535|I679|I739|I8190N|I8262|I879|I879E|I889|I9000|I9060|I9082|I9082C|I9082i|I9100|I9100G|I9108|I9128|I9128E|I9128i|I9152|I9152P|I9158|I9158P|I9158V|I9168|I9168i|I9190|I9192|I9195|I9195I|I9200|I9208|I9220|I9228|I9260|I9268|I9300|I9300i|I9305|I9308|I9308i|I939|I939D|I939i|I9500|I9502|I9505|I9507V|I9508|I9508V|I959|J100|J110|J5008|J7008|N7100|N7102|N7105|N7108|N7108D|N719|N750|N7505|N7506V|N7508V|N7509V|N900|N9002|N9005|N9006|N9008|N9008S|N9008V|N9009|N9100|N9106W|N9108V|N9109W|N9150|N916|N9200|P709|P709E|P729|S6358|S7278|S7278U|S7562C|S7562i|S7898i|b9388)[\s\)]/i)) {
            uaData.device.manufacturer = 'Samsung';
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z]+[0-9]+[A-Z]*, 例如 G9006 G9006V 其实应该是G9006 另外三星只保留3位
            uaData.device.model = match[1].replace(/Galaxy S VI/i, 'Galaxy S6')
                .replace(/Galaxy S V/i, 'Galaxy S5')
                .replace(/Galaxy S IV/i, 'Galaxy S4')
                .replace(/Galaxy s III/i, 'Galaxy S3')
                .replace(/Galaxy S II/i, 'Galaxy S2')
                .replace(/Galaxy S I/i, 'Galaxy S1')
                .replace(/([a-z]+[0-9]{3})[0-9]?[a-z]*/i, '$1');
        }
        // 针对三星已经匹配出的数据做处理
        else if (uaData.device.manufacturer && uaData.device.manufacturer.toLowerCase() === 'samsung' && uaData.device.model) {
            uaData.device.model = uaData.device.model.replace(/Galaxy S VI/i, 'Galaxy S6')
                .replace(/Galaxy S V/i, 'Galaxy S5')
                .replace(/Galaxy S IV/i, 'Galaxy S4')
                .replace(/Galaxy s III/i, 'Galaxy S3')
                .replace(/Galaxy S II/i, 'Galaxy S2')
                .replace(/Galaxy S I/i, 'Galaxy S1')
                .replace(/([a-z]+[0-9]{3})[0-9]?[a-z]*/i, '$1');
        }
        // handle Huawei
        // 兼容build结尾或直接)结尾
        // 华为机型特征：Huawei[\s-_](\w*[-_]?\w*)  或者以 7D-  ALE-  CHE-等开头
        else if (match = ua.match(/(Huawei[\s-_](\w*[-_]?\w*)|\s(7D-\w*|ALE-\w*|ATH-\w*|CHE-\w*|CHM-\w*|Che1-\w*|Che2-\w*|D2-\w*|G616-\w*|G620S-\w*|G621-\w*|G660-\w*|G750-\w*|GRA-\w*|Hol-\w*|MT2-\w*|MT7-\w*|PE-\w*|PLK-\w*|SC-\w*|SCL-\w*|H60-\w*|H30-\w*)[\s\)])/i)) {
            uaData.device.manufacturer = 'Huawei';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：xxx-[A-Z][0-9]+ 例如  H30-L01  H30-L00  H30-L20  都应该是 H30-L
            // h30-l  h30-h  h30-t 都是H30
            if (match = uaData.device.model.match(/(\w*)[\s-_]+[a-z0-9]+/i)) {
                uaData.device.model = match[1];
            }
        }
        // handle Xiaomi
        // 兼容build结尾或直接)结尾 以及特殊的HM处理方案(build/hm2013011)
        // xiaomi手机类型: mi m1 m2 m3 hm 开头
        // hongmi有特殊判断build/hm2015011
        else if (match = ua.match(/;\s(mi|m1|m2|m3|m4|hm)(\s*\w*)[\s\)]/i)) {
            if (tmpMatch = ua.match(/(meitu|MediaPad)/i)) {
                // 美图手机名字冒充小米 比如 meitu m4 mizhi
                uaData.device.manufacturer = tmpMatch[1];
                uaData.device.model = '';
            }
            // 若匹配出的 match[2]没空格 会出现很多例如 mizi mizhi miha 但也会出现mi3 minote之类 特殊处理下
            else if (match[2].length > 0 && !((/\s/).test(match[2]))) {
                if (tmpMatch = match[2].match(/(\d)/i)) {
                    uaData.device.model = match[1] + '-' + tmpMatch[1];
                }
            }
            else {
                uaData.device.manufacturer = 'Xiaomi';
                if (match[2] && match[2].length > 0) {
                    match[2] = match[2].replace(/\s/, '');
                    uaData.device.model = (match[1].substr(match[1].length - 2) + '-' + match[2]).replace(/m(\d)-/i, 'MI-$1');
                }
                else {
                    uaData.device.model = (match[1].substr(match[1].length - 2)).replace(/m(\d)/i, 'MI-$1');
                }

                // 解决移动联通等不同发行版导致的机型不同问题
                // 特征：mi-3c,例如mi-4LTE mi-4 其实应该是 mi-4
                if (/(mi|hm)(-\d)/i.test(uaData.device.model)) {
                    // 看看是不是 MI-3S  MI-4S....
                    if (match = uaData.device.model.match(/(mi|hm)(-\ds)/i)) {
                        uaData.device.model = match[1] + match[2];
                    }
                    // 防止 MI-20150XX等滥竽充数成为MI-2
                    else if (match = uaData.device.model.match(/(mi|hm)(-\d{2})/i)) {
                        uaData.device.model = match[1];
                    }
                    // 将mi-3c mi-3a mi-3w等合为mi-3
                    else if (match = uaData.device.model.match(/(mi|hm)(-\d)[A-Z]/i)) {
                        uaData.device.model = match[1] + match[2];
                    }
                }
                // 去除 mi-4g这样的东西
                if (match = uaData.device.model.match(/(mi|hm)(-\dg)/i)) {
                    uaData.device.model = match[1];
                }
            }
        }
        else if (/build\/HM\d{0,7}\)/i.test(ua)) {
            uaData.device.manufacturer = 'Xiaomi';
            uaData.device.model = 'HM';
        }
        else if (match = ua.match(/redmi\s?(\d+)?/i)) {
            uaData.device.manufacturer = 'Xiaomi';
            uaData.device.model = 'HM-' + match[1];
        }
        else if (uaData.device.manufacturer && uaData.device.manufacturer.toLowerCase() === 'xiaomi' && uaData.device.model) {
            // 针对通过base库判断出数据时命名风格不同。特殊处理适配如下
            if (match = uaData.device.model.match(/mi-one/i)) {
                uaData.device.model = 'MI-1';
            }
            // mi 2
            else if (match = uaData.device.model.match(/mi-two/i)) {
                uaData.device.model = 'MI-2';
            }
            // 20150xxx2014501
            else if (match = uaData.device.model.match(/\d{6}/i)) {
                uaData.device.model = '';
            }
            else if (match = uaData.device.model.match(/redmi/i)) {
                uaData.device.model = uaData.device.model.toUpperCase().replace(/redmi/i, 'HM');
            }
            // m1 m2 m3 写法不标准 另外判断是否是 m1-s
            else if (match = uaData.device.model.match(/(m\d)[\s-_](s?)/i)) {
                uaData.device.model = match[1].replace(/m/, 'MI-') + match[2];
            }
            // mi-2w  mi-3w 等格式化为mi-2  mi-3
            else if (match = uaData.device.model.match(/(hm|mi)[\s-_](\d?)[a-rt-z]/i)) {
                if (tmpMatch = uaData.device.model.match(/(mi|hm)[\s-_](note|pad)(\d?s?)/i)) {
                    uaData.device.model = tmpMatch[1] + '-' + tmpMatch[2] + tmpMatch[3];
                }
                else {
                    uaData.device.model = match[2] ? match[1] + '-' + match[2] : match[1];
                }
            }
            // 处理hm
            else if (match = uaData.device.model.match(/hm/i)) {
                // 判断是不是 hm-201xxx充数
                if (match = uaData.device.model.match(/(hm)[\s-_](\d{2})/i)) {
                    uaData.device.model = 'HM';
                }
                // 判断是不是 hm-2s hm-1s
                else if (match = uaData.device.model.match(/(hm)[\s-_](\ds)/i)) {
                    uaData.device.model = 'HM-' + match[2];
                }
                else if (match = uaData.device.model.match(/(hm)[\s-_](\d)[a-z]/i)) {
                    uaData.device.model = 'HM-' + match[2];
                }
                else {
                    uaData.device.model = 'HM';
                }
                // 过滤类似 2g 3g等数据
                if (/hm-\dg/.test(uaData.device.model)) {
                    uaData.device.model = 'HM';
                }
            }
        }
        // handle Vivo
        // 兼容build结尾或直接)结尾
        // vivo机型特征: Vivo[\s-_](\w*)  或者以 E1  S11t  S7t 等开头
        else if (match = ua.match(/(vivo[\s-_](\w*)|\s(E1\w?|E3\w?|E5\w?|V1\w?|V2\w?|S11\w?|S12\w?|S1\w?|S3\w?|S6\w?|S7\w?|S9\w?|X1\w?|X3\w?|X520\w?|X5\w?|X5Max|X5Max+|X5Pro|X5SL|X710F|X710L|Xplay|Xshot|Xpaly3S|Y11\w?|Y11i\w?|Y11i\w?|Y13\w?|Y15\w?|Y17\w?|Y18\w?|Y19\w?|Y1\w?|Y20\w?|Y22\w?|Y22i\w?|Y23\w?|Y27\w?|Y28\w?|Y29\w?|Y33\w?|Y37\w?|Y3\w?|Y613\w?|Y622\w?|Y627\w?|Y913\w?|Y923\w?|Y927\w?|Y928\w?|Y929\w?|Y937\w?)[\s\)])/i)) {
            uaData.device.manufacturer = 'Vivo';
            uaData.device.model = match[1];
            // 首先剔除 viv-  vivo-  bbg- 等打头的内容
            uaData.device.model = uaData.device.model.replace(/(viv[\s-_]|vivo[\s-_]|bbg[\s-_])/i, '');
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  X5F X5L X5M X5iL 都应该是 X5
            if (match = uaData.device.model.match(/([a-z]+[0-9]+)i?[a-z]?[\s-_]?/i)) {
                uaData.device.model = match[1];
            }
        }
        // handle Oppo
        else if (match = ua.match(/(Oppo[\s-_](\w*)|\s(1100|1105|1107|3000|3005|3007|6607|A100|A103|A105|A105K|A109|A109K|A11|A113|A115|A115K|A121|A125|A127|A129|A201|A203|A209|A31|A31c|A31t|A31u|A51kc|A520|A613|A615|A617|E21W|Find|Mirror|N5110|N5117|N5207|N5209|R2010|R2017|R6007|R7005|R7007|R7c|R7t|R8000|R8007|R801|R805|R807|R809T|R8107|R8109|R811|R811W|R813T|R815T|R815W|R817|R819T|R8200|R8205|R8207|R821T|R823T|R827T|R830|R830S|R831S|R831T|R833T|R850|Real|T703|U2S|U521|U525|U529|U539|U701|U701T|U705T|U705W|X9000|X9007|X903|X905|X9070|X9077|X909|Z101|R829T)[\s\)])/i)) {
            uaData.device.manufacturer = 'Oppo';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  A31c A31s 都应该是 A31
            // 对 Plus 做特殊处理
            if (match = uaData.device.model.match(/([a-z]+[0-9]+)-?(plus)/i)) {
                uaData.device.model = match[1] + '-' + match[2];
            }
            else if (match = uaData.device.model.match(/(\w*-?[a-z]+[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        else if (uaData.device.manufacturer && uaData.device.manufacturer.toLowerCase() === 'oppo' && uaData.device.model) {
            // 针对base库的数据做数据格式化处理
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  A31c A31s 都应该是 A31
            // 对 Plus 做特殊处理
            if (match = uaData.device.model.match(/([a-z]+[0-9]+)-?(plus)/i)) {
                uaData.device.model = match[1] + '-' + match[2];
            }
            else if (match = uaData.device.model.match(/(\w*-?[a-z]+[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        // handle Lenovo
        // 兼容build结尾或直接)结尾 兼容Lenovo-xxx/xxx以及Leveno xxx build等
        else if (match = ua.match(/(Lenovo[\s-_](\w*[-_]?\w*)|\s(A3580|A3860|A5500|A5600|A5860|A7600|A806|A800|A808T|A808T-I|A936|A938t|A788t|K30-E|K30-T|K30-W|K50-T3s|K50-T5|K80M|K910|K910e|K920|S90-e|S90-t|S90-u|S968T|X2-CU|X2-TO|Z90-3|Z90-7)[\s\)])/i)) {
            uaData.device.manufacturer = 'Lenovo';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  A360t A360 都应该是 A360
            if (match = uaData.device.model.match(/([a-z]+[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        // handle coolpad
        else if (match = ua.match(/(Coolpad[\s-_](\w*)|\s(7295C|7298A|7620L|8908|8085|8970L|9190L|Y80D)[\s\)])/i)) {
            uaData.device.manufacturer = 'Coolpad';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }

            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  8297-t01 8297-c01 8297w 都应该是 8297
            if (match = uaData.device.model.match(/([a-z]?[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        else if (uaData.device.manufacturer && uaData.device.manufacturer.toLowerCase() === 'coolpad' && uaData.device.model) {
            // base 库适配
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  8297-t01 8297-c01 8297w 都应该是 8297
            if (match = uaData.device.model.match(/([a-z]?[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        // handle meizu
        else if (match = ua.match(/\s(mx\d*\w*|mz-(\w*))\s(\w*)\s*\w*\s*build/i)) {
            uaData.device.manufacturer = 'Meizu';
            var tmpModel = match[2] ? match[2] : match[1];
            if (match[3]) {
                uaData.device.model = tmpModel + '-' + match[3];
            }
            else {
                uaData.device.model = tmpModel + '';
            }
        }
        else if (match = ua.match(/M463C|M35\d/i)) {
            uaData.device.manufacturer = 'Meizu';
            uaData.device.model = match[1];
        }
        // handle htc
        else if (match = ua.match(/(Htc[-_\s](\w*)|\s(601e|606w|608t|609d|610t|6160|619d|620G|626d|626s|626t|626w|709d|801e|802d|802t|802w|809D|816d|816e|816t|816v|816w|826d|826s|826t|826w|828w|901e|919d|A310e|A50AML|A510e|A620d|A620e|A620t|A810e|A9191|Aero|C620d|C620e|C620t|D316d|D516d|D516t|D516w|D820mt|D820mu|D820t|D820ts|D820u|D820us|E9pt|E9pw|E9sw|E9t|HD7S|M8Et|M8Sd|M8St|M8Sw|M8d|M8e|M8s|M8si|M8t|M8w|M9W|M9ew|Phablet|S510b|S510e|S610d|S710d|S710e|S720e|S720t|T327t|T328d|T328t|T328w|T329d|T329t|T329w|T528d|T528t|T528w|T8698|WF5w|X315e|X710e|X715e|X720d|X920e|Z560e|Z710e|Z710t|Z715e)[\s\)])/)) {
            uaData.device.manufacturer = 'Htc';
            uaData.device.model = match[1];
        }
        // handle Gionee
        else if (match = ua.match(/(Gionee[\s-_](\w*)|\s(GN\d+\w*)[\s\)])/i)) {
            uaData.device.manufacturer = 'Gionee';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
        }
        // handle LG
        else if (match = ua.match(/(LG[-_](\w*)|\s(D728|D729|D802|D855|D856|D857|D858|D859|E985T|F100L|F460|H778|H818|H819|P895|VW820)[\s\)])/i)) {
            uaData.device.manufacturer = 'Lg';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
        }
        // handle tcl
        else if (match = ua.match(/(Tcl[\s-_](\w*)|\s(H916T|P588L|P618L|P620M|P728M)[\s\)])/)) {
            uaData.device.manufacturer = 'Tcl';
            uaData.device.model = match[1];
        }
        // ZTE
        else if (match = ua.match(/(V9180|N918)/i)) {
            uaData.device.manufacturer = 'Zte';
            uaData.device.model = match[1];
        }
        else if (uaData.device.manufacturer && uaData.device.manufacturer.toLowerCase() === 'zte' && uaData.device.model) {
            // base 库适配
            // 解决移动联通等不同发行版导致的机型不同问题
            // 特征：[A-Z][0-9]+[A-Z] 例如  Q505T Q505u 都应该是 Q505
            if (match = uaData.device.model.match(/([a-z]?[0-9]+)/i)) {
                uaData.device.model = match[1];
            }
        }
        // UIMI
        else if (match = ua.match(/(UIMI\w*|umi\w*)[\s-_](\w*)\s*\w*\s*build/i)) {
            uaData.device.manufacturer = 'Uimi';
            if (match[2]) {
                uaData.device.model = match[1] + '-' + match[2];
            }
            else {
                uaData.device.model = match[1] + '';
            }
        }
        // eton
        else if (match = ua.match(/eton[\s-_](\w*)/i)) {
            uaData.device.manufacturer = 'Eton';
            uaData.device.model = match[1];
        }
        // Smartisan
        else if (match = ua.match(/(SM705|SM701|YQ601|YQ603)/i)) {
            uaData.device.manufacturer = 'Smartisan';
            uaData.device.model = ({
                SM705: 'T1',
                SM701: 'T1',
                YQ601: 'U1',
                YQ603: 'U1'
            })[match[1]] || match[1];
        }
        // handle Asus
        else if (match = ua.match(/(Asus[\s-_](\w*)|\s(A500CG|A500KL|A501CG|A600CG|PF400CG|PF500KL|T001|X002|X003|ZC500TG|ZE550ML|ZE551ML)[\s\)])/i)) {
            uaData.device.manufacturer = 'Asus';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
        }
        // handle nubia
        else if (match = ua.match(/(Nubia[-_\s](\w*)|(NX501|NX505J|NX506J|NX507J|NX503A|nx\d+\w*)[\s\)])/i)) {
            uaData.device.manufacturer = 'Nubia';
            if (match[2]) {
                uaData.device.model = match[2];
            }
            else if (match[3]) {
                uaData.device.model = match[3];
            }
        }
        // handle haier
        else if (match = ua.match(/(HT-\w*)|Haier[\s-_](\w*-?\w*)/i)) {
            uaData.device.manufacturer = 'Haier';
            if (match[1]) {
                uaData.device.model = match[1];
            }
            else if (match[2]) {
                uaData.device.model = match[2];
            }
        }
        // tianyu
        else if (match = ua.match(/K-Touch[\s-_](tou\s?ch\s?(\d)|\w*)/i)) {
            uaData.device.manufacturer = 'K-Touch';
            if (match[2]) {
                uaData.device.model = 'Ktouch' + match[2];
            }
            else {
                uaData.device.model = match[1];
            }
        }

        // DOOV
        else if (match = ua.match(/Doov[\s-_](\w*)/i)) {
            uaData.device.manufacturer = 'Doov';
            uaData.device.model = match[1];
        }
        // coobee
        else if (/koobee/i.test(ua)) {
            uaData.device.manufacturer = 'koobee';
        }

        // sony
        else if (/C69/i.test(ua)) {
            uaData.device.manufacturer = 'Sony';
        }

        // haojixing
        else if (/N787|N818S/i.test(ua)) {
            uaData.device.manufacturer = 'Haojixing';
        }

        // haisense
        else if (match = ua.match(/(hs-|Hisense[\s-_])(\w*)/i)) {
            uaData.device.manufacturer = 'Hisense';
            uaData.device.model = match[2];
        }

        // format the style of manufacturer
        if (uaData.device.manufacturer) {
            uaData.device.manufacturer = uaData.device.manufacturer.substr(0, 1).toUpperCase() + uaData.device.manufacturer.substr(1).toLowerCase();
        }
        // format the style of model
        if (uaData.device.model) {
            uaData.device.model = uaData.device.model.toUpperCase().replace(/-+|_+|\s+/g, ' ');
            uaData.device.model = uaData.device.model.match(/\s*(\w*\s*\w*)/)[1].replace(/\s+/, '-');

            // 针对三星、华为做去重的特殊处理
            if (uaData.device.manufacturer === 'Samsung') {
                uaData.device.model = ({
                    'SCH-I95': 'GT-I950',
                    'SCH-I93': 'GT-I930',
                    'SCH-I86': 'GT-I855',
                    'SCH-N71': 'GT-N710',
                    'SCH-I73': 'GT-S789',
                    'SCH-P70': 'GT-I915'
                })[uaData.device.model] || uaData.device.model;
            }
            else if (uaData.device.manufacturer === 'Huawei') {
                uaData.device.model = ({
                    CHE1: 'CHE',
                    CHE2: 'CHE',
                    G620S: 'G621',
                    C8817D: 'G621'
                })[uaData.device.model] || uaData.device.model;
            }
        }

        // 针对xiaomi 的部分数据没有格式化成功，格式化1次
        if (uaData.device.manufacturer && uaData.device.manufacturer === 'Xiaomi') {
            if (match = uaData.device.model.match(/(hm|mi)-(note)/i)) {
                uaData.device.model = match[1] + '-' + match[2];
            }
            else if (match = uaData.device.model.match(/(hm|mi)-(\ds?)/i)) {
                uaData.device.model = match[1] + '-' + match[2];
            }
            else if (match = uaData.device.model.match(/(hm|mi)-(\d)[a-rt-z]/i)) {
                uaData.device.model = match[1] + '-' + match[2];
            }
        }
    }
    // handle browser
    // if (!uaData.browser.name) {
    // ua = ua.toLowerCase();
    if (uaData.device.type === 'desktop') {
        /*
         * 360 security Explorer
         */
        if (match = /360se(?:[ \/]([\w.]+))?/i.exec(ua)) {
            uaData.browser.name = '360 security Explorer';
            uaData.browser.version = {
                original: match[1]
            };
        }
        /**
         * the world
         */
        else if (match = /the world(?:[ \/]([\w.]+))?/i.exec(ua)) {
            uaData.browser.name = 'the world';
            uaData.browser.version = {
                original: match[1]
            };
        }
        /**
         * tencenttraveler
         */
        else if (match = /tencenttraveler ([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'tencenttraveler';
            uaData.browser.version = {
                original: match[1]
            };
        }
        /**
         * LBBROWSER
         */
        else if (match = /LBBROWSER/i.exec(ua)) {
            uaData.browser.name = 'LBBROWSER';
        }
    }
    else if (uaData.device.type === 'mobile' || uaData.device.type === 'tablet') {
        /**
         * BaiduHD
         */
        if (match = /BaiduHD\s+([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'BaiduHD';
            uaData.browser.version = {
                original: match[1]
            };
        }
        /**
         * 360 Browser
         */
        else if (match = /360.s*aphone\s*browser\s*\(version\s*([\w.]+)\)/i.exec(ua)) {
            uaData.browser.name = '360 Browser';
            uaData.browser.version = {
                original: match[1]
            };
        }
        /**
         * Baidu Browser
         */
        else if (match = /flyflow\/([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'Baidu Browser';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * Baidu HD
         */
        else if (match = /baiduhd ([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'Baidu HD';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * baidubrowser
         */
        else if (match = /baidubrowser\/([\d\.]+)\s/i.exec(ua)) {
            uaData.browser.name = 'baidubrowser';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * LieBaoFast
         */
        else if (match = /LieBaoFast\/([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'LieBao Fast';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * LieBao
         */
        else if (match = /LieBao\/([\w.]+)/i.exec(ua)) {
            uaData.browser.name = 'LieBao';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * SOUGOU
         */
        else if (match = /Sogou\w+\/([0-9\.]+)/i.exec(ua)) {
            uaData.browser.name = 'SogouMobileBrowser';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * 百度国际
         */
        else if (match = /bdbrowser\w+\/([0-9\.]+)/i.exec(ua)) {
            uaData.browser.name = '百度国际';
            uaData.browser.version = {
                original: match[1]
            };
        }

        /**
         * Android Chrome Browser
         */
        else if (uaData.os.name === 'Android' && /safari/i.test(ua) && (match = /chrome\/([0-9\.]+)/i.exec(ua))) {
            if (tmpMatch = ua.match(/\s+(\w+Browser)\/?([\d\.]*)/)) {
                uaData.browser.name = tmpMatch[1];
                if (tmpMatch[2]) {
                    uaData.browser.version = {original: tmpMatch[2]};
                } else {
                    uaData.browser.version = {original: match[1]};
                }
            } else {
                uaData.browser.name = 'Android Chrome';
                uaData.browser.version = {original: match[1]};
            }
        }

        /**
         * Android Google Browser
         */
        else if (uaData.os.name === 'Android' && /safari/i.test(ua) && (match = /version\/([0-9\.]+)/i.exec(ua))) {
            if (tmpMatch = ua.match(/\s+(\w+Browser)\/?([\d\.]*)/)) {
                uaData.browser.name = tmpMatch[1];
                if (tmpMatch[2]) {
                    uaData.browser.version = {original: tmpMatch[2]};
                } else {
                    uaData.browser.version = {original: match[1]};
                }
            } else {
                uaData.browser.name = 'Android Browser';
                uaData.browser.version = {original: match[1]};
            }
        }

        /**
         * 'Mozilla/5.0 (iPad; CPU OS 5_1_1 like Mac OS X) AppleWebKit/534.46 (KHTML, like Gecko) Mobile/9B206' belongs to Safari
         */
        else if (/(ipad|iphone).* applewebkit\/.* mobile/i.test(ua)) {
            uaData.browser.name = 'Safari';
        }
    }
    if (match = ua.match(/baiduboxapp\/?([\d\.]*)/i)) {
        uaData.browser.name = '百度框';
        if (match[1]) {
            uaData.browser.version = {
                original: match[1]
            };
        }
        // uaData.browser.name = 'baidu box';
    }
    else if (/BaiduLightAppRuntime/i.test(ua)) {
        uaData.browser.name = '轻应用runtime';
        // uaData.browser.name = 'qing runtime';
    }
    else if (/Weibo/i.test(ua)) {
        uaData.browser.name = '微博';
        // uaData.browser.name = 'weibo';
    }
    else if (/MQQ/i.test(ua)) {
        uaData.browser.name = '手机QQ';
        // uaData.browser.name = 'mobile qq';
    }
    else if (/hao123/i.test(ua)) {
        uaData.browser.name = 'hao123';
    }
    // }
    if (match = /MicroMessenger\/([\w.]+)/i.exec(ua)) {
        uaData.browser.name = '微信';
        var tmpVersion = (match[1]).replace(/_/g, '.');
        tmpMatch = /(\d+\.\d+\.\d+\.\d+)/.exec(tmpVersion);
        if(tmpMatch) {
            tmpVersion = tmpMatch[1];
        }
        uaData.browser.version = {
            original: tmpVersion
        };
    }
    if (match = /UCBrowser\/([\w.]+)/i.exec(ua)) {
        uaData.browser.name = 'UC Browser';
        uaData.browser.version = {
            original: match[1]
        };
    }
    if (match = /OPR\/([\w.]+)/i.exec(ua)) {
        uaData.browser.name = 'Opera';
        uaData.browser.version = {
            original: match[1]
        };
    } else if (match = /OPiOS\/([\w.]+)/i.exec(ua)) {
        uaData.browser.name = 'Opera';
        uaData.browser.version = {
            original: match[1]
        };
    }
    // IE 11
    else if (/Trident\/7/i.test(ua) && /rv:11/i.test(ua)) {
        uaData.browser.name = 'Internet Explorer';
        uaData.browser.version = {
            major: '11',
            original: '11'
        };
    }
    // Microsoft Edge
    else if (/Edge\/12/i.test(ua) && /Windows Phone|Windows NT/i.test(ua)) {
        uaData.browser.name = 'Microsoft Edge';
        uaData.browser.version = {
            major: '12',
            original: '12'
        };
    }
    // miui browser
    else if (match = /miuibrowser\/([\w.]+)/i.exec(ua)) {
        uaData.browser.name = 'miui browser';
        uaData.browser.version = {
            original: match[1]
        };
    }
    // Safari
    if (!uaData.browser.name) {
        if (match = /Safari\/([\w.]+)/i.exec(ua) && /Version/i.test(ua)) {
            uaData.browser.name = 'Safari';
        }
    }
    if (uaData.browser.name && !uaData.browser.version) {
        if (match = /Version\/([\w.]+)/i.exec(ua)) {
            uaData.browser.version =  {
                original: match[1]
            };
        }
    }

    // if (uaData.os.name === 'Windows' && uaData.os.version) {
    //  // Windows 8.1
    //  if (uaData.os.version.alias === 'NT 6.3') {
    //      uaData.os.version.alias = '8.1';
    //  }
    // }
    // handle os
    if (uaData.os.name === 'Windows' || /Windows/i.test(ua)) {
        uaData.os.name = 'Windows';
        if (/NT 6.3/i.test(ua)) {
            uaData.os.version = {
                alias: '8.1',
                original: '8.1'
            };
        }
        else if (/NT 6.4/i.test(ua) || /NT 10.0/i.test(ua)) {
            uaData.os.version = {
                alias: '10',
                original: '10'
            };
        }
    }
    else if (uaData.os.name === 'Mac OS X') {
        uaData.os.name = 'Mac OS X';
        if (match = /Mac OS X[\s\_\-\/](\d+[\.\-\_]\d+[\.\-\_]?\d*)/i.exec(ua)) {
            uaData.os.version = {
                alias: match[1].replace(/_/g, '.'),
                original: match[1].replace(/_/g, '.')
            };
        }
        else {
            uaData.os.version = {
                alias: '',
                original: ''
            };
        }
    }
    else if (/Android/i.test(uaData.os.name)) {
        if (match = ua.match(/Android[\s\_\-\/i686]?[\s\_\-\/](\d+[\.\-\_]\d+[\.\-\_]?\d*)/i)) {
            uaData.os.version = {
                alias: match[1],
                original: match[1]
            };
        }
    }
    return uaData;
};


/***/ }),

/***/ "jyFz":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("SldL");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "k2Ib":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("30KW");
module.exports = __webpack_require__("FeBl").Number.isFinite;


/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var has = __webpack_require__("D2L2");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "kMPS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "kVWZ":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),

/***/ "kXEU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("CbwA");
module.exports = __webpack_require__("FeBl").Object.getOwnPropertyDescriptors;


/***/ }),

/***/ "kiBT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("i/C/"), __esModule: true };

/***/ }),

/***/ "knuC":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "lFEC":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.VMasker = factory();
  }
}(this, function() {
  var DIGIT = "9",
      ALPHA = "A",
      ALPHANUM = "S",
      BY_PASS_KEYS = [9, 16, 17, 18, 36, 37, 38, 39, 40, 91, 92, 93],
      isAllowedKeyCode = function(keyCode) {
        for (var i = 0, len = BY_PASS_KEYS.length; i < len; i++) {
          if (keyCode == BY_PASS_KEYS[i]) {
            return false;
          }
        }
        return true;
      },
      mergeMoneyOptions = function(opts) {
        opts = opts || {};
        opts = {
          delimiter: opts.delimiter || ".",
          lastOutput: opts.lastOutput,
          precision: opts.hasOwnProperty("precision") ? opts.precision : 2,
          separator: opts.separator || ",",
          showSignal: opts.showSignal,
          suffixUnit: opts.suffixUnit && (" " + opts.suffixUnit.replace(/[\s]/g,'')) || "",
          unit: opts.unit && (opts.unit.replace(/[\s]/g,'') + " ") || "",
          zeroCents: opts.zeroCents
        };
        opts.moneyPrecision = opts.zeroCents ? 0 : opts.precision;
        return opts;
      },
      // Fill wildcards past index in output with placeholder
      addPlaceholdersToOutput = function(output, index, placeholder) {
        for (; index < output.length; index++) {
          if(output[index] === DIGIT || output[index] === ALPHA || output[index] === ALPHANUM) {
            output[index] = placeholder;
          }
        }
        return output;
      }
  ;

  var VanillaMasker = function(elements) {
    this.elements = elements;
  };

  VanillaMasker.prototype.unbindElementToMask = function() {
    for (var i = 0, len = this.elements.length; i < len; i++) {
      this.elements[i].lastOutput = "";
      this.elements[i].onkeyup = false;
      this.elements[i].onkeydown = false;

      if (this.elements[i].value.length) {
        this.elements[i].value = this.elements[i].value.replace(/\D/g, '');
      }
    }
  };

  VanillaMasker.prototype.bindElementToMask = function(maskFunction) {
    var that = this,
        onType = function(e) {
          e = e || window.event;
          var source = e.target || e.srcElement;

          if (isAllowedKeyCode(e.keyCode)) {
            setTimeout(function() {
              that.opts.lastOutput = source.lastOutput;
              source.value = VMasker[maskFunction](source.value, that.opts);
              source.lastOutput = source.value;
              if (source.setSelectionRange && that.opts.suffixUnit) {
                source.setSelectionRange(source.value.length, (source.value.length - that.opts.suffixUnit.length));
              }
            }, 0);
          }
        }
    ;
    for (var i = 0, len = this.elements.length; i < len; i++) {
      this.elements[i].lastOutput = "";
      this.elements[i].onkeyup = onType;
      if (this.elements[i].value.length) {
        this.elements[i].value = VMasker[maskFunction](this.elements[i].value, this.opts);
      }
    }
  };

  VanillaMasker.prototype.maskMoney = function(opts) {
    this.opts = mergeMoneyOptions(opts);
    this.bindElementToMask("toMoney");
  };

  VanillaMasker.prototype.maskNumber = function() {
    this.opts = {};
    this.bindElementToMask("toNumber");
  };
  
  VanillaMasker.prototype.maskAlphaNum = function() {
    this.opts = {};
    this.bindElementToMask("toAlphaNumeric");
  };

  VanillaMasker.prototype.maskPattern = function(pattern) {
    this.opts = {pattern: pattern};
    this.bindElementToMask("toPattern");
  };

  VanillaMasker.prototype.unMask = function() {
    this.unbindElementToMask();
  };

  var VMasker = function(el) {
    if (!el) {
      throw new Error("VanillaMasker: There is no element to bind.");
    }
    var elements = ("length" in el) ? (el.length ? el : []) : [el];
    return new VanillaMasker(elements);
  };

  VMasker.toMoney = function(value, opts) {
    opts = mergeMoneyOptions(opts);
    if (opts.zeroCents) {
      opts.lastOutput = opts.lastOutput || "";
      var zeroMatcher = ("("+ opts.separator +"[0]{0,"+ opts.precision +"})"),
          zeroRegExp = new RegExp(zeroMatcher, "g"),
          digitsLength = value.toString().replace(/[\D]/g, "").length || 0,
          lastDigitLength = opts.lastOutput.toString().replace(/[\D]/g, "").length || 0
      ;
      value = value.toString().replace(zeroRegExp, "");
      if (digitsLength < lastDigitLength) {
        value = value.slice(0, value.length - 1);
      }
    }
    var number = value.toString().replace(/[\D]/g, ""),
        clearDelimiter = new RegExp("^(0|\\"+ opts.delimiter +")"),
        clearSeparator = new RegExp("(\\"+ opts.separator +")$"),
        money = number.substr(0, number.length - opts.moneyPrecision),
        masked = money.substr(0, money.length % 3),
        cents = new Array(opts.precision + 1).join("0")
    ;
    money = money.substr(money.length % 3, money.length);
    for (var i = 0, len = money.length; i < len; i++) {
      if (i % 3 === 0) {
        masked += opts.delimiter;
      }
      masked += money[i];
    }
    masked = masked.replace(clearDelimiter, "");
    masked = masked.length ? masked : "0";
    var signal = "";
    if(opts.showSignal === true) {
      signal = value < 0 || (value.startsWith && value.startsWith('-')) ? "-" :  "";
    }
    if (!opts.zeroCents) {
      var beginCents = number.length - opts.precision,
          centsValue = number.substr(beginCents, opts.precision),
          centsLength = centsValue.length,
          centsSliced = (opts.precision > centsLength) ? opts.precision : centsLength
      ;
      cents = (cents + centsValue).slice(-centsSliced);
    }
    var output = opts.unit + signal + masked + opts.separator + cents;
    return output.replace(clearSeparator, "") + opts.suffixUnit;
  };

  VMasker.toPattern = function(value, opts) {
    var pattern = (typeof opts === 'object' ? opts.pattern : opts),
        patternChars = pattern.replace(/\W/g, ''),
        output = pattern.split(""),
        values = value.toString().replace(/\W/g, ""),
        charsValues = values.replace(/\W/g, ''),
        index = 0,
        i,
        outputLength = output.length,
        placeholder = (typeof opts === 'object' ? opts.placeholder : undefined)
    ;
    
    for (i = 0; i < outputLength; i++) {
      // Reached the end of input
      if (index >= values.length) {
        if (patternChars.length == charsValues.length) {
          return output.join("");
        }
        else if ((placeholder !== undefined) && (patternChars.length > charsValues.length)) {
          return addPlaceholdersToOutput(output, i, placeholder).join("");
        }
        else {
          break;
        }
      }
      // Remaining chars in input
      else{
        if ((output[i] === DIGIT && values[index].match(/[0-9]/)) ||
            (output[i] === ALPHA && values[index].match(/[a-zA-Z]/)) ||
            (output[i] === ALPHANUM && values[index].match(/[0-9a-zA-Z]/))) {
          output[i] = values[index++];
        } else if (output[i] === DIGIT || output[i] === ALPHA || output[i] === ALPHANUM) {
          if(placeholder !== undefined){
            return addPlaceholdersToOutput(output, i, placeholder).join("");
          }
          else{
            return output.slice(0, i).join("");
          }
        }
      }
    }
    return output.join("").substr(0, i);
  };

  VMasker.toNumber = function(value) {
    return value.toString().replace(/(?!^-)[^0-9]/g, "");
  };
  
  VMasker.toAlphaNumeric = function(value) {
    return value.toString().replace(/[^a-z0-9 ]+/i, "");
  };

  return VMasker;
}));


/***/ }),

/***/ "lHA8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("pPW7"), __esModule: true };

/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "m9gC":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("RY/4");
var from = __webpack_require__("4WTo");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "mClu":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperty: __webpack_require__("evD5").f });


/***/ }),

/***/ "mP1F":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ "mbce":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("+E39");
var getKeys = __webpack_require__("lktj");
var toIObject = __webpack_require__("TcQ7");
var isEnum = __webpack_require__("NpIQ").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "mcHG":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Y5Mq");
module.exports = Math.pow(2, -52);


/***/ }),

/***/ "msXi":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("77Pl");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "mtWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// EXTERNAL MODULE: ./node_modules/axios/lib/utils.js
var utils = __webpack_require__("cGG2");

// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/bind.js
var bind = __webpack_require__("JP+z");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/toFormData.js
var toFormData = __webpack_require__("D437");

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  var charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && Object(toFormData["a" /* default */])(params, this, options);
}

var AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  var _encode = encoder ? function (value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var _encode = options && options.encode || buildURL_encode;

  var serializeFn = options && options.serialize;

  var serializedParams = void 0;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils["a" /* default */].isURLSearchParams(params) ? params.toString() : new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}
// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js






var InterceptorManager_InterceptorManager = function () {
  function InterceptorManager() {
    classCallCheck_default()(this, InterceptorManager);

    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */


  createClass_default()(InterceptorManager, [{
    key: 'use',
    value: function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    }

    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     *
     * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
     */

  }, {
    key: 'eject',
    value: function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    }

    /**
     * Clear all interceptors from the stack
     *
     * @returns {void}
     */

  }, {
    key: 'clear',
    value: function clear() {
      if (this.handlers) {
        this.handlers = [];
      }
    }

    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     *
     * @returns {void}
     */

  }, {
    key: 'forEach',
    value: function forEach(fn) {
      utils["a" /* default */].forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    }
  }]);

  return InterceptorManager;
}();

/* harmony default export */ var core_InterceptorManager = (InterceptorManager_InterceptorManager);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/axios/lib/core/AxiosError.js
var AxiosError = __webpack_require__("ydVi");

// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);
// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);
// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);
// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
var isStandardBrowserEnv = function () {
  var product = void 0;
  if (typeof navigator !== 'undefined' && ((product = navigator.product) === 'ReactNative' || product === 'NativeScript' || product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
var isStandardBrowserWebWorkerEnv = function () {
  return typeof WorkerGlobalScope !== 'undefined' &&
  // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
}();

/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  isStandardBrowserEnv: isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv: isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});
// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js







function toURLEncodedForm(data, options) {
  return Object(toFormData["a" /* default */])(data, new browser.classes.URLSearchParams(), assign_default()({
    visitor: function visitor(value, key, path, helpers) {
      if (browser.isNode && utils["a" /* default */].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-finite.js
var is_finite = __webpack_require__("AMV0");
var is_finite_default = /*#__PURE__*/__webpack_require__.n(is_finite);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js






/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils["a" /* default */].matchAll(/\w+|\[(\w*)]/g, name).map(function (match) {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  var obj = {};
  var keys = keys_default()(arr);
  var i = void 0;
  var len = keys.length;
  var key = void 0;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    var name = path[index++];
    var isNumericKey = is_finite_default()(+name);
    var isLast = index >= path.length;
    name = !name && utils["a" /* default */].isArray(target) ? target.length : name;

    if (isLast) {
      if (utils["a" /* default */].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils["a" /* default */].isObject(target[name])) {
      target[name] = [];
    }

    var result = buildPath(path, value, target[name], index);

    if (result && utils["a" /* default */].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils["a" /* default */].isFormData(formData) && utils["a" /* default */].isFunction(formData.entries)) {
    var obj = {};

    utils["a" /* default */].forEachEntry(formData, function (name, value) {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);
// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js











var DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils["a" /* default */].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils["a" /* default */].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || stringify_default.a)(rawValue);
}

var defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    var contentType = headers.getContentType() || '';
    var hasJSONContentType = contentType.indexOf('application/json') > -1;
    var isObjectPayload = utils["a" /* default */].isObject(data);

    if (isObjectPayload && utils["a" /* default */].isHTMLForm(data)) {
      data = new FormData(data);
    }

    var isFormData = utils["a" /* default */].isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? stringify_default()(helpers_formDataToJSON(data)) : data;
    }

    if (utils["a" /* default */].isArrayBuffer(data) || utils["a" /* default */].isBuffer(data) || utils["a" /* default */].isStream(data) || utils["a" /* default */].isFile(data) || utils["a" /* default */].isBlob(data)) {
      return data;
    }
    if (utils["a" /* default */].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils["a" /* default */].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    var isFileList = void 0;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils["a" /* default */].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        var _FormData = this.env && this.env.FormData;

        return Object(toFormData["a" /* default */])(isFileList ? { 'files[]': data } : data, _FormData && new _FormData(), this.formSerializer);
      }
    }

    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var JSONRequested = this.responseType === 'json';

    if (data && utils["a" /* default */].isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError["a" /* default */].from(e, AxiosError["a" /* default */].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: browser.classes.FormData,
    Blob: browser.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils["a" /* default */].forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils["a" /* default */].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils["a" /* default */].merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ var lib_defaults = (defaults);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol/to-string-tag.js
var to_string_tag = __webpack_require__("a1FJ");
var to_string_tag_default = /*#__PURE__*/__webpack_require__.n(to_string_tag);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol/iterator.js
var iterator = __webpack_require__("Zzip");
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-property.js
var define_property = __webpack_require__("C4MV");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/create.js
var object_create = __webpack_require__("OvRC");
var create_default = /*#__PURE__*/__webpack_require__.n(object_create);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/symbol.js
var symbol = __webpack_require__("5QVw");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = utils["a" /* default */].toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (function (rawHeaders) {
  var parsed = {};
  var key = void 0;
  var val = void 0;
  var i = void 0;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});
// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js
















var $internals = symbol_default()('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils["a" /* default */].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  var tokens = create_default()(null);
  var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  var match = void 0;

  while (match = tokensRE.exec(str)) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

function isValidHeaderName(str) {
  return (/^[-_a-zA-Z]+$/.test(str.trim())
  );
}

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils["a" /* default */].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils["a" /* default */].isString(value)) return;

  if (utils["a" /* default */].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils["a" /* default */].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function (w, char, str) {
    return char.toUpperCase() + str;
  });
}

function buildAccessors(obj, header) {
  var accessorName = utils["a" /* default */].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(function (methodName) {
    define_property_default()(obj, methodName + accessorName, {
      value: function value(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

var AxiosHeaders_AxiosHeaders = function () {
  function AxiosHeaders(headers) {
    classCallCheck_default()(this, AxiosHeaders);

    headers && this.set(headers);
  }

  createClass_default()(AxiosHeaders, [{
    key: 'set',
    value: function set(header, valueOrRewrite, rewrite) {
      var self = this;

      function setHeader(_value, _header, _rewrite) {
        var lHeader = normalizeHeader(_header);

        if (!lHeader) {
          throw new Error('header name must be a non-empty string');
        }

        var key = utils["a" /* default */].findKey(self, lHeader);

        if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) {
          self[key || _header] = normalizeValue(_value);
        }
      }

      var setHeaders = function setHeaders(headers, _rewrite) {
        return utils["a" /* default */].forEach(headers, function (_value, _header) {
          return setHeader(_value, _header, _rewrite);
        });
      };

      if (utils["a" /* default */].isPlainObject(header) || header instanceof this.constructor) {
        setHeaders(header, valueOrRewrite);
      } else if (utils["a" /* default */].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
        setHeaders(parseHeaders(header), valueOrRewrite);
      } else {
        header != null && setHeader(valueOrRewrite, header, rewrite);
      }

      return this;
    }
  }, {
    key: 'get',
    value: function get(header, parser) {
      header = normalizeHeader(header);

      if (header) {
        var key = utils["a" /* default */].findKey(this, header);

        if (key) {
          var value = this[key];

          if (!parser) {
            return value;
          }

          if (parser === true) {
            return parseTokens(value);
          }

          if (utils["a" /* default */].isFunction(parser)) {
            return parser.call(this, value, key);
          }

          if (utils["a" /* default */].isRegExp(parser)) {
            return parser.exec(value);
          }

          throw new TypeError('parser must be boolean|regexp|function');
        }
      }
    }
  }, {
    key: 'has',
    value: function has(header, matcher) {
      header = normalizeHeader(header);

      if (header) {
        var key = utils["a" /* default */].findKey(this, header);

        return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
      }

      return false;
    }
  }, {
    key: 'delete',
    value: function _delete(header, matcher) {
      var self = this;
      var deleted = false;

      function deleteHeader(_header) {
        _header = normalizeHeader(_header);

        if (_header) {
          var key = utils["a" /* default */].findKey(self, _header);

          if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
            delete self[key];

            deleted = true;
          }
        }
      }

      if (utils["a" /* default */].isArray(header)) {
        header.forEach(deleteHeader);
      } else {
        deleteHeader(header);
      }

      return deleted;
    }
  }, {
    key: 'clear',
    value: function clear(matcher) {
      var keys = keys_default()(this);
      var i = keys.length;
      var deleted = false;

      while (i--) {
        var key = keys[i];
        if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
          delete this[key];
          deleted = true;
        }
      }

      return deleted;
    }
  }, {
    key: 'normalize',
    value: function normalize(format) {
      var self = this;
      var headers = {};

      utils["a" /* default */].forEach(this, function (value, header) {
        var key = utils["a" /* default */].findKey(headers, header);

        if (key) {
          self[key] = normalizeValue(value);
          delete self[header];
          return;
        }

        var normalized = format ? formatHeader(header) : String(header).trim();

        if (normalized !== header) {
          delete self[header];
        }

        self[normalized] = normalizeValue(value);

        headers[normalized] = true;
      });

      return this;
    }
  }, {
    key: 'concat',
    value: function concat() {
      var _constructor;

      for (var _len = arguments.length, targets = Array(_len), _key = 0; _key < _len; _key++) {
        targets[_key] = arguments[_key];
      }

      return (_constructor = this.constructor).concat.apply(_constructor, [this].concat(targets));
    }
  }, {
    key: 'toJSON',
    value: function toJSON(asStrings) {
      var obj = create_default()(null);

      utils["a" /* default */].forEach(this, function (value, header) {
        value != null && value !== false && (obj[header] = asStrings && utils["a" /* default */].isArray(value) ? value.join(', ') : value);
      });

      return obj;
    }
  }, {
    key: iterator_default.a,
    value: function value() {
      return get_iterator_default()(entries_default()(this.toJSON()));
    }
  }, {
    key: 'toString',
    value: function toString() {
      return entries_default()(this.toJSON()).map(function (_ref) {
        var _ref2 = slicedToArray_default()(_ref, 2),
            header = _ref2[0],
            value = _ref2[1];

        return header + ': ' + value;
      }).join('\n');
    }
  }, {
    key: to_string_tag_default.a,
    get: function get() {
      return 'AxiosHeaders';
    }
  }], [{
    key: 'from',
    value: function from(thing) {
      return thing instanceof this ? thing : new this(thing);
    }
  }, {
    key: 'concat',
    value: function concat(first) {
      var computed = new this(first);

      for (var _len2 = arguments.length, targets = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        targets[_key2 - 1] = arguments[_key2];
      }

      targets.forEach(function (target) {
        return computed.set(target);
      });

      return computed;
    }
  }, {
    key: 'accessor',
    value: function accessor(header) {
      var internals = this[$internals] = this[$internals] = {
        accessors: {}
      };

      var accessors = internals.accessors;
      var prototype = this.prototype;

      function defineAccessor(_header) {
        var lHeader = normalizeHeader(_header);

        if (!accessors[lHeader]) {
          buildAccessors(prototype, _header);
          accessors[lHeader] = true;
        }
      }

      utils["a" /* default */].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

      return this;
    }
  }]);

  return AxiosHeaders;
}();

AxiosHeaders_AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

utils["a" /* default */].freezeMethods(AxiosHeaders_AxiosHeaders.prototype);
utils["a" /* default */].freezeMethods(AxiosHeaders_AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders_AxiosHeaders);
// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  var config = this || lib_defaults;
  var context = response || config;
  var headers = core_AxiosHeaders.from(context.headers);
  var data = context.data;

  utils["a" /* default */].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}
// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError["a" /* default */].call(this, message == null ? 'canceled' : message, AxiosError["a" /* default */].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils["a" /* default */].inherits(CanceledError, AxiosError["a" /* default */], {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);
// EXTERNAL MODULE: ./node_modules/axios/lib/helpers/null.js
var helpers_null = __webpack_require__("Aeej");

// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError["a" /* default */]('Request failed with status code ' + response.status, [AxiosError["a" /* default */].ERR_BAD_REQUEST, AxiosError["a" /* default */].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4], response.config, response.request, response));
  }
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js





/* harmony default export */ var cookies = (browser.isStandardBrowserEnv ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils["a" /* default */].isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils["a" /* default */].isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils["a" /* default */].isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}());
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)
  );
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */

function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}
// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var helpers_isURLSameOrigin = (browser.isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL = void 0;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils["a" /* default */].isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}());
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */

function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  var bytes = new Array(samplesCount);
  var timestamps = new Array(samplesCount);
  var head = 0;
  var tail = 0;
  var firstSampleTS = void 0;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    var now = Date.now();

    var startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    var i = tail;
    var bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    var passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);
// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js

















function progressEventReducer(listener, isDownloadStream) {
  var bytesNotified = 0;
  var _speedometer = helpers_speedometer(50, 250);

  return function (e) {
    var loaded = e.loaded;
    var total = e.lengthComputable ? e.total : undefined;
    var progressBytes = loaded - bytesNotified;
    var rate = _speedometer(progressBytes);
    var inRange = loaded <= total;

    bytesNotified = loaded;

    var data = {
      loaded: loaded,
      total: total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

var isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new promise_default.a(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    var responseType = config.responseType;
    var onCanceled = void 0;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils["a" /* default */].isFormData(requestData) && (browser.isStandardBrowserEnv || browser.isStandardBrowserWebWorkerEnv)) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = core_AxiosHeaders.from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError["a" /* default */]('Request aborted', AxiosError["a" /* default */].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError["a" /* default */]('Network Error', AxiosError["a" /* default */].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError["a" /* default */](timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError["a" /* default */].ETIMEDOUT : AxiosError["a" /* default */].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (browser.isStandardBrowserEnv) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || helpers_isURLSameOrigin(fullPath)) && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils["a" /* default */].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils["a" /* default */].isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function onCanceled(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && browser.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError["a" /* default */]('Unsupported protocol ' + protocol + ':', AxiosError["a" /* default */].ERR_BAD_REQUEST, config));
      return;
    }

    // Send the request
    request.send(requestData || null);
  });
});
// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js





var knownAdapters = {
  http: helpers_null["a" /* default */],
  xhr: xhr
};

utils["a" /* default */].forEach(knownAdapters, function (fn, value) {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', { value: value });
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', { value: value });
  }
});

/* harmony default export */ var adapters_adapters = ({
  getAdapter: function getAdapter(adapters) {
    adapters = utils["a" /* default */].isArray(adapters) ? adapters : [adapters];

    var _adapters = adapters,
        length = _adapters.length;

    var nameOrAdapter = void 0;
    var adapter = void 0;

    for (var i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if (adapter = utils["a" /* default */].isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new AxiosError["a" /* default */]('Adapter ' + nameOrAdapter + ' is not supported by the environment', 'ERR_NOT_SUPPORT');
      }

      throw new Error(utils["a" /* default */].hasOwnProp(knownAdapters, nameOrAdapter) ? 'Adapter \'' + nameOrAdapter + '\' is not available in the build' : 'Unknown adapter \'' + nameOrAdapter + '\'');
    }

    if (!utils["a" /* default */].isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});
// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js










/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(config, config.transformRequest);

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  var adapter = adapters_adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(config, config.transformResponse, response);

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, config.transformResponse, reason.response);
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return promise_default.a.reject(reason);
  });
}
// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js






var mergeConfig_headersToObject = function headersToObject(thing) {
  return thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source, caseless) {
    if (utils["a" /* default */].isPlainObject(target) && utils["a" /* default */].isPlainObject(source)) {
      return utils["a" /* default */].merge.call({ caseless: caseless }, target, source);
    } else if (utils["a" /* default */].isPlainObject(source)) {
      return utils["a" /* default */].merge({}, source);
    } else if (utils["a" /* default */].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  var mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: function headers(a, b) {
      return mergeDeepProperties(mergeConfig_headersToObject(a), mergeConfig_headersToObject(b), true);
    }
  };

  utils["a" /* default */].forEach(keys_default()(config1).concat(keys_default()(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(config1[prop], config2[prop], prop);
    utils["a" /* default */].isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });

  return config;
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
var VERSION = "1.3.4";
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js







var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators[type] = function validator(thing) {
    return (typeof thing === 'undefined' ? 'undefined' : typeof_default()(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function (value, opt, opts) {
    if (validator === false) {
      throw new AxiosError["a" /* default */](formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), AxiosError["a" /* default */].ERR_DEPRECATED);
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if ((typeof options === 'undefined' ? 'undefined' : typeof_default()(options)) !== 'object') {
    throw new AxiosError["a" /* default */]('options must be an object', AxiosError["a" /* default */].ERR_BAD_OPTION_VALUE);
  }
  var keys = keys_default()(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError["a" /* default */]('option ' + opt + ' must be ' + result, AxiosError["a" /* default */].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError["a" /* default */]('Unknown option ' + opt, AxiosError["a" /* default */].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var helpers_validator = ({
  assertOptions: assertOptions,
  validators: validators
});
// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js














var Axios_validators = helpers_validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */

var Axios_Axios = function () {
  function Axios(instanceConfig) {
    classCallCheck_default()(this, Axios);

    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */


  createClass_default()(Axios, [{
    key: 'request',
    value: function request(configOrUrl, config) {
      /*eslint no-param-reassign:0*/
      // Allow for axios('example/url'[, config]) a la fetch API
      if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }

      config = mergeConfig(this.defaults, config);

      var _config = config,
          transitional = _config.transitional,
          paramsSerializer = _config.paramsSerializer,
          headers = _config.headers;


      if (transitional !== undefined) {
        helpers_validator.assertOptions(transitional, {
          silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
          forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
          clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
        }, false);
      }

      if (paramsSerializer !== undefined) {
        helpers_validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }

      // Set config.method
      config.method = (config.method || this.defaults.method || 'get').toLowerCase();

      var contextHeaders = void 0;

      // Flatten headers
      contextHeaders = headers && utils["a" /* default */].merge(headers.common, headers[config.method]);

      contextHeaders && utils["a" /* default */].forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function (method) {
        delete headers[method];
      });

      config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

      // filter out skipped interceptors
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
          return;
        }

        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });

      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });

      var promise = void 0;
      var i = 0;
      var len = void 0;

      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest.bind(this), undefined];
        chain.unshift.apply(chain, requestInterceptorChain);
        chain.push.apply(chain, responseInterceptorChain);
        len = chain.length;

        promise = promise_default.a.resolve(config);

        while (i < len) {
          promise = promise.then(chain[i++], chain[i++]);
        }

        return promise;
      }

      len = requestInterceptorChain.length;

      var newConfig = config;

      i = 0;

      while (i < len) {
        var onFulfilled = requestInterceptorChain[i++];
        var onRejected = requestInterceptorChain[i++];
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected.call(this, error);
          break;
        }
      }

      try {
        promise = dispatchRequest.call(this, newConfig);
      } catch (error) {
        return promise_default.a.reject(error);
      }

      i = 0;
      len = responseInterceptorChain.length;

      while (i < len) {
        promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
      }

      return promise;
    }
  }, {
    key: 'getUri',
    value: function getUri(config) {
      config = mergeConfig(this.defaults, config);
      var fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    }
  }]);

  return Axios;
}();

// Provide aliases for supported request methods


utils["a" /* default */].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios_Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils["a" /* default */].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios_Axios.prototype[method] = generateHTTPMethod();

  Axios_Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios_Axios);
// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js







/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */

var CancelToken_CancelToken = function () {
  function CancelToken(executor) {
    classCallCheck_default()(this, CancelToken);

    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    var resolvePromise = void 0;

    this.promise = new promise_default.a(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    var token = this;

    // eslint-disable-next-line func-names
    this.promise.then(function (cancel) {
      if (!token._listeners) return;

      var i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = function (onfulfilled) {
      var _resolve = void 0;
      // eslint-disable-next-line func-names
      var promise = new promise_default.a(function (resolve) {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */


  createClass_default()(CancelToken, [{
    key: 'throwIfRequested',
    value: function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    }

    /**
     * Subscribe to the cancel signal
     */

  }, {
    key: 'subscribe',
    value: function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }

      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    }

    /**
     * Unsubscribe from the cancel signal
     */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    }

    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */

  }], [{
    key: 'source',
    value: function source() {
      var cancel = void 0;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token: token,
        cancel: cancel
      };
    }
  }]);

  return CancelToken;
}();

/* harmony default export */ var cancel_CancelToken = (CancelToken_CancelToken);
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */

function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils["a" /* default */].isObject(payload) && payload.isAxiosError === true;
}
// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js


var HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};

entries_default()(HttpStatusCode).forEach(function (_ref) {
  var _ref2 = slicedToArray_default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);
// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new core_Axios(defaultConfig);
  var instance = Object(bind["a" /* default */])(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils["a" /* default */].extend(instance, core_Axios.prototype, context, { allOwnKeys: true });

  // Copy context to instance
  utils["a" /* default */].extend(instance, context, null, { allOwnKeys: true });

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData["a" /* default */];

// Expose AxiosError class
axios.AxiosError = AxiosError["a" /* default */];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return promise_default.a.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = function (thing) {
  return helpers_formDataToJSON(utils["a" /* default */].isHTMLForm(thing) ? new FormData(thing) : thing);
};

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);
// CONCATENATED MODULE: ./node_modules/axios/index.js
/* unused harmony export Axios */
/* unused harmony export AxiosError */
/* unused harmony export CanceledError */
/* unused harmony export isCancel */
/* unused harmony export CancelToken */
/* unused harmony export VERSION */
/* unused harmony export all */
/* unused harmony export Cancel */
/* unused harmony export isAxiosError */
/* unused harmony export spread */
/* unused harmony export toFormData */
/* unused harmony export AxiosHeaders */
/* unused harmony export HttpStatusCode */
/* unused harmony export formToJSON */
/* unused harmony export mergeConfig */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return lib_axios; });


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var axios_Axios = lib_axios.Axios,
    axios_AxiosError = lib_axios.AxiosError,
    axios_CanceledError = lib_axios.CanceledError,
    axios_isCancel = lib_axios.isCancel,
    axios_CancelToken = lib_axios.CancelToken,
    axios_VERSION = lib_axios.VERSION,
    axios_all = lib_axios.all,
    Cancel = lib_axios.Cancel,
    axios_isAxiosError = lib_axios.isAxiosError,
    axios_spread = lib_axios.spread,
    axios_toFormData = lib_axios.toFormData,
    axios_AxiosHeaders = lib_axios.AxiosHeaders,
    axios_HttpStatusCode = lib_axios.HttpStatusCode,
    formToJSON = lib_axios.formToJSON,
    axios_mergeConfig = lib_axios.mergeConfig;




/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("qkKv"), __esModule: true };

/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "n0T6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Ibhu");
var hiddenKeys = __webpack_require__("xnc9").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "n6Wb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/vux/src/plugins/wechat/1.3.2.js

var wx = void 0;
!function (e, n) {
  wx = n(e);
}(window, function (e, n) {
  function i(n, i, t) {
    e.WeixinJSBridge ? WeixinJSBridge.invoke(n, o(i), function (e) {
      c(n, e, t);
    }) : u(n, t);
  }

  function t(n, i, t) {
    e.WeixinJSBridge ? WeixinJSBridge.on(n, function (e) {
      t && t.trigger && t.trigger(e), c(n, e, i);
    }) : t ? u(n, t) : u(n, i);
  }

  function o(e) {
    return e = e || {}, e.appId = C.appId, e.verifyAppId = C.appId, e.verifySignType = "sha1", e.verifyTimestamp = C.timestamp + "", e.verifyNonceStr = C.nonceStr, e.verifySignature = C.signature, e;
  }

  function r(e) {
    return {
      timeStamp: e.timestamp + "",
      nonceStr: e.nonceStr,
      package: e.package,
      paySign: e.paySign,
      signType: e.signType || "SHA1"
    };
  }

  function a(e) {
    return e.postalCode = e.addressPostalCode, delete e.addressPostalCode, e.provinceName = e.proviceFirstStageName, delete e.proviceFirstStageName, e.cityName = e.addressCitySecondStageName, delete e.addressCitySecondStageName, e.countryName = e.addressCountiesThirdStageName, delete e.addressCountiesThirdStageName, e.detailInfo = e.addressDetailInfo, delete e.addressDetailInfo, e;
  }

  function c(e, n, i) {
    "openEnterpriseChat" == e && (n.errCode = n.err_code), delete n.err_code, delete n.err_desc, delete n.err_detail;
    var t = n.errMsg;
    t || (t = n.err_msg, delete n.err_msg, t = s(e, t), n.errMsg = t), (i = i || {})._complete && (i._complete(n), delete i._complete), t = n.errMsg || "", C.debug && !i.isInnerInvoke && alert(stringify_default()(n));
    var o = t.indexOf(":");
    switch (t.substring(o + 1)) {
      case "ok":
        i.success && i.success(n);
        break;
      case "cancel":
        i.cancel && i.cancel(n);
        break;
      default:
        i.fail && i.fail(n);
    }
    i.complete && i.complete(n);
  }

  function s(e, n) {
    var i = e,
        t = v[i];
    t && (i = t);
    var o = "ok";
    if (n) {
      var r = n.indexOf(":");
      "confirm" == (o = n.substring(r + 1)) && (o = "ok"), "failed" == o && (o = "fail"), -1 != o.indexOf("failed_") && (o = o.substring(7)), -1 != o.indexOf("fail_") && (o = o.substring(5)), "access denied" != (o = (o = o.replace(/_/g, " ")).toLowerCase()) && "no permission to execute" != o || (o = "permission denied"), "config" == i && "function not exist" == o && (o = "ok"), "" == o && (o = "fail");
    }
    return n = i + ":" + o;
  }

  function d(e) {
    if (e) {
      for (var n = 0, i = e.length; n < i; ++n) {
        var t = e[n],
            o = h[t];
        o && (e[n] = o);
      }
      return e;
    }
  }

  function u(e, n) {
    if (!(!C.debug || n && n.isInnerInvoke)) {
      var i = v[e];
      i && (e = i), n && n._complete && delete n._complete, console.log('"' + e + '",', n || "");
    }
  }

  function l(e) {
    if (!(w || T || C.debug || x < "6.0.2" || A.systemType < 0)) {
      var n = new Image();
      A.appId = C.appId, A.initTime = V.initEndTime - V.initStartTime, A.preVerifyTime = V.preVerifyEndTime - V.preVerifyStartTime, N.getNetworkType({
        isInnerInvoke: !0,
        success: function success(e) {
          A.networkType = e.networkType;
          var i = "https://open.weixin.qq.com/sdk/report?v=" + A.version + "&o=" + A.isPreVerifyOk + "&s=" + A.systemType + "&c=" + A.clientVersion + "&a=" + A.appId + "&n=" + A.networkType + "&i=" + A.initTime + "&p=" + A.preVerifyTime + "&u=" + A.url;
          n.src = i;
        }
      });
    }
  }

  function p() {
    return new Date().getTime();
  }

  function f(n) {
    k && (e.WeixinJSBridge ? "preInject" === I.__wxjsjs__isPreInject ? I.addEventListener && I.addEventListener("WeixinJSBridgeReady", n, !1) : n() : I.addEventListener && I.addEventListener("WeixinJSBridgeReady", n, !1));
  }

  function m() {
    N.invoke || (N.invoke = function (n, i, t) {
      e.WeixinJSBridge && WeixinJSBridge.invoke(n, o(i), t);
    }, N.on = function (n, i) {
      e.WeixinJSBridge && WeixinJSBridge.on(n, i);
    });
  }

  function g(e) {
    if ("string" == typeof e && e.length > 0) {
      var n = e.split("?")[0],
          i = e.split("?")[1];
      return n += ".html", void 0 !== i ? n + "?" + i : n;
    }
  }
  if (!e.jWeixin) {
    var h = {
      config: "preVerifyJSAPI",
      onMenuShareTimeline: "menu:share:timeline",
      onMenuShareAppMessage: "menu:share:appmessage",
      onMenuShareQQ: "menu:share:qq",
      onMenuShareWeibo: "menu:share:weiboApp",
      onMenuShareQZone: "menu:share:QZone",
      previewImage: "imagePreview",
      getLocation: "geoLocation",
      openProductSpecificView: "openProductViewWithPid",
      addCard: "batchAddCard",
      openCard: "batchViewCard",
      chooseWXPay: "getBrandWCPayRequest",
      openEnterpriseRedPacket: "getRecevieBizHongBaoRequest",
      startSearchBeacons: "startMonitoringBeacons",
      stopSearchBeacons: "stopMonitoringBeacons",
      onSearchBeacons: "onBeaconsInRange",
      consumeAndShareCard: "consumedShareCard",
      openAddress: "editAddress"
    },
        v = function () {
      var e = {};
      for (var n in h) {
        e[h[n]] = n;
      }return e;
    }(),
        I = e.document,
        S = I.title,
        y = navigator.userAgent.toLowerCase(),
        _ = navigator.platform.toLowerCase(),
        w = !(!_.match("mac") && !_.match("win")),
        T = -1 != y.indexOf("wxdebugger"),
        k = -1 != y.indexOf("micromessenger"),
        M = -1 != y.indexOf("android"),
        P = -1 != y.indexOf("iphone") || -1 != y.indexOf("ipad"),
        x = function () {
      var e = y.match(/micromessenger\/(\d+\.\d+\.\d+)/) || y.match(/micromessenger\/(\d+\.\d+)/);
      return e ? e[1] : "";
    }(),
        V = {
      initStartTime: p(),
      initEndTime: 0,
      preVerifyStartTime: 0,
      preVerifyEndTime: 0
    },
        A = {
      version: 1,
      appId: "",
      initTime: 0,
      preVerifyTime: 0,
      networkType: "",
      isPreVerifyOk: 1,
      systemType: P ? 1 : M ? 2 : -1,
      clientVersion: x,
      url: encodeURIComponent(location.href)
    },
        C = {},
        L = {
      _completes: []
    },
        B = {
      state: 0,
      data: {}
    };
    f(function () {
      V.initEndTime = p();
    });
    var E = !1,
        O = [],
        N = {
      config: function config(e) {
        C = e, u("config", e);
        var n = !1 !== C.check;
        f(function () {
          if (n) i(h.config, {
            verifyJsApiList: d(C.jsApiList)
          }, function () {
            L._complete = function (e) {
              V.preVerifyEndTime = p(), B.state = 1, B.data = e;
            }, L.success = function (e) {
              A.isPreVerifyOk = 0;
            }, L.fail = function (e) {
              L._fail ? L._fail(e) : B.state = -1;
            };
            var e = L._completes;
            return e.push(function () {
              l();
            }), L.complete = function (n) {
              for (var i = 0, t = e.length; i < t; ++i) {
                e[i]();
              }L._completes = [];
            }, L;
          }()), V.preVerifyStartTime = p();else {
            B.state = 1;
            for (var e = L._completes, t = 0, o = e.length; t < o; ++t) {
              e[t]();
            }L._completes = [];
          }
        }), m();
      },
      ready: function ready(e) {
        0 != B.state ? e() : (L._completes.push(e), !k && C.debug && e());
      },
      error: function error(e) {
        x < "6.0.2" || (-1 == B.state ? e(B.data) : L._fail = e);
      },
      checkJsApi: function checkJsApi(e) {
        var n = function n(e) {
          var n = e.checkResult;
          for (var i in n) {
            var t = v[i];
            t && (n[t] = n[i], delete n[i]);
          }
          return e;
        };
        i("checkJsApi", {
          jsApiList: d(e.jsApiList)
        }, (e._complete = function (e) {
          if (M) {
            var i = e.checkResult;
            i && (e.checkResult = JSON.parse(i));
          }
          e = n(e);
        }, e));
      },
      onMenuShareTimeline: function onMenuShareTimeline(e) {
        t(h.onMenuShareTimeline, {
          complete: function complete() {
            i("shareTimeline", {
              title: e.title || S,
              desc: e.title || S,
              img_url: e.imgUrl || "",
              link: e.link || location.href,
              type: e.type || "link",
              data_url: e.dataUrl || ""
            }, e);
          }
        }, e);
      },
      onMenuShareAppMessage: function onMenuShareAppMessage(e) {
        t(h.onMenuShareAppMessage, {
          complete: function complete() {
            i("sendAppMessage", {
              title: e.title || S,
              desc: e.desc || "",
              link: e.link || location.href,
              img_url: e.imgUrl || "",
              type: e.type || "link",
              data_url: e.dataUrl || ""
            }, e);
          }
        }, e);
      },
      onMenuShareQQ: function onMenuShareQQ(e) {
        t(h.onMenuShareQQ, {
          complete: function complete() {
            i("shareQQ", {
              title: e.title || S,
              desc: e.desc || "",
              img_url: e.imgUrl || "",
              link: e.link || location.href
            }, e);
          }
        }, e);
      },
      onMenuShareWeibo: function onMenuShareWeibo(e) {
        t(h.onMenuShareWeibo, {
          complete: function complete() {
            i("shareWeiboApp", {
              title: e.title || S,
              desc: e.desc || "",
              img_url: e.imgUrl || "",
              link: e.link || location.href
            }, e);
          }
        }, e);
      },
      onMenuShareQZone: function onMenuShareQZone(e) {
        t(h.onMenuShareQZone, {
          complete: function complete() {
            i("shareQZone", {
              title: e.title || S,
              desc: e.desc || "",
              img_url: e.imgUrl || "",
              link: e.link || location.href
            }, e);
          }
        }, e);
      },
      startRecord: function startRecord(e) {
        i("startRecord", {}, e);
      },
      stopRecord: function stopRecord(e) {
        i("stopRecord", {}, e);
      },
      onVoiceRecordEnd: function onVoiceRecordEnd(e) {
        t("onVoiceRecordEnd", e);
      },
      playVoice: function playVoice(e) {
        i("playVoice", {
          localId: e.localId
        }, e);
      },
      pauseVoice: function pauseVoice(e) {
        i("pauseVoice", {
          localId: e.localId
        }, e);
      },
      stopVoice: function stopVoice(e) {
        i("stopVoice", {
          localId: e.localId
        }, e);
      },
      onVoicePlayEnd: function onVoicePlayEnd(e) {
        t("onVoicePlayEnd", e);
      },
      uploadVoice: function uploadVoice(e) {
        i("uploadVoice", {
          localId: e.localId,
          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
        }, e);
      },
      downloadVoice: function downloadVoice(e) {
        i("downloadVoice", {
          serverId: e.serverId,
          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
        }, e);
      },
      translateVoice: function translateVoice(e) {
        i("translateVoice", {
          localId: e.localId,
          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
        }, e);
      },
      chooseImage: function chooseImage(e) {
        i("chooseImage", {
          scene: "1|2",
          count: e.count || 9,
          sizeType: e.sizeType || ["original", "compressed"],
          sourceType: e.sourceType || ["album", "camera"]
        }, (e._complete = function (e) {
          if (M) {
            var n = e.localIds;
            n && (e.localIds = JSON.parse(n));
          }
        }, e));
      },
      previewImage: function previewImage(e) {
        i(h.previewImage, {
          current: e.current,
          urls: e.urls
        }, e);
      },
      uploadImage: function uploadImage(e) {
        i("uploadImage", {
          localId: e.localId,
          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
        }, e);
      },
      downloadImage: function downloadImage(e) {
        i("downloadImage", {
          serverId: e.serverId,
          isShowProgressTips: 0 == e.isShowProgressTips ? 0 : 1
        }, e);
      },
      getLocalImgData: function getLocalImgData(e) {
        !1 === E ? (E = !0, i("getLocalImgData", {
          localId: e.localId
        }, (e._complete = function (e) {
          if (E = !1, O.length > 0) {
            var n = O.shift();
            wx.getLocalImgData(n);
          }
        }, e))) : O.push(e);
      },
      getNetworkType: function getNetworkType(e) {
        var n = function n(e) {
          var n = e.errMsg;
          e.errMsg = "getNetworkType:ok";
          var i = e.subtype;
          if (delete e.subtype, i) e.networkType = i;else {
            var t = n.indexOf(":"),
                o = n.substring(t + 1);
            switch (o) {
              case "wifi":
              case "edge":
              case "wwan":
                e.networkType = o;
                break;
              default:
                e.errMsg = "getNetworkType:fail";
            }
          }
          return e;
        };
        i("getNetworkType", {}, (e._complete = function (e) {
          e = n(e);
        }, e));
      },
      openLocation: function openLocation(e) {
        i("openLocation", {
          latitude: e.latitude,
          longitude: e.longitude,
          name: e.name || "",
          address: e.address || "",
          scale: e.scale || 28,
          infoUrl: e.infoUrl || ""
        }, e);
      },
      getLocation: function getLocation(e) {
        e = e || {}, i(h.getLocation, {
          type: e.type || "wgs84"
        }, (e._complete = function (e) {
          delete e.type;
        }, e));
      },
      hideOptionMenu: function hideOptionMenu(e) {
        i("hideOptionMenu", {}, e);
      },
      showOptionMenu: function showOptionMenu(e) {
        i("showOptionMenu", {}, e);
      },
      closeWindow: function closeWindow(e) {
        i("closeWindow", {}, e = e || {});
      },
      hideMenuItems: function hideMenuItems(e) {
        i("hideMenuItems", {
          menuList: e.menuList
        }, e);
      },
      showMenuItems: function showMenuItems(e) {
        i("showMenuItems", {
          menuList: e.menuList
        }, e);
      },
      hideAllNonBaseMenuItem: function hideAllNonBaseMenuItem(e) {
        i("hideAllNonBaseMenuItem", {}, e);
      },
      showAllNonBaseMenuItem: function showAllNonBaseMenuItem(e) {
        i("showAllNonBaseMenuItem", {}, e);
      },
      scanQRCode: function scanQRCode(e) {
        i("scanQRCode", {
          needResult: (e = e || {}).needResult || 0,
          scanType: e.scanType || ["qrCode", "barCode"]
        }, (e._complete = function (e) {
          if (P) {
            var n = e.resultStr;
            if (n) {
              var i = JSON.parse(n);
              e.resultStr = i && i.scan_code && i.scan_code.scan_result;
            }
          }
        }, e));
      },
      openAddress: function openAddress(e) {
        i(h.openAddress, {}, (e._complete = function (e) {
          e = a(e);
        }, e));
      },
      openProductSpecificView: function openProductSpecificView(e) {
        i(h.openProductSpecificView, {
          pid: e.productId,
          view_type: e.viewType || 0,
          ext_info: e.extInfo
        }, e);
      },
      addCard: function addCard(e) {
        for (var n = e.cardList, t = [], o = 0, r = n.length; o < r; ++o) {
          var a = n[o],
              c = {
            card_id: a.cardId,
            card_ext: a.cardExt
          };
          t.push(c);
        }
        i(h.addCard, {
          card_list: t
        }, (e._complete = function (e) {
          var n = e.card_list;
          if (n) {
            for (var i = 0, t = (n = JSON.parse(n)).length; i < t; ++i) {
              var o = n[i];
              o.cardId = o.card_id, o.cardExt = o.card_ext, o.isSuccess = !!o.is_succ, delete o.card_id, delete o.card_ext, delete o.is_succ;
            }
            e.cardList = n, delete e.card_list;
          }
        }, e));
      },
      chooseCard: function chooseCard(e) {
        i("chooseCard", {
          app_id: C.appId,
          location_id: e.shopId || "",
          sign_type: e.signType || "SHA1",
          card_id: e.cardId || "",
          card_type: e.cardType || "",
          card_sign: e.cardSign,
          time_stamp: e.timestamp + "",
          nonce_str: e.nonceStr
        }, (e._complete = function (e) {
          e.cardList = e.choose_card_info, delete e.choose_card_info;
        }, e));
      },
      openCard: function openCard(e) {
        for (var n = e.cardList, t = [], o = 0, r = n.length; o < r; ++o) {
          var a = n[o],
              c = {
            card_id: a.cardId,
            code: a.code
          };
          t.push(c);
        }
        i(h.openCard, {
          card_list: t
        }, e);
      },
      consumeAndShareCard: function consumeAndShareCard(e) {
        i(h.consumeAndShareCard, {
          consumedCardId: e.cardId,
          consumedCode: e.code
        }, e);
      },
      chooseWXPay: function chooseWXPay(e) {
        i(h.chooseWXPay, r(e), e);
      },
      openEnterpriseRedPacket: function openEnterpriseRedPacket(e) {
        i(h.openEnterpriseRedPacket, r(e), e);
      },
      startSearchBeacons: function startSearchBeacons(e) {
        i(h.startSearchBeacons, {
          ticket: e.ticket
        }, e);
      },
      stopSearchBeacons: function stopSearchBeacons(e) {
        i(h.stopSearchBeacons, {}, e);
      },
      onSearchBeacons: function onSearchBeacons(e) {
        t(h.onSearchBeacons, e);
      },
      openEnterpriseChat: function openEnterpriseChat(e) {
        i("openEnterpriseChat", {
          useridlist: e.userIds,
          chatname: e.groupName
        }, e);
      },
      launchMiniProgram: function launchMiniProgram(e) {
        i("launchMiniProgram", {
          targetAppId: e.targetAppId,
          path: g(e.path),
          envVersion: e.envVersion
        }, e);
      },
      miniProgram: {
        navigateBack: function navigateBack(e) {
          e = e || {}, f(function () {
            i("invokeMiniProgramAPI", {
              name: "navigateBack",
              arg: {
                delta: e.delta || 1
              }
            }, e);
          });
        },
        navigateTo: function navigateTo(e) {
          f(function () {
            i("invokeMiniProgramAPI", {
              name: "navigateTo",
              arg: {
                url: e.url
              }
            }, e);
          });
        },
        redirectTo: function redirectTo(e) {
          f(function () {
            i("invokeMiniProgramAPI", {
              name: "redirectTo",
              arg: {
                url: e.url
              }
            }, e);
          });
        },
        switchTab: function switchTab(e) {
          f(function () {
            i("invokeMiniProgramAPI", {
              name: "switchTab",
              arg: {
                url: e.url
              }
            }, e);
          });
        },
        reLaunch: function reLaunch(e) {
          f(function () {
            i("invokeMiniProgramAPI", {
              name: "reLaunch",
              arg: {
                url: e.url
              }
            }, e);
          });
        },
        postMessage: function postMessage(e) {
          f(function () {
            i("invokeMiniProgramAPI", {
              name: "postMessage",
              arg: e.data || {}
            }, e);
          });
        },
        getEnv: function getEnv(n) {
          f(function () {
            n({
              miniprogram: "miniprogram" === e.__wxjs_environment
            });
          });
        }
      }
    },
        b = 1,
        R = {};
    return I.addEventListener("error", function (e) {
      if (!M) {
        var n = e.target,
            i = n.tagName,
            t = n.src;
        if (("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i) && -1 != t.indexOf("wxlocalresource://")) {
          e.preventDefault(), e.stopPropagation();
          var o = n["wx-id"];
          if (o || (o = b++, n["wx-id"] = o), R[o]) return;
          R[o] = !0, wx.ready(function () {
            wx.getLocalImgData({
              localId: t,
              success: function success(e) {
                n.src = e.localData;
              }
            });
          });
        }
      }
    }, !0), I.addEventListener("load", function (e) {
      if (!M) {
        var n = e.target,
            i = n.tagName;
        n.src;
        if ("IMG" == i || "VIDEO" == i || "AUDIO" == i || "SOURCE" == i) {
          var t = n["wx-id"];
          t && (R[t] = !1);
        }
      }
    }, !0), n && (e.wx = e.jWeixin = N), N;
  }
});


// CONCATENATED MODULE: ./node_modules/vux/src/plugins/wechat/index.js
/* unused harmony export install */


var wechat_plugin = {
  install: function install(Vue) {
    Vue.prototype.$wechat = wx;
    Vue.wechat = wx;
  },

  $wechat: wx
};

/* harmony default export */ var wechat = __webpack_exports__["a"] = (wechat_plugin);
var wechat_install = wechat_plugin.install;

/***/ }),

/***/ "nror":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default.a);

/***/ }),

/***/ "oM7Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("sF+V");
var $Object = __webpack_require__("FeBl").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "oNmr":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("9Bbf")('Set');


/***/ }),

/***/ "oeOm":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("7Doy");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "p1oW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(options) {
    var getState = options.stateHandler.getState;

    /**
     * Tells if the element has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is detectable or not.
     */
    function isDetectable(element) {
        var state = getState(element);
        return state && !!state.isDetectable;
    }

    /**
     * Marks the element that it has been made detectable and ready to be listened for resize events.
     * @public
     * @param {element} The element to mark.
     */
    function markAsDetectable(element) {
        getState(element).isDetectable = true;
    }

    /**
     * Tells if the element is busy or not.
     * @public
     * @param {element} The element to check.
     * @returns {boolean} True or false depending on if the element is busy or not.
     */
    function isBusy(element) {
        return !!getState(element).busy;
    }

    /**
     * Marks the object is busy and should not be made detectable.
     * @public
     * @param {element} element The element to mark.
     * @param {boolean} busy If the element is busy or not.
     */
    function markBusy(element, busy) {
        getState(element).busy = !!busy;
    }

    return {
        isDetectable: isDetectable,
        markAsDetectable: markAsDetectable,
        isBusy: isBusy,
        markBusy: markBusy
    };
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pPW7":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("M6a0");
__webpack_require__("zQR9");
__webpack_require__("+tPU");
__webpack_require__("ttyz");
__webpack_require__("BDhv");
__webpack_require__("oNmr");
__webpack_require__("ioQ5");
module.exports = __webpack_require__("FeBl").Set;


/***/ }),

/***/ "pRCB":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__("+E39"), 'Object', { defineProperties: __webpack_require__("qio6") });


/***/ }),

/***/ "q3gF":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("JWAb");
module.exports = __webpack_require__("FeBl").Math.trunc;


/***/ }),

/***/ "q5lo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getKey; });
/* unused harmony export getInlineDesc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLabel; });
/* unused harmony export getLabels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var getValue = function getValue(item) {
  return (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.value : item;
};

var getKey = function getKey(item) {
  return (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.key : item;
};

var getInlineDesc = function getInlineDesc(item) {
  return (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item)) === 'object' ? item.inlineDesc : '';
};

var getLabel = function getLabel() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments[1];

  if (!list.length) {
    return value;
  }
  if (typeof list[0] === 'string') {
    return value;
  }
  var match = list.filter(function (one) {
    return one.key === value;
  });
  if (match.length) {
    return match[0].value || match[0].label;
  }
  return value;
};

var getLabels = function getLabels() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return values.map(function (value) {
    return getLabel(list, value);
  });
};

/***/ }),

/***/ "qARP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("lOnJ");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "qCoq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("9C8M");
var validate = __webpack_require__("LIJb");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("qo66")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "qajy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("RJDW"), __esModule: true };

/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "qkKv":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("FeBl");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "qo66":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7KvD");
var $export = __webpack_require__("kM2E");
var meta = __webpack_require__("06OY");
var fails = __webpack_require__("S82l");
var hide = __webpack_require__("hJx8");
var redefineAll = __webpack_require__("xH/j");
var forOf = __webpack_require__("NWt+");
var anInstance = __webpack_require__("2KxR");
var isObject = __webpack_require__("EqjI");
var setToStringTag = __webpack_require__("e6n0");
var dP = __webpack_require__("evD5").f;
var each = __webpack_require__("ALrJ")(0);
var DESCRIPTORS = __webpack_require__("+E39");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "qyJz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("+ZMJ");
var $export = __webpack_require__("kM2E");
var toObject = __webpack_require__("sB3e");
var call = __webpack_require__("msXi");
var isArrayIter = __webpack_require__("Mhyx");
var toLength = __webpack_require__("QRG4");
var createProperty = __webpack_require__("fBQ2");
var getIterFn = __webpack_require__("3fs2");

$export($export.S + $export.F * !__webpack_require__("dY0y")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "rCgY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("jYc2");

/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "s9og":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("fGru"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),

/***/ "sB3e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "sF+V":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("kM2E");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("Yobk") });


/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "sRRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/errors/index.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var QiniuErrorName;
(function (QiniuErrorName) {
    // 输入错误
    QiniuErrorName["InvalidFile"] = "InvalidFile";
    QiniuErrorName["InvalidToken"] = "InvalidToken";
    QiniuErrorName["InvalidMetadata"] = "InvalidMetadata";
    QiniuErrorName["InvalidChunkSize"] = "InvalidChunkSize";
    QiniuErrorName["InvalidCustomVars"] = "InvalidCustomVars";
    QiniuErrorName["NotAvailableUploadHost"] = "NotAvailableUploadHost";
    // 缓存相关
    QiniuErrorName["ReadCacheFailed"] = "ReadCacheFailed";
    QiniuErrorName["InvalidCacheData"] = "InvalidCacheData";
    QiniuErrorName["WriteCacheFailed"] = "WriteCacheFailed";
    QiniuErrorName["RemoveCacheFailed"] = "RemoveCacheFailed";
    // 图片压缩模块相关
    QiniuErrorName["GetCanvasContextFailed"] = "GetCanvasContextFailed";
    QiniuErrorName["UnsupportedFileType"] = "UnsupportedFileType";
    // 运行环境相关
    QiniuErrorName["FileReaderReadFailed"] = "FileReaderReadFailed";
    QiniuErrorName["NotAvailableXMLHttpRequest"] = "NotAvailableXMLHttpRequest";
    QiniuErrorName["InvalidProgressEventTarget"] = "InvalidProgressEventTarget";
    // 请求错误
    QiniuErrorName["RequestError"] = "RequestError";
})(QiniuErrorName || (QiniuErrorName = {}));
var QiniuError = /** @class */ (function () {
    function QiniuError(name, message) {
        this.name = name;
        this.message = message;
        this.stack = new Error().stack;
    }
    return QiniuError;
}());

var QiniuRequestError = /** @class */ (function (_super) {
    __extends(QiniuRequestError, _super);
    function QiniuRequestError(code, reqId, message, data) {
        var _this = _super.call(this, QiniuErrorName.RequestError, message) || this;
        _this.code = code;
        _this.reqId = reqId;
        /**
         * @description 标记当前的 error 类型是一个 QiniuRequestError
         * @deprecated 下一个大版本将会移除，不推荐使用，推荐直接使用 instanceof 进行判断
         */
        _this.isRequestError = true;
        _this.data = data;
        return _this;
    }
    return QiniuRequestError;
}(QiniuError));

/**
 * @description 由于跨域、证书错误、断网、host 解析失败、系统拦截等原因导致的错误
 */
var QiniuNetworkError = /** @class */ (function (_super) {
    __extends(QiniuNetworkError, _super);
    function QiniuNetworkError(message, reqId) {
        if (reqId === void 0) { reqId = ''; }
        return _super.call(this, 0, reqId, message) || this;
    }
    return QiniuNetworkError;
}(QiniuRequestError));

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/pool.js
var Pool = /** @class */ (function () {
    function Pool(runTask, limit) {
        this.runTask = runTask;
        this.limit = limit;
        this.aborted = false;
        this.queue = [];
        this.processing = [];
    }
    Pool.prototype.enqueue = function (task) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queue.push({
                task: task,
                resolve: resolve,
                reject: reject
            });
            _this.check();
        });
    };
    Pool.prototype.run = function (item) {
        var _this = this;
        this.queue = this.queue.filter(function (v) { return v !== item; });
        this.processing.push(item);
        this.runTask(item.task).then(function () {
            _this.processing = _this.processing.filter(function (v) { return v !== item; });
            item.resolve();
            _this.check();
        }, function (err) { return item.reject(err); });
    };
    Pool.prototype.check = function () {
        var _this = this;
        if (this.aborted)
            return;
        var processingNum = this.processing.length;
        var availableNum = this.limit - processingNum;
        this.queue.slice(0, availableNum).forEach(function (item) {
            _this.run(item);
        });
    };
    Pool.prototype.abort = function () {
        this.queue = [];
        this.aborted = true;
    };
    return Pool;
}());

//# sourceMappingURL=pool.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/observable.js
var observable___extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** 表示可清理的资源，比如 Observable 的执行 */
var Subscription = /** @class */ (function () {
    function Subscription() {
        /** 用来标示该 Subscription 是否被取消订阅的标示位 */
        this.closed = false;
    }
    /** 取消 observer 的订阅 */
    Subscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    };
    /** 添加一个 tear down 在该 Subscription 的 unsubscribe() 期间调用 */
    Subscription.prototype.add = function (teardown) {
        this._unsubscribe = teardown;
    };
    return Subscription;
}());
/**
 * 实现 Observer 接口并且继承 Subscription 类，Observer 是消费 Observable 值的公有 API
 * 所有 Observers 都转化成了 Subscriber，以便提供类似 Subscription 的能力，比如 unsubscribe
*/
var Subscriber = /** @class */ (function (_super) {
    observable___extends(Subscriber, _super);
    function Subscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (observerOrNext && typeof observerOrNext === 'object') {
            _this.destination = observerOrNext;
        }
        else {
            _this.destination = __assign(__assign(__assign({}, observerOrNext && { next: observerOrNext }), error && { error: error }), complete && { complete: complete });
        }
        return _this;
    }
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped && this.destination.next) {
            this.destination.next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped && this.destination.error) {
            this.isStopped = true;
            this.destination.error(err);
        }
    };
    Subscriber.prototype.complete = function (result) {
        if (!this.isStopped && this.destination.complete) {
            this.isStopped = true;
            this.destination.complete(result);
        }
    };
    return Subscriber;
}(Subscription));

/** 可观察对象，当前的上传事件的集合 */
var Observable = /** @class */ (function () {
    function Observable(_subscribe) {
        this._subscribe = _subscribe;
    }
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var sink = new Subscriber(observerOrNext, error, complete);
        sink.add(this._subscribe(sink));
        return sink;
    };
    return Observable;
}());

//# sourceMappingURL=observable.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/base64.js
/* eslint-disable */
// https://github.com/locutusjs/locutus/blob/master/src/php/xml/utf8_encode.js
function utf8Encode(argString) {
    // http://kevin.vanzonneveld.net
    // +   original by: Webtoolkit.info (http://www.webtoolkit.info/)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: sowberry
    // +    tweaked by: Jack
    // +   bugfixed by: Onno Marsman
    // +   improved by: Yves Sucaet
    // +   bugfixed by: Onno Marsman
    // +   bugfixed by: Ulrich
    // +   bugfixed by: Rafal Kukawski
    // +   improved by: kirilloid
    // +   bugfixed by: kirilloid
    // *     example 1: this.utf8Encode('Kevin van Zonneveld')
    // *     returns 1: 'Kevin van Zonneveld'
    if (argString === null || typeof argString === 'undefined') {
        return '';
    }
    var string = argString + ''; // .replace(/\r\n/g, '\n').replace(/\r/g, '\n')
    var utftext = '', start, end, stringl = 0;
    start = end = 0;
    stringl = string.length;
    for (var n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) {
            end++;
        }
        else if (c1 > 127 && c1 < 2048) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        }
        else if ((c1 & 0xf800 ^ 0xd800) > 0) {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        else {
            // surrogate pairs
            if ((c1 & 0xfc00 ^ 0xd800) > 0) {
                throw new RangeError('Unmatched trail surrogate at ' + n);
            }
            var c2 = string.charCodeAt(++n);
            if ((c2 & 0xfc00 ^ 0xdc00) > 0) {
                throw new RangeError('Unmatched lead surrogate at ' + (n - 1));
            }
            c1 = ((c1 & 0x3ff) << 10) + (c2 & 0x3ff) + 0x10000;
            enc = String.fromCharCode((c1 >> 18) | 240, ((c1 >> 12) & 63) | 128, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.slice(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) {
        utftext += string.slice(start, stringl);
    }
    return utftext;
}
// https://github.com/locutusjs/locutus/blob/master/src/php/xml/utf8_decode.js
function utf8Decode(strData) {
    // eslint-disable-line camelcase
    //  discuss at: https://locutus.io/php/utf8_decode/
    // original by: Webtoolkit.info (https://www.webtoolkit.info/)
    //    input by: Aman Gupta
    //    input by: Brett Zamir (https://brett-zamir.me)
    // improved by: Kevin van Zonneveld (https://kvz.io)
    // improved by: Norman "zEh" Fuchs
    // bugfixed by: hitwork
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    // bugfixed by: Kevin van Zonneveld (https://kvz.io)
    // bugfixed by: kirilloid
    // bugfixed by: w35l3y (https://www.wesley.eti.br)
    //   example 1: utf8_decode('Kevin van Zonneveld')
    //   returns 1: 'Kevin van Zonneveld'
    var tmpArr = [];
    var i = 0;
    var c1 = 0;
    var seqlen = 0;
    strData += '';
    while (i < strData.length) {
        c1 = strData.charCodeAt(i) & 0xFF;
        seqlen = 0;
        // https://en.wikipedia.org/wiki/UTF-8#Codepage_layout
        if (c1 <= 0xBF) {
            c1 = (c1 & 0x7F);
            seqlen = 1;
        }
        else if (c1 <= 0xDF) {
            c1 = (c1 & 0x1F);
            seqlen = 2;
        }
        else if (c1 <= 0xEF) {
            c1 = (c1 & 0x0F);
            seqlen = 3;
        }
        else {
            c1 = (c1 & 0x07);
            seqlen = 4;
        }
        for (var ai = 1; ai < seqlen; ++ai) {
            c1 = ((c1 << 0x06) | (strData.charCodeAt(ai + i) & 0x3F));
        }
        if (seqlen === 4) {
            c1 -= 0x10000;
            tmpArr.push(String.fromCharCode(0xD800 | ((c1 >> 10) & 0x3FF)));
            tmpArr.push(String.fromCharCode(0xDC00 | (c1 & 0x3FF)));
        }
        else {
            tmpArr.push(String.fromCharCode(c1));
        }
        i += seqlen;
    }
    return tmpArr.join('');
}
function base64Encode(data) {
    // http://kevin.vanzonneveld.net
    // +   original by: Tyler Akins (http://rumkin.com)
    // +   improved by: Bayron Guevara
    // +   improved by: Thunder.m
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Pellentesque Malesuada
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // -    depends on: this.utf8Encode
    // *     example 1: this.base64Encode('Kevin van Zonneveld')
    // *     returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
    // mozilla has this native
    // - but breaks in 2.0.0.12!
    // if (typeof this.window['atob'] == 'function') {
    //    return atob(data)
    // }
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) {
        return data;
    }
    data = utf8Encode(data + '');
    do {
        // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] =
            b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);
    enc = tmp_arr.join('');
    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
}
function base64Decode(data) {
    // http://kevin.vanzonneveld.net
    // +   original by: Tyler Akins (http://rumkin.com)
    // +   improved by: Thunder.m
    // +      input by: Aman Gupta
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman
    // +   bugfixed by: Pellentesque Malesuada
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
    // *     returns 1: 'Kevin van Zonneveld'
    // mozilla has this native
    // - but breaks in 2.0.0.12!
    // if (typeof this.window['atob'] == 'function') {
    //    return atob(data)
    // }
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, dec = '', tmp_arr = [];
    if (!data) {
        return data;
    }
    data += '';
    do { // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));
        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;
        if (h3 === 64) {
            tmp_arr[ac++] = String.fromCharCode(o1);
        }
        else if (h4 === 64) {
            tmp_arr[ac++] = String.fromCharCode(o1, o2);
        }
        else {
            tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
        }
    } while (i < data.length);
    dec = tmp_arr.join('');
    return utf8Decode(dec);
}
function urlSafeBase64Encode(v) {
    v = base64Encode(v);
    // 参考 https://tools.ietf.org/html/rfc4648#section-5
    return v.replace(/\//g, '_').replace(/\+/g, '-');
}
function urlSafeBase64Decode(v) {
    v = v.replace(/_/g, '/').replace(/-/g, '+');
    return base64Decode(v);
}
//# sourceMappingURL=base64.js.map
// EXTERNAL MODULE: ./node_modules/spark-md5/spark-md5.js
var spark_md5 = __webpack_require__("JSQk");
var spark_md5_default = /*#__PURE__*/__webpack_require__.n(spark_md5);

// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/helper.js
var helper___assign = (this && this.__assign) || function () {
    helper___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return helper___assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var MB = Math.pow(1024, 2);
// 文件分块
function getChunks(file, blockSize) {
    var chunkByteSize = blockSize * MB; // 转换为字节
    // 如果 chunkByteSize 比文件大，则直接取文件的大小
    if (chunkByteSize > file.size) {
        chunkByteSize = file.size;
    }
    else {
        // 因为最多 10000 chunk，所以如果 chunkSize 不符合则把每片 chunk 大小扩大两倍
        while (file.size > chunkByteSize * 10000) {
            chunkByteSize *= 2;
        }
    }
    var chunks = [];
    var count = Math.ceil(file.size / chunkByteSize);
    for (var i = 0; i < count; i++) {
        var chunk = file.slice(chunkByteSize * i, i === count - 1 ? file.size : chunkByteSize * (i + 1));
        chunks.push(chunk);
    }
    return chunks;
}
function isMetaDataValid(params) {
    return Object.keys(params).every(function (key) { return key.indexOf('x-qn-meta-') === 0; });
}
function isCustomVarsValid(params) {
    return Object.keys(params).every(function (key) { return key.indexOf('x:') === 0; });
}
function sum(list) {
    return list.reduce(function (data, loaded) { return data + loaded; }, 0);
}
function setLocalFileInfo(localKey, info, logger) {
    try {
        localStorage.setItem(localKey, JSON.stringify(info));
    }
    catch (err) {
        logger.warn(new QiniuError(QiniuErrorName.WriteCacheFailed, "setLocalFileInfo failed: " + localKey));
    }
}
function createLocalKey(name, key, size) {
    var localKey = key == null ? '_' : "_key_" + key + "_";
    return "qiniu_js_sdk_upload_file_name_" + name + localKey + "size_" + size;
}
function removeLocalFileInfo(localKey, logger) {
    try {
        localStorage.removeItem(localKey);
    }
    catch (err) {
        logger.warn(new QiniuError(QiniuErrorName.RemoveCacheFailed, "removeLocalFileInfo failed. key: " + localKey));
    }
}
function getLocalFileInfo(localKey, logger) {
    var localInfoString = null;
    try {
        localInfoString = localStorage.getItem(localKey);
    }
    catch (_a) {
        logger.warn(new QiniuError(QiniuErrorName.ReadCacheFailed, "getLocalFileInfo failed. key: " + localKey));
    }
    if (localInfoString == null) {
        return null;
    }
    var localInfo = null;
    try {
        localInfo = JSON.parse(localInfoString);
    }
    catch (_b) {
        // 本地信息已被破坏，直接删除
        removeLocalFileInfo(localKey, logger);
        logger.warn(new QiniuError(QiniuErrorName.InvalidCacheData, "getLocalFileInfo failed to parse. key: " + localKey));
    }
    return localInfo;
}
function getAuthHeaders(token) {
    var auth = 'UpToken ' + token;
    return { Authorization: auth };
}
function getHeadersForChunkUpload(token) {
    var header = getAuthHeaders(token);
    return helper___assign({ 'content-type': 'application/octet-stream' }, header);
}
function getHeadersForMkFile(token) {
    var header = getAuthHeaders(token);
    return helper___assign({ 'content-type': 'application/json' }, header);
}
function createXHR() {
    if (window.XMLHttpRequest) {
        return new XMLHttpRequest();
    }
    if (window.ActiveXObject) {
        return new window.ActiveXObject('Microsoft.XMLHTTP');
    }
    throw new QiniuError(QiniuErrorName.NotAvailableXMLHttpRequest, 'the current environment does not support.');
}
function computeMd5(data) {
    return __awaiter(this, void 0, void 0, function () {
        var buffer, spark;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, readAsArrayBuffer(data)];
                case 1:
                    buffer = _a.sent();
                    spark = new spark_md5_default.a.ArrayBuffer();
                    spark.append(buffer);
                    return [2 /*return*/, spark.end()];
            }
        });
    });
}
function readAsArrayBuffer(data) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        // evt 类型目前存在问题 https://github.com/Microsoft/TypeScript/issues/4163
        reader.onload = function (evt) {
            if (evt.target) {
                var body = evt.target.result;
                resolve(body);
            }
            else {
                reject(new QiniuError(QiniuErrorName.InvalidProgressEventTarget, 'progress event target is undefined'));
            }
        };
        reader.onerror = function () {
            reject(new QiniuError(QiniuErrorName.FileReaderReadFailed, 'fileReader read failed'));
        };
        reader.readAsArrayBuffer(data);
    });
}
function request(url, options) {
    return new Promise(function (resolve, reject) {
        var xhr = createXHR();
        xhr.open(options.method, url);
        if (options.onCreate) {
            options.onCreate(xhr);
        }
        if (options.headers) {
            var headers_1 = options.headers;
            Object.keys(headers_1).forEach(function (k) {
                xhr.setRequestHeader(k, headers_1[k]);
            });
        }
        xhr.upload.addEventListener('progress', function (evt) {
            if (evt.lengthComputable && options.onProgress) {
                options.onProgress({
                    loaded: evt.loaded,
                    total: evt.total
                });
            }
        });
        xhr.onreadystatechange = function () {
            var responseText = xhr.responseText;
            if (xhr.readyState !== 4) {
                return;
            }
            var reqId = xhr.getResponseHeader('x-reqId') || '';
            if (xhr.status === 0) {
                // 发生 0 基本都是网络错误，常见的比如跨域、断网、host 解析失败、系统拦截等等
                reject(new QiniuNetworkError('network error.', reqId));
                return;
            }
            if (xhr.status !== 200) {
                var message = "xhr request failed, code: " + xhr.status;
                if (responseText) {
                    message += " response: " + responseText;
                }
                var data = void 0;
                try {
                    data = JSON.parse(responseText);
                }
                catch (_a) {
                    // 无需处理该错误、可能拿到非 json 格式的响应是预期的
                }
                reject(new QiniuRequestError(xhr.status, reqId, message, data));
                return;
            }
            try {
                resolve({
                    data: JSON.parse(responseText),
                    reqId: reqId
                });
            }
            catch (err) {
                reject(err);
            }
        };
        xhr.send(options.body);
    });
}
function getPortFromUrl(url) {
    if (url && url.match) {
        var groups = url.match(/(^https?)/);
        if (!groups) {
            return '';
        }
        var type = groups[1];
        groups = url.match(/^https?:\/\/([^:^/]*):(\d*)/);
        if (groups) {
            return groups[2];
        }
        if (type === 'http') {
            return '80';
        }
        return '443';
    }
    return '';
}
function getDomainFromUrl(url) {
    if (url && url.match) {
        var groups = url.match(/^https?:\/\/([^:^/]*)/);
        return groups ? groups[1] : '';
    }
    return '';
}
function getPutPolicy(token) {
    if (!token)
        throw new QiniuError(QiniuErrorName.InvalidToken, 'invalid token.');
    var segments = token.split(':');
    if (segments.length === 1)
        throw new QiniuError(QiniuErrorName.InvalidToken, 'invalid token segments.');
    // token 构造的差异参考：https://github.com/qbox/product/blob/master/kodo/auths/UpToken.md#admin-uptoken-authorization
    var assessKey = segments.length > 3 ? segments[1] : segments[0];
    if (!assessKey)
        throw new QiniuError(QiniuErrorName.InvalidToken, 'missing assess key field.');
    var putPolicy = null;
    try {
        putPolicy = JSON.parse(urlSafeBase64Decode(segments[segments.length - 1]));
    }
    catch (error) {
        throw new QiniuError(QiniuErrorName.InvalidToken, 'token parse failed.');
    }
    if (putPolicy == null) {
        throw new QiniuError(QiniuErrorName.InvalidToken, 'putPolicy is null.');
    }
    if (putPolicy.scope == null) {
        throw new QiniuError(QiniuErrorName.InvalidToken, 'scope field is null.');
    }
    var bucketName = putPolicy.scope.split(':')[0];
    if (!bucketName) {
        throw new QiniuError(QiniuErrorName.InvalidToken, 'resolve bucketName failed.');
    }
    return { assessKey: assessKey, bucketName: bucketName, scope: putPolicy.scope };
}
function createObjectURL(file) {
    var URL = window.URL || window.webkitURL || window.mozURL;
    // FIXME:  需要 revokeObjectURL
    return URL.createObjectURL(file);
}
//# sourceMappingURL=helper.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/config/region.js
var region__a;
/** 上传区域 */
var region = {
    z0: 'z0',
    z1: 'z1',
    z2: 'z2',
    na0: 'na0',
    as0: 'as0',
    cnEast2: 'cn-east-2'
};
/** 上传区域对应的 host */
var regionUphostMap = (region__a = {},
    region__a[region.z0] = {
        srcUphost: ['up.qiniup.com'],
        cdnUphost: ['upload.qiniup.com']
    },
    region__a[region.z1] = {
        srcUphost: ['up-z1.qiniup.com'],
        cdnUphost: ['upload-z1.qiniup.com']
    },
    region__a[region.z2] = {
        srcUphost: ['up-z2.qiniup.com'],
        cdnUphost: ['upload-z2.qiniup.com']
    },
    region__a[region.na0] = {
        srcUphost: ['up-na0.qiniup.com'],
        cdnUphost: ['upload-na0.qiniup.com']
    },
    region__a[region.as0] = {
        srcUphost: ['up-as0.qiniup.com'],
        cdnUphost: ['upload-as0.qiniup.com']
    },
    region__a[region.cnEast2] = {
        srcUphost: ['up-cn-east-2.qiniup.com'],
        cdnUphost: ['upload-cn-east-2.qiniup.com']
    },
    region__a);
//# sourceMappingURL=region.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/config/index.js

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("1nuA");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/api/index.js
var api___assign = (this && this.__assign) || function () {
    api___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return api___assign.apply(this, arguments);
};
var api___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var api___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function getUpHosts(accessKey, bucketName, protocol) {
    return api___awaiter(this, void 0, void 0, function () {
        var params, url;
        return api___generator(this, function (_a) {
            params = Object(querystring_es3["stringify"])({ ak: accessKey, bucket: bucketName });
            url = protocol + "://api.qiniu.com/v2/query?" + params;
            return [2 /*return*/, request(url, { method: 'GET' })];
        });
    });
}
/**
 * @param bucket 空间名
 * @param key 目标文件名
 * @param uploadInfo 上传信息
 */
function getBaseUrl(bucket, key, uploadInfo) {
    var url = uploadInfo.url, id = uploadInfo.id;
    return url + "/buckets/" + bucket + "/objects/" + (key != null ? urlSafeBase64Encode(key) : '~') + "/uploads/" + id;
}
/**
 * @param token 上传鉴权凭证
 * @param bucket 上传空间
 * @param key 目标文件名
 * @param uploadUrl 上传地址
 */
function initUploadParts(token, bucket, key, uploadUrl) {
    var url = uploadUrl + "/buckets/" + bucket + "/objects/" + (key != null ? urlSafeBase64Encode(key) : '~') + "/uploads";
    return request(url, {
        method: 'POST',
        headers: getAuthHeaders(token)
    });
}
/**
 * @param token 上传鉴权凭证
 * @param index 当前 chunk 的索引
 * @param uploadInfo 上传信息
 * @param options 请求参数
 */
function uploadChunk(token, key, index, uploadInfo, options) {
    var bucket = getPutPolicy(token).bucketName;
    var url = getBaseUrl(bucket, key, uploadInfo) + ("/" + index);
    var headers = getHeadersForChunkUpload(token);
    if (options.md5)
        headers['Content-MD5'] = options.md5;
    return request(url, api___assign(api___assign({}, options), { method: 'PUT', headers: headers }));
}
/**
 * @param token 上传鉴权凭证
 * @param key 目标文件名
 * @param uploadInfo 上传信息
 * @param options 请求参数
 */
function uploadComplete(token, key, uploadInfo, options) {
    var bucket = getPutPolicy(token).bucketName;
    var url = getBaseUrl(bucket, key, uploadInfo);
    return request(url, api___assign(api___assign({}, options), { method: 'POST', headers: getHeadersForMkFile(token) }));
}
/**
 * @param token 上传鉴权凭证
 * @param key 目标文件名
 * @param uploadInfo 上传信息
 */
function deleteUploadedChunks(token, key, uploadinfo) {
    var bucket = getPutPolicy(token).bucketName;
    var url = getBaseUrl(bucket, key, uploadinfo);
    return request(url, {
        method: 'DELETE',
        headers: getAuthHeaders(token)
    });
}
/**
 * @param  {string} url
 * @param  {FormData} data
 * @param  {Partial<utils.RequestOptions>} options
 * @returns Promise
 * @description 直传接口
 */
function direct(url, data, options) {
    return request(url, api___assign({ method: 'POST', body: data }, options));
}
/**
 * @param  {UploadUrlConfig} config
 * @param  {string} token
 * @returns Promise
 * @description 获取上传 url
 */
function getUploadUrl(_config, token) {
    return api___awaiter(this, void 0, void 0, function () {
        var config, protocol, putPolicy, res, hosts;
        return api___generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = normalizeUploadConfig(_config);
                    protocol = config.upprotocol;
                    if (config.uphost.length > 0) {
                        return [2 /*return*/, protocol + "://" + config.uphost[0]];
                    }
                    putPolicy = getPutPolicy(token);
                    return [4 /*yield*/, getUpHosts(putPolicy.assessKey, putPolicy.bucketName, protocol)];
                case 1:
                    res = _a.sent();
                    hosts = res.data.up.acc.main;
                    return [2 /*return*/, protocol + "://" + hosts[0]];
            }
        });
    });
}
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/upload/base.js
var base___assign = (this && this.__assign) || function () {
    base___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return base___assign.apply(this, arguments);
};
var base___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var base___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


var DEFAULT_CHUNK_SIZE = 4; // 单位 MB
// code 信息地址 https://developer.qiniu.com/kodo/3928/error-responses
var FREEZE_CODE_LIST = [0, 502, 503, 504, 599]; // 将会冻结当前 host 的 code
var RETRY_CODE_LIST = __spread(FREEZE_CODE_LIST, [612]); // 会进行重试的 code
var GB = Math.pow(1024, 3);
var base_Base = /** @class */ (function () {
    function Base(options, handlers, hostPool, logger) {
        this.hostPool = hostPool;
        this.logger = logger;
        this.aborted = false;
        this.retryCount = 0;
        this.xhrList = [];
        this.config = options.config;
        logger.info('config inited.', this.config);
        this.putExtra = base___assign({ fname: '' }, options.putExtra);
        logger.info('putExtra inited.', this.putExtra);
        this.key = options.key;
        this.file = options.file;
        this.token = options.token;
        this.onData = handlers.onData;
        this.onError = handlers.onError;
        this.onComplete = handlers.onComplete;
        try {
            var putPolicy = getPutPolicy(this.token);
            this.bucketName = putPolicy.bucketName;
            this.assessKey = putPolicy.assessKey;
        }
        catch (error) {
            logger.error('get putPolicy from token failed.', error);
            this.onError(error);
        }
    }
    // 检查并更新 upload host
    Base.prototype.checkAndUpdateUploadHost = function () {
        return base___awaiter(this, void 0, void 0, function () {
            var newHost;
            return base___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 从 hostPool 中获取一个可用的 host 挂载在 this
                        this.logger.info('get available upload host.');
                        return [4 /*yield*/, this.hostPool.getUp(this.assessKey, this.bucketName, this.config.upprotocol)];
                    case 1:
                        newHost = _a.sent();
                        if (newHost == null) {
                            throw new QiniuError(QiniuErrorName.NotAvailableUploadHost, 'no available upload host.');
                        }
                        if (this.uploadHost != null && this.uploadHost.host !== newHost.host) {
                            this.logger.warn("host switches from " + this.uploadHost.host + " to " + newHost.host + ".");
                        }
                        else {
                            this.logger.info("use host " + newHost.host + ".");
                        }
                        this.uploadHost = newHost;
                        return [2 /*return*/];
                }
            });
        });
    };
    // 检查并解冻当前的 host
    Base.prototype.checkAndUnfreezeHost = function () {
        this.logger.info('check unfreeze host.');
        if (this.uploadHost != null && this.uploadHost.isFrozen()) {
            this.logger.warn(this.uploadHost.host + " will be unfrozen.");
            this.uploadHost.unfreeze();
        }
    };
    // 检查并更新冻结当前的 host
    Base.prototype.checkAndFreezeHost = function (error) {
        this.logger.info('check freeze host.');
        if (error instanceof QiniuRequestError && this.uploadHost != null) {
            if (FREEZE_CODE_LIST.includes(error.code)) {
                this.logger.warn(this.uploadHost.host + " will be temporarily frozen.");
                this.uploadHost.freeze();
            }
        }
    };
    Base.prototype.handleError = function (error) {
        this.logger.error(error.message);
        this.onError(error);
    };
    /**
     * @returns Promise 返回结果与上传最终状态无关，状态信息请通过 [Subscriber] 获取。
     * @description 上传文件，状态信息请通过 [Subscriber] 获取。
     */
    Base.prototype.putFile = function () {
        return base___awaiter(this, void 0, void 0, function () {
            var result, err_1, notReachRetryCount, needRetry;
            return base___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.aborted = false;
                        if (!this.putExtra.fname) {
                            this.logger.info('use file.name as fname.');
                            this.putExtra.fname = this.file.name;
                        }
                        if (this.file.size > 10000 * GB) {
                            this.handleError(new QiniuError(QiniuErrorName.InvalidFile, 'file size exceed maximum value 10000G'));
                            return [2 /*return*/];
                        }
                        if (this.putExtra.customVars) {
                            if (!isCustomVarsValid(this.putExtra.customVars)) {
                                this.handleError(new QiniuError(QiniuErrorName.InvalidCustomVars, 
                                // FIXME: width => with
                                'customVars key should start width x:'));
                                return [2 /*return*/];
                            }
                        }
                        if (this.putExtra.metadata) {
                            if (!isMetaDataValid(this.putExtra.metadata)) {
                                this.handleError(new QiniuError(QiniuErrorName.InvalidMetadata, 'metadata key should start with x-qn-meta-'));
                                return [2 /*return*/];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this.uploadAt = new Date().getTime();
                        return [4 /*yield*/, this.checkAndUpdateUploadHost()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.run()];
                    case 3:
                        result = _a.sent();
                        this.onComplete(result.data);
                        this.checkAndUnfreezeHost();
                        this.sendLog(result.reqId, 200);
                        return [2 /*return*/];
                    case 4:
                        err_1 = _a.sent();
                        if (this.aborted) {
                            this.logger.warn('upload is aborted.');
                            this.sendLog('', -2);
                            return [2 /*return*/];
                        }
                        this.clear();
                        this.logger.error(err_1);
                        if (err_1 instanceof QiniuRequestError) {
                            this.sendLog(err_1.reqId, err_1.code);
                            // 检查并冻结当前的 host
                            this.checkAndFreezeHost(err_1);
                            notReachRetryCount = ++this.retryCount <= this.config.retryCount;
                            needRetry = RETRY_CODE_LIST.includes(err_1.code);
                            // 以下条件满足其中之一则会进行重新上传：
                            // 1. 满足 needRetry 的条件且 retryCount 不为 0
                            // 2. uploadId 无效时在 resume 里会清除本地数据，并且这里触发重新上传
                            if (needRetry && notReachRetryCount) {
                                this.logger.warn("error auto retry: " + this.retryCount + "/" + this.config.retryCount + ".");
                                this.putFile();
                                return [2 /*return*/];
                            }
                        }
                        this.onError(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Base.prototype.clear = function () {
        this.xhrList.forEach(function (xhr) {
            xhr.onreadystatechange = null;
            xhr.abort();
        });
        this.xhrList = [];
        this.logger.info('cleanup uploading xhr.');
    };
    Base.prototype.stop = function () {
        this.logger.info('aborted.');
        this.clear();
        this.aborted = true;
    };
    Base.prototype.addXhr = function (xhr) {
        this.xhrList.push(xhr);
    };
    Base.prototype.sendLog = function (reqId, code) {
        var _a, _b;
        this.logger.report({
            code: code,
            reqId: reqId,
            remoteIp: '',
            upType: 'jssdk-h5',
            size: this.file.size,
            time: Math.floor(this.uploadAt / 1000),
            port: getPortFromUrl((_a = this.uploadHost) === null || _a === void 0 ? void 0 : _a.getUrl()),
            host: getDomainFromUrl((_b = this.uploadHost) === null || _b === void 0 ? void 0 : _b.getUrl()),
            bytesSent: this.progress ? this.progress.total.loaded : 0,
            duration: Math.floor((new Date().getTime() - this.uploadAt) / 1000)
        });
    };
    Base.prototype.getProgressInfoItem = function (loaded, size, fromCache) {
        return base___assign({ size: size,
            loaded: loaded, percent: loaded / size * 100 }, (fromCache == null ? {} : { fromCache: fromCache }));
    };
    return Base;
}());
/* harmony default export */ var base = (base_Base);
//# sourceMappingURL=base.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/upload/resume.js
var resume___extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var resume___assign = (this && this.__assign) || function () {
    resume___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return resume___assign.apply(this, arguments);
};
var resume___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var resume___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




/** 是否为正整数 */
function isPositiveInteger(n) {
    var re = /^[1-9]\d*$/;
    return re.test(String(n));
}
var resume_Resume = /** @class */ (function (_super) {
    resume___extends(Resume, _super);
    function Resume() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @returns  {Promise<ResponseSuccess<any>>}
     * @description 实现了 Base 的 run 接口，处理具体的分片上传事务，并抛出过程中的异常。
     */
    Resume.prototype.run = function () {
        return resume___awaiter(this, void 0, void 0, function () {
            var pool, mkFileResponse, localKey, uploadChunks, error_1;
            var _this = this;
            return resume___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('start run Resume.');
                        if (!this.config.chunkSize || !isPositiveInteger(this.config.chunkSize)) {
                            throw new QiniuError(QiniuErrorName.InvalidChunkSize, 'chunkSize must be a positive integer');
                        }
                        if (this.config.chunkSize > 1024) {
                            throw new QiniuError(QiniuErrorName.InvalidChunkSize, 'chunkSize maximum value is 1024');
                        }
                        return [4 /*yield*/, this.initBeforeUploadChunks()];
                    case 1:
                        _a.sent();
                        pool = new Pool(function (chunkInfo) { return resume___awaiter(_this, void 0, void 0, function () {
                            return resume___generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (this.aborted) {
                                            pool.abort();
                                            throw new Error('pool is aborted');
                                        }
                                        return [4 /*yield*/, this.uploadChunk(chunkInfo)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, this.config.concurrentRequestLimit);
                        mkFileResponse = null;
                        localKey = this.getLocalKey();
                        uploadChunks = this.chunks.map(function (chunk, index) { return pool.enqueue({ chunk: chunk, index: index }); });
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, Promise.all(uploadChunks)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.mkFileReq()];
                    case 4:
                        mkFileResponse = _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        // uploadId 无效，上传参数有误（多由于本地存储信息的 uploadId 失效）
                        if (error_1 instanceof QiniuRequestError && (error_1.code === 612 || error_1.code === 400)) {
                            removeLocalFileInfo(localKey, this.logger);
                        }
                        throw error_1;
                    case 6:
                        // 上传成功，清理本地缓存数据
                        removeLocalFileInfo(localKey, this.logger);
                        return [2 /*return*/, mkFileResponse];
                }
            });
        });
    };
    Resume.prototype.uploadChunk = function (chunkInfo) {
        return resume___awaiter(this, void 0, void 0, function () {
            var index, chunk, cachedInfo, shouldCheckMD5, reuseSaved, md5, onProgress, requestOptions, response;
            var _this = this;
            return resume___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        index = chunkInfo.index, chunk = chunkInfo.chunk;
                        cachedInfo = this.cachedUploadedList[index];
                        this.logger.info("upload part " + index + ", cache:", cachedInfo);
                        shouldCheckMD5 = this.config.checkByMD5;
                        reuseSaved = function () {
                            _this.usedCacheList[index] = true;
                            _this.updateChunkProgress(chunk.size, index);
                            _this.uploadedList[index] = cachedInfo;
                            _this.updateLocalCache();
                        };
                        // FIXME: 至少判断一下 size
                        if (cachedInfo && !shouldCheckMD5) {
                            reuseSaved();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, computeMd5(chunk)];
                    case 1:
                        md5 = _a.sent();
                        this.logger.info('computed part md5.', md5);
                        if (cachedInfo && md5 === cachedInfo.md5) {
                            reuseSaved();
                            return [2 /*return*/];
                        }
                        // 没有使用缓存设置标记为 false
                        this.usedCacheList[index] = false;
                        onProgress = function (data) {
                            _this.updateChunkProgress(data.loaded, index);
                        };
                        requestOptions = {
                            body: chunk,
                            md5: this.config.checkByServer ? md5 : undefined,
                            onProgress: onProgress,
                            onCreate: function (xhr) { return _this.addXhr(xhr); }
                        };
                        this.logger.info("part " + index + " start uploading.");
                        return [4 /*yield*/, uploadChunk(this.token, this.key, chunkInfo.index + 1, this.getUploadInfo(), requestOptions)];
                    case 2:
                        response = _a.sent();
                        this.logger.info("part " + index + " upload completed.");
                        // 在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里在每次分片上传完成后都手动更新下 progress
                        onProgress({
                            loaded: chunk.size,
                            total: chunk.size
                        });
                        this.uploadedList[index] = {
                            etag: response.data.etag,
                            md5: response.data.md5,
                            size: chunk.size
                        };
                        this.updateLocalCache();
                        return [2 /*return*/];
                }
            });
        });
    };
    Resume.prototype.mkFileReq = function () {
        return resume___awaiter(this, void 0, void 0, function () {
            var data, result;
            var _this = this;
            return resume___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = resume___assign(resume___assign(resume___assign({ parts: this.uploadedList.map(function (value, index) { return ({
                                etag: value.etag,
                                // 接口要求 index 需要从 1 开始，所以需要整体 + 1
                                partNumber: index + 1
                            }); }), fname: this.putExtra.fname }, this.putExtra.mimeType && { mimeType: this.putExtra.mimeType }), this.putExtra.customVars && { customVars: this.putExtra.customVars }), this.putExtra.metadata && { metadata: this.putExtra.metadata });
                        this.logger.info('parts upload completed, make file.', data);
                        return [4 /*yield*/, uploadComplete(this.token, this.key, this.getUploadInfo(), {
                                onCreate: function (xhr) { return _this.addXhr(xhr); },
                                body: JSON.stringify(data)
                            })];
                    case 1:
                        result = _a.sent();
                        this.logger.info('finish Resume Progress.');
                        this.updateMkFileProgress(1);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Resume.prototype.initBeforeUploadChunks = function () {
        return resume___awaiter(this, void 0, void 0, function () {
            var cachedInfo, res, infoMessage;
            return resume___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.uploadedList = [];
                        this.usedCacheList = [];
                        cachedInfo = getLocalFileInfo(this.getLocalKey(), this.logger);
                        if (!!cachedInfo) return [3 /*break*/, 2];
                        this.logger.info('init upload parts from api.');
                        return [4 /*yield*/, initUploadParts(this.token, this.bucketName, this.key, this.uploadHost.getUrl())];
                    case 1:
                        res = _a.sent();
                        this.logger.info("initd upload parts of id: " + res.data.uploadId + ".");
                        this.uploadId = res.data.uploadId;
                        this.cachedUploadedList = [];
                        return [3 /*break*/, 3];
                    case 2:
                        infoMessage = [
                            'resume upload parts from local cache,',
                            "total " + cachedInfo.data.length + " part,",
                            "id is " + cachedInfo.id + "."
                        ];
                        this.logger.info(infoMessage.join(' '));
                        this.cachedUploadedList = cachedInfo.data;
                        this.uploadId = cachedInfo.id;
                        _a.label = 3;
                    case 3:
                        this.chunks = getChunks(this.file, this.config.chunkSize);
                        this.loaded = {
                            mkFileProgress: 0,
                            chunks: this.chunks.map(function (_) { return 0; })
                        };
                        this.notifyResumeProgress();
                        return [2 /*return*/];
                }
            });
        });
    };
    Resume.prototype.getUploadInfo = function () {
        return {
            id: this.uploadId,
            url: this.uploadHost.getUrl()
        };
    };
    Resume.prototype.getLocalKey = function () {
        return createLocalKey(this.file.name, this.key, this.file.size);
    };
    Resume.prototype.updateLocalCache = function () {
        setLocalFileInfo(this.getLocalKey(), {
            id: this.uploadId,
            data: this.uploadedList
        }, this.logger);
    };
    Resume.prototype.updateChunkProgress = function (loaded, index) {
        this.loaded.chunks[index] = loaded;
        this.notifyResumeProgress();
    };
    Resume.prototype.updateMkFileProgress = function (progress) {
        this.loaded.mkFileProgress = progress;
        this.notifyResumeProgress();
    };
    Resume.prototype.notifyResumeProgress = function () {
        var _this = this;
        this.progress = {
            total: this.getProgressInfoItem(sum(this.loaded.chunks) + this.loaded.mkFileProgress, 
            // FIXME: 不准确的 fileSize
            this.file.size + 1 // 防止在 complete 未调用的时候进度显示 100%
            ),
            chunks: this.chunks.map(function (chunk, index) {
                var fromCache = _this.usedCacheList[index];
                return _this.getProgressInfoItem(_this.loaded.chunks[index], chunk.size, fromCache);
            }),
            uploadInfo: {
                id: this.uploadId,
                url: this.uploadHost.getUrl()
            }
        };
        this.onData(this.progress);
    };
    return Resume;
}(base));
/* harmony default export */ var resume = (resume_Resume);
//# sourceMappingURL=resume.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/crc32.js
/* eslint-disable no-bitwise */
var crc32___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var crc32___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

/**
 * 以下 class 实现参考
 * https://github.com/Stuk/jszip/blob/d4702a70834bd953d4c2d0bc155fad795076631a/lib/crc32.js
 * 该实现主要针对大文件优化、对计算的值进行了 `>>> 0` 运算（为与服务端保持一致）
 */
var crc32_CRC32 = /** @class */ (function () {
    function CRC32() {
        this.crc = -1;
        this.table = this.makeTable();
    }
    CRC32.prototype.makeTable = function () {
        var table = new Array();
        for (var i = 0; i < 256; i++) {
            var t = i;
            for (var j = 0; j < 8; j++) {
                if (t & 1) {
                    // IEEE 标准
                    t = (t >>> 1) ^ 0xEDB88320;
                }
                else {
                    t >>>= 1;
                }
            }
            table[i] = t;
        }
        return table;
    };
    CRC32.prototype.append = function (data) {
        var crc = this.crc;
        for (var offset = 0; offset < data.byteLength; offset++) {
            crc = (crc >>> 8) ^ this.table[(crc ^ data[offset]) & 0xFF];
        }
        this.crc = crc;
    };
    CRC32.prototype.compute = function () {
        return (this.crc ^ -1) >>> 0;
    };
    CRC32.prototype.readAsUint8Array = function (file) {
        return crc32___awaiter(this, void 0, void 0, function () {
            var _a;
            return crc32___generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof file.arrayBuffer === 'function')) return [3 /*break*/, 2];
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, file.arrayBuffer()];
                    case 1: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onload = function () {
                                if (reader.result == null) {
                                    reject();
                                    return;
                                }
                                if (typeof reader.result === 'string') {
                                    reject();
                                    return;
                                }
                                resolve(new Uint8Array(reader.result));
                            };
                            reader.readAsArrayBuffer(file);
                        })];
                }
            });
        });
    };
    CRC32.prototype.file = function (file) {
        return crc32___awaiter(this, void 0, void 0, function () {
            var _a, count, index, start, end, chuck;
            return crc32___generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(file.size <= MB)) return [3 /*break*/, 2];
                        _a = this.append;
                        return [4 /*yield*/, this.readAsUint8Array(file)];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/, this.compute()];
                    case 2:
                        count = Math.ceil(file.size / MB);
                        index = 0;
                        _b.label = 3;
                    case 3:
                        if (!(index < count)) return [3 /*break*/, 6];
                        start = index * MB;
                        end = index === (count - 1) ? file.size : start + MB;
                        return [4 /*yield*/, this.readAsUint8Array(file.slice(start, end))];
                    case 4:
                        chuck = _b.sent();
                        this.append(new Uint8Array(chuck));
                        _b.label = 5;
                    case 5:
                        index++;
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/, this.compute()];
                }
            });
        });
    };
    CRC32.file = function (file) {
        var crc = new CRC32();
        return crc.file(file);
    };
    return CRC32;
}());

//# sourceMappingURL=crc32.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/upload/direct.js
var direct___extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var direct___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var direct___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var direct_Direct = /** @class */ (function (_super) {
    direct___extends(Direct, _super);
    function Direct() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Direct.prototype.run = function () {
        return direct___awaiter(this, void 0, void 0, function () {
            var formData, crcSign, customVars_1, result;
            var _this = this;
            return direct___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('start run Direct.');
                        formData = new FormData();
                        formData.append('file', this.file);
                        formData.append('token', this.token);
                        if (this.key != null) {
                            formData.append('key', this.key);
                        }
                        formData.append('fname', this.putExtra.fname);
                        if (!this.config.checkByServer) return [3 /*break*/, 2];
                        return [4 /*yield*/, crc32_CRC32.file(this.file)];
                    case 1:
                        crcSign = _a.sent();
                        formData.append('crc32', crcSign.toString());
                        _a.label = 2;
                    case 2:
                        if (this.putExtra.customVars) {
                            this.logger.info('init customVars.');
                            customVars_1 = this.putExtra.customVars;
                            Object.keys(customVars_1).forEach(function (key) { return formData.append(key, customVars_1[key].toString()); });
                            this.logger.info('customVars inited.');
                        }
                        this.logger.info('formData inited.');
                        return [4 /*yield*/, direct(this.uploadHost.getUrl(), formData, {
                                onProgress: function (data) {
                                    _this.updateDirectProgress(data.loaded, data.total);
                                },
                                onCreate: function (xhr) { return _this.addXhr(xhr); }
                            })];
                    case 3:
                        result = _a.sent();
                        this.logger.info('Direct progress finish.');
                        this.finishDirectProgress();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Direct.prototype.updateDirectProgress = function (loaded, total) {
        // 当请求未完成时可能进度会达到100，所以total + 1来防止这种情况出现
        this.progress = { total: this.getProgressInfoItem(loaded, total + 1) };
        this.onData(this.progress);
    };
    Direct.prototype.finishDirectProgress = function () {
        // 在某些浏览器环境下，xhr 的 progress 事件无法被触发，progress 为 null，这里 fake 下
        if (!this.progress) {
            this.logger.warn('progress is null.');
            this.progress = { total: this.getProgressInfoItem(this.file.size, this.file.size) };
            this.onData(this.progress);
            return;
        }
        var total = this.progress.total;
        this.progress = { total: this.getProgressInfoItem(total.loaded + 1, total.size) };
        this.onData(this.progress);
    };
    return Direct;
}(base));
/* harmony default export */ var upload_direct = (direct_Direct);
//# sourceMappingURL=direct.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/logger/report-v3.js

/**
 * @param  {string} token 上传使用的 token
 * @param  {V3LogInfo} data 上报的统计数据
 * @param  {number} retry 重试的次数，默认值 3
 * @description v3 版本的日志上传接口，参考文档 https://github.com/qbox/product/blob/master/kodo/uplog.md#%E7%89%88%E6%9C%AC-3。
 */
function reportV3(token, data, retry) {
    if (retry === void 0) { retry = 3; }
    var xhr = createXHR();
    xhr.open('POST', 'https://uplog.qbox.me/log/3');
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('Authorization', getAuthHeaders(token).Authorization);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status !== 200 && retry > 0) {
            reportV3(token, data, retry - 1);
        }
    };
    // 顺序参考：https://github.com/qbox/product/blob/master/kodo/uplog.md#%E7%89%88%E6%9C%AC-3
    var stringifyData = [
        data.code || '',
        data.reqId || '',
        data.host || '',
        data.remoteIp || '',
        data.port || '',
        data.duration || '',
        data.time || '',
        data.bytesSent || '',
        data.upType || '',
        data.size || ''
    ].join(',');
    xhr.send(stringifyData);
}
//# sourceMappingURL=report-v3.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/logger/index.js
var logger___read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var logger___spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(logger___read(arguments[i]));
    return ar;
};

var logger_Logger = /** @class */ (function () {
    function Logger(token, disableReport, level, prefix) {
        if (disableReport === void 0) { disableReport = true; }
        if (level === void 0) { level = 'OFF'; }
        if (prefix === void 0) { prefix = 'UPLOAD'; }
        this.token = token;
        this.disableReport = disableReport;
        this.level = level;
        this.prefix = prefix;
        // 为每个类分配一个 id
        // 用以区分不同的上传任务
        this.id = ++Logger.id;
    }
    Logger.prototype.getPrintPrefix = function (level) {
        return "Qiniu-JS-SDK [" + level + "][" + this.prefix + "#" + this.id + "]:";
    };
    /**
     * @param  {V3LogInfo} data 上报的数据。
     * @param  {boolean} retry 重试次数，可选，默认为 3。
     * @description 向服务端上报统计信息。
     */
    Logger.prototype.report = function (data, retry) {
        if (this.disableReport)
            return;
        try {
            reportV3(this.token, data, retry);
        }
        catch (error) {
            this.warn(error);
        }
    };
    /**
     * @param  {unknown[]} ...args
     * @description 输出 info 级别的调试信息。
     */
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var allowLevel = ['INFO'];
        if (allowLevel.includes(this.level)) {
            // eslint-disable-next-line no-console
            console.log.apply(console, logger___spread([this.getPrintPrefix('INFO')], args));
        }
    };
    /**
     * @param  {unknown[]} ...args
     * @description 输出 warn 级别的调试信息。
     */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var allowLevel = ['INFO', 'WARN'];
        if (allowLevel.includes(this.level)) {
            // eslint-disable-next-line no-console
            console.warn.apply(console, logger___spread([this.getPrintPrefix('WARN')], args));
        }
    };
    /**
     * @param  {unknown[]} ...args
     * @description 输出 error 级别的调试信息。
     */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var allowLevel = ['INFO', 'WARN', 'ERROR'];
        if (allowLevel.includes(this.level)) {
            // eslint-disable-next-line no-console
            console.error.apply(console, logger___spread([this.getPrintPrefix('ERROR')], args));
        }
    };
    Logger.id = 0;
    return Logger;
}());
/* harmony default export */ var esm_logger = (logger_Logger);
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/upload/hosts.js
var hosts___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var hosts___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var hosts___read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var hosts___spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(hosts___read(arguments[i]));
    return ar;
};

/**
  * @description 解冻时间，key 是 host，value 为解冻时间
  */
var unfreezeTimeMap = new Map();
var Host = /** @class */ (function () {
    function Host(host, protocol) {
        this.host = host;
        this.protocol = protocol;
    }
    /**
     * @description 当前 host 是否为冻结状态
     */
    Host.prototype.isFrozen = function () {
        var currentTime = new Date().getTime();
        var unfreezeTime = unfreezeTimeMap.get(this.host);
        return unfreezeTime != null && unfreezeTime >= currentTime;
    };
    /**
     * @param  {number} time 单位秒，默认 20s
     * @description 冻结该 host 对象，该 host 将在指定时间内不可用
     */
    Host.prototype.freeze = function (time) {
        if (time === void 0) { time = 20; }
        var unfreezeTime = new Date().getTime() + (time * 1000);
        unfreezeTimeMap.set(this.host, unfreezeTime);
    };
    /**
     * @description 解冻该 host
     */
    Host.prototype.unfreeze = function () {
        unfreezeTimeMap["delete"](this.host);
    };
    /**
     * @description 获取当前 host 的完整 url
     */
    Host.prototype.getUrl = function () {
        return this.protocol + "://" + this.host;
    };
    /**
     * @description 获取解冻时间
     */
    Host.prototype.getUnfreezeTime = function () {
        return unfreezeTimeMap.get(this.host);
    };
    return Host;
}());

var hosts_HostPool = /** @class */ (function () {
    /**
     * @param  {string[]} initHosts
     * @description 如果在构造时传入 initHosts，则该 host 池始终使用传入的 initHosts 做为可用的数据
     */
    function HostPool(initHosts) {
        if (initHosts === void 0) { initHosts = []; }
        this.initHosts = initHosts;
        /**
         * @description 缓存的 host 表，以 bucket 和 accessKey 作为 key
         */
        this.cachedHostsMap = new Map();
    }
    /**
     * @param  {string} accessKey
     * @param  {string} bucketName
     * @param  {string[]} hosts
     * @param  {InternalConfig['upprotocol']} protocol
     * @returns  {void}
     * @description 注册可用 host
     */
    HostPool.prototype.register = function (accessKey, bucketName, hosts, protocol) {
        this.cachedHostsMap.set(accessKey + "@" + bucketName, hosts.map(function (host) { return new Host(host, protocol); }));
    };
    /**
     * @param  {string} accessKey
     * @param  {string} bucketName
     * @param  {InternalConfig['upprotocol']} protocol
     * @returns  {Promise<void>}
     * @description 刷新最新的 host 数据，如果用户在构造时该类时传入了 host 或者已经存在缓存则不会发起请求
     */
    HostPool.prototype.refresh = function (accessKey, bucketName, protocol) {
        var _a, _b, _c, _d;
        return hosts___awaiter(this, void 0, void 0, function () {
            var cachedHostList, response, stashHosts;
            return hosts___generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        cachedHostList = this.cachedHostsMap.get(accessKey + "@" + bucketName) || [];
                        if (cachedHostList.length > 0)
                            return [2 /*return*/];
                        if (this.initHosts.length > 0) {
                            this.register(accessKey, bucketName, this.initHosts, protocol);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getUpHosts(accessKey, bucketName, protocol)];
                    case 1:
                        response = _e.sent();
                        if ((response === null || response === void 0 ? void 0 : response.data) != null) {
                            stashHosts = hosts___spread((((_b = (_a = response.data.up) === null || _a === void 0 ? void 0 : _a.acc) === null || _b === void 0 ? void 0 : _b.main) || []), (((_d = (_c = response.data.up) === null || _c === void 0 ? void 0 : _c.acc) === null || _d === void 0 ? void 0 : _d.backup) || []));
                            this.register(accessKey, bucketName, stashHosts, protocol);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param  {string} accessKey
     * @param  {string} bucketName
     * @param  {InternalConfig['upprotocol']} protocol
     * @returns  {Promise<Host | null>}
     * @description 获取一个可用的上传 Host，排除已冻结的
     */
    HostPool.prototype.getUp = function (accessKey, bucketName, protocol) {
        return hosts___awaiter(this, void 0, void 0, function () {
            var cachedHostList, availableHostList, priorityQueue;
            return hosts___generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refresh(accessKey, bucketName, protocol)];
                    case 1:
                        _a.sent();
                        cachedHostList = this.cachedHostsMap.get(accessKey + "@" + bucketName) || [];
                        if (cachedHostList.length === 0)
                            return [2 /*return*/, null];
                        availableHostList = cachedHostList.filter(function (host) { return !host.isFrozen(); });
                        if (availableHostList.length > 0)
                            return [2 /*return*/, availableHostList[0]
                                // 无可用的，去取离解冻最近的 host
                            ];
                        priorityQueue = cachedHostList
                            .slice().sort(function (hostA, hostB) { return (hostA.getUnfreezeTime() || 0) - (hostB.getUnfreezeTime() || 0); });
                        return [2 /*return*/, priorityQueue[0]];
                }
            });
        });
    };
    return HostPool;
}());

//# sourceMappingURL=hosts.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/upload/index.js







function createUploadManager(options, handlers, hostPool, logger) {
    if (options.config && options.config.forceDirect) {
        logger.info('ues forceDirect mode.');
        return new upload_direct(options, handlers, hostPool, logger);
    }
    if (options.file.size > 4 * MB) {
        logger.info('file size over 4M, use Resume.');
        return new resume(options, handlers, hostPool, logger);
    }
    logger.info('file size less or equal than 4M, use Direct.');
    return new upload_direct(options, handlers, hostPool, logger);
}
/**
 * @param file 上传文件
 * @param key 目标文件名
 * @param token 上传凭证
 * @param putExtra 上传文件的相关资源信息配置
 * @param config 上传任务的配置
 * @returns 返回用于上传任务的可观察对象
 */
function upload(file, key, token, putExtra, config) {
    // 为每个任务创建单独的 Logger
    var logger = new esm_logger(token, config === null || config === void 0 ? void 0 : config.disableStatisticsReport, config === null || config === void 0 ? void 0 : config.debugLogLevel, file.name);
    var options = {
        file: file,
        key: key,
        token: token,
        putExtra: putExtra,
        config: normalizeUploadConfig(config, logger)
    };
    // 创建 host 池
    var hostPool = new hosts_HostPool(options.config.uphost);
    return new Observable(function (observer) {
        var manager = createUploadManager(options, {
            onData: function (data) { return observer.next(data); },
            onError: function (err) { return observer.error(err); },
            onComplete: function (res) { return observer.complete(res); }
        }, hostPool, logger);
        manager.putFile();
        return manager.stop.bind(manager);
    });
}
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/config.js
var config___assign = (this && this.__assign) || function () {
    config___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return config___assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var config___read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var config___spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(config___read(arguments[i]));
    return ar;
};


function normalizeUploadConfig(config, logger) {
    var _a = config___assign({}, config), upprotocol = _a.upprotocol, uphost = _a.uphost, otherConfig = __rest(_a, ["upprotocol", "uphost"]);
    var normalizeConfig = config___assign({ uphost: [], retryCount: 3, checkByMD5: false, forceDirect: false, useCdnDomain: true, checkByServer: false, concurrentRequestLimit: 3, chunkSize: DEFAULT_CHUNK_SIZE, upprotocol: 'https', debugLogLevel: 'OFF', disableStatisticsReport: false }, otherConfig);
    // 兼容原来的 http: https: 的写法
    if (upprotocol) {
        normalizeConfig.upprotocol = upprotocol
            .replace(/:$/, '');
    }
    var hostList = [];
    if (logger && (config === null || config === void 0 ? void 0 : config.uphost) != null && (config === null || config === void 0 ? void 0 : config.region) != null) {
        logger.warn('do not use both the uphost and region config.');
    }
    // 如果同时指定了 uphost 参数，添加到可用 host 列表
    if (uphost) {
        if (Array.isArray(uphost)) {
            hostList.push.apply(hostList, config___spread(uphost));
        }
        else {
            hostList.push(uphost);
        }
        // 否则如果用户传了 region，添加指定 region 的 host 到可用 host 列表
    }
    else if (normalizeConfig === null || normalizeConfig === void 0 ? void 0 : normalizeConfig.region) {
        var hostMap = regionUphostMap[normalizeConfig === null || normalizeConfig === void 0 ? void 0 : normalizeConfig.region];
        if (normalizeConfig.useCdnDomain) {
            hostList.push.apply(hostList, config___spread(hostMap.cdnUphost));
        }
        else {
            hostList.push.apply(hostList, config___spread(hostMap.srcUphost));
        }
    }
    return config___assign(config___assign({}, normalizeConfig), { uphost: hostList.filter(Boolean) });
}
//# sourceMappingURL=config.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/compress.js
var compress___assign = (this && this.__assign) || function () {
    compress___assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return compress___assign.apply(this, arguments);
};
var compress___awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var compress___generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var compress_mimeTypes = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
    WEBP: 'image/webp',
    BMP: 'image/bmp'
};
var maxSteps = 4;
var scaleFactor = Math.log(2);
var supportMimeTypes = Object.keys(compress_mimeTypes).map(function (type) { return compress_mimeTypes[type]; });
var defaultType = compress_mimeTypes.JPEG;
function isSupportedType(type) {
    return supportMimeTypes.includes(type);
}
var compress_Compress = /** @class */ (function () {
    function Compress(file, config) {
        this.file = file;
        this.config = config;
        this.config = compress___assign({ quality: 0.92, noCompressIfLarger: false }, this.config);
    }
    Compress.prototype.process = function () {
        return compress___awaiter(this, void 0, void 0, function () {
            var srcDimension, originImage, canvas, scale, scaleCanvas, distBlob;
            return compress___generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.outputType = this.file.type;
                        srcDimension = {};
                        if (!isSupportedType(this.file.type)) {
                            throw new QiniuError(QiniuErrorName.UnsupportedFileType, "unsupported file type: " + this.file.type);
                        }
                        return [4 /*yield*/, this.getOriginImage()];
                    case 1:
                        originImage = _a.sent();
                        return [4 /*yield*/, this.getCanvas(originImage)];
                    case 2:
                        canvas = _a.sent();
                        scale = 1;
                        if (this.config.maxWidth) {
                            scale = Math.min(1, this.config.maxWidth / canvas.width);
                        }
                        if (this.config.maxHeight) {
                            scale = Math.min(1, scale, this.config.maxHeight / canvas.height);
                        }
                        srcDimension.width = canvas.width;
                        srcDimension.height = canvas.height;
                        return [4 /*yield*/, this.doScale(canvas, scale)];
                    case 3:
                        scaleCanvas = _a.sent();
                        distBlob = this.toBlob(scaleCanvas);
                        if (distBlob.size > this.file.size && this.config.noCompressIfLarger) {
                            return [2 /*return*/, {
                                    dist: this.file,
                                    width: srcDimension.width,
                                    height: srcDimension.height
                                }];
                        }
                        return [2 /*return*/, {
                                dist: distBlob,
                                width: scaleCanvas.width,
                                height: scaleCanvas.height
                            }];
                }
            });
        });
    };
    Compress.prototype.clear = function (ctx, width, height) {
        // jpeg 没有 alpha 通道，透明区间会被填充成黑色，这里把透明区间填充为白色
        if (this.outputType === defaultType) {
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, width, height);
        }
        else {
            ctx.clearRect(0, 0, width, height);
        }
    };
    /** 通过 file 初始化 image 对象 */
    Compress.prototype.getOriginImage = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = createObjectURL(_this.file);
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = function () {
                reject('image load error');
            };
            img.src = url;
        });
    };
    Compress.prototype.getCanvas = function (img) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            if (!context) {
                reject(new QiniuError(QiniuErrorName.GetCanvasContextFailed, 'context is null'));
                return;
            }
            var width = img.width, height = img.height;
            canvas.height = height;
            canvas.width = width;
            _this.clear(context, width, height);
            context.drawImage(img, 0, 0);
            resolve(canvas);
        });
    };
    Compress.prototype.doScale = function (source, scale) {
        return compress___awaiter(this, void 0, void 0, function () {
            var sctx, steps, factor, mirror, mctx, width, height, originWidth, originHeight, src, context, i, dw, dh, canvas, data;
            return compress___generator(this, function (_a) {
                if (scale === 1) {
                    return [2 /*return*/, source];
                }
                sctx = source.getContext('2d');
                steps = Math.min(maxSteps, Math.ceil((1 / scale) / scaleFactor));
                factor = Math.pow(scale, (1 / steps));
                mirror = document.createElement('canvas');
                mctx = mirror.getContext('2d');
                width = source.width, height = source.height;
                originWidth = width;
                originHeight = height;
                mirror.width = width;
                mirror.height = height;
                if (!mctx || !sctx) {
                    throw new QiniuError(QiniuErrorName.GetCanvasContextFailed, "mctx or sctx can't be null");
                }
                for (i = 0; i < steps; i++) {
                    dw = width * factor | 0 // eslint-disable-line no-bitwise
                    ;
                    dh = height * factor | 0 // eslint-disable-line no-bitwise
                    ;
                    // 到最后一步的时候 dw, dh 用目标缩放尺寸，否则会出现最后尺寸偏小的情况
                    if (i === steps - 1) {
                        dw = originWidth * scale;
                        dh = originHeight * scale;
                    }
                    if (i % 2 === 0) {
                        src = source;
                        context = mctx;
                    }
                    else {
                        src = mirror;
                        context = sctx;
                    }
                    // 每次画前都清空，避免图像重叠
                    this.clear(context, width, height);
                    context.drawImage(src, 0, 0, width, height, 0, 0, dw, dh);
                    width = dw;
                    height = dh;
                }
                canvas = src === source ? mirror : source;
                data = context.getImageData(0, 0, width, height);
                // resize
                canvas.width = width;
                canvas.height = height;
                // store image data
                context.putImageData(data, 0, 0);
                return [2 /*return*/, canvas];
            });
        });
    };
    /** 这里把 base64 字符串转为 blob 对象 */
    Compress.prototype.toBlob = function (result) {
        var dataURL = result.toDataURL(this.outputType, this.config.quality);
        var buffer = atob(dataURL.split(',')[1]).split('').map(function (char) { return char.charCodeAt(0); });
        var blob = new Blob([new Uint8Array(buffer)], { type: this.outputType });
        return blob;
    };
    return Compress;
}());
var compressImage = function (file, options) { return new compress_Compress(file, options).process(); };
/* harmony default export */ var compress = (compressImage);
//# sourceMappingURL=compress.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/utils/index.js






//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/image/index.js

function getImageUrl(key, domain) {
    key = encodeURIComponent(key);
    if (domain.slice(domain.length - 1) !== '/') {
        domain += '/';
    }
    return domain + key;
}
function imageView2(op, key, domain) {
    if (!/^\d$/.test(String(op.mode))) {
        throw 'mode should be number in imageView2';
    }
    var mode = op.mode, w = op.w, h = op.h, q = op.q, format = op.format;
    if (!w && !h) {
        throw 'param w and h is empty in imageView2';
    }
    var imageUrl = 'imageView2/' + encodeURIComponent(mode);
    imageUrl += w ? '/w/' + encodeURIComponent(w) : '';
    imageUrl += h ? '/h/' + encodeURIComponent(h) : '';
    imageUrl += q ? '/q/' + encodeURIComponent(q) : '';
    imageUrl += format ? '/format/' + encodeURIComponent(format) : '';
    if (key && domain) {
        imageUrl = getImageUrl(key, domain) + '?' + imageUrl;
    }
    return imageUrl;
}
// invoke the imageMogr2 api of Qiniu
function imageMogr2(op, key, domain) {
    var autoOrient = op['auto-orient'];
    var thumbnail = op.thumbnail, strip = op.strip, gravity = op.gravity, crop = op.crop, quality = op.quality, rotate = op.rotate, format = op.format, blur = op.blur;
    var imageUrl = 'imageMogr2';
    imageUrl += autoOrient ? '/auto-orient' : '';
    imageUrl += thumbnail ? '/thumbnail/' + encodeURIComponent(thumbnail) : '';
    imageUrl += strip ? '/strip' : '';
    imageUrl += gravity ? '/gravity/' + encodeURIComponent(gravity) : '';
    imageUrl += quality ? '/quality/' + encodeURIComponent(quality) : '';
    imageUrl += crop ? '/crop/' + encodeURIComponent(crop) : '';
    imageUrl += rotate ? '/rotate/' + encodeURIComponent(rotate) : '';
    imageUrl += format ? '/format/' + encodeURIComponent(format) : '';
    imageUrl += blur ? '/blur/' + encodeURIComponent(blur) : '';
    if (key && domain) {
        imageUrl = getImageUrl(key, domain) + '?' + imageUrl;
    }
    return imageUrl;
}
// invoke the watermark api of Qiniu
function watermark(op, key, domain) {
    var mode = op.mode;
    if (!mode) {
        throw "mode can't be empty in watermark";
    }
    var imageUrl = 'watermark/' + mode;
    if (mode !== 1 && mode !== 2) {
        throw 'mode is wrong';
    }
    if (mode === 1) {
        var image = op.image;
        if (!image) {
            throw "image can't be empty in watermark";
        }
        imageUrl += image ? '/image/' + urlSafeBase64Encode(image) : '';
    }
    if (mode === 2) {
        var text = op.text, font = op.font, fontsize = op.fontsize, fill = op.fill;
        if (!text) {
            throw "text can't be empty in watermark";
        }
        imageUrl += text ? '/text/' + urlSafeBase64Encode(text) : '';
        imageUrl += font ? '/font/' + urlSafeBase64Encode(font) : '';
        imageUrl += fontsize ? '/fontsize/' + fontsize : '';
        imageUrl += fill ? '/fill/' + urlSafeBase64Encode(fill) : '';
    }
    var dissolve = op.dissolve, gravity = op.gravity, dx = op.dx, dy = op.dy;
    imageUrl += dissolve ? '/dissolve/' + encodeURIComponent(dissolve) : '';
    imageUrl += gravity ? '/gravity/' + encodeURIComponent(gravity) : '';
    imageUrl += dx ? '/dx/' + encodeURIComponent(dx) : '';
    imageUrl += dy ? '/dy/' + encodeURIComponent(dy) : '';
    if (key && domain) {
        imageUrl = getImageUrl(key, domain) + '?' + imageUrl;
    }
    return imageUrl;
}
// invoke the imageInfo api of Qiniu
function imageInfo(key, domain) {
    var url = getImageUrl(key, domain) + '?imageInfo';
    return request(url, { method: 'GET' });
}
// invoke the exif api of Qiniu
function exif(key, domain) {
    var url = getImageUrl(key, domain) + '?exif';
    return request(url, { method: 'GET' });
}
function pipeline(arr, key, domain) {
    var isArray = Object.prototype.toString.call(arr) === '[object Array]';
    var option;
    var errOp = false;
    var imageUrl = '';
    if (isArray) {
        for (var i = 0, len = arr.length; i < len; i++) {
            option = arr[i];
            if (!option.fop) {
                throw "fop can't be empty in pipeline";
            }
            switch (option.fop) {
                case 'watermark':
                    imageUrl += watermark(option) + '|';
                    break;
                case 'imageView2':
                    imageUrl += imageView2(option) + '|';
                    break;
                case 'imageMogr2':
                    imageUrl += imageMogr2(option) + '|';
                    break;
                default:
                    errOp = true;
                    break;
            }
            if (errOp) {
                throw 'fop is wrong in pipeline';
            }
        }
        if (key && domain) {
            imageUrl = getImageUrl(key, domain) + '?' + imageUrl;
            var length_1 = imageUrl.length;
            if (imageUrl.slice(length_1 - 1) === '|') {
                imageUrl = imageUrl.slice(0, length_1 - 1);
            }
        }
        return imageUrl;
    }
    throw "pipeline's first param should be array";
}
//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/qiniu-js/esm/index.js
/* unused concated harmony import QiniuErrorName */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return QiniuErrorName; });
/* unused concated harmony import QiniuError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return QiniuError; });
/* unused concated harmony import QiniuRequestError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return QiniuRequestError; });
/* unused concated harmony import QiniuNetworkError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return QiniuNetworkError; });
/* unused concated harmony import imageMogr2 */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return imageMogr2; });
/* unused concated harmony import watermark */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return watermark; });
/* unused concated harmony import imageInfo */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return imageInfo; });
/* unused concated harmony import exif */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return exif; });
/* unused concated harmony import pipeline */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return pipeline; });
/* unused concated harmony import deleteUploadedChunks */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return deleteUploadedChunks; });
/* unused concated harmony import getUploadUrl */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getUploadUrl; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* unused concated harmony import region */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return region; });
/* unused concated harmony import compressImage */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return compress; });
/* unused concated harmony import urlSafeBase64Encode */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return urlSafeBase64Encode; });
/* unused concated harmony import urlSafeBase64Decode */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return urlSafeBase64Decode; });
/* unused concated harmony import getHeadersForMkFile */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getHeadersForMkFile; });
/* unused concated harmony import getHeadersForChunkUpload */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getHeadersForChunkUpload; });






//# sourceMappingURL=index.js.map

/***/ }),

/***/ "t8x9":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("77Pl");
var aFunction = __webpack_require__("lOnJ");
var SPECIES = __webpack_require__("dSzd")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "tGP/":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("9Bbf")('WeakMap');


/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "tX24":
/***/ (function(module, exports) {


/**
 * Array#filter.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Object=} self
 * @return {Array}
 * @throw TypeError
 */

module.exports = function (arr, fn, self) {
  if (arr.filter) return arr.filter(fn, self);
  if (void 0 === arr || null === arr) throw new TypeError;
  if ('function' != typeof fn) throw new TypeError;
  var ret = [];
  for (var i = 0; i < arr.length; i++) {
    if (!hasOwn.call(arr, i)) continue;
    var val = arr[i];
    if (fn.call(self, val, i, arr)) ret.push(val);
  }
  return ret;
};

var hasOwn = Object.prototype.hasOwnProperty;


/***/ }),

/***/ "te2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  hasClass: function hasClass(el, token) {
    return new RegExp('(\\s|^)' + token + '(\\s|$)').test(el.className);
  },
  addClass: function addClass(el, token) {
    if (!el) {
      return;
    }
    if (el.classList) {
      el.classList.add(token);
    } else if (!this.hasClass(el, token)) {
      el.className += '' + token;
    }
  },
  removeClass: function removeClass(el, token) {
    if (!el) {
      return;
    }
    if (el.classList) {
      el.classList.remove(token);
    } else if (this.hasClass(el, token)) {
      el.className = el.className.replace(new RegExp('(\\s|^)' + token + '(\\s|$)'), ' ').replace(/^\s+|\s+$/g, '');
    }
  }
});

/***/ }),

/***/ "ttyz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("9C8M");
var validate = __webpack_require__("LIJb");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("qo66")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "u2KI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("O4R0"), __esModule: true };

/***/ }),

/***/ "uFh6":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "uk2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var forEach                 = __webpack_require__("dbB1").forEach;
var elementUtilsMaker       = __webpack_require__("p1oW");
var listenerHandlerMaker    = __webpack_require__("dUh9");
var idGeneratorMaker        = __webpack_require__("CGCf");
var idHandlerMaker          = __webpack_require__("601f");
var reporterMaker           = __webpack_require__("Og1S");
var browserDetector         = __webpack_require__("Saiw");
var batchProcessorMaker     = __webpack_require__("GpqH");
var stateHandler            = __webpack_require__("+1cx");

//Detection strategies.
var objectStrategyMaker     = __webpack_require__("SKY5");
var scrollStrategyMaker     = __webpack_require__("S1QW");

function isCollection(obj) {
    return Array.isArray(obj) || obj.length !== undefined;
}

function toArray(collection) {
    if (!Array.isArray(collection)) {
        var array = [];
        forEach(collection, function (obj) {
            array.push(obj);
        });
        return array;
    } else {
        return collection;
    }
}

function isElement(obj) {
    return obj && obj.nodeType === 1;
}

/**
 * @typedef idHandler
 * @type {object}
 * @property {function} get Gets the resize detector id of the element.
 * @property {function} set Generate and sets the resize detector id of the element.
 */

/**
 * @typedef Options
 * @type {object}
 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
                                    If not provided, a default id handler will be used.
 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
                                    If not provided, a default id handler will be used.
                                    If set to false, then nothing will be reported.
 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
 */

/**
 * Creates an element resize detector instance.
 * @public
 * @param {Options?} options Optional global options object that will decide how this instance will work.
 */
module.exports = function(options) {
    options = options || {};

    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var idHandler;

    if (options.idHandler) {
        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
        idHandler = {
            get: function (element) { return options.idHandler.get(element, true); },
            set: options.idHandler.set
        };
    } else {
        var idGenerator = idGeneratorMaker();
        var defaultIdHandler = idHandlerMaker({
            idGenerator: idGenerator,
            stateHandler: stateHandler
        });
        idHandler = defaultIdHandler;
    }

    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var reporter = options.reporter;

    if(!reporter) {
        //If options.reporter is false, then the reporter should be quiet.
        var quiet = reporter === false;
        reporter = reporterMaker(quiet);
    }

    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));

    //Options to be used as default for the listenTo function.
    var globalOptions = {};
    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
    globalOptions.debug         = !!getOption(options, "debug", false);

    var eventListenerHandler    = listenerHandlerMaker(idHandler);
    var elementUtils            = elementUtilsMaker({
        stateHandler: stateHandler
    });

    //The detection strategy to be used.
    var detectionStrategy;
    var desiredStrategy = getOption(options, "strategy", "object");
    var importantCssRules = getOption(options, "important", false);
    var strategyOptions = {
        reporter: reporter,
        batchProcessor: batchProcessor,
        stateHandler: stateHandler,
        idHandler: idHandler,
        important: importantCssRules
    };

    if(desiredStrategy === "scroll") {
        if (browserDetector.isLegacyOpera()) {
            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
            desiredStrategy = "object";
        } else if (browserDetector.isIE(9)) {
            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
            desiredStrategy = "object";
        }
    }

    if(desiredStrategy === "scroll") {
        detectionStrategy = scrollStrategyMaker(strategyOptions);
    } else if(desiredStrategy === "object") {
        detectionStrategy = objectStrategyMaker(strategyOptions);
    } else {
        throw new Error("Invalid strategy name: " + desiredStrategy);
    }

    //Calls can be made to listenTo with elements that are still being installed.
    //Also, same elements can occur in the elements list in the listenTo function.
    //With this map, the ready callbacks can be synchronized between the calls
    //so that the ready callback can always be called when an element is ready - even if
    //it wasn't installed from the function itself.
    var onReadyCallbacks = {};

    /**
     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
     * @public
     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
     * @param {function} listener The callback to be executed for each resize event for each element.
     */
    function listenTo(options, elements, listener) {
        function onResizeCallback(element) {
            var listeners = eventListenerHandler.get(element);
            forEach(listeners, function callListenerProxy(listener) {
                listener(element);
            });
        }

        function addListener(callOnAdd, element, listener) {
            eventListenerHandler.add(element, listener);

            if(callOnAdd) {
                listener(element);
            }
        }

        //Options object may be omitted.
        if(!listener) {
            listener = elements;
            elements = options;
            options = {};
        }

        if(!elements) {
            throw new Error("At least one element required.");
        }

        if(!listener) {
            throw new Error("Listener required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        var elementsReady = 0;

        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
        var onReadyCallback = getOption(options, "onReady", function noop() {});
        var debug = getOption(options, "debug", globalOptions.debug);

        forEach(elements, function attachListenerToElement(element) {
            if (!stateHandler.getState(element)) {
                stateHandler.initState(element);
                idHandler.set(element);
            }

            var id = idHandler.get(element);

            debug && reporter.log("Attaching listener to element", id, element);

            if(!elementUtils.isDetectable(element)) {
                debug && reporter.log(id, "Not detectable.");
                if(elementUtils.isBusy(element)) {
                    debug && reporter.log(id, "System busy making it detectable");

                    //The element is being prepared to be detectable. Do not make it detectable.
                    //Just add the listener, because the element will soon be detectable.
                    addListener(callOnAdd, element, listener);
                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
                    onReadyCallbacks[id].push(function onReady() {
                        elementsReady++;

                        if(elementsReady === elements.length) {
                            onReadyCallback();
                        }
                    });
                    return;
                }

                debug && reporter.log(id, "Making detectable...");
                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
                elementUtils.markBusy(element, true);
                return detectionStrategy.makeDetectable({ debug: debug, important: importantCssRules }, element, function onElementDetectable(element) {
                    debug && reporter.log(id, "onElementDetectable");

                    if (stateHandler.getState(element)) {
                        elementUtils.markAsDetectable(element);
                        elementUtils.markBusy(element, false);
                        detectionStrategy.addListener(element, onResizeCallback);
                        addListener(callOnAdd, element, listener);

                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
                        // so that a resize event may be emitted.
                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
                        var state = stateHandler.getState(element);
                        if (state && state.startSize) {
                            var width = element.offsetWidth;
                            var height = element.offsetHeight;
                            if (state.startSize.width !== width || state.startSize.height !== height) {
                                onResizeCallback(element);
                            }
                        }

                        if(onReadyCallbacks[id]) {
                            forEach(onReadyCallbacks[id], function(callback) {
                                callback();
                            });
                        }
                    } else {
                        // The element has been unisntalled before being detectable.
                        debug && reporter.log(id, "Element uninstalled before being detectable.");
                    }

                    delete onReadyCallbacks[id];

                    elementsReady++;
                    if(elementsReady === elements.length) {
                        onReadyCallback();
                    }
                });
            }

            debug && reporter.log(id, "Already detecable, adding listener.");

            //The element has been prepared to be detectable and is ready to be listened to.
            addListener(callOnAdd, element, listener);
            elementsReady++;
        });

        if(elementsReady === elements.length) {
            onReadyCallback();
        }
    }

    function uninstall(elements) {
        if(!elements) {
            return reporter.error("At least one element is required.");
        }

        if (isElement(elements)) {
            // A single element has been passed in.
            elements = [elements];
        } else if (isCollection(elements)) {
            // Convert collection to array for plugins.
            // TODO: May want to check so that all the elements in the collection are valid elements.
            elements = toArray(elements);
        } else {
            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
        }

        forEach(elements, function (element) {
            eventListenerHandler.removeAllListeners(element);
            detectionStrategy.uninstall(element);
            stateHandler.cleanState(element);
        });
    }

    function initDocument(targetDocument) {
        detectionStrategy.initDocument && detectionStrategy.initDocument(targetDocument);
    }

    return {
        listenTo: listenTo,
        removeListener: eventListenerHandler.removeListener,
        removeAllListeners: eventListenerHandler.removeAllListeners,
        uninstall: uninstall,
        initDocument: initDocument
    };
};

function getOption(options, name, defaultValue) {
    var value = options[name];

    if((value === undefined || value === null) && defaultValue !== undefined) {
        return defaultValue;
    }

    return value;
}


/***/ }),

/***/ "uqUo":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("kM2E");
var core = __webpack_require__("FeBl");
var fails = __webpack_require__("S82l");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "us/S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Xd32"), __esModule: true };

/***/ }),

/***/ "v1IJ":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("1J88"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),

/***/ "v5o6":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return FastClick;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "vGyT":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("kM2E");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("S82l")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "vIB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("O4g8");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var hide = __webpack_require__("hJx8");
var Iterators = __webpack_require__("/bQp");
var $iterCreate = __webpack_require__("94VQ");
var setToStringTag = __webpack_require__("e6n0");
var getPrototypeOf = __webpack_require__("PzxK");
var ITERATOR = __webpack_require__("dSzd")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "vLYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (self, name) {
  if (self.$parent && typeof self.$parent[name] !== 'undefined') {
    return self.$parent[name];
  }
  if (self.$parent && self.$parent.$parent && typeof self.$parent.$parent[name] !== 'undefined') {
    return self.$parent.$parent[name];
  }
});

/***/ }),

/***/ "wEtr":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gSvA");
module.exports = __webpack_require__("FeBl").Object.entries;


/***/ }),

/***/ "wj1U":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("Ff/Y"), __webpack_require__("PIk1"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),

/***/ "wmxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var i in styles) {
    if (typeof styles[i] === 'undefined') {
      delete styles[i];
    }
  }
  return styles;
});

/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V3tA"), __esModule: true };

/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "x067":
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__("02Hb"), __webpack_require__("1J88"), __webpack_require__("QA75"));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),

/***/ "xGkn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("4mcu");
var step = __webpack_require__("EGZi");
var Iterators = __webpack_require__("/bQp");
var toIObject = __webpack_require__("TcQ7");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("vIB/")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "xH/j":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("hJx8");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "xNvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
  },

  methods: {
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    }
  }
});

/***/ }),

/***/ "xaZU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "y1vT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yEsh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("K6ED");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "yI0F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("AU64"), __esModule: true };

/***/ }),

/***/ "ydVi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_js__ = __webpack_require__("cGG2");







/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

__WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(function (code) {
  descriptors[code] = { value: code };
});

__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_define_properties___default()(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', { value: true });

// eslint-disable-next-line func-names
AxiosError.from = function (error, code, config, request, response, customProps) {
  var axiosError = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(prototype);

  __WEBPACK_IMPORTED_MODULE_3__utils_js__["a" /* default */].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, function (prop) {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ __webpack_exports__["a"] = (AxiosError);

/***/ }),

/***/ "z2B9":
/***/ (function(module, exports) {

module.exports = (function () {
    var STRINGS_SAMSUNG = 'Samsung',
        STRINGS_SHARP = 'Sharp',
        STRINGS_SONY_ERICSSON = 'Sony Ericsson',
        STRINGS_MOTOROLA = 'Motorola',
        STRINGS_LG = 'LG',
        STRINGS_HUAWEI = 'Huawei',
        STRINGS_HTC = 'HTC',
        STRINGS_COOLPAD = 'Coolpad',
        STRINGS_ASUS = 'Asus',
        STRINGS_ACER = 'Acer';
    var STRINGS_BASED = ' based device';

    var TOUCHWIZ_MODELS = {
        'SAMSUNG': {
            'GT-S3370C': [STRINGS_SAMSUNG, 'Corby 3G'],
            'GT-S3650': [STRINGS_SAMSUNG, 'Corby'],
            'GT-S3653': [STRINGS_SAMSUNG, 'Corby'],
            'GT-S3850': [STRINGS_SAMSUNG, 'Corby II'],
            'GT-S5230': [STRINGS_SAMSUNG, 'Star'],
            'GT-S5230W': [STRINGS_SAMSUNG, 'Star'],
            'GT-S5233': [STRINGS_SAMSUNG, 'Star'],
            'GT-S5260': [STRINGS_SAMSUNG, 'Star II'],
            'GT-S5560': [STRINGS_SAMSUNG, 'Marvel'],
            'GT-S5620': [STRINGS_SAMSUNG, 'Monte'],
            'GT-S7550': [STRINGS_SAMSUNG, 'Blue Earth'],
            'GT-S8000': [STRINGS_SAMSUNG, 'Jet'],
            'GT-S8003': [STRINGS_SAMSUNG, 'Jet'],
            'SGH-F480': [STRINGS_SAMSUNG, 'Tocco'],
            'SGH-T528g': [STRINGS_SAMSUNG, 'Straight Talk'],
            'GT-B3410': [STRINGS_SAMSUNG, 'Star Qwerty'],
            'GT-B5310': [STRINGS_SAMSUNG, 'Corby Pro'],
            'GT-B7722': [STRINGS_SAMSUNG, 'Star Duos'],
            'GT-C6712': [STRINGS_SAMSUNG, 'Star II Duos']
        }
    }

    var BADA_MODELS = {
        'SAMSUNG': {
            'GT- S5250': [STRINGS_SAMSUNG, 'Wave 525'],
            'GT-S5250': [STRINGS_SAMSUNG, 'Wave 525'],
            'GT-S5253': [STRINGS_SAMSUNG, 'Wave 525'],
            'GT-S5330': [STRINGS_SAMSUNG, 'Wave 533'],
            'GT-S5380': [STRINGS_SAMSUNG, 'Wave Y'],
            'GT-S5380D': [STRINGS_SAMSUNG, 'Wave Y'],
            'GT-S5380K': [STRINGS_SAMSUNG, 'Wave Y'],
            'GT-S5750E': [STRINGS_SAMSUNG, 'Wave 575'],
            'GT-S5753E': [STRINGS_SAMSUNG, 'Wave 575'],
            'GT-S7230B': [STRINGS_SAMSUNG, 'Wave 723'],
            'GT-S7230E': [STRINGS_SAMSUNG, 'Wave 723'],
            'GT-S7233E': [STRINGS_SAMSUNG, 'Wave 723'],
            'GT-S7250': [STRINGS_SAMSUNG, 'Wave M'],
            'GT-S7250D': [STRINGS_SAMSUNG, 'Wave M'],
            'GT-S8500': [STRINGS_SAMSUNG, 'Wave'],
            'GT-S8500C': [STRINGS_SAMSUNG, 'Wave'],
            'GT-S8500R': [STRINGS_SAMSUNG, 'Wave'],
            'GT-S8500T': [STRINGS_SAMSUNG, 'Wave'],
            'GT-S8530': [STRINGS_SAMSUNG, 'Wave II'],
            'GT-S8600': [STRINGS_SAMSUNG, 'Wave 3'],
            'SHW-M410': [STRINGS_SAMSUNG, 'Wave 3']
        }
    }

    var TIZEN_MODELS = {
        'SAMSUNG': {
            'GT-I9500': [STRINGS_SAMSUNG, 'GT-I9500']
        }
    }

    var BREW_MODELS = {
        'Coolpad D508': [STRINGS_COOLPAD, 'D508'],
        'Coolpad E600': [STRINGS_COOLPAD, 'E600'],
        'SCH-F839': [STRINGS_SAMSUNG, 'SCH-F839']
    }

    var WINDOWS_MOBILE_MODELS = {
        'DX900': [STRINGS_ACER, 'Tempo DX900'],
        'F900': [STRINGS_ACER, 'Tempo F900'],
        'Coolpad F800': [STRINGS_COOLPAD, 'F800'],
        'garmin-asus-Nuvifone-M10': ['Garmin-Asus', 'Nuvifone M10'],
        'HP iPAQ 510': ['HP', 'iPAQ 510'],
        'HD mini T5555': [STRINGS_HTC, 'HD mini'],
        'HTC HD mini': [STRINGS_HTC, 'HD mini'],
        'HTC HD mini T5555': [STRINGS_HTC, 'HD mini'],
        'HTC HD2': [STRINGS_HTC, 'HD2'],
        'HTC HD2 T8585': [STRINGS_HTC, 'HD2'],
        'HD2 T8585': [STRINGS_HTC, 'HD2'],
        'T-Mobile LEO': [STRINGS_HTC, 'HD2'],
        'dopodT5588': [STRINGS_HTC, 'Hengshan'],
        'HTC Mega-T3333': [STRINGS_HTC, 'Mega'],
        'HTC Snap S521': [STRINGS_HTC, 'Snap'],
        'HTC Touch2 T3320': [STRINGS_HTC, 'Touch 2'],
        'HTC Touch2 T3333': [STRINGS_HTC, 'Touch 2'],
        'HTC Touch2 T3335': [STRINGS_HTC, 'Touch 2'],
        'HTC P3700': [STRINGS_HTC, 'Touch Diamond'],
        'HTC Touch Diamond2 T5353': [STRINGS_HTC, 'Touch Diamond 2'],
        'HTC Touch HD T8282': [STRINGS_HTC, 'Touch HD'],
        'HTC Touch HD T8283': [STRINGS_HTC, 'Touch HD'],
        'HTC Touch HD2 T8585': [STRINGS_HTC, 'Touch HD2'],
        'HTC Touch Pro2 T7373': [STRINGS_HTC, 'Touch Pro 2'],
        'T7380': [STRINGS_HTC, 'Touch Pro 2'],
        'HTC TyTN II': [STRINGS_HTC, 'TyTN II'],
        'GT-B7300': [STRINGS_SAMSUNG, 'Omnia Lite'],
        'GT-B7610': [STRINGS_SAMSUNG, 'Omnia Pro'],
        'GT-i8000': [STRINGS_SAMSUNG, 'Omnia 2'],
        'GT-I8000': [STRINGS_SAMSUNG, 'Omnia 2'],
        'GT-I8000U': [STRINGS_SAMSUNG, 'Omnia 2'],
        'M1i': [STRINGS_SONY_ERICSSON, 'M1i Aspen']
    }

    var WINDOWS_PHONE_MODELS = {
        'Acer': {
            'Allegro': [STRINGS_ACER, 'Allegro'],
            'M310': [STRINGS_ACER, 'Allegro']
        },

        'Asus': {
            'Galaxy6': [STRINGS_ASUS, 'Galaxy 6']
        },

        'DELL': {
            'Venue Pro': ['Dell', 'Venue Pro']
        },

        'FujitsuToshibaMobileCommun': {
            'IS12T': ['Fujitsu Toshiba', 'IS12T']
        },

        'HTC': {
            '7 Mozart': [STRINGS_HTC, '7 Mozart'],
            '7 Mozart T8698': [STRINGS_HTC, '7 Mozart'],
            'T8697': [STRINGS_HTC, '7 Mozart'],
            'T8698': [STRINGS_HTC, '7 Mozart'],
            'PD67100': [STRINGS_HTC, '7 Mozart'],
            'Mozart T8698': [STRINGS_HTC, '7 Mozart'],
            'Mozart': [STRINGS_HTC, '7 Mozart'],
            'USCCHTC-PC93100': [STRINGS_HTC, 'Arrive'],
            'Gold': [STRINGS_HTC, 'Gold '],
            'HD2': [STRINGS_HTC, 'HD2'],
            'HD7': [STRINGS_HTC, 'HD7'],
            'HD7 T9292': [STRINGS_HTC, 'HD7'],
            'T9295': [STRINGS_HTC, 'HD7'],
            'T9296': [STRINGS_HTC, 'HD7'],
            'HD7 Infinity': [STRINGS_HTC, 'HD7'],
            'T7575': [STRINGS_HTC, '7 Pro'],
            '7 Pro T7576': [STRINGS_HTC, '7 Pro'],
            'mwp6985': [STRINGS_HTC, 'Trophy'],
            '7 Trophy T8686': [STRINGS_HTC, 'Trophy'],
            '7 Trophy': [STRINGS_HTC, 'Trophy'],
            'PC40100': [STRINGS_HTC, 'Trophy'],
            'Touch-IT Trophy': [STRINGS_HTC, 'Trophy'],
            'Radar': [STRINGS_HTC, 'Radar'],
            'Radar 4G': [STRINGS_HTC, 'Radar'],
            'Radar C110e': [STRINGS_HTC, 'Radar'],
            'Mazaa': [STRINGS_HTC, 'Mazaa'],
            'Mondrian': [STRINGS_HTC, 'Mondrian'],
            'Schubert': [STRINGS_HTC, 'Schubert'],
            '7 Schubert T9292': [STRINGS_HTC, 'Schubert'],
            'Spark': [STRINGS_HTC, 'Spark'],
            'T8788': [STRINGS_HTC, 'Surround'],
            'TITAN X310e': [STRINGS_HTC, 'Titan'],
            'X310e': [STRINGS_HTC, 'Titan'],
            'PI39100': [STRINGS_HTC, 'Titan'],
            'PI86100': [STRINGS_HTC, 'Titan II'],
            'Ultimate': [STRINGS_HTC, 'Ultimate']
        },

        'LG': {
            'GW910': [STRINGS_LG, 'Optimus 7'],
            'LG E-900': [STRINGS_LG, 'Optimus 7 E900'],
            'LG-E900': [STRINGS_LG, 'Optimus 7 E900'],
            'LG-E900h': [STRINGS_LG, 'Optimus 7 E900'],
            'LG-C900': [STRINGS_LG, 'Optimus 7Q'],
            'LG-C900B': [STRINGS_LG, 'Quantum'],
            'LG-C900k': [STRINGS_LG, 'Quantum']
        },

        'nokia': {
            'SeaRay': ['Nokia', 'Lumia 800'],
            '800C': ['Nokia', 'Lumia 800']
        },

        'NOKIA': {
            '710': ['Nokia', 'Lumia 710'],
            'Nokia 710': ['Nokia', 'Lumia 710'],
            'Lumia 710': ['Nokia', 'Lumia 710'],
            'Lumia 719': ['Nokia', 'Lumia 719'],
            'Lumia 800': ['Nokia', 'Lumia 800'],
            '800': ['Nokia', 'Lumia 800'],
            'Lumia 900': ['Nokia', 'Lumia 900'],
            'XXX': ['Nokia', 'prototype']
        },

        'SAMSUNG': {
            'GT-I8350': [STRINGS_SAMSUNG, 'Omnia W'],
            'GT-I8350T': [STRINGS_SAMSUNG, 'Omnia W'],
            'SGH-i677': [STRINGS_SAMSUNG, 'Focus Flash'],
            'SGH-i707': [STRINGS_SAMSUNG, 'Taylor'],
            'SGH-i917': [STRINGS_SAMSUNG, 'Omnia 7'],
            'SGH-I917': [STRINGS_SAMSUNG, 'Omnia 7'],
            'SGH-i917.': [STRINGS_SAMSUNG, 'Focus'],
            'SGH-i917R': [STRINGS_SAMSUNG, 'Focus'],
            'SGH-i937': [STRINGS_SAMSUNG, 'Focus S'],
            'OMNIA7': [STRINGS_SAMSUNG, 'Omnia 7'],
            'OMINA7': [STRINGS_SAMSUNG, 'Omnia 7'],
            'Taylor': [STRINGS_SAMSUNG, 'Taylor']
        },

        'TOSHIBA': {
            'TSUNAGI': ['Toshiba', 'Tsunagi']
        }
    };

    var ANDROID_MODELS = {
        'Android': [null, null],
        'google sdk': [null, null],
        'sdk': [null, null],
        'generic': [null, null],
        'generic x86': [null, null],
        'amd brazos': ['AMD', 'Fusionbased device'],
        'Amlogic M1 reference board': ['Amlogic', 'M1 reference board'],
        'AML8726M': ['Amlogic', 'AML8726-Mbased device'],
        'vexpress a9': ['ARM', 'Versatile Express development platform'],
        'bcm7231': ['Broadcom', 'BCM7231based device', 'television'],
        'bcm7425': ['Broadcom', 'BCM7425based device', 'television'],
        'bcm7429': ['Broadcom', 'BCM7429based device', 'television'],
        'imx50 rdp': ['Freescale', 'i.MX50based device'],
        'imx51 bbg': ['Freescale', 'i.MX51based device'],
        'imx53 loco': ['Freescale', 'i.MX53based device'],
        'imx53 mp204f3': ['Freescale', 'i.MX53based device'],
        'imx53 smd': ['Freescale', 'i.MX53based device'],
        'imx53 yeagle': ['Freescale', 'i.MX53based device'],
        'imx6q': ['Freescale', 'i.MX6Qbased device'],
        'ODROID-A': ['Hardkernel', 'ODROID-A developer tablet', 'tablet'],
        'mfld dv10': ['Intel', 'Medfieldbased device'],
        'mfld dv20': ['Intel', 'Medfieldbased device'],
        'mfld lw00': ['Intel', 'Medfieldbased device'],
        'mfld pr2': ['Intel', 'Medfieldbased device'],
        'mfld pr3': ['Intel', 'Medfieldbased device'],
        'berlin bg2': ['Marvell', 'Armada 1000based device', 'television'],
        'MStar Amber3': ['MStar', 'Amber3based device'],
        'Konka Amber3': ['MStar', 'Amber3based device'],
        'mt5396': ['Mediatek', 'MT5396based device', 'television'],
        'bird75v2': ['Mediatek', 'MT6575based device'],
        'eagle75v1 2': ['Mediatek', 'MT6575based device'],
        'MBX DVBT reference board (c03ref)': ['MXB', 'DVBT reference board', 'television'],
        'NS2816': ['Nufront', 'NuSmart 2816based device'],
        'Ventana': ['nVidia', 'Tegra Ventana development kit'],
        'Cardhu': ['nVidia', 'Tegra 3based device'],
        'Panda': ['Pandaboard', 'Development Kit'],
        'pandaboard': ['Pandaboard', 'Development Kit'],
        'PandaBoard': ['Pandaboard', 'Development Kit'],
        'MSM': ['Qualcomm', 'Snapdragonbased device'],
        'msm7227 ffa': ['Qualcomm', 'Snapdragon S1based device'],
        'msm7627 surf': ['Qualcomm', 'Snapdragon S1based device'],
        'msm7627a': ['Qualcomm', 'Snapdragon S1based device'],
        'msm7627a sku1': ['Qualcomm', 'Snapdragon S1based device'],
        'msm7627a sku3': ['Qualcomm', 'Snapdragon S1based device'],
        'msm7630 fusion': ['Qualcomm', 'Snapdragon S2based device'],
        'msm7630 surf': ['Qualcomm', 'Snapdragon S2based device'],
        'msm8660 cougar': ['Qualcomm', 'Snapdragon S3based device'],
        'msm8660 surf': ['Qualcomm', 'Snapdragon S3based device'],
        'msm8960': ['Qualcomm', 'Snapdragon S4based device'],
        'rk2808sdk': ['Rockchip', 'RK2808based device'],
        'RK2818': ['Rockchip', 'RK2818based device'],
        'rk2818sdk': ['Rockchip', 'RK2818based device'],
        'Android-for-Rockchip-2818': ['Rockchip', 'RK2818based device'],
        'rk29sdk': ['Rockchip', 'RK29based device'],
        'Rk29sdk': ['Rockchip', 'RK29based device'],
        'rk30sdk': ['Rockchip', 'RK30based device'],
        's3c6410': ['Samsung', 'S3C6410based device'],
        'smdk6410': ['Samsung', 'S3C6410based device'],
        'SMDKC110': ['Samsung', 'Exynos 3110based device'],
        'SMDKV210': ['Samsung', 'Exynos 4210based device'],
        'S5PV210': ['Samsung', 'Exynos 4210based device'],
        'sec smdkc210': ['Samsung', 'Exynos 4210based device'],
        'SMDK4x12': ['Samsung', 'Exynos 4212 or 4412based device'],
        'smp86xx': ['Sigma', 'SMP86xxbased device', 'television'],
        'sv8860': ['Skyviia', 'SV8860based device', 'television'],
        'ste u8500': ['ST Ericsson', 'Novathor U8500based device'],
        'Telechips M801 Evaluation Board': ['Telechips', 'M801based device', 'television'],
        'Telechips TCC8900 Evaluation Board': ['Telechips', 'TCC8900based device', 'television'],
        'TCC8920 STB EV': ['Telechips', 'TCC8920based device', 'television'],
        'OMAP': ['Texas Instruments', 'OMAPbased device'],
        'OMAP SS': ['Texas Instruments', 'OMAPbased device'],
        'LogicPD Zoom2': ['Texas Instruments', 'OMAPbased device'],
        'omap3evm': ['Texas Instruments', 'OMAP3based device'],
        'Omap5sevm': ['Texas Instruments', 'OMAP5based device'],
        'pnx8473 kiryung': ['Trident', 'PNX8473based device', 'television'],
        'crespo': ['Google', 'Nexus S'],
        'Crespo': ['Google', 'Nexus S'],
        'Crespo4G': ['Google', 'Nexus S'],
        'Passion': ['Google', 'Nexus One'],
        'Bravo': ['HTC', 'Desire'],
        'dream': ['HTC', 'Dream'],
        'Vogue': ['HTC', 'Touch'],
        'Vendor Optimus': ['LG', 'Optimus'],
        'Stingray': ['Motorola', 'XOOM', 'tablet'],
        'Wingray': ['Motorola', 'XOOM', 'tablet'],
        'maguro': ['Samsung', 'Galaxy Nexus'],
        'Maguro': ['Samsung', 'Galaxy Nexus'],
        'Toro-VZW': ['Samsung', 'Galaxy Nexus'],
        'blaze': ['Texas Instruments', 'Blaze Tablet', 'tablet'],
        'Blaze': ['Texas Instruments', 'Blaze Tablet', 'tablet'],
        'Blaze Tablet': ['Texas Instruments', 'Blaze Tablet', 'tablet'],
        'BlueStacks': ['BlueStacks', 'App Player', 'desktop'],
        'youwave custom': ['Youwave', 'Android on PC', 'desktop'],
        'A100': ['Acer', 'Iconia Tab A100', 'tablet'],
        'A101': ['Acer', 'Iconia Tab A101', 'tablet'],
        'A200': ['Acer', 'Iconia Tab A200', 'tablet'],
        'A500': ['Acer', 'Iconia Tab A500', 'tablet'],
        'A501': ['Acer', 'Iconia Tab A501', 'tablet'],
        'A510': ['Acer', 'Iconia Tab A510', 'tablet'],
        'A511': ['Acer', 'Iconia Tab A511', 'tablet'],
        'A700': ['Acer', 'Iconia Tab A700', 'tablet'],
        'Acer A800': ['Acer', 'Iconia Tab A800', 'tablet'],
        'E110': ['Acer', 'beTouch E110'],
        'E120': ['Acer', 'beTouch E120'],
        'E130': ['Acer', 'beTouch E130'],
        'E140': ['Acer', 'beTouch E140'],
        'E210': ['Acer', 'beTouch E210'],
        'E310': ['Acer', 'Liquid mini'],
        'E320': ['Acer', 'Liquid Express'],
        'E330': ['Acer', 'Liquid Glow'],
        'E400': ['Acer', 'beTouch E400'],
        'G100W': ['Acer', 'G100W'],
        'S100': ['Acer', 'Liquid'],
        'S110': ['Acer', 'Stream'],
        'S120': ['Acer', 'Liquid mt'],
        'S300': ['Acer', 'Iconia Smart'],
        'S500': ['Acer', 'CloudMobile'],
        'TD600': ['Acer', 'beTouch TD600'],
        'Liquid': ['Acer', 'Liquid'],
        'Liquid E': ['Acer', 'Liquid E'],
        'Liquid Mt': ['Acer', 'Liquid mt'],
        'Liquid MT': ['Acer', 'Liquid mt'],
        'Liquid Metal': ['Acer', 'Liquid mt'],
        'Stream': ['Acer', 'Stream'],
        'N700': ['aigo', 'N700', 'tablet'],
        'M801': ['aigo', 'M801', 'tablet'],
        'Novo7': ['Ainovo', 'Novo7', 'tablet'],
        'Novo7 Aurora': ['Ainovo', 'Novo7 Aurora', 'tablet'],
        'Novo7 Advanced': ['Ainovo', 'Novo7 Advanced', 'tablet'],
        'Novo7 Advanced2': ['Ainovo', 'Novo7 Advanced 2', 'tablet'],
        'Novo7 Basic': ['Ainovo', 'Novo7 Basic', 'tablet'],
        'Novo7 ELF': ['Ainovo', 'Novo7 Elf', 'tablet'],
        'Novo7 PALADIN': ['Ainovo', 'Novo7 Paladin', 'tablet'],
        'Novo8 Advanced': ['Ainovo', 'Novo8 Advanced', 'tablet'],
        'one touch 890': ['Alcatel', 'One Touch 890'],
        'one touch 890D': ['Alcatel', 'One Touch 890'],
        'one touch 891': ['Alcatel', 'One Touch 891'],
        'ONE TOUCH 903': ['Alcatel', 'One Touch 903SHV-E170K'],
        'one touch 906': ['Alcatel', 'One Touch 906'],
        'one touch 908': ['Alcatel', 'One Touch 908'],
        'one touch 908F': ['Alcatel', 'One Touch 908'],
        'one touch 908S': ['Alcatel', 'One Touch 908'],
        'one touch 910': ['Alcatel', 'One Touch 910'],
        'one touch 918': ['Alcatel', 'One Touch 918'],
        'one touch 918D': ['Alcatel', 'One Touch 918'],
        'ONE TOUCH 918D': ['Alcatel', 'One Touch 918'],
        'one touch 918M': ['Alcatel', 'One Touch 918'],
        'one touch 918N': ['Alcatel', 'One Touch 918'],
        'one touch 980': ['Alcatel', 'One Touch 980'],
        'one touch 980A': ['Alcatel', 'One Touch 980'],
        'one touch 981A': ['Alcatel', 'One Touch 981'],
        'one touch 986': ['Alcatel', 'One Touch 986'],
        'one touch 990': ['Alcatel', 'One Touch 990'],
        'one touch 990A': ['Alcatel', 'One Touch 990'],
        'one touch 991': ['Alcatel', 'One Touch 991'],
        'one touch 991D': ['Alcatel', 'One Touch 991'],
        'ONE TOUCH 993': ['Alcatel', 'One Touch 993'],
        'one touch 995': ['Alcatel', 'One Touch 995'],
        'Telenor OneTouch': ['Alcatel', 'One Touch 990'],
        'OT 918': ['Alcatel', 'One Touch 918'],
        'Venture': ['Alcatel', 'Venture'],
        'Allwinner A10': ['AllWinner', 'A10', 'tablet'],
        '97FC': ['AllWinner', 'A10 97FC', 'tablet'],
        'Kindle Fire': ['Amazon', 'Kindle Fire', 'tablet'],
        'Amazon Kindle Fire': ['Amazon', 'Kindle Fire', 'tablet'],
        'AMD120': ['AnyDATA', 'AnyTAB AMD120', 'tablet'],
        'MW0811': ['AOC', 'Breeze MW0811', 'tablet'],
        'MW0821 V2.0': ['AOC', 'Breeze MW0821', 'tablet'],
        'MW0922': ['AOC', 'Breeze MW0922', 'tablet'],
        'Apanda A60': ['Apanda', 'A60'],
        'apanda-A60': ['Apanda', 'A60'],
        'A80KSC': ['Archos', 'Arnova 8', 'tablet'],
        'AN7CG2': ['Archos', 'Arnova 7', 'tablet'],
        'A101B': ['Archos', 'Arnova 10', 'tablet'],
        'AN10BG2DT': ['Archos', 'Arnova 10 B', 'tablet'],
        'AN10G2': ['Archos', 'Arnova 10 G2', 'tablet'],
        'A32': ['Archos', '32', 'media'],
        'A35DE': ['Archos', '35 Smart Home Phone'],
        'A43': ['Archos', '43', 'media'],
        'Archos5': ['Archos', '5', 'media'],
        'A70H': ['Archos', '7', 'tablet'],
        'A70HB': ['Archos', '7', 'tablet'],
        'A70BHT': ['Archos', '7', 'tablet'],
        'A70CHT': ['Archos', '7C', 'tablet'],
        'A70S': ['Archos', '70', 'tablet'],
        'A7EB': ['Archos', '70B', 'tablet'],
        'ARCHOS 70it2': ['Archos', '70 IT 2', 'tablet'],
        'ARCHOS 80G9': ['Archos', '80 G9', 'tablet'],
        'ARCHOS 101G9': ['Archos', '101 G9', 'tablet'],
        'A101IT': ['Archos', '101 IT', 'tablet'],
        'ASTRI': ['ASTRI', 'e-reader', 'ereader'],
        'eeepc': ['Asus', 'Eee Pc'],
        'asus laptop': ['Asus', 'Eee Pc'],
        'ME171': ['Asus', 'Eee Pad MeMO', 'tablet'],
        'Slider SL101': ['Asus', 'Eee Pad Slider', 'tablet'],
        'EPAD': ['Asus', 'Eee Pad Transformer', 'tablet'],
        'TF101': ['Asus', 'Eee Pad Transformer', 'tablet'],
        'Transformer TF101': ['Asus', 'Eee Pad Transformer', 'tablet'],
        'Transformer TF101G': ['Asus', 'Eee Pad Transformer', 'tablet'],
        'TF201': ['Asus', 'Eee Pad Transformer Prime', 'tablet'],
        'Transformer Prime TF201': ['Asus', 'Eee Pad Transformer Prime', 'tablet'],
        'Transformer Prime': ['Asus', 'Eee Pad Transformer Prime', 'tablet'],
        'Transformer Pad TF300T': ['Asus', 'Transformer Pad 300', 'tablet'],
        'ASUS Transformer TF300T': ['Asus', 'Transformer Pad 300', 'tablet'],
        'ASUS Transformer Pad TF300T': ['Asus', 'Transformer Pad 300', 'tablet'],
        'ASUS Transformer Pad TF300TG': ['Asus', 'Transformer Pad 300', 'tablet'],
        'ASUS Transformer Pad TF700T': ['Asus', 'Transformer Pad Infinity 700', 'tablet'],
        'ASUS Transformer Pad TF700K': ['Asus', 'Transformer Pad Infinity 700', 'tablet'],
        'ASUS Transformer TF700K': ['Asus', 'Transformer Pad Infinity 700', 'tablet'],
        'PadFone': ['Asus', 'Padfone', 'tablet'],
        'OMS TTD': ['Asus', 'Eee Pc T10'],
        'ASUS T20': ['Asus', 'Eee Pc T20'],
        'ETBW11AA': ['Asus', 'Tough'],
        'AUX V900': ['AUX', 'V900'],
        'M910A': ['AUX', 'M910'],
        'PICOpad-QGN': ['Axioo', 'Picopad QGN', 'tablet'],
        'NOOK': ['Barnes & Noble', 'NOOK', 'ereader'],
        'NookColor': ['Barnes & Noble', 'NOOK Color', 'ereader'],
        'NOOK BNRV200': ['Barnes & Noble', 'NOOK Color', 'ereader'],
        'NOOK BNRV300': ['Barnes & Noble', 'NOOK Color', 'ereader'],
        'NookTablet': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'Nook Tablet': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'NOOK BNTV250': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'NOOK BNTV250A': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'BNTV250': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'BNTV250A': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'NOOK Slate': ['Barnes & Noble', 'NOOK Tablet', 'ereader'],
        'BenWee 5100': ['BenWee', '5100'],
        'CA907AAC0G': ['Besta', 'CA907AAC0G'],
        'BM999': ['Bmorn', 'BM999', 'tablet'],
        'V11': ['Bmorn', 'V11', 'tablet'],
        'V99': ['Bmorn', 'V99', 'tablet'],
        'bq DaVinci': ['bq', 'DaVinci', 'tablet'],
        'CT704': ['Carrefour', 'CT704', 'tablet'],
        'CT1002': ['Carrefour', 'CT1002', 'tablet'],
        'Camangi-Mangrove7': ['Camangi', 'Mangrove 7', 'tablet'],
        'WS171': ['Camangi', 'WebStation', 'tablet'],
        'IS11CA': ['Casio', 'GzOne IS11CA'],
        'C771': ['Casio', 'GzOne Commando'],
        'CAT NOVA': ['Cat', 'NOVA', 'tablet'],
        'ARMM3V': ['chinaleap', 'ARMM3V', 'tablet'],
        'CIUS-7': ['Cisco', 'Cius', 'tablet'],
        'CIUS-7-AT': ['Cisco', 'Cius', 'tablet'],
        'CSL Spice MI300': ['CSL', 'Spice MI300'],
        'CSL-MI410': ['CSL', 'Spice MI410'],
        'MID1024': ['Coby', 'Kyros MID1024', 'tablet'],
        'MID1125': ['Coby', 'Kyros MID1125', 'tablet'],
        'MID1126': ['Coby', 'Kyros MID1126', 'tablet'],
        'MID7010': ['Coby', 'Kyros MID7010', 'tablet'],
        'MID7012': ['Coby', 'Kyros MID7012', 'tablet'],
        'MID7015': ['Coby', 'Kyros MID7015', 'tablet'],
        'MID7015A': ['Coby', 'Kyros MID7015', 'tablet'],
        'MID7016': ['Coby', 'Kyros MID7016', 'tablet'],
        'MID7020': ['Coby', 'Kyros MID7020', 'tablet'],
        'MID7022': ['Coby', 'Kyros MID7022', 'tablet'],
        'MID7024': ['Coby', 'Kyros MID7024', 'tablet'],
        'MID7025': ['Coby', 'Kyros MID7025', 'tablet'],
        'MID7127': ['Coby', 'Kyros MID7127', 'tablet'],
        'MID8024': ['Coby', 'Kyros MID8024', 'tablet'],
        'MID8125': ['Coby', 'Kyros MID8125', 'tablet'],
        'MID8127': ['Coby', 'Kyros MID8127', 'tablet'],
        'Z71': ['Commtiva', 'Z71'],
        'V-T100': ['Commtiva', 'V-T100'],
        'FIH-FB0': ['Commtiva', 'HD700'],
        'Coolpad D510': ['Coolpad', 'D510'],
        'Coolpad 8020': ['Coolpad', '8020'],
        'D530': ['Coolpad', 'D530'],
        'Coolpad D530': ['Coolpad', 'D530'],
        'D539': ['Coolpad', 'D539'],
        'Coolpad D539': ['Coolpad', 'D539'],
        'E239': ['Coolpad', 'E239'],
        'Coolpad E239': ['Coolpad', 'E239'],
        'Coolpad N930': ['Coolpad', 'N930'],
        'N930': ['Coolpad', 'N930'],
        'Coolpad W706': ['Coolpad', 'W706'],
        'Coolpad W706+': ['Coolpad', 'W706'],
        'Coolpad W708': ['Coolpad', 'W708'],
        'W711': ['Coolpad', 'W711'],
        'Coolpad 5010': ['Coolpad', '5010'],
        'Coolpad 5210': ['Coolpad', '5210'],
        'Coolpad 5820': ['Coolpad', '5820'],
        '5832': ['Coolpad', '5832'],
        'Coolpad 5832': ['Coolpad', '5832'],
        '5855': ['Coolpad', '5855'],
        'Coolpad 5860': ['Coolpad', '5860'],
        'Coolpad 5860+': ['Coolpad', '5860'],
        'Coolpad 5860s': ['Coolpad', '5860'],
        '5860': ['Coolpad', '5860'],
        '5860A': ['Coolpad', '5860'],
        'Coolpad 5870': ['Coolpad', '5870'],
        '5870': ['Coolpad', '5870'],
        'Coolpad 7005': ['Coolpad', '7005'],
        '7260': ['Coolpad', '7260'],
        'Coolpad 7019': ['Coolpad', '7019'],
        'Coolpad 7260': ['Coolpad', '7260'],
        'Coolpad 8013': ['Coolpad', '8013'],
        'Coolpad 8809': ['Coolpad', '8809'],
        'Coolpad 8810': ['Coolpad', '8810'],
        '8810': ['Coolpad', '8810'],
        '8150': ['Coolpad', '8150'],
        'Coolpad 8150D': ['Coolpad', '8150'],

        'Coolpad 8811': ['Coolpad', '8811'],
        'Coolpad 9900': ['Coolpad', '9900'],
        'Coolpad 8050': ['Coolpad', '8050'],
        'ZiiO7': ['Creative', 'ZiiO 7', 'tablet'],
        'ZiiLABS ZiiO7': ['Creative', 'ZiiO 7', 'tablet'],
        'ZiiLABS ZiiO10 ': ['Creative', 'ZiiO 10', 'tablet'],
        'CUBE K8GT A': ['Cube', 'K8GT A', 'tablet'],
        'CUBE K8GT B': ['Cube', 'K8GT B', 'tablet'],
        'K8GT C': ['Cube', 'K8GT C', 'tablet'],
        'K8GT H': ['Cube', 'K8GT H', 'tablet'],
        'CUBE K8GT H': ['Cube', 'K8GT H', 'tablet'],
        'K8GT W': ['Cube', 'K8GT W', 'tablet'],
        'CUBE U8GT': ['Cube', 'U8GT', 'tablet'],
        'CUBE U9GT': ['Cube', 'U9GT', 'tablet'],
        'CUBE U9GT 2': ['Cube', 'U9GT 2', 'tablet'],
        'Cube U9GT2': ['Cube', 'U9GT 2', 'tablet'],
        'U9GT': ['Cube', 'U9GT', 'tablet'],
        'U9GT2 From moage.com': ['Cube', 'U9GT 2', 'tablet'],
        'N90 From moage.com': ['Cube', 'U9GT 2', 'tablet'],
        'U9GT S': ['Cube', 'U9GT S', 'tablet'],
        'U9GT S A': ['Cube', 'U9GT SA', 'tablet'],
        'U9GTS A': ['Cube', 'U9GT SA', 'tablet'],
        'U10GT 2': ['Cube', 'U10GT 2', 'tablet'],
        'U10GT S': ['Cube', 'U10GT S', 'tablet'],
        'U30GT-H': ['Cube', 'U30GT H', 'tablet'],
        'CUBE Q7PRO': ['Cube', 'Q7 Pro', 'tablet'],
        'CUBE Q7PRO J': ['Cube', 'Q7 Pro', 'tablet'],
        'Cydle M7 (v0005.04.03.12.ko)': ['Cydle', 'M7 MultiPAD', 'tablet'],
        'Dell Aero': ['Dell', 'Aero'],
        'Dell M01M': ['Dell', 'Mini 5', 'tablet'],
        'Dell Streak': ['Dell', 'Streak', 'tablet'],
        '001DL': ['Dell', 'Streak', 'tablet'],
        '101DL': ['Dell', 'Streak Pro', 'tablet'],
        'GS01': ['Dell', 'Streak Pro', 'tablet'],
        'Dell Streak Pro': ['Dell', 'Streak Pro', 'tablet'],
        'streak7': ['Dell', 'Streak 7', 'tablet'],
        'Dell Streak 7': ['Dell', 'Streak 7', 'tablet'],
        'Dell Streak 10 Pro': ['Dell', 'Streak 10 Pro', 'tablet'],
        'Dell V04B': ['Dell', 'Streak V04B', 'tablet'],
        'Dell Venue': ['Dell', 'Venue'],
        'Dell XCD35': ['Dell', 'XCD35'],
        'XCD35': ['Dell', 'XCD35'],
        'iDx7': ['Digma', 'iDx7', 'tablet'],
        'iDx10': ['Digma', 'iDx10', 'tablet'],
        'iDx10 3G': ['Digma', 'iDx10', 'tablet'],
        'DM009SH': ['Disney Mobile', 'DM009SH'],
        'DM010SH': ['Disney Mobile', 'DM010SH'],
        'DM012SH': ['Disney Mobile', 'DM012SH'],
        'F-08D': ['Disney Mobile', 'F-08D'],
        'P-05D': ['Disney Mobile', 'P-05D'],
        'Tablet-P27': ['DracoTek', 'P27 Tablet', 'tablet'],
        'edgejr': ['EnTourage', 'Pocket eDGe', 'tablet'],
        'l97D': ['EPad', 'l97D', 'tablet'],
        'M4301': ['Eston', 'MID M4301', 'media'],
        'P10AN': ['Exper', 'Easypad P10AN', 'tablet'],
        'FIH-F0X': ['FIH', 'F0X'],
        'Fly IQ260': ['Fly', 'IQ260 BlackBird'],
        'ISW11F': ['Fujitsu', 'Arrows Z'],
        'ISW13F': ['Fujitsu', 'Arrows Z'],
        'IS12F': ['Fujitsu', 'Arrows ES'],
        'F-01D': ['Fujitsu', 'Arrows Tab LTE', 'tablet'],
        'F-03D': ['Fujitsu', 'Arrows Kiss'],
        'F-05D': ['Fujitsu', 'Arrows X LTE'],
        'F-07D': ['Fujitsu', 'Arrows \u00c3\ufffd\u00c2\u00bc'],
        'F-10D': ['Fujitsu', 'Arrows X F-10D'],
        'F-12C': ['Fujitsu', 'Globetrotter'],
        'f12arc': ['Fujitsu', 'F12arc'],
        'M532': ['Fujitsu', 'Stylistic M532', 'tablet'],
        'Garminfone': ['Garmin-Asus', 'Garminfone'],
        'Garmin-Asus A10': ['Garmin-Asus', 'Nuvifone A10'],
        'Garmin-Asus A50': ['Garmin-Asus', 'Nuvifone A50'],
        'TPA60W': ['Gateway', 'TPA60W', 'tablet'],
        'Geeksphone ZERO': ['Geeksphone', 'ZERO'],
        'gemei G2': ['Gemei', 'G2', 'tablet'],
        'Gemei G2': ['Gemei', 'G2', 'tablet'],
        'gemei G3': ['Gemei', 'G3', 'tablet'],
        'Gemei G9': ['Gemei', 'G9', 'tablet'],
        'GSmart G1317D': ['Gigabyte', 'GSmart G1317D'],
        'Gigabyte TB100': ['Gigabyte', 'TB100', 'tablet'],
        'GN100': ['Gionee', 'GN100'],
        'GN105': ['Gionee', 'GN105'],
        'GN106': ['Gionee', 'GN106'],
        'GN200': ['Gionee', 'GN200'],
        'GN205': ['Gionee', 'GN205'],
        'GN700W': ['Gionee', 'GN700W'],
        'GN708W': ['Gionee', 'GN708W'],
        'Google Ion': ['Google', 'Ion'],
        'Nexus One': ['Google', 'Nexus One'],
        'NexusOne': ['Google', 'Nexus One'],
        'HTC Nexus One': ['Google', 'Nexus One'],
        'Nexus S': ['Google', 'Nexus S'],
        'Google Nexus S': ['Google', 'Nexus S'],
        'Nexus S 4G': ['Google', 'Nexus S 4G'],
        'Dooderbutt-4.0.3-v1': ['Google', 'Nexus S 4G'],
        'Nexus 7': ['Google', 'Nexus 7', 'tablet'],
        'Haier HW-W910': ['Haier', 'HW-W910'],
        'SN10T1': ['HANNspree', 'HANNSpad SN10T1', 'tablet'],
        'SN10T2': ['HANNspree', 'HANNSpad SN10T2', 'tablet'],
        'HannsComb': ['HANNspree', 'HANNSpad', 'tablet'],
        'X1': ['HCL', 'ME X1', 'tablet'],
        'MID Serails': ['Herotab', 'C8', 'tablet'],
        'MID Serials': ['Herotab', 'C8', 'tablet'],
        'COSMO DUO': ['Hiscreen', 'Cosmo DUO', 'tablet'],
        'HS-U8': ['Hisense', 'U8'],
        'HS-T92': ['Hisense', 'T92'],
        'HS-E860': ['Hisense', 'E860'],
        'HS-E910': ['Hisense', 'E910'],
        'HS-E926': ['Hisense', 'E926'],

        'HS-EG900': ['Hisense', 'EG900'],
        'HS-ET919': ['Hisense', 'ET919'],
        'EG968B': ['Hisense', 'EG968B'],
        'HKPHONE H8-3G': ['HKPhone', 'H8 3G'],
        'HOSIN U2': ['Hosin', 'U2'],
        'Touchpad': ['HP', 'TouchPad', 'tablet'],
        'HP Touchpad': ['HP', 'TouchPad', 'tablet'],
        'cm tenderloin': ['HP', 'TouchPad', 'tablet'],
        'aokp tenderloin': ['HP', 'TouchPad', 'tablet'],
        'HTC Amaze 4G': ['HTC', 'Amaze 4G'],
        'HTC Ruby': ['HTC', 'Amaze 4G'],
        'HTC Amaze 4G(Ruby)': ['HTC', 'Amaze 4G'],
        'Amaze 4G': ['HTC', 'Amaze 4G'],
        'HTC Aria': ['HTC', 'Aria'],
        'HTC Aria A6380': ['HTC', 'Aria'],
        'HTC Liberty A6380': ['HTC', 'Aria'],
        'HTC Liberty': ['HTC', 'Aria'],
        'HTC A6366': ['HTC', 'Aria'],
        'HTC Bee': ['HTC', 'Bee'],
        'HTC ChaCha': ['HTC', 'ChaCha'],
        'HTC ChaCha A810e': ['HTC', 'ChaCha'],
        'HTC ChaChaCha A810e': ['HTC', 'ChaCha'],
        'HTC A810e': ['HTC', 'ChaCha'],
        'HTC A9188': ['HTC', 'Tianxi'],
        'HTC Bravo': ['HTC', 'Desire'],
        'HTC Desire': ['HTC', 'Desire'],
        'HTC Desire A8181': ['HTC', 'Desire'],
        'HTC Desire A8183': ['HTC', 'Desire'],
        'HTC Desire Beats A8181': ['HTC', 'Desire'],
        'HTC Desire CDMA': ['HTC', 'Desire'],
        'HTC Desire SMS': ['HTC', 'Desire'],
        'HTC Desire S.M.S': ['HTC', 'Desire'],
        'HTC Desire C': ['HTC', 'Desire C'],
        'HTC DesireHD': ['HTC', 'Desire HD'],
        'HTC DesireHD A9191': ['HTC', 'Desire HD'],
        'HTC DesireHD A9192': ['HTC', 'Desire HD'],
        'HTC Desire HD A9191': ['HTC', 'Desire HD'],
        'HTC A9191': ['HTC', 'Desire HD'],
        'HTC A9191 for AT&T': ['HTC', 'Desire HD'],
        'HTC A9192': ['HTC', 'Desire HD'],
        'HTC Desire HD': ['HTC', 'Desire HD'],
        'HTC Desire HD with Beats Audio': ['HTC', 'Desire HD'],
        'HTC Desire S': ['HTC', 'Desire S'],
        'HTC DesireS': ['HTC', 'Desire S'],
        'HTC DesiresS': ['HTC', 'Desire S'],
        'HTC DesireS S510e': ['HTC', 'Desire S'],
        'HTC DesireS S510b': ['HTC', 'Desire S'],
        'HTC Desire S S510e': ['HTC', 'Desire S'],
        'HTC S510e': ['HTC', 'Desire S'],
        'HTC Desire Saga': ['HTC', 'Desire S'],
        'HTC Desire V': ['HTC', 'Desire V'],
        'HTC T328w': ['HTC', 'Desire V'],
        'HTC Desire VC': ['HTC', 'Desire VC'],
        'HTC T328d': ['HTC', 'Desire VC'],
        'HTC T328t': ['HTC', 'Desire VT'],
        'HTC Desire Z': ['HTC', 'Desire Z'],
        'HTC DesireZ': ['HTC', 'Desire Z'],
        'HTC DesireZ A7272': ['HTC', 'Desire Z'],
        'HTC Desire Z A7272': ['HTC', 'Desire Z'],
        'HTC Vision': ['HTC', 'Desire Z'],
        'HTC A7275': ['HTC', 'Desire Z'],
        'HTC Dream': ['HTC', 'Dream'],
        'HTC S710d': ['HTC', 'Droid Incredible 2'],
        'HTC Incredible 2': ['HTC', 'Droid Incredible 2'],
        'HTC X515d': ['HTC', 'EVO 3D'],
        'HTC X515m': ['HTC', 'EVO 3D'],
        'HTC X515C': ['HTC', 'EVO 3D'],
        'HTC Evo 3D': ['HTC', 'EVO 3D'],
        'HTC EVO 3D': ['HTC', 'EVO 3D'],
        'HTC EVO 3D GSM': ['HTC', 'EVO 3D'],
        'HTC EVO 3D X515a': ['HTC', 'EVO 3D'],
        'HTC EVO 3D GSM X515m': ['HTC', 'EVO 3D'],
        'HTC EVO 3D X515m': ['HTC', 'EVO 3D'],
        'HTC EVO 3D X515M': ['HTC', 'EVO 3D'],
        'HTC EVO3D X515a': ['HTC', 'EVO 3D'],
        'HTC EVO3D X515m': ['HTC', 'EVO 3D'],
        'HTC Evo 3D X515m': ['HTC', 'EVO 3D'],
        'HTC Evo 3D with Beats Audio X515m': ['HTC', 'EVO 3D'],
        'HTC Evo 4G': ['HTC', 'EVO 4G'],
        'HTC EVO 4G': ['HTC', 'EVO 4G'],
        'HTC X515E': ['HTC', 'EVO 4G+'],
        'HTC EVO 4G+ For Sprint': ['HTC', 'EVO 4G+'],
        'HTC EVO 4G++ For Sprint': ['HTC', 'EVO 4G+'],
        'HTC C715c': ['HTC', 'EVO Design 4G'],
        'HTC Design 4G': ['HTC', 'EVO Design 4G'],
        'HTC EVO design 4G': ['HTC', 'EVO Design 4G'],
        'HTC EVO Design 4G': ['HTC', 'EVO Design 4G'],
        'HTC Evo Shift': ['HTC', 'EVO Shift'],
        'HTC EVO Shift 4G': ['HTC', 'EVO Shift'],
        'HTC A310e': ['HTC', 'Explorer'],
        'HTC Explorer': ['HTC', 'Explorer'],
        'HTC Explorer A310b': ['HTC', 'Explorer'],
        'HTC Explorer A310e': ['HTC', 'Explorer'],
        'HTC P510e': ['HTC', 'Flyer', 'tablet'],
        'HTC Flyer': ['HTC', 'Flyer', 'tablet'],
        'HTC Flyer P510e': ['HTC', 'Flyer', 'tablet'],
        'HTC Flyer P512': ['HTC', 'Flyer', 'tablet'],
        'HTC Flyer P512 NA': ['HTC', 'Flyer', 'tablet'],
        'HTC P515E': ['HTC', 'Flyer 4G', 'tablet'],
        'HTC Gratia A6380': ['HTC', 'Gratia'],
        'HTC HD': ['HTC', 'HD'],
        'HTC HD2': ['HTC', 'HD2'],
        'HTC HD2 T8585': ['HTC', 'HD2'],
        'HTC HD2(Leo)': ['HTC', 'HD2'],
        'HTC HD7': ['HTC', 'HD7'],
        'HTC T9299+': ['HTC', 'HD7'],
        'HTC HD7 for Sprint': ['HTC', 'HD7'],
        'HTC HD7 4G T9299 For AT&T': ['HTC', 'HD7'],
        'HTC HD7 4G T9299+ For AT&T': ['HTC', 'HD7'],
        'HTC T9299+ For AT&T': ['HTC', 'HD7'],
        'HTC HD7S T9399+': ['HTC', 'HD7s'],
        'HTC HD7S T9899+': ['HTC', 'HD7s'],
        'HTC T9899+ For AT&T': ['HTC', 'HD7s'],
        'VitMod ExtraLite 1.6.5.fullodex for HTC HD7 Pro': ['HTC', 'HD7 Pro'],
        'HTC Hero': ['HTC', 'Hero'],
        'HTC HERO': ['HTC', 'Hero'],
        'HTC Hero CDMA': ['HTC', 'Hero'],
        'HTC HERO CDMA': ['HTC', 'Hero'],
        'HTC HERO200': ['HTC', 'Hero 200'],
        'HTC Hero S': ['HTC', 'Hero S'],
        'HTC IMAGIO': ['HTC', 'Imagio'],
        'HTC Incredible': ['HTC', 'Incredible'],
        'HTC Incredible S710E': ['HTC', 'Incredible S'],
        'HTC S710e': ['HTC', 'Incredible S'],
        'HTC Incredible S': ['HTC', 'Incredible S'],
        'HTC Incredible S S710e': ['HTC', 'Incredible S'],
        'HTC Incredible S s710e': ['HTC', 'Incredible S'],
        'HTC IncredibleS S710e': ['HTC', 'Incredible S'],
        'HTC Incredible S with Beats Audio': ['HTC', 'Incredible S'],
        'HTC Vivo': ['HTC', 'Incredible S'],
        'HTC Innovation': ['HTC', 'Innovation'],
        'HTC Inspire 4G': ['HTC', 'Inspire 4G'],
        'HTC HD7 Inspire 4G For Vodafone': ['HTC', 'Inspire 4G'],
        'HTC P715a': ['HTC', 'Jetstream', 'tablet'],
        'HTC Legend': ['HTC', 'Legend'],
        'HTC Magic': ['HTC', 'Magic'],
        'HTC Sapphire': ['HTC', 'Magic'],
        'HTC Lexikon': ['HTC', 'Merge'],
        'HTC One S': ['HTC', 'One S'],
        'HTC Z520e': ['HTC', 'One S'],
        'HTC One V': ['HTC', 'One V'],
        'HTC T320e': ['HTC', 'One V'],
        'HTC One X': ['HTC', 'One X'],
        'HTC S720e': ['HTC', 'One X'],
        'HTC Endeavour-LS': ['HTC', 'One X'],
        'HTC One XL': ['HTC', 'One XL'],
        'HTC X710a': ['HTC', 'Raider 4G'],
        'HTC Raider': ['HTC', 'Raider 4G'],
        'HTC Raider X710e': ['HTC', 'Raider 4G'],
        'HTC Raider X710s': ['HTC', 'Raider 4G'],
        'HTC Raider 4G X710e': ['HTC', 'Raider 4G'],
        'HTC PH39100': ['HTC', 'Raider 4G'],
        'HTC Holiday': ['HTC', 'Raider 4G'],
        'HTC Velocity 4G X710s': ['HTC', 'Raider 4G'],
        'HTC Rezound': ['HTC', 'Rezound'],
        'HTC Rhyme S510b': ['HTC', 'Rhyme'],
        'HTC S510b': ['HTC', 'Rhyme'],
        'HTC Bliss': ['HTC', 'Rhyme'],
        'HTC Bliss S510b': ['HTC', 'Rhyme'],
        'HTC Salsa C510e': ['HTC', 'Salsa'],
        'HTC C510e': ['HTC', 'Salsa'],
        'HTC Z710a': ['HTC', 'Sensation'],
        'HTC Z710e': ['HTC', 'Sensation'],
        'HTC Z710t': ['HTC', 'Sensation'],
        'HTC Sensation': ['HTC', 'Sensation'],
        'HTC Sensation Z710': ['HTC', 'Sensation'],
        'HTC Sensation Z710a': ['HTC', 'Sensation'],
        'HTC Sensation Z710e': ['HTC', 'Sensation'],
        'HTC Sensation Z710E': ['HTC', 'Sensation'],
        'HTC Sensation Z710e For AT&T': ['HTC', 'Sensation'],
        'HTC Sensation Z710e with Beats Audio': ['HTC', 'Sensation'],
        'HTC Sensation with Beats Audio Z710e': ['HTC', 'Sensation'],
        'HTC Sensation with Beats Audio': ['HTC', 'Sensation'],
        'HTC Sensation Taste': ['HTC', 'Sensation'],
        'HTC Pyramid': ['HTC', 'Sensation'],
        'HTC Pyramid Z710a': ['HTC', 'Sensation'],
        'HTC Pyramid Z710e': ['HTC', 'Sensation'],
        'HTC Sensation 4G': ['HTC', 'Sensation'],
        'HTC Sensation 4G with Beats Audio': ['HTC', 'Sensation'],
        'HTC Sensation G14': ['HTC', 'Sensation'],
        'HTC Sensation G14 for AT&T': ['HTC', 'Sensation'],
        'HTC G14 sensation': ['HTC', 'Sensation'],
        'HTC Z715e': ['HTC', 'Sensation XE'],
        'HTC Sensation Z715e': ['HTC', 'Sensation XE'],
        'HTC SensationXE Beats': ['HTC', 'Sensation XE'],
        'HTC SensationXE Beats Z715a': ['HTC', 'Sensation XE'],
        'HTC SensationXE Beats Z715e': ['HTC', 'Sensation XE'],
        'HTC Sensation XE': ['HTC', 'Sensation XE'],
        'HTC Sensation XE Z715e': ['HTC', 'Sensation XE'],
        'HTC SensationXE Z715e': ['HTC', 'Sensation XE'],
        'HTC Sensation XE Beats': ['HTC', 'Sensation XE'],
        'HTC SensationXE with Beats Audio': ['HTC', 'Sensation XE'],
        'HTC Sensation XE with Beats Audio': ['HTC', 'Sensation XE'],
        'HTC Sensation XE with Beats Audio Z715a': ['HTC', 'Sensation XE'],
        'HTC Sensation Juredroid XE Beats Audio': ['HTC', 'Sensation XE'],
        'HTC Sensation XE with Beats Audio Z715e': ['HTC', 'Sensation XE'],
        'HTC Sensation XE With Beats Audio Z715e': ['HTC', 'Sensation XE'],
        'HTC Sensation 4G XE with Beats Audio': ['HTC', 'Sensation XE'],
        'HTC Sensation with Beats Audio Z715e': ['HTC', 'Sensation XE'],
        'HTC X315E': ['HTC', 'Sensation XL'],
        'HTC SensationXL Beats X315b': ['HTC', 'Sensation XL'],
        'HTC SensationXL Beats X315e': ['HTC', 'Sensation XL'],
        'HTC Sensation XL with Beats Audio X315b': ['HTC', 'Sensation XL'],
        'HTC Sensation XL with Beats Audio X315e': ['HTC', 'Sensation XL'],
        'HTC Runnymede': ['HTC', 'Sensation XL'],
        'HTC G21': ['HTC', 'Sensation XL'],
        'HTC PH06130': ['HTC', 'Status'],
        'HTC Status': ['HTC', 'Status'],
        'HTC Tattoo': ['HTC', 'Tattoo'],
        'HTC TATTOO A3288': ['HTC', 'Tattoo'],
        'HTC click': ['HTC', 'Tattoo'],
        'HTC X310e': ['HTC', 'Titan'],
        'HTC T7373': ['HTC', 'Touch Pro II'],
        'HTC ThunderBolt': ['HTC', 'ThunderBolt'],
        'HTC Mecha': ['HTC', 'ThunderBolt'],
        'HTC Velocity 4G': ['HTC', 'Velocity 4G'],
        'HTC Wildfire': ['HTC', 'Wildfire'],
        'HTC Wildfire A3333': ['HTC', 'Wildfire'],
        'HTC A3366': ['HTC', 'Wildfire'],
        'HTC A3380': ['HTC', 'Wildfire'],
        'HTC WildfireS': ['HTC', 'Wildfire S'],
        'HTC Wildfire S': ['HTC', 'Wildfire S'],
        'Htc Wildfire s': ['HTC', 'Wildfire S'],
        'HTC Wildfire S A510e': ['HTC', 'Wildfire S'],
        'HTC Wildfire S A510b': ['HTC', 'Wildfire S'],
        'HTC WildfireS A510e': ['HTC', 'Wildfire S'],
        'HTC WildfireS A510b': ['HTC', 'Wildfire S'],
        'htc wildfire s a510e': ['HTC', 'Wildfire S'],
        'HTC Wildfire S A515c': ['HTC', 'Wildfire S'],
        'HTC A510a': ['HTC', 'Wildfire S'],
        'HTC A510e': ['HTC', 'Wildfire S'],
        'HTC A510c': ['HTC', 'Wildfire S'],
        'HTCX06HT': ['HTC', 'Desire'],
        'HTC A6390': ['HTC', 'A6390'],
        'HTC A8180': ['HTC', 'A8180'],
        'HTC PG762': ['HTC', 'PG762'],
        'HTC S715e': ['HTC', 'S715e'],
        'HTC S720t': ['HTC', 'S720t'],
        'HTC Z510d': ['HTC', 'Z510d'],
        'HTC Z560e': ['HTC', 'Z560e'],
        'HTC VLE U': ['HTC', 'One S'],
        'HTC VLE#U': ['HTC', 'One S'],
        'HTC VIE U': ['HTC', 'One S'],
        'HTC EVA UL': ['HTC', 'One V'],
        'HTC ENR U': ['HTC', 'One X'],
        'ENR U': ['HTC', 'One X'],
        'EndeavorU': ['HTC', 'One X'],
        'Liberty': ['HTC', 'Aria'],
        'Desire': ['HTC', 'Desire'],
        'Desire A8181': ['HTC', 'Desire'],
        'desire hd': ['HTC', 'Desire HD'],
        'Desire HD': ['HTC', 'Desire HD'],
        'Dedire HD': ['HTC', 'Desire HD'],
        'Desire Hd (ace)': ['HTC', 'Desire HD'],
        'Desire S': ['HTC', 'Desire S'],
        'DesireS': ['HTC', 'Desire S'],
        'Desire Saga': ['HTC', 'Desire S'],
        'Desire Z': ['HTC', 'Desire Z'],
        'Dream': ['HTC', 'Dream'],
        'Droid Incredible': ['HTC', 'Droid Incredible'],
        'EVO': ['HTC', 'EVO'],
        'Evo HD2': ['HTC', 'EVO HD'],
        'Evo 3D Beats X515m': ['HTC', 'EVO 3D'],
        'Evo 3D GSM': ['HTC', 'EVO 3D'],
        'EVO 3D X515m': ['HTC', 'EVO 3D'],
        'EVO3D X515m': ['HTC', 'EVO 3D'],
        'Evo 4G': ['HTC', 'EVO 4G'],
        'EVO 4G': ['HTC', 'EVO 4G'],
        'photon': ['HTC', 'HD mini'],
        'GinDream\/GinMagic': ['HTC', 'Dream'],
        'HD2': ['HTC', 'HD2'],
        'HD7  Pro': ['HTC', 'HD7 Pro'],
        'Hero': ['HTC', 'Hero'],
        'HERO CDMA': ['HTC', 'Hero'],
        'HERO200': ['HTC', 'Hero 200'],
        'Incredible': ['HTC', 'Droid Incredible'],
        'Incredible 2': ['HTC', 'Droid Incredible 2'],
        'Incredible S': ['HTC', 'Incredible S'],
        'IncredibleS S710e': ['HTC', 'Incredible S'],
        'IncredibleS': ['HTC', 'Incredible S'],
        'Inspire HD': ['HTC', 'Inspire 4G'],
        'Inspire 4G': ['HTC', 'Inspire 4G'],
        'Legend': ['HTC', 'Legend'],
        'NexusHD2': ['HTC', 'HD2'],
        'Nexus HD2': ['HTC', 'HD2'],
        'Docomo HT-03A': ['HTC', 'Magic'],
        'MIUI.us Sensation 4G': ['HTC', 'Sensation 4G'],
        'SiRF Dream': ['HTC', 'Dream'],
        'Pyramid': ['HTC', 'Sensation'],
        'Sensation': ['HTC', 'Sensation'],
        'Sensation Z710e': ['HTC', 'Sensation'],
        'Sensation 4G': ['HTC', 'Sensation'],
        'Sensation 4g': ['HTC', 'Sensation'],
        'TripNiCE Pyramid': ['HTC', 'Sensation'],
        'SensationXE Beats Z715e': ['HTC', 'Sensation XE'],
        'SensationXL Beats X315e': ['HTC', 'Sensation XL'],
        'Click': ['HTC', 'Tattoo'],
        'Wildfire': ['HTC', 'Wildfire'],
        'Wildfire S': ['HTC', 'Wildfire S'],
        'Wildfire S A510e': ['HTC', 'Wildfire S'],
        'Sprint APX515CKT': ['HTC', 'EVO 3D'],
        'Sprint APA9292KT': ['HTC', 'EVO 4G'],
        'Sprint APA7373KT': ['HTC', 'EVO Shift 4G'],
        'Sprint APC715CKT': ['HTC', 'EVO Design 4G'],
        'A3380': ['HTC', 'Wildfire'],
        'A6277': ['HTC', 'Hero'],
        'a7272': ['HTC', 'Desire Z'],
        'A7272+(HTC DesireZ)': ['HTC', 'Desire Z'],
        'S31HT': ['HTC', 'Aria'],
        'S710d': ['HTC', 'Droid Incredible 2'],
        'S710D': ['HTC', 'Droid Incredible 2'],
        'X06HT': ['HTC', 'Desire'],
        '001HT': ['HTC', 'Desire HD'],
        'X325a': ['HTC', 'One X'],
        'Z520m': ['HTC', 'One S'],
        'Z710': ['HTC', 'Sensation'],
        'Z710e': ['HTC', 'Sensation'],
        'T9199h': ['HTC', 'T9199h'],
        'HTC S610d': ['HTC', 'S610d'],
        'ADR6200': ['HTC', 'Droid Eris'],
        'ADR6300': ['HTC', 'Droid Incredible'],
        'ADR6325VW': ['HTC', 'Merge'],
        'ADR6330VW': ['HTC', 'Rhyme'],
        'ADR6350': ['HTC', 'Droid Incredible 2'],
        'ADR6400L': ['HTC', 'Thunderbolt 4G'],
        'ADR6400L 4G': ['HTC', 'Thunderbolt 4G'],
        'ADR6410LVW 4G': ['HTC', 'Fireball'],
        'ADR6425LVW': ['HTC', 'Rezound'],
        'ADR6425LVW 4G': ['HTC', 'Rezound'],
        'Coquettish Red': ['HTC', 'Rezound'],
        'PB99400': ['HTC', 'Droid Incredible'],
        'pcdadr6350': ['HTC', 'Droid Incredible 2'],
        'PC36100': ['HTC', 'EVO 4G'],
        'PG06100': ['HTC', 'EVO Shift 4G'],
        'PG41200': ['HTC', 'EVO View 4G', 'tablet'],
        'PG86100': ['HTC', 'EVO 3D'],
        'PG8610000': ['HTC', 'EVO 3D'],
        'PH44100': ['HTC', 'EVO Design 4G'],
        'PJ83100': ['HTC', 'One X'],
        'ISW11HT': ['HTC', 'EVO 4G'],
        'ISW12HT': ['HTC', 'EVO 3D'],
        'ISW13HT': ['HTC', 'J'],
        'USCCADR6275US Carrier ID 45': ['HTC', 'Desire'],
        'USCCADR6285US': ['HTC', 'Hero S'],
        'USCCADR6325US Carrier ID 45': ['HTC', 'Merge'],
        'MediaPad': ['Huawei', 'MediaPad', 'tablet'],
        'Huawei MediaPad': ['Huawei', 'MediaPad', 'tablet'],
        'HUAWEI MediaPad': ['Huawei', 'MediaPad', 'tablet'],
        'Huawei S7-312u': ['Huawei', 'MediaPad', 'tablet'],
        'MediaPad 10 FHD': ['Huawei', 'MediaPad', 'tablet'],
        'Huawei C8500': ['Huawei', 'C8500'],
        'Huawei C8500S': ['Huawei', 'C8500'],
        'Huawei C8600': ['Huawei', 'C8600'],
        'Huawei C8650': ['Huawei', 'C8650'],
        'Huawei C8650+': ['Huawei', 'C8650'],
        'Huawei C8800': ['Huawei', 'IDEOS X5'],
        'Huawei C8810': ['Huawei', 'Ascend G300'],
        'Huawei C8812': ['Huawei', 'Ascend C8812'],
        'Huawei C8812E': ['Huawei', 'Ascend C8812'],
        'Huawei C8825D': ['Huawei', 'Ascend C8825D'],
        'Huawei C8860E': ['Huawei', 'Honor'],
        'Huawei M835': ['Huawei', 'M835'],
        'Huawei M860': ['Huawei', 'Ascend'],
        'Huawei M921': ['Huawei', 'M921'],
        'Huawei S8520': ['Huawei', 'S8520'],
        'Huawei S8600': ['Huawei', 'S8600'],
        'Huawei T8300': ['Huawei', 'T8300'],
        'Huawei T8600': ['Huawei', 'T8600'],
        'Huawei T8830': ['Huawei', 'T8830'],
        'T8830': ['Huawei', 'T8830'],
        'T8620': ['Huawei', 'T8620'],
        'Huawei T8828': ['Huawei', 'T8828'],
        'Huawei U8220': ['Huawei', 'U8220'],
        'Huawei u8500': ['Huawei', 'IDEOS X2'],
        'Huawei U8815': ['Huawei', 'Ascend G300'],
        'Huawei U8825D': ['Huawei', 'Ascend G330D'],
        'Huawei U8850': ['Huawei', 'Vision'],
        'Huawei U8652': ['Huawei', 'Sonic'],
        'Huawei U8800-51': ['Huawei', 'IDEOS X5'],
        'Huawei U8818': ['Huawei', 'Ascend G300'],
        'Huawei U9000': ['Huawei', 'Ascend X'],
        'Huawei IDEOS U8500': ['Huawei', 'IDEOS X2'],
        'Huawei IDEOS U8650': ['Huawei', 'Sonic'],
        'Huawei IDEOS X3': ['Huawei', 'IDEOS X3'],
        'Huawei Ideos X5': ['Huawei', 'IDEOS X5'],
        'Huawei Ideos X5 1.12.9(ret4rt)': ['Huawei', 'IDEOS X5'],
        'Huawei SONIC': ['Huawei', 'Sonic'],
        'Huawei 8100-9': ['Huawei', 'U8100'],
        'FUSIONideos': ['Huawei', 'IDEOS'],
        'Gnappo Ideos': ['Huawei', 'IDEOS'],
        'Ideos': ['Huawei', 'IDEOS'],
        'IDEOS X5': ['Huawei', 'IDEOS X5'],
        'Ideos S7': ['Huawei', 'IDEOS S7', 'tablet'],
        'IDEOS S7': ['Huawei', 'IDEOS S7', 'tablet'],
        'IDEOS S7 Slim': ['Huawei', 'IDEOS S7', 'tablet'],
        'Huawei S7': ['Huawei', 'IDEOS S7', 'tablet'],
        'SONIC': ['Huawei', 'Sonic'],
        'Kyivstar Aqua': ['Huawei', 'Sonic'],
        'Lucky Ultra Sonic U8650': ['Huawei', 'Sonic'],
        'Turkcell T20': ['Huawei', 'Sonic'],
        'MTC 950': ['Huawei', 'U8160'],
        'MTC 955': ['Huawei', 'Sonic'],
        'MTC Evo': ['Huawei', 'C8500'],
        'MTC Android': ['Huawei', 'U8110'],
        'S31HW': ['Huawei', 'Pocket WiFi S'],
        'S41HW': ['Huawei', 'Pocket WiFi S II'],
        '007HW': ['Huawei', 'Vision'],
        'UM840': ['Huawei', 'Evolution'],
        'M860': ['Huawei', 'Ascend'],
        'M865': ['Huawei', 'Ascend II'],
        'M886': ['Huawei', 'Glory'],
        'C8150': ['Huawei', 'IDEOS'],
        'c8500': ['Huawei', 'C8500'],
        'C8500': ['Huawei', 'C8500'],
        'C8500S': ['Huawei', 'C8500'],
        'C8600': ['Huawei', 'C8600'],
        'c8650': ['Huawei', 'C8650'],
        'C8650': ['Huawei', 'C8650'],
        'c8800': ['Huawei', 'C8800'],
        'C8800': ['Huawei', 'C8800'],
        'c8810': ['Huawei', 'Ascend G300C'],
        'C8812': ['Huawei', 'Ascend C8812'],
        'S8600': ['Huawei', 'S8600'],
        'U8100': ['Huawei', 'U8100'],
        'U8110': ['Huawei', 'U8110'],
        'u8120': ['Huawei', 'U8120'],
        'U8120': ['Huawei', 'U8120'],
        'U8180': ['Huawei', 'IDEOS X1'],
        'U8220': ['Huawei', 'Pulse'],
        'U8300': ['Huawei', 'U8300'],
        'U8350': ['Huawei', 'Boulder'],
        'U8150': ['Huawei', 'IDEOS'],
        'U8160': ['Huawei', 'U8160'],
        'U8500': ['Huawei', 'IDEOS X2'],
        'U8500 HiQQ': ['Huawei', 'U8500 HiQQ Edition'],
        'U8510': ['Huawei', 'IDEOS X3'],
        'u8650': ['Huawei', 'Sonic'],
        'U8650': ['Huawei', 'Sonic'],
        'U8650-1': ['Huawei', 'Sonic'],
        'U8660': ['Huawei', 'Sonic'],
        'u8800': ['Huawei', 'IDEOS X5'],
        'U8800': ['Huawei', 'IDEOS X5'],
        'U8800+': ['Huawei', 'IDEOS X5'],
        'U8800X': ['Huawei', 'IDEOS X5'],
        'U8800pro': ['Huawei', 'IDEOS X5 Pro'],
        'U8800PRO': ['Huawei', 'IDEOS X5 Pro'],
        'U8800Pro': ['Huawei', 'IDEOS X5 Pro'],
        'u8800pro': ['Huawei', 'IDEOS X5 Pro'],
        'U8800 Pro': ['Huawei', 'IDEOS X5 Pro'],
        'U8818': ['Huawei', 'Ascend G300'],
        'U8850': ['Huawei', 'Vision'],
        'u8860': ['Huawei', 'Honor'],
        'U8860': ['Huawei', 'Honor'],
        'U9000': ['Huawei', 'Ascend X'],
        'U9200': ['Huawei', 'Ascend P1'],
        'U9200-1': ['Huawei', 'Ascend P1'],
        'U9500': ['Huawei', 'Ascend D1'],
        'U9501L': ['Huawei', 'Ascend D LTE'],
        'U9510': ['Huawei', 'Ascend D quad'],
        'U9510E': ['Huawei', 'Ascend D quad'],
        'Comet': ['Huawei', 'Comet'],
        'GS02': ['Huawei', 'Honor'],
        'GS03': ['Huawei', 'Ascend P1'],
        'DroniX-0.5': ['Huawei', 'U8180'],
        'MTS-SP101': ['Huawei', 'C8511'],
        'TSP21': ['Huawei', 'U8110'],
        'HYUNDAI H6': ['Hyundai', 'Storm H6'],
        'iBall Slide i7011': ['iBall', 'Slide i7011'],
        'NetTAB RUNE': ['IconBit', 'NetTab Rune', 'tablet'],
        'D70W': ['Icoo', 'D70W', 'tablet'],
        'D80': ['Icoo', 'D80', 'tablet'],
        'INFOBAR A01': ['iida', 'INFOBAR A01'],
        'M009F': ['Infotmic', 'M009F'],
        'AZ210A': ['Intel', 'AZ210A'],
        'AZ210B': ['Intel', 'AZ210B'],
        'AZ510': ['Intel', 'AZ510'],
        'greenridge': ['Intel', 'Green Ridge', 'tablet'],
        'INQ Cloud Touch': ['INQ', 'Cloud Touch'],
        'ILT-MX100': ['iRiver', 'Tab', 'tablet'],
        'IVIO_DE38': ['Ivio', 'DE38'],
        'JY-G2': ['Jiayu', 'G2'],
        'JXD S601WIFI': ['JXD', 'S601 WIFI', 'media'],
        'A2': ['KakaTech', 'A2'],
        'D91': ['KK', 'D91', 'tablet'],
        'K080': ['Kobo', 'K080', 'ereader'],
        'A106': ['koobee', 'A160'],
        'KPT A9': ['KPT', 'A9'],
        'EV-S100': ['Kttech', 'Take EV-S100'],
        'KM-S120': ['Kttech', 'Take 2 KM-S120'],
        'KM-S200': ['TAKE', 'Janus KM-S200'],
        'KM-S220': ['Kttech', 'Take Tachy KM-S220'],
        'Kyobo mirasol eReader': ['Kyobo', 'eReader', 'ereader'],
        'ISW11K': ['Kyocera', 'Digno'],
        'JC-KSP8000': ['Kyocera', 'Echo'],
        'KSP8000': ['Kyocera', 'Echo'],
        'Zio': ['Kyocera', 'Zio'],
        'C5155': ['Kyocera', 'C5155'],
        'C5170': ['Kyocera', 'C5170'],
        'M9300': ['Kyocera', 'M9300'],
        'E800': ['K-Touch', 'E800'],
        'W606': ['K-Touch', 'W606'],
        'K-Touch T619': ['K-Touch', 'T619'],
        'K-Touch W619': ['K-Touch', 'W619'],
        'K-Touch W650': ['K-Touch', 'W650'],
        'W700': ['K-Touch', 'W700'],
        'W800': ['K-Touch', 'W800'],
        'W806': ['K-Touch', 'W806'],
        'W808': ['K-Touch', 'W808'],
        'W810': ['K-Touch', 'W810'],
        'X900': ['Lava', 'XOLO X900'],
        'Lenovo A798t': ['Lenovo', 'A798t'],
        'LENOVO-Lenovo-A288t': ['Lenovo', 'LePhone A288'],
        'ThinkPad Tablet': ['Lenovo', 'ThinkPad Tablet', 'tablet'],
        'K1': ['Lenovo', 'IdeaPad K1', 'tablet'],
        'Ideapad S10-3T': ['Lenovo', 'IdeaPad S10-3T', 'tablet'],
        'S2005A-H': ['Lenovo', 'S2005A'],
        'IdeaTab S2007A-D': ['Lenovo', 'IdeaTab S2007A', 'tablet'],
        'IdeaTabV2007A': ['Lenovo', 'IdeaTab V2007A', 'tablet'],
        'IdeaTabV2007A-D-I': ['Lenovo', 'IdeaTab V2007A', 'tablet'],
        'IdeaTabV2010A': ['Lenovo', 'IdeaTab V2010A', 'tablet'],
        'IdeaTab A2107A-H': ['Lenovo', 'IdeaTab V2107A', 'tablet'],
        'A1 07': ['Lenovo', 'LePad', 'tablet'],
        'lepad 001b': ['Lenovo', 'LePad', 'tablet'],
        'lepad 001n': ['Lenovo', 'LePad', 'tablet'],
        '3GC101': ['Lenovo', 'LePhone 3GC101'],
        'Lenovo 3GC101': ['Lenovo', 'LePhone 3GC101'],
        '3GW100': ['Lenovo', 'LePhone 3GW100'],
        'Lenovo 3GW100': ['Lenovo', 'LePhone 3GW100'],
        '3GW101': ['Lenovo', 'LePhone 3GW101'],
        'Lenovo 3GW101': ['Lenovo', 'LePhone 3GW101'],
        'Lephone 3GW101': ['Lenovo', 'LePhone 3GW101'],
        'Lenovo A1-32AB0': ['Lenovo', 'LePhone A1-32AB0'],
        'Lenovo S1-37AH0': ['Lenovo', 'LePhone S1-37AH0'],
        'S1 37AHO': ['Lenovo', 'LePhone S1-37AH0'],
        'Lenovo S2-38AH0': ['Lenovo', 'LePhone S2-38AH0'],
        'Lenovo S2-38AT0': ['Lenovo', 'LePhone S2-38AT0'],
        'Lenovo A288t': ['Lenovo', 'LePhone A288'],
        'Lenovo A366t': ['Lenovo', 'LePhone A366'],
        'Lenovo A390e': ['Lenovo', 'LePhone A390'],
        'Lenovo A500': ['Lenovo', 'LePhone A500'],
        'Lenovo A520': ['Lenovo', 'LePhone A520'],
        'Lenovo A560e': ['Lenovo', 'A560'],
        'Lenovo A668t': ['Lenovo', 'LePhone A668'],
        'Lenovo A698t': ['Lenovo', 'LePhone A698'],
        'Lenovo A750': ['Lenovo', 'LePhone A750'],
        'Lenovo A780': ['Lenovo', 'LePhone A780'],
        'Lenovo A789': ['Lenovo', 'LePhone A789'],
        'Lenovo A790e': ['Lenovo', 'LePhone A790'],
        'Lenovo P70': ['Lenovo', 'LePhone P70'],
        'Lenovo P700': ['Lenovo', 'LePhone P700'],
        'Lenovo S850e': ['Lenovo', 'S850'],
        'Lenovo S880': ['Lenovo', 'S880'],
        'Lenovo K860': ['Lenovo', 'K860'],
        'A30t': ['Lenovo', 'A30t'],
        'Lenovo A60': ['Lenovo', 'A60'],
        'Lenovo A65': ['Lenovo', 'A65'],
        'Lenovo A66t': ['Lenovo', 'A66t'],
        'Lenovo A68e': ['Lenovo', 'A68e'],
        'Lenovo K800': ['Lenovo', 'K800'],
        'IDEA TV T100': ['Lenovo', 'IDEA TV', 'television'],
        'IDEA TV K91': ['Lenovo', 'IDEA TV', 'television'],
        'TC970': ['Le Pan', 'TC970', 'tablet'],
        'LePanII': ['Le Pan', 'II', 'tablet'],
        'LG-C555': ['LG', 'Optimus Chat'],
        'LG-C555-parrot': ['LG', 'Optimus Chat'],
        'LG-C660h': ['LG', 'Optimus Pro'],
        'LG-C729': ['LG', 'DoublePlay'],
        'LG-C800G': ['LG', 'Eclypse'],
        'LG-CX670': ['LG', 'Optimus 3G'],
        'LG-E400': ['LG', 'Optimus L3'],
        'LG-E400f': ['LG', 'Optimus L3'],
        'LG-E510': ['LG', 'Optimus Hub'],
        'LG-E510f': ['LG', 'Optimus Hub'],
        'LG-E510g': ['LG', 'Optimus Hub'],
        'LG-E610': ['LG', 'Optimus L5'],
        'LG-E612': ['LG', 'Optimus L5'],
        'LG-E612g': ['LG', 'Optimus L5'],
        'LG-E615F': ['LG', 'E615'],
        'LG-E617G': ['LG', 'E617'],
        'LG-E720': ['LG', 'Optimus Chic'],
        'LG-E720b': ['LG', 'Optimus Chic'],
        'LG-E730': ['LG', 'Optimus Sol'],
        'LG-E970': ['LG', 'Shine'],
        'LG-F100L': ['LG', 'Optimus Vu'],
        'LG-F100S': ['LG', 'Optimus Vu'],
        'LG-F120K': ['LG', 'Optimus LTE Tag'],
        'LG-F120L': ['LG', 'Optimus LTE Tag'],
        'LG-F120S': ['LG', 'Optimus LTE Tag'],
        'LG-F160K': ['LG', 'Optimus LTE II'],
        'LG-F160L': ['LG', 'Optimus LTE II'],
        'LG-F160S': ['LG', 'Optimus LTE II'],
        'LG-F180L': ['LG', 'F180L'],
        'LG-GT540': ['LG', 'Optimus'],
        'LG-GT540f': ['LG', 'Optimus'],
        'LG-GT540 Swift': ['LG', 'Optimus'],
        'LG-GW620': ['LG', 'GW620'],
        'LG-KH5200': ['LG', 'Andro-1'],
        'LG-KU3700': ['LG', 'Optimus One'],
        'LG-KU5400': ['LG', 'PRADA 3.0'],
        'LG-KU5900': ['LG', 'Optimus Black'],
        'LG-L40G': ['LG', 'L40G'],
        'LG-LG855': ['LG', 'Marquee'],
        'LG-LS670': ['LG', 'Optimus S'],
        'LG-LS696': ['LG', 'Optimus Elite'],
        'LG-LS840': ['LG', 'Viper 4G'],
        'LG-LS855': ['LG', 'Marquee'],
        'LG-LS860': ['LG', '\'Cayenne\''],
        'LG-LS970': ['LG', '\'Eclipse\''],
        'LG-LU3000': ['LG', 'Optimus Mach'],
        'LG-LU3100': ['LG', 'Optimus Chic'],
        'LG-LU3700': ['LG', 'Optimus One'],
        'LG-LU5400': ['LG', 'PRADA 3.0'],
        'LG-LU6200': ['LG', 'Optimus Q2'],
        'LG-lu6200': ['LG', 'Optimus Q2'],
        'LG-LU6500': ['LG', 'Optimus Note'],
        'LG-LU6800': ['LG', 'Optimus Big'],
        'LG-LU8300': ['LG', 'Optimus Pad LTE'],
        'LG-LW690': ['LG', 'Optimus C'],
        'LG-LW770': ['LG', 'LW770'],
        'LG-MS690': ['LG', 'Optimus M'],
        'LG-MS770': ['LG', 'MS770'],
        'LG-MS840': ['LG', 'Connect 4G'],
        'LG-MS910': ['LG', 'Esteem'],
        'LG-MS695': ['LG', 'Optimus M+'],
        'LG P350': ['LG', 'Optimus Me'],
        'LG-P350': ['LG', 'Optimus Me'],
        'LG-P350f': ['LG', 'Optimus Me'],
        'LG-P350g': ['LG', 'Optimus Me'],
        'LG-P355': ['LG', 'P355'],
        'LG-P500': ['LG', 'Optimus One'],
        'LG-P500h': ['LG', 'Optimus One'],
        'LG-P500h-parrot': ['LG', 'Optimus One'],
        'LG-P503': ['LG', 'Optimus One'],
        'LG-P504': ['LG', 'Optimus One'],
        'LG-P505': ['LG', 'Phoenix'],
        'LG-P505R': ['LG', 'Phoenix'],
        'LG-P506': ['LG', 'Thrive'],
        'LG-P509': ['LG', 'Optimus T'],
        'LG-P690': ['LG', 'Optimus Net'],
        'LG-P693': ['LG', 'P693'],
        'LG-P698': ['LG', 'Optimus Net'],
        'LG-P698f': ['LG', 'Optimus Net'],
        'LG-P700': ['LG', 'Optimus L7'],
        'LG-P705': ['LG', 'Optimus L7'],
        'LG-P705f': ['LG', 'Optimus L7'],
        'LG-P705g': ['LG', 'Optimus L7'],
        'LG-P708g': ['LG', 'P708'],
        'LG-P720': ['LG', 'Optimus Chic'],
        'LG-P720h': ['LG', 'Optimus Chic'],
        'LG-P725': ['LG', 'Optimus 3D Max'],
        'LG-P760': ['LG', 'P760'],
        'LG-P769': ['LG', 'P769'],
        'LG-P860': ['LG', 'P860'],
        'LG-P870': ['LG', 'P870'],
        'LG-P870F': ['LG', 'P870'],
        'LG-P880': ['LG', 'X3'],
        'LG-P880g': ['LG', 'X3'],
        'LG-P895': ['LG', 'P895'],
        'LG-P920': ['LG', 'Optimus 3D'],
        'LG-P920h': ['LG', 'Optimus 3D'],
        'LG-P925': ['LG', 'Thrill'],
        'LG-P925g': ['LG', 'Thrill'],
        'LG-P930': ['LG', 'Nitro HD'],
        'LG-P936': ['LG', 'Optimus LTE'],
        'LG-P940': ['LG', 'PRADA 3.0'],
        'LG-P970': ['LG', 'Optimus Black'],
        'LG-P970h': ['LG', 'Optimus Black'],
        'LG-P990': ['LG', 'Optimus 2X Speed'],
        'LG-P990h': ['LG', 'Optimus 2X Speed'],
        'LG-P990hN': ['LG', 'Optimus 2X Speed'],
        'LG-P990H': ['LG', 'Optimus 2X Speed'],
        'LG-P993': ['LG', 'Optimus 2X'],
        'LG-SU540': ['LG', 'PRADA 3.0'],
        'LG-SU640': ['LG', 'Optimus LTE'],
        'LG-SU660': ['LG', 'Optimus 2X'],
        'LG-SU760': ['LG', 'Optimus 3D'],
        'LG-SU760-Kust': ['LG', 'Optimus 3D'],
        'LG-SU870': ['LG', 'Optimus 3D Cube'],
        'LG-SU880': ['LG', 'Optimus EX'],
        'LG-US670': ['LG', 'Optimus U'],
        'LG-US730': ['LG', 'US730'],
        'LG-V900': ['LG', 'Optimus Pad', 'tablet'],
        'LG-V905R': ['LG', 'Optimus G-Slate', 'tablet'],
        'LG-V909': ['LG', 'Optimus G-Slate', 'tablet'],
        'LG-VM670': ['LG', 'Optimus V'],
        'LG-VM696': ['LG', 'Optimus Elite'],
        'LG-VM701': ['LG', 'Optimus Slider'],
        'LG-VS660': ['LG', 'Vortex'],
        'LG-VS700': ['LG', 'Enlighten'],
        'LG-VS740': ['LG', 'Ally'],
        'LG-VS840': ['LG', 'Connect 4G'],
        'LG-VS910': ['LG', 'Revolution'],
        'lgp-970': ['LG', 'Optimus Black'],
        'E900': ['LG', 'Optimus 7'],
        'GT540': ['LG', 'Optimus GT540'],
        'GW620': ['LG', 'GW620'],
        'KU9500': ['LG', 'Optimus Z'],
        'LGC660': ['LG', 'Optimus Pro'],
        'LGL45C': ['LG', 'Optimus Net'],
        'LGL55C': ['LG', 'Optimus Q'],
        'LU2300': ['LG', 'Optimus Q'],
        'LS670': ['LG', 'Optimus S'],
        'P940': ['LG', 'PRADA 3.0'],
        'P990': ['LG', 'Optimus 2X Speed'],
        'USCC-US730': ['LG', 'US730'],
        'USCC-US760': ['LG', 'Genesis'],
        'VM670': ['LG', 'Optimus V'],
        'VS840 4G': ['LG', 'Connect 4G'],
        'VS900-4G': ['LG', 'VS900'],
        'VS910 4G': ['LG', 'Revolution 4G'],
        'VS920 4G': ['LG', 'Spectrum 4G'],
        'VS930 4G': ['LG', 'VS930'],
        'VS950 4G': ['LG', 'VS950'],
        'L-01D': ['LG', 'Optimus LTE'],
        'L-02D': ['LG', 'PRADA phone'],
        'L-04C': ['LG', 'Optimus Chat'],
        'L-05D': ['LG', 'Optimus it'],
        'L-06C': ['LG', 'Optimus Pad', 'tablet'],
        'L-06D': ['LG', 'Optimus Vu'],
        'L-07C': ['LG', 'Optimus Bright'],
        'LG-Eve': ['LG', 'Eve'],
        'LG-Optimus One P500': ['LG', 'Optimus One'],
        'LG-Optimus 2X': ['LG', 'Optimus 2X'],
        'LG-GT540 Optimus': ['LG', 'Optimus'],
        'LG-Optimus Black': ['LG', 'Optimus Black'],
        'Ally': ['LG', 'Ally'],
        'Optimus': ['LG', 'Optimus'],
        'Optimus Me': ['LG', 'Optimus Me'],
        'optimus me p350': ['LG', 'Optimus Me'],
        'Optimus 2X': ['LG', 'Optimus 2X'],
        'Optimus 2x': ['LG', 'Optimus 2X'],
        'IS11LG': ['LG', 'Optimus X'],
        'Vortex': ['LG', 'Vortex'],
        'LDK-ICK v1.4': ['LG', 'Esteem'],
        'T6': ['Malata', 'Zpad T6', 'tablet'],
        'Malata SMBA1002': ['Malata', 'Tablet SMB-A1002', 'tablet'],
        'STM712HCZ': ['Mediacom', 'SmartPad 712c', 'tablet'],
        'STM803HC': ['Mediacom', 'SmartPad 810c', 'tablet'],
        'Mediacom 810C': ['Mediacom', 'SmartPad 810c', 'tablet'],
        'Smartpad810c': ['Mediacom', 'SmartPad 810c', 'tablet'],
        'SmartPad810c': ['Mediacom', 'SmartPad 810c', 'tablet'],
        'MP810C': ['Mediacom', 'SmartPad 810c', 'tablet'],
        'MP907C': ['Mediacom', 'SmartPad 907c', 'tablet'],
        'MTK6516': ['Mediatek', 'MTK6516'],
        'LIFETAB S9512': ['Medion', 'Lifetab S9512', 'tablet'],
        'LIFETAB P9514': ['Medion', 'Lifetab P9514', 'tablet'],
        'MD LIFETAB P9516': ['Medion', 'Lifetab P9516', 'tablet'],
        'MEDION LIFE P4310': ['Medion', 'Life P4310'],
        'M8': ['Meizu', 'M8'],
        'M9': ['Meizu', 'M9'],
        'M040': ['Meizu', 'M040'],
        'M9-unlocked': ['Meizu', 'M9'],
        'meizu m9': ['Meizu', 'M9'],
        'MEIZU M9': ['Meizu', 'M9'],
        'MEIZU MX': ['Meizu', 'MX'],
        'M030': ['Meizu', 'MX M030'],
        'M031': ['Meizu', 'MX M031'],
        'M032': ['Meizu', 'MX M032'],
        'Slidepad': ['Memup', 'Slidepad', 'tablet'],
        'A45': ['Micromax', 'A45 Punk'],
        'Micromax A50': ['Micromax', 'A50 Ninja'],
        'Micromax A60': ['Micromax', 'Andro A60'],
        'Micromax A70': ['Micromax', 'Andro A70'],
        'P300(Funbook)': ['Micromax', 'Funbook P300', 'tablet'],
        'AT735': ['Moinstone', 'AT735', 'tablet'],
        'A853': ['Motorola', 'Milestone'],
        'A953': ['Motorola', 'Milestone 2'],
        'A1680': ['Motorola', 'MOTO A1680'],
        'ET1': ['Motorola', 'ET1 Enterprise Tablet', 'tablet'],
        'MB200': ['Motorola', 'CLIQ'],
        'MB300': ['Motorola', 'BACKFLIP'],
        'MB501': ['Motorola', 'CLIQ XT'],
        'MB502': ['Motorola', 'CHARM'],
        'MB511': ['Motorola', 'FLIPOUT'],
        'MB520': ['Motorola', 'BRAVO'],
        'MB525': ['Motorola', 'DEFY'],
        'MB525+': ['Motorola', 'DEFY'],
        'MB525 for me': ['Motorola', 'DEFY'],
        'MB526': ['Motorola', 'DEFY+'],
        'MB611': ['Motorola', 'CLIQ 2'],
        'MB612': ['Motorola', 'XPRT'],
        'MB632': ['Motorola', 'PRO+'],
        'MB855': ['Motorola', 'PHOTON 4G'],
        'MB860': ['Motorola', 'ATRIX'],
        'MB861': ['Motorola', 'ATRIX'],
        'mb861': ['Motorola', 'ATRIX'],
        'MB865': ['Motorola', 'ATRIX 2'],
        'MB870': ['Motorola', 'Droid X2'],
        'MB886': ['Motorola', 'DINARA'],
        'ME501': ['Motorola', 'CLIQ XT'],
        'ME511': ['Motorola', 'FLIPOUT'],
        'me525': ['Motorola', 'MOTO ME525'],
        'Me525': ['Motorola', 'MOTO ME525'],
        'ME525': ['Motorola', 'MOTO ME525'],
        'ME525+': ['Motorola', 'MOTO ME525'],
        'ME600': ['Motorola', 'BACKFLIP'],
        'ME632': ['Motorola', 'PRO+'],
        'ME722': ['Motorola', 'Milestone 2'],
        'ME811': ['Motorola', 'Droid X'],
        'ME860': ['Motorola', 'ATRIX'],
        'ME863': ['Motorola', 'Milestone 3'],
        'ME865': ['Motorola', 'ATRIX 2'],
        'MT620': ['Motorola', 'MOTO MT620'],
        'MT620t': ['Motorola', 'MOTO MT620'],
        'MT716': ['Motorola', 'MOTO MT716'],
        'MT810': ['Motorola', 'MOTO MT810'],
        'MT870': ['Motorola', 'MOTO MT870'],
        'MT917': ['Motorola', 'MT917'],
        'MZ505': ['Motorola', 'XOOM Family Edition', 'tablet'],
        'MZ600': ['Motorola', 'XOOM 4G LTE', 'tablet'],
        'MZ601': ['Motorola', 'XOOM 3G', 'tablet'],
        'MZ602': ['Motorola', 'XOOM 4G LTE', 'tablet'],
        'MZ603': ['Motorola', 'XOOM 3G', 'tablet'],
        'MZ604': ['Motorola', 'XOOM WiFi', 'tablet'],
        'MZ605': ['Motorola', 'XOOM 3G', 'tablet'],
        'MZ606': ['Motorola', 'XOOM WiFi', 'tablet'],
        'MZ607': ['Motorola', 'XOOM 2 WiFi Media Edition', 'tablet'],
        'MZ609': ['Motorola', 'Droid XYBOARD 8.2', 'tablet'],
        'MZ609 4G': ['Motorola', 'Droid XYBOARD 8.2', 'tablet'],
        'MZ615': ['Motorola', 'XOOM 2 WiFi', 'tablet'],
        'MZ617': ['Motorola', 'Droid XYBOARD 10.1', 'tablet'],
        'MZ617 4G': ['Motorola', 'Droid XYBOARD 10.1', 'tablet'],
        'WX435': ['Motorola', 'TRIUMPH WX435'],
        'WX445': ['Motorola', 'CITRUS WX445'],
        'XT300': ['Motorola', 'SPICE'],
        'XT301': ['Motorola', 'MOTO XT301'],
        'XT311': ['Motorola', 'FIRE'],
        'XT316': ['Motorola', 'MOTO XT316'],
        'XT319': ['Motorola', 'MOTO XT319'],
        'XT390': ['Motorola', 'MOTO XT390'],
        'XT320': ['Motorola', 'DEFY Mini'],
        'XT321': ['Motorola', 'DEFY Mini'],
        'XT500': ['Motorola', 'MOTO XT500'],
        'xt-500': ['Motorola', 'MOTO XT500'],
        'XT502': ['Motorola', 'QUENCH XT5'],
        'XT530': ['Motorola', 'FIRE XT'],
        'XT531': ['Motorola', 'FIRE XT'],
        'XT532': ['Motorola', 'XT532'],
        'XT535': ['Motorola', 'DEFY'],
        'XT550': ['Motorola', 'XT550'],
        'XT556': ['Motorola', 'XT556'],
        'XT603': ['Motorola', 'ADMIRAL'],
        'XT610': ['Motorola', 'Droid Pro'],
        'XT615': ['Motorola', 'MOTO XT615'],
        'XT626': ['Motorola', 'MOTO XT626'],
        'XT681': ['Motorola', 'MOTO XT681'],
        'XT682': ['Motorola', 'Droid 3'],
        'XT685': ['Motorola', 'MOTO XT685'],
        'XT687': ['Motorola', 'ATRIX TV'],
        'XT701': ['Motorola', 'XT701'],
        'XT702': ['Motorola', 'MOTO XT702'],
        'XT711': ['Motorola', 'MOTO XT711'],
        'XT720': ['Motorola', 'Milestone'],
        'XT875': ['Motorola', 'Droid Bionic'],
        'XT800': ['Motorola', 'MOTO XT800'],
        'XT800+': ['Motorola', 'MOTO XT800'],
        'XT800W': ['Motorola', 'MOTO Glam'],
        'XT806': ['Motorola', 'MOTO XT806'],
        'XT860': ['Motorola', 'Milestone 3'],
        'XT862': ['Motorola', 'Droid 3'],
        'XT882': ['Motorola', 'MOTO XT882'],
        'XT883': ['Motorola', 'Milestone 3'],
        'XT889': ['Motorola', 'XT889'],
        'XT897': ['Motorola', 'Droid 4'],
        'XT901': ['Motorola', 'RAZR'],
        'XT910': ['Motorola', 'RAZR'],
        'XT910K': ['Motorola', 'RAZR'],
        'XT910S': ['Motorola', 'RAZR'],
        'XT910 4G': ['Motorola', 'RAZR'],
        'XT912': ['Motorola', 'Droid RAZR'],
        'XT923': ['Motorola', 'Droid RAZR HD'],
        'XT925': ['Motorola', 'Droid RAZR HD'],
        'XT926': ['Motorola', 'Droid RAZR'],
        'XT926 4G': ['Motorola', 'Droid RAZR'],
        'XT928': ['Motorola', 'XT928'],
        'Atrix 2': ['Motorola', 'ATRIX 2'],
        'Atrix 4g': ['Motorola', 'ATRIX 4G'],
        'Atrix 4G': ['Motorola', 'ATRIX 4G'],
        'Atrix 4G ME860': ['Motorola', 'ATRIX 4G'],
        'CLIQ': ['Motorola', 'CLIQ'],
        'CLIQ XT': ['Motorola', 'CLIQ XT'],
        'CLIQ2': ['Motorola', 'CLIQ 2'],
        'Corvair': ['Motorola', 'Corvair', 'tablet'],
        'DEFY': ['Motorola', 'DEFY'],
        'Defy+': ['Motorola', 'DEFY+'],
        'Defy Plus': ['Motorola', 'DEFY+'],
        'Devour': ['Motorola', 'Devour'],
        'Dext': ['Motorola', 'Dext'],
        'Droid': ['Motorola', 'Droid'],
        'DROID': ['Motorola', 'Droid'],
        'DROID2': ['Motorola', 'Droid 2'],
        'DROID2 GLOBAL': ['Motorola', 'Droid 2'],
        'DROID2 Global': ['Motorola', 'Droid 2'],
        'Droid2Global': ['Motorola', 'Droid 2'],
        'DROID 2': ['Motorola', 'Droid 2'],
        'DROID3': ['Motorola', 'Droid 3'],
        'DROID4': ['Motorola', 'Droid 4'],
        'DROID4 4G': ['Motorola', 'Droid 4'],
        'DROID Pro': ['Motorola', 'Droid Pro'],
        'DROID BIONIC': ['Motorola', 'Droid Bionic'],
        'DROID BIONIC 4G': ['Motorola', 'Droid Bionic'],
        'DROID BIONIC XT875 4G': ['Motorola', 'Droid Bionic'],
        'DROIDRAZR': ['Motorola', 'Droid RAZR'],
        'Droid Razr': ['Motorola', 'Droid RAZR'],
        'DROID RAZR': ['Motorola', 'Droid RAZR'],
        'DROID RAZR 4G': ['Motorola', 'Droid RAZR'],
        'DROID SPYDER': ['Motorola', 'Droid RAZR'],
        'DROID RAZR HD': ['Motorola', 'Droid RAZR HD'],
        'DROID RAZR HD 4G': ['Motorola', 'Droid RAZR HD'],
        'DroidX': ['Motorola', 'Droid X'],
        'DROIDX': ['Motorola', 'Droid X'],
        'droid x': ['Motorola', 'Droid X'],
        'Droid X': ['Motorola', 'Droid X'],
        'DROID X': ['Motorola', 'Droid X'],
        'DROID X2': ['Motorola', 'Droid X2'],
        'Electrify': ['Motorola', 'Electrify'],
        'Milestone XT720': ['Motorola', 'Milestone'],
        'Milestone Xt720': ['Motorola', 'Milestone'],
        'Milestone': ['Motorola', 'Milestone'],
        'A853 Milestone': ['Motorola', 'Milestone'],
        'Milestone X': ['Motorola', 'Milestone X'],
        'Milestone X2': ['Motorola', 'Milestone X2'],
        'MotoroiX': ['Motorola', 'Droid X'],
        'Moto Backflip': ['Motorola', 'BACKFLIP'],
        'RAZR': ['Motorola', 'RAZR'],
        'Triumph': ['Motorola', 'TRIUMPH'],
        'Opus One': ['Motorola', 'i1'],
        'Photon': ['Motorola', 'PHOTON'],
        'Photon 4G': ['Motorola', 'PHOTON 4G'],
        'XOOM': ['Motorola', 'XOOM', 'tablet'],
        'Xoom': ['Motorola', 'XOOM', 'tablet'],
        'XOOM 2': ['Motorola', 'XOOM 2', 'tablet'],
        'XOOM 2 ME': ['Motorola', 'XOOM 2', 'tablet'],
        'XOOM MZ606': ['Motorola', 'XOOM WiFi', 'tablet'],
        'ISW11M': ['Motorola', 'PHOTON'],
        'IS12M': ['Motorola', 'RAZR'],
        'MOTWX435KT': ['Motorola', 'TRIUMPH'],
        'X3-Ice MIUI XT720 Memorila Classics': ['Motorola', 'Milestone'],
        'NABI-A': ['Nabi', 'Kids tablet', 'tablet'],
        'Newpad': ['Newsmy', 'Newpad', 'tablet'],
        'Newpad-K97': ['Newsmy', 'Newpad K97', 'tablet'],
        'Newpad P9': ['Newsmy', 'Newpad P9', 'tablet'],
        'M-PAD N8': ['Newsmy', 'M-pad N8', 'tablet'],
        'LT-NA7': ['NEC', 'LT-NA7'],
        'N-01D': ['NEC', 'MEDIAS PP N-01D'],
        'N-04C': ['NEC', 'MEDIAS N-04C'],
        'N-04D': ['NEC', 'MEDIAS LTE N-04D'],
        'N-05D': ['NEC', 'MEDIAS ES N-05D'],
        'N-06C': ['NEC', 'MEDIAS WP N-06C'],
        'N-06D': ['NEC', 'MEDIAS Tab N-06D', 'tablet'],
        'N-07D': ['NEC', 'MEDIAS X N-07D'],
        '101N': ['NEC', 'MEDIAS CH Softbank 101N'],
        'IS11N': ['NEC', 'MEDIAS BR IS11N'],
        'Nexian NX-A890': ['Nexian', 'Journey'],
        'NX-A891': ['Nexian', 'Ultra Journey'],
        'M726HC': ['Nextbook', 'Premium 7', 'ereader'],
        'NXM726HN': ['Nextbook', 'Premium 7', 'ereader'],
        'NXM803HD': ['Nextbook', 'Premium 8', 'ereader'],
        'DATAM803HC': ['Nextbook', 'Premium 8', 'ereader'],
        'NXM901': ['Nextbook', 'Next 3', 'ereader'],
        'NGM Vanity Smart': ['NGM', 'Vanity Smart'],
        'Nokia N9': ['Nokia', 'N9'],
        'Nokia N900': ['Nokia', 'N900'],
        'Lumia800': ['Nokia', 'Lumia 800'],
        'Lumia 900': ['Nokia', 'Lumia 900'],
        'Notion Ink ADAM': ['Notion Ink', 'ADAM', 'tablet'],
        'P4D SIRIUS': ['Nvsbl', 'P4D SIRIUS', 'tablet'],
        'P4D Sirius': ['Nvsbl', 'P4D SIRIUS', 'tablet'],
        'EFM710A': ['Oblio', 'Mint 7x', 'tablet'],
        'ODYS-Xpress': ['Odys', 'Xpress', 'tablet'],
        'Olivetti Olipad 100': ['Olivetti', 'Olipad 100', 'tablet'],
        'OP110': ['Olivetti', 'Olipad 110', 'tablet'],
        'ONDA MID': ['Onda', 'MID', 'tablet'],
        'VX580A': ['Onda', 'VX580A', 'tablet'],
        'VX610A': ['Onda', 'VX610A', 'tablet'],
        'TQ150': ['Onda', 'TQ150'],
        'N2T': ['ONN', 'N2T', 'tablet'],
        'Renesas': ['Opad', 'Renesas', 'tablet'],
        'renesas emev': ['Opad', 'Renesas', 'tablet'],
        'X903': ['Oppo', 'Find Me X903'],
        'X905': ['Oppo', 'Find 3 X905'],
        'R805': ['Oppo', 'R805'],
        'R801': ['Oppo', 'R801'],
        'R811': ['Oppo', 'R811'],
        'X909': ['Oppo', 'X909'],
        'OPPOR801': ['Oppo', 'R801'],
        'OPPOX905': ['Oppo', 'Find 3 X905'],
        'OPPOX907': ['Oppo', 'Find 3 X907'],
        'X907': ['Oppo', 'Find 3 X907'],
        'X9015': ['Oppo', 'Find X9015'],
        'OPPOX9017': ['Oppo', 'Finder X9017'],
        'OPPOU701': ['Oppo', 'OPPOU701'],
        'OPPOR807': ['Oppo', 'Real R807'],
        'OPPOR805': ['Oppo', 'Real R805'],
        'R807': ['Oppo', 'Real R807'],
        'OPPOT703': ['Oppo', 'T703'],
        'P-01D': ['Panasonic', 'P-01D'],
        'P-02D': ['Panasonic', 'Lumix Phone'],
        'P-04D': ['Panasonic', 'Eluga'],
        'P-07C': ['Panasonic', 'P-07C'],
        'dL1': ['Panasonic', 'Eluga dL1'],
        '101P': ['Panasonic', 'Lumix Phone'],
        'JT-H580VT': ['Panasonic', 'BizPad 7', 'tablet'],
        'JT-H581VT': ['Panasonic', 'BizPad 10', 'tablet'],
        'FZ-A1A': ['Panasonic', 'Toughpad', 'tablet'],
        'pandigital9hr': ['Pandigital', '9HR', 'tablet'],
        'pandigital9hr2': ['Pandigital', '9HR2', 'tablet'],
        'pandigitalopc1': ['Pandigital', 'OPC1', 'tablet'],
        'pandigitalopp1': ['Pandigital', 'OPP1', 'tablet'],
        'pandigitalp1hr': ['Pandigital', 'p1hr', 'tablet'],
        'IM-A600S': ['Pantech', 'SIRIUS \u00c3\ufffd\u00c2\u00b1'],
        'IM-A630K': ['Pantech', 'SKY Izar'],
        'IM-A690L': ['Pantech', 'SKY'],
        'IM-A690S': ['Pantech', 'SKY'],
        'IM-A710K': ['Pantech', 'SKY Vega Xpress'],
        'IM-A720L': ['Pantech', 'SKY Vega Xpress'],
        'IM-A725L': ['Pantech', 'SKY Vega X+'],
        'IM-A730s': ['Pantech', 'SKY Vega S'],
        'IM-A730S': ['Pantech', 'SKY Vega S'],
        'IM-A750K': ['Pantech', 'SKY Mirach A'],
        'IM-A760S': ['Pantech', 'SKY Vega Racer'],
        'IM-A770K': ['Pantech', 'SKY Vega Racer'],
        'IM-A780L': ['Pantech', 'SKY Vega Racer'],
        'IM-A800S': ['Pantech', 'SKY Vega LTE'],
        'IM-A810K': ['Pantech', 'SKY Vega LTE M'],
        'IM-A810S': ['Pantech', 'SKY Vega LTE M'],
        'IM-A820L': ['Pantech', 'SKY Vega LTE EX'],
        'IM-A830K': ['Pantech', 'SKY Vega Racer 2'],
        'IM-A830L': ['Pantech', 'SKY Vega Racer 2'],
        'IM-A830S': ['Pantech', 'SKY Vega Racer 2'],
        'IM-A840S': ['Pantech', 'SKY Vega S5'],
        'IM-A850K': ['Pantech', 'IM-A850K'],
        'IM-T100K': ['Pantech', 'SKY Vega No. 5', 'tablet'],
        'IS06': ['Pantech', 'SIRIUS \u00c3\ufffd\u00c2\u00b1'],
        'ADR8995': ['Pantech', 'Breakout'],
        'ADR8995 4G': ['Pantech', 'Breakout'],
        'ADR910L 4G': ['Pantech', 'ADR910L'],
        'PantechP4100': ['Pantech', 'Element', 'tablet'],
        'PantechP8000': ['Pantech', 'Crossover'],
        'PantechP8010': ['Pantech', 'P8010'],
        'PantechP9060': ['Pantech', 'Pocket'],
        'PantechP9070': ['Pantech', 'Burst'],
        'SKY IM-A600S': ['Pantech', 'SIRIUS \u00c3\ufffd\u00c2\u00b1'],
        'SKY IM-A630K': ['Pantech', 'SKY Izar'],
        'SKY IM-A650S': ['Pantech', 'SKY Vega'],
        'IS11PT': ['Pantech', 'Mirach IS11PT'],
        'PAT712W': ['Perfeo', 'PAT712W', 'tablet'],
        'X7G': ['Pearl', 'Touchlet X7G', 'tablet'],
        'FWS810': ['PHICOMM', 'FWS810'],
        'Philips PI5000': ['Philips', 'PI5000', 'tablet'],
        'PI7000': ['Philips', 'PI7000', 'tablet'],
        'Philips W626': ['Philips', 'W626'],
        'Philips W632': ['Philips', 'W632'],
        'MOMO': ['Ployer', 'MOMO', 'tablet'],
        'MOMO15': ['Ployer', 'MOMO15', 'tablet'],
        'PocketBook A7': ['PocketBook', 'A7', 'tablet'],
        'PocketBook A10': ['PocketBook', 'A10', 'tablet'],
        'Mobii 7': ['Point Of View', 'Mobii 7', 'tablet'],
        'PMP3384BRU': ['Prestigio', 'Multipad 3384', 'tablet'],
        'TB07FTA': ['Positivo', 'TB07FTA', 'tablet'],
        'QW TB-1207': ['Qware', 'Pro3', 'tablet'],
        'W6HD ICS': ['Ramos', 'W6HD', 'tablet'],
        'w10': ['Ramos', 'W10', 'tablet'],
        'W10': ['Ramos', 'W10', 'tablet'],
        'w10 v2.0': ['Ramos', 'W10 v2.0', 'tablet'],
        'W10 V2.0': ['Ramos', 'W10 v2.0', 'tablet'],
        'T11AD': ['Ramos', 'T11AD', 'tablet'],
        'T11AD.FE': ['Ramos', 'T11AD', 'tablet'],
        'PlayBook': ['RIM', 'BlackBerry PlayBook', 'tablet'],
        'RBK-490': ['Ritmix', 'RBK-490', 'tablet'],
        'A8HD': ['Saayi', 'Dropad A8HD', 'tablet'],
        'GT-S7568': ['Samsung', 'S7568'],
        'Galaxy Nexus': ['Samsung', 'Galaxy Nexus'],
        'GT-B5330': ['Samsung', 'GT-B5330'],
        'GT-B5510': ['Samsung', 'Galaxy Y Pro'],
        'GT-B5510B': ['Samsung', 'Galaxy Y Pro'],
        'GT-B5510L': ['Samsung', 'Galaxy Y Pro'],
        'GT-B5512': ['Samsung', 'Galaxy Y Pro Duos'],
        'GT-B7510': ['Samsung', 'Galaxy Pro'],
        'GT-B7510L': ['Samsung', 'Galaxy Pro'],
        'GT-I5500': ['Samsung', 'Galaxy 5'],
        'GT-I5500B': ['Samsung', 'Galaxy 5'],
        'GT-I5500L': ['Samsung', 'Galaxy 5'],
        'GT-I5500M': ['Samsung', 'Galaxy 5'],
        'GT-I5500-MR3': ['Samsung', 'Galaxy 5'],
        'GT-I5503': ['Samsung', 'Galaxy 5'],
        'GT-I5508': ['Samsung', 'Galaxy 5'],
        'GT-I5510': ['Samsung', 'Galaxy 551'],
        'GT-I5510L': ['Samsung', 'Galaxy 551'],
        'GT-I5510M': ['Samsung', 'Galaxy 551'],
        'GT-I5510T': ['Samsung', 'Galaxy 551'],
        'GT-I5700': ['Samsung', 'Galaxy Spica'],
        'GT-I5700L': ['Samsung', 'Galaxy Spica'],
        'GT-I5800': ['Samsung', 'Galaxy Apollo'],
        'GT-I5800D': ['Samsung', 'Galaxy Apollo'],
        'GT-I5800L': ['Samsung', 'Galaxy Apollo'],
        'GT-I5801': ['Samsung', 'Galaxy Apollo'],
        'GT-I6500U': ['Samsung', 'Saturn'],
        'GT-I8000': ['Samsung', 'Omnia 2'],
        'GT-I8150': ['Samsung', 'Galaxy W'],
        'GT-I8150B': ['Samsung', 'Galaxy W'],
        'GT-I8160': ['Samsung', 'Galaxy Ace 2'],
        'GT-I8160L': ['Samsung', 'Galaxy Ace 2'],
        'GT-I8160P': ['Samsung', 'Galaxy Ace 2'],
        'GT-I8320': ['Samsung', 'H1'],
        'GT-I8520': ['Samsung', 'Galaxy Beam'],
        'GT-I8530': ['Samsung', 'Galaxy Beam'],
        'GT-I8250': ['Samsung', 'Galaxy Beam'],
        'GT-i9000': ['Samsung', 'Galaxy S'],
        'GT-I9000': ['Samsung', 'Galaxy S'],
        'GT-I9000B': ['Samsung', 'Galaxy S'],
        'GT-I9000M': ['Samsung', 'Galaxy S Vibrant'],
        'GT-I9000T': ['Samsung', 'Galaxy S'],
        'GT-I9001': ['Samsung', 'Galaxy S Plus'],
        'GT-I9003': ['Samsung', 'Galaxy SL'],
        'GT-I9003L': ['Samsung', 'Galaxy SL'],
        'GT-I9008': ['Samsung', 'Galaxy S'],
        'GT-I9008L': ['Samsung', 'Galaxy S'],
        'GT-I9010': ['Samsung', 'Galaxy S Giorgio Armani'],
        'GT-I9018': ['Samsung', 'Galaxy GT-I9018'],
        'GT-I9070': ['Samsung', 'Galaxy S Advance'],
        'GT-I9070P': ['Samsung', 'Galaxy S Advance'],
        'GT-I9082': ['Samsung', 'Galaxy Grand DUOS'],
        'GT-I9088': ['Samsung', 'Galaxy S'],
        'GT-i9100': ['Samsung', 'Galaxy S II'],
        'GT-I9100': ['Samsung', 'Galaxy S II'],
        'GT-I9100G': ['Samsung', 'Galaxy S II'],
        'GT-I9100M': ['Samsung', 'Galaxy S II'],
        'GT-I9100T': ['Samsung', 'Galaxy S II'],
        'GT-I9100P': ['Samsung', 'Galaxy S II'],
        'GT-I9103': ['Samsung', 'Galaxy R'],
        'GT-I9108': ['Samsung', 'Galaxy S II'],
        'GT-I9210': ['Samsung', 'Galaxy S II LTE'],
        'GT-I9210T': ['Samsung', 'Galaxy S II LTE'],
        'GT-I9220': ['Samsung', 'Galaxy Note'],
        'GT-I9228': ['Samsung', 'Galaxy Note'],
        'GT-I9250': ['Samsung', 'Galaxy Nexus'],
        'GT-I9250 EUR XX': ['Samsung', 'Galaxy Nexus'],
        'GT-I9260': ['Samsung', 'Galaxy Premier'],
        'GT-I9300': ['Samsung', 'Galaxy S III'],
        'GT-I9300T': ['Samsung', 'Galaxy S III'],
        'GT-I9303T': ['Samsung', 'Galaxy S III'],
        'GT-I9308': ['Samsung', 'Galaxy S III'],
        'GT-I9500': ['Samsung', 'Galaxy GT-I9500'],
        'GT-I9800': ['Samsung', 'Galaxy GT-I9800'],
        'GT-N7000': ['Samsung', 'Galaxy Note'],
        'GT-N7000B': ['Samsung', 'Galaxy Note'],
        'GT-N7100': ['Samsung', 'Galaxy Note II'],
        'GT-N7102': ['Samsung', 'Galaxy Note II'],
        'GT-N8000': ['Samsung', 'Galaxy Note 10.1'],
        'GT-N8010': ['Samsung', 'Galaxy Note 10.1'],
        'GT-P1000': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1000L': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1000M': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1000N': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1000T': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1000 Tablet': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P1010': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GT-P3100': ['Samsung', 'Galaxy Tab 2 (7.0)', 'tablet'],
        'GT-P3100B': ['Samsung', 'Galaxy Tab 2 (7.0)', 'tablet'],
        'GT-P3110': ['Samsung', 'Galaxy Tab 2 (7.0)', 'tablet'],
        'GT-P3113': ['Samsung', 'Galaxy Tab 2 (7.0)', 'tablet'],
        'GT-P5100': ['Samsung', 'Galaxy Tab 2 (10.1)', 'tablet'],
        'GT-P5110': ['Samsung', 'Galaxy Tab 2 (10.1)', 'tablet'],
        'GT-P5113': ['Samsung', 'Galaxy Tab 2 (10.1)', 'tablet'],
        'GT-P6200': ['Samsung', 'Galaxy Tab 7.0 Plus', 'tablet'],
        'GT-P6200L': ['Samsung', 'Galaxy Tab 7.0 Plus', 'tablet'],
        'GT-P6201': ['Samsung', 'Galaxy Tab 7.0 Plus N', 'tablet'],
        'GT-P6210': ['Samsung', 'Galaxy Tab 7.0 Plus', 'tablet'],
        'GT-P6211': ['Samsung', 'Galaxy Tab 7.0 Plus N', 'tablet'],
        'GT-P6800': ['Samsung', 'Galaxy Tab 7.7', 'tablet'],
        'GT-P6810': ['Samsung', 'Galaxy Tab 7.7', 'tablet'],
        'GT-P7100': ['Samsung', 'Galaxy Tab 10.1V', 'tablet'],
        'GT-P7300': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'GT-P7300B': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'GT-P7310': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'GT-P7320': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'GT-P7320T': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'GT-P7500': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'GT-P7500D': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'GT-P7500R': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'GT-P7500V': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'GT-P7501': ['Samsung', 'Galaxy Tab 10.1N', 'tablet'],
        'GT-P7510': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'GT-P7511': ['Samsung', 'Galaxy Tab 10.1N', 'tablet'],
        'GT-S5300': ['Samsung', 'Galaxy Pocket'],
        'GT-S5360': ['Samsung', 'Galaxy Y'],
        'GT-S5360B': ['Samsung', 'Galaxy Y'],
        'GT-S5360L': ['Samsung', 'Galaxy Y'],
        'GT-S5363': ['Samsung', 'Galaxy Y'],
        'GT-S5367': ['Samsung', 'Galaxy Y TV'],
        'GT-S5368': ['Samsung', 'GT-S5368'],
        'GT-S5369': ['Samsung', 'Galaxy Y'],
        'GT-S5570': ['Samsung', 'Galaxy Mini'],
        'GT-S5570B': ['Samsung', 'Galaxy Mini'],
        'GT-S5570I': ['Samsung', 'Galaxy Mini'],
        'GT-S5570L': ['Samsung', 'Galaxy Mini'],
        'GT-S5578': ['Samsung', 'Galaxy Mini'],
        'GT-S5660': ['Samsung', 'Galaxy Gio'],
        'GT-S5660M': ['Samsung', 'Galaxy Gio'],
        'GT-S5660V': ['Samsung', 'Galaxy Gio'],
        'GT-S5670': ['Samsung', 'Galaxy Fit'],
        'GT-S5670B': ['Samsung', 'Galaxy Fit'],
        'GT-S5670L': ['Samsung', 'Galaxy Fit'],
        'GT-S5690': ['Samsung', 'Galaxy Xcover'],
        'GT-S5690L': ['Samsung', 'Galaxy Xcover'],
        'GT-S5820': ['Samsung', 'Galaxy Ace'],
        'GT-S5830': ['Samsung', 'Galaxy Ace'],
        'GT-S5830B': ['Samsung', 'Galaxy Ace'],
        'GT-S5830C': ['Samsung', 'Galaxy Ace'],
        'GT-S5830D': ['Samsung', 'Galaxy Ace'],
        'GT-S5830D-parrot': ['Samsung', 'Galaxy Ace'],
        'GT-S5830i': ['Samsung', 'Galaxy Ace'],
        'GT-S5830L': ['Samsung', 'Galaxy Ace'],
        'GT-S5830M': ['Samsung', 'Galaxy Ace'],
        'GT-S5830T': ['Samsung', 'Galaxy Ace'],
        'GT-S5838': ['Samsung', 'Galaxy Ace'],
        'GT-S5839i': ['Samsung', 'Galaxy Ace'],
        'GT-S6102': ['Samsung', 'Galaxy Y Duos'],
        'GT-S6102B': ['Samsung', 'Galaxy Y Duos'],
        'GT-S6500': ['Samsung', 'Galaxy Mini 2'],
        'GT-S6500D': ['Samsung', 'Galaxy Mini 2'],
        'GT-S6702': ['Samsung', 'GT-S6702'],
        'GT-S6802': ['Samsung', 'Galaxy Ace Duos'],
        'GT-S7500': ['Samsung', 'Galaxy Ace Plus'],
        'GT-S7500L': ['Samsung', 'Galaxy Ace Plus'],
        'GT-S7500W': ['Samsung', 'Galaxy Ace Plus'],
        'GT-T959': ['Samsung', 'Galaxy S Vibrant'],
        'SCH-i509': ['Samsung', 'Galaxy Y'],
        'SCH-i559': ['Samsung', 'Galaxy Pop'],
        'SCH-i569': ['Samsung', 'Galaxy Gio'],
        'SCH-i579': ['Samsung', 'Galaxy Ace'],
        'SCH-i589': ['Samsung', 'Galaxy Ace Duos'],
        'SCH-i705 4G': ['Samsung', 'Galaxy Tab 2 (7.0)', 'tablet'],
        'SCH-i809': ['Samsung', 'SCH-i809'],
        'SCH-i889': ['Samsung', 'Galaxy Note'],
        'SCH-i909': ['Samsung', 'Galaxy S'],
        'SCH-i919': ['Samsung', 'SCH-i919'],
        'SCH-i929': ['Samsung', 'SCH-i929'],
        'SCH-I100': ['Samsung', 'Gem'],
        'SCH-I110': ['Samsung', 'Illusion'],
        'SCH-I400': ['Samsung', 'Continuum'],
        'SCH-I405': ['Samsung', 'Stratosphere'],
        'SCH-I405 4G': ['Samsung', 'Stratosphere'],
        'SCH-I500': ['Samsung', 'Fascinate'],
        'SCH-I510': ['Samsung', 'Stealth V'],
        'SCH-I510 4G': ['Samsung', 'Droid Charge'],
        'SCH-I515': ['Samsung', 'Galaxy Nexus'],
        'SCH-I535': ['Samsung', 'Galaxy S III'],
        'SCH-I535 4G': ['Samsung', 'Galaxy S III'],
        'SCH-I619': ['Samsung', 'SCH-I619'],
        'SCH-I699': ['Samsung', 'SCH-I699'],
        'SCH-I779': ['Samsung', 'SCH-I779'],
        'SCH-I800': ['Samsung', 'Galaxy Tab 7.0', 'tablet'],
        'SCH-I815': ['Samsung', 'Galaxy Tab 7.7', 'tablet'],
        'SCH-I815 4G': ['Samsung', 'Galaxy Tab 7.7', 'tablet'],
        'SCH-I905': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SCH-I905 4G': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SCH-I909': ['Samsung', 'Galaxy S'],
        'SCH-I915': ['Samsung', 'SCH-I915'],
        'SCH-I939': ['Samsung', 'Galaxy S III'],
        'SCH-M828C': ['Samsung', 'Galaxy Precedent'],
        'SCH-M828Carray(9096483449)': ['Samsung', 'Galaxy Precedent'],
        'SCH-R530U': ['Samsung', 'Galaxy S III'],
        'SCH-R680': ['Samsung', 'Repp'],
        'SCH-R720': ['Samsung', 'Admire'],
        'SCH-R730': ['Samsung', 'Transfix'],
        'SCH-R760': ['Samsung', 'Galaxy S II'],
        'SCH-R820': ['Samsung', 'SCH-R820'],
        'SCH-R880': ['Samsung', 'Acclaim'],
        'SCH-R910': ['Samsung', 'Galaxy Indulge 4G'],
        'SCH-R915': ['Samsung', 'Galaxy Indulge'],
        'SCH-R920': ['Samsung', 'Galaxy Attain 4G'],
        'SCH-R930': ['Samsung', 'Galaxy S Aviator'],
        'SCH-R940': ['Samsung', 'Galaxy S Lightray'],
        'SCH-S720C': ['Samsung', 'Galaxy Proclaim'],
        'SCH-S735C': ['Samsung', 'SCH-S735'],
        'SCH-W899': ['Samsung', 'SCH-W899'],
        'SCH-W999': ['Samsung', 'SCH-W999'],
        'SGH-I547': ['Samsung', 'SGH-I547'],
        'SGH-I717': ['Samsung', 'Galaxy Note'],
        'SGH-I717D': ['Samsung', 'Galaxy Note'],
        'SGH-I717M': ['Samsung', 'Galaxy Note'],
        'SGH-I717R': ['Samsung', 'Galaxy Note'],
        'SGH-I727': ['Samsung', 'Galaxy S II Skyrocket'],
        'SGH-i727R': ['Samsung', 'Galaxy S II'],
        'SGH-I727R': ['Samsung', 'Galaxy S II'],
        'SGH-I747': ['Samsung', 'Galaxy S III'],
        'SGH-I747M': ['Samsung', 'Galaxy S III'],
        'SGH-I748': ['Samsung', 'Galaxy S III'],
        'SGH-I757': ['Samsung', 'Galaxy S II Skyrocket HD'],
        'SGH-I777': ['Samsung', 'Galaxy S II'],
        'SGH-I9777': ['Samsung', 'Galaxy S II'],
        'SGH-I896': ['Samsung', 'Captivate'],
        'SGH-I897': ['Samsung', 'Captivate'],
        'SGH-I927': ['Samsung', 'Captivate Glide'],
        'SGH-I927R': ['Samsung', 'Captivate Glide'],
        'SGH-I957': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SGH-I957D': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SGH-I957M': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SGH-I957R': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SGH-I987': ['Samsung', 'Galaxy Tab 7.0', 'tablet'],
        'SGH-I997': ['Samsung', 'Infuse 4G'],
        'SGH-I997R': ['Samsung', 'Infuse 4G'],
        'SGH-I9000': ['Samsung', 'Galaxy S'],
        'SGH-S730G': ['Samsung', 'SGH-S730'],
        'SGH-T499': ['Samsung', 'Dart'],
        'SGH-T499V': ['Samsung', 'Galaxy Mini'],
        'SGH-T499Y': ['Samsung', 'Galaxy Mini'],
        'SGH-T589': ['Samsung', 'Gravity Smart'],
        'SGH-T589R': ['Samsung', 'Gravity Smart'],
        'SGH-T679': ['Samsung', 'Exhibit II 4G'],
        'SGH-T679M': ['Samsung', 'Exhibit II 4G'],
        'SGH-T759': ['Samsung', 'Exhibit 4G'],
        'SGH-T769': ['Samsung', 'Galaxy S Blaze 4G'],
        'SGH-T839': ['Samsung', 'T-Mobile Sidekick'],
        'SGH-T849': ['Samsung', 'Galaxy Tab 7.0', 'tablet'],
        'SGH-T859': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SGH-T869': ['Samsung', 'Galaxy Tab 7.0 Plus', 'tablet'],
        'SGH-T879': ['Samsung', 'Galaxy Note'],
        'SGH-T959': ['Samsung', 'Vibrant'],
        'SGH-T959D': ['Samsung', 'Galaxy S Fascinate 3G+'],
        'SGH-T959P': ['Samsung', 'Galaxy S Fascinate 4G'],
        'SGH-T959V': ['Samsung', 'Galaxy S 4G'],
        'SGH-T989': ['Samsung', 'Galaxy S II'],
        'SGH-T989D': ['Samsung', 'Galaxy S II X'],
        'SGH-T999': ['Samsung', 'Galaxy S Blaze 4G'],
        'SGH-T999V': ['Samsung', 'Galaxy S Blaze 4G'],
        'SHV-E120K': ['Samsung', 'Galaxy S II HD LTE'],
        'SHV-E120L': ['Samsung', 'Galaxy S II HD LTE'],
        'SHV-E120S': ['Samsung', 'Galaxy S II HD LTE'],
        'SHV-E110S': ['Samsung', 'Galaxy S II LTE'],
        'SHV-E140S': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SHV-E150S': ['Samsung', 'Galaxy Tab 7.7', 'tablet'],
        'SHV-E160K': ['Samsung', 'Galaxy Note'],
        'SHV-E160L': ['Samsung', 'Galaxy Note LTE'],
        'SHV-E160S': ['Samsung', 'Galaxy Note LTE'],
        'SHV-E170K': ['Samsung', 'SHV-E170K'],
        'SHV-E170L': ['Samsung', 'SHV-E170L'],
        'SHV-E210K': ['Samsung', 'Galaxy S III'],
        'SHV-E210L': ['Samsung', 'Galaxy S III'],
        'SHV-E210S': ['Samsung', 'Galaxy S III'],
        'SHW-M100S': ['Samsung', 'Galaxy A'],
        'SHW-M110S': ['Samsung', 'Galaxy S'],
        'SHW-M130L': ['Samsung', 'Galaxy U'],
        'SHW-M130K': ['Samsung', 'Galaxy K'],
        'SHW-M180K': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SHW-M180L': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SHW-M180S': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SHW-M180W': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SHW-M185S': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SHW-M190S': ['Samsung', 'Galaxy S Hoppin'],
        'SHW-M220L': ['Samsung', 'Galaxy Neo'],
        'SHW-M240S': ['Samsung', 'Galaxy Ace'],
        'SHW-M250K': ['Samsung', 'Galaxy S II'],
        'SHW-M250L': ['Samsung', 'Galaxy S II'],
        'SHW-M250S': ['Samsung', 'Galaxy S II'],
        'SHW-M300W': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SHW-M305W': ['Samsung', 'Galaxy Tab 8.9', 'tablet'],
        'SHW-M340S': ['Samsung', 'Galaxy M Style'],
        'SHW-M380K': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SHW-M380S': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SHW-M380W': ['Samsung', 'Galaxy Tab 10.1', 'tablet'],
        'SHW-M440S': ['Samsung', 'Galaxy S III'],
        'SMT-i9100': ['Samsung', 'SMT-I9100', 'tablet'],
        'SPH-D600': ['Samsung', 'Conquer 4G'],
        'SPH-D700': ['Samsung', 'Epic 4G'],
        'SPH-D705': ['Samsung', 'Epic 4G 2'],
        'SPH-D710': ['Samsung', 'Epic 4G Touch'],
        'SPH-L700': ['Samsung', 'Galaxy Nexus'],
        'SPH-L710': ['Samsung', 'Galaxy S III'],
        'SPH-M820': ['Samsung', 'Galaxy Prevail'],
        'SPH-M820-BST': ['Samsung', 'Galaxy Prevail'],
        'SPH-M580': ['Samsung', 'Replenish'],
        'SPH-M900': ['Samsung', 'Moment'],
        'SPH-M910': ['Samsung', 'Intercept'],
        'SPH-M920': ['Samsung', 'Transform'],
        'SPH-M930': ['Samsung', 'Transform Ultra'],
        'SPH-M930BST': ['Samsung', 'Transform Ultra'],
        'SPH-P100': ['Samsung', 'Galaxy Tab', 'tablet'],
        'YP-GB1': ['Samsung', 'Galaxy Player', 'media'],
        'YP-GB70': ['Samsung', 'Galaxy Player 70', 'media'],
        'YP-GB70D': ['Samsung', 'Galaxy Player 70 Plus', 'media'],
        'YP-GS1': ['Samsung', 'Galaxy S WiFi 3.6', 'media'],
        'YP-G1': ['Samsung', 'Galaxy S WiFi 4.0', 'media'],
        'YP-GI1': ['Samsung', 'Galaxy S WiFi 4.2', 'media'],
        'YP-G50': ['Samsung', 'Galaxy Player', 'media'],
        'YP-G70': ['Samsung', 'Galaxy S WiFi 5.0', 'media'],
        'GT9100': ['Samsung', 'Galaxy S II'],
        'I897': ['Samsung', 'Captivate'],
        'I7500': ['Samsung', 'Galaxy'],
        'I9000': ['Samsung', 'Galaxy S'],
        'T959': ['Samsung', 'Galaxy S Vibrant'],
        'Captivate-I897': ['Samsung', 'Captivate'],
        'Galaxy': ['Samsung', 'Galaxy'],
        'Galaxy Note': ['Samsung', 'Galaxy Note'],
        'GalaxyS': ['Samsung', 'Galaxy S'],
        'Galaxy S II': ['Samsung', 'Galaxy S II'],
        'Galaxy X': ['Samsung', 'Galaxy X'],
        'Galaxy Spica': ['Samsung', 'Galaxy Spica'],
        'GALAXY Tab': ['Samsung', 'Galaxy Tab', 'tablet'],
        'GALAXY NEXUS': ['Samsung', 'Galaxy Nexus'],
        'Vibrantmtd': ['Samsung', 'Vibrant'],
        'SC-01C': ['Samsung', 'Galaxy Tab', 'tablet'],
        'SC-01D': ['Samsung', 'Galaxy Tab 10.1 LTE', 'tablet'],
        'SC-02B': ['Samsung', 'Galaxy S'],
        'SC-02C': ['Samsung', 'Galaxy S II'],
        'SC-02D': ['Samsung', 'Galaxy Tab 7.0 Plus', 'tablet'],
        'SC-03D': ['Samsung', 'Galaxy S II LTE'],
        'SC-04D': ['Samsung', 'Galaxy Nexus'],
        'SC-05D': ['Samsung', 'Galaxy Note LTE'],
        'SC-06D': ['Samsung', 'Galaxy S III'],
        'ISW11SC': ['Samsung', 'Galaxy S II WiMAX'],
        'GT-S7562': ['Samsung', 'GT-S7562'],
        'GT-S7562i': ['Samsung', 'GT-S7562i'],
        'A01SH': ['Sharp', 'A01SH'],
        'IS01': ['Sharp', 'IS01'],
        'IS03': ['Sharp', 'IS03'],
        'IS05': ['Sharp', 'IS05'],
        'IS11SH': ['Sharp', 'Aquos IS11SH'],
        'IS12SH': ['Sharp', 'Aquos IS12SH'],
        'IS13SH': ['Sharp', 'Aquos IS13SH'],
        'IS14SH': ['Sharp', 'Aquos IS14SH'],
        'ISW16SH': ['Sharp', 'Aquos ISW16SH'],
        'EB-W51GJ': ['Sharp', 'EB-W51GJ'],
        'SBM003SH': ['Sharp', 'Galapagos'],
        'SBM005SH': ['Sharp', 'Galapagos'],
        'SBM006SH': ['Sharp', 'Aquos'],
        'SBM007SH': ['Sharp', 'Aquos 007SH'],
        'SBM009SH': ['Sharp', 'Aquos 009SH'],
        'SBM102SH': ['Sharp', 'Aquos 102SH'],
        'SBM103SH': ['Sharp', 'Aquos 103SH'],
        'SBM104SH': ['Sharp', 'Aquos 104SH'],
        'SBM107SH': ['Sharp', 'Aquos 107SH'],
        'SBM107SHB': ['Sharp', 'Aquos 107SH'],
        'SH-01D': ['Sharp', 'Aquos SH-01D'],
        'SH-02D': ['Sharp', 'Aquos slider SH-02D'],
        'SH-03C': ['Sharp', 'Lynx 3D'],
        'SH-06D': ['Sharp', 'Aquos SH-06D'],
        'SH-09D': ['Sharp', 'Aquos Zeta SH-09D'],
        'SH-10B': ['Sharp', 'Lynx'],
        'SH-12C': ['Sharp', 'Aquos'],
        'SH-13C': ['Sharp', 'Aquos f SH-13C'],
        'SH80F': ['Sharp', 'Aquos SH80F'],
        'SH72x8U': ['Sharp', 'SH72x8U'],
        'SH8118U': ['Sharp', 'SH8118U'],
        'SH8128U': ['Sharp', 'SH8128U'],
        'SH8158U': ['Sharp', 'SH8158U'],
        'SH8188U': ['Sharp', 'SH8188U'],
        'SH8268U': ['Sharp', 'SH8268U'],
        'INFOBAR C01': ['Sharp', 'INFOBAR C01'],
        'SPX-5': ['Simvalley', 'SPX-5'],
        'SPX-5 3G': ['Simvalley', 'SPX-5 3G'],
        'SmartQ G7': ['SmartQ', 'G7', 'tablet'],
        'SmartQT7': ['SmartQ', 'T7', 'tablet'],
        'SmartQT10': ['SmartQ', 'T10', 'tablet'],
        'SmartQT15': ['SmartQ', 'T15', 'tablet'],
        'SmartQT19': ['SmartQ', 'T19', 'tablet'],
        'SmartQT20': ['SmartQ', 'T20', 'tablet'],
        'OMS1 6': ['Sony Ericsson', 'A8i'],
        'E10a': ['Sony Ericsson', 'Xperia X10 Mini'],
        'E10i': ['Sony Ericsson', 'Xperia X10 Mini'],
        'E10iv': ['Sony Ericsson', 'Xperia X10 Mini'],
        'E15': ['Sony Ericsson', 'Xperia X8'],
        'E15a': ['Sony Ericsson', 'Xperia X8'],
        'E15i': ['Sony Ericsson', 'Xperia X8'],
        'E15iv': ['Sony Ericsson', 'Xperia X8'],
        'E15i-o': ['Sony Ericsson', 'Xperia X8'],
        'E16i': ['Sony Ericsson', 'W8 Walkman'],
        'LT11i': ['Sony Ericsson', 'Xperia Neo V'],
        'LT15': ['Sony Ericsson', 'Xperia Arc'],
        'LT15a': ['Sony Ericsson', 'Xperia Arc'],
        'LT15i': ['Sony Ericsson', 'Xperia Arc'],
        'LT15iv': ['Sony Ericsson', 'Xperia Arc'],
        'LT15i-o': ['Sony Ericsson', 'Xperia Arc'],
        'LT18a': ['Sony Ericsson', 'Xperia Arc S'],
        'LT18i': ['Sony Ericsson', 'Xperia Arc S'],
        'LT18iv': ['Sony Ericsson', 'Xperia Arc S'],
        'LT18i-o': ['Sony Ericsson', 'Xperia Arc S'],
        'LT22i': ['Sony', 'Xperia P'],
        'LT26i': ['Sony', 'Xperia S'],
        'LT26ii': ['Sony', 'Xperia S'],
        'LT26i-o': ['Sony', 'Xperia S'],
        'LT28at': ['Sony', 'Xperia Ion'],
        'LT28h': ['Sony', 'Xperia Ion'],
        'LT28i': ['Sony', 'Xperia Ion'],
        'LT29i': ['Sony', 'Xperia GX'],
        'SonyLT29i': ['Sony', 'Xperia GX'],
        'SonyLT30a': ['Sony', 'Xperia Mint'],
        'SonyLT30p': ['Sony', 'Xperia Mint'],
        'MK16a': ['Sony Ericsson', 'Xperia Pro'],
        'MK16i': ['Sony Ericsson', 'Xperia Pro'],
        'MT11a': ['Sony Ericsson', 'Xperia Neo V'],
        'MT11i': ['Sony Ericsson', 'Xperia Neo V'],
        'MT11iv': ['Sony Ericsson', 'Xperia Neo V'],
        'MT11i-o': ['Sony Ericsson', 'Xperia Neo V'],
        'MT15a': ['Sony Ericsson', 'Xperia Neo'],
        'MT15i': ['Sony Ericsson', 'Xperia Neo'],
        'MT15iv': ['Sony Ericsson', 'Xperia Neo'],
        'MT15i-o': ['Sony Ericsson', 'Xperia Neo'],
        'MT25i': ['Sony', 'Xperia Neo L'],
        'MT27i': ['Sony', 'Xperia Sola'],
        'R800a': ['Sony Ericsson', 'Xperia Play'],
        'R800i': ['Sony Ericsson', 'Xperia Play'],
        'R800iv': ['Sony Ericsson', 'Xperia Play'],
        'R800at': ['Sony Ericsson', 'Xperia Play'],
        'R800x': ['Sony Ericsson', 'Xperia Play'],
        'SK17a': ['Sony Ericsson', 'Xperia Mini Pro'],
        'SK17i': ['Sony Ericsson', 'Xperia Mini Pro'],
        'SK17iv': ['Sony Ericsson', 'Xperia Mini Pro'],
        'SK17i-o': ['Sony Ericsson', 'Xperia Mini Pro'],
        'ST15a': ['Sony Ericsson', 'Xperia Mini'],
        'ST15i': ['Sony Ericsson', 'Xperia Mini'],
        'ST17a': ['Sony Ericsson', 'Xperia Active'],
        'ST17i': ['Sony Ericsson', 'Xperia Active'],
        'ST18a': ['Sony Ericsson', 'Xperia Ray'],
        'ST18i': ['Sony Ericsson', 'Xperia Ray'],
        'ST18iv': ['Sony Ericsson', 'Xperia Ray'],
        'ST18av': ['Sony Ericsson', 'Xperia Ray'],
        'SonyST21': ['Sony', '\'Tapioca\''],
        'SonyST21i': ['Sony', '\'Tapioca\''],
        'SonyST21a2': ['Sony', '\'Tapioca\''],
        'ST21': ['Sony', '\'Tapioca\''],
        'ST21i': ['Sony', '\'Tapioca\''],
        'SonyST23i': ['Sony', '\'Tapioca DS\''],
        'ST25i': ['Sony', 'Xperia U'],
        'ST27i': ['Sony', 'Xperia Go'],
        'U20a': ['Sony Ericsson', 'Xperia X10 Mini Pro'],
        'U20i': ['Sony Ericsson', 'Xperia X10 Mini Pro'],
        'U20iv': ['Sony Ericsson', 'Xperia X10 Mini Pro'],
        'WT13i': ['Sony Ericsson', 'Mix Walkman'],
        'WT18i': ['Sony Ericsson', 'Walkman'],
        'WT19a': ['Sony Ericsson', 'Live with Walkman'],
        'WT19i': ['Sony Ericsson', 'Live with Walkman'],
        'WT19iv': ['Sony Ericsson', 'Live with Walkman'],
        'X8': ['Sony Ericsson', 'Xperia X8'],
        'X10': ['Sony Ericsson', 'Xperia X10'],
        'X10a': ['Sony Ericsson', 'Xperia X10'],
        'X10i': ['Sony Ericsson', 'Xperia X10'],
        'X10iv': ['Sony Ericsson', 'Xperia X10'],
        'X10S': ['Sony Ericsson', 'Xperia X10'],
        'X10mini': ['Sony Ericsson', 'Xperia X10 Mini'],
        'X10 Mini': ['Sony Ericsson', 'Xperia X10 Mini'],
        'X10 Mini Pro': ['Sony Ericsson', 'Xperia X10 Mini Pro'],
        'Z1i': ['Sony Ericsson', 'Xperia Play'],
        'S51SE': ['Sony Ericsson', 'Xperia Mini'],
        'IS11S': ['Sony Ericsson', 'Xperia Acro'],
        'IS12S': ['Sony Ericsson', 'Xperia Acro HD'],
        'SO-01B': ['Sony Ericsson', 'Xperia X10'],
        'SO-01C': ['Sony Ericsson', 'Xperia Arc'],
        'SO-01D': ['Sony Ericsson', 'Xperia Play'],
        'SO-02C': ['Sony Ericsson', 'Xperia Acro'],
        'SO-02D': ['Sony Ericsson', 'Xperia NX'],
        'SO-03C': ['Sony Ericsson', 'Xperia Ray'],
        'SO-03D': ['Sony Ericsson', 'Xperia Acro HD'],
        'SO-04D': ['Sony', 'Xperia GX'],
        'SO-05D': ['Sony', 'Xperia SX'],
        'XPERIA X8': ['Sony Ericsson', 'Xperia X8'],
        'Xperia X8': ['Sony Ericsson', 'Xperia X8'],
        'Xperia X10': ['Sony Ericsson', 'Xperia X10'],
        'Xperia ray': ['Sony Ericsson', 'Xperia Ray'],
        'Xperia Ray': ['Sony Ericsson', 'Xperia Ray'],
        'Xperia Arc': ['Sony Ericsson', 'Xperia Arc'],
        'Xperia Mini': ['Sony Ericsson', 'Xperia Mini'],
        'Xperia neo': ['Sony Ericsson', 'Xperia Neo'],
        'Xperia Neo': ['Sony Ericsson', 'Xperia Neo'],
        'XPERIA NEO': ['Sony Ericsson', 'Xperia Neo'],
        'Xperia NeoV': ['Sony Ericsson', 'Xperia Neo V'],
        'Xperia Neo V': ['Sony Ericsson', 'Xperia Neo V'],
        'Xperia Play': ['Sony Ericsson', 'Xperia Play'],
        'Sony Ericsson Xperia X1': ['Sony Ericsson', 'Xperia X1'],
        'SonyHayabusa': ['Sony', 'Xperia Ion'],
        'Hayabusa': ['Sony', 'Xperia Ion'],
        'nozomi': ['Sony', 'Xperia S'],
        'Sony Tablet P': ['Sony', 'Tablet P', 'tablet'],
        'Sony Tablet S': ['Sony', 'Tablet S', 'tablet'],
        'NWZ-Z1000Series': ['Sony', 'Walkman Z', 'media'],
        'NW-Z1000Series': ['Sony', 'Walkman Z', 'media'],
        'Spice Mi280': ['Spice', 'Mi-280'],
        'Spice Mi300': ['Spice', 'Mi-300'],
        'Spice Mi-310': ['Spice', 'Mi-310'],
        'Spice Mi-425': ['Spice', 'Mi-425'],
        'SPICE Mi-720': ['Spice', 'Mi-720'],
        'A7272+': ['Star', 'A7272+'],
        'e1109 v73 gq1002 ctp': ['Star', 'X18i'],
        'TS1004T': ['Surf 3Q', 'TS1004T', 'tablet'],
        'SYTABEX7-2': ['Sylvania', 'SYTABEX7', 'tablet'],
        'TCL A860': ['TCL', 'A860'],
        'TCL A906': ['TCL', 'A906'],
        'TCL A909': ['TCL', 'A909'],
        'TCL A919': ['TCL', 'A919'],
        'TCL A990': ['TCL', 'A990'],
        'TCL A996': ['TCL', 'A996'],
        'TCL A998': ['TCL', 'A998'],
        'TCL GENESEE E708': ['TCL', 'Genesee E708'],
        'A10t(5DM3)': ['Teclast', 'A10T', 'tablet'],
        'P72': ['Teclast', 'P72', 'tablet'],
        'P76TI': ['Teclast', 'P76Ti', 'tablet'],
        'P81HD': ['Teclast', 'P81HD', 'tablet'],
        'P85(R8A1)': ['Teclast', 'P85', 'tablet'],
        'T720 SE': ['Teclast', 'T720', 'tablet'],
        'T760 from moage.com': ['Teclast', 'T760', 'tablet'],
        'tegav2': ['Tegatech', 'TEGA v2', 'tablet'],
        'TM-7025': ['teXet', 'TM-7025', 'tablet'],
        'MoFing': ['Thomson', 'MoFing', 'tablet'],
        'Ultimate10': ['Tomtec', 'Ultimate10', 'tablet'],
        'Thl V7': ['THL', 'V7'],
        'ThL V7': ['THL', 'V7'],
        'ThL V8': ['THL', 'V8'],
        'ThL V9': ['THL', 'V9'],
        'ThL V11': ['THL', 'V11'],
        'TSB CLOUD COMPANION;TOSHIBA AC AND AZ': ['Toshiba', 'Dynabook AZ', 'desktop'],
        'TOSHIBA AC AND AZ': ['Toshiba', 'Dynabook AZ', 'desktop'],
        'TOSHIBA FOLIO AND A': ['Toshiba', 'Folio 100', 'tablet'],
        'T-01C': ['Toshiba', 'Regza T-01C'],
        'T-01D': ['Toshiba', 'Regza T-01D'],
        'IS04': ['Toshiba', 'Regza IS04'],
        'IS11T': ['Toshiba', 'Regza IS11T'],
        'AT1S0': ['Toshiba', 'Regza AT1S0'],
        'Tostab03': ['Toshiba', 'Regza AT100', 'tablet'],
        'AT100': ['Toshiba', 'Regza AT100', 'tablet'],
        'AT200': ['Toshiba', 'Regza AT200', 'tablet'],
        'AT470': ['Toshiba', 'Regza AT470', 'tablet'],
        'AT570': ['Toshiba', 'Regza AT570', 'tablet'],
        'AT830': ['Toshiba', 'Regza AT830', 'tablet'],
        'Folio 100': ['Toshiba', 'Folio 100', 'tablet'],
        'folio100': ['Toshiba', 'Folio 100', 'tablet'],
        'THRiVE': ['Toshiba', 'THRiVE', 'tablet'],
        'Fantastic T3': ['TWM', 'Fantastic T3'],
        'M70014': ['United Star Technology', 'M70014', 'tablet'],
        'PS47': ['Velocity Micro', 'Cruz PS47', 'tablet'],
        'T301': ['Velocity Micro', 'Cruz T301', 'tablet'],
        'Vibo-A688': ['FIH', 'Vibo A688'],
        'Videocon-V7500': ['Videocon', 'V7500'],
        'GTablet': ['ViewSonic', 'gTablet', 'tablet'],
        'GtabComb': ['ViewSonic', 'gTablet', 'tablet'],
        'TeamDRH ICS for GTablet': ['ViewSonic', 'gTablet', 'tablet'],
        'ViewPad7': ['ViewSonic', 'ViewPad 7', 'tablet'],
        'ViewPad 10e': ['ViewSonic', 'ViewPad 10e', 'tablet'],
        'VTAB1008': ['Vizio', 'VTAB1008', 'tablet'],
        'VTAB3010': ['Vizio', 'VTAB3010', 'tablet'],
        'VOTO W5300': ['VOTO', 'W5300'],
        'xPAD-70': ['WayteQ', 'xPAD-70', 'tablet'],
        'xTAB-70': ['WayteQ', 'xTAB-70', 'tablet'],
        'WellcoM-A99': ['WellcoM', 'A99'],
        'N12': ['Window', 'N12', 'tablet'],
        'N12R': ['Window', 'N12R', 'tablet'],
        'N50': ['Window', 'N50', 'tablet'],
        'N50DT': ['Window', 'N50DT', 'tablet'],
        'N50GT': ['Window', 'N50GT', 'tablet'],
        'N50GT A': ['Window', 'N50GT-A', 'tablet'],
        'N70': ['Window', 'N70', 'tablet'],
        'N70 DUAL CORE': ['Window', 'N70 Dual Core', 'tablet'],
        'N80': ['Window', 'N80', 'tablet'],
        'N90': ['Window', 'N90', 'tablet'],
        'N90 DUAL CORE2 V12': ['Window', 'N90 Dual Core', 'tablet'],
        'N612': ['Wishway', 'N612'],
        'AT-AS43D': ['Wolfgang', 'AT-AS43D'],
        'M12': ['Wopad', 'M12', 'tablet'],
        'WM8650': ['WonderMedia', 'WM8650', 'tablet'],
        'MI-ONE': ['Xiaomi', 'MI-ONE'],
        'MI-ONE C1': ['Xiaomi', 'MI-ONE C1'],
        'MI-ONE Plus': ['Xiaomi', 'MI-ONE Plus'],
        'MI 1S': ['Xiaomi', 'MI-ONE Plus'],
        'MI 1SC': ['Xiaomi', 'MI-ONE 1SC'],
        'mione plus': ['Xiaomi', 'MI-ONE Plus'],
        'MI-TWO': ['Xiaomi', 'MI-TWO'],
        'MI 2': ['Xiaomi', 'MI-TWO'],
        'MI 2S': ['Xiaomi', 'MI-TWO Plus'],
        'MI 2SC': ['Xiaomi', 'MI-TWO Plus'],
        'Q07CL01': ['XVision', 'Q07', 'tablet'],
        'N6': ['Yarvik', '210 Tablet', 'tablet'],
        'EMR1879': ['Yidong', 'EMR1879', 'tablet'],
        'yusun W702': ['Yusun', 'W702'],
        'YX-YUSUN E80': ['Yusun', 'E80'],
        'zt180': ['Zenithink', 'ZT-180', 'tablet'],
        'Jaguar7': ['ZiiLabs', 'Jaguar 7', 'tablet'],
        'Ziss Ranger HD': ['Ziss', 'Ranger HD'],
        'ZTE Libra': ['ZTE', 'Libra'],
        'ZTE-T T9': ['ZTE', 'Light Tab T9', 'tablet'],
        'V9': ['ZTE', 'Light Tab V9', 'tablet'],
        'V9e+': ['ZTE', 'Light Tab 2', 'tablet'],
        'V9A': ['ZTE', 'Light Tab 2', 'tablet'],
        'Light Tab 2W': ['ZTE', 'Light Tab 2', 'tablet'],
        'Light Tab 2': ['ZTE', 'Light Tab 2', 'tablet'],
        'V9C': ['ZTE', 'Light Tab 3', 'tablet'],
        'V55': ['ZTE', 'Optik', 'tablet'],
        'Acqua': ['ZTE', 'Acqua'],
        'Blade': ['ZTE', 'Blade'],
        'Blade-V880': ['ZTE', 'Blade'],
        'ZTE-U V880': ['ZTE', 'Blade'],
        'Blade-opda': ['ZTE', 'Blade'],
        'ZTE-BLADE': ['ZTE', 'Blade'],
        'ZTE Blade': ['ZTE', 'Blade'],
        'ZTE V880': ['ZTE', 'Blade'],
        'ZTE-U(V)880+': ['ZTE', 'Blade'],
        'V880': ['ZTE', 'Blade'],
        'a5': ['ZTE', 'Blade'],
        'Blade2': ['ZTE', 'Blade 2'],
        'Blade S': ['ZTE', 'Blade S'],
        'X500': ['ZTE', 'Score'],
        'ZTE-X500': ['ZTE', 'Score'],
        'Skate': ['ZTE', 'Skate'],
        'ZTE Skate': ['ZTE', 'Skate'],
        'ZTE-Skate': ['ZTE', 'Skate'],
        'ZTE-SKATE': ['ZTE', 'Skate'],
        'ZTE-V960': ['ZTE', 'Skate'],
        'ZTE-U V960': ['ZTE', 'Skate'],
        'ZTE Racer': ['ZTE', 'Racer'],
        'ZTE-RACER': ['ZTE', 'Racer'],
        'MTC 916': ['ZTE', 'Racer'],
        'Racer': ['ZTE', 'Racer'],
        'RacerII': ['ZTE', 'Racer 2'],
        'RACERII': ['ZTE', 'Racer 2'],
        'ZTE Roamer': ['ZTE', 'Roamer'],
        'N860': ['ZTE', 'Warp'],
        'N880': ['ZTE', 'Blade'],
        'ZTE-T U802': ['ZTE', 'T-U802'],
        'ZTE-T U806': ['ZTE', 'T-U806'],
        'ZTE-T U812': ['ZTE', 'T-U812'],
        'ZTE-T U830': ['ZTE', 'T-U830'],
        'ZTE-T U880': ['ZTE', 'T-U880'],
        'ZTE T U880': ['ZTE', 'T-U880'],
        'ZTE-TU880': ['ZTE', 'T-U880'],
        'ZTE-TU900': ['ZTE', 'T-U900'],
        'ZTE-T U960': ['ZTE', 'T-U960'],
        'ZTE-TU960s': ['ZTE', 'T-U960'],
        'ZTE-T U960s': ['ZTE', 'T-U960'],
        'ZTE U N720': ['ZTE', 'U-N720'],
        'ZTE-U V856': ['ZTE', 'U-V856'],
        'ZTE-U V857': ['ZTE', 'U-V857'],
        'ZTE-U V881': ['ZTE', 'U-V881'],
        'ZTE-U X850': ['ZTE', 'U-X850'],
        'ZTE-U X876': ['ZTE', 'U-X876'],
        'ZTE-X876': ['ZTE', 'U-X876'],
        'ZTE-C R750': ['ZTE', 'C-R750'],
        'ZTE-C N600': ['ZTE', 'C-N600'],
        'ZTE-C N600+': ['ZTE', 'C-N600'],
        'ZTE-C N606': ['ZTE', 'C-N606'],
        'ZTE-C N700': ['ZTE', 'C-N700'],
        'ZTE-C N760': ['ZTE', 'C-N760'],
        'ZTE-C N880': ['ZTE', 'C-N880'],
        'ZTE-C N880S': ['ZTE', 'C-N880'],
        'ZTE-C N880s': ['ZTE', 'C-N880'],
        'ZTE-C X500': ['ZTE', 'C-X500'],
        'ZTE-C X920': ['ZTE', 'C-X920'],
        'ZXY-ZTE-C X920': ['ZTE', 'C-X920'],
        'ZTE GV821': ['ZTE', 'G-V821'],
        'ZTE N880E': ['ZTE', 'N880E'],
        'ZTE-N880E': ['ZTE', 'N880E'],
        'MIUI N880S': ['ZTE', 'N880S'],
        'ZTE N882E': ['ZTE', 'N882E'],
        'ZTE N855D': ['ZTE', 'N855D'],
        'ZTE-N910': ['ZTE', 'N910'],
        'E810': ['ZTE', 'E810'],
        'u880': ['ZTE', 'U880'],
        'ZTE U880E': ['ZTE', 'U880E'],
        'U880': ['ZTE', 'U880'],
        'ZTE U970': ['ZTE', 'U970'],
        'ZTE V768': ['ZTE', 'V768'],
        'ZTE-V856': ['ZTE', 'V856'],
        'ZTE V877b': ['ZTE', 'V877'],
        'ZTE V889D': ['ZTE', 'V889'],
        'ZTE-Z990': ['ZTE', 'Z990'],
        'ZTEU790': ['ZTE', 'U790'],
        '003Z': ['ZTE', 'Softbank 003Z'],
        '008Z': ['ZTE', 'Softbank 008Z'],
        '009Z': ['ZTE', 'Softbank Star7'],
        'i-mobile i691': ['i-Mobile', 'i691'],
        'i-mobile i695': ['i-Mobile', 'i695'],
        'i-mobile i858': ['i-Mobile', 'i858'],
        'i-mobile 3G 8500': ['i-Mobile', '3G 8500'],
        'i-mobile I-Note': ['i-Mobile', 'i-Note', 'tablet'],
        'Optimus Boston': ['Optimus', 'Boston'],
        'Optimus San Francisco': ['Optimus', 'San Francisco'],
        'Optimus Monte Carlo': ['Optimus', 'Monte Carlo'],
        'Orange Boston': ['Orange', 'Boston'],
        'Orange Monte Carlo': ['Orange', 'Monte Carlo'],
        'San Francisco': ['Orange', 'San Francisco'],
        'San Francisco for Orange': ['Orange', 'San Francisco'],
        'Orange San Francisco': ['Orange', 'San Francisco'],
        'MOVE': ['T-Mobile', 'MOVE'],
        'T-Mobile G1': ['T-Mobile', 'G1'],
        'T-Mobile G2': ['T-Mobile', 'G2'],
        'T-Mobile G2 Touch': ['T-Mobile', 'G2'],
        'LG-P999': ['T-Mobile', 'G2x'],
        'LG-E739': ['T-Mobile', 'myTouch'],
        'T-Mobile myTouch 3G': ['T-Mobile', 'myTouch 3G'],
        'T-Mobile myTouch 3G Slide': ['T-Mobile', 'myTouch 3G Slide'],
        'T-Mobile Espresso': ['T-Mobile', 'myTouch 3G Slide'],
        'HTC myTouch 3G Slide': ['T-Mobile', 'myTouch 3G Slide'],
        'T-Mobile myTouch 4G': ['T-Mobile', 'myTouch 4G'],
        'HTC Glacier': ['T-Mobile', 'myTouch 4G'],
        'HTC Panache': ['T-Mobile', 'myTouch 4G'],
        'myTouch4G': ['T-Mobile', 'myTouch 4G'],
        'My Touch 4G': ['T-Mobile', 'myTouch 4G'],
        'HTC Mytouch 4G': ['T-Mobile', 'myTouch 4G'],
        'HTC My Touch 4G': ['T-Mobile', 'myTouch 4G'],
        'HTC mytouch4g': ['T-Mobile', 'myTouch 4G'],
        'HTC myTouch 4G Slide': ['T-Mobile', 'myTouch 4G Slide'],
        'myTouch 4G Slide': ['T-Mobile', 'myTouch 4G Slide'],
        'T-Mobile myTouch Q': ['T-Mobile', 'myTouch Q'],
        'LG-C800': ['T-Mobile', 'myTouch Q'],
        'Pulse Mini': ['T-Mobile', 'Pulse Mini'],
        'Vodafone 845': ['Vodafone', '845 Nova'],
        'Vodafone 858': ['Vodafone', '858 Smart'],
        'Vodafone 945': ['Vodafone', '945'],
        'Vodafone Smart II': ['Vodafone', 'Smart II'],
        'SmartTab10': ['Vodafone', 'SmartTab 10', 'tablet'],
        'SCH-N719': ['Samsung', 'Galaxy Note II'],
        'Coolpad 8190': ['Coolpad', '8190'],
        'U705T': ['Oppo', 'Ulike2'],
        'Coolpad 8020+': ['Coolpad', '8020'],
        'Huawei Y310-5000': ['Huawei', 'Y310'],
        'GT-S7572': ['Samsung', 'Galaxy Trend Duos II'],
        'Lenovo A278t': ['Lenovo', 'A278t'],
        'Lenovo A690': ['Lenovo', 'A690'],
        'GT-I8262D': ['Samsung', 'LePhone I8262D'],
        'Lenovo A278t': ['Lenovo', 'A278t'],
        'MI 2C': ['Xiaomi', 'MI-TWO'],
        'Coolpad 8070': ['Coolpad', '8070'],
        'R813T': ['Oppo', 'R813T'],
        'ZTE U930': ['ZTE', 'U930'],
        'Lenovo A360': ['Lenovo', 'LePhone A360'],
        'SCH-N719': ['Samsung', 'Galaxy Note II'],
        'Coolpad 8010': ['Coolpad', '8010'],
        'LENOVO-Lenovo-A288t': ['Lenovo', 'A288t'],
        'U701T': ['Oppo', 'U701T'],
        'ZTEU795': ['Coolpad', 'U795'],
        'Haier-HT-I617': ['Haier', 'I617'],
        'ZTEU880s': ['ZTE', 'T-U880'],
        'GT-S6352': ['Samsung', 'GT-S6352'],
        'GT-S7568': ['Samsung', 'GT-S7568'],
        'K-Touch T619+': ['K-Touch', 'T619'],
        'MI 2A': ['Xiaomi', 'MI-TWO A'],
        'GT-N7108': ['Samsung', 'Galaxy Note II'],
        'K-Touch T621': ['K-Touch', 'T621'],
        'LENOVO-Lenovo-A298t': ['Lenovo', 'A298'],
        'Coolpad 8150': ['Coolpad', '8150'],
        '5860S': ['Coolpad', '5860'],
        'ZTEU807': ['ZTE', 'U807'],
        'SCH-I739': ['Samsung', 'SCH-I739'],
        'SCH-I829': ['Samsung', 'SCH-I829'],
        'HS-E830': ['Hisense', 'E830'],
        'HS-E920': ['Hisense', 'E920'],
        'Lenovo S720': ['Lenovo', 'S720'],
        'MI 2C': ['Xiaomi', 'MI-TWO'],
        'OPPO R813T': ['Oppo', 'R813'],
        'SCH-I879': ['Samsung', 'Galaxy Note'],
        'GT-S6102E': ['Samsung', 'Galaxy Y Duos']
    }

    var BLACKBERRY_MODELS = {
        '9600': 'Bold',
        '9650': 'Bold',
        '9700': 'Bold',
        '9780': 'Bold',
        '9790': 'Bold',
        '9900': 'Bold',
        '9930': 'Bold',
        '8300': 'Curve',
        '8310': 'Curve',
        '8320': 'Curve',
        '8330': 'Curve',
        '8350i': 'Curve',
        '8520': 'Curve',
        '8530': 'Curve',
        '8900': 'Curve',
        '9220': 'Curve',
        '9300': 'Curve',
        '9330': 'Curve',
        '9350': 'Curve',
        '9360': 'Curve',
        '9370': 'Curve',
        '9380': 'Curve',
        '8100': 'Pearl',
        '8110': 'Pearl',
        '8120': 'Pearl',
        '8130': 'Pearl',
        '8220': 'Pearl',
        '8230': 'Pearl',
        '9100': 'Pearl',
        '9105': 'Pearl',
        '9530': 'Storm',
        '9550': 'Storm',
        '9670': 'Style',
        '9800': 'Torch',
        '9810': 'Torch',
        '9850': 'Torch',
        '9860': 'Torch',
        '9630': 'Tour',
        '9981': 'Porsche P'
    };


    var Version = function () {
        this.initialize.apply(this, Array.prototype.slice.call(arguments))
    };
    Version.prototype = {
        initialize: function (v) {
            this.original = v.value || null;
            this.alias = v.alias || null;
            
        }
    }

    var Detected = function () {
        this.initialize.apply(this, arguments)
    };
    Detected.prototype = {
        initialize: function (ua, options) {
            this.options = {
                useFeatures: options && options.useFeatures || false,
                detectCamouflage: options && options.detectCamouflage || true
            }

            this.browser = {
                'stock': true,
                'hidden': false,
                'channel': ''
            };
            this.engine = {};
            this.os = {};
            this.device = {
                'type': 'desktop',
                'identified': false
            };

            this.camouflage = false;
            this.features = [];
            this.detect(ua);
        },

        detect: function (ua) {

            /****************************************************
             *      Unix
             */

            if (ua.match('Unix')) {
                this.os.name = 'Unix';
            }

            /****************************************************
             *      FreeBSD
             */

            if (ua.match('FreeBSD')) {
                this.os.name = 'FreeBSD';
            }

            /****************************************************
             *      OpenBSD
             */

            if (ua.match('OpenBSD')) {
                this.os.name = 'OpenBSD';
            }

            /****************************************************
             *      NetBSD
             */

            if (ua.match('NetBSD')) {
                this.os.name = 'NetBSD';
            }

            /****************************************************
             *      SunOS
             */

            if (ua.match('SunOS')) {
                this.os.name = 'Solaris';
            }

            /****************************************************
             *      Linux
             */

            if (ua.match('Linux')) {
                this.os.name = 'Linux';

                if (ua.match('CentOS')) {
                    this.os.name = 'CentOS';
                    if (match = /CentOS\/[0-9\.\-]+el([0-9_]+)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1].replace(/_/g, '.')
                        });
                    }
                }

                if (ua.match('Debian')) {
                    this.os.name = 'Debian';
                }

                if (ua.match('Fedora')) {
                    this.os.name = 'Fedora';
                    if (match = /Fedora\/[0-9\.\-]+fc([0-9]+)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1]
                        });
                    }
                }

                if (ua.match('Gentoo')) {
                    this.os.name = 'Gentoo';
                }

                if (ua.match('Kubuntu')) {
                    this.os.name = 'Kubuntu';
                }

                if (ua.match('Mandriva Linux')) {
                    this.os.name = 'Mandriva';
                    if (match = /Mandriva Linux\/[0-9\.\-]+mdv([0-9]+)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1]
                        });
                    }
                }

                if (ua.match('Mageia')) {
                    this.os.name = 'Mageia';
                    if (match = /Mageia\/[0-9\.\-]+mga([0-9]+)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1]
                        });
                    }
                }

                if (ua.match('Red Hat')) {
                    this.os.name = 'Red Hat';
                    if (match = /Red Hat[^\/]*\/[0-9\.\-]+el([0-9_]+)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1].replace(/_/g, '.')
                        });
                    }
                }

                if (ua.match('Slackware')) {
                    this.os.name = 'Slackware';
                }

                if (ua.match('SUSE')) {
                    this.os.name = 'SUSE';
                }

                if (ua.match('Turbolinux')) {
                    this.os.name = 'Turbolinux';
                }

                if (ua.match('Ubuntu')) {
                    this.os.name = 'Ubuntu';
                    if (match = /Ubuntu\/([0-9.]*)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1]
                        });
                    }
                }
            }

            /****************************************************
             *      iOS
             */

            if (ua.match('iPhone( Simulator)?;') || ua.match('iPad;') || ua.match('iPod;') || ua.match(/iPhone\s*\d*s?[cp]?;/i)) {
                this.os.name = 'iOS';
                this.os.version = new Version({
                    value: '1.0'
                });

                if (match = /OS (.*) like Mac OS X/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1].replace(/_/g, '.')
                    });
                }

                if (ua.match('iPhone Simulator;')) {
                    this.device.type = 'emulator';
                } else if (ua.match('iPod;')) {
                    this.device.type = 'media';
                    this.device.manufacturer = 'Apple';
                    this.device.model = 'iPod Touch';
                } else if (ua.match('iPhone;') || ua.match(/iPhone\s*\d*s?[cp]?;/i)) {
                    this.device.type = 'mobile';
                    this.device.manufacturer = 'Apple';
                    this.device.model = 'iPhone';
                } else {
                    this.device.type = 'tablet';
                    this.device.manufacturer = 'Apple';
                    this.device.model = 'iPad';
                }

                this.device.identified = true;
            }

            /****************************************************
             *      MacOS X
             */

            else if (ua.match('Mac OS X')) {
                this.os.name = 'Mac OS X';

                if (match = /Mac OS X (10[0-9\._]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1].replace(/_/g, '.')
                    });
                }
            }

            /****************************************************
             *      Windows
             */

            if (ua.match('Windows')) {
                this.os.name = 'Windows';

                if (match = /Windows NT ([0-9]\.[0-9])/.exec(ua)) {
                    this.os.version = parseVersion(match[1]);

                    switch (match[1]) {
                        case '6.2':
                            this.os.version = new Version({
                                value: match[1],
                                alias: '8'
                            });
                            break;
                        case '6.1':
                            this.os.version = new Version({
                                value: match[1],
                                alias: '7'
                            });
                            break;
                        case '6.0':
                            this.os.version = new Version({
                                value: match[1],
                                alias: 'Vista'
                            });
                            break;
                        case '5.2':
                            this.os.version = new Version({
                                value: match[1],
                                alias: 'Server 2003'
                            });
                            break;
                        case '5.1':
                            this.os.version = new Version({
                                value: match[1],
                                alias: 'XP'
                            });
                            break;
                        case '5.0':
                            this.os.version = new Version({
                                value: match[1],
                                alias: '2000'
                            });
                            break;
                        default:
                            this.os.version = new Version({
                                value: match[1],
                                alias: 'NT ' + this.os.version
                            });
                    }
                }

                if (ua.match('Windows 95') || ua.match('Win95') || ua.match('Win 9x 4.00')) {
                    this.os.version = new Version({
                        value: '4.0',
                        alias: '95'
                    });
                }

                if (ua.match('Windows 98') || ua.match('Win98') || ua.match('Win 9x 4.10')) {
                    this.os.version = new Version({
                        value: '4.1',
                        alias: '98'
                    });
                }

                if (ua.match('Windows ME') || ua.match('WinME') || ua.match('Win 9x 4.90')) {
                    this.os.version = new Version({
                        value: '4.9',
                        alias: 'ME'
                    });
                }

                if (ua.match('Windows XP') || ua.match('WinXP')) {
                    this.os.name = new Version({
                        value: '5.1',
                        alias: 'XP'
                    });
                }

                if (ua.match('WP7')) {
                    this.os.name = 'Windows Phone';
                    this.os.version = new Version({
                        value: '7.0',
                        details: 2
                    });
                    this.device.type = 'mobile';
                    this.browser.mode = 'desktop';
                }

                if (ua.match('Windows CE') || ua.match('WinCE') || ua.match('WindowsCE')) {
                    if (ua.match(' IEMobile')) {
                        this.os.name = 'Windows Mobile';

                        if (ua.match(' IEMobile 8')) {
                            this.os.version = new Version({
                                value: '6.5',
                                details: 2
                            });
                        }

                        if (ua.match(' IEMobile 7')) {
                            this.os.version = new Version({
                                value: '6.1',
                                details: 2
                            });
                        }

                        if (ua.match(' IEMobile 6')) {
                            this.os.version = new Version({
                                value: '6.0',
                                details: 2
                            });
                        }
                    } else {
                        this.os.name = 'Windows CE';

                        if (match = /WindowsCEOS\/([0-9.]*)/.exec(ua)) {
                            this.os.version = new Version({
                                value: match[1],
                                details: 2
                            });
                        }

                        if (match = /Windows CE ([0-9.]*)/.exec(ua)) {
                            this.os.version = new Version({
                                value: match[1],
                                details: 2
                            });
                        }
                    }

                    this.device.type = 'mobile';
                }

                if (ua.match('Windows Mobile')) {
                    this.os.name = 'Windows Mobile';
                    this.device.type = 'mobile';
                }

                if (match = /WindowsMobile\/([0-9.]*)/.exec(ua)) {
                    this.os.name = 'Windows Mobile';
                    this.os.version = new Version({
                        value: match[1],
                        details: 2
                    });
                    this.device.type = 'mobile';
                }

                if (ua.match('Windows Phone [0-9]')) {
                    this.os.name = 'Windows Mobile';
                    this.os.version = new Version({
                        value: ua.match(/Windows Phone ([0-9.]*)/)[1],
                        details: 2
                    });
                    this.device.type = 'mobile';
                }

                if (ua.match('Windows Phone OS')) {
                    this.os.name = 'Windows Phone';
                    this.os.version = new Version({
                        value: ua.match(/Windows Phone OS ([0-9.]*)/)[1],
                        details: 2
                    });

                    if (this.os.version < 7) {
                        this.os.name = 'Windows Mobile';
                    }

                    if (match = /IEMobile\/[^;]+; ([^;]+); ([^;]+)[;|\)]/.exec(ua)) {
                        this.device.manufacturer = match[1];
                        this.device.model = match[2];
                    }

                    this.device.type = 'mobile';

                    var manufacturer = this.device.manufacturer;
                    var model = cleanupModel(this.device.model);

                    if (typeof WINDOWS_PHONE_MODELS[manufacturer] !== 'undefined' && typeof WINDOWS_PHONE_MODELS[manufacturer][model] !== 'undefined') {
                        this.device.manufacturer = WINDOWS_PHONE_MODELS[manufacturer][model][0];
                        this.device.model = WINDOWS_PHONE_MODELS[manufacturer][model][1];
                        this.device.identified = true;
                    }

                    if (manufacturer === 'Microsoft' && model === 'XDeviceEmulator') {
                        this.device.manufacturer = null;
                        this.device.model = null;
                        this.device.type = 'emulator';
                        this.device.identified = true;
                    }
                }
            }

            /****************************************************
             *      Android
             */
            if (ua.match('Android')) {
                this.os.name = 'Android';
                this.os.version = null;

                if (match = /Android(?: )?(?:AllPhone_|CyanogenMod_)?(?:\/)?v?([0-9.]+)/.exec(ua.replace('-update', '.'))) {
                    this.os.version = new Version({
                        value: match[1],
                        details: 3
                    })
                }

                if (ua.match('Android Eclair')) {
                    this.os.version = new Version({
                        value: '2.0',
                        details: 3
                    });
                }

                this.device.type = 'mobile';
                if (this.os.version >= 3) this.device.type = 'tablet';
                if (this.os.version >= 4 && ua.match('Mobile')) this.device.type = 'mobile';

                if (match = /Eclair; (?:[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?) Build\/([^\/]*)\//.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /; ([^;]*[^;\s])\s+Build/.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?; ([^;]*[^;\s]);\s+Build/.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /\(([^;]+);U;Android\/[^;]+;[0-9]+\*[0-9]+;CTC\/2.0\)/.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /;\s?([^;]+);\s?[0-9]+\*[0-9]+;\s?CTC\/2.0/.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /zh-cn;\s*(.*?)(\/|build)/i.exec(ua)) {
                    this.device.model = match[1];
                } else if (match = /Android [^;]+; (?:[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?; )?([^)]+)\)/.exec(ua)) {
                    if (!ua.match(/[a-zA-Z][a-zA-Z](?:[-_][a-zA-Z][a-zA-Z])?/)) {
                        this.device.model = match[1];
                    }
                } else if (match = /^(.+?)\/\S+/i.exec(ua)) {
                    this.device.model = match[1];
                }


                /* Sometimes we get a model name that starts with Android, in that case it is a mismatch and we should ignore it */
                if (this.device.model && this.device.model.substring(0, 7) === 'Android') {
                    this.device.model = null;
                }

                if (this.device.model) {
                    var model = cleanupModel(this.device.model);

                    if (typeof ANDROID_MODELS[model] !== 'undefined') {
                        this.device.manufacturer = ANDROID_MODELS[model][0];
                        this.device.model = ANDROID_MODELS[model][1];
                        if (typeof ANDROID_MODELS[model][2] !== 'undefined') this.device.type = ANDROID_MODELS[model][2];
                        this.device.identified = true;
                    }

                    if (model === 'Emulator' || model === 'x86 Emulator' || model === 'x86 VirtualBox' || model === 'vm') {
                        this.device.manufacturer = null;
                        this.device.model = null;
                        this.device.type = 'emulator';
                        this.device.identified = true;
                    }
                }

                if (ua.match('HP eStation')) {
                    this.device.manufacturer = 'HP';
                    this.device.model = 'eStation';
                    this.device.type = 'tablet';
                    this.device.identified = true;
                }
                if (ua.match('Pre\/1.0')) {
                    this.device.manufacturer = 'Palm';
                    this.device.model = 'Pre';
                    this.device.identified = true;
                }
                if (ua.match('Pre\/1.1')) {
                    this.device.manufacturer = 'Palm';
                    this.device.model = 'Pre Plus';
                    this.device.identified = true;
                }
                if (ua.match('Pre\/1.2')) {
                    this.device.manufacturer = 'Palm';
                    this.device.model = 'Pre 2';
                    this.device.identified = true;
                }
                if (ua.match('Pre\/3.0')) {
                    this.device.manufacturer = 'HP';
                    this.device.model = 'Pre 3';
                    this.device.identified = true;
                }
                if (ua.match('Pixi\/1.0')) {
                    this.device.manufacturer = 'Palm';
                    this.device.model = 'Pixi';
                    this.device.identified = true;
                }
                if (ua.match('Pixi\/1.1')) {
                    this.device.manufacturer = 'Palm';
                    this.device.model = 'Pixi Plus';
                    this.device.identified = true;
                }
                if (ua.match('P160UN?A?\/1.0')) {
                    this.device.manufacturer = 'HP';
                    this.device.model = 'Veer';
                    this.device.identified = true;
                }
            }

            /****************************************************
             *      Google TV
             */

            if (ua.match('GoogleTV')) {
                this.os.name = 'Google TV';

                if (ua.match('Chrome/5.')) {
                    this.os.version = new Version({
                        value: '1'
                    });
                }

                if (ua.match('Chrome/11.')) {
                    this.os.version = new Version({
                        value: '2'
                    });
                }

                this.device.type = 'television';
            }

            /****************************************************
             *      WoPhone
             */

            if (ua.match('WoPhone')) {
                this.os.name = 'WoPhone';

                if (match = /WoPhone\/([0-9\.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.type = 'mobile';
            }

            /****************************************************
             *      BlackBerry
             */

            if (ua.match('BlackBerry')) {
                this.os.name = 'BlackBerry OS';

                if (!ua.match('Opera')) {
                    if (match = /BlackBerry([0-9]*)\/([0-9.]*)/.exec(ua)) {
                        this.device.model = match[1];
                        this.os.version = new Version({
                            value: match[2],
                            details: 2
                        });
                    }

                    if (match = /; BlackBerry ([0-9]*);/.exec(ua)) {
                        this.device.model = match[1];
                    }

                    if (match = /Version\/([0-9.]*)/.exec(ua)) {
                        this.os.version = new Version({
                            value: match[1],
                            details: 2
                        });
                    }

                    if (this.os.version >= 10) {
                        this.os.name = 'BlackBerry';
                    }

                    if (typeof this.device.model !== 'undefined') {
                        if (typeof BLACKBERRY_MODELS[this.device.model] !== 'undefined') {
                            this.device.model = 'BlackBerry ' + BLACKBERRY_MODELS[this.device.model] + ' ' + this.device.model;
                        } else {
                            this.device.model = 'BlackBerry ' + this.device.model;
                        }
                    } else {
                        this.device.model = 'BlackBerry';
                    }
                } else {
                    this.device.model = 'BlackBerry';
                }

                this.device.manufacturer = 'RIM';
                this.device.type = 'mobile';
                this.device.identified = true;
            }

            /****************************************************
             *      BlackBerry PlayBook
             */

            if (ua.match('RIM Tablet OS')) {
                this.os.name = 'BlackBerry Tablet OS';
                this.os.version = new Version({
                    value: ua.match(/RIM Tablet OS ([0-9.]*)/)[1],
                    details: 2
                });

                this.device.manufacturer = 'RIM';
                this.device.model = 'BlackBerry PlayBook';
                this.device.type = 'tablet';
                this.device.identified = true;
            } else if (ua.match('PlayBook')) {
                if (match = /Version\/(10[0-9.]*)/.exec(ua)) {
                    this.os.name = 'BlackBerry';
                    this.os.version = new Version({
                        value: match[1],
                        details: 2
                    });

                    this.device.manufacturer = 'RIM';
                    this.device.model = 'BlackBerry PlayBook';
                    this.device.type = 'tablet';
                    this.device.identified = true;
                }
            }


            /****************************************************
             *      WebOS
             */

            if (ua.match('(?:web|hpw)OS')) {
                this.os.name = 'webOS';
                this.os.version = new Version({
                    value: ua.match(/(?:web|hpw)OS\/([0-9.]*)/)[1]
                });

                if (ua.match('tablet')) this.device.type = 'tablet';
                else this.device.type = 'mobile';

                this.device.manufacturer = ua.match('hpwOS') ? 'HP' : 'Palm';
                if (ua.match('Pre\/1.0')) this.device.model = 'Pre';
                if (ua.match('Pre\/1.1')) this.device.model = 'Pre Plus';
                if (ua.match('Pre\/1.2')) this.device.model = 'Pre2';
                if (ua.match('Pre\/3.0')) this.device.model = 'Pre3';
                if (ua.match('Pixi\/1.0')) this.device.model = 'Pixi';
                if (ua.match('Pixi\/1.1')) this.device.model = 'Pixi Plus';
                if (ua.match('P160UN?A?\/1.0')) this.device.model = 'Veer';
                if (ua.match('TouchPad\/1.0')) this.device.model = 'TouchPad';

                if (ua.match('Emulator\/') || ua.match('Desktop\/')) {
                    this.device.type = 'emulator';
                    this.device.manufacturer = null;
                    this.device.model = null;
                }

                this.device.identified = true;
            }

            /****************************************************
             *      S60
             */

            if (ua.match('Symbian') || ua.match('Series[ ]?60') || ua.match('S60')) {
                this.os.name = 'Series60';

                if (ua.match('SymbianOS/9.1') && !ua.match('Series60')) {
                    this.os.version = new Version({
                        value: '3.0'
                    });
                }

                if (match = /Series60\/([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                if (match = /Nokia([^\/;]+)[\/|;]/.exec(ua)) {
                    if (match[1] !== 'Browser') {
                        this.device.manufacturer = 'Nokia';
                        this.device.model = match[1];
                        this.device.identified = true;
                    }
                }

                if (match = /Vertu([^\/;]+)[\/|;]/.exec(ua)) {
                    this.device.manufacturer = 'Vertu';
                    this.device.model = match[1];
                    this.device.identified = true;
                }

                if (match = /Symbian; U; ([^;]+); [a-z][a-z]\-[a-z][a-z]/i.exec(ua)) {
                    this.device.manufacturer = 'Nokia';
                    this.device.model = match[1];
                    this.device.identified = true;
                }

                if (match = /Samsung\/([^;]*);/.exec(ua)) {
                    this.device.manufacturer = STRINGS_SAMSUNG;
                    this.device.model = match[1];
                    this.device.identified = true;
                }

                this.device.type = 'mobile';
            }

            /****************************************************
             *      S40
             */

            if (ua.match('Series40')) {
                this.os.name = 'Series40';

                if (match = /Nokia([^\/]+)\//.exec(ua)) {
                    this.device.manufacturer = 'Nokia';
                    this.device.model = match[1];
                    this.device.identified = true;
                }

                this.device.type = 'mobile';
            }

            /****************************************************
             *      MeeGo
             */

            if (ua.match('MeeGo')) {
                this.os.name = 'MeeGo';
                this.device.type = 'mobile';

                if (match = /Nokia([^\)]+)\)/.exec(ua)) {
                    this.device.manufacturer = 'Nokia';
                    this.device.model = match[1];
                    this.device.identified = true;
                }
            }

            /****************************************************
             *      Maemo
             */

            if (ua.match('Maemo')) {
                this.os.name = 'Maemo';
                this.device.type = 'mobile';

                if (match = /(N[0-9]+)/.exec(ua)) {
                    this.device.manufacturer = 'Nokia';
                    this.device.model = match[1];
                    this.device.identified = true;
                }
            }

            /****************************************************
             *      Tizen
             */

            if (ua.match('Tizen')) {
                this.os.name = 'Tizen';

                if (match = /Tizen[\/ ]([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.type = 'mobile';

                if (match = /\(([^;]+); ([^\/]+)\//.exec(ua)) {
                    if (match[1] !== 'Linux') {
                        this.device.manufacturer = match[1];
                        this.device.model = match[2];

                        if (typeof TIZEN_MODELS[this.device.manufacturer] !== 'undefined' && typeof TIZEN_MODELS[this.device.manufacturer][this.device.model] !== 'undefined') {
                            var manufacturer = this.device.manufacturer;
                            var model = cleanupModel(this.device.model);

                            this.device.manufacturer = TIZEN_MODELS[manufacturer][model][0];
                            this.device.model = TIZEN_MODELS[manufacturer][model][1];
                            this.device.identified = true;
                        }
                    }
                }
            }

            /****************************************************
             *      Bada
             */

            if (ua.match('[b|B]ada')) {
                this.os.name = 'Bada';

                if (match = /[b|B]ada\/([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.type = 'mobile';

                if (match = /\(([^;]+); ([^\/]+)\//.exec(ua)) {
                    this.device.manufacturer = match[1];
                    this.device.model = cleanupModel(match[2]);
                }

                if (typeof BADA_MODELS[this.device.manufacturer] !== 'undefined' && typeof BADA_MODELS[this.device.manufacturer][this.device.model] !== 'undefined') {
                    var manufacturer = this.device.manufacturer;
                    var model = cleanupModel(this.device.model);

                    this.device.manufacturer = BADA_MODELS[manufacturer][model][0];
                    this.device.model = BADA_MODELS[manufacturer][model][1];
                    this.device.identified = true;
                }
            }

            /****************************************************
             *      Brew
             */

            if (ua.match(/BREW/i) || ua.match('BMP; U')) {
                this.os.name = 'Brew';
                this.device.type = 'mobile';

                if (match = /BREW; U; ([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                } else if (match = /;BREW\/([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }


                if (match = /\(([^;]+);U;REX\/[^;]+;BREW\/[^;]+;(?:.*;)?[0-9]+\*[0-9]+;CTC\/2.0\)/.exec(ua)) {
                    this.device.model = match[1];
                }

                if (this.device.model) {
                    var model = cleanupModel(this.device.model);

                    if (typeof BREW_MODELS[model] !== 'undefined') {
                        this.device.manufacturer = BREW_MODELS[model][0];
                        this.device.model = BREW_MODELS[model][1];
                        this.device.identified = true;
                    }
                }
            }

            /****************************************************
             *      MTK
             */

            if (ua.match(/\(MTK;/)) {
                this.os.name = 'MTK';
                this.device.type = 'mobile';
            }

            /****************************************************
             *      CrOS
             */

            if (ua.match('CrOS')) {
                this.os.name = 'Chrome OS';
                this.device.type = 'desktop';
            }

            /****************************************************
             *      Joli OS
             */

            if (ua.match('Joli OS')) {
                this.os.name = 'Joli OS';
                this.device.type = 'desktop';

                if (match = /Joli OS\/([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Haiku
             */

            if (ua.match('Haiku')) {
                this.os.name = 'Haiku';
                this.device.type = 'desktop';
            }

            /****************************************************
             *      QNX
             */

            if (ua.match('QNX')) {
                this.os.name = 'QNX';
                this.device.type = 'mobile';
            }

            /****************************************************
             *      OS/2 Warp
             */

            if (ua.match('OS\/2; Warp')) {
                this.os.name = 'OS/2 Warp';
                this.device.type = 'desktop';

                if (match = /OS\/2; Warp ([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Grid OS
             */

            if (ua.match('Grid OS')) {
                this.os.name = 'Grid OS';
                this.device.type = 'tablet';

                if (match = /Grid OS ([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      AmigaOS
             */

            if (ua.match(/AmigaOS/i)) {
                this.os.name = 'AmigaOS';
                this.device.type = 'desktop';

                if (match = /AmigaOS ([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

            }

            /****************************************************
             *      MorphOS
             */

            if (ua.match(/MorphOS/i)) {
                this.os.name = 'MorphOS';
                this.device.type = 'desktop';

                if (match = /MorphOS ([0-9.]*)/i.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

            }

            /****************************************************
             *      Kindle
             */

            if (ua.match('Kindle') && !ua.match('Fire')) {
                this.os.name = '';

                this.device.manufacturer = 'Amazon';
                this.device.model = 'Kindle';
                this.device.type = 'ereader';

                if (ua.match('Kindle\/2.0')) this.device.model = 'Kindle 2';
                if (ua.match('Kindle\/3.0')) this.device.model = 'Kindle 3 or later';

                this.device.identified = true;
            }

            /****************************************************
             *      NOOK
             */

            if (ua.match('nook browser')) {
                this.os.name = 'Android';

                this.device.manufacturer = 'Barnes & Noble';
                this.device.model = 'NOOK';
                this.device.type = 'ereader';
                this.device.identified = true;
            }

            /****************************************************
             *      Bookeen
             */

            if (ua.match('bookeen\/cybook')) {
                this.os.name = '';

                this.device.manufacturer = 'Bookeen';
                this.device.model = 'Cybook';
                this.device.type = 'ereader';

                if (ua.match('Orizon')) {
                    this.device.model = 'Cybook Orizon';
                }

                this.device.identified = true;
            }

            /****************************************************
             *      Sony Reader
             */

            if (ua.match('EBRD1101')) {
                this.os.name = '';

                this.device.manufacturer = 'Sony';
                this.device.model = 'Reader';
                this.device.type = 'ereader';
                this.device.identified = true;
            }

            /****************************************************
             *      iRiver
             */

            if (ua.match('Iriver ;')) {
                this.os.name = '';

                this.device.manufacturer = 'iRiver';
                this.device.model = 'Story';
                this.device.type = 'ereader';

                if (ua.match('EB07')) {
                    this.device.model = 'Story HD EB07';
                }

                this.device.identified = true;
            }

            /****************************************************
             *      Nintendo
             *
             *      Opera/9.30 (Nintendo Wii; U; ; 3642; en)
             *      Opera/9.30 (Nintendo Wii; U; ; 2047-7; en)
             *      Opera/9.50 (Nintendo DSi; Opera/507; U; en-US)
             *      Mozilla/5.0 (Nintendo 3DS; U; ; en) Version/1.7455.US
             *      Mozilla/5.0 (Nintendo 3DS; U; ; en) Version/1.7455.EU
             */

            if (ua.match('Nintendo Wii')) {
                this.os.name = '';

                this.device.manufacturer = 'Nintendo';
                this.device.model = 'Wii';
                this.device.type = 'gaming';
                this.device.identified = true;
            }

            if (ua.match('Nintendo DSi')) {
                this.os.name = '';

                this.device.manufacturer = 'Nintendo';
                this.device.model = 'DSi';
                this.device.type = 'gaming';
                this.device.identified = true;
            }

            if (ua.match('Nintendo 3DS')) {
                this.os.name = '';

                this.device.manufacturer = 'Nintendo';
                this.device.model = '3DS';
                this.device.type = 'gaming';

                if (match = /Version\/([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.identified = true;
            }


            if (ua.match('PlayStation Portable')) {
                this.os.name = '';

                this.device.manufacturer = 'Sony';
                this.device.model = 'Playstation Portable';
                this.device.type = 'gaming';
                this.device.identified = true;
            }

            if (ua.match('PlayStation Vita')) {
                this.os.name = '';

                if (match = /PlayStation Vita ([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.manufacturer = 'Sony';
                this.device.model = 'PlayStation Vita';
                this.device.type = 'gaming';
                this.device.identified = true;
            }

            if (ua.match(/PlayStation 3/i)) {
                this.os.name = '';

                if (match = /PLAYSTATION 3;? ([0-9.]*)/.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                this.device.manufacturer = 'Sony';
                this.device.model = 'Playstation 3';
                this.device.type = 'gaming';
                this.device.identified = true;
            }

            /****************************************************
             *      Panasonic Smart Viera
             *
             *      Mozilla/5.0 (FreeBSD; U; Viera; ja-JP) AppleWebKit/535.1 (KHTML, like Gecko) Viera/1.2.4 Chrome/14.0.835.202 Safari/535.1
             */

            if (ua.match('Viera')) {
                this.os.name = '';
                this.device.manufacturer = 'Panasonic';
                this.device.model = 'Smart Viera';
                this.device.type = 'television';
                this.device.identified = true;
            }


            /****************************************************
             *      Sharp AQUOS TV
             *
             *      Mozilla/5.0 (DTV) AppleWebKit/531.2  (KHTML, like Gecko) AQUOSBrowser/1.0 (US00DTV;V;0001;0001)
             *      Mozilla/5.0 (DTV) AppleWebKit/531.2+ (KHTML, like Gecko) Espial/6.0.4 AQUOSBrowser/1.0 (CH00DTV;V;0001;0001)
             *      Opera/9.80 (Linux armv6l; U; en) Presto/2.8.115 Version/11.10 AQUOS-AS/1.0 LC-40LE835X
             */

            if (ua.match('AQUOSBrowser') || ua.match('AQUOS-AS')) {
                this.os.name = '';
                this.device.manufacturer = STRINGS_SHARP;
                this.device.model = 'Aquos TV';
                this.device.type = 'television';
                this.device.identified = true;
            }


            /****************************************************
             *      Samsung Smart TV
             *
             *      Mozilla/5.0 (SmartHub; SMART-TV; U; Linux/SmartTV; Maple2012) AppleWebKit/534.7 (KHTML, like Gecko) SmartTV Safari/534.7
             *      Mozilla/5.0 (SmartHub; SMART-TV; U; Linux/SmartTV) AppleWebKit/531.2+ (KHTML, like Gecko) WebBrowser/1.0 SmartTV Safari/531.2+
             */

            if (ua.match('SMART-TV')) {
                this.os.name = '';
                this.device.manufacturer = STRINGS_SAMSUNG;
                this.device.model = 'Smart TV';
                this.device.type = 'television';
                this.device.identified = true;

                if (match = /Maple([0-9]*)/.exec(ua)) {
                    this.device.model += ' ' + match[1];
                }
            }

            /****************************************************
             *      Sony Internet TV
             *
             *      Opera/9.80 (Linux armv7l; U; InettvBrowser/2.2(00014A;SonyDTV115;0002;0100) KDL-46EX640; CC/USA; en) Presto/2.8.115 Version/11.10
             *      Opera/9.80 (Linux armv7l; U; InettvBrowser/2.2(00014A;SonyDTV115;0002;0100) KDL-40EX640; CC/USA; en) Presto/2.10.250 Version/11.60
             *      Opera/9.80 (Linux armv7l; U; InettvBrowser/2.2(00014A;SonyDTV115;0002;0100) N/A; CC/USA; en) Presto/2.8.115 Version/11.10
             *      Opera/9.80 (Linux mips; U; InettvBrowser/2.2 (00014A;SonyDTV115;0002;0100) ; CC/JPN; en) Presto/2.9.167 Version/11.50
             *      Opera/9.80 (Linux mips; U; InettvBrowser/2.2 (00014A;SonyDTV115;0002;0100) AZ2CVT2; CC/CAN; en) Presto/2.7.61 Version/11.00
             *      Opera/9.80 (Linux armv6l; Opera TV Store/4207; U; (SonyBDP/BDV11); en) Presto/2.9.167 Version/11.50
             *      Opera/9.80 (Linux armv6l ; U; (SonyBDP/BDV11); en) Presto/2.6.33 Version/10.60
             *      Opera/9.80 (Linux armv6l; U; (SonyBDP/BDV11); en) Presto/2.8.115 Version/11.10
             */

            if (ua.match('SonyDTV|SonyBDP|SonyCEBrowser')) {
                this.os.name = '';
                this.device.manufacturer = 'Sony';
                this.device.model = 'Internet TV';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      Philips Net TV
             *
             *      Opera/9.70 (Linux armv6l ; U; CE-HTML/1.0 NETTV/2.0.2; en) Presto/2.2.1
             *      Opera/9.80 (Linux armv6l ; U; CE-HTML/1.0 NETTV/3.0.1;; en) Presto/2.6.33 Version/10.60
             *      Opera/9.80 (Linux mips; U; CE-HTML/1.0 NETTV/3.0.1; PHILIPS-AVM-2012; en) Presto/2.9.167 Version/11.50
             *      Opera/9.80 (Linux mips ; U; HbbTV/1.1.1 (; Philips; ; ; ; ) CE-HTML/1.0 NETTV/3.1.0; en) Presto/2.6.33 Version/10.70
             *      Opera/9.80 (Linux i686; U; HbbTV/1.1.1 (; Philips; ; ; ; ) CE-HTML/1.0 NETTV/3.1.0; en) Presto/2.9.167 Version/11.50
             */

            if (ua.match('NETTV\/')) {
                this.os.name = '';
                this.device.manufacturer = 'Philips';
                this.device.model = 'Net TV';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      LG NetCast TV
             *
             *      Mozilla/5.0 (DirectFB; Linux armv7l) AppleWebKit/534.26+ (KHTML, like Gecko) Version/5.0 Safari/534.26+ LG Browser/5.00.00(+mouse+3D+SCREEN+TUNER; LGE; GLOBAL-PLAT4; 03.09.22; 0x00000001;); LG NetCast.TV-2012
             *      Mozilla/5.0 (DirectFB; Linux armv7l) AppleWebKit/534.26+ (KHTML, like Gecko) Version/5.0 Safari/534.26+ LG Browser/5.00.00(+SCREEN+TUNER; LGE; GLOBAL-PLAT4; 01.00.00; 0x00000001;); LG NetCast.TV-2012
             *      Mozilla/5.0 (DirectFB; U; Linux armv6l; en) AppleWebKit/531.2  (KHTML, like Gecko) Safari/531.2  LG Browser/4.1.4( BDP; LGE; Media/BD660; 6970; abc;); LG NetCast.Media-2011
             *      Mozilla/5.0 (DirectFB; U; Linux 7631; en) AppleWebKit/531.2  (KHTML, like Gecko) Safari/531.2  LG Browser/4.1.4( NO_NUM; LGE; Media/SP520; ST.3.97.409.F; 0x00000001;); LG NetCast.Media-2011
             *      Mozilla/5.0 (DirectFB; U; Linux 7630; en) AppleWebKit/531.2  (KHTML, like Gecko) Safari/531.2  LG Browser/4.1.4( 3D BDP NO_NUM; LGE; Media/ST600; LG NetCast.Media-2011
             *      (LGSmartTV/1.0) AppleWebKit/534.23 OBIGO-T10/2.0
             */

            if (match = /LG NetCast\.(?:TV|Media)-([0-9]*)/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = STRINGS_LG;
                this.device.model = 'NetCast TV ' + match[1];
                this.device.type = 'television';
                this.device.identified = true;
            }

            if (match = /LGSmartTV/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = STRINGS_LG;
                this.device.model = 'Smart TV';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      Toshiba Smart TV
             *
             *      Mozilla/5.0 (Linux mipsel; U; HbbTV/1.1.1 (; TOSHIBA; DTV_RL953; 56.7.66.7; t12; ) ; ToshibaTP/1.3.0 (+VIDEO_MP4+VIDEO_X_MS_ASF+AUDIO_MPEG+AUDIO_MP4+DRM+NATIVELAUNCH) ; en) AppleWebKit/534.1 (KHTML, like Gecko)
             *      Mozilla/5.0 (DTV; TSBNetTV/T32013713.0203.7DD; TVwithVideoPlayer; like Gecko) NetFront/4.1 DTVNetBrowser/2.2 (000039;T32013713;0203;7DD) InettvBrowser/2.2 (000039;T32013713;0203;7DD)
             *      Mozilla/5.0 (Linux mipsel; U; HbbTV/1.1.1 (; TOSHIBA; 40PX200; 0.7.3.0.; t12; ) ; Toshiba_TP/1.3.0 (+VIDEO_MP4+AUDIO_MPEG+AUDIO_MP4+VIDEO_X_MS_ASF+OFFLINEAPP) ; en) AppleWebKit/534.1 (KHTML, like Gec
             */

            if (ua.match('Toshiba_?TP\/') || ua.match('TSBNetTV\/')) {
                this.os.name = '';
                this.device.manufacturer = 'Toshiba';
                this.device.model = 'Smart TV';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      MachBlue XT
             */

            if (match = /mbxtWebKit\/([0-9.]*)/.exec(ua)) {
                this.os.name = '';
                this.browser.name = 'MachBlue XT'
                this.browser.version = new Version({
                    value: match[1],
                    details: 2
                });
                this.device.type = 'television';
            }

            /****************************************************
             *      ADB
             */

            if (match = /\(ADB; ([^\)]+)\)/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = 'ADB';
                this.device.model = (match[1] !== 'Unknown' ? match[1].replace('ADB', '') + ' ' : '') + 'IPTV receiver';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      MStar
             */

            if (ua.match(/Mstar;OWB/)) {
                this.os.name = '';
                this.device.manufacturer = 'MStar';
                this.device.model = 'PVR';
                this.device.type = 'television';
                this.device.identified = true;

                this.browser.name = 'Origyn Web Browser';
            }

            /****************************************************
             *      TechniSat
             */

            if (match = /\TechniSat ([^;]+);/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = 'TechniSat';
                this.device.model = match[1];
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      Technicolor
             */

            if (match = /\Technicolor_([^;]+);/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = 'Technicolor';
                this.device.model = match[1];
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      Winbox Evo2
             */

            if (match = /Winbox Evo2/.exec(ua)) {
                this.os.name = '';
                this.device.manufacturer = 'Winbox';
                this.device.model = 'Evo2';
                this.device.type = 'television';
                this.device.identified = true;
            }

            /****************************************************
             *      Roku
             */

            if (match = /^Roku\/DVP-([0-9]+)/.exec(ua)) {
                this.device.manufacturer = 'Roku';
                this.device.type = 'television';

                switch (match[1]) {
                    case '2000':
                        this.device.model = 'HD';
                        break;
                    case '2050':
                        this.device.model = 'XD';
                        break;
                    case '2100':
                        this.device.model = 'XDS';
                        break;
                    case '2400':
                        this.device.model = 'LT';
                        break;
                    case '3000':
                        this.device.model = '2 HD';
                        break;
                    case '3050':
                        this.device.model = '2 XD';
                        break;
                    case '3100':
                        this.device.model = '2 XS';
                        break;
                }

                this.device.identified = true;
            }

            if (match = /HbbTV\/1.1.1 \([^;]*;\s*([^;]*)\s*;\s*([^;]*)\s*;/.exec(ua)) {
                var vendorName = match[1].trim();
                var modelName = match[2].trim();

                if (!this.device.manufacturer && vendorName !== '' && vendorName !== 'vendorName') {
                    switch (vendorName) {
                        case 'LGE':
                            this.device.manufacturer = 'LG';
                            break;
                        case 'TOSHIBA':
                            this.device.manufacturer = 'Toshiba';
                            break;
                        case 'smart':
                            this.device.manufacturer = 'Smart';
                            break;
                        case 'tv2n':
                            this.device.manufacturer = 'TV2N';
                            break;
                        default:
                            this.device.manufacturer = vendorName;
                    }

                    if (!this.device.model && modelName !== '' && modelName !== 'modelName') {
                        switch (modelName) {
                            case 'GLOBAL_PLAT3':
                                this.device.model = 'NetCast TV';
                                break;
                            case 'SmartTV2012':
                                this.device.model = 'Smart TV 2012';
                                break;
                            case 'videoweb':
                                this.device.model = 'Videoweb';
                                break;
                            default:
                                this.device.model = modelName;
                        }

                        if (vendorName === 'Humax') {
                            this.device.model = this.device.model.toUpperCase();
                        }

                        this.device.identified = true;
                        this.os.name = '';
                    }
                }

                this.device.type = 'television';
            }

            /****************************************************
             *      Detect type based on common identifiers
             */

            if (ua.match('InettvBrowser')) {
                this.device.type = 'television';
            }

            if (ua.match('MIDP')) {
                this.device.type = 'mobile';
            }

            /****************************************************
             *      Try to detect any devices based on common
             *      locations of model ids
             */

            if (!this.device.model && !this.device.manufacturer) {
                var candidates = [];

                if (!ua.match(/^(Mozilla|Opera)/)) if (match = /^(?:MQQBrowser\/[0-9\.]+\/)?([^\s]+)/.exec(ua)) {
                    match[1] = match[1].replace(/_TD$/, '');
                    match[1] = match[1].replace(/_CMCC$/, '');
                    match[1] = match[1].replace(/[_ ]Mozilla$/, '');
                    match[1] = match[1].replace(/ Linux$/, '');
                    match[1] = match[1].replace(/ Opera$/, '');
                    match[1] = match[1].replace(/\/[0-9].*$/, '');

                    candidates.push(match[1]);
                }

                if (match = /[0-9]+x[0-9]+; ([^;]+)/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /[0-9]+X[0-9]+ ([^;\/\(\)]+)/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /Windows NT 5.1; ([^;]+); Windows Phone/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /\) PPC; (?:[0-9]+x[0-9]+; )?([^;\/\(\)]+)/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /\(([^;]+); U; Windows Mobile/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /Vodafone\/1.0\/([^\/]+)/.exec(ua)) {
                    candidates.push(match[1]);
                }

                if (match = /\ ([^\s]+)$/.exec(ua)) {
                    candidates.push(match[1]);
                }

                for (var i = 0; i < candidates.length; i++) {

                    if (!this.device.model && !this.device.manufacturer) {
                        var model = cleanupModel(candidates[i]);
                        var result = false;

                        if (this.os.name === 'Android') {
                            if (typeof ANDROID_MODELS[model] !== 'undefined') {
                                this.device.manufacturer = ANDROID_MODELS[model][0];
                                this.device.model = ANDROID_MODELS[model][1];
                                if (typeof ANDROID_MODELS[model][2] !== 'undefined') this.device.type = ANDROID_MODELS[model][2];
                                this.device.identified = true;

                                result = true;
                            }
                        }

                        if (!this.os.name || this.os.name === 'Windows' || this.os.name === 'Windows Mobile' || this.os.name === 'Windows CE') {
                            if (typeof WINDOWS_MOBILE_MODELS[model] !== 'undefined') {
                                this.device.manufacturer = WINDOWS_MOBILE_MODELS[model][0];
                                this.device.model = WINDOWS_MOBILE_MODELS[model][1];
                                this.device.type = 'mobile';
                                this.device.identified = true;

                                if (this.os.name !== 'Windows Mobile') {
                                    this.os.name = 'Windows Mobile';
                                    this.os.version = null;
                                }

                                result = true;
                            }
                        }
                    }

                    if (!result) {
                        if (match = /^GIONEE-([^\s]+)/.exec(candidates[i])) {
                            this.device.manufacturer = 'Gionee';
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^HTC_?([^\/_]+)(?:\/|_|$)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_HTC;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^HUAWEI-([^\/]*)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_HUAWEI;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /(?:^|\()LGE?(?:\/|-|_|\s)([^\s]*)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_LG;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^MOT-([^\/_]+)(?:\/|_|$)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_MOTOROLA;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^Motorola_([^\/_]+)(?:\/|_|$)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_MOTOROLA;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^Nokia([^\/]+)(?:\/|$)/.exec(candidates[i])) {
                            this.device.manufacturer = 'Nokia';
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;

                            if (!this.os.name) {
                                this.os.name = 'Series40';
                            }
                        }

                        if (match = /^SonyEricsson([^\/_]+)(?:\/|_|$)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_SONY_ERICSSON;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';
                            this.device.identified = true;
                        }

                        if (match = /^SAMSUNG-([^\/_]+)(?:\/|_|$)/.exec(candidates[i])) {
                            this.device.manufacturer = STRINGS_SAMSUNG;
                            this.device.model = cleanupModel(match[1]);
                            this.device.type = 'mobile';

                            if (this.os.name === 'Bada') {
                                var manufacturer = 'SAMSUNG';
                                var model = cleanupModel(this.device.model);

                                if (typeof BADA_MODELS[manufacturer] !== 'undefined' && typeof BADA_MODELS[manufacturer][model] !== 'undefined') {
                                    this.device.manufacturer = BADA_MODELS[manufacturer][model][0];
                                    this.device.model = BADA_MODELS[manufacturer][model][1];
                                    this.device.identified = true;
                                }
                            } else if (match = /Jasmine\/([0-9.]*)/.exec(ua)) {
                                var version = match[1];
                                var manufacturer = 'SAMSUNG';
                                var model = cleanupModel(this.device.model);

                                if (typeof TOUCHWIZ_MODELS[manufacturer] !== 'undefined' && typeof TOUCHWIZ_MODELS[manufacturer][model] !== 'undefined') {
                                    this.device.manufacturer = TOUCHWIZ_MODELS[manufacturer][model][0];
                                    this.device.model = TOUCHWIZ_MODELS[manufacturer][model][1];
                                    this.device.identified = true;

                                    this.os.name = 'Touchwiz';
                                    this.os.version = new Version({
                                        value: '2.0'
                                    });
                                }
                            } else if (match = /Dolfin\/([0-9.]*)/.exec(ua)) {
                                var version = match[1];
                                var manufacturer = 'SAMSUNG';
                                var model = cleanupModel(this.device.model);

                                if (typeof BADA_MODELS[manufacturer] !== 'undefined' && typeof BADA_MODELS[manufacturer][model] !== 'undefined') {
                                    this.device.manufacturer = BADA_MODELS[manufacturer][model][0];
                                    this.device.model = BADA_MODELS[manufacturer][model][1];
                                    this.device.identified = true;

                                    this.os.name = 'Bada';

                                    switch (version) {
                                        case '2.0':
                                            this.os.version = new Version({
                                                value: '1.0'
                                            });
                                            break;
                                        case '2.2':
                                            this.os.version = new Version({
                                                value: '1.2'
                                            });
                                            break;
                                        case '3.0':
                                            this.os.version = new Version({
                                                value: '2.0'
                                            });
                                            break;
                                    }
                                }

                                if (typeof TOUCHWIZ_MODELS[manufacturer] !== 'undefined' && typeof TOUCHWIZ_MODELS[manufacturer][model] !== 'undefined') {
                                    this.device.manufacturer = TOUCHWIZ_MODELS[manufacturer][model][0];
                                    this.device.model = TOUCHWIZ_MODELS[manufacturer][model][1];
                                    this.device.identified = true;

                                    this.os.name = 'Touchwiz';

                                    switch (version) {
                                        case '1.0':
                                            this.os.version = new Version({
                                                value: '1.0'
                                            });
                                            break;
                                        case '1.5':
                                            this.os.version = new Version({
                                                value: '2.0'
                                            });
                                            break;
                                        case '2.0':
                                            this.os.version = new Version({
                                                value: '3.0'
                                            });
                                            break;
                                    }
                                }
                            }
                        }
                    }
                }
            }


            if (match = /\((?:LG[-|\/])(.*) (?:Browser\/)?AppleWebkit/.exec(ua)) {
                this.device.manufacturer = STRINGS_LG;
                this.device.model = match[1];
                this.device.type = 'mobile';
                this.device.identified = true;
            }

            if (match = /^Mozilla\/5.0 \((?:Nokia|NOKIA)(?:\s?)([^\)]+)\)UC AppleWebkit\(like Gecko\) Safari\/530$/.exec(ua)) {
                this.device.manufacturer = 'Nokia';
                this.device.model = match[1];
                this.device.type = 'mobile';
                this.device.identified = true;

                this.os.name = 'Series60';
            }



            /****************************************************
             *      Safari
             */

            if (ua.match('Safari')) {
                if (this.os.name === 'iOS') {
                    this.browser.stock = true;
                    this.browser.hidden = true;
                    this.browser.name = 'Safari';
                    this.browser.version = null;
                }



                if (this.os.name === 'Mac OS X' || this.os.name === 'Windows') {
                    this.browser.name = 'Safari';
                    this.browser.stock = this.os.name === 'Mac OS X';

                    if (match = /Version\/([0-9\.]+)/.exec(ua)) {
                        this.browser.version = new Version({
                            value: match[1]
                        });
                    }

                    if (ua.match(/AppleWebKit\/[0-9\.]+\+/)) {
                        this.browser.name = 'WebKit Nightly Build';
                        this.browser.version = null;
                    }
                }
            }

            /****************************************************
             *      Internet Explorer
             */

            if (ua.match('MSIE')) {
                this.browser.name = 'Internet Explorer';

                if (ua.match('IEMobile') || ua.match('Windows CE') || ua.match('Windows Phone') || ua.match('WP7')) {
                    this.browser.name = 'Mobile Internet Explorer';
                }

                if (match = /MSIE ([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Opera
             */

            if (ua.match(/Opera/i)) {
                this.browser.stock = false;
                this.browser.name = 'Opera';

                if (match = /Opera[\/| ]([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                if (match = /Version\/([0-9.]*)/.exec(ua)) {
                    if (parseFloat(match[1]) >= 10) {
                        this.browser.version = new Version({
                            value: match[1]
                        });
                    } else {
                        this.browser.version = null;
                    }
                }

                if (this.browser.version && ua.match('Edition Labs')) {
                    this.browser.version.type = 'alpha';
                    this.browser.channel = 'Labs';
                }

                if (this.browser.version && ua.match('Edition Next')) {
                    this.browser.version.type = 'alpha';
                    this.browser.channel = 'Next';
                }

                if (ua.match('Opera Tablet')) {
                    this.browser.name = 'Opera Mobile';
                    this.device.type = 'tablet';
                }

                if (ua.match('Opera Mobi')) {
                    this.browser.name = 'Opera Mobile';
                    this.device.type = 'mobile';
                }

                if (match = /Opera Mini;/.exec(ua)) {
                    this.browser.name = 'Opera Mini';
                    this.browser.version = null;
                    this.browser.mode = 'proxy';
                    this.device.type = 'mobile';
                }

                if (match = /Opera Mini\/(?:att\/)?([0-9.]*)/.exec(ua)) {
                    this.browser.name = 'Opera Mini';
                    this.browser.version = new Version({
                        value: match[1],
                        details: -1
                    });
                    this.browser.mode = 'proxy';
                    this.device.type = 'mobile';
                }

                if (this.browser.name === 'Opera' && this.device.type === 'mobile') {
                    this.browser.name = 'Opera Mobile';

                    if (ua.match(/BER/)) {
                        this.browser.name = 'Opera Mini';
                        this.browser.version = null;
                    }
                }

                if (ua.match('InettvBrowser')) {
                    this.device.type = 'television';
                }

                if (ua.match('Opera TV') || ua.match('Opera-TV')) {
                    this.browser.name = 'Opera';
                    this.device.type = 'television';
                }

                if (ua.match('Linux zbov')) {
                    this.browser.name = 'Opera Mobile';
                    this.browser.mode = 'desktop';

                    this.device.type = 'mobile';

                    this.os.name = null;
                    this.os.version = null;
                }

                if (ua.match('Linux zvav')) {
                    this.browser.name = 'Opera Mini';
                    this.browser.version = null;
                    this.browser.mode = 'desktop';

                    this.device.type = 'mobile';

                    this.os.name = null;
                    this.os.version = null;
                }
            }

            /****************************************************
             *      Firefox
             */

            if (ua.match('Firefox')) {
                this.browser.stock = false;
                this.browser.name = 'Firefox';

                if (match = /Firefox\/([0-9ab.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                if (this.browser.version.type === 'alpha') {
                    this.browser.channel = 'Aurora';
                }

                if (this.browser.version.type === 'beta') {
                    this.browser.channel = 'Beta';
                }

                if (ua.match('Fennec')) {
                    this.device.type = 'mobile';
                }

                if (ua.match('Mobile; rv')) {
                    this.device.type = 'mobile';
                }

                if (ua.match('Tablet; rv')) {
                    this.device.type = 'tablet';
                }

                if (this.device.type === 'mobile' || this.device.type === 'tablet') {
                    this.browser.name = 'Firefox Mobile';
                }
            }

            if (ua.match('Namoroka')) {
                this.browser.stock = false;
                this.browser.name = 'Firefox';

                if (match = /Namoroka\/([0-9ab.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                this.browser.channel = 'Namoroka';
            }

            if (ua.match('Shiretoko')) {
                this.browser.stock = false;
                this.browser.name = 'Firefox';

                if (match = /Shiretoko\/([0-9ab.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                this.browser.channel = 'Shiretoko';
            }

            if (ua.match('Minefield')) {
                this.browser.stock = false;
                this.browser.name = 'Firefox';

                if (match = /Minefield\/([0-9ab.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                this.browser.channel = 'Minefield';
            }

            if (ua.match('Firebird')) {
                this.browser.stock = false;
                this.browser.name = 'Firebird';

                if (match = /Firebird\/([0-9ab.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      SeaMonkey
             */

            if (ua.match('SeaMonkey')) {
                this.browser.stock = false;
                this.browser.name = 'SeaMonkey';

                if (match = /SeaMonkey\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Netscape
             */

            if (ua.match('Netscape')) {
                this.browser.stock = false;
                this.browser.name = 'Netscape';

                if (match = /Netscape[0-9]?\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Konqueror
             */

            if (ua.match('[k|K]onqueror/')) {
                this.browser.name = 'Konqueror';

                if (match = /[k|K]onqueror\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Chrome
             */

            if (match = /(?:Chrome|CrMo|CriOS)\/([0-9.]*)/.exec(ua)) {
                this.browser.stock = false;
                this.browser.name = 'Chrome';
                this.browser.version = new Version({
                    value: match[1]
                });

                if (this.os.name === 'Android') {
                    switch (match[1].split('.', 3).join('.')) {
                        case '16.0.912':
                            this.browser.channel = 'Beta';
                            break;
                        case '18.0.1025':
                            this.browser.version.details = 1;
                            break;
                        default:
                            this.browser.channel = 'Nightly';
                            break;
                    }
                } else {
                    switch (match[1].split('.', 3).join('.')) {
                        case '0.2.149':
                        case '0.3.154':
                        case '0.4.154':
                        case '1.0.154':
                        case '2.0.172':
                        case '3.0.195':
                        case '4.0.249':
                        case '4.1.249':
                        case '5.0.375':
                        case '6.0.472':
                        case '7.0.517':
                        case '8.0.552':
                        case '9.0.597':
                        case '10.0.648':
                        case '11.0.696':
                        case '12.0.742':
                        case '13.0.782':
                        case '14.0.835':
                        case '15.0.874':
                        case '16.0.912':
                        case '17.0.963':
                        case '18.0.1025':
                        case '19.0.1084':
                        case '20.0.1132':
                        case '21.0.1180':
                            if (this.browser.version.minor === 0) this.browser.version.details = 1;
                            else this.browser.version.details = 2;

                            break;
                        default:
                            this.browser.channel = 'Nightly';
                            break;
                    }
                }
            }

            /****************************************************
             *      Chrome Frame
             */

            if (ua.match('chromeframe')) {
                this.browser.stock = false;
                this.browser.name = 'Chrome Frame';

                if (match = /chromeframe\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Chromium
             */

            if (ua.match('Chromium')) {
                this.browser.stock = false;
                this.browser.channel = '';
                this.browser.name = 'Chromium';

                if (match = /Chromium\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      BrowserNG
             */

            if (ua.match('BrowserNG')) {
                this.browser.name = 'Nokia Browser';

                if (match = /BrowserNG\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1],
                        details: 3,
                        builds: false
                    });
                }
            }

            /****************************************************
             *      Nokia Browser
             */

            if (ua.match('NokiaBrowser')) {
                this.browser.name = 'Nokia Browser';

                if (match = /NokiaBrowser\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1],
                        details: 3
                    });
                }
            }

            /****************************************************
             *      MicroB
             */

            if (ua.match('Maemo[ |_]Browser')) {
                this.browser.name = 'MicroB';

                if (match = /Maemo[ |_]Browser[ |_]([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1],
                        details: 3
                    });
                }
            }


            /****************************************************
             *      NetFront
             */

            if (ua.match('NetFront')) {
                this.browser.name = 'NetFront';
                this.device.type = 'mobile';

                if (match = /NetFront\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                if (ua.match('InettvBrowser')) {
                    this.device.type = 'television';
                }
            }

            /****************************************************
             *      Silk
             */

            if (ua.match('Silk')) {
                if (ua.match('Silk-Accelerated')) {
                    this.browser.name = 'Silk';

                    if (match = /Silk\/([0-9.]*)/.exec(ua)) {
                        this.browser.version = new Version({
                            value: match[1],
                            details: 2
                        });
                    }

                    this.device.manufacturer = 'Amazon';
                    this.device.model = 'Kindle Fire';
                    this.device.type = 'tablet';
                    this.device.identified = true;

                    if (this.os.name !== 'Android') {
                        this.os.name = 'Android';
                        this.os.version = null;
                    }
                }
            }

            /****************************************************
             *      Dolfin
             */

            if (ua.match('Dolfin')) {
                this.browser.name = 'Dolfin';

                if (match = /Dolfin\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }


            /****************************************************
             *      Iris
             */

            if (ua.match('Iris')) {
                this.browser.name = 'Iris';

                this.device.type = 'mobile';
                this.device.model = null;
                this.device.manufacturer = null;

                this.os.name = 'Windows Mobile';
                this.os.version = null;

                if (match = /Iris\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                if (match = / WM([0-9]) /.exec(ua)) {
                    this.os.version = new Version({
                        value: match[1] + '.0'
                    });
                } else {
                    this.browser.mode = 'desktop';
                }
            }

            /****************************************************
             *      Jasmine
             */

            if (ua.match('Jasmine')) {
                this.browser.name = 'Jasmine';

                if (match = /Jasmine\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Boxee
             */

            if (ua.match('Boxee')) {
                this.browser.name = 'Boxee';
                this.device.type = 'television';

                if (match = /Boxee\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Espial
             */

            if (ua.match('Espial')) {
                this.browser.name = 'Espial';

                this.os.name = '';
                this.os.version = null;

                if (this.device.type !== 'television') {
                    this.device.type = 'television';
                    this.device.model = null;
                    this.device.manufacturer = null;
                }

                if (match = /Espial\/([0-9.]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      ANT Galio
             */
            if (match = /ANTGalio\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'ANT Galio';
                this.browser.version = new Version({
                    value: match[1],
                    details: 3
                });
                this.device.type = 'television';
            }

            /****************************************************
             *      NetFront NX
             */
            if (match = /NX\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'NetFront NX';
                this.browser.version = new Version({
                    value: match[1],
                    details: 2
                });
                if (match = /DTV/i.exec(ua)) {
                    this.device.type = 'television';
                } else if (match = /mobile/i.exec(ua)) {
                    this.device.type = 'mobile';
                } else {
                    this.device.type = 'desktop';
                }

                this.os.name = null;
                this.os.version = null;
            }

            /****************************************************
             *      Obigo
             */

            if (ua.match(/Obigo/i)) {
                this.browser.name = 'Obigo';

                if (match = /Obigo\/([0-9.]*)/i.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1]
                    });
                }

                if (match = /Obigo\/([A-Z])([0-9.]*)/i.exec(ua)) {
                    this.browser.name = 'Obigo ' + match[1];
                    this.browser.version = new Version({
                        value: match[2]
                    });
                }

                if (match = /Obigo-([A-Z])([0-9.]*)\//i.exec(ua)) {
                    this.browser.name = 'Obigo ' + match[1];
                    this.browser.version = new Version({
                        value: match[2]
                    });
                }
            }

            /****************************************************
             *      UC Web
             */

            if (ua.match('UCWEB')) {
                this.browser.stock = false;
                this.browser.name = 'UC Browser';

                if (match = /UCWEB([0-9]*[.][0-9]*)/.exec(ua)) {
                    this.browser.version = new Version({
                        value: match[1],
                        details: 3
                    });
                }

                if (this.os.name === 'Linux') {
                    this.os.name = '';
                }

                this.device.type = 'mobile';

                if (match = /^IUC \(U;\s?iOS ([0-9\.]+);/.exec(ua)) {
                    this.os.name = 'iOS';
                    this.os.version = new Version({
                        value: match[1]
                    });
                }

                if (match = /^JUC \(Linux; U; ([0-9\.]+)[^;]*; [^;]+; ([^;]*[^\s])\s*; [0-9]+\*[0-9]+\)/.exec(ua)) {
                    var model = cleanupModel(match[2]);

                    this.os.name = 'Android';
                    this.os.version = new Version({
                        value: match[1]
                    });

                    if (typeof ANDROID_MODELS[model] !== 'undefined') {
                        this.device.manufacturer = ANDROID_MODELS[model][0];
                        this.device.model = ANDROID_MODELS[model][1];
                        if (typeof ANDROID_MODELS[model][2] !== 'undefined') this.device.type = ANDROID_MODELS[model][2];
                        this.device.identified = true;
                    }
                }
            }

            if (ua.match(/\) UC /)) {
                this.browser.stock = false;
                this.browser.name = 'UC Browser';
            }

            if (match = /UCBrowser\/([0-9.]*)/.exec(ua)) {
                this.browser.stock = false;
                this.browser.name = 'UC Browser';
                this.browser.version = new Version({
                    value: match[1],
                    details: 2
                });
            }

            /****************************************************
             *      NineSky
             */

            if (match = /Ninesky(?:-android-mobile(?:-cn)?)?\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'NineSky';
                this.browser.version = new Version({
                    value: match[1]
                });

                if (this.os.name !== 'Android') {
                    this.os.name = 'Android';
                    this.os.version = null;

                    this.device.manufacturer = null;
                    this.device.model = null;
                }
            }

            /****************************************************
             *      Skyfire
             */

            if (match = /Skyfire\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'Skyfire';
                this.browser.version = new Version({
                    value: match[1]
                });

                this.device.type = 'mobile';

                this.os.name = 'Android';
                this.os.version = null;
            }

            /****************************************************
             *      Dolphin HD
             */

            if (match = /DolphinHDCN\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'Dolphin';
                this.browser.version = new Version({
                    value: match[1]
                });

                this.device.type = 'mobile';

                if (this.os.name !== 'Android') {
                    this.os.name = 'Android';
                    this.os.version = null;
                }
            }

            if (match = /Dolphin\/INT/.exec(ua)) {
                this.browser.name = 'Dolphin';
                this.device.type = 'mobile';
            }

            /****************************************************
             *      QQ Browser
             */

            if (match = /(M?QQBrowser)\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'QQ Browser';

                var version = match[2];
                if (version.match(/^[0-9][0-9]$/)) version = version[0] + '.' + version[1];

                this.browser.version = new Version({
                    value: version,
                    details: 2
                });
                this.browser.channel = ''

                if (!this.os.name && match[1] === 'QQBrowser') {
                    this.os.name = 'Windows';
                }
            }

            /****************************************************
             *      iBrowser
             */

            if (match = /(iBrowser)\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'iBrowser';

                var version = match[2];
                if (version.match(/[0-9][0-9]/)) version = version[0] + '.' + version[1];

                this.browser.version = new Version({
                    value: version,
                    details: 2
                });
                this.browser.channel = ''
            }

            /****************************************************
             *      Puffin
             */

            if (match = /Puffin\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'Puffin';
                this.browser.version = new Version({
                    value: match[1],
                    details: 2
                });

                this.device.type = 'mobile';

                if (this.os.name === 'Linux') {
                    this.os.name = null;
                    this.os.version = null;
                }
            }

            /****************************************************
             *      360 Extreme Explorer
             */

            if (ua.match('360EE')) {
                this.browser.stock = false;
                this.browser.name = '360 Extreme Explorer';
                this.browser.version = null;
            }

            /****************************************************
             *      Midori
             */

            if (match = /Midori\/([0-9.]*)/.exec(ua)) {
                this.browser.name = 'Midori';
                this.browser.version = new Version({
                    value: match[1]
                });

                if (this.os.name !== 'Linux') {
                    this.os.name = 'Linux';
                    this.os.version = null;
                }

                this.device.manufacturer = null;
                this.device.model = null;
                this.device.type = 'desktop';
            }

            /****************************************************
             *      Others
             */

            var browsers = [{
                name: 'AdobeAIR',
                regexp: /AdobeAIR\/([0-9.]*)/
            }, {
                name: 'Awesomium',
                regexp: /Awesomium\/([0-9.]*)/
            }, {
                name: 'Canvace',
                regexp: /Canvace Standalone\/([0-9.]*)/
            }, {
                name: 'Ekioh',
                regexp: /Ekioh\/([0-9.]*)/
            }, {
                name: 'JavaFX',
                regexp: /JavaFX\/([0-9.]*)/
            }, {
                name: 'GFXe',
                regexp: /GFXe\/([0-9.]*)/
            }, {
                name: 'LuaKit',
                regexp: /luakit/
            }, {
                name: 'Titanium',
                regexp: /Titanium\/([0-9.]*)/
            }, {
                name: 'OpenWebKitSharp',
                regexp: /OpenWebKitSharp/
            }, {
                name: 'Prism',
                regexp: /Prism\/([0-9.]*)/
            }, {
                name: 'Qt',
                regexp: /Qt\/([0-9.]*)/
            }, {
                name: 'QtEmbedded',
                regexp: /QtEmbedded/
            }, {
                name: 'QtEmbedded',
                regexp: /QtEmbedded.*Qt\/([0-9.]*)/
            }, {
                name: 'RhoSimulator',
                regexp: /RhoSimulator/
            }, {
                name: 'UWebKit',
                regexp: /UWebKit\/([0-9.]*)/
            },

            {
                name: 'PhantomJS',
                regexp: /PhantomJS\/([0-9.]*)/
            }, {
                name: 'Google Web Preview',
                regexp: /Google Web Preview/
            },

            {
                name: 'Google Earth',
                regexp: /Google Earth\/([0-9.]*)/
            }, {
                name: 'EA Origin',
                regexp: /Origin\/([0-9.]*)/
            }, {
                name: 'SecondLife',
                regexp: /SecondLife\/([0-9.]*)/
            }, {
                name: 'Valve Steam',
                regexp: /Valve Steam/
            },

            {
                name: 'Songbird',
                regexp: /Songbird\/([0-9.]*)/
            }, {
                name: 'Thunderbird',
                regexp: /Thunderbird\/([0-9.]*)/
            },

            {
                name: 'Abrowser',
                regexp: /Abrowser\/([0-9.]*)/
            }, {
                name: 'arora',
                regexp: /[Aa]rora\/([0-9.]*)/
            }, {
                name: 'Baidu Browser',
                regexp: /M?BaiduBrowser\/([0-9.]*)/i
            }, {
                name: 'Camino',
                regexp: /Camino\/([0-9.]*)/
            }, {
                name: 'Canure',
                regexp: /Canure\/([0-9.]*)/,
                details: 3
            }, {
                name: 'CometBird',
                regexp: /CometBird\/([0-9.]*)/
            }, {
                name: 'Comodo Dragon',
                regexp: /Comodo_Dragon\/([0-9.]*)/,
                details: 2
            }, {
                name: 'Conkeror',
                regexp: /[Cc]onkeror\/([0-9.]*)/
            }, {
                name: 'CoolNovo',
                regexp: /(?:CoolNovo|CoolNovoChromePlus)\/([0-9.]*)/,
                details: 3
            }, {
                name: 'ChromePlus',
                regexp: /ChromePlus(?:\/([0-9.]*))?$/,
                details: 3
            }, {
                name: 'Daedalus',
                regexp: /Daedalus ([0-9.]*)/,
                details: 2
            }, {
                name: 'Demobrowser',
                regexp: /demobrowser\/([0-9.]*)/
            }, {
                name: 'Dooble',
                regexp: /Dooble(?:\/([0-9.]*))?/
            }, {
                name: 'DWB',
                regexp: /dwb(?:-hg)?(?:\/([0-9.]*))?/
            }, {
                name: 'Epiphany',
                regexp: /Epiphany\/([0-9.]*)/
            }, {
                name: 'FireWeb',
                regexp: /FireWeb\/([0-9.]*)/
            }, {
                name: 'Flock',
                regexp: /Flock\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Galeon',
                regexp: /Galeon\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Helium',
                regexp: /HeliumMobileBrowser\/([0-9.]*)/
            }, {
                name: 'iCab',
                regexp: /iCab\/([0-9.]*)/
            }, {
                name: 'Iceape',
                regexp: /Iceape\/([0-9.]*)/
            }, {
                name: 'IceCat',
                regexp: /IceCat ([0-9.]*)/
            }, {
                name: 'Iceweasel',
                regexp: /Iceweasel\/([0-9.]*)/
            }, {
                name: 'InternetSurfboard',
                regexp: /InternetSurfboard\/([0-9.]*)/
            }, {
                name: 'Iron',
                regexp: /Iron\/([0-9.]*)/,
                details: 2
            }, {
                name: 'Isis',
                regexp: /BrowserServer/
            }, {
                name: 'Jumanji',
                regexp: /jumanji/
            }, {
                name: 'Kazehakase',
                regexp: /Kazehakase\/([0-9.]*)/
            }, {
                name: 'KChrome',
                regexp: /KChrome\/([0-9.]*)/,
                details: 3
            }, {
                name: 'K-Meleon',
                regexp: /K-Meleon\/([0-9.]*)/
            }, {
                name: 'Leechcraft',
                regexp: /Leechcraft(?:\/([0-9.]*))?/,
                details: 2
            }, {
                name: 'Lightning',
                regexp: /Lightning\/([0-9.]*)/
            }, {
                name: 'Lunascape',
                regexp: /Lunascape[\/| ]([0-9.]*)/,
                details: 3
            }, {
                name: 'iLunascape',
                regexp: /iLunascape\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Maxthon',
                regexp: /Maxthon[\/ ]([0-9.]*)/,
                details: 3
            }, {
                name: 'MiniBrowser',
                regexp: /MiniBr?owserM\/([0-9.]*)/
            }, {
                name: 'MiniBrowser',
                regexp: /MiniBrowserMobile\/([0-9.]*)/
            }, {
                name: 'MixShark',
                regexp: /MixShark\/([0-9.]*)/
            }, {
                name: 'Motorola WebKit',
                regexp: /MotorolaWebKit\/([0-9.]*)/,
                details: 3
            }, {
                name: 'NetFront LifeBrowser',
                regexp: /NetFrontLifeBrowser\/([0-9.]*)/
            }, {
                name: 'Netscape Navigator',
                regexp: /Navigator\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Odyssey',
                regexp: /OWB\/([0-9.]*)/
            }, {
                name: 'OmniWeb',
                regexp: /OmniWeb/
            }, {
                name: 'Orca',
                regexp: /Orca\/([0-9.]*)/
            }, {
                name: 'Origyn',
                regexp: /Origyn Web Browser/
            }, {
                name: 'Palemoon',
                regexp: /Pale[mM]oon\/([0-9.]*)/
            }, {
                name: 'Phantom',
                regexp: /Phantom\/V([0-9.]*)/
            }, {
                name: 'Polaris',
                regexp: /Polaris\/v?([0-9.]*)/i,
                details: 2
            }, {
                name: 'QtCreator',
                regexp: /QtCreator\/([0-9.]*)/
            }, {
                name: 'QtQmlViewer',
                regexp: /QtQmlViewer/
            }, {
                name: 'QtTestBrowser',
                regexp: /QtTestBrowser\/([0-9.]*)/
            }, {
                name: 'QtWeb',
                regexp: /QtWeb Internet Browser\/([0-9.]*)/
            }, {
                name: 'QupZilla',
                regexp: /QupZilla\/([0-9.]*)/
            }, {
                name: 'Roccat',
                regexp: /Roccat\/([0-9]\.[0-9.]*)/
            }, {
                name: 'Raven for Mac',
                regexp: /Raven for Mac\/([0-9.]*)/
            }, {
                name: 'rekonq',
                regexp: /rekonq/
            }, {
                name: 'RockMelt',
                regexp: /RockMelt\/([0-9.]*)/,
                details: 2
            }, {
                name: 'Sleipnir',
                regexp: /Sleipnir\/([0-9.]*)/,
                details: 3
            }, {
                name: 'SMBrowser',
                regexp: /SMBrowser/
            }, {
                name: 'Sogou Explorer',
                regexp: /SE 2.X MetaSr/
            }, {
                name: 'Snowshoe',
                regexp: /Snowshoe\/([0-9.]*)/,
                details: 2
            }, {
                name: 'Sputnik',
                regexp: /Sputnik\/([0-9.]*)/i,
                details: 3
            }, {
                name: 'Stainless',
                regexp: /Stainless\/([0-9.]*)/
            }, {
                name: 'SunChrome',
                regexp: /SunChrome\/([0-9.]*)/
            }, {
                name: 'Surf',
                regexp: /Surf\/([0-9.]*)/
            }, {
                name: 'TaoBrowser',
                regexp: /TaoBrowser\/([0-9.]*)/,
                details: 2
            }, {
                name: 'TaomeeBrowser',
                regexp: /TaomeeBrowser\/([0-9.]*)/,
                details: 2
            }, {
                name: 'TazWeb',
                regexp: /TazWeb/
            }, {
                name: 'Viera',
                regexp: /Viera\/([0-9.]*)/
            }, {
                name: 'Villanova',
                regexp: /Villanova\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Wavelink Velocity',
                regexp: /Wavelink Velocity Browser\/([0-9.]*)/,
                details: 2
            }, {
                name: 'WebPositive',
                regexp: /WebPositive/
            }, {
                name: 'WebRender',
                regexp: /WebRender/
            }, {
                name: 'Wyzo',
                regexp: /Wyzo\/([0-9.]*)/,
                details: 3
            }, {
                name: 'Zetakey',
                regexp: /Zetakey Webkit\/([0-9.]*)/
            }, {
                name: 'Zetakey',
                regexp: /Zetakey\/([0-9.]*)/
            }]

            for (var b = 0; b < browsers.length; b++) {
                if (match = browsers[b].regexp.exec(ua)) {
                    this.browser.name = browsers[b].name;
                    this.browser.channel = '';
                    this.browser.stock = false;

                    if (match[1]) {
                        this.browser.version = new Version({
                            value: match[1],
                            details: browsers[b].details || null
                        });
                    } else {
                        this.browser.version = null;
                    }
                }
            }



            /****************************************************
             *      WebKit
             */

            if (match = /WebKit\/([0-9.]*)/i.exec(ua)) {
                this.engine.name = 'Webkit';
                this.engine.version = new Version({
                    value: match[1]
                });
            }

            if (match = /Browser\/AppleWebKit([0-9.]*)/i.exec(ua)) {
                this.engine.name = 'Webkit';
                this.engine.version = new Version({
                    value: match[1]
                });
            }

            /****************************************************
             *      KHTML
             */

            if (match = /KHTML\/([0-9.]*)/.exec(ua)) {
                this.engine.name = 'KHTML';
                this.engine.version = new Version({
                    value: match[1]
                });
            }

            /****************************************************
             *      Gecko
             */

            if (/Gecko/.exec(ua) && !/like Gecko/i.exec(ua)) {
                this.engine.name = 'Gecko';

                if (match = /; rv:([^\)]+)\)/.exec(ua)) {
                    this.engine.version = new Version({
                        value: match[1]
                    });
                }
            }

            /****************************************************
             *      Presto
             */

            if (match = /Presto\/([0-9.]*)/.exec(ua)) {
                this.engine.name = 'Presto';
                this.engine.version = new Version({
                    value: match[1]
                });
            }

            /****************************************************
             *      Trident
             */

            if (match = /Trident\/([0-9.]*)/.exec(ua)) {
                this.engine.name = 'Trident';
                this.engine.version = new Version({
                    value: match[1]
                });

                if (this.browser.name === 'Internet Explorer') {
                    if (parseVersion(this.engine.version) === 6 && parseFloat(this.browser.version) < 10) {
                        this.browser.version = new Version({
                            value: '10.0'
                        });
                        this.browser.mode = 'compat';
                    }

                    if (parseVersion(this.engine.version) === 5 && parseFloat(this.browser.version) < 9) {
                        this.browser.version = new Version({
                            value: '9.0'
                        });
                        this.browser.mode = 'compat';
                    }

                    if (parseVersion(this.engine.version) === 4 && parseFloat(this.browser.version) < 8) {
                        this.browser.version = new Version({
                            value: '8.0'
                        });
                        this.browser.mode = 'compat';
                    }
                }

                if (this.os.name === 'Windows Phone') {
                    if (parseVersion(this.engine.version) === 5 && parseFloat(this.os.version) < 7.5) {
                        this.os.version = new Version({
                            value: '7.5'
                        });
                    }
                }
            }


            /****************************************************
             *      Corrections
             */

            if (this.os.name === 'Android' && this.browser.stock) {
                this.browser.hidden = true;
            }

            if (this.os.name === 'iOS' && this.browser.name === 'Opera Mini') {
                this.os.version = null;
            }

            if (this.browser.name === 'Midori' && this.engine.name !== 'Webkit') {
                this.engine.name = 'Webkit';
                this.engine.version = null;
            }

            if (this.device.type === 'television' && this.browser.name === 'Opera') {
                this.browser.name = 'Opera Devices';
                switch (true) {
                    case this.engine.version.is('2.10'):
                        this.browser.version = new Version({
                            value: 3.2
                        });
                        break;
                    case this.engine.version.is('2.9'):
                        this.browser.version = new Version({
                            value: 3.1
                        });
                        break;
                    case this.engine.version.is('2.8'):
                        this.browser.version = new Version({
                            value: 3.0
                        });
                        break;
                    case this.engine.version.is('2.7'):
                        this.browser.version = new Version({
                            value: 2.9
                        });
                        break;
                    case this.engine.version.is('2.6'):
                        this.browser.version = new Version({
                            value: 2.8
                        });
                        break;
                    case this.engine.version.is('2.4'):
                        this.browser.version = new Version({
                            value: 10.3
                        });
                        break;
                    case this.engine.version.is('2.3'):
                        this.browser.version = new Version({
                            value: 10
                        });
                        break;
                    case this.engine.version.is('2.2'):
                        this.browser.version = new Version({
                            value: 9.7
                        });
                        break;
                    case this.engine.version.is('2.1'):
                        this.browser.version = new Version({
                            value: 9.6
                        });
                        break;
                    default:
                        this.browser.version = null;
                }

                this.os.name = null;
                this.os.version = null;
            }


            /****************************************************
             *      Camouflage
             */

            if (this.options.detectCamouflage) {

                if (match = /Mac OS X 10_6_3; ([^;]+); [a-z]{2}-(?:[a-z]{2})?\)/.exec(ua)) {
                    this.browser.name = '';
                    this.browser.version = null;
                    this.browser.mode = 'desktop';

                    this.os.name = 'Android';
                    this.os.version = null;

                    this.engine.name = 'Webkit';
                    this.engine.version = null;

                    this.device.model = match[1];
                    this.device.type = 'mobile';

                    var model = cleanupModel(this.device.model);
                    if (typeof ANDROID_MODELS[model] !== 'undefined') {
                        this.device.manufacturer = ANDROID_MODELS[model][0];
                        this.device.model = ANDROID_MODELS[model][1];
                        if (typeof ANDROID_MODELS[model][2] !== 'undefined') this.device.type = ANDROID_MODELS[model][2];
                        this.device.identified = true;
                    }

                    this.features.push('foundDevice');
                }

                if (match = /Linux Ventana; [a-z]{2}-[a-z]{2}; (.+) Build/.exec(ua)) {
                    this.browser.name = '';
                    this.browser.version = null;
                    this.browser.mode = 'desktop';

                    this.os.name = 'Android';
                    this.os.version = null;

                    this.engine.name = 'Webkit';
                    this.engine.version = null;

                    this.device.model = match[1];
                    this.device.type = 'mobile';

                    var model = cleanupModel(this.device.model);
                    if (typeof ANDROID_MODELS[model] !== 'undefined') {
                        this.device.manufacturer = ANDROID_MODELS[model][0];
                        this.device.model = ANDROID_MODELS[model][1];
                        if (typeof ANDROID_MODELS[model][2] !== 'undefined') this.device.type = ANDROID_MODELS[model][2];
                        this.device.identified = true;
                    }

                    this.features.push('foundDevice');
                }

                if (this.browser.name === 'Safari') {
                    if (this.os.name !== 'iOS' && /AppleWebKit\/([0-9]+.[0-9]+)/i.exec(ua)[1] !== /Safari\/([0-9]+.[0-9]+)/i.exec(ua)[1]) {
                        this.features.push('safariMismatch');
                        this.camouflage = true;
                    }

                    if (this.os.name === 'iOS' && !ua.match(/^Mozilla/)) {
                        this.features.push('noMozillaPrefix');
                        this.camouflage = true;
                    }

                    if (!/Version\/[0-9\.]+/.exec(ua)) {
                        this.features.push('noVersion');
                        this.camouflage = true;
                    }
                }

                if (this.browser.name === 'Chrome') {
                    if (!/(?:Chrome|CrMo|CriOS)\/([0-9]{1,2}\.[0-9]\.[0-9]{3,4}\.[0-9]+)/.exec(ua)) {
                        this.features.push('wrongVersion');
                        this.camouflage = true;
                    }
                }


                if (this.options.useFeatures) {
                    /* If it claims not to be Trident, but it is probably Trident running camouflage mode */
                    if (window.ActiveXObject) {
                        this.features.push('trident');

                        if (typeof this.engine.name !== 'undefined' && this.engine.name !== 'Trident') {
                            this.camouflage = typeof this.browser.name === 'undefined' || this.browser.name !== 'Maxthon';
                        }
                    }

                    /* If it claims not to be Opera, but it is probably Opera running camouflage mode */
                    if (window.opera) {
                        this.features.push('presto');

                        if (typeof this.engine.name !== 'undefined' && this.engine.name !== 'Presto') {
                            this.camouflage = true;
                        }

                        if (this.browser.name === 'Internet Explorer') {
                            this.camouflage = true;
                        }
                    }

                    /* If it claims not to be Gecko, but it is probably Gecko running camouflage mode */
                    if ('getBoxObjectFor' in document || 'mozInnerScreenX' in window) {
                        this.features.push('gecko');

                        if (typeof this.engine.name !== 'undefined' && this.engine.name !== 'Gecko') {
                            this.camouflage = true;
                        }

                        if (this.browser.name === 'Internet Explorer') {
                            this.camouflage = true;
                        }
                    }

                    /* If it claims not to be Webkit, but it is probably Webkit running camouflage mode */
                    if ('WebKitCSSMatrix' in window || 'WebKitPoint' in window || 'webkitStorageInfo' in window || 'webkitURL' in window) {
                        this.features.push('webkit');

                        if (typeof this.engine.name !== 'undefined' && this.engine.name !== 'Webkit') {
                            this.camouflage = true;
                        }

                        if (this.browser.name === 'Internet Explorer') {
                            this.camouflage = true;
                        }
                    }



                    /* If it claims to be Safari and uses V8, it is probably an Android device running camouflage mode */
                    if (this.engine.name === 'Webkit' && ({}.toString).toString().indexOf('\n') === -1) {
                        this.features.push('v8');

                        if (this.browser !== null && this.browser.name === 'Safari') {
                            this.camouflage = true;
                        }
                    }



                    /* If we have an iPad that is not 768 x 1024, we have an imposter */
                    if (this.device.model === 'iPad') {
                        if ((screen.width !== 0 && screen.height !== 0) && (screen.width !== 768 && screen.height !== 1024) && (screen.width !== 1024 && screen.height !== 768)) {
                            this.features.push('sizeMismatch');
                            this.camouflage = true;
                        }
                    }

                    /* If we have an iPhone or iPod that is not 320 x 480, we have an imposter */
                    if (this.device.model === 'iPhone' || this.device.model === 'iPod') {
                        if ((screen.width !== 0 && screen.height !== 0) && (screen.width !== 320 && screen.height !== 480) && (screen.width !== 480 && screen.height !== 320)) {
                            this.features.push('sizeMismatch');
                            this.camouflage = true;
                        }
                    }


                    if (this.os.name === 'iOS' && this.os.version) {

                        if (this.os.version.isOlder('4.0') && 'sandbox' in document.createElement('iframe')) {
                            this.features.push('foundSandbox');
                            this.camouflage = true;
                        }

                        if (this.os.version.isOlder('4.2') && 'WebSocket' in window) {
                            this.features.push('foundSockets');
                            this.camouflage = true;
                        }

                        if (this.os.version.isOlder('5.0') && !! window.Worker) {
                            this.features.push('foundWorker');
                            this.camouflage = true;
                        }

                        if (this.os.version.isNewer('2.1') && !window.applicationCache) {
                            this.features.push('noAppCache');
                            this.camouflage = true;
                        }
                    }

                    if (this.os.name !== 'iOS' && this.browser.name === 'Safari' && this.browser.version) {

                        if (this.browser.version.isOlder('4.0') && !! window.applicationCache) {
                            this.features.push('foundAppCache');
                            this.camouflage = true;
                        }

                        if (this.browser.version.isOlder('4.1') && !! (window.history && history.pushState)) {
                            this.features.push('foundHistory');
                            this.camouflage = true;
                        }

                        if (this.browser.version.isOlder('5.1') && !! document.documentElement.webkitRequestFullScreen) {
                            this.features.push('foundFullscreen');
                            this.camouflage = true;
                        }

                        if (this.browser.version.isOlder('5.2') && 'FileReader' in window) {
                            this.features.push('foundFileReader');
                            this.camouflage = true;
                        }
                    }
                }
            }
        }
    };

    function cleanupModel(s) {
        s = typeof s === 'undefined' ? '' : s;

        s = s.replace(/_TD$/, '');
        s = s.replace(/_CMCC$/, '');

        s = s.replace(/_/g, ' ');
        s = s.replace(/^\s+|\s+$/g, '');
        s = s.replace(/\/[^/]+$/, '');
        s = s.replace(/\/[^/]+ Android\/.*/, '');

        s = s.replace(/^tita on /, '');
        s = s.replace(/^Android on /, '');
        s = s.replace(/^Android for /, '');
        s = s.replace(/^ICS AOSP on /, '');
        s = s.replace(/^Full AOSP on /, '');
        s = s.replace(/^Full Android on /, '');
        s = s.replace(/^Full Cappuccino on /, '');
        s = s.replace(/^Full MIPS Android on /, '');
        s = s.replace(/^Full Android/, '');

        s = s.replace(/^Acer ?/i, '');
        s = s.replace(/^Iconia /, '');
        s = s.replace(/^Ainol /, '');
        s = s.replace(/^Coolpad ?/i, 'Coolpad ');
        s = s.replace(/^ALCATEL /, '');
        s = s.replace(/^Alcatel OT-(.*)/, 'one touch $1');
        s = s.replace(/^YL-/, '');
        s = s.replace(/^Novo7 ?/i, 'Novo7 ');
        s = s.replace(/^GIONEE /, '');
        s = s.replace(/^HW-/, '');
        s = s.replace(/^Huawei[ -]/i, 'Huawei ');
        s = s.replace(/^SAMSUNG[ -]/i, '');
        s = s.replace(/^SonyEricsson/, '');
        s = s.replace(/^Lenovo Lenovo/, 'Lenovo');
        s = s.replace(/^LNV-Lenovo/, 'Lenovo');
        s = s.replace(/^Lenovo-/, 'Lenovo ');
        s = s.replace(/^(LG)[ _\/]/, '$1-');
        s = s.replace(/^(HTC.*)\s(?:v|V)?[0-9.]+$/, '$1');
        s = s.replace(/^(HTC)[-\/]/, '$1 ');
        s = s.replace(/^(HTC)([A-Z][0-9][0-9][0-9])/, '$1 $2');
        s = s.replace(/^(Motorola[\s|-])/, '')
        s = s.replace(/^(Moto|MOT-)/, '')

        s = s.replace(/-?(orange(-ls)?|vodafone|bouygues)$/i, '');
        s = s.replace(/http:\/\/.+$/i, '');

        s = s.replace(/^\s+|\s+$/g, '');

        return s;
    }

    function parseVersion(version) {
        version = version.toString();
        var components = version.split('.');
        var major = components.shift();
        return parseFloat(major + '.' + components.join(''));
    }

    return Detected;

})();

/***/ }),

/***/ "zDi5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_filter__ = __webpack_require__("tX24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_array_filter__);





var Manager = function () {
  function Manager(data, count, fixedColumns) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Manager);

    if (false) {
      var notStringList = data.filter(function (item) {
        return item.parent && item.parent !== 0 && item.parent !== '0' && (typeof item.parent === 'number' || typeof item.value === 'number');
      });
      if (notStringList.length) {
        console.warn('[VUX] picker data\'s value and parent should be string:\n' + _JSON$stringify(notStringList, null, 2));
      }
    }
    this.data = data;
    this.count = count;
    if (fixedColumns) {
      this.fixedColumns = fixedColumns;
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Manager, [{
    key: 'getChildren',
    value: function getChildren(value) {
      return __WEBPACK_IMPORTED_MODULE_3_array_filter___default()(this.data, function (one) {
        return one.parent === value;
      });
    }
  }, {
    key: 'getFirstColumn',
    value: function getFirstColumn() {
      return __WEBPACK_IMPORTED_MODULE_3_array_filter___default()(this.data, function (one) {
        return !one.parent || one.parent === 0 || one.parent === '0';
      });
    }
  }, {
    key: 'getPure',
    value: function getPure(obj) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
    }
  }, {
    key: 'getColumns',
    value: function getColumns(value) {
      var _this = this;

      // check is data contains the values
      if (value.length > 0) {
        var matchCount = this.getPure(this.data).filter(function (item) {
          return _this.getPure(value).indexOf(item.value) > -1;
        }).length;
        if (matchCount < this.getPure(value).length) {
          value = [];
        }
      }
      var datas = [];
      var max = this.fixedColumns || 8;
      for (var i = 0; i < max; i++) {
        if (i === 0) {
          datas.push(this.getFirstColumn());
        } else {
          // 没有数据时，取得上一级的第一个
          if (!value[i]) {
            if (typeof datas[i - 1][0] === 'undefined') {
              break;
            } else {
              var topValue = datas[i - 1][0].value;
              datas.push(this.getChildren(topValue));
            }
          } else {
            datas.push(this.getChildren(value[i - 1]));
          }
        }
      }
      var list = datas.filter(function (item) {
        return item.length > 0;
      });
      // correct the column
      this.count = list.length;
      return list;
    }
  }]);

  return Manager;
}();

/* harmony default export */ __webpack_exports__["a"] = (Manager);

/***/ }),

/***/ "zQR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("h65t")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("vIB/")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "zwoO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ })

});


// WEBPACK FOOTER //
// static/js/vendor.350d6bf436b3eab2affb.js